
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("iCpeT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "AppDiscoveryPage", () => $b9513046dd6bab9c$export$103f829e9c4e4c9d);
$parcel$export(module.exports, "default", () => $b9513046dd6bab9c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $frZnw = parcelRequire("frZnw");

var $2RidI = parcelRequire("2RidI");

var $e4LQq = parcelRequire("e4LQq");
const $b9513046dd6bab9c$export$103f829e9c4e4c9d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RidI.default), {
        appName: (0, $frZnw.APP_NAMES).APP_DISCOVERY
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $b9513046dd6bab9c$var$appDiscoverySettingsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e4LQq.AppDiscoverySettings), null)));
var $b9513046dd6bab9c$export$2e2bcd8739ae039 = $b9513046dd6bab9c$export$103f829e9c4e4c9d;
const $b9513046dd6bab9c$var$appDiscoverySettingsContainerStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.300'
});

});
parcelRegister("2RidI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3141fb0b4d3f9503$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8WuJm = parcelRequire("8WuJm");

var $iVSJI = parcelRequire("iVSJI");

var $frZnw = parcelRequire("frZnw");

var $fO5rB = parcelRequire("fO5rB");

var $bhwgQ = parcelRequire("bhwgQ");

var $1IzB8 = parcelRequire("1IzB8");
const $3141fb0b4d3f9503$var$ServiceDeskAppBase = ({ appName: appName, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1IzB8.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
        subProduct: "serviceDesk"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iVSJI.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: (0, $frZnw.toPackageName)(appName),
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, children))));
var $3141fb0b4d3f9503$export$2e2bcd8739ae039 = $3141fb0b4d3f9503$var$ServiceDeskAppBase;

});
// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("6QL9v", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $c2784746c0813b99$export$b1fe420ed15dff7b);

var $dWlsy = parcelRequire("dWlsy");
const $c2784746c0813b99$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $dWlsy.subProductFromProjectType)(projectType);
};

});

parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});


parcelRegister("1IzB8", function(module, exports) {

$parcel$export(module.exports, "default", () => $edeca50de0b85084$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $10fdS = parcelRequire("10fdS");


var $bsgfb = parcelRequire("bsgfb");

var $1fuiA = parcelRequire("1fuiA");
const $edeca50de0b85084$var$AccessCheck = ({ children: children })=>{
    const isSettingsRoute = (0, $10fdS.useCurrentRoute)().path.includes(`${(0, $2df94debed157361$export$967ba7bfb5ce30bd)}/:projectKey/settings/`);
    const Gate = isSettingsRoute ? (0, $1fuiA.default) : (0, $bsgfb.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Gate, null, children);
};
var $edeca50de0b85084$export$2e2bcd8739ae039 = $edeca50de0b85084$var$AccessCheck;

});
const $2df94debed157361$export$967ba7bfb5ce30bd = '/jira/servicedesk/projects';

parcelRegister("bsgfb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7d02215a42a3332$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fz8wa = parcelRequire("fz8wa");

var $lB25E = parcelRequire("lB25E");

var $11C4f = parcelRequire("11C4f");
const $a7d02215a42a3332$var$ProductAccessCheck = ({ children: children })=>{
    const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, $fz8wa.useApplicationPermissions)();
    const [projectKey = ''] = (0, $lB25E.usePathParam)('projectKey');
    if (projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $11C4f.default), null, children);
    return hasServiceDeskAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: "/jira"
    });
};
var $a7d02215a42a3332$export$2e2bcd8739ae039 = $a7d02215a42a3332$var$ProductAccessCheck;

});
parcelRegister("11C4f", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2544b3bfea70255$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");

var $jyTef = parcelRequire("jyTef");


var $6tW8V = parcelRequire("6tW8V");
const $a2544b3bfea70255$var$AgentCheck = ({ children: children })=>{
    const [projectKey = ''] = (0, $lB25E.usePathParam)('projectKey');
    const [{ data: data, error: error }] = (0, $jyTef.useServiceDeskContext)();
    if (data || error) {
        // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
        if (!(0, $6tW8V.isAccessError)(error)) {
            const { userRole: userRole = '' } = data || {};
            if (userRole === 'agent' || userRole === 'agent-project-admin') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
            if (error) throw error;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: `${(0, $2df94debed157361$export$967ba7bfb5ce30bd)}/${projectKey}/issues`
        });
    }
    return null;
};
var $a2544b3bfea70255$export$2e2bcd8739ae039 = $a2544b3bfea70255$var$AgentCheck;

});
parcelRegister("jyTef", function(module, exports) {

$parcel$export(module.exports, "useServiceDeskContext", () => $3f940b317a874b53$export$712ead87353ac687);

var $eUqFw = parcelRequire("eUqFw");

var $iZJHG = parcelRequire("iZJHG");

var $ct0sQ = parcelRequire("ct0sQ");
const $3f940b317a874b53$var$getServiceDeskContextResource = ()=>(0, $ct0sQ.serviceDeskContextResource);
const $3f940b317a874b53$export$712ead87353ac687 = (projectKey, customContext)=>{
    const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, $iZJHG.useResourceWithCustomRouterContext)($3f940b317a874b53$var$getServiceDeskContextResource(), customContext);
    (0, $eUqFw.useEffect)(()=>{
        if (!false) refreshCache();
    }, [
        projectKey,
        refreshCache
    ]);
    return [
        {
            data: data,
            loading: loading,
            error: error
        }
    ];
};

});

parcelRegister("6tW8V", function(module, exports) {

$parcel$export(module.exports, "isAccessError", () => $5107715f0b974007$export$ddaebe4928e793cb);

const $5107715f0b974007$var$RESTRICTED_ACCESS_CODES = [
    (0, $1c3fbb431a173cc6$export$a3269a3914b007e3),
    (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef),
    (0, $1c3fbb431a173cc6$export$67d19e9a991baa07)
];
const $5107715f0b974007$export$ddaebe4928e793cb = (error)=>error?.statusCode != null ? $5107715f0b974007$var$RESTRICTED_ACCESS_CODES.includes(error.statusCode) : false;

});
const $1c3fbb431a173cc6$export$ff39ebd4bb12b718 = 201;
const $1c3fbb431a173cc6$export$3288b14b6745c572 = 204;
const $1c3fbb431a173cc6$export$9de493bcd9b1d977 = 400;
const $1c3fbb431a173cc6$export$67d19e9a991baa07 = 401;
const $1c3fbb431a173cc6$export$a3269a3914b007e3 = 403;
const $1c3fbb431a173cc6$export$8bca792d963eb0ef = 404;
const $1c3fbb431a173cc6$export$4a3cb39801694eee = 407;
const $1c3fbb431a173cc6$export$fa405bbf47d510e2 = 408;
const $1c3fbb431a173cc6$export$c09e7ea0fc79f34f = 409;
const $1c3fbb431a173cc6$export$5244030134e99 = 412;
const $1c3fbb431a173cc6$export$f90ac1df0b60853d = 413;
const $1c3fbb431a173cc6$export$a447d0a965e16776 = 422;
const $1c3fbb431a173cc6$export$3b48aba8957000cd = 426;
const $1c3fbb431a173cc6$export$6763168a631449a2 = 429;
const $1c3fbb431a173cc6$export$e813cd7045fcc98d = 500;
const $1c3fbb431a173cc6$export$2ce38d41a306034e = 502;
const $1c3fbb431a173cc6$export$974c37534b0191b1 = 503;
const $1c3fbb431a173cc6$export$5400e8dddac3fcf3 = 504;




parcelRegister("1fuiA", function(module, exports) {

$parcel$export(module.exports, "default", () => $0788b3e6146363c4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2Ba2b = parcelRequire("2Ba2b");

var $jyTef = parcelRequire("jyTef");

var $6tW8V = parcelRequire("6tW8V");
const $0788b3e6146363c4$var$SettingsAccessCheck = ({ children: children })=>{
    const [{ data: serviceDeskContext, error: serviceDeskContextError }] = (0, $jyTef.useServiceDeskContext)();
    const userRole = serviceDeskContext?.userRole;
    // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
    const hasAccessError = (0, $6tW8V.isAccessError)(serviceDeskContextError);
    // Service desk context is updated on every route change
    // If context fails to give us an indicative result (e.g. fetch failed, 500 error)
    // We will continue to use current value to assess permissions
    if (userRole === 'agent-project-admin' && !hasAccessError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    if (userRole !== undefined || hasAccessError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Ba2b.ProjectNotFound), null);
    if (serviceDeskContextError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Ba2b.GenericError), null);
    return null;
};
var $0788b3e6146363c4$export$2e2bcd8739ae039 = $0788b3e6146363c4$var$SettingsAccessCheck;

});
parcelRegister("2Ba2b", function(module, exports) {

$parcel$export(module.exports, "ProjectNotFound", () => $abcdf98f8a718d25$export$849d319c342682a2);
$parcel$export(module.exports, "GenericError", () => $abcdf98f8a718d25$export$7d465be8efa67280);

var $eUqFw = parcelRequire("eUqFw");

var $220ac = parcelRequire("220ac");

var $heNSb = parcelRequire("heNSb");

var $lQXqy = parcelRequire("lQXqy");

var $7QuzF = parcelRequire("7QuzF");

var $4Es8k = parcelRequire("4Es8k");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lB25E = parcelRequire("lB25E");

var $6Yj0X = parcelRequire("6Yj0X");
const $abcdf98f8a718d25$export$849d319c342682a2 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const projectsPath = '/jira/projects';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: formatMessage((0, $6Yj0X.default).notFoundDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        renderImage: (0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $7QuzF.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $6Yj0X.default).notFoundTitle),
        description: formatMessage((0, $6Yj0X.default).notFoundDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), {
            to: projectsPath
        }, formatMessage((0, $6Yj0X.default).notFoundAction))
    }));
};
const $abcdf98f8a718d25$export$7d465be8efa67280 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: formatMessage((0, $6Yj0X.default).genericDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        renderImage: (0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $lQXqy.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $6Yj0X.default).genericErrorTitle),
        description: formatMessage((0, $6Yj0X.default).genericErrorDescription)
    }));
};

});
parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

parcelRegister("lQXqy", function(module, exports) {

$parcel$export(module.exports, "default", () => $30559913302f86cb$export$2e2bcd8739ae039);
$parcel$export(module.exports, "viewBox", () => $30559913302f86cb$export$a179c88182cb9d56);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("1cuWo")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("48S62")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = m5v37k2r2scm86wgmrk6
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/m5v37k2r2scm86wgmrk6

var $9TZf5 = parcelRequire("9TZf5");

var $48S62 = parcelRequire("48S62");

var $1cuWo = parcelRequire("1cuWo");
const $30559913302f86cb$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($1cuWo)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($48S62))
});
var $30559913302f86cb$export$2e2bcd8739ae039 = $30559913302f86cb$var$Illustration;
// for advanced use only
const $30559913302f86cb$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    218
];

});
parcelRegister("48S62", function(module, exports) {
module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();

});

parcelRegister("1cuWo", function(module, exports) {
module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();

});


parcelRegister("7QuzF", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ab5059cf2dfabb6$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 53grvvhrxck68z6q4s7ztq4p
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/53grvvhrxck68z6q4s7ztq4p

var $9TZf5 = parcelRequire("9TZf5");

var $fCVbE = parcelRequire("fCVbE");
const $3ab5059cf2dfabb6$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($fCVbE)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($fCVbE))
});
var $3ab5059cf2dfabb6$export$2e2bcd8739ae039 = $3ab5059cf2dfabb6$var$Illustration;
// for advanced use only
const $3ab5059cf2dfabb6$export$a179c88182cb9d56 = [
    0,
    0,
    167,
    226
];

});
parcelRegister("fCVbE", function(module, exports) {
module.exports = new URL("search-error.a6df7c97.svg", import.meta.url).toString();

});


parcelRegister("6Yj0X", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c13e1fbd282caae$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6c13e1fbd282caae$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    notFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-document-title-jsm",
        "defaultMessage": "Project not found - Service project"
    },
    notFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-title",
        "defaultMessage": "This project isn't available"
    },
    notFoundDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-description",
        "defaultMessage": "It may have been deleted or your permissions may have changed"
    },
    notFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-action",
        "defaultMessage": "View a list of all projects"
    },
    genericDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-document-title-jsm",
        "defaultMessage": "Error - Service project"
    },
    genericErrorTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-title",
        "defaultMessage": "An error occurred"
    },
    genericErrorDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-description",
        "defaultMessage": "An error occurred while loading this page"
    }
});

});





parcelRegister("e4LQq", function(module, exports) {

$parcel$export(module.exports, "AppDiscoverySettings", () => $17da1e033ba54f2b$export$391f3e31f056e32a);

var $eUqFw = parcelRequire("eUqFw");

var $bNe1g = parcelRequire("bNe1g");

var $i6yF7 = parcelRequire("i6yF7");

var $6vrw7 = parcelRequire("6vrw7");
const $17da1e033ba54f2b$export$391f3e31f056e32a = ()=>{
    const baseUrl = (0, $6vrw7.toBaseUrl)('');
    const { data: projectContext } = (0, $bNe1g.useProjectContext)();
    if (projectContext == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6yF7.default), {
        baseUrl: baseUrl,
        projectKey: projectContext.projectKey,
        isJiraAdmin: projectContext.isProjectAdmin || false,
        isProjectSimplified: projectContext.simplified,
        projectName: projectContext.projectName
    });
};

});
parcelRegister("i6yF7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9394a82b86c4d8d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9c7gV = parcelRequire("9c7gV");
var $j7bQJ = parcelRequire("j7bQJ");
var $6tahE = parcelRequire("6tahE");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $c76ap = parcelRequire("c76ap");

var $3a8wJ = parcelRequire("3a8wJ");

var $eI5EY = parcelRequire("eI5EY");

var $giAhk = parcelRequire("giAhk");

var $dFKOv = parcelRequire("dFKOv");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $be3PE = parcelRequire("be3PE");

var $iJHZm = parcelRequire("iJHZm");

var $9YeNs = parcelRequire("9YeNs");

var $4hLx8 = parcelRequire("4hLx8");

var $g8MSG = parcelRequire("g8MSG");
const $d9394a82b86c4d8d$var$ACTION_SUBJECT_ID = 'jsdSettingsAppDiscovery';
const $d9394a82b86c4d8d$var$MARKETPLACE_SOURCE = 'servicedesk-settings';
function $d9394a82b86c4d8d$var$AppDiscoverySettings(props) {
    const { isProjectSimplified: isProjectSimplified, baseUrl: baseUrl, projectKey: projectKey, projectName: projectName, isJiraAdmin: isJiraAdmin, intl: { formatMessage: formatMessage } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "jsdSettingsAppDiscovery",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9YeNs.default), {
        isProjectSimplified: isProjectSimplified,
        baseUrl: baseUrl,
        projectKey: projectKey,
        projectName: projectName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9c7gV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j7bQJ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6tahE.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a8wJ.default), {
        breadcrumbs: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $d9394a82b86c4d8d$var$breadcrumbsWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c76ap.default), {
            // @ts-expect-error - Type '{ baseUrl: string; projectKey: string; projectName: string; }' is not assignable to type 'IntrinsicAttributes & Omit<Omit<Omit<{ TenantContextSubscriber: SubscriberComponent<State, BoundActions<State, Actions>, unknown>; onMount: (args_0: UIAnalyticsEvent) => void; }, keyof WithAnalyticsEventsProps>, "TenantContextSubscriber" | "onMount"> & Partial<...>, "TenantContextSubscriber" | "onMount">'.
            baseUrl: baseUrl,
            projectKey: projectKey,
            projectName: projectName
        }))
    }, formatMessage((0, $eI5EY.fg)('jsm_simplified_project_settings_navigation') ? (0, $g8MSG.default).headerNew : (0, $g8MSG.default).header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $g8MSG.default).subHeaderJsm))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6tahE.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dFKOv.default), {
        categoryTitle: formatMessage((0, $g8MSG.default).categoryAssetManagement),
        marketingLabel: "asset-management",
        isJiraAdmin: isJiraAdmin,
        actionSubjectId: $d9394a82b86c4d8d$var$ACTION_SUBJECT_ID,
        source: $d9394a82b86c4d8d$var$MARKETPLACE_SOURCE
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6tahE.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dFKOv.default), {
        categoryTitle: formatMessage((0, $g8MSG.default).categoryHelpCenterFormCustomization),
        marketingLabel: "in-app-customization",
        isJiraAdmin: isJiraAdmin,
        actionSubjectId: $d9394a82b86c4d8d$var$ACTION_SUBJECT_ID,
        source: $d9394a82b86c4d8d$var$MARKETPLACE_SOURCE
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6tahE.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dFKOv.default), {
        categoryTitle: formatMessage((0, $g8MSG.default).categoryAgentProductivity),
        marketingLabel: "jsd-in-app-agent-productivity",
        isJiraAdmin: isJiraAdmin,
        actionSubjectId: $d9394a82b86c4d8d$var$ACTION_SUBJECT_ID,
        source: $d9394a82b86c4d8d$var$MARKETPLACE_SOURCE
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6tahE.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dFKOv.default), {
        categoryTitle: formatMessage((0, $g8MSG.default).categoryReportingAnalytics),
        marketingLabel: "in-app-reporting",
        isJiraAdmin: isJiraAdmin,
        actionSubjectId: $d9394a82b86c4d8d$var$ACTION_SUBJECT_ID,
        source: $d9394a82b86c4d8d$var$MARKETPLACE_SOURCE
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6tahE.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dFKOv.default), {
        categoryTitle: formatMessage((0, $g8MSG.default).categoryAlertingIncidentManagement),
        marketingLabel: "in-app-incident-mgt",
        isJiraAdmin: isJiraAdmin,
        actionSubjectId: $d9394a82b86c4d8d$var$ACTION_SUBJECT_ID,
        source: $d9394a82b86c4d8d$var$MARKETPLACE_SOURCE
    })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: {
            isJiraAdmin: isJiraAdmin
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $be3PE.JsmPageInteractiveEvent), {
        appName: "jira-servicedesk-apps-discovery",
        ttrSlo: (0, $4hLx8.APP_DISCOVERY_TTR_THRESHOLD),
        ttiSlo: (0, $4hLx8.APP_DISCOVERY_TTI_THRESHOLD),
        // @ts-expect-error - TS2322 - Type 'PageLoadMetric' is not assignable to type 'BM3Metric'.
        metric: (0, $4hLx8.appsDiscoveryPageLoad)
    }), (0, $eI5EY.fg)('jsm_simplified_project_settings_navigation') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageReady), null));
}
var $d9394a82b86c4d8d$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($d9394a82b86c4d8d$var$AppDiscoverySettings);
const $d9394a82b86c4d8d$var$breadcrumbsWrapperStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.100',
    marginLeft: 'space.negative.050'
});

});
parcelRegister("9c7gV", function(module, exports) {

$parcel$export(module.exports, "default", () => $4be3daaa307b075d$export$2e2bcd8739ae039);

var $aJWi0 = parcelRequire("aJWi0");

var $j7bQJ = parcelRequire("j7bQJ");

var $6tahE = parcelRequire("6tahE");
var // Page already has a jsdoc where it is defined
// eslint-disable-next-line @repo/internal/react/require-jsdoc
$4be3daaa307b075d$export$2e2bcd8739ae039 = (0, $aJWi0.default);

});
parcelRegister("aJWi0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7341c6e5fd381e79$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $cuCEk = parcelRequire("cuCEk");
function $7341c6e5fd381e79$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7341c6e5fd381e79$var$bannerStyles = {
    name: "4oew4k",
    styles: "width:100%;position:fixed"
};
const $7341c6e5fd381e79$var$bannerContainerStyles = {
    name: "1x3pv69",
    styles: "width:100%;position:relative;z-index:3;flex:1 0 auto;transition:height 0.25s ease-in-out"
};
const $7341c6e5fd381e79$var$pageContentStyles = {
    name: "15n167b",
    styles: "min-width:0;position:relative;z-index:1;flex:1 1 auto"
};
const $7341c6e5fd381e79$var$wrapperStyles = {
    name: "m5v4sl",
    styles: "display:flex;width:100%;min-height:100%;flex-direction:column"
};
const $7341c6e5fd381e79$var$mainContainerStyles = {
    name: "1cete8c",
    styles: "display:flex;flex:1 1 auto"
};
const $7341c6e5fd381e79$var$navigationStyles = {
    name: "wrqbg1",
    styles: "position:relative;z-index:2"
};
/**
 * __Page__
 *
 * Used to build page layouts.
 *
 * Has built in support for positioning [banners](https://atlassian.design/components/banner/examples)
 * and the deprecated `@atlaskit/navigation`.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $7341c6e5fd381e79$var$Page = ({ isBannerOpen: isBannerOpen = false, bannerHeight: bannerHeight = (0, $cuCEk.defaultBannerHeight), banner: banner, navigation: navigation, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7341c6e5fd381e79$var$wrapperStyles,
        "data-testid": testId
    }, banner ? /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7341c6e5fd381e79$var$bannerContainerStyles,
        style: {
            height: isBannerOpen ? `${bannerHeight}px` : '0'
        },
        "aria-hidden": !isBannerOpen,
        "data-testid": testId ? `${testId}--banner-container` : undefined
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7341c6e5fd381e79$var$bannerStyles
    }, banner)) : null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7341c6e5fd381e79$var$mainContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7341c6e5fd381e79$var$navigationStyles
    }, navigation), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7341c6e5fd381e79$var$pageContentStyles
    }, children)));
};
var $7341c6e5fd381e79$export$2e2bcd8739ae039 = $7341c6e5fd381e79$var$Page;

});
parcelRegister("cuCEk", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", () => $63536614c324c20f$export$74797698e12f8baa);
$parcel$export(module.exports, "defaultGridColumnWidth", () => $63536614c324c20f$export$b8241a1616ab1b96);
$parcel$export(module.exports, "spacingMapping", () => $63536614c324c20f$export$2a89a65a43bab52d);
$parcel$export(module.exports, "defaultSpacing", () => $63536614c324c20f$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $63536614c324c20f$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $63536614c324c20f$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $63536614c324c20f$export$2303d2bd9eeff99a);
$parcel$export(module.exports, "varColumnsNum", () => $63536614c324c20f$export$9ddc3632bbfb8966);
$parcel$export(module.exports, "varColumnSpan", () => $63536614c324c20f$export$8b7e31f391e6e681);
$parcel$export(module.exports, "varGridSpacing", () => $63536614c324c20f$export$936829b4511db3e4);
const $63536614c324c20f$export$3aaf3a78c909ea56 = 8;
const $63536614c324c20f$export$74797698e12f8baa = 12;
const $63536614c324c20f$export$b8241a1616ab1b96 = $63536614c324c20f$export$3aaf3a78c909ea56 * 10;
const $63536614c324c20f$export$2a89a65a43bab52d = {
    comfortable: $63536614c324c20f$export$3aaf3a78c909ea56 * 5,
    cosy: $63536614c324c20f$export$3aaf3a78c909ea56 * 2,
    compact: $63536614c324c20f$export$3aaf3a78c909ea56 * 0.5
};
const $63536614c324c20f$export$8ec7372efd74b753 = 'cosy';
const $63536614c324c20f$export$d77f83c3d17a7b8a = 52;
const $63536614c324c20f$export$f8725d21f81f3e01 = 0;
const $63536614c324c20f$export$2303d2bd9eeff99a = 'fixed';
const $63536614c324c20f$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $63536614c324c20f$export$8b7e31f391e6e681 = '--ds-column-span';
const $63536614c324c20f$export$936829b4511db3e4 = '--ds-grid-spacing';

});


parcelRegister("j7bQJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $21cf405c5617943d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cuCEk = parcelRequire("cuCEk");

var $gw8fk = parcelRequire("gw8fk");

var $6tahE = parcelRequire("6tahE");

var $02LzD = parcelRequire("02LzD");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $21cf405c5617943d$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    const { medium: medium } = (0, $eUqFw.useContext)((0, $6tahE.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $cuCEk.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $cuCEk.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $02LzD.GridContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gw8fk.Grid), {
        layout: layout,
        testId: testId
    }, children));
};
var $21cf405c5617943d$export$2e2bcd8739ae039 = $21cf405c5617943d$var$GridWrapper;

});
parcelRegister("gw8fk", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $7946ba115b4da3a8$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cuCEk = parcelRequire("cuCEk");

var $02LzD = parcelRequire("02LzD");
function $7946ba115b4da3a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7946ba115b4da3a8$var$gridStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 calc(var(${(0, $cuCEk.varGridSpacing)}) / 2)`,
    position: 'relative',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
});
const $7946ba115b4da3a8$var$gridLayoutStyles = {
    fixed: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(var(${(0, $cuCEk.varColumnsNum)}) * ${(0, $cuCEk.defaultGridColumnWidth)}px)`
    }),
    fluid: {
        name: "qhxz92",
        styles: "max-width:100%"
    }
};
const $7946ba115b4da3a8$var$nestedGridStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(-1 * var(${(0, $cuCEk.varGridSpacing)}))`
});
const $7946ba115b4da3a8$export$ef2184bd89960b14 = ({ layout: layout = (0, $cuCEk.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $7946ba115b4da3a8$var$gridStyles,
            $7946ba115b4da3a8$var$gridLayoutStyles[layout],
            isNested && $7946ba115b4da3a8$var$nestedGridStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varColumnsNum)]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varGridSpacing)]: `${(0, $cuCEk.spacingMapping)[spacing]}px`
        },
        "data-testid": testId
    }, children);
};

});
parcelRegister("02LzD", function(module, exports) {

$parcel$export(module.exports, "GridContext", () => $abe6d6b3e91c4986$export$11cae3e04ab99fae);

var $eUqFw = parcelRequire("eUqFw");

var $cuCEk = parcelRequire("cuCEk");
const $abe6d6b3e91c4986$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $cuCEk.defaultSpacing),
    columns: (0, $cuCEk.defaultGridColumns)
});

});


parcelRegister("6tahE", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", () => $384e4fce86f51330$export$1229ad7112b989f5);
$parcel$export(module.exports, "default", () => $384e4fce86f51330$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cuCEk = parcelRequire("cuCEk");

var $02LzD = parcelRequire("02LzD");
var $384e4fce86f51330$var$ColumnVariant;
/**
 * Determines the method by which column width is calculated.
 */ (function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
})($384e4fce86f51330$var$ColumnVariant || ($384e4fce86f51330$var$ColumnVariant = {}));
const $384e4fce86f51330$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $cuCEk.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $384e4fce86f51330$var$availableWidth = '99.9999%';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $384e4fce86f51330$var$singleColumnWidth = `(${$384e4fce86f51330$var$availableWidth} / var(${(0, $cuCEk.varColumnsNum)}))`;
const $384e4fce86f51330$var$gridColumnStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `calc(${$384e4fce86f51330$var$singleColumnWidth} - var(${(0, $cuCEk.varGridSpacing)}))`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(var(${(0, $cuCEk.varGridSpacing)}) / 2)`,
    flexGrow: 1,
    flexShrink: 0,
    wordWrap: 'break-word'
});
const $384e4fce86f51330$var$gridColumnWidthStyles = {
    ["auto"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `auto`
    }),
    ["bounded"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(${$384e4fce86f51330$var$singleColumnWidth} *  var(${(0, $cuCEk.varColumnSpan)}) - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `100%`
    }),
    ["fullWidth"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `100%`
    })
};
const $384e4fce86f51330$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    medium: (0, $cuCEk.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $384e4fce86f51330$var$GridColumn = ({ medium: medium = (0, $cuCEk.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $384e4fce86f51330$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)($384e4fce86f51330$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $384e4fce86f51330$var$gridColumnStyles,
            $384e4fce86f51330$var$gridColumnWidthStyles[variant]
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
        },
        "data-testid": testId
    }, children));
};
var $384e4fce86f51330$export$2e2bcd8739ae039 = $384e4fce86f51330$var$GridColumn;

});



parcelRegister("3a8wJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2992b0d4d3fe9569$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hFGUl = parcelRequire("hFGUl");
const $2992b0d4d3fe9569$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFGUl.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2992b0d4d3fe9569$var$ActionsWrapper, null, actions) : null
    });
var $2992b0d4d3fe9569$export$2e2bcd8739ae039 = $2992b0d4d3fe9569$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2992b0d4d3fe9569$var$ActionsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hFGUl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0ce2fac4b2f156d$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $eUqFw = parcelRequire("eUqFw");

var $5ubTM = parcelRequire("5ubTM");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $f0ce2fac4b2f156d$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.OuterWrapper), null, breadcrumbs, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleWrapper), {
        truncateTitle: truncateTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleContainer), {
        truncateTitle: truncateTitle
    }, disableTitleStyles ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.StyledTitleWrapper), {
        ref: innerRef,
        truncateTitle: truncateTitle,
        id: id
    }, children)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.ActionsWrapper), null, actions)), bottomBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.BottomBarWrapper), null, " ", bottomBar, " "));
};
var $f0ce2fac4b2f156d$export$2e2bcd8739ae039 = $f0ce2fac4b2f156d$var$PageHeader;

});
parcelRegister("5ubTM", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $fce98fdc5842132f$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $fce98fdc5842132f$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $fce98fdc5842132f$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $fce98fdc5842132f$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $fce98fdc5842132f$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $fce98fdc5842132f$export$6330225854c30dc);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
function $fce98fdc5842132f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fce98fdc5842132f$var$truncateStyles = {
    name: "13oenf9",
    styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $fce98fdc5842132f$var$outerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
});
const $fce98fdc5842132f$var$titleStyles = {
    name: "1o56te0",
    styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
};
const $fce98fdc5842132f$var$titleWrapperStyles = {
    name: "1wb76vg",
    styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
};
const $fce98fdc5842132f$var$titleWrapperTruncateStyles = {
    name: "14gl6v0",
    styles: "flex-wrap:nowrap"
};
const $fce98fdc5842132f$var$titleContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    minWidth: 0,
    maxWidth: '100%',
    flex: '1 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flexShrink: undefined,
    marginBlockEnd: "var(--ds-space-100, 8px)"
});
const $fce98fdc5842132f$var$actionStyles = {
    name: "1ianfu6",
    styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
};
const $fce98fdc5842132f$var$titleContainerTruncateStyles = {
    name: "s2a4s9",
    styles: "flex-shrink:1"
};
const $fce98fdc5842132f$var$bottomBarStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.200'
});
const $fce98fdc5842132f$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$outerStyles
    }, children);
};
const $fce98fdc5842132f$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("h1", {
        css: [
            $fce98fdc5842132f$var$titleStyles,
            truncateTitle && $fce98fdc5842132f$var$truncateStyles
        ],
        ref: ref,
        tabIndex: -1,
        id: id
    }, children);
});
const $fce98fdc5842132f$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleWrapperStyles,
            truncateTitle && $fce98fdc5842132f$var$titleWrapperTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleContainerStyles,
            truncateTitle && $fce98fdc5842132f$var$titleContainerTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$actionStyles
    }, children);
};
const $fce98fdc5842132f$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $fce98fdc5842132f$var$bottomBarStyles
    }, children);
};

});



parcelRegister("dFKOv", function(module, exports) {

$parcel$export(module.exports, "default", () => $2555a5c87f3e28c5$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $c8Guq = parcelRequire("c8Guq");

var $g5DHJ = parcelRequire("g5DHJ");

var $lwEMm = parcelRequire("lwEMm");
var $b5Eig = parcelRequire("b5Eig");
var $6XDNr = parcelRequire("6XDNr");

var $8J0kb = parcelRequire("8J0kb");
var $5E4rM = parcelRequire("5E4rM");

var $8un0w = parcelRequire("8un0w");

var $eGI9v = parcelRequire("eGI9v");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $eodt0 = parcelRequire("eodt0");

var $jxzG5 = parcelRequire("jxzG5");
// This data is okay to be checked into git and bundled to webpack
// We're following the same pattern as https://bitbucket.org/atlassian-marketplace/marketplace-frontend/src/master/packages/amkt-addon-discovery/dev/algolia_config.json
const $2555a5c87f3e28c5$var$algoliaConfig = {
    applicationId: '7LVR1JKTDF',
    apiKey: '3ef48f0fc67ee7e9c5a9dbbf6b45908c'
};
const $2555a5c87f3e28c5$var$landingPagesFilters = (0, $g5DHJ.Map)({
    product: 'jira',
    hosting: 'cloud'
});
const $2555a5c87f3e28c5$var$buildAppUrl = (addonKey, addonId, isJiraAdmin, source, projectKey, projectId, installDialogOpen, requestDialogOpen)=>{
    if (isJiraAdmin) return (0, $jxzG5.getEmceeAppListingLink)(addonKey, {
        source: source,
        installDialogOpen: installDialogOpen
    }, {}, 'DISCOVER');
    if ((0, $1ybV0.ff)('enduser-emcee-discover') && projectKey !== null && projectId !== null) return (0, $jxzG5.getEmceeAppListingLink)(addonKey, {
        source: source,
        requestDialogOpen: requestDialogOpen
    }, {
        'project.key': projectKey,
        'project.id': String(projectId)
    });
    // Project admins without jira admin will be redirected to MPAC instead, otherwise they'll see an 'Access denied' page
    return `https://marketplace.atlassian.com/apps/${addonId}`;
};
const $2555a5c87f3e28c5$var$MarketplaceAppTiles = (props)=>{
    const { StaticSearch: // @ts-expect-error - TS2339 - Property 'StaticSearch' does not exist on type 'Props'.
    StaticSearch = (0, $6XDNr.default), SearchParamsUpdate: // @ts-expect-error - TS2339 - Property 'SearchParamsUpdate' does not exist on type 'Props'.
    SearchParamsUpdate = (0, $b5Eig.default), FacetType: // @ts-expect-error - TS2339 - Property 'FacetType' does not exist on type 'Props'.
    FacetType = (0, $lwEMm.default), categoryTitle: categoryTitle, marketingLabel: marketingLabel, onSortHits: onSortHits, colSpan: colSpan, extraApp: ExtraApp, isJiraAdmin: isJiraAdmin, source: source, projectKey: projectKey, projectId: projectId, installDialogOpen: installDialogOpen, requestDialogOpen: requestDialogOpen, actionSubjectId: actionSubjectId, installInContext: installInContext, onTileClicked: onTileClicked, onAppInstallSuccess: onAppInstallSuccess, onAppInstallStarted: onAppInstallStarted, onAppInstallFailure: onAppInstallFailure, onDismissSuccessModal: onDismissSuccessModal } = props;
    const [shouldRefetch, setShouldRefetch] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        // We aren't passing the `onAppInstallSuccess` callback to children so we're instead relying on
        // children updating the `shouldRefetch` state to trigger the callback. This fixes a race condition where
        // refetching would occur before modals closed, resulting in a clunky UX. Suspect this is a symptom of
        // React.Suspense not unmounting child content rendered in portals (modals) while suspended.
        if (shouldRefetch) {
            onAppInstallSuccess?.();
            setShouldRefetch(false);
        }
    }, [
        shouldRefetch,
        onAppInstallSuccess
    ]);
    const { marketplaceDialog: marketplaceDialog, openMarketplaceDialog: openMarketplaceDialog } = (0, $eodt0.useMarketPlaceDialog)({
        requestLocation: source,
        ...(0, $eI5EY.fg)('jira_improve_scm_onboarding_gate') && {
            onDismissSuccessModal: onDismissSuccessModal
        }
    });
    const hitContext = (0, $g5DHJ.Map)({
        // @ts-expect-error - TS7031 - Binding element 'hit' implicitly has an 'any' type.
        hitHrefResolver: ({ hit: hit })=>{
            const addonKey = hit.get('addonKey');
            const addonId = hit.get('addonId');
            return $2555a5c87f3e28c5$var$buildAppUrl(addonKey, addonId, isJiraAdmin, source, projectKey, projectId, installDialogOpen, requestDialogOpen);
        },
        // @ts-expect-error - TS7031 - Binding element 'hit' implicitly has an 'any' type.
        hitImageHrefResolver: ({ hit: hit })=>{
            const logoImagePath = hit.getIn([
                'logo',
                'highRes'
            ]) || hit.getIn([
                'logo',
                'image'
            ]);
            return `https://marketplace-cdn.atlassian.com/files/${logoImagePath}`;
        },
        // onHitClick callback is required, but this also causes the anchor link to do nothing when clicked,
        // hence the window.location.href workaround here
        // @ts-expect-error - TS7031 - Binding element 'hit' implicitly has an 'any' type. | TS7031 - Binding element 'hitRank' implicitly has an 'any' type.
        onHitClick: ({ hit: hit, hitRank: hitRank })=>{
            const addonKey = hit.get('addonKey');
            const addonId = hit.get('addonId');
            onTileClicked && onTileClicked(addonKey, hitRank, isJiraAdmin, actionSubjectId, // @ts-expect-error - TS2345 - Argument of type 'number | null | undefined' is not assignable to parameter of type 'number | null'.
            projectId, projectKey);
            // We still need installInContext as we don't want in context installation for these 2 places yet:
            // * Dev details dialog - we don't have a 'onSuccess' flow here yet
            // * JSM -> Project settings -> Apps page - Fusion doesn't own this. So we can't set it to true if they don't want it or not ready for it yet.
            if (installInContext === true) {
                openMarketplaceDialog({
                    appKey: addonKey,
                    appName: hit.get('name'),
                    isAppFree: !(hit.get('version')?.get('paid') ?? true),
                    onInstallSuccess: onAppInstallSuccess,
                    onInstallStarted: onAppInstallStarted,
                    onFailure: onAppInstallFailure
                });
                return;
            }
            window.open($2555a5c87f3e28c5$var$buildAppUrl(addonKey, addonId, isJiraAdmin, source, projectKey, projectId, installDialogOpen, requestDialogOpen), '_blank');
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", null, '.app-title-font-workaround h3 { font-family: inherit; }'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2555a5c87f3e28c5$var$CategoryDiv, {
        className: "app-title-font-workaround"
    }, categoryTitle !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2555a5c87f3e28c5$var$CategoryTitleH3, null, categoryTitle) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2555a5c87f3e28c5$var$StaticSearchWrapperDiv, null, ExtraApp, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StaticSearch, {
        algoliaConfig: (0, $g5DHJ.fromJS)($2555a5c87f3e28c5$var$algoliaConfig),
        applyOverrides: new SearchParamsUpdate({
            types: (0, $g5DHJ.Set)([
                FacetType.disjunctive('marketingLabels')
            ]),
            // @ts-expect-error - TS7006 - Parameter 'params' implicitly has an 'any' type.
            apply: (params)=>params.addDisjunctiveFacetRefinement('marketingLabels', marketingLabel)
        }),
        debug: false,
        filters: $2555a5c87f3e28c5$var$landingPagesFilters,
        environment: "prod" // dev, stg, prod filters={landingPagesFilters}
        ,
        hitContext: hitContext,
        hitSize: "large",
        screenClass: "xl" // not yet using react-grid-system (should it?)
        ,
        sortHits: onSortHits,
        colSpan: colSpan
    }), marketplaceDialog)));
};
const $2555a5c87f3e28c5$var$MarketplaceAppTilesWrapped = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "marketplaceAppTiles",
        packageName: "jiraMarketplaceAppTiles",
        sendToPrivacyUnsafeSplunk: true,
        teamName: "fusion-isotopes"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5E4rM.InstallationLockProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8J0kb.AppInstallAnalyticsListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2555a5c87f3e28c5$var$MarketplaceAppTiles, props))));
var $2555a5c87f3e28c5$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $eGI9v.default)('tile', {
    onTileClicked: 'clicked'
}), (0, $8un0w.default)({
    onTileClicked: (// @ts-expect-error - TS7006 - Parameter 'addonKey' implicitly has an 'any' type.
    addonKey, // @ts-expect-error - TS7006 - Parameter 'hitRank' implicitly has an 'any' type.
    hitRank, // @ts-expect-error - TS7006 - Parameter 'isJiraAdmin' implicitly has an 'any' type.
    isJiraAdmin, // @ts-expect-error - TS7006 - Parameter 'actionSubjectId' implicitly has an 'any' type.
    actionSubjectId, // @ts-expect-error - TS7006 - Parameter 'projectId' implicitly has an 'any' type.
    projectId, // @ts-expect-error - TS7006 - Parameter 'projectKey' implicitly has an 'any' type.
    projectKey)=>({
            name: actionSubjectId,
            addonKey: addonKey,
            hitRank: hitRank,
            isJiraAdmin: isJiraAdmin,
            projectId: projectId,
            projectKey: projectKey
        })
}))($2555a5c87f3e28c5$var$MarketplaceAppTilesWrapped);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2555a5c87f3e28c5$var$CategoryDiv = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkxy5q",
            __cmplp.className
        ])
    });
});
const $2555a5c87f3e28c5$var$CategoryTitleH3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h3", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyrpxbi",
            __cmplp.className
        ])
    });
});
const $2555a5c87f3e28c5$var$StaticSearchWrapperDiv = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0x0bf _1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("g5DHJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "isImmutable", () => isImmutable);
$parcel$export(module.exports, "isCollection", () => isCollection);
$parcel$export(module.exports, "isKeyed", () => isKeyed);
$parcel$export(module.exports, "isIndexed", () => isIndexed);
$parcel$export(module.exports, "isAssociative", () => isAssociative);
$parcel$export(module.exports, "isOrdered", () => isOrdered);
$parcel$export(module.exports, "isValueObject", () => isValueObject);
$parcel$export(module.exports, "Collection", () => Collection);
$parcel$export(module.exports, "Seq", () => Seq);
$parcel$export(module.exports, "is", () => is);
$parcel$export(module.exports, "hash", () => hash);
$parcel$export(module.exports, "Map", () => Map);
$parcel$export(module.exports, "OrderedMap", () => OrderedMap);
$parcel$export(module.exports, "has", () => has);
$parcel$export(module.exports, "get", () => get);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "set", () => set);
$parcel$export(module.exports, "updateIn", () => updateIn);
$parcel$export(module.exports, "setIn", () => setIn$1);
$parcel$export(module.exports, "removeIn", () => removeIn);
$parcel$export(module.exports, "update", () => update$1);
$parcel$export(module.exports, "merge", () => merge$1);
$parcel$export(module.exports, "mergeWith", () => mergeWith$1);
$parcel$export(module.exports, "mergeDeep", () => mergeDeep$1);
$parcel$export(module.exports, "mergeDeepWith", () => mergeDeepWith$1);
$parcel$export(module.exports, "List", () => List);
$parcel$export(module.exports, "Stack", () => Stack);
$parcel$export(module.exports, "Set", () => Set);
$parcel$export(module.exports, "OrderedSet", () => OrderedSet);
$parcel$export(module.exports, "Range", () => Range);
$parcel$export(module.exports, "getIn", () => getIn$1);
$parcel$export(module.exports, "hasIn", () => hasIn$1);
$parcel$export(module.exports, "Record", () => Record);
$parcel$export(module.exports, "Repeat", () => Repeat);
$parcel$export(module.exports, "fromJS", () => fromJS);
$parcel$export(module.exports, "version", () => version);
$parcel$export(module.exports, "Iterable", () => Iterable);
$parcel$export(module.exports, "default", () => $bb6be968fd3babc9$export$2e2bcd8739ae039);
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ // Used for setting prototype methods that IE8 chokes on.
var DELETE = 'delete';
// Constants describing the size of trie nodes.
var SHIFT = 5; // Resulted in best performance after ______?
var SIZE = 1 << SHIFT;
var MASK = SIZE - 1;
// A consistent shared value representing "not set" which equals nothing other
// than itself, and nothing that could be provided externally.
var NOT_SET = {};
// Boolean references, Rough equivalent of `bool &`.
var CHANGE_LENGTH = {
    value: false
};
var DID_ALTER = {
    value: false
};
function MakeRef(ref) {
    ref.value = false;
    return ref;
}
function SetRef(ref) {
    ref && (ref.value = true);
}
// A function which returns a value representing an "owner" for transient writes
// to tries. The return value will only ever equal itself, and will not equal
// the return of any subsequent call of this function.
function OwnerID() {}
function ensureSize(iter) {
    if (iter.size === undefined) iter.size = iter.__iterate(returnTrue);
    return iter.size;
}
function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
        var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
        if ('' + uint32Index !== index || uint32Index === 4294967295) return NaN;
        index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
}
function returnTrue() {
    return true;
}
function wholeSlice(begin, end, size) {
    return (begin === 0 && !isNeg(begin) || size !== undefined && begin <= -size) && (end === undefined || size !== undefined && end >= size);
}
function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
}
function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
}
function resolveIndex(index, size, defaultIndex) {
    // Sanitize indices using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    return index === undefined ? defaultIndex : isNeg(index) ? size === Infinity ? size : Math.max(0, size + index) | 0 : size === undefined || size === index ? index : Math.min(size, index) | 0;
}
function isNeg(value) {
    // Account for -0 which is negative, but not less than 0.
    return value < 0 || value === 0 && 1 / value === -Infinity;
}
function isImmutable(maybeImmutable) {
    return isCollection(maybeImmutable) || isRecord(maybeImmutable);
}
function isCollection(maybeCollection) {
    return !!(maybeCollection && maybeCollection[IS_ITERABLE_SENTINEL]);
}
function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
}
function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
}
function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
}
function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
}
function isRecord(maybeRecord) {
    return !!(maybeRecord && maybeRecord[IS_RECORD_SENTINEL]);
}
function isValueObject(maybeValue) {
    return !!(maybeValue && typeof maybeValue.equals === 'function' && typeof maybeValue.hashCode === 'function');
}
var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
var IS_RECORD_SENTINEL = '@@__IMMUTABLE_RECORD__@@';
var Collection = function Collection(value) {
    return isCollection(value) ? value : Seq(value);
};
var KeyedCollection = function(Collection) {
    function KeyedCollection(value) {
        return isKeyed(value) ? value : KeyedSeq(value);
    }
    if (Collection) KeyedCollection.__proto__ = Collection;
    KeyedCollection.prototype = Object.create(Collection && Collection.prototype);
    KeyedCollection.prototype.constructor = KeyedCollection;
    return KeyedCollection;
}(Collection);
var IndexedCollection = function(Collection) {
    function IndexedCollection(value) {
        return isIndexed(value) ? value : IndexedSeq(value);
    }
    if (Collection) IndexedCollection.__proto__ = Collection;
    IndexedCollection.prototype = Object.create(Collection && Collection.prototype);
    IndexedCollection.prototype.constructor = IndexedCollection;
    return IndexedCollection;
}(Collection);
var SetCollection = function(Collection) {
    function SetCollection(value) {
        return isCollection(value) && !isAssociative(value) ? value : SetSeq(value);
    }
    if (Collection) SetCollection.__proto__ = Collection;
    SetCollection.prototype = Object.create(Collection && Collection.prototype);
    SetCollection.prototype.constructor = SetCollection;
    return SetCollection;
}(Collection);
Collection.Keyed = KeyedCollection;
Collection.Indexed = IndexedCollection;
Collection.Set = SetCollection;
var ITERATE_KEYS = 0;
var ITERATE_VALUES = 1;
var ITERATE_ENTRIES = 2;
var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';
var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
var Iterator = function Iterator(next) {
    this.next = next;
};
Iterator.prototype.toString = function toString() {
    return '[Iterator]';
};
Iterator.KEYS = ITERATE_KEYS;
Iterator.VALUES = ITERATE_VALUES;
Iterator.ENTRIES = ITERATE_ENTRIES;
Iterator.prototype.inspect = Iterator.prototype.toSource = function() {
    return this.toString();
};
Iterator.prototype[ITERATOR_SYMBOL] = function() {
    return this;
};
function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [
        k,
        v
    ];
    iteratorResult ? iteratorResult.value = value : iteratorResult = {
        value: value,
        done: false
    };
    return iteratorResult;
}
function iteratorDone() {
    return {
        value: undefined,
        done: true
    };
}
function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
}
function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
}
function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
}
function getIteratorFn(iterable) {
    var iteratorFn = iterable && (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL] || iterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') return iteratorFn;
}
var hasOwnProperty = Object.prototype.hasOwnProperty;
function isArrayLike(value) {
    return value && typeof value.length === 'number';
}
var Seq = function(Collection$$1) {
    function Seq(value) {
        return value === null || value === undefined ? emptySequence() : isImmutable(value) ? value.toSeq() : seqFromValue(value);
    }
    if (Collection$$1) Seq.__proto__ = Collection$$1;
    Seq.prototype = Object.create(Collection$$1 && Collection$$1.prototype);
    Seq.prototype.constructor = Seq;
    Seq.prototype.toSeq = function toSeq() {
        return this;
    };
    Seq.prototype.toString = function toString() {
        return this.__toString('Seq {', '}');
    };
    Seq.prototype.cacheResult = function cacheResult() {
        if (!this._cache && this.__iterateUncached) {
            this._cache = this.entrySeq().toArray();
            this.size = this._cache.length;
        }
        return this;
    };
    // abstract __iterateUncached(fn, reverse)
    Seq.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1 = this;
        var cache = this._cache;
        if (cache) {
            var size = cache.length;
            var i = 0;
            while(i !== size){
                var entry = cache[reverse ? size - ++i : i++];
                if (fn(entry[1], entry[0], this$1) === false) break;
            }
            return i;
        }
        return this.__iterateUncached(fn, reverse);
    };
    // abstract __iteratorUncached(type, reverse)
    Seq.prototype.__iterator = function __iterator(type, reverse) {
        var cache = this._cache;
        if (cache) {
            var size = cache.length;
            var i = 0;
            return new Iterator(function() {
                if (i === size) return iteratorDone();
                var entry = cache[reverse ? size - ++i : i++];
                return iteratorValue(type, entry[0], entry[1]);
            });
        }
        return this.__iteratorUncached(type, reverse);
    };
    return Seq;
}(Collection);
var KeyedSeq = function(Seq) {
    function KeyedSeq(value) {
        return value === null || value === undefined ? emptySequence().toKeyedSeq() : isCollection(value) ? isKeyed(value) ? value.toSeq() : value.fromEntrySeq() : isRecord(value) ? value.toSeq() : keyedSeqFromValue(value);
    }
    if (Seq) KeyedSeq.__proto__ = Seq;
    KeyedSeq.prototype = Object.create(Seq && Seq.prototype);
    KeyedSeq.prototype.constructor = KeyedSeq;
    KeyedSeq.prototype.toKeyedSeq = function toKeyedSeq() {
        return this;
    };
    return KeyedSeq;
}(Seq);
var IndexedSeq = function(Seq) {
    function IndexedSeq(value) {
        return value === null || value === undefined ? emptySequence() : isCollection(value) ? isKeyed(value) ? value.entrySeq() : value.toIndexedSeq() : isRecord(value) ? value.toSeq().entrySeq() : indexedSeqFromValue(value);
    }
    if (Seq) IndexedSeq.__proto__ = Seq;
    IndexedSeq.prototype = Object.create(Seq && Seq.prototype);
    IndexedSeq.prototype.constructor = IndexedSeq;
    IndexedSeq.of = function of() {
        return IndexedSeq(arguments);
    };
    IndexedSeq.prototype.toIndexedSeq = function toIndexedSeq() {
        return this;
    };
    IndexedSeq.prototype.toString = function toString() {
        return this.__toString('Seq [', ']');
    };
    return IndexedSeq;
}(Seq);
var SetSeq = function(Seq) {
    function SetSeq(value) {
        return (isCollection(value) && !isAssociative(value) ? value : IndexedSeq(value)).toSetSeq();
    }
    if (Seq) SetSeq.__proto__ = Seq;
    SetSeq.prototype = Object.create(Seq && Seq.prototype);
    SetSeq.prototype.constructor = SetSeq;
    SetSeq.of = function of() {
        return SetSeq(arguments);
    };
    SetSeq.prototype.toSetSeq = function toSetSeq() {
        return this;
    };
    return SetSeq;
}(Seq);
Seq.isSeq = isSeq;
Seq.Keyed = KeyedSeq;
Seq.Set = SetSeq;
Seq.Indexed = IndexedSeq;
var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
Seq.prototype[IS_SEQ_SENTINEL] = true;
// #pragma Root Sequences
var ArraySeq = function(IndexedSeq) {
    function ArraySeq(array) {
        this._array = array;
        this.size = array.length;
    }
    if (IndexedSeq) ArraySeq.__proto__ = IndexedSeq;
    ArraySeq.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    ArraySeq.prototype.constructor = ArraySeq;
    ArraySeq.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };
    ArraySeq.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1 = this;
        var array = this._array;
        var size = array.length;
        var i = 0;
        while(i !== size){
            var ii = reverse ? size - ++i : i++;
            if (fn(array[ii], ii, this$1) === false) break;
        }
        return i;
    };
    ArraySeq.prototype.__iterator = function __iterator(type, reverse) {
        var array = this._array;
        var size = array.length;
        var i = 0;
        return new Iterator(function() {
            if (i === size) return iteratorDone();
            var ii = reverse ? size - ++i : i++;
            return iteratorValue(type, ii, array[ii]);
        });
    };
    return ArraySeq;
}(IndexedSeq);
var ObjectSeq = function(KeyedSeq) {
    function ObjectSeq(object) {
        var keys = Object.keys(object);
        this._object = object;
        this._keys = keys;
        this.size = keys.length;
    }
    if (KeyedSeq) ObjectSeq.__proto__ = KeyedSeq;
    ObjectSeq.prototype = Object.create(KeyedSeq && KeyedSeq.prototype);
    ObjectSeq.prototype.constructor = ObjectSeq;
    ObjectSeq.prototype.get = function get(key, notSetValue) {
        if (notSetValue !== undefined && !this.has(key)) return notSetValue;
        return this._object[key];
    };
    ObjectSeq.prototype.has = function has(key) {
        return hasOwnProperty.call(this._object, key);
    };
    ObjectSeq.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1 = this;
        var object = this._object;
        var keys = this._keys;
        var size = keys.length;
        var i = 0;
        while(i !== size){
            var key = keys[reverse ? size - ++i : i++];
            if (fn(object[key], key, this$1) === false) break;
        }
        return i;
    };
    ObjectSeq.prototype.__iterator = function __iterator(type, reverse) {
        var object = this._object;
        var keys = this._keys;
        var size = keys.length;
        var i = 0;
        return new Iterator(function() {
            if (i === size) return iteratorDone();
            var key = keys[reverse ? size - ++i : i++];
            return iteratorValue(type, key, object[key]);
        });
    };
    return ObjectSeq;
}(KeyedSeq);
ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
var CollectionSeq = function(IndexedSeq) {
    function CollectionSeq(collection) {
        this._collection = collection;
        this.size = collection.length || collection.size;
    }
    if (IndexedSeq) CollectionSeq.__proto__ = IndexedSeq;
    CollectionSeq.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    CollectionSeq.prototype.constructor = CollectionSeq;
    CollectionSeq.prototype.__iterateUncached = function __iterateUncached(fn, reverse) {
        var this$1 = this;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var collection = this._collection;
        var iterator = getIterator(collection);
        var iterations = 0;
        if (isIterator(iterator)) {
            var step;
            while(!(step = iterator.next()).done){
                if (fn(step.value, iterations++, this$1) === false) break;
            }
        }
        return iterations;
    };
    CollectionSeq.prototype.__iteratorUncached = function __iteratorUncached(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var collection = this._collection;
        var iterator = getIterator(collection);
        if (!isIterator(iterator)) return new Iterator(iteratorDone);
        var iterations = 0;
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, iterations++, step.value);
        });
    };
    return CollectionSeq;
}(IndexedSeq);
var IteratorSeq = function(IndexedSeq) {
    function IteratorSeq(iterator) {
        this._iterator = iterator;
        this._iteratorCache = [];
    }
    if (IndexedSeq) IteratorSeq.__proto__ = IndexedSeq;
    IteratorSeq.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    IteratorSeq.prototype.constructor = IteratorSeq;
    IteratorSeq.prototype.__iterateUncached = function __iterateUncached(fn, reverse) {
        var this$1 = this;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterator = this._iterator;
        var cache = this._iteratorCache;
        var iterations = 0;
        while(iterations < cache.length){
            if (fn(cache[iterations], iterations++, this$1) === false) return iterations;
        }
        var step;
        while(!(step = iterator.next()).done){
            var val = step.value;
            cache[iterations] = val;
            if (fn(val, iterations++, this$1) === false) break;
        }
        return iterations;
    };
    IteratorSeq.prototype.__iteratorUncached = function __iteratorUncached(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = this._iterator;
        var cache = this._iteratorCache;
        var iterations = 0;
        return new Iterator(function() {
            if (iterations >= cache.length) {
                var step = iterator.next();
                if (step.done) return step;
                cache[iterations] = step.value;
            }
            return iteratorValue(type, iterations, cache[iterations++]);
        });
    };
    return IteratorSeq;
}(IndexedSeq);
// # pragma Helper functions
function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
}
var EMPTY_SEQ;
function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
}
function keyedSeqFromValue(value) {
    var seq = Array.isArray(value) ? new ArraySeq(value) : isIterator(value) ? new IteratorSeq(value) : hasIterator(value) ? new CollectionSeq(value) : undefined;
    if (seq) return seq.fromEntrySeq();
    if (typeof value === 'object') return new ObjectSeq(value);
    throw new TypeError('Expected Array or collection object of [k, v] entries, or keyed object: ' + value);
}
function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (seq) return seq;
    throw new TypeError('Expected Array or collection object of values: ' + value);
}
function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (seq) return seq;
    if (typeof value === 'object') return new ObjectSeq(value);
    throw new TypeError('Expected Array or collection object of values, or keyed object: ' + value);
}
function maybeIndexedSeqFromValue(value) {
    return isArrayLike(value) ? new ArraySeq(value) : isIterator(value) ? new IteratorSeq(value) : hasIterator(value) ? new CollectionSeq(value) : undefined;
}
/**
 * An extension of the "same-value" algorithm as [described for use by ES6 Map
 * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
 *
 * NaN is considered the same as NaN, however -0 and 0 are considered the same
 * value, which is different from the algorithm described by
 * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
 *
 * This is extended further to allow Objects to describe the values they
 * represent, by way of `valueOf` or `equals` (and `hashCode`).
 *
 * Note: because of this extension, the key equality of Immutable.Map and the
 * value equality of Immutable.Set will differ from ES6 Map and Set.
 *
 * ### Defining custom values
 *
 * The easiest way to describe the value an object represents is by implementing
 * `valueOf`. For example, `Date` represents a value by returning a unix
 * timestamp for `valueOf`:
 *
 *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
 *     var date2 = new Date(1234567890000);
 *     date1.valueOf(); // 1234567890000
 *     assert( date1 !== date2 );
 *     assert( Immutable.is( date1, date2 ) );
 *
 * Note: overriding `valueOf` may have other implications if you use this object
 * where JavaScript expects a primitive, such as implicit string coercion.
 *
 * For more complex types, especially collections, implementing `valueOf` may
 * not be performant. An alternative is to implement `equals` and `hashCode`.
 *
 * `equals` takes another object, presumably of similar type, and returns true
 * if it is equal. Equality is symmetrical, so the same result should be
 * returned if this and the argument are flipped.
 *
 *     assert( a.equals(b) === b.equals(a) );
 *
 * `hashCode` returns a 32bit integer number representing the object which will
 * be used to determine how to store the value object in a Map or Set. You must
 * provide both or neither methods, one must not exist without the other.
 *
 * Also, an important relationship between these methods must be upheld: if two
 * values are equal, they *must* return the same hashCode. If the values are not
 * equal, they might have the same hashCode; this is called a hash collision,
 * and while undesirable for performance reasons, it is acceptable.
 *
 *     if (a.equals(b)) {
 *       assert( a.hashCode() === b.hashCode() );
 *     }
 *
 * All Immutable collections are Value Objects: they implement `equals()`
 * and `hashCode()`.
 */ function is(valueA, valueB) {
    if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
    if (!valueA || !valueB) return false;
    if (typeof valueA.valueOf === 'function' && typeof valueB.valueOf === 'function') {
        valueA = valueA.valueOf();
        valueB = valueB.valueOf();
        if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
        if (!valueA || !valueB) return false;
    }
    return !!(isValueObject(valueA) && isValueObject(valueB) && valueA.equals(valueB));
}
var imul = typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ? Math.imul : function imul(a, b) {
    a |= 0; // int
    b |= 0; // int
    var c = a & 0xffff;
    var d = b & 0xffff;
    // Shift by 0 fixes the sign on the high part.
    return c * d + ((a >>> 16) * d + c * (b >>> 16) << 16 >>> 0) | 0; // int
};
// v8 has an optimization for storing 31-bit signed numbers.
// Values which have either 00 or 11 as the high order bits qualify.
// This function drops the highest order bit in a signed number, maintaining
// the sign bit.
function smi(i32) {
    return i32 >>> 1 & 0x40000000 | i32 & 0xbfffffff;
}
function hash(o) {
    if (o === false || o === null || o === undefined) return 0;
    if (typeof o.valueOf === 'function') {
        o = o.valueOf();
        if (o === false || o === null || o === undefined) return 0;
    }
    if (o === true) return 1;
    var type = typeof o;
    if (type === 'number') {
        if (o !== o || o === Infinity) return 0;
        var h = o | 0;
        if (h !== o) h ^= o * 0xffffffff;
        while(o > 0xffffffff){
            o /= 0xffffffff;
            h ^= o;
        }
        return smi(h);
    }
    if (type === 'string') return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    if (typeof o.hashCode === 'function') // Drop any high bits from accidentally long hash codes.
    return smi(o.hashCode());
    if (type === 'object') return hashJSObj(o);
    if (typeof o.toString === 'function') return hashString(o.toString());
    throw new Error('Value type ' + type + ' cannot be hashed.');
}
function cachedHashString(string) {
    var hashed = stringHashCache[string];
    if (hashed === undefined) {
        hashed = hashString(string);
        if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
            STRING_HASH_CACHE_SIZE = 0;
            stringHashCache = {};
        }
        STRING_HASH_CACHE_SIZE++;
        stringHashCache[string] = hashed;
    }
    return hashed;
}
// http://jsperf.com/hashing-strings
function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hashed = 0;
    for(var ii = 0; ii < string.length; ii++)hashed = 31 * hashed + string.charCodeAt(ii) | 0;
    return smi(hashed);
}
function hashJSObj(obj) {
    var hashed;
    if (usingWeakMap) {
        hashed = weakMap.get(obj);
        if (hashed !== undefined) return hashed;
    }
    hashed = obj[UID_HASH_KEY];
    if (hashed !== undefined) return hashed;
    if (!canDefineProperty) {
        hashed = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
        if (hashed !== undefined) return hashed;
        hashed = getIENodeHash(obj);
        if (hashed !== undefined) return hashed;
    }
    hashed = ++objHashUID;
    if (objHashUID & 0x40000000) objHashUID = 0;
    if (usingWeakMap) weakMap.set(obj, hashed);
    else if (isExtensible !== undefined && isExtensible(obj) === false) throw new Error('Non-extensible objects are not allowed as keys.');
    else if (canDefineProperty) Object.defineProperty(obj, UID_HASH_KEY, {
        enumerable: false,
        configurable: false,
        writable: false,
        value: hashed
    });
    else if (obj.propertyIsEnumerable !== undefined && obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
        // Since we can't define a non-enumerable property on the object
        // we'll hijack one of the less-used non-enumerable properties to
        // save our hash on it. Since this is a function it will not show up in
        // `JSON.stringify` which is what we want.
        obj.propertyIsEnumerable = function() {
            return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
        };
        obj.propertyIsEnumerable[UID_HASH_KEY] = hashed;
    } else if (obj.nodeType !== undefined) // At this point we couldn't get the IE `uniqueID` to use as a hash
    // and we couldn't use a non-enumerable property to exploit the
    // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
    // itself.
    obj[UID_HASH_KEY] = hashed;
    else throw new Error('Unable to set a non-enumerable property on object.');
    return hashed;
}
// Get references to ES5 object methods.
var isExtensible = Object.isExtensible;
// True if Object.defineProperty works as expected. IE8 fails this test.
var canDefineProperty = function() {
    try {
        Object.defineProperty({}, '@', {});
        return true;
    } catch (e) {
        return false;
    }
}();
// IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
// and avoid memory leaks from the IE cloneNode bug.
function getIENodeHash(node) {
    if (node && node.nodeType > 0) switch(node.nodeType){
        case 1:
            return node.uniqueID;
        case 9:
            return node.documentElement && node.documentElement.uniqueID;
    }
}
// If possible, use a WeakMap.
var usingWeakMap = typeof WeakMap === 'function';
var weakMap;
if (usingWeakMap) weakMap = new WeakMap();
var objHashUID = 0;
var UID_HASH_KEY = '__immutablehash__';
if (typeof Symbol === 'function') UID_HASH_KEY = Symbol(UID_HASH_KEY);
var STRING_HASH_CACHE_MIN_STRLEN = 16;
var STRING_HASH_CACHE_MAX_SIZE = 255;
var STRING_HASH_CACHE_SIZE = 0;
var stringHashCache = {};
var ToKeyedSequence = function(KeyedSeq$$1) {
    function ToKeyedSequence(indexed, useKeys) {
        this._iter = indexed;
        this._useKeys = useKeys;
        this.size = indexed.size;
    }
    if (KeyedSeq$$1) ToKeyedSequence.__proto__ = KeyedSeq$$1;
    ToKeyedSequence.prototype = Object.create(KeyedSeq$$1 && KeyedSeq$$1.prototype);
    ToKeyedSequence.prototype.constructor = ToKeyedSequence;
    ToKeyedSequence.prototype.get = function get(key, notSetValue) {
        return this._iter.get(key, notSetValue);
    };
    ToKeyedSequence.prototype.has = function has(key) {
        return this._iter.has(key);
    };
    ToKeyedSequence.prototype.valueSeq = function valueSeq() {
        return this._iter.valueSeq();
    };
    ToKeyedSequence.prototype.reverse = function reverse() {
        var this$1 = this;
        var reversedSequence = reverseFactory(this, true);
        if (!this._useKeys) reversedSequence.valueSeq = function() {
            return this$1._iter.toSeq().reverse();
        };
        return reversedSequence;
    };
    ToKeyedSequence.prototype.map = function map(mapper, context) {
        var this$1 = this;
        var mappedSequence = mapFactory(this, mapper, context);
        if (!this._useKeys) mappedSequence.valueSeq = function() {
            return this$1._iter.toSeq().map(mapper, context);
        };
        return mappedSequence;
    };
    ToKeyedSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1 = this;
        return this._iter.__iterate(function(v, k) {
            return fn(v, k, this$1);
        }, reverse);
    };
    ToKeyedSequence.prototype.__iterator = function __iterator(type, reverse) {
        return this._iter.__iterator(type, reverse);
    };
    return ToKeyedSequence;
}(KeyedSeq);
ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
var ToIndexedSequence = function(IndexedSeq$$1) {
    function ToIndexedSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    if (IndexedSeq$$1) ToIndexedSequence.__proto__ = IndexedSeq$$1;
    ToIndexedSequence.prototype = Object.create(IndexedSeq$$1 && IndexedSeq$$1.prototype);
    ToIndexedSequence.prototype.constructor = ToIndexedSequence;
    ToIndexedSequence.prototype.includes = function includes(value) {
        return this._iter.includes(value);
    };
    ToIndexedSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1 = this;
        var i = 0;
        reverse && ensureSize(this);
        return this._iter.__iterate(function(v) {
            return fn(v, reverse ? this$1.size - ++i : i++, this$1);
        }, reverse);
    };
    ToIndexedSequence.prototype.__iterator = function __iterator(type, reverse) {
        var this$1 = this;
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        var i = 0;
        reverse && ensureSize(this);
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, reverse ? this$1.size - ++i : i++, step.value, step);
        });
    };
    return ToIndexedSequence;
}(IndexedSeq);
var ToSetSequence = function(SetSeq$$1) {
    function ToSetSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    if (SetSeq$$1) ToSetSequence.__proto__ = SetSeq$$1;
    ToSetSequence.prototype = Object.create(SetSeq$$1 && SetSeq$$1.prototype);
    ToSetSequence.prototype.constructor = ToSetSequence;
    ToSetSequence.prototype.has = function has(key) {
        return this._iter.includes(key);
    };
    ToSetSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1 = this;
        return this._iter.__iterate(function(v) {
            return fn(v, v, this$1);
        }, reverse);
    };
    ToSetSequence.prototype.__iterator = function __iterator(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, step.value, step.value, step);
        });
    };
    return ToSetSequence;
}(SetSeq);
var FromEntriesSequence = function(KeyedSeq$$1) {
    function FromEntriesSequence(entries) {
        this._iter = entries;
        this.size = entries.size;
    }
    if (KeyedSeq$$1) FromEntriesSequence.__proto__ = KeyedSeq$$1;
    FromEntriesSequence.prototype = Object.create(KeyedSeq$$1 && KeyedSeq$$1.prototype);
    FromEntriesSequence.prototype.constructor = FromEntriesSequence;
    FromEntriesSequence.prototype.entrySeq = function entrySeq() {
        return this._iter.toSeq();
    };
    FromEntriesSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1 = this;
        return this._iter.__iterate(function(entry) {
            // Check if entry exists first so array access doesn't throw for holes
            // in the parent iteration.
            if (entry) {
                validateEntry(entry);
                var indexedCollection = isCollection(entry);
                return fn(indexedCollection ? entry.get(1) : entry[1], indexedCollection ? entry.get(0) : entry[0], this$1);
            }
        }, reverse);
    };
    FromEntriesSequence.prototype.__iterator = function __iterator(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        return new Iterator(function() {
            while(true){
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                // Check if entry exists first so array access doesn't throw for holes
                // in the parent iteration.
                if (entry) {
                    validateEntry(entry);
                    var indexedCollection = isCollection(entry);
                    return iteratorValue(type, indexedCollection ? entry.get(0) : entry[0], indexedCollection ? entry.get(1) : entry[1], step);
                }
            }
        });
    };
    return FromEntriesSequence;
}(KeyedSeq);
ToIndexedSequence.prototype.cacheResult = ToKeyedSequence.prototype.cacheResult = ToSetSequence.prototype.cacheResult = FromEntriesSequence.prototype.cacheResult = cacheResultThrough;
function flipFactory(collection) {
    var flipSequence = makeSequence(collection);
    flipSequence._iter = collection;
    flipSequence.size = collection.size;
    flipSequence.flip = function() {
        return collection;
    };
    flipSequence.reverse = function() {
        var reversedSequence = collection.reverse.apply(this); // super.reverse()
        reversedSequence.flip = function() {
            return collection.reverse();
        };
        return reversedSequence;
    };
    flipSequence.has = function(key) {
        return collection.includes(key);
    };
    flipSequence.includes = function(key) {
        return collection.has(key);
    };
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function(fn, reverse) {
        var this$1 = this;
        return collection.__iterate(function(v, k) {
            return fn(k, v, this$1) !== false;
        }, reverse);
    };
    flipSequence.__iteratorUncached = function(type, reverse) {
        if (type === ITERATE_ENTRIES) {
            var iterator = collection.__iterator(type, reverse);
            return new Iterator(function() {
                var step = iterator.next();
                if (!step.done) {
                    var k = step.value[0];
                    step.value[0] = step.value[1];
                    step.value[1] = k;
                }
                return step;
            });
        }
        return collection.__iterator(type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES, reverse);
    };
    return flipSequence;
}
function mapFactory(collection, mapper, context) {
    var mappedSequence = makeSequence(collection);
    mappedSequence.size = collection.size;
    mappedSequence.has = function(key) {
        return collection.has(key);
    };
    mappedSequence.get = function(key, notSetValue) {
        var v = collection.get(key, NOT_SET);
        return v === NOT_SET ? notSetValue : mapper.call(context, v, key, collection);
    };
    mappedSequence.__iterateUncached = function(fn, reverse) {
        var this$1 = this;
        return collection.__iterate(function(v, k, c) {
            return fn(mapper.call(context, v, k, c), k, this$1) !== false;
        }, reverse);
    };
    mappedSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        return new Iterator(function() {
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            var key = entry[0];
            return iteratorValue(type, key, mapper.call(context, entry[1], key, collection), step);
        });
    };
    return mappedSequence;
}
function reverseFactory(collection, useKeys) {
    var this$1 = this;
    var reversedSequence = makeSequence(collection);
    reversedSequence._iter = collection;
    reversedSequence.size = collection.size;
    reversedSequence.reverse = function() {
        return collection;
    };
    if (collection.flip) reversedSequence.flip = function() {
        var flipSequence = flipFactory(collection);
        flipSequence.reverse = function() {
            return collection.flip();
        };
        return flipSequence;
    };
    reversedSequence.get = function(key, notSetValue) {
        return collection.get(useKeys ? key : -1 - key, notSetValue);
    };
    reversedSequence.has = function(key) {
        return collection.has(useKeys ? key : -1 - key);
    };
    reversedSequence.includes = function(value) {
        return collection.includes(value);
    };
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function(fn, reverse) {
        var this$1 = this;
        var i = 0;
        reverse && ensureSize(collection);
        return collection.__iterate(function(v, k) {
            return fn(v, useKeys ? k : reverse ? this$1.size - ++i : i++, this$1);
        }, !reverse);
    };
    reversedSequence.__iterator = function(type, reverse) {
        var i = 0;
        reverse && ensureSize(collection);
        var iterator = collection.__iterator(ITERATE_ENTRIES, !reverse);
        return new Iterator(function() {
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            return iteratorValue(type, useKeys ? entry[0] : reverse ? this$1.size - ++i : i++, entry[1], step);
        });
    };
    return reversedSequence;
}
function filterFactory(collection, predicate, context, useKeys) {
    var filterSequence = makeSequence(collection);
    if (useKeys) {
        filterSequence.has = function(key) {
            var v = collection.get(key, NOT_SET);
            return v !== NOT_SET && !!predicate.call(context, v, key, collection);
        };
        filterSequence.get = function(key, notSetValue) {
            var v = collection.get(key, NOT_SET);
            return v !== NOT_SET && predicate.call(context, v, key, collection) ? v : notSetValue;
        };
    }
    filterSequence.__iterateUncached = function(fn, reverse) {
        var this$1 = this;
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            if (predicate.call(context, v, k, c)) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1);
            }
        }, reverse);
        return iterations;
    };
    filterSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        var iterations = 0;
        return new Iterator(function() {
            while(true){
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                var key = entry[0];
                var value = entry[1];
                if (predicate.call(context, value, key, collection)) return iteratorValue(type, useKeys ? key : iterations++, value, step);
            }
        });
    };
    return filterSequence;
}
function countByFactory(collection, grouper, context) {
    var groups = Map().asMutable();
    collection.__iterate(function(v, k) {
        groups.update(grouper.call(context, v, k, collection), 0, function(a) {
            return a + 1;
        });
    });
    return groups.asImmutable();
}
function groupByFactory(collection, grouper, context) {
    var isKeyedIter = isKeyed(collection);
    var groups = (isOrdered(collection) ? OrderedMap() : Map()).asMutable();
    collection.__iterate(function(v, k) {
        groups.update(grouper.call(context, v, k, collection), function(a) {
            return a = a || [], a.push(isKeyedIter ? [
                k,
                v
            ] : v), a;
        });
    });
    var coerce = collectionClass(collection);
    return groups.map(function(arr) {
        return reify(collection, coerce(arr));
    });
}
function sliceFactory(collection, begin, end, useKeys) {
    var originalSize = collection.size;
    if (wholeSlice(begin, end, originalSize)) return collection;
    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);
    // begin or end will be NaN if they were provided as negative numbers and
    // this collection's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) return sliceFactory(collection.toSeq().cacheResult(), begin, end, useKeys);
    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    var sliceSeq = makeSequence(collection);
    // If collection.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : collection.size && sliceSize || undefined;
    if (!useKeys && isSeq(collection) && sliceSize >= 0) sliceSeq.get = function(index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ? collection.get(index + resolvedBegin, notSetValue) : notSetValue;
    };
    sliceSeq.__iterateUncached = function(fn, reverse) {
        var this$1 = this;
        if (sliceSize === 0) return 0;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var skipped = 0;
        var isSkipping = true;
        var iterations = 0;
        collection.__iterate(function(v, k) {
            if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1) !== false && iterations !== sliceSize;
            }
        });
        return iterations;
    };
    sliceSeq.__iteratorUncached = function(type, reverse) {
        if (sliceSize !== 0 && reverse) return this.cacheResult().__iterator(type, reverse);
        // Don't bother instantiating parent iterator if taking 0.
        if (sliceSize === 0) return new Iterator(iteratorDone);
        var iterator = collection.__iterator(type, reverse);
        var skipped = 0;
        var iterations = 0;
        return new Iterator(function() {
            while(skipped++ < resolvedBegin)iterator.next();
            if (++iterations > sliceSize) return iteratorDone();
            var step = iterator.next();
            if (useKeys || type === ITERATE_VALUES || step.done) return step;
            if (type === ITERATE_KEYS) return iteratorValue(type, iterations - 1, undefined, step);
            return iteratorValue(type, iterations - 1, step.value[1], step);
        });
    };
    return sliceSeq;
}
function takeWhileFactory(collection, predicate, context) {
    var takeSequence = makeSequence(collection);
    takeSequence.__iterateUncached = function(fn, reverse) {
        var this$1 = this;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$1);
        });
        return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {
        var this$1 = this;
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        var iterating = true;
        return new Iterator(function() {
            if (!iterating) return iteratorDone();
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            var k = entry[0];
            var v = entry[1];
            if (!predicate.call(context, v, k, this$1)) {
                iterating = false;
                return iteratorDone();
            }
            return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
        });
    };
    return takeSequence;
}
function skipWhileFactory(collection, predicate, context, useKeys) {
    var skipSequence = makeSequence(collection);
    skipSequence.__iterateUncached = function(fn, reverse) {
        var this$1 = this;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var isSkipping = true;
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1);
            }
        });
        return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {
        var this$1 = this;
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        var skipping = true;
        var iterations = 0;
        return new Iterator(function() {
            var step;
            var k;
            var v;
            do {
                step = iterator.next();
                if (step.done) {
                    if (useKeys || type === ITERATE_VALUES) return step;
                    if (type === ITERATE_KEYS) return iteratorValue(type, iterations++, undefined, step);
                    return iteratorValue(type, iterations++, step.value[1], step);
                }
                var entry = step.value;
                k = entry[0];
                v = entry[1];
                skipping && (skipping = predicate.call(context, v, k, this$1));
            }while (skipping);
            return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
        });
    };
    return skipSequence;
}
function concatFactory(collection, values) {
    var isKeyedCollection = isKeyed(collection);
    var iters = [
        collection
    ].concat(values).map(function(v) {
        if (!isCollection(v)) v = isKeyedCollection ? keyedSeqFromValue(v) : indexedSeqFromValue(Array.isArray(v) ? v : [
            v
        ]);
        else if (isKeyedCollection) v = KeyedCollection(v);
        return v;
    }).filter(function(v) {
        return v.size !== 0;
    });
    if (iters.length === 0) return collection;
    if (iters.length === 1) {
        var singleton = iters[0];
        if (singleton === collection || isKeyedCollection && isKeyed(singleton) || isIndexed(collection) && isIndexed(singleton)) return singleton;
    }
    var concatSeq = new ArraySeq(iters);
    if (isKeyedCollection) concatSeq = concatSeq.toKeyedSeq();
    else if (!isIndexed(collection)) concatSeq = concatSeq.toSetSeq();
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(function(sum, seq) {
        if (sum !== undefined) {
            var size = seq.size;
            if (size !== undefined) return sum + size;
        }
    }, 0);
    return concatSeq;
}
function flattenFactory(collection, depth, useKeys) {
    var flatSequence = makeSequence(collection);
    flatSequence.__iterateUncached = function(fn, reverse) {
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterations = 0;
        var stopped = false;
        function flatDeep(iter, currentDepth) {
            iter.__iterate(function(v, k) {
                if ((!depth || currentDepth < depth) && isCollection(v)) flatDeep(v, currentDepth + 1);
                else {
                    iterations++;
                    if (fn(v, useKeys ? k : iterations - 1, flatSequence) === false) stopped = true;
                }
                return !stopped;
            }, reverse);
        }
        flatDeep(collection, 0);
        return iterations;
    };
    flatSequence.__iteratorUncached = function(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator(type, reverse);
        var stack = [];
        var iterations = 0;
        return new Iterator(function() {
            while(iterator){
                var step = iterator.next();
                if (step.done !== false) {
                    iterator = stack.pop();
                    continue;
                }
                var v = step.value;
                if (type === ITERATE_ENTRIES) v = v[1];
                if ((!depth || stack.length < depth) && isCollection(v)) {
                    stack.push(iterator);
                    iterator = v.__iterator(type, reverse);
                } else return useKeys ? step : iteratorValue(type, iterations++, v, step);
            }
            return iteratorDone();
        });
    };
    return flatSequence;
}
function flatMapFactory(collection, mapper, context) {
    var coerce = collectionClass(collection);
    return collection.toSeq().map(function(v, k) {
        return coerce(mapper.call(context, v, k, collection));
    }).flatten(true);
}
function interposeFactory(collection, separator) {
    var interposedSequence = makeSequence(collection);
    interposedSequence.size = collection.size && collection.size * 2 - 1;
    interposedSequence.__iterateUncached = function(fn, reverse) {
        var this$1 = this;
        var iterations = 0;
        collection.__iterate(function(v) {
            return (!iterations || fn(separator, iterations++, this$1) !== false) && fn(v, iterations++, this$1) !== false;
        }, reverse);
        return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator(ITERATE_VALUES, reverse);
        var iterations = 0;
        var step;
        return new Iterator(function() {
            if (!step || iterations % 2) {
                step = iterator.next();
                if (step.done) return step;
            }
            return iterations % 2 ? iteratorValue(type, iterations++, separator) : iteratorValue(type, iterations++, step.value, step);
        });
    };
    return interposedSequence;
}
function sortFactory(collection, comparator, mapper) {
    if (!comparator) comparator = defaultComparator;
    var isKeyedCollection = isKeyed(collection);
    var index = 0;
    var entries = collection.toSeq().map(function(v, k) {
        return [
            k,
            v,
            index++,
            mapper ? mapper(v, k, collection) : v
        ];
    }).valueSeq().toArray();
    entries.sort(function(a, b) {
        return comparator(a[3], b[3]) || a[2] - b[2];
    }).forEach(isKeyedCollection ? function(v, i) {
        entries[i].length = 2;
    } : function(v, i) {
        entries[i] = v[1];
    });
    return isKeyedCollection ? KeyedSeq(entries) : isIndexed(collection) ? IndexedSeq(entries) : SetSeq(entries);
}
function maxFactory(collection, comparator, mapper) {
    if (!comparator) comparator = defaultComparator;
    if (mapper) {
        var entry = collection.toSeq().map(function(v, k) {
            return [
                v,
                mapper(v, k, collection)
            ];
        }).reduce(function(a, b) {
            return maxCompare(comparator, a[1], b[1]) ? b : a;
        });
        return entry && entry[0];
    }
    return collection.reduce(function(a, b) {
        return maxCompare(comparator, a, b) ? b : a;
    });
}
function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return comp === 0 && b !== a && (b === undefined || b === null || b !== b) || comp > 0;
}
function zipWithFactory(keyIter, zipper, iters, zipAll) {
    var zipSequence = makeSequence(keyIter);
    var sizes = new ArraySeq(iters).map(function(i) {
        return i.size;
    });
    zipSequence.size = zipAll ? sizes.max() : sizes.min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
        var this$1 = this;
        /* generic:
    var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
    var step;
    var iterations = 0;
    while (!(step = iterator.next()).done) {
      iterations++;
      if (fn(step.value[1], step.value[0], this) === false) {
        break;
      }
    }
    return iterations;
    */ // indexed:
        var iterator = this.__iterator(ITERATE_VALUES, reverse);
        var step;
        var iterations = 0;
        while(!(step = iterator.next()).done){
            if (fn(step.value, iterations++, this$1) === false) break;
        }
        return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
        var iterators = iters.map(function(i) {
            return i = Collection(i), getIterator(reverse ? i.reverse() : i);
        });
        var iterations = 0;
        var isDone = false;
        return new Iterator(function() {
            var steps;
            if (!isDone) {
                steps = iterators.map(function(i) {
                    return i.next();
                });
                isDone = zipAll ? steps.every(function(s) {
                    return s.done;
                }) : steps.some(function(s) {
                    return s.done;
                });
            }
            if (isDone) return iteratorDone();
            return iteratorValue(type, iterations++, zipper.apply(null, steps.map(function(s) {
                return s.value;
            })));
        });
    };
    return zipSequence;
}
// #pragma Helper Functions
function reify(iter, seq) {
    return iter === seq ? iter : isSeq(iter) ? seq : iter.constructor(seq);
}
function validateEntry(entry) {
    if (entry !== Object(entry)) throw new TypeError('Expected [K, V] tuple: ' + entry);
}
function collectionClass(collection) {
    return isKeyed(collection) ? KeyedCollection : isIndexed(collection) ? IndexedCollection : SetCollection;
}
function makeSequence(collection) {
    return Object.create((isKeyed(collection) ? KeyedSeq : isIndexed(collection) ? IndexedSeq : SetSeq).prototype);
}
function cacheResultThrough() {
    if (this._iter.cacheResult) {
        this._iter.cacheResult();
        this.size = this._iter.size;
        return this;
    }
    return Seq.prototype.cacheResult.call(this);
}
function defaultComparator(a, b) {
    if (a === undefined && b === undefined) return 0;
    if (a === undefined) return 1;
    if (b === undefined) return -1;
    return a > b ? 1 : a < b ? -1 : 0;
}
// http://jsperf.com/copy-array-inline
function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for(var ii = 0; ii < len; ii++)newArr[ii] = arr[ii + offset];
    return newArr;
}
function invariant(condition, error) {
    if (!condition) throw new Error(error);
}
function assertNotInfinite(size) {
    invariant(size !== Infinity, 'Cannot perform this action with an infinite size.');
}
function coerceKeyPath(keyPath) {
    if (isArrayLike(keyPath) && typeof keyPath !== 'string') return keyPath;
    if (isOrdered(keyPath)) return keyPath.toArray();
    throw new TypeError('Invalid keyPath: expected Ordered Collection or Array: ' + keyPath);
}
function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
}
/**
 * Returns true if the value is a potentially-persistent data structure, either
 * provided by Immutable.js or a plain Array or Object.
 */ function isDataStructure(value) {
    return isImmutable(value) || Array.isArray(value) || isPlainObj(value);
}
/**
 * Converts a value to a string, adding quotes if a string was provided.
 */ function quoteString(value) {
    try {
        return typeof value === 'string' ? JSON.stringify(value) : String(value);
    } catch (_ignoreError) {
        return JSON.stringify(value);
    }
}
function has(collection, key) {
    return isImmutable(collection) ? collection.has(key) : isDataStructure(collection) && hasOwnProperty.call(collection, key);
}
function get(collection, key, notSetValue) {
    return isImmutable(collection) ? collection.get(key, notSetValue) : !has(collection, key) ? notSetValue : typeof collection.get === 'function' ? collection.get(key) : collection[key];
}
function shallowCopy(from) {
    if (Array.isArray(from)) return arrCopy(from);
    var to = {};
    for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
    return to;
}
function remove(collection, key) {
    if (!isDataStructure(collection)) throw new TypeError('Cannot update non-data-structure value: ' + collection);
    if (isImmutable(collection)) {
        if (!collection.remove) throw new TypeError('Cannot update immutable value without .remove() method: ' + collection);
        return collection.remove(key);
    }
    if (!hasOwnProperty.call(collection, key)) return collection;
    var collectionCopy = shallowCopy(collection);
    if (Array.isArray(collectionCopy)) collectionCopy.splice(key, 1);
    else delete collectionCopy[key];
    return collectionCopy;
}
function set(collection, key, value) {
    if (!isDataStructure(collection)) throw new TypeError('Cannot update non-data-structure value: ' + collection);
    if (isImmutable(collection)) {
        if (!collection.set) throw new TypeError('Cannot update immutable value without .set() method: ' + collection);
        return collection.set(key, value);
    }
    if (hasOwnProperty.call(collection, key) && value === collection[key]) return collection;
    var collectionCopy = shallowCopy(collection);
    collectionCopy[key] = value;
    return collectionCopy;
}
function updateIn(collection, keyPath, notSetValue, updater) {
    if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
    }
    var updatedValue = updateInDeeply(isImmutable(collection), collection, coerceKeyPath(keyPath), 0, notSetValue, updater);
    return updatedValue === NOT_SET ? notSetValue : updatedValue;
}
function updateInDeeply(inImmutable, existing, keyPath, i, notSetValue, updater) {
    var wasNotSet = existing === NOT_SET;
    if (i === keyPath.length) {
        var existingValue = wasNotSet ? notSetValue : existing;
        var newValue = updater(existingValue);
        return newValue === existingValue ? existing : newValue;
    }
    if (!wasNotSet && !isDataStructure(existing)) throw new TypeError('Cannot update within non-data-structure value in path [' + keyPath.slice(0, i).map(quoteString) + ']: ' + existing);
    var key = keyPath[i];
    var nextExisting = wasNotSet ? NOT_SET : get(existing, key, NOT_SET);
    var nextUpdated = updateInDeeply(nextExisting === NOT_SET ? inImmutable : isImmutable(nextExisting), nextExisting, keyPath, i + 1, notSetValue, updater);
    return nextUpdated === nextExisting ? existing : nextUpdated === NOT_SET ? remove(existing, key) : set(wasNotSet ? inImmutable ? emptyMap() : {} : existing, key, nextUpdated);
}
function setIn$1(collection, keyPath, value) {
    return updateIn(collection, keyPath, NOT_SET, function() {
        return value;
    });
}
function setIn$$1(keyPath, v) {
    return setIn$1(this, keyPath, v);
}
function removeIn(collection, keyPath) {
    return updateIn(collection, keyPath, function() {
        return NOT_SET;
    });
}
function deleteIn(keyPath) {
    return removeIn(this, keyPath);
}
function update$1(collection, key, notSetValue, updater) {
    return updateIn(collection, [
        key
    ], notSetValue, updater);
}
function update$$1(key, notSetValue, updater) {
    return arguments.length === 1 ? key(this) : update$1(this, key, notSetValue, updater);
}
function updateIn$1(keyPath, notSetValue, updater) {
    return updateIn(this, keyPath, notSetValue, updater);
}
function merge() {
    var iters = [], len = arguments.length;
    while(len--)iters[len] = arguments[len];
    return mergeIntoKeyedWith(this, iters);
}
function mergeWith(merger) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return mergeIntoKeyedWith(this, iters, merger);
}
function mergeIntoKeyedWith(collection, collections, merger) {
    var iters = [];
    for(var ii = 0; ii < collections.length; ii++){
        var collection$1 = KeyedCollection(collections[ii]);
        if (collection$1.size !== 0) iters.push(collection$1);
    }
    if (iters.length === 0) return collection;
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) return collection.constructor(iters[0]);
    return collection.withMutations(function(collection) {
        var mergeIntoCollection = merger ? function(value, key) {
            update$1(collection, key, NOT_SET, function(oldVal) {
                return oldVal === NOT_SET ? value : merger(oldVal, value, key);
            });
        } : function(value, key) {
            collection.set(key, value);
        };
        for(var ii = 0; ii < iters.length; ii++)iters[ii].forEach(mergeIntoCollection);
    });
}
function merge$1(collection) {
    var sources = [], len = arguments.length - 1;
    while(len-- > 0)sources[len] = arguments[len + 1];
    return mergeWithSources(collection, sources);
}
function mergeWith$1(merger, collection) {
    var sources = [], len = arguments.length - 2;
    while(len-- > 0)sources[len] = arguments[len + 2];
    return mergeWithSources(collection, sources, merger);
}
function mergeDeep$1(collection) {
    var sources = [], len = arguments.length - 1;
    while(len-- > 0)sources[len] = arguments[len + 1];
    return mergeDeepWithSources(collection, sources);
}
function mergeDeepWith$1(merger, collection) {
    var sources = [], len = arguments.length - 2;
    while(len-- > 0)sources[len] = arguments[len + 2];
    return mergeDeepWithSources(collection, sources, merger);
}
function mergeDeepWithSources(collection, sources, merger) {
    return mergeWithSources(collection, sources, deepMergerWith(merger));
}
function mergeWithSources(collection, sources, merger) {
    if (!isDataStructure(collection)) throw new TypeError('Cannot merge into non-data-structure value: ' + collection);
    if (isImmutable(collection)) return collection.mergeWith ? collection.mergeWith.apply(collection, [
        merger
    ].concat(sources)) : collection.concat.apply(collection, sources);
    var isArray = Array.isArray(collection);
    var merged = collection;
    var Collection$$1 = isArray ? IndexedCollection : KeyedCollection;
    var mergeItem = isArray ? function(value) {
        // Copy on write
        if (merged === collection) merged = shallowCopy(merged);
        merged.push(value);
    } : function(value, key) {
        var hasVal = hasOwnProperty.call(merged, key);
        var nextVal = hasVal && merger ? merger(merged[key], value, key) : value;
        if (!hasVal || nextVal !== merged[key]) {
            // Copy on write
            if (merged === collection) merged = shallowCopy(merged);
            merged[key] = nextVal;
        }
    };
    for(var i = 0; i < sources.length; i++)Collection$$1(sources[i]).forEach(mergeItem);
    return merged;
}
function deepMergerWith(merger) {
    function deepMerger(oldValue, newValue, key) {
        return isDataStructure(oldValue) && isDataStructure(newValue) ? mergeWithSources(oldValue, [
            newValue
        ], deepMerger) : merger ? merger(oldValue, newValue, key) : newValue;
    }
    return deepMerger;
}
function mergeDeep() {
    var iters = [], len = arguments.length;
    while(len--)iters[len] = arguments[len];
    return mergeDeepWithSources(this, iters);
}
function mergeDeepWith(merger) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return mergeDeepWithSources(this, iters, merger);
}
function mergeIn(keyPath) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return updateIn(this, keyPath, emptyMap(), function(m) {
        return mergeWithSources(m, iters);
    });
}
function mergeDeepIn(keyPath) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return updateIn(this, keyPath, emptyMap(), function(m) {
        return mergeDeepWithSources(m, iters);
    });
}
function withMutations(fn) {
    var mutable = this.asMutable();
    fn(mutable);
    return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
}
function asMutable() {
    return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
}
function asImmutable() {
    return this.__ensureOwner();
}
function wasAltered() {
    return this.__altered;
}
var Map = function(KeyedCollection$$1) {
    function Map(value) {
        return value === null || value === undefined ? emptyMap() : isMap(value) && !isOrdered(value) ? value : emptyMap().withMutations(function(map) {
            var iter = KeyedCollection$$1(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    if (KeyedCollection$$1) Map.__proto__ = KeyedCollection$$1;
    Map.prototype = Object.create(KeyedCollection$$1 && KeyedCollection$$1.prototype);
    Map.prototype.constructor = Map;
    Map.of = function of() {
        var keyValues = [], len = arguments.length;
        while(len--)keyValues[len] = arguments[len];
        return emptyMap().withMutations(function(map) {
            for(var i = 0; i < keyValues.length; i += 2){
                if (i + 1 >= keyValues.length) throw new Error('Missing value for key: ' + keyValues[i]);
                map.set(keyValues[i], keyValues[i + 1]);
            }
        });
    };
    Map.prototype.toString = function toString() {
        return this.__toString('Map {', '}');
    };
    // @pragma Access
    Map.prototype.get = function get(k, notSetValue) {
        return this._root ? this._root.get(0, undefined, k, notSetValue) : notSetValue;
    };
    // @pragma Modification
    Map.prototype.set = function set(k, v) {
        return updateMap(this, k, v);
    };
    Map.prototype.remove = function remove(k) {
        return updateMap(this, k, NOT_SET);
    };
    Map.prototype.deleteAll = function deleteAll(keys) {
        var collection = Collection(keys);
        if (collection.size === 0) return this;
        return this.withMutations(function(map) {
            collection.forEach(function(key) {
                return map.remove(key);
            });
        });
    };
    Map.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._root = null;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyMap();
    };
    // @pragma Composition
    Map.prototype.sort = function sort(comparator) {
        // Late binding
        return OrderedMap(sortFactory(this, comparator));
    };
    Map.prototype.sortBy = function sortBy(mapper, comparator) {
        // Late binding
        return OrderedMap(sortFactory(this, comparator, mapper));
    };
    // @pragma Mutability
    Map.prototype.__iterator = function __iterator(type, reverse) {
        return new MapIterator(this, type, reverse);
    };
    Map.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1 = this;
        var iterations = 0;
        this._root && this._root.iterate(function(entry) {
            iterations++;
            return fn(entry[1], entry[0], this$1);
        }, reverse);
        return iterations;
    };
    Map.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return emptyMap();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeMap(this.size, this._root, ownerID, this.__hash);
    };
    return Map;
}(KeyedCollection);
function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
}
Map.isMap = isMap;
var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
var MapPrototype = Map.prototype;
MapPrototype[IS_MAP_SENTINEL] = true;
MapPrototype[DELETE] = MapPrototype.remove;
MapPrototype.removeAll = MapPrototype.deleteAll;
MapPrototype.concat = MapPrototype.merge;
MapPrototype.setIn = setIn$$1;
MapPrototype.removeIn = MapPrototype.deleteIn = deleteIn;
MapPrototype.update = update$$1;
MapPrototype.updateIn = updateIn$1;
MapPrototype.merge = merge;
MapPrototype.mergeWith = mergeWith;
MapPrototype.mergeDeep = mergeDeep;
MapPrototype.mergeDeepWith = mergeDeepWith;
MapPrototype.mergeIn = mergeIn;
MapPrototype.mergeDeepIn = mergeDeepIn;
MapPrototype.withMutations = withMutations;
MapPrototype.wasAltered = wasAltered;
MapPrototype.asImmutable = asImmutable;
MapPrototype['@@transducer/init'] = MapPrototype.asMutable = asMutable;
MapPrototype['@@transducer/step'] = function(result, arr) {
    return result.set(arr[0], arr[1]);
};
MapPrototype['@@transducer/result'] = function(obj) {
    return obj.asImmutable();
};
// #pragma Trie Nodes
var ArrayMapNode = function ArrayMapNode(ownerID, entries) {
    this.ownerID = ownerID;
    this.entries = entries;
};
ArrayMapNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    var entries = this.entries;
    for(var ii = 0, len = entries.length; ii < len; ii++){
        if (is(key, entries[ii][0])) return entries[ii][1];
    }
    return notSetValue;
};
ArrayMapNode.prototype.update = function update$$1(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    var removed = value === NOT_SET;
    var entries = this.entries;
    var idx = 0;
    var len = entries.length;
    for(; idx < len; idx++){
        if (is(key, entries[idx][0])) break;
    }
    var exists = idx < len;
    if (exists ? entries[idx][1] === value : removed) return this;
    SetRef(didAlter);
    (removed || !exists) && SetRef(didChangeSize);
    if (removed && entries.length === 1) return; // undefined
    if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) return createNodes(ownerID, entries, key, value);
    var isEditable = ownerID && ownerID === this.ownerID;
    var newEntries = isEditable ? entries : arrCopy(entries);
    if (exists) {
        if (removed) idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
        else newEntries[idx] = [
            key,
            value
        ];
    } else newEntries.push([
        key,
        value
    ]);
    if (isEditable) {
        this.entries = newEntries;
        return this;
    }
    return new ArrayMapNode(ownerID, newEntries);
};
var BitmapIndexedNode = function BitmapIndexedNode(ownerID, bitmap, nodes) {
    this.ownerID = ownerID;
    this.bitmap = bitmap;
    this.nodes = nodes;
};
BitmapIndexedNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    if (keyHash === undefined) keyHash = hash(key);
    var bit = 1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK);
    var bitmap = this.bitmap;
    return (bitmap & bit) === 0 ? notSetValue : this.nodes[popCount(bitmap & bit - 1)].get(shift + SHIFT, keyHash, key, notSetValue);
};
BitmapIndexedNode.prototype.update = function update$$1(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = hash(key);
    var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var bit = 1 << keyHashFrag;
    var bitmap = this.bitmap;
    var exists = (bitmap & bit) !== 0;
    if (!exists && value === NOT_SET) return this;
    var idx = popCount(bitmap & bit - 1);
    var nodes = this.nodes;
    var node = exists ? nodes[idx] : undefined;
    var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
    if (newNode === node) return this;
    if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
    if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) return nodes[idx ^ 1];
    if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) return newNode;
    var isEditable = ownerID && ownerID === this.ownerID;
    var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
    var newNodes = exists ? newNode ? setAt(nodes, idx, newNode, isEditable) : spliceOut(nodes, idx, isEditable) : spliceIn(nodes, idx, newNode, isEditable);
    if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
    }
    return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
};
var HashArrayMapNode = function HashArrayMapNode(ownerID, count, nodes) {
    this.ownerID = ownerID;
    this.count = count;
    this.nodes = nodes;
};
HashArrayMapNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    if (keyHash === undefined) keyHash = hash(key);
    var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var node = this.nodes[idx];
    return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
};
HashArrayMapNode.prototype.update = function update$$1(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = hash(key);
    var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var removed = value === NOT_SET;
    var nodes = this.nodes;
    var node = nodes[idx];
    if (removed && !node) return this;
    var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
    if (newNode === node) return this;
    var newCount = this.count;
    if (!node) newCount++;
    else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) return packNodes(ownerID, nodes, newCount, idx);
    }
    var isEditable = ownerID && ownerID === this.ownerID;
    var newNodes = setAt(nodes, idx, newNode, isEditable);
    if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
    }
    return new HashArrayMapNode(ownerID, newCount, newNodes);
};
var HashCollisionNode = function HashCollisionNode(ownerID, keyHash, entries) {
    this.ownerID = ownerID;
    this.keyHash = keyHash;
    this.entries = entries;
};
HashCollisionNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    var entries = this.entries;
    for(var ii = 0, len = entries.length; ii < len; ii++){
        if (is(key, entries[ii][0])) return entries[ii][1];
    }
    return notSetValue;
};
HashCollisionNode.prototype.update = function update$$1(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = hash(key);
    var removed = value === NOT_SET;
    if (keyHash !== this.keyHash) {
        if (removed) return this;
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [
            key,
            value
        ]);
    }
    var entries = this.entries;
    var idx = 0;
    var len = entries.length;
    for(; idx < len; idx++){
        if (is(key, entries[idx][0])) break;
    }
    var exists = idx < len;
    if (exists ? entries[idx][1] === value : removed) return this;
    SetRef(didAlter);
    (removed || !exists) && SetRef(didChangeSize);
    if (removed && len === 2) return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
    var isEditable = ownerID && ownerID === this.ownerID;
    var newEntries = isEditable ? entries : arrCopy(entries);
    if (exists) {
        if (removed) idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
        else newEntries[idx] = [
            key,
            value
        ];
    } else newEntries.push([
        key,
        value
    ]);
    if (isEditable) {
        this.entries = newEntries;
        return this;
    }
    return new HashCollisionNode(ownerID, this.keyHash, newEntries);
};
var ValueNode = function ValueNode(ownerID, keyHash, entry) {
    this.ownerID = ownerID;
    this.keyHash = keyHash;
    this.entry = entry;
};
ValueNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
};
ValueNode.prototype.update = function update$$1(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    var removed = value === NOT_SET;
    var keyMatch = is(key, this.entry[0]);
    if (keyMatch ? value === this.entry[1] : removed) return this;
    SetRef(didAlter);
    if (removed) {
        SetRef(didChangeSize);
        return; // undefined
    }
    if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
            this.entry[1] = value;
            return this;
        }
        return new ValueNode(ownerID, this.keyHash, [
            key,
            value
        ]);
    }
    SetRef(didChangeSize);
    return mergeIntoNode(this, ownerID, shift, hash(key), [
        key,
        value
    ]);
};
// #pragma Iterators
ArrayMapNode.prototype.iterate = HashCollisionNode.prototype.iterate = function(fn, reverse) {
    var entries = this.entries;
    for(var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++){
        if (fn(entries[reverse ? maxIndex - ii : ii]) === false) return false;
    }
};
BitmapIndexedNode.prototype.iterate = HashArrayMapNode.prototype.iterate = function(fn, reverse) {
    var nodes = this.nodes;
    for(var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++){
        var node = nodes[reverse ? maxIndex - ii : ii];
        if (node && node.iterate(fn, reverse) === false) return false;
    }
};
// eslint-disable-next-line no-unused-vars
ValueNode.prototype.iterate = function(fn, reverse) {
    return fn(this.entry);
};
var MapIterator = function(Iterator$$1) {
    function MapIterator(map, type, reverse) {
        this._type = type;
        this._reverse = reverse;
        this._stack = map._root && mapIteratorFrame(map._root);
    }
    if (Iterator$$1) MapIterator.__proto__ = Iterator$$1;
    MapIterator.prototype = Object.create(Iterator$$1 && Iterator$$1.prototype);
    MapIterator.prototype.constructor = MapIterator;
    MapIterator.prototype.next = function next() {
        var this$1 = this;
        var type = this._type;
        var stack = this._stack;
        while(stack){
            var node = stack.node;
            var index = stack.index++;
            var maxIndex = void 0;
            if (node.entry) {
                if (index === 0) return mapIteratorValue(type, node.entry);
            } else if (node.entries) {
                maxIndex = node.entries.length - 1;
                if (index <= maxIndex) return mapIteratorValue(type, node.entries[this$1._reverse ? maxIndex - index : index]);
            } else {
                maxIndex = node.nodes.length - 1;
                if (index <= maxIndex) {
                    var subNode = node.nodes[this$1._reverse ? maxIndex - index : index];
                    if (subNode) {
                        if (subNode.entry) return mapIteratorValue(type, subNode.entry);
                        stack = this$1._stack = mapIteratorFrame(subNode, stack);
                    }
                    continue;
                }
            }
            stack = this$1._stack = this$1._stack.__prev;
        }
        return iteratorDone();
    };
    return MapIterator;
}(Iterator);
function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
}
function mapIteratorFrame(node, prev) {
    return {
        node: node,
        index: 0,
        __prev: prev
    };
}
function makeMap(size, root, ownerID, hash$$1) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash$$1;
    map.__altered = false;
    return map;
}
var EMPTY_MAP;
function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
}
function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
        if (v === NOT_SET) return map;
        newSize = 1;
        newRoot = new ArrayMapNode(map.__ownerID, [
            [
                k,
                v
            ]
        ]);
    } else {
        var didChangeSize = MakeRef(CHANGE_LENGTH);
        var didAlter = MakeRef(DID_ALTER);
        newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
        if (!didAlter.value) return map;
        newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
        map.size = newSize;
        map._root = newRoot;
        map.__hash = undefined;
        map.__altered = true;
        return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
}
function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
        if (value === NOT_SET) return node;
        SetRef(didAlter);
        SetRef(didChangeSize);
        return new ValueNode(ownerID, keyHash, [
            key,
            value
        ]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
}
function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
}
function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) return new HashCollisionNode(ownerID, keyHash, [
        node.entry,
        entry
    ]);
    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var newNode;
    var nodes = idx1 === idx2 ? [
        mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)
    ] : (newNode = new ValueNode(ownerID, keyHash, entry), idx1 < idx2 ? [
        node,
        newNode
    ] : [
        newNode,
        node
    ]);
    return new BitmapIndexedNode(ownerID, 1 << idx1 | 1 << idx2, nodes);
}
function createNodes(ownerID, entries, key, value) {
    if (!ownerID) ownerID = new OwnerID();
    var node = new ValueNode(ownerID, hash(key), [
        key,
        value
    ]);
    for(var ii = 0; ii < entries.length; ii++){
        var entry = entries[ii];
        node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
}
function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for(var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1){
        var node = nodes[ii];
        if (node !== undefined && ii !== excluding) {
            bitmap |= bit;
            packedNodes[packedII++] = node;
        }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
}
function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for(var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1)expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
}
function popCount(x) {
    x -= x >> 1 & 0x55555555;
    x = (x & 0x33333333) + (x >> 2 & 0x33333333);
    x = x + (x >> 4) & 0x0f0f0f0f;
    x += x >> 8;
    x += x >> 16;
    return x & 0x7f;
}
function setAt(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
}
function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
        array[idx] = val;
        return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for(var ii = 0; ii < newLen; ii++)if (ii === idx) {
        newArray[ii] = val;
        after = -1;
    } else newArray[ii] = array[ii + after];
    return newArray;
}
function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
        array.pop();
        return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for(var ii = 0; ii < newLen; ii++){
        if (ii === idx) after = 1;
        newArray[ii] = array[ii + after];
    }
    return newArray;
}
var MAX_ARRAY_MAP_SIZE = SIZE / 4;
var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
var List = function(IndexedCollection$$1) {
    function List(value) {
        var empty = emptyList();
        if (value === null || value === undefined) return empty;
        if (isList(value)) return value;
        var iter = IndexedCollection$$1(value);
        var size = iter.size;
        if (size === 0) return empty;
        assertNotInfinite(size);
        if (size > 0 && size < SIZE) return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
        return empty.withMutations(function(list) {
            list.setSize(size);
            iter.forEach(function(v, i) {
                return list.set(i, v);
            });
        });
    }
    if (IndexedCollection$$1) List.__proto__ = IndexedCollection$$1;
    List.prototype = Object.create(IndexedCollection$$1 && IndexedCollection$$1.prototype);
    List.prototype.constructor = List;
    List.of = function of() {
        return this(arguments);
    };
    List.prototype.toString = function toString() {
        return this.__toString('List [', ']');
    };
    // @pragma Access
    List.prototype.get = function get(index, notSetValue) {
        index = wrapIndex(this, index);
        if (index >= 0 && index < this.size) {
            index += this._origin;
            var node = listNodeFor(this, index);
            return node && node.array[index & MASK];
        }
        return notSetValue;
    };
    // @pragma Modification
    List.prototype.set = function set(index, value) {
        return updateList(this, index, value);
    };
    List.prototype.remove = function remove(index) {
        return !this.has(index) ? this : index === 0 ? this.shift() : index === this.size - 1 ? this.pop() : this.splice(index, 1);
    };
    List.prototype.insert = function insert(index, value) {
        return this.splice(index, 0, value);
    };
    List.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = this._origin = this._capacity = 0;
            this._level = SHIFT;
            this._root = this._tail = null;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyList();
    };
    List.prototype.push = function push() {
        var values = arguments;
        var oldSize = this.size;
        return this.withMutations(function(list) {
            setListBounds(list, 0, oldSize + values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(oldSize + ii, values[ii]);
        });
    };
    List.prototype.pop = function pop() {
        return setListBounds(this, 0, -1);
    };
    List.prototype.unshift = function unshift() {
        var values = arguments;
        return this.withMutations(function(list) {
            setListBounds(list, -values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(ii, values[ii]);
        });
    };
    List.prototype.shift = function shift() {
        return setListBounds(this, 1);
    };
    // @pragma Composition
    List.prototype.concat = function concat() {
        var arguments$1 = arguments;
        var seqs = [];
        for(var i = 0; i < arguments.length; i++){
            var argument = arguments$1[i];
            var seq = IndexedCollection$$1(typeof argument !== 'string' && hasIterator(argument) ? argument : [
                argument
            ]);
            if (seq.size !== 0) seqs.push(seq);
        }
        if (seqs.length === 0) return this;
        if (this.size === 0 && !this.__ownerID && seqs.length === 1) return this.constructor(seqs[0]);
        return this.withMutations(function(list) {
            seqs.forEach(function(seq) {
                return seq.forEach(function(value) {
                    return list.push(value);
                });
            });
        });
    };
    List.prototype.setSize = function setSize(size) {
        return setListBounds(this, 0, size);
    };
    // @pragma Iteration
    List.prototype.slice = function slice(begin, end) {
        var size = this.size;
        if (wholeSlice(begin, end, size)) return this;
        return setListBounds(this, resolveBegin(begin, size), resolveEnd(end, size));
    };
    List.prototype.__iterator = function __iterator(type, reverse) {
        var index = reverse ? this.size : 0;
        var values = iterateList(this, reverse);
        return new Iterator(function() {
            var value = values();
            return value === DONE ? iteratorDone() : iteratorValue(type, reverse ? --index : index++, value);
        });
    };
    List.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1 = this;
        var index = reverse ? this.size : 0;
        var values = iterateList(this, reverse);
        var value;
        while((value = values()) !== DONE){
            if (fn(value, reverse ? --index : index++, this$1) === false) break;
        }
        return index;
    };
    List.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return emptyList();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };
    return List;
}(IndexedCollection);
function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
}
List.isList = isList;
var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
var ListPrototype = List.prototype;
ListPrototype[IS_LIST_SENTINEL] = true;
ListPrototype[DELETE] = ListPrototype.remove;
ListPrototype.merge = ListPrototype.concat;
ListPrototype.setIn = setIn$$1;
ListPrototype.deleteIn = ListPrototype.removeIn = deleteIn;
ListPrototype.update = update$$1;
ListPrototype.updateIn = updateIn$1;
ListPrototype.mergeIn = mergeIn;
ListPrototype.mergeDeepIn = mergeDeepIn;
ListPrototype.withMutations = withMutations;
ListPrototype.wasAltered = wasAltered;
ListPrototype.asImmutable = asImmutable;
ListPrototype['@@transducer/init'] = ListPrototype.asMutable = asMutable;
ListPrototype['@@transducer/step'] = function(result, arr) {
    return result.push(arr);
};
ListPrototype['@@transducer/result'] = function(obj) {
    return obj.asImmutable();
};
var VNode = function VNode(array, ownerID) {
    this.array = array;
    this.ownerID = ownerID;
};
// TODO: seems like these methods are very similar
VNode.prototype.removeBefore = function removeBefore(ownerID, level, index) {
    if (index === level ? 1 << level : this.array.length === 0) return this;
    var originIndex = index >>> level & MASK;
    if (originIndex >= this.array.length) return new VNode([], ownerID);
    var removingFirst = originIndex === 0;
    var newChild;
    if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) return this;
    }
    if (removingFirst && !newChild) return this;
    var editable = editableVNode(this, ownerID);
    if (!removingFirst) for(var ii = 0; ii < originIndex; ii++)editable.array[ii] = undefined;
    if (newChild) editable.array[originIndex] = newChild;
    return editable;
};
VNode.prototype.removeAfter = function removeAfter(ownerID, level, index) {
    if (index === (level ? 1 << level : 0) || this.array.length === 0) return this;
    var sizeIndex = index - 1 >>> level & MASK;
    if (sizeIndex >= this.array.length) return this;
    var newChild;
    if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) return this;
    }
    var editable = editableVNode(this, ownerID);
    editable.array.splice(sizeIndex + 1);
    if (newChild) editable.array[sizeIndex] = newChild;
    return editable;
};
var DONE = {};
function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;
    return iterateNodeOrLeaf(list._root, list._level, 0);
    function iterateNodeOrLeaf(node, level, offset) {
        return level === 0 ? iterateLeaf(node, offset) : iterateNode(node, level, offset);
    }
    function iterateLeaf(node, offset) {
        var array = offset === tailPos ? tail && tail.array : node && node.array;
        var from = offset > left ? 0 : left - offset;
        var to = right - offset;
        if (to > SIZE) to = SIZE;
        return function() {
            if (from === to) return DONE;
            var idx = reverse ? --to : from++;
            return array && array[idx];
        };
    }
    function iterateNode(node, level, offset) {
        var values;
        var array = node && node.array;
        var from = offset > left ? 0 : left - offset >> level;
        var to = (right - offset >> level) + 1;
        if (to > SIZE) to = SIZE;
        return function() {
            while(true){
                if (values) {
                    var value = values();
                    if (value !== DONE) return value;
                    values = null;
                }
                if (from === to) return DONE;
                var idx = reverse ? --to : from++;
                values = iterateNodeOrLeaf(array && array[idx], level - SHIFT, offset + (idx << level));
            }
        };
    }
}
function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
}
var EMPTY_LIST;
function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
}
function updateList(list, index, value) {
    index = wrapIndex(list, index);
    if (index !== index) return list;
    if (index >= list.size || index < 0) return list.withMutations(function(list) {
        index < 0 ? setListBounds(list, index).set(0, value) : setListBounds(list, 0, index + 1).set(index, value);
    });
    index += list._origin;
    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    else newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    if (!didAlter.value) return list;
    if (list.__ownerID) {
        list._root = newRoot;
        list._tail = newTail;
        list.__hash = undefined;
        list.__altered = true;
        return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
}
function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = index >>> level & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) return node;
    var newNode;
    if (level > 0) {
        var lowerNode = node && node.array[idx];
        var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
        if (newLowerNode === lowerNode) return node;
        newNode = editableVNode(node, ownerID);
        newNode.array[idx] = newLowerNode;
        return newNode;
    }
    if (nodeHas && node.array[idx] === value) return node;
    SetRef(didAlter);
    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) newNode.array.pop();
    else newNode.array[idx] = value;
    return newNode;
}
function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) return node;
    return new VNode(node ? node.array.slice() : [], ownerID);
}
function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) return list._tail;
    if (rawIndex < 1 << list._level + SHIFT) {
        var node = list._root;
        var level = list._level;
        while(node && level > 0){
            node = node.array[rawIndex >>> level & MASK];
            level -= SHIFT;
        }
        return node;
    }
}
function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) begin |= 0;
    if (end !== undefined) end |= 0;
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) return list;
    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) return list.clear();
    var newLevel = list._level;
    var newRoot = list._root;
    // New origin might need creating a higher root.
    var offsetShift = 0;
    while(newOrigin + offsetShift < 0){
        newRoot = new VNode(newRoot && newRoot.array.length ? [
            undefined,
            newRoot
        ] : [], owner);
        newLevel += SHIFT;
        offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
        newOrigin += offsetShift;
        oldOrigin += offsetShift;
        newCapacity += offsetShift;
        oldCapacity += offsetShift;
    }
    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);
    // New size might need creating a higher root.
    while(newTailOffset >= 1 << newLevel + SHIFT){
        newRoot = new VNode(newRoot && newRoot.array.length ? [
            newRoot
        ] : [], owner);
        newLevel += SHIFT;
    }
    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ? listNodeFor(list, newCapacity - 1) : newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
        newRoot = editableVNode(newRoot, owner);
        var node = newRoot;
        for(var level = newLevel; level > SHIFT; level -= SHIFT){
            var idx = oldTailOffset >>> level & MASK;
            node = node.array[idx] = editableVNode(node.array[idx], owner);
        }
        node.array[oldTailOffset >>> SHIFT & MASK] = oldTail;
    }
    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
        newOrigin -= newTailOffset;
        newCapacity -= newTailOffset;
        newLevel = SHIFT;
        newRoot = null;
        newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
        offsetShift = 0;
        // Identify the new top root node of the subtree of the old root.
        while(newRoot){
            var beginIndex = newOrigin >>> newLevel & MASK;
            if (beginIndex !== newTailOffset >>> newLevel & MASK) break;
            if (beginIndex) offsetShift += (1 << newLevel) * beginIndex;
            newLevel -= SHIFT;
            newRoot = newRoot.array[beginIndex];
        }
        // Trim the new sides of the new root.
        if (newRoot && newOrigin > oldOrigin) newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
        if (newRoot && newTailOffset < oldTailOffset) newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
        if (offsetShift) {
            newOrigin -= offsetShift;
            newCapacity -= offsetShift;
        }
    }
    if (list.__ownerID) {
        list.size = newCapacity - newOrigin;
        list._origin = newOrigin;
        list._capacity = newCapacity;
        list._level = newLevel;
        list._root = newRoot;
        list._tail = newTail;
        list.__hash = undefined;
        list.__altered = true;
        return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
}
function getTailOffset(size) {
    return size < SIZE ? 0 : size - 1 >>> SHIFT << SHIFT;
}
var OrderedMap = function(Map$$1) {
    function OrderedMap(value) {
        return value === null || value === undefined ? emptyOrderedMap() : isOrderedMap(value) ? value : emptyOrderedMap().withMutations(function(map) {
            var iter = KeyedCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    if (Map$$1) OrderedMap.__proto__ = Map$$1;
    OrderedMap.prototype = Object.create(Map$$1 && Map$$1.prototype);
    OrderedMap.prototype.constructor = OrderedMap;
    OrderedMap.of = function of() {
        return this(arguments);
    };
    OrderedMap.prototype.toString = function toString() {
        return this.__toString('OrderedMap {', '}');
    };
    // @pragma Access
    OrderedMap.prototype.get = function get(k, notSetValue) {
        var index = this._map.get(k);
        return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };
    // @pragma Modification
    OrderedMap.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._map.clear();
            this._list.clear();
            return this;
        }
        return emptyOrderedMap();
    };
    OrderedMap.prototype.set = function set(k, v) {
        return updateOrderedMap(this, k, v);
    };
    OrderedMap.prototype.remove = function remove(k) {
        return updateOrderedMap(this, k, NOT_SET);
    };
    OrderedMap.prototype.wasAltered = function wasAltered() {
        return this._map.wasAltered() || this._list.wasAltered();
    };
    OrderedMap.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1 = this;
        return this._list.__iterate(function(entry) {
            return entry && fn(entry[1], entry[0], this$1);
        }, reverse);
    };
    OrderedMap.prototype.__iterator = function __iterator(type, reverse) {
        return this._list.fromEntrySeq().__iterator(type, reverse);
    };
    OrderedMap.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        var newList = this._list.__ensureOwner(ownerID);
        if (!ownerID) {
            if (this.size === 0) return emptyOrderedMap();
            this.__ownerID = ownerID;
            this._map = newMap;
            this._list = newList;
            return this;
        }
        return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };
    return OrderedMap;
}(Map);
function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
}
OrderedMap.isOrderedMap = isOrderedMap;
OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
}
var EMPTY_ORDERED_MAP;
function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
}
function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) {
        // removed
        if (!has) return omap;
        if (list.size >= SIZE && list.size >= map.size * 2) {
            newList = list.filter(function(entry, idx) {
                return entry !== undefined && i !== idx;
            });
            newMap = newList.toKeyedSeq().map(function(entry) {
                return entry[0];
            }).flip().toMap();
            if (omap.__ownerID) newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        } else {
            newMap = map.remove(k);
            newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
        }
    } else if (has) {
        if (v === list.get(i)[1]) return omap;
        newMap = map;
        newList = list.set(i, [
            k,
            v
        ]);
    } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [
            k,
            v
        ]);
    }
    if (omap.__ownerID) {
        omap.size = newMap.size;
        omap._map = newMap;
        omap._list = newList;
        omap.__hash = undefined;
        return omap;
    }
    return makeOrderedMap(newMap, newList);
}
var Stack = function(IndexedCollection$$1) {
    function Stack(value) {
        return value === null || value === undefined ? emptyStack() : isStack(value) ? value : emptyStack().pushAll(value);
    }
    if (IndexedCollection$$1) Stack.__proto__ = IndexedCollection$$1;
    Stack.prototype = Object.create(IndexedCollection$$1 && IndexedCollection$$1.prototype);
    Stack.prototype.constructor = Stack;
    Stack.of = function of() {
        return this(arguments);
    };
    Stack.prototype.toString = function toString() {
        return this.__toString('Stack [', ']');
    };
    // @pragma Access
    Stack.prototype.get = function get(index, notSetValue) {
        var head = this._head;
        index = wrapIndex(this, index);
        while(head && index--)head = head.next;
        return head ? head.value : notSetValue;
    };
    Stack.prototype.peek = function peek() {
        return this._head && this._head.value;
    };
    // @pragma Modification
    Stack.prototype.push = function push() {
        var arguments$1 = arguments;
        if (arguments.length === 0) return this;
        var newSize = this.size + arguments.length;
        var head = this._head;
        for(var ii = arguments.length - 1; ii >= 0; ii--)head = {
            value: arguments$1[ii],
            next: head
        };
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    Stack.prototype.pushAll = function pushAll(iter) {
        iter = IndexedCollection$$1(iter);
        if (iter.size === 0) return this;
        if (this.size === 0 && isStack(iter)) return iter;
        assertNotInfinite(iter.size);
        var newSize = this.size;
        var head = this._head;
        iter.__iterate(function(value) {
            newSize++;
            head = {
                value: value,
                next: head
            };
        }, /* reverse */ true);
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    Stack.prototype.pop = function pop() {
        return this.slice(1);
    };
    Stack.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._head = undefined;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyStack();
    };
    Stack.prototype.slice = function slice(begin, end) {
        if (wholeSlice(begin, end, this.size)) return this;
        var resolvedBegin = resolveBegin(begin, this.size);
        var resolvedEnd = resolveEnd(end, this.size);
        if (resolvedEnd !== this.size) // super.slice(begin, end);
        return IndexedCollection$$1.prototype.slice.call(this, begin, end);
        var newSize = this.size - resolvedBegin;
        var head = this._head;
        while(resolvedBegin--)head = head.next;
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    // @pragma Mutability
    Stack.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return emptyStack();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeStack(this.size, this._head, ownerID, this.__hash);
    };
    // @pragma Iteration
    Stack.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1 = this;
        if (reverse) return new ArraySeq(this.toArray()).__iterate(function(v, k) {
            return fn(v, k, this$1);
        }, reverse);
        var iterations = 0;
        var node = this._head;
        while(node){
            if (fn(node.value, iterations++, this$1) === false) break;
            node = node.next;
        }
        return iterations;
    };
    Stack.prototype.__iterator = function __iterator(type, reverse) {
        if (reverse) return new ArraySeq(this.toArray()).__iterator(type, reverse);
        var iterations = 0;
        var node = this._head;
        return new Iterator(function() {
            if (node) {
                var value = node.value;
                node = node.next;
                return iteratorValue(type, iterations++, value);
            }
            return iteratorDone();
        });
    };
    return Stack;
}(IndexedCollection);
function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
}
Stack.isStack = isStack;
var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
var StackPrototype = Stack.prototype;
StackPrototype[IS_STACK_SENTINEL] = true;
StackPrototype.shift = StackPrototype.pop;
StackPrototype.unshift = StackPrototype.push;
StackPrototype.unshiftAll = StackPrototype.pushAll;
StackPrototype.withMutations = withMutations;
StackPrototype.wasAltered = wasAltered;
StackPrototype.asImmutable = asImmutable;
StackPrototype['@@transducer/init'] = StackPrototype.asMutable = asMutable;
StackPrototype['@@transducer/step'] = function(result, arr) {
    return result.unshift(arr);
};
StackPrototype['@@transducer/result'] = function(obj) {
    return obj.asImmutable();
};
function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
}
var EMPTY_STACK;
function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
}
function deepEqual(a, b) {
    if (a === b) return true;
    if (!isCollection(b) || a.size !== undefined && b.size !== undefined && a.size !== b.size || a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash || isKeyed(a) !== isKeyed(b) || isIndexed(a) !== isIndexed(b) || isOrdered(a) !== isOrdered(b)) return false;
    if (a.size === 0 && b.size === 0) return true;
    var notAssociative = !isAssociative(a);
    if (isOrdered(a)) {
        var entries = a.entries();
        return b.every(function(v, k) {
            var entry = entries.next().value;
            return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
        }) && entries.next().done;
    }
    var flipped = false;
    if (a.size === undefined) {
        if (b.size === undefined) {
            if (typeof a.cacheResult === 'function') a.cacheResult();
        } else {
            flipped = true;
            var _ = a;
            a = b;
            b = _;
        }
    }
    var allEqual = true;
    var bSize = b.__iterate(function(v, k) {
        if (notAssociative ? !a.has(v) : flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
            allEqual = false;
            return false;
        }
    });
    return allEqual && a.size === bSize;
}
/**
 * Contributes additional methods to a constructor
 */ function mixin(ctor, methods) {
    var keyCopier = function(key) {
        ctor.prototype[key] = methods[key];
    };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
}
function toJS(value) {
    return isDataStructure(value) ? Seq(value).map(toJS).toJSON() : value;
}
var Set = function(SetCollection$$1) {
    function Set(value) {
        return value === null || value === undefined ? emptySet() : isSet(value) && !isOrdered(value) ? value : emptySet().withMutations(function(set) {
            var iter = SetCollection$$1(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    if (SetCollection$$1) Set.__proto__ = SetCollection$$1;
    Set.prototype = Object.create(SetCollection$$1 && SetCollection$$1.prototype);
    Set.prototype.constructor = Set;
    Set.of = function of() {
        return this(arguments);
    };
    Set.fromKeys = function fromKeys(value) {
        return this(KeyedCollection(value).keySeq());
    };
    Set.intersect = function intersect(sets) {
        sets = Collection(sets).toArray();
        return sets.length ? SetPrototype.intersect.apply(Set(sets.pop()), sets) : emptySet();
    };
    Set.union = function union(sets) {
        sets = Collection(sets).toArray();
        return sets.length ? SetPrototype.union.apply(Set(sets.pop()), sets) : emptySet();
    };
    Set.prototype.toString = function toString() {
        return this.__toString('Set {', '}');
    };
    // @pragma Access
    Set.prototype.has = function has(value) {
        return this._map.has(value);
    };
    // @pragma Modification
    Set.prototype.add = function add(value) {
        return updateSet(this, this._map.set(value, value));
    };
    Set.prototype.remove = function remove(value) {
        return updateSet(this, this._map.remove(value));
    };
    Set.prototype.clear = function clear() {
        return updateSet(this, this._map.clear());
    };
    // @pragma Composition
    Set.prototype.union = function union() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        iters = iters.filter(function(x) {
            return x.size !== 0;
        });
        if (iters.length === 0) return this;
        if (this.size === 0 && !this.__ownerID && iters.length === 1) return this.constructor(iters[0]);
        return this.withMutations(function(set) {
            for(var ii = 0; ii < iters.length; ii++)SetCollection$$1(iters[ii]).forEach(function(value) {
                return set.add(value);
            });
        });
    };
    Set.prototype.intersect = function intersect() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetCollection$$1(iter);
        });
        var toRemove = [];
        this.forEach(function(value) {
            if (!iters.every(function(iter) {
                return iter.includes(value);
            })) toRemove.push(value);
        });
        return this.withMutations(function(set) {
            toRemove.forEach(function(value) {
                set.remove(value);
            });
        });
    };
    Set.prototype.subtract = function subtract() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetCollection$$1(iter);
        });
        var toRemove = [];
        this.forEach(function(value) {
            if (iters.some(function(iter) {
                return iter.includes(value);
            })) toRemove.push(value);
        });
        return this.withMutations(function(set) {
            toRemove.forEach(function(value) {
                set.remove(value);
            });
        });
    };
    Set.prototype.sort = function sort(comparator) {
        // Late binding
        return OrderedSet(sortFactory(this, comparator));
    };
    Set.prototype.sortBy = function sortBy(mapper, comparator) {
        // Late binding
        return OrderedSet(sortFactory(this, comparator, mapper));
    };
    Set.prototype.wasAltered = function wasAltered() {
        return this._map.wasAltered();
    };
    Set.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1 = this;
        return this._map.__iterate(function(k) {
            return fn(k, k, this$1);
        }, reverse);
    };
    Set.prototype.__iterator = function __iterator(type, reverse) {
        return this._map.__iterator(type, reverse);
    };
    Set.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        if (!ownerID) {
            if (this.size === 0) return this.__empty();
            this.__ownerID = ownerID;
            this._map = newMap;
            return this;
        }
        return this.__make(newMap, ownerID);
    };
    return Set;
}(SetCollection);
function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
}
Set.isSet = isSet;
var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
var SetPrototype = Set.prototype;
SetPrototype[IS_SET_SENTINEL] = true;
SetPrototype[DELETE] = SetPrototype.remove;
SetPrototype.merge = SetPrototype.concat = SetPrototype.union;
SetPrototype.withMutations = withMutations;
SetPrototype.asImmutable = asImmutable;
SetPrototype['@@transducer/init'] = SetPrototype.asMutable = asMutable;
SetPrototype['@@transducer/step'] = function(result, arr) {
    return result.add(arr);
};
SetPrototype['@@transducer/result'] = function(obj) {
    return obj.asImmutable();
};
SetPrototype.__empty = emptySet;
SetPrototype.__make = makeSet;
function updateSet(set, newMap) {
    if (set.__ownerID) {
        set.size = newMap.size;
        set._map = newMap;
        return set;
    }
    return newMap === set._map ? set : newMap.size === 0 ? set.__empty() : set.__make(newMap);
}
function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
}
var EMPTY_SET;
function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
}
/**
 * Returns a lazy seq of nums from start (inclusive) to end
 * (exclusive), by step, where start defaults to 0, step to 1, and end to
 * infinity. When start is equal to end, returns empty list.
 */ var Range = function(IndexedSeq$$1) {
    function Range(start, end, step) {
        if (!(this instanceof Range)) return new Range(start, end, step);
        invariant(step !== 0, 'Cannot step a Range by 0');
        start = start || 0;
        if (end === undefined) end = Infinity;
        step = step === undefined ? 1 : Math.abs(step);
        if (end < start) step = -step;
        this._start = start;
        this._end = end;
        this._step = step;
        this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
        if (this.size === 0) {
            if (EMPTY_RANGE) return EMPTY_RANGE;
            EMPTY_RANGE = this;
        }
    }
    if (IndexedSeq$$1) Range.__proto__ = IndexedSeq$$1;
    Range.prototype = Object.create(IndexedSeq$$1 && IndexedSeq$$1.prototype);
    Range.prototype.constructor = Range;
    Range.prototype.toString = function toString() {
        if (this.size === 0) return 'Range []';
        return 'Range [ ' + this._start + '...' + this._end + (this._step !== 1 ? ' by ' + this._step : '') + ' ]';
    };
    Range.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._start + wrapIndex(this, index) * this._step : notSetValue;
    };
    Range.prototype.includes = function includes(searchValue) {
        var possibleIndex = (searchValue - this._start) / this._step;
        return possibleIndex >= 0 && possibleIndex < this.size && possibleIndex === Math.floor(possibleIndex);
    };
    Range.prototype.slice = function slice(begin, end) {
        if (wholeSlice(begin, end, this.size)) return this;
        begin = resolveBegin(begin, this.size);
        end = resolveEnd(end, this.size);
        if (end <= begin) return new Range(0, 0);
        return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };
    Range.prototype.indexOf = function indexOf(searchValue) {
        var offsetValue = searchValue - this._start;
        if (offsetValue % this._step === 0) {
            var index = offsetValue / this._step;
            if (index >= 0 && index < this.size) return index;
        }
        return -1;
    };
    Range.prototype.lastIndexOf = function lastIndexOf(searchValue) {
        return this.indexOf(searchValue);
    };
    Range.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1 = this;
        var size = this.size;
        var step = this._step;
        var value = reverse ? this._start + (size - 1) * step : this._start;
        var i = 0;
        while(i !== size){
            if (fn(value, reverse ? size - ++i : i++, this$1) === false) break;
            value += reverse ? -step : step;
        }
        return i;
    };
    Range.prototype.__iterator = function __iterator(type, reverse) {
        var size = this.size;
        var step = this._step;
        var value = reverse ? this._start + (size - 1) * step : this._start;
        var i = 0;
        return new Iterator(function() {
            if (i === size) return iteratorDone();
            var v = value;
            value += reverse ? -step : step;
            return iteratorValue(type, reverse ? size - ++i : i++, v);
        });
    };
    Range.prototype.equals = function equals(other) {
        return other instanceof Range ? this._start === other._start && this._end === other._end && this._step === other._step : deepEqual(this, other);
    };
    return Range;
}(IndexedSeq);
var EMPTY_RANGE;
function getIn$1(collection, searchKeyPath, notSetValue) {
    var keyPath = coerceKeyPath(searchKeyPath);
    var i = 0;
    while(i !== keyPath.length){
        collection = get(collection, keyPath[i++], NOT_SET);
        if (collection === NOT_SET) return notSetValue;
    }
    return collection;
}
function getIn$$1(searchKeyPath, notSetValue) {
    return getIn$1(this, searchKeyPath, notSetValue);
}
function hasIn$1(collection, keyPath) {
    return getIn$1(collection, keyPath, NOT_SET) !== NOT_SET;
}
function hasIn$$1(searchKeyPath) {
    return hasIn$1(this, searchKeyPath);
}
function toObject() {
    assertNotInfinite(this.size);
    var object = {};
    this.__iterate(function(v, k) {
        object[k] = v;
    });
    return object;
}
// Note: all of these methods are deprecated.
Collection.isIterable = isCollection;
Collection.isKeyed = isKeyed;
Collection.isIndexed = isIndexed;
Collection.isAssociative = isAssociative;
Collection.isOrdered = isOrdered;
Collection.Iterator = Iterator;
mixin(Collection, {
    // ### Conversion to other types
    toArray: function toArray() {
        assertNotInfinite(this.size);
        var array = new Array(this.size || 0);
        var useTuples = isKeyed(this);
        var i = 0;
        this.__iterate(function(v, k) {
            // Keyed collections produce an array of tuples.
            array[i++] = useTuples ? [
                k,
                v
            ] : v;
        });
        return array;
    },
    toIndexedSeq: function toIndexedSeq() {
        return new ToIndexedSequence(this);
    },
    toJS: function toJS$1() {
        return toJS(this);
    },
    toKeyedSeq: function toKeyedSeq() {
        return new ToKeyedSequence(this, true);
    },
    toMap: function toMap() {
        // Use Late Binding here to solve the circular dependency.
        return Map(this.toKeyedSeq());
    },
    toObject: toObject,
    toOrderedMap: function toOrderedMap() {
        // Use Late Binding here to solve the circular dependency.
        return OrderedMap(this.toKeyedSeq());
    },
    toOrderedSet: function toOrderedSet() {
        // Use Late Binding here to solve the circular dependency.
        return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },
    toSet: function toSet() {
        // Use Late Binding here to solve the circular dependency.
        return Set(isKeyed(this) ? this.valueSeq() : this);
    },
    toSetSeq: function toSetSeq() {
        return new ToSetSequence(this);
    },
    toSeq: function toSeq() {
        return isIndexed(this) ? this.toIndexedSeq() : isKeyed(this) ? this.toKeyedSeq() : this.toSetSeq();
    },
    toStack: function toStack() {
        // Use Late Binding here to solve the circular dependency.
        return Stack(isKeyed(this) ? this.valueSeq() : this);
    },
    toList: function toList() {
        // Use Late Binding here to solve the circular dependency.
        return List(isKeyed(this) ? this.valueSeq() : this);
    },
    // ### Common JavaScript methods and properties
    toString: function toString() {
        return '[Collection]';
    },
    __toString: function __toString(head, tail) {
        if (this.size === 0) return head + tail;
        return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },
    // ### ES6 Collection methods (ES6 Array and Map)
    concat: function concat() {
        var values = [], len = arguments.length;
        while(len--)values[len] = arguments[len];
        return reify(this, concatFactory(this, values));
    },
    includes: function includes(searchValue) {
        return this.some(function(value) {
            return is(value, searchValue);
        });
    },
    entries: function entries() {
        return this.__iterator(ITERATE_ENTRIES);
    },
    every: function every(predicate, context) {
        assertNotInfinite(this.size);
        var returnValue = true;
        this.__iterate(function(v, k, c) {
            if (!predicate.call(context, v, k, c)) {
                returnValue = false;
                return false;
            }
        });
        return returnValue;
    },
    filter: function filter(predicate, context) {
        return reify(this, filterFactory(this, predicate, context, true));
    },
    find: function find(predicate, context, notSetValue) {
        var entry = this.findEntry(predicate, context);
        return entry ? entry[1] : notSetValue;
    },
    forEach: function forEach(sideEffect, context) {
        assertNotInfinite(this.size);
        return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },
    join: function join(separator) {
        assertNotInfinite(this.size);
        separator = separator !== undefined ? '' + separator : ',';
        var joined = '';
        var isFirst = true;
        this.__iterate(function(v) {
            isFirst ? isFirst = false : joined += separator;
            joined += v !== null && v !== undefined ? v.toString() : '';
        });
        return joined;
    },
    keys: function keys() {
        return this.__iterator(ITERATE_KEYS);
    },
    map: function map(mapper, context) {
        return reify(this, mapFactory(this, mapper, context));
    },
    reduce: function reduce$1(reducer, initialReduction, context) {
        return reduce(this, reducer, initialReduction, context, arguments.length < 2, false);
    },
    reduceRight: function reduceRight(reducer, initialReduction, context) {
        return reduce(this, reducer, initialReduction, context, arguments.length < 2, true);
    },
    reverse: function reverse() {
        return reify(this, reverseFactory(this, true));
    },
    slice: function slice(begin, end) {
        return reify(this, sliceFactory(this, begin, end, true));
    },
    some: function some(predicate, context) {
        return !this.every(not(predicate), context);
    },
    sort: function sort(comparator) {
        return reify(this, sortFactory(this, comparator));
    },
    values: function values() {
        return this.__iterator(ITERATE_VALUES);
    },
    // ### More sequential methods
    butLast: function butLast() {
        return this.slice(0, -1);
    },
    isEmpty: function isEmpty() {
        return this.size !== undefined ? this.size === 0 : !this.some(function() {
            return true;
        });
    },
    count: function count(predicate, context) {
        return ensureSize(predicate ? this.toSeq().filter(predicate, context) : this);
    },
    countBy: function countBy(grouper, context) {
        return countByFactory(this, grouper, context);
    },
    equals: function equals(other) {
        return deepEqual(this, other);
    },
    entrySeq: function entrySeq() {
        var collection = this;
        if (collection._cache) // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(collection._cache);
        var entriesSequence = collection.toSeq().map(entryMapper).toIndexedSeq();
        entriesSequence.fromEntrySeq = function() {
            return collection.toSeq();
        };
        return entriesSequence;
    },
    filterNot: function filterNot(predicate, context) {
        return this.filter(not(predicate), context);
    },
    findEntry: function findEntry(predicate, context, notSetValue) {
        var found = notSetValue;
        this.__iterate(function(v, k, c) {
            if (predicate.call(context, v, k, c)) {
                found = [
                    k,
                    v
                ];
                return false;
            }
        });
        return found;
    },
    findKey: function findKey(predicate, context) {
        var entry = this.findEntry(predicate, context);
        return entry && entry[0];
    },
    findLast: function findLast(predicate, context, notSetValue) {
        return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },
    findLastEntry: function findLastEntry(predicate, context, notSetValue) {
        return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
    },
    findLastKey: function findLastKey(predicate, context) {
        return this.toKeyedSeq().reverse().findKey(predicate, context);
    },
    first: function first() {
        return this.find(returnTrue);
    },
    flatMap: function flatMap(mapper, context) {
        return reify(this, flatMapFactory(this, mapper, context));
    },
    flatten: function flatten(depth) {
        return reify(this, flattenFactory(this, depth, true));
    },
    fromEntrySeq: function fromEntrySeq() {
        return new FromEntriesSequence(this);
    },
    get: function get(searchKey, notSetValue) {
        return this.find(function(_, key) {
            return is(key, searchKey);
        }, undefined, notSetValue);
    },
    getIn: getIn$$1,
    groupBy: function groupBy(grouper, context) {
        return groupByFactory(this, grouper, context);
    },
    has: function has(searchKey) {
        return this.get(searchKey, NOT_SET) !== NOT_SET;
    },
    hasIn: hasIn$$1,
    isSubset: function isSubset(iter) {
        iter = typeof iter.includes === 'function' ? iter : Collection(iter);
        return this.every(function(value) {
            return iter.includes(value);
        });
    },
    isSuperset: function isSuperset(iter) {
        iter = typeof iter.isSubset === 'function' ? iter : Collection(iter);
        return iter.isSubset(this);
    },
    keyOf: function keyOf(searchValue) {
        return this.findKey(function(value) {
            return is(value, searchValue);
        });
    },
    keySeq: function keySeq() {
        return this.toSeq().map(keyMapper).toIndexedSeq();
    },
    last: function last() {
        return this.toSeq().reverse().first();
    },
    lastKeyOf: function lastKeyOf(searchValue) {
        return this.toKeyedSeq().reverse().keyOf(searchValue);
    },
    max: function max(comparator) {
        return maxFactory(this, comparator);
    },
    maxBy: function maxBy(mapper, comparator) {
        return maxFactory(this, comparator, mapper);
    },
    min: function min(comparator) {
        return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },
    minBy: function minBy(mapper, comparator) {
        return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },
    rest: function rest() {
        return this.slice(1);
    },
    skip: function skip(amount) {
        return amount === 0 ? this : this.slice(Math.max(0, amount));
    },
    skipLast: function skipLast(amount) {
        return amount === 0 ? this : this.slice(0, -Math.max(0, amount));
    },
    skipWhile: function skipWhile(predicate, context) {
        return reify(this, skipWhileFactory(this, predicate, context, true));
    },
    skipUntil: function skipUntil(predicate, context) {
        return this.skipWhile(not(predicate), context);
    },
    sortBy: function sortBy(mapper, comparator) {
        return reify(this, sortFactory(this, comparator, mapper));
    },
    take: function take(amount) {
        return this.slice(0, Math.max(0, amount));
    },
    takeLast: function takeLast(amount) {
        return this.slice(-Math.max(0, amount));
    },
    takeWhile: function takeWhile(predicate, context) {
        return reify(this, takeWhileFactory(this, predicate, context));
    },
    takeUntil: function takeUntil(predicate, context) {
        return this.takeWhile(not(predicate), context);
    },
    update: function update(fn) {
        return fn(this);
    },
    valueSeq: function valueSeq() {
        return this.toIndexedSeq();
    },
    // ### Hashable Object
    hashCode: function hashCode() {
        return this.__hash || (this.__hash = hashCollection(this));
    }
});
var CollectionPrototype = Collection.prototype;
CollectionPrototype[IS_ITERABLE_SENTINEL] = true;
CollectionPrototype[ITERATOR_SYMBOL] = CollectionPrototype.values;
CollectionPrototype.toJSON = CollectionPrototype.toArray;
CollectionPrototype.__toStringMapper = quoteString;
CollectionPrototype.inspect = CollectionPrototype.toSource = function() {
    return this.toString();
};
CollectionPrototype.chain = CollectionPrototype.flatMap;
CollectionPrototype.contains = CollectionPrototype.includes;
mixin(KeyedCollection, {
    // ### More sequential methods
    flip: function flip() {
        return reify(this, flipFactory(this));
    },
    mapEntries: function mapEntries(mapper, context) {
        var this$1 = this;
        var iterations = 0;
        return reify(this, this.toSeq().map(function(v, k) {
            return mapper.call(context, [
                k,
                v
            ], iterations++, this$1);
        }).fromEntrySeq());
    },
    mapKeys: function mapKeys(mapper, context) {
        var this$1 = this;
        return reify(this, this.toSeq().flip().map(function(k, v) {
            return mapper.call(context, k, v, this$1);
        }).flip());
    }
});
var KeyedCollectionPrototype = KeyedCollection.prototype;
KeyedCollectionPrototype[IS_KEYED_SENTINEL] = true;
KeyedCollectionPrototype[ITERATOR_SYMBOL] = CollectionPrototype.entries;
KeyedCollectionPrototype.toJSON = toObject;
KeyedCollectionPrototype.__toStringMapper = function(v, k) {
    return quoteString(k) + ': ' + quoteString(v);
};
mixin(IndexedCollection, {
    // ### Conversion to other types
    toKeyedSeq: function toKeyedSeq() {
        return new ToKeyedSequence(this, false);
    },
    // ### ES6 Collection methods (ES6 Array and Map)
    filter: function filter(predicate, context) {
        return reify(this, filterFactory(this, predicate, context, false));
    },
    findIndex: function findIndex(predicate, context) {
        var entry = this.findEntry(predicate, context);
        return entry ? entry[0] : -1;
    },
    indexOf: function indexOf(searchValue) {
        var key = this.keyOf(searchValue);
        return key === undefined ? -1 : key;
    },
    lastIndexOf: function lastIndexOf(searchValue) {
        var key = this.lastKeyOf(searchValue);
        return key === undefined ? -1 : key;
    },
    reverse: function reverse() {
        return reify(this, reverseFactory(this, false));
    },
    slice: function slice(begin, end) {
        return reify(this, sliceFactory(this, begin, end, false));
    },
    splice: function splice(index, removeNum /*, ...values*/ ) {
        var numArgs = arguments.length;
        removeNum = Math.max(removeNum || 0, 0);
        if (numArgs === 0 || numArgs === 2 && !removeNum) return this;
        // If index is negative, it should resolve relative to the size of the
        // collection. However size may be expensive to compute if not cached, so
        // only call count() if the number is in fact negative.
        index = resolveBegin(index, index < 0 ? this.count() : this.size);
        var spliced = this.slice(0, index);
        return reify(this, numArgs === 1 ? spliced : spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum)));
    },
    // ### More collection methods
    findLastIndex: function findLastIndex(predicate, context) {
        var entry = this.findLastEntry(predicate, context);
        return entry ? entry[0] : -1;
    },
    first: function first() {
        return this.get(0);
    },
    flatten: function flatten(depth) {
        return reify(this, flattenFactory(this, depth, false));
    },
    get: function get(index, notSetValue) {
        index = wrapIndex(this, index);
        return index < 0 || this.size === Infinity || this.size !== undefined && index > this.size ? notSetValue : this.find(function(_, key) {
            return key === index;
        }, undefined, notSetValue);
    },
    has: function has(index) {
        index = wrapIndex(this, index);
        return index >= 0 && (this.size !== undefined ? this.size === Infinity || index < this.size : this.indexOf(index) !== -1);
    },
    interpose: function interpose(separator) {
        return reify(this, interposeFactory(this, separator));
    },
    interleave: function interleave() {
        var collections = [
            this
        ].concat(arrCopy(arguments));
        var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, collections);
        var interleaved = zipped.flatten(true);
        if (zipped.size) interleaved.size = zipped.size * collections.length;
        return reify(this, interleaved);
    },
    keySeq: function keySeq() {
        return Range(0, this.size);
    },
    last: function last() {
        return this.get(-1);
    },
    skipWhile: function skipWhile(predicate, context) {
        return reify(this, skipWhileFactory(this, predicate, context, false));
    },
    zip: function zip() {
        var collections = [
            this
        ].concat(arrCopy(arguments));
        return reify(this, zipWithFactory(this, defaultZipper, collections));
    },
    zipAll: function zipAll() {
        var collections = [
            this
        ].concat(arrCopy(arguments));
        return reify(this, zipWithFactory(this, defaultZipper, collections, true));
    },
    zipWith: function zipWith(zipper /*, ...collections */ ) {
        var collections = arrCopy(arguments);
        collections[0] = this;
        return reify(this, zipWithFactory(this, zipper, collections));
    }
});
var IndexedCollectionPrototype = IndexedCollection.prototype;
IndexedCollectionPrototype[IS_INDEXED_SENTINEL] = true;
IndexedCollectionPrototype[IS_ORDERED_SENTINEL] = true;
mixin(SetCollection, {
    // ### ES6 Collection methods (ES6 Array and Map)
    get: function get(value, notSetValue) {
        return this.has(value) ? value : notSetValue;
    },
    includes: function includes(value) {
        return this.has(value);
    },
    // ### More sequential methods
    keySeq: function keySeq() {
        return this.valueSeq();
    }
});
SetCollection.prototype.has = CollectionPrototype.includes;
SetCollection.prototype.contains = SetCollection.prototype.includes;
// Mixin subclasses
mixin(KeyedSeq, KeyedCollection.prototype);
mixin(IndexedSeq, IndexedCollection.prototype);
mixin(SetSeq, SetCollection.prototype);
// #pragma Helper functions
function reduce(collection, reducer, reduction, context, useFirst, reverse) {
    assertNotInfinite(collection.size);
    collection.__iterate(function(v, k, c) {
        if (useFirst) {
            useFirst = false;
            reduction = v;
        } else reduction = reducer.call(context, reduction, v, k, c);
    }, reverse);
    return reduction;
}
function keyMapper(v, k) {
    return k;
}
function entryMapper(v, k) {
    return [
        k,
        v
    ];
}
function not(predicate) {
    return function() {
        return !predicate.apply(this, arguments);
    };
}
function neg(predicate) {
    return function() {
        return -predicate.apply(this, arguments);
    };
}
function defaultZipper() {
    return arrCopy(arguments);
}
function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
}
function hashCollection(collection) {
    if (collection.size === Infinity) return 0;
    var ordered = isOrdered(collection);
    var keyed = isKeyed(collection);
    var h = ordered ? 1 : 0;
    var size = collection.__iterate(keyed ? ordered ? function(v, k) {
        h = 31 * h + hashMerge(hash(v), hash(k)) | 0;
    } : function(v, k) {
        h = h + hashMerge(hash(v), hash(k)) | 0;
    } : ordered ? function(v) {
        h = 31 * h + hash(v) | 0;
    } : function(v) {
        h = h + hash(v) | 0;
    });
    return murmurHashOfSize(size, h);
}
function murmurHashOfSize(size, h) {
    h = imul(h, 0xcc9e2d51);
    h = imul(h << 15 | h >>> -15, 0x1b873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xe6546b64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85ebca6b);
    h = imul(h ^ h >>> 13, 0xc2b2ae35);
    h = smi(h ^ h >>> 16);
    return h;
}
function hashMerge(a, b) {
    return a ^ b + 0x9e3779b9 + (a << 6) + (a >> 2) | 0; // int
}
var OrderedSet = function(Set$$1) {
    function OrderedSet(value) {
        return value === null || value === undefined ? emptyOrderedSet() : isOrderedSet(value) ? value : emptyOrderedSet().withMutations(function(set) {
            var iter = SetCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    if (Set$$1) OrderedSet.__proto__ = Set$$1;
    OrderedSet.prototype = Object.create(Set$$1 && Set$$1.prototype);
    OrderedSet.prototype.constructor = OrderedSet;
    OrderedSet.of = function of() {
        return this(arguments);
    };
    OrderedSet.fromKeys = function fromKeys(value) {
        return this(KeyedCollection(value).keySeq());
    };
    OrderedSet.prototype.toString = function toString() {
        return this.__toString('OrderedSet {', '}');
    };
    return OrderedSet;
}(Set);
function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
}
OrderedSet.isOrderedSet = isOrderedSet;
var OrderedSetPrototype = OrderedSet.prototype;
OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
OrderedSetPrototype.zip = IndexedCollectionPrototype.zip;
OrderedSetPrototype.zipWith = IndexedCollectionPrototype.zipWith;
OrderedSetPrototype.__empty = emptyOrderedSet;
OrderedSetPrototype.__make = makeOrderedSet;
function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
}
var EMPTY_ORDERED_SET;
function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
}
var Record = function Record(defaultValues, name) {
    var hasInitialized;
    var RecordType = function Record(values) {
        var this$1 = this;
        if (values instanceof RecordType) return values;
        if (!(this instanceof RecordType)) return new RecordType(values);
        if (!hasInitialized) {
            hasInitialized = true;
            var keys = Object.keys(defaultValues);
            var indices = RecordTypePrototype._indices = {};
            RecordTypePrototype._name = name;
            RecordTypePrototype._keys = keys;
            RecordTypePrototype._defaultValues = defaultValues;
            for(var i = 0; i < keys.length; i++){
                var propName = keys[i];
                indices[propName] = i;
                if (RecordTypePrototype[propName]) /* eslint-disable no-console */ typeof console === 'object' && console.warn && console.warn('Cannot define ' + recordName(this$1) + ' with property "' + propName + '" since that property name is part of the Record API.');
                else setProp(RecordTypePrototype, propName);
            }
        }
        this.__ownerID = undefined;
        this._values = List().withMutations(function(l) {
            l.setSize(this$1._keys.length);
            KeyedCollection(values).forEach(function(v, k) {
                l.set(this$1._indices[k], v === this$1._defaultValues[k] ? undefined : v);
            });
        });
    };
    var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
    RecordTypePrototype.constructor = RecordType;
    return RecordType;
};
Record.prototype.toString = function toString() {
    var this$1 = this;
    var str = recordName(this) + ' { ';
    var keys = this._keys;
    var k;
    for(var i = 0, l = keys.length; i !== l; i++){
        k = keys[i];
        str += (i ? ', ' : '') + k + ': ' + quoteString(this$1.get(k));
    }
    return str + ' }';
};
Record.prototype.equals = function equals(other) {
    return this === other || other && this._keys === other._keys && recordSeq(this).equals(recordSeq(other));
};
Record.prototype.hashCode = function hashCode() {
    return recordSeq(this).hashCode();
};
// @pragma Access
Record.prototype.has = function has(k) {
    return this._indices.hasOwnProperty(k);
};
Record.prototype.get = function get(k, notSetValue) {
    if (!this.has(k)) return notSetValue;
    var index = this._indices[k];
    var value = this._values.get(index);
    return value === undefined ? this._defaultValues[k] : value;
};
// @pragma Modification
Record.prototype.set = function set(k, v) {
    if (this.has(k)) {
        var newValues = this._values.set(this._indices[k], v === this._defaultValues[k] ? undefined : v);
        if (newValues !== this._values && !this.__ownerID) return makeRecord(this, newValues);
    }
    return this;
};
Record.prototype.remove = function remove(k) {
    return this.set(k);
};
Record.prototype.clear = function clear() {
    var newValues = this._values.clear().setSize(this._keys.length);
    return this.__ownerID ? this : makeRecord(this, newValues);
};
Record.prototype.wasAltered = function wasAltered() {
    return this._values.wasAltered();
};
Record.prototype.toSeq = function toSeq() {
    return recordSeq(this);
};
Record.prototype.toJS = function toJS$1() {
    return toJS(this);
};
Record.prototype.entries = function entries() {
    return this.__iterator(ITERATE_ENTRIES);
};
Record.prototype.__iterator = function __iterator(type, reverse) {
    return recordSeq(this).__iterator(type, reverse);
};
Record.prototype.__iterate = function __iterate(fn, reverse) {
    return recordSeq(this).__iterate(fn, reverse);
};
Record.prototype.__ensureOwner = function __ensureOwner(ownerID) {
    if (ownerID === this.__ownerID) return this;
    var newValues = this._values.__ensureOwner(ownerID);
    if (!ownerID) {
        this.__ownerID = ownerID;
        this._values = newValues;
        return this;
    }
    return makeRecord(this, newValues, ownerID);
};
Record.isRecord = isRecord;
Record.getDescriptiveName = recordName;
var RecordPrototype = Record.prototype;
RecordPrototype[IS_RECORD_SENTINEL] = true;
RecordPrototype[DELETE] = RecordPrototype.remove;
RecordPrototype.deleteIn = RecordPrototype.removeIn = deleteIn;
RecordPrototype.getIn = getIn$$1;
RecordPrototype.hasIn = CollectionPrototype.hasIn;
RecordPrototype.merge = merge;
RecordPrototype.mergeWith = mergeWith;
RecordPrototype.mergeIn = mergeIn;
RecordPrototype.mergeDeep = mergeDeep;
RecordPrototype.mergeDeepWith = mergeDeepWith;
RecordPrototype.mergeDeepIn = mergeDeepIn;
RecordPrototype.setIn = setIn$$1;
RecordPrototype.update = update$$1;
RecordPrototype.updateIn = updateIn$1;
RecordPrototype.withMutations = withMutations;
RecordPrototype.asMutable = asMutable;
RecordPrototype.asImmutable = asImmutable;
RecordPrototype[ITERATOR_SYMBOL] = RecordPrototype.entries;
RecordPrototype.toJSON = RecordPrototype.toObject = CollectionPrototype.toObject;
RecordPrototype.inspect = RecordPrototype.toSource = function() {
    return this.toString();
};
function makeRecord(likeRecord, values, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._values = values;
    record.__ownerID = ownerID;
    return record;
}
function recordName(record) {
    return record._name || record.constructor.name || 'Record';
}
function recordSeq(record) {
    return keyedSeqFromValue(record._keys.map(function(k) {
        return [
            k,
            record.get(k)
        ];
    }));
}
function setProp(prototype, name) {
    try {
        Object.defineProperty(prototype, name, {
            get: function() {
                return this.get(name);
            },
            set: function(value) {
                invariant(this.__ownerID, 'Cannot set on an immutable record.');
                this.set(name, value);
            }
        });
    } catch (error) {
    // Object.defineProperty failed. Probably IE8.
    }
}
/**
 * Returns a lazy Seq of `value` repeated `times` times. When `times` is
 * undefined, returns an infinite sequence of `value`.
 */ var Repeat = function(IndexedSeq$$1) {
    function Repeat(value, times) {
        if (!(this instanceof Repeat)) return new Repeat(value, times);
        this._value = value;
        this.size = times === undefined ? Infinity : Math.max(0, times);
        if (this.size === 0) {
            if (EMPTY_REPEAT) return EMPTY_REPEAT;
            EMPTY_REPEAT = this;
        }
    }
    if (IndexedSeq$$1) Repeat.__proto__ = IndexedSeq$$1;
    Repeat.prototype = Object.create(IndexedSeq$$1 && IndexedSeq$$1.prototype);
    Repeat.prototype.constructor = Repeat;
    Repeat.prototype.toString = function toString() {
        if (this.size === 0) return 'Repeat []';
        return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };
    Repeat.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._value : notSetValue;
    };
    Repeat.prototype.includes = function includes(searchValue) {
        return is(this._value, searchValue);
    };
    Repeat.prototype.slice = function slice(begin, end) {
        var size = this.size;
        return wholeSlice(begin, end, size) ? this : new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };
    Repeat.prototype.reverse = function reverse() {
        return this;
    };
    Repeat.prototype.indexOf = function indexOf(searchValue) {
        if (is(this._value, searchValue)) return 0;
        return -1;
    };
    Repeat.prototype.lastIndexOf = function lastIndexOf(searchValue) {
        if (is(this._value, searchValue)) return this.size;
        return -1;
    };
    Repeat.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1 = this;
        var size = this.size;
        var i = 0;
        while(i !== size){
            if (fn(this$1._value, reverse ? size - ++i : i++, this$1) === false) break;
        }
        return i;
    };
    Repeat.prototype.__iterator = function __iterator(type, reverse) {
        var this$1 = this;
        var size = this.size;
        var i = 0;
        return new Iterator(function() {
            return i === size ? iteratorDone() : iteratorValue(type, reverse ? size - ++i : i++, this$1._value);
        });
    };
    Repeat.prototype.equals = function equals(other) {
        return other instanceof Repeat ? is(this._value, other._value) : deepEqual(other);
    };
    return Repeat;
}(IndexedSeq);
var EMPTY_REPEAT;
function fromJS(value, converter) {
    return fromJSWith([], converter || defaultConverter, value, '', converter && converter.length > 2 ? [] : undefined, {
        '': value
    });
}
function fromJSWith(stack, converter, value, key, keyPath, parentValue) {
    var toSeq = Array.isArray(value) ? IndexedSeq : isPlainObj(value) ? KeyedSeq : null;
    if (toSeq) {
        if (~stack.indexOf(value)) throw new TypeError('Cannot convert circular structure to Immutable');
        stack.push(value);
        keyPath && key !== '' && keyPath.push(key);
        var converted = converter.call(parentValue, key, toSeq(value).map(function(v, k) {
            return fromJSWith(stack, converter, v, k, keyPath, value);
        }), keyPath && keyPath.slice());
        stack.pop();
        keyPath && keyPath.pop();
        return converted;
    }
    return value;
}
function defaultConverter(k, v) {
    return isKeyed(v) ? v.toMap() : v.toList();
}
var version = "4.0.0-rc.9";
// Functional read/write API
var Immutable = {
    version: version,
    Collection: Collection,
    // Note: Iterable is deprecated
    Iterable: Collection,
    Seq: Seq,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,
    Record: Record,
    Range: Range,
    Repeat: Repeat,
    is: is,
    fromJS: fromJS,
    hash: hash,
    isImmutable: isImmutable,
    isCollection: isCollection,
    isKeyed: isKeyed,
    isIndexed: isIndexed,
    isAssociative: isAssociative,
    isOrdered: isOrdered,
    isValueObject: isValueObject,
    get: get,
    getIn: getIn$1,
    has: has,
    hasIn: hasIn$1,
    merge: merge$1,
    mergeDeep: mergeDeep$1,
    mergeWith: mergeWith$1,
    mergeDeepWith: mergeDeepWith$1,
    remove: remove,
    removeIn: removeIn,
    set: set,
    setIn: setIn$1,
    update: update$1,
    updateIn: updateIn
};
// Note: Iterable is deprecated
var Iterable = Collection;
var $bb6be968fd3babc9$export$2e2bcd8739ae039 = Immutable;

});

parcelRegister("lwEMm", function(module, exports) {

$parcel$export(module.exports, "DISJUNCTIVE_FACET_TYPE", () => $fabc37f8a80d584d$export$91bee53bcb4bd3f8);
$parcel$export(module.exports, "CONJUNCTIVE_FACET_TYPE", () => $fabc37f8a80d584d$export$67e226be74e0a900);
$parcel$export(module.exports, "default", () => $fabc37f8a80d584d$export$2e2bcd8739ae039);

var $g5DHJ = parcelRequire("g5DHJ");

var $1Qivz = parcelRequire("1Qivz");
const $fabc37f8a80d584d$export$91bee53bcb4bd3f8 = 'disjunctive';
const $fabc37f8a80d584d$export$67e226be74e0a900 = 'conjunctive';
class $fabc37f8a80d584d$export$2e2bcd8739ae039 extends (0, $g5DHJ.Record)({
    algoliaFacetKey: undefined,
    queryType: undefined
}) {
    static disjunctive(algoliaFacetKey) {
        return new $fabc37f8a80d584d$export$2e2bcd8739ae039({
            algoliaFacetKey: algoliaFacetKey,
            queryType: $fabc37f8a80d584d$export$91bee53bcb4bd3f8
        });
    }
    static conjunctive(algoliaFacetKey) {
        return new $fabc37f8a80d584d$export$2e2bcd8739ae039({
            algoliaFacetKey: algoliaFacetKey,
            queryType: $fabc37f8a80d584d$export$67e226be74e0a900
        });
    }
}
const $fabc37f8a80d584d$export$a0dd41b84533ed48 = (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).instanceOf($fabc37f8a80d584d$export$2e2bcd8739ae039);

});

parcelRegister("b5Eig", function(module, exports) {

$parcel$export(module.exports, "default", () => $812f6ac9b2b15b51$export$2e2bcd8739ae039);
$parcel$export(module.exports, "SearchParamsUpdatePropType", () => $812f6ac9b2b15b51$export$851407edb471805);

var $g5DHJ = parcelRequire("g5DHJ");

var $1Qivz = parcelRequire("1Qivz");
class $812f6ac9b2b15b51$export$2e2bcd8739ae039 extends (0, $g5DHJ.Record)({
    /**
   * Set[FacetType]
   */ types: undefined,
    /**
   * params => params
   */ apply: undefined
}) {
    compose(spu2) {
        return new $812f6ac9b2b15b51$export$2e2bcd8739ae039({
            types: this.types.concat(spu2.types),
            apply: (params)=>spu2.apply(this.apply(params))
        });
    }
    copy(_ref) {
        let { types: types, apply: apply } = _ref;
        return new $812f6ac9b2b15b51$export$2e2bcd8739ae039({
            types: types || this.types,
            apply: apply || this.apply
        });
    }
    /**
   * @param f : params => params
   * @return {SearchParamsUpdate}
   */ composeApply(f) {
        return new $812f6ac9b2b15b51$export$2e2bcd8739ae039({
            types: this.types,
            apply: (params)=>f(this.apply(params))
        });
    }
    static default_() {
        return new $812f6ac9b2b15b51$export$2e2bcd8739ae039({
            types: (0, $g5DHJ.Set)(),
            apply: (q)=>q
        });
    }
}
const $812f6ac9b2b15b51$export$851407edb471805 = (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).instanceOf($812f6ac9b2b15b51$export$2e2bcd8739ae039);

});

parcelRegister("6XDNr", function(module, exports) {

$parcel$export(module.exports, "default", () => $51171f84a5f42d79$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $lgRZl = parcelRequire("lgRZl");

var $g5DHJ = parcelRequire("g5DHJ");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("jJs3W");
var $b02ud = parcelRequire("b02ud");


var $90ON9 = parcelRequire("90ON9");

var $b5Eig = parcelRequire("b5Eig");

var $emLm3 = parcelRequire("emLm3");

var $8OnOc = parcelRequire("8OnOc");

var $iXJMo = parcelRequire("iXJMo");

var $lqDCJ = parcelRequire("lqDCJ");
const $51171f84a5f42d79$var$App = (props)=>{
    const store = (0, $eUqFw.useMemo)(()=>(0, $emLm3.default)({
            debug: props.debug,
            reducer: $lqDCJ.default
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b02ud.default), {
        store: store
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iXJMo.default), (0, $kU09D.default)({}, props, {
        algoliaClient: props.algoliaClient || (0, $8OnOc.createAlgoliaClient)(props.algoliaConfig.toObject())
    })));
};
$51171f84a5f42d79$var$App.propTypes = {
    /**
   * Algolia config, ie. Application and API keys
   *
   * shape: Map({
   *      applicationId: string,
   *      apiKey: string
   * })
   *
   * Required if Algolia Client is not provided
   */ algoliaConfig: (0, $lgRZl.default).requiredIf((0, $90ON9.default).algoliaConfig, (props)=>!props.algoliaClient),
    /**
   * Algolia search client for maintaining cache between searches
   * Provided by third-party algoliasearch library, and not dereferenced
   *
   * shape: any (but must have AlgoliaClient class name)
   *
   * Required if Algolia Config is not provided
   */ algoliaClient: (0, $lgRZl.default).requiredIf((0, $90ON9.default).algoliaClient, (props)=>!props.algoliaConfig),
    /**
   * A SearchParamsUpdate where:
   * types: Set<FacetType>
   * apply: (AlgoliaSearchHelper.SearchParameters) => AlgoliaSearchHelper.SearchParameters
   *
   * `types` lets you define a set of facets that aren't already known to Addon Discovery but are defined
   * in Algolia. `apply` lets you apply relevant filtering to the SearchParameters.
   */ applyOverrides: (0, $b5Eig.SearchParamsUpdatePropType),
    /**
   * List<FeaturedContentOverride>
   * For each FeaturedContentOverride, we will always render the node from `render()` in place of the
   * tile at `index`.
   *
   * shape: List.of(
   *      featuredContentOverride : Record({
   *           index: number,
   *           render: function
   *      })
   * )
   */ contentOverrides: (0, $90ON9.default).contentOverrides,
    /**
   * A class name to apply to the top-level element.
   */ containerClassName: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    /**
   * When true, will turn on debug mode.
   */ debug: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    /**
   * Which environment we are running in.
   */ environment: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
        (0, $658e6bd3ffbfdac1$export$404582bc18fe4d9e),
        (0, $658e6bd3ffbfdac1$export$46be287603848c56),
        (0, $658e6bd3ffbfdac1$export$e51cdc15d0c6bee2)
    ]).isRequired,
    /**
   * Map<string, string | Set<string>>
   * The filters to apply to the search facets. Each key corresponds to a facet name.
   * Accepts "unenhanced" filters, meaning that for filters that accept
   * multiple values, it will also accept a single value.
   */ filters: (0, $90ON9.default).filters,
    /**
   * When true, the "Load more results" button will not be rendered even if there are
   * more possible results to fetch.
   */ hidePagination: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    /**
   * A map of callbacks for when hit-related actions occur such as click or mount, plus
   * functions for resolving relative URLs in search results into absolute URLs.
   *
   * shape: Map({
   *     hitHrefResolver: function (optional),
   *     hitImageHrefResolver: function,
   *     onHitClick: function,
   *     onHitMount: function (optional),
   *     onRatingsClick: function (optional)
   * })
   */ hitContext: (0, $90ON9.default).hitContext.isRequired,
    /**
   * "large" | "small"
   * The size of each hit to render.
   */ hitSize: (0, $90ON9.default).hitSize,
    /**
   * If defined, the maximum number of hits to render.
   */ maxLength: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    /**
   * ({ currentPage: number }) => void
   * A callback for when the "Load more results" button is clicked. This overrides the default
   * behaviour of fetching another page of results.
   */ onLoadMoreResultsClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    /**
   * Map<string,
   *     ({ params: AlgoliaSearchHelper.SearchParameters, filters: Filters }) => AlgoliaSearchHelper.SearchParameters>
   * With the key being a facet, each function allows low-level modifications to the SearchParameters sent to Algolia.
   */ resolveAlgoliaQueryFilterOverrides: (0, $90ON9.default).resolveAlgoliaQueryFilterOverrides,
    /**
   * (List<Hit>) => List<Hit>
   * A function that reorders the given list of hits to a desired order.
   * If provided, only one page of results will ever be displayed.
   */ sortHits: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
};
$51171f84a5f42d79$var$App.defaultProps = {
    colSpan: (0, $g5DHJ.Map)(),
    debug: false,
    applyOverrides: (0, $b5Eig.default).default_(),
    filters: (0, $g5DHJ.Map)(),
    hidePagination: false,
    screenClass: 'xl'
};
var $51171f84a5f42d79$export$2e2bcd8739ae039 = $51171f84a5f42d79$var$App;

});
parcelRegister("lgRZl", function(module, exports) {

$parcel$export(module.exports, "default", () => $03ff0c44770159d9$export$2e2bcd8739ae039);

var $1Qivz = parcelRequire("1Qivz");
var $03ff0c44770159d9$export$2e2bcd8739ae039 = {
    requiredIf (type, condition) {
        return function(props) {
            const test = condition(props) ? type.isRequired : type; // eslint-disable-next-line prefer-rest-params
            return test.apply(this, arguments);
        };
    },
    screenClass: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
        'xl',
        'lg',
        'md',
        'sm',
        'xs'
    ])
};

});

parcelRegister("jJs3W", function(module, exports) {
$parcel$export(module.exports, "connect", () => (parcelRequire("94zHK")).default);
$parcel$export(module.exports, "Provider", () => (parcelRequire("b02ud")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("6N2vY")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("cU4FA")).useSelector);
parcelRequire("lPIk7");
parcelRequire("035eW");
var $lEfVV = parcelRequire("lEfVV");

var $4Ut1d = parcelRequire("4Ut1d");
// with standard React renderers (ReactDOM, React Native)
(0, $4Ut1d.setBatch)((0, $lEfVV.unstable_batchedUpdates));

});
parcelRegister("lPIk7", function(module, exports) {

$parcel$export(module.exports, "Provider", () => (parcelRequire("b02ud")).default);
$parcel$export(module.exports, "connect", () => (parcelRequire("94zHK")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("6N2vY")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("cU4FA")).useSelector);

var $b02ud = parcelRequire("b02ud");

var $lwCWn = parcelRequire("lwCWn");

var $iqB4h = parcelRequire("iqB4h");

var $94zHK = parcelRequire("94zHK");

var $6N2vY = parcelRequire("6N2vY");

var $cU4FA = parcelRequire("cU4FA");

var $2bGhE = parcelRequire("2bGhE");

var $9UMSs = parcelRequire("9UMSs");

});
parcelRegister("b02ud", function(module, exports) {

$parcel$export(module.exports, "default", () => $80219f881731fd50$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $iqB4h = parcelRequire("iqB4h");

var $eOZYb = parcelRequire("eOZYb");

var $8RW1t = parcelRequire("8RW1t");
function $80219f881731fd50$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $eUqFw.useMemo)(function() {
        var subscription = (0, $eOZYb.createSubscription)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $eUqFw.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $8RW1t.useIsomorphicLayoutEffect)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $iqB4h.ReactReduxContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $80219f881731fd50$export$2e2bcd8739ae039 = $80219f881731fd50$var$Provider;

});
parcelRegister("iqB4h", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", () => $d6a768a4a73470b3$export$cc80c08dc91f1c00);

var $eUqFw = parcelRequire("eUqFw");
var $d6a768a4a73470b3$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(null);
var $d6a768a4a73470b3$export$2e2bcd8739ae039 = $d6a768a4a73470b3$export$cc80c08dc91f1c00;

});

parcelRegister("eOZYb", function(module, exports) {

$parcel$export(module.exports, "createSubscription", () => $aca5ce1240833bb9$export$d567d2b9af322f8f);

var $4Ut1d = parcelRequire("4Ut1d");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $aca5ce1240833bb9$var$createListenerCollection() {
    var batch = (0, $4Ut1d.getBatch)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $aca5ce1240833bb9$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $aca5ce1240833bb9$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $aca5ce1240833bb9$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $aca5ce1240833bb9$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $aca5ce1240833bb9$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}

});
parcelRegister("4Ut1d", function(module, exports) {

$parcel$export(module.exports, "setBatch", () => $3932e6df69670101$export$4b9874722d0da7bc);
$parcel$export(module.exports, "getBatch", () => $3932e6df69670101$export$fc47d4c0ba3bd2c6);
// Default to a dummy "batch" implementation that just runs the callback
function $3932e6df69670101$var$defaultNoopBatch(callback) {
    callback();
}
var $3932e6df69670101$var$batch = $3932e6df69670101$var$defaultNoopBatch; // Allow injecting another batching function later
var $3932e6df69670101$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $3932e6df69670101$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $3932e6df69670101$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $3932e6df69670101$var$batch;
};

});


parcelRegister("8RW1t", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $67504818408d46d4$export$700979bc83e7db82);

var $eUqFw = parcelRequire("eUqFw");
var $67504818408d46d4$export$700979bc83e7db82 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $eUqFw.useLayoutEffect) : (0, $eUqFw.useEffect);

});


parcelRegister("lwCWn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fabacaeccb986465$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");

var $lxchL = parcelRequire("lxchL");

var $eUqFw = parcelRequire("eUqFw");

var $8T8or = parcelRequire("8T8or");

var $eOZYb = parcelRequire("eOZYb");

var $8RW1t = parcelRequire("8RW1t");

var $iqB4h = parcelRequire("iqB4h");
var $fabacaeccb986465$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $fabacaeccb986465$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $fabacaeccb986465$var$EMPTY_ARRAY = [];
var $fabacaeccb986465$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $fabacaeccb986465$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $fabacaeccb986465$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $fabacaeccb986465$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $8RW1t.useIsomorphicLayoutEffect)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $fabacaeccb986465$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $fabacaeccb986465$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: 'STORE_UPDATED',
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $fabacaeccb986465$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $fabacaeccb986465$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $iqB4h.ReactReduxContext) : _ref2$context, connectOptions = (0, $6XgOP.default)(_ref2, $fabacaeccb986465$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $kU09D.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $eUqFw.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $eUqFw.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $6XgOP.default)(props, $fabacaeccb986465$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $eUqFw.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $8T8or.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $eUqFw.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $eUqFw.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $eUqFw.useMemo)(function() {
                if (!shouldHandleStateChanges) return $fabacaeccb986465$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $eOZYb.createSubscription)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $eUqFw.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $kU09D.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $eUqFw.useReducer)($fabacaeccb986465$var$storeStateUpdatesReducer, $fabacaeccb986465$var$EMPTY_ARRAY, $fabacaeccb986465$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $eUqFw.useRef)();
            var lastWrapperProps = (0, $eUqFw.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $eUqFw.useRef)();
            var renderIsScheduled = (0, $eUqFw.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $fabacaeccb986465$var$useIsomorphicLayoutEffectWithArgs($fabacaeccb986465$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $fabacaeccb986465$var$useIsomorphicLayoutEffectWithArgs($fabacaeccb986465$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $eUqFw.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, (0, $kU09D.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $eUqFw.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Connect, (0, $kU09D.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($lxchL)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($lxchL)))(Connect, WrappedComponent);
    };
}

});
parcelRegister("8T8or", function(module, exports) {
'use strict';

module.exports = (parcelRequire("eU3cC"));

});
parcelRegister("eU3cC", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $ad98c79b0cc564ad$export$a7c73072b1a182ae, (v) => $ad98c79b0cc564ad$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $ad98c79b0cc564ad$export$9f27bc3417b4524d, (v) => $ad98c79b0cc564ad$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $ad98c79b0cc564ad$export$db77ccec0bb4ccac, (v) => $ad98c79b0cc564ad$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $ad98c79b0cc564ad$export$8392c0c9d3dcbd35, (v) => $ad98c79b0cc564ad$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $ad98c79b0cc564ad$export$ffb0004e005737fa, (v) => $ad98c79b0cc564ad$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $ad98c79b0cc564ad$export$b624eff549462981, (v) => $ad98c79b0cc564ad$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $ad98c79b0cc564ad$export$7897aa7841a5380c, (v) => $ad98c79b0cc564ad$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $ad98c79b0cc564ad$export$602eac185826482c, (v) => $ad98c79b0cc564ad$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $ad98c79b0cc564ad$export$e2c29f18771995cb, (v) => $ad98c79b0cc564ad$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $ad98c79b0cc564ad$export$5f8d39834fd61797, (v) => $ad98c79b0cc564ad$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $ad98c79b0cc564ad$export$74bf444e3cd11ea5, (v) => $ad98c79b0cc564ad$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $ad98c79b0cc564ad$export$92387174baf9b227, (v) => $ad98c79b0cc564ad$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $ad98c79b0cc564ad$export$ec112efeb987d9c6, (v) => $ad98c79b0cc564ad$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $ad98c79b0cc564ad$export$b706b080d889d2c9, (v) => $ad98c79b0cc564ad$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $ad98c79b0cc564ad$export$5be5a87408f70ddc, (v) => $ad98c79b0cc564ad$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $ad98c79b0cc564ad$export$45a5e7f76e0caa8d, (v) => $ad98c79b0cc564ad$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $ad98c79b0cc564ad$export$455c2e768291efa6, (v) => $ad98c79b0cc564ad$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $ad98c79b0cc564ad$export$9522e17588c12572, (v) => $ad98c79b0cc564ad$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $ad98c79b0cc564ad$export$2110ac352bb060b9, (v) => $ad98c79b0cc564ad$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $ad98c79b0cc564ad$export$56885ab8b9c456ab, (v) => $ad98c79b0cc564ad$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $ad98c79b0cc564ad$export$d927fcb6adf8f9de, (v) => $ad98c79b0cc564ad$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $ad98c79b0cc564ad$export$b82d16f27459e05a, (v) => $ad98c79b0cc564ad$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $ad98c79b0cc564ad$export$522c17b4f5e123e8, (v) => $ad98c79b0cc564ad$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $ad98c79b0cc564ad$export$1aabd8a0274ecfd6, (v) => $ad98c79b0cc564ad$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $ad98c79b0cc564ad$export$9b621391a187a31a, (v) => $ad98c79b0cc564ad$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $ad98c79b0cc564ad$export$f5bbd400c2f4426f, (v) => $ad98c79b0cc564ad$export$f5bbd400c2f4426f = v);
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ad98c79b0cc564ad$export$a7c73072b1a182ae;
var $ad98c79b0cc564ad$export$9f27bc3417b4524d;
var $ad98c79b0cc564ad$export$db77ccec0bb4ccac;
var $ad98c79b0cc564ad$export$8392c0c9d3dcbd35;
var $ad98c79b0cc564ad$export$ffb0004e005737fa;
var $ad98c79b0cc564ad$export$b624eff549462981;
var $ad98c79b0cc564ad$export$7897aa7841a5380c;
var $ad98c79b0cc564ad$export$602eac185826482c;
var $ad98c79b0cc564ad$export$e2c29f18771995cb;
var $ad98c79b0cc564ad$export$5f8d39834fd61797;
var $ad98c79b0cc564ad$export$74bf444e3cd11ea5;
var $ad98c79b0cc564ad$export$92387174baf9b227;
var $ad98c79b0cc564ad$export$ec112efeb987d9c6;
var $ad98c79b0cc564ad$export$b706b080d889d2c9;
var $ad98c79b0cc564ad$export$5be5a87408f70ddc;
var $ad98c79b0cc564ad$export$45a5e7f76e0caa8d;
var $ad98c79b0cc564ad$export$455c2e768291efa6;
var $ad98c79b0cc564ad$export$9522e17588c12572;
var $ad98c79b0cc564ad$export$2110ac352bb060b9;
var $ad98c79b0cc564ad$export$56885ab8b9c456ab;
var $ad98c79b0cc564ad$export$d927fcb6adf8f9de;
var $ad98c79b0cc564ad$export$b82d16f27459e05a;
var $ad98c79b0cc564ad$export$522c17b4f5e123e8;
var $ad98c79b0cc564ad$export$1aabd8a0274ecfd6;
var $ad98c79b0cc564ad$export$9b621391a187a31a;
var $ad98c79b0cc564ad$export$f5bbd400c2f4426f;
'use strict';
var $ad98c79b0cc564ad$var$b = 60103, $ad98c79b0cc564ad$var$c = 60106, $ad98c79b0cc564ad$var$d = 60107, $ad98c79b0cc564ad$var$e = 60108, $ad98c79b0cc564ad$var$f = 60114, $ad98c79b0cc564ad$var$g = 60109, $ad98c79b0cc564ad$var$h = 60110, $ad98c79b0cc564ad$var$k = 60112, $ad98c79b0cc564ad$var$l = 60113, $ad98c79b0cc564ad$var$m = 60120, $ad98c79b0cc564ad$var$n = 60115, $ad98c79b0cc564ad$var$p = 60116, $ad98c79b0cc564ad$var$q = 60121, $ad98c79b0cc564ad$var$r = 60122, $ad98c79b0cc564ad$var$u = 60117, $ad98c79b0cc564ad$var$v = 60129, $ad98c79b0cc564ad$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $ad98c79b0cc564ad$var$x = Symbol.for;
    $ad98c79b0cc564ad$var$b = $ad98c79b0cc564ad$var$x("react.element");
    $ad98c79b0cc564ad$var$c = $ad98c79b0cc564ad$var$x("react.portal");
    $ad98c79b0cc564ad$var$d = $ad98c79b0cc564ad$var$x("react.fragment");
    $ad98c79b0cc564ad$var$e = $ad98c79b0cc564ad$var$x("react.strict_mode");
    $ad98c79b0cc564ad$var$f = $ad98c79b0cc564ad$var$x("react.profiler");
    $ad98c79b0cc564ad$var$g = $ad98c79b0cc564ad$var$x("react.provider");
    $ad98c79b0cc564ad$var$h = $ad98c79b0cc564ad$var$x("react.context");
    $ad98c79b0cc564ad$var$k = $ad98c79b0cc564ad$var$x("react.forward_ref");
    $ad98c79b0cc564ad$var$l = $ad98c79b0cc564ad$var$x("react.suspense");
    $ad98c79b0cc564ad$var$m = $ad98c79b0cc564ad$var$x("react.suspense_list");
    $ad98c79b0cc564ad$var$n = $ad98c79b0cc564ad$var$x("react.memo");
    $ad98c79b0cc564ad$var$p = $ad98c79b0cc564ad$var$x("react.lazy");
    $ad98c79b0cc564ad$var$q = $ad98c79b0cc564ad$var$x("react.block");
    $ad98c79b0cc564ad$var$r = $ad98c79b0cc564ad$var$x("react.server.block");
    $ad98c79b0cc564ad$var$u = $ad98c79b0cc564ad$var$x("react.fundamental");
    $ad98c79b0cc564ad$var$v = $ad98c79b0cc564ad$var$x("react.debug_trace_mode");
    $ad98c79b0cc564ad$var$w = $ad98c79b0cc564ad$var$x("react.legacy_hidden");
}
function $ad98c79b0cc564ad$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $ad98c79b0cc564ad$var$b:
                switch(a = a.type, a){
                    case $ad98c79b0cc564ad$var$d:
                    case $ad98c79b0cc564ad$var$f:
                    case $ad98c79b0cc564ad$var$e:
                    case $ad98c79b0cc564ad$var$l:
                    case $ad98c79b0cc564ad$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $ad98c79b0cc564ad$var$h:
                            case $ad98c79b0cc564ad$var$k:
                            case $ad98c79b0cc564ad$var$p:
                            case $ad98c79b0cc564ad$var$n:
                            case $ad98c79b0cc564ad$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $ad98c79b0cc564ad$var$c:
                return t;
        }
    }
}
var $ad98c79b0cc564ad$var$z = $ad98c79b0cc564ad$var$g, $ad98c79b0cc564ad$var$A = $ad98c79b0cc564ad$var$b, $ad98c79b0cc564ad$var$B = $ad98c79b0cc564ad$var$k, $ad98c79b0cc564ad$var$C = $ad98c79b0cc564ad$var$d, $ad98c79b0cc564ad$var$D = $ad98c79b0cc564ad$var$p, $ad98c79b0cc564ad$var$E = $ad98c79b0cc564ad$var$n, $ad98c79b0cc564ad$var$F = $ad98c79b0cc564ad$var$c, $ad98c79b0cc564ad$var$G = $ad98c79b0cc564ad$var$f, $ad98c79b0cc564ad$var$H = $ad98c79b0cc564ad$var$e, $ad98c79b0cc564ad$var$I = $ad98c79b0cc564ad$var$l;
$ad98c79b0cc564ad$export$a7c73072b1a182ae = $ad98c79b0cc564ad$var$h;
$ad98c79b0cc564ad$export$9f27bc3417b4524d = $ad98c79b0cc564ad$var$z;
$ad98c79b0cc564ad$export$db77ccec0bb4ccac = $ad98c79b0cc564ad$var$A;
$ad98c79b0cc564ad$export$8392c0c9d3dcbd35 = $ad98c79b0cc564ad$var$B;
$ad98c79b0cc564ad$export$ffb0004e005737fa = $ad98c79b0cc564ad$var$C;
$ad98c79b0cc564ad$export$b624eff549462981 = $ad98c79b0cc564ad$var$D;
$ad98c79b0cc564ad$export$7897aa7841a5380c = $ad98c79b0cc564ad$var$E;
$ad98c79b0cc564ad$export$602eac185826482c = $ad98c79b0cc564ad$var$F;
$ad98c79b0cc564ad$export$e2c29f18771995cb = $ad98c79b0cc564ad$var$G;
$ad98c79b0cc564ad$export$5f8d39834fd61797 = $ad98c79b0cc564ad$var$H;
$ad98c79b0cc564ad$export$74bf444e3cd11ea5 = $ad98c79b0cc564ad$var$I;
$ad98c79b0cc564ad$export$92387174baf9b227 = function() {
    return !1;
};
$ad98c79b0cc564ad$export$ec112efeb987d9c6 = function() {
    return !1;
};
$ad98c79b0cc564ad$export$b706b080d889d2c9 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$h;
};
$ad98c79b0cc564ad$export$5be5a87408f70ddc = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$g;
};
$ad98c79b0cc564ad$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $ad98c79b0cc564ad$var$b;
};
$ad98c79b0cc564ad$export$455c2e768291efa6 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$k;
};
$ad98c79b0cc564ad$export$9522e17588c12572 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$d;
};
$ad98c79b0cc564ad$export$2110ac352bb060b9 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$p;
};
$ad98c79b0cc564ad$export$56885ab8b9c456ab = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$n;
};
$ad98c79b0cc564ad$export$d927fcb6adf8f9de = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$c;
};
$ad98c79b0cc564ad$export$b82d16f27459e05a = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$f;
};
$ad98c79b0cc564ad$export$522c17b4f5e123e8 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$e;
};
$ad98c79b0cc564ad$export$1aabd8a0274ecfd6 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$l;
};
$ad98c79b0cc564ad$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $ad98c79b0cc564ad$var$d || a === $ad98c79b0cc564ad$var$f || a === $ad98c79b0cc564ad$var$v || a === $ad98c79b0cc564ad$var$e || a === $ad98c79b0cc564ad$var$l || a === $ad98c79b0cc564ad$var$m || a === $ad98c79b0cc564ad$var$w || "object" === typeof a && null !== a && (a.$$typeof === $ad98c79b0cc564ad$var$p || a.$$typeof === $ad98c79b0cc564ad$var$n || a.$$typeof === $ad98c79b0cc564ad$var$g || a.$$typeof === $ad98c79b0cc564ad$var$h || a.$$typeof === $ad98c79b0cc564ad$var$k || a.$$typeof === $ad98c79b0cc564ad$var$u || a.$$typeof === $ad98c79b0cc564ad$var$q || a[0] === $ad98c79b0cc564ad$var$r) ? !0 : !1;
};
$ad98c79b0cc564ad$export$f5bbd400c2f4426f = $ad98c79b0cc564ad$var$y;

});



parcelRegister("94zHK", function(module, exports) {

$parcel$export(module.exports, "default", () => $69b02ef9f183b3d3$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");

var $lwCWn = parcelRequire("lwCWn");

var $9UMSs = parcelRequire("9UMSs");

var $foygv = parcelRequire("foygv");

var $jjA10 = parcelRequire("jjA10");

var $2Spd8 = parcelRequire("2Spd8");

var $eEprf = parcelRequire("eEprf");
var $69b02ef9f183b3d3$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $69b02ef9f183b3d3$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $69b02ef9f183b3d3$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $69b02ef9f183b3d3$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $lwCWn.default) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $jjA10.default) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $foygv.default) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $2Spd8.default) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $eEprf.default) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $69b02ef9f183b3d3$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $9UMSs.default) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $9UMSs.default) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $9UMSs.default) : _ref3$areMergedPropsE, extraOptions = (0, $6XgOP.default)(_ref3, $69b02ef9f183b3d3$var$_excluded);
        var initMapStateToProps = $69b02ef9f183b3d3$var$match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
        var initMapDispatchToProps = $69b02ef9f183b3d3$var$match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
        var initMergeProps = $69b02ef9f183b3d3$var$match(mergeProps, mergePropsFactories, 'mergeProps');
        return connectHOC(selectorFactory, (0, $kU09D.default)({
            // used in error messages
            methodName: 'connect',
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $69b02ef9f183b3d3$export$2e2bcd8739ae039 = /*#__PURE__*/ $69b02ef9f183b3d3$export$9f9feb656dec1fc4();

});
parcelRegister("9UMSs", function(module, exports) {

$parcel$export(module.exports, "default", () => $737f420d78dbedc2$export$2e2bcd8739ae039);
function $737f420d78dbedc2$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $737f420d78dbedc2$export$2e2bcd8739ae039(objA, objB) {
    if ($737f420d78dbedc2$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$737f420d78dbedc2$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});

parcelRegister("foygv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b353ad45ed306afd$export$2e2bcd8739ae039);

var $aGUDQ = parcelRequire("aGUDQ");

var $16dJ8 = parcelRequire("16dJ8");
function $b353ad45ed306afd$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === 'function' ? (0, $16dJ8.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function $b353ad45ed306afd$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $16dJ8.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $b353ad45ed306afd$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $16dJ8.wrapMapToPropsConstant)(function(dispatch) {
        return (0, $aGUDQ.default)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $b353ad45ed306afd$export$2e2bcd8739ae039 = [
    $b353ad45ed306afd$export$a9f27b4b187c1166,
    $b353ad45ed306afd$export$ba20d1a7aa0c4a90,
    $b353ad45ed306afd$export$94a6e55709d4d961
];

});
parcelRegister("aGUDQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c89c37b8d715cdf$export$2e2bcd8739ae039);
function $7c89c37b8d715cdf$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}

});

parcelRegister("16dJ8", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", () => $0cd0ffddfe5f8933$export$710f7c60f68acd3e);
$parcel$export(module.exports, "wrapMapToPropsFunc", () => $0cd0ffddfe5f8933$export$8d46c7f53c8c602f);
parcelRequire("32fpu");
function $0cd0ffddfe5f8933$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $0cd0ffddfe5f8933$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $0cd0ffddfe5f8933$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $0cd0ffddfe5f8933$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $0cd0ffddfe5f8933$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("32fpu", function(module, exports) {

var $lkFcE = parcelRequire("lkFcE");

var $2pJov = parcelRequire("2pJov");
function $235d832188fff043$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $lkFcE.default)(value)) (0, $2pJov.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}

});
parcelRegister("lkFcE", function(module, exports) {

$parcel$export(module.exports, "default", () => $f87b6d4f23da449f$export$2e2bcd8739ae039);
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $f87b6d4f23da449f$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});

parcelRegister("2pJov", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c2120ec62b602d3$export$2e2bcd8739ae039);
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $1c2120ec62b602d3$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});




parcelRegister("jjA10", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0fbba8fd20a154b$export$2e2bcd8739ae039);

var $16dJ8 = parcelRequire("16dJ8");
function $e0fbba8fd20a154b$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === 'function' ? (0, $16dJ8.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
}
function $e0fbba8fd20a154b$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $16dJ8.wrapMapToPropsConstant)(function() {
        return {};
    }) : undefined;
}
var $e0fbba8fd20a154b$export$2e2bcd8739ae039 = [
    $e0fbba8fd20a154b$export$23fc470827b14aa,
    $e0fbba8fd20a154b$export$514bc8c1a53c1d66
];

});

parcelRegister("2Spd8", function(module, exports) {

$parcel$export(module.exports, "default", () => $21842e43b7ea3faa$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");
parcelRequire("32fpu");
function $21842e43b7ea3faa$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $kU09D.default)({}, ownProps, stateProps, dispatchProps);
}
function $21842e43b7ea3faa$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $21842e43b7ea3faa$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === 'function' ? $21842e43b7ea3faa$export$5b105939c84b5234(mergeProps) : undefined;
}
function $21842e43b7ea3faa$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $21842e43b7ea3faa$export$691c327fc30bc857;
    } : undefined;
}
var $21842e43b7ea3faa$export$2e2bcd8739ae039 = [
    $21842e43b7ea3faa$export$d61b680184bc3f00,
    $21842e43b7ea3faa$export$a13ba70ef50dda6d
];

});

parcelRegister("eEprf", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaa888a6349e99a0$export$2e2bcd8739ae039);

var $6XgOP = parcelRequire("6XgOP");
parcelRequire("dGyYX");
var $aaa888a6349e99a0$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $aaa888a6349e99a0$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $aaa888a6349e99a0$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $aaa888a6349e99a0$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $6XgOP.default)(_ref2, $aaa888a6349e99a0$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $aaa888a6349e99a0$export$d20c0c2ca6eb2b6f : $aaa888a6349e99a0$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("dGyYX", function(module, exports) {

var $2pJov = parcelRequire("2pJov");
function $9f6a5555b7986929$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $2pJov.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $9f6a5555b7986929$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $9f6a5555b7986929$var$verify(mapStateToProps, 'mapStateToProps', displayName);
    $9f6a5555b7986929$var$verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
    $9f6a5555b7986929$var$verify(mergeProps, 'mergeProps', displayName);
}

});



parcelRegister("6N2vY", function(module, exports) {

$parcel$export(module.exports, "useDispatch", () => $4f194509acee95c5$export$8ad76b76a4c905f8);

var $iqB4h = parcelRequire("iqB4h");

var $2bGhE = parcelRequire("2bGhE");
function $4f194509acee95c5$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $iqB4h.ReactReduxContext);
    var useStore = context === (0, $iqB4h.ReactReduxContext) ? (0, $2bGhE.useStore) : (0, $2bGhE.createStoreHook)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $4f194509acee95c5$export$8ad76b76a4c905f8 = /*#__PURE__*/ $4f194509acee95c5$export$bc9b55530897c558();

});
parcelRegister("2bGhE", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", () => $197d688751cead73$export$671dba69185d0304);
$parcel$export(module.exports, "useStore", () => $197d688751cead73$export$6ccbb43953eebf8);

var $eUqFw = parcelRequire("eUqFw");

var $iqB4h = parcelRequire("iqB4h");

var $bs1OA = parcelRequire("bs1OA");
function $197d688751cead73$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $iqB4h.ReactReduxContext);
    var useReduxContext = context === (0, $iqB4h.ReactReduxContext) ? (0, $bs1OA.useReduxContext) : function() {
        return (0, $eUqFw.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $197d688751cead73$export$6ccbb43953eebf8 = /*#__PURE__*/ $197d688751cead73$export$671dba69185d0304();

});
parcelRegister("bs1OA", function(module, exports) {

$parcel$export(module.exports, "useReduxContext", () => $8563b7a80af4c71a$export$c1275ca9a6fd3ec5);

var $eUqFw = parcelRequire("eUqFw");

var $iqB4h = parcelRequire("iqB4h");
function $8563b7a80af4c71a$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $eUqFw.useContext)((0, $iqB4h.ReactReduxContext));
    return contextValue;
}

});



parcelRegister("cU4FA", function(module, exports) {

$parcel$export(module.exports, "useSelector", () => $964e5656bc2edcae$export$2105062e25df4afe);

var $eUqFw = parcelRequire("eUqFw");

var $bs1OA = parcelRequire("bs1OA");

var $eOZYb = parcelRequire("eOZYb");

var $8RW1t = parcelRequire("8RW1t");

var $iqB4h = parcelRequire("iqB4h");
var $964e5656bc2edcae$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $964e5656bc2edcae$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $eUqFw.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $eUqFw.useMemo)(function() {
        return (0, $eOZYb.createSubscription)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $eUqFw.useRef)();
    var latestSelector = (0, $eUqFw.useRef)();
    var latestStoreState = (0, $eUqFw.useRef)();
    var latestSelectedState = (0, $eUqFw.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $8RW1t.useIsomorphicLayoutEffect)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $8RW1t.useIsomorphicLayoutEffect)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $964e5656bc2edcae$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $iqB4h.ReactReduxContext);
    var useReduxContext = context === (0, $iqB4h.ReactReduxContext) ? (0, $bs1OA.useReduxContext) : function() {
        return (0, $eUqFw.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $964e5656bc2edcae$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $964e5656bc2edcae$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $eUqFw.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $964e5656bc2edcae$export$2105062e25df4afe = /*#__PURE__*/ $964e5656bc2edcae$export$2b53f90d2bd1cbfb();

});


parcelRegister("035eW", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", () => (parcelRequire("lEfVV")).unstable_batchedUpdates);
/* eslint-disable import/no-unresolved */ 
var $lEfVV = parcelRequire("lEfVV");

});


const $658e6bd3ffbfdac1$export$404582bc18fe4d9e = 'dev';
const $658e6bd3ffbfdac1$export$46be287603848c56 = 'stg';
const $658e6bd3ffbfdac1$export$e51cdc15d0c6bee2 = 'prod';

parcelRegister("90ON9", function(module, exports) {

$parcel$export(module.exports, "default", () => $68fb835227ef2e44$export$2e2bcd8739ae039);

var $lgRZl = parcelRequire("lgRZl");

var $fEeDC = parcelRequire("fEeDC");

var $g5DHJ = parcelRequire("g5DHJ");

var $1Qivz = parcelRequire("1Qivz");

var $3ONu7 = parcelRequire("3ONu7");

var $fCICH = parcelRequire("fCICH");

var $eMCmH = parcelRequire("eMCmH");

var $fOzGB = parcelRequire("fOzGB");


var $gggoS = parcelRequire("gggoS");
const $68fb835227ef2e44$var$highlightResult = (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
    matchLevel: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired
});
const $68fb835227ef2e44$var$hitImage = (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
    image: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    highRes: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    smallImage: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    smallHighResImage: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string
});
const $68fb835227ef2e44$var$hitVendor = (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
    isTopVendor: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired
});
const $68fb835227ef2e44$var$hitDistribution = (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
    bundled: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
    activeInstalls: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    downloads: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number.isRequired,
    deltaInstalls: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number.isRequired
});
const $68fb835227ef2e44$var$hitVersion = (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
    compatibilities: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).listOf((0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
        applicationKey: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
        applicationName: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
        hosting: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired
    })),
    remotable: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired
});
const $68fb835227ef2e44$var$hitRatings = (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
    avgStars: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number.isRequired,
    numRatings: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number.isRequired
});
const $68fb835227ef2e44$var$hit = (fromSearch)=>(0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).recordOf({
        _highlightResult: (0, $lgRZl.default).requiredIf((0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
            name: $68fb835227ef2e44$var$highlightResult.isRequired,
            tokenizedName: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).listOf($68fb835227ef2e44$var$highlightResult).isRequired,
            tagLine: $68fb835227ef2e44$var$highlightResult,
            tokenizedTagLine: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).listOf($68fb835227ef2e44$var$highlightResult)
        }), ()=>fromSearch),
        addonId: (0, $lgRZl.default).requiredIf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number, ()=>fromSearch),
        addonKey: (0, $lgRZl.default).requiredIf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string, ()=>fromSearch),
        releaseDate: (0, $lgRZl.default).requiredIf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number, ()=>fromSearch),
        name: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
        tagLine: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
        categories: (0, $lgRZl.default).requiredIf((0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).listOf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string), ()=>fromSearch),
        deployments: (0, $lgRZl.default).requiredIf((0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).listOf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string), ()=>fromSearch),
        documentType: (0, $lgRZl.default).requiredIf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string, ()=>fromSearch),
        logo: (0, $lgRZl.default).requiredIf($68fb835227ef2e44$var$hitImage, ()=>fromSearch),
        vendor: (0, $lgRZl.default).requiredIf($68fb835227ef2e44$var$hitVendor, ()=>fromSearch),
        distribution: (0, $lgRZl.default).requiredIf($68fb835227ef2e44$var$hitDistribution, ()=>fromSearch),
        version: (0, $lgRZl.default).requiredIf($68fb835227ef2e44$var$hitVersion, ()=>fromSearch),
        ratings: (0, $lgRZl.default).requiredIf($68fb835227ef2e44$var$hitRatings, ()=>fromSearch)
    });
const $68fb835227ef2e44$var$colSpan = (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
    xl: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    lg: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    md: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    sm: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    xs: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number
});
const $68fb835227ef2e44$var$featuredContentOverride = (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).instanceOf((0, $eMCmH.default));
const $68fb835227ef2e44$var$algoliaClientPropType = (0, $fOzGB.chainablePropType)((props, propName, componentName)=>props[propName].constructor.name !== 'AlgoliaClient' ? new Error("Invalid prop ".concat(propName, " supplied to ").concat(componentName, ". Validation failed.")) : null);
const $68fb835227ef2e44$var$CommonPropTypes = {
    algoliaClient: $68fb835227ef2e44$var$algoliaClientPropType,
    algoliaConfig: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
        applicationId: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
        apiKey: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired
    }),
    colSpan: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
        largeHits: $68fb835227ef2e44$var$colSpan,
        smallHits: $68fb835227ef2e44$var$colSpan
    }),
    contentOverrides: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).listOf($68fb835227ef2e44$var$featuredContentOverride),
    discoverCollectionsConfig: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).mapOf((0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).list, (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf((0, $g5DHJ.Map)($122620c1047e308e$exports).toList().push((0, $3ONu7.HOME)).toArray())),
    featuredContentOverride: $68fb835227ef2e44$var$featuredContentOverride,
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains((0, $gggoS.filtersPropTypeFactory)((0, $fCICH.getFilters)()).toJS()),
    resolveAlgoliaQueryFilterOverrides: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).mapOf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func, (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf((0, $fCICH.getFilters)().keySeq().toJS())),
    hit () {
        function checkType(isRequired, props) {
            const test = $68fb835227ef2e44$var$hit(props.fromSearch);
            for(var _len = arguments.length, restArgs = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)restArgs[_key - 2] = arguments[_key];
            return (isRequired ? test.isRequired : test).apply(this, [
                props,
                ...restArgs
            ]);
        }
        const chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
    },
    hitContext: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
        hitHrefResolver: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        hitImageHrefResolver: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
        onHitClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
        onHitMount: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        onRatingsClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        hitGroup: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string
    }),
    hitSize: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
        'large',
        'small'
    ]),
    screenClass: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
        'xl',
        'lg',
        'md',
        'sm',
        'xs'
    ]),
    search: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
        currentPage: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
        dataError: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
        dataErrorMessages: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).list.isRequired,
        loadingFreshSearchResults: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
        moreResultsDataError: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
        moreResultsDataErrorMessages: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).list.isRequired,
        searchResults: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
            searchId: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
            facets: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).list,
            hits: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).list,
            numberOfPages: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
            numberOfHits: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number
        }),
        initialized: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
        searchInProgress: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired
    }),
    transitions: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
        transitionStarted: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        transitionCompleted: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
    }),
    unenhancedFilters: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains((0, $gggoS.unenhancedPropTypeFactory)((0, $fCICH.getFilters)()).toJS())
};
var $68fb835227ef2e44$export$2e2bcd8739ae039 = $68fb835227ef2e44$var$CommonPropTypes;

});
parcelRegister("fEeDC", function(module, exports) {
/**
 * This is a straight rip-off of the React.js ReactPropTypes.js proptype validators,
 * modified to make it possible to validate Immutable.js data.
 *     ImmutableTypes.listOf is patterned after React.PropTypes.arrayOf, but for Immutable.List
 *     ImmutableTypes.shape  is based on React.PropTypes.shape, but for any Immutable.Iterable
 */ "use strict";

var $g5DHJ = parcelRequire("g5DHJ");
var $b645f239ba611daa$var$ANONYMOUS = "<<anonymous>>";
var $b645f239ba611daa$var$ImmutablePropTypes;
var $b645f239ba611daa$var$productionTypeChecker = function productionTypeChecker() {
    invariant(false, "ImmutablePropTypes type checking code is stripped in production.");
};
$b645f239ba611daa$var$productionTypeChecker.isRequired = $b645f239ba611daa$var$productionTypeChecker;
var $b645f239ba611daa$var$getProductionTypeChecker = function getProductionTypeChecker() {
    return $b645f239ba611daa$var$productionTypeChecker;
};
$b645f239ba611daa$var$ImmutablePropTypes = {
    listOf: $b645f239ba611daa$var$getProductionTypeChecker,
    mapOf: $b645f239ba611daa$var$getProductionTypeChecker,
    orderedMapOf: $b645f239ba611daa$var$getProductionTypeChecker,
    setOf: $b645f239ba611daa$var$getProductionTypeChecker,
    orderedSetOf: $b645f239ba611daa$var$getProductionTypeChecker,
    stackOf: $b645f239ba611daa$var$getProductionTypeChecker,
    iterableOf: $b645f239ba611daa$var$getProductionTypeChecker,
    recordOf: $b645f239ba611daa$var$getProductionTypeChecker,
    shape: $b645f239ba611daa$var$getProductionTypeChecker,
    contains: $b645f239ba611daa$var$getProductionTypeChecker,
    mapContains: $b645f239ba611daa$var$getProductionTypeChecker,
    // Primitive Types
    list: $b645f239ba611daa$var$productionTypeChecker,
    map: $b645f239ba611daa$var$productionTypeChecker,
    orderedMap: $b645f239ba611daa$var$productionTypeChecker,
    set: $b645f239ba611daa$var$productionTypeChecker,
    orderedSet: $b645f239ba611daa$var$productionTypeChecker,
    stack: $b645f239ba611daa$var$productionTypeChecker,
    seq: $b645f239ba611daa$var$productionTypeChecker,
    record: $b645f239ba611daa$var$productionTypeChecker,
    iterable: $b645f239ba611daa$var$productionTypeChecker
};
$b645f239ba611daa$var$ImmutablePropTypes.iterable.indexed = $b645f239ba611daa$var$createIterableSubclassTypeChecker("Indexed", $g5DHJ.Iterable.isIndexed);
$b645f239ba611daa$var$ImmutablePropTypes.iterable.keyed = $b645f239ba611daa$var$createIterableSubclassTypeChecker("Keyed", $g5DHJ.Iterable.isKeyed);
function $b645f239ba611daa$var$getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) return "array";
    if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return "object";
    if (propValue instanceof $g5DHJ.Iterable) return "Immutable." + propValue.toSource().split(" ")[0];
    return propType;
}
function $b645f239ba611daa$var$createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        for(var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++)rest[_key - 6] = arguments[_key];
        propFullName = propFullName || propName;
        componentName = componentName || $b645f239ba611daa$var$ANONYMOUS;
        if (props[propName] == null) {
            var locationName = location;
            if (isRequired) return new Error("Required " + locationName + " `" + propFullName + "` was not specified in " + ("`" + componentName + "`."));
        } else return validate.apply(undefined, [
            props,
            propName,
            componentName,
            location,
            propFullName
        ].concat(rest));
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}
function $b645f239ba611daa$var$createImmutableTypeChecker(immutableClassName, immutableClassTypeValidator) {
    function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!immutableClassTypeValidator(propValue)) {
            var propType = $b645f239ba611daa$var$getPropType(propValue);
            return new Error("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `" + immutableClassName + "`."));
        }
        return null;
    }
    return $b645f239ba611daa$var$createChainableTypeChecker(validate);
}
function $b645f239ba611daa$var$createIterableSubclassTypeChecker(subclassName, validator) {
    return $b645f239ba611daa$var$createImmutableTypeChecker("Iterable." + subclassName, function(propValue) {
        return $g5DHJ.Iterable.isIterable(propValue) && validator(propValue);
    });
}
function $b645f239ba611daa$var$createIterableTypeChecker(typeChecker, immutableClassName, immutableClassTypeValidator) {
    function validate(props, propName, componentName, location, propFullName) {
        for(var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++)rest[_key - 5] = arguments[_key];
        var propValue = props[propName];
        if (!immutableClassTypeValidator(propValue)) {
            var locationName = location;
            var propType = $b645f239ba611daa$var$getPropType(propValue);
            return new Error("Invalid " + locationName + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an Immutable.js " + immutableClassName + "."));
        }
        if (typeof typeChecker !== "function") return new Error("Invalid typeChecker supplied to `" + componentName + "` " + ("for propType `" + propFullName + "`, expected a function."));
        var propValues = propValue.valueSeq().toArray();
        for(var i = 0, len = propValues.length; i < len; i++){
            var error = typeChecker.apply(undefined, [
                propValues,
                i,
                componentName,
                location,
                "" + propFullName + "[" + i + "]"
            ].concat(rest));
            if (error instanceof Error) return error;
        }
    }
    return $b645f239ba611daa$var$createChainableTypeChecker(validate);
}
function $b645f239ba611daa$var$createKeysTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
        for(var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++)rest[_key - 5] = arguments[_key];
        var propValue = props[propName];
        if (typeof typeChecker !== "function") return new Error("Invalid keysTypeChecker (optional second argument) supplied to `" + componentName + "` " + ("for propType `" + propFullName + "`, expected a function."));
        var keys = propValue.keySeq().toArray();
        for(var i = 0, len = keys.length; i < len; i++){
            var error = typeChecker.apply(undefined, [
                keys,
                i,
                componentName,
                location,
                "" + propFullName + " -> key(" + keys[i] + ")"
            ].concat(rest));
            if (error instanceof Error) return error;
        }
    }
    return $b645f239ba611daa$var$createChainableTypeChecker(validate);
}
function $b645f239ba611daa$var$createListOfTypeChecker(typeChecker) {
    return $b645f239ba611daa$var$createIterableTypeChecker(typeChecker, "List", $g5DHJ.List.isList);
}
function $b645f239ba611daa$var$createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, immutableClassName, immutableClassTypeValidator) {
    function validate() {
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return $b645f239ba611daa$var$createIterableTypeChecker(valuesTypeChecker, immutableClassName, immutableClassTypeValidator).apply(undefined, args) || keysTypeChecker && $b645f239ba611daa$var$createKeysTypeChecker(keysTypeChecker).apply(undefined, args);
    }
    return $b645f239ba611daa$var$createChainableTypeChecker(validate);
}
function $b645f239ba611daa$var$createMapOfTypeChecker(valuesTypeChecker, keysTypeChecker) {
    return $b645f239ba611daa$var$createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, "Map", $g5DHJ.Map.isMap);
}
function $b645f239ba611daa$var$createOrderedMapOfTypeChecker(valuesTypeChecker, keysTypeChecker) {
    return $b645f239ba611daa$var$createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, "OrderedMap", $g5DHJ.OrderedMap.isOrderedMap);
}
function $b645f239ba611daa$var$createSetOfTypeChecker(typeChecker) {
    return $b645f239ba611daa$var$createIterableTypeChecker(typeChecker, "Set", $g5DHJ.Set.isSet);
}
function $b645f239ba611daa$var$createOrderedSetOfTypeChecker(typeChecker) {
    return $b645f239ba611daa$var$createIterableTypeChecker(typeChecker, "OrderedSet", $g5DHJ.OrderedSet.isOrderedSet);
}
function $b645f239ba611daa$var$createStackOfTypeChecker(typeChecker) {
    return $b645f239ba611daa$var$createIterableTypeChecker(typeChecker, "Stack", $g5DHJ.Stack.isStack);
}
function $b645f239ba611daa$var$createIterableOfTypeChecker(typeChecker) {
    return $b645f239ba611daa$var$createIterableTypeChecker(typeChecker, "Iterable", $g5DHJ.Iterable.isIterable);
}
function $b645f239ba611daa$var$createRecordOfTypeChecker(recordKeys) {
    function validate(props, propName, componentName, location, propFullName) {
        for(var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++)rest[_key - 5] = arguments[_key];
        var propValue = props[propName];
        if (!(propValue instanceof $g5DHJ.Record)) {
            var propType = $b645f239ba611daa$var$getPropType(propValue);
            var locationName = location;
            return new Error("Invalid " + locationName + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected an Immutable.js Record."));
        }
        for(var key in recordKeys){
            var checker = recordKeys[key];
            if (!checker) continue;
            var mutablePropValue = propValue.toObject();
            var error = checker.apply(undefined, [
                mutablePropValue,
                key,
                componentName,
                location,
                "" + propFullName + "." + key
            ].concat(rest));
            if (error) return error;
        }
    }
    return $b645f239ba611daa$var$createChainableTypeChecker(validate);
}
// there is some irony in the fact that shapeTypes is a standard hash and not an immutable collection
function $b645f239ba611daa$var$createShapeTypeChecker(shapeTypes) {
    var immutableClassName = arguments[1] === undefined ? "Iterable" : arguments[1];
    var immutableClassTypeValidator = arguments[2] === undefined ? $g5DHJ.Iterable.isIterable : arguments[2];
    function validate(props, propName, componentName, location, propFullName) {
        for(var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++)rest[_key - 5] = arguments[_key];
        var propValue = props[propName];
        if (!immutableClassTypeValidator(propValue)) {
            var propType = $b645f239ba611daa$var$getPropType(propValue);
            var locationName = location;
            return new Error("Invalid " + locationName + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected an Immutable.js " + immutableClassName + "."));
        }
        var mutablePropValue = propValue.toObject();
        for(var key in shapeTypes){
            var checker = shapeTypes[key];
            if (!checker) continue;
            var error = checker.apply(undefined, [
                mutablePropValue,
                key,
                componentName,
                location,
                "" + propFullName + "." + key
            ].concat(rest));
            if (error) return error;
        }
    }
    return $b645f239ba611daa$var$createChainableTypeChecker(validate);
}
function $b645f239ba611daa$var$createShapeChecker(shapeTypes) {
    return $b645f239ba611daa$var$createShapeTypeChecker(shapeTypes);
}
function $b645f239ba611daa$var$createMapContainsChecker(shapeTypes) {
    return $b645f239ba611daa$var$createShapeTypeChecker(shapeTypes, "Map", $g5DHJ.Map.isMap);
}
module.exports = $b645f239ba611daa$var$ImmutablePropTypes;

});

parcelRegister("3ONu7", function(module, exports) {

$parcel$export(module.exports, "HOME", () => $2c7c6d4234dd21cf$export$a7c5707626fc90f);
$parcel$export(module.exports, "CollectionsEnum", () => $2c7c6d4234dd21cf$export$39bbf650e2467463);
$parcel$export(module.exports, "LARGE_COLLECTION_TYPE", () => $2c7c6d4234dd21cf$export$1da19aa559318561);
$parcel$export(module.exports, "SMALL_COLLECTION_TYPE", () => $2c7c6d4234dd21cf$export$954f870831c20abc);
$parcel$export(module.exports, "default", () => $2c7c6d4234dd21cf$export$2e2bcd8739ae039);

var $3RTYU = parcelRequire("3RTYU");

var $g5DHJ = parcelRequire("g5DHJ");

var $c8Guq = parcelRequire("c8Guq");

var $fMsDx = parcelRequire("fMsDx");

var $fCICH = parcelRequire("fCICH");

var $9LwYq = parcelRequire("9LwYq");



var $b5Eig = parcelRequire("b5Eig");

var $bavaN = parcelRequire("bavaN");
const $2c7c6d4234dd21cf$export$a7c5707626fc90f = 'home';
const $2c7c6d4234dd21cf$export$fb0b7b8e1356bdd8 = {
    SPOTLIGHT: 'marketplaceSpotlight',
    BEST_SELLER: 'marketplaceBestSeller',
    RISING_STAR: 'marketplaceRisingStar'
};
const $2c7c6d4234dd21cf$export$39bbf650e2467463 = {
    FEATURED: 'featured',
    TOP_SELLING: 'topSelling',
    TOP_SELLING_CLOUD: 'topSellingCloud',
    TOP_SELLING_SERVER: 'topSellingServer',
    RECENTLY_ADDED: 'recentlyAdded',
    TRENDING: 'trending',
    NATURAL_WITHOUT_FEATURED: 'naturalWithoutFeatured',
    CLOUD_FORTIFIED: 'cloudFortified',
    SPOTLIGHT: 'spotlight',
    BEST_SELLER: 'bestseller',
    RISING_STAR: 'risingStar'
};
const $2c7c6d4234dd21cf$var$emptyQuery = (0, $g5DHJ.Map)({
    filters: (0, $g5DHJ.Map)(),
    applyOverrides: (0, $b5Eig.default).default_()
});
const $2c7c6d4234dd21cf$var$baseWithoutAtlassianQuery = $2c7c6d4234dd21cf$var$emptyQuery.update('applyOverrides', (applyOverrides)=>applyOverrides.compose({
        types: (0, $g5DHJ.Set)([
            (0, $fMsDx.default).get('isAtlassian')
        ]),
        apply: (params)=>params.addFacetRefinement((0, $fMsDx.default).get('isAtlassian').algoliaFacetKey, 'false')
    }));
const $2c7c6d4234dd21cf$var$basePaidViaAtlassianQuery = $2c7c6d4234dd21cf$var$baseWithoutAtlassianQuery.update('applyOverrides', (applyOverrides)=>applyOverrides.composeApply((p)=>p.addDisjunctiveFacetRefinement((0, $fMsDx.default).get('marketplaceType').algoliaFacetKey, (0, $ad0fdcf1dd8b1c21$export$820680178c2de888))));
const $2c7c6d4234dd21cf$export$1da19aa559318561 = 'LARGE_COLLECTION_TYPE';
const $2c7c6d4234dd21cf$export$954f870831c20abc = 'SMALL_COLLECTION_TYPE';
const $2c7c6d4234dd21cf$var$resolveProductLabel = (_ref)=>{
    let { productKey: productKey, options: options } = _ref;
    return (0, $fCICH.getFilters)({
        featureFlags: options
    }).getIn([
        'product',
        'customFilters',
        productKey,
        'label'
    ]);
};
const $2c7c6d4234dd21cf$var$resolveBaseWithoutAtlassianQueries = (_ref2)=>{
    let { baseFilters: baseFilters, baseApplyOverrides: baseApplyOverrides } = _ref2;
    return $2c7c6d4234dd21cf$var$resolveQueriesFactory({
        baseQuery: $2c7c6d4234dd21cf$var$baseWithoutAtlassianQuery,
        baseFilters: baseFilters,
        baseApplyOverrides: baseApplyOverrides
    });
};
const $2c7c6d4234dd21cf$var$resolveQueriesFactory = (_ref3)=>{
    let { baseQuery: baseQuery, baseFilters: baseFilters, baseApplyOverrides: baseApplyOverrides } = _ref3;
    baseFilters = baseFilters || (0, $g5DHJ.Map)();
    baseApplyOverrides = baseApplyOverrides || (0, $b5Eig.default).default_();
    return function() {
        let { filters: filters, applyOverrides: applyOverrides } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            filters: (0, $g5DHJ.Map)(),
            applyOverrides: (0, $b5Eig.default).default_()
        };
        const apo = applyOverrides || (0, $b5Eig.default).default_();
        return (0, $g5DHJ.List)([
            baseQuery.update('filters', (fs)=>fs.merge(baseFilters).merge(filters)).update('applyOverrides', (ao)=>ao.compose(baseApplyOverrides).compose(apo))
        ]);
    };
};
const $2c7c6d4234dd21cf$var$singleResolveHits = (_ref4)=>{
    let { hits: hits } = _ref4;
    return (0, $3RTYU).sample(hits.flatten(1), 6);
};
const $2c7c6d4234dd21cf$var$singleResolveHitsForCompass = (_ref5)=>{
    let { hits: hits } = _ref5;
    return (0, $3RTYU).sample(hits.flatten(1), 18);
};
const $2c7c6d4234dd21cf$var$preserveHitsOrder = (addonKeys)=>(hits)=>hits.sort((a, b)=>addonKeys.indexOf(a.get('addonKey')) - addonKeys.indexOf(b.get('addonKey')));
const $2c7c6d4234dd21cf$var$flattenHits = (_ref6)=>{
    let { hits: hits } = _ref6;
    return hits.flatten(1);
};
const $2c7c6d4234dd21cf$var$customCriteriaCollectionFactory = (_ref7)=>{
    let { key: key, featuredCollectionConfig: featuredCollectionConfig, tileType: tileType, numDisplayResults: numDisplayResults, marketingLabelFilter: marketingLabelFilter } = _ref7;
    const flattenRequiredNumberOfHits = (_ref8)=>{
        let { hits: hits } = _ref8;
        return (0, $3RTYU).sample(hits.flatten(1), numDisplayResults);
    };
    const baseQueries = (0, $g5DHJ.List)([
        $2c7c6d4234dd21cf$var$emptyQuery.update('applyOverrides', (applyOverrides)=>applyOverrides.compose((0, $bavaN.searchParamsUpdateForAddonKeys)(featuredCollectionConfig.curatedApps)))
    ]);
    const { title: title, tagline: tagline, curatedApps: curatedApps } = featuredCollectionConfig;
    return (0, $g5DHJ.Map)({
        key: key,
        analyticsTileType: key,
        numResults: 10,
        numDisplayResults: numDisplayResults,
        title: title,
        tagline: tagline,
        type: tileType,
        usesContentOverride: true,
        resolveQueries: (_ref9)=>{
            let { filters: filters, applyOverrides: applyOverrides } = _ref9;
            return baseQueries.map((bq)=>bq.update('filters', (fs)=>fs.mergeDeep(filters)).update('applyOverrides', (ao)=>ao.compose(applyOverrides)));
        },
        resolveHits: (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))([
            flattenRequiredNumberOfHits,
            $2c7c6d4234dd21cf$var$preserveHitsOrder(curatedApps)
        ]),
        filters: (0, $g5DHJ.Map)({
            marketingLabel: (0, $g5DHJ.Set)([
                marketingLabelFilter
            ])
        })
    });
};
const $2c7c6d4234dd21cf$var$spotlightCollectionFactory = (featuredCollectionsConfig)=>{
    const spotlightCollection = featuredCollectionsConfig.find((featuredCollectionConfig)=>featuredCollectionConfig.key === $2c7c6d4234dd21cf$export$fb0b7b8e1356bdd8.SPOTLIGHT);
    if (spotlightCollection) return $2c7c6d4234dd21cf$var$customCriteriaCollectionFactory({
        key: $2c7c6d4234dd21cf$export$39bbf650e2467463.SPOTLIGHT,
        featuredCollectionConfig: spotlightCollection,
        tileType: $2c7c6d4234dd21cf$export$1da19aa559318561,
        numDisplayResults: 6,
        marketingLabelFilter: 'Spotlight'
    });
};
const $2c7c6d4234dd21cf$var$bestSellerCollectionFactory = (featuredCollectionsConfig)=>{
    const bestsellerCollection = featuredCollectionsConfig.find((featuredCollectionConfig)=>featuredCollectionConfig.key === $2c7c6d4234dd21cf$export$fb0b7b8e1356bdd8.BEST_SELLER);
    if (bestsellerCollection) return $2c7c6d4234dd21cf$var$customCriteriaCollectionFactory({
        key: $2c7c6d4234dd21cf$export$39bbf650e2467463.BEST_SELLER,
        featuredCollectionConfig: bestsellerCollection,
        tileType: $2c7c6d4234dd21cf$export$954f870831c20abc,
        numDisplayResults: 9,
        marketingLabelFilter: 'Bestseller'
    });
};
const $2c7c6d4234dd21cf$var$risingStarCollectionFactory = (featuredCollectionsConfig)=>{
    const risingStarCollection = featuredCollectionsConfig.find((featuredCollectionConfig)=>featuredCollectionConfig.key === $2c7c6d4234dd21cf$export$fb0b7b8e1356bdd8.RISING_STAR);
    if (risingStarCollection) return $2c7c6d4234dd21cf$var$customCriteriaCollectionFactory({
        key: $2c7c6d4234dd21cf$export$39bbf650e2467463.RISING_STAR,
        featuredCollectionConfig: risingStarCollection,
        tileType: $2c7c6d4234dd21cf$export$954f870831c20abc,
        numDisplayResults: 9,
        marketingLabelFilter: 'Rising Star'
    });
};
const $2c7c6d4234dd21cf$var$featuredCollectionFactory = (_ref10)=>{
    let { baseQueries: baseQueries, numDisplayResults: numDisplayResults, resolveHits: resolveHits, title: title, tagline: tagline, product: product } = _ref10;
    return (0, $g5DHJ.Map)({
        key: $2c7c6d4234dd21cf$export$39bbf650e2467463.FEATURED,
        analyticsTileType: 'exploreTile',
        numResults: product === (0, $122620c1047e308e$export$d5e9b613bc4c47f) ? 18 : 10,
        numDisplayResults: numDisplayResults,
        title: title,
        tagline: tagline,
        type: $2c7c6d4234dd21cf$export$1da19aa559318561,
        hideViewMore: product !== (0, $122620c1047e308e$export$d5e9b613bc4c47f),
        recordTileImpressions: true,
        usesContentOverride: true,
        resolveQueries: (_ref11)=>{
            let { filters: filters, applyOverrides: applyOverrides = (0, $b5Eig.default).default_() } = _ref11;
            return baseQueries.map((bq)=>bq.update('filters', (fs)=>fs.mergeDeep(filters)).update('applyOverrides', (ao)=>ao.compose(applyOverrides)));
        },
        resolveHits: resolveHits
    });
};
const $2c7c6d4234dd21cf$var$topSellingCollectionFactory = function topSellingCollectionFactory() {
    let { productKey: productKey, tagline: tagline, options: options } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (0, $g5DHJ.Map)({
        key: $2c7c6d4234dd21cf$export$39bbf650e2467463.TOP_SELLING,
        analyticsTileType: 'topSelling',
        numResults: 9,
        title: productKey ? "Top-selling ".concat($2c7c6d4234dd21cf$var$resolveProductLabel({
            productKey: productKey,
            options: options
        }), " apps") : 'Top-selling apps',
        tagline: tagline,
        type: $2c7c6d4234dd21cf$export$954f870831c20abc,
        resolveQueries: $2c7c6d4234dd21cf$var$resolveBaseWithoutAtlassianQueries({
            baseFilters: $2c7c6d4234dd21cf$var$topSellingBaseFilters
        }),
        resolveHits: $2c7c6d4234dd21cf$var$flattenHits,
        filters: $2c7c6d4234dd21cf$var$topSellingBaseFilters
    });
};
const $2c7c6d4234dd21cf$var$topSellingBaseFilters = (0, $g5DHJ.Map)({
    sort: (0, $9LwYq.sortOptions).get('topSelling').get('key')
});
const $2c7c6d4234dd21cf$var$recentlyAddedCollectionFactory = function recentlyAddedCollectionFactory() {
    let { productKey: productKey, tagline: tagline, options: options } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (0, $g5DHJ.Map)({
        key: $2c7c6d4234dd21cf$export$39bbf650e2467463.RECENTLY_ADDED,
        analyticsTileType: 'newestTile',
        numResults: 9,
        title: productKey ? "Newest ".concat($2c7c6d4234dd21cf$var$resolveProductLabel({
            productKey: productKey,
            options: options
        }), " apps") : 'Newest apps',
        tagline: tagline,
        type: $2c7c6d4234dd21cf$export$954f870831c20abc,
        resolveQueries: $2c7c6d4234dd21cf$var$resolveBaseWithoutAtlassianQueries({
            baseFilters: $2c7c6d4234dd21cf$var$recentlyAddedBaseFilters
        }),
        resolveHits: $2c7c6d4234dd21cf$var$flattenHits,
        filters: $2c7c6d4234dd21cf$var$recentlyAddedBaseFilters
    });
};
const $2c7c6d4234dd21cf$var$recentlyAddedBaseFilters = (0, $g5DHJ.Map)({
    sort: (0, $9LwYq.sortOptions).get('newest').get('key')
});
const $2c7c6d4234dd21cf$var$trendingCollectionFactory = function trendingCollectionFactory() {
    let { productKey: productKey, tagline: tagline, options: options } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (0, $g5DHJ.Map)({
        key: $2c7c6d4234dd21cf$export$39bbf650e2467463.TRENDING,
        analyticsTileType: 'trendingTile',
        numResults: 9,
        title: productKey ? "Trending ".concat($2c7c6d4234dd21cf$var$resolveProductLabel({
            productKey: productKey,
            options: options
        }), " apps") : 'Trending apps',
        tagline: tagline,
        type: $2c7c6d4234dd21cf$export$954f870831c20abc,
        resolveQueries: $2c7c6d4234dd21cf$var$resolveBaseWithoutAtlassianQueries({
            baseFilters: $2c7c6d4234dd21cf$var$trendingBaseFilters
        }),
        resolveHits: $2c7c6d4234dd21cf$var$flattenHits,
        filters: $2c7c6d4234dd21cf$var$trendingBaseFilters
    });
};
const $2c7c6d4234dd21cf$var$trendingBaseFilters = (0, $g5DHJ.Map)({
    sort: (0, $9LwYq.sortOptions).get('trending').get('key')
});
const $2c7c6d4234dd21cf$var$featuredCollectionNumDisplayResults = 6;
const $2c7c6d4234dd21cf$export$dfaaf09f3edb4c4a = (0, $g5DHJ.Map)({
    moreFilters: (0, $g5DHJ.Set)([
        'cloudFortified'
    ])
});
const $2c7c6d4234dd21cf$var$cloudFortifiedAppsCollectionFactory = ()=>(0, $g5DHJ.Map)({
        key: $2c7c6d4234dd21cf$export$39bbf650e2467463.CLOUD_FORTIFIED,
        analyticsTileType: 'cloudFortifiedAppTile',
        numResults: 3,
        title: 'Cloud Fortified Apps',
        tagline: "Cloud apps with additional security, reliability, and support to meet your organization's needs.",
        type: $2c7c6d4234dd21cf$export$1da19aa559318561,
        resolveHits: $2c7c6d4234dd21cf$var$flattenHits,
        hideViewMore: false,
        resolveQueries: $2c7c6d4234dd21cf$var$resolveQueriesFactory({
            baseQuery: $2c7c6d4234dd21cf$var$cloudFortifiedAppQuery
        }),
        filters: $2c7c6d4234dd21cf$export$dfaaf09f3edb4c4a
    });
const $2c7c6d4234dd21cf$var$cloudFortifiedAppQuery = $2c7c6d4234dd21cf$var$basePaidViaAtlassianQuery.update('applyOverrides', (applyOverrides)=>applyOverrides.composeApply((p)=>p.addFacetRefinement((0, $fMsDx.default).get('cloudFortified').algoliaFacetKey, 'approved')));
const $2c7c6d4234dd21cf$var$getHomeCollections = (featuredAddonsConfig, options)=>{
    if (featuredAddonsConfig) {
        const featuredCollectionsHomeConfig = featuredAddonsConfig.get($2c7c6d4234dd21cf$export$a7c5707626fc90f);
        const showCloudFortifiedAppsCollection = options === null || options === void 0 ? void 0 : options.enableCloudFortifiedAppsDiscovery;
        const homeDefaultCollections = [
            ...showCloudFortifiedAppsCollection ? [
                $2c7c6d4234dd21cf$var$cloudFortifiedAppsCollectionFactory()
            ] : []
        ];
        const customCriteriaCollections = featuredCollectionsHomeConfig && featuredCollectionsHomeConfig.length > 0 ? [
            $2c7c6d4234dd21cf$var$spotlightCollectionFactory(featuredCollectionsHomeConfig),
            $2c7c6d4234dd21cf$var$bestSellerCollectionFactory(featuredCollectionsHomeConfig),
            $2c7c6d4234dd21cf$var$risingStarCollectionFactory(featuredCollectionsHomeConfig)
        ] : [];
        return (0, $g5DHJ.List)([
            ...homeDefaultCollections,
            ...customCriteriaCollections
        ]);
    }
    return (0, $g5DHJ.List)([]);
};
const $2c7c6d4234dd21cf$var$getJiraCollections = (featuredAddonsConfig)=>{
    if (featuredAddonsConfig) {
        const featuredCollectionsJiraConfig = featuredAddonsConfig.get((0, $122620c1047e308e$export$c1fabc4e59d98025));
        return featuredCollectionsJiraConfig && featuredCollectionsJiraConfig.length > 0 ? (0, $g5DHJ.List)([
            $2c7c6d4234dd21cf$var$spotlightCollectionFactory(featuredCollectionsJiraConfig),
            $2c7c6d4234dd21cf$var$bestSellerCollectionFactory(featuredCollectionsJiraConfig),
            $2c7c6d4234dd21cf$var$risingStarCollectionFactory(featuredCollectionsJiraConfig)
        ]) : (0, $g5DHJ.List)([]);
    }
    return (0, $g5DHJ.List)([]);
};
const $2c7c6d4234dd21cf$var$getJiraServiceDeskCollections = (featuredAddonsConfig)=>{
    if (featuredAddonsConfig) {
        const featuredCollectionsJsdConfig = featuredAddonsConfig.get((0, $122620c1047e308e$export$3afc372bb8c4538c));
        return featuredCollectionsJsdConfig && featuredCollectionsJsdConfig.length > 0 ? (0, $g5DHJ.List)([
            $2c7c6d4234dd21cf$var$spotlightCollectionFactory(featuredCollectionsJsdConfig),
            $2c7c6d4234dd21cf$var$bestSellerCollectionFactory(featuredCollectionsJsdConfig),
            $2c7c6d4234dd21cf$var$risingStarCollectionFactory(featuredCollectionsJsdConfig)
        ]) : (0, $g5DHJ.List)([]);
    }
    return (0, $g5DHJ.List)([]);
};
const $2c7c6d4234dd21cf$var$getConfluenceCollections = (featuredAddonsConfig)=>{
    if (featuredAddonsConfig) {
        const featuredCollectionsConfluenceConfig = featuredAddonsConfig.get((0, $122620c1047e308e$export$c811f21c9ad05dc2));
        return featuredCollectionsConfluenceConfig && featuredCollectionsConfluenceConfig.length > 0 ? (0, $g5DHJ.List)([
            $2c7c6d4234dd21cf$var$spotlightCollectionFactory(featuredCollectionsConfluenceConfig),
            $2c7c6d4234dd21cf$var$bestSellerCollectionFactory(featuredCollectionsConfluenceConfig),
            $2c7c6d4234dd21cf$var$risingStarCollectionFactory(featuredCollectionsConfluenceConfig)
        ]) : (0, $g5DHJ.List)([]);
    }
    return (0, $g5DHJ.List)([]);
};
const $2c7c6d4234dd21cf$var$getBitbucketCollections = (featuredAddonsConfig, options)=>{
    const commonBitbucketCollections = [
        $2c7c6d4234dd21cf$var$topSellingCollectionFactory({
            productKey: (0, $122620c1047e308e$export$59864d7602eb300a),
            options: options
        }),
        $2c7c6d4234dd21cf$var$recentlyAddedCollectionFactory({
            productKey: (0, $122620c1047e308e$export$59864d7602eb300a),
            options: options
        })
    ];
    let featuredBitbucketCollection;
    if (featuredAddonsConfig) {
        featuredBitbucketCollection = $2c7c6d4234dd21cf$var$featuredCollectionFactory({
            baseQueries: $2c7c6d4234dd21cf$var$resolveProductQueries({
                productBaseQuery: $2c7c6d4234dd21cf$var$basePaidViaAtlassianQuery,
                product: (0, $122620c1047e308e$export$59864d7602eb300a),
                featuredAddonsConfig: featuredAddonsConfig
            }),
            numDisplayResults: $2c7c6d4234dd21cf$var$featuredCollectionNumDisplayResults,
            resolveHits: $2c7c6d4234dd21cf$var$resolveHits((0, $122620c1047e308e$export$59864d7602eb300a), featuredAddonsConfig)
        });
        return (0, $g5DHJ.List)([
            featuredBitbucketCollection,
            ...commonBitbucketCollections
        ]);
    }
};
const $2c7c6d4234dd21cf$var$getHipchatCollections = (featuredAddonsConfig, options)=>{
    const commonHipchatCollections = [
        $2c7c6d4234dd21cf$var$recentlyAddedCollectionFactory({
            productKey: (0, $122620c1047e308e$export$77363fc37d01ae41),
            options: options
        }),
        $2c7c6d4234dd21cf$var$trendingCollectionFactory({
            productKey: (0, $122620c1047e308e$export$77363fc37d01ae41),
            options: options
        })
    ];
    const featuredHipchatCollection = $2c7c6d4234dd21cf$var$featuredCollectionFactory({
        baseQueries: $2c7c6d4234dd21cf$var$resolveProductQueries({
            productBaseQuery: $2c7c6d4234dd21cf$var$baseWithoutAtlassianQuery.update('filters', (filters)=>filters.set('marketingLabel', (0, $g5DHJ.Set)([
                    'hipchat-default'
                ]))),
            product: (0, $122620c1047e308e$export$77363fc37d01ae41),
            featuredAddonsConfig: featuredAddonsConfig
        }),
        numDisplayResults: $2c7c6d4234dd21cf$var$featuredCollectionNumDisplayResults,
        resolveHits: $2c7c6d4234dd21cf$var$resolveHits((0, $122620c1047e308e$export$77363fc37d01ae41), featuredAddonsConfig)
    });
    return (0, $g5DHJ.List)([
        featuredHipchatCollection,
        ...commonHipchatCollections
    ]);
};
const $2c7c6d4234dd21cf$var$getFecruCollections = (featuredAddonsConfig, options)=>{
    const commonFecruCollections = [
        $2c7c6d4234dd21cf$var$topSellingCollectionFactory({
            productKey: (0, $122620c1047e308e$export$e95554a59f3e0c28),
            options: options
        }),
        $2c7c6d4234dd21cf$var$recentlyAddedCollectionFactory({
            productKey: (0, $122620c1047e308e$export$e95554a59f3e0c28),
            options: options
        }),
        $2c7c6d4234dd21cf$var$trendingCollectionFactory({
            productKey: (0, $122620c1047e308e$export$e95554a59f3e0c28),
            options: options
        })
    ];
    const featuredFecruCollection = $2c7c6d4234dd21cf$var$featuredCollectionFactory({
        baseQueries: $2c7c6d4234dd21cf$var$resolveProductQueries({
            productBaseQuery: $2c7c6d4234dd21cf$var$basePaidViaAtlassianQuery,
            product: (0, $122620c1047e308e$export$e95554a59f3e0c28),
            featuredAddonsConfig: featuredAddonsConfig
        }),
        numDisplayResults: $2c7c6d4234dd21cf$var$featuredCollectionNumDisplayResults,
        resolveHits: $2c7c6d4234dd21cf$var$resolveHits((0, $122620c1047e308e$export$e95554a59f3e0c28), featuredAddonsConfig)
    });
    return (0, $g5DHJ.List)([
        featuredFecruCollection,
        ...commonFecruCollections
    ]);
};
const $2c7c6d4234dd21cf$var$getBambooCollections = (featuredAddonsConfig, options)=>{
    const commonBambooCollections = [
        $2c7c6d4234dd21cf$var$topSellingCollectionFactory({
            productKey: (0, $122620c1047e308e$export$1876370d95915b3b),
            options: options
        }),
        $2c7c6d4234dd21cf$var$recentlyAddedCollectionFactory({
            productKey: (0, $122620c1047e308e$export$1876370d95915b3b),
            options: options
        }),
        $2c7c6d4234dd21cf$var$trendingCollectionFactory({
            productKey: (0, $122620c1047e308e$export$1876370d95915b3b),
            options: options
        })
    ];
    const featuredBambooCollection = $2c7c6d4234dd21cf$var$featuredCollectionFactory({
        baseQueries: $2c7c6d4234dd21cf$var$resolveProductQueries({
            productBaseQuery: $2c7c6d4234dd21cf$var$basePaidViaAtlassianQuery,
            product: (0, $122620c1047e308e$export$1876370d95915b3b),
            featuredAddonsConfig: featuredAddonsConfig
        }),
        numDisplayResults: $2c7c6d4234dd21cf$var$featuredCollectionNumDisplayResults,
        resolveHits: $2c7c6d4234dd21cf$var$resolveHits((0, $122620c1047e308e$export$1876370d95915b3b), featuredAddonsConfig)
    });
    return (0, $g5DHJ.List)([
        featuredBambooCollection,
        ...commonBambooCollections
    ]);
};
const $2c7c6d4234dd21cf$var$getCompassCollections = (featuredAddonsConfig)=>{
    const featuredCompassCollection = $2c7c6d4234dd21cf$var$featuredCollectionFactory({
        baseQueries: $2c7c6d4234dd21cf$var$resolveProductQueries({
            productBaseQuery: $2c7c6d4234dd21cf$var$emptyQuery,
            product: (0, $122620c1047e308e$export$d5e9b613bc4c47f),
            featuredAddonsConfig: featuredAddonsConfig
        }),
        numDisplayResults: 18,
        resolveHits: $2c7c6d4234dd21cf$var$resolveHits((0, $122620c1047e308e$export$d5e9b613bc4c47f), featuredAddonsConfig),
        product: (0, $122620c1047e308e$export$d5e9b613bc4c47f)
    });
    return (0, $g5DHJ.List)([
        featuredCompassCollection
    ]);
};
const $2c7c6d4234dd21cf$var$getCrowdCollections = (featuredAddonsConfig, options)=>{
    const commonCrowdCollections = [
        $2c7c6d4234dd21cf$var$recentlyAddedCollectionFactory({
            productKey: (0, $122620c1047e308e$export$6bc23744ed8b8097),
            options: options
        }),
        $2c7c6d4234dd21cf$var$trendingCollectionFactory({
            productKey: (0, $122620c1047e308e$export$6bc23744ed8b8097),
            options: options
        })
    ];
    const featuredCrowdCollection = $2c7c6d4234dd21cf$var$featuredCollectionFactory({
        baseQueries: $2c7c6d4234dd21cf$var$resolveProductQueries({
            productBaseQuery: $2c7c6d4234dd21cf$var$baseWithoutAtlassianQuery,
            product: (0, $122620c1047e308e$export$6bc23744ed8b8097),
            featuredAddonsConfig: featuredAddonsConfig
        }),
        numDisplayResults: $2c7c6d4234dd21cf$var$featuredCollectionNumDisplayResults,
        resolveHits: $2c7c6d4234dd21cf$var$resolveHits((0, $122620c1047e308e$export$6bc23744ed8b8097), featuredAddonsConfig)
    });
    return (0, $g5DHJ.List)([
        featuredCrowdCollection,
        ...commonCrowdCollections
    ]);
};
const $2c7c6d4234dd21cf$var$resolveHits = (product, featuredAddonsConfig)=>{
    const featuredAddons = featuredAddonsConfig.get(product);
    if (product === (0, $122620c1047e308e$export$d5e9b613bc4c47f)) return $2c7c6d4234dd21cf$var$singleResolveHitsForCompass;
    return featuredAddons !== null && featuredAddons !== void 0 && featuredAddons.curatedApps ? (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))([
        $2c7c6d4234dd21cf$var$singleResolveHits,
        $2c7c6d4234dd21cf$var$preserveHitsOrder(featuredAddons.curatedApps)
    ]) : $2c7c6d4234dd21cf$var$singleResolveHits;
};
const $2c7c6d4234dd21cf$var$resolveProductQueries = (_ref12)=>{
    let { productBaseQuery: productBaseQuery, product: product, featuredAddonsConfig: featuredAddonsConfig } = _ref12;
    const featuredAddons = featuredAddonsConfig.get(product);
    return (0, $g5DHJ.List)([
        featuredAddons !== null && featuredAddons !== void 0 && featuredAddons.curatedApps ? $2c7c6d4234dd21cf$var$emptyQuery.update('applyOverrides', (applyOverrides)=>applyOverrides.compose((0, $bavaN.searchParamsUpdateForAddonKeys)(featuredAddons.curatedApps))) : productBaseQuery.update('filters', (filters)=>filters.set('product', product))
    ]);
};
var $2c7c6d4234dd21cf$export$2e2bcd8739ae039 = (_ref13)=>{
    let { featuredAddonsConfig: featuredAddonsConfig, options: options } = _ref13;
    const homeCollections = $2c7c6d4234dd21cf$var$getHomeCollections(featuredAddonsConfig, options);
    const jiraCollections = $2c7c6d4234dd21cf$var$getJiraCollections(featuredAddonsConfig);
    const jiraServiceDeskCollections = $2c7c6d4234dd21cf$var$getJiraServiceDeskCollections(featuredAddonsConfig);
    const confluenceCollections = $2c7c6d4234dd21cf$var$getConfluenceCollections(featuredAddonsConfig);
    const bitbucketCollections = $2c7c6d4234dd21cf$var$getBitbucketCollections(featuredAddonsConfig, options);
    const hipchatCollections = $2c7c6d4234dd21cf$var$getHipchatCollections(featuredAddonsConfig, options);
    const fecruCollections = $2c7c6d4234dd21cf$var$getFecruCollections(featuredAddonsConfig, options);
    const bambooCollections = $2c7c6d4234dd21cf$var$getBambooCollections(featuredAddonsConfig, options);
    const crowdCollections = $2c7c6d4234dd21cf$var$getCrowdCollections(featuredAddonsConfig, options);
    const compassCollections = $2c7c6d4234dd21cf$var$getCompassCollections(featuredAddonsConfig);
    return (0, $g5DHJ.Map)({
        [$2c7c6d4234dd21cf$export$a7c5707626fc90f]: homeCollections,
        [(0, $122620c1047e308e$export$c1fabc4e59d98025)]: jiraCollections,
        [(0, $122620c1047e308e$export$d5e9b613bc4c47f)]: compassCollections,
        [(0, $122620c1047e308e$export$3afc372bb8c4538c)]: jiraServiceDeskCollections,
        [(0, $122620c1047e308e$export$c811f21c9ad05dc2)]: confluenceCollections,
        [(0, $122620c1047e308e$export$59864d7602eb300a)]: bitbucketCollections,
        [(0, $122620c1047e308e$export$77363fc37d01ae41)]: hipchatCollections,
        [(0, $122620c1047e308e$export$e95554a59f3e0c28)]: fecruCollections,
        [(0, $122620c1047e308e$export$1876370d95915b3b)]: bambooCollections,
        [(0, $122620c1047e308e$export$6bc23744ed8b8097)]: crowdCollections
    });
};

});
parcelRegister("3RTYU", function(module, exports) {

$parcel$export(module.exports, "fill", () => (parcelRequire("2sAIk")).default);
$parcel$export(module.exports, "listToMap", () => (parcelRequire("h5SyG")).default);
$parcel$export(module.exports, "sample", () => (parcelRequire("1U4eV")).default);
$parcel$export(module.exports, "shuffle", () => (parcelRequire("loHyr")).default);

var $2sAIk = parcelRequire("2sAIk");

var $h5SyG = parcelRequire("h5SyG");

var $1U4eV = parcelRequire("1U4eV");

var $loHyr = parcelRequire("loHyr");

});
parcelRegister("2sAIk", function(module, exports) {

$parcel$export(module.exports, "default", () => $1caaaceb3739a06c$export$2e2bcd8739ae039);

var $g5DHJ = parcelRequire("g5DHJ");

var $loHyr = parcelRequire("loHyr");
function $1caaaceb3739a06c$export$2e2bcd8739ae039() {
    let startList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $g5DHJ.List)();
    return (totalSize)=>(withList)=>{
            return startList.size > totalSize ? startList.take(totalSize) : startList.concat((0, $loHyr.default)(withList || (0, $g5DHJ.List)()).take(totalSize - startList.size));
        };
}

});
parcelRegister("loHyr", function(module, exports) {

$parcel$export(module.exports, "default", () => $f93d9fdebd9d7277$export$2e2bcd8739ae039);

var $g5DHJ = parcelRequire("g5DHJ");
function $f93d9fdebd9d7277$export$2e2bcd8739ae039(list) {
    const set = list;
    const size = set.size;
    return list.reduce((acc, _item, i)=>{
        const rand = $f93d9fdebd9d7277$var$random(0, i);
        if (rand !== i) {
            const randItem = acc.get(rand);
            acc = acc.set(i, randItem);
        }
        const itemAtI = set.get(i);
        return acc.set(rand, itemAtI);
    }, (0, $g5DHJ.List)(new Array(size)));
}
function $f93d9fdebd9d7277$var$random(min, max) {
    if (max === null) {
        max = min;
        min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
}

});


parcelRegister("h5SyG", function(module, exports) {

$parcel$export(module.exports, "default", () => $c71d3972fa41c563$export$2e2bcd8739ae039);

var $g5DHJ = parcelRequire("g5DHJ");
function $c71d3972fa41c563$export$2e2bcd8739ae039(list, getKeyFunction) {
    return list.reduce((acc, value)=>acc.set(getKeyFunction(value), value), (0, $g5DHJ.Map)());
}

});

parcelRegister("1U4eV", function(module, exports) {

$parcel$export(module.exports, "default", () => $162e4f58c41cdac3$export$2e2bcd8739ae039);

var $loHyr = parcelRequire("loHyr");
function $162e4f58c41cdac3$export$2e2bcd8739ae039(list, n) {
    return (0, $loHyr.default)(list).slice(0, Math.max(0, n));
}

});


parcelRegister("fMsDx", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7d18d5f855d684c$export$2e2bcd8739ae039);

var $g5DHJ = parcelRequire("g5DHJ");

var $lwEMm = parcelRequire("lwEMm");
var $b7d18d5f855d684c$export$2e2bcd8739ae039 = (0, $g5DHJ.Map)({
    product: (0, $lwEMm.default).disjunctive('version.compatibilities.applicationKey'),
    hidden: (0, $lwEMm.default).disjunctive('hidden'),
    hosting: (0, $lwEMm.default).disjunctive('version.compatibilities.hosting'),
    deployments: (0, $lwEMm.default).disjunctive('deployments'),
    categories: (0, $lwEMm.default).disjunctive('categories'),
    paid: (0, $lwEMm.default).conjunctive('version.paid'),
    topVendor: (0, $lwEMm.default).conjunctive('vendor.isTopVendor'),
    vendorSupported: (0, $lwEMm.default).conjunctive('version.supported'),
    stable: (0, $lwEMm.default).conjunctive('version.stable'),
    canonicalVersion: (0, $lwEMm.default).conjunctive('version.canonicalVersion'),
    latestOfHosting: (0, $lwEMm.default).conjunctive('version.latestOfHosting'),
    isAtlassian: (0, $lwEMm.default).conjunctive('vendor.isAtlassian'),
    marketplaceType: (0, $lwEMm.default).disjunctive('version.marketplaceType'),
    marketingLabels: (0, $lwEMm.default).disjunctive('marketingLabels'),
    pluginSystemVersion: (0, $lwEMm.default).conjunctive('version.pluginSystemVersion'),
    cloudFortified: (0, $lwEMm.default).conjunctive('programs.cloudFortified.status'),
    freeStarterTier: (0, $lwEMm.default).conjunctive('freeStarterTierStatus'),
    bugBountyParticipant: (0, $lwEMm.default).conjunctive('programs.bugBountyParticipant')
});

});

parcelRegister("fCICH", function(module, exports) {

$parcel$export(module.exports, "sortingLogic", () => $b5fd04e2494471c1$export$1daa9d759361acf);
$parcel$export(module.exports, "getFilters", () => $b5fd04e2494471c1$export$1933a9fe712fc1fd);
$parcel$export(module.exports, "getTabletMobileFilters", () => $b5fd04e2494471c1$export$fa7a9d830f6dbd45);

var $kafab = parcelRequire("kafab");

var $g5DHJ = parcelRequire("g5DHJ");



var $lwEMm = parcelRequire("lwEMm");

var $fMsDx = parcelRequire("fMsDx");

var $io1ow = parcelRequire("io1ow");

var $9LwYq = parcelRequire("9LwYq");
const $b5fd04e2494471c1$var$categoriesByUsage = (0, $io1ow.default).sortedByUsage.map((categoryName)=>categoryName.toLowerCase());
const $b5fd04e2494471c1$export$1daa9d759361acf = {
    USAGE_AND_ALPHABETICAL: 'usage-and-alphabetical',
    ALPHABETICAL: 'alphabetical',
    COUNT_AND_ALPHABETICAL: 'count-and-alphabetical',
    DEFAULT: 'default'
};
const $b5fd04e2494471c1$export$efc12c4ce5cdead = Object.freeze({
    enabled: 'enabled',
    disabled: 'disabled'
});
function $b5fd04e2494471c1$var$resolveFacetProductCount(facets, facetKey, facetProductKey) {
    const facet = facets.find((f)=>f.get('name') === facetKey);
    return facet ? facet.getIn([
        'data',
        facetProductKey
    ]) || 0 : 0;
}
function $b5fd04e2494471c1$var$sortByCountDesc(a, b) {
    if (b.get('count') - a.get('count') !== 0) return b.get('count') - a.get('count');
    return a.get('label').localeCompare(b.get('label'));
}
const $b5fd04e2494471c1$var$sortByUsage = (a, b)=>{
    const getIndex = (element)=>!$b5fd04e2494471c1$var$categoriesByUsage.includes(element.toLowerCase()) ? Number.POSITIVE_INFINITY : $b5fd04e2494471c1$var$categoriesByUsage.indexOf(element.toLowerCase());
    return getIndex(a.get('label')) - getIndex(b.get('label'));
};
// eslint-disable-next-line max-lines-per-function -- Fix me
const $b5fd04e2494471c1$var$productFilter = function productFilter() {
    var _options$featureFlags;
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const customFilters = {
        [(0, $122620c1047e308e$export$c1fabc4e59d98025)]: (0, $g5DHJ.Map)({
            value: (0, $122620c1047e308e$export$c1fabc4e59d98025),
            algoliaValue: 'jira',
            label: 'Jira',
            resolveFacetCount (facets) {
                return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, productFilter().get('algoliaFacetKey'), 'jira');
            }
        }),
        [(0, $122620c1047e308e$export$3afc372bb8c4538c)]: (0, $g5DHJ.Map)({
            value: (0, $122620c1047e308e$export$3afc372bb8c4538c),
            algoliaValue: 'jira-service-desk',
            label: 'Jira Service Management',
            resolveFacetCount (facets) {
                return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, productFilter().get('algoliaFacetKey'), 'jira-service-desk');
            }
        }),
        [(0, $122620c1047e308e$export$c811f21c9ad05dc2)]: (0, $g5DHJ.Map)({
            algoliaValue: 'confluence',
            value: (0, $122620c1047e308e$export$c811f21c9ad05dc2),
            label: 'Confluence',
            resolveFacetCount (facets) {
                return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, productFilter().get('algoliaFacetKey'), 'confluence');
            }
        }),
        [(0, $122620c1047e308e$export$59864d7602eb300a)]: (0, $g5DHJ.Map)({
            algoliaValue: 'bitbucket',
            value: (0, $122620c1047e308e$export$59864d7602eb300a),
            label: 'Bitbucket',
            resolveFacetCount (facets) {
                return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, productFilter().get('algoliaFacetKey'), 'bitbucket');
            }
        })
    };
    if ((options === null || options === void 0 ? void 0 : (_options$featureFlags = options.featureFlags) === null || _options$featureFlags === void 0 ? void 0 : _options$featureFlags.showCompassApps) !== false) customFilters[0, $122620c1047e308e$export$d5e9b613bc4c47f] = (0, $g5DHJ.Map)({
        algoliaValue: 'compass',
        value: (0, $122620c1047e308e$export$d5e9b613bc4c47f),
        label: 'Compass',
        resolveFacetCount (facets) {
            return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, productFilter().get('algoliaFacetKey'), 'compass');
        }
    });
    customFilters[0, $122620c1047e308e$export$e95554a59f3e0c28] = (0, $g5DHJ.Map)({
        algoliaValue: 'fecru',
        value: (0, $122620c1047e308e$export$e95554a59f3e0c28),
        label: 'Fisheye/Crucible',
        resolveFacetCount (facets) {
            return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, productFilter().get('algoliaFacetKey'), 'fecru');
        }
    });
    customFilters[0, $122620c1047e308e$export$1876370d95915b3b] = (0, $g5DHJ.Map)({
        algoliaValue: 'bamboo',
        value: (0, $122620c1047e308e$export$1876370d95915b3b),
        label: 'Bamboo',
        resolveFacetCount (facets) {
            return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, productFilter().get('algoliaFacetKey'), 'bamboo');
        }
    });
    customFilters[0, $122620c1047e308e$export$6bc23744ed8b8097] = (0, $g5DHJ.Map)({
        algoliaValue: 'crowd',
        value: (0, $122620c1047e308e$export$6bc23744ed8b8097),
        label: 'Crowd',
        resolveFacetCount (facets) {
            return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, productFilter().get('algoliaFacetKey'), 'crowd');
        }
    });
    return (0, $g5DHJ.Map)({
        key: 'product',
        label: 'Product',
        sidebarLabel: 'All Products',
        topBarLabel: 'Products',
        algoliaFacetKey: (0, $fMsDx.default).getIn([
            'product',
            'algoliaFacetKey'
        ]),
        queryType: (0, $lwEMm.DISJUNCTIVE_FACET_TYPE),
        type: (0, $lwEMm.CONJUNCTIVE_FACET_TYPE),
        primary: true,
        custom: true,
        displayInCurrent: true,
        facet: true,
        discoverFilter: true,
        requiredDiscoverFilterWhenNonEmpty: true,
        useDropDownComponentForSidebar: true,
        resolveAlgoliaQuery (_ref) {
            let { params: params, filters: filters } = _ref;
            const product = filters.get('product');
            return product ? params.addDisjunctiveFacetRefinement(productFilter().get('algoliaFacetKey'), productFilter().getIn([
                'customFilters',
                product,
                'algoliaValue'
            ])) : params;
        },
        customFilters: (0, $g5DHJ.OrderedMap)(customFilters)
    });
};
const $b5fd04e2494471c1$var$hostingFilter = ()=>(0, $g5DHJ.Map)({
        key: 'hosting',
        label: 'Select a hosting type',
        sidebarLabel: 'Select a hosting type',
        topBarLabel: 'Hosting',
        algoliaFacetKey: (0, $fMsDx.default).getIn([
            'hosting',
            'algoliaFacetKey'
        ]),
        queryType: (0, $lwEMm.DISJUNCTIVE_FACET_TYPE),
        type: (0, $lwEMm.CONJUNCTIVE_FACET_TYPE),
        custom: true,
        displayInCurrent: true,
        facet: true,
        openByDefault: true,
        useDropDownComponentForSidebar: true,
        resolveAlgoliaQuery (_ref2) {
            let { params: params, filters: filters } = _ref2;
            const customFilter = $b5fd04e2494471c1$var$hostingFilter().getIn([
                'customFilters',
                filters.get('hosting')
            ]);
            return customFilter ? params.addFacetRefinement((0, $fMsDx.default).getIn([
                'latestOfHosting',
                'algoliaFacetKey'
            ]), 'true').addDisjunctiveFacetRefinement($b5fd04e2494471c1$var$hostingFilter().get('algoliaFacetKey'), customFilter.get('value')) : params.addFacetRefinement((0, $fMsDx.default).getIn([
                'canonicalVersion',
                'algoliaFacetKey'
            ]), 'true');
        },
        customFilters: (0, $g5DHJ.Map)({
            cloud: (0, $g5DHJ.Map)({
                algoliaValue: (0, $8749bcdb7e4afe9a$export$428c0af80a7329cd),
                value: (0, $8749bcdb7e4afe9a$export$428c0af80a7329cd),
                label: 'Cloud',
                resolveFacetCount (facets, filters) {
                    const facetKey = filters.get('hosting') ? $b5fd04e2494471c1$var$hostingFilter().get('algoliaFacetKey') : (0, $fMsDx.default).getIn([
                        'deployments',
                        'algoliaFacetKey'
                    ]);
                    return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, facetKey, (0, $8749bcdb7e4afe9a$export$428c0af80a7329cd));
                }
            }),
            server: (0, $g5DHJ.Map)({
                algoliaValue: (0, $8749bcdb7e4afe9a$export$7fc2afdd98086cb1),
                value: (0, $8749bcdb7e4afe9a$export$7fc2afdd98086cb1),
                label: 'Server',
                resolveFacetCount (facets, filters) {
                    const facetKey = filters.get('hosting') ? $b5fd04e2494471c1$var$hostingFilter().get('algoliaFacetKey') : (0, $fMsDx.default).getIn([
                        'deployments',
                        'algoliaFacetKey'
                    ]);
                    return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, facetKey, (0, $8749bcdb7e4afe9a$export$7fc2afdd98086cb1));
                }
            }),
            dataCenter: (0, $g5DHJ.Map)({
                algoliaValue: (0, $8749bcdb7e4afe9a$export$35e53a8bdbe06647),
                value: (0, $8749bcdb7e4afe9a$export$35e53a8bdbe06647),
                label: 'Data Center',
                resolveFacetCount (facets, filters) {
                    const facetKey = filters.get('hosting') ? $b5fd04e2494471c1$var$hostingFilter().get('algoliaFacetKey') : (0, $fMsDx.default).getIn([
                        'deployments',
                        'algoliaFacetKey'
                    ]);
                    return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, facetKey, (0, $8749bcdb7e4afe9a$export$35e53a8bdbe06647));
                }
            })
        })
    });
const $b5fd04e2494471c1$var$categoryFilter = ()=>(0, $g5DHJ.Map)({
        key: 'category',
        algoliaFacetKey: (0, $fMsDx.default).getIn([
            'categories',
            'algoliaFacetKey'
        ]),
        label: 'Categories',
        queryType: (0, $lwEMm.DISJUNCTIVE_FACET_TYPE),
        type: (0, $lwEMm.CONJUNCTIVE_FACET_TYPE),
        displayInCurrent: true,
        facet: true,
        primary: true,
        resolveAlgoliaQuery (_ref3) {
            let { params: params, filters: filters } = _ref3;
            const category = filters.get('category');
            return category ? params.addDisjunctiveFacetRefinement((0, $fMsDx.default).getIn([
                'categories',
                'algoliaFacetKey'
            ]), category) : params;
        },
        // MC-731 Experiment when sorting logic is usage-and-alphabetical, render in groups of popular and all
        collateFunction (facetProducts, sortLogic) {
            if (sortLogic === $b5fd04e2494471c1$export$1daa9d759361acf.USAGE_AND_ALPHABETICAL) {
                const firstFiveByUsage = facetProducts.slice(0, 5);
                const restByLabel = facetProducts.slice(5);
                return {
                    popular: firstFiveByUsage,
                    all: restByLabel
                };
            }
            return facetProducts;
        },
        sortFunction (facetProducts, sortLogic) {
            const productsByUsage = facetProducts.sort($b5fd04e2494471c1$var$sortByUsage);
            const productsByLabel = facetProducts.sortBy((valA)=>valA.get('label'));
            const productsByAppCount = facetProducts.sort($b5fd04e2494471c1$var$sortByCountDesc);
            switch(sortLogic){
                case $b5fd04e2494471c1$export$1daa9d759361acf.ALPHABETICAL:
                    return productsByLabel;
                case $b5fd04e2494471c1$export$1daa9d759361acf.USAGE_AND_ALPHABETICAL:
                    {
                        const firstFiveByUsage = productsByUsage.slice(0, 5);
                        const restByLabel = productsByUsage.sortBy((valA)=>valA.get('label'));
                        return firstFiveByUsage.concat(restByLabel);
                    }
                case $b5fd04e2494471c1$export$1daa9d759361acf.COUNT_AND_ALPHABETICAL:
                    {
                        const firstFiveByCount = productsByAppCount.slice(0, 5);
                        const restByLabel = productsByAppCount.slice(5).sortBy((valA)=>valA.get('label'));
                        return firstFiveByCount.concat(restByLabel);
                    }
                default:
                    return facetProducts;
            }
        }
    });
const $b5fd04e2494471c1$var$freeCustomFilter = (0, $g5DHJ.Map)({
    label: 'Free for all teams',
    value: 'free',
    algoliaFacetKey: (0, $fMsDx.default).getIn([
        'paid',
        'algoliaFacetKey'
    ]),
    queryType: (0, $lwEMm.CONJUNCTIVE_FACET_TYPE),
    resolveFacetCount (facets) {
        return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, $b5fd04e2494471c1$var$freeCustomFilter.get('algoliaFacetKey'), 'false');
    },
    resolveAlgoliaQuery (_ref4) {
        let { params: params, moreFilters: moreFilters } = _ref4;
        return moreFilters.includes($b5fd04e2494471c1$var$freeCustomFilter.get('value')) ? params.addFacetRefinement($b5fd04e2494471c1$var$freeCustomFilter.get('algoliaFacetKey'), 'false') : params;
    }
});
const $b5fd04e2494471c1$var$ecosystemCloudAppsFilter = ()=>(0, $g5DHJ.Map)({
        key: 'nonEcosystemCloudApps',
        label: 'Non Ecosystem Cloud Apps',
        value: 'nonEcosystemCloudApps',
        algoliaFacetKey: (0, $fMsDx.default).getIn([
            'pluginSystemVersion',
            'algoliaFacetKey'
        ]),
        queryType: (0, $lwEMm.CONJUNCTIVE_FACET_TYPE),
        resolveAlgoliaQuery (_ref5) {
            let { params: params } = _ref5;
            return params;
        }
    });
const $b5fd04e2494471c1$var$vendorSupportedCustomFilter = (0, $g5DHJ.Map)({
    label: 'Partner supported',
    value: 'vendorSupported',
    algoliaFacetKey: (0, $fMsDx.default).getIn([
        'vendorSupported',
        'algoliaFacetKey'
    ]),
    queryType: (0, $lwEMm.CONJUNCTIVE_FACET_TYPE),
    resolveFacetCount (facets) {
        return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, $b5fd04e2494471c1$var$vendorSupportedCustomFilter.get('algoliaFacetKey'), 'true');
    },
    resolveAlgoliaQuery (_ref6) {
        let { params: params, moreFilters: moreFilters } = _ref6;
        return moreFilters.includes($b5fd04e2494471c1$var$vendorSupportedCustomFilter.get('value')) ? params.addFacetRefinement($b5fd04e2494471c1$var$vendorSupportedCustomFilter.get('algoliaFacetKey'), 'true') : params;
    }
});
const $b5fd04e2494471c1$var$betaVersionCustomFilter = (0, $g5DHJ.Map)({
    label: 'Beta version',
    value: 'betaVersion',
    algoliaFacetKey: (0, $fMsDx.default).getIn([
        'stable',
        'algoliaFacetKey'
    ]),
    queryType: (0, $lwEMm.CONJUNCTIVE_FACET_TYPE),
    resolveFacetCount (facets) {
        return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, $b5fd04e2494471c1$var$betaVersionCustomFilter.get('algoliaFacetKey'), 'false');
    },
    resolveAlgoliaQuery (_ref7) {
        let { params: params, moreFilters: moreFilters } = _ref7;
        return moreFilters.includes($b5fd04e2494471c1$var$betaVersionCustomFilter.get('value')) ? params.addFacetRefinement($b5fd04e2494471c1$var$betaVersionCustomFilter.get('algoliaFacetKey'), 'false') : params;
    }
});
const $b5fd04e2494471c1$var$cloudFortifiedAppCustomFilter = (0, $g5DHJ.Map)({
    key: 'cloudFortified',
    label: 'Cloud Fortified apps',
    value: 'cloudFortified',
    algoliaFacetKey: (0, $fMsDx.default).getIn([
        'cloudFortified',
        'algoliaFacetKey'
    ]),
    queryType: (0, $lwEMm.CONJUNCTIVE_FACET_TYPE),
    resolveFacetCount (facets) {
        return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, $b5fd04e2494471c1$var$cloudFortifiedAppCustomFilter.get('algoliaFacetKey'), (0, $kafab.CloudFortifiedStatusValues).Approved);
    },
    resolveAlgoliaQuery (_ref8) {
        let { params: params, moreFilters: moreFilters } = _ref8;
        return moreFilters.includes($b5fd04e2494471c1$var$cloudFortifiedAppCustomFilter.get('value')) ? params.addFacetRefinement($b5fd04e2494471c1$var$cloudFortifiedAppCustomFilter.get('algoliaFacetKey'), (0, $kafab.CloudFortifiedStatusValues).Approved) : params;
    }
});
const $b5fd04e2494471c1$var$freeStarterTierFilter = (0, $g5DHJ.Map)({
    key: 'freeStarterTier',
    label: 'Free up to 10 users',
    value: 'freeStarterTier',
    algoliaFacetKey: (0, $fMsDx.default).getIn([
        'freeStarterTier',
        'algoliaFacetKey'
    ]),
    queryType: (0, $lwEMm.CONJUNCTIVE_FACET_TYPE),
    resolveFacetCount (facets) {
        return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, $b5fd04e2494471c1$var$freeStarterTierFilter.get('algoliaFacetKey'), $b5fd04e2494471c1$export$efc12c4ce5cdead.enabled);
    },
    resolveAlgoliaQuery (_ref9) {
        let { params: params, moreFilters: moreFilters } = _ref9;
        return moreFilters.includes($b5fd04e2494471c1$var$freeStarterTierFilter.get('value')) ? params.addFacetRefinement($b5fd04e2494471c1$var$freeStarterTierFilter.get('algoliaFacetKey'), $b5fd04e2494471c1$export$efc12c4ce5cdead.enabled) : params;
    }
});
const $b5fd04e2494471c1$var$moreCustomFilters = (0, $g5DHJ.OrderedMap)({
    cloudFortified: $b5fd04e2494471c1$var$cloudFortifiedAppCustomFilter,
    vendorSupported: $b5fd04e2494471c1$var$vendorSupportedCustomFilter,
    free: $b5fd04e2494471c1$var$freeCustomFilter,
    betaVersion: $b5fd04e2494471c1$var$betaVersionCustomFilter,
    freeStarterTier: $b5fd04e2494471c1$var$freeStarterTierFilter
});
const $b5fd04e2494471c1$var$moreFiltersFilter = ()=>(0, $g5DHJ.Map)({
        key: 'moreFilters',
        label: 'Filter By',
        sidebarLabel: 'Filter By',
        topBarLabel: 'More Filters',
        type: (0, $lwEMm.DISJUNCTIVE_FACET_TYPE),
        custom: true,
        displayInCurrent: true,
        facet: true,
        primary: true,
        resolveAlgoliaQuery (_ref10) {
            let { params: params, filters: filters } = _ref10;
            const moreFilters = filters.get('moreFilters');
            return $b5fd04e2494471c1$var$moreFiltersFilter().get('customFilters').reduce((p, cf)=>cf.get('resolveAlgoliaQuery')({
                    params: p,
                    moreFilters: moreFilters
                }), params);
        },
        customFilters: $b5fd04e2494471c1$var$moreCustomFilters
    });
const $b5fd04e2494471c1$var$queryFilter = (0, $g5DHJ.Map)({
    key: 'query',
    facet: false,
    displayInCurrent: true,
    resolveCurrentFilterText (_ref11) {
        let { value: value } = _ref11;
        return "\"".concat(value, "\"");
    },
    resolveAlgoliaQuery (_ref12) {
        let { params: params, filters: filters } = _ref12;
        return params.setQuery(filters.get('query') || '');
    }
});
const $b5fd04e2494471c1$var$marketingLabel = (0, $g5DHJ.Map)({
    algoliaFacetKey: (0, $fMsDx.default).getIn([
        'marketingLabels',
        'algoliaFacetKey'
    ]),
    key: 'marketingLabel',
    queryType: (0, $lwEMm.DISJUNCTIVE_FACET_TYPE),
    type: (0, $lwEMm.DISJUNCTIVE_FACET_TYPE),
    facet: false,
    displayInCurrent: true,
    resolveCurrentFilterText (_ref13) {
        let { value: value } = _ref13;
        return value;
    },
    resolveAlgoliaQuery (_ref14) {
        let { params: params, filters: filters } = _ref14;
        return filters.get('marketingLabel').reduce((p, c)=>p.addDisjunctiveFacetRefinement((0, $fMsDx.default).getIn([
                'marketingLabels',
                'algoliaFacetKey'
            ]), c), params);
    }
});
const $b5fd04e2494471c1$var$sortFilter = ()=>(0, $g5DHJ.Map)({
        key: 'sort',
        facet: true,
        label: 'Sort By',
        sidebarLabel: 'Sort By',
        topBarLabel: 'Sort',
        displayInCurrent: false,
        type: (0, $lwEMm.CONJUNCTIVE_FACET_TYPE),
        primary: true,
        custom: true,
        nonRetrievableAttribute: true,
        useDropDownComponentForSidebar: true,
        resolveAlgoliaQuery (_ref15) {
            let { params: params, sort: sort } = _ref15;
            const applyOverrides = sort && sort.get('applyOverrides') || ((q)=>q);
            return applyOverrides(params);
        },
        customFilters: (0, $9LwYq.sortOptions).reduce((acc, so)=>acc.set(so.get('key'), (0, $g5DHJ.Map)({
                value: so.get('key'),
                label: so.get('label')
            })), (0, $g5DHJ.OrderedMap)())
    });
const $b5fd04e2494471c1$export$1933a9fe712fc1fd = function getFilters() {
    let Config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        featureFlags: {}
    };
    const { featureFlags: featureFlags = {} } = Config;
    return (0, $g5DHJ.List)([
        $b5fd04e2494471c1$var$ecosystemCloudAppsFilter(),
        $b5fd04e2494471c1$var$productFilter({
            featureFlags: featureFlags
        }),
        $b5fd04e2494471c1$var$hostingFilter(),
        $b5fd04e2494471c1$var$sortFilter(),
        $b5fd04e2494471c1$var$moreFiltersFilter(),
        $b5fd04e2494471c1$var$categoryFilter(),
        $b5fd04e2494471c1$var$queryFilter,
        $b5fd04e2494471c1$var$marketingLabel
    ]).reduce((acc, f)=>acc.set(f.get('key'), f), (0, $g5DHJ.Map)());
};
const $b5fd04e2494471c1$export$fa7a9d830f6dbd45 = function getTabletMobileFilters() {
    let Config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        featureFlags: {}
    };
    const { featureFlags: featureFlags = {} } = Config;
    return (0, $g5DHJ.List)([
        $b5fd04e2494471c1$var$ecosystemCloudAppsFilter(),
        $b5fd04e2494471c1$var$sortFilter(),
        $b5fd04e2494471c1$var$productFilter({
            featureFlags: featureFlags
        }),
        $b5fd04e2494471c1$var$hostingFilter(),
        $b5fd04e2494471c1$var$categoryFilter(),
        $b5fd04e2494471c1$var$moreFiltersFilter(),
        $b5fd04e2494471c1$var$queryFilter,
        $b5fd04e2494471c1$var$marketingLabel
    ]).reduce((acc, f)=>acc.set(f.get('key'), f), (0, $g5DHJ.Map)());
};

});
parcelRegister("kafab", function(module, exports) {

$parcel$export(module.exports, "AppDeployment", () => $eae080eae4c0a874$export$2e70d094723cb405);
$parcel$export(module.exports, "CloudFortifiedStatusValues", () => $eae080eae4c0a874$export$bd6703b2aeee9fc9);
$parcel$export(module.exports, "BugBountyStatusValues", () => $eae080eae4c0a874$export$8091ba0174454217);
$parcel$export(module.exports, "CompatibleProductTypeValues", () => $eae080eae4c0a874$export$ef4576ddc4afe7f4);
$parcel$export(module.exports, "AppMarketingLabel", () => $eae080eae4c0a874$export$631cc0d39f36372a);
const $eae080eae4c0a874$var$CONNECT_DEPLOYMENT = 'MarketplaceConnectAppDeployment';
const $eae080eae4c0a874$var$ECOSYSTEM_CLOUD_DEPLOYMENT = 'MarketplaceCloudAppDeployment';
const $eae080eae4c0a874$var$INSTRUCTIONAL_DEPLOYMENT = 'MarketplaceInstructionalAppDeployment';
const $eae080eae4c0a874$var$PLUGINS1_DEPLOYMENT = 'MarketplacePlugins1AppDeployment';
const $eae080eae4c0a874$var$PLUGINS2_DEPLOYMENT = 'MarketplacePlugins2AppDeployment';
const $eae080eae4c0a874$var$WORKFLOW_DEPLOYMENT = 'MarketplaceWorkflowAppDeployment';
const $eae080eae4c0a874$export$2e70d094723cb405 = Object.freeze({
    CONNECT: $eae080eae4c0a874$var$CONNECT_DEPLOYMENT,
    ECOSYSTEM_CLOUD: $eae080eae4c0a874$var$ECOSYSTEM_CLOUD_DEPLOYMENT,
    INSTRUCTIONAL: $eae080eae4c0a874$var$INSTRUCTIONAL_DEPLOYMENT,
    PLUGINS1: $eae080eae4c0a874$var$PLUGINS1_DEPLOYMENT,
    PLUGINS2: $eae080eae4c0a874$var$PLUGINS2_DEPLOYMENT,
    WORKFLOW: $eae080eae4c0a874$var$WORKFLOW_DEPLOYMENT
});
const $eae080eae4c0a874$export$bd6703b2aeee9fc9 = Object.freeze({
    Approved: 'approved',
    Rejected: 'rejected'
});
const $eae080eae4c0a874$export$8091ba0174454217 = Object.freeze({
    Approved: 'approved',
    Rejected: 'rejected'
});
const $eae080eae4c0a874$export$ef4576ddc4afe7f4 = Object.freeze({
    CLOUD_PRODUCT: 'CompatibleAtlassianCloudProduct',
    SERVER_PRODUCT: 'CompatibleAtlassianServerProduct',
    DATACENTER_PRODUCT: 'CompatibleAtlassianDataCenterProduct'
});
const $eae080eae4c0a874$export$631cc0d39f36372a = Object.freeze({
    CompatibleWithJSM: 'jira-servicedesk',
    CompatibleWithJSW: 'jira-software'
});

});

const $8749bcdb7e4afe9a$export$7fc2afdd98086cb1 = 'server';
const $8749bcdb7e4afe9a$export$428c0af80a7329cd = 'cloud';
const $8749bcdb7e4afe9a$export$35e53a8bdbe06647 = 'dataCenter';

var $122620c1047e308e$exports = {};

$parcel$export($122620c1047e308e$exports, "JIRA", () => $122620c1047e308e$export$c1fabc4e59d98025);
$parcel$export($122620c1047e308e$exports, "JIRA_SERVICE_DESK", () => $122620c1047e308e$export$3afc372bb8c4538c);
$parcel$export($122620c1047e308e$exports, "CONFLUENCE", () => $122620c1047e308e$export$c811f21c9ad05dc2);
$parcel$export($122620c1047e308e$exports, "HIPCHAT", () => $122620c1047e308e$export$77363fc37d01ae41);
$parcel$export($122620c1047e308e$exports, "BITBUCKET", () => $122620c1047e308e$export$59864d7602eb300a);
$parcel$export($122620c1047e308e$exports, "FECRU", () => $122620c1047e308e$export$e95554a59f3e0c28);
$parcel$export($122620c1047e308e$exports, "BAMBOO", () => $122620c1047e308e$export$1876370d95915b3b);
$parcel$export($122620c1047e308e$exports, "CROWD", () => $122620c1047e308e$export$6bc23744ed8b8097);
$parcel$export($122620c1047e308e$exports, "COMPASS", () => $122620c1047e308e$export$d5e9b613bc4c47f);
const $122620c1047e308e$export$c1fabc4e59d98025 = 'jira';
const $122620c1047e308e$export$3afc372bb8c4538c = 'jsd';
const $122620c1047e308e$export$c811f21c9ad05dc2 = 'confluence';
const $122620c1047e308e$export$77363fc37d01ae41 = 'hipchat';
const $122620c1047e308e$export$59864d7602eb300a = 'bitbucket';
const $122620c1047e308e$export$e95554a59f3e0c28 = 'fecru';
const $122620c1047e308e$export$1876370d95915b3b = 'bamboo';
const $122620c1047e308e$export$6bc23744ed8b8097 = 'crowd';
const $122620c1047e308e$export$d5e9b613bc4c47f = 'compass';

parcelRegister("io1ow", function(module, exports) {

$parcel$export(module.exports, "default", () => $d62b8ccdcf201916$export$2e2bcd8739ae039);
var $d62b8ccdcf201916$export$2e2bcd8739ae039 = {
    sortedByUsage: [
        'Project management',
        'Time tracking',
        'Charts & diagramming',
        'IT & helpdesk',
        'Reports',
        'Workflow',
        'Monitoring',
        'Testing & QA',
        'Document management',
        'Custom fields',
        'Messaging',
        'Integrations',
        'Admin tools',
        'Continuous integration',
        'Dashboard gadgets',
        'Utilities',
        'Tasks',
        'Mobile',
        'Security',
        'Themes & styles',
        'CRM',
        'Blueprints',
        'Design tools',
        'Documentation',
        'Email',
        'Code review',
        'Macros',
        'Source code',
        'Code quality',
        'Deployments',
        'Dependency management',
        'Repository connectors',
        'Build management',
        'Shared workflows',
        'Repository hooks',
        'Language packs'
    ]
};

});

parcelRegister("9LwYq", function(module, exports) {

$parcel$export(module.exports, "sortOptions", () => $71c214b547f03e4a$export$2ecc3309bc48a1e0);

var $g5DHJ = parcelRequire("g5DHJ");



var $fMsDx = parcelRequire("fMsDx");
const $71c214b547f03e4a$export$2ecc3309bc48a1e0 = (0, $g5DHJ.List)([
    (0, $g5DHJ.Map)({
        key: 'topRated',
        label: 'Top rated',
        title: 'Top-rated',
        indexSuffix: ()=>{
            return 'desc_ratings.ratingsScore';
        }
    }),
    (0, $g5DHJ.Map)({
        key: 'trending',
        label: 'Top trending',
        title: 'Trending',
        indexSuffix: ()=>{
            return 'desc_distribution.deltaInstalls';
        },
        applyOverrides: (query)=>query.addFacetRefinement((0, $fMsDx.default).getIn([
                'isAtlassian',
                'algoliaFacetKey'
            ]), 'false')
    }),
    (0, $g5DHJ.Map)({
        key: 'topSelling',
        label: 'Top selling',
        title: 'Top-selling',
        indexSuffix: (_ref)=>{
            let { filters: filters } = _ref;
            switch(filters.get('hosting')){
                case 0, $8749bcdb7e4afe9a$export$428c0af80a7329cd:
                    return 'desc_sales.recentGrossCloud';
                case 0, $8749bcdb7e4afe9a$export$7fc2afdd98086cb1:
                    return 'desc_sales.recentGrossServer';
                case 0, $8749bcdb7e4afe9a$export$35e53a8bdbe06647:
                    return 'desc_sales.recentGrossServer';
                default:
                    return 'desc_sales.recentGrossTotal';
            }
        },
        applyOverrides: (query)=>query.addFacetRefinement((0, $fMsDx.default).getIn([
                'isAtlassian',
                'algoliaFacetKey'
            ]), 'false').addDisjunctiveFacetRefinement((0, $fMsDx.default).getIn([
                'marketplaceType',
                'algoliaFacetKey'
            ]), (0, $ad0fdcf1dd8b1c21$export$820680178c2de888))
    }),
    (0, $g5DHJ.Map)({
        key: 'newest',
        label: 'Newest',
        title: 'Newest',
        indexSuffix: ()=>{
            return 'desc_releaseDate';
        }
    })
]).reduce((acc, s)=>acc.set(s.get('key'), s), (0, $g5DHJ.OrderedMap)());

});
const $ad0fdcf1dd8b1c21$export$820680178c2de888 = 'Paid via Atlassian';
const $ad0fdcf1dd8b1c21$export$694bcde6b7d89a08 = 'Paid via Vendor';
const $ad0fdcf1dd8b1c21$export$f6a4630f2b8ac290 = 'Free';



parcelRegister("bavaN", function(module, exports) {

$parcel$export(module.exports, "search", () => $8218cf38b62bc272$export$d76128d007d19019);
$parcel$export(module.exports, "getAppDetailsByAppKeys", () => $8218cf38b62bc272$export$3a72445f5cc3c98d);
$parcel$export(module.exports, "searchParamsUpdateForAddonKeys", () => $8218cf38b62bc272$export$bbe41be4aeb45c0e);

var $kPJQm = parcelRequire("kPJQm");

var $7TFuJ = parcelRequire("7TFuJ");

var $g5DHJ = parcelRequire("g5DHJ");

var $lwEMm = parcelRequire("lwEMm");

var $b5Eig = parcelRequire("b5Eig");

var $8HDz3 = parcelRequire("8HDz3");

var $72e1Y = parcelRequire("72e1Y");

var $7Qfm4 = parcelRequire("7Qfm4");

var $dbmA1 = parcelRequire("dbmA1");

var $aViHK = parcelRequire("aViHK");
function $8218cf38b62bc272$export$d76128d007d19019(_ref) {
    let { algoliaClient: algoliaClient, environment: environment, filters: filters, numHits: numHits, page: page, applyOverrides: applyOverrides, resolveAlgoliaQueryFilterOverrides: resolveAlgoliaQueryFilterOverrides, featureFlags: featureFlags = {} } = _ref;
    const enhancedFilters = (0, $72e1Y.default)(filters, featureFlags);
    const sort = (0, $aViHK.resolveSortFromFilters)({
        filters: enhancedFilters
    });
    const { enableV2SearchIndex: enableV2SearchIndex } = featureFlags;
    const searchIndexToUse = (0, $dbmA1.resolveSearchIndex)({
        environment: environment,
        filters: filters,
        sort: sort,
        enableV2SearchIndex: enableV2SearchIndex
    });
    const searchParameters = (0, $7Qfm4.default)({
        applyOverrides: applyOverrides,
        filters: enhancedFilters,
        index: searchIndexToUse,
        numHits: numHits,
        page: page,
        sort: sort,
        resolveAlgoliaQueryFilterOverrides: resolveAlgoliaQueryFilterOverrides,
        featureFlags: featureFlags
    });
    return $8218cf38b62bc272$var$doSearch({
        algoliaClient: algoliaClient,
        filters: filters,
        index: searchIndexToUse,
        searchParameters: searchParameters,
        featureFlags: featureFlags
    });
}
function $8218cf38b62bc272$export$3a72445f5cc3c98d(algoliaClient, environment, appKeys) {
    const searchIndexToUse = (0, $dbmA1.resolveSearchIndex)({
        environment: environment
    });
    const searchParameters = {
        facetFilters: [
            appKeys.map((addonKey)=>"addonKey:".concat(addonKey))
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($7TFuJ)))(algoliaClient, searchIndexToUse, {
        hitsPerPage: appKeys.length
    }).searchOnce(searchParameters);
}
function $8218cf38b62bc272$var$doSearch(_ref2) {
    let { algoliaClient: algoliaClient, filters: filters, index: index, searchParameters: searchParameters, featureFlags: featureFlags } = _ref2;
    return new Promise((resolve, reject)=>{
        // This random request id is added to track algolia requests to debug issues faced while upgrading
        // algoliasearch from version 3.35.1 -> 4.19.1 https://ecosystem.atlassian.net/browse/MC-3539
        algoliaClient.setExtraHeader('x-request-id', (0, $kPJQm.generateRequestId)());
        (0, (/*@__PURE__*/$parcel$interopDefault($7TFuJ)))(algoliaClient, index).searchOnce(searchParameters).then((_ref3)=>{
            let { content: content } = _ref3;
            resolve((0, $g5DHJ.Map)({
                facets: (0, $8HDz3.resolveFacets)({
                    facets: (0, $g5DHJ.fromJS)(content.facets).concat((0, $g5DHJ.fromJS)(content.disjunctiveFacets)),
                    filters: filters,
                    featureFlags: featureFlags
                }),
                searchResults: (0, $8HDz3.resolveSearchResults)({
                    hits: (0, $g5DHJ.fromJS)(content.hits),
                    page: content.page,
                    numberOfHits: content.nbHits,
                    numberOfPages: content.nbPages
                })
            }));
        }, (error)=>{
            reject(error.name === 'AlgoliaSearchJSONPScriptErrorError' ? {
                message: 'Connection error'
            } : error);
        });
    });
}
function $8218cf38b62bc272$export$bbe41be4aeb45c0e(addonKeys) {
    return new (0, $b5Eig.default)({
        types: (0, $g5DHJ.Set)([
            (0, $lwEMm.default).disjunctive('addonKey')
        ]),
        apply: (params)=>addonKeys.reduce((finalParams, key)=>finalParams.addDisjunctiveFacetRefinement('addonKey', key), params)
    });
}
function $8218cf38b62bc272$export$af4868b408661b46(addonKeys) {
    return new (0, $b5Eig.default)({
        types: (0, $g5DHJ.Set)([
            (0, $lwEMm.default).conjunctive('addonKey')
        ]),
        apply: (params)=>addonKeys.reduce((finalParams, key)=>finalParams.addExcludeRefinement('addonKey', key), params)
    });
}

});
parcelRegister("kPJQm", function(module, exports) {

$parcel$export(module.exports, "generateRequestId", () => $f2ac219f1a32cffd$export$adb840ec535541d1);

var $xL0Mh = parcelRequire("xL0Mh");
const $f2ac219f1a32cffd$export$adb840ec535541d1 = ()=>{
    return (0, $xL0Mh.default)();
};

});
parcelRegister("xL0Mh", function(module, exports) {

$parcel$export(module.exports, "default", () => $06578cb21acca6fd$export$2e2bcd8739ae039);

var $hDwuw = parcelRequire("hDwuw");

var $HdBQi = parcelRequire("HdBQi");

var $li8Mb = parcelRequire("li8Mb");
function $06578cb21acca6fd$var$v4(options, buf, offset) {
    if ((0, $hDwuw.default).randomUUID && !buf && !options) return (0, $hDwuw.default).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $HdBQi.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $li8Mb.unsafeStringify)(rnds);
}
var $06578cb21acca6fd$export$2e2bcd8739ae039 = $06578cb21acca6fd$var$v4;

});
parcelRegister("hDwuw", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd6f48419f6a0d5c$export$2e2bcd8739ae039);
const $cd6f48419f6a0d5c$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $cd6f48419f6a0d5c$export$2e2bcd8739ae039 = {
    randomUUID: $cd6f48419f6a0d5c$var$randomUUID
};

});

parcelRegister("HdBQi", function(module, exports) {

$parcel$export(module.exports, "default", () => $081e92cd8e858721$export$2e2bcd8739ae039);
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $081e92cd8e858721$var$getRandomValues;
const $081e92cd8e858721$var$rnds8 = new Uint8Array(16);
function $081e92cd8e858721$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$081e92cd8e858721$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $081e92cd8e858721$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$081e92cd8e858721$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $081e92cd8e858721$var$getRandomValues($081e92cd8e858721$var$rnds8);
}

});

parcelRegister("li8Mb", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", () => $f802162c6c4c14f9$export$8fb373d660548968);

var $3s81w = parcelRequire("3s81w");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $f802162c6c4c14f9$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$f802162c6c4c14f9$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $f802162c6c4c14f9$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $f802162c6c4c14f9$var$byteToHex[arr[offset + 0]] + $f802162c6c4c14f9$var$byteToHex[arr[offset + 1]] + $f802162c6c4c14f9$var$byteToHex[arr[offset + 2]] + $f802162c6c4c14f9$var$byteToHex[arr[offset + 3]] + '-' + $f802162c6c4c14f9$var$byteToHex[arr[offset + 4]] + $f802162c6c4c14f9$var$byteToHex[arr[offset + 5]] + '-' + $f802162c6c4c14f9$var$byteToHex[arr[offset + 6]] + $f802162c6c4c14f9$var$byteToHex[arr[offset + 7]] + '-' + $f802162c6c4c14f9$var$byteToHex[arr[offset + 8]] + $f802162c6c4c14f9$var$byteToHex[arr[offset + 9]] + '-' + $f802162c6c4c14f9$var$byteToHex[arr[offset + 10]] + $f802162c6c4c14f9$var$byteToHex[arr[offset + 11]] + $f802162c6c4c14f9$var$byteToHex[arr[offset + 12]] + $f802162c6c4c14f9$var$byteToHex[arr[offset + 13]] + $f802162c6c4c14f9$var$byteToHex[arr[offset + 14]] + $f802162c6c4c14f9$var$byteToHex[arr[offset + 15]];
}
function $f802162c6c4c14f9$var$stringify(arr, offset = 0) {
    const uuid = $f802162c6c4c14f9$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $3s81w.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $f802162c6c4c14f9$export$2e2bcd8739ae039 = $f802162c6c4c14f9$var$stringify;

});
parcelRegister("3s81w", function(module, exports) {

$parcel$export(module.exports, "default", () => $283a35f0440388bc$export$2e2bcd8739ae039);

var $k3dlA = parcelRequire("k3dlA");
function $283a35f0440388bc$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $k3dlA.default).test(uuid);
}
var $283a35f0440388bc$export$2e2bcd8739ae039 = $283a35f0440388bc$var$validate;

});
parcelRegister("k3dlA", function(module, exports) {

$parcel$export(module.exports, "default", () => $e98e70ee3642a85d$export$2e2bcd8739ae039);
var $e98e70ee3642a85d$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});





parcelRegister("7TFuJ", function(module, exports) {
'use strict';

var $9stTq = parcelRequire("9stTq");

var $ltsLR = parcelRequire("ltsLR");

var $dBe1E = parcelRequire("dBe1E");
/**
 * The algoliasearchHelper module is the function that will let its
 * contains everything needed to use the Algoliasearch
 * Helper. It is a also a function that instanciate the helper.
 * To use the helper, you also need the Algolia JS client v3.
 * @example
 * //using the UMD build
 * var client = algoliasearch('latency', '6be0576ff61c053d5f9a3225e2a90f76');
 * var helper = algoliasearchHelper(client, 'bestbuy', {
 *   facets: ['shipping'],
 *   disjunctiveFacets: ['category']
 * });
 * helper.on('result', function(event) {
 *   console.log(event.results);
 * });
 * helper
 *   .toggleFacetRefinement('category', 'Movies & TV Shows')
 *   .toggleFacetRefinement('shipping', 'Free shipping')
 *   .search();
 * @example
 * // The helper is an event emitter using the node API
 * helper.on('result', updateTheResults);
 * helper.once('result', updateTheResults);
 * helper.removeListener('result', updateTheResults);
 * helper.removeAllListeners('result');
 * @module algoliasearchHelper
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the name of the index to query
 * @param  {SearchParameters|object} opts an object defining the initial config of the search. It doesn't have to be a {SearchParameters}, just an object containing the properties you need from it.
 * @return {AlgoliaSearchHelper} The helper instance
 */ function $5bfddb6cbac80ba9$var$algoliasearchHelper(client, index, opts) {
    return new $9stTq(client, index, opts);
}

/**
 * The version currently used
 * @member module:algoliasearchHelper.version
 * @type {number}
 */ $5bfddb6cbac80ba9$var$algoliasearchHelper.version = (parcelRequire("2s3Na"));
/**
 * Constructor for the Helper.
 * @member module:algoliasearchHelper.AlgoliaSearchHelper
 * @type {AlgoliaSearchHelper}
 */ $5bfddb6cbac80ba9$var$algoliasearchHelper.AlgoliaSearchHelper = $9stTq;
/**
 * Constructor for the object containing all the parameters of the search.
 * @member module:algoliasearchHelper.SearchParameters
 * @type {SearchParameters}
 */ $5bfddb6cbac80ba9$var$algoliasearchHelper.SearchParameters = $ltsLR;
/**
 * Constructor for the object containing the results of the search.
 * @member module:algoliasearchHelper.SearchResults
 * @type {SearchResults}
 */ $5bfddb6cbac80ba9$var$algoliasearchHelper.SearchResults = $dBe1E;
module.exports = $5bfddb6cbac80ba9$var$algoliasearchHelper;

});
parcelRegister("9stTq", function(module, exports) {
'use strict';

var $90FFK = parcelRequire("90FFK");

var $9SPXt = parcelRequire("9SPXt");

var $iOTWh = parcelRequire("iOTWh");
var $6e2deaae49fcf720$require$escapeFacetValue = $iOTWh.escapeFacetValue;

var $gVBvC = parcelRequire("gVBvC");

var $2KSyk = parcelRequire("2KSyk");

var $6Wgxo = parcelRequire("6Wgxo");

var $ka9BV = parcelRequire("ka9BV");

var $5BVQk = parcelRequire("5BVQk");

var $ltsLR = parcelRequire("ltsLR");

var $dBe1E = parcelRequire("dBe1E");

var $2s3Na = parcelRequire("2s3Na");
/**
 * Event triggered when a parameter is set or updated
 * @event AlgoliaSearchHelper#event:change
 * @property {object} event
 * @property {SearchParameters} event.state the current parameters with the latest changes applied
 * @property {SearchResults} event.results the previous results received from Algolia. `null` before the first request
 * @example
 * helper.on('change', function(event) {
 *   console.log('The parameters have changed');
 * });
 */ /**
 * Event triggered when a main search is sent to Algolia
 * @event AlgoliaSearchHelper#event:search
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search
 * @property {SearchResults} event.results the results from the previous search. `null` if it is the first search.
 * @example
 * helper.on('search', function(event) {
 *   console.log('Search sent');
 * });
 */ /**
 * Event triggered when a search using `searchForFacetValues` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchForFacetValues
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @property {string} event.facet the facet searched into
 * @property {string} event.query the query used to search in the facets
 * @example
 * helper.on('searchForFacetValues', function(event) {
 *   console.log('searchForFacetValues sent');
 * });
 */ /**
 * Event triggered when a search using `searchOnce` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchOnce
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @example
 * helper.on('searchOnce', function(event) {
 *   console.log('searchOnce sent');
 * });
 */ /**
 * Event triggered when the results are retrieved from Algolia
 * @event AlgoliaSearchHelper#event:result
 * @property {object} event
 * @property {SearchResults} event.results the results received from Algolia
 * @property {SearchParameters} event.state the parameters used to query Algolia. Those might be different from the one in the helper instance (for example if the network is unreliable).
 * @example
 * helper.on('result', function(event) {
 *   console.log('Search results received');
 * });
 */ /**
 * Event triggered when Algolia sends back an error. For example, if an unknown parameter is
 * used, the error can be caught using this event.
 * @event AlgoliaSearchHelper#event:error
 * @property {object} event
 * @property {Error} event.error the error returned by the Algolia.
 * @example
 * helper.on('error', function(event) {
 *   console.log('Houston we got a problem.');
 * });
 */ /**
 * Event triggered when the queue of queries have been depleted (with any result or outdated queries)
 * @event AlgoliaSearchHelper#event:searchQueueEmpty
 * @example
 * helper.on('searchQueueEmpty', function() {
 *   console.log('No more search pending');
 *   // This is received before the result event if we're not expecting new results
 * });
 *
 * helper.search();
 */ /**
 * Initialize a new AlgoliaSearchHelper
 * @class
 * @classdesc The AlgoliaSearchHelper is a class that ease the management of the
 * search. It provides an event based interface for search callbacks:
 *  - change: when the internal search state is changed.
 *    This event contains a {@link SearchParameters} object and the
 *    {@link SearchResults} of the last result if any.
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 *  - error: when the response is an error. This event contains the error returned by the server.
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the index name to query
 * @param  {SearchParameters | object} options an object defining the initial
 * config of the search. It doesn't have to be a {SearchParameters},
 * just an object containing the properties you need from it.
 */ function $6e2deaae49fcf720$var$AlgoliaSearchHelper(client, index, options) {
    if (typeof client.addAlgoliaAgent === 'function') client.addAlgoliaAgent('JS Helper (' + $2s3Na + ')');
    this.setClient(client);
    var opts = options || {};
    opts.index = index;
    this.state = $ltsLR.make(opts);
    this.lastResults = null;
    this._queryId = 0;
    this._lastQueryIdReceived = -1;
    this.derivedHelpers = [];
    this._currentNbQueries = 0;
}
$gVBvC($6e2deaae49fcf720$var$AlgoliaSearchHelper, $90FFK);
/**
 * Start the search with the parameters set in the state. When the
 * method is called, it triggers a `search` event. The results will
 * be available through the `result` event. If an error occurs, an
 * `error` will be fired instead.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires search
 * @fires result
 * @fires error
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.search = function() {
    this._search({
        onlyWithDerivedHelpers: false
    });
    return this;
};
$6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.searchOnlyWithDerivedHelpers = function() {
    this._search({
        onlyWithDerivedHelpers: true
    });
    return this;
};
/**
 * Gets the search query parameters that would be sent to the Algolia Client
 * for the hits
 * @return {object} Query Parameters
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.getQuery = function() {
    var state = this.state;
    return $5BVQk._getHitsSearchParams(state);
};
/**
 * Start a search using a modified version of the current state. This method does
 * not trigger the helper lifecycle and does not modify the state kept internally
 * by the helper. This second aspect means that the next search call will be the
 * same as a search call before calling searchOnce.
 * @param {object} options can contain all the parameters that can be set to SearchParameters
 * plus the index
 * @param {function} [cb] optional callback executed when the response from the
 * server is back.
 * @return {promise|undefined} if a callback is passed the method returns undefined
 * otherwise it returns a promise containing an object with two keys :
 *  - content with a SearchResults
 *  - state with the state used for the query as a SearchParameters
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the callback API
 * var state = helper.searchOnce({hitsPerPage: 1},
 *   function(error, content, state) {
 *     // if an error occurred it will be passed in error, otherwise its value is null
 *     // content contains the results formatted as a SearchResults
 *     // state is the instance of SearchParameters used for this search
 *   });
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the promise API
 * var state1 = helper.searchOnce({hitsPerPage: 1})
 *                 .then(promiseHandler);
 *
 * function promiseHandler(res) {
 *   // res contains
 *   // {
 *   //   content : SearchResults
 *   //   state   : SearchParameters (the one used for this specific search)
 *   // }
 * }
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.searchOnce = function(options, cb) {
    var tempState = !options ? this.state : this.state.setQueryParameters(options);
    var queries = $5BVQk._getQueries(tempState.index, tempState);
    // eslint-disable-next-line consistent-this
    var self = this;
    this._currentNbQueries++;
    this.emit('searchOnce', {
        state: tempState
    });
    if (cb) {
        this.client.search(queries).then(function(content) {
            self._currentNbQueries--;
            if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
            cb(null, new $dBe1E(tempState, content.results), tempState);
        }).catch(function(err) {
            self._currentNbQueries--;
            if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
            cb(err, null, tempState);
        });
        return undefined;
    }
    return this.client.search(queries).then(function(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
        return {
            content: new $dBe1E(tempState, content.results),
            state: tempState,
            _originalResponse: content
        };
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
        throw e;
    });
};
/**
 * Start the search for answers with the parameters set in the state.
 * This method returns a promise.
 * @param {Object} options - the options for answers API call
 * @param {string[]} options.attributesForPrediction - Attributes to use for predictions. If empty, `searchableAttributes` is used instead.
 * @param {string[]} options.queryLanguages - The languages in the query. Currently only supports ['en'].
 * @param {number} options.nbHits - Maximum number of answers to retrieve from the Answers Engine. Cannot be greater than 1000.
 *
 * @return {promise} the answer results
 * @deprecated answers is deprecated and will be replaced with new initiatives
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.findAnswers = function(options) {
    // eslint-disable-next-line no-console
    console.warn('[algoliasearch-helper] answers is no longer supported');
    var state = this.state;
    var derivedHelper = this.derivedHelpers[0];
    if (!derivedHelper) return Promise.resolve([]);
    var derivedState = derivedHelper.getModifiedState(state);
    var data = $2KSyk({
        attributesForPrediction: options.attributesForPrediction,
        nbHits: options.nbHits
    }, {
        params: $ka9BV($5BVQk._getHitsSearchParams(derivedState), [
            'attributesToSnippet',
            'hitsPerPage',
            'restrictSearchableAttributes',
            'snippetEllipsisText'
        ])
    });
    var errorMessage = 'search for answers was called, but this client does not have a function client.initIndex(index).findAnswers';
    if (typeof this.client.initIndex !== 'function') throw new Error(errorMessage);
    var index = this.client.initIndex(derivedState.index);
    if (typeof index.findAnswers !== 'function') throw new Error(errorMessage);
    return index.findAnswers(derivedState.query, options.queryLanguages, data);
};
/**
 * Structure of each result when using
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * @typedef FacetSearchHit
 * @type {object}
 * @property {string} value the facet value
 * @property {string} highlighted the facet value highlighted with the query string
 * @property {number} count number of occurrence of this facet value
 * @property {boolean} isRefined true if the value is already refined
 */ /**
 * Structure of the data resolved by the
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * promise.
 * @typedef FacetSearchResult
 * @type {object}
 * @property {FacetSearchHit} facetHits the results for this search for facet values
 * @property {number} processingTimeMS time taken by the query inside the engine
 */ /**
 * Search for facet values based on an query and the name of a faceted attribute. This
 * triggers a search and will return a promise. On top of using the query, it also sends
 * the parameters from the state so that the search is narrowed down to only the possible values.
 *
 * See the description of [FacetSearchResult](reference.html#FacetSearchResult)
 * @param {string} facet the name of the faceted attribute
 * @param {string} query the string query for the search
 * @param {number} [maxFacetHits] the maximum number values returned. Should be > 0 and <= 100
 * @param {object} [userState] the set of custom parameters to use on top of the current state. Setting a property to `undefined` removes
 * it in the generated query.
 * @return {promise.<FacetSearchResult>} the results of the search
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.searchForFacetValues = function(facet, query, maxFacetHits, userState) {
    var clientHasSFFV = typeof this.client.searchForFacetValues === 'function';
    var clientHasInitIndex = typeof this.client.initIndex === 'function';
    if (!clientHasSFFV && !clientHasInitIndex && typeof this.client.search !== 'function') throw new Error('search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues or client.initIndex(index).searchForFacetValues');
    var state = this.state.setQueryParameters(userState || {});
    var isDisjunctive = state.isDisjunctiveFacet(facet);
    var algoliaQuery = $5BVQk.getSearchForFacetQuery(facet, query, maxFacetHits, state);
    this._currentNbQueries++;
    // eslint-disable-next-line consistent-this
    var self = this;
    var searchForFacetValuesPromise;
    // newer algoliasearch ^3.27.1 - ~4.0.0
    if (clientHasSFFV) searchForFacetValuesPromise = this.client.searchForFacetValues([
        {
            indexName: state.index,
            params: algoliaQuery
        }
    ]);
    else if (clientHasInitIndex) searchForFacetValuesPromise = this.client.initIndex(state.index).searchForFacetValues(algoliaQuery);
    else {
        // @MAJOR only use client.search
        delete algoliaQuery.facetName;
        searchForFacetValuesPromise = this.client.search([
            {
                type: 'facet',
                facet: facet,
                indexName: state.index,
                params: algoliaQuery
            }
        ]).then(function processResponse(response) {
            return response.results[0];
        });
    }
    this.emit('searchForFacetValues', {
        state: state,
        facet: facet,
        query: query
    });
    return searchForFacetValuesPromise.then(function addIsRefined(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
        content = Array.isArray(content) ? content[0] : content;
        content.facetHits.forEach(function(f) {
            f.escapedValue = $6e2deaae49fcf720$require$escapeFacetValue(f.value);
            f.isRefined = isDisjunctive ? state.isDisjunctiveFacetRefined(facet, f.escapedValue) : state.isFacetRefined(facet, f.escapedValue);
        });
        return content;
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
        throw e;
    });
};
/**
 * Sets the text query used for the search.
 *
 * This method resets the current page to 0.
 * @param  {string} q the user query
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.setQuery = function(q) {
    this._change({
        state: this.state.resetPage().setQuery(q),
        isPageReset: true
    });
    return this;
};
/**
 * Remove all the types of refinements except tags. A string can be provided to remove
 * only the refinements of a specific attribute. For more advanced use case, you can
 * provide a function instead. This function should follow the
 * [clearCallback definition](#SearchParameters.clearCallback).
 *
 * This method resets the current page to 0.
 * @param {string} [name] optional name of the facet / attribute on which we want to remove all refinements
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * // Removing all the refinements
 * helper.clearRefinements().search();
 * @example
 * // Removing all the filters on a the category attribute.
 * helper.clearRefinements('category').search();
 * @example
 * // Removing only the exclude filters on the category facet.
 * helper.clearRefinements(function(value, attribute, type) {
 *   return type === 'exclude' && attribute === 'category';
 * }).search();
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.clearRefinements = function(name) {
    this._change({
        state: this.state.resetPage().clearRefinements(name),
        isPageReset: true
    });
    return this;
};
/**
 * Remove all the tag filters.
 *
 * This method resets the current page to 0.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.clearTags = function() {
    this._change({
        state: this.state.resetPage().clearTags(),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.addDisjunctiveFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().addDisjunctiveFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addDisjunctiveFacetRefinement}
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.addDisjunctiveRefine = function() {
    return this.addDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Adds a refinement on a hierarchical facet. It will throw
 * an exception if the facet is not defined or if the facet
 * is already refined.
 *
 * This method resets the current page to 0.
 * @param {string} facet the facet name
 * @param {string} path the hierarchical facet path
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error if the facet is not defined or if the facet is refined
 * @chainable
 * @fires change
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.addHierarchicalFacetRefinement = function(facet, path) {
    this._change({
        state: this.state.resetPage().addHierarchicalFacetRefinement(facet, path),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} operator the operator of the filter
 * @param  {number} value the value of the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.addNumericRefinement = function(attribute, operator, value) {
    this._change({
        state: this.state.resetPage().addNumericRefinement(attribute, operator, value),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.addFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().addFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetRefinement}
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.addRefine = function() {
    return this.addFacetRefinement.apply(this, arguments);
};
/**
 * Adds a an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.addFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().addExcludeRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetExclusion}
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.addExclude = function() {
    return this.addFacetExclusion.apply(this, arguments);
};
/**
 * Adds a tag filter with the `tag` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag the tag to add to the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.addTag = function(tag) {
    this._change({
        state: this.state.resetPage().addTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Removes an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * Some parameters are optional, triggering different behavior:
 *  - if the value is not provided, then all the numeric value will be removed for the
 *  specified attribute/operator couple.
 *  - if the operator is not provided either, then all the numeric filter on this attribute
 *  will be removed.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} [operator] the operator of the filter
 * @param  {number} [value] the value of the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.removeNumericRefinement = function(attribute, operator, value) {
    this._change({
        state: this.state.resetPage().removeNumericRefinement(attribute, operator, value),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.removeDisjunctiveFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeDisjunctiveFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeDisjunctiveFacetRefinement}
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.removeDisjunctiveRefine = function() {
    return this.removeDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Removes the refinement set on a hierarchical facet.
 * @param {string} facet the facet name
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error if the facet is not defined or if the facet is not refined
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.removeHierarchicalFacetRefinement = function(facet) {
    this._change({
        state: this.state.resetPage().removeHierarchicalFacetRefinement(facet),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.removeFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetRefinement}
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.removeRefine = function() {
    return this.removeFacetRefinement.apply(this, arguments);
};
/**
 * Removes an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.removeFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeExcludeRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetExclusion}
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.removeExclude = function() {
    return this.removeFacetExclusion.apply(this, arguments);
};
/**
 * Removes a tag filter with the `tag` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove from the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.removeTag = function(tag) {
    this._change({
        state: this.state.resetPage().removeTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Adds or removes an exclusion filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.toggleFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().toggleExcludeFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetExclusion}
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.toggleExclude = function() {
    return this.toggleFacetExclusion.apply(this, arguments);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 * @deprecated since version 2.19.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.toggleRefinement = function(facet, value) {
    return this.toggleFacetRefinement(facet, value);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.toggleFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().toggleFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.toggleRefine = function() {
    return this.toggleFacetRefinement.apply(this, arguments);
};
/**
 * Adds or removes a tag filter with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove or add
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.toggleTag = function(tag) {
    this._change({
        state: this.state.resetPage().toggleTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Increments the page number by one.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * helper.setPage(0).nextPage().getPage();
 * // returns 1
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.nextPage = function() {
    var page = this.state.page || 0;
    return this.setPage(page + 1);
};
/**
 * Decrements the page number by one.
 * @fires change
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @chainable
 * @example
 * helper.setPage(1).previousPage().getPage();
 * // returns 0
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.previousPage = function() {
    var page = this.state.page || 0;
    return this.setPage(page - 1);
};
/**
 * @private
 * @param {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @chainable
 * @fires change
 */ function $6e2deaae49fcf720$var$setCurrentPage(page) {
    if (page < 0) throw new Error('Page requested below 0.');
    this._change({
        state: this.state.setPage(page),
        isPageReset: false
    });
    return this;
}
/**
 * Change the current page
 * @deprecated
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.setCurrentPage = $6e2deaae49fcf720$var$setCurrentPage;
/**
 * Updates the current page.
 * @function
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.setPage = $6e2deaae49fcf720$var$setCurrentPage;
/**
 * Updates the name of the index that will be targeted by the query.
 *
 * This method resets the current page to 0.
 * @param {string} name the index name
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.setIndex = function(name) {
    this._change({
        state: this.state.resetPage().setIndex(name),
        isPageReset: true
    });
    return this;
};
/**
 * Update a parameter of the search. This method reset the page
 *
 * The complete list of parameters is available on the
 * [Algolia website](https://www.algolia.com/doc/rest#query-an-index).
 * The most commonly used parameters have their own [shortcuts](#query-parameters-shortcuts)
 * or benefit from higher-level APIs (all the kind of filters and facets have their own API)
 *
 * This method resets the current page to 0.
 * @param {string} parameter name of the parameter to update
 * @param {any} value new value of the parameter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * helper.setQueryParameter('hitsPerPage', 20).search();
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.setQueryParameter = function(parameter, value) {
    this._change({
        state: this.state.resetPage().setQueryParameter(parameter, value),
        isPageReset: true
    });
    return this;
};
/**
 * Set the whole state (warning: will erase previous state)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.setState = function(newState) {
    this._change({
        state: $ltsLR.make(newState),
        isPageReset: false
    });
    return this;
};
/**
 * Override the current state without triggering a change event.
 * Do not use this method unless you know what you are doing. (see the example
 * for a legit use case)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @example
 *  helper.on('change', function(state){
 *    // In this function you might want to find a way to store the state in the url/history
 *    updateYourURL(state)
 *  })
 *  window.onpopstate = function(event){
 *    // This is naive though as you should check if the state is really defined etc.
 *    helper.overrideStateWithoutTriggeringChangeEvent(event.state).search()
 *  }
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.overrideStateWithoutTriggeringChangeEvent = function(newState) {
    this.state = new $ltsLR(newState);
    return this;
};
/**
 * Check if an attribute has any numeric, conjunctive, disjunctive or hierarchical filters.
 * @param {string} attribute the name of the attribute
 * @return {boolean} true if the attribute is filtered by at least one value
 * @example
 * // hasRefinements works with numeric, conjunctive, disjunctive and hierarchical filters
 * helper.hasRefinements('price'); // false
 * helper.addNumericRefinement('price', '>', 100);
 * helper.hasRefinements('price'); // true
 *
 * helper.hasRefinements('color'); // false
 * helper.addFacetRefinement('color', 'blue');
 * helper.hasRefinements('color'); // true
 *
 * helper.hasRefinements('material'); // false
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * helper.hasRefinements('material'); // true
 *
 * helper.hasRefinements('categories'); // false
 * helper.toggleFacetRefinement('categories', 'kitchen > knife');
 * helper.hasRefinements('categories'); // true
 *
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.hasRefinements = function(attribute) {
    if ($6Wgxo(this.state.getNumericRefinements(attribute))) return true;
    else if (this.state.isConjunctiveFacet(attribute)) return this.state.isFacetRefined(attribute);
    else if (this.state.isDisjunctiveFacet(attribute)) return this.state.isDisjunctiveFacetRefined(attribute);
    else if (this.state.isHierarchicalFacet(attribute)) return this.state.isHierarchicalFacetRefined(attribute);
    // there's currently no way to know that the user did call `addNumericRefinement` at some point
    // thus we cannot distinguish if there once was a numeric refinement that was cleared
    // so we will return false in every other situations to be consistent
    // while what we should do here is throw because we did not find the attribute in any type
    // of refinement
    return false;
};
/**
 * Check if a value is excluded for a specific faceted attribute. If the value
 * is omitted then the function checks if there is any excluding refinements.
 *
 * @param  {string}  facet name of the attribute for used for faceting
 * @param  {string}  [value] optional value. If passed will test that this value
 * is filtering the given facet.
 * @return {boolean} true if refined
 * @example
 * helper.isExcludeRefined('color'); // false
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // false
 *
 * helper.addFacetExclusion('color', 'red');
 *
 * helper.isExcludeRefined('color'); // true
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // true
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.isExcluded = function(facet, value) {
    return this.state.isExcludeRefined(facet, value);
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasRefinements}
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.isDisjunctiveRefined = function(facet, value) {
    return this.state.isDisjunctiveFacetRefined(facet, value);
};
/**
 * Check if the string is a currently filtering tag.
 * @param {string} tag tag to check
 * @return {boolean} true if the tag is currently refined
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.hasTag = function(tag) {
    return this.state.isTagRefined(tag);
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasTag}
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.isTagRefined = function() {
    return this.hasTagRefinements.apply(this, arguments);
};
/**
 * Get the name of the currently used index.
 * @return {string} name of the index
 * @example
 * helper.setIndex('highestPrice_products').getIndex();
 * // returns 'highestPrice_products'
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.getIndex = function() {
    return this.state.index;
};
function $6e2deaae49fcf720$var$getCurrentPage() {
    return this.state.page;
}
/**
 * Get the currently selected page
 * @deprecated
 * @return {number} the current page
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.getCurrentPage = $6e2deaae49fcf720$var$getCurrentPage;
/**
 * Get the currently selected page
 * @function
 * @return {number} the current page
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.getPage = $6e2deaae49fcf720$var$getCurrentPage;
/**
 * Get all the tags currently set to filters the results.
 *
 * @return {string[]} The list of tags currently set.
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.getTags = function() {
    return this.state.tagRefinements;
};
/**
 * Get the list of refinements for a given attribute. This method works with
 * conjunctive, disjunctive, excluding and numerical filters.
 *
 * See also SearchResults#getRefinements
 *
 * @param {string} facetName attribute name used for faceting
 * @return {Array.<FacetRefinement|NumericRefinement>} All Refinement are objects that contain a value, and
 * a type. Numeric also contains an operator.
 * @example
 * helper.addNumericRefinement('price', '>', 100);
 * helper.getRefinements('price');
 * // [
 * //   {
 * //     "value": [
 * //       100
 * //     ],
 * //     "operator": ">",
 * //     "type": "numeric"
 * //   }
 * // ]
 * @example
 * helper.addFacetRefinement('color', 'blue');
 * helper.addFacetExclusion('color', 'red');
 * helper.getRefinements('color');
 * // [
 * //   {
 * //     "value": "blue",
 * //     "type": "conjunctive"
 * //   },
 * //   {
 * //     "value": "red",
 * //     "type": "exclude"
 * //   }
 * // ]
 * @example
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * // [
 * //   {
 * //     "value": "plastic",
 * //     "type": "disjunctive"
 * //   }
 * // ]
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.getRefinements = function(facetName) {
    var refinements = [];
    if (this.state.isConjunctiveFacet(facetName)) {
        var conjRefinements = this.state.getConjunctiveRefinements(facetName);
        conjRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: 'conjunctive'
            });
        });
        var excludeRefinements = this.state.getExcludeRefinements(facetName);
        excludeRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: 'exclude'
            });
        });
    } else if (this.state.isDisjunctiveFacet(facetName)) {
        var disjunctiveRefinements = this.state.getDisjunctiveRefinements(facetName);
        disjunctiveRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: 'disjunctive'
            });
        });
    }
    var numericRefinements = this.state.getNumericRefinements(facetName);
    Object.keys(numericRefinements).forEach(function(operator) {
        var value = numericRefinements[operator];
        refinements.push({
            value: value,
            operator: operator,
            type: 'numeric'
        });
    });
    return refinements;
};
/**
 * Return the current refinement for the (attribute, operator)
 * @param {string} attribute attribute in the record
 * @param {string} operator operator applied on the refined values
 * @return {Array.<number|number[]>} refined values
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.getNumericRefinement = function(attribute, operator) {
    return this.state.getNumericRefinement(attribute, operator);
};
/**
 * Get the current breadcrumb for a hierarchical facet, as an array
 * @param  {string} facetName Hierarchical facet name
 * @return {array.<string>} the path as an array of string
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.getHierarchicalFacetBreadcrumb = function(facetName) {
    return this.state.getHierarchicalFacetBreadcrumb(facetName);
};
// /////////// PRIVATE
/**
 * Perform the underlying queries
 * @private
 * @param {object} options options for the query
 * @param {boolean} [options.onlyWithDerivedHelpers=false] if true, only the derived helpers will be queried
 * @return {undefined} does not return anything
 * @fires search
 * @fires result
 * @fires error
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype._search = function(options) {
    var state = this.state;
    var states = [];
    var mainQueries = [];
    if (!options.onlyWithDerivedHelpers) {
        mainQueries = $5BVQk._getQueries(state.index, state);
        states.push({
            state: state,
            queriesCount: mainQueries.length,
            helper: this
        });
        this.emit('search', {
            state: state,
            results: this.lastResults
        });
    }
    var derivedQueries = this.derivedHelpers.map(function(derivedHelper) {
        var derivedState = derivedHelper.getModifiedState(state);
        var derivedStateQueries = derivedState.index ? $5BVQk._getQueries(derivedState.index, derivedState) : [];
        states.push({
            state: derivedState,
            queriesCount: derivedStateQueries.length,
            helper: derivedHelper
        });
        derivedHelper.emit('search', {
            state: derivedState,
            results: derivedHelper.lastResults
        });
        return derivedStateQueries;
    });
    var queries = Array.prototype.concat.apply(mainQueries, derivedQueries);
    var queryId = this._queryId++;
    this._currentNbQueries++;
    if (!queries.length) return Promise.resolve({
        results: []
    }).then(this._dispatchAlgoliaResponse.bind(this, states, queryId));
    try {
        this.client.search(queries).then(this._dispatchAlgoliaResponse.bind(this, states, queryId)).catch(this._dispatchAlgoliaError.bind(this, queryId));
    } catch (error) {
        // If we reach this part, we're in an internal error state
        this.emit('error', {
            error: error
        });
    }
    return undefined;
};
/**
 * Transform the responses as sent by the server and transform them into a user
 * usable object that merge the results of all the batch requests. It will dispatch
 * over the different helper + derived helpers (when there are some).
 * @private
 * @param {array.<{SearchParameters, AlgoliaQueries, AlgoliaSearchHelper}>} states state used to generate the request
 * @param {number} queryId id of the current request
 * @param {object} content content of the response
 * @return {undefined}
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype._dispatchAlgoliaResponse = function(states, queryId, content) {
    // @TODO remove the number of outdated queries discarded instead of just one
    if (queryId < this._lastQueryIdReceived) // Outdated answer
    return;
    this._currentNbQueries -= queryId - this._lastQueryIdReceived;
    this._lastQueryIdReceived = queryId;
    if (this._currentNbQueries === 0) this.emit('searchQueueEmpty');
    var results = content.results.slice();
    states.forEach(function(s) {
        var state = s.state;
        var queriesCount = s.queriesCount;
        var helper = s.helper;
        var specificResults = results.splice(0, queriesCount);
        if (!state.index) {
            helper.emit('result', {
                results: null,
                state: state
            });
            return;
        }
        helper.lastResults = new $dBe1E(state, specificResults);
        helper.emit('result', {
            results: helper.lastResults,
            state: state
        });
    });
};
$6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype._dispatchAlgoliaError = function(queryId, error) {
    if (queryId < this._lastQueryIdReceived) // Outdated answer
    return;
    this._currentNbQueries -= queryId - this._lastQueryIdReceived;
    this._lastQueryIdReceived = queryId;
    this.emit('error', {
        error: error
    });
    if (this._currentNbQueries === 0) this.emit('searchQueueEmpty');
};
$6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.containsRefinement = function(query, facetFilters, numericFilters, tagFilters) {
    return query || facetFilters.length !== 0 || numericFilters.length !== 0 || tagFilters.length !== 0;
};
/**
 * Test if there are some disjunctive refinements on the facet
 * @private
 * @param {string} facet the attribute to test
 * @return {boolean} true if there are refinements on this attribute
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype._hasDisjunctiveRefinements = function(facet) {
    return this.state.disjunctiveRefinements[facet] && this.state.disjunctiveRefinements[facet].length > 0;
};
$6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype._change = function(event) {
    var state = event.state;
    var isPageReset = event.isPageReset;
    if (state !== this.state) {
        this.state = state;
        this.emit('change', {
            state: this.state,
            results: this.lastResults,
            isPageReset: isPageReset
        });
    }
};
/**
 * Clears the cache of the underlying Algolia client.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.clearCache = function() {
    if (this.client.clearCache) this.client.clearCache();
    return this;
};
/**
 * Updates the internal client instance. If the reference of the clients
 * are equal then no update is actually done.
 * @param  {AlgoliaSearch} newClient an AlgoliaSearch client
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.setClient = function(newClient) {
    if (this.client === newClient) return this;
    if (typeof newClient.addAlgoliaAgent === 'function') newClient.addAlgoliaAgent('JS Helper (' + $2s3Na + ')');
    this.client = newClient;
    return this;
};
/**
 * Gets the instance of the currently used client.
 * @return {AlgoliaSearch} the currently used client
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.getClient = function() {
    return this.client;
};
/**
 * Creates an derived instance of the Helper. A derived helper
 * is a way to request other indices synchronised with the lifecycle
 * of the main Helper. This mechanism uses the multiqueries feature
 * of Algolia to aggregate all the requests in a single network call.
 *
 * This method takes a function that is used to create a new SearchParameter
 * that will be used to create requests to Algolia. Those new requests
 * are created just before the `search` event. The signature of the function
 * is `SearchParameters -> SearchParameters`.
 *
 * This method returns a new DerivedHelper which is an EventEmitter
 * that fires the same `search`, `result` and `error` events. Those
 * events, however, will receive data specific to this DerivedHelper
 * and the SearchParameters that is returned by the call of the
 * parameter function.
 * @param {function} fn SearchParameters -> SearchParameters
 * @return {DerivedHelper} a new DerivedHelper
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.derive = function(fn) {
    var derivedHelper = new $9SPXt(this, fn);
    this.derivedHelpers.push(derivedHelper);
    return derivedHelper;
};
/**
 * This method detaches a derived Helper from the main one. Prefer using the one from the
 * derived helper itself, to remove the event listeners too.
 * @private
 * @param  {DerivedHelper} derivedHelper the derived helper to detach
 * @return {undefined} nothing is returned
 * @throws Error
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.detachDerivedHelper = function(derivedHelper) {
    var pos = this.derivedHelpers.indexOf(derivedHelper);
    if (pos === -1) throw new Error('Derived helper already detached');
    this.derivedHelpers.splice(pos, 1);
};
/**
 * This method returns true if there is currently at least one on-going search.
 * @return {boolean} true if there is a search pending
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.hasPendingRequests = function() {
    return this._currentNbQueries > 0;
};
/**
 * @typedef AlgoliaSearchHelper.NumericRefinement
 * @type {object}
 * @property {number[]} value the numbers that are used for filtering this attribute with
 * the operator specified.
 * @property {string} operator the faceting data: value, number of entries
 * @property {string} type will be 'numeric'
 */ /**
 * @typedef AlgoliaSearchHelper.FacetRefinement
 * @type {object}
 * @property {string} value the string use to filter the attribute
 * @property {string} type the type of filter: 'conjunctive', 'disjunctive', 'exclude'
 */ module.exports = $6e2deaae49fcf720$var$AlgoliaSearchHelper;

});
parcelRegister("90FFK", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
function $68f47069226118a5$var$EventEmitter() {
    this._events = this._events || {};
    this._maxListeners = this._maxListeners || undefined;
}
module.exports = $68f47069226118a5$var$EventEmitter;
// Backwards-compat with node 0.10.x
// EventEmitter.EventEmitter = EventEmitter;
$68f47069226118a5$var$EventEmitter.prototype._events = undefined;
$68f47069226118a5$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
$68f47069226118a5$var$EventEmitter.defaultMaxListeners = 10;
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$68f47069226118a5$var$EventEmitter.prototype.setMaxListeners = function(n) {
    if (!$68f47069226118a5$var$isNumber(n) || n < 0 || isNaN(n)) throw TypeError('n must be a positive number');
    this._maxListeners = n;
    return this;
};
$68f47069226118a5$var$EventEmitter.prototype.emit = function(type) {
    var er, handler, len, args, i, listeners;
    if (!this._events) this._events = {};
    // If there is no 'error' event listener then throw.
    if (type === 'error') {
        if (!this._events.error || $68f47069226118a5$var$isObject(this._events.error) && !this._events.error.length) {
            er = arguments[1];
            if (er instanceof Error) throw er; // Unhandled 'error' event
            else {
                // At least give some kind of context to the user
                var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
                err.context = er;
                throw err;
            }
        }
    }
    handler = this._events[type];
    if ($68f47069226118a5$var$isUndefined(handler)) return false;
    if ($68f47069226118a5$var$isFunction(handler)) switch(arguments.length){
        // fast cases
        case 1:
            handler.call(this);
            break;
        case 2:
            handler.call(this, arguments[1]);
            break;
        case 3:
            handler.call(this, arguments[1], arguments[2]);
            break;
        // slower
        default:
            args = Array.prototype.slice.call(arguments, 1);
            handler.apply(this, args);
    }
    else if ($68f47069226118a5$var$isObject(handler)) {
        args = Array.prototype.slice.call(arguments, 1);
        listeners = handler.slice();
        len = listeners.length;
        for(i = 0; i < len; i++)listeners[i].apply(this, args);
    }
    return true;
};
$68f47069226118a5$var$EventEmitter.prototype.addListener = function(type, listener) {
    var m;
    if (!$68f47069226118a5$var$isFunction(listener)) throw TypeError('listener must be a function');
    if (!this._events) this._events = {};
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (this._events.newListener) this.emit('newListener', type, $68f47069226118a5$var$isFunction(listener.listener) ? listener.listener : listener);
    if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
    else if ($68f47069226118a5$var$isObject(this._events[type])) // If we've already got an array, just append.
    this._events[type].push(listener);
    else // Adding the second element, need to change to array.
    this._events[type] = [
        this._events[type],
        listener
    ];
    // Check for listener leak
    if ($68f47069226118a5$var$isObject(this._events[type]) && !this._events[type].warned) {
        if (!$68f47069226118a5$var$isUndefined(this._maxListeners)) m = this._maxListeners;
        else m = $68f47069226118a5$var$EventEmitter.defaultMaxListeners;
        if (m && m > 0 && this._events[type].length > m) {
            this._events[type].warned = true;
            console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[type].length);
            if (typeof console.trace === 'function') // not supported in IE 10
            console.trace();
        }
    }
    return this;
};
$68f47069226118a5$var$EventEmitter.prototype.on = $68f47069226118a5$var$EventEmitter.prototype.addListener;
$68f47069226118a5$var$EventEmitter.prototype.once = function(type, listener) {
    if (!$68f47069226118a5$var$isFunction(listener)) throw TypeError('listener must be a function');
    var fired = false;
    function g() {
        this.removeListener(type, g);
        if (!fired) {
            fired = true;
            listener.apply(this, arguments);
        }
    }
    g.listener = listener;
    this.on(type, g);
    return this;
};
// emits a 'removeListener' event iff the listener was removed
$68f47069226118a5$var$EventEmitter.prototype.removeListener = function(type, listener) {
    var list, position, length, i;
    if (!$68f47069226118a5$var$isFunction(listener)) throw TypeError('listener must be a function');
    if (!this._events || !this._events[type]) return this;
    list = this._events[type];
    length = list.length;
    position = -1;
    if (list === listener || $68f47069226118a5$var$isFunction(list.listener) && list.listener === listener) {
        delete this._events[type];
        if (this._events.removeListener) this.emit('removeListener', type, listener);
    } else if ($68f47069226118a5$var$isObject(list)) {
        for(i = length; i-- > 0;)if (list[i] === listener || list[i].listener && list[i].listener === listener) {
            position = i;
            break;
        }
        if (position < 0) return this;
        if (list.length === 1) {
            list.length = 0;
            delete this._events[type];
        } else list.splice(position, 1);
        if (this._events.removeListener) this.emit('removeListener', type, listener);
    }
    return this;
};
$68f47069226118a5$var$EventEmitter.prototype.removeAllListeners = function(type) {
    var key, listeners;
    if (!this._events) return this;
    // not listening for removeListener, no need to emit
    if (!this._events.removeListener) {
        if (arguments.length === 0) this._events = {};
        else if (this._events[type]) delete this._events[type];
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        for(key in this._events){
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = {};
        return this;
    }
    listeners = this._events[type];
    if ($68f47069226118a5$var$isFunction(listeners)) this.removeListener(type, listeners);
    else if (listeners) // LIFO order
    while(listeners.length)this.removeListener(type, listeners[listeners.length - 1]);
    delete this._events[type];
    return this;
};
$68f47069226118a5$var$EventEmitter.prototype.listeners = function(type) {
    var ret;
    if (!this._events || !this._events[type]) ret = [];
    else if ($68f47069226118a5$var$isFunction(this._events[type])) ret = [
        this._events[type]
    ];
    else ret = this._events[type].slice();
    return ret;
};
$68f47069226118a5$var$EventEmitter.prototype.listenerCount = function(type) {
    if (this._events) {
        var evlistener = this._events[type];
        if ($68f47069226118a5$var$isFunction(evlistener)) return 1;
        else if (evlistener) return evlistener.length;
    }
    return 0;
};
$68f47069226118a5$var$EventEmitter.listenerCount = function(emitter, type) {
    return emitter.listenerCount(type);
};
function $68f47069226118a5$var$isFunction(arg) {
    return typeof arg === 'function';
}
function $68f47069226118a5$var$isNumber(arg) {
    return typeof arg === 'number';
}
function $68f47069226118a5$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
function $68f47069226118a5$var$isUndefined(arg) {
    return arg === void 0;
}

});

parcelRegister("9SPXt", function(module, exports) {
'use strict';

var $90FFK = parcelRequire("90FFK");

var $gVBvC = parcelRequire("gVBvC");
/**
 * A DerivedHelper is a way to create sub requests to
 * Algolia from a main helper.
 * @class
 * @classdesc The DerivedHelper provides an event based interface for search callbacks:
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 * @param {AlgoliaSearchHelper} mainHelper the main helper
 * @param {function} fn the function to create the derived state
 */ function $7321760683955e1d$var$DerivedHelper(mainHelper, fn) {
    this.main = mainHelper;
    this.fn = fn;
    this.lastResults = null;
}
$gVBvC($7321760683955e1d$var$DerivedHelper, $90FFK);
/**
 * Detach this helper from the main helper
 * @return {undefined}
 * @throws Error if the derived helper is already detached
 */ $7321760683955e1d$var$DerivedHelper.prototype.detach = function() {
    this.removeAllListeners();
    this.main.detachDerivedHelper(this);
};
$7321760683955e1d$var$DerivedHelper.prototype.getModifiedState = function(parameters) {
    return this.fn(parameters);
};
module.exports = $7321760683955e1d$var$DerivedHelper;

});
parcelRegister("gVBvC", function(module, exports) {
'use strict';
function $c52f10bd4374e9c0$var$inherits(ctor, superCtor) {
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
}
module.exports = $c52f10bd4374e9c0$var$inherits;

});


parcelRegister("iOTWh", function(module, exports) {
'use strict';
/**
 * Replaces a leading - with \-
 * @private
 * @param {any} value the facet value to replace
 * @returns {any} the escaped facet value or the value if it was not a string
 */ function $db3849d6a8baa0a3$var$escapeFacetValue(value) {
    if (typeof value !== 'string') return value;
    return String(value).replace(/^-/, '\\-');
}
/**
 * Replaces a leading \- with -
 * @private
 * @param {any} value the escaped facet value
 * @returns {any} the unescaped facet value or the value if it was not a string
 */ function $db3849d6a8baa0a3$var$unescapeFacetValue(value) {
    if (typeof value !== 'string') return value;
    return value.replace(/^\\-/, '-');
}
module.exports = {
    escapeFacetValue: $db3849d6a8baa0a3$var$escapeFacetValue,
    unescapeFacetValue: $db3849d6a8baa0a3$var$unescapeFacetValue
};

});

parcelRegister("2KSyk", function(module, exports) {
'use strict';
function $201a31a8d237951d$var$clone(value) {
    if (typeof value === 'object' && value !== null) return $201a31a8d237951d$var$_merge(Array.isArray(value) ? [] : {}, value);
    return value;
}
function $201a31a8d237951d$var$isObjectOrArrayOrFunction(value) {
    return typeof value === 'function' || Array.isArray(value) || Object.prototype.toString.call(value) === '[object Object]';
}
function $201a31a8d237951d$var$_merge(target, source) {
    if (target === source) return target;
    // eslint-disable-next-line no-restricted-syntax
    for(var key in source){
        if (!Object.prototype.hasOwnProperty.call(source, key) || key === '__proto__' || key === 'constructor') continue;
        var sourceVal = source[key];
        var targetVal = target[key];
        if (typeof targetVal !== 'undefined' && typeof sourceVal === 'undefined') continue;
        if ($201a31a8d237951d$var$isObjectOrArrayOrFunction(targetVal) && $201a31a8d237951d$var$isObjectOrArrayOrFunction(sourceVal)) target[key] = $201a31a8d237951d$var$_merge(targetVal, sourceVal);
        else target[key] = $201a31a8d237951d$var$clone(sourceVal);
    }
    return target;
}
/**
 * This method is like Object.assign, but recursively merges own and inherited
 * enumerable keyed properties of source objects into the destination object.
 *
 * NOTE: this behaves like lodash/merge, but:
 * - does mutate functions if they are a source
 * - treats non-plain objects as plain
 * - does not work for circular objects
 * - treats sparse arrays as sparse
 * - does not convert Array-like objects (Arguments, NodeLists, etc.) to arrays
 *
 * @param {Object} target The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 */ function $201a31a8d237951d$var$merge(target) {
    if (!$201a31a8d237951d$var$isObjectOrArrayOrFunction(target)) target = {};
    for(var i = 1, l = arguments.length; i < l; i++){
        var source = arguments[i];
        if ($201a31a8d237951d$var$isObjectOrArrayOrFunction(source)) $201a31a8d237951d$var$_merge(target, source);
    }
    return target;
}
module.exports = $201a31a8d237951d$var$merge;

});

parcelRegister("6Wgxo", function(module, exports) {
'use strict';
function $50d4fcde2ec60061$var$objectHasKeys(obj) {
    return obj && Object.keys(obj).length > 0;
}
module.exports = $50d4fcde2ec60061$var$objectHasKeys;

});

parcelRegister("ka9BV", function(module, exports) {
'use strict';
// https://github.com/babel/babel/blob/3aaafae053fa75febb3aa45d45b6f00646e30ba4/packages/babel-helpers/src/helpers.js#L604-L620
function $eadc324ca96c39f3$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source === null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key;
    var i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        // eslint-disable-next-line no-continue
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = $eadc324ca96c39f3$var$_objectWithoutPropertiesLoose;

});

parcelRegister("5BVQk", function(module, exports) {
'use strict';

var $2KSyk = parcelRequire("2KSyk");
function $010de43d4c96dde2$var$sortObject(obj) {
    return Object.keys(obj).sort().reduce(function(acc, curr) {
        acc[curr] = obj[curr];
        return acc;
    }, {});
}
var $010de43d4c96dde2$var$requestBuilder = {
    /**
   * Get all the queries to send to the client, those queries can used directly
   * with the Algolia client.
   * @private
   * @param  {string} index The name of the index
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object[]} The queries
   */ _getQueries: function getQueries(index, state) {
        var queries = [];
        // One query for the hits
        queries.push({
            indexName: index,
            params: $010de43d4c96dde2$var$requestBuilder._getHitsSearchParams(state)
        });
        // One for each disjunctive facets
        state.getRefinedDisjunctiveFacets().forEach(function(refinedFacet) {
            queries.push({
                indexName: index,
                params: $010de43d4c96dde2$var$requestBuilder._getDisjunctiveFacetSearchParams(state, refinedFacet)
            });
        });
        // More to get the parent levels of the hierarchical facets when refined
        state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
            var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
            var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            // If we are deeper than level 0 (starting from `beer > IPA`)
            // we want to get all parent values
            if (currentRefinement.length > 0 && currentRefinement[0].split(separator).length > 1) {
                // We generate a map of the filters we will use for our facet values queries
                var filtersMap = currentRefinement[0].split(separator).slice(0, -1).reduce(function createFiltersMap(map, segment, level) {
                    return map.concat({
                        attribute: hierarchicalFacet.attributes[level],
                        value: level === 0 ? segment : [
                            map[map.length - 1].value,
                            segment
                        ].join(separator)
                    });
                }, []);
                filtersMap.forEach(function(filter, level) {
                    var params = $010de43d4c96dde2$var$requestBuilder._getDisjunctiveFacetSearchParams(state, filter.attribute, level === 0);
                    // Keep facet filters unrelated to current hierarchical attributes
                    function hasHierarchicalFacetFilter(value) {
                        return hierarchicalFacet.attributes.some(function(attribute) {
                            return attribute === value.split(':')[0];
                        });
                    }
                    var filteredFacetFilters = (params.facetFilters || []).reduce(function(acc, facetFilter) {
                        if (Array.isArray(facetFilter)) {
                            var filtered = facetFilter.filter(function(filterValue) {
                                return !hasHierarchicalFacetFilter(filterValue);
                            });
                            if (filtered.length > 0) acc.push(filtered);
                        }
                        if (typeof facetFilter === 'string' && !hasHierarchicalFacetFilter(facetFilter)) acc.push(facetFilter);
                        return acc;
                    }, []);
                    var parent = filtersMap[level - 1];
                    if (level > 0) params.facetFilters = filteredFacetFilters.concat(parent.attribute + ':' + parent.value);
                    else params.facetFilters = filteredFacetFilters.length > 0 ? filteredFacetFilters : undefined;
                    queries.push({
                        indexName: index,
                        params: params
                    });
                });
            }
        });
        return queries;
    },
    /**
   * Build search parameters used to fetch hits
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object.<string, any>} The search parameters for hits
   */ _getHitsSearchParams: function(state) {
        var facets = state.facets.concat(state.disjunctiveFacets).concat($010de43d4c96dde2$var$requestBuilder._getHitsHierarchicalFacetsAttributes(state)).sort();
        var facetFilters = $010de43d4c96dde2$var$requestBuilder._getFacetFilters(state);
        var numericFilters = $010de43d4c96dde2$var$requestBuilder._getNumericFilters(state);
        var tagFilters = $010de43d4c96dde2$var$requestBuilder._getTagFilters(state);
        var additionalParams = {
            facets: facets.indexOf('*') > -1 ? [
                '*'
            ] : facets,
            tagFilters: tagFilters
        };
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        return $010de43d4c96dde2$var$sortObject($2KSyk({}, state.getQueryParams(), additionalParams));
    },
    /**
   * Build search parameters used to fetch a disjunctive facet
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @param  {string} facet the associated facet name
   * @param  {boolean} hierarchicalRootLevel ?? FIXME
   * @return {object} The search parameters for a disjunctive facet
   */ _getDisjunctiveFacetSearchParams: function(state, facet, hierarchicalRootLevel) {
        var facetFilters = $010de43d4c96dde2$var$requestBuilder._getFacetFilters(state, facet, hierarchicalRootLevel);
        var numericFilters = $010de43d4c96dde2$var$requestBuilder._getNumericFilters(state, facet);
        var tagFilters = $010de43d4c96dde2$var$requestBuilder._getTagFilters(state);
        var additionalParams = {
            hitsPerPage: 0,
            page: 0,
            analytics: false,
            clickAnalytics: false
        };
        if (tagFilters.length > 0) additionalParams.tagFilters = tagFilters;
        var hierarchicalFacet = state.getHierarchicalFacetByName(facet);
        if (hierarchicalFacet) additionalParams.facets = $010de43d4c96dde2$var$requestBuilder._getDisjunctiveHierarchicalFacetAttribute(state, hierarchicalFacet, hierarchicalRootLevel);
        else additionalParams.facets = facet;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        return $010de43d4c96dde2$var$sortObject($2KSyk({}, state.getQueryParams(), additionalParams));
    },
    /**
   * Return the numeric filters in an algolia request fashion
   * @private
   * @param {SearchParameters} state the state from which to get the filters
   * @param {string} [facetName] the name of the attribute for which the filters should be excluded
   * @return {string[]} the numeric filters in the algolia format
   */ _getNumericFilters: function(state, facetName) {
        if (state.numericFilters) return state.numericFilters;
        var numericFilters = [];
        Object.keys(state.numericRefinements).forEach(function(attribute) {
            var operators = state.numericRefinements[attribute] || {};
            Object.keys(operators).forEach(function(operator) {
                var values = operators[operator] || [];
                if (facetName !== attribute) values.forEach(function(value) {
                    if (Array.isArray(value)) {
                        var vs = value.map(function(v) {
                            return attribute + operator + v;
                        });
                        numericFilters.push(vs);
                    } else numericFilters.push(attribute + operator + value);
                });
            });
        });
        return numericFilters;
    },
    /**
   * Return the tags filters depending on which format is used, either tagFilters or tagRefinements
   * @private
   * @param {SearchParameters} state the state from which to get the filters
   * @return {string} Tag filters in a single string
   */ _getTagFilters: function(state) {
        if (state.tagFilters) return state.tagFilters;
        return state.tagRefinements.join(',');
    },
    /**
   * Build facetFilters parameter based on current refinements. The array returned
   * contains strings representing the facet filters in the algolia format.
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @param  {string} [facet] if set, the current disjunctive facet
   * @param  {boolean} [hierarchicalRootLevel] ?? FIXME
   * @return {array.<string>} The facet filters in the algolia format
   */ _getFacetFilters: function(state, facet, hierarchicalRootLevel) {
        var facetFilters = [];
        var facetsRefinements = state.facetsRefinements || {};
        Object.keys(facetsRefinements).sort().forEach(function(facetName) {
            var facetValues = facetsRefinements[facetName] || [];
            facetValues.sort().forEach(function(facetValue) {
                facetFilters.push(facetName + ':' + facetValue);
            });
        });
        var facetsExcludes = state.facetsExcludes || {};
        Object.keys(facetsExcludes).sort().forEach(function(facetName) {
            var facetValues = facetsExcludes[facetName] || [];
            facetValues.sort().forEach(function(facetValue) {
                facetFilters.push(facetName + ':-' + facetValue);
            });
        });
        var disjunctiveFacetsRefinements = state.disjunctiveFacetsRefinements || {};
        Object.keys(disjunctiveFacetsRefinements).sort().forEach(function(facetName) {
            var facetValues = disjunctiveFacetsRefinements[facetName] || [];
            if (facetName === facet || !facetValues || facetValues.length === 0) return;
            var orFilters = [];
            facetValues.sort().forEach(function(facetValue) {
                orFilters.push(facetName + ':' + facetValue);
            });
            facetFilters.push(orFilters);
        });
        var hierarchicalFacetsRefinements = state.hierarchicalFacetsRefinements || {};
        Object.keys(hierarchicalFacetsRefinements).sort().forEach(function(facetName) {
            var facetValues = hierarchicalFacetsRefinements[facetName] || [];
            var facetValue = facetValues[0];
            if (facetValue === undefined) return;
            var hierarchicalFacet = state.getHierarchicalFacetByName(facetName);
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
            var attributeToRefine;
            var attributesIndex;
            // we ask for parent facet values only when the `facet` is the current hierarchical facet
            if (facet === facetName) {
                // if we are at the root level already, no need to ask for facet values, we get them from
                // the hits query
                if (facetValue.indexOf(separator) === -1 || !rootPath && hierarchicalRootLevel === true || rootPath && rootPath.split(separator).length === facetValue.split(separator).length) return;
                if (!rootPath) {
                    attributesIndex = facetValue.split(separator).length - 2;
                    facetValue = facetValue.slice(0, facetValue.lastIndexOf(separator));
                } else {
                    attributesIndex = rootPath.split(separator).length - 1;
                    facetValue = rootPath;
                }
                attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
            } else {
                attributesIndex = facetValue.split(separator).length - 1;
                attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
            }
            if (attributeToRefine) facetFilters.push([
                attributeToRefine + ':' + facetValue
            ]);
        });
        return facetFilters;
    },
    _getHitsHierarchicalFacetsAttributes: function(state) {
        var out = [];
        return state.hierarchicalFacets.reduce(// ask for as much levels as there's hierarchical refinements
        function getHitsAttributesForHierarchicalFacet(allAttributes, hierarchicalFacet) {
            var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0];
            // if no refinement, ask for root level
            if (!hierarchicalRefinement) {
                allAttributes.push(hierarchicalFacet.attributes[0]);
                return allAttributes;
            }
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            var level = hierarchicalRefinement.split(separator).length;
            var newAttributes = hierarchicalFacet.attributes.slice(0, level + 1);
            return allAttributes.concat(newAttributes);
        }, out);
    },
    _getDisjunctiveHierarchicalFacetAttribute: function(state, hierarchicalFacet, rootLevel) {
        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        if (rootLevel === true) {
            var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
            var attributeIndex = 0;
            if (rootPath) attributeIndex = rootPath.split(separator).length;
            return [
                hierarchicalFacet.attributes[attributeIndex]
            ];
        }
        var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0] || '';
        // if refinement is 'beers > IPA > Flying dog',
        // then we want `facets: ['beers > IPA']` as disjunctive facet (parent level values)
        var parentLevel = hierarchicalRefinement.split(separator).length - 1;
        return hierarchicalFacet.attributes.slice(0, parentLevel + 1);
    },
    getSearchForFacetQuery: function(facetName, query, maxFacetHits, state) {
        var stateForSearchForFacetValues = state.isDisjunctiveFacet(facetName) ? state.clearRefinements(facetName) : state;
        var searchForFacetSearchParameters = {
            facetQuery: query,
            facetName: facetName
        };
        if (typeof maxFacetHits === 'number') searchForFacetSearchParameters.maxFacetHits = maxFacetHits;
        return $010de43d4c96dde2$var$sortObject($2KSyk({}, $010de43d4c96dde2$var$requestBuilder._getHitsSearchParams(stateForSearchForFacetValues), searchForFacetSearchParameters));
    }
};
module.exports = $010de43d4c96dde2$var$requestBuilder;

});

parcelRegister("ltsLR", function(module, exports) {
'use strict';

var $kee8o = parcelRequire("kee8o");

var $5B6z1 = parcelRequire("5B6z1");

var $7t031 = parcelRequire("7t031");

var $2KSyk = parcelRequire("2KSyk");

var $6Wgxo = parcelRequire("6Wgxo");

var $ka9BV = parcelRequire("ka9BV");

var $b5TIZ = parcelRequire("b5TIZ");

var $1dEVb = parcelRequire("1dEVb");

var $gRx5R = parcelRequire("gRx5R");
/**
 * isEqual, but only for numeric refinement values, possible values:
 * - 5
 * - [5]
 * - [[5]]
 * - [[5,5],[4]]
 * @param {any} a numeric refinement value
 * @param {any} b numeric refinement value
 * @return {boolean} true if the values are equal
 */ function $fa229fb6834531c7$var$isEqualNumericRefinement(a, b) {
    if (Array.isArray(a) && Array.isArray(b)) return a.length === b.length && a.every(function(el, i) {
        return $fa229fb6834531c7$var$isEqualNumericRefinement(b[i], el);
    });
    return a === b;
}
/**
 * like _.find but using deep equality to be able to use it
 * to find arrays.
 * @private
 * @param {any[]} array array to search into (elements are base or array of base)
 * @param {any} searchedValue the value we're looking for (base or array of base)
 * @return {any} the searched value or undefined
 */ function $fa229fb6834531c7$var$findArray(array, searchedValue) {
    return $5B6z1(array, function(currentValue) {
        return $fa229fb6834531c7$var$isEqualNumericRefinement(currentValue, searchedValue);
    });
}
/**
 * The facet list is the structure used to store the list of values used to
 * filter a single attribute.
 * @typedef {string[]} SearchParameters.FacetList
 */ /**
 * Structure to store numeric filters with the operator as the key. The supported operators
 * are `=`, `>`, `<`, `>=`, `<=` and `!=`.
 * @typedef {Object.<string, Array.<number|number[]>>} SearchParameters.OperatorList
 */ /**
 * SearchParameters is the data structure that contains all the information
 * usable for making a search to Algolia API. It doesn't do the search itself,
 * nor does it contains logic about the parameters.
 * It is an immutable object, therefore it has been created in a way that each
 * changes does not change the object itself but returns a copy with the
 * modification.
 * This object should probably not be instantiated outside of the helper. It will
 * be provided when needed. This object is documented for reference as you'll
 * get it from events generated by the {@link AlgoliaSearchHelper}.
 * If need be, instantiate the Helper from the factory function {@link SearchParameters.make}
 * @constructor
 * @classdesc contains all the parameters of a search
 * @param {object|SearchParameters} newParameters existing parameters or partial object
 * for the properties of a new SearchParameters
 * @see SearchParameters.make
 * @example <caption>SearchParameters of the first query in
 *   <a href="http://demos.algolia.com/instant-search-demo/">the instant search demo</a></caption>
{
   "query": "",
   "disjunctiveFacets": [
      "customerReviewCount",
      "category",
      "salePrice_range",
      "manufacturer"
  ],
   "maxValuesPerFacet": 30,
   "page": 0,
   "hitsPerPage": 10,
   "facets": [
      "type",
      "shipping"
  ]
}
 */ function $fa229fb6834531c7$var$SearchParameters(newParameters) {
    var params = newParameters ? $fa229fb6834531c7$var$SearchParameters._parseNumbers(newParameters) : {};
    if (params.userToken !== undefined && !$1dEVb(params.userToken)) // eslint-disable-next-line no-console
    console.warn('[algoliasearch-helper] The `userToken` parameter is invalid. This can lead to wrong analytics.\n  - Format: [a-zA-Z0-9_-]{1,64}');
    /**
   * This attribute contains the list of all the conjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */ this.facets = params.facets || [];
    /**
   * This attribute contains the list of all the disjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */ this.disjunctiveFacets = params.disjunctiveFacets || [];
    /**
   * This attribute contains the list of all the hierarchical facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * Hierarchical facets are a sub type of disjunctive facets that
   * let you filter faceted attributes hierarchically.
   * @member {string[]|object[]}
   */ this.hierarchicalFacets = params.hierarchicalFacets || [];
    // Refinements
    /**
   * This attribute contains all the filters that need to be
   * applied on the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.facetsRefinements = params.facetsRefinements || {};
    /**
   * This attribute contains all the filters that need to be
   * excluded from the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters excluded for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.facetsExcludes = params.facetsExcludes || {};
    /**
   * This attribute contains all the filters that need to be
   * applied on the disjunctive facets. Each facet must be properly
   * defined in the `disjunctiveFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.disjunctiveFacetsRefinements = params.disjunctiveFacetsRefinements || {};
    /**
   * This attribute contains all the filters that need to be
   * applied on the numeric attributes.
   *
   * The key is the name of the attribute, and the value is the
   * filters to apply to this attribute.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `numericFilters` attribute.
   * @member {Object.<string, SearchParameters.OperatorList>}
   */ this.numericRefinements = params.numericRefinements || {};
    /**
   * This attribute contains all the tags used to refine the query.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `tagFilters` attribute.
   * @member {string[]}
   */ this.tagRefinements = params.tagRefinements || [];
    /**
   * This attribute contains all the filters that need to be
   * applied on the hierarchical facets. Each facet must be properly
   * defined in the `hierarchicalFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name. The FacetList values
   * are structured as a string that contain the values for each level
   * separated by the configured separator.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.hierarchicalFacetsRefinements = params.hierarchicalFacetsRefinements || {};
    // eslint-disable-next-line consistent-this
    var self = this;
    Object.keys(params).forEach(function(paramName) {
        var isKeyKnown = $fa229fb6834531c7$var$SearchParameters.PARAMETERS.indexOf(paramName) !== -1;
        var isValueDefined = params[paramName] !== undefined;
        if (!isKeyKnown && isValueDefined) self[paramName] = params[paramName];
    });
}
/**
 * List all the properties in SearchParameters and therefore all the known Algolia properties
 * This doesn't contain any beta/hidden features.
 * @private
 */ $fa229fb6834531c7$var$SearchParameters.PARAMETERS = Object.keys(new $fa229fb6834531c7$var$SearchParameters());
/**
 * @private
 * @param {object} partialState full or part of a state
 * @return {object} a new object with the number keys as number
 */ $fa229fb6834531c7$var$SearchParameters._parseNumbers = function(partialState) {
    // Do not parse numbers again in SearchParameters, they ought to be parsed already
    if (partialState instanceof $fa229fb6834531c7$var$SearchParameters) return partialState;
    var numbers = {};
    var numberKeys = [
        'aroundPrecision',
        'aroundRadius',
        'getRankingInfo',
        'minWordSizefor2Typos',
        'minWordSizefor1Typo',
        'page',
        'maxValuesPerFacet',
        'distinct',
        'minimumAroundRadius',
        'hitsPerPage',
        'minProximity'
    ];
    numberKeys.forEach(function(k) {
        var value = partialState[k];
        if (typeof value === 'string') {
            var parsedValue = parseFloat(value);
            // global isNaN is ok to use here, value is only number or NaN
            numbers[k] = isNaN(parsedValue) ? value : parsedValue;
        }
    });
    // there's two formats of insideBoundingBox, we need to parse
    // the one which is an array of float geo rectangles
    if (Array.isArray(partialState.insideBoundingBox)) numbers.insideBoundingBox = partialState.insideBoundingBox.map(function(geoRect) {
        if (Array.isArray(geoRect)) return geoRect.map(function(value) {
            return parseFloat(value);
        });
        return geoRect;
    });
    if (partialState.numericRefinements) {
        var numericRefinements = {};
        Object.keys(partialState.numericRefinements).forEach(function(attribute) {
            var operators = partialState.numericRefinements[attribute] || {};
            numericRefinements[attribute] = {};
            Object.keys(operators).forEach(function(operator) {
                var values = operators[operator];
                var parsedValues = values.map(function(v) {
                    if (Array.isArray(v)) return v.map(function(vPrime) {
                        if (typeof vPrime === 'string') return parseFloat(vPrime);
                        return vPrime;
                    });
                    else if (typeof v === 'string') return parseFloat(v);
                    return v;
                });
                numericRefinements[attribute][operator] = parsedValues;
            });
        });
        numbers.numericRefinements = numericRefinements;
    }
    return $2KSyk({}, partialState, numbers);
};
/**
 * Factory for SearchParameters
 * @param {object|SearchParameters} newParameters existing parameters or partial
 * object for the properties of a new SearchParameters
 * @return {SearchParameters} frozen instance of SearchParameters
 */ $fa229fb6834531c7$var$SearchParameters.make = function makeSearchParameters(newParameters) {
    var instance = new $fa229fb6834531c7$var$SearchParameters(newParameters);
    var hierarchicalFacets = newParameters.hierarchicalFacets || [];
    hierarchicalFacets.forEach(function(facet) {
        if (facet.rootPath) {
            var currentRefinement = instance.getHierarchicalRefinement(facet.name);
            if (currentRefinement.length > 0 && currentRefinement[0].indexOf(facet.rootPath) !== 0) instance = instance.clearRefinements(facet.name);
            // get it again in case it has been cleared
            currentRefinement = instance.getHierarchicalRefinement(facet.name);
            if (currentRefinement.length === 0) instance = instance.toggleHierarchicalFacetRefinement(facet.name, facet.rootPath);
        }
    });
    return instance;
};
/**
 * Validates the new parameters based on the previous state
 * @param {SearchParameters} currentState the current state
 * @param {object|SearchParameters} parameters the new parameters to set
 * @return {Error|null} Error if the modification is invalid, null otherwise
 */ $fa229fb6834531c7$var$SearchParameters.validate = function(currentState, parameters) {
    var params = parameters || {};
    if (currentState.tagFilters && params.tagRefinements && params.tagRefinements.length > 0) return new Error("[Tags] Cannot switch from the managed tag API to the advanced API. It is probably an error, if it is really what you want, you should first clear the tags with clearTags method.");
    if (currentState.tagRefinements.length > 0 && params.tagFilters) return new Error("[Tags] Cannot switch from the advanced tag API to the managed API. It is probably an error, if it is not, you should first clear the tags with clearTags method.");
    if (currentState.numericFilters && params.numericRefinements && $6Wgxo(params.numericRefinements)) return new Error("[Numeric filters] Can't switch from the advanced to the managed API. It is probably an error, if this is really what you want, you have to first clear the numeric filters.");
    if ($6Wgxo(currentState.numericRefinements) && params.numericFilters) return new Error("[Numeric filters] Can't switch from the managed API to the advanced. It is probably an error, if this is really what you want, you have to first clear the numeric filters.");
    return null;
};
$fa229fb6834531c7$var$SearchParameters.prototype = {
    constructor: $fa229fb6834531c7$var$SearchParameters,
    /**
   * Remove all refinements (disjunctive + conjunctive + excludes + numeric filters)
   * @method
   * @param {undefined|string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {SearchParameters} new instance with filters cleared
   */ clearRefinements: function clearRefinements(attribute) {
        var patch = {
            numericRefinements: this._clearNumericRefinements(attribute),
            facetsRefinements: $gRx5R.clearRefinement(this.facetsRefinements, attribute, 'conjunctiveFacet'),
            facetsExcludes: $gRx5R.clearRefinement(this.facetsExcludes, attribute, 'exclude'),
            disjunctiveFacetsRefinements: $gRx5R.clearRefinement(this.disjunctiveFacetsRefinements, attribute, 'disjunctiveFacet'),
            hierarchicalFacetsRefinements: $gRx5R.clearRefinement(this.hierarchicalFacetsRefinements, attribute, 'hierarchicalFacet')
        };
        if (patch.numericRefinements === this.numericRefinements && patch.facetsRefinements === this.facetsRefinements && patch.facetsExcludes === this.facetsExcludes && patch.disjunctiveFacetsRefinements === this.disjunctiveFacetsRefinements && patch.hierarchicalFacetsRefinements === this.hierarchicalFacetsRefinements) return this;
        return this.setQueryParameters(patch);
    },
    /**
   * Remove all the refined tags from the SearchParameters
   * @method
   * @return {SearchParameters} new instance with tags cleared
   */ clearTags: function clearTags() {
        if (this.tagFilters === undefined && this.tagRefinements.length === 0) return this;
        return this.setQueryParameters({
            tagFilters: undefined,
            tagRefinements: []
        });
    },
    /**
   * Set the index.
   * @method
   * @param {string} index the index name
   * @return {SearchParameters} new instance
   */ setIndex: function setIndex(index) {
        if (index === this.index) return this;
        return this.setQueryParameters({
            index: index
        });
    },
    /**
   * Query setter
   * @method
   * @param {string} newQuery value for the new query
   * @return {SearchParameters} new instance
   */ setQuery: function setQuery(newQuery) {
        if (newQuery === this.query) return this;
        return this.setQueryParameters({
            query: newQuery
        });
    },
    /**
   * Page setter
   * @method
   * @param {number} newPage new page number
   * @return {SearchParameters} new instance
   */ setPage: function setPage(newPage) {
        if (newPage === this.page) return this;
        return this.setQueryParameters({
            page: newPage
        });
    },
    /**
   * Facets setter
   * The facets are the simple facets, used for conjunctive (and) faceting.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for conjunctive faceting
   * @return {SearchParameters} new instance
   */ setFacets: function setFacets(facets) {
        return this.setQueryParameters({
            facets: facets
        });
    },
    /**
   * Disjunctive facets setter
   * Change the list of disjunctive (or) facets the helper chan handle.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for disjunctive faceting
   * @return {SearchParameters} new instance
   */ setDisjunctiveFacets: function setDisjunctiveFacets(facets) {
        return this.setQueryParameters({
            disjunctiveFacets: facets
        });
    },
    /**
   * HitsPerPage setter
   * Hits per page represents the number of hits retrieved for this query
   * @method
   * @param {number} n number of hits retrieved per page of results
   * @return {SearchParameters} new instance
   */ setHitsPerPage: function setHitsPerPage(n) {
        if (this.hitsPerPage === n) return this;
        return this.setQueryParameters({
            hitsPerPage: n
        });
    },
    /**
   * typoTolerance setter
   * Set the value of typoTolerance
   * @method
   * @param {string} typoTolerance new value of typoTolerance ("true", "false", "min" or "strict")
   * @return {SearchParameters} new instance
   */ setTypoTolerance: function setTypoTolerance(typoTolerance) {
        if (this.typoTolerance === typoTolerance) return this;
        return this.setQueryParameters({
            typoTolerance: typoTolerance
        });
    },
    /**
   * Add a numeric filter for a given attribute
   * When value is an array, they are combined with OR
   * When value is a single value, it will combined with AND
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} operator operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number | number[]} value value of the filter
   * @return {SearchParameters} new instance
   * @example
   * // for price = 50 or 40
   * state.addNumericRefinement('price', '=', [50, 40]);
   * @example
   * // for size = 38 and 40
   * state.addNumericRefinement('size', '=', 38);
   * state.addNumericRefinement('size', '=', 40);
   */ addNumericRefinement: function(attribute, operator, value) {
        var val = $b5TIZ(value);
        if (this.isNumericRefined(attribute, operator, val)) return this;
        var mod = $2KSyk({}, this.numericRefinements);
        mod[attribute] = $2KSyk({}, mod[attribute]);
        if (mod[attribute][operator]) {
            // Array copy
            mod[attribute][operator] = mod[attribute][operator].slice();
            // Add the element. Concat can't be used here because value can be an array.
            mod[attribute][operator].push(val);
        } else mod[attribute][operator] = [
            val
        ];
        return this.setQueryParameters({
            numericRefinements: mod
        });
    },
    /**
   * Get the list of conjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getConjunctiveRefinements: function(facetName) {
        if (!this.isConjunctiveFacet(facetName)) return [];
        return this.facetsRefinements[facetName] || [];
    },
    /**
   * Get the list of disjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getDisjunctiveRefinements: function(facetName) {
        if (!this.isDisjunctiveFacet(facetName)) return [];
        return this.disjunctiveFacetsRefinements[facetName] || [];
    },
    /**
   * Get the list of hierarchical refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getHierarchicalRefinement: function(facetName) {
        // we send an array but we currently do not support multiple
        // hierarchicalRefinements for a hierarchicalFacet
        return this.hierarchicalFacetsRefinements[facetName] || [];
    },
    /**
   * Get the list of exclude refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getExcludeRefinements: function(facetName) {
        if (!this.isConjunctiveFacet(facetName)) return [];
        return this.facetsExcludes[facetName] || [];
    },
    /**
   * Remove all the numeric filter for a given (attribute, operator)
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} [operator] operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number} [number] the value to be removed
   * @return {SearchParameters} new instance
   */ removeNumericRefinement: function(attribute, operator, number) {
        var paramValue = number;
        if (paramValue !== undefined) {
            if (!this.isNumericRefined(attribute, operator, paramValue)) return this;
            return this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(value, key) {
                    return key === attribute && value.op === operator && $fa229fb6834531c7$var$isEqualNumericRefinement(value.val, $b5TIZ(paramValue));
                })
            });
        } else if (operator !== undefined) {
            if (!this.isNumericRefined(attribute, operator)) return this;
            return this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(value, key) {
                    return key === attribute && value.op === operator;
                })
            });
        }
        if (!this.isNumericRefined(attribute)) return this;
        return this.setQueryParameters({
            numericRefinements: this._clearNumericRefinements(function(value, key) {
                return key === attribute;
            })
        });
    },
    /**
   * Get the list of numeric refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {SearchParameters.OperatorList} list of refinements
   */ getNumericRefinements: function(facetName) {
        return this.numericRefinements[facetName] || {};
    },
    /**
   * Return the current refinement for the (attribute, operator)
   * @param {string} attribute attribute in the record
   * @param {string} operator operator applied on the refined values
   * @return {Array.<number|number[]>} refined values
   */ getNumericRefinement: function(attribute, operator) {
        return this.numericRefinements[attribute] && this.numericRefinements[attribute][operator];
    },
    /**
   * Clear numeric filters.
   * @method
   * @private
   * @param {string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {Object.<string, OperatorList>} new numeric refinements
   */ _clearNumericRefinements: function _clearNumericRefinements(attribute) {
        if (attribute === undefined) {
            if (!$6Wgxo(this.numericRefinements)) return this.numericRefinements;
            return {};
        } else if (typeof attribute === 'string') return $ka9BV(this.numericRefinements, [
            attribute
        ]);
        else if (typeof attribute === 'function') {
            var hasChanged = false;
            var numericRefinements = this.numericRefinements;
            var newNumericRefinements = Object.keys(numericRefinements).reduce(function(memo, key) {
                var operators = numericRefinements[key];
                var operatorList = {};
                operators = operators || {};
                Object.keys(operators).forEach(function(operator) {
                    var values = operators[operator] || [];
                    var outValues = [];
                    values.forEach(function(value) {
                        var predicateResult = attribute({
                            val: value,
                            op: operator
                        }, key, 'numeric');
                        if (!predicateResult) outValues.push(value);
                    });
                    if (outValues.length !== values.length) hasChanged = true;
                    operatorList[operator] = outValues;
                });
                memo[key] = operatorList;
                return memo;
            }, {});
            if (hasChanged) return newNumericRefinements;
            return this.numericRefinements;
        }
        // We return nothing if the attribute is not undefined, a string or a function,
        // as it is not a valid value for a refinement
        return undefined;
    },
    /**
   * Add a facet to the facets attribute of the helper configuration, if it
   * isn't already present.
   * @method
   * @param {string} facet facet name to add
   * @return {SearchParameters} new instance
   */ addFacet: function addFacet(facet) {
        if (this.isConjunctiveFacet(facet)) return this;
        return this.setQueryParameters({
            facets: this.facets.concat([
                facet
            ])
        });
    },
    /**
   * Add a disjunctive facet to the disjunctiveFacets attribute of the helper
   * configuration, if it isn't already present.
   * @method
   * @param {string} facet disjunctive facet name to add
   * @return {SearchParameters} new instance
   */ addDisjunctiveFacet: function addDisjunctiveFacet(facet) {
        if (this.isDisjunctiveFacet(facet)) return this;
        return this.setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.concat([
                facet
            ])
        });
    },
    /**
   * Add a hierarchical facet to the hierarchicalFacets attribute of the helper
   * configuration.
   * @method
   * @param {object} hierarchicalFacet hierarchical facet to add
   * @return {SearchParameters} new instance
   * @throws will throw an error if a hierarchical facet with the same name was already declared
   */ addHierarchicalFacet: function addHierarchicalFacet(hierarchicalFacet) {
        if (this.isHierarchicalFacet(hierarchicalFacet.name)) throw new Error('Cannot declare two hierarchical facets with the same name: `' + hierarchicalFacet.name + '`');
        return this.setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.concat([
                hierarchicalFacet
            ])
        });
    },
    /**
   * Add a refinement on a "normal" facet
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addFacetRefinement: function addFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        if ($gRx5R.isRefined(this.facetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            facetsRefinements: $gRx5R.addRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Exclude a value from a "normal" facet
   * @method
   * @param {string} facet attribute to apply the exclusion on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addExcludeRefinement: function addExcludeRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        if ($gRx5R.isRefined(this.facetsExcludes, facet, value)) return this;
        return this.setQueryParameters({
            facetsExcludes: $gRx5R.addRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Adds a refinement on a disjunctive facet.
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addDisjunctiveFacetRefinement: function addDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
        if ($gRx5R.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $gRx5R.addRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * addTagRefinement adds a tag to the list used to filter the results
   * @param {string} tag tag to be added
   * @return {SearchParameters} new instance
   */ addTagRefinement: function addTagRefinement(tag) {
        if (this.isTagRefined(tag)) return this;
        var modification = {
            tagRefinements: this.tagRefinements.concat(tag)
        };
        return this.setQueryParameters(modification);
    },
    /**
   * Remove a facet from the facets attribute of the helper configuration, if it
   * is present.
   * @method
   * @param {string} facet facet name to remove
   * @return {SearchParameters} new instance
   */ removeFacet: function removeFacet(facet) {
        if (!this.isConjunctiveFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            facets: this.facets.filter(function(f) {
                return f !== facet;
            })
        });
    },
    /**
   * Remove a disjunctive facet from the disjunctiveFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet disjunctive facet name to remove
   * @return {SearchParameters} new instance
   */ removeDisjunctiveFacet: function removeDisjunctiveFacet(facet) {
        if (!this.isDisjunctiveFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.filter(function(f) {
                return f !== facet;
            })
        });
    },
    /**
   * Remove a hierarchical facet from the hierarchicalFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet hierarchical facet name to remove
   * @return {SearchParameters} new instance
   */ removeHierarchicalFacet: function removeHierarchicalFacet(facet) {
        if (!this.isHierarchicalFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.filter(function(f) {
                return f.name !== facet;
            })
        });
    },
    /**
   * Remove a refinement set on facet. If a value is provided, it will clear the
   * refinement for the given value, otherwise it will clear all the refinement
   * values for the faceted attribute.
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} [value] value used to filter
   * @return {SearchParameters} new instance
   */ removeFacetRefinement: function removeFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        if (!$gRx5R.isRefined(this.facetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            facetsRefinements: $gRx5R.removeRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Remove a negative refinement on a facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters} new instance
   */ removeExcludeRefinement: function removeExcludeRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        if (!$gRx5R.isRefined(this.facetsExcludes, facet, value)) return this;
        return this.setQueryParameters({
            facetsExcludes: $gRx5R.removeRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Remove a refinement on a disjunctive facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters} new instance
   */ removeDisjunctiveFacetRefinement: function removeDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
        if (!$gRx5R.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $gRx5R.removeRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * Remove a tag from the list of tag refinements
   * @method
   * @param {string} tag the tag to remove
   * @return {SearchParameters} new instance
   */ removeTagRefinement: function removeTagRefinement(tag) {
        if (!this.isTagRefined(tag)) return this;
        var modification = {
            tagRefinements: this.tagRefinements.filter(function(t) {
                return t !== tag;
            })
        };
        return this.setQueryParameters(modification);
    },
    /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters} new instance
   * @throws will throw an error if the facet is not declared in the settings of the helper
   * @deprecated since version 2.19.0, see {@link SearchParameters#toggleFacetRefinement}
   */ toggleRefinement: function toggleRefinement(facet, value) {
        return this.toggleFacetRefinement(facet, value);
    },
    /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters} new instance
   * @throws will throw an error if the facet is not declared in the settings of the helper
   */ toggleFacetRefinement: function toggleFacetRefinement(facet, value) {
        if (this.isHierarchicalFacet(facet)) return this.toggleHierarchicalFacetRefinement(facet, value);
        else if (this.isConjunctiveFacet(facet)) return this.toggleConjunctiveFacetRefinement(facet, value);
        else if (this.isDisjunctiveFacet(facet)) return this.toggleDisjunctiveFacetRefinement(facet, value);
        throw new Error('Cannot refine the undeclared facet ' + facet + '; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets');
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleConjunctiveFacetRefinement: function toggleConjunctiveFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        return this.setQueryParameters({
            facetsRefinements: $gRx5R.toggleRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleExcludeFacetRefinement: function toggleExcludeFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        return this.setQueryParameters({
            facetsExcludes: $gRx5R.toggleRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleDisjunctiveFacetRefinement: function toggleDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $gRx5R.toggleRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleHierarchicalFacetRefinement: function toggleHierarchicalFacetRefinement(facet, value) {
        if (!this.isHierarchicalFacet(facet)) throw new Error(facet + ' is not defined in the hierarchicalFacets attribute of the helper configuration');
        var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facet));
        var mod = {};
        var upOneOrMultipleLevel = this.hierarchicalFacetsRefinements[facet] !== undefined && this.hierarchicalFacetsRefinements[facet].length > 0 && // remove current refinement:
        // refinement was 'beer > IPA', call is toggleRefine('beer > IPA'), refinement should be `beer`
        (this.hierarchicalFacetsRefinements[facet][0] === value || // remove a parent refinement of the current refinement:
        //  - refinement was 'beer > IPA > Flying dog'
        //  - call is toggleRefine('beer > IPA')
        //  - refinement should be `beer`
        this.hierarchicalFacetsRefinements[facet][0].indexOf(value + separator) === 0);
        if (upOneOrMultipleLevel) {
            if (value.indexOf(separator) === -1) // go back to root level
            mod[facet] = [];
            else mod[facet] = [
                value.slice(0, value.lastIndexOf(separator))
            ];
        } else mod[facet] = [
            value
        ];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $kee8o({}, mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Adds a refinement on a hierarchical facet.
   * @param {string} facet the facet name
   * @param {string} path the hierarchical facet path
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is refined
   */ addHierarchicalFacetRefinement: function(facet, path) {
        if (this.isHierarchicalFacetRefined(facet)) throw new Error(facet + ' is already refined.');
        if (!this.isHierarchicalFacet(facet)) throw new Error(facet + ' is not defined in the hierarchicalFacets attribute of the helper configuration.');
        var mod = {};
        mod[facet] = [
            path
        ];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $kee8o({}, mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Removes the refinement set on a hierarchical facet.
   * @param {string} facet the facet name
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is not refined
   */ removeHierarchicalFacetRefinement: function(facet) {
        if (!this.isHierarchicalFacetRefined(facet)) return this;
        var mod = {};
        mod[facet] = [];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $kee8o({}, mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Switch the tag refinement
   * @method
   * @param {string} tag the tag to remove or add
   * @return {SearchParameters} new instance
   */ toggleTagRefinement: function toggleTagRefinement(tag) {
        if (this.isTagRefined(tag)) return this.removeTagRefinement(tag);
        return this.addTagRefinement(tag);
    },
    /**
   * Test if the facet name is from one of the disjunctive facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean} true if facet is a disjunctive facet
   */ isDisjunctiveFacet: function(facet) {
        return this.disjunctiveFacets.indexOf(facet) > -1;
    },
    /**
   * Test if the facet name is from one of the hierarchical facets
   * @method
   * @param {string} facetName facet name to test
   * @return {boolean} true if facetName is a hierarchical facet
   */ isHierarchicalFacet: function(facetName) {
        return this.getHierarchicalFacetByName(facetName) !== undefined;
    },
    /**
   * Test if the facet name is from one of the conjunctive/normal facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean} true if facet is a conjunctive facet
   */ isConjunctiveFacet: function(facet) {
        return this.facets.indexOf(facet) > -1;
    },
    /**
   * Returns true if the facet is refined, either for a specific value or in
   * general.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value, optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */ isFacetRefined: function isFacetRefined(facet, value) {
        if (!this.isConjunctiveFacet(facet)) return false;
        return $gRx5R.isRefined(this.facetsRefinements, facet, value);
    },
    /**
   * Returns true if the facet contains exclusions or if a specific value is
   * excluded.
   *
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} [value] optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */ isExcludeRefined: function isExcludeRefined(facet, value) {
        if (!this.isConjunctiveFacet(facet)) return false;
        return $gRx5R.isRefined(this.facetsExcludes, facet, value);
    },
    /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean} true if the facet is refined
   */ isDisjunctiveFacetRefined: function isDisjunctiveFacetRefined(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) return false;
        return $gRx5R.isRefined(this.disjunctiveFacetsRefinements, facet, value);
    },
    /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean} true if the facet is refined
   */ isHierarchicalFacetRefined: function isHierarchicalFacetRefined(facet, value) {
        if (!this.isHierarchicalFacet(facet)) return false;
        var refinements = this.getHierarchicalRefinement(facet);
        if (!value) return refinements.length > 0;
        return refinements.indexOf(value) !== -1;
    },
    /**
   * Test if the triple (attribute, operator, value) is already refined.
   * If only the attribute and the operator are provided, it tests if the
   * contains any refinement value.
   * @method
   * @param {string} attribute attribute for which the refinement is applied
   * @param {string} [operator] operator of the refinement
   * @param {string} [value] value of the refinement
   * @return {boolean} true if it is refined
   */ isNumericRefined: function isNumericRefined(attribute, operator, value) {
        if (value === undefined && operator === undefined) return Boolean(this.numericRefinements[attribute]);
        var isOperatorDefined = this.numericRefinements[attribute] && this.numericRefinements[attribute][operator] !== undefined;
        if (value === undefined || !isOperatorDefined) return isOperatorDefined;
        var parsedValue = $b5TIZ(value);
        var isAttributeValueDefined = $fa229fb6834531c7$var$findArray(this.numericRefinements[attribute][operator], parsedValue) !== undefined;
        return isOperatorDefined && isAttributeValueDefined;
    },
    /**
   * Returns true if the tag refined, false otherwise
   * @method
   * @param {string} tag the tag to check
   * @return {boolean} true if tag is refined
   */ isTagRefined: function isTagRefined(tag) {
        return this.tagRefinements.indexOf(tag) !== -1;
    },
    /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]} returns the list of refinements
   */ getRefinedDisjunctiveFacets: function getRefinedDisjunctiveFacets() {
        // eslint-disable-next-line consistent-this
        var self = this;
        // attributes used for numeric filter can also be disjunctive
        var disjunctiveNumericRefinedFacets = $7t031(Object.keys(this.numericRefinements).filter(function(facet) {
            return Object.keys(self.numericRefinements[facet]).length > 0;
        }), this.disjunctiveFacets);
        return Object.keys(this.disjunctiveFacetsRefinements).filter(function(facet) {
            return self.disjunctiveFacetsRefinements[facet].length > 0;
        }).concat(disjunctiveNumericRefinedFacets).concat(this.getRefinedHierarchicalFacets()).sort();
    },
    /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]} returns the list of refinements
   */ getRefinedHierarchicalFacets: function getRefinedHierarchicalFacets() {
        // eslint-disable-next-line consistent-this
        var self = this;
        return $7t031(// enforce the order between the two arrays,
        // so that refinement name index === hierarchical facet index
        this.hierarchicalFacets.map(function(facet) {
            return facet.name;
        }), Object.keys(this.hierarchicalFacetsRefinements).filter(function(facet) {
            return self.hierarchicalFacetsRefinements[facet].length > 0;
        })).sort();
    },
    /**
   * Returned the list of all disjunctive facets not refined
   * @method
   * @return {string[]} returns the list of facets that are not refined
   */ getUnrefinedDisjunctiveFacets: function() {
        var refinedFacets = this.getRefinedDisjunctiveFacets();
        return this.disjunctiveFacets.filter(function(f) {
            return refinedFacets.indexOf(f) === -1;
        });
    },
    managedParameters: [
        'index',
        'facets',
        'disjunctiveFacets',
        'facetsRefinements',
        'hierarchicalFacets',
        'facetsExcludes',
        'disjunctiveFacetsRefinements',
        'numericRefinements',
        'tagRefinements',
        'hierarchicalFacetsRefinements'
    ],
    getQueryParams: function getQueryParams() {
        var managedParameters = this.managedParameters;
        var queryParams = {};
        // eslint-disable-next-line consistent-this
        var self = this;
        Object.keys(this).forEach(function(paramName) {
            var paramValue = self[paramName];
            if (managedParameters.indexOf(paramName) === -1 && paramValue !== undefined) queryParams[paramName] = paramValue;
        });
        return queryParams;
    },
    /**
   * Let the user set a specific value for a given parameter. Will return the
   * same instance if the parameter is invalid or if the value is the same as the
   * previous one.
   * @method
   * @param {string} parameter the parameter name
   * @param {any} value the value to be set, must be compliant with the definition
   * of the attribute on the object
   * @return {SearchParameters} the updated state
   */ setQueryParameter: function setParameter(parameter, value) {
        if (this[parameter] === value) return this;
        var modification = {};
        modification[parameter] = value;
        return this.setQueryParameters(modification);
    },
    /**
   * Let the user set any of the parameters with a plain object.
   * @method
   * @param {object} params all the keys and the values to be updated
   * @return {SearchParameters} a new updated instance
   */ setQueryParameters: function setQueryParameters(params) {
        if (!params) return this;
        var error = $fa229fb6834531c7$var$SearchParameters.validate(this, params);
        if (error) throw error;
        // eslint-disable-next-line consistent-this
        var self = this;
        var nextWithNumbers = $fa229fb6834531c7$var$SearchParameters._parseNumbers(params);
        var previousPlainObject = Object.keys(this).reduce(function(acc, key) {
            acc[key] = self[key];
            return acc;
        }, {});
        var nextPlainObject = Object.keys(nextWithNumbers).reduce(function(previous, key) {
            var isPreviousValueDefined = previous[key] !== undefined;
            var isNextValueDefined = nextWithNumbers[key] !== undefined;
            if (isPreviousValueDefined && !isNextValueDefined) return $ka9BV(previous, [
                key
            ]);
            if (isNextValueDefined) previous[key] = nextWithNumbers[key];
            return previous;
        }, previousPlainObject);
        return new this.constructor(nextPlainObject);
    },
    /**
   * Returns a new instance with the page reset. Two scenarios possible:
   * the page is omitted -> return the given instance
   * the page is set -> return a new instance with a page of 0
   * @return {SearchParameters} a new updated instance
   */ resetPage: function() {
        if (this.page === undefined) return this;
        return this.setPage(0);
    },
    /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */ _getHierarchicalFacetSortBy: function(hierarchicalFacet) {
        return hierarchicalFacet.sortBy || [
            'isRefined:desc',
            'name:asc'
        ];
    },
    /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */ _getHierarchicalFacetSeparator: function(hierarchicalFacet) {
        return hierarchicalFacet.separator || ' > ';
    },
    /**
   * Helper function to get the hierarchicalFacet prefix path or null
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.rootPath or null as default
   */ _getHierarchicalRootPath: function(hierarchicalFacet) {
        return hierarchicalFacet.rootPath || null;
    },
    /**
   * Helper function to check if we show the parent level of the hierarchicalFacet
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.showParentLevel or true as default
   */ _getHierarchicalShowParentLevel: function(hierarchicalFacet) {
        if (typeof hierarchicalFacet.showParentLevel === 'boolean') return hierarchicalFacet.showParentLevel;
        return true;
    },
    /**
   * Helper function to get the hierarchicalFacet by it's name
   * @param  {string} hierarchicalFacetName the hierarchicalFacet name
   * @return {object} a hierarchicalFacet
   */ getHierarchicalFacetByName: function(hierarchicalFacetName) {
        return $5B6z1(this.hierarchicalFacets, function(f) {
            return f.name === hierarchicalFacetName;
        });
    },
    /**
   * Get the current breadcrumb for a hierarchical facet, as an array
   * @param  {string} facetName Hierarchical facet name
   * @return {array.<string>} the path as an array of string
   */ getHierarchicalFacetBreadcrumb: function(facetName) {
        if (!this.isHierarchicalFacet(facetName)) return [];
        var refinement = this.getHierarchicalRefinement(facetName)[0];
        if (!refinement) return [];
        var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facetName));
        var path = refinement.split(separator);
        return path.map(function(part) {
            return part.trim();
        });
    },
    toString: function() {
        return JSON.stringify(this, null, 2);
    }
};
/**
 * Callback used for clearRefinement method
 * @callback SearchParameters.clearCallback
 * @param {OperatorList|FacetList} value the value of the filter
 * @param {string} key the current attribute name
 * @param {string} type `numeric`, `disjunctiveFacet`, `conjunctiveFacet`, `hierarchicalFacet` or `exclude`
 * depending on the type of facet
 * @return {boolean} `true` if the element should be removed. `false` otherwise.
 */ module.exports = $fa229fb6834531c7$var$SearchParameters;

});
parcelRegister("kee8o", function(module, exports) {
'use strict';
// NOTE: this behaves like lodash/defaults, but doesn't mutate the target
// it also preserve keys order
module.exports = function defaultsPure() {
    var sources = Array.prototype.slice.call(arguments);
    return sources.reduceRight(function(acc, source) {
        Object.keys(Object(source)).forEach(function(key) {
            if (source[key] === undefined) return;
            if (acc[key] !== undefined) // remove if already added, so that we can add it in correct order
            delete acc[key];
            acc[key] = source[key];
        });
        return acc;
    }, {});
};

});

parcelRegister("5B6z1", function(module, exports) {
'use strict';
// @MAJOR can be replaced by native Array#find when we change support
module.exports = function find(array, comparator) {
    if (!Array.isArray(array)) return undefined;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return array[i];
    }
    return undefined;
};

});

parcelRegister("7t031", function(module, exports) {
'use strict';
function $56fb47540a73f032$var$intersection(arr1, arr2) {
    return arr1.filter(function(value, index) {
        return arr2.indexOf(value) > -1 && arr1.indexOf(value) === index /* skips duplicates */ ;
    });
}
module.exports = $56fb47540a73f032$var$intersection;

});

parcelRegister("b5TIZ", function(module, exports) {
'use strict';
function $813b63199a18d078$var$valToNumber(v) {
    if (typeof v === 'number') return v;
    else if (typeof v === 'string') return parseFloat(v);
    else if (Array.isArray(v)) return v.map($813b63199a18d078$var$valToNumber);
    throw new Error('The value should be a number, a parsable string or an array of those.');
}
module.exports = $813b63199a18d078$var$valToNumber;

});

parcelRegister("1dEVb", function(module, exports) {
'use strict';
module.exports = function isValidUserToken(userToken) {
    if (userToken === null) return false;
    return /^[a-zA-Z0-9_-]{1,64}$/.test(userToken);
};

});

parcelRegister("gRx5R", function(module, exports) {
'use strict';

var $kee8o = parcelRequire("kee8o");

var $6Wgxo = parcelRequire("6Wgxo");

var $ka9BV = parcelRequire("ka9BV");
var $c46b4446075c5ddd$var$lib = {
    /**
   * Adds a refinement to a RefinementList
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement, if the value is not a string it will be converted
   * @return {RefinementList} a new and updated refinement list
   */ addRefinement: function addRefinement(refinementList, attribute, value) {
        if ($c46b4446075c5ddd$var$lib.isRefined(refinementList, attribute, value)) return refinementList;
        var valueAsString = '' + value;
        var facetRefinement = !refinementList[attribute] ? [
            valueAsString
        ] : refinementList[attribute].concat(valueAsString);
        var mod = {};
        mod[attribute] = facetRefinement;
        return $kee8o({}, mod, refinementList);
    },
    /**
   * Removes refinement(s) for an attribute:
   *  - if the value is specified removes the refinement for the value on the attribute
   *  - if no value is specified removes all the refinements for this attribute
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} [value] the value of the refinement
   * @return {RefinementList} a new and updated refinement lst
   */ removeRefinement: function removeRefinement(refinementList, attribute, value) {
        if (value === undefined) // we use the "filter" form of clearRefinement, since it leaves empty values as-is
        // the form with a string will remove the attribute completely
        return $c46b4446075c5ddd$var$lib.clearRefinement(refinementList, function(v, f) {
            return attribute === f;
        });
        var valueAsString = '' + value;
        return $c46b4446075c5ddd$var$lib.clearRefinement(refinementList, function(v, f) {
            return attribute === f && valueAsString === v;
        });
    },
    /**
   * Toggles the refinement value for an attribute.
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement
   * @return {RefinementList} a new and updated list
   */ toggleRefinement: function toggleRefinement(refinementList, attribute, value) {
        if (value === undefined) throw new Error('toggleRefinement should be used with a value');
        if ($c46b4446075c5ddd$var$lib.isRefined(refinementList, attribute, value)) return $c46b4446075c5ddd$var$lib.removeRefinement(refinementList, attribute, value);
        return $c46b4446075c5ddd$var$lib.addRefinement(refinementList, attribute, value);
    },
    /**
   * Clear all or parts of a RefinementList. Depending on the arguments, three
   * kinds of behavior can happen:
   *  - if no attribute is provided: clears the whole list
   *  - if an attribute is provided as a string: clears the list for the specific attribute
   *  - if an attribute is provided as a function: discards the elements for which the function returns true
   * @param {RefinementList} refinementList the initial list
   * @param {string} [attribute] the attribute or function to discard
   * @param {string} [refinementType] optional parameter to give more context to the attribute function
   * @return {RefinementList} a new and updated refinement list
   */ clearRefinement: function clearRefinement(refinementList, attribute, refinementType) {
        if (attribute === undefined) {
            // return the same object if the list is already empty
            // this is mainly for tests, as it doesn't have much impact on performance
            if (!$6Wgxo(refinementList)) return refinementList;
            return {};
        } else if (typeof attribute === 'string') return $ka9BV(refinementList, [
            attribute
        ]);
        else if (typeof attribute === 'function') {
            var hasChanged = false;
            var newRefinementList = Object.keys(refinementList).reduce(function(memo, key) {
                var values = refinementList[key] || [];
                var facetList = values.filter(function(value) {
                    return !attribute(value, key, refinementType);
                });
                if (facetList.length !== values.length) hasChanged = true;
                memo[key] = facetList;
                return memo;
            }, {});
            if (hasChanged) return newRefinementList;
            return refinementList;
        }
        // We return nothing if the attribute is not undefined, a string or a function,
        // as it is not a valid value for a refinement
        return undefined;
    },
    /**
   * Test if the refinement value is used for the attribute. If no refinement value
   * is provided, test if the refinementList contains any refinement for the
   * given attribute.
   * @param {RefinementList} refinementList the list of refinement
   * @param {string} attribute name of the attribute
   * @param {string} [refinementValue] value of the filter/refinement
   * @return {boolean} true if the attribute is refined, false otherwise
   */ isRefined: function isRefined(refinementList, attribute, refinementValue) {
        var containsRefinements = Boolean(refinementList[attribute]) && refinementList[attribute].length > 0;
        if (refinementValue === undefined || !containsRefinements) return containsRefinements;
        var refinementValueAsString = '' + refinementValue;
        return refinementList[attribute].indexOf(refinementValueAsString) !== -1;
    }
};
module.exports = $c46b4446075c5ddd$var$lib;

});


parcelRegister("dBe1E", function(module, exports) {
'use strict';

var $5Y7uW = parcelRequire("5Y7uW");

var $kee8o = parcelRequire("kee8o");

var $iOTWh = parcelRequire("iOTWh");

var $5B6z1 = parcelRequire("5B6z1");

var $7qXEB = parcelRequire("7qXEB");

var $jARvP = parcelRequire("jARvP");

var $2KSyk = parcelRequire("2KSyk");

var $3XDAH = parcelRequire("3XDAH");
var $9e699c47e0c26cf0$var$escapeFacetValue = $iOTWh.escapeFacetValue;
var $9e699c47e0c26cf0$var$unescapeFacetValue = $iOTWh.unescapeFacetValue;

var $9ztro = parcelRequire("9ztro");
/**
 * @typedef SearchResults.Facet
 * @type {object}
 * @property {string} name name of the attribute in the record
 * @property {object} data the faceting data: value, number of entries
 * @property {object} stats undefined unless facet_stats is retrieved from algolia
 */ /**
 * @typedef SearchResults.HierarchicalFacet
 * @type {object}
 * @property {string} name name of the current value given the hierarchical level, trimmed.
 * If root node, you get the facet name
 * @property {number} count number of objects matching this hierarchical value
 * @property {string} path the current hierarchical value full path
 * @property {boolean} isRefined `true` if the current value was refined, `false` otherwise
 * @property {HierarchicalFacet[]} data sub values for the current level
 */ /**
 * @typedef SearchResults.FacetValue
 * @type {object}
 * @property {string} name the facet value itself
 * @property {number} count times this facet appears in the results
 * @property {boolean} isRefined is the facet currently selected
 * @property {boolean} isExcluded is the facet currently excluded (only for conjunctive facets)
 */ /**
 * @typedef Refinement
 * @type {object}
 * @property {string} type the type of filter used:
 * `numeric`, `facet`, `exclude`, `disjunctive`, `hierarchical`
 * @property {string} attributeName name of the attribute used for filtering
 * @property {string} name the value of the filter
 * @property {number} numericValue the value as a number. Only for numeric filters.
 * @property {string} operator the operator used. Only for numeric filters.
 * @property {number} count the number of computed hits for this filter. Only on facets.
 * @property {boolean} exhaustive if the count is exhaustive
 */ /**
 * Turn an array of attributes in an object of attributes with their position in the array as value
 * @param {string[]} attributes the list of attributes in the record
 * @return {object} the list of attributes indexed by attribute name
 */ function $9e699c47e0c26cf0$var$getIndices(attributes) {
    var indices = {};
    attributes.forEach(function(val, idx) {
        indices[val] = idx;
    });
    return indices;
}
function $9e699c47e0c26cf0$var$assignFacetStats(dest, facetStats, key) {
    if (facetStats && facetStats[key]) dest.stats = facetStats[key];
}
/**
 * @typedef {Object} HierarchicalFacet
 * @property {string} name
 * @property {string[]} attributes
 */ /**
 * @param {HierarchicalFacet[]} hierarchicalFacets All hierarchical facets
 * @param {string} hierarchicalAttributeName The name of the hierarchical attribute
 * @return {HierarchicalFacet} The hierarchical facet matching the attribute name
 */ function $9e699c47e0c26cf0$var$findMatchingHierarchicalFacetFromAttributeName(hierarchicalFacets, hierarchicalAttributeName) {
    return $5B6z1(hierarchicalFacets, function facetKeyMatchesAttribute(hierarchicalFacet) {
        var facetNames = hierarchicalFacet.attributes || [];
        return facetNames.indexOf(hierarchicalAttributeName) > -1;
    });
}
// eslint-disable-next-line valid-jsdoc
/**
 * Constructor for SearchResults
 * @class
 * @classdesc SearchResults contains the results of a query to Algolia using the
 * {@link AlgoliaSearchHelper}.
 * @param {SearchParameters} state state that led to the response
 * @param {array.<object>} results the results from algolia client
 * @example <caption>SearchResults of the first query in
 * <a href="http://demos.algolia.com/instant-search-demo">the instant search demo</a></caption>
{
   "hitsPerPage": 10,
   "processingTimeMS": 2,
   "facets": [
      {
         "name": "type",
         "data": {
            "HardGood": 6627,
            "BlackTie": 550,
            "Music": 665,
            "Software": 131,
            "Game": 456,
            "Movie": 1571
         },
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "Free shipping": 5507
         },
         "name": "shipping"
      }
  ],
   "hits": [
      {
         "thumbnailImage": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_54x108_s.gif",
         "_highlightResult": {
            "shortDescription": {
               "matchLevel": "none",
               "value": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
               "matchedWords": []
            },
            "category": {
               "matchLevel": "none",
               "value": "Computer Security Software",
               "matchedWords": []
            },
            "manufacturer": {
               "matchedWords": [],
               "value": "Webroot",
               "matchLevel": "none"
            },
            "name": {
               "value": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
               "matchedWords": [],
               "matchLevel": "none"
            }
         },
         "image": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_105x210_sc.jpg",
         "shipping": "Free shipping",
         "bestSellingRank": 4,
         "shortDescription": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
         "url": "http://www.bestbuy.com/site/webroot-secureanywhere-internet-security-3-devi…d=1219060687969&skuId=1688832&cmp=RMX&ky=2d3GfEmNIzjA0vkzveHdZEBgpPCyMnLTJ",
         "name": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
         "category": "Computer Security Software",
         "salePrice_range": "1 - 50",
         "objectID": "1688832",
         "type": "Software",
         "customerReviewCount": 5980,
         "salePrice": 49.99,
         "manufacturer": "Webroot"
      },
      ....
  ],
   "nbHits": 10000,
   "disjunctiveFacets": [
      {
         "exhaustive": false,
         "data": {
            "5": 183,
            "12": 112,
            "7": 149,
            ...
         },
         "name": "customerReviewCount",
         "stats": {
            "max": 7461,
            "avg": 157.939,
            "min": 1
         }
      },
      {
         "data": {
            "Printer Ink": 142,
            "Wireless Speakers": 60,
            "Point & Shoot Cameras": 48,
            ...
         },
         "name": "category",
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "> 5000": 2,
            "1 - 50": 6524,
            "501 - 2000": 566,
            "201 - 500": 1501,
            "101 - 200": 1360,
            "2001 - 5000": 47
         },
         "name": "salePrice_range"
      },
      {
         "data": {
            "Dynex™": 202,
            "Insignia™": 230,
            "PNY": 72,
            ...
         },
         "name": "manufacturer",
         "exhaustive": false
      }
  ],
   "query": "",
   "nbPages": 100,
   "page": 0,
   "index": "bestbuy"
}
 **/ function $9e699c47e0c26cf0$var$SearchResults(state, results, options) {
    var mainSubResponse = results[0];
    this._rawResults = results;
    // eslint-disable-next-line consistent-this
    var self = this;
    // https://www.algolia.com/doc/api-reference/api-methods/search/#response
    Object.keys(mainSubResponse).forEach(function(key) {
        self[key] = mainSubResponse[key];
    });
    // Make every key of the result options reachable from the instance
    Object.keys(options || {}).forEach(function(key) {
        self[key] = options[key];
    });
    /**
   * query used to generate the results
   * @name query
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * The query as parsed by the engine given all the rules.
   * @name parsedQuery
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * all the records that match the search parameters. Each record is
   * augmented with a new attribute `_highlightResult`
   * which is an object keyed by attribute and with the following properties:
   * - `value` : the value of the facet highlighted (html)
   * - `matchLevel`: `full`, `partial` or `none`, depending on how the query terms match
   * @name hits
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */ /**
   * index where the results come from
   * @name index
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * number of hits per page requested
   * @name hitsPerPage
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * total number of hits of this query on the index
   * @name nbHits
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * total number of pages with respect to the number of hits per page and the total number of hits
   * @name nbPages
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * current page
   * @name page
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * The position if the position was guessed by IP.
   * @name aroundLatLng
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "48.8637,2.3615",
   */ /**
   * The radius computed by Algolia.
   * @name automaticRadius
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "126792922",
   */ /**
   * String identifying the server used to serve this request.
   *
   * getRankingInfo needs to be set to `true` for this to be returned
   *
   * @name serverUsed
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "c7-use-2.algolia.net",
   */ /**
   * Boolean that indicates if the computation of the counts did time out.
   * @deprecated
   * @name timeoutCounts
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * Boolean that indicates if the computation of the hits did time out.
   * @deprecated
   * @name timeoutHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * True if the counts of the facets is exhaustive
   * @name exhaustiveFacetsCount
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * True if the number of hits is exhaustive
   * @name exhaustiveNbHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * Contains the userData if they are set by a [query rule](https://www.algolia.com/doc/guides/query-rules/query-rules-overview/).
   * @name userData
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */ /**
   * queryID is the unique identifier of the query used to generate the current search results.
   * This value is only available if the `clickAnalytics` search parameter is set to `true`.
   * @name queryID
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * sum of the processing time of all the queries
   * @name processingTimeMS
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ this.processingTimeMS = results.reduce(function(sum, result) {
        return result.processingTimeMS === undefined ? sum : sum + result.processingTimeMS;
    }, 0);
    /**
   * disjunctive facets results
   * @member {SearchResults.Facet[]}
   */ this.disjunctiveFacets = [];
    /**
   * disjunctive facets results
   * @member {SearchResults.HierarchicalFacet[]}
   */ this.hierarchicalFacets = state.hierarchicalFacets.map(function initFutureTree() {
        return [];
    });
    /**
   * other facets results
   * @member {SearchResults.Facet[]}
   */ this.facets = [];
    var disjunctiveFacets = state.getRefinedDisjunctiveFacets();
    var facetsIndices = $9e699c47e0c26cf0$var$getIndices(state.facets);
    var disjunctiveFacetsIndices = $9e699c47e0c26cf0$var$getIndices(state.disjunctiveFacets);
    var nextDisjunctiveResult = 1;
    // Since we send request only for disjunctive facets that have been refined,
    // we get the facets information from the first, general, response.
    var mainFacets = mainSubResponse.facets || {};
    Object.keys(mainFacets).forEach(function(facetKey) {
        var facetValueObject = mainFacets[facetKey];
        var hierarchicalFacet = $9e699c47e0c26cf0$var$findMatchingHierarchicalFacetFromAttributeName(state.hierarchicalFacets, facetKey);
        if (hierarchicalFacet) {
            // Place the hierarchicalFacet data at the correct index depending on
            // the attributes order that was defined at the helper initialization
            var facetIndex = hierarchicalFacet.attributes.indexOf(facetKey);
            var idxAttributeName = $7qXEB(state.hierarchicalFacets, function(f) {
                return f.name === hierarchicalFacet.name;
            });
            self.hierarchicalFacets[idxAttributeName][facetIndex] = {
                attribute: facetKey,
                data: facetValueObject,
                exhaustive: mainSubResponse.exhaustiveFacetsCount
            };
        } else {
            var isFacetDisjunctive = state.disjunctiveFacets.indexOf(facetKey) !== -1;
            var isFacetConjunctive = state.facets.indexOf(facetKey) !== -1;
            var position;
            if (isFacetDisjunctive) {
                position = disjunctiveFacetsIndices[facetKey];
                self.disjunctiveFacets[position] = {
                    name: facetKey,
                    data: facetValueObject,
                    exhaustive: mainSubResponse.exhaustiveFacetsCount
                };
                $9e699c47e0c26cf0$var$assignFacetStats(self.disjunctiveFacets[position], mainSubResponse.facets_stats, facetKey);
            }
            if (isFacetConjunctive) {
                position = facetsIndices[facetKey];
                self.facets[position] = {
                    name: facetKey,
                    data: facetValueObject,
                    exhaustive: mainSubResponse.exhaustiveFacetsCount
                };
                $9e699c47e0c26cf0$var$assignFacetStats(self.facets[position], mainSubResponse.facets_stats, facetKey);
            }
        }
    });
    // Make sure we do not keep holes within the hierarchical facets
    this.hierarchicalFacets = $5Y7uW(this.hierarchicalFacets);
    // aggregate the refined disjunctive facets
    disjunctiveFacets.forEach(function(disjunctiveFacet) {
        var result = results[nextDisjunctiveResult];
        var facets = result && result.facets ? result.facets : {};
        var hierarchicalFacet = state.getHierarchicalFacetByName(disjunctiveFacet);
        // There should be only item in facets.
        Object.keys(facets).forEach(function(dfacet) {
            var facetResults = facets[dfacet];
            var position;
            if (hierarchicalFacet) {
                position = $7qXEB(state.hierarchicalFacets, function(f) {
                    return f.name === hierarchicalFacet.name;
                });
                var attributeIndex = $7qXEB(self.hierarchicalFacets[position], function(f) {
                    return f.attribute === dfacet;
                });
                // previous refinements and no results so not able to find it
                if (attributeIndex === -1) return;
                self.hierarchicalFacets[position][attributeIndex].data = $2KSyk({}, self.hierarchicalFacets[position][attributeIndex].data, facetResults);
            } else {
                position = disjunctiveFacetsIndices[dfacet];
                var dataFromMainRequest = mainSubResponse.facets && mainSubResponse.facets[dfacet] || {};
                self.disjunctiveFacets[position] = {
                    name: dfacet,
                    data: $kee8o({}, facetResults, dataFromMainRequest),
                    exhaustive: result.exhaustiveFacetsCount
                };
                $9e699c47e0c26cf0$var$assignFacetStats(self.disjunctiveFacets[position], result.facets_stats, dfacet);
                if (state.disjunctiveFacetsRefinements[dfacet]) state.disjunctiveFacetsRefinements[dfacet].forEach(function(refinementValue) {
                    // add the disjunctive refinements if it is no more retrieved
                    if (!self.disjunctiveFacets[position].data[refinementValue] && state.disjunctiveFacetsRefinements[dfacet].indexOf($9e699c47e0c26cf0$var$unescapeFacetValue(refinementValue)) > -1) self.disjunctiveFacets[position].data[refinementValue] = 0;
                });
            }
        });
        nextDisjunctiveResult++;
    });
    // if we have some parent level values for hierarchical facets, merge them
    state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
        var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
        // if we are already at a root refinement (or no refinement at all), there is no
        // root level values request
        if (currentRefinement.length === 0 || currentRefinement[0].split(separator).length < 2) return;
        results.slice(nextDisjunctiveResult).forEach(function(result) {
            var facets = result && result.facets ? result.facets : {};
            Object.keys(facets).forEach(function(dfacet) {
                var facetResults = facets[dfacet];
                var position = $7qXEB(state.hierarchicalFacets, function(f) {
                    return f.name === hierarchicalFacet.name;
                });
                var attributeIndex = $7qXEB(self.hierarchicalFacets[position], function(f) {
                    return f.attribute === dfacet;
                });
                // previous refinements and no results so not able to find it
                if (attributeIndex === -1) return;
                // when we always get root levels, if the hits refinement is `beers > IPA` (count: 5),
                // then the disjunctive values will be `beers` (count: 100),
                // but we do not want to display
                //   | beers (100)
                //     > IPA (5)
                // We want
                //   | beers (5)
                //     > IPA (5)
                var defaultData = {};
                if (currentRefinement.length > 0) {
                    var root = currentRefinement[0].split(separator)[0];
                    defaultData[root] = self.hierarchicalFacets[position][attributeIndex].data[root];
                }
                self.hierarchicalFacets[position][attributeIndex].data = $kee8o(defaultData, facetResults, self.hierarchicalFacets[position][attributeIndex].data);
            });
            nextDisjunctiveResult++;
        });
    });
    // add the excludes
    Object.keys(state.facetsExcludes).forEach(function(facetName) {
        var excludes = state.facetsExcludes[facetName];
        var position = facetsIndices[facetName];
        self.facets[position] = {
            name: facetName,
            data: mainFacets[facetName],
            exhaustive: mainSubResponse.exhaustiveFacetsCount
        };
        excludes.forEach(function(facetValue) {
            self.facets[position] = self.facets[position] || {
                name: facetName
            };
            self.facets[position].data = self.facets[position].data || {};
            self.facets[position].data[facetValue] = 0;
        });
    });
    /**
   * @type {Array}
   */ this.hierarchicalFacets = this.hierarchicalFacets.map($9ztro(state));
    /**
   * @type {Array}
   */ this.facets = $5Y7uW(this.facets);
    /**
   * @type {Array}
   */ this.disjunctiveFacets = $5Y7uW(this.disjunctiveFacets);
    this._state = state;
}
/**
 * Get a facet object with its name
 * @deprecated
 * @param {string} name name of the faceted attribute
 * @return {SearchResults.Facet} the facet object
 */ $9e699c47e0c26cf0$var$SearchResults.prototype.getFacetByName = function(name) {
    function predicate(facet) {
        return facet.name === name;
    }
    return $5B6z1(this.facets, predicate) || $5B6z1(this.disjunctiveFacets, predicate) || $5B6z1(this.hierarchicalFacets, predicate);
};
/**
 * Get the facet values of a specified attribute from a SearchResults object.
 * @private
 * @param {SearchResults} results the search results to search in
 * @param {string} attribute name of the faceted attribute to search for
 * @return {array|object} facet values. For the hierarchical facets it is an object.
 */ function $9e699c47e0c26cf0$var$extractNormalizedFacetValues(results, attribute) {
    function predicate(facet) {
        return facet.name === attribute;
    }
    if (results._state.isConjunctiveFacet(attribute)) {
        var facet = $5B6z1(results.facets, predicate);
        if (!facet) return [];
        return Object.keys(facet.data).map(function(name) {
            var value = $9e699c47e0c26cf0$var$escapeFacetValue(name);
            return {
                name: name,
                escapedValue: value,
                count: facet.data[name],
                isRefined: results._state.isFacetRefined(attribute, value),
                isExcluded: results._state.isExcludeRefined(attribute, name)
            };
        });
    } else if (results._state.isDisjunctiveFacet(attribute)) {
        var disjunctiveFacet = $5B6z1(results.disjunctiveFacets, predicate);
        if (!disjunctiveFacet) return [];
        return Object.keys(disjunctiveFacet.data).map(function(name) {
            var value = $9e699c47e0c26cf0$var$escapeFacetValue(name);
            return {
                name: name,
                escapedValue: value,
                count: disjunctiveFacet.data[name],
                isRefined: results._state.isDisjunctiveFacetRefined(attribute, value)
            };
        });
    } else if (results._state.isHierarchicalFacet(attribute)) {
        var hierarchicalFacetValues = $5B6z1(results.hierarchicalFacets, predicate);
        if (!hierarchicalFacetValues) return hierarchicalFacetValues;
        var hierarchicalFacet = results._state.getHierarchicalFacetByName(attribute);
        var separator = results._state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var currentRefinement = $9e699c47e0c26cf0$var$unescapeFacetValue(results._state.getHierarchicalRefinement(attribute)[0] || '');
        if (currentRefinement.indexOf(hierarchicalFacet.rootPath) === 0) currentRefinement = currentRefinement.replace(hierarchicalFacet.rootPath + separator, '');
        var currentRefinementSplit = currentRefinement.split(separator);
        currentRefinementSplit.unshift(attribute);
        $9e699c47e0c26cf0$var$setIsRefined(hierarchicalFacetValues, currentRefinementSplit, 0);
        return hierarchicalFacetValues;
    }
    return undefined;
}
/**
 * Set the isRefined of a hierarchical facet result based on the current state.
 * @param {SearchResults.HierarchicalFacet} item Hierarchical facet to fix
 * @param {string[]} currentRefinement array of parts of the current hierarchical refinement
 * @param {number} depth recursion depth in the currentRefinement
 * @return {undefined} function mutates the item
 */ function $9e699c47e0c26cf0$var$setIsRefined(item, currentRefinement, depth) {
    item.isRefined = item.name === currentRefinement[depth];
    if (item.data) item.data.forEach(function(child) {
        $9e699c47e0c26cf0$var$setIsRefined(child, currentRefinement, depth + 1);
    });
}
/**
 * Sort nodes of a hierarchical or disjunctive facet results
 * @private
 * @param {function} sortFn sort function to apply
 * @param {HierarchicalFacet|Array} node node upon which we want to apply the sort
 * @param {string[]} names attribute names
 * @param {number} [level=0] current index in the names array
 * @return {HierarchicalFacet|Array} sorted node
 */ function $9e699c47e0c26cf0$var$recSort(sortFn, node, names, level) {
    level = level || 0;
    if (Array.isArray(node)) return sortFn(node, names[level]);
    if (!node.data || node.data.length === 0) return node;
    var children = node.data.map(function(childNode) {
        return $9e699c47e0c26cf0$var$recSort(sortFn, childNode, names, level + 1);
    });
    var sortedChildren = sortFn(children, names[level]);
    var newNode = $kee8o({
        data: sortedChildren
    }, node);
    return newNode;
}
$9e699c47e0c26cf0$var$SearchResults.DEFAULT_SORT = [
    'isRefined:desc',
    'count:desc',
    'name:asc'
];
function $9e699c47e0c26cf0$var$vanillaSortFn(order, data) {
    return data.sort(order);
}
/**
 * @typedef FacetOrdering
 * @type {Object}
 * @property {string[]} [order]
 * @property {'count' | 'alpha' | 'hidden'} [sortRemainingBy]
 */ /**
 * Sorts facet arrays via their facet ordering
 * @param {Array} facetValues the values
 * @param {FacetOrdering} facetOrdering the ordering
 * @returns {Array} the sorted facet values
 */ function $9e699c47e0c26cf0$var$sortViaFacetOrdering(facetValues, facetOrdering) {
    var orderedFacets = [];
    var remainingFacets = [];
    var order = facetOrdering.order || [];
    /**
   * an object with the keys being the values in order, the values their index:
   * ['one', 'two'] -> { one: 0, two: 1 }
   */ var reverseOrder = order.reduce(function(acc, name, i) {
        acc[name] = i;
        return acc;
    }, {});
    facetValues.forEach(function(item) {
        // hierarchical facets get sorted using their raw name
        var name = item.path || item.name;
        if (reverseOrder[name] !== undefined) orderedFacets[reverseOrder[name]] = item;
        else remainingFacets.push(item);
    });
    orderedFacets = orderedFacets.filter(function(facet) {
        return facet;
    });
    var sortRemainingBy = facetOrdering.sortRemainingBy;
    var ordering;
    if (sortRemainingBy === 'hidden') return orderedFacets;
    else if (sortRemainingBy === 'alpha') ordering = [
        [
            'path',
            'name'
        ],
        [
            'asc',
            'asc'
        ]
    ];
    else ordering = [
        [
            'count'
        ],
        [
            'desc'
        ]
    ];
    return orderedFacets.concat($3XDAH(remainingFacets, ordering[0], ordering[1]));
}
/**
 * @param {SearchResults} results the search results class
 * @param {string} attribute the attribute to retrieve ordering of
 * @returns {FacetOrdering | undefined} the facet ordering
 */ function $9e699c47e0c26cf0$var$getFacetOrdering(results, attribute) {
    return results.renderingContent && results.renderingContent.facetOrdering && results.renderingContent.facetOrdering.values && results.renderingContent.facetOrdering.values[attribute];
}
/**
 * Get a the list of values for a given facet attribute. Those values are sorted
 * refinement first, descending count (bigger value on top), and name ascending
 * (alphabetical order). The sort formula can overridden using either string based
 * predicates or a function.
 *
 * This method will return all the values returned by the Algolia engine plus all
 * the values already refined. This means that it can happen that the
 * `maxValuesPerFacet` [configuration](https://www.algolia.com/doc/rest-api/search#param-maxValuesPerFacet)
 * might not be respected if you have facet values that are already refined.
 * @param {string} attribute attribute name
 * @param {object} opts configuration options.
 * @param {boolean} [opts.facetOrdering]
 * Force the use of facetOrdering from the result if a sortBy is present. If
 * sortBy isn't present, facetOrdering will be used automatically.
 * @param {Array.<string> | function} opts.sortBy
 * When using strings, it consists of
 * the name of the [FacetValue](#SearchResults.FacetValue) or the
 * [HierarchicalFacet](#SearchResults.HierarchicalFacet) attributes with the
 * order (`asc` or `desc`). For example to order the value by count, the
 * argument would be `['count:asc']`.
 *
 * If only the attribute name is specified, the ordering defaults to the one
 * specified in the default value for this attribute.
 *
 * When not specified, the order is
 * ascending.  This parameter can also be a function which takes two facet
 * values and should return a number, 0 if equal, 1 if the first argument is
 * bigger or -1 otherwise.
 *
 * The default value for this attribute `['isRefined:desc', 'count:desc', 'name:asc']`
 * @return {FacetValue[]|HierarchicalFacet|undefined} depending on the type of facet of
 * the attribute requested (hierarchical, disjunctive or conjunctive)
 * @example
 * helper.on('result', function(event){
 *   //get values ordered only by name ascending using the string predicate
 *   event.results.getFacetValues('city', {sortBy: ['name:asc']});
 *   //get values  ordered only by count ascending using a function
 *   event.results.getFacetValues('city', {
 *     // this is equivalent to ['count:asc']
 *     sortBy: function(a, b) {
 *       if (a.count === b.count) return 0;
 *       if (a.count > b.count)   return 1;
 *       if (b.count > a.count)   return -1;
 *     }
 *   });
 * });
 */ $9e699c47e0c26cf0$var$SearchResults.prototype.getFacetValues = function(attribute, opts) {
    var facetValues = $9e699c47e0c26cf0$var$extractNormalizedFacetValues(this, attribute);
    if (!facetValues) return undefined;
    var options = $kee8o({}, opts, {
        sortBy: $9e699c47e0c26cf0$var$SearchResults.DEFAULT_SORT,
        // if no sortBy is given, attempt to sort based on facetOrdering
        // if it is given, we still allow to sort via facet ordering first
        facetOrdering: !(opts && opts.sortBy)
    });
    // eslint-disable-next-line consistent-this
    var results = this;
    var attributes;
    if (Array.isArray(facetValues)) attributes = [
        attribute
    ];
    else {
        var config = results._state.getHierarchicalFacetByName(facetValues.name);
        attributes = config.attributes;
    }
    return $9e699c47e0c26cf0$var$recSort(function(data, facetName) {
        if (options.facetOrdering) {
            var facetOrdering = $9e699c47e0c26cf0$var$getFacetOrdering(results, facetName);
            if (facetOrdering) return $9e699c47e0c26cf0$var$sortViaFacetOrdering(data, facetOrdering);
        }
        if (Array.isArray(options.sortBy)) {
            var order = $jARvP(options.sortBy, $9e699c47e0c26cf0$var$SearchResults.DEFAULT_SORT);
            return $3XDAH(data, order[0], order[1]);
        } else if (typeof options.sortBy === 'function') return $9e699c47e0c26cf0$var$vanillaSortFn(options.sortBy, data);
        throw new Error("options.sortBy is optional but if defined it must be either an array of string (predicates) or a sorting function");
    }, facetValues, attributes);
};
/**
 * Returns the facet stats if attribute is defined and the facet contains some.
 * Otherwise returns undefined.
 * @param {string} attribute name of the faceted attribute
 * @return {object} The stats of the facet
 */ $9e699c47e0c26cf0$var$SearchResults.prototype.getFacetStats = function(attribute) {
    if (this._state.isConjunctiveFacet(attribute)) return $9e699c47e0c26cf0$var$getFacetStatsIfAvailable(this.facets, attribute);
    else if (this._state.isDisjunctiveFacet(attribute)) return $9e699c47e0c26cf0$var$getFacetStatsIfAvailable(this.disjunctiveFacets, attribute);
    return undefined;
};
/**
 * @typedef {Object} FacetListItem
 * @property {string} name
 */ /**
 * @param {FacetListItem[]} facetList (has more items, but enough for here)
 * @param {string} facetName The attribute to look for
 * @return {object|undefined} The stats of the facet
 */ function $9e699c47e0c26cf0$var$getFacetStatsIfAvailable(facetList, facetName) {
    var data = $5B6z1(facetList, function(facet) {
        return facet.name === facetName;
    });
    return data && data.stats;
}
/**
 * Returns all refinements for all filters + tags. It also provides
 * additional information: count and exhaustiveness for each filter.
 *
 * See the [refinement type](#Refinement) for an exhaustive view of the available
 * data.
 *
 * Note that for a numeric refinement, results are grouped per operator, this
 * means that it will return responses for operators which are empty.
 *
 * @return {Array.<Refinement>} all the refinements
 */ $9e699c47e0c26cf0$var$SearchResults.prototype.getRefinements = function() {
    var state = this._state;
    // eslint-disable-next-line consistent-this
    var results = this;
    var res = [];
    Object.keys(state.facetsRefinements).forEach(function(attributeName) {
        state.facetsRefinements[attributeName].forEach(function(name) {
            res.push($9e699c47e0c26cf0$var$getRefinement(state, 'facet', attributeName, name, results.facets));
        });
    });
    Object.keys(state.facetsExcludes).forEach(function(attributeName) {
        state.facetsExcludes[attributeName].forEach(function(name) {
            res.push($9e699c47e0c26cf0$var$getRefinement(state, 'exclude', attributeName, name, results.facets));
        });
    });
    Object.keys(state.disjunctiveFacetsRefinements).forEach(function(attributeName) {
        state.disjunctiveFacetsRefinements[attributeName].forEach(function(name) {
            res.push($9e699c47e0c26cf0$var$getRefinement(state, 'disjunctive', attributeName, name, results.disjunctiveFacets));
        });
    });
    Object.keys(state.hierarchicalFacetsRefinements).forEach(function(attributeName) {
        state.hierarchicalFacetsRefinements[attributeName].forEach(function(name) {
            res.push($9e699c47e0c26cf0$var$getHierarchicalRefinement(state, attributeName, name, results.hierarchicalFacets));
        });
    });
    Object.keys(state.numericRefinements).forEach(function(attributeName) {
        var operators = state.numericRefinements[attributeName];
        Object.keys(operators).forEach(function(operator) {
            operators[operator].forEach(function(value) {
                res.push({
                    type: 'numeric',
                    attributeName: attributeName,
                    name: value,
                    numericValue: value,
                    operator: operator
                });
            });
        });
    });
    state.tagRefinements.forEach(function(name) {
        res.push({
            type: 'tag',
            attributeName: '_tags',
            name: name
        });
    });
    return res;
};
/**
 * @typedef {Object} Facet
 * @property {string} name
 * @property {Object} data
 * @property {boolean} exhaustive
 */ /**
 * @param {SearchParameters} state the current state
 * @param {string} type the type of the refinement
 * @param {string} attributeName The attribute of the facet
 * @param {*} name The name of the facet
 * @param {Facet[]} resultsFacets facets from the results
 * @return {Refinement} the refinement
 */ function $9e699c47e0c26cf0$var$getRefinement(state, type, attributeName, name, resultsFacets) {
    var facet = $5B6z1(resultsFacets, function(f) {
        return f.name === attributeName;
    });
    var count = facet && facet.data && facet.data[name] ? facet.data[name] : 0;
    var exhaustive = facet && facet.exhaustive || false;
    return {
        type: type,
        attributeName: attributeName,
        name: name,
        count: count,
        exhaustive: exhaustive
    };
}
/**
 * @param {SearchParameters} state the current state
 * @param {string} attributeName the attribute of the hierarchical facet
 * @param {string} name the name of the facet
 * @param {Facet[]} resultsFacets facets from the results
 * @return {HierarchicalFacet} the hierarchical facet
 */ function $9e699c47e0c26cf0$var$getHierarchicalRefinement(state, attributeName, name, resultsFacets) {
    var facetDeclaration = state.getHierarchicalFacetByName(attributeName);
    var separator = state._getHierarchicalFacetSeparator(facetDeclaration);
    var split = name.split(separator);
    var rootFacet = $5B6z1(resultsFacets, function(facet) {
        return facet.name === attributeName;
    });
    var facet = split.reduce(function(intermediateFacet, part) {
        var newFacet = intermediateFacet && $5B6z1(intermediateFacet.data, function(f) {
            return f.name === part;
        });
        return newFacet !== undefined ? newFacet : intermediateFacet;
    }, rootFacet);
    var count = facet && facet.count || 0;
    var exhaustive = facet && facet.exhaustive || false;
    var path = facet && facet.path || '';
    return {
        type: 'hierarchical',
        attributeName: attributeName,
        name: path,
        count: count,
        exhaustive: exhaustive
    };
}
module.exports = $9e699c47e0c26cf0$var$SearchResults;

});
parcelRegister("5Y7uW", function(module, exports) {
'use strict';
module.exports = function compact(array) {
    if (!Array.isArray(array)) return [];
    return array.filter(Boolean);
};

});

parcelRegister("7qXEB", function(module, exports) {
'use strict';
// @MAJOR can be replaced by native Array#findIndex when we change support
module.exports = function find(array, comparator) {
    if (!Array.isArray(array)) return -1;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return i;
    }
    return -1;
};

});

parcelRegister("jARvP", function(module, exports) {
'use strict';

var $5B6z1 = parcelRequire("5B6z1");
/**
 * Transform sort format from user friendly notation to lodash format
 * @param {string[]} sortBy array of predicate of the form "attribute:order"
 * @param {string[]} [defaults] array of predicate of the form "attribute:order"
 * @return {array.<string[]>} array containing 2 elements : attributes, orders
 */ module.exports = function formatSort(sortBy, defaults) {
    var defaultInstructions = (defaults || []).map(function(sort) {
        return sort.split(':');
    });
    return sortBy.reduce(function preparePredicate(out, sort) {
        var sortInstruction = sort.split(':');
        var matchingDefault = $5B6z1(defaultInstructions, function(defaultInstruction) {
            return defaultInstruction[0] === sortInstruction[0];
        });
        if (sortInstruction.length > 1 || !matchingDefault) {
            out[0].push(sortInstruction[0]);
            out[1].push(sortInstruction[1]);
            return out;
        }
        out[0].push(matchingDefault[0]);
        out[1].push(matchingDefault[1]);
        return out;
    }, [
        [],
        []
    ]);
};

});

parcelRegister("3XDAH", function(module, exports) {
'use strict';
function $2e2597bb3c738014$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined;
        var valIsNull = value === null;
        var othIsDefined = other !== undefined;
        var othIsNull = other === null;
        if (!othIsNull && value > other || valIsNull && othIsDefined || !valIsDefined) return 1;
        if (!valIsNull && value < other || othIsNull && valIsDefined || !othIsDefined) return -1;
    }
    return 0;
}
/**
 * @param {Array<object>} collection object with keys in attributes
 * @param {Array<string>} iteratees attributes
 * @param {Array<string>} orders asc | desc
 * @return {Array<object>} sorted collection
 */ function $2e2597bb3c738014$var$orderBy(collection, iteratees, orders) {
    if (!Array.isArray(collection)) return [];
    if (!Array.isArray(orders)) orders = [];
    var result = collection.map(function(value, index) {
        return {
            criteria: iteratees.map(function(iteratee) {
                return value[iteratee];
            }),
            index: index,
            value: value
        };
    });
    result.sort(function comparer(object, other) {
        var index = -1;
        while(++index < object.criteria.length){
            var res = $2e2597bb3c738014$var$compareAscending(object.criteria[index], other.criteria[index]);
            if (res) {
                if (index >= orders.length) return res;
                if (orders[index] === 'desc') return -res;
                return res;
            }
        }
        // This ensures a stable sort in V8 and other engines.
        // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
        return object.index - other.index;
    });
    return result.map(function(res) {
        return res.value;
    });
}
module.exports = $2e2597bb3c738014$var$orderBy;

});

parcelRegister("9ztro", function(module, exports) {
'use strict';
module.exports = $6f7e3846909b74d4$var$generateTrees;

var $iOTWh = parcelRequire("iOTWh");

var $5B6z1 = parcelRequire("5B6z1");

var $jARvP = parcelRequire("jARvP");

var $3XDAH = parcelRequire("3XDAH");
var $6f7e3846909b74d4$var$escapeFacetValue = $iOTWh.escapeFacetValue;
var $6f7e3846909b74d4$var$unescapeFacetValue = $iOTWh.unescapeFacetValue;
function $6f7e3846909b74d4$var$generateTrees(state) {
    return function generate(hierarchicalFacetResult, hierarchicalFacetIndex) {
        var hierarchicalFacet = state.hierarchicalFacets[hierarchicalFacetIndex];
        var hierarchicalFacetRefinement = state.hierarchicalFacetsRefinements[hierarchicalFacet.name] && state.hierarchicalFacetsRefinements[hierarchicalFacet.name][0] || '';
        var hierarchicalSeparator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var hierarchicalRootPath = state._getHierarchicalRootPath(hierarchicalFacet);
        var hierarchicalShowParentLevel = state._getHierarchicalShowParentLevel(hierarchicalFacet);
        var sortBy = $jARvP(state._getHierarchicalFacetSortBy(hierarchicalFacet));
        var rootExhaustive = hierarchicalFacetResult.every(function(facetResult) {
            return facetResult.exhaustive;
        });
        var generateTreeFn = $6f7e3846909b74d4$var$generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, hierarchicalFacetRefinement);
        var results = hierarchicalFacetResult;
        if (hierarchicalRootPath) results = hierarchicalFacetResult.slice(hierarchicalRootPath.split(hierarchicalSeparator).length);
        return results.reduce(generateTreeFn, {
            name: state.hierarchicalFacets[hierarchicalFacetIndex].name,
            count: null,
            isRefined: true,
            path: null,
            escapedValue: null,
            exhaustive: rootExhaustive,
            data: null
        });
    };
}
function $6f7e3846909b74d4$var$generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, currentRefinement) {
    return function generateTree(hierarchicalTree, hierarchicalFacetResult, currentHierarchicalLevel) {
        var parent = hierarchicalTree;
        if (currentHierarchicalLevel > 0) {
            var level = 0;
            parent = hierarchicalTree;
            while(level < currentHierarchicalLevel){
                /**
         * @type {object[]]} hierarchical data
         */ var data = parent && Array.isArray(parent.data) ? parent.data : [];
                parent = $5B6z1(data, function(subtree) {
                    return subtree.isRefined;
                });
                level++;
            }
        }
        // we found a refined parent, let's add current level data under it
        if (parent) {
            // filter values in case an object has multiple categories:
            //   {
            //     categories: {
            //       level0: ['beers', 'bières'],
            //       level1: ['beers > IPA', 'bières > Belges']
            //     }
            //   }
            //
            // If parent refinement is `beers`, then we do not want to have `bières > Belges`
            // showing up
            var picked = Object.keys(hierarchicalFacetResult.data).map(function(facetValue) {
                return [
                    facetValue,
                    hierarchicalFacetResult.data[facetValue]
                ];
            }).filter(function(tuple) {
                var facetValue = tuple[0];
                return $6f7e3846909b74d4$var$onlyMatchingTree(facetValue, parent.path || hierarchicalRootPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel);
            });
            parent.data = $3XDAH(picked.map(function(tuple) {
                var facetValue = tuple[0];
                var facetCount = tuple[1];
                return $6f7e3846909b74d4$var$format(facetCount, facetValue, hierarchicalSeparator, $6f7e3846909b74d4$var$unescapeFacetValue(currentRefinement), hierarchicalFacetResult.exhaustive);
            }), sortBy[0], sortBy[1]);
        }
        return hierarchicalTree;
    };
}
// eslint-disable-next-line max-params
function $6f7e3846909b74d4$var$onlyMatchingTree(facetValue, parentPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel) {
    // we want the facetValue is a child of hierarchicalRootPath
    if (hierarchicalRootPath && (facetValue.indexOf(hierarchicalRootPath) !== 0 || hierarchicalRootPath === facetValue)) return false;
    // we always want root levels (only when there is no prefix path)
    return !hierarchicalRootPath && facetValue.indexOf(hierarchicalSeparator) === -1 || // if there is a rootPath, being root level mean 1 level under rootPath
    hierarchicalRootPath && facetValue.split(hierarchicalSeparator).length - hierarchicalRootPath.split(hierarchicalSeparator).length === 1 || // if current refinement is a root level and current facetValue is a root level,
    // keep the facetValue
    facetValue.indexOf(hierarchicalSeparator) === -1 && currentRefinement.indexOf(hierarchicalSeparator) === -1 || // currentRefinement is a child of the facet value
    currentRefinement.indexOf(facetValue) === 0 || // facetValue is a child of the current parent, add it
    facetValue.indexOf(parentPath + hierarchicalSeparator) === 0 && (hierarchicalShowParentLevel || facetValue.indexOf(currentRefinement) === 0);
}
function $6f7e3846909b74d4$var$format(facetCount, facetValue, hierarchicalSeparator, currentRefinement, exhaustive) {
    var parts = facetValue.split(hierarchicalSeparator);
    return {
        name: parts[parts.length - 1].trim(),
        path: facetValue,
        escapedValue: $6f7e3846909b74d4$var$escapeFacetValue(facetValue),
        count: facetCount,
        isRefined: currentRefinement === facetValue || currentRefinement.indexOf(facetValue + hierarchicalSeparator) === 0,
        exhaustive: exhaustive,
        data: null
    };
}

});


parcelRegister("2s3Na", function(module, exports) {
'use strict';
module.exports = '3.14.0';

});



parcelRegister("8HDz3", function(module, exports) {

$parcel$export(module.exports, "resolveFacets", () => $6561078758bfdc64$export$a182255654db46e1);
$parcel$export(module.exports, "resolveSearchResults", () => $6561078758bfdc64$export$11ccebd170701e17);
$parcel$export(module.exports, "resolveHits", () => $6561078758bfdc64$export$2438408af19dc22a);

var $g5DHJ = parcelRequire("g5DHJ");

var $fCICH = parcelRequire("fCICH");

var $ELb1a = parcelRequire("ELb1a");

var $3lrDB = parcelRequire("3lrDB");
function $6561078758bfdc64$var$resolveFacetValuesAndCount(facets, facetKey) {
    const foundFacent = facets.find((facet)=>facet.get('name') === facetKey);
    return foundFacent ? foundFacent.get('data') : (0, $g5DHJ.Map)();
}
function $6561078758bfdc64$export$a182255654db46e1(_ref) {
    let { facets: facets, filters: filters, featureFlags: featureFlags } = _ref;
    const screenClass = (0, $3lrDB.getScreenClass)(window.innerWidth);
    const showDesktopFilters = screenClass === 'xl';
    const receivedFilters = showDesktopFilters ? (0, $fCICH.getFilters)({
        featureFlags: featureFlags
    }) : (0, $fCICH.getTabletMobileFilters)({
        featureFlags: featureFlags
    });
    return receivedFilters.filter((f)=>f.get('facet')).map((f)=>{
        let facetProducts;
        if (f.get('custom')) facetProducts = f.get('customFilters').map((cfp)=>(0, $g5DHJ.Map)({
                label: cfp.get('label'),
                value: cfp.get('value'),
                count: cfp.get('resolveFacetCount') && cfp.get('resolveFacetCount')(facets, filters)
            })).toList();
        else facetProducts = $6561078758bfdc64$var$resolveFacetValuesAndCount(facets, f.get('algoliaFacetKey')).map((count, facetProductValue)=>(0, $g5DHJ.Map)({
                label: facetProductValue,
                value: facetProductValue,
                count: count
            })).toList();
        return (0, $g5DHJ.Map)({
            useDropDownComponentForSidebar: f.get('useDropDownComponentForSidebar'),
            key: f.get('key'),
            sidebarLabel: f.get('sidebarLabel') || f.get('label'),
            topBarLabel: f.get('topBarLabel') || f.get('label'),
            type: f.get('type'),
            facetProducts: facetProducts,
            openByDefault: !!f.get('openByDefault'),
            primary: !!f.get('primary')
        });
    }).toList();
}
function $6561078758bfdc64$export$11ccebd170701e17(_ref2) {
    let { hits: hits, numberOfHits: numberOfHits, numberOfPages: numberOfPages } = _ref2;
    return (0, $g5DHJ.Map)({
        hits: hits.map((h)=>new (0, $ELb1a.default)(h)),
        numberOfHits: numberOfHits,
        numberOfPages: numberOfPages
    });
}
function $6561078758bfdc64$export$2438408af19dc22a(hits) {
    return (0, $g5DHJ.fromJS)(hits).map((h)=>new (0, $ELb1a.default)(h));
}

});
parcelRegister("ELb1a", function(module, exports) {

$parcel$export(module.exports, "defaults", () => $07a854da62cebaeb$export$ebe90cb607ad99e);
$parcel$export(module.exports, "default", () => $07a854da62cebaeb$export$2e2bcd8739ae039);

var $g5DHJ = parcelRequire("g5DHJ");
const $07a854da62cebaeb$export$ebe90cb607ad99e = {
    _highlightResult: undefined,
    addonId: undefined,
    addonKey: undefined,
    releaseDate: undefined,
    name: undefined,
    tagLine: undefined,
    categories: undefined,
    deployments: undefined,
    documentType: undefined,
    logo: undefined,
    vendor: undefined,
    distribution: undefined,
    version: undefined,
    ratings: undefined,
    marketingLabels: undefined,
    programs: undefined
};
var $07a854da62cebaeb$export$2e2bcd8739ae039 = (0, $g5DHJ.Record)($07a854da62cebaeb$export$ebe90cb607ad99e);

});

parcelRegister("3lrDB", function(module, exports) {

$parcel$export(module.exports, "getScreenClass", () => $26f8c585788e6a6c$export$334677fa002011d3);
function $26f8c585788e6a6c$export$334677fa002011d3(innerWidth) {
    if (innerWidth < 576) return 'sm';
    else if (innerWidth >= 576 && innerWidth < 768) return 'md';
    else if (innerWidth >= 768 && innerWidth < 992) return 'lg';
    else if (innerWidth >= 992) return 'xl';
}

});


parcelRegister("72e1Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $51f39a85cb5f5249$export$2e2bcd8739ae039);

var $g5DHJ = parcelRequire("g5DHJ");

var $fCICH = parcelRequire("fCICH");

var $lwEMm = parcelRequire("lwEMm");
const $51f39a85cb5f5249$var$multiFilters = (featureFlags)=>(0, $fCICH.getFilters)({
        featureFlags: featureFlags
    }).filter((f)=>f.get('type') === (0, $lwEMm.DISJUNCTIVE_FACET_TYPE)).map((f)=>f.get('key'));
const $51f39a85cb5f5249$var$baseFilters = (featureFlags)=>$51f39a85cb5f5249$var$multiFilters(featureFlags).reduce((r, q)=>r.set(q, (0, $g5DHJ.Set)()), (0, $g5DHJ.Map)());
function $51f39a85cb5f5249$export$2e2bcd8739ae039(filters) {
    let featureFlags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return $51f39a85cb5f5249$var$baseFilters(featureFlags).merge(filters.filter((q)=>q)).map((v, k)=>{
        if ($51f39a85cb5f5249$var$multiFilters(featureFlags).includes(k)) {
            if ((0, $g5DHJ.Iterable).isIterable(v)) return v.toSet();
            else return (0, $g5DHJ.Set)([
                v
            ]);
        }
        return v;
    });
}

});

parcelRegister("7Qfm4", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b594ce74739029e$export$2e2bcd8739ae039);

var $g5DHJ = parcelRequire("g5DHJ");

var $fCICH = parcelRequire("fCICH");

var $jdVrg = parcelRequire("jdVrg");
function $5b594ce74739029e$export$2e2bcd8739ae039(_ref) {
    let { applyOverrides: applyOverrides, filters: filters, index: index, numHits: numHits, page: page, sort: sort, resolveAlgoliaQueryFilterOverrides: resolveAlgoliaQueryFilterOverrides = (0, $g5DHJ.Map)(), featureFlags: featureFlags } = _ref;
    const searchParameters = (0, $jdVrg.default)({
        additionalFacets: applyOverrides ? applyOverrides.types : (0, $g5DHJ.Set)()
    }).setIndex(index).setHitsPerPage(numHits);
    // if (featureFlags?.showCompassApps === false) {
    //   searchParameters = searchParameters.addDisjunctiveFacetRefinement(
    //     'version.compatibilities.applicationKey',
    //     '-compass'
    //   );
    // }
    const filtersSearchParameters = (0, $fCICH.getFilters)({
        featureFlags: featureFlags
    }).reduce((filterParams, f)=>(resolveAlgoliaQueryFilterOverrides.get(f.get('key')) || f.get('resolveAlgoliaQuery') || ((_ref2)=>{
            let { params: params } = _ref2;
            return params;
        }))({
            params: filterParams,
            filters: filters,
            sort: sort
        }), searchParameters);
    return (applyOverrides ? applyOverrides.apply(filtersSearchParameters) : filtersSearchParameters).setPage(page); // Must be last as changing parameters resets page to 0
}

});
parcelRegister("jdVrg", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfebc95c71c01cbe$export$2e2bcd8739ae039);

var $7TFuJ = parcelRequire("7TFuJ");

var $g5DHJ = parcelRequire("g5DHJ");

var $fMsDx = parcelRequire("fMsDx");

var $fCICH = parcelRequire("fCICH");

var $lwEMm = parcelRequire("lwEMm");

var $ELb1a = parcelRequire("ELb1a");
const $dfebc95c71c01cbe$var$resolvePartition = (facets, basePartition)=>facets.reduce((_ref, f)=>{
        let { disjunctive: disjunctive, conjunctive: conjunctive } = _ref;
        if (f.get('queryType') === (0, $lwEMm.DISJUNCTIVE_FACET_TYPE)) return {
            disjunctive: disjunctive.add(f.get('algoliaFacetKey')),
            conjunctive: conjunctive
        };
        else return {
            disjunctive: disjunctive,
            conjunctive: conjunctive.add(f.get('algoliaFacetKey'))
        };
    }, basePartition);
const { disjunctive: $dfebc95c71c01cbe$var$disjunctive, conjunctive: $dfebc95c71c01cbe$var$conjunctive } = (0, $fCICH.getFilters)().toSet().filter((f)=>!f.get('nonRetrievableAttribute')).reduce((filterAccumulator, f)=>{
    if (f.get('algoliaFacetKey')) {
        if (f.get('queryType') === (0, $lwEMm.DISJUNCTIVE_FACET_TYPE)) return {
            disjunctive: filterAccumulator.disjunctive.add(f.get('algoliaFacetKey')),
            conjunctive: filterAccumulator.conjunctive
        };
        else return {
            disjunctive: filterAccumulator.disjunctive,
            conjunctive: filterAccumulator.conjunctive.add(f.get('algoliaFacetKey'))
        };
    } else if (f.get('custom')) return f.get('customFilters').toSet().reduce((customFilterAccumulator, cf)=>{
        if (cf.get('queryType') === (0, $lwEMm.DISJUNCTIVE_FACET_TYPE)) return {
            disjunctive: customFilterAccumulator.disjunctive.add(cf.get('algoliaFacetKey')),
            conjunctive: customFilterAccumulator.conjunctive
        };
        else return {
            disjunctive: customFilterAccumulator.disjunctive,
            conjunctive: customFilterAccumulator.conjunctive.add(cf.get('algoliaFacetKey'))
        };
    }, {
        disjunctive: filterAccumulator.disjunctive,
        conjunctive: filterAccumulator.disjunctive
    });
    return {
        disjunctive: filterAccumulator.disjunctive,
        conjunctive: filterAccumulator.conjunctive
    };
}, {
    disjunctive: (0, $g5DHJ.Set)(),
    conjunctive: (0, $g5DHJ.Set)()
});
const $dfebc95c71c01cbe$var$combinedAlreadyResolved = new Set($dfebc95c71c01cbe$var$disjunctive.concat($dfebc95c71c01cbe$var$conjunctive));
const $dfebc95c71c01cbe$var$intermediatePartition = $dfebc95c71c01cbe$var$resolvePartition((0, $fMsDx.default).toSet().filter((af)=>!$dfebc95c71c01cbe$var$combinedAlreadyResolved.has(af.get('algoliaFacetKey'))), {
    disjunctive: $dfebc95c71c01cbe$var$disjunctive,
    conjunctive: $dfebc95c71c01cbe$var$conjunctive
});
var $dfebc95c71c01cbe$export$2e2bcd8739ae039 = (_ref2)=>{
    let { additionalFacets: additionalFacets } = _ref2;
    const finalPartition = $dfebc95c71c01cbe$var$resolvePartition(additionalFacets, $dfebc95c71c01cbe$var$intermediatePartition);
    return new (0, $7TFuJ.SearchParameters)({
        attributesToRetrieve: Object.keys((0, $ELb1a.defaults)),
        disjunctiveFacets: finalPartition.disjunctive.toJS(),
        facets: finalPartition.conjunctive.toJS()
    }).addDisjunctiveFacetRefinement((0, $fMsDx.default).getIn([
        'hidden',
        'algoliaFacetKey'
    ]), 'notHidden');
};

});


parcelRegister("dbmA1", function(module, exports) {

$parcel$export(module.exports, "resolveSearchIndex", () => $998dd161474b2914$export$e9da379f185a7937);

var $73HyZ = parcelRequire("73HyZ");
function $998dd161474b2914$export$e9da379f185a7937(_ref) {
    let { environment: environment, filters: filters, sort: sort, enableV2SearchIndex: enableV2SearchIndex = false } = _ref;
    const index = enableV2SearchIndex ? (0, $73HyZ.searchIndicesV2) : (0, $73HyZ.searchIndicesV1);
    const sortIndexSuffix = sort ? sort.get('indexSuffix')({
        filters: filters
    }) : undefined;
    return "".concat(index.getIn([
        environment,
        'indexName'
    ])).concat(sortIndexSuffix ? "_".concat(sortIndexSuffix) : '');
}

});
parcelRegister("73HyZ", function(module, exports) {

$parcel$export(module.exports, "searchIndicesV1", () => $523a9afc12d99df8$export$1cce0c12da2f23c3);
$parcel$export(module.exports, "searchIndicesV2", () => $523a9afc12d99df8$export$ba433f7d838a8998);

var $g5DHJ = parcelRequire("g5DHJ");

const $523a9afc12d99df8$export$1cce0c12da2f23c3 = (0, $g5DHJ.Map)({
    [(0, $658e6bd3ffbfdac1$export$404582bc18fe4d9e)]: (0, $g5DHJ.Map)({
        indexName: 'marketplace_plugins_dev'
    }),
    [(0, $658e6bd3ffbfdac1$export$46be287603848c56)]: (0, $g5DHJ.Map)({
        indexName: 'marketplace_plugins_stg'
    }),
    [(0, $658e6bd3ffbfdac1$export$e51cdc15d0c6bee2)]: (0, $g5DHJ.Map)({
        indexName: 'marketplace_plugins_prod'
    })
});
const $523a9afc12d99df8$export$ba433f7d838a8998 = (0, $g5DHJ.Map)({
    [(0, $658e6bd3ffbfdac1$export$404582bc18fe4d9e)]: (0, $g5DHJ.Map)({
        indexName: 'marketplace_plugins_dev_v2'
    }),
    [(0, $658e6bd3ffbfdac1$export$46be287603848c56)]: (0, $g5DHJ.Map)({
        indexName: 'marketplace_plugins_stg_v2'
    }),
    [(0, $658e6bd3ffbfdac1$export$e51cdc15d0c6bee2)]: (0, $g5DHJ.Map)({
        indexName: 'marketplace_plugins_prod_v2'
    })
});

});


parcelRegister("aViHK", function(module, exports) {

$parcel$export(module.exports, "resolveSortFromFilters", () => $020d620270581175$export$e313698ed48e2e6b);

var $9LwYq = parcelRequire("9LwYq");
function $020d620270581175$export$e313698ed48e2e6b(_ref) {
    let { filters: filters } = _ref;
    return (0, $9LwYq.sortOptions).get(filters.get('sort'));
}

});



parcelRegister("eMCmH", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac334ee9c816a80e$export$2e2bcd8739ae039);

var $g5DHJ = parcelRequire("g5DHJ");
var $ac334ee9c816a80e$export$2e2bcd8739ae039 = (0, $g5DHJ.Record)({
    index: undefined,
    render: undefined
});

});

parcelRegister("fOzGB", function(module, exports) {

$parcel$export(module.exports, "chainablePropType", () => $b837350d8718cc7e$export$f6667e36efa19954);
const $b837350d8718cc7e$export$f6667e36efa19954 = (predicate)=>{
    const propType = (props, propName, componentName)=>{
        if (props[propName] == null) return;
        return predicate(props, propName, componentName);
    };
    propType.isRequired = (props, propName, componentName)=>{
        if (props[propName] == null) return new Error("Required prop `".concat(propName, "` was not specified in `").concat(componentName, "`."));
        return predicate(props, propName, componentName);
    };
    return propType;
};

});

parcelRegister("gggoS", function(module, exports) {

$parcel$export(module.exports, "baseFiltersPropTypeFactory", () => $bd6adcb5f859022b$export$3ca42cd8b2f1d091);
$parcel$export(module.exports, "filtersPropTypeFactory", () => $bd6adcb5f859022b$export$8e6e41f029c56cfa);
$parcel$export(module.exports, "unenhancedPropTypeFactory", () => $bd6adcb5f859022b$export$5db18c4d5558cd79);

var $fEeDC = parcelRequire("fEeDC");

var $1Qivz = parcelRequire("1Qivz");

var $9LwYq = parcelRequire("9LwYq");

var $lwEMm = parcelRequire("lwEMm");
function $bd6adcb5f859022b$export$3ca42cd8b2f1d091(fs, disjunctiveFacetPropType) {
    let isFilterRequired = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ()=>false;
    return fs.map((f)=>{
        const filterValueType = f.get('custom') ? (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
            ...f.get('customFilters').map((cf)=>cf.get('value')).values()
        ]) : (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string;
        const propType = f.get('type') === (0, $lwEMm.DISJUNCTIVE_FACET_TYPE) ? disjunctiveFacetPropType(filterValueType) : filterValueType;
        return isFilterRequired(f) ? propType.isRequired : propType;
    }).set('sort', (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf((0, $9LwYq.sortOptions).keySeq().toJS()));
}
function $bd6adcb5f859022b$export$8e6e41f029c56cfa(fs) {
    let isFilterRequired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ()=>false;
    return $bd6adcb5f859022b$export$3ca42cd8b2f1d091(fs, (fvt)=>(0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).setOf(fvt), isFilterRequired);
}
function $bd6adcb5f859022b$export$5db18c4d5558cd79(fs) {
    let isFilterRequired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ()=>false;
    return $bd6adcb5f859022b$export$3ca42cd8b2f1d091(fs, (fvt)=>(0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
            fvt,
            (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).setOf(fvt)
        ]), isFilterRequired);
}

});


parcelRegister("emLm3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a757da6ae28ebe7a$export$2e2bcd8739ae039);

var $g5DHJ = parcelRequire("g5DHJ");

var $4QJdp = parcelRequire("4QJdp");

var $8Cu0c = parcelRequire("8Cu0c");
const $a757da6ae28ebe7a$var$middleware = [
    (0, $8Cu0c.default)
];
function $a757da6ae28ebe7a$var$finalCreateStore(_ref) {
    let { debug: debug } = _ref;
    if (debug && window.__REDUX_DEVTOOLS_EXTENSION__) {
        const reduxDevtools = window.__REDUX_DEVTOOLS_EXTENSION__({
            serialize: {
                immutable: (0, $g5DHJ.default)
            }
        });
        return (0, $4QJdp.compose)((0, $4QJdp.applyMiddleware)(...$a757da6ae28ebe7a$var$middleware), reduxDevtools)((0, $4QJdp.createStore));
    } else return (0, $4QJdp.compose)((0, $4QJdp.applyMiddleware)(...$a757da6ae28ebe7a$var$middleware))((0, $4QJdp.createStore));
}
function $a757da6ae28ebe7a$export$2e2bcd8739ae039(_ref2) {
    let { debug: debug, reducer: reducer } = _ref2;
    return $a757da6ae28ebe7a$var$finalCreateStore({
        debug: debug
    })(reducer);
}

});
parcelRegister("4QJdp", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $387f179275880db7$export$f51a9068ac82ea43);
$parcel$export(module.exports, "combineReducers", () => $387f179275880db7$export$66e4520cdb265d18);
$parcel$export(module.exports, "bindActionCreators", () => $387f179275880db7$export$aea084d96e84da92);
$parcel$export(module.exports, "compose", () => $387f179275880db7$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "applyMiddleware", () => $387f179275880db7$export$9ff26e0402cc7b7);

var $1Xn5q = parcelRequire("1Xn5q");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $387f179275880db7$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $387f179275880db7$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $387f179275880db7$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $387f179275880db7$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $387f179275880db7$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $387f179275880db7$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $387f179275880db7$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $387f179275880db7$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $387f179275880db7$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($387f179275880db7$var$isDate(val)) return 'date';
    if ($387f179275880db7$var$isError(val)) return 'error';
    var constructorName = $387f179275880db7$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $387f179275880db7$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $387f179275880db7$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $387f179275880db7$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $387f179275880db7$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $387f179275880db7$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($387f179275880db7$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($387f179275880db7$var$formatProdErrorMessage(1));
        return enhancer($387f179275880db7$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($387f179275880db7$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($387f179275880db7$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($387f179275880db7$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($387f179275880db7$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($387f179275880db7$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$387f179275880db7$var$isPlainObject(action)) throw new Error($387f179275880db7$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($387f179275880db7$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($387f179275880db7$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($387f179275880db7$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $387f179275880db7$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($387f179275880db7$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$387f179275880db7$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $387f179275880db7$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$387f179275880db7$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $387f179275880db7$export$8928921ea2d3b126 = $387f179275880db7$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $387f179275880db7$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $387f179275880db7$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $387f179275880db7$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$387f179275880db7$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $387f179275880db7$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $387f179275880db7$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $387f179275880db7$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $387f179275880db7$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($387f179275880db7$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $387f179275880db7$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($387f179275880db7$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $387f179275880db7$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $387f179275880db7$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($387f179275880db7$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $387f179275880db7$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $387f179275880db7$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $387f179275880db7$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($387f179275880db7$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $387f179275880db7$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $387f179275880db7$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $387f179275880db7$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($387f179275880db7$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $387f179275880db7$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("1Xn5q", function(module, exports) {

$parcel$export(module.exports, "default", () => $16cd35a30248fb20$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
function $16cd35a30248fb20$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $16cd35a30248fb20$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $16cd35a30248fb20$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $16cd35a30248fb20$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});


parcelRegister("8Cu0c", function(module, exports) {

$parcel$export(module.exports, "default", () => $6469252af98da682$export$2e2bcd8739ae039);
function $6469252af98da682$var$createThunkMiddleware(extraArgument) {
    return function(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                if (typeof action === 'function') return action(dispatch, getState, extraArgument);
                return next(action);
            };
        };
    };
}
var $6469252af98da682$var$thunk = $6469252af98da682$var$createThunkMiddleware();
$6469252af98da682$var$thunk.withExtraArgument = $6469252af98da682$var$createThunkMiddleware;
var $6469252af98da682$export$2e2bcd8739ae039 = $6469252af98da682$var$thunk;

});


parcelRegister("8OnOc", function(module, exports) {

$parcel$export(module.exports, "createAlgoliaClient", () => $66a576258c3c5b84$export$87d27fb85ba26f49);

var $f2Nkd = parcelRequire("f2Nkd");
function $66a576258c3c5b84$export$87d27fb85ba26f49(algoliaConfig) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Nkd)))(algoliaConfig.applicationId, algoliaConfig.apiKey);
}

});
parcelRegister("f2Nkd", function(module, exports) {
'use strict';

var $38oKI = parcelRequire("38oKI");

var $bRA3t = parcelRequire("bRA3t");
module.exports = $bRA3t($38oKI, 'Browser');

});
parcelRegister("38oKI", function(module, exports) {
module.exports = $248551c8b7135f69$var$AlgoliaSearch;

var $9uH7N = parcelRequire("9uH7N");

var $5Zn4S = parcelRequire("5Zn4S");

var $gWPav = parcelRequire("gWPav");

var $eQwxt = parcelRequire("eQwxt");

var $lyUaN = parcelRequire("lyUaN");

var $bRG5U = parcelRequire("bRG5U");
function $248551c8b7135f69$var$AlgoliaSearch() {
    $eQwxt.apply(this, arguments);
}
$lyUaN($248551c8b7135f69$var$AlgoliaSearch, $eQwxt);
/*
 * Delete an index
 *
 * @param indexName the name of index to delete
 * @param callback the result callback called with two arguments
 *  error: null or Error('message')
 *  content: the server answer that contains the task ID
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.deleteIndex = function(indexName, callback) {
    return this._jsonRequest({
        method: 'DELETE',
        url: '/1/indexes/' + encodeURIComponent(indexName),
        hostType: 'write',
        callback: callback
    });
};
/**
 * Move an existing index.
 * @param srcIndexName the name of index to copy.
 * @param dstIndexName the new index name that will contains a copy of
 * srcIndexName (destination will be overriten if it already exist).
 * @param callback the result callback called with two arguments
 *  error: null or Error('message')
 *  content: the server answer that contains the task ID
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.moveIndex = function(srcIndexName, dstIndexName, callback) {
    var postObj = {
        operation: 'move',
        destination: dstIndexName
    };
    return this._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(srcIndexName) + '/operation',
        body: postObj,
        hostType: 'write',
        callback: callback
    });
};
/**
 * Copy an existing index.
 * @param srcIndexName the name of index to copy.
 * @param dstIndexName the new index name that will contains a copy
 * of srcIndexName (destination will be overriten if it already exist).
 * @param scope an array of scopes to copy: ['settings', 'synonyms', 'rules']
 * @param callback the result callback called with two arguments
 *  error: null or Error('message')
 *  content: the server answer that contains the task ID
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.copyIndex = function(srcIndexName, dstIndexName, scopeOrCallback, _callback) {
    var postObj = {
        operation: 'copy',
        destination: dstIndexName
    };
    var callback = _callback;
    if (typeof scopeOrCallback === 'function') // oops, old behaviour of third argument being a function
    callback = scopeOrCallback;
    else if (Array.isArray(scopeOrCallback) && scopeOrCallback.length > 0) postObj.scope = scopeOrCallback;
    else if (typeof scopeOrCallback !== 'undefined') throw new Error('the scope given to `copyIndex` was not an array with settings, synonyms or rules');
    return this._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(srcIndexName) + '/operation',
        body: postObj,
        hostType: 'write',
        callback: callback
    });
};

/**
 * Return last log entries.
 * @param offset Specify the first entry to retrieve (0-based, 0 is the most recent log entry).
 * @param length Specify the maximum number of entries to retrieve starting
 * at offset. Maximum allowed value: 1000.
 * @param type Specify the maximum number of entries to retrieve starting
 * at offset. Maximum allowed value: 1000.
 * @param callback the result callback called with two arguments
 *  error: null or Error('message')
 *  content: the server answer that contains the task ID
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.getLogs = function(offset, length, callback) {
    var clone = (parcelRequire("eFOtW"));
    var params = {};
    if (typeof offset === 'object') {
        // getLogs(params)
        params = clone(offset);
        callback = length;
    } else if (arguments.length === 0 || typeof offset === 'function') // getLogs([cb])
    callback = offset;
    else if (arguments.length === 1 || typeof length === 'function') {
        // getLogs(1, [cb)]
        callback = length;
        params.offset = offset;
    } else {
        // getLogs(1, 2, [cb])
        params.offset = offset;
        params.length = length;
    }
    if (params.offset === undefined) params.offset = 0;
    if (params.length === undefined) params.length = 10;
    return this._jsonRequest({
        method: 'GET',
        url: '/1/logs?' + this._getSearchParams(params, ''),
        hostType: 'read',
        callback: callback
    });
};
/*
 * List all existing indexes (paginated)
 *
 * @param page The page to retrieve, starting at 0.
 * @param callback the result callback called with two arguments
 *  error: null or Error('message')
 *  content: the server answer with index list
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.listIndexes = function(page, callback) {
    var params = '';
    if (page === undefined || typeof page === 'function') callback = page;
    else params = '?page=' + page;
    return this._jsonRequest({
        method: 'GET',
        url: '/1/indexes' + params,
        hostType: 'read',
        callback: callback
    });
};
/*
 * Get the index object initialized
 *
 * @param indexName the name of index
 * @param callback the result callback with one argument (the Index instance)
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.initIndex = function(indexName) {
    return new $9uH7N(this, indexName);
};

$248551c8b7135f69$var$AlgoliaSearch.prototype.initAnalytics = function(opts) {
    // the actual require must be inside the function, when put outside then you have a cyclic dependency
    // not well resolved that ends up making the main "./index.js" (main module, the agloliasearch function)
    // export an object instead of a function
    // Other workarounds:
    // - rewrite the lib in ES6, cyclic dependencies may be better supported
    // - move initAnalytics to a property on the main module (algoliasearch.initAnalytics),
    // same as places.
    // The current API was made mostly to mimic the one made in PHP
    var createAnalyticsClient = (parcelRequire("hz3TB"));
    return createAnalyticsClient(this.applicationID, this.apiKey, opts);
};
/*
 * @deprecated use client.listApiKeys
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.listUserKeys = $5Zn4S(function(callback) {
    return this.listApiKeys(callback);
}, $gWPav('client.listUserKeys()', 'client.listApiKeys()'));
/*
 * List all existing api keys with their associated ACLs
 *
 * @param callback the result callback called with two arguments
 *  error: null or Error('message')
 *  content: the server answer with api keys list
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.listApiKeys = function(callback) {
    return this._jsonRequest({
        method: 'GET',
        url: '/1/keys',
        hostType: 'read',
        callback: callback
    });
};
/*
 * @deprecated see client.getApiKey
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.getUserKeyACL = $5Zn4S(function(key, callback) {
    return this.getApiKey(key, callback);
}, $gWPav('client.getUserKeyACL()', 'client.getApiKey()'));
/*
 * Get an API key
 *
 * @param key
 * @param callback the result callback called with two arguments
 *  error: null or Error('message')
 *  content: the server answer with the right API key
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.getApiKey = function(key, callback) {
    return this._jsonRequest({
        method: 'GET',
        url: '/1/keys/' + key,
        hostType: 'read',
        callback: callback
    });
};
/*
 * @deprecated see client.deleteApiKey
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.deleteUserKey = $5Zn4S(function(key, callback) {
    return this.deleteApiKey(key, callback);
}, $gWPav('client.deleteUserKey()', 'client.deleteApiKey()'));
/*
 * Delete an existing API key
 * @param key
 * @param callback the result callback called with two arguments
 *  error: null or Error('message')
 *  content: the server answer with the date of deletion
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.deleteApiKey = function(key, callback) {
    return this._jsonRequest({
        method: 'DELETE',
        url: '/1/keys/' + key,
        hostType: 'write',
        callback: callback
    });
};
/**
 * Restore a deleted API key
 *
 * @param {String} key - The key to restore
 * @param {Function} callback - The result callback called with two arguments
 *   error: null or Error('message')
 *   content: the server answer with the restored API key
 * @return {Promise|undefined} Returns a promise if no callback given
 * @example
 * client.restoreApiKey('APIKEY')
 * @see {@link https://www.algolia.com/doc/rest-api/search/#restore-api-key|Algolia REST API Documentation}
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.restoreApiKey = function(key, callback) {
    return this._jsonRequest({
        method: 'POST',
        url: '/1/keys/' + key + '/restore',
        hostType: 'write',
        callback: callback
    });
};
/*
 @deprecated see client.addApiKey
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.addUserKey = $5Zn4S(function(acls, params, callback) {
    return this.addApiKey(acls, params, callback);
}, $gWPav('client.addUserKey()', 'client.addApiKey()'));

/*
 * Add a new global API key
 *
 * @param {string[]} acls - The list of ACL for this key. Defined by an array of strings that
 *   can contains the following values:
 *     - search: allow to search (https and http)
 *     - addObject: allows to add/update an object in the index (https only)
 *     - deleteObject : allows to delete an existing object (https only)
 *     - deleteIndex : allows to delete index content (https only)
 *     - settings : allows to get index settings (https only)
 *     - editSettings : allows to change index settings (https only)
 * @param {Object} [params] - Optionnal parameters to set for the key
 * @param {number} params.validity - Number of seconds after which the key will be automatically removed (0 means no time limit for this key)
 * @param {number} params.maxQueriesPerIPPerHour - Number of API calls allowed from an IP address per hour
 * @param {number} params.maxHitsPerQuery - Number of hits this API key can retrieve in one call
 * @param {string[]} params.indexes - Allowed targeted indexes for this key
 * @param {string} params.description - A description for your key
 * @param {string[]} params.referers - A list of authorized referers
 * @param {Object} params.queryParameters - Force the key to use specific query parameters
 * @param {Function} callback - The result callback called with two arguments
 *   error: null or Error('message')
 *   content: the server answer with the added API key
 * @return {Promise|undefined} Returns a promise if no callback given
 * @example
 * client.addApiKey(['search'], {
 *   validity: 300,
 *   maxQueriesPerIPPerHour: 2000,
 *   maxHitsPerQuery: 3,
 *   indexes: ['fruits'],
 *   description: 'Eat three fruits',
 *   referers: ['*.algolia.com'],
 *   queryParameters: {
 *     tagFilters: ['public'],
 *   }
 * })
 * @see {@link https://www.algolia.com/doc/rest_api#AddKey|Algolia REST API Documentation}
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.addApiKey = function(acls, params, callback) {
    var isArray = (parcelRequire("HZ0dR"));
    var usage = 'Usage: client.addApiKey(arrayOfAcls[, params, callback])';
    if (!isArray(acls)) throw new Error(usage);
    if (arguments.length === 1 || typeof params === 'function') {
        callback = params;
        params = null;
    }
    var postObj = {
        acl: acls
    };
    if (params) {
        postObj.validity = params.validity;
        postObj.maxQueriesPerIPPerHour = params.maxQueriesPerIPPerHour;
        postObj.maxHitsPerQuery = params.maxHitsPerQuery;
        postObj.indexes = params.indexes;
        postObj.description = params.description;
        if (params.queryParameters) postObj.queryParameters = this._getSearchParams(params.queryParameters, '');
        postObj.referers = params.referers;
    }
    return this._jsonRequest({
        method: 'POST',
        url: '/1/keys',
        body: postObj,
        hostType: 'write',
        callback: callback
    });
};
/**
 * @deprecated Please use client.addApiKey()
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.addUserKeyWithValidity = $5Zn4S(function(acls, params, callback) {
    return this.addApiKey(acls, params, callback);
}, $gWPav('client.addUserKeyWithValidity()', 'client.addApiKey()'));
/**
 * @deprecated Please use client.updateApiKey()
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.updateUserKey = $5Zn4S(function(key, acls, params, callback) {
    return this.updateApiKey(key, acls, params, callback);
}, $gWPav('client.updateUserKey()', 'client.updateApiKey()'));

/**
 * Update an existing API key
 * @param {string} key - The key to update
 * @param {string[]} acls - The list of ACL for this key. Defined by an array of strings that
 *   can contains the following values:
 *     - search: allow to search (https and http)
 *     - addObject: allows to add/update an object in the index (https only)
 *     - deleteObject : allows to delete an existing object (https only)
 *     - deleteIndex : allows to delete index content (https only)
 *     - settings : allows to get index settings (https only)
 *     - editSettings : allows to change index settings (https only)
 * @param {Object} [params] - Optionnal parameters to set for the key
 * @param {number} params.validity - Number of seconds after which the key will be automatically removed (0 means no time limit for this key)
 * @param {number} params.maxQueriesPerIPPerHour - Number of API calls allowed from an IP address per hour
 * @param {number} params.maxHitsPerQuery - Number of hits this API key can retrieve in one call
 * @param {string[]} params.indexes - Allowed targeted indexes for this key
 * @param {string} params.description - A description for your key
 * @param {string[]} params.referers - A list of authorized referers
 * @param {Object} params.queryParameters - Force the key to use specific query parameters
 * @param {Function} callback - The result callback called with two arguments
 *   error: null or Error('message')
 *   content: the server answer with the modified API key
 * @return {Promise|undefined} Returns a promise if no callback given
 * @example
 * client.updateApiKey('APIKEY', ['search'], {
 *   validity: 300,
 *   maxQueriesPerIPPerHour: 2000,
 *   maxHitsPerQuery: 3,
 *   indexes: ['fruits'],
 *   description: 'Eat three fruits',
 *   referers: ['*.algolia.com'],
 *   queryParameters: {
 *     tagFilters: ['public'],
 *   }
 * })
 * @see {@link https://www.algolia.com/doc/rest_api#UpdateIndexKey|Algolia REST API Documentation}
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.updateApiKey = function(key, acls, params, callback) {
    var isArray = (parcelRequire("HZ0dR"));
    var usage = 'Usage: client.updateApiKey(key, arrayOfAcls[, params, callback])';
    if (!isArray(acls)) throw new Error(usage);
    if (arguments.length === 2 || typeof params === 'function') {
        callback = params;
        params = null;
    }
    var putObj = {
        acl: acls
    };
    if (params) {
        putObj.validity = params.validity;
        putObj.maxQueriesPerIPPerHour = params.maxQueriesPerIPPerHour;
        putObj.maxHitsPerQuery = params.maxHitsPerQuery;
        putObj.indexes = params.indexes;
        putObj.description = params.description;
        if (params.queryParameters) putObj.queryParameters = this._getSearchParams(params.queryParameters, '');
        putObj.referers = params.referers;
    }
    return this._jsonRequest({
        method: 'PUT',
        url: '/1/keys/' + key,
        body: putObj,
        hostType: 'write',
        callback: callback
    });
};
/**
 * Initialize a new batch of search queries
 * @deprecated use client.search()
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.startQueriesBatch = $5Zn4S(function startQueriesBatchDeprecated() {
    this._batch = [];
}, $gWPav('client.startQueriesBatch()', 'client.search()'));
/**
 * Add a search query in the batch
 * @deprecated use client.search()
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.addQueryInBatch = $5Zn4S(function addQueryInBatchDeprecated(indexName, query, args) {
    this._batch.push({
        indexName: indexName,
        query: query,
        params: args
    });
}, $gWPav('client.addQueryInBatch()', 'client.search()'));
/**
 * Launch the batch of queries using XMLHttpRequest.
 * @deprecated use client.search()
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.sendQueriesBatch = $5Zn4S(function sendQueriesBatchDeprecated(callback) {
    return this.search(this._batch, callback);
}, $gWPav('client.sendQueriesBatch()', 'client.search()'));

/**
 * Perform write operations across multiple indexes.
 *
 * To reduce the amount of time spent on network round trips,
 * you can create, update, or delete several objects in one call,
 * using the batch endpoint (all operations are done in the given order).
 *
 * Available actions:
 *   - addObject
 *   - updateObject
 *   - partialUpdateObject
 *   - partialUpdateObjectNoCreate
 *   - deleteObject
 *
 * https://www.algolia.com/doc/rest_api#Indexes
 * @param  {Object[]} operations An array of operations to perform
 * @return {Promise|undefined} Returns a promise if no callback given
 * @example
 * client.batch([{
 *   action: 'addObject',
 *   indexName: 'clients',
 *   body: {
 *     name: 'Bill'
 *   }
 * }, {
 *   action: 'udpateObject',
 *   indexName: 'fruits',
 *   body: {
 *     objectID: '29138',
 *     name: 'banana'
 *   }
 * }], cb)
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.batch = function(operations, callback) {
    var isArray = (parcelRequire("HZ0dR"));
    var usage = 'Usage: client.batch(operations[, callback])';
    if (!isArray(operations)) throw new Error(usage);
    return this._jsonRequest({
        method: 'POST',
        url: '/1/indexes/*/batch',
        body: {
            requests: operations
        },
        hostType: 'write',
        callback: callback
    });
};
/**
 * Assign or Move a userID to a cluster
 *
 * @param {string} data.userID The userID to assign to a new cluster
 * @param {string} data.cluster The cluster to assign the user to
 * @return {Promise|undefined} Returns a promise if no callback given
 * @example
 * client.assignUserID({ cluster: 'c1-test', userID: 'some-user' });
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.assignUserID = function(data, callback) {
    if (!data.userID || !data.cluster) throw new $bRG5U.AlgoliaSearchError('You have to provide both a userID and cluster', data);
    return this._jsonRequest({
        method: 'POST',
        url: '/1/clusters/mapping',
        hostType: 'write',
        body: {
            cluster: data.cluster
        },
        callback: callback,
        headers: {
            'x-algolia-user-id': data.userID
        }
    });
};
/**
 * Assign a array of userIDs to a cluster.
 *
 * @param {Array} data.userIDs The array of userIDs to assign to a new cluster
 * @param {string} data.cluster The cluster to assign the user to
 * @return {Promise|undefined} Returns a promise if no callback given
 * @example
 * client.assignUserIDs({ cluster: 'c1-test', userIDs: ['some-user-1', 'some-user-2'] });
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.assignUserIDs = function(data, callback) {
    if (!data.userIDs || !data.cluster) throw new $bRG5U.AlgoliaSearchError('You have to provide both an array of userIDs and cluster', data);
    return this._jsonRequest({
        method: 'POST',
        url: '/1/clusters/mapping/batch',
        hostType: 'write',
        body: {
            cluster: data.cluster,
            users: data.userIDs
        },
        callback: callback
    });
};
/**
 * Get the top userIDs
 *
 * (the callback is the second argument)
 *
 * @return {Promise|undefined} Returns a promise if no callback given
 * @example
 * client.getTopUserID();
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.getTopUserID = function(callback) {
    return this._jsonRequest({
        method: 'GET',
        url: '/1/clusters/mapping/top',
        hostType: 'read',
        callback: callback
    });
};
/**
 * Get userID
 *
 * @param {string} data.userID The userID to get info about
 * @return {Promise|undefined} Returns a promise if no callback given
 * @example
 * client.getUserID({ userID: 'some-user' });
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.getUserID = function(data, callback) {
    if (!data.userID) throw new $bRG5U.AlgoliaSearchError('You have to provide a userID', {
        debugData: data
    });
    return this._jsonRequest({
        method: 'GET',
        url: '/1/clusters/mapping/' + data.userID,
        hostType: 'read',
        callback: callback
    });
};
/**
 * List all the clusters
 *
 * (the callback is the second argument)
 *
 * @return {Promise|undefined} Returns a promise if no callback given
 * @example
 * client.listClusters();
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.listClusters = function(callback) {
    return this._jsonRequest({
        method: 'GET',
        url: '/1/clusters',
        hostType: 'read',
        callback: callback
    });
};
/**
 * List the userIDs
 *
 * (the callback is the second argument)
 *
 * @param {string} data.hitsPerPage How many hits on every page
 * @param {string} data.page The page to retrieve
 * @return {Promise|undefined} Returns a promise if no callback given
 * @example
 * client.listClusters();
 * client.listClusters({ page: 3, hitsPerPage: 30});
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.listUserIDs = function(data, callback) {
    return this._jsonRequest({
        method: 'GET',
        url: '/1/clusters/mapping',
        body: data,
        hostType: 'read',
        callback: callback
    });
};
/**
 * Remove an userID
 *
 * @param {string} data.userID The userID to assign to a new cluster
 * @return {Promise|undefined} Returns a promise if no callback given
 * @example
 * client.removeUserID({ userID: 'some-user' });
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.removeUserID = function(data, callback) {
    if (!data.userID) throw new $bRG5U.AlgoliaSearchError('You have to provide a userID', {
        debugData: data
    });
    return this._jsonRequest({
        method: 'DELETE',
        url: '/1/clusters/mapping',
        hostType: 'write',
        callback: callback,
        headers: {
            'x-algolia-user-id': data.userID
        }
    });
};
/**
 * Search for userIDs
 *
 * @param {string} data.cluster The cluster to target
 * @param {string} data.query The query to execute
 * @param {string} data.hitsPerPage How many hits on every page
 * @param {string} data.page The page to retrieve
 * @return {Promise|undefined} Returns a promise if no callback given
 * @example
 * client.searchUserIDs({ cluster: 'c1-test', query: 'some-user' });
 * client.searchUserIDs({
 *   cluster: "c1-test",
 *   query: "some-user",
 *   page: 3,
 *   hitsPerPage: 2
 * });
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.searchUserIDs = function(data, callback) {
    return this._jsonRequest({
        method: 'POST',
        url: '/1/clusters/mapping/search',
        body: data,
        hostType: 'read',
        callback: callback
    });
};
/**
 * Set strategy for personalization
 *
 * @param {Object} data
 * @param {Object} data.eventsScoring Associate a score to an event
 * @param {Object} data.eventsScoring.<eventName> The name of the event
 * @param {Number} data.eventsScoring.<eventName>.score The score to associate to <eventName>
 * @param {String} data.eventsScoring.<eventName>.type Either "click", "conversion" or "view"
 * @param {Object} data.facetsScoring Associate a score to a facet
 * @param {Object} data.facetsScoring.<facetName> The name of the facet
 * @param {Number} data.facetsScoring.<facetName>.score The score to associate to <facetName>
 * @return {Promise|undefined} Returns a promise if no callback given
 * @example
 * client.setPersonalizationStrategy({
 *   eventsScoring: {
 *      "Add to cart": { score: 50, type: "conversion" },
 *      Purchase: { score: 100, type: "conversion" }
 *   },
 *   facetsScoring: {
 *      brand: { score: 100 },
 *      categories: { score: 10 }
 *   }
 * });
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.setPersonalizationStrategy = function(data, callback) {
    return this._jsonRequest({
        method: 'POST',
        url: '/1/recommendation/personalization/strategy',
        body: data,
        hostType: 'write',
        callback: callback
    });
};
/**
 * Get strategy for personalization
 *
 * @return {Promise|undefined} Returns a promise if no callback given
 * @example
 * client.getPersonalizationStrategy();
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.getPersonalizationStrategy = function(callback) {
    return this._jsonRequest({
        method: 'GET',
        url: '/1/recommendation/personalization/strategy',
        hostType: 'read',
        callback: callback
    });
};
// environment specific methods
$248551c8b7135f69$var$AlgoliaSearch.prototype.destroy = $248551c8b7135f69$var$notImplemented;
$248551c8b7135f69$var$AlgoliaSearch.prototype.enableRateLimitForward = $248551c8b7135f69$var$notImplemented;
$248551c8b7135f69$var$AlgoliaSearch.prototype.disableRateLimitForward = $248551c8b7135f69$var$notImplemented;
$248551c8b7135f69$var$AlgoliaSearch.prototype.useSecuredAPIKey = $248551c8b7135f69$var$notImplemented;
$248551c8b7135f69$var$AlgoliaSearch.prototype.disableSecuredAPIKey = $248551c8b7135f69$var$notImplemented;
$248551c8b7135f69$var$AlgoliaSearch.prototype.generateSecuredApiKey = $248551c8b7135f69$var$notImplemented;
$248551c8b7135f69$var$AlgoliaSearch.prototype.getSecuredApiKeyRemainingValidity = $248551c8b7135f69$var$notImplemented;
function $248551c8b7135f69$var$notImplemented() {
    var message = "Not implemented in this environment.\nIf you feel this is a mistake, write to support@algolia.com";
    throw new $bRG5U.AlgoliaSearchError(message);
}

});
parcelRegister("9uH7N", function(module, exports) {

var $lyUaN = parcelRequire("lyUaN");

var $dsyjX = parcelRequire("dsyjX");

var $5Zn4S = parcelRequire("5Zn4S");

var $gWPav = parcelRequire("gWPav");

var $hb1rf = parcelRequire("hb1rf");

var $bRG5U = parcelRequire("bRG5U");
var $6e985e154f6271a8$var$deprecateForwardToSlaves = $5Zn4S(function() {}, $gWPav('forwardToSlaves', 'forwardToReplicas'));
module.exports = $6e985e154f6271a8$var$Index;
function $6e985e154f6271a8$var$Index() {
    $dsyjX.apply(this, arguments);
}
$lyUaN($6e985e154f6271a8$var$Index, $dsyjX);
/*
* Add an object in this index
*
* @param content contains the javascript object to add inside the index
* @param objectID (optional) an objectID you want to attribute to this object
* (if the attribute already exist the old object will be overwrite)
* @param callback (optional) the result callback called with two arguments:
*  error: null or Error('message')
*  content: the server answer that contains 3 elements: createAt, taskId and objectID
*/ $6e985e154f6271a8$var$Index.prototype.addObject = function(content, objectID, callback) {
    var indexObj = this;
    if (arguments.length === 1 || typeof objectID === 'function') {
        callback = objectID;
        objectID = undefined;
    }
    return this.as._jsonRequest({
        method: objectID !== undefined ? 'PUT' : 'POST',
        url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + // create
        (objectID !== undefined ? '/' + encodeURIComponent(objectID) : ''),
        body: content,
        hostType: 'write',
        callback: callback
    });
};

/*
* Add several objects
*
* @param objects contains an array of objects to add
* @param callback (optional) the result callback called with two arguments:
*  error: null or Error('message')
*  content: the server answer that updateAt and taskID
*/ $6e985e154f6271a8$var$Index.prototype.addObjects = function(objects, callback) {
    var isArray = (parcelRequire("HZ0dR"));
    var usage = 'Usage: index.addObjects(arrayOfObjects[, callback])';
    if (!isArray(objects)) throw new Error(usage);
    var indexObj = this;
    var postObj = {
        requests: []
    };
    for(var i = 0; i < objects.length; ++i){
        var request = {
            action: 'addObject',
            body: objects[i]
        };
        postObj.requests.push(request);
    }
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/batch',
        body: postObj,
        hostType: 'write',
        callback: callback
    });
};
/*
* Update partially an object (only update attributes passed in argument)
*
* @param partialObject contains the javascript attributes to override, the
*  object must contains an objectID attribute
* @param createIfNotExists (optional) if false, avoid an automatic creation of the object
* @param callback (optional) the result callback called with two arguments:
*  error: null or Error('message')
*  content: the server answer that contains 3 elements: createAt, taskId and objectID
*/ $6e985e154f6271a8$var$Index.prototype.partialUpdateObject = function(partialObject, createIfNotExists, callback) {
    if (arguments.length === 1 || typeof createIfNotExists === 'function') {
        callback = createIfNotExists;
        createIfNotExists = undefined;
    }
    var indexObj = this;
    var url = '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/' + encodeURIComponent(partialObject.objectID) + '/partial';
    if (createIfNotExists === false) url += '?createIfNotExists=false';
    return this.as._jsonRequest({
        method: 'POST',
        url: url,
        body: partialObject,
        hostType: 'write',
        callback: callback
    });
};

/*
* Partially Override the content of several objects
*
* @param objects contains an array of objects to update (each object must contains a objectID attribute)
* @param callback (optional) the result callback called with two arguments:
*  error: null or Error('message')
*  content: the server answer that updateAt and taskID
*/ $6e985e154f6271a8$var$Index.prototype.partialUpdateObjects = function(objects, createIfNotExists, callback) {
    if (arguments.length === 1 || typeof createIfNotExists === 'function') {
        callback = createIfNotExists;
        createIfNotExists = true;
    }
    var isArray = (parcelRequire("HZ0dR"));
    var usage = 'Usage: index.partialUpdateObjects(arrayOfObjects[, callback])';
    if (!isArray(objects)) throw new Error(usage);
    var indexObj = this;
    var postObj = {
        requests: []
    };
    for(var i = 0; i < objects.length; ++i){
        var request = {
            action: createIfNotExists === true ? 'partialUpdateObject' : 'partialUpdateObjectNoCreate',
            objectID: objects[i].objectID,
            body: objects[i]
        };
        postObj.requests.push(request);
    }
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/batch',
        body: postObj,
        hostType: 'write',
        callback: callback
    });
};
/*
* Override the content of object
*
* @param object contains the javascript object to save, the object must contains an objectID attribute
* @param callback (optional) the result callback called with two arguments:
*  error: null or Error('message')
*  content: the server answer that updateAt and taskID
*/ $6e985e154f6271a8$var$Index.prototype.saveObject = function(object, callback) {
    var indexObj = this;
    return this.as._jsonRequest({
        method: 'PUT',
        url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/' + encodeURIComponent(object.objectID),
        body: object,
        hostType: 'write',
        callback: callback
    });
};

/*
* Override the content of several objects
*
* @param objects contains an array of objects to update (each object must contains a objectID attribute)
* @param callback (optional) the result callback called with two arguments:
*  error: null or Error('message')
*  content: the server answer that updateAt and taskID
*/ $6e985e154f6271a8$var$Index.prototype.saveObjects = function(objects, callback) {
    var isArray = (parcelRequire("HZ0dR"));
    var usage = 'Usage: index.saveObjects(arrayOfObjects[, callback])';
    if (!isArray(objects)) throw new Error(usage);
    var indexObj = this;
    var postObj = {
        requests: []
    };
    for(var i = 0; i < objects.length; ++i){
        var request = {
            action: 'updateObject',
            objectID: objects[i].objectID,
            body: objects[i]
        };
        postObj.requests.push(request);
    }
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/batch',
        body: postObj,
        hostType: 'write',
        callback: callback
    });
};
/*
* Delete an object from the index
*
* @param objectID the unique identifier of object to delete
* @param callback (optional) the result callback called with two arguments:
*  error: null or Error('message')
*  content: the server answer that contains 3 elements: createAt, taskId and objectID
*/ $6e985e154f6271a8$var$Index.prototype.deleteObject = function(objectID, callback) {
    if (typeof objectID === 'function' || typeof objectID !== 'string' && typeof objectID !== 'number') {
        var err = new $bRG5U.AlgoliaSearchError(objectID && typeof objectID !== 'function' ? 'ObjectID must be a string' : 'Cannot delete an object without an objectID');
        callback = objectID;
        if (typeof callback === 'function') return callback(err);
        return this.as._promise.reject(err);
    }
    var indexObj = this;
    return this.as._jsonRequest({
        method: 'DELETE',
        url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/' + encodeURIComponent(objectID),
        hostType: 'write',
        callback: callback
    });
};


/*
* Delete several objects from an index
*
* @param objectIDs contains an array of objectID to delete
* @param callback (optional) the result callback called with two arguments:
*  error: null or Error('message')
*  content: the server answer that contains 3 elements: createAt, taskId and objectID
*/ $6e985e154f6271a8$var$Index.prototype.deleteObjects = function(objectIDs, callback) {
    var isArray = (parcelRequire("HZ0dR"));
    var map = (parcelRequire("4B8vt"));
    var usage = 'Usage: index.deleteObjects(arrayOfObjectIDs[, callback])';
    if (!isArray(objectIDs)) throw new Error(usage);
    var indexObj = this;
    var postObj = {
        requests: map(objectIDs, function prepareRequest(objectID) {
            return {
                action: 'deleteObject',
                objectID: objectID,
                body: {
                    objectID: objectID
                }
            };
        })
    };
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/batch',
        body: postObj,
        hostType: 'write',
        callback: callback
    });
};


/*
* Delete all objects matching a query
*
* @param query the query string
* @param params the optional query parameters
* @param callback (optional) the result callback called with one argument
*  error: null or Error('message')
* @deprecated see index.deleteBy
*/ $6e985e154f6271a8$var$Index.prototype.deleteByQuery = $5Zn4S(function(query, params, callback) {
    var clone = (parcelRequire("eFOtW"));
    var map = (parcelRequire("4B8vt"));
    var indexObj = this;
    var client = indexObj.as;
    if (arguments.length === 1 || typeof params === 'function') {
        callback = params;
        params = {};
    } else params = clone(params);
    params.attributesToRetrieve = 'objectID';
    params.hitsPerPage = 1000;
    params.distinct = false;
    // when deleting, we should never use cache to get the
    // search results
    this.clearCache();
    // there's a problem in how we use the promise chain,
    // see how waitTask is done
    var promise = this.search(query, params).then(stopOrDelete);
    function stopOrDelete(searchContent) {
        // stop here
        if (searchContent.nbHits === 0) // return indexObj.as._request.resolve();
        return searchContent;
        // continue and do a recursive call
        var objectIDs = map(searchContent.hits, function getObjectID(object) {
            return object.objectID;
        });
        return indexObj.deleteObjects(objectIDs).then(waitTask).then(doDeleteByQuery);
    }
    function waitTask(deleteObjectsContent) {
        return indexObj.waitTask(deleteObjectsContent.taskID);
    }
    function doDeleteByQuery() {
        return indexObj.deleteByQuery(query, params);
    }
    if (!callback) return promise;
    promise.then(success, failure);
    function success() {
        $hb1rf(function exit() {
            callback(null);
        }, client._setTimeout || setTimeout);
    }
    function failure(err) {
        $hb1rf(function exit() {
            callback(err);
        }, client._setTimeout || setTimeout);
    }
}, $gWPav('index.deleteByQuery()', 'index.deleteBy()'));
/**
* Delete all objects matching a query
*
* the query parameters that can be used are:
* - filters (numeric, facet, tag)
* - geo
*
* you can not send an empty query or filters
*
* @param params the optional query parameters
* @param callback (optional) the result callback called with one argument
*  error: null or Error('message')
*/ $6e985e154f6271a8$var$Index.prototype.deleteBy = function(params, callback) {
    var indexObj = this;
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/deleteByQuery',
        body: {
            params: indexObj.as._getSearchParams(params, '')
        },
        hostType: 'write',
        callback: callback
    });
};


/*
* Browse all content from an index using events. Basically this will do
* .browse() -> .browseFrom -> .browseFrom -> .. until all the results are returned
*
* @param {string} query - The full text query
* @param {Object} [queryParameters] - Any search query parameter
* @return {EventEmitter}
* @example
* var browser = index.browseAll('cool songs', {
*   tagFilters: 'public,comments',
*   hitsPerPage: 500
* });
*
* browser.on('result', function resultCallback(content) {
*   console.log(content.hits);
* });
*
* // if any error occurs, you get it
* browser.on('error', function(err) {
*   throw err;
* });
*
* // when you have browsed the whole index, you get this event
* browser.on('end', function() {
*   console.log('finished');
* });
*
* // at any point if you want to stop the browsing process, you can stop it manually
* // otherwise it will go on and on
* browser.stop();
*
* @see {@link https://www.algolia.com/doc/rest_api#Browse|Algolia REST API Documentation}
*/ $6e985e154f6271a8$var$Index.prototype.browseAll = function(query, queryParameters) {
    if (typeof query === 'object') {
        queryParameters = query;
        query = undefined;
    }
    var merge = (parcelRequire("e1p6j"));
    var IndexBrowser = (parcelRequire("eSgQh"));
    var browser = new IndexBrowser();
    var client = this.as;
    var index = this;
    var params = client._getSearchParams(merge({}, queryParameters || {}, {
        query: query
    }), '');
    // start browsing
    browseLoop();
    function browseLoop(cursor) {
        if (browser._stopped) return;
        var body;
        if (cursor !== undefined) body = {
            cursor: cursor
        };
        else body = {
            params: params
        };
        client._jsonRequest({
            method: 'POST',
            url: '/1/indexes/' + encodeURIComponent(index.indexName) + '/browse',
            hostType: 'read',
            body: body,
            callback: browseCallback
        });
    }
    function browseCallback(err, content) {
        if (browser._stopped) return;
        if (err) {
            browser._error(err);
            return;
        }
        browser._result(content);
        // no cursor means we are finished browsing
        if (content.cursor === undefined) {
            browser._end();
            return;
        }
        browseLoop(content.cursor);
    }
    return browser;
};
/*
* Get a Typeahead.js adapter
* @param searchParams contains an object with query parameters (see search for details)
*/ $6e985e154f6271a8$var$Index.prototype.ttAdapter = $5Zn4S(function(params) {
    var self = this;
    return function ttAdapter(query, syncCb, asyncCb) {
        var cb;
        if (typeof asyncCb === 'function') // typeahead 0.11
        cb = asyncCb;
        else // pre typeahead 0.11
        cb = syncCb;
        self.search(query, params, function searchDone(err, content) {
            if (err) {
                cb(err);
                return;
            }
            cb(content.hits);
        });
    };
}, "ttAdapter is not necessary anymore and will be removed in the next version,\nhave a look at autocomplete.js (https://github.com/algolia/autocomplete.js)");
/*
* Wait the publication of a task on the server.
* All server task are asynchronous and you can check with this method that the task is published.
*
* @param taskID the id of the task returned by server
* @param callback the result callback with with two arguments:
*  error: null or Error('message')
*  content: the server answer that contains the list of results
*/ $6e985e154f6271a8$var$Index.prototype.waitTask = function(taskID, callback) {
    // wait minimum 100ms before retrying
    var baseDelay = 100;
    // wait maximum 5s before retrying
    var maxDelay = 5000;
    var loop = 0;
    // waitTask() must be handled differently from other methods,
    // it's a recursive method using a timeout
    var indexObj = this;
    var client = indexObj.as;
    var promise = retryLoop();
    function retryLoop() {
        return client._jsonRequest({
            method: 'GET',
            hostType: 'read',
            url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/task/' + taskID
        }).then(function success(content) {
            loop++;
            var delay = baseDelay * loop * loop;
            if (delay > maxDelay) delay = maxDelay;
            if (content.status !== 'published') return client._promise.delay(delay).then(retryLoop);
            return content;
        });
    }
    if (!callback) return promise;
    promise.then(successCb, failureCb);
    function successCb(content) {
        $hb1rf(function exit() {
            callback(null, content);
        }, client._setTimeout || setTimeout);
    }
    function failureCb(err) {
        $hb1rf(function exit() {
            callback(err);
        }, client._setTimeout || setTimeout);
    }
};
/*
* This function deletes the index content. Settings and index specific API keys are kept untouched.
*
* @param callback (optional) the result callback called with two arguments
*  error: null or Error('message')
*  content: the settings object or the error message if a failure occurred
*/ $6e985e154f6271a8$var$Index.prototype.clearIndex = function(callback) {
    var indexObj = this;
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/clear',
        hostType: 'write',
        callback: callback
    });
};
/*
* Get settings of this index
*
* @param opts an object of options to add
* @param opts.advanced get more settings like nbShards (useful for Enterprise)
* @param callback (optional) the result callback called with two arguments
*  error: null or Error('message')
*  content: the settings object or the error message if a failure occurred
*/ $6e985e154f6271a8$var$Index.prototype.getSettings = function(opts, callback) {
    if (arguments.length === 1 && typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    opts = opts || {};
    var indexName = encodeURIComponent(this.indexName);
    return this.as._jsonRequest({
        method: 'GET',
        url: '/1/indexes/' + indexName + '/settings?getVersion=2' + (opts.advanced ? '&advanced=' + opts.advanced : ''),
        hostType: 'read',
        callback: callback
    });
};
$6e985e154f6271a8$var$Index.prototype.searchSynonyms = function(params, callback) {
    if (typeof params === 'function') {
        callback = params;
        params = {};
    } else if (params === undefined) params = {};
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/synonyms/search',
        body: params,
        hostType: 'read',
        callback: callback
    });
};
function $6e985e154f6271a8$var$exportData(method, _hitsPerPage, callback) {
    function search(page, _previous) {
        var options = {
            page: page || 0,
            hitsPerPage: _hitsPerPage || 100
        };
        var previous = _previous || [];
        return method(options).then(function(result) {
            var hits = result.hits;
            var nbHits = result.nbHits;
            var current = hits.map(function(s) {
                delete s._highlightResult;
                return s;
            });
            var synonyms = previous.concat(current);
            if (synonyms.length < nbHits) return search(options.page + 1, synonyms);
            return synonyms;
        });
    }
    return search().then(function(data) {
        if (typeof callback === 'function') {
            callback(data);
            return undefined;
        }
        return data;
    });
}
/**
 * Retrieve all the synonyms in an index
 * @param [number=100] hitsPerPage The amount of synonyms to retrieve per batch
 * @param [function] callback will be called after all synonyms are retrieved
 */ $6e985e154f6271a8$var$Index.prototype.exportSynonyms = function(hitsPerPage, callback) {
    return $6e985e154f6271a8$var$exportData(this.searchSynonyms.bind(this), hitsPerPage, callback);
};
$6e985e154f6271a8$var$Index.prototype.saveSynonym = function(synonym, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    } else if (opts === undefined) opts = {};
    if (opts.forwardToSlaves !== undefined) $6e985e154f6271a8$var$deprecateForwardToSlaves();
    var forwardToReplicas = opts.forwardToSlaves || opts.forwardToReplicas ? 'true' : 'false';
    return this.as._jsonRequest({
        method: 'PUT',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/synonyms/' + encodeURIComponent(synonym.objectID) + '?forwardToReplicas=' + forwardToReplicas,
        body: synonym,
        hostType: 'write',
        callback: callback
    });
};
$6e985e154f6271a8$var$Index.prototype.getSynonym = function(objectID, callback) {
    return this.as._jsonRequest({
        method: 'GET',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/synonyms/' + encodeURIComponent(objectID),
        hostType: 'read',
        callback: callback
    });
};
$6e985e154f6271a8$var$Index.prototype.deleteSynonym = function(objectID, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    } else if (opts === undefined) opts = {};
    if (opts.forwardToSlaves !== undefined) $6e985e154f6271a8$var$deprecateForwardToSlaves();
    var forwardToReplicas = opts.forwardToSlaves || opts.forwardToReplicas ? 'true' : 'false';
    return this.as._jsonRequest({
        method: 'DELETE',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/synonyms/' + encodeURIComponent(objectID) + '?forwardToReplicas=' + forwardToReplicas,
        hostType: 'write',
        callback: callback
    });
};
$6e985e154f6271a8$var$Index.prototype.clearSynonyms = function(opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    } else if (opts === undefined) opts = {};
    if (opts.forwardToSlaves !== undefined) $6e985e154f6271a8$var$deprecateForwardToSlaves();
    var forwardToReplicas = opts.forwardToSlaves || opts.forwardToReplicas ? 'true' : 'false';
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/synonyms/clear' + '?forwardToReplicas=' + forwardToReplicas,
        hostType: 'write',
        callback: callback
    });
};
$6e985e154f6271a8$var$Index.prototype.batchSynonyms = function(synonyms, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    } else if (opts === undefined) opts = {};
    if (opts.forwardToSlaves !== undefined) $6e985e154f6271a8$var$deprecateForwardToSlaves();
    var forwardToReplicas = opts.forwardToSlaves || opts.forwardToReplicas ? 'true' : 'false';
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/synonyms/batch' + '?forwardToReplicas=' + forwardToReplicas + '&replaceExistingSynonyms=' + (opts.replaceExistingSynonyms ? 'true' : 'false'),
        hostType: 'write',
        body: synonyms,
        callback: callback
    });
};
$6e985e154f6271a8$var$Index.prototype.searchRules = function(params, callback) {
    if (typeof params === 'function') {
        callback = params;
        params = {};
    } else if (params === undefined) params = {};
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/rules/search',
        body: params,
        hostType: 'read',
        callback: callback
    });
};
/**
 * Retrieve all the query rules in an index
 * @param [number=100] hitsPerPage The amount of query rules to retrieve per batch
 * @param [function] callback will be called after all query rules are retrieved
 *  error: null or Error('message')
 */ $6e985e154f6271a8$var$Index.prototype.exportRules = function(hitsPerPage, callback) {
    return $6e985e154f6271a8$var$exportData(this.searchRules.bind(this), hitsPerPage, callback);
};
$6e985e154f6271a8$var$Index.prototype.saveRule = function(rule, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    } else if (opts === undefined) opts = {};
    if (!rule.objectID) throw new $bRG5U.AlgoliaSearchError('Missing or empty objectID field for rule');
    var forwardToReplicas = opts.forwardToReplicas === true ? 'true' : 'false';
    return this.as._jsonRequest({
        method: 'PUT',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/rules/' + encodeURIComponent(rule.objectID) + '?forwardToReplicas=' + forwardToReplicas,
        body: rule,
        hostType: 'write',
        callback: callback
    });
};
$6e985e154f6271a8$var$Index.prototype.getRule = function(objectID, callback) {
    return this.as._jsonRequest({
        method: 'GET',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/rules/' + encodeURIComponent(objectID),
        hostType: 'read',
        callback: callback
    });
};
$6e985e154f6271a8$var$Index.prototype.deleteRule = function(objectID, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    } else if (opts === undefined) opts = {};
    var forwardToReplicas = opts.forwardToReplicas === true ? 'true' : 'false';
    return this.as._jsonRequest({
        method: 'DELETE',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/rules/' + encodeURIComponent(objectID) + '?forwardToReplicas=' + forwardToReplicas,
        hostType: 'write',
        callback: callback
    });
};
$6e985e154f6271a8$var$Index.prototype.clearRules = function(opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    } else if (opts === undefined) opts = {};
    var forwardToReplicas = opts.forwardToReplicas === true ? 'true' : 'false';
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/rules/clear' + '?forwardToReplicas=' + forwardToReplicas,
        hostType: 'write',
        callback: callback
    });
};
$6e985e154f6271a8$var$Index.prototype.batchRules = function(rules, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    } else if (opts === undefined) opts = {};
    var forwardToReplicas = opts.forwardToReplicas === true ? 'true' : 'false';
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/rules/batch' + '?forwardToReplicas=' + forwardToReplicas + '&clearExistingRules=' + (opts.clearExistingRules === true ? 'true' : 'false'),
        hostType: 'write',
        body: rules,
        callback: callback
    });
};
$6e985e154f6271a8$var$Index.prototype.exists = function(callback) {
    var result = this.getSettings().then(function() {
        return true;
    }).catch(function(err) {
        if (err instanceof $bRG5U.AlgoliaSearchError && err.statusCode === 404) return false;
        throw err;
    });
    if (typeof callback !== 'function') return result;
    result.then(function(res) {
        callback(null, res);
    }).catch(function(err) {
        callback(err);
    });
};
$6e985e154f6271a8$var$Index.prototype.findObject = function(findCallback, requestOptions, callback) {
    requestOptions = requestOptions === undefined ? {} : requestOptions;
    var paginate = requestOptions.paginate !== undefined ? requestOptions.paginate : true;
    var query = requestOptions.query !== undefined ? requestOptions.query : '';
    var that = this;
    var page = 0;
    var paginateLoop = function() {
        requestOptions.page = page;
        return that.search(query, requestOptions).then(function(result) {
            var hits = result.hits;
            for(var position = 0; position < hits.length; position++){
                var hit = hits[position];
                if (findCallback(hit)) return {
                    object: hit,
                    position: position,
                    page: page
                };
            }
            page += 1;
            // paginate if option was set and has next page
            if (!paginate || page >= result.nbPages) throw new $bRG5U.ObjectNotFound('Object not found');
            return paginateLoop();
        });
    };
    var promise = paginateLoop(page);
    if (callback === undefined) return promise;
    promise.then(function(res) {
        callback(null, res);
    }).catch(function(err) {
        callback(err);
    });
};
$6e985e154f6271a8$var$Index.prototype.getObjectPosition = function(result, objectID) {
    var hits = result.hits;
    for(var position = 0; position < hits.length; position++){
        if (hits[position].objectID === objectID) return position;
    }
    return -1;
};
/*
* Set settings for this index
*
* @param settings the settings object that can contains :
* - minWordSizefor1Typo: (integer) the minimum number of characters to accept one typo (default = 3).
* - minWordSizefor2Typos: (integer) the minimum number of characters to accept two typos (default = 7).
* - hitsPerPage: (integer) the number of hits per page (default = 10).
* - attributesToRetrieve: (array of strings) default list of attributes to retrieve in objects.
*   If set to null, all attributes are retrieved.
* - attributesToHighlight: (array of strings) default list of attributes to highlight.
*   If set to null, all indexed attributes are highlighted.
* - attributesToSnippet**: (array of strings) default list of attributes to snippet alongside the number
* of words to return (syntax is attributeName:nbWords).
*   By default no snippet is computed. If set to null, no snippet is computed.
* - attributesToIndex: (array of strings) the list of fields you want to index.
*   If set to null, all textual and numerical attributes of your objects are indexed,
*   but you should update it to get optimal results.
*   This parameter has two important uses:
*     - Limit the attributes to index: For example if you store a binary image in base64,
*     you want to store it and be able to
*       retrieve it but you don't want to search in the base64 string.
*     - Control part of the ranking*: (see the ranking parameter for full explanation)
*     Matches in attributes at the beginning of
*       the list will be considered more important than matches in attributes further down the list.
*       In one attribute, matching text at the beginning of the attribute will be
*       considered more important than text after, you can disable
*       this behavior if you add your attribute inside `unordered(AttributeName)`,
*       for example attributesToIndex: ["title", "unordered(text)"].
* - attributesForFaceting: (array of strings) The list of fields you want to use for faceting.
*   All strings in the attribute selected for faceting are extracted and added as a facet.
*   If set to null, no attribute is used for faceting.
* - attributeForDistinct: (string) The attribute name used for the Distinct feature.
* This feature is similar to the SQL "distinct" keyword: when enabled
*   in query with the distinct=1 parameter, all hits containing a duplicate
*   value for this attribute are removed from results.
*   For example, if the chosen attribute is show_name and several hits have
*   the same value for show_name, then only the best one is kept and others are removed.
* - ranking: (array of strings) controls the way results are sorted.
*   We have six available criteria:
*    - typo: sort according to number of typos,
*    - geo: sort according to decreassing distance when performing a geo-location based search,
*    - proximity: sort according to the proximity of query words in hits,
*    - attribute: sort according to the order of attributes defined by attributesToIndex,
*    - exact:
*        - if the user query contains one word: sort objects having an attribute
*        that is exactly the query word before others.
*          For example if you search for the "V" TV show, you want to find it
*          with the "V" query and avoid to have all popular TV
*          show starting by the v letter before it.
*        - if the user query contains multiple words: sort according to the
*        number of words that matched exactly (and not as a prefix).
*    - custom: sort according to a user defined formula set in **customRanking** attribute.
*   The standard order is ["typo", "geo", "proximity", "attribute", "exact", "custom"]
* - customRanking: (array of strings) lets you specify part of the ranking.
*   The syntax of this condition is an array of strings containing attributes
*   prefixed by asc (ascending order) or desc (descending order) operator.
*   For example `"customRanking" => ["desc(population)", "asc(name)"]`
* - queryType: Select how the query words are interpreted, it can be one of the following value:
*   - prefixAll: all query words are interpreted as prefixes,
*   - prefixLast: only the last word is interpreted as a prefix (default behavior),
*   - prefixNone: no query word is interpreted as a prefix. This option is not recommended.
* - highlightPreTag: (string) Specify the string that is inserted before
* the highlighted parts in the query result (default to "<em>").
* - highlightPostTag: (string) Specify the string that is inserted after
* the highlighted parts in the query result (default to "</em>").
* - optionalWords: (array of strings) Specify a list of words that should
* be considered as optional when found in the query.
* @param callback (optional) the result callback called with two arguments
*  error: null or Error('message')
*  content: the server answer or the error message if a failure occurred
*/ $6e985e154f6271a8$var$Index.prototype.setSettings = function(settings, opts, callback) {
    if (arguments.length === 1 || typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    if (opts.forwardToSlaves !== undefined) $6e985e154f6271a8$var$deprecateForwardToSlaves();
    var forwardToReplicas = opts.forwardToSlaves || opts.forwardToReplicas ? 'true' : 'false';
    var indexObj = this;
    return this.as._jsonRequest({
        method: 'PUT',
        url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/settings?forwardToReplicas=' + forwardToReplicas,
        hostType: 'write',
        body: settings,
        callback: callback
    });
};
/*
* @deprecated see client.listApiKeys()
*/ $6e985e154f6271a8$var$Index.prototype.listUserKeys = $5Zn4S(function(callback) {
    return this.listApiKeys(callback);
}, $gWPav('index.listUserKeys()', 'client.listApiKeys()'));
/*
* List all existing API keys to this index
*
* @param callback the result callback called with two arguments
*  error: null or Error('message')
*  content: the server answer with API keys belonging to the index
*
* @deprecated see client.listApiKeys()
*/ $6e985e154f6271a8$var$Index.prototype.listApiKeys = $5Zn4S(function(callback) {
    var indexObj = this;
    return this.as._jsonRequest({
        method: 'GET',
        url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/keys',
        hostType: 'read',
        callback: callback
    });
}, $gWPav('index.listApiKeys()', 'client.listApiKeys()'));
/*
* @deprecated see client.getApiKey()
*/ $6e985e154f6271a8$var$Index.prototype.getUserKeyACL = $5Zn4S(function(key, callback) {
    return this.getApiKey(key, callback);
}, $gWPav('index.getUserKeyACL()', 'client.getApiKey()'));
/*
* Get an API key from this index
*
* @param key
* @param callback the result callback called with two arguments
*  error: null or Error('message')
*  content: the server answer with the right API key
*
* @deprecated see client.getApiKey()
*/ $6e985e154f6271a8$var$Index.prototype.getApiKey = $5Zn4S(function(key, callback) {
    var indexObj = this;
    return this.as._jsonRequest({
        method: 'GET',
        url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/keys/' + key,
        hostType: 'read',
        callback: callback
    });
}, $gWPav('index.getApiKey()', 'client.getApiKey()'));
/*
* @deprecated see client.deleteApiKey()
*/ $6e985e154f6271a8$var$Index.prototype.deleteUserKey = $5Zn4S(function(key, callback) {
    return this.deleteApiKey(key, callback);
}, $gWPav('index.deleteUserKey()', 'client.deleteApiKey()'));
/*
* Delete an existing API key associated to this index
*
* @param key
* @param callback the result callback called with two arguments
*  error: null or Error('message')
*  content: the server answer with the deletion date
*
* @deprecated see client.deleteApiKey()
*/ $6e985e154f6271a8$var$Index.prototype.deleteApiKey = $5Zn4S(function(key, callback) {
    var indexObj = this;
    return this.as._jsonRequest({
        method: 'DELETE',
        url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/keys/' + key,
        hostType: 'write',
        callback: callback
    });
}, $gWPav('index.deleteApiKey()', 'client.deleteApiKey()'));
/*
* @deprecated see client.addApiKey()
*/ $6e985e154f6271a8$var$Index.prototype.addUserKey = $5Zn4S(function(acls, params, callback) {
    return this.addApiKey(acls, params, callback);
}, $gWPav('index.addUserKey()', 'client.addApiKey()'));

/*
* Add a new API key to this index
*
* @param {string[]} acls - The list of ACL for this key. Defined by an array of strings that
*   can contains the following values:
*     - search: allow to search (https and http)
*     - addObject: allows to add/update an object in the index (https only)
*     - deleteObject : allows to delete an existing object (https only)
*     - deleteIndex : allows to delete index content (https only)
*     - settings : allows to get index settings (https only)
*     - editSettings : allows to change index settings (https only)
* @param {Object} [params] - Optionnal parameters to set for the key
* @param {number} params.validity - Number of seconds after which the key will
* be automatically removed (0 means no time limit for this key)
* @param {number} params.maxQueriesPerIPPerHour - Number of API calls allowed from an IP address per hour
* @param {number} params.maxHitsPerQuery - Number of hits this API key can retrieve in one call
* @param {string} params.description - A description for your key
* @param {string[]} params.referers - A list of authorized referers
* @param {Object} params.queryParameters - Force the key to use specific query parameters
* @param {Function} callback - The result callback called with two arguments
*   error: null or Error('message')
*   content: the server answer with the added API key
* @return {Promise|undefined} Returns a promise if no callback given
* @example
* index.addUserKey(['search'], {
*   validity: 300,
*   maxQueriesPerIPPerHour: 2000,
*   maxHitsPerQuery: 3,
*   description: 'Eat three fruits',
*   referers: ['*.algolia.com'],
*   queryParameters: {
*     tagFilters: ['public'],
*   }
* })
* @see {@link https://www.algolia.com/doc/rest_api#AddIndexKey|Algolia REST API Documentation}
*
* @deprecated see client.addApiKey()
*/ $6e985e154f6271a8$var$Index.prototype.addApiKey = $5Zn4S(function(acls, params, callback) {
    var isArray = (parcelRequire("HZ0dR"));
    var usage = 'Usage: index.addApiKey(arrayOfAcls[, params, callback])';
    if (!isArray(acls)) throw new Error(usage);
    if (arguments.length === 1 || typeof params === 'function') {
        callback = params;
        params = null;
    }
    var postObj = {
        acl: acls
    };
    if (params) {
        postObj.validity = params.validity;
        postObj.maxQueriesPerIPPerHour = params.maxQueriesPerIPPerHour;
        postObj.maxHitsPerQuery = params.maxHitsPerQuery;
        postObj.description = params.description;
        if (params.queryParameters) postObj.queryParameters = this.as._getSearchParams(params.queryParameters, '');
        postObj.referers = params.referers;
    }
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/keys',
        body: postObj,
        hostType: 'write',
        callback: callback
    });
}, $gWPav('index.addApiKey()', 'client.addApiKey()'));
/**
* @deprecated use client.addApiKey()
*/ $6e985e154f6271a8$var$Index.prototype.addUserKeyWithValidity = $5Zn4S(function deprecatedAddUserKeyWithValidity(acls, params, callback) {
    return this.addApiKey(acls, params, callback);
}, $gWPav('index.addUserKeyWithValidity()', 'client.addApiKey()'));
/*
* @deprecated see client.updateApiKey()
*/ $6e985e154f6271a8$var$Index.prototype.updateUserKey = $5Zn4S(function(key, acls, params, callback) {
    return this.updateApiKey(key, acls, params, callback);
}, $gWPav('index.updateUserKey()', 'client.updateApiKey()'));

/**
* Update an existing API key of this index
* @param {string} key - The key to update
* @param {string[]} acls - The list of ACL for this key. Defined by an array of strings that
*   can contains the following values:
*     - search: allow to search (https and http)
*     - addObject: allows to add/update an object in the index (https only)
*     - deleteObject : allows to delete an existing object (https only)
*     - deleteIndex : allows to delete index content (https only)
*     - settings : allows to get index settings (https only)
*     - editSettings : allows to change index settings (https only)
* @param {Object} [params] - Optionnal parameters to set for the key
* @param {number} params.validity - Number of seconds after which the key will
* be automatically removed (0 means no time limit for this key)
* @param {number} params.maxQueriesPerIPPerHour - Number of API calls allowed from an IP address per hour
* @param {number} params.maxHitsPerQuery - Number of hits this API key can retrieve in one call
* @param {string} params.description - A description for your key
* @param {string[]} params.referers - A list of authorized referers
* @param {Object} params.queryParameters - Force the key to use specific query parameters
* @param {Function} callback - The result callback called with two arguments
*   error: null or Error('message')
*   content: the server answer with user keys list
* @return {Promise|undefined} Returns a promise if no callback given
* @example
* index.updateApiKey('APIKEY', ['search'], {
*   validity: 300,
*   maxQueriesPerIPPerHour: 2000,
*   maxHitsPerQuery: 3,
*   description: 'Eat three fruits',
*   referers: ['*.algolia.com'],
*   queryParameters: {
*     tagFilters: ['public'],
*   }
* })
* @see {@link https://www.algolia.com/doc/rest_api#UpdateIndexKey|Algolia REST API Documentation}
*
* @deprecated see client.updateApiKey()
*/ $6e985e154f6271a8$var$Index.prototype.updateApiKey = $5Zn4S(function(key, acls, params, callback) {
    var isArray = (parcelRequire("HZ0dR"));
    var usage = 'Usage: index.updateApiKey(key, arrayOfAcls[, params, callback])';
    if (!isArray(acls)) throw new Error(usage);
    if (arguments.length === 2 || typeof params === 'function') {
        callback = params;
        params = null;
    }
    var putObj = {
        acl: acls
    };
    if (params) {
        putObj.validity = params.validity;
        putObj.maxQueriesPerIPPerHour = params.maxQueriesPerIPPerHour;
        putObj.maxHitsPerQuery = params.maxHitsPerQuery;
        putObj.description = params.description;
        if (params.queryParameters) putObj.queryParameters = this.as._getSearchParams(params.queryParameters, '');
        putObj.referers = params.referers;
    }
    return this.as._jsonRequest({
        method: 'PUT',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/keys/' + key,
        body: putObj,
        hostType: 'write',
        callback: callback
    });
}, $gWPav('index.updateApiKey()', 'client.updateApiKey()'));

});
parcelRegister("lyUaN", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("dsyjX", function(module, exports) {

var $lfQVS = parcelRequire("lfQVS");

var $5Zn4S = parcelRequire("5Zn4S");

var $gWPav = parcelRequire("gWPav");
module.exports = $9cc883490bc9625b$var$IndexCore;
/*
* Index class constructor.
* You should not use this method directly but use initIndex() function
*/ function $9cc883490bc9625b$var$IndexCore(algoliasearch, indexName) {
    this.indexName = indexName;
    this.as = algoliasearch;
    this.typeAheadArgs = null;
    this.typeAheadValueOption = null;
    // make sure every index instance has it's own cache
    this.cache = {};
}
/*
* Clear all queries in cache
*/ $9cc883490bc9625b$var$IndexCore.prototype.clearCache = function() {
    this.cache = {};
};
/*
* Search inside the index using XMLHttpRequest request (Using a POST query to
* minimize number of OPTIONS queries: Cross-Origin Resource Sharing).
*
* @param {string} [query] the full text query
* @param {object} [args] (optional) if set, contains an object with query parameters:
* - page: (integer) Pagination parameter used to select the page to retrieve.
*                   Page is zero-based and defaults to 0. Thus,
*                   to retrieve the 10th page you need to set page=9
* - hitsPerPage: (integer) Pagination parameter used to select the number of hits per page. Defaults to 20.
* - attributesToRetrieve: a string that contains the list of object attributes
* you want to retrieve (let you minimize the answer size).
*   Attributes are separated with a comma (for example "name,address").
*   You can also use an array (for example ["name","address"]).
*   By default, all attributes are retrieved. You can also use '*' to retrieve all
*   values when an attributesToRetrieve setting is specified for your index.
* - attributesToHighlight: a string that contains the list of attributes you
*   want to highlight according to the query.
*   Attributes are separated by a comma. You can also use an array (for example ["name","address"]).
*   If an attribute has no match for the query, the raw value is returned.
*   By default all indexed text attributes are highlighted.
*   You can use `*` if you want to highlight all textual attributes.
*   Numerical attributes are not highlighted.
*   A matchLevel is returned for each highlighted attribute and can contain:
*      - full: if all the query terms were found in the attribute,
*      - partial: if only some of the query terms were found,
*      - none: if none of the query terms were found.
* - attributesToSnippet: a string that contains the list of attributes to snippet alongside
* the number of words to return (syntax is `attributeName:nbWords`).
*    Attributes are separated by a comma (Example: attributesToSnippet=name:10,content:10).
*    You can also use an array (Example: attributesToSnippet: ['name:10','content:10']).
*    By default no snippet is computed.
* - minWordSizefor1Typo: the minimum number of characters in a query word to accept one typo in this word.
* Defaults to 3.
* - minWordSizefor2Typos: the minimum number of characters in a query word
* to accept two typos in this word. Defaults to 7.
* - getRankingInfo: if set to 1, the result hits will contain ranking
* information in _rankingInfo attribute.
* - aroundLatLng: search for entries around a given
* latitude/longitude (specified as two floats separated by a comma).
*   For example aroundLatLng=47.316669,5.016670).
*   You can specify the maximum distance in meters with the aroundRadius parameter (in meters)
*   and the precision for ranking with aroundPrecision
*   (for example if you set aroundPrecision=100, two objects that are distant of
*   less than 100m will be considered as identical for "geo" ranking parameter).
*   At indexing, you should specify geoloc of an object with the _geoloc attribute
*   (in the form {"_geoloc":{"lat":48.853409, "lng":2.348800}})
* - insideBoundingBox: search entries inside a given area defined by the two extreme points
* of a rectangle (defined by 4 floats: p1Lat,p1Lng,p2Lat,p2Lng).
*   For example insideBoundingBox=47.3165,4.9665,47.3424,5.0201).
*   At indexing, you should specify geoloc of an object with the _geoloc attribute
*   (in the form {"_geoloc":{"lat":48.853409, "lng":2.348800}})
* - numericFilters: a string that contains the list of numeric filters you want to
* apply separated by a comma.
*   The syntax of one filter is `attributeName` followed by `operand` followed by `value`.
*   Supported operands are `<`, `<=`, `=`, `>` and `>=`.
*   You can have multiple conditions on one attribute like for example numericFilters=price>100,price<1000.
*   You can also use an array (for example numericFilters: ["price>100","price<1000"]).
* - tagFilters: filter the query by a set of tags. You can AND tags by separating them by commas.
*   To OR tags, you must add parentheses. For example, tags=tag1,(tag2,tag3) means tag1 AND (tag2 OR tag3).
*   You can also use an array, for example tagFilters: ["tag1",["tag2","tag3"]]
*   means tag1 AND (tag2 OR tag3).
*   At indexing, tags should be added in the _tags** attribute
*   of objects (for example {"_tags":["tag1","tag2"]}).
* - facetFilters: filter the query by a list of facets.
*   Facets are separated by commas and each facet is encoded as `attributeName:value`.
*   For example: `facetFilters=category:Book,author:John%20Doe`.
*   You can also use an array (for example `["category:Book","author:John%20Doe"]`).
* - facets: List of object attributes that you want to use for faceting.
*   Comma separated list: `"category,author"` or array `['category','author']`
*   Only attributes that have been added in **attributesForFaceting** index setting
*   can be used in this parameter.
*   You can also use `*` to perform faceting on all attributes specified in **attributesForFaceting**.
* - queryType: select how the query words are interpreted, it can be one of the following value:
*    - prefixAll: all query words are interpreted as prefixes,
*    - prefixLast: only the last word is interpreted as a prefix (default behavior),
*    - prefixNone: no query word is interpreted as a prefix. This option is not recommended.
* - optionalWords: a string that contains the list of words that should
* be considered as optional when found in the query.
*   Comma separated and array are accepted.
* - distinct: If set to 1, enable the distinct feature (disabled by default)
* if the attributeForDistinct index setting is set.
*   This feature is similar to the SQL "distinct" keyword: when enabled
*   in a query with the distinct=1 parameter,
*   all hits containing a duplicate value for the attributeForDistinct attribute are removed from results.
*   For example, if the chosen attribute is show_name and several hits have
*   the same value for show_name, then only the best
*   one is kept and others are removed.
* - restrictSearchableAttributes: List of attributes you want to use for
* textual search (must be a subset of the attributesToIndex index setting)
* either comma separated or as an array
* @param {function} [callback] the result callback called with two arguments:
*  error: null or Error('message'). If false, the content contains the error.
*  content: the server answer that contains the list of results.
*/ $9cc883490bc9625b$var$IndexCore.prototype.search = $lfQVS('query');
/*
* -- BETA --
* Search a record similar to the query inside the index using XMLHttpRequest request (Using a POST query to
* minimize number of OPTIONS queries: Cross-Origin Resource Sharing).
*
* @param {string} [query] the similar query
* @param {object} [args] (optional) if set, contains an object with query parameters.
*   All search parameters are supported (see search function), restrictSearchableAttributes and facetFilters
*   are the two most useful to restrict the similar results and get more relevant content
*/ $9cc883490bc9625b$var$IndexCore.prototype.similarSearch = $5Zn4S($lfQVS('similarQuery'), $gWPav('index.similarSearch(query[, callback])', 'index.search({ similarQuery: query }[, callback])'));

/*
* Browse index content. The response content will have a `cursor` property that you can use
* to browse subsequent pages for this query. Use `index.browseFrom(cursor)` when you want.
*
* @param {string} query - The full text query
* @param {Object} [queryParameters] - Any search query parameter
* @param {Function} [callback] - The result callback called with two arguments
*   error: null or Error('message')
*   content: the server answer with the browse result
* @return {Promise|undefined} Returns a promise if no callback given
* @example
* index.browse('cool songs', {
*   tagFilters: 'public,comments',
*   hitsPerPage: 500
* }, callback);
* @see {@link https://www.algolia.com/doc/rest_api#Browse|Algolia REST API Documentation}
*/ $9cc883490bc9625b$var$IndexCore.prototype.browse = function(query, queryParameters, callback) {
    var merge = (parcelRequire("e1p6j"));
    var indexObj = this;
    var page;
    var hitsPerPage;
    // we check variadic calls that are not the one defined
    // .browse()/.browse(fn)
    // => page = 0
    if (arguments.length === 0 || arguments.length === 1 && typeof arguments[0] === 'function') {
        page = 0;
        callback = arguments[0];
        query = undefined;
    } else if (typeof arguments[0] === 'number') {
        // .browse(2)/.browse(2, 10)/.browse(2, fn)/.browse(2, 10, fn)
        page = arguments[0];
        if (typeof arguments[1] === 'number') hitsPerPage = arguments[1];
        else if (typeof arguments[1] === 'function') {
            callback = arguments[1];
            hitsPerPage = undefined;
        }
        query = undefined;
        queryParameters = undefined;
    } else if (typeof arguments[0] === 'object') {
        // .browse(queryParameters)/.browse(queryParameters, cb)
        if (typeof arguments[1] === 'function') callback = arguments[1];
        queryParameters = arguments[0];
        query = undefined;
    } else if (typeof arguments[0] === 'string' && typeof arguments[1] === 'function') {
        // .browse(query, cb)
        callback = arguments[1];
        queryParameters = undefined;
    }
    // otherwise it's a .browse(query)/.browse(query, queryParameters)/.browse(query, queryParameters, cb)
    // get search query parameters combining various possible calls
    // to .browse();
    queryParameters = merge({}, queryParameters || {}, {
        page: page,
        hitsPerPage: hitsPerPage,
        query: query
    });
    var params = this.as._getSearchParams(queryParameters, '');
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/browse',
        body: {
            params: params
        },
        hostType: 'read',
        callback: callback
    });
};
/*
* Continue browsing from a previous position (cursor), obtained via a call to `.browse()`.
*
* @param {string} query - The full text query
* @param {Object} [queryParameters] - Any search query parameter
* @param {Function} [callback] - The result callback called with two arguments
*   error: null or Error('message')
*   content: the server answer with the browse result
* @return {Promise|undefined} Returns a promise if no callback given
* @example
* index.browseFrom('14lkfsakl32', callback);
* @see {@link https://www.algolia.com/doc/rest_api#Browse|Algolia REST API Documentation}
*/ $9cc883490bc9625b$var$IndexCore.prototype.browseFrom = function(cursor, callback) {
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/browse',
        body: {
            cursor: cursor
        },
        hostType: 'read',
        callback: callback
    });
};


/*
* Search for facet values
* https://www.algolia.com/doc/rest-api/search#search-for-facet-values
*
* @param {string} params.facetName Facet name, name of the attribute to search for values in.
* Must be declared as a facet
* @param {string} params.facetQuery Query for the facet search
* @param {string} [params.*] Any search parameter of Algolia,
* see https://www.algolia.com/doc/api-client/javascript/search#search-parameters
* Pagination is not supported. The page and hitsPerPage parameters will be ignored.
* @param callback (optional)
*/ $9cc883490bc9625b$var$IndexCore.prototype.searchForFacetValues = function(params, callback) {
    var clone = (parcelRequire("eFOtW"));
    var omit = (parcelRequire("eTtOA"));
    var usage = 'Usage: index.searchForFacetValues({facetName, facetQuery, ...params}[, callback])';
    if (params.facetName === undefined || params.facetQuery === undefined) throw new Error(usage);
    var facetName = params.facetName;
    var filteredParams = omit(clone(params), function(keyName) {
        return keyName === 'facetName';
    });
    var searchParameters = this.as._getSearchParams(filteredParams, '');
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/facets/' + encodeURIComponent(facetName) + '/query',
        hostType: 'read',
        body: {
            params: searchParameters
        },
        callback: callback
    });
};
$9cc883490bc9625b$var$IndexCore.prototype.searchFacet = $5Zn4S(function(params, callback) {
    return this.searchForFacetValues(params, callback);
}, $gWPav('index.searchFacet(params[, callback])', 'index.searchForFacetValues(params[, callback])'));
$9cc883490bc9625b$var$IndexCore.prototype._search = function(params, url, callback, additionalUA) {
    return this.as._jsonRequest({
        cache: this.cache,
        method: 'POST',
        url: url || '/1/indexes/' + encodeURIComponent(this.indexName) + '/query',
        body: {
            params: params
        },
        hostType: 'read',
        fallback: {
            method: 'GET',
            url: '/1/indexes/' + encodeURIComponent(this.indexName),
            body: {
                params: params
            }
        },
        callback: callback,
        additionalUA: additionalUA
    });
};
/*
* Get an object from this index
*
* @param objectID the unique identifier of the object to retrieve
* @param attrs (optional) if set, contains the array of attribute names to retrieve
* @param callback (optional) the result callback called with two arguments
*  error: null or Error('message')
*  content: the object to retrieve or the error message if a failure occurred
*/ $9cc883490bc9625b$var$IndexCore.prototype.getObject = function(objectID, attrs, callback) {
    var indexObj = this;
    if (arguments.length === 1 || typeof attrs === 'function') {
        callback = attrs;
        attrs = undefined;
    }
    var params = '';
    if (attrs !== undefined) {
        params = '?attributes=';
        for(var i = 0; i < attrs.length; ++i){
            if (i !== 0) params += ',';
            params += attrs[i];
        }
    }
    return this.as._jsonRequest({
        method: 'GET',
        url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/' + encodeURIComponent(objectID) + params,
        hostType: 'read',
        callback: callback
    });
};


/*
* Get several objects from this index
*
* @param objectIDs the array of unique identifier of objects to retrieve
*/ $9cc883490bc9625b$var$IndexCore.prototype.getObjects = function(objectIDs, attributesToRetrieve, callback) {
    var isArray = (parcelRequire("HZ0dR"));
    var map = (parcelRequire("4B8vt"));
    var usage = 'Usage: index.getObjects(arrayOfObjectIDs[, callback])';
    if (!isArray(objectIDs)) throw new Error(usage);
    var indexObj = this;
    if (arguments.length === 1 || typeof attributesToRetrieve === 'function') {
        callback = attributesToRetrieve;
        attributesToRetrieve = undefined;
    }
    var body = {
        requests: map(objectIDs, function prepareRequest(objectID) {
            var request = {
                indexName: indexObj.indexName,
                objectID: objectID
            };
            if (attributesToRetrieve) request.attributesToRetrieve = attributesToRetrieve.join(',');
            return request;
        })
    };
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/*/objects',
        hostType: 'read',
        body: body,
        callback: callback
    });
};
$9cc883490bc9625b$var$IndexCore.prototype.as = null;
$9cc883490bc9625b$var$IndexCore.prototype.indexName = null;
$9cc883490bc9625b$var$IndexCore.prototype.typeAheadArgs = null;
$9cc883490bc9625b$var$IndexCore.prototype.typeAheadValueOption = null;

});
parcelRegister("lfQVS", function(module, exports) {
module.exports = $f7940efec25e04bb$var$buildSearchMethod;

var $bRG5U = parcelRequire("bRG5U");
/**
 * Creates a search method to be used in clients
 * @param {string} queryParam the name of the attribute used for the query
 * @param {string} url the url
 * @return {function} the search method
 */ function $f7940efec25e04bb$var$buildSearchMethod(queryParam, url) {
    /**
   * The search method. Prepares the data and send the query to Algolia.
   * @param {string} query the string used for query search
   * @param {object} args additional parameters to send with the search
   * @param {function} [callback] the callback to be called with the client gets the answer
   * @return {undefined|Promise} If the callback is not provided then this methods returns a Promise
   */ return function search(query, args, callback) {
        // warn V2 users on how to search
        if (typeof query === 'function' && typeof args === 'object' || typeof callback === 'object') // .search(query, params, cb)
        // .search(cb, params)
        throw new $bRG5U.AlgoliaSearchError('index.search usage is index.search(query, params, cb)');
        // Normalizing the function signature
        if (arguments.length === 0 || typeof query === 'function') {
            // Usage : .search(), .search(cb)
            callback = query;
            query = '';
        } else if (arguments.length === 1 || typeof args === 'function') {
            // Usage : .search(query/args), .search(query, cb)
            callback = args;
            args = undefined;
        }
        // At this point we have 3 arguments with values
        // Usage : .search(args) // careful: typeof null === 'object'
        if (typeof query === 'object' && query !== null) {
            args = query;
            query = undefined;
        } else if (query === undefined || query === null) query = '';
        var params = '';
        if (query !== undefined) params += queryParam + '=' + encodeURIComponent(query);
        var additionalUA;
        if (args !== undefined) {
            if (args.additionalUA) {
                additionalUA = args.additionalUA;
                delete args.additionalUA;
            }
            // `_getSearchParams` will augment params, do not be fooled by the = versus += from previous if
            params = this.as._getSearchParams(args, params);
        }
        return this._search(params, url, callback, additionalUA);
    };
}

});
parcelRegister("bRG5U", function(module, exports) {
'use strict';

var $lyUaN = parcelRequire("lyUaN");

function $8a354bfab069986d$var$AlgoliaSearchError(message, extraProperties) {
    var forEach = (parcelRequire("8wZP1"));
    var error = this;
    // try to get a stacktrace
    if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
    else error.stack = new Error().stack || 'Cannot get a stacktrace, browser is too old';
    this.name = 'AlgoliaSearchError';
    this.message = message || 'Unknown error';
    if (extraProperties) forEach(extraProperties, function addToErrorObject(value, key) {
        error[key] = value;
    });
}
$lyUaN($8a354bfab069986d$var$AlgoliaSearchError, Error);
function $8a354bfab069986d$var$createCustomError(name, message) {
    function AlgoliaSearchCustomError() {
        var args = Array.prototype.slice.call(arguments, 0);
        // custom message not set, use default
        if (typeof args[0] !== 'string') args.unshift(message);
        $8a354bfab069986d$var$AlgoliaSearchError.apply(this, args);
        this.name = 'AlgoliaSearch' + name + 'Error';
    }
    $lyUaN(AlgoliaSearchCustomError, $8a354bfab069986d$var$AlgoliaSearchError);
    return AlgoliaSearchCustomError;
}
// late exports to let various fn defs and inherits take place
module.exports = {
    AlgoliaSearchError: $8a354bfab069986d$var$AlgoliaSearchError,
    UnparsableJSON: $8a354bfab069986d$var$createCustomError('UnparsableJSON', 'Could not parse the incoming response as JSON, see err.more for details'),
    RequestTimeout: $8a354bfab069986d$var$createCustomError('RequestTimeout', 'Request timed out before getting a response'),
    Network: $8a354bfab069986d$var$createCustomError('Network', 'Network issue, see err.more for details'),
    JSONPScriptFail: $8a354bfab069986d$var$createCustomError('JSONPScriptFail', '<script> was loaded but did not call our provided callback'),
    ValidUntilNotFound: $8a354bfab069986d$var$createCustomError('ValidUntilNotFound', 'The SecuredAPIKey does not have a validUntil parameter.'),
    JSONPScriptError: $8a354bfab069986d$var$createCustomError('JSONPScriptError', '<script> unable to load due to an `error` event on it'),
    ObjectNotFound: $8a354bfab069986d$var$createCustomError('ObjectNotFound', 'Object not found'),
    Unknown: $8a354bfab069986d$var$createCustomError('Unknown', 'Unknown error occured')
};

});
parcelRegister("8wZP1", function(module, exports) {
var $63614473feb41dab$var$hasOwn = Object.prototype.hasOwnProperty;
var $63614473feb41dab$var$toString = Object.prototype.toString;
module.exports = function forEach(obj, fn, ctx) {
    if ($63614473feb41dab$var$toString.call(fn) !== '[object Function]') throw new TypeError('iterator must be a function');
    var l = obj.length;
    if (l === +l) for(var i = 0; i < l; i++)fn.call(ctx, obj[i], i, obj);
    else {
        for(var k in obj)if ($63614473feb41dab$var$hasOwn.call(obj, k)) fn.call(ctx, obj[k], k, obj);
    }
};

});



parcelRegister("5Zn4S", function(module, exports) {
module.exports = function deprecate(fn, message) {
    var warned = false;
    function deprecated() {
        if (!warned) {
            /* eslint no-console:0 */ console.warn(message);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};

});

parcelRegister("gWPav", function(module, exports) {
module.exports = function deprecatedMessage(previousUsage, newUsage) {
    var githubAnchorLink = previousUsage.toLowerCase().replace(/[\.\(\)]/g, '');
    return 'algoliasearch: `' + previousUsage + '` was replaced by `' + newUsage + '`. Please see https://github.com/algolia/algoliasearch-client-javascript/wiki/Deprecated#' + githubAnchorLink;
};

});

parcelRegister("e1p6j", function(module, exports) {

var $8wZP1 = parcelRequire("8wZP1");
module.exports = function merge(destination /* , sources */ ) {
    var sources = Array.prototype.slice.call(arguments);
    $8wZP1(sources, function(source) {
        for(var keyName in source)if (source.hasOwnProperty(keyName)) {
            if (typeof destination[keyName] === 'object' && typeof source[keyName] === 'object') destination[keyName] = merge({}, destination[keyName], source[keyName]);
            else if (source[keyName] !== undefined) destination[keyName] = source[keyName];
        }
    });
    return destination;
};

});

parcelRegister("eFOtW", function(module, exports) {
module.exports = function clone(obj) {
    return JSON.parse(JSON.stringify(obj));
};

});

parcelRegister("eTtOA", function(module, exports) {


module.exports = function omit(obj, test) {
    var keys = (parcelRequire("4jDQV"));
    var foreach = (parcelRequire("8wZP1"));
    var filtered = {};
    foreach(keys(obj), function doFilter(keyName) {
        if (test(keyName) !== true) filtered[keyName] = obj[keyName];
    });
    return filtered;
};

});
parcelRegister("4jDQV", function(module, exports) {
'use strict';
var $3247d9b061104208$var$slice = Array.prototype.slice;

var $96nTn = parcelRequire("96nTn");
var $3247d9b061104208$var$origKeys = Object.keys;

var $3247d9b061104208$var$keysShim = $3247d9b061104208$var$origKeys ? function keys(o) {
    return $3247d9b061104208$var$origKeys(o);
} : (parcelRequire("a7WlO"));
var $3247d9b061104208$var$originalKeys = Object.keys;
$3247d9b061104208$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($96nTn(object)) return $3247d9b061104208$var$originalKeys($3247d9b061104208$var$slice.call(object));
            return $3247d9b061104208$var$originalKeys(object);
        };
    } else Object.keys = $3247d9b061104208$var$keysShim;
    return Object.keys || $3247d9b061104208$var$keysShim;
};
module.exports = $3247d9b061104208$var$keysShim;

});
parcelRegister("96nTn", function(module, exports) {
'use strict';
var $6a0735185fec05e3$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $6a0735185fec05e3$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $6a0735185fec05e3$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("a7WlO", function(module, exports) {
'use strict';
var $75f7d21b7a735a78$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $75f7d21b7a735a78$var$has = Object.prototype.hasOwnProperty;
    var $75f7d21b7a735a78$var$toStr = Object.prototype.toString;
    var $75f7d21b7a735a78$var$isArgs = (parcelRequire("96nTn")); // eslint-disable-line global-require
    var $75f7d21b7a735a78$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $75f7d21b7a735a78$var$hasDontEnumBug = !$75f7d21b7a735a78$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $75f7d21b7a735a78$var$hasProtoEnumBug = $75f7d21b7a735a78$var$isEnumerable.call(function() {}, 'prototype');
    var $75f7d21b7a735a78$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $75f7d21b7a735a78$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $75f7d21b7a735a78$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $75f7d21b7a735a78$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$75f7d21b7a735a78$var$excludedKeys['$' + k] && $75f7d21b7a735a78$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $75f7d21b7a735a78$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $75f7d21b7a735a78$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$75f7d21b7a735a78$var$hasAutomationEqualityBug) return $75f7d21b7a735a78$var$equalsConstructorPrototype(o);
        try {
            return $75f7d21b7a735a78$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $75f7d21b7a735a78$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $75f7d21b7a735a78$var$toStr.call(object) === '[object Function]';
        var isArguments = $75f7d21b7a735a78$var$isArgs(object);
        var isString = isObject && $75f7d21b7a735a78$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $75f7d21b7a735a78$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$75f7d21b7a735a78$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $75f7d21b7a735a78$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($75f7d21b7a735a78$var$hasDontEnumBug) {
            var skipConstructor = $75f7d21b7a735a78$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $75f7d21b7a735a78$var$dontEnums.length; ++k)if (!(skipConstructor && $75f7d21b7a735a78$var$dontEnums[k] === 'constructor') && $75f7d21b7a735a78$var$has.call(object, $75f7d21b7a735a78$var$dontEnums[k])) theKeys.push($75f7d21b7a735a78$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $75f7d21b7a735a78$var$keysShim;

});



parcelRegister("HZ0dR", function(module, exports) {
var $0843561c5784f7ef$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $0843561c5784f7ef$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("4B8vt", function(module, exports) {

var $8wZP1 = parcelRequire("8wZP1");
module.exports = function map(arr, fn) {
    var newArr = [];
    $8wZP1(arr, function(item, itemIndex) {
        newArr.push(fn(item, itemIndex, arr));
    });
    return newArr;
};

});


parcelRegister("hb1rf", function(module, exports) {
// Parse cloud does not supports setTimeout
// We do not store a setTimeout reference in the client everytime
// We only fallback to a fake setTimeout when not available
// setTimeout cannot be override globally sadly
module.exports = function exitPromise(fn, _setTimeout) {
    _setTimeout(fn, 0);
};

});

parcelRegister("eSgQh", function(module, exports) {
'use strict';
// This is the object returned by the `index.browseAll()` method
module.exports = $ad432c584df945d4$var$IndexBrowser;

var $lyUaN = parcelRequire("lyUaN");

var $3yIb1 = parcelRequire("3yIb1");
var $ad432c584df945d4$require$EventEmitter = $3yIb1.EventEmitter;
function $ad432c584df945d4$var$IndexBrowser() {}
$lyUaN($ad432c584df945d4$var$IndexBrowser, $ad432c584df945d4$require$EventEmitter);
$ad432c584df945d4$var$IndexBrowser.prototype.stop = function() {
    this._stopped = true;
    this._clean();
};
$ad432c584df945d4$var$IndexBrowser.prototype._end = function() {
    this.emit('end');
    this._clean();
};
$ad432c584df945d4$var$IndexBrowser.prototype._error = function(err) {
    this.emit('error', err);
    this._clean();
};
$ad432c584df945d4$var$IndexBrowser.prototype._result = function(content) {
    this.emit('result', content);
};
$ad432c584df945d4$var$IndexBrowser.prototype._clean = function() {
    this.removeAllListeners('stop');
    this.removeAllListeners('end');
    this.removeAllListeners('error');
    this.removeAllListeners('result');
};

});
parcelRegister("3yIb1", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
function $2976d0a902c30135$var$EventEmitter() {
    this._events = this._events || {};
    this._maxListeners = this._maxListeners || undefined;
}
module.exports = $2976d0a902c30135$var$EventEmitter;
// Backwards-compat with node 0.10.x
$2976d0a902c30135$var$EventEmitter.EventEmitter = $2976d0a902c30135$var$EventEmitter;
$2976d0a902c30135$var$EventEmitter.prototype._events = undefined;
$2976d0a902c30135$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
$2976d0a902c30135$var$EventEmitter.defaultMaxListeners = 10;
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$2976d0a902c30135$var$EventEmitter.prototype.setMaxListeners = function(n) {
    if (!$2976d0a902c30135$var$isNumber(n) || n < 0 || isNaN(n)) throw TypeError('n must be a positive number');
    this._maxListeners = n;
    return this;
};
$2976d0a902c30135$var$EventEmitter.prototype.emit = function(type) {
    var er, handler, len, args, i, listeners;
    if (!this._events) this._events = {};
    // If there is no 'error' event listener then throw.
    if (type === 'error') {
        if (!this._events.error || $2976d0a902c30135$var$isObject(this._events.error) && !this._events.error.length) {
            er = arguments[1];
            if (er instanceof Error) throw er; // Unhandled 'error' event
            else {
                // At least give some kind of context to the user
                var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
                err.context = er;
                throw err;
            }
        }
    }
    handler = this._events[type];
    if ($2976d0a902c30135$var$isUndefined(handler)) return false;
    if ($2976d0a902c30135$var$isFunction(handler)) switch(arguments.length){
        // fast cases
        case 1:
            handler.call(this);
            break;
        case 2:
            handler.call(this, arguments[1]);
            break;
        case 3:
            handler.call(this, arguments[1], arguments[2]);
            break;
        // slower
        default:
            args = Array.prototype.slice.call(arguments, 1);
            handler.apply(this, args);
    }
    else if ($2976d0a902c30135$var$isObject(handler)) {
        args = Array.prototype.slice.call(arguments, 1);
        listeners = handler.slice();
        len = listeners.length;
        for(i = 0; i < len; i++)listeners[i].apply(this, args);
    }
    return true;
};
$2976d0a902c30135$var$EventEmitter.prototype.addListener = function(type, listener) {
    var m;
    if (!$2976d0a902c30135$var$isFunction(listener)) throw TypeError('listener must be a function');
    if (!this._events) this._events = {};
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (this._events.newListener) this.emit('newListener', type, $2976d0a902c30135$var$isFunction(listener.listener) ? listener.listener : listener);
    if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
    else if ($2976d0a902c30135$var$isObject(this._events[type])) // If we've already got an array, just append.
    this._events[type].push(listener);
    else // Adding the second element, need to change to array.
    this._events[type] = [
        this._events[type],
        listener
    ];
    // Check for listener leak
    if ($2976d0a902c30135$var$isObject(this._events[type]) && !this._events[type].warned) {
        if (!$2976d0a902c30135$var$isUndefined(this._maxListeners)) m = this._maxListeners;
        else m = $2976d0a902c30135$var$EventEmitter.defaultMaxListeners;
        if (m && m > 0 && this._events[type].length > m) {
            this._events[type].warned = true;
            console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[type].length);
            if (typeof console.trace === 'function') // not supported in IE 10
            console.trace();
        }
    }
    return this;
};
$2976d0a902c30135$var$EventEmitter.prototype.on = $2976d0a902c30135$var$EventEmitter.prototype.addListener;
$2976d0a902c30135$var$EventEmitter.prototype.once = function(type, listener) {
    if (!$2976d0a902c30135$var$isFunction(listener)) throw TypeError('listener must be a function');
    var fired = false;
    function g() {
        this.removeListener(type, g);
        if (!fired) {
            fired = true;
            listener.apply(this, arguments);
        }
    }
    g.listener = listener;
    this.on(type, g);
    return this;
};
// emits a 'removeListener' event iff the listener was removed
$2976d0a902c30135$var$EventEmitter.prototype.removeListener = function(type, listener) {
    var list, position, length, i;
    if (!$2976d0a902c30135$var$isFunction(listener)) throw TypeError('listener must be a function');
    if (!this._events || !this._events[type]) return this;
    list = this._events[type];
    length = list.length;
    position = -1;
    if (list === listener || $2976d0a902c30135$var$isFunction(list.listener) && list.listener === listener) {
        delete this._events[type];
        if (this._events.removeListener) this.emit('removeListener', type, listener);
    } else if ($2976d0a902c30135$var$isObject(list)) {
        for(i = length; i-- > 0;)if (list[i] === listener || list[i].listener && list[i].listener === listener) {
            position = i;
            break;
        }
        if (position < 0) return this;
        if (list.length === 1) {
            list.length = 0;
            delete this._events[type];
        } else list.splice(position, 1);
        if (this._events.removeListener) this.emit('removeListener', type, listener);
    }
    return this;
};
$2976d0a902c30135$var$EventEmitter.prototype.removeAllListeners = function(type) {
    var key, listeners;
    if (!this._events) return this;
    // not listening for removeListener, no need to emit
    if (!this._events.removeListener) {
        if (arguments.length === 0) this._events = {};
        else if (this._events[type]) delete this._events[type];
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        for(key in this._events){
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = {};
        return this;
    }
    listeners = this._events[type];
    if ($2976d0a902c30135$var$isFunction(listeners)) this.removeListener(type, listeners);
    else if (listeners) // LIFO order
    while(listeners.length)this.removeListener(type, listeners[listeners.length - 1]);
    delete this._events[type];
    return this;
};
$2976d0a902c30135$var$EventEmitter.prototype.listeners = function(type) {
    var ret;
    if (!this._events || !this._events[type]) ret = [];
    else if ($2976d0a902c30135$var$isFunction(this._events[type])) ret = [
        this._events[type]
    ];
    else ret = this._events[type].slice();
    return ret;
};
$2976d0a902c30135$var$EventEmitter.prototype.listenerCount = function(type) {
    if (this._events) {
        var evlistener = this._events[type];
        if ($2976d0a902c30135$var$isFunction(evlistener)) return 1;
        else if (evlistener) return evlistener.length;
    }
    return 0;
};
$2976d0a902c30135$var$EventEmitter.listenerCount = function(emitter, type) {
    return emitter.listenerCount(type);
};
function $2976d0a902c30135$var$isFunction(arg) {
    return typeof arg === 'function';
}
function $2976d0a902c30135$var$isNumber(arg) {
    return typeof arg === 'number';
}
function $2976d0a902c30135$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
function $2976d0a902c30135$var$isUndefined(arg) {
    return arg === void 0;
}

});



parcelRegister("eQwxt", function(module, exports) {
module.exports = $acef29916697dd9e$var$AlgoliaSearchCore;

var $bRG5U = parcelRequire("bRG5U");

var $hb1rf = parcelRequire("hb1rf");

var $dsyjX = parcelRequire("dsyjX");

var $72Pfb = parcelRequire("72Pfb");
// We will always put the API KEY in the JSON body in case of too long API KEY,
// to avoid query string being too long and failing in various conditions (our server limit, browser limit,
// proxies limit)
var $acef29916697dd9e$var$MAX_API_KEY_LENGTH = 500;
var $acef29916697dd9e$var$RESET_APP_DATA_TIMER = 120000; // after 2 minutes reset to first host




/*
 * Algolia Search library initialization
 * https://www.algolia.com/
 *
 * @param {string} applicationID - Your applicationID, found in your dashboard
 * @param {string} apiKey - Your API key, found in your dashboard
 * @param {Object} [opts]
 * @param {number} [opts.timeout=2000] - The request timeout set in milliseconds,
 * another request will be issued after this timeout
 * @param {string} [opts.protocol='https:'] - The protocol used to query Algolia Search API.
 *                                        Set to 'http:' to force using http.
 * @param {Object|Array} [opts.hosts={
 *           read: [this.applicationID + '-dsn.algolia.net'].concat([
 *             this.applicationID + '-1.algolianet.com',
 *             this.applicationID + '-2.algolianet.com',
 *             this.applicationID + '-3.algolianet.com']
 *           ]),
 *           write: [this.applicationID + '.algolia.net'].concat([
 *             this.applicationID + '-1.algolianet.com',
 *             this.applicationID + '-2.algolianet.com',
 *             this.applicationID + '-3.algolianet.com']
 *           ]) - The hosts to use for Algolia Search API.
 *           If you provide them, you will less benefit from our HA implementation
 */ function $acef29916697dd9e$var$AlgoliaSearchCore(applicationID, apiKey, opts) {
    var debug = (parcelRequire("5KxQY"))('algoliasearch');
    var clone = (parcelRequire("eFOtW"));
    var isArray = (parcelRequire("HZ0dR"));
    var map = (parcelRequire("4B8vt"));
    var usage = 'Usage: algoliasearch(applicationID, apiKey, opts)';
    if (opts._allowEmptyCredentials !== true && !applicationID) throw new $bRG5U.AlgoliaSearchError('Please provide an application ID. ' + usage);
    if (opts._allowEmptyCredentials !== true && !apiKey) throw new $bRG5U.AlgoliaSearchError('Please provide an API key. ' + usage);
    this.applicationID = applicationID;
    this.apiKey = apiKey;
    this.hosts = {
        read: [],
        write: []
    };
    opts = opts || {};
    this._timeouts = opts.timeouts || {
        connect: 1000,
        read: 2000,
        write: 30000
    };
    // backward compat, if opts.timeout is passed, we use it to configure all timeouts like before
    if (opts.timeout) this._timeouts.connect = this._timeouts.read = this._timeouts.write = opts.timeout;
    var protocol = opts.protocol || 'https:';
    // while we advocate for colon-at-the-end values: 'http:' for `opts.protocol`
    // we also accept `http` and `https`. It's a common error.
    if (!/:$/.test(protocol)) protocol = protocol + ':';
    if (protocol !== 'http:' && protocol !== 'https:') throw new $bRG5U.AlgoliaSearchError('protocol must be `http:` or `https:` (was `' + opts.protocol + '`)');
    this._checkAppIdData();
    if (!opts.hosts) {
        var defaultHosts = map(this._shuffleResult, function(hostNumber) {
            return applicationID + '-' + hostNumber + '.algolianet.com';
        });
        // no hosts given, compute defaults
        var mainSuffix = (opts.dsn === false ? '' : '-dsn') + '.algolia.net';
        this.hosts.read = [
            this.applicationID + mainSuffix
        ].concat(defaultHosts);
        this.hosts.write = [
            this.applicationID + '.algolia.net'
        ].concat(defaultHosts);
    } else if (isArray(opts.hosts)) {
        // when passing custom hosts, we need to have a different host index if the number
        // of write/read hosts are different.
        this.hosts.read = clone(opts.hosts);
        this.hosts.write = clone(opts.hosts);
    } else {
        this.hosts.read = clone(opts.hosts.read);
        this.hosts.write = clone(opts.hosts.write);
    }
    // add protocol and lowercase hosts
    this.hosts.read = map(this.hosts.read, $acef29916697dd9e$var$prepareHost(protocol));
    this.hosts.write = map(this.hosts.write, $acef29916697dd9e$var$prepareHost(protocol));
    this.extraHeaders = {};
    // In some situations you might want to warm the cache
    this.cache = opts._cache || {};
    this._ua = opts._ua;
    this._useCache = opts._useCache === undefined || opts._cache ? true : opts._useCache;
    this._useRequestCache = this._useCache && opts._useRequestCache;
    this._useFallback = opts.useFallback === undefined ? true : opts.useFallback;
    this._setTimeout = opts._setTimeout;
    debug('init done, %j', this);
}
/*
 * Get the index object initialized
 *
 * @param indexName the name of index
 * @param callback the result callback with one argument (the Index instance)
 */ $acef29916697dd9e$var$AlgoliaSearchCore.prototype.initIndex = function(indexName) {
    return new $dsyjX(this, indexName);
};
/**
* Add an extra field to the HTTP request
*
* @param name the header field name
* @param value the header field value
*/ $acef29916697dd9e$var$AlgoliaSearchCore.prototype.setExtraHeader = function(name, value) {
    this.extraHeaders[name.toLowerCase()] = value;
};
/**
* Get the value of an extra HTTP header
*
* @param name the header field name
*/ $acef29916697dd9e$var$AlgoliaSearchCore.prototype.getExtraHeader = function(name) {
    return this.extraHeaders[name.toLowerCase()];
};
/**
* Remove an extra field from the HTTP request
*
* @param name the header field name
*/ $acef29916697dd9e$var$AlgoliaSearchCore.prototype.unsetExtraHeader = function(name) {
    delete this.extraHeaders[name.toLowerCase()];
};
/**
* Augment sent x-algolia-agent with more data, each agent part
* is automatically separated from the others by a semicolon;
*
* @param algoliaAgent the agent to add
*/ $acef29916697dd9e$var$AlgoliaSearchCore.prototype.addAlgoliaAgent = function(algoliaAgent) {
    var algoliaAgentWithDelimiter = '; ' + algoliaAgent;
    if (this._ua.indexOf(algoliaAgentWithDelimiter) === -1) this._ua += algoliaAgentWithDelimiter;
};

/*
 * Wrapper that try all hosts to maximize the quality of service
 */ $acef29916697dd9e$var$AlgoliaSearchCore.prototype._jsonRequest = function(initialOpts) {
    this._checkAppIdData();
    var requestDebug = (parcelRequire("5KxQY"))('algoliasearch:' + initialOpts.url);
    var body;
    var cacheID;
    var additionalUA = initialOpts.additionalUA || '';
    var cache = initialOpts.cache;
    var client = this;
    var tries = 0;
    var usingFallback = false;
    var hasFallback = client._useFallback && client._request.fallback && initialOpts.fallback;
    var headers;
    if (this.apiKey.length > $acef29916697dd9e$var$MAX_API_KEY_LENGTH && initialOpts.body !== undefined && (initialOpts.body.params !== undefined || // index.search()
    initialOpts.body.requests !== undefined // client.search()
    )) {
        initialOpts.body.apiKey = this.apiKey;
        headers = this._computeRequestHeaders({
            additionalUA: additionalUA,
            withApiKey: false,
            headers: initialOpts.headers
        });
    } else headers = this._computeRequestHeaders({
        additionalUA: additionalUA,
        headers: initialOpts.headers
    });
    if (initialOpts.body !== undefined) body = $acef29916697dd9e$var$safeJSONStringify(initialOpts.body);
    requestDebug('request start');
    var debugData = [];
    function doRequest(requester, reqOpts) {
        client._checkAppIdData();
        var startTime = new Date();
        if (client._useCache && !client._useRequestCache) cacheID = initialOpts.url;
        // as we sometime use POST requests to pass parameters (like query='aa'),
        // the cacheID must also include the body to be different between calls
        if (client._useCache && !client._useRequestCache && body) cacheID += '_body_' + reqOpts.body;
        // handle cache existence
        if (isCacheValidWithCurrentID(!client._useRequestCache, cache, cacheID)) {
            requestDebug('serving response from cache');
            var responseText = cache[cacheID];
            // Cache response must match the type of the original one
            return client._promise.resolve({
                body: JSON.parse(responseText),
                responseText: responseText
            });
        }
        // if we reached max tries
        if (tries >= client.hosts[initialOpts.hostType].length) {
            if (!hasFallback || usingFallback) {
                requestDebug('could not get any response');
                // then stop
                return client._promise.reject(new $bRG5U.AlgoliaSearchError("Cannot connect to the AlgoliaSearch API. Send an email to support@algolia.com to report and resolve the issue. Application id was: " + client.applicationID, {
                    debugData: debugData
                }));
            }
            requestDebug('switching to fallback');
            // let's try the fallback starting from here
            tries = 0;
            // method, url and body are fallback dependent
            reqOpts.method = initialOpts.fallback.method;
            reqOpts.url = initialOpts.fallback.url;
            reqOpts.jsonBody = initialOpts.fallback.body;
            if (reqOpts.jsonBody) reqOpts.body = $acef29916697dd9e$var$safeJSONStringify(reqOpts.jsonBody);
            // re-compute headers, they could be omitting the API KEY
            headers = client._computeRequestHeaders({
                additionalUA: additionalUA,
                headers: initialOpts.headers
            });
            reqOpts.timeouts = client._getTimeoutsForRequest(initialOpts.hostType);
            client._setHostIndexByType(0, initialOpts.hostType);
            usingFallback = true; // the current request is now using fallback
            return doRequest(client._request.fallback, reqOpts);
        }
        var currentHost = client._getHostByType(initialOpts.hostType);
        var url = currentHost + reqOpts.url;
        var options = {
            body: reqOpts.body,
            jsonBody: reqOpts.jsonBody,
            method: reqOpts.method,
            headers: headers,
            timeouts: reqOpts.timeouts,
            debug: requestDebug,
            forceAuthHeaders: reqOpts.forceAuthHeaders
        };
        requestDebug('method: %s, url: %s, headers: %j, timeouts: %d', options.method, url, options.headers, options.timeouts);
        if (requester === client._request.fallback) requestDebug('using fallback');
        // `requester` is any of this._request or this._request.fallback
        // thus it needs to be called using the client as context
        return requester.call(client, url, options).then(success, tryFallback);
        function success(httpResponse) {
            // compute the status of the response,
            //
            // When in browser mode, using XDR or JSONP, we have no statusCode available
            // So we rely on our API response `status` property.
            // But `waitTask` can set a `status` property which is not the statusCode (it's the task status)
            // So we check if there's a `message` along `status` and it means it's an error
            //
            // That's the only case where we have a response.status that's not the http statusCode
            var status = httpResponse && httpResponse.body && httpResponse.body.message && httpResponse.body.status || // this is important to check the request statusCode AFTER the body eventual
            // statusCode because some implementations (jQuery XDomainRequest transport) may
            // send statusCode 200 while we had an error
            httpResponse.statusCode || // When in browser mode, using XDR or JSONP
            // we default to success when no error (no response.status && response.message)
            // If there was a JSON.parse() error then body is null and it fails
            httpResponse && httpResponse.body && 200;
            requestDebug('received response: statusCode: %s, computed statusCode: %d, headers: %j', httpResponse.statusCode, status, httpResponse.headers);
            var httpResponseOk = Math.floor(status / 100) === 2;
            var endTime = new Date();
            debugData.push({
                currentHost: currentHost,
                headers: $acef29916697dd9e$var$removeCredentials(headers),
                content: body || null,
                contentLength: body !== undefined ? body.length : null,
                method: reqOpts.method,
                timeouts: reqOpts.timeouts,
                url: reqOpts.url,
                startTime: startTime,
                endTime: endTime,
                duration: endTime - startTime,
                statusCode: status
            });
            if (httpResponseOk) {
                if (client._useCache && !client._useRequestCache && cache) cache[cacheID] = httpResponse.responseText;
                return {
                    responseText: httpResponse.responseText,
                    body: httpResponse.body
                };
            }
            var shouldRetry = Math.floor(status / 100) !== 4;
            if (shouldRetry) {
                tries += 1;
                return retryRequest();
            }
            requestDebug('unrecoverable error');
            // no success and no retry => fail
            var unrecoverableError = new $bRG5U.AlgoliaSearchError(httpResponse.body && httpResponse.body.message, {
                debugData: debugData,
                statusCode: status
            });
            return client._promise.reject(unrecoverableError);
        }
        function tryFallback(err) {
            // error cases:
            //  While not in fallback mode:
            //    - CORS not supported
            //    - network error
            //  While in fallback mode:
            //    - timeout
            //    - network error
            //    - badly formatted JSONP (script loaded, did not call our callback)
            //  In both cases:
            //    - uncaught exception occurs (TypeError)
            requestDebug('error: %s, stack: %s', err.message, err.stack);
            var endTime = new Date();
            debugData.push({
                currentHost: currentHost,
                headers: $acef29916697dd9e$var$removeCredentials(headers),
                content: body || null,
                contentLength: body !== undefined ? body.length : null,
                method: reqOpts.method,
                timeouts: reqOpts.timeouts,
                url: reqOpts.url,
                startTime: startTime,
                endTime: endTime,
                duration: endTime - startTime
            });
            if (!(err instanceof $bRG5U.AlgoliaSearchError)) err = new $bRG5U.Unknown(err && err.message, err);
            tries += 1;
            // stop the request implementation when:
            if (// we did not generate this error,
            // it comes from a throw in some other piece of code
            err instanceof $bRG5U.Unknown || // server sent unparsable JSON
            err instanceof $bRG5U.UnparsableJSON || // max tries and already using fallback or no fallback
            tries >= client.hosts[initialOpts.hostType].length && (usingFallback || !hasFallback)) {
                // stop request implementation for this command
                err.debugData = debugData;
                return client._promise.reject(err);
            }
            // When a timeout occurred, retry by raising timeout
            if (err instanceof $bRG5U.RequestTimeout) return retryRequestWithHigherTimeout();
            return retryRequest();
        }
        function retryRequest() {
            requestDebug('retrying request');
            client._incrementHostIndex(initialOpts.hostType);
            return doRequest(requester, reqOpts);
        }
        function retryRequestWithHigherTimeout() {
            requestDebug('retrying request with higher timeout');
            client._incrementHostIndex(initialOpts.hostType);
            client._incrementTimeoutMultipler();
            reqOpts.timeouts = client._getTimeoutsForRequest(initialOpts.hostType);
            return doRequest(requester, reqOpts);
        }
    }
    function isCacheValidWithCurrentID(useRequestCache, currentCache, currentCacheID) {
        return client._useCache && useRequestCache && currentCache && currentCache[currentCacheID] !== undefined;
    }
    function interopCallbackReturn(request, callback) {
        if (isCacheValidWithCurrentID(client._useRequestCache, cache, cacheID)) request.catch(function() {
            // Release the cache on error
            delete cache[cacheID];
        });
        if (typeof initialOpts.callback === 'function') // either we have a callback
        request.then(function okCb(content) {
            $hb1rf(function() {
                initialOpts.callback(null, callback(content));
            }, client._setTimeout || setTimeout);
        }, function nookCb(err) {
            $hb1rf(function() {
                initialOpts.callback(err);
            }, client._setTimeout || setTimeout);
        });
        else // either we are using promises
        return request.then(callback);
    }
    if (client._useCache && client._useRequestCache) cacheID = initialOpts.url;
    // as we sometime use POST requests to pass parameters (like query='aa'),
    // the cacheID must also include the body to be different between calls
    if (client._useCache && client._useRequestCache && body) cacheID += '_body_' + body;
    if (isCacheValidWithCurrentID(client._useRequestCache, cache, cacheID)) {
        requestDebug('serving request from cache');
        var maybePromiseForCache = cache[cacheID];
        // In case the cache is warmup with value that is not a promise
        var promiseForCache = typeof maybePromiseForCache.then !== 'function' ? client._promise.resolve({
            responseText: maybePromiseForCache
        }) : maybePromiseForCache;
        return interopCallbackReturn(promiseForCache, function(content) {
            // In case of the cache request, return the original value
            return JSON.parse(content.responseText);
        });
    }
    var request = doRequest(client._request, {
        url: initialOpts.url,
        method: initialOpts.method,
        body: body,
        jsonBody: initialOpts.body,
        timeouts: client._getTimeoutsForRequest(initialOpts.hostType),
        forceAuthHeaders: initialOpts.forceAuthHeaders
    });
    if (client._useCache && client._useRequestCache && cache) cache[cacheID] = request;
    return interopCallbackReturn(request, function(content) {
        // In case of the first request, return the JSON value
        return content.body;
    });
};
/*
* Transform search param object in query string
* @param {object} args arguments to add to the current query string
* @param {string} params current query string
* @return {string} the final query string
*/ $acef29916697dd9e$var$AlgoliaSearchCore.prototype._getSearchParams = function(args, params) {
    if (args === undefined || args === null) return params;
    for(var key in args)if (key !== null && args[key] !== undefined && args.hasOwnProperty(key)) {
        params += params === '' ? '' : '&';
        params += key + '=' + encodeURIComponent(Object.prototype.toString.call(args[key]) === '[object Array]' ? $acef29916697dd9e$var$safeJSONStringify(args[key]) : args[key]);
    }
    return params;
};

/**
 * Compute the headers for a request
 *
 * @param [string] options.additionalUA semi-colon separated string with other user agents to add
 * @param [boolean=true] options.withApiKey Send the api key as a header
 * @param [Object] options.headers Extra headers to send
 */ $acef29916697dd9e$var$AlgoliaSearchCore.prototype._computeRequestHeaders = function(options) {
    var forEach = (parcelRequire("8wZP1"));
    var ua = options.additionalUA ? this._ua + '; ' + options.additionalUA : this._ua;
    var requestHeaders = {
        'x-algolia-agent': ua,
        'x-algolia-application-id': this.applicationID
    };
    // browser will inline headers in the url, node.js will use http headers
    // but in some situations, the API KEY will be too long (big secured API keys)
    // so if the request is a POST and the KEY is very long, we will be asked to not put
    // it into headers but in the JSON body
    if (options.withApiKey !== false) requestHeaders['x-algolia-api-key'] = this.apiKey;
    if (this.userToken) requestHeaders['x-algolia-usertoken'] = this.userToken;
    if (this.securityTags) requestHeaders['x-algolia-tagfilters'] = this.securityTags;
    forEach(this.extraHeaders, function addToRequestHeaders(value, key) {
        requestHeaders[key] = value;
    });
    if (options.headers) forEach(options.headers, function addToRequestHeaders(value, key) {
        requestHeaders[key] = value;
    });
    return requestHeaders;
};


/**
 * Search through multiple indices at the same time
 * @param  {Object[]}   queries  An array of queries you want to run.
 * @param {string} queries[].indexName The index name you want to target
 * @param {string} [queries[].query] The query to issue on this index. Can also be passed into `params`
 * @param {Object} queries[].params Any search param like hitsPerPage, ..
 * @param  {Function} callback Callback to be called
 * @return {Promise|undefined} Returns a promise if no callback given
 */ $acef29916697dd9e$var$AlgoliaSearchCore.prototype.search = function(queries, opts, callback) {
    var isArray = (parcelRequire("HZ0dR"));
    var map = (parcelRequire("4B8vt"));
    var usage = 'Usage: client.search(arrayOfQueries[, callback])';
    if (!isArray(queries)) throw new Error(usage);
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    } else if (opts === undefined) opts = {};
    var client = this;
    var postObj = {
        requests: map(queries, function prepareRequest(query) {
            var params = '';
            // allow query.query
            // so we are mimicing the index.search(query, params) method
            // {indexName:, query:, params:}
            if (query.query !== undefined) params += 'query=' + encodeURIComponent(query.query);
            return {
                indexName: query.indexName,
                params: client._getSearchParams(query.params, params)
            };
        })
    };
    var JSONPParams = map(postObj.requests, function prepareJSONPParams(request, requestId) {
        return requestId + '=' + encodeURIComponent('/1/indexes/' + encodeURIComponent(request.indexName) + '?' + request.params);
    }).join('&');
    var url = '/1/indexes/*/queries';
    if (opts.strategy !== undefined) postObj.strategy = opts.strategy;
    return this._jsonRequest({
        cache: this.cache,
        method: 'POST',
        url: url,
        body: postObj,
        hostType: 'read',
        fallback: {
            method: 'GET',
            url: '/1/indexes/*',
            body: {
                params: JSONPParams
            }
        },
        callback: callback
    });
};




/**
* Search for facet values
* https://www.algolia.com/doc/rest-api/search#search-for-facet-values
* This is the top-level API for SFFV.
*
* @param {object[]} queries An array of queries to run.
* @param {string} queries[].indexName Index name, name of the index to search.
* @param {object} queries[].params Query parameters.
* @param {string} queries[].params.facetName Facet name, name of the attribute to search for values in.
* Must be declared as a facet
* @param {string} queries[].params.facetQuery Query for the facet search
* @param {string} [queries[].params.*] Any search parameter of Algolia,
* see https://www.algolia.com/doc/api-client/javascript/search#search-parameters
* Pagination is not supported. The page and hitsPerPage parameters will be ignored.
*/ $acef29916697dd9e$var$AlgoliaSearchCore.prototype.searchForFacetValues = function(queries) {
    var isArray = (parcelRequire("HZ0dR"));
    var map = (parcelRequire("4B8vt"));
    var usage = 'Usage: client.searchForFacetValues([{indexName, params: {facetName, facetQuery, ...params}}, ...queries])'; // eslint-disable-line max-len
    if (!isArray(queries)) throw new Error(usage);
    var client = this;
    return client._promise.all(map(queries, function performQuery(query) {
        if (!query || query.indexName === undefined || query.params.facetName === undefined || query.params.facetQuery === undefined) throw new Error(usage);
        var clone = (parcelRequire("eFOtW"));
        var omit = (parcelRequire("eTtOA"));
        var indexName = query.indexName;
        var params = query.params;
        var facetName = params.facetName;
        var filteredParams = omit(clone(params), function(keyName) {
            return keyName === 'facetName';
        });
        var searchParameters = client._getSearchParams(filteredParams, '');
        return client._jsonRequest({
            cache: client.cache,
            method: 'POST',
            url: '/1/indexes/' + encodeURIComponent(indexName) + '/facets/' + encodeURIComponent(facetName) + '/query',
            hostType: 'read',
            body: {
                params: searchParameters
            }
        });
    }));
};
/**
 * Set the extra security tagFilters header
 * @param {string|array} tags The list of tags defining the current security filters
 */ $acef29916697dd9e$var$AlgoliaSearchCore.prototype.setSecurityTags = function(tags) {
    if (Object.prototype.toString.call(tags) === '[object Array]') {
        var strTags = [];
        for(var i = 0; i < tags.length; ++i)if (Object.prototype.toString.call(tags[i]) === '[object Array]') {
            var oredTags = [];
            for(var j = 0; j < tags[i].length; ++j)oredTags.push(tags[i][j]);
            strTags.push('(' + oredTags.join(',') + ')');
        } else strTags.push(tags[i]);
        tags = strTags.join(',');
    }
    this.securityTags = tags;
};
/**
 * Set the extra user token header
 * @param {string} userToken The token identifying a uniq user (used to apply rate limits)
 */ $acef29916697dd9e$var$AlgoliaSearchCore.prototype.setUserToken = function(userToken) {
    this.userToken = userToken;
};
/**
 * Clear all queries in client's cache
 * @return undefined
 */ $acef29916697dd9e$var$AlgoliaSearchCore.prototype.clearCache = function() {
    this.cache = {};
};
/**
* Set the number of milliseconds a request can take before automatically being terminated.
* @deprecated
* @param {Number} milliseconds
*/ $acef29916697dd9e$var$AlgoliaSearchCore.prototype.setRequestTimeout = function(milliseconds) {
    if (milliseconds) this._timeouts.connect = this._timeouts.read = this._timeouts.write = milliseconds;
};
/**
* Set the three different (connect, read, write) timeouts to be used when requesting
* @param {Object} timeouts
*/ $acef29916697dd9e$var$AlgoliaSearchCore.prototype.setTimeouts = function(timeouts) {
    this._timeouts = timeouts;
};
/**
* Get the three different (connect, read, write) timeouts to be used when requesting
* @param {Object} timeouts
*/ $acef29916697dd9e$var$AlgoliaSearchCore.prototype.getTimeouts = function() {
    return this._timeouts;
};
$acef29916697dd9e$var$AlgoliaSearchCore.prototype._getAppIdData = function() {
    var data = $72Pfb.get(this.applicationID);
    if (data !== null) this._cacheAppIdData(data);
    return data;
};
$acef29916697dd9e$var$AlgoliaSearchCore.prototype._setAppIdData = function(data) {
    data.lastChange = new Date().getTime();
    this._cacheAppIdData(data);
    return $72Pfb.set(this.applicationID, data);
};
$acef29916697dd9e$var$AlgoliaSearchCore.prototype._checkAppIdData = function() {
    var data = this._getAppIdData();
    var now = new Date().getTime();
    if (data === null || now - data.lastChange > $acef29916697dd9e$var$RESET_APP_DATA_TIMER) return this._resetInitialAppIdData(data);
    return data;
};
$acef29916697dd9e$var$AlgoliaSearchCore.prototype._resetInitialAppIdData = function(data) {
    var newData = data || {};
    newData.hostIndexes = {
        read: 0,
        write: 0
    };
    newData.timeoutMultiplier = 1;
    newData.shuffleResult = newData.shuffleResult || $acef29916697dd9e$var$shuffle([
        1,
        2,
        3
    ]);
    return this._setAppIdData(newData);
};
$acef29916697dd9e$var$AlgoliaSearchCore.prototype._cacheAppIdData = function(data) {
    this._hostIndexes = data.hostIndexes;
    this._timeoutMultiplier = data.timeoutMultiplier;
    this._shuffleResult = data.shuffleResult;
};

$acef29916697dd9e$var$AlgoliaSearchCore.prototype._partialAppIdDataUpdate = function(newData) {
    var foreach = (parcelRequire("8wZP1"));
    var currentData = this._getAppIdData();
    foreach(newData, function(value, key) {
        currentData[key] = value;
    });
    return this._setAppIdData(currentData);
};
$acef29916697dd9e$var$AlgoliaSearchCore.prototype._getHostByType = function(hostType) {
    return this.hosts[hostType][this._getHostIndexByType(hostType)];
};
$acef29916697dd9e$var$AlgoliaSearchCore.prototype._getTimeoutMultiplier = function() {
    return this._timeoutMultiplier;
};
$acef29916697dd9e$var$AlgoliaSearchCore.prototype._getHostIndexByType = function(hostType) {
    return this._hostIndexes[hostType];
};

$acef29916697dd9e$var$AlgoliaSearchCore.prototype._setHostIndexByType = function(hostIndex, hostType) {
    var clone = (parcelRequire("eFOtW"));
    var newHostIndexes = clone(this._hostIndexes);
    newHostIndexes[hostType] = hostIndex;
    this._partialAppIdDataUpdate({
        hostIndexes: newHostIndexes
    });
    return hostIndex;
};
$acef29916697dd9e$var$AlgoliaSearchCore.prototype._incrementHostIndex = function(hostType) {
    return this._setHostIndexByType((this._getHostIndexByType(hostType) + 1) % this.hosts[hostType].length, hostType);
};
$acef29916697dd9e$var$AlgoliaSearchCore.prototype._incrementTimeoutMultipler = function() {
    var timeoutMultiplier = Math.max(this._timeoutMultiplier + 1, 4);
    return this._partialAppIdDataUpdate({
        timeoutMultiplier: timeoutMultiplier
    });
};
$acef29916697dd9e$var$AlgoliaSearchCore.prototype._getTimeoutsForRequest = function(hostType) {
    return {
        connect: this._timeouts.connect * this._timeoutMultiplier,
        complete: this._timeouts[hostType] * this._timeoutMultiplier
    };
};
function $acef29916697dd9e$var$prepareHost(protocol) {
    return function prepare(host) {
        return protocol + '//' + host.toLowerCase();
    };
}
// Prototype.js < 1.7, a widely used library, defines a weird
// Array.prototype.toJSON function that will fail to stringify our content
// appropriately
// refs:
//   - https://groups.google.com/forum/#!topic/prototype-core/E-SAVvV_V9Q
//   - https://github.com/sstephenson/prototype/commit/038a2985a70593c1a86c230fadbdfe2e4898a48c
//   - http://stackoverflow.com/a/3148441/147079
function $acef29916697dd9e$var$safeJSONStringify(obj) {
    /* eslint no-extend-native:0 */ if (Array.prototype.toJSON === undefined) return JSON.stringify(obj);
    var toJSON = Array.prototype.toJSON;
    delete Array.prototype.toJSON;
    var out = JSON.stringify(obj);
    Array.prototype.toJSON = toJSON;
    return out;
}
function $acef29916697dd9e$var$shuffle(array) {
    var currentIndex = array.length;
    var temporaryValue;
    var randomIndex;
    // While there remain elements to shuffle...
    while(currentIndex !== 0){
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }
    return array;
}
function $acef29916697dd9e$var$removeCredentials(headers) {
    var newHeaders = {};
    for(var headerName in headers)if (Object.prototype.hasOwnProperty.call(headers, headerName)) {
        var value;
        if (headerName === 'x-algolia-api-key' || headerName === 'x-algolia-application-id') value = '**hidden for security purposes**';
        else value = headers[headerName];
        newHeaders[headerName] = value;
    }
    return newHeaders;
}

});
parcelRegister("72Pfb", function(module, exports) {

var $5210784c65a6e35e$var$debug = (parcelRequire("5KxQY"))('algoliasearch:src/hostIndexState.js');
var $5210784c65a6e35e$var$localStorageNamespace = 'algoliasearch-client-js';
var $5210784c65a6e35e$var$store;
var $5210784c65a6e35e$var$moduleStore = {
    state: {},
    set: function(key, data) {
        this.state[key] = data;
        return this.state[key];
    },
    get: function(key) {
        return this.state[key] || null;
    }
};
var $5210784c65a6e35e$var$localStorageStore = {
    set: function(key, data) {
        $5210784c65a6e35e$var$moduleStore.set(key, data); // always replicate localStorageStore to moduleStore in case of failure
        try {
            var namespace = JSON.parse($parcel$global.localStorage[$5210784c65a6e35e$var$localStorageNamespace]);
            namespace[key] = data;
            $parcel$global.localStorage[$5210784c65a6e35e$var$localStorageNamespace] = JSON.stringify(namespace);
            return namespace[key];
        } catch (e) {
            return $5210784c65a6e35e$var$localStorageFailure(key, e);
        }
    },
    get: function(key) {
        try {
            return JSON.parse($parcel$global.localStorage[$5210784c65a6e35e$var$localStorageNamespace])[key] || null;
        } catch (e) {
            return $5210784c65a6e35e$var$localStorageFailure(key, e);
        }
    }
};
function $5210784c65a6e35e$var$localStorageFailure(key, e) {
    $5210784c65a6e35e$var$debug('localStorage failed with', e);
    $5210784c65a6e35e$var$cleanup();
    $5210784c65a6e35e$var$store = $5210784c65a6e35e$var$moduleStore;
    return $5210784c65a6e35e$var$store.get(key);
}
$5210784c65a6e35e$var$store = $5210784c65a6e35e$var$supportsLocalStorage() ? $5210784c65a6e35e$var$localStorageStore : $5210784c65a6e35e$var$moduleStore;
module.exports = {
    get: $5210784c65a6e35e$var$getOrSet,
    set: $5210784c65a6e35e$var$getOrSet,
    supportsLocalStorage: $5210784c65a6e35e$var$supportsLocalStorage
};
function $5210784c65a6e35e$var$getOrSet(key, data) {
    if (arguments.length === 1) return $5210784c65a6e35e$var$store.get(key);
    return $5210784c65a6e35e$var$store.set(key, data);
}
function $5210784c65a6e35e$var$supportsLocalStorage() {
    try {
        if ('localStorage' in $parcel$global && $parcel$global.localStorage !== null) {
            if (!$parcel$global.localStorage[$5210784c65a6e35e$var$localStorageNamespace]) // actual creation of the namespace
            $parcel$global.localStorage.setItem($5210784c65a6e35e$var$localStorageNamespace, JSON.stringify({}));
            return true;
        }
        return false;
    } catch (_) {
        return false;
    }
}
// In case of any error on localStorage, we clean our own namespace, this should handle
// quota errors when a lot of keys + data are used
function $5210784c65a6e35e$var$cleanup() {
    try {
        $parcel$global.localStorage.removeItem($5210784c65a6e35e$var$localStorageNamespace);
    } catch (_) {
    // nothing to do
    }
}

});
parcelRegister("5KxQY", function(module, exports) {
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */ 
var $2fFJv = parcelRequire("2fFJv");

exports = module.exports = (parcelRequire("6WfuY"));
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();
/**
 * Colors.
 */ exports.colors = [
    'lightseagreen',
    'forestgreen',
    'goldenrod',
    'dodgerblue',
    'darkorchid',
    'crimson'
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') return true;
    // is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ exports.formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (err) {
        return '[UnexpectedJSONParseError]: ' + err.message;
    }
};
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    var useColors = this.useColors;
    args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + exports.humanize(this.diff);
    if (!useColors) return;
    var c = 'color: ' + this.color;
    args.splice(1, 0, c, 'color: inherit');
    // the final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    var index = 0;
    var lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, function(match) {
        if ('%%' === match) return;
        index++;
        if ('%c' === match) // we only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */ function log() {
    // this hackery is required for IE8/9, where
    // the `console.log` function doesn't have 'apply'
    return 'object' === typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
}
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (null == namespaces) exports.storage.removeItem('debug');
        else exports.storage.debug = namespaces;
    } catch (e) {}
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    var r;
    try {
        r = exports.storage.debug;
    } catch (e) {}
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    if (!r && typeof $2fFJv !== 'undefined' && 'env' in $2fFJv) r = undefined;
    return r;
}
/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */ exports.enable(load());
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        return window.localStorage;
    } catch (e) {}
}

});
parcelRegister("6WfuY", function(module, exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */ exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;

exports.humanize = (parcelRequire("4Hrkz"));
/**
 * The currently active debug mode names, and names to skip.
 */ exports.names = [];
exports.skips = [];
/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */ exports.formatters = {};
/**
 * Previous log timestamp.
 */ var prevTime;
/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */ function selectColor(namespace) {
    var hash = 0, i;
    for(i in namespace){
        hash = (hash << 5) - hash + namespace.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
    }
    return exports.colors[Math.abs(hash) % exports.colors.length];
}
/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */ function createDebug(namespace) {
    function debug() {
        // disabled?
        if (!debug.enabled) return;
        var self = debug;
        // set `diff` timestamp
        var curr = +new Date();
        var ms = curr - (prevTime || curr);
        self.diff = ms;
        self.prev = prevTime;
        self.curr = curr;
        prevTime = curr;
        // turn the `arguments` into a proper Array
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        args[0] = exports.coerce(args[0]);
        if ('string' !== typeof args[0]) // anything else let's inspect with %O
        args.unshift('%O');
        // apply any `formatters` transformations
        var index = 0;
        args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
            // if we encounter an escaped % then don't increase the array index
            if (match === '%%') return match;
            index++;
            var formatter = exports.formatters[format];
            if ('function' === typeof formatter) {
                var val = args[index];
                match = formatter.call(self, val);
                // now we need to remove `args[index]` since it's inlined in the `format`
                args.splice(index, 1);
                index--;
            }
            return match;
        });
        // apply env-specific formatting (colors, etc.)
        exports.formatArgs.call(self, args);
        var logFn = debug.log || exports.log || console.log.bind(console);
        logFn.apply(self, args);
    }
    debug.namespace = namespace;
    debug.enabled = exports.enabled(namespace);
    debug.useColors = exports.useColors();
    debug.color = selectColor(namespace);
    // env-specific initialization logic for debug instances
    if ('function' === typeof exports.init) exports.init(debug);
    return debug;
}
/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */ function enable(namespaces) {
    exports.save(namespaces);
    exports.names = [];
    exports.skips = [];
    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
    var len = split.length;
    for(var i = 0; i < len; i++){
        if (!split[i]) continue; // ignore empty strings
        namespaces = split[i].replace(/\*/g, '.*?');
        if (namespaces[0] === '-') exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
        else exports.names.push(new RegExp('^' + namespaces + '$'));
    }
}
/**
 * Disable debug output.
 *
 * @api public
 */ function disable() {
    exports.enable('');
}
/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */ function enabled(name) {
    var i, len;
    for(i = 0, len = exports.skips.length; i < len; i++){
        if (exports.skips[i].test(name)) return false;
    }
    for(i = 0, len = exports.names.length; i < len; i++){
        if (exports.names[i].test(name)) return true;
    }
    return false;
}
/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */ function coerce(val) {
    if (val instanceof Error) return val.stack || val.message;
    return val;
}

});
parcelRegister("4Hrkz", function(module, exports) {
/**
 * Helpers.
 */ var $36c060e549cc702e$var$s = 1000;
var $36c060e549cc702e$var$m = $36c060e549cc702e$var$s * 60;
var $36c060e549cc702e$var$h = $36c060e549cc702e$var$m * 60;
var $36c060e549cc702e$var$d = $36c060e549cc702e$var$h * 24;
var $36c060e549cc702e$var$y = $36c060e549cc702e$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === 'string' && val.length > 0) return $36c060e549cc702e$var$parse(val);
    else if (type === 'number' && isNaN(val) === false) return options.long ? $36c060e549cc702e$var$fmtLong(val) : $36c060e549cc702e$var$fmtShort(val);
    throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $36c060e549cc702e$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();
    switch(type){
        case 'years':
        case 'year':
        case 'yrs':
        case 'yr':
        case 'y':
            return n * $36c060e549cc702e$var$y;
        case 'days':
        case 'day':
        case 'd':
            return n * $36c060e549cc702e$var$d;
        case 'hours':
        case 'hour':
        case 'hrs':
        case 'hr':
        case 'h':
            return n * $36c060e549cc702e$var$h;
        case 'minutes':
        case 'minute':
        case 'mins':
        case 'min':
        case 'm':
            return n * $36c060e549cc702e$var$m;
        case 'seconds':
        case 'second':
        case 'secs':
        case 'sec':
        case 's':
            return n * $36c060e549cc702e$var$s;
        case 'milliseconds':
        case 'millisecond':
        case 'msecs':
        case 'msec':
        case 'ms':
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $36c060e549cc702e$var$fmtShort(ms) {
    if (ms >= $36c060e549cc702e$var$d) return Math.round(ms / $36c060e549cc702e$var$d) + 'd';
    if (ms >= $36c060e549cc702e$var$h) return Math.round(ms / $36c060e549cc702e$var$h) + 'h';
    if (ms >= $36c060e549cc702e$var$m) return Math.round(ms / $36c060e549cc702e$var$m) + 'm';
    if (ms >= $36c060e549cc702e$var$s) return Math.round(ms / $36c060e549cc702e$var$s) + 's';
    return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $36c060e549cc702e$var$fmtLong(ms) {
    return $36c060e549cc702e$var$plural(ms, $36c060e549cc702e$var$d, 'day') || $36c060e549cc702e$var$plural(ms, $36c060e549cc702e$var$h, 'hour') || $36c060e549cc702e$var$plural(ms, $36c060e549cc702e$var$m, 'minute') || $36c060e549cc702e$var$plural(ms, $36c060e549cc702e$var$s, 'second') || ms + ' ms';
}
/**
 * Pluralization helper.
 */ function $36c060e549cc702e$var$plural(ms, n, name) {
    if (ms < n) return;
    if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
    return Math.ceil(ms / n) + ' ' + name + 's';
}

});





parcelRegister("hz3TB", function(module, exports) {
module.exports = $cc98ba2a31b758a9$var$createAnalyticsClient;

var $f2Nkd = parcelRequire("f2Nkd");
function $cc98ba2a31b758a9$var$createAnalyticsClient(appId, apiKey, opts) {
    var analytics = {};
    opts = opts || {};
    // there need to be 4 hosts, like on the client, since if requests fail,
    // the counter goes up by 1, so we need to have the same amount of hosts
    // 4 because: -dsn, -1, -2, -3
    // This is done because the APPID used for search will be the same for the analytics client created,
    // and since the state of available hosts is shared by APPID globally for the module, we had issues
    // where the hostIndex would be 1 while the array was only one entry (you got an empty host)
    opts.hosts = opts.hosts || [
        'analytics.algolia.com',
        'analytics.algolia.com',
        'analytics.algolia.com',
        'analytics.algolia.com'
    ];
    opts.protocol = opts.protocol || 'https:';
    analytics.as = $f2Nkd(appId, apiKey, opts);
    analytics.getABTests = function(_params, callback) {
        var params = params || {};
        var offset = params.offset || 0;
        var limit = params.limit || 10;
        return this.as._jsonRequest({
            method: 'GET',
            url: '/2/abtests?offset=' + encodeURIComponent(offset) + '&limit=' + encodeURIComponent(limit),
            hostType: 'read',
            forceAuthHeaders: true,
            callback: callback
        });
    };
    analytics.getABTest = function(abTestID, callback) {
        return this.as._jsonRequest({
            method: 'GET',
            url: '/2/abtests/' + encodeURIComponent(abTestID),
            hostType: 'read',
            forceAuthHeaders: true,
            callback: callback
        });
    };
    analytics.addABTest = function(abTest, callback) {
        return this.as._jsonRequest({
            method: 'POST',
            url: '/2/abtests',
            body: abTest,
            hostType: 'read',
            forceAuthHeaders: true,
            callback: callback
        });
    };
    analytics.stopABTest = function(abTestID, callback) {
        return this.as._jsonRequest({
            method: 'POST',
            url: '/2/abtests/' + encodeURIComponent(abTestID) + '/stop',
            hostType: 'read',
            forceAuthHeaders: true,
            callback: callback
        });
    };
    analytics.deleteABTest = function(abTestID, callback) {
        return this.as._jsonRequest({
            method: 'DELETE',
            url: '/2/abtests/' + encodeURIComponent(abTestID),
            hostType: 'write',
            forceAuthHeaders: true,
            callback: callback
        });
    };
    analytics.waitTask = function(indexName, taskID, callback) {
        return this.as.initIndex(indexName).waitTask(taskID, callback);
    };
    return analytics;
}

});


parcelRegister("bRA3t", function(module, exports) {
'use strict';

var $ggJ6Z = parcelRequire("ggJ6Z");

var $8a309cbc55d5afac$var$Promise = $ggJ6Z.Promise || (parcelRequire("7C6pt")).Promise;








// This is the standalone browser build entry point
// Browser implementation of the Algolia Search JavaScript client,
// using XMLHttpRequest, XDomainRequest and JSONP as fallback
module.exports = function createAlgoliasearch(AlgoliaSearch, uaSuffix) {
    var inherits = (parcelRequire("lyUaN"));
    var errors = (parcelRequire("bRG5U"));
    var inlineHeaders = (parcelRequire("jvF5r"));
    var jsonpRequest = (parcelRequire("4udmp"));
    var places = (parcelRequire("joGZo"));
    uaSuffix = uaSuffix || '';
    function algoliasearch(applicationID, apiKey, opts) {
        var cloneDeep = (parcelRequire("eFOtW"));
        opts = cloneDeep(opts || {});
        opts._ua = opts._ua || algoliasearch.ua;
        return new AlgoliaSearchBrowser(applicationID, apiKey, opts);
    }
    algoliasearch.version = (parcelRequire("7FtoO"));
    algoliasearch.ua = 'Algolia for JavaScript (' + algoliasearch.version + '); ' + uaSuffix;
    algoliasearch.initPlaces = places(algoliasearch);
    // we expose into window no matter how we are used, this will allow
    // us to easily debug any website running algolia
    $ggJ6Z.__algolia = {
        debug: (parcelRequire("5KxQY")),
        algoliasearch: algoliasearch
    };
    var support = {
        hasXMLHttpRequest: 'XMLHttpRequest' in $ggJ6Z,
        hasXDomainRequest: 'XDomainRequest' in $ggJ6Z
    };
    if (support.hasXMLHttpRequest) support.cors = 'withCredentials' in new XMLHttpRequest();
    function AlgoliaSearchBrowser() {
        // call AlgoliaSearch constructor
        AlgoliaSearch.apply(this, arguments);
    }
    inherits(AlgoliaSearchBrowser, AlgoliaSearch);
    AlgoliaSearchBrowser.prototype._request = function request(url, opts) {
        return new $8a309cbc55d5afac$var$Promise(function wrapRequest(resolve, reject) {
            // no cors or XDomainRequest, no request
            if (!support.cors && !support.hasXDomainRequest) {
                // very old browser, not supported
                reject(new errors.Network('CORS not supported'));
                return;
            }
            url = inlineHeaders(url, opts.headers);
            var body = opts.body;
            var req = support.cors ? new XMLHttpRequest() : new XDomainRequest();
            var reqTimeout;
            var timedOut;
            var connected = false;
            reqTimeout = setTimeout(onTimeout, opts.timeouts.connect);
            // we set an empty onprogress listener
            // so that XDomainRequest on IE9 is not aborted
            // refs:
            //  - https://github.com/algolia/algoliasearch-client-js/issues/76
            //  - https://social.msdn.microsoft.com/Forums/ie/en-US/30ef3add-767c-4436-b8a9-f1ca19b4812e/ie9-rtm-xdomainrequest-issued-requests-may-abort-if-all-event-handlers-not-specified?forum=iewebdevelopment
            req.onprogress = onProgress;
            if ('onreadystatechange' in req) req.onreadystatechange = onReadyStateChange;
            req.onload = onLoad;
            req.onerror = onError;
            // do not rely on default XHR async flag, as some analytics code like hotjar
            // breaks it and set it to false by default
            if (req instanceof XMLHttpRequest) {
                req.open(opts.method, url, true);
                // The Analytics API never accepts Auth headers as query string
                // this option exists specifically for them.
                if (opts.forceAuthHeaders) {
                    req.setRequestHeader('x-algolia-application-id', opts.headers['x-algolia-application-id']);
                    req.setRequestHeader('x-algolia-api-key', opts.headers['x-algolia-api-key']);
                }
            } else req.open(opts.method, url);
            // headers are meant to be sent after open
            if (support.cors) {
                if (body) {
                    if (opts.method === 'POST') // https://developer.mozilla.org/en-US/docs/Web/HTTP/Access_control_CORS#Simple_requests
                    req.setRequestHeader('content-type', 'application/x-www-form-urlencoded');
                    else req.setRequestHeader('content-type', 'application/json');
                }
                req.setRequestHeader('accept', 'application/json');
            }
            if (body) req.send(body);
            else req.send();
            // event object not received in IE8, at least
            // but we do not use it, still important to note
            function onLoad() {
                // When browser does not supports req.timeout, we can
                // have both a load and timeout event, since handled by a dumb setTimeout
                if (timedOut) return;
                clearTimeout(reqTimeout);
                var out;
                try {
                    out = {
                        body: JSON.parse(req.responseText),
                        responseText: req.responseText,
                        statusCode: req.status,
                        // XDomainRequest does not have any response headers
                        headers: req.getAllResponseHeaders && req.getAllResponseHeaders() || {}
                    };
                } catch (e) {
                    out = new errors.UnparsableJSON({
                        more: req.responseText
                    });
                }
                if (out instanceof errors.UnparsableJSON) reject(out);
                else resolve(out);
            }
            function onError(event) {
                if (timedOut) return;
                clearTimeout(reqTimeout);
                // error event is trigerred both with XDR/XHR on:
                //   - DNS error
                //   - unallowed cross domain request
                reject(new errors.Network({
                    more: event
                }));
            }
            function onTimeout() {
                timedOut = true;
                req.abort();
                reject(new errors.RequestTimeout());
            }
            function onConnect() {
                connected = true;
                clearTimeout(reqTimeout);
                reqTimeout = setTimeout(onTimeout, opts.timeouts.complete);
            }
            function onProgress() {
                if (!connected) onConnect();
            }
            function onReadyStateChange() {
                if (!connected && req.readyState > 1) onConnect();
            }
        });
    };
    AlgoliaSearchBrowser.prototype._request.fallback = function requestFallback(url, opts) {
        url = inlineHeaders(url, opts.headers);
        return new $8a309cbc55d5afac$var$Promise(function wrapJsonpRequest(resolve, reject) {
            jsonpRequest(url, opts, function jsonpRequestDone(err, content) {
                if (err) {
                    reject(err);
                    return;
                }
                resolve(content);
            });
        });
    };
    AlgoliaSearchBrowser.prototype._promise = {
        reject: function rejectPromise(val) {
            return $8a309cbc55d5afac$var$Promise.reject(val);
        },
        resolve: function resolvePromise(val) {
            return $8a309cbc55d5afac$var$Promise.resolve(val);
        },
        delay: function delayPromise(ms) {
            return new $8a309cbc55d5afac$var$Promise(function resolveOnTimeout(resolve /* , reject*/ ) {
                setTimeout(resolve, ms);
            });
        },
        all: function all(promises) {
            return $8a309cbc55d5afac$var$Promise.all(promises);
        }
    };
    return algoliasearch;
};

});
parcelRegister("ggJ6Z", function(module, exports) {
var $bd81223a300b482e$var$win;
if (typeof window !== "undefined") $bd81223a300b482e$var$win = window;
else if (typeof $parcel$global !== "undefined") $bd81223a300b482e$var$win = $parcel$global;
else if (typeof self !== "undefined") $bd81223a300b482e$var$win = self;
else $bd81223a300b482e$var$win = {};
module.exports = $bd81223a300b482e$var$win;

});

parcelRegister("7C6pt", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.8+1e68dce6
 */ (function(global1, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function objectOrFunction(x) {
        var type = typeof x;
        return x !== null && (type === 'object' || type === 'function');
    }
    function isFunction(x) {
        return typeof x === 'function';
    }
    var _isArray = void 0;
    if (Array.isArray) _isArray = Array.isArray;
    else _isArray = function(x) {
        return Object.prototype.toString.call(x) === '[object Array]';
    };
    var isArray = _isArray;
    var len = 0;
    var vertxNext = void 0;
    var customSchedulerFn = void 0;
    var asap = function asap(callback, arg) {
        queue[len] = callback;
        queue[len + 1] = arg;
        len += 2;
        if (len === 2) {
            // If len is 2, that means that we need to schedule an async flush.
            // If additional callbacks are queued before the queue is flushed, they
            // will be processed by this flush that we are scheduling.
            if (customSchedulerFn) customSchedulerFn(flush);
            else scheduleFlush();
        }
    };
    function setScheduler(scheduleFn) {
        customSchedulerFn = scheduleFn;
    }
    function setAsap(asapFn) {
        asap = asapFn;
    }
    var browserWindow = typeof window !== 'undefined' ? window : undefined;
    var browserGlobal = browserWindow || {};
    var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
    var isNode = typeof self === 'undefined' && typeof $2fFJv !== 'undefined' && ({}).toString.call($2fFJv) === '[object process]';
    // test for web worker but not in IE10
    var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';
    // node
    function useNextTick() {
        // node version 0.10.x displays a deprecation warning when nextTick is used recursively
        // see https://github.com/cujojs/when/issues/410 for details
        return function() {
            return $2fFJv.nextTick(flush);
        };
    }
    // vertx
    function useVertxTimer() {
        if (typeof vertxNext !== 'undefined') return function() {
            vertxNext(flush);
        };
        return useSetTimeout();
    }
    function useMutationObserver() {
        var iterations = 0;
        var observer = new BrowserMutationObserver(flush);
        var node = document.createTextNode('');
        observer.observe(node, {
            characterData: true
        });
        return function() {
            node.data = iterations = ++iterations % 2;
        };
    }
    // web worker
    function useMessageChannel() {
        var channel = new MessageChannel();
        channel.port1.onmessage = flush;
        return function() {
            return channel.port2.postMessage(0);
        };
    }
    function useSetTimeout() {
        // Store setTimeout reference so es6-promise will be unaffected by
        // other code modifying setTimeout (like sinon.useFakeTimers())
        var globalSetTimeout = setTimeout;
        return function() {
            return globalSetTimeout(flush, 1);
        };
    }
    var queue = new Array(1000);
    function flush() {
        for(var i = 0; i < len; i += 2){
            var callback = queue[i];
            var arg = queue[i + 1];
            callback(arg);
            queue[i] = undefined;
            queue[i + 1] = undefined;
        }
        len = 0;
    }
    function attemptVertx() {
        try {
            var vertx = Function('return this')().require('vertx');
            vertxNext = vertx.runOnLoop || vertx.runOnContext;
            return useVertxTimer();
        } catch (e) {
            return useSetTimeout();
        }
    }
    var scheduleFlush = void 0;
    // Decide what async method to use to triggering processing of queued callbacks:
    if (isNode) scheduleFlush = useNextTick();
    else if (BrowserMutationObserver) scheduleFlush = useMutationObserver();
    else if (isWorker) scheduleFlush = useMessageChannel();
    else if (browserWindow === undefined && true) scheduleFlush = attemptVertx();
    else scheduleFlush = useSetTimeout();
    function then(onFulfillment, onRejection) {
        var parent = this;
        var child = new this.constructor(noop);
        if (child[PROMISE_ID] === undefined) makePromise(child);
        var _state = parent._state;
        if (_state) {
            var callback = arguments[_state - 1];
            asap(function() {
                return invokeCallback(_state, child, callback, parent._result);
            });
        } else subscribe(parent, child, onFulfillment, onRejection);
        return child;
    }
    /**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/ function resolve$1(object) {
        /*jshint validthis:true */ var Constructor = this;
        if (object && typeof object === 'object' && object.constructor === Constructor) return object;
        var promise = new Constructor(noop);
        resolve(promise, object);
        return promise;
    }
    var PROMISE_ID = Math.random().toString(36).substring(2);
    function noop() {}
    var PENDING = void 0;
    var FULFILLED = 1;
    var REJECTED = 2;
    function selfFulfillment() {
        return new TypeError("You cannot resolve a promise with itself");
    }
    function cannotReturnOwn() {
        return new TypeError('A promises callback cannot return that same promise.');
    }
    function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
        try {
            then$$1.call(value, fulfillmentHandler, rejectionHandler);
        } catch (e) {
            return e;
        }
    }
    function handleForeignThenable(promise, thenable, then$$1) {
        asap(function(promise) {
            var sealed = false;
            var error = tryThen(then$$1, thenable, function(value) {
                if (sealed) return;
                sealed = true;
                if (thenable !== value) resolve(promise, value);
                else fulfill(promise, value);
            }, function(reason) {
                if (sealed) return;
                sealed = true;
                reject(promise, reason);
            }, 'Settle: ' + (promise._label || ' unknown promise'));
            if (!sealed && error) {
                sealed = true;
                reject(promise, error);
            }
        }, promise);
    }
    function handleOwnThenable(promise, thenable) {
        if (thenable._state === FULFILLED) fulfill(promise, thenable._result);
        else if (thenable._state === REJECTED) reject(promise, thenable._result);
        else subscribe(thenable, undefined, function(value) {
            return resolve(promise, value);
        }, function(reason) {
            return reject(promise, reason);
        });
    }
    function handleMaybeThenable(promise, maybeThenable, then$$1) {
        if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) handleOwnThenable(promise, maybeThenable);
        else {
            if (then$$1 === undefined) fulfill(promise, maybeThenable);
            else if (isFunction(then$$1)) handleForeignThenable(promise, maybeThenable, then$$1);
            else fulfill(promise, maybeThenable);
        }
    }
    function resolve(promise, value) {
        if (promise === value) reject(promise, selfFulfillment());
        else if (objectOrFunction(value)) {
            var then$$1 = void 0;
            try {
                then$$1 = value.then;
            } catch (error) {
                reject(promise, error);
                return;
            }
            handleMaybeThenable(promise, value, then$$1);
        } else fulfill(promise, value);
    }
    function publishRejection(promise) {
        if (promise._onerror) promise._onerror(promise._result);
        publish(promise);
    }
    function fulfill(promise, value) {
        if (promise._state !== PENDING) return;
        promise._result = value;
        promise._state = FULFILLED;
        if (promise._subscribers.length !== 0) asap(publish, promise);
    }
    function reject(promise, reason) {
        if (promise._state !== PENDING) return;
        promise._state = REJECTED;
        promise._result = reason;
        asap(publishRejection, promise);
    }
    function subscribe(parent, child, onFulfillment, onRejection) {
        var _subscribers = parent._subscribers;
        var length = _subscribers.length;
        parent._onerror = null;
        _subscribers[length] = child;
        _subscribers[length + FULFILLED] = onFulfillment;
        _subscribers[length + REJECTED] = onRejection;
        if (length === 0 && parent._state) asap(publish, parent);
    }
    function publish(promise) {
        var subscribers = promise._subscribers;
        var settled = promise._state;
        if (subscribers.length === 0) return;
        var child = void 0, callback = void 0, detail = promise._result;
        for(var i = 0; i < subscribers.length; i += 3){
            child = subscribers[i];
            callback = subscribers[i + settled];
            if (child) invokeCallback(settled, child, callback, detail);
            else callback(detail);
        }
        promise._subscribers.length = 0;
    }
    function invokeCallback(settled, promise, callback, detail) {
        var hasCallback = isFunction(callback), value = void 0, error = void 0, succeeded = true;
        if (hasCallback) {
            try {
                value = callback(detail);
            } catch (e) {
                succeeded = false;
                error = e;
            }
            if (promise === value) {
                reject(promise, cannotReturnOwn());
                return;
            }
        } else value = detail;
        if (promise._state !== PENDING) ;
        else if (hasCallback && succeeded) resolve(promise, value);
        else if (succeeded === false) reject(promise, error);
        else if (settled === FULFILLED) fulfill(promise, value);
        else if (settled === REJECTED) reject(promise, value);
    }
    function initializePromise(promise, resolver) {
        try {
            resolver(function resolvePromise(value) {
                resolve(promise, value);
            }, function rejectPromise(reason) {
                reject(promise, reason);
            });
        } catch (e) {
            reject(promise, e);
        }
    }
    var id = 0;
    function nextId() {
        return id++;
    }
    function makePromise(promise) {
        promise[PROMISE_ID] = id++;
        promise._state = undefined;
        promise._result = undefined;
        promise._subscribers = [];
    }
    function validationError() {
        return new Error('Array Methods must be provided an Array');
    }
    var Enumerator = function() {
        function Enumerator(Constructor, input) {
            this._instanceConstructor = Constructor;
            this.promise = new Constructor(noop);
            if (!this.promise[PROMISE_ID]) makePromise(this.promise);
            if (isArray(input)) {
                this.length = input.length;
                this._remaining = input.length;
                this._result = new Array(this.length);
                if (this.length === 0) fulfill(this.promise, this._result);
                else {
                    this.length = this.length || 0;
                    this._enumerate(input);
                    if (this._remaining === 0) fulfill(this.promise, this._result);
                }
            } else reject(this.promise, validationError());
        }
        Enumerator.prototype._enumerate = function _enumerate(input) {
            for(var i = 0; this._state === PENDING && i < input.length; i++)this._eachEntry(input[i], i);
        };
        Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
            var c = this._instanceConstructor;
            var resolve$$1 = c.resolve;
            if (resolve$$1 === resolve$1) {
                var _then = void 0;
                var error = void 0;
                var didError = false;
                try {
                    _then = entry.then;
                } catch (e) {
                    didError = true;
                    error = e;
                }
                if (_then === then && entry._state !== PENDING) this._settledAt(entry._state, i, entry._result);
                else if (typeof _then !== 'function') {
                    this._remaining--;
                    this._result[i] = entry;
                } else if (c === Promise$1) {
                    var promise = new c(noop);
                    if (didError) reject(promise, error);
                    else handleMaybeThenable(promise, entry, _then);
                    this._willSettleAt(promise, i);
                } else this._willSettleAt(new c(function(resolve$$1) {
                    return resolve$$1(entry);
                }), i);
            } else this._willSettleAt(resolve$$1(entry), i);
        };
        Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
            var promise = this.promise;
            if (promise._state === PENDING) {
                this._remaining--;
                if (state === REJECTED) reject(promise, value);
                else this._result[i] = value;
            }
            if (this._remaining === 0) fulfill(promise, this._result);
        };
        Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
            var enumerator = this;
            subscribe(promise, undefined, function(value) {
                return enumerator._settledAt(FULFILLED, i, value);
            }, function(reason) {
                return enumerator._settledAt(REJECTED, i, reason);
            });
        };
        return Enumerator;
    }();
    /**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/ function all(entries) {
        return new Enumerator(this, entries).promise;
    }
    /**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/ function race(entries) {
        /*jshint validthis:true */ var Constructor = this;
        if (!isArray(entries)) return new Constructor(function(_, reject) {
            return reject(new TypeError('You must pass an array to race.'));
        });
        else return new Constructor(function(resolve, reject) {
            var length = entries.length;
            for(var i = 0; i < length; i++)Constructor.resolve(entries[i]).then(resolve, reject);
        });
    }
    /**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/ function reject$1(reason) {
        /*jshint validthis:true */ var Constructor = this;
        var promise = new Constructor(noop);
        reject(promise, reason);
        return promise;
    }
    function needsResolver() {
        throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
    }
    function needsNew() {
        throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
    }
    /**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/ var Promise$1 = function() {
        function Promise(resolver) {
            this[PROMISE_ID] = nextId();
            this._result = this._state = undefined;
            this._subscribers = [];
            if (noop !== resolver) {
                typeof resolver !== 'function' && needsResolver();
                this instanceof Promise ? initializePromise(this, resolver) : needsNew();
            }
        }
        /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */ /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */ Promise.prototype.catch = function _catch(onRejection) {
            return this.then(null, onRejection);
        };
        /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */ Promise.prototype.finally = function _finally(callback) {
            var promise = this;
            var constructor = promise.constructor;
            if (isFunction(callback)) return promise.then(function(value) {
                return constructor.resolve(callback()).then(function() {
                    return value;
                });
            }, function(reason) {
                return constructor.resolve(callback()).then(function() {
                    throw reason;
                });
            });
            return promise.then(callback, callback);
        };
        return Promise;
    }();
    Promise$1.prototype.then = then;
    Promise$1.all = all;
    Promise$1.race = race;
    Promise$1.resolve = resolve$1;
    Promise$1.reject = reject$1;
    Promise$1._setScheduler = setScheduler;
    Promise$1._setAsap = setAsap;
    Promise$1._asap = asap;
    /*global self*/ function polyfill() {
        var local = void 0;
        if (typeof $parcel$global !== 'undefined') local = $parcel$global;
        else if (typeof self !== 'undefined') local = self;
        else try {
            local = Function('return this')();
        } catch (e) {
            throw new Error('polyfill failed because global object is unavailable in this environment');
        }
        var P = local.Promise;
        if (P) {
            var promiseToString = null;
            try {
                promiseToString = Object.prototype.toString.call(P.resolve());
            } catch (e) {
            // silently ignored
            }
            if (promiseToString === '[object Promise]' && !P.cast) return;
        }
        local.Promise = Promise$1;
    }
    // Strange compat..
    Promise$1.polyfill = polyfill;
    Promise$1.Promise = Promise$1;
    return Promise$1;
});

});

parcelRegister("jvF5r", function(module, exports) {
'use strict';
module.exports = $e340c886c300671b$var$inlineHeaders;

var $9xtCu = parcelRequire("9xtCu");
function $e340c886c300671b$var$inlineHeaders(url, headers) {
    if (/\?/.test(url)) url += '&';
    else url += '?';
    return url + $9xtCu(headers);
}

});
parcelRegister("9xtCu", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $6f1e2c05a5f80c6e$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? 'true' : 'false';
        case 'number':
            return isFinite(v) ? v : '';
        default:
            return '';
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || '&';
    eq = eq || '=';
    if (obj === null) obj = undefined;
    if (typeof obj === 'object') return $6f1e2c05a5f80c6e$var$map($6f1e2c05a5f80c6e$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($6f1e2c05a5f80c6e$var$stringifyPrimitive(k)) + eq;
        if ($6f1e2c05a5f80c6e$var$isArray(obj[k])) return $6f1e2c05a5f80c6e$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($6f1e2c05a5f80c6e$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($6f1e2c05a5f80c6e$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return '';
    return encodeURIComponent($6f1e2c05a5f80c6e$var$stringifyPrimitive(name)) + eq + encodeURIComponent($6f1e2c05a5f80c6e$var$stringifyPrimitive(obj));
};
var $6f1e2c05a5f80c6e$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};
function $6f1e2c05a5f80c6e$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $6f1e2c05a5f80c6e$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

});


parcelRegister("4udmp", function(module, exports) {
'use strict';
module.exports = $344453e151f0cff5$var$jsonpRequest;

var $bRG5U = parcelRequire("bRG5U");
var $344453e151f0cff5$var$JSONPCounter = 0;
function $344453e151f0cff5$var$jsonpRequest(url, opts, cb) {
    if (opts.method !== 'GET') {
        cb(new Error('Method ' + opts.method + ' ' + url + ' is not supported by JSONP.'));
        return;
    }
    opts.debug('JSONP: start');
    var cbCalled = false;
    var timedOut = false;
    $344453e151f0cff5$var$JSONPCounter += 1;
    var head = document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    var cbName = 'algoliaJSONP_' + $344453e151f0cff5$var$JSONPCounter;
    var done = false;
    window[cbName] = function(data) {
        removeGlobals();
        if (timedOut) {
            opts.debug('JSONP: Late answer, ignoring');
            return;
        }
        cbCalled = true;
        clean();
        cb(null, {
            body: data,
            responseText: JSON.stringify(data)
        });
    };
    // add callback by hand
    url += '&callback=' + cbName;
    // add body params manually
    if (opts.jsonBody && opts.jsonBody.params) url += '&' + opts.jsonBody.params;
    var ontimeout = setTimeout(timeout, opts.timeouts.complete);
    // script onreadystatechange needed only for
    // <= IE8
    // https://github.com/angular/angular.js/issues/4523
    script.onreadystatechange = readystatechange;
    script.onload = success;
    script.onerror = error;
    script.async = true;
    script.defer = true;
    script.src = url;
    head.appendChild(script);
    function success() {
        opts.debug('JSONP: success');
        if (done || timedOut) return;
        done = true;
        // script loaded but did not call the fn => script loading error
        if (!cbCalled) {
            opts.debug('JSONP: Fail. Script loaded but did not call the callback');
            clean();
            cb(new $bRG5U.JSONPScriptFail());
        }
    }
    function readystatechange() {
        if (this.readyState === 'loaded' || this.readyState === 'complete') success();
    }
    function clean() {
        clearTimeout(ontimeout);
        script.onload = null;
        script.onreadystatechange = null;
        script.onerror = null;
        head.removeChild(script);
    }
    function removeGlobals() {
        try {
            delete window[cbName];
            delete window[cbName + '_loaded'];
        } catch (e) {
            window[cbName] = window[cbName + '_loaded'] = undefined;
        }
    }
    function timeout() {
        opts.debug('JSONP: Script timeout');
        timedOut = true;
        clean();
        cb(new $bRG5U.RequestTimeout());
    }
    function error() {
        opts.debug('JSONP: Script error');
        if (done || timedOut) return;
        clean();
        cb(new $bRG5U.JSONPScriptError());
    }
}

});

parcelRegister("joGZo", function(module, exports) {
module.exports = $e1f19af914187025$var$createPlacesClient;

var $8itcz = parcelRequire("8itcz");

var $lfQVS = parcelRequire("lfQVS");

function $e1f19af914187025$var$createPlacesClient(algoliasearch) {
    return function places(appID, apiKey, opts) {
        var cloneDeep = (parcelRequire("eFOtW"));
        opts = opts && cloneDeep(opts) || {};
        opts.hosts = opts.hosts || [
            'places-dsn.algolia.net',
            'places-1.algolianet.com',
            'places-2.algolianet.com',
            'places-3.algolianet.com'
        ];
        // allow initPlaces() no arguments => community rate limited
        if (arguments.length === 0 || typeof appID === 'object' || appID === undefined) {
            appID = '';
            apiKey = '';
            opts._allowEmptyCredentials = true;
        }
        var client = algoliasearch(appID, apiKey, opts);
        var index = client.initIndex('places');
        index.search = $lfQVS('query', '/1/places/query');
        index.reverse = function(options, callback) {
            var encoded = $8itcz.encode(options);
            return this.as._jsonRequest({
                method: 'GET',
                url: '/1/places/reverse?' + encoded,
                hostType: 'read',
                callback: callback
            });
        };
        index.getObject = function(objectID, callback) {
            return this.as._jsonRequest({
                method: 'GET',
                url: '/1/places/' + encodeURIComponent(objectID),
                hostType: 'read',
                callback: callback
            });
        };
        return index;
    };
}

});
parcelRegister("8itcz", function(module, exports) {

$parcel$export(module.exports, "decode", () => $60a6a8029ffaae01$export$2f872c0f2117be69, (v) => $60a6a8029ffaae01$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "parse", () => $60a6a8029ffaae01$export$98e6a39c04603d36, (v) => $60a6a8029ffaae01$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "encode", () => $60a6a8029ffaae01$export$c564cdbbe6da493, (v) => $60a6a8029ffaae01$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "stringify", () => $60a6a8029ffaae01$export$fac44ee5b035f737, (v) => $60a6a8029ffaae01$export$fac44ee5b035f737 = v);
var $60a6a8029ffaae01$export$2f872c0f2117be69;
var $60a6a8029ffaae01$export$98e6a39c04603d36;
var $60a6a8029ffaae01$export$c564cdbbe6da493;
var $60a6a8029ffaae01$export$fac44ee5b035f737;
'use strict';

$60a6a8029ffaae01$export$2f872c0f2117be69 = $60a6a8029ffaae01$export$98e6a39c04603d36 = (parcelRequire("4WGGY"));

$60a6a8029ffaae01$export$c564cdbbe6da493 = $60a6a8029ffaae01$export$fac44ee5b035f737 = (parcelRequire("9xtCu"));

});
parcelRegister("4WGGY", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $399db1fd33a7e3fa$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || '&';
    eq = eq || '=';
    var obj = {};
    if (typeof qs !== 'string' || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === 'number') maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, '%20'), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = '';
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$399db1fd33a7e3fa$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($399db1fd33a7e3fa$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var $399db1fd33a7e3fa$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};

});



parcelRegister("7FtoO", function(module, exports) {
'use strict';
module.exports = '3.35.1';

});




parcelRegister("iXJMo", function(module, exports) {

$parcel$export(module.exports, "default", () => $dce13f907d833a6d$export$2e2bcd8739ae039);
parcelRequire("jJs3W");
var $94zHK = parcelRequire("94zHK");

var $kKkev = parcelRequire("kKkev");

var $kUEnb = parcelRequire("kUEnb");
function $dce13f907d833a6d$var$mapStateToProps(state) {
    return {
        search: state.get('search')
    };
}
function $dce13f907d833a6d$var$mapDispatchToProps(dispatch, ownProps) {
    return {
        doFreshSearch (_ref) {
            let { filters: filters, resolveAlgoliaQueryFilterOverrides: resolveAlgoliaQueryFilterOverrides, featureFlags: featureFlags } = _ref;
            dispatch((0, $kKkev.doFreshSearch)({
                algoliaClient: ownProps.algoliaClient,
                applyOverrides: ownProps.applyOverrides,
                environment: ownProps.environment,
                filters: filters,
                resolveAlgoliaQueryFilterOverrides: resolveAlgoliaQueryFilterOverrides,
                featureFlags: featureFlags
            }));
        },
        onLoadMoreResultsClick (_ref2) {
            let { currentPage: currentPage, featureFlags: featureFlags } = _ref2;
            if (ownProps.onLoadMoreResultsClick) ownProps.onLoadMoreResultsClick({
                currentPage: currentPage
            });
            dispatch((0, $kKkev.loadMoreResults)({
                algoliaClient: ownProps.algoliaClient,
                applyOverrides: ownProps.applyOverrides,
                environment: ownProps.environment,
                filters: ownProps.filters,
                nextPage: currentPage + 1,
                resolveAlgoliaQueryFilterOverrides: ownProps.resolveAlgoliaQueryFilterOverrides,
                featureFlags: featureFlags
            }));
        }
    };
}
var $dce13f907d833a6d$export$2e2bcd8739ae039 = (0, $94zHK.default)($dce13f907d833a6d$var$mapStateToProps, $dce13f907d833a6d$var$mapDispatchToProps)((0, $kUEnb.default));

});
parcelRegister("kKkev", function(module, exports) {

$parcel$export(module.exports, "RECEIVE_FACETS", () => $f1a7cc5ea189d86b$export$84c83b2dccce27d0);
$parcel$export(module.exports, "FACETS_DATA_ERROR", () => $f1a7cc5ea189d86b$export$5033f6e9d7ffa3d4);
$parcel$export(module.exports, "RETRIEVE_FRESH_SEARCH_RESULTS", () => $f1a7cc5ea189d86b$export$da8cccd087c6db9b);
$parcel$export(module.exports, "RECEIVE_FRESH_SEARCH_RESULTS", () => $f1a7cc5ea189d86b$export$7ef116fec8a1ad14);
$parcel$export(module.exports, "DATA_ERROR_FRESH_SEARCH_RESULTS", () => $f1a7cc5ea189d86b$export$61ce092fd8b8a8ef);
$parcel$export(module.exports, "RETRIEVE_MORE_SEARCH_RESULTS", () => $f1a7cc5ea189d86b$export$b2107ac8eb4fbfd9);
$parcel$export(module.exports, "RECEIVE_MORE_SEARCH_RESULTS", () => $f1a7cc5ea189d86b$export$49f90134eeb0802d);
$parcel$export(module.exports, "DATA_ERROR_MORE_SEARCH_RESULTS", () => $f1a7cc5ea189d86b$export$f15d7aa2af12e80f);
$parcel$export(module.exports, "doFreshSearch", () => $f1a7cc5ea189d86b$export$ab0863ca760fbd87);
$parcel$export(module.exports, "loadMoreResults", () => $f1a7cc5ea189d86b$export$4b86a09a3957e324);

var $fUOHe = parcelRequire("fUOHe");

var $4fL5K = parcelRequire("4fL5K");

var $bavaN = parcelRequire("bavaN");

var $iDEAo = parcelRequire("iDEAo");

var $8Hj3g = parcelRequire("8Hj3g");
const $f1a7cc5ea189d86b$export$84c83b2dccce27d0 = 'SEARCH_RECEIVE_FACETS';
const $f1a7cc5ea189d86b$export$5033f6e9d7ffa3d4 = 'SEARCH_FACETS_DATA_ERROR';
const $f1a7cc5ea189d86b$export$da8cccd087c6db9b = 'SEARCH_RETRIEVE_FRESH_SEARCH_RESULTS';
const $f1a7cc5ea189d86b$export$7ef116fec8a1ad14 = 'SEARCH_RECEIVE_FRESH_SEARCH_RESULTS';
const $f1a7cc5ea189d86b$export$61ce092fd8b8a8ef = 'SEARCH_DATA_ERROR_FRESH_SEARCH_RESULTS';
const $f1a7cc5ea189d86b$export$b2107ac8eb4fbfd9 = 'SEARCH_RETRIEVE_MORE_SEARCH_RESULTS';
const $f1a7cc5ea189d86b$export$49f90134eeb0802d = 'SEARCH_RECEIVE_MORE_SEARCH_RESULTS';
const $f1a7cc5ea189d86b$export$f15d7aa2af12e80f = 'SEARCH_DATA_ERROR_MORE_SEARCH_RESULTS';
function $f1a7cc5ea189d86b$var$retrieveFreshSearchResults(_ref) {
    let { searchId: searchId, reducerId: reducerId } = _ref;
    return {
        type: $f1a7cc5ea189d86b$export$da8cccd087c6db9b,
        searchId: searchId,
        reducerId: reducerId
    };
}
function $f1a7cc5ea189d86b$var$receiveFreshSearchResults(_ref2) {
    let { searchId: searchId, searchResults: searchResults, reducerId: reducerId } = _ref2;
    return {
        type: $f1a7cc5ea189d86b$export$7ef116fec8a1ad14,
        searchId: searchId,
        searchResults: searchResults,
        reducerId: reducerId
    };
}
function $f1a7cc5ea189d86b$var$dataErrorFreshSearchResults(_ref3) {
    let { dataErrorMessages: dataErrorMessages, reducerId: reducerId } = _ref3;
    return {
        type: $f1a7cc5ea189d86b$export$61ce092fd8b8a8ef,
        dataErrorMessages: dataErrorMessages,
        reducerId: reducerId
    };
}
function $f1a7cc5ea189d86b$var$retrieveMoreSearchResults(_ref4) {
    let { reducerId: reducerId } = _ref4;
    return {
        type: $f1a7cc5ea189d86b$export$b2107ac8eb4fbfd9,
        reducerId: reducerId
    };
}
function $f1a7cc5ea189d86b$var$receiveMoreSearchResults(_ref5) {
    let { page: page, searchResults: searchResults, reducerId: reducerId } = _ref5;
    return {
        type: $f1a7cc5ea189d86b$export$49f90134eeb0802d,
        page: page,
        searchResults: searchResults,
        reducerId: reducerId
    };
}
function $f1a7cc5ea189d86b$var$dataErrorMoreSearchResults(_ref6) {
    let { dataErrorMessages: dataErrorMessages, reducerId: reducerId } = _ref6;
    return {
        type: $f1a7cc5ea189d86b$export$f15d7aa2af12e80f,
        dataErrorMessages: dataErrorMessages,
        reducerId: reducerId
    };
}
function $f1a7cc5ea189d86b$var$receiveFacets(_ref7) {
    let { facets: facets, reducerId: reducerId } = _ref7;
    return {
        type: $f1a7cc5ea189d86b$export$84c83b2dccce27d0,
        facets: facets,
        reducerId: reducerId
    };
}
function $f1a7cc5ea189d86b$var$facetsDataError(_ref8) {
    let { dataErrorMessages: dataErrorMessages, reducerId: reducerId } = _ref8;
    return {
        type: $f1a7cc5ea189d86b$export$5033f6e9d7ffa3d4,
        dataErrorMessages: dataErrorMessages,
        reducerId: reducerId
    };
}
const $f1a7cc5ea189d86b$var$HITS_PER_PAGE = 24;
function $f1a7cc5ea189d86b$export$ab0863ca760fbd87(_ref9) {
    let { algoliaClient: algoliaClient, applyOverrides: applyOverrides, environment: environment, filters: filters, resolveAlgoliaQueryFilterOverrides: resolveAlgoliaQueryFilterOverrides, featureFlags: featureFlags } = _ref9;
    let { forReducerId: forReducerId } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        forReducerId: undefined
    };
    return (dispatch)=>{
        (0, $4fL5K.SearchTask).start();
        const searchId = (0, $iDEAo.generateSearchId)();
        dispatch($f1a7cc5ea189d86b$var$retrieveFreshSearchResults({
            searchId: searchId,
            reducerId: forReducerId
        }));
        (0, $bavaN.search)({
            algoliaClient: algoliaClient,
            applyOverrides: applyOverrides,
            resolveAlgoliaQueryFilterOverrides: resolveAlgoliaQueryFilterOverrides,
            environment: environment,
            filters: filters,
            numHits: $f1a7cc5ea189d86b$var$HITS_PER_PAGE,
            page: 0,
            featureFlags: featureFlags
        }).then((data)=>{
            dispatch($f1a7cc5ea189d86b$var$receiveFacets({
                facets: data.get('facets'),
                reducerId: forReducerId
            }));
            dispatch($f1a7cc5ea189d86b$var$receiveFreshSearchResults({
                searchId: searchId,
                searchResults: data.get('searchResults'),
                reducerId: forReducerId
            }));
            (0, $4fL5K.SearchTask).succeeded();
        }, (error)=>{
            if (error.debugData) {
                console.error('Search error, debug data: ');
                console.error(error.debugData);
            }
            const dataErrorMessages = (0, $8Hj3g.default)(error);
            dispatch($f1a7cc5ea189d86b$var$facetsDataError({
                dataErrorMessages: dataErrorMessages,
                reducerId: forReducerId
            }));
            dispatch($f1a7cc5ea189d86b$var$dataErrorFreshSearchResults({
                dataErrorMessages: dataErrorMessages,
                reducerId: forReducerId
            }));
            (0, $fUOHe.default).setUFOInteractionError({
                name: (0, $4fL5K.searchTaskName),
                errorMessage: error === null || error === void 0 ? void 0 : error.message
            });
            (0, $4fL5K.SearchTask).failed(error);
        });
    };
}
function $f1a7cc5ea189d86b$export$4b86a09a3957e324(_ref10) {
    let { algoliaClient: algoliaClient, applyOverrides: applyOverrides, environment: environment, filters: filters, nextPage: nextPage, resolveAlgoliaQueryFilterOverrides: resolveAlgoliaQueryFilterOverrides, featureFlags: featureFlags } = _ref10;
    let { forReducerId: forReducerId } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        forReducerId: undefined
    };
    return (dispatch)=>{
        dispatch($f1a7cc5ea189d86b$var$retrieveMoreSearchResults({
            reducerId: forReducerId
        }));
        (0, $bavaN.search)({
            algoliaClient: algoliaClient,
            applyOverrides: applyOverrides,
            environment: environment,
            filters: filters,
            numHits: $f1a7cc5ea189d86b$var$HITS_PER_PAGE,
            page: nextPage,
            resolveAlgoliaQueryFilterOverrides: resolveAlgoliaQueryFilterOverrides,
            featureFlags: featureFlags
        }).then((data)=>{
            dispatch($f1a7cc5ea189d86b$var$receiveFacets({
                facets: data.get('facets'),
                reducerId: forReducerId
            }));
            dispatch($f1a7cc5ea189d86b$var$receiveMoreSearchResults({
                page: nextPage,
                searchResults: data.get('searchResults'),
                reducerId: forReducerId
            }));
        }, (error)=>{
            if (error.debugData) {
                console.error('Search error, debug data: ');
                console.error(error.debugData);
            }
            const dataErrorMessages = (0, $8Hj3g.default)(error);
            dispatch($f1a7cc5ea189d86b$var$dataErrorMoreSearchResults({
                dataErrorMessages: dataErrorMessages,
                reducerId: forReducerId
            }));
        });
    };
}

});
parcelRegister("fUOHe", function(module, exports) {

$parcel$export(module.exports, "default", () => $b963692fe4cd3445$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $6bWmm = parcelRequire("6bWmm");

var $fX8fU = parcelRequire("fX8fU");

var $ilgCJ = parcelRequire("ilgCJ");

var $MB7Ow = parcelRequire("MB7Ow");

var $kCL8m = parcelRequire("kCL8m");
function $b963692fe4cd3445$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b963692fe4cd3445$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b963692fe4cd3445$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b963692fe4cd3445$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $b963692fe4cd3445$export$2e2bcd8739ae039 {
    static setPage() {
        let pageName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'PAGE_UNKNOWN';
        // If we'd previously set a page and are changing it now,
        // it should be a client side render
        if ($b963692fe4cd3445$export$2e2bcd8739ae039.activePageName && $b963692fe4cd3445$export$2e2bcd8739ae039.activePageName !== pageName) {
            $b963692fe4cd3445$export$2e2bcd8739ae039.isInitialRender = false;
            $b963692fe4cd3445$export$2e2bcd8739ae039.pageNavigationStartTime = performance.now();
            $b963692fe4cd3445$export$2e2bcd8739ae039.isPageReady.resolve();
        }
        $b963692fe4cd3445$export$2e2bcd8739ae039.activePageName = pageName;
    }
    static fireComponentBoundaryError(componentName, error) {
        $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit({
            type: (0, $6bWmm.Events).LABEL_COMPONENT_ERROR_BOUNDARY,
            componentName: componentName,
            error: error
        });
        $b963692fe4cd3445$export$2e2bcd8739ae039.abortAllTasks(error);
    }
    static fireSearchTiming(duration) {
        $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit({
            type: (0, $6bWmm.Events).LABEL_ALGOLIA_SEARCH_TIMING,
            duration: duration
        });
    }
    static task(options) {
        const { successful: successful, task: task, taskId: taskId, duration: duration, cause: cause } = options;
        $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit({
            type: (0, $6bWmm.Events).LABEL_GENERIC_TASK,
            successful: successful,
            task: task,
            taskId: taskId,
            duration: duration,
            cause: cause
        });
    }
    static _createTask(taskName, taskType) {
        const createdTask = new (0, $fX8fU.default)(taskName);
        createdTask.addCompletionListener((args)=>{
            const { success: success, duration: duration, cause: cause, taskId: taskId, task: task } = args;
            $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit($b963692fe4cd3445$var$_objectSpread($b963692fe4cd3445$var$_objectSpread({}, taskType), {}, {
                successful: success,
                task: task,
                taskId: taskId,
                duration: duration,
                cause: cause
            }));
        });
        $b963692fe4cd3445$export$2e2bcd8739ae039.registeredTasks.push(createdTask);
        return createdTask;
    }
    static createPageViewTask(taskName) {
        return $b963692fe4cd3445$export$2e2bcd8739ae039._createTask(taskName, {
            type: (0, $6bWmm.Events).LABEL_PAGE_VIEW_TASK
        });
    }
    static createGenericTask(taskName) {
        return $b963692fe4cd3445$export$2e2bcd8739ae039._createTask(taskName, {
            type: (0, $6bWmm.Events).LABEL_GENERIC_TASK
        });
    }
    static abortAllTasks(error) {
        $b963692fe4cd3445$export$2e2bcd8739ae039.registeredTasks.forEach((task)=>task.failed(error));
    }
    static routeChangeStart() {
        $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit({
            type: (0, $6bWmm.Events).LABEL_ROUTE_CHANGE_START
        });
    }
    static timeToFirstPaint(duration) {
        $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit({
            type: (0, $6bWmm.Events).LABEL_TIME_TO_FIRST_CONTENTFUL_PAINT,
            duration: duration
        });
    }
    static timeToFirstMeaningfulPaint(endTime) {
        $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit({
            type: (0, $6bWmm.Events).LABEL_TIME_TO_FIRST_MEANINGFUL_PAINT,
            endTime: endTime
        });
    }
    static timeToLargestContentfulPaint(duration) {
        $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit({
            type: (0, $6bWmm.Events).LABEL_TIME_TO_LARGEST_CONTENTFUL_PAINT,
            duration: duration
        });
    }
    static firstInputDelay(duration) {
        $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit({
            type: (0, $6bWmm.Events).LABEL_FIRST_INPUT_DELAY,
            duration: duration
        });
    }
    static timeToFirstByte(duration) {
        $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit({
            type: (0, $6bWmm.Events).LABEL_TIME_TO_FIRST_BYTE,
            duration: duration
        });
    }
    static timeToInteractive(duration) {
        $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit({
            type: (0, $6bWmm.Events).LABEL_TIME_TO_INTERACTIVE,
            duration: duration
        });
    }
    static cumulativeLayoutShift(shift) {
        $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit({
            type: (0, $6bWmm.Events).LABEL_CUMULATIVE_LAYOUT_SHIFT,
            shift: shift
        });
    }
    static resourceDownloadTime(type, duration) {
        $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit({
            type: (0, $6bWmm.Events).LABEL_RESOURCE_DOWNLOAD_TIME_SUM,
            duration: duration,
            resourceType: type
        });
    }
    static traceUFOPageLoad(routeName) {
        $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit({
            type: (0, $6bWmm.Events).LABEL_TRACE_UFO_PAGE_LOAD,
            routeName: routeName
        });
    }
    static setUFOInteractionError(error, interactionName) {
        $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit({
            type: (0, $6bWmm.Events).LABEL_UFO_INTERACTION_ERROR,
            error: error,
            interactionName: interactionName
        });
    }
    static traceUFOPress(interactionName) {
        $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit({
            type: (0, $6bWmm.Events).LABEL_TRACE_UFO_PRESS,
            interactionName: interactionName
        });
    }
}
(0, $5zQU9.default)($b963692fe4cd3445$export$2e2bcd8739ae039, "messageQueue", new (0, $MB7Ow.default)());
(0, $5zQU9.default)($b963692fe4cd3445$export$2e2bcd8739ae039, "registeredTasks", []);
(0, $5zQU9.default)($b963692fe4cd3445$export$2e2bcd8739ae039, "isInitialRender", true);
(0, $5zQU9.default)($b963692fe4cd3445$export$2e2bcd8739ae039, "activePageName", '');
(0, $5zQU9.default)($b963692fe4cd3445$export$2e2bcd8739ae039, "pageNavigationStartTime", (0, $kCL8m.getNavigationTiming)().fetchStart);
(0, $5zQU9.default)($b963692fe4cd3445$export$2e2bcd8739ae039, "isPageReady", new (0, $ilgCJ.default)());

});
parcelRegister("6bWmm", function(module, exports) {

$parcel$export(module.exports, "Events", () => $48210a2505b4e0c9$export$ada873a34909da65);
let $48210a2505b4e0c9$export$ada873a34909da65 = /*#__PURE__*/ function(Events) {
    Events["LABEL_FIRST_INPUT_DELAY"] = "first-input-delay";
    Events["LABEL_TIME_TO_FIRST_BYTE"] = "time-to-first-byte";
    Events["LABEL_TIME_TO_INTERACTIVE"] = "time-to-interactive";
    Events["LABEL_TIME_TO_FIRST_CONTENTFUL_PAINT"] = "first-contentful-paint";
    Events["LABEL_TIME_TO_LARGEST_CONTENTFUL_PAINT"] = "largest-contentful-paint";
    Events["LABEL_CUMULATIVE_LAYOUT_SHIFT"] = "cumulative-layout-shift";
    Events["LABEL_TIME_TO_FIRST_MEANINGFUL_PAINT"] = "first-meaningful-paint";
    Events["LABEL_RESOURCE_DOWNLOAD_TIME_SUM"] = "resource-download-time-sum";
    Events["LABEL_CAAS_SPI_METHOD_EXECUTION"] = "caas-spi-execution";
    Events["LABEL_ALGOLIA_SEARCH_TIMING"] = "algolia-search";
    Events["LABEL_COMPONENT_ERROR_BOUNDARY"] = "component-error-boundary";
    Events["LABEL_GENERIC_TASK"] = "generic-task";
    Events["LABEL_PAGE_VIEW_TASK"] = "page-view-task";
    Events["LABEL_ROUTE_CHANGE_START"] = "route-change-start";
    Events["LABEL_TRACE_UFO_PAGE_LOAD"] = "trace-ufo-page-load";
    Events["LABEL_UFO_INTERACTION_ERROR"] = "set-ufo-interaction-error";
    Events["LABEL_TRACE_UFO_PRESS"] = "trace-ufo-page-press";
    return Events;
}({}); /** @see https://developer.atlassian.com/platform/metal/introduction/metric-descriptions/#component-boundary-errors */ 

});

parcelRegister("fX8fU", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9d2c51a881f167c$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
function $b9d2c51a881f167c$var$_classPrivateFieldInitSpec(e, t, a) {
    $b9d2c51a881f167c$var$_checkPrivateRedeclaration(e, t), t.set(e, a);
}
function $b9d2c51a881f167c$var$_checkPrivateRedeclaration(e, t) {
    if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $b9d2c51a881f167c$var$_classPrivateFieldGet(s, a) {
    return s.get($b9d2c51a881f167c$var$_assertClassBrand(s, a));
}
function $b9d2c51a881f167c$var$_classPrivateFieldSet(s, a, r) {
    return s.set($b9d2c51a881f167c$var$_assertClassBrand(s, a), r), r;
}
function $b9d2c51a881f167c$var$_assertClassBrand(e, t, n) {
    if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
    throw new TypeError("Private element is not present on this object");
}
var $b9d2c51a881f167c$var$_dependencies = /*#__PURE__*/ new WeakMap();
var $b9d2c51a881f167c$var$_startTime = /*#__PURE__*/ new WeakMap();
var $b9d2c51a881f167c$var$_pendingDependencies = /*#__PURE__*/ new WeakMap();
var $b9d2c51a881f167c$var$_onCompleteListeners = /*#__PURE__*/ new WeakMap();
var $b9d2c51a881f167c$var$_onDependencyCompleted = /*#__PURE__*/ new WeakMap();
class $b9d2c51a881f167c$export$2e2bcd8739ae039 {
    constructor(task){
        (0, $5zQU9.default)(this, "task", void 0);
        $b9d2c51a881f167c$var$_classPrivateFieldInitSpec(this, $b9d2c51a881f167c$var$_dependencies, void 0);
        $b9d2c51a881f167c$var$_classPrivateFieldInitSpec(this, $b9d2c51a881f167c$var$_startTime, void 0);
        $b9d2c51a881f167c$var$_classPrivateFieldInitSpec(this, $b9d2c51a881f167c$var$_pendingDependencies, void 0);
        $b9d2c51a881f167c$var$_classPrivateFieldInitSpec(this, $b9d2c51a881f167c$var$_onCompleteListeners, void 0);
        $b9d2c51a881f167c$var$_classPrivateFieldInitSpec(this, $b9d2c51a881f167c$var$_onDependencyCompleted, void 0);
        this.task = task;
        $b9d2c51a881f167c$var$_classPrivateFieldSet($b9d2c51a881f167c$var$_onCompleteListeners, this, []);
        $b9d2c51a881f167c$var$_classPrivateFieldSet($b9d2c51a881f167c$var$_dependencies, this, []);
        $b9d2c51a881f167c$var$_classPrivateFieldSet($b9d2c51a881f167c$var$_onDependencyCompleted, this, (completedTask)=>{
            const { task: currentTask, success: success } = completedTask;
            if (!$b9d2c51a881f167c$var$_classPrivateFieldGet($b9d2c51a881f167c$var$_startTime, this)) return;
            if (!success) {
                // a dependency has failed, so we must end the current task as a failure
                // end also takes care of cleanup
                this.failed(completedTask);
                return;
            }
            // remove the current dependency task from the pending list
            $b9d2c51a881f167c$var$_classPrivateFieldSet($b9d2c51a881f167c$var$_pendingDependencies, this, $b9d2c51a881f167c$var$_classPrivateFieldGet($b9d2c51a881f167c$var$_pendingDependencies, this).filter((dependency)=>dependency.task !== currentTask));
            // if all pending tasks have been completed (successfully), this task should also be marked complete
            if ($b9d2c51a881f167c$var$_classPrivateFieldGet($b9d2c51a881f167c$var$_pendingDependencies, this).length === 0) this.succeeded();
        });
    }
    hasDependencies() {
        return $b9d2c51a881f167c$var$_classPrivateFieldGet($b9d2c51a881f167c$var$_dependencies, this).length !== 0;
    }
    addCompletionListener(listener) {
        $b9d2c51a881f167c$var$_classPrivateFieldGet($b9d2c51a881f167c$var$_onCompleteListeners, this).push(listener);
        return this;
    }
    start() {
        $b9d2c51a881f167c$var$_classPrivateFieldSet($b9d2c51a881f167c$var$_startTime, this, performance.now());
        $b9d2c51a881f167c$var$_classPrivateFieldSet($b9d2c51a881f167c$var$_pendingDependencies, this, $b9d2c51a881f167c$var$_classPrivateFieldGet($b9d2c51a881f167c$var$_dependencies, this).map((dependency)=>dependency));
        return this;
    }
    /**
   * Call when the task is successfully completed. If this task has dependencies, it will
   * automatically be marked as successfully completed when _all_ of the dependencies also
   * successfully completed.
   */ succeeded() {
        this._end(true);
    }
    /**
   * Call when the task fails. If this task has dependencies, it will automatically be marked as
   * failed if _any one_ of the dependencies also fail.
   */ failed(cause, errorIdentifier) {
        this._end(false, cause, errorIdentifier);
    }
    /**
   * Call when the task needs to be aborted. This resets the state without triggering any "success"
   * or "failure" events.
   * Eg: For an App Listing page view task, if the used is redirected to the login page, the task
   * would need to be aborted since its neither a success not a failure.
   */ abort() {
        if (typeof $b9d2c51a881f167c$var$_classPrivateFieldGet($b9d2c51a881f167c$var$_startTime, this) !== 'number') {
            console.warn("[".concat(this.task, "] noop: Attempted to \"abort\" a task which wasn't started."));
            return;
        }
        $b9d2c51a881f167c$var$_classPrivateFieldGet($b9d2c51a881f167c$var$_pendingDependencies, this).forEach((depdendency)=>depdendency.abort());
        this._resetState();
    }
    _end(success, cause, identifier) {
        const startTime = $b9d2c51a881f167c$var$_classPrivateFieldGet($b9d2c51a881f167c$var$_startTime, this);
        if (typeof startTime !== 'number') {
            console.warn("[".concat(this.task, "] noop: Attempted to \"end\" a task which wasn't started."));
            return;
        }
        const duration = performance.now() - startTime;
        /* Metal doesn't provide an option to pass error identifier.
     * So, utilising taskId as a error identifier */ $b9d2c51a881f167c$var$_classPrivateFieldGet($b9d2c51a881f167c$var$_onCompleteListeners, this).forEach((listener)=>listener({
                task: this.task,
                taskId: identifier,
                success: success,
                cause: cause,
                duration: duration
            }));
        this._resetState();
        return this;
    }
    _resetState() {
        $b9d2c51a881f167c$var$_classPrivateFieldSet($b9d2c51a881f167c$var$_startTime, this, null);
        $b9d2c51a881f167c$var$_classPrivateFieldSet($b9d2c51a881f167c$var$_pendingDependencies, this, []);
        return this;
    }
    dependsOn(dependencies) {
        const hasNestedDependencies = dependencies.some((dependency)=>dependency.hasDependencies());
        if (hasNestedDependencies) throw new Error("[".concat(this.task, "] task may not depend on sub-tasks which themselves have other dependencies"));
        $b9d2c51a881f167c$var$_classPrivateFieldSet($b9d2c51a881f167c$var$_dependencies, this, [
            ...dependencies
        ]);
        $b9d2c51a881f167c$var$_classPrivateFieldGet($b9d2c51a881f167c$var$_dependencies, this).forEach((dependency)=>{
            dependency.addCompletionListener($b9d2c51a881f167c$var$_classPrivateFieldGet($b9d2c51a881f167c$var$_onDependencyCompleted, this));
        });
        return this;
    }
}

});

parcelRegister("ilgCJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5a71545a2ea84cc$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
class $d5a71545a2ea84cc$export$2e2bcd8739ae039 {
    constructor(){
        (0, $5zQU9.default)(this, "resolve", ()=>{
        /* resolve undefined by default */ });
        (0, $5zQU9.default)(this, "reject", ()=>{
        /* reject with undefined by default */ });
        (0, $5zQU9.default)(this, "promise", new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        }));
        (0, $5zQU9.default)(this, "then", this.promise.then.bind(this.promise));
        (0, $5zQU9.default)(this, "catch", this.promise.catch.bind(this.promise));
    }
}

});

parcelRegister("MB7Ow", function(module, exports) {

$parcel$export(module.exports, "default", () => $0921481131df09da$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $94Bah = parcelRequire("94Bah");
function $0921481131df09da$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0921481131df09da$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0921481131df09da$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0921481131df09da$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $0921481131df09da$export$2e2bcd8739ae039 {
    constructor(){
        (0, $5zQU9.default)(this, "messages", []);
        (0, $5zQU9.default)(this, "subscriber", void 0);
    }
    emit(message) {
        this.messages.push($0921481131df09da$var$_objectSpread({
            id: (0, $94Bah.nanoid)()
        }, message));
        if (this.subscriber) this.processQueue();
    }
    setSubscriber(subscriber) {
        this.subscriber = subscriber;
        this.processQueue();
    }
    dequeueMessage(messageId) {
        this.messages = this.messages.filter((message)=>message.id !== messageId);
    }
    processQueue() {
        this.messages.forEach((message)=>{
            this.subscriber(message);
            this.dequeueMessage(message.id);
        });
    }
}

});
parcelRegister("94Bah", function(module, exports) {

$parcel$export(module.exports, "nanoid", () => $69b150f0899625f9$export$ac4959f4f1338dfc);

var $5AMK0 = parcelRequire("5AMK0");
let $69b150f0899625f9$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $69b150f0899625f9$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = '';
        while(true){
            let bytes = getRandom(step);
            let j = step;
            while(j--){
                id += alphabet[bytes[j] & mask] || '';
                if (id.length === size) return id;
            }
        }
    };
};
let $69b150f0899625f9$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$69b150f0899625f9$export$a5cee9e955a615e5(alphabet, size, $69b150f0899625f9$export$4385e60b38654f68);
let $69b150f0899625f9$export$ac4959f4f1338dfc = (size = 21)=>crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte)=>{
        byte &= 63;
        if (byte < 36) id += byte.toString(36);
        else if (byte < 62) id += (byte - 26).toString(36).toUpperCase();
        else if (byte > 62) id += '-';
        else id += '_';
        return id;
    }, '');

});
parcelRegister("5AMK0", function(module, exports) {
let $41261f7b5bd1b133$export$2b646eea95309f00 = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';

});



parcelRegister("kCL8m", function(module, exports) {

$parcel$export(module.exports, "getNavigationTiming", () => $f03beb0b696c28bd$export$e413ff2bddb62bda);
$parcel$export(module.exports, "getNetworkRequestTimes", () => $f03beb0b696c28bd$export$b6d9d88295231c29);
$parcel$export(module.exports, "waitForFirstContentfulPaint", () => $f03beb0b696c28bd$export$78f1760dd462ea4a);
$parcel$export(module.exports, "waitForNoLongTasks", () => $f03beb0b696c28bd$export$1d86caac13391b1c);
$parcel$export(module.exports, "waitForNoDOMMutations", () => $f03beb0b696c28bd$export$bd525458204149d0);
$parcel$export(module.exports, "waitForTimeToInteractive", () => $f03beb0b696c28bd$export$8d11ab137fc90ae1);
$parcel$export(module.exports, "PageVisibilityObserver", () => $f03beb0b696c28bd$export$e1e90d5d8290b834);

var $5zQU9 = parcelRequire("5zQU9");

var $66CK0 = parcelRequire("66CK0");

var $isJAq = parcelRequire("isJAq");
function $f03beb0b696c28bd$export$e413ff2bddb62bda() {
    var _performance, _performance$timing;
    if (typeof ((_performance = performance) === null || _performance === void 0 ? void 0 : (_performance$timing = _performance.timing) === null || _performance$timing === void 0 ? void 0 : _performance$timing.responseStart) !== 'number') // when we're on the server, there's no appropriate value for this so we'll just default to 0.
    // none of the metrics collected here should be published when running on the server
    return {
        responseStart: 0,
        fetchStart: 0
    };
    // Performance Timing API has been deprecated and replaced with Navigation Timing Level 2,
    // but browsers like Firefox are populate quirky values when using this new API.
    // To simulate L2, values are normalized to start from the beginning of page load than epoch time
    return {
        responseStart: performance.timing.responseStart - performance.timing.navigationStart,
        fetchStart: performance.timing.fetchStart - performance.timing.navigationStart
    };
}
const $f03beb0b696c28bd$var$getFileExtension = (path)=>{
    const matches = path.match(/.+\.(\w+)$/);
    return matches === null || matches === void 0 ? void 0 : matches[1];
};
/**
 * The `initiatorType` property on the resource timing object indicates the type of
 * the source which initiated the resource load rather than type of resource being loaded.
 * While `initiatorType` provides a good approximation usually, for some cases this needs to
 * be normalized.
 * E.g. Image requests triggered from CSS files will have `initiatorType: css` instead of `img`.
 */ const $f03beb0b696c28bd$var$getResourceType = (resource)=>{
    const resourcePath = new URL(resource.name).pathname;
    const resourceFileExtension = $f03beb0b696c28bd$var$getFileExtension(resourcePath);
    // Files from https://marketplace.com/files/... are more likely
    // to be images than CSS assets if initiated from CSS
    if (resource.initiatorType === 'css' && resourcePath.startsWith('/files/')) return resourceFileExtension || 'img';
    if (resource.initiatorType === 'link' && resourceFileExtension) return resourceFileExtension;
    return resource.initiatorType;
};
function $f03beb0b696c28bd$export$b6d9d88295231c29(allowRegexes, denyRegexes) {
    const perfEntries = performance.getEntriesByType('resource');
    // 1. Filter all requests based on match criteria
    const matchedRequests = perfEntries.filter((entry)=>allowRegexes.some((regex)=>{
            var _entry$name$match;
            return (_entry$name$match = entry.name.match(regex)) === null || _entry$name$match === void 0 ? void 0 : _entry$name$match.length;
        })).filter((entry)=>denyRegexes.every((regex)=>{
            var _entry$name$match2;
            return !((_entry$name$match2 = entry.name.match(regex)) !== null && _entry$name$match2 !== void 0 && _entry$name$match2.length);
        })).map((entry)=>({
            type: $f03beb0b696c28bd$var$getResourceType(entry),
            name: entry.name,
            duration: entry.responseEnd - entry.startTime
        }));
    // 2. Sum up download times by resource type
    const requestTimeGroupedByType = matchedRequests.reduce((groupedByType, nextRequest)=>{
        if (nextRequest.type in groupedByType) groupedByType[nextRequest.type] += nextRequest.duration;
        else groupedByType[nextRequest.type] = nextRequest.duration;
        return groupedByType;
    }, {});
    // 3. Return sum of times as an array
    return Object.entries(requestTimeGroupedByType).map((_ref)=>{
        let [type, duration] = _ref;
        return {
            type: type,
            duration: duration
        };
    });
}
function $f03beb0b696c28bd$export$78f1760dd462ea4a() {
    return new Promise((resolve)=>{
        (0, $66CK0.getFCP)((_ref2)=>{
            let { value: value } = _ref2;
            return resolve(value);
        });
    });
}
function $f03beb0b696c28bd$export$1d86caac13391b1c() {
    let quiescenceFor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2000;
    return new Promise((resolve)=>{
        let lastLongRunningTaskTime = null;
        const timer = new (0, $isJAq.default)(quiescenceFor, ()=>{
            observer.disconnect();
            resolve(lastLongRunningTaskTime);
        });
        timer.start();
        const callback = (list)=>{
            const perfEntries = list.getEntries();
            if (perfEntries.length) {
                const lastEntry = perfEntries[perfEntries.length - 1];
                lastLongRunningTaskTime = lastEntry.startTime + lastEntry.duration;
                timer.restart();
            }
        };
        const observer = new PerformanceObserver(callback);
        observer.observe({
            type: 'longtask',
            buffered: true
        });
    });
}
function $f03beb0b696c28bd$export$bd525458204149d0(rootNode) {
    let quiescenceFor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;
    const mutationObserverConfig = {
        attributes: false,
        childList: true,
        subtree: true
    };
    return new Promise((resolve)=>{
        let lastMutationTime = null;
        const timer = new (0, $isJAq.default)(quiescenceFor, ()=>{
            observer.disconnect();
            resolve(lastMutationTime);
        });
        timer.start();
        const callback = ()=>{
            lastMutationTime = performance.now();
            timer.restart();
        };
        const observer = new MutationObserver(callback);
        observer.observe(rootNode, mutationObserverConfig);
    });
}
function $f03beb0b696c28bd$export$8d11ab137fc90ae1(rootNode) {
    return $f03beb0b696c28bd$export$78f1760dd462ea4a().then((FCPTimestamp)=>Promise.all([
            $f03beb0b696c28bd$export$1d86caac13391b1c(),
            $f03beb0b696c28bd$export$bd525458204149d0(rootNode)
        ]).then((_ref3)=>{
            let [mainTheadFreeTimestamp, DOMMutationFreeTimestamp] = _ref3;
            return Math.max(FCPTimestamp, mainTheadFreeTimestamp || 0, DOMMutationFreeTimestamp || 0);
        }));
}
class $f03beb0b696c28bd$export$e1e90d5d8290b834 {
    static start() {
        $f03beb0b696c28bd$export$e1e90d5d8290b834.hasDocumentBeenHidden = document.hidden;
        if (!$f03beb0b696c28bd$export$e1e90d5d8290b834.isObserving) {
            document.addEventListener('visibilitychange', $f03beb0b696c28bd$export$e1e90d5d8290b834.handleVisibilityChange, true);
            $f03beb0b696c28bd$export$e1e90d5d8290b834.isObserving = true;
        }
    }
    static handleVisibilityChange() {
        if (document.hidden) {
            $f03beb0b696c28bd$export$e1e90d5d8290b834.hasDocumentBeenHidden = true;
            document.removeEventListener('visibilitychange', $f03beb0b696c28bd$export$e1e90d5d8290b834.handleVisibilityChange, true);
        }
    }
}
(0, $5zQU9.default)($f03beb0b696c28bd$export$e1e90d5d8290b834, "isObserving", false);
(0, $5zQU9.default)($f03beb0b696c28bd$export$e1e90d5d8290b834, "hasDocumentBeenHidden", false);

});
parcelRegister("66CK0", function(module, exports) {

$parcel$export(module.exports, "getFCP", () => $47215ac651147e49$export$52489892712e8192);
$parcel$export(module.exports, "getCLS", () => $47215ac651147e49$export$fc6227831ee7c7);
$parcel$export(module.exports, "getFID", () => $47215ac651147e49$export$134ed2977d320dfd);
$parcel$export(module.exports, "getLCP", () => $47215ac651147e49$export$da982ced0ff8a670);
$parcel$export(module.exports, "getTTFB", () => $47215ac651147e49$export$6e8eea9a35032c92);
var $47215ac651147e49$var$e, $47215ac651147e49$var$t, $47215ac651147e49$var$n, $47215ac651147e49$var$i, $47215ac651147e49$var$r = function(e, t) {
    return {
        name: e,
        value: void 0 === t ? -1 : t,
        delta: 0,
        entries: [],
        id: "v2-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12)
    };
}, $47215ac651147e49$var$a = function(e, t) {
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(e)) {
            if ("first-input" === e && !("PerformanceEventTiming" in self)) return;
            var n = new PerformanceObserver(function(e) {
                return e.getEntries().map(t);
            });
            return n.observe({
                type: e,
                buffered: !0
            }), n;
        }
    } catch (e) {}
}, $47215ac651147e49$var$o = function(e, t) {
    var n = function n(i) {
        "pagehide" !== i.type && "hidden" !== document.visibilityState || (e(i), t && (removeEventListener("visibilitychange", n, !0), removeEventListener("pagehide", n, !0)));
    };
    addEventListener("visibilitychange", n, !0), addEventListener("pagehide", n, !0);
}, $47215ac651147e49$var$u = function(e) {
    addEventListener("pageshow", function(t) {
        t.persisted && e(t);
    }, !0);
}, $47215ac651147e49$var$c = function(e, t, n) {
    var i;
    return function(r) {
        t.value >= 0 && (r || n) && (t.delta = t.value - (i || 0), (t.delta || void 0 === i) && (i = t.value, e(t)));
    };
}, $47215ac651147e49$var$f = -1, $47215ac651147e49$var$s = function() {
    return "hidden" === document.visibilityState ? 0 : 1 / 0;
}, $47215ac651147e49$var$m = function() {
    $47215ac651147e49$var$o(function(e) {
        var t = e.timeStamp;
        $47215ac651147e49$var$f = t;
    }, !0);
}, $47215ac651147e49$var$v = function() {
    return $47215ac651147e49$var$f < 0 && ($47215ac651147e49$var$f = $47215ac651147e49$var$s(), $47215ac651147e49$var$m(), $47215ac651147e49$var$u(function() {
        setTimeout(function() {
            $47215ac651147e49$var$f = $47215ac651147e49$var$s(), $47215ac651147e49$var$m();
        }, 0);
    })), {
        get firstHiddenTime () {
            return $47215ac651147e49$var$f;
        }
    };
}, $47215ac651147e49$export$52489892712e8192 = function(e, t) {
    var n, i = $47215ac651147e49$var$v(), o = $47215ac651147e49$var$r("FCP"), f = function(e) {
        "first-contentful-paint" === e.name && (m && m.disconnect(), e.startTime < i.firstHiddenTime && (o.value = e.startTime, o.entries.push(e), n(!0)));
    }, s = window.performance && performance.getEntriesByName && performance.getEntriesByName("first-contentful-paint")[0], m = s ? null : $47215ac651147e49$var$a("paint", f);
    (s || m) && (n = $47215ac651147e49$var$c(e, o, t), s && f(s), $47215ac651147e49$var$u(function(i) {
        o = $47215ac651147e49$var$r("FCP"), n = $47215ac651147e49$var$c(e, o, t), requestAnimationFrame(function() {
            requestAnimationFrame(function() {
                o.value = performance.now() - i.timeStamp, n(!0);
            });
        });
    }));
}, $47215ac651147e49$var$p = !1, $47215ac651147e49$var$l = -1, $47215ac651147e49$export$fc6227831ee7c7 = function(e, t) {
    $47215ac651147e49$var$p || ($47215ac651147e49$export$52489892712e8192(function(e) {
        $47215ac651147e49$var$l = e.value;
    }), $47215ac651147e49$var$p = !0);
    var n, i = function(t) {
        $47215ac651147e49$var$l > -1 && e(t);
    }, f = $47215ac651147e49$var$r("CLS", 0), s = 0, m = [], v = function(e) {
        if (!e.hadRecentInput) {
            var t = m[0], i = m[m.length - 1];
            s && e.startTime - i.startTime < 1e3 && e.startTime - t.startTime < 5e3 ? (s += e.value, m.push(e)) : (s = e.value, m = [
                e
            ]), s > f.value && (f.value = s, f.entries = m, n());
        }
    }, h = $47215ac651147e49$var$a("layout-shift", v);
    h && (n = $47215ac651147e49$var$c(i, f, t), $47215ac651147e49$var$o(function() {
        h.takeRecords().map(v), n(!0);
    }), $47215ac651147e49$var$u(function() {
        s = 0, $47215ac651147e49$var$l = -1, f = $47215ac651147e49$var$r("CLS", 0), n = $47215ac651147e49$var$c(i, f, t);
    }));
}, $47215ac651147e49$var$T = {
    passive: !0,
    capture: !0
}, $47215ac651147e49$var$y = new Date, $47215ac651147e49$var$g = function(i, r) {
    $47215ac651147e49$var$e || ($47215ac651147e49$var$e = r, $47215ac651147e49$var$t = i, $47215ac651147e49$var$n = new Date, $47215ac651147e49$var$w(removeEventListener), $47215ac651147e49$var$E());
}, $47215ac651147e49$var$E = function() {
    if ($47215ac651147e49$var$t >= 0 && $47215ac651147e49$var$t < $47215ac651147e49$var$n - $47215ac651147e49$var$y) {
        var r = {
            entryType: "first-input",
            name: $47215ac651147e49$var$e.type,
            target: $47215ac651147e49$var$e.target,
            cancelable: $47215ac651147e49$var$e.cancelable,
            startTime: $47215ac651147e49$var$e.timeStamp,
            processingStart: $47215ac651147e49$var$e.timeStamp + $47215ac651147e49$var$t
        };
        $47215ac651147e49$var$i.forEach(function(e) {
            e(r);
        }), $47215ac651147e49$var$i = [];
    }
}, $47215ac651147e49$var$S = function(e) {
    if (e.cancelable) {
        var t = (e.timeStamp > 1e12 ? new Date : performance.now()) - e.timeStamp;
        "pointerdown" == e.type ? function(e, t) {
            var n = function() {
                $47215ac651147e49$var$g(e, t), r();
            }, i = function() {
                r();
            }, r = function() {
                removeEventListener("pointerup", n, $47215ac651147e49$var$T), removeEventListener("pointercancel", i, $47215ac651147e49$var$T);
            };
            addEventListener("pointerup", n, $47215ac651147e49$var$T), addEventListener("pointercancel", i, $47215ac651147e49$var$T);
        }(t, e) : $47215ac651147e49$var$g(t, e);
    }
}, $47215ac651147e49$var$w = function(e) {
    [
        "mousedown",
        "keydown",
        "touchstart",
        "pointerdown"
    ].forEach(function(t) {
        return e(t, $47215ac651147e49$var$S, $47215ac651147e49$var$T);
    });
}, $47215ac651147e49$export$134ed2977d320dfd = function(n, f) {
    var s, m = $47215ac651147e49$var$v(), d = $47215ac651147e49$var$r("FID"), p = function(e) {
        e.startTime < m.firstHiddenTime && (d.value = e.processingStart - e.startTime, d.entries.push(e), s(!0));
    }, l = $47215ac651147e49$var$a("first-input", p);
    s = $47215ac651147e49$var$c(n, d, f), l && $47215ac651147e49$var$o(function() {
        l.takeRecords().map(p), l.disconnect();
    }, !0), l && $47215ac651147e49$var$u(function() {
        var a;
        d = $47215ac651147e49$var$r("FID"), s = $47215ac651147e49$var$c(n, d, f), $47215ac651147e49$var$i = [], $47215ac651147e49$var$t = -1, $47215ac651147e49$var$e = null, $47215ac651147e49$var$w(addEventListener), a = p, $47215ac651147e49$var$i.push(a), $47215ac651147e49$var$E();
    });
}, $47215ac651147e49$var$b = {}, $47215ac651147e49$export$da982ced0ff8a670 = function(e, t) {
    var n, i = $47215ac651147e49$var$v(), f = $47215ac651147e49$var$r("LCP"), s = function(e) {
        var t = e.startTime;
        t < i.firstHiddenTime && (f.value = t, f.entries.push(e), n());
    }, m = $47215ac651147e49$var$a("largest-contentful-paint", s);
    if (m) {
        n = $47215ac651147e49$var$c(e, f, t);
        var d = function() {
            $47215ac651147e49$var$b[f.id] || (m.takeRecords().map(s), m.disconnect(), $47215ac651147e49$var$b[f.id] = !0, n(!0));
        };
        [
            "keydown",
            "click"
        ].forEach(function(e) {
            addEventListener(e, d, {
                once: !0,
                capture: !0
            });
        }), $47215ac651147e49$var$o(d, !0), $47215ac651147e49$var$u(function(i) {
            f = $47215ac651147e49$var$r("LCP"), n = $47215ac651147e49$var$c(e, f, t), requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                    f.value = performance.now() - i.timeStamp, $47215ac651147e49$var$b[f.id] = !0, n(!0);
                });
            });
        });
    }
}, $47215ac651147e49$export$6e8eea9a35032c92 = function(e) {
    var t, n = $47215ac651147e49$var$r("TTFB");
    t = function() {
        try {
            var t = performance.getEntriesByType("navigation")[0] || function() {
                var e = performance.timing, t = {
                    entryType: "navigation",
                    startTime: 0
                };
                for(var n in e)"navigationStart" !== n && "toJSON" !== n && (t[n] = Math.max(e[n] - e.navigationStart, 0));
                return t;
            }();
            if (n.value = n.delta = t.responseStart, n.value < 0 || n.value > performance.now()) return;
            n.entries = [
                t
            ], e(n);
        } catch (e) {}
    }, "complete" === document.readyState ? setTimeout(t, 0) : addEventListener("load", function() {
        return setTimeout(t, 0);
    });
};

});

parcelRegister("isJAq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d70e3410a186ec1e$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
class $d70e3410a186ec1e$export$2e2bcd8739ae039 {
    constructor(duration, onEndCallback){
        (0, $5zQU9.default)(this, "duration", void 0);
        (0, $5zQU9.default)(this, "onExpire", void 0);
        (0, $5zQU9.default)(this, "timerID", void 0);
        this.duration = duration;
        this.onExpire = onEndCallback;
    }
    start() {
        if (this.timerID) clearTimeout(this.timerID);
        this.timerID = setTimeout(()=>{
            this.onExpire();
        }, this.duration);
    }
    restart() {
        this.start();
    }
    stop() {
        if (this.timerID) clearTimeout(this.timerID);
    }
}

});



parcelRegister("4fL5K", function(module, exports) {

$parcel$export(module.exports, "discoveryFacetsTaskName", () => $318d178ba33992d8$export$3a8eb4d94d5abd40);
$parcel$export(module.exports, "discoveryCollectionsTaskName", () => $318d178ba33992d8$export$1d21d04e724b0ea8);
$parcel$export(module.exports, "DiscoveryFacetsTask", () => $318d178ba33992d8$export$bd5e6f65f2096339);
$parcel$export(module.exports, "DiscoveryCollectionsTask", () => $318d178ba33992d8$export$293c4a6d0b0af62f);
$parcel$export(module.exports, "searchTaskName", () => $318d178ba33992d8$export$91794a5b17bc9a0d);
$parcel$export(module.exports, "SearchTask", () => $318d178ba33992d8$export$e2d2b3bbeec3756f);

var $fUOHe = parcelRequire("fUOHe");
const $318d178ba33992d8$export$3a8eb4d94d5abd40 = 'view-discovery-facets';
const $318d178ba33992d8$export$1d21d04e724b0ea8 = 'view-discovery-collections';
const $318d178ba33992d8$export$bd5e6f65f2096339 = (0, $fUOHe.default).createGenericTask($318d178ba33992d8$export$3a8eb4d94d5abd40);
const $318d178ba33992d8$export$293c4a6d0b0af62f = (0, $fUOHe.default).createGenericTask('view-discovery-collections');
const $318d178ba33992d8$export$91794a5b17bc9a0d = 'view-search-results';
const $318d178ba33992d8$export$e2d2b3bbeec3756f = (0, $fUOHe.default).createGenericTask($318d178ba33992d8$export$91794a5b17bc9a0d);

});

parcelRegister("iDEAo", function(module, exports) {

$parcel$export(module.exports, "generateSearchId", () => $d91b5a089d99586f$export$6ebf659764156c0a);
function $d91b5a089d99586f$export$6ebf659764156c0a() {
    return Number.parseInt(Math.random() * 1000000);
}

});

parcelRegister("8Hj3g", function(module, exports) {

$parcel$export(module.exports, "default", () => $65511e29407d312a$export$2e2bcd8739ae039);

var $g5DHJ = parcelRequire("g5DHJ");
function $65511e29407d312a$export$2e2bcd8739ae039(err) {
    return (0, $g5DHJ.List)([
        (0, $g5DHJ.Map)({
            message: err.message
        }) // Just one message for now, but let's make it accommodate for more
    ]);
}

});


parcelRegister("kUEnb", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3985ad36e06b010$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $hvUUg = parcelRequire("hvUUg");

var $biTOe = parcelRequire("biTOe");
var $9l6Pq = parcelRequire("9l6Pq");

var $hjlb6 = parcelRequire("hjlb6");

var $eUqFw = parcelRequire("eUqFw");

var $3qG4B = parcelRequire("3qG4B");
const $f3985ad36e06b010$var$StaticSearchContainer = (0, $3UXZ8.default)("div", {
    target: "e78wpkx0",
    label: "StaticSearchContainer"
})((0, $hvUUg.baseStylesCss), "");
class $f3985ad36e06b010$var$StaticSearch extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "onLoadMoreResultsClick", (_ref)=>{
            let { currentPage: currentPage } = _ref;
            this.transitionStarted();
            this.props.onLoadMoreResultsClick({
                currentPage: currentPage
            });
        });
    }
    componentDidMount() {
        this.doFreshSearch({
            filters: this.props.filters
        });
    }
    componentDidUpdate(prevProps) {
        const newFilters = this.props.filters;
        if (!newFilters.equals(prevProps.filters)) this.doFreshSearch({
            filters: newFilters
        });
        if (this.props.transitions && this.props.transitions.get('transitionStarted') && prevProps.search.get('searchInProgress') && !this.props.search.get('searchInProgress')) this.props.transitions.get('transitionCompleted')();
    }
    doFreshSearch(_ref2) {
        var _this$props$statsigCl;
        let { filters: filters } = _ref2;
        const { enableV2SearchIndex: enableV2SearchIndex } = this.props;
        const showCompassApps = (_this$props$statsigCl = this.props.statsigClient) === null || _this$props$statsigCl === void 0 ? void 0 : _this$props$statsigCl.showCompassApps();
        this.transitionStarted();
        this.props.doFreshSearch({
            filters: filters,
            featureFlags: {
                enableV2SearchIndex: enableV2SearchIndex,
                showCompassApps: !!showCompassApps
            }
        });
    }
    transitionStarted() {
        if (this.props.transitions && this.props.transitions.get('transitionStarted')) this.props.transitions.get('transitionStarted')();
    }
    render() {
        const hits = this.props.sortHits && this.props.search.getIn([
            'searchResults',
            'hits'
        ]) ? this.props.sortHits(this.props.search.getIn([
            'searchResults',
            'hits'
        ])) : this.props.search.getIn([
            'searchResults',
            'hits'
        ]);
        const numberOfPages = this.props.sortHits ? 1 : this.props.search.getIn([
            'searchResults',
            'numberOfPages'
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f3985ad36e06b010$var$StaticSearchContainer, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))(this.props.containerClassName, this.props.className)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3qG4B.default), {
            colSpan: this.props.colSpan,
            contentOverrides: this.props.contentOverrides,
            currentPage: this.props.search.get('currentPage'),
            dataError: this.props.search.get('dataError'),
            dataErrorMessages: this.props.search.get('dataErrorMessages'),
            filters: this.props.filters,
            hidePagination: this.props.hidePagination,
            hitContext: this.props.hitContext,
            hitSize: this.props.hitSize,
            hits: hits,
            loading: !this.props.search.get('initialized'),
            loadingMoreResults: this.props.search.get('loadingMoreResults'),
            maxLength: this.props.maxLength,
            moreResultsDataError: this.props.search.get('moreResultsDataError'),
            moreResultsDataErrorMessages: this.props.search.get('moreResultsDataErrorMessages'),
            numberOfPages: numberOfPages,
            onLoadMoreResultsClick: this.onLoadMoreResultsClick,
            screenClass: this.props.screenClass,
            searchId: this.props.search.get('currentSearchId')
        }));
    }
}
var $f3985ad36e06b010$export$2e2bcd8739ae039 = (0, $biTOe.withFeatureFlags)((0, $9l6Pq.withStatsig)($f3985ad36e06b010$var$StaticSearch));

});
parcelRegister("3UXZ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $2da521dca9c97a7c$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $rDBG3 = parcelRequire("rDBG3");

var $ibjku = parcelRequire("ibjku");

var $k0tcF = parcelRequire("k0tcF");

var $1FjgH = parcelRequire("1FjgH");
var $2da521dca9c97a7c$var$testOmitPropsOnStringTag = (0, $rDBG3.default);
var $2da521dca9c97a7c$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme' && key !== 'innerRef';
};
var $2da521dca9c97a7c$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $2da521dca9c97a7c$var$testOmitPropsOnStringTag : $2da521dca9c97a7c$var$testOmitPropsOnComponent;
};
function $2da521dca9c97a7c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2da521dca9c97a7c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2da521dca9c97a7c$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $5zQU9.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2da521dca9c97a7c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $2da521dca9c97a7c$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $2da521dca9c97a7c$var$Noop = function Noop() {
    return null;
};
var $2da521dca9c97a7c$var$createStyled = function createStyled(tag, options) {
    var identifierName;
    var shouldForwardProp;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
        shouldForwardProp = tag.__emotion_forwardProp && options.shouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && // $FlowFixMe
            options.shouldForwardProp(propName);
        } : options.shouldForwardProp;
    }
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    var defaultShouldForwardProp = shouldForwardProp || $2da521dca9c97a7c$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $ibjku.withEmotionCache)(function(props, context, ref) {
            return /*#__PURE__*/ (0, $eUqFw.createElement)((0, $ibjku.ThemeContext).Consumer, null, function(theme) {
                var finalTag = shouldUseAs && props.as || baseTag;
                var className = '';
                var classInterpolations = [];
                var mergedProps = props;
                if (props.theme == null) {
                    mergedProps = {};
                    for(var key in props)mergedProps[key] = props[key];
                    mergedProps.theme = theme;
                }
                if (typeof props.className === 'string') className = (0, $k0tcF.getRegisteredStyles)(context.registered, classInterpolations, props.className);
                else if (props.className != null) className = props.className + " ";
                var serialized = (0, $1FjgH.serializeStyles)(styles.concat(classInterpolations), context.registered, mergedProps);
                var rules = (0, $k0tcF.insertStyles)(context, serialized, typeof finalTag === 'string');
                className += context.key + "-" + serialized.name;
                if (targetClassName !== undefined) className += " " + targetClassName;
                var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $2da521dca9c97a7c$var$getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
                var newProps = {};
                for(var _key in props){
                    if (shouldUseAs && _key === 'as') continue;
                    if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
                }
                newProps.className = className;
                newProps.ref = ref || props.innerRef;
                var ele = /*#__PURE__*/ (0, $eUqFw.createElement)(finalTag, newProps);
                var possiblyStyleElement = /*#__PURE__*/ (0, $eUqFw.createElement)($2da521dca9c97a7c$var$Noop, null);
                return /*#__PURE__*/ (0, $eUqFw.createElement)((0, $eUqFw.Fragment), null, possiblyStyleElement, ele);
            });
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, nextOptions !== undefined ? $2da521dca9c97a7c$var$_objectSpread({}, options || {}, {}, nextOptions) : options).apply(void 0, styles);
        };
        return Styled;
    };
};
var $2da521dca9c97a7c$export$2e2bcd8739ae039 = $2da521dca9c97a7c$var$createStyled;

});
parcelRegister("rDBG3", function(module, exports) {

$parcel$export(module.exports, "default", () => $05313ecbd5cc202f$export$2e2bcd8739ae039);

var $e03Zn = parcelRequire("e03Zn");
var $05313ecbd5cc202f$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $05313ecbd5cc202f$var$index = (0, $e03Zn.default)(function(prop) {
    return $05313ecbd5cc202f$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $05313ecbd5cc202f$export$2e2bcd8739ae039 = $05313ecbd5cc202f$var$index;

});
parcelRegister("e03Zn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a31428e98e323b09$export$2e2bcd8739ae039);
function $a31428e98e323b09$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $a31428e98e323b09$export$2e2bcd8739ae039 = $a31428e98e323b09$var$memoize;

});



parcelRegister("hvUUg", function(module, exports) {

$parcel$export(module.exports, "baseStylesCss", () => $cc01795616bab096$export$c1b112a4bc2bf8b2);
$parcel$export(module.exports, "baseMediumFontSize", () => $cc01795616bab096$export$8b11cc0b368dc9df);
$parcel$export(module.exports, "baseLineHeight", () => $cc01795616bab096$export$535730c89dd84be3);
$parcel$export(module.exports, "CharlieFontFamily", () => $cc01795616bab096$export$f611bc8c56762dcf);
$parcel$export(module.exports, "BoldText", () => $cc01795616bab096$export$d8a8e2cd87eed68c);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");
var $ivTMz = parcelRequire("ivTMz");

var $ibjku = parcelRequire("ibjku");
function $cc01795616bab096$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cc01795616bab096$export$c1b112a4bc2bf8b2 = /*#__PURE__*/ (0, $ibjku.css)("color:", "var(--ds-text, ".concat((0, $j0gMm).N800, ")"), ";font-family:", (0, $ivTMz.fontFamily)(), ";font-size:", (0, $ivTMz.fontSize)() + 'px', ";;label:baseStylesCss;");
const $cc01795616bab096$export$8b11cc0b368dc9df = {
    name: "1rgsehg-baseMediumFontSize",
    styles: "font-size:16px;;label:baseMediumFontSize;"
};
const $cc01795616bab096$export$535730c89dd84be3 = {
    name: "nf0vu6-baseLineHeight",
    styles: "line-height:24px;;label:baseLineHeight;"
};
const $cc01795616bab096$export$e8b14c4827b02e0d = /*#__PURE__*/ (0, $ibjku.css)("a{color:", "var(--ds-link, ".concat((0, $j0gMm).B400, ")"), ";text-decoration:none;cursor:pointer;&:active,&:hover{outline:0;text-decoration:underline;}};label:baseAnchorStylesCss;");
const $cc01795616bab096$export$f611bc8c56762dcf = /*#__PURE__*/ (0, $ibjku.css)("font-family:'Charlie Display',", (0, $ivTMz.fontFamily)(), ";;label:CharlieFontFamily;");
const $cc01795616bab096$export$d8a8e2cd87eed68c = (0, $3UXZ8.default)("b", {
    target: "e11879yo0",
    label: "BoldText"
})({
    name: "35ezg3",
    styles: "font-weight:600;"
});
var $cc01795616bab096$export$2e2bcd8739ae039 = (0, $3UXZ8.default)("div", {
    target: "e11879yo1"
})($cc01795616bab096$export$c1b112a4bc2bf8b2, "");

});
parcelRegister("j0gMm", function(module, exports) {

$parcel$export(module.exports, "R50", () => $dd5b085d4e6867fb$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R75", () => $dd5b085d4e6867fb$export$b34b069eff244586);
$parcel$export(module.exports, "R100", () => $dd5b085d4e6867fb$export$be802dd0d8b57f35);
$parcel$export(module.exports, "R200", () => $dd5b085d4e6867fb$export$60847d42f9da92a6);
$parcel$export(module.exports, "R300", () => $dd5b085d4e6867fb$export$4a7404f376229999);
$parcel$export(module.exports, "R400", () => $dd5b085d4e6867fb$export$2010d0fb4295b346);
$parcel$export(module.exports, "R500", () => $dd5b085d4e6867fb$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $dd5b085d4e6867fb$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y75", () => $dd5b085d4e6867fb$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y100", () => $dd5b085d4e6867fb$export$1cc05bbbf340e559);
$parcel$export(module.exports, "Y200", () => $dd5b085d4e6867fb$export$5aae31392d72caaa);
$parcel$export(module.exports, "Y300", () => $dd5b085d4e6867fb$export$c6930421db9fa514);
$parcel$export(module.exports, "Y400", () => $dd5b085d4e6867fb$export$59619663aa6500fb);
$parcel$export(module.exports, "Y500", () => $dd5b085d4e6867fb$export$874739ea9e379ab6);
$parcel$export(module.exports, "G50", () => $dd5b085d4e6867fb$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G75", () => $dd5b085d4e6867fb$export$69a3bf21b9686c2b);
$parcel$export(module.exports, "G100", () => $dd5b085d4e6867fb$export$afbce1382ec95f73);
$parcel$export(module.exports, "G200", () => $dd5b085d4e6867fb$export$747d86715d4175de);
$parcel$export(module.exports, "G300", () => $dd5b085d4e6867fb$export$940e1f69e873f202);
$parcel$export(module.exports, "G400", () => $dd5b085d4e6867fb$export$a49394138f7b8e85);
$parcel$export(module.exports, "G500", () => $dd5b085d4e6867fb$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $dd5b085d4e6867fb$export$226de0355ed012f8);
$parcel$export(module.exports, "B75", () => $dd5b085d4e6867fb$export$8c13c2ee36917869);
$parcel$export(module.exports, "B100", () => $dd5b085d4e6867fb$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B200", () => $dd5b085d4e6867fb$export$215b7063051591f1);
$parcel$export(module.exports, "B300", () => $dd5b085d4e6867fb$export$e62e8919cca44969);
$parcel$export(module.exports, "B400", () => $dd5b085d4e6867fb$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $dd5b085d4e6867fb$export$a6ee3d71bc067634);
$parcel$export(module.exports, "P50", () => $dd5b085d4e6867fb$export$363e4475840015bb);
$parcel$export(module.exports, "P75", () => $dd5b085d4e6867fb$export$4b0a4417ed59760f);
$parcel$export(module.exports, "P100", () => $dd5b085d4e6867fb$export$6011520a64d9a187);
$parcel$export(module.exports, "P200", () => $dd5b085d4e6867fb$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $dd5b085d4e6867fb$export$b48405b95304b5a1);
$parcel$export(module.exports, "P400", () => $dd5b085d4e6867fb$export$c71e4279dd54a18d);
$parcel$export(module.exports, "P500", () => $dd5b085d4e6867fb$export$147899de772240ec);
$parcel$export(module.exports, "T50", () => $dd5b085d4e6867fb$export$2cf711fe14c66f06);
$parcel$export(module.exports, "T75", () => $dd5b085d4e6867fb$export$7a8f4d33f6f9772c);
$parcel$export(module.exports, "T100", () => $dd5b085d4e6867fb$export$776c9c497ef08533);
$parcel$export(module.exports, "T200", () => $dd5b085d4e6867fb$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $dd5b085d4e6867fb$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T400", () => $dd5b085d4e6867fb$export$7c835c78b6fcdef8);
$parcel$export(module.exports, "T500", () => $dd5b085d4e6867fb$export$6036577f95c3877e);
$parcel$export(module.exports, "N0", () => $dd5b085d4e6867fb$export$29a4f05edc054374);
$parcel$export(module.exports, "N10", () => $dd5b085d4e6867fb$export$e655ef011c4aa1a2);
$parcel$export(module.exports, "N20", () => $dd5b085d4e6867fb$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $dd5b085d4e6867fb$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N40", () => $dd5b085d4e6867fb$export$1ce2d1575d444ceb);
$parcel$export(module.exports, "N50", () => $dd5b085d4e6867fb$export$8754fc7e6d8b3000);
$parcel$export(module.exports, "N60", () => $dd5b085d4e6867fb$export$c2e91cbeada39b8b);
$parcel$export(module.exports, "N70", () => $dd5b085d4e6867fb$export$5f71e19f3a7ad9de);
$parcel$export(module.exports, "N80", () => $dd5b085d4e6867fb$export$eaa8c8a70ac22806);
$parcel$export(module.exports, "N90", () => $dd5b085d4e6867fb$export$7c87d337fb91a97d);
$parcel$export(module.exports, "N100", () => $dd5b085d4e6867fb$export$d6447c357493214f);
$parcel$export(module.exports, "N200", () => $dd5b085d4e6867fb$export$f563ee71e9ee74cd);
$parcel$export(module.exports, "N300", () => $dd5b085d4e6867fb$export$e2ef2124cf4024b1);
$parcel$export(module.exports, "N400", () => $dd5b085d4e6867fb$export$eece5f492e429f08);
$parcel$export(module.exports, "N500", () => $dd5b085d4e6867fb$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "N600", () => $dd5b085d4e6867fb$export$7090862dc3038a9f);
$parcel$export(module.exports, "N700", () => $dd5b085d4e6867fb$export$ad0bacf983b7ddaa);
$parcel$export(module.exports, "N800", () => $dd5b085d4e6867fb$export$7d61b15e0da132af);
$parcel$export(module.exports, "N900", () => $dd5b085d4e6867fb$export$fbda843f0a27fe96);
$parcel$export(module.exports, "N10A", () => $dd5b085d4e6867fb$export$791e57b27ca738ef);
$parcel$export(module.exports, "N20A", () => $dd5b085d4e6867fb$export$8d43898f60b96a82);
$parcel$export(module.exports, "N30A", () => $dd5b085d4e6867fb$export$920c0d5c49070351);
$parcel$export(module.exports, "N40A", () => $dd5b085d4e6867fb$export$46987b49aab6d1a8);
$parcel$export(module.exports, "N50A", () => $dd5b085d4e6867fb$export$7d3359664e8bb0e5);
$parcel$export(module.exports, "N60A", () => $dd5b085d4e6867fb$export$d2d3bedfb276cac0);
$parcel$export(module.exports, "N70A", () => $dd5b085d4e6867fb$export$6e5e7499ff054f6d);
$parcel$export(module.exports, "N80A", () => $dd5b085d4e6867fb$export$59264b346c877fa7);
$parcel$export(module.exports, "N90A", () => $dd5b085d4e6867fb$export$d092757d7c64925c);
$parcel$export(module.exports, "N100A", () => $dd5b085d4e6867fb$export$486ab785e4bac3c6);
$parcel$export(module.exports, "N200A", () => $dd5b085d4e6867fb$export$fba592bbc6419fea);
$parcel$export(module.exports, "N300A", () => $dd5b085d4e6867fb$export$13609db0e6812ab8);
$parcel$export(module.exports, "N400A", () => $dd5b085d4e6867fb$export$fbae4efaa892d883);
$parcel$export(module.exports, "N500A", () => $dd5b085d4e6867fb$export$f13946d26f440ce6);
$parcel$export(module.exports, "N600A", () => $dd5b085d4e6867fb$export$19f58225ac52a306);
$parcel$export(module.exports, "N700A", () => $dd5b085d4e6867fb$export$6384f09da70e7b62);
$parcel$export(module.exports, "N800A", () => $dd5b085d4e6867fb$export$d0dccc730683edc2);
$parcel$export(module.exports, "DN900", () => $dd5b085d4e6867fb$export$2f6319cf7d736c2a);
$parcel$export(module.exports, "DN800", () => $dd5b085d4e6867fb$export$95126bc8884d6634);
$parcel$export(module.exports, "DN700", () => $dd5b085d4e6867fb$export$8338d8c35d44ff1);
$parcel$export(module.exports, "DN600", () => $dd5b085d4e6867fb$export$5368d76ae4fbbda7);
$parcel$export(module.exports, "DN500", () => $dd5b085d4e6867fb$export$9f0a771d16ec8d36);
$parcel$export(module.exports, "DN400", () => $dd5b085d4e6867fb$export$abcf8c38338b4aa5);
$parcel$export(module.exports, "DN300", () => $dd5b085d4e6867fb$export$97e81faa16a182c7);
$parcel$export(module.exports, "DN200", () => $dd5b085d4e6867fb$export$bfe21c59123ecf33);
$parcel$export(module.exports, "DN100", () => $dd5b085d4e6867fb$export$ee82aa2ea6a1558);
$parcel$export(module.exports, "DN90", () => $dd5b085d4e6867fb$export$682927c6ed76be02);
$parcel$export(module.exports, "DN80", () => $dd5b085d4e6867fb$export$91fd9994c5be9757);
$parcel$export(module.exports, "DN70", () => $dd5b085d4e6867fb$export$d281fbfe3cff2df6);
$parcel$export(module.exports, "DN60", () => $dd5b085d4e6867fb$export$3902c91d8b98a753);
$parcel$export(module.exports, "DN50", () => $dd5b085d4e6867fb$export$8e8133c1ba5845b5);
$parcel$export(module.exports, "DN40", () => $dd5b085d4e6867fb$export$33ff357f6620b39);
$parcel$export(module.exports, "DN30", () => $dd5b085d4e6867fb$export$633847cf062b69e0);
$parcel$export(module.exports, "DN20", () => $dd5b085d4e6867fb$export$9776a6e503bdbf76);
$parcel$export(module.exports, "DN10", () => $dd5b085d4e6867fb$export$6c813d5160dff5db);
$parcel$export(module.exports, "DN0", () => $dd5b085d4e6867fb$export$3d4f271a500072a);
$parcel$export(module.exports, "DN800A", () => $dd5b085d4e6867fb$export$fe151285c22759ec);
$parcel$export(module.exports, "DN700A", () => $dd5b085d4e6867fb$export$a101c6190d0da34);
$parcel$export(module.exports, "DN600A", () => $dd5b085d4e6867fb$export$4b16f52932fda51);
$parcel$export(module.exports, "DN500A", () => $dd5b085d4e6867fb$export$a74bcd7b9845b0d8);
$parcel$export(module.exports, "DN400A", () => $dd5b085d4e6867fb$export$9209c179316d1751);
$parcel$export(module.exports, "DN300A", () => $dd5b085d4e6867fb$export$88f55133f636c8dd);
$parcel$export(module.exports, "DN200A", () => $dd5b085d4e6867fb$export$51126f85d1009512);
$parcel$export(module.exports, "DN100A", () => $dd5b085d4e6867fb$export$a069b547bd23af78);
$parcel$export(module.exports, "DN90A", () => $dd5b085d4e6867fb$export$40cce05af3b2600a);
$parcel$export(module.exports, "DN80A", () => $dd5b085d4e6867fb$export$b78942185925a0d);
$parcel$export(module.exports, "DN70A", () => $dd5b085d4e6867fb$export$e058fb44b8eaafca);
$parcel$export(module.exports, "DN60A", () => $dd5b085d4e6867fb$export$92b0b8de26920c18);
$parcel$export(module.exports, "DN50A", () => $dd5b085d4e6867fb$export$67564f7459d3fc9e);
$parcel$export(module.exports, "DN40A", () => $dd5b085d4e6867fb$export$77868e1ca884ffa3);
$parcel$export(module.exports, "DN30A", () => $dd5b085d4e6867fb$export$2afd71d7d3ea2cd5);
$parcel$export(module.exports, "DN20A", () => $dd5b085d4e6867fb$export$f2a0acaab9972c70);
$parcel$export(module.exports, "DN10A", () => $dd5b085d4e6867fb$export$9ab70e67d6475361);
$parcel$export(module.exports, "background", () => $dd5b085d4e6867fb$export$8ce1fd94bee2f412);
$parcel$export(module.exports, "backgroundActive", () => $dd5b085d4e6867fb$export$b861914ea877b580);
$parcel$export(module.exports, "backgroundHover", () => $dd5b085d4e6867fb$export$3f1b020df94387af);
$parcel$export(module.exports, "backgroundOnLayer", () => $dd5b085d4e6867fb$export$c0183dbab98ca63e);
$parcel$export(module.exports, "text", () => $dd5b085d4e6867fb$export$6f093cfa640b7166);
$parcel$export(module.exports, "textHover", () => $dd5b085d4e6867fb$export$42f8e9c698766e7a);
$parcel$export(module.exports, "textActive", () => $dd5b085d4e6867fb$export$c2d157ca1c34b6e3);
$parcel$export(module.exports, "subtleText", () => $dd5b085d4e6867fb$export$1905ba28d7cf066f);
$parcel$export(module.exports, "placeholderText", () => $dd5b085d4e6867fb$export$bd9002130d306d39);
$parcel$export(module.exports, "heading", () => $dd5b085d4e6867fb$export$46e4a324ac90507f);
$parcel$export(module.exports, "subtleHeading", () => $dd5b085d4e6867fb$export$79f3f2b82beb0d36);
$parcel$export(module.exports, "codeBlock", () => $dd5b085d4e6867fb$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "link", () => $dd5b085d4e6867fb$export$9c30223ca0a664fb);
$parcel$export(module.exports, "linkHover", () => $dd5b085d4e6867fb$export$7ed258b0728b004b);
$parcel$export(module.exports, "linkActive", () => $dd5b085d4e6867fb$export$dfa920d8decc8a59);
$parcel$export(module.exports, "linkOutline", () => $dd5b085d4e6867fb$export$6069e6ad5c78f632);
$parcel$export(module.exports, "primary", () => $dd5b085d4e6867fb$export$9ad721cf3b3debe0);
$parcel$export(module.exports, "blue", () => $dd5b085d4e6867fb$export$2aa0182783e7e9de);
$parcel$export(module.exports, "teal", () => $dd5b085d4e6867fb$export$8bf7dff220b82b4a);
$parcel$export(module.exports, "purple", () => $dd5b085d4e6867fb$export$e13cce2a2d16a9d4);
$parcel$export(module.exports, "red", () => $dd5b085d4e6867fb$export$a90204d1394caf30);
$parcel$export(module.exports, "yellow", () => $dd5b085d4e6867fb$export$594c5a8758200c32);
$parcel$export(module.exports, "green", () => $dd5b085d4e6867fb$export$955a2ebd2fb142ae);
$parcel$export(module.exports, "skeleton", () => $dd5b085d4e6867fb$export$2a0674ff2eb10214);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $kvIKC = parcelRequire("kvIKC");
const $dd5b085d4e6867fb$export$4b84fd0e2c617bd = '#FFEBE6';
const $dd5b085d4e6867fb$export$b34b069eff244586 = '#FFBDAD';
const $dd5b085d4e6867fb$export$be802dd0d8b57f35 = '#FF8F73';
const $dd5b085d4e6867fb$export$60847d42f9da92a6 = '#FF7452';
const $dd5b085d4e6867fb$export$4a7404f376229999 = '#FF5630';
const $dd5b085d4e6867fb$export$2010d0fb4295b346 = '#DE350B';
const $dd5b085d4e6867fb$export$2837b5a1a71d5c02 = '#BF2600';
const $dd5b085d4e6867fb$export$8d9596b529bbb9cf = '#FFFAE6';
const $dd5b085d4e6867fb$export$41060a744ab0b7ae = '#FFF0B3';
const $dd5b085d4e6867fb$export$1cc05bbbf340e559 = '#FFE380';
const $dd5b085d4e6867fb$export$5aae31392d72caaa = '#FFC400';
const $dd5b085d4e6867fb$export$c6930421db9fa514 = '#FFAB00';
const $dd5b085d4e6867fb$export$59619663aa6500fb = '#FF991F';
const $dd5b085d4e6867fb$export$874739ea9e379ab6 = '#FF8B00';
const $dd5b085d4e6867fb$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $dd5b085d4e6867fb$export$69a3bf21b9686c2b = '#ABF5D1';
const $dd5b085d4e6867fb$export$afbce1382ec95f73 = '#79F2C0';
const $dd5b085d4e6867fb$export$747d86715d4175de = '#57D9A3';
const $dd5b085d4e6867fb$export$940e1f69e873f202 = '#36B37E';
const $dd5b085d4e6867fb$export$a49394138f7b8e85 = '#00875A';
const $dd5b085d4e6867fb$export$6fa04827ac68a4fb = '#006644';
const $dd5b085d4e6867fb$export$226de0355ed012f8 = '#DEEBFF';
const $dd5b085d4e6867fb$export$8c13c2ee36917869 = '#B3D4FF';
const $dd5b085d4e6867fb$export$ecfc1dff386a3e7a = '#4C9AFF';
const $dd5b085d4e6867fb$export$215b7063051591f1 = '#2684FF';
const $dd5b085d4e6867fb$export$e62e8919cca44969 = '#0065FF';
const $dd5b085d4e6867fb$export$b3de0ae08da2ce64 = '#0052CC';
const $dd5b085d4e6867fb$export$a6ee3d71bc067634 = '#0747A6';
const $dd5b085d4e6867fb$export$363e4475840015bb = '#EAE6FF';
const $dd5b085d4e6867fb$export$4b0a4417ed59760f = '#C0B6F2';
const $dd5b085d4e6867fb$export$6011520a64d9a187 = '#998DD9';
const $dd5b085d4e6867fb$export$a7175d4e9206bc80 = '#8777D9';
const $dd5b085d4e6867fb$export$b48405b95304b5a1 = '#6554C0';
const $dd5b085d4e6867fb$export$c71e4279dd54a18d = '#5243AA';
const $dd5b085d4e6867fb$export$147899de772240ec = '#403294';
const $dd5b085d4e6867fb$export$2cf711fe14c66f06 = '#E6FCFF';
const $dd5b085d4e6867fb$export$7a8f4d33f6f9772c = '#B3F5FF';
const $dd5b085d4e6867fb$export$776c9c497ef08533 = '#79E2F2';
const $dd5b085d4e6867fb$export$69cb3ca10c1e330e = '#00C7E6';
const $dd5b085d4e6867fb$export$9dc1ef0f3f48059b = '#00B8D9';
const $dd5b085d4e6867fb$export$7c835c78b6fcdef8 = '#00A3BF';
const $dd5b085d4e6867fb$export$6036577f95c3877e = '#008DA6';
const $dd5b085d4e6867fb$export$29a4f05edc054374 = '#FFFFFF';
const $dd5b085d4e6867fb$export$e655ef011c4aa1a2 = '#FAFBFC';
const $dd5b085d4e6867fb$export$9fdfb749e33cdf97 = '#F4F5F7';
const $dd5b085d4e6867fb$export$3e51e8f1440314ba = '#EBECF0';
const $dd5b085d4e6867fb$export$1ce2d1575d444ceb = '#DFE1E6';
const $dd5b085d4e6867fb$export$8754fc7e6d8b3000 = '#C1C7D0';
const $dd5b085d4e6867fb$export$c2e91cbeada39b8b = '#B3BAC5';
const $dd5b085d4e6867fb$export$5f71e19f3a7ad9de = '#A5ADBA';
const $dd5b085d4e6867fb$export$eaa8c8a70ac22806 = '#97A0AF';
const $dd5b085d4e6867fb$export$7c87d337fb91a97d = '#8993A4';
const $dd5b085d4e6867fb$export$d6447c357493214f = '#7A869A';
const $dd5b085d4e6867fb$export$f563ee71e9ee74cd = '#6B778C';
const $dd5b085d4e6867fb$export$e2ef2124cf4024b1 = '#5E6C84';
const $dd5b085d4e6867fb$export$eece5f492e429f08 = '#505F79';
const $dd5b085d4e6867fb$export$c39c0fe0f26207ae = '#42526E';
const $dd5b085d4e6867fb$export$7090862dc3038a9f = '#344563';
const $dd5b085d4e6867fb$export$ad0bacf983b7ddaa = '#253858';
const $dd5b085d4e6867fb$export$7d61b15e0da132af = '#172B4D';
const $dd5b085d4e6867fb$export$fbda843f0a27fe96 = '#091E42';
const $dd5b085d4e6867fb$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $dd5b085d4e6867fb$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $dd5b085d4e6867fb$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $dd5b085d4e6867fb$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $dd5b085d4e6867fb$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $dd5b085d4e6867fb$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $dd5b085d4e6867fb$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $dd5b085d4e6867fb$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $dd5b085d4e6867fb$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $dd5b085d4e6867fb$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $dd5b085d4e6867fb$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $dd5b085d4e6867fb$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $dd5b085d4e6867fb$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $dd5b085d4e6867fb$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $dd5b085d4e6867fb$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $dd5b085d4e6867fb$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $dd5b085d4e6867fb$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $dd5b085d4e6867fb$export$2f6319cf7d736c2a = '#E6EDFA';
const $dd5b085d4e6867fb$export$95126bc8884d6634 = '#DCE5F5';
const $dd5b085d4e6867fb$export$8338d8c35d44ff1 = '#CED9EB';
const $dd5b085d4e6867fb$export$5368d76ae4fbbda7 = '#B8C7E0';
const $dd5b085d4e6867fb$export$9f0a771d16ec8d36 = '#ABBBD6';
const $dd5b085d4e6867fb$export$abcf8c38338b4aa5 = '#9FB0CC';
const $dd5b085d4e6867fb$export$97e81faa16a182c7 = '#8C9CB8';
const $dd5b085d4e6867fb$export$bfe21c59123ecf33 = '#7988A3';
const $dd5b085d4e6867fb$export$ee82aa2ea6a1558 = '#67758F';
const $dd5b085d4e6867fb$export$682927c6ed76be02 = '#56637A';
const $dd5b085d4e6867fb$export$91fd9994c5be9757 = '#455166';
const $dd5b085d4e6867fb$export$d281fbfe3cff2df6 = '#3B475C';
const $dd5b085d4e6867fb$export$3902c91d8b98a753 = '#313D52';
const $dd5b085d4e6867fb$export$8e8133c1ba5845b5 = '#283447';
const $dd5b085d4e6867fb$export$33ff357f6620b39 = '#202B3D';
const $dd5b085d4e6867fb$export$633847cf062b69e0 = '#1B2638';
const $dd5b085d4e6867fb$export$9776a6e503bdbf76 = '#121A29';
const $dd5b085d4e6867fb$export$6c813d5160dff5db = '#0E1624';
const $dd5b085d4e6867fb$export$3d4f271a500072a = '#0D1424';
const $dd5b085d4e6867fb$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $dd5b085d4e6867fb$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $dd5b085d4e6867fb$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $dd5b085d4e6867fb$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $dd5b085d4e6867fb$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $dd5b085d4e6867fb$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $dd5b085d4e6867fb$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $dd5b085d4e6867fb$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $dd5b085d4e6867fb$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $dd5b085d4e6867fb$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $dd5b085d4e6867fb$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $dd5b085d4e6867fb$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $dd5b085d4e6867fb$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $dd5b085d4e6867fb$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $dd5b085d4e6867fb$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $dd5b085d4e6867fb$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $dd5b085d4e6867fb$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $dd5b085d4e6867fb$export$8ce1fd94bee2f412 = (0, $kvIKC.default)({
    light: `var(--ds-surface, ${$dd5b085d4e6867fb$export$29a4f05edc054374})`,
    dark: `var(--ds-surface, ${$dd5b085d4e6867fb$export$633847cf062b69e0})`
});
const $dd5b085d4e6867fb$export$b861914ea877b580 = (0, $kvIKC.default)({
    light: `var(--ds-background-selected, ${$dd5b085d4e6867fb$export$226de0355ed012f8})`,
    dark: `var(--ds-background-selected, ${$dd5b085d4e6867fb$export$8c13c2ee36917869})`
});
const $dd5b085d4e6867fb$export$3f1b020df94387af = (0, $kvIKC.default)({
    light: `var(--ds-background-neutral-hovered, ${$dd5b085d4e6867fb$export$3e51e8f1440314ba})`,
    dark: `var(--ds-background-neutral-hovered, ${$dd5b085d4e6867fb$export$d281fbfe3cff2df6})`
});
const $dd5b085d4e6867fb$export$c0183dbab98ca63e = (0, $kvIKC.default)({
    light: `var(--ds-surface-overlay, ${$dd5b085d4e6867fb$export$29a4f05edc054374})`,
    dark: `var(--ds-surface-overlay, ${$dd5b085d4e6867fb$export$8e8133c1ba5845b5})`
});
const $dd5b085d4e6867fb$export$6f093cfa640b7166 = (0, $kvIKC.default)({
    light: `var(--ds-text, ${$dd5b085d4e6867fb$export$fbda843f0a27fe96})`,
    dark: `var(--ds-text, ${$dd5b085d4e6867fb$export$5368d76ae4fbbda7})`
});
const $dd5b085d4e6867fb$export$42f8e9c698766e7a = (0, $kvIKC.default)({
    light: `var(--ds-text, ${$dd5b085d4e6867fb$export$7d61b15e0da132af})`,
    dark: `var(--ds-text, ${$dd5b085d4e6867fb$export$5368d76ae4fbbda7})`
});
const $dd5b085d4e6867fb$export$c2d157ca1c34b6e3 = (0, $kvIKC.default)({
    light: `var(--ds-text-selected, ${$dd5b085d4e6867fb$export$b3de0ae08da2ce64})`,
    dark: `var(--ds-text-selected, ${$dd5b085d4e6867fb$export$b3de0ae08da2ce64})`
});
const $dd5b085d4e6867fb$export$1905ba28d7cf066f = (0, $kvIKC.default)({
    light: `var(--ds-text-subtlest, ${$dd5b085d4e6867fb$export$f563ee71e9ee74cd})`,
    dark: `var(--ds-text-subtlest, ${$dd5b085d4e6867fb$export$97e81faa16a182c7})`
});
const $dd5b085d4e6867fb$export$bd9002130d306d39 = (0, $kvIKC.default)({
    light: `var(--ds-text-subtlest, ${$dd5b085d4e6867fb$export$f563ee71e9ee74cd})`,
    dark: `var(--ds-text-subtlest, ${$dd5b085d4e6867fb$export$bfe21c59123ecf33})`
});
const $dd5b085d4e6867fb$export$46e4a324ac90507f = (0, $kvIKC.default)({
    light: `var(--ds-text, ${$dd5b085d4e6867fb$export$7d61b15e0da132af})`,
    dark: `var(--ds-text, ${$dd5b085d4e6867fb$export$5368d76ae4fbbda7})`
});
const $dd5b085d4e6867fb$export$79f3f2b82beb0d36 = (0, $kvIKC.default)({
    light: `var(--ds-text-subtlest, ${$dd5b085d4e6867fb$export$f563ee71e9ee74cd})`,
    dark: `var(--ds-text-subtlest, ${$dd5b085d4e6867fb$export$97e81faa16a182c7})`
});
const $dd5b085d4e6867fb$export$7bb0d5c671655cc4 = (0, $kvIKC.default)({
    light: $dd5b085d4e6867fb$export$9fdfb749e33cdf97,
    dark: $dd5b085d4e6867fb$export$8e8133c1ba5845b5
});
const $dd5b085d4e6867fb$export$9c30223ca0a664fb = (0, $kvIKC.default)({
    light: `var(--ds-link, ${$dd5b085d4e6867fb$export$b3de0ae08da2ce64})`,
    dark: `var(--ds-link, ${$dd5b085d4e6867fb$export$ecfc1dff386a3e7a})`
});
const $dd5b085d4e6867fb$export$7ed258b0728b004b = (0, $kvIKC.default)({
    light: `var(--ds-link-pressed, ${$dd5b085d4e6867fb$export$e62e8919cca44969})`,
    dark: `var(--ds-link-pressed, ${$dd5b085d4e6867fb$export$215b7063051591f1})`
});
const $dd5b085d4e6867fb$export$dfa920d8decc8a59 = (0, $kvIKC.default)({
    light: `var(--ds-link-pressed, ${$dd5b085d4e6867fb$export$a6ee3d71bc067634})`,
    dark: `var(--ds-link-pressed, ${$dd5b085d4e6867fb$export$ecfc1dff386a3e7a})`
});
const $dd5b085d4e6867fb$export$6069e6ad5c78f632 = (0, $kvIKC.default)({
    light: `var(--ds-border-focused, ${$dd5b085d4e6867fb$export$215b7063051591f1})`,
    dark: `var(--ds-border-focused, ${$dd5b085d4e6867fb$export$215b7063051591f1})`
});
const $dd5b085d4e6867fb$export$9ad721cf3b3debe0 = (0, $kvIKC.default)({
    light: `var(--ds-background-brand-bold, ${$dd5b085d4e6867fb$export$b3de0ae08da2ce64})`,
    dark: `var(--ds-background-brand-bold, ${$dd5b085d4e6867fb$export$ecfc1dff386a3e7a})`
});
const $dd5b085d4e6867fb$export$2aa0182783e7e9de = (0, $kvIKC.default)({
    light: $dd5b085d4e6867fb$export$b3de0ae08da2ce64,
    dark: $dd5b085d4e6867fb$export$ecfc1dff386a3e7a
});
const $dd5b085d4e6867fb$export$8bf7dff220b82b4a = (0, $kvIKC.default)({
    light: $dd5b085d4e6867fb$export$9dc1ef0f3f48059b,
    dark: $dd5b085d4e6867fb$export$69cb3ca10c1e330e
});
const $dd5b085d4e6867fb$export$e13cce2a2d16a9d4 = (0, $kvIKC.default)({
    light: $dd5b085d4e6867fb$export$b48405b95304b5a1,
    dark: $dd5b085d4e6867fb$export$6011520a64d9a187
});
const $dd5b085d4e6867fb$export$a90204d1394caf30 = (0, $kvIKC.default)({
    light: $dd5b085d4e6867fb$export$4a7404f376229999,
    dark: $dd5b085d4e6867fb$export$4a7404f376229999
});
const $dd5b085d4e6867fb$export$594c5a8758200c32 = (0, $kvIKC.default)({
    light: $dd5b085d4e6867fb$export$c6930421db9fa514,
    dark: $dd5b085d4e6867fb$export$c6930421db9fa514
});
const $dd5b085d4e6867fb$export$955a2ebd2fb142ae = (0, $kvIKC.default)({
    light: $dd5b085d4e6867fb$export$940e1f69e873f202,
    dark: $dd5b085d4e6867fb$export$940e1f69e873f202
});
const $dd5b085d4e6867fb$export$2a0674ff2eb10214 = ()=>`var(--ds-skeleton, ${$dd5b085d4e6867fb$export$8d43898f60b96a82})`;

});
parcelRegister("kvIKC", function(module, exports) {

$parcel$export(module.exports, "default", () => $eee96a7bfa4a30f7$export$2e2bcd8739ae039);
/* eslint-disable prefer-rest-params */ 
var $2d3Fv = parcelRequire("2d3Fv");
// Unpack custom variants, and get correct value for the current theme
function $eee96a7bfa4a30f7$var$themedVariants(variantProp, variants) {
    return (props)=>{
        const theme = (0, $2d3Fv.default)(props);
        if (props && props[variantProp] && variants) {
            const modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                const value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return '';
    };
}
function $eee96a7bfa4a30f7$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === 'string') return $eee96a7bfa4a30f7$var$themedVariants(modesOrVariant, variantModes);
    const modes = modesOrVariant;
    return (props)=>{
        // Get theme from the user's props
        const theme = (0, $2d3Fv.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            const value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return '';
    };
}

});
parcelRegister("2d3Fv", function(module, exports) {

$parcel$export(module.exports, "default", () => $19bfa42aaeedfa77$export$2e2bcd8739ae039);

var $ivTMz = parcelRequire("ivTMz");
function $19bfa42aaeedfa77$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $ivTMz.CHANNEL) in props.theme) return props.theme[0, $ivTMz.CHANNEL];
        else if ('mode' in props.theme && (0, $ivTMz.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $ivTMz.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("ivTMz", function(module, exports) {

$parcel$export(module.exports, "CHANNEL", () => $d7a664710b9e9400$export$44ffba16bd48dac6);
$parcel$export(module.exports, "DEFAULT_THEME_MODE", () => $d7a664710b9e9400$export$c93026a968943f95);
$parcel$export(module.exports, "THEME_MODES", () => $d7a664710b9e9400$export$6ba72c8346b4c57e);
$parcel$export(module.exports, "borderRadius", () => $d7a664710b9e9400$export$7a57f79000377ca2);
$parcel$export(module.exports, "gridSize", () => $d7a664710b9e9400$export$6d8204c2cb2e06b8);
$parcel$export(module.exports, "fontSize", () => $d7a664710b9e9400$export$85e3c3ca0c6fb93);
$parcel$export(module.exports, "fontSizeSmall", () => $d7a664710b9e9400$export$6746fe0d9c9fab54);
$parcel$export(module.exports, "fontFamily", () => $d7a664710b9e9400$export$a5975749f0374264);
$parcel$export(module.exports, "codeFontFamily", () => $d7a664710b9e9400$export$356129969ee49c55);
$parcel$export(module.exports, "layers", () => $d7a664710b9e9400$export$7be255094ccdc533);
$parcel$export(module.exports, "skeletonShimmer", () => $d7a664710b9e9400$export$e497e856b4f89fcd);

var $1Ivg5 = parcelRequire("1Ivg5");

var $j0gMm = parcelRequire("j0gMm");
const $d7a664710b9e9400$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
const $d7a664710b9e9400$export$c93026a968943f95 = 'light';
const $d7a664710b9e9400$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
const $d7a664710b9e9400$export$7a57f79000377ca2 = ()=>3;
const $d7a664710b9e9400$export$6d8204c2cb2e06b8 = ()=>8;
const $d7a664710b9e9400$export$85e3c3ca0c6fb93 = ()=>14;
const $d7a664710b9e9400$export$6746fe0d9c9fab54 = ()=>11;
const $d7a664710b9e9400$export$a5975749f0374264 = ()=>`-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif`;
const $d7a664710b9e9400$export$356129969ee49c55 = ()=>`'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace`;
const $d7a664710b9e9400$export$8e24544ddba725ee = (color = `var(--ds-border-focused, ${0, $j0gMm.B200})`, outlineWidth = $d7a664710b9e9400$export$6d8204c2cb2e06b8() / 4)=>{
    (0, $1Ivg5.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return `
  &:focus {
    outline: none;
    box-shadow: 0px 0px 0px ${outlineWidth}px ${color};
  }
`;
};
const $d7a664710b9e9400$export$c0dd343266bc3261 = ()=>`
  box-shadow: none;
`;
const $d7a664710b9e9400$export$7be255094ccdc533 = {
    card: ()=>100,
    navigation: ()=>200,
    dialog: ()=>300,
    layer: ()=>400,
    blanket: ()=>500,
    modal: ()=>510,
    flag: ()=>600,
    spotlight: ()=>700,
    tooltip: ()=>9999
};
const $d7a664710b9e9400$export$a1b3edb637fb4f35 = ()=>{
    (0, $1Ivg5.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
const $d7a664710b9e9400$export$ba1d834b86d72a09 = $d7a664710b9e9400$export$a1b3edb637fb4f35;
const $d7a664710b9e9400$export$e497e856b4f89fcd = ()=>({
        css: {
            backgroundColor: `var(--ds-skeleton, ${(0, $j0gMm.skeleton)()})`,
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: `var(--ds-skeleton, ${(0, $j0gMm.skeleton)()})`
            },
            to: {
                backgroundColor: `var(--ds-skeleton-subtle, ${0, $j0gMm.N30A})`
            }
        }
    });

});





parcelRegister("biTOe", function(module, exports) {

$parcel$export(module.exports, "withFeatureFlags", () => $83acaab187a6f443$export$871b61ce44f2bb3a);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $inwKI = parcelRequire("inwKI");
function $83acaab187a6f443$export$871b61ce44f2bb3a(Component) {
    const WrappedComponent = (props)=>{
        const featureFlags = (0, $inwKI.useFeatureFlags)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, (0, $kU09D.default)({}, featureFlags, props));
    };
    WrappedComponent.displayName = "withFeatureFlags(".concat(Component.displayName, ")");
    return WrappedComponent;
}

});
parcelRegister("inwKI", function(module, exports) {

$parcel$export(module.exports, "FeatureFlagsProvider", () => $d613c7f31008c942$export$6d7e43f2d6e1c7c6);
$parcel$export(module.exports, "useFeatureFlags", () => $d613c7f31008c942$export$90335b3ff08f335);

var $eUqFw = parcelRequire("eUqFw");

var $d5mip = parcelRequire("d5mip");
const $d613c7f31008c942$var$FeatureFlagsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext((0, $d5mip.DEFAULT_MARKETPLACE_FEATURE_FLAGS));
const $d613c7f31008c942$export$6d7e43f2d6e1c7c6 = $d613c7f31008c942$var$FeatureFlagsContext.Provider;
function $d613c7f31008c942$export$90335b3ff08f335() {
    return (0, $eUqFw.useContext)($d613c7f31008c942$var$FeatureFlagsContext);
}

});
parcelRegister("d5mip", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_MARKETPLACE_FEATURE_FLAGS", () => $986d097efb87e48f$export$7abc7769c16a0fd6);

var $1lmYm = parcelRequire("1lmYm");
const $986d097efb87e48f$export$7abc7769c16a0fd6 = {
    replaceCategoriesOnAppTilesWithVendorName: false,
    enableBugBountyProgram: false,
    enableCloudFortifiedAppsDiscovery: false,
    showCustomBackendErrorsFromUpm: false,
    enableFreeStarterTierFilter: false,
    disableAppInstall: false,
    showManageAppRequestAlternativeLayout: false,
    disableAllHostingFromPromotionsDropdown: false,
    enableInContextAppRequest: false,
    enableInProductHelpPartnerReporting: false,
    showTrustSignalsInManageAppRequests: false,
    showDatePickerOnManagePricingTab: false,
    showBenchmarkingUiDropdown: false,
    showQualtricsSurvey: false,
    enableRetryForLicenseDetailsPostInstallation: false,
    allowSectionMessageForPartnersForMigrationToCcp: [],
    enableIncludePartnerForAllowSectionMessageForMigrationToCcp: false,
    enableReactivateForgeAppFromEmcee: false,
    enableReactivateForgeAppFromEmceeForHAMS: false,
    enableGoogleAnalytics4Tracking: false,
    showCopyChangesForPartnerContact: false,
    enableDualLicenseToggleInPartnersTable: false,
    enableCloudMigrationToggle: false,
    enablePrefixCodeSectionForGenericCloudPromotions: false,
    enableBacRedirectionForCcpPromotions: false,
    enableMpacServerEolWarning: false,
    enableReportsV2FeedbackCollector: false,
    enableReportsAccessibilityChanges: false,
    enableFiftyKPricingTiers: false,
    useAnalyticsWebClient: false,
    enableNewCategoriesAndKeywordsMessage: false,
    enableDeprecatedInstallationsGQL: false,
    enableV2SearchIndex: false,
    partnersNavigationRefresh: false,
    enablePartnerPaymentsViaConsoleBff: false,
    maintenanceBannerConfiguration: (0, $1lmYm.MaintenanceNone),
    privacySecurityTabDataResidency: false,
    useAnalyticsWebClientForPartnerEvents: false,
    showCommunityLicensesUnderPaidFilter: false
};

});
parcelRegister("1lmYm", function(module, exports) {

$parcel$export(module.exports, "MAINTENANCE_TYPE", () => $0fa992813a9efe2d$export$31f47edd0bcc48ff);
$parcel$export(module.exports, "MAINTENANCE_STATE", () => $0fa992813a9efe2d$export$8a69e83ecdbdde43);
$parcel$export(module.exports, "MAINTENANCE_BANNER_TARGET_PAGES", () => $0fa992813a9efe2d$export$d0f207d82e583b99);
$parcel$export(module.exports, "MaintenanceNone", () => $0fa992813a9efe2d$export$3f6ca9ffd8c7b46e);
let $0fa992813a9efe2d$export$31f47edd0bcc48ff = /*#__PURE__*/ function(MAINTENANCE_TYPE) {
    MAINTENANCE_TYPE["NONE"] = "maintenance-none";
    MAINTENANCE_TYPE["NO_CAPABILITIES_DISRUPTION"] = "no-disruption";
    MAINTENANCE_TYPE["WITH_CAPABILITIES_DISRUPTION"] = "with-disruption";
    return MAINTENANCE_TYPE;
}({});
let $0fa992813a9efe2d$export$8a69e83ecdbdde43 = /*#__PURE__*/ function(MAINTENANCE_STATE) {
    MAINTENANCE_STATE["SCHEDULED"] = "scheduled";
    MAINTENANCE_STATE["IN_PROGRESS"] = "in-progress";
    return MAINTENANCE_STATE;
}({});
let $0fa992813a9efe2d$export$d0f207d82e583b99 = /*#__PURE__*/ function(MAINTENANCE_BANNER_TARGET_PAGES) {
    MAINTENANCE_BANNER_TARGET_PAGES["ALL"] = "all";
    MAINTENANCE_BANNER_TARGET_PAGES["MARKETPLACE_PARTNER_PORTAL"] = "marketplace-partner-portal";
    return MAINTENANCE_BANNER_TARGET_PAGES;
}({});
const $0fa992813a9efe2d$export$3f6ca9ffd8c7b46e = {
    type: $0fa992813a9efe2d$export$31f47edd0bcc48ff.NONE,
    content: ''
};

});




parcelRegister("9l6Pq", function(module, exports) {

$parcel$export(module.exports, "StatsigContext", () => $6ccb5f35c6d3739c$export$d3dd0785b656dcb6);
$parcel$export(module.exports, "useStatsig", () => $6ccb5f35c6d3739c$export$ddc6406e1d54d599);
$parcel$export(module.exports, "withStatsig", () => $6ccb5f35c6d3739c$export$974e56e25a4e0e09);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $jkLPm = parcelRequire("jkLPm");
const $6ccb5f35c6d3739c$export$d3dd0785b656dcb6 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    statsigClient: new (0, $jkLPm.StatsigClient)() // without init it will return only falsy or default value. its required so that consumer does has to put a check for undefined
});
function $6ccb5f35c6d3739c$export$ddc6406e1d54d599() {
    const context = (0, $eUqFw.useContext)($6ccb5f35c6d3739c$export$d3dd0785b656dcb6);
    if (context === undefined) console.error('useStatsig must be used within a StatsigProvider');
    return context.statsigClient;
}
function $6ccb5f35c6d3739c$export$974e56e25a4e0e09(Component) {
    return function StatsigComponent(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ccb5f35c6d3739c$export$d3dd0785b656dcb6.Consumer, null, (_ref)=>{
            let { statsigClient: statsigClient } = _ref;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, (0, $kU09D.default)({}, props, {
                statsigClient: statsigClient
            }));
        });
    };
}

});
parcelRegister("jkLPm", function(module, exports) {

$parcel$export(module.exports, "StatsigClient", () => $e134fc1d6577ca86$export$189a85bb51d82b2e);

var $5zQU9 = parcelRequire("5zQU9");

var $8tM2T = parcelRequire("8tM2T");
function $e134fc1d6577ca86$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e134fc1d6577ca86$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e134fc1d6577ca86$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e134fc1d6577ca86$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $e134fc1d6577ca86$export$189a85bb51d82b2e {
    constructor(){
        var _this = this;
        (0, $5zQU9.default)(this, "isStatsigInitialized", false);
        (0, $5zQU9.default)(this, "evaluatedFlags", {});
        (0, $5zQU9.default)(this, "evaluatedExperiments", {});
        (0, $5zQU9.default)(this, "source", undefined);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, $5zQU9.default)(this, "overrides", {});
        (0, $5zQU9.default)(this, "getExperimentValue", function(experimentName, propertyName) {
            let defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            if (!_this.isStatsigInitialized) {
                console.warn('Statsig client not initialized.');
                return defaultValue;
            }
            if (_this.overrides[experimentName] !== undefined && _this.overrides[experimentName][propertyName] !== undefined) return _this.overrides[experimentName][propertyName];
            const evaluatedValue = (0, $8tM2T.default).getExperimentValue(experimentName, propertyName, defaultValue);
            _this.evaluatedExperiments = $e134fc1d6577ca86$var$_objectSpread($e134fc1d6577ca86$var$_objectSpread({}, _this.evaluatedExperiments), {}, {
                [experimentName]: $e134fc1d6577ca86$var$_objectSpread($e134fc1d6577ca86$var$_objectSpread({}, _this.evaluatedExperiments[experimentName]), {}, {
                    [propertyName]: evaluatedValue
                })
            });
            return evaluatedValue;
        });
        (0, $5zQU9.default)(this, "checkGate", function(gateName) {
            let defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            if (!_this.isStatsigInitialized) {
                console.warn('Statsig client not initialized.');
                return defaultValue;
            }
            if (_this.overrides[gateName] !== undefined) return Boolean(_this.overrides[gateName]);
            const evaluatedValue = (0, $8tM2T.default).checkGate(gateName);
            _this.evaluatedFlags[gateName] = evaluatedValue;
            return evaluatedValue;
        });
        (0, $5zQU9.default)(this, "initializeStatsigClientWithValues", async (_ref, source)=>{
            let { marketplaceAnonymousId: marketplaceAnonymousId, environment: environment, targetApp: targetApp, clientSdkKey: clientSdkKey, experimentValues: experimentValues, customAttributes: customAttributes } = _ref;
            this.source = source;
            await (0, $8tM2T.default).initializeFromValues({
                environment: environment,
                targetApp: targetApp,
                sdkKey: clientSdkKey
            }, {
                marketplaceAnonymousId: marketplaceAnonymousId
            }, customAttributes, experimentValues);
            this.isStatsigInitialized = true;
        });
        (0, $5zQU9.default)(this, "setOverride", (overrideValues)=>{
            this.overrides = overrideValues;
        });
        (0, $5zQU9.default)(this, "getEvaluatedFlags", ()=>{
            return this.evaluatedFlags;
        });
        (0, $5zQU9.default)(this, "getEvaluatedExperiments", ()=>{
            return this.evaluatedExperiments;
        });
        // ---------------------- Experiments EMCEE-------------------------
        /**
     * discussion: https://atlassian.enterprise.slack.com/archives/C04PR2YE4UC/p1725317404567309?thread_ts=1725277152.022099&channel=C04PR2YE4UC&message_ts=1725317404.567309
     * suggests that the exposures from the other target apps will cause issues, and recommends either suppressing the experiment or adding an in-code check
     **/ (0, $5zQU9.default)(this, "enableEmceeAetherExperience", ()=>{
            if (this.source !== 'PRODUCT') return false;
            return this.getExperimentValue('enable_emcee_aether_experiment_by_tenant', 'isExperienceEnabled', false);
        });
        // ---------------------- Experiments MPAC-------------------------
        (0, $5zQU9.default)(this, "enableAetherExperience", ()=>{
            return this.getExperimentValue('enable_aether_experience_experiment', 'isExperienceEnabled', false);
        });
        // ---------------------- Feature Flags ----------------------
        (0, $5zQU9.default)(this, "enableStaffPickOnAppListing", ()=>{
            return this.checkGate('enable_staff_pick_on_app_listing');
        });
        (0, $5zQU9.default)(this, "showAnnouncementBannerInResourcesTab", ()=>{
            return this.checkGate('show_announcement_banner_in_resources_tab');
        });
        (0, $5zQU9.default)(this, "enableAetherSearchOverlay", ()=>{
            return this.checkGate('enable_aether_search_overlay');
        });
        (0, $5zQU9.default)(this, "enableAetherSearchEmbedded", ()=>{
            return this.checkGate('enable_aether_embedded_search_experience');
        });
        (0, $5zQU9.default)(this, "showCompassApps", ()=>{
            return this.checkGate('show_compass_apps');
        });
        (0, $5zQU9.default)(this, "showNewJiraSoftwareLabel", ()=>{
            return this.checkGate('show_new_jira_software_label');
        });
        (0, $5zQU9.default)(this, "enableMosaicPartnerProfileExperience", ()=>{
            return this.checkGate('enable_mosaic_partner_profile_experience');
        });
        (0, $5zQU9.default)(this, "showChangemakersCollectionTile", ()=>{
            return this.checkGate('show_changemakers_collection_tile');
        });
        (0, $5zQU9.default)(this, "showAtlassianRovoCollectionTile", ()=>{
            return this.checkGate('enable_atlassian_rovo_marketplace_collection');
        });
        (0, $5zQU9.default)(this, "enableAetherBenefitsModal", ()=>{
            return this.checkGate('enable_aether_benefits_modal');
        });
        (0, $5zQU9.default)(this, "enableAetherFeedbackCollector", ()=>{
            return this.checkGate('enable_aether_feedback_collector');
        });
        (0, $5zQU9.default)(this, "enableAetherAppListingPage", ()=>{
            if (this.enableEmceeAetherExperience()) return true;
            if (this.enableAetherExperience()) return this.checkGate('enable_aether_applisting_page');
            return false;
        });
        (0, $5zQU9.default)(this, "enableCurrentUserApiViaStoreBff", ()=>{
            return this.checkGate('enable_current_user_api_via_store_bff');
        });
        (0, $5zQU9.default)(this, "enableTeamsWithMakerIntegration", ()=>{
            return this.checkGate('partner_teams_tab_maker_integration');
        });
        (0, $5zQU9.default)(this, "displayAuditTabInManagePartnerPage", ()=>{
            return this.checkGate('display_audit_tab_in_manage_partner_page');
        });
        (0, $5zQU9.default)(this, "enableReactUFO", ()=>{
            return this.checkGate('enable_react_ufo');
        });
        (0, $5zQU9.default)(this, "enableAlgoliaCallOnAppListingAndDialogs", ()=>{
            return this.checkGate('enable_algolia_call_on_applising_and_dialogs');
        });
        (0, $5zQU9.default)(this, "enablePartnerUserApiViaConsoleBffGql", ()=>{
            return this.checkGate('enable_partner_user_api_via_console_bff_gql');
        });
        (0, $5zQU9.default)(this, "enableReactUFOEmcee", ()=>{
            return this.checkGate('enable_react_ufo_emcee');
        });
        (0, $5zQU9.default)(this, "showUpdatedPartnerTierMessage", ()=>this.checkGate('partner_tier_messaging_update'));
        // ---------------------- Permanent Feature Flags ----------------------
        (0, $5zQU9.default)(this, "showAppListingTrustTab", ()=>{
            // https://switcheroo.atlassian.com/ui/gates/1301e2c9-053a-4d13-9697-b06d84d481bf
            return this.checkGate('show_applisting_trust_tab');
        });
    }
    async initWithStatsigGlobalInstance(source) {
        // for jira and connie the statsig client is already initialized globally
        // we cannot pass the custom attributes as statsig is initialized in their backend
        this.isStatsigInitialized = true;
        this.source = source;
    }
    // IMPORTANT: Calling this method will completely re-initialize the client with a new set of flags. You will need to re-render the entire page after this completes to ensure everything picks up the new flag values. You should avoid using this frequently as it has implications on the user experience.
    async initializeStatsigClient(_ref2) {
        let { clientKey: clientKey, environment: environment, targetApp: targetApp, marketplaceAnonymousId: marketplaceAnonymousId, tenantId: tenantId, atlassianAccountId: atlassianAccountId } = _ref2;
        let customAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let source = arguments.length > 2 ? arguments[2] : undefined;
        this.source = source;
        try {
            await (0, $8tM2T.default).initialize({
                apiKey: clientKey,
                environment: environment,
                targetApp: targetApp,
                fetchTimeoutMs: 5000
            }, {
                marketplaceAnonymousId: marketplaceAnonymousId,
                tenantId: tenantId,
                atlassianAccountId: atlassianAccountId
            }, customAttributes);
            this.isStatsigInitialized = true;
        } catch (err) {
            console.error('Failed to initialize FeatureGates client.', err);
        }
    }
}
var $e134fc1d6577ca86$export$2e2bcd8739ae039 = $e134fc1d6577ca86$export$189a85bb51d82b2e;

});


parcelRegister("hjlb6", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("3qG4B", function(module, exports) {

$parcel$export(module.exports, "default", () => $27f46fa8c3f90cb8$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $5OdZ3 = parcelRequire("5OdZ3");

var $fyH4h = parcelRequire("fyH4h");
var $czlCy = parcelRequire("czlCy");
var $lgRZl = parcelRequire("lgRZl");

var $9osuT = parcelRequire("9osuT");

var $biTOe = parcelRequire("biTOe");
var $9l6Pq = parcelRequire("9l6Pq");

var $fEeDC = parcelRequire("fEeDC");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $5YKni = parcelRequire("5YKni");


var $6jEcw = parcelRequire("6jEcw");

var $90ON9 = parcelRequire("90ON9");

var $2Ywog = parcelRequire("2Ywog");
function $27f46fa8c3f90cb8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $27f46fa8c3f90cb8$var$PaginationStyled = (0, $3UXZ8.default)("div", {
    target: "eglpq9d0",
    label: "PaginationStyled"
})({
    name: "gt4wuf",
    styles: "margin-top:var(--ds-space-250, 20px);"
});
function $27f46fa8c3f90cb8$var$isLoading(props) {
    return !props.dataError && props.loading;
}
class $27f46fa8c3f90cb8$var$SearchResults extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "onLoadMoreResultsClick", ()=>{
            const showCompassApps = this.props.statsigClient.showCompassApps();
            this.props.onLoadMoreResultsClick({
                currentPage: this.props.currentPage,
                featureFlags: {
                    enableV2SearchIndex: !!this.props.enableV2SearchIndex,
                    showCompassApps: !!showCompassApps
                }
            });
            this.props.fireAnalyticsEvent({
                eventType: (0, $5YKni.ButtonClickedEvent),
                actionSubjectId: (0, $5YKni.ANALYTICS_SUBJECT_ID_SEARCH_RESULTS_LOAD_MORE_BUTTON),
                source: (0, $5YKni.EVENT_SOURCE),
                attributes: {
                    currentPage: this.props.currentPage + '',
                    currentPerspective: (0, $37a31921fd56c86d$export$a6b9aaee40d49fd0)
                }
            }, (0, $5YKni.EVENT_CHANNEL));
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fyH4h.default), {
            baseMessage: "Oops! Looks like something went wrong.",
            dataError: this.props.dataError,
            dataErrorMessages: this.props.dataErrorMessages,
            loading: $27f46fa8c3f90cb8$var$isLoading(this.props),
            optimisticLoadTime: 1000
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, this.props.contentOverrides || this.props.hits && !this.props.hits.isEmpty() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Ywog.default), {
            colSpan: this.props.colSpan,
            contentOverrides: this.props.contentOverrides,
            fromSearch: true,
            hitContext: this.props.hitContext,
            hits: this.props.hits,
            hitSize: this.props.hitSize,
            maxLength: this.props.maxLength,
            onCategoryClick: this.props.onHitCategoryClick,
            perspective: this.props.perspective,
            screenClass: this.props.screenClass,
            searchId: this.props.searchId,
            stateChangeRequested: this.props.stateChangeRequested,
            overrideLargeHitRightContent: this.props.overrideLargeHitRightContent,
            filters: this.props.filters
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, "Sorry! We didn't find any matching apps."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, "Did you know that you can build your own apps? Find out how at "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5OdZ3.default), {
            href: "https://developer.atlassian.com",
            rel: "noopener noreferrer",
            target: "_blank"
        }, "https://developer.atlassian.com"), ".")), !this.props.hidePagination && this.props.numberOfPages - 1 > this.props.currentPage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($27f46fa8c3f90cb8$var$PaginationStyled, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $czlCy.default), {
            loadingMoreResults: this.props.loadingMoreResults,
            moreResultsDataError: this.props.moreResultsDataError,
            moreResultsDataErrorMessages: this.props.moreResultsDataErrorMessages,
            onLoadMoreResultsClick: this.onLoadMoreResultsClick
        })) : undefined));
    }
}
(0, $5zQU9.default)($27f46fa8c3f90cb8$var$SearchResults, "propTypes", {
    colSpan: (0, $90ON9.default).colSpan.isRequired,
    contentOverrides: (0, $90ON9.default).contentOverrides,
    fireAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    currentPage: (0, $lgRZl.default).requiredIf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number, (props)=>!$27f46fa8c3f90cb8$var$isLoading(props)),
    dataError: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
    dataErrorMessages: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).list.isRequired,
    hidePagination: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    hitContext: (0, $90ON9.default).hitContext,
    hitSize: (0, $90ON9.default).hitSize,
    hits: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).listOf((0, $90ON9.default).hit()),
    loading: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
    loadingMoreResults: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
    maxLength: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    moreResultsDataError: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
    moreResultsDataErrorMessages: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).list.isRequired,
    numberOfPages: (0, $lgRZl.default).requiredIf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number, (props)=>!$27f46fa8c3f90cb8$var$isLoading(props)),
    onHitCategoryClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    onLoadMoreResultsClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    perspective: (0, $6jEcw.default).perspective.isRequired,
    screenClass: (0, $90ON9.default).screenClass.isRequired,
    searchId: (0, $lgRZl.default).requiredIf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number, (props)=>!$27f46fa8c3f90cb8$var$isLoading(props)),
    stateChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    overrideLargeHitRightContent: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    filters: (0, $90ON9.default).filters,
    enableV2SearchIndex: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool
});
(0, $5zQU9.default)($27f46fa8c3f90cb8$var$SearchResults, "defaultProps", {
    hidePagination: false,
    hitSize: 'large'
});
var $27f46fa8c3f90cb8$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)((0, $biTOe.withFeatureFlags)((0, $9l6Pq.withStatsig)($27f46fa8c3f90cb8$var$SearchResults)));

});
parcelRegister("fyH4h", function(module, exports) {

$parcel$export(module.exports, "default", () => $b53b7069df6cb5b3$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $lRvnl = parcelRequire("lRvnl");

var $fEeDC = parcelRequire("fEeDC");

var $g5DHJ = parcelRequire("g5DHJ");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $kU8RF = parcelRequire("kU8RF");
function $b53b7069df6cb5b3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b53b7069df6cb5b3$export$42a852a2b6b56249 = (0, $3UXZ8.default)("div", {
    target: "ebku820",
    label: "Container"
})({
    name: "8atqhb",
    styles: "width:100%;"
});
const $b53b7069df6cb5b3$export$6586c12bbf6d0c20 = (0, $3UXZ8.default)("ul", {
    target: "ebku821",
    label: "ErrorMessages"
})({
    name: "gx0lhm",
    styles: "margin-bottom:0;"
});
class $b53b7069df6cb5b3$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const errorMessages = this.props.dataErrorMessages.map((e, i)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", {
                key: 'data-error-message-' + i
            }, e.get('message'));
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b53b7069df6cb5b3$export$42a852a2b6b56249, {
            className: this.props.className
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kU8RF.default), {
            active: this.props.loading,
            delay: this.props.optimisticLoadTime,
            size: this.props.spinnerSize,
            testId: "content-container-loader"
        }, this.props.dataError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
            appearance: "error"
        }, this.props.baseMessage, errorMessages.size > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b53b7069df6cb5b3$export$6586c12bbf6d0c20, null, errorMessages) : undefined) : this.props.children));
    }
}
(0, $5zQU9.default)($b53b7069df6cb5b3$export$2e2bcd8739ae039, "propTypes", {
    baseMessage: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    loading: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    dataError: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    dataErrorMessages: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).listOf((0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
        message: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string
    })),
    optimisticLoadTime: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    spinnerSize: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number
});
(0, $5zQU9.default)($b53b7069df6cb5b3$export$2e2bcd8739ae039, "defaultProps", {
    baseMessage: 'Oops! Looks like something went wrong.',
    dataError: false,
    loading: false,
    dataErrorMessages: (0, $g5DHJ.List)(),
    spinnerSize: 50
});

});
parcelRegister("kU8RF", function(module, exports) {

$parcel$export(module.exports, "default", () => $f37fe9eb95d1abf5$export$2e2bcd8739ae039);

var $lSV8Z = parcelRequire("lSV8Z");
var $hYDGa = parcelRequire("hYDGa");

var $4Bees = parcelRequire("4Bees");

var $eUqFw = parcelRequire("eUqFw");

var $9kUzi = parcelRequire("9kUzi");
const $f37fe9eb95d1abf5$var$getSpinnerTestId = (testId)=>{
    if (testId !== null && testId !== void 0 && testId.length) return "".concat(testId, "--spinner");
};
const $f37fe9eb95d1abf5$var$SPINNER_MASK_DEFAULT_SIZE = 'large';
const $f37fe9eb95d1abf5$var$SPINNER_MASK_DEFAULT_MIN_HEIGHT = 100;
const $f37fe9eb95d1abf5$var$SpinnerMask = (props)=>{
    const { active: active, appearance: appearance, children: children, className: className, delay: delay, minHeight: minHeight = $f37fe9eb95d1abf5$var$SPINNER_MASK_DEFAULT_MIN_HEIGHT, size: size = $f37fe9eb95d1abf5$var$SPINNER_MASK_DEFAULT_SIZE, testId: testId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9kUzi.Mask), {
        minHeight: minHeight,
        "data-testid": testId,
        className: className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lSV8Z.default), {
        appear: true
    }, active && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hYDGa.default), null, (fadeProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9kUzi.SpinnerContainer), fadeProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            appearance: appearance,
            delay: delay,
            size: size,
            testId: $f37fe9eb95d1abf5$var$getSpinnerTestId(testId)
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9kUzi.ContentWrapper), {
        visible: !active
    }, children));
};
var $f37fe9eb95d1abf5$export$2e2bcd8739ae039 = $f37fe9eb95d1abf5$var$SpinnerMask;

});
parcelRegister("9kUzi", function(module, exports) {

$parcel$export(module.exports, "ContentWrapper", () => $6cc1dc9af648698c$export$6ce170286acaa8d3);
$parcel$export(module.exports, "Mask", () => $6cc1dc9af648698c$export$991dcf7284de63d);
$parcel$export(module.exports, "SpinnerContainer", () => $6cc1dc9af648698c$export$a5e06607a5ac6158);

var $3UXZ8 = parcelRequire("3UXZ8");
function $6cc1dc9af648698c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6cc1dc9af648698c$export$6ce170286acaa8d3 = (0, $3UXZ8.default)("div", {
    target: "ex486hq0",
    label: "ContentWrapper"
})("width:100%;transition:opacity ", (_ref)=>{
    let { visible: visible } = _ref;
    return visible ? 'linear 0.2s' : '0s';
}, ";opacity:", (_ref2)=>{
    let { visible: visible } = _ref2;
    return visible ? 1 : 0;
}, ";visibility:", (_ref3)=>{
    let { visible: visible } = _ref3;
    return visible ? 'visible' : 'hidden';
}, ";");
const $6cc1dc9af648698c$export$991dcf7284de63d = (0, $3UXZ8.default)("div", {
    target: "ex486hq1",
    label: "Mask"
})("position:relative;width:100%;min-height:", (props)=>props.minHeight, "px;");
const $6cc1dc9af648698c$export$a5e06607a5ac6158 = (0, $3UXZ8.default)("div", {
    target: "ex486hq2",
    label: "SpinnerContainer"
})({
    name: "16jw3vr",
    styles: "width:100%;display:flex;justify-content:center;height:100%;align-items:center;position:absolute;top:0;"
});

});



parcelRegister("czlCy", function(module, exports) {

$parcel$export(module.exports, "default", () => $9269865f7dc51cbb$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $9oiuL = parcelRequire("9oiuL");

var $lRvnl = parcelRequire("lRvnl");

var $fEeDC = parcelRequire("fEeDC");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $kU8RF = parcelRequire("kU8RF");
function $9269865f7dc51cbb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9269865f7dc51cbb$var$ErrorWrapper = (0, $3UXZ8.default)("div", {
    target: "e19hyeel0",
    label: "ErrorWrapper"
})({
    name: "nel67k",
    styles: "display:flex;justify-content:center;margin-bottom:10px;"
});
const $9269865f7dc51cbb$var$ButtonWrapper = (0, $3UXZ8.default)("div", {
    target: "e19hyeel1",
    label: "ButtonWrapper"
})({
    name: "1iahunv",
    styles: "display:flex;justify-content:center;height:45px;"
});
const $9269865f7dc51cbb$export$378165210bc6a84a = (0, $3UXZ8.default)("div", {
    target: "e19hyeel2",
    label: "AkButtonWrapper"
})({
    name: "1l4w6pd",
    styles: "display:flex;justify-content:center;"
});
function $9269865f7dc51cbb$var$resolveErrorMessage(_ref) {
    let { dataErrorMessages: dataErrorMessages } = _ref;
    return "Oops! Looks like something went wrong - ".concat(dataErrorMessages.map((e)=>e.get('message')).join(', '), ". Try again.");
}
class $9269865f7dc51cbb$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, this.props.moreResultsDataError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9269865f7dc51cbb$var$ErrorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
            appearance: "warning"
        }, $9269865f7dc51cbb$var$resolveErrorMessage({
            dataErrorMessages: this.props.moreResultsDataErrorMessages
        }))) : undefined, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9269865f7dc51cbb$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kU8RF.default), {
            active: this.props.loadingMoreResults,
            size: 20
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9269865f7dc51cbb$export$378165210bc6a84a, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9oiuL.default), {
            appearance: this.props.appearance,
            onClick: this.props.onLoadMoreResultsClick
        }, "More results")))));
    }
}
(0, $5zQU9.default)($9269865f7dc51cbb$export$2e2bcd8739ae039, "propTypes", {
    appearance: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    loadingMoreResults: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
    moreResultsDataError: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
    moreResultsDataErrorMessages: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).list.isRequired,
    onLoadMoreResultsClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired
});
(0, $5zQU9.default)($9269865f7dc51cbb$export$2e2bcd8739ae039, "defaultProps", {
    appearance: 'primary'
});

});
parcelRegister("9oiuL", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d64b3bb3ca126ae$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");

var $6ZjRV = parcelRequire("6ZjRV");

var $atXX9 = parcelRequire("atXX9");

var $96HLH = parcelRequire("96HLH");

var $i8QFr = parcelRequire("i8QFr");
const $6d64b3bb3ca126ae$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * CAUTION: Legacy buttons will soon be deprecated. Please use the new Button components from `@atlaskit/button/new`.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ const $6d64b3bb3ca126ae$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function Button({ appearance: appearance = 'default', children: children, iconBefore: iconBefore, iconAfter: iconAfter, isSelected: isSelected = false, onMouseDown: providedOnMouseDown = (0, $5Q9wj.default), onMouseUp: providedOnMouseUp = (0, $5Q9wj.default), shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', ...rest }, ref) {
    const { mode: mode } = (0, $6ZjRV.useGlobalTheme)();
    const isOnlySingleIcon = (0, $i8QFr.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    const [isActive, setIsActive] = (0, $eUqFw.useState)(false);
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    const onMouseDown = (0, $eUqFw.useCallback)((event)=>{
        providedOnMouseDown(event);
        if ($6d64b3bb3ca126ae$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    const onMouseUp = (0, $eUqFw.useCallback)((event)=>{
        providedOnMouseUp(event);
        if ($6d64b3bb3ca126ae$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    const buttonCss = (0, $eUqFw.useMemo)(()=>(0, $96HLH.getCss)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        }), [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atXX9.default), (0, $kU09D.default)({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$6d64b3bb3ca126ae$var$Button.displayName = 'Button';
var $6d64b3bb3ca126ae$export$2e2bcd8739ae039 = $6d64b3bb3ca126ae$var$Button;

});
parcelRegister("6ZjRV", function(module, exports) {

$parcel$export(module.exports, "useGlobalTheme", () => $5167da1ef3c95e68$export$7692396083754928);
$parcel$export(module.exports, "default", () => $5167da1ef3c95e68$export$2e2bcd8739ae039);

var $d8yWP = parcelRequire("d8yWP");
// Create default global light theme
const { Provider: $5167da1ef3c95e68$var$Provider, Consumer: $5167da1ef3c95e68$var$Consumer, useTheme: $5167da1ef3c95e68$export$7692396083754928 } = (0, $d8yWP.createTheme)(()=>({
        mode: 'light'
    }));
const $5167da1ef3c95e68$var$Theme = {
    Provider: $5167da1ef3c95e68$var$Provider,
    Consumer: $5167da1ef3c95e68$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5167da1ef3c95e68$export$2e2bcd8739ae039 = $5167da1ef3c95e68$var$Theme;

});
parcelRegister("d8yWP", function(module, exports) {

$parcel$export(module.exports, "createTheme", () => $990721a330b4da83$export$25d302a5b900a763);

var $eUqFw = parcelRequire("eUqFw");
function $990721a330b4da83$export$25d302a5b900a763(defaultGetTokens) {
    const emptyThemeFn = (getTokens, props)=>getTokens(props);
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ const ThemeContext = /*#__PURE__*/ (0, $eUqFw.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        const theme = (0, $eUqFw.useContext)(ThemeContext);
        const themeFn = theme || emptyThemeFn;
        const tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        const { children: children, ...themeProps } = props;
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        const tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        const themeFn = (0, $eUqFw.useContext)(ThemeContext);
        const valueFn = props.value || emptyThemeFn;
        const mixedFn = (0, $eUqFw.useCallback)((themeProps)=>valueFn(themeFn, themeProps), [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("atXX9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a1b1e3e76c89374$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lv3Pn = parcelRequire("lv3Pn");

var $5Q9wj = parcelRequire("5Q9wj");

var $hhlqA = parcelRequire("hhlqA");

var $51sCz = parcelRequire("51sCz");

var $jsCXU = parcelRequire("jsCXU");

var $j0gMm = parcelRequire("j0gMm");

var $isb2W = parcelRequire("isb2W");

var $96HLH = parcelRequire("96HLH");

var $gp7Z4 = parcelRequire("gp7Z4");
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
const $7a1b1e3e76c89374$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform.design-system-team.enable-new-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ const $7a1b1e3e76c89374$var$iconBeforeSpacingFixStyle = (0, $byn9U.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
const $7a1b1e3e76c89374$var$iconAfterSpacingFixStyle = (0, $byn9U.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
const $7a1b1e3e76c89374$var$getSpacingFix = (children, spacingStyles)=>{
    if (!children || (0, $gp7Z4.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
const $7a1b1e3e76c89374$var$getChildren = (children, childrenStyles)=>{
    if ((0, $gp7Z4.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? (0, $byn9U.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
const $7a1b1e3e76c89374$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function ButtonBase(props, ref) {
    const { analyticsContext: // I don't think analytics should be in button, but for now it is
    analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, buttonCss: buttonCss, children: children, className: className, href: href, // use the provided component prop,
    // else default to anchor if there is a href, and button if there is no href
    component: Component = href ? 'a' : 'button', iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled = false, isSelected: isSelected = false, onBlur: onBlur, onClick: providedOnClick = (0, $5Q9wj.default), onFocus: onFocus, onMouseDown: providedOnMouseDown = (0, $5Q9wj.default), overlay: overlay, shouldFitContainer: // Pulling out so it doesn't spread on rendered component
    shouldFitContainer, spacing: spacing = 'default', tabIndex: tabIndex = 0, type: type = !href ? 'button' : undefined, testId: testId, ...rest } = props;
    const ourRef = (0, $eUqFw.useRef)();
    const setRef = (0, $eUqFw.useCallback)((node)=>{
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $hhlqA.default)(ourRef, autoFocus);
    const interactionContext = (0, $eUqFw.useContext)((0, $jsCXU.default));
    const handleClick = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $lv3Pn.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "@atlaskit/button",
        packageVersion: "18.4.1",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    const onMouseDown = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $eUqFw.useEffect)(()=>{
        const el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    const hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const fadeStyles = (0, $byn9U.css)((0, $96HLH.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    const isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: `${isSelected || isDisabled ? `var(--ds-icon-subtle, ${0, $j0gMm.N500})` : `var(--ds-icon-warning-inverse, ${0, $j0gMm.N500})`} !important`
        }
    };
    return (0, $byn9U.jsx)((0, $51sCz.default), null, (0, $byn9U.jsx)(Component, (0, $kU09D.default)({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $7a1b1e3e76c89374$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $isb2W.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $byn9U.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $96HLH.getIconStyle)({
                spacing: spacing
            }),
            $7a1b1e3e76c89374$var$getSpacingFix(children, $7a1b1e3e76c89374$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $7a1b1e3e76c89374$var$getChildren(children, [
        fadeStyles,
        (0, $96HLH.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $byn9U.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $96HLH.getIconStyle)({
                spacing: spacing
            }),
            $7a1b1e3e76c89374$var$getSpacingFix(children, $7a1b1e3e76c89374$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $byn9U.jsx)("span", {
        css: [
            (0, $96HLH.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7a1b1e3e76c89374$export$2e2bcd8739ae039 = $7a1b1e3e76c89374$var$ButtonBase;

});
parcelRegister("lv3Pn", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $040a0e4b9b09a444$export$a4687b0234b40e28);

var $eUqFw = parcelRequire("eUqFw");

var $6lQr9 = parcelRequire("6lQr9");

var $l94Sf = parcelRequire("l94Sf");
function $040a0e4b9b09a444$export$a4687b0234b40e28({ fn: fn, action: action, componentName: componentName, actionSubject: actionSubject, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6lQr9.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $l94Sf.useTrackedRef)(analyticsData);
    const fnRef = (0, $l94Sf.useTrackedRef)(fn);
    const handler = (0, $eUqFw.useCallback)((value)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("6lQr9", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $49fd61246242ecc9$export$5bf35293e545f20c);

var $fzXll = parcelRequire("fzXll");

var $8HgcJ = parcelRequire("8HgcJ");

var $jxAQm = parcelRequire("jxAQm");
function $49fd61246242ecc9$export$5bf35293e545f20c() {
    const analyticsContext = (0, $jxAQm.useAnalyticsContext)();
    const createAnalyticsEvent = (0, $fzXll.useCallbackOne)((payload)=>{
        return new (0, $8HgcJ.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("8HgcJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $654ee8bdc6dd9dd0$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $7g3jL = parcelRequire("7g3jL");
const $654ee8bdc6dd9dd0$export$35f8383928ba8d7 = (obj)=>{
    var _obj$constructor;
    return obj instanceof $654ee8bdc6dd9dd0$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 ? void 0 : (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
class $654ee8bdc6dd9dd0$export$2e2bcd8739ae039 extends (0, $7g3jL.default) {
    constructor(props){
        super(props);
        (0, $5zQU9.default)(this, "_isUIAnalyticsEvent", true);
        (0, $5zQU9.default)(this, "clone", ()=>{
            if (this.hasFired) return null;
            const context = [
                ...this.context
            ];
            const handlers = [
                ...this.handlers
            ];
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ const payload = JSON.parse(JSON.stringify(this.payload));
            return new $654ee8bdc6dd9dd0$export$2e2bcd8739ae039({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $5zQU9.default)(this, "fire", (channel)=>{
            if (this.hasFired) return;
            this.handlers.forEach((handler)=>handler(this, channel));
            this.hasFired = true;
        });
        this.context = props.context || [];
        this.handlers = props.handlers || [];
        this.hasFired = false;
    }
    update(updater) {
        if (this.hasFired) return this;
        return super.update(updater);
    }
}

});
parcelRegister("7g3jL", function(module, exports) {

$parcel$export(module.exports, "default", () => $548c99e3fa1120c4$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
const $548c99e3fa1120c4$export$ad4be5c2ec28cecf = (obj)=>{
    var _obj$constructor;
    return obj instanceof $548c99e3fa1120c4$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 ? void 0 : (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
class $548c99e3fa1120c4$export$2e2bcd8739ae039 {
    constructor(props){
        (0, $5zQU9.default)(this, "_isAnalyticsEvent", true);
        (0, $5zQU9.default)(this, "clone", ()=>{
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            const payload = {
                ...this.payload
            };
            return new $548c99e3fa1120c4$export$2e2bcd8739ae039({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    update(updater) {
        if (typeof updater === 'function') this.payload = updater(this.payload);
        if (typeof updater === 'object') this.payload = {
            ...this.payload,
            ...updater
        };
        return this;
    }
}

});


parcelRegister("jxAQm", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", () => $e39dadba9c41f28f$export$d1f587f82ad51c4);

var $eUqFw = parcelRequire("eUqFw");

var $kNx8v = parcelRequire("kNx8v");
const $e39dadba9c41f28f$export$d1f587f82ad51c4 = ()=>{
    return (0, $eUqFw.useContext)((0, $kNx8v.default));
};

});


parcelRegister("l94Sf", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", () => $f64e381c18db5f8b$export$1d27a74659855e44);

var $eUqFw = parcelRequire("eUqFw");
const $f64e381c18db5f8b$export$1d27a74659855e44 = (value)=>{
    const ref = (0, $eUqFw.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("isb2W", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6f369235bd69ccd$export$2e2bcd8739ae039);
function $d6f369235bd69ccd$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $d6f369235bd69ccd$var$tabKeyCode = 9;
function $d6f369235bd69ccd$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $d6f369235bd69ccd$var$tabKeyCode) return;
    $d6f369235bd69ccd$var$abort(event);
}
const $d6f369235bd69ccd$var$block = {
    onMouseDownCapture: $d6f369235bd69ccd$var$abort,
    onMouseUpCapture: $d6f369235bd69ccd$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $d6f369235bd69ccd$var$onKey,
    onKeyUpCapture: $d6f369235bd69ccd$var$onKey,
    onTouchStartCapture: $d6f369235bd69ccd$var$abort,
    onTouchEndCapture: $d6f369235bd69ccd$var$abort,
    onPointerDownCapture: $d6f369235bd69ccd$var$abort,
    onPointerUpCapture: $d6f369235bd69ccd$var$abort,
    onClickCapture: $d6f369235bd69ccd$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $d6f369235bd69ccd$var$abort
};
const $d6f369235bd69ccd$var$doNotBlock = {};
function $d6f369235bd69ccd$export$2e2bcd8739ae039({ isInteractive: isInteractive }) {
    return isInteractive ? $d6f369235bd69ccd$var$doNotBlock : $d6f369235bd69ccd$var$block;
}

});

parcelRegister("96HLH", function(module, exports) {

$parcel$export(module.exports, "getCss", () => $6a16a016cffcb4ff$export$955358618f994a11);
$parcel$export(module.exports, "getIconStyle", () => $6a16a016cffcb4ff$export$864eea3f4ec3368f);
$parcel$export(module.exports, "getContentStyle", () => $6a16a016cffcb4ff$export$7ad0316cc0dd65a);
$parcel$export(module.exports, "getFadingCss", () => $6a16a016cffcb4ff$export$1b5827d324e945b1);
$parcel$export(module.exports, "overlayCss", () => $6a16a016cffcb4ff$export$1a9fe1b84c876bb5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $ivTMz = parcelRequire("ivTMz");

var $5JMSv = parcelRequire("5JMSv");
const $6a16a016cffcb4ff$var$gridSize = (0, $ivTMz.gridSize)();
const $6a16a016cffcb4ff$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
const $6a16a016cffcb4ff$var$heights = {
    default: `${32 / 14}em`,
    // 32px
    compact: `${24 / 14}em`,
    none: 'auto'
};
const $6a16a016cffcb4ff$var$lineHeights = {
    default: $6a16a016cffcb4ff$var$heights.default,
    compact: $6a16a016cffcb4ff$var$heights.compact,
    none: 'inherit'
};
const $6a16a016cffcb4ff$var$padding = {
    // 10px gutter
    default: `0 ${$6a16a016cffcb4ff$var$gridSize + $6a16a016cffcb4ff$var$gridSize / 4}px`,
    compact: `0 ${$6a16a016cffcb4ff$var$gridSize + $6a16a016cffcb4ff$var$gridSize / 4}px`,
    none: '0'
};
const $6a16a016cffcb4ff$var$singleIconPadding = {
    // 2px gutter
    compact: `0 ${$6a16a016cffcb4ff$var$gridSize / 4}px`,
    default: `0 ${$6a16a016cffcb4ff$var$gridSize / 4}px`,
    none: '0'
};
const $6a16a016cffcb4ff$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
const $6a16a016cffcb4ff$var$innerMargin = {
    content: `0 ${$6a16a016cffcb4ff$var$gridSize / 4}px`,
    icon: `0 ${$6a16a016cffcb4ff$var$gridSize / 4}px`
};
const $6a16a016cffcb4ff$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
const $6a16a016cffcb4ff$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #172B4D)",
    '&:not([disabled])::after': {
        ...$6a16a016cffcb4ff$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border, #091E4224)"
    },
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #091E424F)"
    }
};
const $6a16a016cffcb4ff$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #0C66E4)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #0055CC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #09326C)"
    }
};
const $6a16a016cffcb4ff$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #0C66E4)",
    '&:hover': {
        color: "var(--ds-link, #0C66E4)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #0055CC)",
        textDecoration: 'underline'
    }
};
const $6a16a016cffcb4ff$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #44546F)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
    }
};
const $6a16a016cffcb4ff$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #44546F)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #44546F)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #172B4D)",
        textDecoration: 'underline'
    }
};
const $6a16a016cffcb4ff$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #F5CD47)",
    color: "var(--ds-text-warning-inverse, #172B4D)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #E2B203)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #CF9F02)"
    }
};
const $6a16a016cffcb4ff$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #5D1F1A)"
    }
};
const $6a16a016cffcb4ff$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "var(--ds-text-selected, #0C66E4)",
    '&:not([disabled])::after': {
        ...$6a16a016cffcb4ff$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border-selected, #0C66E4)"
    }
};
const $6a16a016cffcb4ff$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $6a16a016cffcb4ff$var$getColor({ group: group, key: key, mode: mode }) {
    const rule = group[key] || group.default;
    return rule[mode];
}
function $6a16a016cffcb4ff$var$getColors({ appearance: appearance, key: key, mode: mode }) {
    return {
        background: $6a16a016cffcb4ff$var$getColor({
            group: (0, $5JMSv.default).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: `${$6a16a016cffcb4ff$var$getColor({
            group: (0, $5JMSv.default).color[appearance],
            key: key,
            mode: mode
        })} !important`
    };
}
function $6a16a016cffcb4ff$export$955358618f994a11({ appearance: appearance, spacing: spacing, mode: mode, isSelected: isSelected, shouldFitContainer: shouldFitContainer, isOnlySingleIcon: isOnlySingleIcon }) {
    const baseColors = $6a16a016cffcb4ff$var$getColors({
        appearance: appearance,
        key: isSelected ? 'selected' : 'default',
        mode: mode
    });
    return {
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: 500,
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        // dynamic styles
        ...!(0, $XHGTv.fg)('platform.design-system-team.component-visual-refresh_t8zbo') && baseColors,
        cursor: 'pointer',
        height: $6a16a016cffcb4ff$var$heights[spacing],
        lineHeight: $6a16a016cffcb4ff$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $6a16a016cffcb4ff$var$singleIconPadding[spacing] : $6a16a016cffcb4ff$var$padding[spacing],
        verticalAlign: $6a16a016cffcb4ff$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center',
        // Note: we cannot disable pointer events when there is an overlay.
        // That would be easy for styling, but it would start letting events through on disabled buttons
        ...!(0, $XHGTv.fg)('platform.design-system-team.component-visual-refresh_t8zbo') && {
            // Disabling visited styles (just using the base colors)
            '&:visited': {
                ...baseColors
            },
            '&:hover': {
                ...$6a16a016cffcb4ff$var$getColors({
                    appearance: appearance,
                    key: isSelected ? 'selected' : 'hover',
                    mode: mode
                }),
                textDecoration: !isSelected && (appearance === 'link' || appearance === 'subtle-link') ? 'underline' : 'inherit',
                // background, box-shadow
                transitionDuration: '0s, 0.15s'
            },
            // giving active styles preference by listing them after focus
            '&:active': {
                ...$6a16a016cffcb4ff$var$getColors({
                    appearance: appearance,
                    key: isSelected ? 'selected' : 'active',
                    mode: mode
                }),
                // background, box-shadow
                transitionDuration: '0s, 0s'
            },
            // preventDefault prevents regular active styles from applying in Firefox
            '&[data-firefox-is-active="true"]': {
                ...$6a16a016cffcb4ff$var$getColors({
                    appearance: appearance,
                    key: isSelected ? 'selected' : 'active',
                    mode: mode
                }),
                // background, box-shadow
                transitionDuration: '0s, 0s'
            },
            // Giving disabled styles preference over active by listing them after.
            // Not using '&:disabled' because :disabled is not a valid state for all element types
            // so we are targeting the attribute
            // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
            '&[disabled]': {
                // always using 'disabled' even when selected
                ...$6a16a016cffcb4ff$var$getColors({
                    appearance: appearance,
                    key: 'disabled',
                    mode: mode
                }),
                cursor: 'not-allowed',
                textDecoration: 'none'
            },
            ...$6a16a016cffcb4ff$var$hasOverlayStyles,
            // disabling hover and active color changes when there is an overlay, but the button is not disabled
            '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': {
                ...$6a16a016cffcb4ff$var$getColors({
                    appearance: appearance,
                    key: isSelected ? 'selected' : 'default',
                    mode: mode
                })
            }
        },
        // dynamic colours for visual refresh:
        ...(0, $XHGTv.fg)('platform.design-system-team.component-visual-refresh_t8zbo') && (isSelected ? $6a16a016cffcb4ff$var$selectedStyles : {
            ...appearance === 'default' && $6a16a016cffcb4ff$var$defaultStyles,
            ...appearance === 'primary' && $6a16a016cffcb4ff$var$primaryStyles,
            ...appearance === 'link' && $6a16a016cffcb4ff$var$linkStyles,
            ...appearance === 'subtle' && $6a16a016cffcb4ff$var$subtleStyles,
            ...appearance === 'subtle-link' && $6a16a016cffcb4ff$var$subtleLinkStyles,
            ...appearance === 'warning' && $6a16a016cffcb4ff$var$warningStyles,
            ...appearance === 'danger' && $6a16a016cffcb4ff$var$dangerStyles,
            '&[disabled]': {
                color: "var(--ds-text-disabled, #091E424F)",
                backgroundColor: $6a16a016cffcb4ff$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent',
                cursor: 'not-allowed',
                textDecoration: 'none',
                '&:hovered': {
                    backgroundColor: $6a16a016cffcb4ff$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent'
                },
                '&:active': {
                    backgroundColor: $6a16a016cffcb4ff$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent'
                }
            },
            ...$6a16a016cffcb4ff$var$hasOverlayStyles,
            // disabling hover and active color changes when there is an overlay, but the button is not disabled
            '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': {
                background: 'inherit'
            }
        }),
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    };
}
function $6a16a016cffcb4ff$export$864eea3f4ec3368f({ spacing: spacing }) {
    return (0, $byn9U.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $6a16a016cffcb4ff$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        fontSize: 0,
        lineHeight: 0,
        userSelect: 'none'
    });
}
function $6a16a016cffcb4ff$export$7ad0316cc0dd65a({ spacing: spacing }) {
    return (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $6a16a016cffcb4ff$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}
function $6a16a016cffcb4ff$export$1b5827d324e945b1({ hasOverlay: hasOverlay }) {
    return (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}
const $6a16a016cffcb4ff$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

});
parcelRegister("5JMSv", function(module, exports) {

$parcel$export(module.exports, "default", () => $42d711e5758e758b$export$2e2bcd8739ae039);

var $j0gMm = parcelRequire("j0gMm");
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
const $42d711e5758e758b$var$fadedB75 = 'rgba(179, 212, 255, 0.6)';
const $42d711e5758e758b$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: `var(--ds-background-neutral, ${$j0gMm.N20A})`,
                dark: `var(--ds-background-neutral, ${$j0gMm.DN70})`
            },
            hover: {
                light: `var(--ds-background-neutral-hovered, ${$j0gMm.N30A})`,
                dark: `var(--ds-background-neutral-hovered, ${$j0gMm.DN60})`
            },
            active: {
                light: `var(--ds-background-neutral-pressed, ${$42d711e5758e758b$var$fadedB75})`,
                dark: `var(--ds-background-neutral-pressed, ${$j0gMm.B75})`
            },
            disabled: {
                light: `var(--ds-background-disabled, ${$j0gMm.N20A})`,
                dark: `var(--ds-background-disabled, ${$j0gMm.DN70})`
            },
            selected: {
                light: `var(--ds-background-selected, ${$j0gMm.N700})`,
                dark: `var(--ds-background-selected, ${$j0gMm.DN0})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$j0gMm.N700})`,
                dark: `var(--ds-background-selected, ${$j0gMm.DN0})`
            }
        },
        primary: {
            default: {
                light: `var(--ds-background-brand-bold, ${$j0gMm.B400})`,
                dark: `var(--ds-background-brand-bold, ${$j0gMm.B100})`
            },
            hover: {
                light: `var(--ds-background-brand-bold-hovered, ${$j0gMm.B300})`,
                dark: `var(--ds-background-brand-bold-hovered, ${$j0gMm.B75})`
            },
            active: {
                light: `var(--ds-background-brand-bold-pressed, ${$j0gMm.B500})`,
                dark: `var(--ds-background-brand-bold-pressed, ${$j0gMm.B200})`
            },
            disabled: {
                light: `var(--ds-background-disabled, ${$j0gMm.N20A})`,
                dark: `var(--ds-background-disabled, ${$j0gMm.DN70})`
            },
            selected: {
                light: `var(--ds-background-selected, ${$j0gMm.N700})`,
                dark: `var(--ds-background-selected, ${$j0gMm.DN0})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$j0gMm.N700})`,
                dark: `var(--ds-background-selected, ${$j0gMm.DN0})`
            }
        },
        warning: {
            default: {
                light: `var(--ds-background-warning-bold, ${$j0gMm.Y300})`,
                dark: `var(--ds-background-warning-bold, ${$j0gMm.Y300})`
            },
            hover: {
                light: `var(--ds-background-warning-bold-hovered, ${$j0gMm.Y200})`,
                dark: `var(--ds-background-warning-bold-hovered, ${$j0gMm.Y200})`
            },
            active: {
                light: `var(--ds-background-warning-bold-pressed, ${$j0gMm.Y400})`,
                dark: `var(--ds-background-warning-bold-pressed, ${$j0gMm.Y400})`
            },
            disabled: {
                light: `var(--ds-background-disabled, ${$j0gMm.N20A})`,
                dark: `var(--ds-background-disabled, ${$j0gMm.DN70})`
            },
            selected: {
                light: `var(--ds-background-selected, ${$j0gMm.Y400})`,
                dark: `var(--ds-background-selected, ${$j0gMm.Y400})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$j0gMm.Y400})`,
                dark: `var(--ds-background-selected, ${$j0gMm.Y400})`
            }
        },
        danger: {
            default: {
                light: `var(--ds-background-danger-bold, ${$j0gMm.R400})`,
                dark: `var(--ds-background-danger-bold, ${$j0gMm.R400})`
            },
            hover: {
                light: `var(--ds-background-danger-bold-hovered, ${$j0gMm.R300})`,
                dark: `var(--ds-background-danger-bold-hovered, ${$j0gMm.R300})`
            },
            active: {
                light: `var(--ds-background-danger-bold-pressed, ${$j0gMm.R500})`,
                dark: `var(--ds-background-danger-bold-pressed, ${$j0gMm.R500})`
            },
            disabled: {
                light: `var(--ds-background-disabled, ${$j0gMm.N20A})`,
                dark: `var(--ds-background-disabled, ${$j0gMm.DN70})`
            },
            selected: {
                light: `var(--ds-background-selected, ${$j0gMm.R500})`,
                dark: `var(--ds-background-selected, ${$j0gMm.R500})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$j0gMm.R500})`,
                dark: `var(--ds-background-selected, ${$j0gMm.R500})`
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: `var(--ds-background-selected, ${$j0gMm.N700})`,
                dark: `var(--ds-background-selected, ${$j0gMm.N20})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$j0gMm.N700})`,
                dark: `var(--ds-background-selected, ${$j0gMm.N20})`
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: `var(--ds-background-neutral-subtle-hovered, ${$j0gMm.N30A})`,
                dark: `var(--ds-background-neutral-subtle-hovered, ${$j0gMm.DN60})`
            },
            active: {
                light: `var(--ds-background-neutral-subtle-pressed, ${$42d711e5758e758b$var$fadedB75})`,
                dark: `var(--ds-background-neutral-subtle-pressed, ${$j0gMm.B75})`
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: `var(--ds-background-selected, ${$j0gMm.N700})`,
                dark: `var(--ds-background-selected, ${$j0gMm.DN0})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$j0gMm.N700})`,
                dark: `var(--ds-background-selected, ${$j0gMm.DN0})`
            }
        },
        'subtle-link': {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: `var(--ds-background-selected, ${$j0gMm.N700})`,
                dark: `var(--ds-background-selected, ${$j0gMm.N20})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$j0gMm.N700})`,
                dark: `var(--ds-background-selected, ${$j0gMm.N20})`
            }
        }
    },
    color: {
        default: {
            default: {
                light: `var(--ds-text, ${$j0gMm.N500})`,
                dark: `var(--ds-text, ${$j0gMm.DN400})`
            },
            active: {
                light: `var(--ds-text, ${$j0gMm.B400})`,
                dark: `var(--ds-text, ${$j0gMm.B400})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$j0gMm.N70})`,
                dark: `var(--ds-text-disabled, ${$j0gMm.DN30})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$j0gMm.N20})`,
                dark: `var(--ds-text-selected, ${$j0gMm.DN400})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$j0gMm.N20})`,
                dark: `var(--ds-text-selected, ${$j0gMm.DN400})`
            }
        },
        primary: {
            default: {
                light: `var(--ds-text-inverse, ${$j0gMm.N0})`,
                dark: `var(--ds-text-inverse, ${$j0gMm.DN30})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$j0gMm.N70})`,
                dark: `var(--ds-text-disabled, ${$j0gMm.DN30})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$j0gMm.N20})`,
                dark: `var(--ds-text-selected, ${$j0gMm.DN400})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$j0gMm.N20})`,
                dark: `var(--ds-text-selected, ${$j0gMm.DN400})`
            }
        },
        warning: {
            default: {
                light: `var(--ds-text-warning-inverse, ${$j0gMm.N800})`,
                dark: `var(--ds-text-warning-inverse, ${$j0gMm.N800})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$j0gMm.N70})`,
                dark: `var(--ds-text-disabled, ${$j0gMm.DN30})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$j0gMm.N800})`,
                dark: `var(--ds-text-selected, ${$j0gMm.N800})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$j0gMm.N800})`,
                dark: `var(--ds-text-selected, ${$j0gMm.N800})`
            }
        },
        danger: {
            default: {
                light: `var(--ds-text-inverse, ${$j0gMm.N0})`,
                dark: `var(--ds-text-inverse, ${$j0gMm.N0})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$j0gMm.N70})`,
                dark: `var(--ds-text-disabled, ${$j0gMm.DN30})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$j0gMm.N0})`,
                dark: `var(--ds-text-selected, ${$j0gMm.N0})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$j0gMm.N0})`,
                dark: `var(--ds-text-selected, ${$j0gMm.N0})`
            }
        },
        link: {
            default: {
                light: `var(--ds-link, ${$j0gMm.B400})`,
                dark: `var(--ds-link, ${$j0gMm.B100})`
            },
            hover: {
                light: `var(--ds-link, ${$j0gMm.B300})`,
                dark: `var(--ds-link, ${$j0gMm.B75})`
            },
            active: {
                light: `var(--ds-link-pressed, ${$j0gMm.B500})`,
                dark: `var(--ds-link-pressed, ${$j0gMm.B200})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$j0gMm.N70})`,
                dark: `var(--ds-text-disabled, ${$j0gMm.DN100})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$j0gMm.N20})`,
                dark: `var(--ds-text-selected, ${$j0gMm.N700})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$j0gMm.N20})`,
                dark: `var(--ds-text-selected, ${$j0gMm.N700})`
            }
        },
        subtle: {
            default: {
                light: `var(--ds-text, ${$j0gMm.N500})`,
                dark: `var(--ds-text, ${$j0gMm.DN400})`
            },
            active: {
                light: `var(--ds-text, ${$j0gMm.B400})`,
                dark: `var(--ds-text, ${$j0gMm.B400})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$j0gMm.N70})`,
                dark: `var(--ds-text-disabled, ${$j0gMm.DN100})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$j0gMm.N20})`,
                dark: `var(--ds-text-selected, ${$j0gMm.DN400})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$j0gMm.N20})`,
                dark: `var(--ds-text-selected, ${$j0gMm.DN400})`
            }
        },
        'subtle-link': {
            default: {
                light: `var(--ds-text-subtle, ${$j0gMm.N200})`,
                dark: `var(--ds-text-subtle, ${$j0gMm.DN400})`
            },
            hover: {
                light: `var(--ds-text-subtle, ${$j0gMm.N90})`,
                dark: `var(--ds-text-subtle, ${$j0gMm.B50})`
            },
            active: {
                light: `var(--ds-text, ${$j0gMm.N400})`,
                dark: `var(--ds-text, ${$j0gMm.DN300})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$j0gMm.N70})`,
                dark: `var(--ds-text-disabled, ${$j0gMm.DN100})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$j0gMm.N20})`,
                dark: `var(--ds-text-selected, ${$j0gMm.DN400})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$j0gMm.N20})`,
                dark: `var(--ds-text-selected, ${$j0gMm.DN400})`
            }
        }
    }
};
var $42d711e5758e758b$export$2e2bcd8739ae039 = $42d711e5758e758b$var$values;

});


parcelRegister("gp7Z4", function(module, exports) {

$parcel$export(module.exports, "getIfVisuallyHiddenChildren", () => $bf152c964bbefff2$export$20bbd2efb0d734c4);

var $eUqFw = parcelRequire("eUqFw");

var $lkPEe = parcelRequire("lkPEe");
const $bf152c964bbefff2$export$20bbd2efb0d734c4 = (children)=>{
    return children && /*#__PURE__*/ (0, $eUqFw.isValidElement)(children) && children.type === (0, $lkPEe.default);
};

});


parcelRegister("i8QFr", function(module, exports) {

$parcel$export(module.exports, "default", () => $d351d3f9e19f85a3$export$2e2bcd8739ae039);

var $gp7Z4 = parcelRequire("gp7Z4");
function $d351d3f9e19f85a3$export$2e2bcd8739ae039({ children: children, iconBefore: iconBefore, iconAfter: iconAfter }) {
    if ((0, $gp7Z4.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});



parcelRegister("9osuT", function(module, exports) {

$parcel$export(module.exports, "withAnalytics", () => $6d6c75e3b31068d4$export$af9baadf0e4f6e13);
$parcel$export(module.exports, "useAnalyticsEvents", () => $6d6c75e3b31068d4$export$5bf35293e545f20c);

var $kU09D = parcelRequire("kU09D");

var $5zQU9 = parcelRequire("5zQU9");

var $bFzGY = parcelRequire("bFzGY");
var $2jDha = parcelRequire("2jDha");

var $eUqFw = parcelRequire("eUqFw");
function $6d6c75e3b31068d4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6d6c75e3b31068d4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6d6c75e3b31068d4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6d6c75e3b31068d4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6d6c75e3b31068d4$export$af9baadf0e4f6e13(BaseComponent) {
    function HOCComponent(props) {
        const fireAnalyticsEvent = (prop)=>{
            return function(payload) {
                let channel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'marketplace';
                return prop.createAnalyticsEvent($6d6c75e3b31068d4$var$_objectSpread({}, payload)).fire(channel);
            };
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(BaseComponent, (0, $kU09D.default)({}, props, {
            fireAnalyticsEvent: fireAnalyticsEvent(props)
        }));
    }
    return (0, $2jDha.default)()(HOCComponent);
}
const $6d6c75e3b31068d4$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleAnalyticsEvent = function handleAnalyticsEvent(payload) {
        let channel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'marketplace';
        createAnalyticsEvent($6d6c75e3b31068d4$var$_objectSpread({}, payload)).fire(channel);
    };
    return handleAnalyticsEvent;
};

});

parcelRegister("5YKni", function(module, exports) {

$parcel$export(module.exports, "EVENT_CHANNEL", () => $45a6876c6afbbcae$export$3f072f06b90c3985);
$parcel$export(module.exports, "EVENT_SOURCE", () => $45a6876c6afbbcae$export$ad44d4a0591d8dba);
$parcel$export(module.exports, "ANALYTICS_EVENT_SOURCE_APP_TILE", () => $45a6876c6afbbcae$export$c0d95cba1328281f);
$parcel$export(module.exports, "OBJECT_TYPE_APP", () => $45a6876c6afbbcae$export$3447b6239ae57ddd);
$parcel$export(module.exports, "OBJECT_TYPE_FILTER", () => $45a6876c6afbbcae$export$5905e5171c9f2f40);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_COLLECTION_VIEW_MORE_LINK", () => $45a6876c6afbbcae$export$7f88c9ee14d66e0);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_STANDARD_TEXT_SEARCH", () => $45a6876c6afbbcae$export$51bbb2ceb2c4ced8);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MOBILE_DROPDOWN_MENU_APPLY_BUTTON", () => $45a6876c6afbbcae$export$84c5cf81a5e0304a);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MOBILE_DROPDOWN_TOGGLE_BUTTON", () => $45a6876c6afbbcae$export$61eefd3744bff60d);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_SEARCH_RESULTS_LOAD_MORE_BUTTON", () => $45a6876c6afbbcae$export$f69ce01328abf193);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_TOPBAR_FACET_FILTER", () => $45a6876c6afbbcae$export$58f7a306966c5bd0);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_SIDEBAR_FACET_FILTER", () => $45a6876c6afbbcae$export$959c0b270f8b1f8f);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_TILE_CATEGORY_FILTER", () => $45a6876c6afbbcae$export$92135508c9017260);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_CURRENT_FILTER_X_REMOVE_ICON", () => $45a6876c6afbbcae$export$f6872a52104678ed);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_TOPBAR_FACET", () => $45a6876c6afbbcae$export$ab7453ac757dacc9);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_SIDEBAR_FACET", () => $45a6876c6afbbcae$export$93db890f8d9684f);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_COLLECTION_TILE", () => $45a6876c6afbbcae$export$87b79657bc96eff0);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_DISCOVER_TILES", () => $45a6876c6afbbcae$export$23fcac335494955c);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_SEARCH_TILES", () => $45a6876c6afbbcae$export$360bd94af1885bc7);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_HIT", () => $45a6876c6afbbcae$export$37779239347ba832);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_RIGHT_CLICK_HIT", () => $45a6876c6afbbcae$export$5a290d8d68e9fd69);
$parcel$export(module.exports, "ButtonClickedEvent", () => $45a6876c6afbbcae$export$17f5c589a3d47ee0);
$parcel$export(module.exports, "FacetCollapsedEvent", () => $45a6876c6afbbcae$export$4dfc9f322ac27c10);
$parcel$export(module.exports, "FacetExpandedEvent", () => $45a6876c6afbbcae$export$f641b6c08ddea7b0);
$parcel$export(module.exports, "LinkClickedEvent", () => $45a6876c6afbbcae$export$12ddebffbf3b4da1);
$parcel$export(module.exports, "TileClickedEvent", () => $45a6876c6afbbcae$export$140af44fcdb541fc);
$parcel$export(module.exports, "TilesRenderedEvent", () => $45a6876c6afbbcae$export$a0ce8ac2d8f9789f);
$parcel$export(module.exports, "default", () => $45a6876c6afbbcae$export$2e2bcd8739ae039);
// IMPORTANT!!
//
// To add a new analytics event, you MUST:
// 1) Add a const below representing the event's action, actionSubject, and details
// 2) Add the const from step 1 to the default export
//
// If you skip any step, you will cause issues for the consumer, because they will not
// have any way to query this event.

var $gaiog = parcelRequire("gaiog");
var $lNaxt = parcelRequire("lNaxt");

var $g5DHJ = parcelRequire("g5DHJ");
const $45a6876c6afbbcae$export$3f072f06b90c3985 = 'addonDiscovery';
const $45a6876c6afbbcae$export$ad44d4a0591d8dba = 'addonDiscovery';
const $45a6876c6afbbcae$export$c0d95cba1328281f = 'appTile';
const $45a6876c6afbbcae$export$3447b6239ae57ddd = 'app';
const $45a6876c6afbbcae$export$5905e5171c9f2f40 = 'filter';
// Analytics Action Subjects
const $45a6876c6afbbcae$var$ANALYTICS_SUBJECT_FACET = 'facet';
const $45a6876c6afbbcae$var$ANALYTICS_SUBJECT_TILE = 'tile';
const $45a6876c6afbbcae$var$ANALYTICS_SUBJECT_TILES = 'tiles';
const $45a6876c6afbbcae$export$7f88c9ee14d66e0 = 'collectionViewMoreLink';
const $45a6876c6afbbcae$export$51bbb2ceb2c4ced8 = 'standardTextSearch';
const $45a6876c6afbbcae$export$84c5cf81a5e0304a = 'mobileDropdownMenuApplyButton';
const $45a6876c6afbbcae$export$61eefd3744bff60d = 'mobileDropdownToggleButton';
const $45a6876c6afbbcae$export$f69ce01328abf193 = 'searchResultsLoadMoreButton';
const $45a6876c6afbbcae$export$58f7a306966c5bd0 = 'topbarFacetFilter';
const $45a6876c6afbbcae$export$959c0b270f8b1f8f = 'sidebarFacetFilter';
const $45a6876c6afbbcae$export$92135508c9017260 = 'tileCategoryFilter';
const $45a6876c6afbbcae$export$f6872a52104678ed = 'currentFilterXRemoveIcon';
const $45a6876c6afbbcae$export$ab7453ac757dacc9 = 'topbarFacet';
const $45a6876c6afbbcae$export$93db890f8d9684f = 'sidebarFacet';
const $45a6876c6afbbcae$export$87b79657bc96eff0 = 'collectionTile';
const $45a6876c6afbbcae$export$23fcac335494955c = 'discoverTiles';
const $45a6876c6afbbcae$export$360bd94af1885bc7 = 'searchTiles';
const $45a6876c6afbbcae$export$37779239347ba832 = 'hit';
const $45a6876c6afbbcae$export$5a290d8d68e9fd69 = 'rightHit';
const $45a6876c6afbbcae$export$17f5c589a3d47ee0 = {
    action: (0, $gaiog.ANALYTICS_ACTION_CLICKED),
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_BUTTON),
    details: 'User clicked a button',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $45a6876c6afbbcae$export$4dfc9f322ac27c10 = {
    action: (0, $gaiog.ANALYTICS_ACTION_COLLAPSED),
    actionSubject: $45a6876c6afbbcae$var$ANALYTICS_SUBJECT_FACET,
    details: 'User has collapsed a search facet',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $45a6876c6afbbcae$export$f641b6c08ddea7b0 = {
    action: (0, $gaiog.ANALYTICS_ACTION_EXPANDED),
    actionSubject: $45a6876c6afbbcae$var$ANALYTICS_SUBJECT_FACET,
    details: 'User has expanded a search facet',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $45a6876c6afbbcae$export$12ddebffbf3b4da1 = {
    action: (0, $gaiog.ANALYTICS_ACTION_CLICKED),
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_LINK),
    details: 'User clicked a link',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $45a6876c6afbbcae$export$140af44fcdb541fc = {
    action: (0, $gaiog.ANALYTICS_ACTION_CLICKED),
    actionSubject: $45a6876c6afbbcae$var$ANALYTICS_SUBJECT_TILE,
    details: 'User clicked a tile',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $45a6876c6afbbcae$export$1f3e456d736fa1ca = {
    action: (0, $gaiog.ANALYTICS_ACTION_RENDERED),
    actionSubject: $45a6876c6afbbcae$var$ANALYTICS_SUBJECT_TILE,
    details: 'A Marketplace app tile was rendered and is now visible to the user',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $45a6876c6afbbcae$export$a0ce8ac2d8f9789f = {
    action: (0, $gaiog.ANALYTICS_ACTION_RENDERED),
    actionSubject: $45a6876c6afbbcae$var$ANALYTICS_SUBJECT_TILES,
    details: 'Marketplace app tiles were rendered and are now visible to the user',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
var $45a6876c6afbbcae$export$2e2bcd8739ae039 = (0, $g5DHJ.List)([
    $45a6876c6afbbcae$export$17f5c589a3d47ee0,
    $45a6876c6afbbcae$export$4dfc9f322ac27c10,
    $45a6876c6afbbcae$export$f641b6c08ddea7b0,
    $45a6876c6afbbcae$export$12ddebffbf3b4da1,
    $45a6876c6afbbcae$export$140af44fcdb541fc,
    $45a6876c6afbbcae$export$1f3e456d736fa1ca,
    $45a6876c6afbbcae$export$a0ce8ac2d8f9789f,
    (0, $gaiog.FilterClickedEvent)
]);

});
parcelRegister("gaiog", function(module, exports) {

$parcel$export(module.exports, "makeEventContainer", () => $bc4bd871465bb41c$export$6f3dfcfde2a26c23);
$parcel$export(module.exports, "EVENT_CONTAINER_CLOUD_FORTIFIED_INFO_MODAL", () => $bc4bd871465bb41c$export$ab846e0a50e2a2f7);
$parcel$export(module.exports, "EVENT_CONTAINER_CLOUD_FORTIFIED_TOOLTIP", () => $bc4bd871465bb41c$export$9b6461c33e3d2a74);
$parcel$export(module.exports, "EVENT_CONTAINER_CERTIFICATION_SECTION", () => $bc4bd871465bb41c$export$bd2524a30eaf04e7);
$parcel$export(module.exports, "EVENT_CONTAINER_APPLISTING_SCREEN", () => $bc4bd871465bb41c$export$4bc4b1926fda6c51);
$parcel$export(module.exports, "EVENT_CONTAINER_SUPPORT_APPLISTING_TAB", () => $bc4bd871465bb41c$export$473571ee36f54def);
$parcel$export(module.exports, "makeAnalyticsAction", () => $bc4bd871465bb41c$export$4859a05fe90e78fe);
$parcel$export(module.exports, "ANALYTICS_ACTION_CLICKED", () => $bc4bd871465bb41c$export$c7a8bc68d822f729);
$parcel$export(module.exports, "ANALYTICS_ACTION_COLLAPSED", () => $bc4bd871465bb41c$export$afa7a066ba6e8212);
$parcel$export(module.exports, "ANALYTICS_ACTION_EXPANDED", () => $bc4bd871465bb41c$export$a5b9d8afa6e5173d);
$parcel$export(module.exports, "ANALYTICS_ACTION_FETCH_FAILED", () => $bc4bd871465bb41c$export$d46f53f6e9d0c675);
$parcel$export(module.exports, "ANALYTICS_ACTION_REMOVED", () => $bc4bd871465bb41c$export$a48c0b3ec8978236);
$parcel$export(module.exports, "ANALYTICS_ACTION_REMOVE_FAILED", () => $bc4bd871465bb41c$export$bfeff6b6f5f68025);
$parcel$export(module.exports, "ANALYTICS_ACTION_RENDERED", () => $bc4bd871465bb41c$export$e6ff11761cb083ce);
$parcel$export(module.exports, "ANALYTICS_ACTION_CHANGED", () => $bc4bd871465bb41c$export$6b270c18231f6695);
$parcel$export(module.exports, "makeAnalyticsActionSubject", () => $bc4bd871465bb41c$export$d4e5825945a3cdda);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_APP", () => $bc4bd871465bb41c$export$c52d8f46dfbf2dbd);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_BUTTON", () => $bc4bd871465bb41c$export$e416b27154b468db);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_LINK", () => $bc4bd871465bb41c$export$ea9f82a04bb0c5a6);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_TILES", () => $bc4bd871465bb41c$export$84007be1e3689955);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_UI", () => $bc4bd871465bb41c$export$7d8b518bcf85a1d1);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_IMAGE", () => $bc4bd871465bb41c$export$92bc2c5a9eecf3e8);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_IMAGE_LINK", () => $bc4bd871465bb41c$export$ff7b08d6eeeefff8);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_APP_DOCUMENTATION_LINK", () => $bc4bd871465bb41c$export$24a8c739518b831b);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_APP_FORUMS_LINK", () => $bc4bd871465bb41c$export$b230e89140cf55ed);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_APP_STATUS_PAGE_LINK", () => $bc4bd871465bb41c$export$5312a593452aafaf);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_APP_ISSUE_TRACKER_LINK", () => $bc4bd871465bb41c$export$269c3ac827ccca4);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_COMMUNITY_QUESTION_LINK", () => $bc4bd871465bb41c$export$a47a806019d7c6e1);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_SUPPORT_TICKET_LINK", () => $bc4bd871465bb41c$export$8cf343804eb3c603);
$parcel$export(module.exports, "makeAnalyticsCategory", () => $bc4bd871465bb41c$export$7805576a5ac813be);
$parcel$export(module.exports, "ButtonClickedEvent", () => $bc4bd871465bb41c$export$17f5c589a3d47ee0);
$parcel$export(module.exports, "ImageClickedEvent", () => $bc4bd871465bb41c$export$12c476215d2a57f9);
$parcel$export(module.exports, "LinkClickedEvent", () => $bc4bd871465bb41c$export$12ddebffbf3b4da1);
$parcel$export(module.exports, "TextFieldBlurEvent", () => $bc4bd871465bb41c$export$3c2219e2206e58b);
$parcel$export(module.exports, "TileClickedEvent", () => $bc4bd871465bb41c$export$140af44fcdb541fc);
$parcel$export(module.exports, "MenuItemClickedEvent", () => $bc4bd871465bb41c$export$13221a3b471c7ff5);
$parcel$export(module.exports, "BreadcrumbClickedEvent", () => $bc4bd871465bb41c$export$c6143a15227d967d);
$parcel$export(module.exports, "SearchSubmittedEvent", () => $bc4bd871465bb41c$export$574ad81d49991481);
$parcel$export(module.exports, "FilterClickedEvent", () => $bc4bd871465bb41c$export$1bc924770e976d12);
$parcel$export(module.exports, "TabClickedEvent", () => $bc4bd871465bb41c$export$484fdf4eeab12e86);
$parcel$export(module.exports, "ModalRenderedEvent", () => $bc4bd871465bb41c$export$8aa882460238b456);
$parcel$export(module.exports, "TooltipViewedEvent", () => $bc4bd871465bb41c$export$368aeee6baccc0e0);
$parcel$export(module.exports, "SearchOverlayViewEvent", () => $bc4bd871465bb41c$export$eef4c4c219985794);
$parcel$export(module.exports, "SearchOverlaySuggestionClickEvent", () => $bc4bd871465bb41c$export$95c08a8a1d00d5d9);
$parcel$export(module.exports, "SearchOverlayEnterKeyEvent", () => $bc4bd871465bb41c$export$5f2ac52054ff0703);
$parcel$export(module.exports, "SearchEmbeddedViewEvent", () => $bc4bd871465bb41c$export$3b5c1a8abac22038);
$parcel$export(module.exports, "SearchEmbeddedSuggestionClickEvent", () => $bc4bd871465bb41c$export$835e2ca6154629af);
$parcel$export(module.exports, "TilesRenderedEvent", () => $bc4bd871465bb41c$export$a0ce8ac2d8f9789f);
$parcel$export(module.exports, "SearchEmbeddedEnterKeyEvent", () => $bc4bd871465bb41c$export$f015ff8244e789d5);
$parcel$export(module.exports, "ClearFilterEvent", () => $bc4bd871465bb41c$export$15a0a93c7224b959);
$parcel$export(module.exports, "ErrorStateEvent", () => $bc4bd871465bb41c$export$3024be86a7637e37);
// Analytics Actions

var $eqVJB = parcelRequire("eqVJB");

var $lNaxt = parcelRequire("lNaxt");
const $bc4bd871465bb41c$export$6f3dfcfde2a26c23 = (v)=>v;
const $bc4bd871465bb41c$export$ab846e0a50e2a2f7 = $bc4bd871465bb41c$export$6f3dfcfde2a26c23('cloudFortifiedInfoModal');
const $bc4bd871465bb41c$export$9b6461c33e3d2a74 = $bc4bd871465bb41c$export$6f3dfcfde2a26c23('cloudFortifiedTooltip');
const $bc4bd871465bb41c$export$bd2524a30eaf04e7 = $bc4bd871465bb41c$export$6f3dfcfde2a26c23('certificationSection');
const $bc4bd871465bb41c$export$81880ccc80ea713d = $bc4bd871465bb41c$export$6f3dfcfde2a26c23('homeScreen');
const $bc4bd871465bb41c$export$8cc795b5314dd424 = $bc4bd871465bb41c$export$6f3dfcfde2a26c23('collectionsScreen');
const $bc4bd871465bb41c$export$4bc4b1926fda6c51 = $bc4bd871465bb41c$export$6f3dfcfde2a26c23('appListingScreen');
const $bc4bd871465bb41c$export$473571ee36f54def = $bc4bd871465bb41c$export$6f3dfcfde2a26c23('supportAppListingTab');
const $bc4bd871465bb41c$export$4859a05fe90e78fe = (v)=>v;
const $bc4bd871465bb41c$export$c7a8bc68d822f729 = $bc4bd871465bb41c$export$4859a05fe90e78fe('clicked');
const $bc4bd871465bb41c$export$afa7a066ba6e8212 = $bc4bd871465bb41c$export$4859a05fe90e78fe('collapsed');
const $bc4bd871465bb41c$export$a5b9d8afa6e5173d = $bc4bd871465bb41c$export$4859a05fe90e78fe('expanded');
const $bc4bd871465bb41c$export$d46f53f6e9d0c675 = $bc4bd871465bb41c$export$4859a05fe90e78fe('fetchFailed');
const $bc4bd871465bb41c$export$a48c0b3ec8978236 = $bc4bd871465bb41c$export$4859a05fe90e78fe('removed');
const $bc4bd871465bb41c$export$bfeff6b6f5f68025 = $bc4bd871465bb41c$export$4859a05fe90e78fe('removeFailed');
const $bc4bd871465bb41c$export$e6ff11761cb083ce = $bc4bd871465bb41c$export$4859a05fe90e78fe('rendered');
const $bc4bd871465bb41c$export$a96187c6d64d9f94 = $bc4bd871465bb41c$export$4859a05fe90e78fe('submitted');
const $bc4bd871465bb41c$export$6b270c18231f6695 = $bc4bd871465bb41c$export$4859a05fe90e78fe('changed');
const $bc4bd871465bb41c$export$34804d491cd2e7c9 = $bc4bd871465bb41c$export$4859a05fe90e78fe('toggled');
const $bc4bd871465bb41c$export$e52f895ec237339d = $bc4bd871465bb41c$export$4859a05fe90e78fe('blurred');
const $bc4bd871465bb41c$export$db23786aad95018a = $bc4bd871465bb41c$export$4859a05fe90e78fe('viewed');
const $bc4bd871465bb41c$export$cc8e7fae1116fc7b = $bc4bd871465bb41c$export$4859a05fe90e78fe('entered');
const $bc4bd871465bb41c$export$d4e5825945a3cdda = (v)=>v;
const $bc4bd871465bb41c$export$854041e05049ffd3 = $bc4bd871465bb41c$export$d4e5825945a3cdda('formField');
const $bc4bd871465bb41c$export$c52d8f46dfbf2dbd = $bc4bd871465bb41c$export$d4e5825945a3cdda('app');
const $bc4bd871465bb41c$export$dfa59625382b09c7 = $bc4bd871465bb41c$export$d4e5825945a3cdda('breadcrumb');
const $bc4bd871465bb41c$export$e416b27154b468db = $bc4bd871465bb41c$export$d4e5825945a3cdda('button');
const $bc4bd871465bb41c$export$ea9f82a04bb0c5a6 = $bc4bd871465bb41c$export$d4e5825945a3cdda('link');
const $bc4bd871465bb41c$export$7c5ceefc025e6114 = $bc4bd871465bb41c$export$d4e5825945a3cdda('menu');
const $bc4bd871465bb41c$export$27511148c59b417 = $bc4bd871465bb41c$export$d4e5825945a3cdda('menuItem');
const $bc4bd871465bb41c$export$ed02ca6faedaddbc = $bc4bd871465bb41c$export$d4e5825945a3cdda('tab');
const $bc4bd871465bb41c$export$80226708124d0f9 = $bc4bd871465bb41c$export$d4e5825945a3cdda('lozenge');
const $bc4bd871465bb41c$export$5b9593189ff4ac2c = $bc4bd871465bb41c$export$d4e5825945a3cdda('tile');
const $bc4bd871465bb41c$export$84007be1e3689955 = $bc4bd871465bb41c$export$d4e5825945a3cdda('tiles');
const $bc4bd871465bb41c$export$7d8b518bcf85a1d1 = $bc4bd871465bb41c$export$d4e5825945a3cdda('ui');
const $bc4bd871465bb41c$export$d21f0ec946449799 = $bc4bd871465bb41c$export$d4e5825945a3cdda('search');
const $bc4bd871465bb41c$export$8372f7a903a3e882 = $bc4bd871465bb41c$export$d4e5825945a3cdda('filter');
const $bc4bd871465bb41c$export$b5beeddca34af740 = $bc4bd871465bb41c$export$d4e5825945a3cdda('sort');
const $bc4bd871465bb41c$export$7914c2967253beb2 = $bc4bd871465bb41c$export$4859a05fe90e78fe('radioButton');
const $bc4bd871465bb41c$export$e17d600e77461f28 = $bc4bd871465bb41c$export$d4e5825945a3cdda('textField');
const $bc4bd871465bb41c$export$693afa5826a27336 = $bc4bd871465bb41c$export$d4e5825945a3cdda('pageNotFound');
const $bc4bd871465bb41c$export$1990eb2a6896738f = $bc4bd871465bb41c$export$d4e5825945a3cdda('modal');
const $bc4bd871465bb41c$export$f6de073840adcdec = $bc4bd871465bb41c$export$d4e5825945a3cdda('rowItem');
const $bc4bd871465bb41c$export$754b7bb056ca55bc = $bc4bd871465bb41c$export$d4e5825945a3cdda('checkbox');
const $bc4bd871465bb41c$export$67e91a0457e9466b = $bc4bd871465bb41c$export$d4e5825945a3cdda('banner');
const $bc4bd871465bb41c$export$27ffada7d4695dc6 = $bc4bd871465bb41c$export$d4e5825945a3cdda('tooltip');
const $bc4bd871465bb41c$export$fc86e2bd1ade636d = $bc4bd871465bb41c$export$d4e5825945a3cdda('discoverTile');
const $bc4bd871465bb41c$export$5dc1597cf4b6c0c7 = $bc4bd871465bb41c$export$d4e5825945a3cdda('collectionTile');
const $bc4bd871465bb41c$export$92bc2c5a9eecf3e8 = $bc4bd871465bb41c$export$d4e5825945a3cdda('image');
const $bc4bd871465bb41c$export$ff7b08d6eeeefff8 = $bc4bd871465bb41c$export$d4e5825945a3cdda('imageLink');
const $bc4bd871465bb41c$export$24a8c739518b831b = $bc4bd871465bb41c$export$d4e5825945a3cdda('appDocumentationLink');
const $bc4bd871465bb41c$export$b230e89140cf55ed = $bc4bd871465bb41c$export$d4e5825945a3cdda('appForumsLink');
const $bc4bd871465bb41c$export$5312a593452aafaf = $bc4bd871465bb41c$export$d4e5825945a3cdda('statusPageLink');
const $bc4bd871465bb41c$export$269c3ac827ccca4 = $bc4bd871465bb41c$export$d4e5825945a3cdda('issueTrackerLink');
const $bc4bd871465bb41c$export$a47a806019d7c6e1 = $bc4bd871465bb41c$export$d4e5825945a3cdda('communityQuestionLink');
const $bc4bd871465bb41c$export$8cf343804eb3c603 = $bc4bd871465bb41c$export$d4e5825945a3cdda('supportRequestLink');
const $bc4bd871465bb41c$export$bcfbaf5a28647621 = $bc4bd871465bb41c$export$d4e5825945a3cdda('searchOverlay');
const $bc4bd871465bb41c$export$f49811924c23f531 = $bc4bd871465bb41c$export$d4e5825945a3cdda('searchEmbedded');
const $bc4bd871465bb41c$export$2c845c02055cfe32 = $bc4bd871465bb41c$export$d4e5825945a3cdda('error');
const $bc4bd871465bb41c$export$2dfd3d1dcf2c7652 = $bc4bd871465bb41c$export$d4e5825945a3cdda('navigationItem');
const $bc4bd871465bb41c$export$292cd545f4464697 = $bc4bd871465bb41c$export$d4e5825945a3cdda('screenViewed');
const $bc4bd871465bb41c$export$7805576a5ac813be = (v)=>v;
const $bc4bd871465bb41c$export$17f5c589a3d47ee0 = {
    action: $bc4bd871465bb41c$export$c7a8bc68d822f729,
    actionSubject: $bc4bd871465bb41c$export$e416b27154b468db,
    details: 'User clicked a button',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$12c476215d2a57f9 = {
    action: $bc4bd871465bb41c$export$c7a8bc68d822f729,
    actionSubject: $bc4bd871465bb41c$export$92bc2c5a9eecf3e8,
    details: 'User clicked a image',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$12ddebffbf3b4da1 = {
    action: $bc4bd871465bb41c$export$c7a8bc68d822f729,
    actionSubject: $bc4bd871465bb41c$export$ea9f82a04bb0c5a6,
    details: 'User clicked a link',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$3c2219e2206e58b = {
    action: $bc4bd871465bb41c$export$e52f895ec237339d,
    actionSubject: $bc4bd871465bb41c$export$e17d600e77461f28,
    details: 'User clicked away from the text field',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$592238d52ca28e8d = {
    action: $bc4bd871465bb41c$export$34804d491cd2e7c9,
    actionSubject: $bc4bd871465bb41c$export$7914c2967253beb2,
    details: 'User toggled a radio option',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$140af44fcdb541fc = {
    action: $bc4bd871465bb41c$export$c7a8bc68d822f729,
    actionSubject: $bc4bd871465bb41c$export$5b9593189ff4ac2c,
    details: 'User clicked a tile',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$20dbd94f06494a41 = {
    action: $bc4bd871465bb41c$export$a5b9d8afa6e5173d,
    actionSubject: $bc4bd871465bb41c$export$7c5ceefc025e6114,
    details: 'User expanded a menu',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$13221a3b471c7ff5 = {
    action: $bc4bd871465bb41c$export$c7a8bc68d822f729,
    actionSubject: $bc4bd871465bb41c$export$27511148c59b417,
    details: 'User clicked a menu item',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$c6143a15227d967d = {
    action: $bc4bd871465bb41c$export$c7a8bc68d822f729,
    actionSubject: $bc4bd871465bb41c$export$dfa59625382b09c7,
    details: 'User clicked a breadcrumb item',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$574ad81d49991481 = {
    action: $bc4bd871465bb41c$export$a96187c6d64d9f94,
    actionSubject: $bc4bd871465bb41c$export$d21f0ec946449799,
    details: 'When a search input is submitted',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$1bc924770e976d12 = {
    action: $bc4bd871465bb41c$export$c7a8bc68d822f729,
    actionSubject: $bc4bd871465bb41c$export$8372f7a903a3e882,
    details: 'User has selected a filter for the app search',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$484fdf4eeab12e86 = {
    action: $bc4bd871465bb41c$export$c7a8bc68d822f729,
    actionSubject: $bc4bd871465bb41c$export$ed02ca6faedaddbc,
    details: 'User clicked a tab',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$1b1fb2b1e7140655 = {
    action: $bc4bd871465bb41c$export$c7a8bc68d822f729,
    actionSubject: $bc4bd871465bb41c$export$80226708124d0f9,
    details: 'User clicked a lozenge',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$8459b73933570c5b = {
    action: $bc4bd871465bb41c$export$e6ff11761cb083ce,
    actionSubject: $bc4bd871465bb41c$export$693afa5826a27336,
    details: 'User landed on a not found page',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$8aa882460238b456 = {
    action: $bc4bd871465bb41c$export$e6ff11761cb083ce,
    actionSubject: $bc4bd871465bb41c$export$1990eb2a6896738f,
    details: 'User opened a Modal',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$5d2f57e0f5e426a0 = {
    action: $bc4bd871465bb41c$export$c7a8bc68d822f729,
    actionSubject: $bc4bd871465bb41c$export$754b7bb056ca55bc,
    details: 'User clicked a checkbox',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$2736b9cdccb89154 = {
    action: $bc4bd871465bb41c$export$db23786aad95018a,
    actionSubject: $bc4bd871465bb41c$export$67e91a0457e9466b,
    details: 'User viewed a banner',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$368aeee6baccc0e0 = {
    action: $bc4bd871465bb41c$export$db23786aad95018a,
    actionSubject: $bc4bd871465bb41c$export$27ffada7d4695dc6,
    details: 'User viewed a Tooltip',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$eef4c4c219985794 = {
    action: $bc4bd871465bb41c$export$db23786aad95018a,
    actionSubject: $bc4bd871465bb41c$export$bcfbaf5a28647621,
    details: 'User has viewed the search overlay',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$95c08a8a1d00d5d9 = {
    action: $bc4bd871465bb41c$export$c7a8bc68d822f729,
    actionSubject: $bc4bd871465bb41c$export$bcfbaf5a28647621,
    details: 'User has selected a suggestion',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$5f2ac52054ff0703 = {
    action: $bc4bd871465bb41c$export$cc8e7fae1116fc7b,
    actionSubject: $bc4bd871465bb41c$export$bcfbaf5a28647621,
    details: 'User pressed an enter key',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$3b5c1a8abac22038 = {
    action: $bc4bd871465bb41c$export$db23786aad95018a,
    actionSubject: $bc4bd871465bb41c$export$f49811924c23f531,
    details: 'User has viewed the search overlay',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$835e2ca6154629af = {
    action: $bc4bd871465bb41c$export$c7a8bc68d822f729,
    actionSubject: $bc4bd871465bb41c$export$f49811924c23f531,
    details: 'User has selected a suggestion',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$a0ce8ac2d8f9789f = {
    action: $bc4bd871465bb41c$export$e6ff11761cb083ce,
    actionSubject: $bc4bd871465bb41c$export$84007be1e3689955,
    details: 'Marketplace app tiles were rendered and are now visible to the user',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$57e303b46a8f8ad2 = {
    action: $bc4bd871465bb41c$export$c7a8bc68d822f729,
    actionSubject: $bc4bd871465bb41c$export$2dfd3d1dcf2c7652,
    details: 'User clicked a navbar item',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$f015ff8244e789d5 = {
    action: $bc4bd871465bb41c$export$cc8e7fae1116fc7b,
    actionSubject: $bc4bd871465bb41c$export$f49811924c23f531,
    details: 'User pressed an enter key',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$15a0a93c7224b959 = {
    action: $bc4bd871465bb41c$export$c7a8bc68d822f729,
    actionSubject: $bc4bd871465bb41c$export$8372f7a903a3e882,
    details: 'User has cleared a selected filter for the app search',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$3024be86a7637e37 = {
    action: $bc4bd871465bb41c$export$e6ff11761cb083ce,
    actionSubject: $bc4bd871465bb41c$export$2c845c02055cfe32,
    details: 'An error state has been rendered',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$4b1506fea14c13bf = {
    action: $bc4bd871465bb41c$export$db23786aad95018a,
    actionSubject: $bc4bd871465bb41c$export$292cd545f4464697,
    details: 'User viewed screen',
    type: (0, $eqVJB.SCREEN_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$b30d9e3d99fe197b = {
    action: $bc4bd871465bb41c$export$c7a8bc68d822f729,
    actionSubject: $bc4bd871465bb41c$export$b5beeddca34af740,
    details: 'User has selected a sort option',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};

});
parcelRegister("eqVJB", function(module, exports) {

$parcel$export(module.exports, "makeAnalyticsSourceID", () => $a8204745d0602e03$export$1223c02d6be97202);
$parcel$export(module.exports, "SCREEN_EVENT_TYPE", () => $a8204745d0602e03$export$f1d537d508d2945a);
const $a8204745d0602e03$export$1223c02d6be97202 = (v)=>v;
const $a8204745d0602e03$export$f1d537d508d2945a = 'screen';

});

parcelRegister("lNaxt", function(module, exports) {

$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => $fdd65966a4263b8f$export$12346a674644c156);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $fdd65966a4263b8f$export$947dac6c72b26f81);
$parcel$export(module.exports, "UI_EVENT_TYPE", () => $fdd65966a4263b8f$export$a1562d08625f5d7e);
$parcel$export(module.exports, "foldAnalyticsEventType", () => $fdd65966a4263b8f$export$de3afd46ec224b2f);

var $gC8Po = parcelRequire("gC8Po");
const $fdd65966a4263b8f$export$12346a674644c156 = 'operational';
const $fdd65966a4263b8f$export$947dac6c72b26f81 = 'track';
const $fdd65966a4263b8f$export$a1562d08625f5d7e = 'ui';
function $fdd65966a4263b8f$export$de3afd46ec224b2f(analyticsEventType) {
    return function foldAnalyticsEventTypeInner(track, ui, operational) {
        switch(analyticsEventType){
            case 'track':
                return track();
            case 'ui':
                return ui();
            case 'operational':
                return operational();
            default:
                throw (0, $gC8Po.default).unexpectedCase(analyticsEventType);
        }
    };
}

});
parcelRegister("gC8Po", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1870afb8d649de0$export$2e2bcd8739ae039);
/**
 * This is usually used with exhaustive union type handling
 * It provides compile time validation that we have handled all the cases in the union type
 * It also returns an error to throw which will help at runtime.
 * To know more about it : https://medium.com/@ibosz/advance-flow-type-1-exhaustive-checking-with-empty-type-a02e503cd3a0
 * @param impossible
 * @return {Error}
 */ function $c1870afb8d649de0$var$unexpectedCase(impossible) {
    return new Error("Unexpected case ".concat(impossible));
}
var $c1870afb8d649de0$export$2e2bcd8739ae039 = {
    unexpectedCase: $c1870afb8d649de0$var$unexpectedCase
};

});




const $37a31921fd56c86d$export$27b2e48e28163360 = 'discover';
const $37a31921fd56c86d$export$a6b9aaee40d49fd0 = 'search';

parcelRegister("6jEcw", function(module, exports) {

$parcel$export(module.exports, "default", () => $4993b38195ee1ef3$export$2e2bcd8739ae039);

var $fEeDC = parcelRequire("fEeDC");

var $1Qivz = parcelRequire("1Qivz");

var $fCICH = parcelRequire("fCICH");

var $gggoS = parcelRequire("gggoS");

var $isqrX = parcelRequire("isqrX");

const $4993b38195ee1ef3$var$facetType = (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
    'disjunctive',
    'conjunctive'
]);
var $4993b38195ee1ef3$export$2e2bcd8739ae039 = {
    filtersContext: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
        discoverFacetHrefResolver: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        searchFacetHrefResolver: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
    }),
    sortOption: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
        key: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
        title: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
        indexSuffix: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
        exclusions: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).map
    }),
    discoverFilters: $4993b38195ee1ef3$var$discoverFilters,
    facetType: $4993b38195ee1ef3$var$facetType,
    hiddenFilters: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains((0, $gggoS.baseFiltersPropTypeFactory)((0, $fCICH.getFilters)(), (fvt)=>fvt).map((pt)=>(0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
            (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).setOf(pt)
        ])).toJS()),
    perspective: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
        (0, $37a31921fd56c86d$export$27b2e48e28163360),
        (0, $37a31921fd56c86d$export$a6b9aaee40d49fd0)
    ]),
    processedFacet: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
        facetProducts: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).listOf((0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
            count: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
            label: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired
        })),
        key: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
        sidebarLabel: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
        topBarLabel: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
        openByDefault: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
        primary: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
        type: $4993b38195ee1ef3$var$facetType.isRequired
    })
};
function $4993b38195ee1ef3$var$discoverFilters(props) {
    for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
    return (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains((0, $gggoS.filtersPropTypeFactory)((0, $fCICH.getFilters)().filter((f)=>f.get('discoverFilter')), (f)=>f.get('requiredDiscoverFilterWhenNonEmpty') && (0, $isqrX.valuedFilters)(props.filters).size).toJS())(props, ...rest);
}

});
parcelRegister("isqrX", function(module, exports) {

$parcel$export(module.exports, "valuedFilters", () => $d6ff5bef0d7aac4e$export$7c675e3025ea0a3a);
$parcel$export(module.exports, "validateFilters", () => $d6ff5bef0d7aac4e$export$d04f997183dbc18f);
$parcel$export(module.exports, "shouldFacetBeShown", () => $d6ff5bef0d7aac4e$export$73b3d0d53f61a5d0);
$parcel$export(module.exports, "shouldFacetProductBeShown", () => $d6ff5bef0d7aac4e$export$af318335bdaeb886);
$parcel$export(module.exports, "shouldCloudForitifedFacetProductBeShown", () => $d6ff5bef0d7aac4e$export$53b632ebf0f470c9);
$parcel$export(module.exports, "shouldFreeStarterFacetProductBeShown", () => $d6ff5bef0d7aac4e$export$1659162fb5c0ed51);

var $eA9U1 = parcelRequire("eA9U1");

var $g5DHJ = parcelRequire("g5DHJ");

var $fCICH = parcelRequire("fCICH");

var $lwEMm = parcelRequire("lwEMm");
function $d6ff5bef0d7aac4e$export$7c675e3025ea0a3a(filters) {
    return filters.filter((f)=>(0, $g5DHJ.Iterable).isIterable(f) ? f.size : f);
}
const $d6ff5bef0d7aac4e$var$filtersValidator = (0, $fCICH.getFilters)().reduce((validator, f)=>{
    if (f.get('custom')) return validator.addOneOfValidator(f.get('key'), f.get('customFilters').map((cf)=>cf.get('value')).toSet(), f.get('type') === (0, $lwEMm.DISJUNCTIVE_FACET_TYPE));
    else return validator;
}, new (0, $eA9U1.default)());
function $d6ff5bef0d7aac4e$export$d04f997183dbc18f(filters) {
    return $d6ff5bef0d7aac4e$var$filtersValidator.validate(filters);
}
function $d6ff5bef0d7aac4e$export$73b3d0d53f61a5d0(facetKey, hiddenFilters) {
    return hiddenFilters.get(facetKey) !== true;
}
function $d6ff5bef0d7aac4e$export$af318335bdaeb886(facetKey, facetProductKey, hiddenFilters) {
    const hiddenFilter = hiddenFilters.get(facetKey);
    if (hiddenFilter !== undefined) return (0, $g5DHJ.Set).isSet(hiddenFilter) ? !hiddenFilter.includes(facetProductKey) : $d6ff5bef0d7aac4e$export$73b3d0d53f61a5d0(facetKey, hiddenFilters);
    else return true;
}
function $d6ff5bef0d7aac4e$export$53b632ebf0f470c9(value, enableCloudFortifiedAppsDiscovery) {
    return value !== 'cloudFortified' || enableCloudFortifiedAppsDiscovery;
}
function $d6ff5bef0d7aac4e$export$1659162fb5c0ed51(value, enableFreeStarterTierFilter) {
    return value !== 'freeStarterTier' || enableFreeStarterTierFilter;
}

});
parcelRegister("eA9U1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9dc1becfc64d1c8$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $g5DHJ = parcelRequire("g5DHJ");
function $a9dc1becfc64d1c8$var$requiredValidator(key) {
    return (queryParams)=>{
        const value = queryParams.get(key);
        if (!value || (0, $g5DHJ.isCollection)(value) && !value.size) return (0, $g5DHJ.Set)([
            "A value for '".concat(key, "' is required.")
        ]);
        return (0, $g5DHJ.Set)();
    };
}
function $a9dc1becfc64d1c8$var$oneOfValidatorHelper(value, key, inSet, state) {
    const valueSet = typeof inSet === 'function' ? inSet(state) : inSet;
    if (!valueSet.includes(value)) return (0, $g5DHJ.Set)([
        "Value '".concat(value, "' is invalid for parameter '").concat(key, "'. Acceptable values are ").concat(valueSet.map((k)=>"'".concat(k, "'")).join(', '), ".")
    ]);
    return (0, $g5DHJ.Set)();
}
function $a9dc1becfc64d1c8$var$oneOfValidator(key, inSet, multipleAllowed) {
    return (queryParams, state)=>{
        const value = queryParams.get(key);
        if (!value) return (0, $g5DHJ.Set)();
        else if ((0, $g5DHJ.isCollection)(value)) {
            const valueSet = value;
            if (!multipleAllowed && valueSet.size >= 2) return (0, $g5DHJ.Set)([
                "Multiple values for '".concat(key, "' are not allowed.")
            ]);
            return valueSet.reduce((acc, v)=>acc.union($a9dc1becfc64d1c8$var$oneOfValidatorHelper(v, key, inSet, state)), (0, $g5DHJ.Set)());
        } else return $a9dc1becfc64d1c8$var$oneOfValidatorHelper(value, key, inSet, state);
    };
}
class $a9dc1becfc64d1c8$export$2e2bcd8739ae039 {
    constructor(validators){
        (0, $5zQU9.default)(this, "validatorSet", void 0);
        if ((0, $g5DHJ.isCollection)(validators)) this.validatorSet = validators;
        else if (typeof validators === 'function') this.validatorSet = (0, $g5DHJ.Set)([
            validators
        ]);
        else this.validatorSet = (0, $g5DHJ.Set)();
    }
    addValidator(validator) {
        return new $a9dc1becfc64d1c8$export$2e2bcd8739ae039(this.validatorSet.union(validator instanceof (0, $g5DHJ.Set) ? validator : (0, $g5DHJ.Set)([
            validator
        ]) // Must be a function
        ));
    }
    addRequiredValidator() {
        for(var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++)keys[_key] = arguments[_key];
        return new $a9dc1becfc64d1c8$export$2e2bcd8739ae039(keys.reduce((res, key)=>{
            return res.add($a9dc1becfc64d1c8$var$requiredValidator(key));
        }, this.validatorSet));
    }
    addOneOfValidator(key, inSet) {
        let multipleAllowed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        return this.addValidator($a9dc1becfc64d1c8$var$oneOfValidator(key, inSet, multipleAllowed));
    }
    validate(queryParams, state) {
        return this.validatorSet.reduce((res, validator)=>{
            return res.union(validator(queryParams, state));
        }, (0, $g5DHJ.Set)());
    }
}

});



parcelRegister("2Ywog", function(module, exports) {

$parcel$export(module.exports, "default", () => $22aa4f71021b1d83$export$2e2bcd8739ae039);

var $hM72j = parcelRequire("hM72j");
var $22aa4f71021b1d83$export$2e2bcd8739ae039 = (0, $hM72j.default);

});
parcelRegister("hM72j", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf0c60a66fbd41a7$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $gwoWU = parcelRequire("gwoWU");
var $lgRZl = parcelRequire("lgRZl");

var $inwKI = parcelRequire("inwKI");

var $kafab = parcelRequire("kafab");

var $ammkg = parcelRequire("ammkg");

var $fEeDC = parcelRequire("fEeDC");

var $g5DHJ = parcelRequire("g5DHJ");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $l5PRC = parcelRequire("l5PRC");
var $e2VTq = parcelRequire("e2VTq");

var $iW4kt = parcelRequire("iW4kt");

var $6jEcw = parcelRequire("6jEcw");

var $90ON9 = parcelRequire("90ON9");

var $iDEAo = parcelRequire("iDEAo");

var $ieOz2 = parcelRequire("ieOz2");

var $kLILm = parcelRequire("kLILm");
function $cf0c60a66fbd41a7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cf0c60a66fbd41a7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cf0c60a66fbd41a7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cf0c60a66fbd41a7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $cf0c60a66fbd41a7$export$3d3ee440779f81f = 'hits';
const $cf0c60a66fbd41a7$export$eb54c0b36b24646d = 'fadeIn';
const $cf0c60a66fbd41a7$export$407c97aa5ff397af = 'fadeInActive';
const $cf0c60a66fbd41a7$var$HitsContainer = (0, $3UXZ8.default)("div", {
    target: "e1m4a8560",
    label: "HitsContainer"
})(".", ()=>$cf0c60a66fbd41a7$export$3d3ee440779f81f, "{display:flex;flex-flow:row wrap;.", ()=>$cf0c60a66fbd41a7$export$eb54c0b36b24646d, "{opacity:0.01;&.", ()=>$cf0c60a66fbd41a7$export$407c97aa5ff397af, "{opacity:1;transition:opacity 200ms ease-in;}}}");
const $cf0c60a66fbd41a7$var$fadeMs = 200;
function $cf0c60a66fbd41a7$var$resolveSearchId(props) {
    return props.searchId || (0, $iDEAo.generateSearchId)();
}
// eslint-disable-next-line max-lines-per-function
const $cf0c60a66fbd41a7$var$Hits = (props)=>{
    const context = (0, $inwKI.useFeatureFlags)();
    const searchId = $cf0c60a66fbd41a7$var$resolveSearchId(props);
    const onHitClickFactory = (_ref)=>{
        let { hitRank: hitRank } = _ref;
        return (options, event)=>{
            props.hitContext.get('onHitClick')($cf0c60a66fbd41a7$var$_objectSpread($cf0c60a66fbd41a7$var$_objectSpread({}, options), {}, {
                hitRank: hitRank
            }), event);
        };
    };
    const onHitMountFactory = (_ref2)=>{
        let { hitRank: hitRank } = _ref2;
        return (_ref3)=>{
            let { hit: hit } = _ref3;
            if (props.hitContext.get('onHitMount')) props.hitContext.get('onHitMount')({
                hit: hit,
                hitRank: hitRank
            });
        };
    };
    const getHitContextForRank = (hitRank)=>props.hitContext.set('onHitClick', onHitClickFactory({
            hitRank: hitRank
        })).set('onHitMount', onHitMountFactory({
            hitRank: hitRank
        }));
    const mapToBugBountyParticipant = (bbp)=>{
        return {
            cloud: {
                status: bbp === null || bbp === void 0 ? void 0 : bbp.getIn([
                    'cloud',
                    'status'
                ])
            },
            server: {
                status: bbp === null || bbp === void 0 ? void 0 : bbp.getIn([
                    'server',
                    'status'
                ])
            },
            dataCenter: {
                status: bbp === null || bbp === void 0 ? void 0 : bbp.getIn([
                    'dataCenter',
                    'status'
                ])
            }
        };
    };
    const resolveSingleHit = (h, i)=>{
        const hasCloudSecurityBadge = (context === null || context === void 0 ? void 0 : context.enableBugBountyProgram) && // True only if cloud app is enrolled in the program. Eg: don't show if server is enrolled and cloud isn't
        (0, $gwoWU.isBugBountyParticipant)((0, $ammkg.AtlassianProductHostingType).Cloud, mapToBugBountyParticipant(h === null || h === void 0 ? void 0 : h.getIn([
            'programs',
            'bugBountyParticipant'
        ]))) && // Verify that app has cloud deployment
        h.get('deployments').includes('cloud');
        const hasCloudFortifiedBadge = (context === null || context === void 0 ? void 0 : context.enableCloudFortifiedAppsDiscovery) && h.getIn([
            'programs',
            'cloudFortified',
            'status'
        ]) === (0, $kafab.CloudFortifiedStatusValues).Approved;
        const hitAnalyticsAttributes = {
            hasCloudSecurityBadge: hasCloudFortifiedBadge ? false : hasCloudSecurityBadge,
            hasCloudFortifiedBadge: hasCloudFortifiedBadge
        };
        const hitRank = i + 1;
        switch(props.hitSize){
            case 'large':
                return resolveHitTransition(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ieOz2.default), {
                    colSpan: props.colSpan,
                    fromSearch: props.fromSearch,
                    hit: h,
                    hitContext: getHitContextForRank(hitRank),
                    onCategoryClick: props.onCategoryClick,
                    perspective: props.perspective,
                    screenClass: props.screenClass,
                    stateChangeRequested: props.stateChangeRequested,
                    overrideLargeHitRightContent: props.overrideLargeHitRightContent,
                    hasCloudSecurityBadge: hasCloudSecurityBadge,
                    hasCloudFortifiedBadge: hasCloudFortifiedBadge,
                    filters: props.filters,
                    sectionTitle: props.sectionTitle
                }), i, hitAnalyticsAttributes);
            case 'small':
                return resolveHitTransition(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kLILm.default), {
                    colSpan: props.colSpan,
                    fromSearch: props.fromSearch,
                    hit: h,
                    hitContext: getHitContextForRank(hitRank),
                    perspective: props.perspective,
                    screenClass: props.screenClass,
                    hasCloudSecurityBadge: hasCloudSecurityBadge,
                    hasCloudFortifiedBadge: hasCloudFortifiedBadge,
                    filters: props.filters,
                    sectionTitle: props.sectionTitle
                }), i, hitAnalyticsAttributes);
            default:
                console.error("Invalid hit type specified: '".concat(props.hitSize, "'"));
        }
    };
    const resolveCustomHit = (fn, i)=>{
        const Hit = props.hitSize === 'small' ? (0, $kLILm.default) : (0, $ieOz2.default);
        const contentOverride = fn({
            screenClass: props.screenClass,
            hitSize: props.hitSize
        });
        return resolveHitTransition(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Hit, {
            colSpan: props.colSpan,
            contentOverride: contentOverride,
            fromSearch: false,
            screenClass: props.screenClass
        }), i);
    };
    const resolveHits = ()=>{
        const hitRenderers = (props.hits || (0, $g5DHJ.List)()).map((h)=>{
            return (i)=>resolveSingleHit(h, i);
        });
        const overrideRenderers = (props.contentOverrides || (0, $g5DHJ.List)()).sortBy((o)=>o.get('index'));
        const allRenderers = overrideRenderers.reduce((acc, override)=>acc.insert(Math.max(0, Math.min(override.get('index'), acc.size)), (i)=>resolveCustomHit(override.get('render'), i)), hitRenderers);
        const clampedRenderers = props.maxLength && allRenderers.size > props.maxLength ? allRenderers.setSize(props.maxLength) : allRenderers;
        return clampedRenderers.map((fn, i)=>fn(i));
    };
    const resolveHitTransition = (hit, i, hitAnalyticsAttributes)=>{
        const analyticsAttributes = $cf0c60a66fbd41a7$var$_objectSpread({
            hitRank: i + 1,
            hitSize: props.hitSize
        }, hitAnalyticsAttributes);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l5PRC.default), {
            classNames: {
                enter: $cf0c60a66fbd41a7$export$eb54c0b36b24646d,
                enterActive: $cf0c60a66fbd41a7$export$407c97aa5ff397af,
                appear: $cf0c60a66fbd41a7$export$eb54c0b36b24646d,
                appearActive: $cf0c60a66fbd41a7$export$407c97aa5ff397af
            },
            appear: true,
            exit: false,
            key: "searchId_".concat(searchId, "_hit_").concat(i),
            timeout: {
                enter: $cf0c60a66fbd41a7$var$fadeMs,
                appear: $cf0c60a66fbd41a7$var$fadeMs
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iW4kt.default), analyticsAttributes, hit));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf0c60a66fbd41a7$var$HitsContainer, {
        className: "ui-hits-container",
        "data-search-id": searchId,
        "data-testid": "hits-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e2VTq.default), {
        className: $cf0c60a66fbd41a7$export$3d3ee440779f81f
    }, resolveHits()));
};
$cf0c60a66fbd41a7$var$Hits.propTypes = {
    colSpan: (0, $90ON9.default).colSpan.isRequired,
    contentOverrides: (0, $90ON9.default).contentOverrides,
    fromSearch: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
    hitContext: (0, $90ON9.default).hitContext,
    hits: (0, $lgRZl.default).requiredIf((0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).listOf((0, $90ON9.default).hit()), (props)=>!props.contentOverrides),
    hitSize: (0, $90ON9.default).hitSize.isRequired,
    maxLength: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    onCategoryClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    perspective: (0, $6jEcw.default).perspective,
    screenClass: (0, $90ON9.default).screenClass.isRequired,
    searchId: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    stateChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    overrideLargeHitRightContent: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    filters: (0, $90ON9.default).filters,
    sectionTitle: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string
};
var $cf0c60a66fbd41a7$export$2e2bcd8739ae039 = $cf0c60a66fbd41a7$var$Hits;

});
parcelRegister("gwoWU", function(module, exports) {

$parcel$export(module.exports, "isBugBountyParticipant", () => $c072fce12c6e26f6$export$8892bb2726357eb0);

var $kafab = parcelRequire("kafab");

var $ammkg = parcelRequire("ammkg");

var $bTrQR = parcelRequire("bTrQR");
const $c072fce12c6e26f6$export$ea94770af14d60f6 = (hosting)=>{
    if (hosting === (0, $ammkg.AtlassianProductHostingType).Cloud) return 'cloud';
    else if (hosting === (0, $ammkg.AtlassianProductHostingType).DataCenter) return 'dataCenter';
    else if (hosting === (0, $ammkg.AtlassianProductHostingType).Server) return 'server';
};
const $c072fce12c6e26f6$export$aaafe22bbdc50ba8 = (bb, hosting)=>{
    if (hosting === (0, $ammkg.AtlassianProductHostingType).Cloud) {
        var _bb$cloud, _bb$cloud$status;
        return (bb === null || bb === void 0 ? void 0 : (_bb$cloud = bb.cloud) === null || _bb$cloud === void 0 ? void 0 : (_bb$cloud$status = _bb$cloud.status) === null || _bb$cloud$status === void 0 ? void 0 : _bb$cloud$status.toLowerCase()) === (0, $kafab.BugBountyStatusValues).Approved;
    } else if (hosting === (0, $ammkg.AtlassianProductHostingType).DataCenter) {
        var _bb$dataCenter, _bb$dataCenter$status;
        return (bb === null || bb === void 0 ? void 0 : (_bb$dataCenter = bb.dataCenter) === null || _bb$dataCenter === void 0 ? void 0 : (_bb$dataCenter$status = _bb$dataCenter.status) === null || _bb$dataCenter$status === void 0 ? void 0 : _bb$dataCenter$status.toLowerCase()) === (0, $kafab.BugBountyStatusValues).Approved;
    } else if (hosting === (0, $ammkg.AtlassianProductHostingType).Server) {
        var _bb$server, _bb$server$status;
        return (bb === null || bb === void 0 ? void 0 : (_bb$server = bb.server) === null || _bb$server === void 0 ? void 0 : (_bb$server$status = _bb$server.status) === null || _bb$server$status === void 0 ? void 0 : _bb$server$status.toLowerCase()) === (0, $kafab.BugBountyStatusValues).Approved;
    }
    return false;
};
const $c072fce12c6e26f6$export$8892bb2726357eb0 = (hostingType, bugBountyParticipant)=>{
    const bugBountyHosting = $c072fce12c6e26f6$export$ea94770af14d60f6(hostingType);
    if (!bugBountyHosting) {
        (0, $bTrQR.default).error("isBugBountyParticipant", "Error in mapping hosting value for ".concat(hostingType));
        return false;
    }
    return $c072fce12c6e26f6$export$aaafe22bbdc50ba8(bugBountyParticipant, hostingType);
};

});
parcelRegister("ammkg", function(module, exports) {

$parcel$export(module.exports, "AtlassianProductHostingType", () => $78ad46e0d6808149$export$38d407d6909984c2);
$parcel$export(module.exports, "MarketplaceAppPaymentModel", () => $78ad46e0d6808149$export$f25ba44b203e3645);
$parcel$export(module.exports, "MarketplaceAppVersionVisibility", () => $78ad46e0d6808149$export$6e069b93ed3dba5f);
$parcel$export(module.exports, "MarketplaceBillingCycle", () => $78ad46e0d6808149$export$dafb60ab7ab08188);
$parcel$export(module.exports, "MarketplaceLocation", () => $78ad46e0d6808149$export$25ad001a38719422);
$parcel$export(module.exports, "MarketplacePartnerSupportHolidayFrequency", () => $78ad46e0d6808149$export$96bfc8c3eec61fd0);
$parcel$export(module.exports, "MarketplacePartnerTierType", () => $78ad46e0d6808149$export$4f999921e3690a15);
$parcel$export(module.exports, "MarketplacePartnerType", () => $78ad46e0d6808149$export$8fec59d6f9a79101);
$parcel$export(module.exports, "MarketplacePricingTierMode", () => $78ad46e0d6808149$export$3c578ff2609d82d7);
$parcel$export(module.exports, "MarketplacePricingTierPolicy", () => $78ad46e0d6808149$export$7edcca7ce5991948);
$parcel$export(module.exports, "MarketplacePricingTierType", () => $78ad46e0d6808149$export$645f0980d82252ac);
$parcel$export(module.exports, "MarketplaceProgramStatus", () => $78ad46e0d6808149$export$2cbd5d0207702c5);
$parcel$export(module.exports, "MarketplaceStoreInstallAppStatus", () => $78ad46e0d6808149$export$f6c61b63a81bc74a);
$parcel$export(module.exports, "MarketplaceStoreInstallationTargetProduct", () => $78ad46e0d6808149$export$36ca2010d8fa9f9a);
/**
 *   This file is auto-generated.
 *   Any manual changes done could be lost.
 **/ /** All built-in and custom scalars, mapped to their actual values */ let $78ad46e0d6808149$export$1798210ae1009578 = /*#__PURE__*/ function(AcceptableResponse) {
    AcceptableResponse["False"] = "FALSE";
    AcceptableResponse["NotApplicable"] = "NOT_APPLICABLE";
    AcceptableResponse["True"] = "TRUE";
    return AcceptableResponse;
}({}); /**
 * "
 * The lifecycle status of the account
 */ 
let $78ad46e0d6808149$export$3693f74db10d5f88 = /*#__PURE__*/ function(AccountStatus) {
    AccountStatus["Active"] = "active";
    AccountStatus["Closed"] = "closed";
    AccountStatus["Inactive"] = "inactive";
    return AccountStatus;
}({}); /** An action that an app implements */  /** A type of action that an app can implement */  /** An app and the actions it supports */ 
let $78ad46e0d6808149$export$db8ac507a39ab8b4 = /*#__PURE__*/ function(ActionsAuthType) {
    ActionsAuthType["ThreeLegged"] = "THREE_LEGGED";
    ActionsAuthType["TwoLegged"] = "TWO_LEGGED";
    return ActionsAuthType;
}({}); /** Description for the action or action input */  /** --------------------------------------- activity_api_v2.graphqls */  /** --------------------------------------- activity_api_v2.graphqls */  /** --------------------------------------- activity_api_v2.graphqls */  /** Extension of ActivitiesEvent, is a part of ActivitiesEventExtension union */ 
let $78ad46e0d6808149$export$d36a88022706d185 = /*#__PURE__*/ function(ActivitiesContainerType) {
    ActivitiesContainerType["Project"] = "PROJECT";
    ActivitiesContainerType["Site"] = "SITE";
    ActivitiesContainerType["Space"] = "SPACE";
    ActivitiesContainerType["Workspace"] = "WORKSPACE";
    return ActivitiesContainerType;
}({});
let $78ad46e0d6808149$export$c1fb1f213efc1d1a = /*#__PURE__*/ function(ActivitiesFilterType) {
    ActivitiesFilterType["And"] = "AND";
    ActivitiesFilterType["Or"] = "OR";
    return ActivitiesFilterType;
}({}); /** Extension of ActivitiesObject, is a part of ActivitiesObjectExtension union */ 
let $78ad46e0d6808149$export$4edf00fad4b97379 = /*#__PURE__*/ function(ActivitiesObjectType) {
    ActivitiesObjectType["Blogpost"] = "BLOGPOST";
    ActivitiesObjectType["Database"] = "DATABASE";
    ActivitiesObjectType["Embed"] = "EMBED";
    ActivitiesObjectType["Goal"] = "GOAL";
    ActivitiesObjectType["Issue"] = "ISSUE";
    ActivitiesObjectType["Page"] = "PAGE";
    ActivitiesObjectType["Project"] = "PROJECT";
    ActivitiesObjectType["Whiteboard"] = "WHITEBOARD";
    return ActivitiesObjectType;
}({}); /** Extension of ActivitiesEvent, is a part of ActivitiesEventExtension union */  /** --------------------------------------- activity_api_v3 */  /** --------------------------------------- activity_api_v3 */  /** --------------------------------------- activity_api_v3 */ 
let $78ad46e0d6808149$export$132f858337fea016 = /*#__PURE__*/ function(ActivityEventType) {
    ActivityEventType["Assigned"] = "ASSIGNED";
    ActivityEventType["Commented"] = "COMMENTED";
    ActivityEventType["Created"] = "CREATED";
    ActivityEventType["Edited"] = "EDITED";
    ActivityEventType["Liked"] = "LIKED";
    ActivityEventType["Published"] = "PUBLISHED";
    ActivityEventType["Transitioned"] = "TRANSITIONED";
    ActivityEventType["Unassigned"] = "UNASSIGNED";
    ActivityEventType["Updated"] = "UPDATED";
    ActivityEventType["Viewed"] = "VIEWED";
    return ActivityEventType;
}({});
let $78ad46e0d6808149$export$d02a56686be43f69 = /*#__PURE__*/ function(ActivityObjectType) {
    ActivityObjectType["Blogpost"] = "BLOGPOST";
    ActivityObjectType["Comment"] = "COMMENT";
    ActivityObjectType["Database"] = "DATABASE";
    ActivityObjectType["Embed"] = "EMBED";
    ActivityObjectType["Goal"] = "GOAL";
    ActivityObjectType["Issue"] = "ISSUE";
    ActivityObjectType["Page"] = "PAGE";
    ActivityObjectType["Project"] = "PROJECT";
    ActivityObjectType["Site"] = "SITE";
    ActivityObjectType["Space"] = "SPACE";
    ActivityObjectType["Task"] = "TASK";
    ActivityObjectType["Whiteboard"] = "WHITEBOARD";
    return ActivityObjectType;
}({});
let $78ad46e0d6808149$export$3ca4051c67b8ec7b = /*#__PURE__*/ function(ActivityProduct) {
    ActivityProduct["Confluence"] = "CONFLUENCE";
    ActivityProduct["Jira"] = "JIRA";
    ActivityProduct["JiraBusiness"] = "JIRA_BUSINESS";
    ActivityProduct["JiraOps"] = "JIRA_OPS";
    ActivityProduct["JiraServiceDesk"] = "JIRA_SERVICE_DESK";
    ActivityProduct["JiraSoftware"] = "JIRA_SOFTWARE";
    ActivityProduct["Townsquare"] = "TOWNSQUARE";
    return ActivityProduct;
}({}); /**
 * Represents arbitrary transition,
 * e.g. in case of TRANSITIONED event type it could be `from: "inprogress" to: "done"`.
 */ 
let $78ad46e0d6808149$export$276a961098f2db01 = /*#__PURE__*/ function(AlertEventStatus) {
    AlertEventStatus["Acknowledged"] = "ACKNOWLEDGED";
    AlertEventStatus["Closed"] = "CLOSED";
    AlertEventStatus["Opened"] = "OPENED";
    AlertEventStatus["Snoozed"] = "SNOOZED";
    return AlertEventStatus;
}({});
let $78ad46e0d6808149$export$232eaa1effb46fa2 = /*#__PURE__*/ function(AlertPriority) {
    AlertPriority["P1"] = "P1";
    AlertPriority["P2"] = "P2";
    AlertPriority["P3"] = "P3";
    AlertPriority["P4"] = "P4";
    AlertPriority["P5"] = "P5";
    return AlertPriority;
}({}); /** Only used for inside the schema to mark the context for generic types */ 
let $78ad46e0d6808149$export$f6d52655da4aa77d = /*#__PURE__*/ function(ApiContext) {
    ApiContext["Devops"] = "DEVOPS";
    return ApiContext;
}({}); /**
 * This enum is the names of API groupings within the total Atlassian API.
 *
 * This is used by our documentation tooling to group together types and fields into logical groups
 */ 
let $78ad46e0d6808149$export$8145658f3946b657 = /*#__PURE__*/ function(ApiGroup) {
    ApiGroup["Actions"] = "ACTIONS";
    ApiGroup["AppRecommendations"] = "APP_RECOMMENDATIONS";
    ApiGroup["Caas"] = "CAAS";
    ApiGroup["CloudAdmin"] = "CLOUD_ADMIN";
    ApiGroup["CollaborationGraph"] = "COLLABORATION_GRAPH";
    ApiGroup["CommerceCcp"] = "COMMERCE_CCP";
    ApiGroup["CommerceHams"] = "COMMERCE_HAMS";
    ApiGroup["CommerceSharedApi"] = "COMMERCE_SHARED_API";
    ApiGroup["Compass"] = "COMPASS";
    ApiGroup["Confluence"] = "CONFLUENCE";
    ApiGroup["ConfluenceAnalytics"] = "CONFLUENCE_ANALYTICS";
    ApiGroup["ConfluenceLegacy"] = "CONFLUENCE_LEGACY";
    ApiGroup["ConfluenceMutations"] = "CONFLUENCE_MUTATIONS";
    ApiGroup["ConfluencePages"] = "CONFLUENCE_PAGES";
    ApiGroup["ConfluencePageTree"] = "CONFLUENCE_PAGE_TREE";
    ApiGroup["ConfluenceSmarts"] = "CONFLUENCE_SMARTS";
    ApiGroup["ConfluenceTenant"] = "CONFLUENCE_TENANT";
    ApiGroup["ConfluenceUser"] = "CONFLUENCE_USER";
    ApiGroup["ConfluenceV2"] = "CONFLUENCE_V2";
    ApiGroup["ContentPlatformApi"] = "CONTENT_PLATFORM_API";
    ApiGroup["CustomerService"] = "CUSTOMER_SERVICE";
    ApiGroup["DevopsAriGraph"] = "DEVOPS_ARI_GRAPH";
    ApiGroup["DevopsContainerRelationship"] = "DEVOPS_CONTAINER_RELATIONSHIP";
    ApiGroup["DevopsService"] = "DEVOPS_SERVICE";
    ApiGroup["DevopsThirdParty"] = "DEVOPS_THIRD_PARTY";
    ApiGroup["DevopsToolchain"] = "DEVOPS_TOOLCHAIN";
    ApiGroup["FeatureReleaseQuery"] = "FEATURE_RELEASE_QUERY";
    ApiGroup["Forge"] = "FORGE";
    ApiGroup["Help"] = "HELP";
    ApiGroup["Identity"] = "IDENTITY";
    ApiGroup["InsightsXperienceService"] = "INSIGHTS_XPERIENCE_SERVICE";
    ApiGroup["Jira"] = "JIRA";
    ApiGroup["Papi"] = "PAPI";
    ApiGroup["Polaris"] = "POLARIS";
    ApiGroup["SurfacePlatform"] = "SURFACE_PLATFORM";
    ApiGroup["Teams"] = "TEAMS";
    ApiGroup["VirtualAgent"] = "VIRTUAL_AGENT";
    ApiGroup["WebTriggers"] = "WEB_TRIGGERS";
    ApiGroup["XenInvocationService"] = "XEN_INVOCATION_SERVICE";
    ApiGroup["XenLogsApi"] = "XEN_LOGS_API";
    return ApiGroup;
}({});
let $78ad46e0d6808149$export$50693beeb92df79c = /*#__PURE__*/ function(AppContributorRole) {
    AppContributorRole["Admin"] = "ADMIN";
    AppContributorRole["Deployer"] = "DEPLOYER";
    AppContributorRole["Developer"] = "DEVELOPER";
    AppContributorRole["Viewer"] = "VIEWER";
    AppContributorRole["ViewerAdvanced"] = "VIEWER_ADVANCED";
    return AppContributorRole;
}({});
let $78ad46e0d6808149$export$2f94efde4452c4e8 = /*#__PURE__*/ function(AppDeploymentEventLogLevel) {
    AppDeploymentEventLogLevel["Error"] = "ERROR";
    AppDeploymentEventLogLevel["Info"] = "INFO";
    AppDeploymentEventLogLevel["Warning"] = "WARNING";
    return AppDeploymentEventLogLevel;
}({});
let $78ad46e0d6808149$export$df989df2cca988a2 = /*#__PURE__*/ function(AppDeploymentStatus) {
    AppDeploymentStatus["Done"] = "DONE";
    AppDeploymentStatus["Failed"] = "FAILED";
    AppDeploymentStatus["InProgress"] = "IN_PROGRESS";
    return AppDeploymentStatus;
}({});
let $78ad46e0d6808149$export$aa4fe8ce66c067b1 = /*#__PURE__*/ function(AppDeploymentStepStatus) {
    AppDeploymentStepStatus["Done"] = "DONE";
    AppDeploymentStepStatus["Failed"] = "FAILED";
    AppDeploymentStepStatus["Started"] = "STARTED";
    return AppDeploymentStepStatus;
}({}); /** Used to uniquely identify an environment, when being used as an input. */ 
let $78ad46e0d6808149$export$bbec072c9916131d = /*#__PURE__*/ function(AppEnvironmentType) {
    AppEnvironmentType["Development"] = "DEVELOPMENT";
    AppEnvironmentType["Production"] = "PRODUCTION";
    AppEnvironmentType["Staging"] = "STAGING";
    return AppEnvironmentType;
}({}); /** The input needed to create or update an environment variable. */  /**
 * Represents a major version of an AppEnvironment.
 * A major version is one that requires consent from end users before upgrading installations, typically a change in
 * the permissions an App requires.
 * Other changes do not trigger a new major version to be created and are instead applied to the latest major version
 */ 
let $78ad46e0d6808149$export$cb9e000131989fd = /*#__PURE__*/ function(AppNetworkPermissionType) {
    AppNetworkPermissionType["FetchBackendSide"] = "FETCH_BACKEND_SIDE";
    AppNetworkPermissionType["FetchClientSide"] = "FETCH_CLIENT_SIDE";
    AppNetworkPermissionType["Fonts"] = "FONTS";
    AppNetworkPermissionType["Frames"] = "FRAMES";
    AppNetworkPermissionType["Images"] = "IMAGES";
    AppNetworkPermissionType["Media"] = "MEDIA";
    AppNetworkPermissionType["Navigation"] = "NAVIGATION";
    AppNetworkPermissionType["Scripts"] = "SCRIPTS";
    AppNetworkPermissionType["Styles"] = "STYLES";
    return AppNetworkPermissionType;
}({});
let $78ad46e0d6808149$export$46aa181a404c6a14 = /*#__PURE__*/ function(AppNetworkPermissionTypeExtension) {
    AppNetworkPermissionTypeExtension["FetchBackendSide"] = "FETCH_BACKEND_SIDE";
    AppNetworkPermissionTypeExtension["FetchClientSide"] = "FETCH_CLIENT_SIDE";
    AppNetworkPermissionTypeExtension["Fonts"] = "FONTS";
    AppNetworkPermissionTypeExtension["Frames"] = "FRAMES";
    AppNetworkPermissionTypeExtension["Images"] = "IMAGES";
    AppNetworkPermissionTypeExtension["Media"] = "MEDIA";
    AppNetworkPermissionTypeExtension["Navigation"] = "NAVIGATION";
    AppNetworkPermissionTypeExtension["Scripts"] = "SCRIPTS";
    AppNetworkPermissionTypeExtension["Styles"] = "STYLES";
    return AppNetworkPermissionTypeExtension;
}({}); /** Permissions that relate to the App's interaction with supported APIs and supported network egress */  /**
 * The context object provides essential insights into the users' current experience and operations.
 *
 * The supported product and subproduct keys can be found at https://hello.atlassian.net/wiki/spaces/ECON/pages/2339030895/App+Identifiers
 */ 
let $78ad46e0d6808149$export$1618aa24ce40e8c9 = /*#__PURE__*/ function(AppSecurityPoliciesPermissionType) {
    AppSecurityPoliciesPermissionType["Scripts"] = "SCRIPTS";
    AppSecurityPoliciesPermissionType["Styles"] = "STYLES";
    return AppSecurityPoliciesPermissionType;
}({});
let $78ad46e0d6808149$export$3397fdc734564301 = /*#__PURE__*/ function(AppSecurityPoliciesPermissionTypeExtension) {
    AppSecurityPoliciesPermissionTypeExtension["Scripts"] = "SCRIPTS";
    AppSecurityPoliciesPermissionTypeExtension["Styles"] = "STYLES";
    return AppSecurityPoliciesPermissionTypeExtension;
}({});
let $78ad46e0d6808149$export$abe79a166182d5dd = /*#__PURE__*/ function(AppStoredCustomEntityFilterCondition) {
    AppStoredCustomEntityFilterCondition["BeginsWith"] = "BEGINS_WITH";
    AppStoredCustomEntityFilterCondition["Between"] = "BETWEEN";
    AppStoredCustomEntityFilterCondition["Contains"] = "CONTAINS";
    AppStoredCustomEntityFilterCondition["EqualTo"] = "EQUAL_TO";
    AppStoredCustomEntityFilterCondition["Exists"] = "EXISTS";
    AppStoredCustomEntityFilterCondition["GreaterThan"] = "GREATER_THAN";
    AppStoredCustomEntityFilterCondition["GreaterThanEqualTo"] = "GREATER_THAN_EQUAL_TO";
    AppStoredCustomEntityFilterCondition["LessThan"] = "LESS_THAN";
    AppStoredCustomEntityFilterCondition["LessThanEqualTo"] = "LESS_THAN_EQUAL_TO";
    AppStoredCustomEntityFilterCondition["NotContains"] = "NOT_CONTAINS";
    AppStoredCustomEntityFilterCondition["NotEqualTo"] = "NOT_EQUAL_TO";
    AppStoredCustomEntityFilterCondition["NotExists"] = "NOT_EXISTS";
    return AppStoredCustomEntityFilterCondition;
}({});
let $78ad46e0d6808149$export$8c6210489e377c93 = /*#__PURE__*/ function(AppStoredCustomEntityRangeCondition) {
    AppStoredCustomEntityRangeCondition["BeginsWith"] = "BEGINS_WITH";
    AppStoredCustomEntityRangeCondition["Between"] = "BETWEEN";
    AppStoredCustomEntityRangeCondition["EqualTo"] = "EQUAL_TO";
    AppStoredCustomEntityRangeCondition["GreaterThan"] = "GREATER_THAN";
    AppStoredCustomEntityRangeCondition["GreaterThanEqualTo"] = "GREATER_THAN_EQUAL_TO";
    AppStoredCustomEntityRangeCondition["LessThan"] = "LESS_THAN";
    AppStoredCustomEntityRangeCondition["LessThanEqualTo"] = "LESS_THAN_EQUAL_TO";
    return AppStoredCustomEntityRangeCondition;
}({});
let $78ad46e0d6808149$export$6c1157c4fc1b51c4 = /*#__PURE__*/ function(AppStoredEntityCondition) {
    AppStoredEntityCondition["In"] = "IN";
    AppStoredEntityCondition["NotEqualTo"] = "NOT_EQUAL_TO";
    AppStoredEntityCondition["StartsWith"] = "STARTS_WITH";
    return AppStoredEntityCondition;
}({}); /**
 * The identifier for this entity
 *
 * where condition to filter
 */ 
let $78ad46e0d6808149$export$63fbd5015391964b = /*#__PURE__*/ function(AppTaskState) {
    AppTaskState["Complete"] = "COMPLETE";
    AppTaskState["Failed"] = "FAILED";
    AppTaskState["Pending"] = "PENDING";
    AppTaskState["Running"] = "RUNNING";
    return AppTaskState;
}({}); /** App trust information state */ 
let $78ad46e0d6808149$export$5b9c3b8406b5cf1a = /*#__PURE__*/ function(AppTrustInformationState) {
    AppTrustInformationState["Draft"] = "DRAFT";
    AppTrustInformationState["Live"] = "LIVE";
    return AppTrustInformationState;
}({}); /** Input payload for the app environment uninstall mutation */  /** The response from the uninstallation of an app environment */  /**
 * This does not represent a real person but rather the identity that backs an installed application
 *
 * See the documentation on the `User` for more details
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __identity:atlassian-external__
 * * __read:account__
 */ 
let $78ad46e0d6808149$export$c8ae3a8e8f57359f = /*#__PURE__*/ function(ArchivedMode) {
    ArchivedMode["ActiveOnly"] = "ACTIVE_ONLY";
    ArchivedMode["All"] = "ALL";
    ArchivedMode["ArchivedOnly"] = "ARCHIVED_ONLY";
    return ArchivedMode;
}({}); /**
 * At least 'from' or 'to' must be specified. If both are specified, then 'type' is required.
 *
 * If only one side of the relationship is provided, and no type is provided,
 * then every relationship (where that side of the relationship equals the provided ARI)
 * for every applicable relationship type will be deleted.
 */ 
let $78ad46e0d6808149$export$207a81844461bdb0 = /*#__PURE__*/ function(AriGraphRelationshipsSortDirection) {
    AriGraphRelationshipsSortDirection["Asc"] = "ASC";
    AriGraphRelationshipsSortDirection["Desc"] = "DESC";
    return AriGraphRelationshipsSortDirection;
}({}); /**
 * This represents a real person that has an account in a wide range of Atlassian products
 *
 * See the documentation on the `User` and `LocalizationContext` for more details
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __identity:atlassian-external__
 * * __read:account__
 */ 
let $78ad46e0d6808149$export$38d407d6909984c2 = /*#__PURE__*/ function(AtlassianProductHostingType) {
    AtlassianProductHostingType["Cloud"] = "CLOUD";
    AtlassianProductHostingType["DataCenter"] = "DATA_CENTER";
    AtlassianProductHostingType["Server"] = "SERVER";
    return AtlassianProductHostingType;
}({}); /** Accepts input to attach a data manager to a component. */  /** The payload returned from attaching a data manager to a component. */  /** This type contains information about the currently logged in user */  /** Entry point for auto-suggestion search */  /** Entry point for auto-suggestion search */  /** Payload to invoke an AUX Effect */  /** A response to an aux invocation */  /** The input for a Avatar for a Third Party Repository */  /** Bitbucket Permission Enum */ 
let $78ad46e0d6808149$export$a3fe6fe047d6ad5c = /*#__PURE__*/ function(BitbucketPermission) {
    BitbucketPermission["Admin"] = "ADMIN";
    return BitbucketPermission;
}({}); /** Relay connection definition for a list of board features */  /** Relay edge definition for a board feature */  /** Relay connection definition for a list of board feature groups */  /** Relay edge definition for a board feature group */ 
let $78ad46e0d6808149$export$dd75b3db211b43be = /*#__PURE__*/ function(BoardFeatureStatus) {
    BoardFeatureStatus["ComingSoon"] = "COMING_SOON";
    BoardFeatureStatus["Disabled"] = "DISABLED";
    BoardFeatureStatus["Enabled"] = "ENABLED";
    return BoardFeatureStatus;
}({});
let $78ad46e0d6808149$export$c0a71a6782116cff = /*#__PURE__*/ function(BoardFeatureToggleStatus) {
    BoardFeatureToggleStatus["Disabled"] = "DISABLED";
    BoardFeatureToggleStatus["Enabled"] = "ENABLED";
    return BoardFeatureToggleStatus;
}({}); /** Root node for queries about simple / agility / nextgen boards. */  /** Root node for queries about simple / agility / nextgen boards. */  /** Root node for queries about simple / agility / nextgen boards. */  /** Root node for queries about simple / agility / nextgen boards. */  /** Root node for queries about simple / agility / nextgen boards. */  /** Root node for queries about simple / agility / nextgen boards. */  /** Root node for queries about simple / agility / nextgen boards. */  /** Available strategies for grouping issues into swimlanes for a classic board */ 
let $78ad46e0d6808149$export$19baf80f4562d4e3 = /*#__PURE__*/ function(BoardSwimlaneStrategy) {
    BoardSwimlaneStrategy["AssigneeUnassignedFirst"] = "ASSIGNEE_UNASSIGNED_FIRST";
    BoardSwimlaneStrategy["AssigneeUnassignedLast"] = "ASSIGNEE_UNASSIGNED_LAST";
    BoardSwimlaneStrategy["Custom"] = "CUSTOM";
    BoardSwimlaneStrategy["Epic"] = "EPIC";
    BoardSwimlaneStrategy["IssueChildren"] = "ISSUE_CHILDREN";
    BoardSwimlaneStrategy["IssueParent"] = "ISSUE_PARENT";
    BoardSwimlaneStrategy["None"] = "NONE";
    BoardSwimlaneStrategy["ParentChild"] = "PARENT_CHILD";
    BoardSwimlaneStrategy["Project"] = "PROJECT";
    BoardSwimlaneStrategy["RequestType"] = "REQUEST_TYPE";
    return BoardSwimlaneStrategy;
}({});
let $78ad46e0d6808149$export$52d25977f4eeeb6 = /*#__PURE__*/ function(BuiltinPolarisIdeaField) {
    BuiltinPolarisIdeaField["Archived"] = "ARCHIVED";
    BuiltinPolarisIdeaField["ArchivedBy"] = "ARCHIVED_BY";
    BuiltinPolarisIdeaField["ArchivedOn"] = "ARCHIVED_ON";
    BuiltinPolarisIdeaField["Assignee"] = "ASSIGNEE";
    BuiltinPolarisIdeaField["AtlasGoal"] = "ATLAS_GOAL";
    BuiltinPolarisIdeaField["AtlasProject"] = "ATLAS_PROJECT";
    BuiltinPolarisIdeaField["AtlasProjectStatus"] = "ATLAS_PROJECT_STATUS";
    BuiltinPolarisIdeaField["AtlasProjectTarget"] = "ATLAS_PROJECT_TARGET";
    BuiltinPolarisIdeaField["Created"] = "CREATED";
    BuiltinPolarisIdeaField["Creator"] = "CREATOR";
    BuiltinPolarisIdeaField["DeliveryProgress"] = "DELIVERY_PROGRESS";
    BuiltinPolarisIdeaField["DeliveryStatus"] = "DELIVERY_STATUS";
    BuiltinPolarisIdeaField["Description"] = "DESCRIPTION";
    BuiltinPolarisIdeaField["IssueComments"] = "ISSUE_COMMENTS";
    BuiltinPolarisIdeaField["IssueId"] = "ISSUE_ID";
    BuiltinPolarisIdeaField["IssueType"] = "ISSUE_TYPE";
    BuiltinPolarisIdeaField["Key"] = "KEY";
    BuiltinPolarisIdeaField["Labels"] = "LABELS";
    BuiltinPolarisIdeaField["LinkedIssues"] = "LINKED_ISSUES";
    BuiltinPolarisIdeaField["NumDataPoints"] = "NUM_DATA_POINTS";
    BuiltinPolarisIdeaField["Reporter"] = "REPORTER";
    BuiltinPolarisIdeaField["Status"] = "STATUS";
    BuiltinPolarisIdeaField["Summary"] = "SUMMARY";
    BuiltinPolarisIdeaField["Updated"] = "UPDATED";
    BuiltinPolarisIdeaField["Votes"] = "VOTES";
    return BuiltinPolarisIdeaField;
}({}); /** Accepts input for deleting multiple existing components. */  /** The payload returned from deleting existing components. */  /**
 * ###################################################################################################################
 *  COMPASS MUTATION RESPONSES
 * ###################################################################################################################
 */ 
let $78ad46e0d6808149$export$184db778f5e78171 = /*#__PURE__*/ function(CapabilitySet) {
    CapabilitySet["CapabilityAdvanced"] = "capabilityAdvanced";
    CapabilitySet["CapabilityStandard"] = "capabilityStandard";
    return CapabilitySet;
}({});
let $78ad46e0d6808149$export$805b6160e3efc186 = /*#__PURE__*/ function(CardHierarchyLevelEnumType) {
    CardHierarchyLevelEnumType["Base"] = "BASE";
    CardHierarchyLevelEnumType["Child"] = "CHILD";
    CardHierarchyLevelEnumType["Parent"] = "PARENT";
    return CardHierarchyLevelEnumType;
}({});
let $78ad46e0d6808149$export$ee2a5f4674ed5b8d = /*#__PURE__*/ function(CcpActivationReason) {
    CcpActivationReason["AdvantagePricing"] = "ADVANTAGE_PRICING";
    CcpActivationReason["DefaultPricing"] = "DEFAULT_PRICING";
    CcpActivationReason["ExperimentalPricing"] = "EXPERIMENTAL_PRICING";
    return CcpActivationReason;
}({}); /**
 * An experience flow that can be presented to a user so that they can perform a given task.
 * The flow never redirects or returns control to the caller, so it should be opened in a new
 * tab if it is desired that the user returns to the referring experience.
 */ 
let $78ad46e0d6808149$export$dd06bd5976bfc6e3 = /*#__PURE__*/ function(CcpBillingInterval) {
    CcpBillingInterval["Day"] = "DAY";
    CcpBillingInterval["Month"] = "MONTH";
    CcpBillingInterval["Week"] = "WEEK";
    CcpBillingInterval["Year"] = "YEAR";
    return CcpBillingInterval;
}({}); /**
 * An experience flow that can be presented to a user so that they can perform a given task.
 * The flow never redirects or returns control to the caller, so it should be opened in a new
 * tab if it is desired that the user returns to the referring experience.
 */ 
let $78ad46e0d6808149$export$f1663167a1dfb133 = /*#__PURE__*/ function(CcpChargeType) {
    CcpChargeType["AutoScaling"] = "AUTO_SCALING";
    CcpChargeType["Licensed"] = "LICENSED";
    CcpChargeType["Metered"] = "METERED";
    return CcpChargeType;
}({}); /**
 * An experience flow that can be presented to a user so that they can perform a given task.
 * The flow never redirects or returns control to the caller, so it should be opened in a new
 * tab if it is desired that the user returns to the referring experience.
 */ 
let $78ad46e0d6808149$export$c0b393797b8a5dd1 = /*#__PURE__*/ function(CcpCurrency) {
    CcpCurrency["Jpy"] = "JPY";
    CcpCurrency["Usd"] = "USD";
    return CcpCurrency;
}({});
let $78ad46e0d6808149$export$5f9edcd77bf8a9b9 = /*#__PURE__*/ function(CcpDuration) {
    CcpDuration["Forever"] = "FOREVER";
    CcpDuration["Once"] = "ONCE";
    CcpDuration["Repeating"] = "REPEATING";
    return CcpDuration;
}({}); /** An entitlement represents the right of a transaction account to use an offering. */  /** An entitlement represents the right of a transaction account to use an offering. */  /**
 * Returns status IN_PRE_DUNNING if at least one pre-dunning exists for the entitlement,
 * irrespective of the state of the entitlement before pre-dunning (paid offering or trial)
 * firstPreDunningEndTimestamp is the end time of the earliest pre-dunning of the entitlement, if there are more than one instance.
 */ 
let $78ad46e0d6808149$export$57f8dd5442590d31 = /*#__PURE__*/ function(CcpEntitlementPreDunningStatus) {
    CcpEntitlementPreDunningStatus["InPreDunning"] = "IN_PRE_DUNNING";
    CcpEntitlementPreDunningStatus["NotInPreDunning"] = "NOT_IN_PRE_DUNNING";
    return CcpEntitlementPreDunningStatus;
}({});
let $78ad46e0d6808149$export$21652ca36153879b = /*#__PURE__*/ function(CcpEntitlementStatus) {
    CcpEntitlementStatus["Active"] = "ACTIVE";
    CcpEntitlementStatus["Inactive"] = "INACTIVE";
    return CcpEntitlementStatus;
}({}); /** A type of product usage as it relates to an entitlement */  /**
 * An experience flow that can be presented to a user so that they can perform a given task.
 * The flow never redirects or returns control to the caller, so it should be opened in a new
 * tab if it is desired that the user returns to the referring experience.
 */ 
let $78ad46e0d6808149$export$e9dd9659ef9f0fb5 = /*#__PURE__*/ function(CcpOfferingHostingType) {
    CcpOfferingHostingType["Cloud"] = "CLOUD";
    return CcpOfferingHostingType;
}({});
let $78ad46e0d6808149$export$a6e9989b075a8458 = /*#__PURE__*/ function(CcpOfferingStatus) {
    CcpOfferingStatus["Active"] = "ACTIVE";
    CcpOfferingStatus["AtNotice"] = "AT_NOTICE";
    CcpOfferingStatus["Draft"] = "DRAFT";
    CcpOfferingStatus["Expired"] = "EXPIRED";
    return CcpOfferingStatus;
}({});
let $78ad46e0d6808149$export$2ec95e801b135b6a = /*#__PURE__*/ function(CcpOfferingType) {
    CcpOfferingType["Child"] = "CHILD";
    CcpOfferingType["Parent"] = "PARENT";
    return CcpOfferingType;
}({}); /** An order from a transaction account. */  /** A pricing plan represents the way to charge for a subscription. */ 
let $78ad46e0d6808149$export$b1c315941e36715 = /*#__PURE__*/ function(CcpPricingPlanStatus) {
    CcpPricingPlanStatus["Active"] = "ACTIVE";
    CcpPricingPlanStatus["AtNotice"] = "AT_NOTICE";
    CcpPricingPlanStatus["Draft"] = "DRAFT";
    CcpPricingPlanStatus["Expired"] = "EXPIRED";
    return CcpPricingPlanStatus;
}({});
let $78ad46e0d6808149$export$c9b826d15992706b = /*#__PURE__*/ function(CcpPricingType) {
    CcpPricingType["External"] = "EXTERNAL";
    CcpPricingType["Free"] = "FREE";
    CcpPricingType["LimitedFree"] = "LIMITED_FREE";
    CcpPricingType["Paid"] = "PAID";
    return CcpPricingType;
}({});
let $78ad46e0d6808149$export$2b3bbef813bc7ddb = /*#__PURE__*/ function(CcpProrateOnUsageChange) {
    CcpProrateOnUsageChange["AlwaysInvoice"] = "ALWAYS_INVOICE";
    CcpProrateOnUsageChange["CreateProrations"] = "CREATE_PRORATIONS";
    CcpProrateOnUsageChange["None"] = "NONE";
    return CcpProrateOnUsageChange;
}({}); /**
 * Commerce Cloud Platform is Atlassian's commerce platform and replaces the legacy platform HAMS.
 * Some of the types in this schema implement interfaces defined in commerce_schema to provide CCP entitlements data for common commerce API.
 */ 
let $78ad46e0d6808149$export$bec7023af534df98 = /*#__PURE__*/ function(CcpRelationshipPricingType) {
    CcpRelationshipPricingType["AdvantagePricing"] = "ADVANTAGE_PRICING";
    CcpRelationshipPricingType["CurrencyGenerated"] = "CURRENCY_GENERATED";
    CcpRelationshipPricingType["NextPricing"] = "NEXT_PRICING";
    CcpRelationshipPricingType["SyntheticGenerated"] = "SYNTHETIC_GENERATED";
    return CcpRelationshipPricingType;
}({});
let $78ad46e0d6808149$export$1597d868ca01d69 = /*#__PURE__*/ function(CcpSubscriptionScheduleAction) {
    CcpSubscriptionScheduleAction["Cancel"] = "CANCEL";
    CcpSubscriptionScheduleAction["Update"] = "UPDATE";
    return CcpSubscriptionScheduleAction;
}({});
let $78ad46e0d6808149$export$dcee3eda38daaeab = /*#__PURE__*/ function(CcpSubscriptionStatus) {
    CcpSubscriptionStatus["Active"] = "ACTIVE";
    CcpSubscriptionStatus["Cancelled"] = "CANCELLED";
    CcpSubscriptionStatus["Processing"] = "PROCESSING";
    return CcpSubscriptionStatus;
}({});
let $78ad46e0d6808149$export$30c9d4dfd26087be = /*#__PURE__*/ function(CcpSupportedBillingSystems) {
    CcpSupportedBillingSystems["Ccp"] = "CCP";
    CcpSupportedBillingSystems["Hams"] = "HAMS";
    CcpSupportedBillingSystems["Opsgenie"] = "OPSGENIE";
    return CcpSupportedBillingSystems;
}({});
let $78ad46e0d6808149$export$55c02debb712e2db = /*#__PURE__*/ function(CcpTiersMode) {
    CcpTiersMode["Graduated"] = "GRADUATED";
    CcpTiersMode["Volume"] = "VOLUME";
    return CcpTiersMode;
}({}); /**
 * A CCP transaction account represents a customer,
 * i.e. the legal entity with which Atlassian is doing business.
 * It may be an individual, a business, etc.
 */ 
let $78ad46e0d6808149$export$cec1fe9fa75edecd = /*#__PURE__*/ function(Classification) {
    Classification["Other"] = "other";
    Classification["Pii"] = "pii";
    Classification["Ugc"] = "ugc";
    return Classification;
}({}); /** Level of access to an Atlassian product that a cloud app can request */  /**
 * A Version Control System object
 * Eg. Bitbucket, GitHub, GitLab
 */ 
let $78ad46e0d6808149$export$998d732c1030d8c = /*#__PURE__*/ function(CompassBuildEventState) {
    CompassBuildEventState["Cancelled"] = "CANCELLED";
    CompassBuildEventState["Error"] = "ERROR";
    CompassBuildEventState["Failed"] = "FAILED";
    CompassBuildEventState["InProgress"] = "IN_PROGRESS";
    CompassBuildEventState["Successful"] = "SUCCESSFUL";
    CompassBuildEventState["TimedOut"] = "TIMED_OUT";
    CompassBuildEventState["Unknown"] = "UNKNOWN";
    return CompassBuildEventState;
}({}); /**
 * ###################################################################################################################
 *  COMPASS Campaign configuration
 * ###################################################################################################################
 */ 
let $78ad46e0d6808149$export$b18beaf85a2196b5 = /*#__PURE__*/ function(CompassCampaignQuerySortOrder) {
    CompassCampaignQuerySortOrder["Asc"] = "ASC";
    CompassCampaignQuerySortOrder["Desc"] = "DESC";
    return CompassCampaignQuerySortOrder;
}({}); /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Metadata about who created or updated the object and when. */  /** A component represents a software development artifact tracked in Compass. */  /** A component represents a software development artifact tracked in Compass. */  /** A component represents a software development artifact tracked in Compass. */  /** A component represents a software development artifact tracked in Compass. */  /** A component represents a software development artifact tracked in Compass. */  /** A component represents a software development artifact tracked in Compass. */  /** An external integration that manages data for a particular component. */  /** A label provides additional contextual information about a component. */  /** A connection that returns a paginated collection of metric sources. */  /** The query to get the metric sources of a component. */  /** A component scorecard relationship. */  /** A component scorecard relationship. */  /** A component scorecard relationship. */  /** A component scorecard relationship. */  /** Scorecard score on a component for a scorecard. */  /** A tier provides additional contextual information about a component. */  /** Identifies the type of component. */ 
let $78ad46e0d6808149$export$dbf96ee31a2e1415 = /*#__PURE__*/ function(CompassComponentType) {
    CompassComponentType["Application"] = "APPLICATION";
    CompassComponentType["Library"] = "LIBRARY";
    CompassComponentType["Other"] = "OTHER";
    CompassComponentType["Service"] = "SERVICE";
    return CompassComponentType;
}({}); /** Represents a type of software component that is distinguishable from other types.  Service vs Library, for example */  /** Input for querying Compass component types */  /** An alert event. */  /** Accepts input for creating a component announcement. */  /** The payload returned after creating a component announcement. */  /** The payload returned from sending a question to have an answer created. */  /** A build event. */  /** Accepts input for creating a component scorecard Jira issue. */  /** The payload returned from creating a component scorecard Jira issue. */  /** Input for creating a component subscription. */  /** The payload returned from creating a component subscription. */  /** Accepts input for creating a custom boolean field definition. */  /** A custom event. */  /** Accepts input for creating a custom field definition. You must provide exactly one of the fields in this input type. */  /** The payload returned from creating a custom field definition. */  /** Accepts input for creating a custom multi select field definition. */  /** Accepts input for creating a custom number field definition. */  /** Accepts input for creating a custom single select field definition. */  /** Accepts input for creating a custom text field definition. */  /** Accepts input for creating a custom user field definition. */  /** A deployment event. */  /** The list of properties of the deployment event. */  /** A flag event. */  /** The list of properties of the flag event. */  /** Accepts input to create a scorecard criterion checking the value of a specified custom boolean field. */  /** Accepts input to create a scorecard criterion checking the value of a specified custom number field. */  /** Accepts input to create a scorecard criterion checking the value of a specified custom text field. */  /** An incident event. */  /** The list of properties of the incident event. */  /** The user-provided input to create an incoming webhook */  /** The payload returned from sending an incoming webhook to be created */  /** A lifecycle event. */  /** The input for creating a metric definition. */  /** The payload returned from creating a metric definition. */  /** The input to create a metric source. */  /** The payload returned from creating a metric source. */  /** A pull request event. */ 
let $78ad46e0d6808149$export$ad2a5e42be992de9 = /*#__PURE__*/ function(CompassCreatePullRequestStatus) {
    CompassCreatePullRequestStatus["Created"] = "CREATED";
    CompassCreatePullRequestStatus["InReview"] = "IN_REVIEW";
    CompassCreatePullRequestStatus["Merged"] = "MERGED";
    CompassCreatePullRequestStatus["Rejected"] = "REJECTED";
    return CompassCreatePullRequestStatus;
}({}); /** A push event. */  /** Accepts input for creating team checkin's action item. */  /** Accepts input for creating a checkin. */  /** The payload returned after creating a component announcement. */  /** Accepts input for creating team checkin responses with rich text. */ 
let $78ad46e0d6808149$export$ec0d5c1fa3218a83 = /*#__PURE__*/ function(CompassCriteriaBooleanComparatorOptions) {
    CompassCriteriaBooleanComparatorOptions["Equals"] = "EQUALS";
    return CompassCriteriaBooleanComparatorOptions;
}({});
let $78ad46e0d6808149$export$e387eb9a14a2773b = /*#__PURE__*/ function(CompassCriteriaCollectionComparatorOptions) {
    CompassCriteriaCollectionComparatorOptions["AllOf"] = "ALL_OF";
    CompassCriteriaCollectionComparatorOptions["AnyOf"] = "ANY_OF";
    CompassCriteriaCollectionComparatorOptions["NoneOf"] = "NONE_OF";
    return CompassCriteriaCollectionComparatorOptions;
}({});
let $78ad46e0d6808149$export$9597031f08feb1bc = /*#__PURE__*/ function(CompassCriteriaMembershipComparatorOptions) {
    CompassCriteriaMembershipComparatorOptions["In"] = "IN";
    CompassCriteriaMembershipComparatorOptions["NotIn"] = "NOT_IN";
    return CompassCriteriaMembershipComparatorOptions;
}({});
let $78ad46e0d6808149$export$8a8b436a51cf3b62 = /*#__PURE__*/ function(CompassCriteriaNumberComparatorOptions) {
    CompassCriteriaNumberComparatorOptions["Equals"] = "EQUALS";
    CompassCriteriaNumberComparatorOptions["GreaterThan"] = "GREATER_THAN";
    CompassCriteriaNumberComparatorOptions["GreaterThanOrEqualTo"] = "GREATER_THAN_OR_EQUAL_TO";
    CompassCriteriaNumberComparatorOptions["LessThan"] = "LESS_THAN";
    CompassCriteriaNumberComparatorOptions["LessThanOrEqualTo"] = "LESS_THAN_OR_EQUAL_TO";
    return CompassCriteriaNumberComparatorOptions;
}({});
let $78ad46e0d6808149$export$b7f3ac0d38937afa = /*#__PURE__*/ function(CompassCriteriaTextComparatorOptions) {
    CompassCriteriaTextComparatorOptions["IsPresent"] = "IS_PRESENT";
    CompassCriteriaTextComparatorOptions["MatchesRegex"] = "MATCHES_REGEX";
    return CompassCriteriaTextComparatorOptions;
}({}); /** A custom field containing a boolean value. */  /** The definition of a custom field containing a boolean value. */  /** Accepts input for setting a boolean value on a custom field. */ 
let $78ad46e0d6808149$export$ce4ce86422cc81d0 = /*#__PURE__*/ function(CompassCustomEventIcon) {
    CompassCustomEventIcon["Checkpoint"] = "CHECKPOINT";
    CompassCustomEventIcon["Info"] = "INFO";
    CompassCustomEventIcon["Warning"] = "WARNING";
    return CompassCustomEventIcon;
}({}); /** Properties specific to Custom events */  /** The list of properties of the custom event. */  /** A custom field contains data about the component. */  /** Annotation for a custom field value */  /** Annotatation input for a custom field value */  /** Defines a custom field that may be applied to multiple component types. A custom field must be applied to at least one component type. */  /** An edge that contains a custom field definition and a cursor. */  /** The query for retrieving a custom field definition by id on a Compass site. */  /** A connection that returns a paginated collection of custom field definitions. */  /** The query for retrieving custom field definitions on a Compass site. */  /** Accepts input for setting a custom field value. You must provide exactly one of the fields in this input type. */  /** A custom multi-select field. */  /** The definition of a custom multi-select field. */  /** Accepts input for setting options for a multi-select field. */  /** A custom field containing a number. */  /** The definition of a custom field containing a number. */  /** Accepts input for setting a number on a custom field. */  /** Preset options to update custom permission configs, either open to all teams/roles or restricted to product admins and owners. */ 
let $78ad46e0d6808149$export$43cacf9c2c9c2a10 = /*#__PURE__*/ function(CompassCustomPermissionPreset) {
    CompassCustomPermissionPreset["AdminsAndOwners"] = "ADMINS_AND_OWNERS";
    CompassCustomPermissionPreset["Default"] = "DEFAULT";
    return CompassCustomPermissionPreset;
}({}); /** The option of a single-select or multi-select custom field. */  /** A custom single-select field. */  /** The definition of a custom single-select field. */  /** Accepts input for setting an option for single-select field. */  /** A custom field containing a text string. */  /** The definition of a custom field containing a text string. */  /** Accepts input for setting a text string on a custom field. */  /** A custom field containing a user. */  /** The definition of a custom field containing a user. */  /** Accepts input for setting a user on a custom field. */  /** Accepts input for deleting a component announcement. */  /** The payload returned after deleting a component announcement. */  /** Accepts input for delete a subscription. */  /** Payload returned from stop watching a component. */  /** Accepts input for deleting a custom field definition, along with all values associated with the definition. */  /** The payload returned from deleting a custom field definition. */  /** The user-provided input to delete an incoming webhook */  /** The payload returned from deleting an incoming webhook */  /** The input to delete a metric definition. */  /** The payload returned from updating a metric definition. */  /** The input to delete a metric source. */  /** The payload returned from deleting a metric source. */  /** Accepts input for deleting a team checkin. */  /** Accepts input for deleting a team checkin. */  /** The payload returned after deleting a team checkin. */ 
let $78ad46e0d6808149$export$15c39df7a190a18a = /*#__PURE__*/ function(CompassDeploymentEventEnvironmentCategory) {
    CompassDeploymentEventEnvironmentCategory["Development"] = "DEVELOPMENT";
    CompassDeploymentEventEnvironmentCategory["Production"] = "PRODUCTION";
    CompassDeploymentEventEnvironmentCategory["Staging"] = "STAGING";
    CompassDeploymentEventEnvironmentCategory["Testing"] = "TESTING";
    CompassDeploymentEventEnvironmentCategory["Unmapped"] = "UNMAPPED";
    return CompassDeploymentEventEnvironmentCategory;
}({}); /** The environment where the deployment event has occurred. */  /** Filters for deployment events. */  /** The deployment event pipeline. */  /** Compass Deployment Event */ 
let $78ad46e0d6808149$export$43d1deedebbbaa4e = /*#__PURE__*/ function(CompassDeploymentEventState) {
    CompassDeploymentEventState["Cancelled"] = "CANCELLED";
    CompassDeploymentEventState["Failed"] = "FAILED";
    CompassDeploymentEventState["InProgress"] = "IN_PROGRESS";
    CompassDeploymentEventState["Pending"] = "PENDING";
    CompassDeploymentEventState["RolledBack"] = "ROLLED_BACK";
    CompassDeploymentEventState["Successful"] = "SUCCESSFUL";
    CompassDeploymentEventState["Unknown"] = "UNKNOWN";
    return CompassDeploymentEventState;
}({}); /** Stores the categories that various pieces of documentation will be grouped under */  /** Filters for events sent to Compass. */  /** The type of event. One and only one of the fields in this input type must be provided. */ 
let $78ad46e0d6808149$export$155351532e5d1b9f = /*#__PURE__*/ function(CompassEventType) {
    CompassEventType["Alert"] = "ALERT";
    CompassEventType["Build"] = "BUILD";
    CompassEventType["Custom"] = "CUSTOM";
    CompassEventType["Deployment"] = "DEPLOYMENT";
    CompassEventType["Flag"] = "FLAG";
    CompassEventType["Incident"] = "INCIDENT";
    CompassEventType["Lifecycle"] = "LIFECYCLE";
    CompassEventType["PullRequest"] = "PULL_REQUEST";
    CompassEventType["Push"] = "PUSH";
    return CompassEventType;
}({}); /** An alias of the component in an external system. */  /** A field represents data about a component. */  /** The schema of a field. */  /** Specifies the type of value for a field. */ 
let $78ad46e0d6808149$export$5ba534b6379276b = /*#__PURE__*/ function(CompassFieldType) {
    CompassFieldType["Date"] = "DATE";
    CompassFieldType["Enum"] = "ENUM";
    CompassFieldType["Number"] = "NUMBER";
    CompassFieldType["Text"] = "TEXT";
    return CompassFieldType;
}({}); /** Accepts input to find filtered components count */  /** Properties specific to Flag events */  /** A user-defined parameter containing a string value. */  /** The configuration for a scorecard criterion checking the value of a specified custom boolean field. */  /** The configuration for a scorecard criterion checking the value of a specified custom boolean field. */  /** The configuration for a scorecard criterion checking the value of a specified custom number field. */  /** The configuration for a scorecard criterion checking the value of a specified custom number field. */  /** The configuration for a scorecard criterion checking the value of a specified custom text field. */  /** The configuration for a scorecard criterion checking the value of a specified custom text field. */  /** The configuration for a scorecard criterion representing the presence of a description. */  /** The configuration for a scorecard criterion representing the presence of a description. */  /** The configuration for a scorecard criterion representing the presence of a field, for example, 'Has Tier'. */  /** The configuration for a scorecard criterion representing the presence of a field, for example, 'Has Tier'. */  /** The configuration for a scorecard criterion representing the presence of a link, for example, 'Has Repository', or 'Has Documentation'. */  /** The configuration for a scorecard criterion representing the presence of a link, for example, 'Has Repository', or 'Has Documentation'. */  /** The configuration for a scorecard criterion checking the value of a specified metric name. */  /** The configuration for a scorecard criterion checking the value of a specified metric name. */  /** Configuration for a scorecard criteria representing the presence of an owner */  /** Configuration for a scorecard criteria representing the presence of an owner */  /** Properties specific to Incident events */  /** The severity of an incident */  /** The severity of an incident */ 
let $78ad46e0d6808149$export$9a02db1f2decc63 = /*#__PURE__*/ function(CompassIncidentEventSeverityLevel) {
    CompassIncidentEventSeverityLevel["Five"] = "FIVE";
    CompassIncidentEventSeverityLevel["Four"] = "FOUR";
    CompassIncidentEventSeverityLevel["One"] = "ONE";
    CompassIncidentEventSeverityLevel["Three"] = "THREE";
    CompassIncidentEventSeverityLevel["Two"] = "TWO";
    return CompassIncidentEventSeverityLevel;
}({});
let $78ad46e0d6808149$export$f8b82012c65b70c9 = /*#__PURE__*/ function(CompassIncidentEventState) {
    CompassIncidentEventState["Deleted"] = "DELETED";
    CompassIncidentEventState["Open"] = "OPEN";
    CompassIncidentEventState["Resolved"] = "RESOLVED";
    return CompassIncidentEventState;
}({}); /** Represents a user-defined incoming webhook for creating events in Compass */  /**
 * ###################################################################################################################
 *  COMPASS INCOMING WEBHOOKS
 * ###################################################################################################################
 */ 
let $78ad46e0d6808149$export$4366f17562f80ce7 = /*#__PURE__*/ function(CompassLifecycleEventStage) {
    CompassLifecycleEventStage["Deprecation"] = "DEPRECATION";
    CompassLifecycleEventStage["EndOfLife"] = "END_OF_LIFE";
    CompassLifecycleEventStage["PreRelease"] = "PRE_RELEASE";
    CompassLifecycleEventStage["Production"] = "PRODUCTION";
    return CompassLifecycleEventStage;
}({}); /** A link to an entity or resource on the internet. */  /** The types used to identify the intent of the link. */ 
let $78ad46e0d6808149$export$56307b64f049eb43 = /*#__PURE__*/ function(CompassLinkType) {
    CompassLinkType["ChatChannel"] = "CHAT_CHANNEL";
    CompassLinkType["Dashboard"] = "DASHBOARD";
    CompassLinkType["Document"] = "DOCUMENT";
    CompassLinkType["OnCall"] = "ON_CALL";
    CompassLinkType["OtherLink"] = "OTHER_LINK";
    CompassLinkType["Project"] = "PROJECT";
    CompassLinkType["Repository"] = "REPOSITORY";
    return CompassLinkType;
}({}); /** A metric definition defines a metric across multiple components. */  /** A metric definition defines a metric across multiple components. */  /** An edge that contains a metric definition and a cursor. */  /** The format option to append a plain-text suffix to metric values. */  /** The format option to append a plain-text suffix to metric values. */  /** Used to identify the type for the metric */ 
let $78ad46e0d6808149$export$270abbff10f02537 = /*#__PURE__*/ function(CompassMetricDefinitionType) {
    CompassMetricDefinitionType["BuiltIn"] = "BUILT_IN";
    CompassMetricDefinitionType["Custom"] = "CUSTOM";
    return CompassMetricDefinitionType;
}({}); /** A connection that returns a paginated collection of metric definitions. */  /** The query to get the metric definitions on a Compass site. */  /** A metric source contains values that provide numerical data about the component. */  /** A metric source contains values that provide numerical data about the component. */  /** An edge that contains a metric source and a cursor. */  /** A base for different scopes of metrics. Future metric sources can implement this and add their scope specific fields */  /** A connection that returns a paginated collection of metric values. */  /** The query to get the metric values from a component's metric source. */  /** A metric value stores the numerical data relating to the component. */  /** An edge that contains a metric value and a cursor. */  /** A metric value to be inserted. */  /** A list of bucketed, ordered, metric values */  /** The details of a Compass pull request. */  /** A pull request event. */  /** The list of properties of the pull request event. */  /** The list of properties of the pull event. */ 
let $78ad46e0d6808149$export$7a6755e08e21a7bd = /*#__PURE__*/ function(CompassPullRequestQuerySortName) {
    CompassPullRequestQuerySortName["CycleTime"] = "CYCLE_TIME";
    CompassPullRequestQuerySortName["OpenToFirstReview"] = "OPEN_TO_FIRST_REVIEW";
    CompassPullRequestQuerySortName["PrClosedTime"] = "PR_CLOSED_TIME";
    CompassPullRequestQuerySortName["PrCreatedTime"] = "PR_CREATED_TIME";
    CompassPullRequestQuerySortName["ReviewTime"] = "REVIEW_TIME";
    return CompassPullRequestQuerySortName;
}({});
let $78ad46e0d6808149$export$d5ddc46f2d03ff56 = /*#__PURE__*/ function(CompassPullRequestStatus) {
    CompassPullRequestStatus["Created"] = "CREATED";
    CompassPullRequestStatus["FirstReviewed"] = "FIRST_REVIEWED";
    CompassPullRequestStatus["Merged"] = "MERGED";
    CompassPullRequestStatus["Overdue"] = "OVERDUE";
    CompassPullRequestStatus["Rejected"] = "REJECTED";
    return CompassPullRequestStatus;
}({}); /** The pull request status used in the StatusInTimeRangeFilter query. */ 
let $78ad46e0d6808149$export$6a1e195288b23c05 = /*#__PURE__*/ function(CompassPullRequestStatusForStatusInTimeRangeFilter) {
    CompassPullRequestStatusForStatusInTimeRangeFilter["Created"] = "CREATED";
    CompassPullRequestStatusForStatusInTimeRangeFilter["FirstReviewed"] = "FIRST_REVIEWED";
    CompassPullRequestStatusForStatusInTimeRangeFilter["Merged"] = "MERGED";
    CompassPullRequestStatusForStatusInTimeRangeFilter["Rejected"] = "REJECTED";
    return CompassPullRequestStatusForStatusInTimeRangeFilter;
}({}); /** Accepts input to find pull requests. */  /** Accepts input for querying pull requests. */  /** A push event. */  /** The author who made the push */  /** The list of properties of the push event. */  /** The list of properties of the push event. */  /** A filter to apply to the search results. */ 
let $78ad46e0d6808149$export$94d43384cf172d05 = /*#__PURE__*/ function(CompassQuerySortOrder) {
    CompassQuerySortOrder["Asc"] = "ASC";
    CompassQuerySortOrder["Desc"] = "DESC";
    return CompassQuerySortOrder;
}({}); /** A relationship between two components. The startNode and endNode depends on the direction of the relationship. */  /** Defines the possible relationship directions between components. */ 
let $78ad46e0d6808149$export$c8e6de4296189e26 = /*#__PURE__*/ function(CompassRelationshipDirection) {
    CompassRelationshipDirection["Inward"] = "INWARD";
    CompassRelationshipDirection["Outward"] = "OUTWARD";
    return CompassRelationshipDirection;
}({}); /** Accepts input for finding component relationships. */  /** Defines the relationship types. A relationship must be one of these types. */ 
let $78ad46e0d6808149$export$2a274d082ac90bb0 = /*#__PURE__*/ function(CompassRelationshipType) {
    CompassRelationshipType["DependsOn"] = "DEPENDS_ON";
    return CompassRelationshipType;
}({}); /** Accepts input for removing labels from a team. */  /** The payload returned after removing labels from a team. */  /** An object containing rich text versions of a string. */  /** The configuration for a scorecard that can be used by components. */  /** The configuration for a scorecard that can be used by components. */  /** The configuration for a scorecard that can be used by components. */  /** The configuration for a scorecard that can be used by components. */  /** The configuration for a scorecard that can be used by components. */  /** The configuration for a scorecard that can be used by components. */  /** The configuration for a scorecard that can be used by components. */  /** The configuration for a scorecard that can be used by components. */  /** Contains the application rules for how a scorecard will apply to components. */  /** Accepts input to find components a scorecard is applied to and their scores */  /** Accepts input to sort the applied components by. */  /** The configuration for a scorecard criterion that can be shared across components. */  /** The configuration for a scorecard criterion that can be shared across components. */  /** Contains the calculated score for each scorecard criteria that is associated with a specific component. */  /** Historical criteria scores. */  /** Specifies the periodicity (regular repetition at fixed intervals) of the criteria score history data. */ 
let $78ad46e0d6808149$export$854cc3c30987ee51 = /*#__PURE__*/ function(CompassScorecardCriteriaScoreHistoryPeriodicity) {
    CompassScorecardCriteriaScoreHistoryPeriodicity["Daily"] = "DAILY";
    CompassScorecardCriteriaScoreHistoryPeriodicity["Weekly"] = "WEEKLY";
    return CompassScorecardCriteriaScoreHistoryPeriodicity;
}({}); /** Accepts input for querying criteria score history. */  /** Accepts input for filtering when querying criteria score history. */  /** Represents a historical breakdown of scorecard criteria score. */  /** Accepts input to filter the scorecard criteria statistics history. */ 
let $78ad46e0d6808149$export$742385f55bd1cd4c = /*#__PURE__*/ function(CompassScorecardCriteriaScoringStrategyRuleAction) {
    CompassScorecardCriteriaScoringStrategyRuleAction["MarkAsFailed"] = "MARK_AS_FAILED";
    CompassScorecardCriteriaScoringStrategyRuleAction["MarkAsPassed"] = "MARK_AS_PASSED";
    CompassScorecardCriteriaScoringStrategyRuleAction["MarkAsSkipped"] = "MARK_AS_SKIPPED";
    return CompassScorecardCriteriaScoringStrategyRuleAction;
}({}); /** Represents a statistical breakdown of scorecard criteria. */  /** Represents a count of components with the given score status for a scorecard criterion. */  /** COMPASS SCORECARD DEACTIVATION TYPES */  /** The types used to identify the importance of the scorecard. */ 
let $78ad46e0d6808149$export$8f487531178b2612 = /*#__PURE__*/ function(CompassScorecardImportance) {
    CompassScorecardImportance["Recommended"] = "RECOMMENDED";
    CompassScorecardImportance["Required"] = "REQUIRED";
    CompassScorecardImportance["UserDefined"] = "USER_DEFINED";
    return CompassScorecardImportance;
}({}); /** Accepts input to filter the scorecards by. */  /** Accepts input to sort the scorecards by. */  /** Sort scorecards in ascending or descending order of specified field. */ 
let $78ad46e0d6808149$export$edfe0f1e34848d09 = /*#__PURE__*/ function(CompassScorecardQuerySortOrder) {
    CompassScorecardQuerySortOrder["Asc"] = "ASC";
    CompassScorecardQuerySortOrder["Desc"] = "DESC";
    return CompassScorecardQuerySortOrder;
}({}); /** Contains the calculated score for a component. Each component has one calculated score per scorecard. */  /** Accepts input to filter the scorecard score durations statistics. */  /** A historical scorecard score. */  /** SCORE HISTORY */  /** Specifies the periodicity (regular repetition at fixed intervals) of the scorecard score history data. */ 
let $78ad46e0d6808149$export$ac226c775361dae9 = /*#__PURE__*/ function(CompassScorecardScoreHistoryPeriodicity) {
    CompassScorecardScoreHistoryPeriodicity["Daily"] = "DAILY";
    CompassScorecardScoreHistoryPeriodicity["Weekly"] = "WEEKLY";
    return CompassScorecardScoreHistoryPeriodicity;
}({}); /** Accepts input for querying scorecard score history. */  /** Accepts input for filtering when querying scorecard score history. */  /** Scorecard score on a scorecard for a component. */  /** Represents a count of components with the given score status for a scorecard. */  /** Represents a historical breakdown of scorecard score. */  /** SCORE STATISTICS HISTORY */  /** Accepts input to filter the scorecard score statistics history. */  /** Represents a scorecard score status. */ 
let $78ad46e0d6808149$export$f073cd3745c42272 = /*#__PURE__*/ function(CompassScorecardScoringStrategyType) {
    CompassScorecardScoringStrategyType["PointBased"] = "POINT_BASED";
    CompassScorecardScoringStrategyType["WeightBased"] = "WEIGHT_BASED";
    return CompassScorecardScoringStrategyType;
}({}); /** Accepts input to find available scorecards, optionally filtered and/or sorted. */  /** The query to find component labels within Compass. */  /** The query to find components. */  /** A connection that returns a paginated collection of team labels. */  /** An edge that contains a team label and a cursor. */  /** Accepts input for searching team labels. */  /** A connection that returns a paginated collection of teams */  /** The details of a Pull request's timestamps. */  /** A team checkin communicates checkin for a team. */  /** An action item of a team checkin. */  /** Accepts input for creating/updating/deleting team checkin's action item. */  /** Accepts input for deleting a team checkin. */  /** The payload returned when querying for Compass-specific team data. */  /** The payload returned when querying for Compass-specific team data. */  /** The payload returned when querying for Compass-specific team data. */  /** Accepts input for viewing Compass-specific data about a team. */  /** A label provides additional contextual information about a team. */  /** A metric source scoped to a Team */  /** A metric source scoped to a Team */  /** Accepts input for updating a component announcement. */  /** The payload returned after updating a component announcement. */  /** Accepts input for updating a Component Scorecard Jira issue. */  /** The payload returned after updating a Compass Component Scorecard Jira issue. */  /** Accepts input for updating a custom boolean field definition. */  /** Accepts input for updating a custom field definition. You must provide exactly one of the fields in this input type. */  /** The payload returned from updating a custom field definition. */  /** Accepts input for updating a custom multi select field definition. */  /** Accepts input for updating a custom number field definition. */  /** Accepts input for updating a custom single select field definition. */  /** Accepts input for updating a custom text field definition. */  /** Accepts input for updating a custom user field definition. */  /** Accepts input to update a scorecard criterion checking the value of a specified custom boolean field. */  /** Accepts input to update a scorecard criterion checking the value of a specified custom number field. */  /** Accepts input to update a scorecard criterion checking the value of a specified custom text field. */  /** The input to update a metric definition. */  /** The payload returned from updating a metric definition. */  /** The payload returned after updating the custom permission configs. */  /** Accepts input for updating a team checkin action. */  /** Accepts input for updating a team checkin. */  /** The payload returned after updating a team checkin. */  /** Accepts input for updating team checkin responses with rich text. */  /** Definition of a parameter that enables users to input data */  /** Viewer's subscription. */  /** A webhook that is invoked after a component is created from a template. */  /** All Atlassian Cloud Products an app version is compatible with */  /** All Atlassian DataCenter Products an app version is compatible with */  /** All Atlassian Products an app version is compatible with */  /** All Atlassian Server Products an app version is compatible with */  /** Complete sprint */  /** Event data corresponding to a dataManager updating a component. */  /** Details on the result of the last component sync. */  /** Status types of a data manager sync event. */ 
let $78ad46e0d6808149$export$f1221e641dc6f3ef = /*#__PURE__*/ function(ComponentSyncEventStatus) {
    ComponentSyncEventStatus["ServerError"] = "SERVER_ERROR";
    ComponentSyncEventStatus["Success"] = "SUCCESS";
    ComponentSyncEventStatus["UserError"] = "USER_ERROR";
    return ComponentSyncEventStatus;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:blogpost:confluence__
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$f2d20e136929adb = /*#__PURE__*/ function(ConfluenceBlogPostStatus) {
    ConfluenceBlogPostStatus["Archived"] = "ARCHIVED";
    ConfluenceBlogPostStatus["Current"] = "CURRENT";
    ConfluenceBlogPostStatus["Deleted"] = "DELETED";
    ConfluenceBlogPostStatus["Draft"] = "DRAFT";
    ConfluenceBlogPostStatus["Historical"] = "HISTORICAL";
    ConfluenceBlogPostStatus["Trashed"] = "TRASHED";
    return ConfluenceBlogPostStatus;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:content.metadata:confluence__
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$92fbeeae7bfc11f8 = /*#__PURE__*/ function(ConfluenceBodyRepresentation) {
    ConfluenceBodyRepresentation["AnonymousExportView"] = "ANONYMOUS_EXPORT_VIEW";
    ConfluenceBodyRepresentation["AtlasDocFormat"] = "ATLAS_DOC_FORMAT";
    ConfluenceBodyRepresentation["Dynamic"] = "DYNAMIC";
    ConfluenceBodyRepresentation["Editor"] = "EDITOR";
    ConfluenceBodyRepresentation["Editor2"] = "EDITOR2";
    ConfluenceBodyRepresentation["ExportView"] = "EXPORT_VIEW";
    ConfluenceBodyRepresentation["Storage"] = "STORAGE";
    ConfluenceBodyRepresentation["StyledView"] = "STYLED_VIEW";
    ConfluenceBodyRepresentation["View"] = "VIEW";
    return ConfluenceBodyRepresentation;
}({});
let $78ad46e0d6808149$export$c0eb639b68d4388a = /*#__PURE__*/ function(ConfluenceCollaborativeEditingService) {
    ConfluenceCollaborativeEditingService["Ncs"] = "NCS";
    ConfluenceCollaborativeEditingService["Synchrony"] = "SYNCHRONY";
    return ConfluenceCollaborativeEditingService;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:comment:confluence__
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$33f6fe4ae00b4df5 = /*#__PURE__*/ function(ConfluenceCommentStatus) {
    ConfluenceCommentStatus["Current"] = "CURRENT";
    ConfluenceCommentStatus["Draft"] = "DRAFT";
    return ConfluenceCommentStatus;
}({});
let $78ad46e0d6808149$export$6fc7e2bddad2dec7 = /*#__PURE__*/ function(ConfluenceCommentType) {
    ConfluenceCommentType["Footer"] = "FOOTER";
    ConfluenceCommentType["Inline"] = "INLINE";
    return ConfluenceCommentType;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:content.metadata:confluence__
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$7ba61dc1e5005a2 = /*#__PURE__*/ function(ConfluenceContentRepresentation) {
    ConfluenceContentRepresentation["AtlasDocFormat"] = "ATLAS_DOC_FORMAT";
    ConfluenceContentRepresentation["Editor"] = "EDITOR";
    ConfluenceContentRepresentation["Editor2"] = "EDITOR2";
    ConfluenceContentRepresentation["ExportView"] = "EXPORT_VIEW";
    ConfluenceContentRepresentation["Plain"] = "PLAIN";
    ConfluenceContentRepresentation["Raw"] = "RAW";
    ConfluenceContentRepresentation["Storage"] = "STORAGE";
    ConfluenceContentRepresentation["StyledView"] = "STYLED_VIEW";
    ConfluenceContentRepresentation["View"] = "VIEW";
    ConfluenceContentRepresentation["Wiki"] = "WIKI";
    return ConfluenceContentRepresentation;
}({});
let $78ad46e0d6808149$export$98ac9eece9e68319 = /*#__PURE__*/ function(ConfluenceContentType) {
    ConfluenceContentType["Attachment"] = "ATTACHMENT";
    ConfluenceContentType["BlogPost"] = "BLOG_POST";
    ConfluenceContentType["Comment"] = "COMMENT";
    ConfluenceContentType["Page"] = "PAGE";
    ConfluenceContentType["Whiteboard"] = "WHITEBOARD";
    return ConfluenceContentType;
}({});
let $78ad46e0d6808149$export$353a51d90d6c94b7 = /*#__PURE__*/ function(ConfluenceContributionStatus) {
    ConfluenceContributionStatus["Current"] = "CURRENT";
    ConfluenceContributionStatus["Draft"] = "DRAFT";
    ConfluenceContributionStatus["Unknown"] = "UNKNOWN";
    ConfluenceContributionStatus["Unpublished"] = "UNPUBLISHED";
    return ConfluenceContributionStatus;
}({}); /** The result of a successful copy page Long Task. */  /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$d9c59fb36f888de3 = /*#__PURE__*/ function(ConfluenceInlineCommentResolutionStatus) {
    ConfluenceInlineCommentResolutionStatus["Resolved"] = "RESOLVED";
    ConfluenceInlineCommentResolutionStatus["Unresolved"] = "UNRESOLVED";
    return ConfluenceInlineCommentResolutionStatus;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:inlinetask:confluence__
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$d6dc66c7e58b1f27 = /*#__PURE__*/ function(ConfluenceInlineTaskStatus) {
    ConfluenceInlineTaskStatus["Complete"] = "COMPLETE";
    ConfluenceInlineTaskStatus["Incomplete"] = "INCOMPLETE";
    return ConfluenceInlineTaskStatus;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:label:confluence__
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$55cdc784c43406a6 = /*#__PURE__*/ function(ConfluenceLegacyAccessStatus) {
    ConfluenceLegacyAccessStatus["AnonymousAccess"] = "ANONYMOUS_ACCESS";
    ConfluenceLegacyAccessStatus["ExternalCollaboratorAccess"] = "EXTERNAL_COLLABORATOR_ACCESS";
    ConfluenceLegacyAccessStatus["ExternalShareAccess"] = "EXTERNAL_SHARE_ACCESS";
    ConfluenceLegacyAccessStatus["LicensedAdminAccess"] = "LICENSED_ADMIN_ACCESS";
    ConfluenceLegacyAccessStatus["LicensedUseAccess"] = "LICENSED_USE_ACCESS";
    ConfluenceLegacyAccessStatus["NotPermitted"] = "NOT_PERMITTED";
    ConfluenceLegacyAccessStatus["UnlicensedAuthenticatedAccess"] = "UNLICENSED_AUTHENTICATED_ACCESS";
    return ConfluenceLegacyAccessStatus;
}({});
let $78ad46e0d6808149$export$6fb100d84dc744ee = /*#__PURE__*/ function(ConfluenceLegacyAccessType) {
    ConfluenceLegacyAccessType["Edit"] = "EDIT";
    ConfluenceLegacyAccessType["View"] = "VIEW";
    return ConfluenceLegacyAccessType;
}({});
let $78ad46e0d6808149$export$f94f4d758ab56d24 = /*#__PURE__*/ function(ConfluenceLegacyAccountType) {
    ConfluenceLegacyAccountType["App"] = "APP";
    ConfluenceLegacyAccountType["Atlassian"] = "ATLASSIAN";
    ConfluenceLegacyAccountType["Customer"] = "CUSTOMER";
    ConfluenceLegacyAccountType["Unknown"] = "UNKNOWN";
    return ConfluenceLegacyAccountType;
}({}); /** --------------------------------------------------------------------------------------------- */  /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$67a1e2571d1b8f49 = /*#__PURE__*/ function(ConfluenceLegacyAdminAnnouncementBannerSettingsByCriteriaOrder) {
    ConfluenceLegacyAdminAnnouncementBannerSettingsByCriteriaOrder["Default"] = "DEFAULT";
    ConfluenceLegacyAdminAnnouncementBannerSettingsByCriteriaOrder["ScheduledEndDate"] = "SCHEDULED_END_DATE";
    ConfluenceLegacyAdminAnnouncementBannerSettingsByCriteriaOrder["ScheduledStartDate"] = "SCHEDULED_START_DATE";
    ConfluenceLegacyAdminAnnouncementBannerSettingsByCriteriaOrder["Visibility"] = "VISIBILITY";
    return ConfluenceLegacyAdminAnnouncementBannerSettingsByCriteriaOrder;
}({});
let $78ad46e0d6808149$export$abe83d18892e131e = /*#__PURE__*/ function(ConfluenceLegacyAdminAnnouncementBannerStatusType) {
    ConfluenceLegacyAdminAnnouncementBannerStatusType["Published"] = "PUBLISHED";
    ConfluenceLegacyAdminAnnouncementBannerStatusType["Saved"] = "SAVED";
    ConfluenceLegacyAdminAnnouncementBannerStatusType["Scheduled"] = "SCHEDULED";
    return ConfluenceLegacyAdminAnnouncementBannerStatusType;
}({});
let $78ad46e0d6808149$export$6ea4d7ff878e1fa7 = /*#__PURE__*/ function(ConfluenceLegacyAdminAnnouncementBannerVisibilityType) {
    ConfluenceLegacyAdminAnnouncementBannerVisibilityType["All"] = "ALL";
    ConfluenceLegacyAdminAnnouncementBannerVisibilityType["Authorized"] = "AUTHORIZED";
    return ConfluenceLegacyAdminAnnouncementBannerVisibilityType;
}({}); /** --------------------------------------------------------------------------------------------- */ 
let $78ad46e0d6808149$export$592845e9ae5bd115 = /*#__PURE__*/ function(ConfluenceLegacyAllUpdatesFeedEventType) {
    ConfluenceLegacyAllUpdatesFeedEventType["Comment"] = "COMMENT";
    ConfluenceLegacyAllUpdatesFeedEventType["Create"] = "CREATE";
    ConfluenceLegacyAllUpdatesFeedEventType["Edit"] = "EDIT";
    return ConfluenceLegacyAllUpdatesFeedEventType;
}({});
let $78ad46e0d6808149$export$4f7b2d728c929a44 = /*#__PURE__*/ function(ConfluenceLegacyAnalyticsCommentType) {
    ConfluenceLegacyAnalyticsCommentType["Inline"] = "inline";
    ConfluenceLegacyAnalyticsCommentType["Page"] = "page";
    return ConfluenceLegacyAnalyticsCommentType;
}({});
let $78ad46e0d6808149$export$e30f067708a78859 = /*#__PURE__*/ function(ConfluenceLegacyAnalyticsContentType) {
    ConfluenceLegacyAnalyticsContentType["Blogpost"] = "blogpost";
    ConfluenceLegacyAnalyticsContentType["Page"] = "page";
    return ConfluenceLegacyAnalyticsContentType;
}({}); /** Events to gather analytics for */ 
let $78ad46e0d6808149$export$974cb55686fb4ebc = /*#__PURE__*/ function(ConfluenceLegacyAnalyticsEventName) {
    ConfluenceLegacyAnalyticsEventName["AnalyticsPageModalViewed"] = "analyticsPageModal_viewed";
    ConfluenceLegacyAnalyticsEventName["AutomationRuleTrackCreated"] = "automationRuleTrack_created";
    ConfluenceLegacyAnalyticsEventName["CalendarCreated"] = "calendar_created";
    ConfluenceLegacyAnalyticsEventName["CommentCreated"] = "comment_created";
    ConfluenceLegacyAnalyticsEventName["DatabaseCreated"] = "database_created";
    ConfluenceLegacyAnalyticsEventName["DatabaseViewed"] = "database_viewed";
    ConfluenceLegacyAnalyticsEventName["InspectPermissionsDialogViewed"] = "inspectPermissionsDialog_viewed";
    ConfluenceLegacyAnalyticsEventName["InstanceAnalyticsViewed"] = "instanceAnalytics_viewed";
    ConfluenceLegacyAnalyticsEventName["PageAnalyticsViewed"] = "pageAnalytics_viewed";
    ConfluenceLegacyAnalyticsEventName["PageCreated"] = "page_created";
    ConfluenceLegacyAnalyticsEventName["PageUpdated"] = "page_updated";
    ConfluenceLegacyAnalyticsEventName["PageViewed"] = "page_viewed";
    ConfluenceLegacyAnalyticsEventName["PubliclinkPageViewed"] = "publiclink_page_viewed";
    ConfluenceLegacyAnalyticsEventName["SpaceAnalyticsViewed"] = "spaceAnalytics_viewed";
    ConfluenceLegacyAnalyticsEventName["TeamCalendarsViewed"] = "teamCalendars_viewed";
    ConfluenceLegacyAnalyticsEventName["WhiteboardCreated"] = "whiteboard_created";
    ConfluenceLegacyAnalyticsEventName["WhiteboardViewed"] = "whiteboard_viewed";
    return ConfluenceLegacyAnalyticsEventName;
}({}); /** Events to gather measure analytics for */ 
let $78ad46e0d6808149$export$9dc60e43906fc093 = /*#__PURE__*/ function(ConfluenceLegacyAnalyticsMeasuresEventName) {
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentBlogpostCountSitestateMeasured"] = "currentBlogpostCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentBlogpostCountSpacestateMeasured"] = "currentBlogpostCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentDatabaseCountSitestateMeasured"] = "currentDatabaseCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentDatabaseCountSpacestateMeasured"] = "currentDatabaseCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentPageCountSitestateMeasured"] = "currentPageCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentPageCountSpacestateMeasured"] = "currentPageCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentWhiteboardCountSitestateMeasured"] = "currentWhiteboardCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentWhiteboardCountSpacestateMeasured"] = "currentWhiteboardCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["InactivePageCountSitestateMeasured"] = "inactivePageCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["InactivePageCountSpacestateMeasured"] = "inactivePageCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalActiveCommunalSpacesSitestateMeasured"] = "totalActiveCommunalSpaces_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalActivePersonalSpacesSitestateMeasured"] = "totalActivePersonalSpaces_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalActivePublicLinksSitestateMeasured"] = "totalActivePublicLinks_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalActivePublicLinksSpacestateMeasured"] = "totalActivePublicLinks_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalActiveSpacesSitestateMeasured"] = "totalActiveSpaces_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalCurrentBlogpostCountSitestateMeasured"] = "totalCurrentBlogpostCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalCurrentDatabaseCountSitestateMeasured"] = "totalCurrentDatabaseCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalCurrentPageCountSitestateMeasured"] = "totalCurrentPageCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalCurrentWhiteboardCountSitestateMeasured"] = "totalCurrentWhiteboardCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalPagesDeactivatedOwnerSitestateMeasured"] = "totalPagesDeactivatedOwner_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalPagesDeactivatedOwnerSpacestateMeasured"] = "totalPagesDeactivatedOwner_spacestate_measured";
    return ConfluenceLegacyAnalyticsMeasuresEventName;
}({}); /** Events to gather measure analytics space state */ 
let $78ad46e0d6808149$export$529a0a3fc89fb460 = /*#__PURE__*/ function(ConfluenceLegacyAnalyticsMeasuresSpaceEventName) {
    ConfluenceLegacyAnalyticsMeasuresSpaceEventName["CurrentBlogpostCountSpacestateMeasured"] = "currentBlogpostCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresSpaceEventName["CurrentDatabaseCountSpacestateMeasured"] = "currentDatabaseCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresSpaceEventName["CurrentPageCountSpacestateMeasured"] = "currentPageCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresSpaceEventName["CurrentWhiteboardCountSpacestateMeasured"] = "currentWhiteboardCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresSpaceEventName["InactivePageCountSpacestateMeasured"] = "inactivePageCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresSpaceEventName["TotalActivePublicLinksSpacestateMeasured"] = "totalActivePublicLinks_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresSpaceEventName["TotalPagesDeactivatedOwnerSpacestateMeasured"] = "totalPagesDeactivatedOwner_spacestate_measured";
    return ConfluenceLegacyAnalyticsMeasuresSpaceEventName;
}({}); /** Events to gather search analytics for */ 
let $78ad46e0d6808149$export$5a62729781e5150 = /*#__PURE__*/ function(ConfluenceLegacyAnalyticsSearchEventName) {
    ConfluenceLegacyAnalyticsSearchEventName["AdvancedSearchResultLinkClicked"] = "advancedSearchResultLink_clicked";
    ConfluenceLegacyAnalyticsSearchEventName["AdvancedSearchResultsShown"] = "advancedSearchResults_shown";
    ConfluenceLegacyAnalyticsSearchEventName["QuickSearchRequestCompleted"] = "quickSearchRequest_completed";
    ConfluenceLegacyAnalyticsSearchEventName["QuickSearchResultSelected"] = "quickSearchResult_selected";
    return ConfluenceLegacyAnalyticsSearchEventName;
}({}); /** Granularity to group events by */ 
let $78ad46e0d6808149$export$cd1f6d32ed31f38f = /*#__PURE__*/ function(ConfluenceLegacyAnalyticsTimeseriesGranularity) {
    ConfluenceLegacyAnalyticsTimeseriesGranularity["Day"] = "DAY";
    ConfluenceLegacyAnalyticsTimeseriesGranularity["Hour"] = "HOUR";
    ConfluenceLegacyAnalyticsTimeseriesGranularity["Month"] = "MONTH";
    ConfluenceLegacyAnalyticsTimeseriesGranularity["Week"] = "WEEK";
    return ConfluenceLegacyAnalyticsTimeseriesGranularity;
}({}); /** --------------------------------------------------------------------------------------------- */ 
let $78ad46e0d6808149$export$84cc0985ee5132c3 = /*#__PURE__*/ function(ConfluenceLegacyBackendExperiment) {
    ConfluenceLegacyBackendExperiment["Einstein"] = "EINSTEIN";
    return ConfluenceLegacyBackendExperiment;
}({});
let $78ad46e0d6808149$export$72d2271493719cd9 = /*#__PURE__*/ function(ConfluenceLegacyBillingSourceSystem) {
    ConfluenceLegacyBillingSourceSystem["Ccp"] = "CCP";
    ConfluenceLegacyBillingSourceSystem["Hams"] = "HAMS";
    return ConfluenceLegacyBillingSourceSystem;
}({}); /** Represents a block-rendered smart-link on a page */ 
let $78ad46e0d6808149$export$1d6c7c01499dab = /*#__PURE__*/ function(ConfluenceLegacyBodyFormatType) {
    ConfluenceLegacyBodyFormatType["AnonymousExportView"] = "ANONYMOUS_EXPORT_VIEW";
    ConfluenceLegacyBodyFormatType["AtlasDocFormat"] = "ATLAS_DOC_FORMAT";
    ConfluenceLegacyBodyFormatType["Editor"] = "EDITOR";
    ConfluenceLegacyBodyFormatType["Editor2"] = "EDITOR2";
    ConfluenceLegacyBodyFormatType["ExportView"] = "EXPORT_VIEW";
    ConfluenceLegacyBodyFormatType["Storage"] = "STORAGE";
    ConfluenceLegacyBodyFormatType["StyledView"] = "STYLED_VIEW";
    ConfluenceLegacyBodyFormatType["View"] = "VIEW";
    return ConfluenceLegacyBodyFormatType;
}({});
let $78ad46e0d6808149$export$808cc4b811411528 = /*#__PURE__*/ function(ConfluenceLegacyBulkSetSpacePermissionSpaceType) {
    ConfluenceLegacyBulkSetSpacePermissionSpaceType["Collaboration"] = "COLLABORATION";
    ConfluenceLegacyBulkSetSpacePermissionSpaceType["Global"] = "GLOBAL";
    ConfluenceLegacyBulkSetSpacePermissionSpaceType["KnowledgeBase"] = "KNOWLEDGE_BASE";
    ConfluenceLegacyBulkSetSpacePermissionSpaceType["Personal"] = "PERSONAL";
    return ConfluenceLegacyBulkSetSpacePermissionSpaceType;
}({});
let $78ad46e0d6808149$export$7537b52b3e1ca17f = /*#__PURE__*/ function(ConfluenceLegacyBulkSetSpacePermissionSubjectType) {
    ConfluenceLegacyBulkSetSpacePermissionSubjectType["Group"] = "GROUP";
    ConfluenceLegacyBulkSetSpacePermissionSubjectType["User"] = "USER";
    return ConfluenceLegacyBulkSetSpacePermissionSubjectType;
}({});
let $78ad46e0d6808149$export$c274657b6ae8c08b = /*#__PURE__*/ function(ConfluenceLegacyCatchupContentType) {
    ConfluenceLegacyCatchupContentType["Blogpost"] = "BLOGPOST";
    ConfluenceLegacyCatchupContentType["Page"] = "PAGE";
    return ConfluenceLegacyCatchupContentType;
}({});
let $78ad46e0d6808149$export$d3260cc27acb2273 = /*#__PURE__*/ function(ConfluenceLegacyCatchupUpdateType) {
    ConfluenceLegacyCatchupUpdateType["TopN"] = "TOP_N";
    return ConfluenceLegacyCatchupUpdateType;
}({});
let $78ad46e0d6808149$export$fbf27f279c195cfd = /*#__PURE__*/ function(ConfluenceLegacyCommentCreationLocation) {
    ConfluenceLegacyCommentCreationLocation["Editor"] = "EDITOR";
    ConfluenceLegacyCommentCreationLocation["Live"] = "LIVE";
    ConfluenceLegacyCommentCreationLocation["Renderer"] = "RENDERER";
    ConfluenceLegacyCommentCreationLocation["Whiteboard"] = "WHITEBOARD";
    return ConfluenceLegacyCommentCreationLocation;
}({});
let $78ad46e0d6808149$export$68d0cd998b71f75b = /*#__PURE__*/ function(ConfluenceLegacyCommentDeletionLocation) {
    ConfluenceLegacyCommentDeletionLocation["Live"] = "LIVE";
    return ConfluenceLegacyCommentDeletionLocation;
}({});
let $78ad46e0d6808149$export$e2f309d5fad312d0 = /*#__PURE__*/ function(ConfluenceLegacyCommentReplyType) {
    ConfluenceLegacyCommentReplyType["Emoji"] = "EMOJI";
    ConfluenceLegacyCommentReplyType["Prompt"] = "PROMPT";
    ConfluenceLegacyCommentReplyType["QuickReply"] = "QUICK_REPLY";
    return ConfluenceLegacyCommentReplyType;
}({});
let $78ad46e0d6808149$export$2dfdca1bacc36231 = /*#__PURE__*/ function(ConfluenceLegacyCommentType) {
    ConfluenceLegacyCommentType["Footer"] = "FOOTER";
    ConfluenceLegacyCommentType["Inline"] = "INLINE";
    ConfluenceLegacyCommentType["Resolved"] = "RESOLVED";
    ConfluenceLegacyCommentType["Unresolved"] = "UNRESOLVED";
    return ConfluenceLegacyCommentType;
}({});
let $78ad46e0d6808149$export$b6d21fe6703a2599 = /*#__PURE__*/ function(ConfluenceLegacyCommentsType) {
    ConfluenceLegacyCommentsType["Footer"] = "FOOTER";
    ConfluenceLegacyCommentsType["Inline"] = "INLINE";
    return ConfluenceLegacyCommentsType;
}({});
let $78ad46e0d6808149$export$83d2156f88d87d3c = /*#__PURE__*/ function(ConfluenceLegacyContactAdminPageDisabledReason) {
    ConfluenceLegacyContactAdminPageDisabledReason["ConfigOff"] = "CONFIG_OFF";
    ConfluenceLegacyContactAdminPageDisabledReason["NoAdminEmails"] = "NO_ADMIN_EMAILS";
    ConfluenceLegacyContactAdminPageDisabledReason["NoMailServer"] = "NO_MAIL_SERVER";
    ConfluenceLegacyContactAdminPageDisabledReason["NoRecaptcha"] = "NO_RECAPTCHA";
    return ConfluenceLegacyContactAdminPageDisabledReason;
}({}); /** --------------------------------------------------------------------------------------------- */ 
let $78ad46e0d6808149$export$dc0b3486b6d302da = /*#__PURE__*/ function(ConfluenceLegacyContainerType) {
    ConfluenceLegacyContainerType["Blogpost"] = "BLOGPOST";
    ConfluenceLegacyContainerType["Page"] = "PAGE";
    ConfluenceLegacyContainerType["Space"] = "SPACE";
    ConfluenceLegacyContainerType["Whiteboard"] = "WHITEBOARD";
    return ConfluenceLegacyContainerType;
}({});
let $78ad46e0d6808149$export$14a0d7c84f79aebf = /*#__PURE__*/ function(ConfluenceLegacyContentAccessInputType) {
    ConfluenceLegacyContentAccessInputType["EveryoneCanEdit"] = "EVERYONE_CAN_EDIT";
    ConfluenceLegacyContentAccessInputType["EveryoneCanView"] = "EVERYONE_CAN_VIEW";
    ConfluenceLegacyContentAccessInputType["EveryoneNoAccess"] = "EVERYONE_NO_ACCESS";
    ConfluenceLegacyContentAccessInputType["Private"] = "PRIVATE";
    return ConfluenceLegacyContentAccessInputType;
}({});
let $78ad46e0d6808149$export$cf8f2171d823bde = /*#__PURE__*/ function(ConfluenceLegacyContentAccessType) {
    ConfluenceLegacyContentAccessType["EveryoneCanEdit"] = "EVERYONE_CAN_EDIT";
    ConfluenceLegacyContentAccessType["EveryoneCanView"] = "EVERYONE_CAN_VIEW";
    ConfluenceLegacyContentAccessType["EveryoneNoAccess"] = "EVERYONE_NO_ACCESS";
    return ConfluenceLegacyContentAccessType;
}({});
let $78ad46e0d6808149$export$1c8c23d711ae773e = /*#__PURE__*/ function(ConfluenceLegacyContentAction) {
    ConfluenceLegacyContentAction["Created"] = "created";
    ConfluenceLegacyContentAction["Updated"] = "updated";
    ConfluenceLegacyContentAction["Viewed"] = "viewed";
    return ConfluenceLegacyContentAction;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$a78e2be628bf0936 = /*#__PURE__*/ function(ConfluenceLegacyContentDataClassificationMutationContentStatus) {
    ConfluenceLegacyContentDataClassificationMutationContentStatus["Current"] = "CURRENT";
    ConfluenceLegacyContentDataClassificationMutationContentStatus["Draft"] = "DRAFT";
    return ConfluenceLegacyContentDataClassificationMutationContentStatus;
}({});
let $78ad46e0d6808149$export$8294e4a5584cdafb = /*#__PURE__*/ function(ConfluenceLegacyContentDataClassificationQueryContentStatus) {
    ConfluenceLegacyContentDataClassificationQueryContentStatus["Archived"] = "ARCHIVED";
    ConfluenceLegacyContentDataClassificationQueryContentStatus["Current"] = "CURRENT";
    ConfluenceLegacyContentDataClassificationQueryContentStatus["Draft"] = "DRAFT";
    return ConfluenceLegacyContentDataClassificationQueryContentStatus;
}({});
let $78ad46e0d6808149$export$11a7365bbd55a2c3 = /*#__PURE__*/ function(ConfluenceLegacyContentDeleteActionType) {
    ConfluenceLegacyContentDeleteActionType["DeleteDraft"] = "DELETE_DRAFT";
    ConfluenceLegacyContentDeleteActionType["DeleteDraftIfBlank"] = "DELETE_DRAFT_IF_BLANK";
    ConfluenceLegacyContentDeleteActionType["MoveToTrash"] = "MOVE_TO_TRASH";
    ConfluenceLegacyContentDeleteActionType["PurgeFromTrash"] = "PURGE_FROM_TRASH";
    return ConfluenceLegacyContentDeleteActionType;
}({});
let $78ad46e0d6808149$export$e4765167602a01a4 = /*#__PURE__*/ function(ConfluenceLegacyContentPermissionType) {
    ConfluenceLegacyContentPermissionType["Edit"] = "EDIT";
    ConfluenceLegacyContentPermissionType["View"] = "VIEW";
    return ConfluenceLegacyContentPermissionType;
}({});
let $78ad46e0d6808149$export$52bfd28e9d78a168 = /*#__PURE__*/ function(ConfluenceLegacyContentRendererMode) {
    ConfluenceLegacyContentRendererMode["Editor"] = "EDITOR";
    ConfluenceLegacyContentRendererMode["Pdf"] = "PDF";
    ConfluenceLegacyContentRendererMode["Renderer"] = "RENDERER";
    return ConfluenceLegacyContentRendererMode;
}({});
let $78ad46e0d6808149$export$9f48a780e64ab98d = /*#__PURE__*/ function(ConfluenceLegacyContentRepresentation) {
    ConfluenceLegacyContentRepresentation["AtlasDocFormat"] = "ATLAS_DOC_FORMAT";
    ConfluenceLegacyContentRepresentation["Editor"] = "EDITOR";
    ConfluenceLegacyContentRepresentation["Editor2"] = "EDITOR2";
    ConfluenceLegacyContentRepresentation["ExportView"] = "EXPORT_VIEW";
    ConfluenceLegacyContentRepresentation["Plain"] = "PLAIN";
    ConfluenceLegacyContentRepresentation["Raw"] = "RAW";
    ConfluenceLegacyContentRepresentation["Storage"] = "STORAGE";
    ConfluenceLegacyContentRepresentation["StyledView"] = "STYLED_VIEW";
    ConfluenceLegacyContentRepresentation["View"] = "VIEW";
    ConfluenceLegacyContentRepresentation["Wiki"] = "WIKI";
    return ConfluenceLegacyContentRepresentation;
}({});
let $78ad46e0d6808149$export$22638a777276bf91 = /*#__PURE__*/ function(ConfluenceLegacyContentRole) {
    ConfluenceLegacyContentRole["Default"] = "DEFAULT";
    ConfluenceLegacyContentRole["Editor"] = "EDITOR";
    ConfluenceLegacyContentRole["Viewer"] = "VIEWER";
    return ConfluenceLegacyContentRole;
}({});
let $78ad46e0d6808149$export$962cbd35615f4fff = /*#__PURE__*/ function(ConfluenceLegacyContentStateRestrictionLevel) {
    ConfluenceLegacyContentStateRestrictionLevel["None"] = "NONE";
    ConfluenceLegacyContentStateRestrictionLevel["PageOwner"] = "PAGE_OWNER";
    return ConfluenceLegacyContentStateRestrictionLevel;
}({});
let $78ad46e0d6808149$export$c24d6a3d72599268 = /*#__PURE__*/ function(ConfluenceLegacyContentStatus) {
    ConfluenceLegacyContentStatus["Archived"] = "ARCHIVED";
    ConfluenceLegacyContentStatus["Current"] = "CURRENT";
    ConfluenceLegacyContentStatus["Deleted"] = "DELETED";
    ConfluenceLegacyContentStatus["Draft"] = "DRAFT";
    return ConfluenceLegacyContentStatus;
}({});
let $78ad46e0d6808149$export$492d1092720944e9 = /*#__PURE__*/ function(ConfluenceLegacyContentTemplateType) {
    ConfluenceLegacyContentTemplateType["Blueprint"] = "BLUEPRINT";
    ConfluenceLegacyContentTemplateType["Page"] = "PAGE";
    return ConfluenceLegacyContentTemplateType;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$1ead28a8886cdf4e = /*#__PURE__*/ function(ConfluenceLegacyDataSecurityPolicyAction) {
    ConfluenceLegacyDataSecurityPolicyAction["AppAccess"] = "APP_ACCESS";
    ConfluenceLegacyDataSecurityPolicyAction["PageExport"] = "PAGE_EXPORT";
    ConfluenceLegacyDataSecurityPolicyAction["PublicLinks"] = "PUBLIC_LINKS";
    return ConfluenceLegacyDataSecurityPolicyAction;
}({});
let $78ad46e0d6808149$export$d97f1f6b89a9dab8 = /*#__PURE__*/ function(ConfluenceLegacyDataSecurityPolicyCoverageType) {
    ConfluenceLegacyDataSecurityPolicyCoverageType["ClassificationLevel"] = "CLASSIFICATION_LEVEL";
    ConfluenceLegacyDataSecurityPolicyCoverageType["Container"] = "CONTAINER";
    ConfluenceLegacyDataSecurityPolicyCoverageType["None"] = "NONE";
    ConfluenceLegacyDataSecurityPolicyCoverageType["Workspace"] = "WORKSPACE";
    return ConfluenceLegacyDataSecurityPolicyCoverageType;
}({});
let $78ad46e0d6808149$export$b8ebe8bcbe0edcc9 = /*#__PURE__*/ function(ConfluenceLegacyDataSecurityPolicyDecidableContentStatus) {
    ConfluenceLegacyDataSecurityPolicyDecidableContentStatus["Archived"] = "ARCHIVED";
    ConfluenceLegacyDataSecurityPolicyDecidableContentStatus["Current"] = "CURRENT";
    ConfluenceLegacyDataSecurityPolicyDecidableContentStatus["Draft"] = "DRAFT";
    return ConfluenceLegacyDataSecurityPolicyDecidableContentStatus;
}({});
let $78ad46e0d6808149$export$8f82f21f1f98a966 = /*#__PURE__*/ function(ConfluenceLegacyDateFormat) {
    ConfluenceLegacyDateFormat["Global"] = "GLOBAL";
    ConfluenceLegacyDateFormat["Millis"] = "MILLIS";
    ConfluenceLegacyDateFormat["User"] = "USER";
    ConfluenceLegacyDateFormat["UserFriendly"] = "USER_FRIENDLY";
    return ConfluenceLegacyDateFormat;
}({});
let $78ad46e0d6808149$export$1c761a9499909678 = /*#__PURE__*/ function(ConfluenceLegacyDeactivatedPageOwnerUserType) {
    ConfluenceLegacyDeactivatedPageOwnerUserType["FormerUsers"] = "FORMER_USERS";
    ConfluenceLegacyDeactivatedPageOwnerUserType["NonFormerUsers"] = "NON_FORMER_USERS";
    return ConfluenceLegacyDeactivatedPageOwnerUserType;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$477e85946b13cfd1 = /*#__PURE__*/ function(ConfluenceLegacyDepth) {
    ConfluenceLegacyDepth["All"] = "ALL";
    ConfluenceLegacyDepth["Root"] = "ROOT";
    return ConfluenceLegacyDepth;
}({});
let $78ad46e0d6808149$export$8ca8fdccfce3b6b2 = /*#__PURE__*/ function(ConfluenceLegacyDescendantsNoteApplicationOption) {
    ConfluenceLegacyDescendantsNoteApplicationOption["All"] = "ALL";
    ConfluenceLegacyDescendantsNoteApplicationOption["None"] = "NONE";
    ConfluenceLegacyDescendantsNoteApplicationOption["Roots"] = "ROOTS";
    return ConfluenceLegacyDescendantsNoteApplicationOption;
}({});
let $78ad46e0d6808149$export$9e676a15531fad10 = /*#__PURE__*/ function(ConfluenceLegacyDocumentRepresentation) {
    ConfluenceLegacyDocumentRepresentation["AtlasDocFormat"] = "ATLAS_DOC_FORMAT";
    ConfluenceLegacyDocumentRepresentation["Html"] = "HTML";
    ConfluenceLegacyDocumentRepresentation["Storage"] = "STORAGE";
    ConfluenceLegacyDocumentRepresentation["View"] = "VIEW";
    return ConfluenceLegacyDocumentRepresentation;
}({});
let $78ad46e0d6808149$export$c54c52e1dab26d52 = /*#__PURE__*/ function(ConfluenceLegacyEdition) {
    ConfluenceLegacyEdition["Free"] = "FREE";
    ConfluenceLegacyEdition["Premium"] = "PREMIUM";
    ConfluenceLegacyEdition["Standard"] = "STANDARD";
    return ConfluenceLegacyEdition;
}({});
let $78ad46e0d6808149$export$42d27343a8b84fc8 = /*#__PURE__*/ function(ConfluenceLegacyEditorConversionSetting) {
    ConfluenceLegacyEditorConversionSetting["None"] = "NONE";
    ConfluenceLegacyEditorConversionSetting["Supported"] = "SUPPORTED";
    return ConfluenceLegacyEditorConversionSetting;
}({}); /** Represents a smart-link rendered as embedded on a page */  /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$fb03d9af47277a3d = /*#__PURE__*/ function(ConfluenceLegacyEnvironment) {
    ConfluenceLegacyEnvironment["Development"] = "DEVELOPMENT";
    ConfluenceLegacyEnvironment["Production"] = "PRODUCTION";
    ConfluenceLegacyEnvironment["Staging"] = "STAGING";
    return ConfluenceLegacyEnvironment;
}({}); /** The default space assigned to new Confluence Guests on role assignment. */ 
let $78ad46e0d6808149$export$4e6002c4c65764d4 = /*#__PURE__*/ function(ConfluenceLegacyExternalCollaboratorsSortField) {
    ConfluenceLegacyExternalCollaboratorsSortField["Name"] = "NAME";
    return ConfluenceLegacyExternalCollaboratorsSortField;
}({});
let $78ad46e0d6808149$export$a828ec9b508a2266 = /*#__PURE__*/ function(ConfluenceLegacyFeedEventType) {
    ConfluenceLegacyFeedEventType["Comment"] = "COMMENT";
    ConfluenceLegacyFeedEventType["Create"] = "CREATE";
    ConfluenceLegacyFeedEventType["Edit"] = "EDIT";
    return ConfluenceLegacyFeedEventType;
}({});
let $78ad46e0d6808149$export$13866e2e9da2ea4b = /*#__PURE__*/ function(ConfluenceLegacyFeedItemSourceType) {
    ConfluenceLegacyFeedItemSourceType["Person"] = "PERSON";
    ConfluenceLegacyFeedItemSourceType["Space"] = "SPACE";
    return ConfluenceLegacyFeedItemSourceType;
}({});
let $78ad46e0d6808149$export$2e72a60396e89995 = /*#__PURE__*/ function(ConfluenceLegacyFeedType) {
    ConfluenceLegacyFeedType["Direct"] = "DIRECT";
    ConfluenceLegacyFeedType["Following"] = "FOLLOWING";
    ConfluenceLegacyFeedType["Popular"] = "POPULAR";
    return ConfluenceLegacyFeedType;
}({});
let $78ad46e0d6808149$export$25f79122cd5df609 = /*#__PURE__*/ function(ConfluenceLegacyFrontCoverState) {
    ConfluenceLegacyFrontCoverState["Hidden"] = "HIDDEN";
    ConfluenceLegacyFrontCoverState["Shown"] = "SHOWN";
    ConfluenceLegacyFrontCoverState["Transition"] = "TRANSITION";
    ConfluenceLegacyFrontCoverState["Unset"] = "UNSET";
    return ConfluenceLegacyFrontCoverState;
}({});
let $78ad46e0d6808149$export$a19da40648493053 = /*#__PURE__*/ function(ConfluenceLegacyHomeWidgetState) {
    ConfluenceLegacyHomeWidgetState["Collapsed"] = "COLLAPSED";
    ConfluenceLegacyHomeWidgetState["Expanded"] = "EXPANDED";
    return ConfluenceLegacyHomeWidgetState;
}({});
let $78ad46e0d6808149$export$5f0193f955ef0cb1 = /*#__PURE__*/ function(ConfluenceLegacyInitialPermissionOptions) {
    ConfluenceLegacyInitialPermissionOptions["CopyFromSpace"] = "COPY_FROM_SPACE";
    ConfluenceLegacyInitialPermissionOptions["Default"] = "DEFAULT";
    ConfluenceLegacyInitialPermissionOptions["Private"] = "PRIVATE";
    return ConfluenceLegacyInitialPermissionOptions;
}({}); /** Represents an inline-rendered smart-link on a page */  /** The date range for an Inline Tasks Query Date. Start dates and end dates can be null-able to represent no specified boundary. */ 
let $78ad46e0d6808149$export$df2ab38c891954c2 = /*#__PURE__*/ function(ConfluenceLegacyInlineTasksQuerySortColumn) {
    ConfluenceLegacyInlineTasksQuerySortColumn["Assignee"] = "ASSIGNEE";
    ConfluenceLegacyInlineTasksQuerySortColumn["DueDate"] = "DUE_DATE";
    ConfluenceLegacyInlineTasksQuerySortColumn["PageTitle"] = "PAGE_TITLE";
    return ConfluenceLegacyInlineTasksQuerySortColumn;
}({});
let $78ad46e0d6808149$export$cba96ef83f91f0df = /*#__PURE__*/ function(ConfluenceLegacyInlineTasksQuerySortOrder) {
    ConfluenceLegacyInlineTasksQuerySortOrder["Ascending"] = "ASCENDING";
    ConfluenceLegacyInlineTasksQuerySortOrder["Descending"] = "DESCENDING";
    return ConfluenceLegacyInlineTasksQuerySortOrder;
}({});
let $78ad46e0d6808149$export$b2bba2f5e2a7ff3e = /*#__PURE__*/ function(ConfluenceLegacyInspectPermissions) {
    ConfluenceLegacyInspectPermissions["Comment"] = "COMMENT";
    ConfluenceLegacyInspectPermissions["Edit"] = "EDIT";
    ConfluenceLegacyInspectPermissions["View"] = "VIEW";
    return ConfluenceLegacyInspectPermissions;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$56cd0576b91fa37a = /*#__PURE__*/ function(ConfluenceLegacyLabelSortDirection) {
    ConfluenceLegacyLabelSortDirection["Ascending"] = "ASCENDING";
    ConfluenceLegacyLabelSortDirection["Descending"] = "DESCENDING";
    return ConfluenceLegacyLabelSortDirection;
}({});
let $78ad46e0d6808149$export$c05dc088e940cc05 = /*#__PURE__*/ function(ConfluenceLegacyLabelSortField) {
    ConfluenceLegacyLabelSortField["LabellingCreationdate"] = "LABELLING_CREATIONDATE";
    ConfluenceLegacyLabelSortField["LabellingId"] = "LABELLING_ID";
    return ConfluenceLegacyLabelSortField;
}({});
let $78ad46e0d6808149$export$33f17291ac91a786 = /*#__PURE__*/ function(ConfluenceLegacyLicenseStatus) {
    ConfluenceLegacyLicenseStatus["Active"] = "ACTIVE";
    ConfluenceLegacyLicenseStatus["Suspended"] = "SUSPENDED";
    ConfluenceLegacyLicenseStatus["Unlicensed"] = "UNLICENSED";
    return ConfluenceLegacyLicenseStatus;
}({});
let $78ad46e0d6808149$export$662bb1896031bf06 = /*#__PURE__*/ function(ConfluenceLegacyLoomUserStatus) {
    ConfluenceLegacyLoomUserStatus["Linked"] = "LINKED";
    ConfluenceLegacyLoomUserStatus["Mastered"] = "MASTERED";
    ConfluenceLegacyLoomUserStatus["NotFound"] = "NOT_FOUND";
    return ConfluenceLegacyLoomUserStatus;
}({});
let $78ad46e0d6808149$export$fd5adc8aad00cb78 = /*#__PURE__*/ function(ConfluenceLegacyMobilePlatform) {
    ConfluenceLegacyMobilePlatform["Android"] = "ANDROID";
    ConfluenceLegacyMobilePlatform["Ios"] = "IOS";
    return ConfluenceLegacyMobilePlatform;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$728d574e7c9f150a = /*#__PURE__*/ function(ConfluenceLegacyOperation) {
    ConfluenceLegacyOperation["Assigned"] = "ASSIGNED";
    ConfluenceLegacyOperation["Complete"] = "COMPLETE";
    ConfluenceLegacyOperation["Deleted"] = "DELETED";
    ConfluenceLegacyOperation["InComplete"] = "IN_COMPLETE";
    ConfluenceLegacyOperation["Reworded"] = "REWORDED";
    ConfluenceLegacyOperation["Unassigned"] = "UNASSIGNED";
    return ConfluenceLegacyOperation;
}({});
let $78ad46e0d6808149$export$42875c45c64c8240 = /*#__PURE__*/ function(ConfluenceLegacyOutputDeviceType) {
    ConfluenceLegacyOutputDeviceType["Desktop"] = "DESKTOP";
    ConfluenceLegacyOutputDeviceType["Email"] = "EMAIL";
    ConfluenceLegacyOutputDeviceType["Mobile"] = "MOBILE";
    return ConfluenceLegacyOutputDeviceType;
}({}); /** --------------------------------------------------------------------------------------------- */ 
let $78ad46e0d6808149$export$938d9fc91bf189e3 = /*#__PURE__*/ function(ConfluenceLegacyPtGraphQlPageStatus) {
    ConfluenceLegacyPtGraphQlPageStatus["Current"] = "CURRENT";
    ConfluenceLegacyPtGraphQlPageStatus["Draft"] = "DRAFT";
    ConfluenceLegacyPtGraphQlPageStatus["Historical"] = "HISTORICAL";
    ConfluenceLegacyPtGraphQlPageStatus["Trashed"] = "TRASHED";
    return ConfluenceLegacyPtGraphQlPageStatus;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$32601201a16f0b5d = /*#__PURE__*/ function(ConfluenceLegacyPageActivityAction) {
    ConfluenceLegacyPageActivityAction["Created"] = "created";
    ConfluenceLegacyPageActivityAction["Updated"] = "updated";
    return ConfluenceLegacyPageActivityAction;
}({});
let $78ad46e0d6808149$export$768747d8a19c91ab = /*#__PURE__*/ function(ConfluenceLegacyPageActivityActionSubject) {
    ConfluenceLegacyPageActivityActionSubject["Comment"] = "comment";
    ConfluenceLegacyPageActivityActionSubject["Page"] = "page";
    return ConfluenceLegacyPageActivityActionSubject;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$47389b8ef7f23bf3 = /*#__PURE__*/ function(ConfluenceLegacyPageAnalyticsCountType) {
    ConfluenceLegacyPageAnalyticsCountType["All"] = "ALL";
    ConfluenceLegacyPageAnalyticsCountType["User"] = "USER";
    return ConfluenceLegacyPageAnalyticsCountType;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$1a9b6173c3040cc0 = /*#__PURE__*/ function(ConfluenceLegacyPageAnalyticsTimeseriesCountType) {
    ConfluenceLegacyPageAnalyticsTimeseriesCountType["All"] = "ALL";
    return ConfluenceLegacyPageAnalyticsTimeseriesCountType;
}({});
let $78ad46e0d6808149$export$aa202cd8cef6b1c2 = /*#__PURE__*/ function(ConfluenceLegacyPageCardInPageTreeHoverPreference) {
    ConfluenceLegacyPageCardInPageTreeHoverPreference["NoOptionSelected"] = "NO_OPTION_SELECTED";
    ConfluenceLegacyPageCardInPageTreeHoverPreference["NoShowPagecard"] = "NO_SHOW_PAGECARD";
    ConfluenceLegacyPageCardInPageTreeHoverPreference["ShowPagecard"] = "SHOW_PAGECARD";
    return ConfluenceLegacyPageCardInPageTreeHoverPreference;
}({});
let $78ad46e0d6808149$export$865c06c6ecba3931 = /*#__PURE__*/ function(ConfluenceLegacyPageCopyRestrictionValidationStatus) {
    ConfluenceLegacyPageCopyRestrictionValidationStatus["InvalidMultiple"] = "INVALID_MULTIPLE";
    ConfluenceLegacyPageCopyRestrictionValidationStatus["InvalidSingle"] = "INVALID_SINGLE";
    ConfluenceLegacyPageCopyRestrictionValidationStatus["Valid"] = "VALID";
    return ConfluenceLegacyPageCopyRestrictionValidationStatus;
}({});
let $78ad46e0d6808149$export$29a013f0158561e = /*#__PURE__*/ function(ConfluenceLegacyPageStatus) {
    ConfluenceLegacyPageStatus["Current"] = "CURRENT";
    ConfluenceLegacyPageStatus["Draft"] = "DRAFT";
    ConfluenceLegacyPageStatus["Historical"] = "HISTORICAL";
    ConfluenceLegacyPageStatus["Trashed"] = "TRASHED";
    return ConfluenceLegacyPageStatus;
}({});
let $78ad46e0d6808149$export$cb32a82a68eac3ea = /*#__PURE__*/ function(ConfluenceLegacyPageStatusInput) {
    ConfluenceLegacyPageStatusInput["Current"] = "CURRENT";
    ConfluenceLegacyPageStatusInput["Draft"] = "DRAFT";
    return ConfluenceLegacyPageStatusInput;
}({});
let $78ad46e0d6808149$export$88e74ffbe5a7ddc7 = /*#__PURE__*/ function(ConfluenceLegacyPageUpdateTrigger) {
    ConfluenceLegacyPageUpdateTrigger["CreatePage"] = "CREATE_PAGE";
    ConfluenceLegacyPageUpdateTrigger["DiscardChanges"] = "DISCARD_CHANGES";
    ConfluenceLegacyPageUpdateTrigger["EditPage"] = "EDIT_PAGE";
    ConfluenceLegacyPageUpdateTrigger["LinkRefactoring"] = "LINK_REFACTORING";
    ConfluenceLegacyPageUpdateTrigger["MigratePageCollab"] = "MIGRATE_PAGE_COLLAB";
    ConfluenceLegacyPageUpdateTrigger["OwnerChange"] = "OWNER_CHANGE";
    ConfluenceLegacyPageUpdateTrigger["PageRename"] = "PAGE_RENAME";
    ConfluenceLegacyPageUpdateTrigger["PersonalTasklist"] = "PERSONAL_TASKLIST";
    ConfluenceLegacyPageUpdateTrigger["Revert"] = "REVERT";
    ConfluenceLegacyPageUpdateTrigger["SpaceCreate"] = "SPACE_CREATE";
    ConfluenceLegacyPageUpdateTrigger["Unknown"] = "UNKNOWN";
    ConfluenceLegacyPageUpdateTrigger["ViewPage"] = "VIEW_PAGE";
    return ConfluenceLegacyPageUpdateTrigger;
}({});
let $78ad46e0d6808149$export$e9c8dbdf7b225312 = /*#__PURE__*/ function(ConfluenceLegacyPagesDisplayPersistenceOption) {
    ConfluenceLegacyPagesDisplayPersistenceOption["Cards"] = "CARDS";
    ConfluenceLegacyPagesDisplayPersistenceOption["CompactList"] = "COMPACT_LIST";
    ConfluenceLegacyPagesDisplayPersistenceOption["List"] = "LIST";
    return ConfluenceLegacyPagesDisplayPersistenceOption;
}({});
let $78ad46e0d6808149$export$aaf6c229cce2f3b3 = /*#__PURE__*/ function(ConfluenceLegacyPagesSortField) {
    ConfluenceLegacyPagesSortField["LastModifiedDate"] = "LAST_MODIFIED_DATE";
    ConfluenceLegacyPagesSortField["Relevant"] = "RELEVANT";
    ConfluenceLegacyPagesSortField["Title"] = "TITLE";
    return ConfluenceLegacyPagesSortField;
}({});
let $78ad46e0d6808149$export$318b7a7639914e93 = /*#__PURE__*/ function(ConfluenceLegacyPagesSortOrder) {
    ConfluenceLegacyPagesSortOrder["Asc"] = "ASC";
    ConfluenceLegacyPagesSortOrder["Desc"] = "DESC";
    return ConfluenceLegacyPagesSortOrder;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$c7738cb0d3dab26f = /*#__PURE__*/ function(ConfluenceLegacyPathType) {
    ConfluenceLegacyPathType["Absolute"] = "ABSOLUTE";
    ConfluenceLegacyPathType["Relative"] = "RELATIVE";
    ConfluenceLegacyPathType["RelativeNoContext"] = "RELATIVE_NO_CONTEXT";
    return ConfluenceLegacyPathType;
}({});
let $78ad46e0d6808149$export$45c5982866ef3f86 = /*#__PURE__*/ function(ConfluenceLegacyPaywallStatus) {
    ConfluenceLegacyPaywallStatus["Active"] = "ACTIVE";
    ConfluenceLegacyPaywallStatus["Deactivated"] = "DEACTIVATED";
    ConfluenceLegacyPaywallStatus["Unset"] = "UNSET";
    return ConfluenceLegacyPaywallStatus;
}({});
let $78ad46e0d6808149$export$bdd86c404514bf5e = /*#__PURE__*/ function(ConfluenceLegacyPermissionDisplayType) {
    ConfluenceLegacyPermissionDisplayType["Anonymous"] = "ANONYMOUS";
    ConfluenceLegacyPermissionDisplayType["Group"] = "GROUP";
    ConfluenceLegacyPermissionDisplayType["GuestUser"] = "GUEST_USER";
    ConfluenceLegacyPermissionDisplayType["LicensedUser"] = "LICENSED_USER";
    return ConfluenceLegacyPermissionDisplayType;
}({});
let $78ad46e0d6808149$export$5e661380a2aa4206 = /*#__PURE__*/ function(ConfluenceLegacyPlatform) {
    ConfluenceLegacyPlatform["Android"] = "ANDROID";
    ConfluenceLegacyPlatform["Ios"] = "IOS";
    ConfluenceLegacyPlatform["Web"] = "WEB";
    return ConfluenceLegacyPlatform;
}({});
let $78ad46e0d6808149$export$b8313f5a464cf0ed = /*#__PURE__*/ function(ConfluenceLegacyPremiumToolsDropdownStatus) {
    ConfluenceLegacyPremiumToolsDropdownStatus["Collapsed"] = "COLLAPSED";
    ConfluenceLegacyPremiumToolsDropdownStatus["Expanded"] = "EXPANDED";
    ConfluenceLegacyPremiumToolsDropdownStatus["Unset"] = "UNSET";
    return ConfluenceLegacyPremiumToolsDropdownStatus;
}({});
let $78ad46e0d6808149$export$44790dd8acc73dd6 = /*#__PURE__*/ function(ConfluenceLegacyPrincipalType) {
    ConfluenceLegacyPrincipalType["Group"] = "GROUP";
    ConfluenceLegacyPrincipalType["User"] = "USER";
    return ConfluenceLegacyPrincipalType;
}({});
let $78ad46e0d6808149$export$132f1b98364f7846 = /*#__PURE__*/ function(ConfluenceLegacyProduct) {
    ConfluenceLegacyProduct["Confluence"] = "CONFLUENCE";
    return ConfluenceLegacyProduct;
}({});
let $78ad46e0d6808149$export$baf22e4384c384d6 = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkAdminAction) {
    ConfluenceLegacyPublicLinkAdminAction["Block"] = "BLOCK";
    ConfluenceLegacyPublicLinkAdminAction["Off"] = "OFF";
    ConfluenceLegacyPublicLinkAdminAction["On"] = "ON";
    ConfluenceLegacyPublicLinkAdminAction["Unblock"] = "UNBLOCK";
    return ConfluenceLegacyPublicLinkAdminAction;
}({});
let $78ad46e0d6808149$export$6c27a44327a1685c = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkDefaultSpaceStatus) {
    ConfluenceLegacyPublicLinkDefaultSpaceStatus["Off"] = "OFF";
    ConfluenceLegacyPublicLinkDefaultSpaceStatus["On"] = "ON";
    return ConfluenceLegacyPublicLinkDefaultSpaceStatus;
}({});
let $78ad46e0d6808149$export$882b105854002ad0 = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkPageStatus) {
    ConfluenceLegacyPublicLinkPageStatus["BlockedByClassificationLevel"] = "BLOCKED_BY_CLASSIFICATION_LEVEL";
    ConfluenceLegacyPublicLinkPageStatus["BlockedByOrg"] = "BLOCKED_BY_ORG";
    ConfluenceLegacyPublicLinkPageStatus["BlockedByProduct"] = "BLOCKED_BY_PRODUCT";
    ConfluenceLegacyPublicLinkPageStatus["BlockedBySpace"] = "BLOCKED_BY_SPACE";
    ConfluenceLegacyPublicLinkPageStatus["Off"] = "OFF";
    ConfluenceLegacyPublicLinkPageStatus["On"] = "ON";
    ConfluenceLegacyPublicLinkPageStatus["SiteBlocked"] = "SITE_BLOCKED";
    ConfluenceLegacyPublicLinkPageStatus["SiteDisabled"] = "SITE_DISABLED";
    ConfluenceLegacyPublicLinkPageStatus["SpaceBlocked"] = "SPACE_BLOCKED";
    ConfluenceLegacyPublicLinkPageStatus["SpaceDisabled"] = "SPACE_DISABLED";
    return ConfluenceLegacyPublicLinkPageStatus;
}({});
let $78ad46e0d6808149$export$e1e4b830a0825f2b = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkPageStatusFilter) {
    ConfluenceLegacyPublicLinkPageStatusFilter["BlockedByProduct"] = "BLOCKED_BY_PRODUCT";
    ConfluenceLegacyPublicLinkPageStatusFilter["BlockedBySpace"] = "BLOCKED_BY_SPACE";
    ConfluenceLegacyPublicLinkPageStatusFilter["Off"] = "OFF";
    ConfluenceLegacyPublicLinkPageStatusFilter["On"] = "ON";
    return ConfluenceLegacyPublicLinkPageStatusFilter;
}({});
let $78ad46e0d6808149$export$9acef11a8ce6e3c6 = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkPagesByCriteriaOrder) {
    ConfluenceLegacyPublicLinkPagesByCriteriaOrder["DateEnabled"] = "DATE_ENABLED";
    ConfluenceLegacyPublicLinkPagesByCriteriaOrder["Status"] = "STATUS";
    ConfluenceLegacyPublicLinkPagesByCriteriaOrder["Title"] = "TITLE";
    return ConfluenceLegacyPublicLinkPagesByCriteriaOrder;
}({});
let $78ad46e0d6808149$export$892bc471a65769c0 = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkPermissionsObjectType) {
    ConfluenceLegacyPublicLinkPermissionsObjectType["Content"] = "CONTENT";
    return ConfluenceLegacyPublicLinkPermissionsObjectType;
}({});
let $78ad46e0d6808149$export$353b2d93c5c6cf5c = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkPermissionsType) {
    ConfluenceLegacyPublicLinkPermissionsType["Edit"] = "EDIT";
    return ConfluenceLegacyPublicLinkPermissionsType;
}({});
let $78ad46e0d6808149$export$1363899e44b2229b = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkSiteStatus) {
    ConfluenceLegacyPublicLinkSiteStatus["BlockedByOrg"] = "BLOCKED_BY_ORG";
    ConfluenceLegacyPublicLinkSiteStatus["Off"] = "OFF";
    ConfluenceLegacyPublicLinkSiteStatus["On"] = "ON";
    return ConfluenceLegacyPublicLinkSiteStatus;
}({});
let $78ad46e0d6808149$export$6344a7355e3086d1 = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkSpaceStatus) {
    ConfluenceLegacyPublicLinkSpaceStatus["BlockedByOrg"] = "BLOCKED_BY_ORG";
    ConfluenceLegacyPublicLinkSpaceStatus["BlockedByProduct"] = "BLOCKED_BY_PRODUCT";
    ConfluenceLegacyPublicLinkSpaceStatus["Off"] = "OFF";
    ConfluenceLegacyPublicLinkSpaceStatus["On"] = "ON";
    return ConfluenceLegacyPublicLinkSpaceStatus;
}({});
let $78ad46e0d6808149$export$24ea1c3cc5ac9e7d = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkSpacesByCriteriaOrder) {
    ConfluenceLegacyPublicLinkSpacesByCriteriaOrder["ActiveLinks"] = "ACTIVE_LINKS";
    ConfluenceLegacyPublicLinkSpacesByCriteriaOrder["Name"] = "NAME";
    ConfluenceLegacyPublicLinkSpacesByCriteriaOrder["Status"] = "STATUS";
    return ConfluenceLegacyPublicLinkSpacesByCriteriaOrder;
}({});
let $78ad46e0d6808149$export$fde6c5e19eaa1054 = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkStatus) {
    ConfluenceLegacyPublicLinkStatus["BlockedByClassificationLevel"] = "BLOCKED_BY_CLASSIFICATION_LEVEL";
    ConfluenceLegacyPublicLinkStatus["BlockedByOrg"] = "BLOCKED_BY_ORG";
    ConfluenceLegacyPublicLinkStatus["BlockedByProduct"] = "BLOCKED_BY_PRODUCT";
    ConfluenceLegacyPublicLinkStatus["BlockedBySpace"] = "BLOCKED_BY_SPACE";
    ConfluenceLegacyPublicLinkStatus["Off"] = "OFF";
    ConfluenceLegacyPublicLinkStatus["On"] = "ON";
    ConfluenceLegacyPublicLinkStatus["SiteBlocked"] = "SITE_BLOCKED";
    ConfluenceLegacyPublicLinkStatus["SiteDisabled"] = "SITE_DISABLED";
    ConfluenceLegacyPublicLinkStatus["SpaceBlocked"] = "SPACE_BLOCKED";
    ConfluenceLegacyPublicLinkStatus["SpaceDisabled"] = "SPACE_DISABLED";
    return ConfluenceLegacyPublicLinkStatus;
}({});
let $78ad46e0d6808149$export$9b956743b565355b = /*#__PURE__*/ function(ConfluenceLegacyPublicLinksByCriteriaOrder) {
    ConfluenceLegacyPublicLinksByCriteriaOrder["DateEnabled"] = "DATE_ENABLED";
    ConfluenceLegacyPublicLinksByCriteriaOrder["Status"] = "STATUS";
    ConfluenceLegacyPublicLinksByCriteriaOrder["Title"] = "TITLE";
    return ConfluenceLegacyPublicLinksByCriteriaOrder;
}({});
let $78ad46e0d6808149$export$9e74ac381de41243 = /*#__PURE__*/ function(ConfluenceLegacyPushNotificationGroupInputType) {
    ConfluenceLegacyPushNotificationGroupInputType["None"] = "NONE";
    ConfluenceLegacyPushNotificationGroupInputType["Quiet"] = "QUIET";
    ConfluenceLegacyPushNotificationGroupInputType["Standard"] = "STANDARD";
    return ConfluenceLegacyPushNotificationGroupInputType;
}({});
let $78ad46e0d6808149$export$4b9d765e6088e3c4 = /*#__PURE__*/ function(ConfluenceLegacyPushNotificationSettingGroup) {
    ConfluenceLegacyPushNotificationSettingGroup["Custom"] = "CUSTOM";
    ConfluenceLegacyPushNotificationSettingGroup["None"] = "NONE";
    ConfluenceLegacyPushNotificationSettingGroup["Quiet"] = "QUIET";
    ConfluenceLegacyPushNotificationSettingGroup["Standard"] = "STANDARD";
    return ConfluenceLegacyPushNotificationSettingGroup;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$4490245889e26dee = /*#__PURE__*/ function(ConfluenceLegacyReactionContentType) {
    ConfluenceLegacyReactionContentType["Blogpost"] = "BLOGPOST";
    ConfluenceLegacyReactionContentType["Comment"] = "COMMENT";
    ConfluenceLegacyReactionContentType["Page"] = "PAGE";
    return ConfluenceLegacyReactionContentType;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$74f0035aff7ea1c0 = /*#__PURE__*/ function(ConfluenceLegacyRecentFilter) {
    ConfluenceLegacyRecentFilter["All"] = "ALL";
    ConfluenceLegacyRecentFilter["Created"] = "CREATED";
    ConfluenceLegacyRecentFilter["WorkedOn"] = "WORKED_ON";
    return ConfluenceLegacyRecentFilter;
}({});
let $78ad46e0d6808149$export$6875c90eb8212aba = /*#__PURE__*/ function(ConfluenceLegacyRecommendedPagesSpaceBehavior) {
    ConfluenceLegacyRecommendedPagesSpaceBehavior["Hidden"] = "HIDDEN";
    ConfluenceLegacyRecommendedPagesSpaceBehavior["Shown"] = "SHOWN";
    return ConfluenceLegacyRecommendedPagesSpaceBehavior;
}({});
let $78ad46e0d6808149$export$c3e45d6c8873afa5 = /*#__PURE__*/ function(ConfluenceLegacyRelationSourceType) {
    ConfluenceLegacyRelationSourceType["User"] = "user";
    return ConfluenceLegacyRelationSourceType;
}({});
let $78ad46e0d6808149$export$9cbd9eca53d8233e = /*#__PURE__*/ function(ConfluenceLegacyRelationTargetType) {
    ConfluenceLegacyRelationTargetType["Content"] = "content";
    ConfluenceLegacyRelationTargetType["Space"] = "space";
    return ConfluenceLegacyRelationTargetType;
}({});
let $78ad46e0d6808149$export$b7e6e1a18c840b8f = /*#__PURE__*/ function(ConfluenceLegacyRelationType) {
    ConfluenceLegacyRelationType["Collaborator"] = "collaborator";
    ConfluenceLegacyRelationType["Favourite"] = "favourite";
    ConfluenceLegacyRelationType["Touched"] = "touched";
    return ConfluenceLegacyRelationType;
}({});
let $78ad46e0d6808149$export$367b84a88c23075f = /*#__PURE__*/ function(ConfluenceLegacyRelevantUserFilter) {
    ConfluenceLegacyRelevantUserFilter["Collaborators"] = "collaborators";
    return ConfluenceLegacyRelevantUserFilter;
}({});
let $78ad46e0d6808149$export$8b22f13531a8344e = /*#__PURE__*/ function(ConfluenceLegacyRelevantUsersSortOrder) {
    ConfluenceLegacyRelevantUsersSortOrder["Asc"] = "asc";
    ConfluenceLegacyRelevantUsersSortOrder["Desc"] = "desc";
    return ConfluenceLegacyRelevantUsersSortOrder;
}({});
let $78ad46e0d6808149$export$376441298d996eee = /*#__PURE__*/ function(ConfluenceLegacyResponseType) {
    ConfluenceLegacyResponseType["BulletListAdf"] = "BULLET_LIST_ADF";
    ConfluenceLegacyResponseType["BulletListMarkdown"] = "BULLET_LIST_MARKDOWN";
    ConfluenceLegacyResponseType["ParagraphPlaintext"] = "PARAGRAPH_PLAINTEXT";
    return ConfluenceLegacyResponseType;
}({});
let $78ad46e0d6808149$export$7f316768f979019e = /*#__PURE__*/ function(ConfluenceLegacyReverseTrialCohort) {
    ConfluenceLegacyReverseTrialCohort["Control"] = "CONTROL";
    ConfluenceLegacyReverseTrialCohort["Enrolled"] = "ENROLLED";
    ConfluenceLegacyReverseTrialCohort["NotEnrolled"] = "NOT_ENROLLED";
    ConfluenceLegacyReverseTrialCohort["Unassigned"] = "UNASSIGNED";
    ConfluenceLegacyReverseTrialCohort["Unknown"] = "UNKNOWN";
    ConfluenceLegacyReverseTrialCohort["Variant"] = "VARIANT";
    return ConfluenceLegacyReverseTrialCohort;
}({});
let $78ad46e0d6808149$export$3bf4e8049523f596 = /*#__PURE__*/ function(ConfluenceLegacyRevertToLegacyEditorResult) {
    ConfluenceLegacyRevertToLegacyEditorResult["NotReverted"] = "NOT_REVERTED";
    ConfluenceLegacyRevertToLegacyEditorResult["Reverted"] = "REVERTED";
    return ConfluenceLegacyRevertToLegacyEditorResult;
}({});
let $78ad46e0d6808149$export$ef682e8bdb6dbe2e = /*#__PURE__*/ function(ConfluenceLegacyRoleAssignmentPrincipalType) {
    ConfluenceLegacyRoleAssignmentPrincipalType["AccessClass"] = "ACCESS_CLASS";
    ConfluenceLegacyRoleAssignmentPrincipalType["Group"] = "GROUP";
    ConfluenceLegacyRoleAssignmentPrincipalType["Team"] = "TEAM";
    ConfluenceLegacyRoleAssignmentPrincipalType["User"] = "USER";
    return ConfluenceLegacyRoleAssignmentPrincipalType;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$e1172c4cec191be2 = /*#__PURE__*/ function(ConfluenceLegacySearchesByTermColumns) {
    ConfluenceLegacySearchesByTermColumns["PageViewedPercentage"] = "pageViewedPercentage";
    ConfluenceLegacySearchesByTermColumns["SearchClickCount"] = "searchClickCount";
    ConfluenceLegacySearchesByTermColumns["SearchSessionCount"] = "searchSessionCount";
    ConfluenceLegacySearchesByTermColumns["SearchTerm"] = "searchTerm";
    ConfluenceLegacySearchesByTermColumns["Total"] = "total";
    ConfluenceLegacySearchesByTermColumns["UniqueUsers"] = "uniqueUsers";
    return ConfluenceLegacySearchesByTermColumns;
}({});
let $78ad46e0d6808149$export$e7d6f21793433a06 = /*#__PURE__*/ function(ConfluenceLegacySearchesByTermPeriod) {
    ConfluenceLegacySearchesByTermPeriod["Day"] = "day";
    ConfluenceLegacySearchesByTermPeriod["Month"] = "month";
    ConfluenceLegacySearchesByTermPeriod["Week"] = "week";
    return ConfluenceLegacySearchesByTermPeriod;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$a199f440cd936cc = /*#__PURE__*/ function(ConfluenceLegacyShareType) {
    ConfluenceLegacyShareType["InviteToEdit"] = "INVITE_TO_EDIT";
    ConfluenceLegacyShareType["SharePage"] = "SHARE_PAGE";
    return ConfluenceLegacyShareType;
}({});
let $78ad46e0d6808149$export$5f5a76dd02b1e8f0 = /*#__PURE__*/ function(ConfluenceLegacySitePermissionOperationType) {
    ConfluenceLegacySitePermissionOperationType["AdministerConfluence"] = "ADMINISTER_CONFLUENCE";
    ConfluenceLegacySitePermissionOperationType["AdministerSystem"] = "ADMINISTER_SYSTEM";
    ConfluenceLegacySitePermissionOperationType["CreateProfileattachment"] = "CREATE_PROFILEATTACHMENT";
    ConfluenceLegacySitePermissionOperationType["CreateSpace"] = "CREATE_SPACE";
    ConfluenceLegacySitePermissionOperationType["ExternalCollaborator"] = "EXTERNAL_COLLABORATOR";
    ConfluenceLegacySitePermissionOperationType["LimitedUseConfluence"] = "LIMITED_USE_CONFLUENCE";
    ConfluenceLegacySitePermissionOperationType["ReadUserprofile"] = "READ_USERPROFILE";
    ConfluenceLegacySitePermissionOperationType["UpdateUserstatus"] = "UPDATE_USERSTATUS";
    ConfluenceLegacySitePermissionOperationType["UseConfluence"] = "USE_CONFLUENCE";
    ConfluenceLegacySitePermissionOperationType["UsePersonalspace"] = "USE_PERSONALSPACE";
    return ConfluenceLegacySitePermissionOperationType;
}({});
let $78ad46e0d6808149$export$c0dc9e525f1888d7 = /*#__PURE__*/ function(ConfluenceLegacySitePermissionType) {
    ConfluenceLegacySitePermissionType["Anonymous"] = "ANONYMOUS";
    ConfluenceLegacySitePermissionType["App"] = "APP";
    ConfluenceLegacySitePermissionType["External"] = "EXTERNAL";
    ConfluenceLegacySitePermissionType["Internal"] = "INTERNAL";
    ConfluenceLegacySitePermissionType["Jsd"] = "JSD";
    return ConfluenceLegacySitePermissionType;
}({});
let $78ad46e0d6808149$export$cacd2625b0eb5c10 = /*#__PURE__*/ function(ConfluenceLegacySitePermissionTypeFilter) {
    ConfluenceLegacySitePermissionTypeFilter["All"] = "ALL";
    ConfluenceLegacySitePermissionTypeFilter["Externalcollaborator"] = "EXTERNALCOLLABORATOR";
    ConfluenceLegacySitePermissionTypeFilter["None"] = "NONE";
    return ConfluenceLegacySitePermissionTypeFilter;
}({}); /** Represents a smart-link on a page */ 
let $78ad46e0d6808149$export$3427a291ccf5b35f = /*#__PURE__*/ function(ConfluenceLegacySpaceAssignmentType) {
    ConfluenceLegacySpaceAssignmentType["Assigned"] = "ASSIGNED";
    ConfluenceLegacySpaceAssignmentType["Unassigned"] = "UNASSIGNED";
    return ConfluenceLegacySpaceAssignmentType;
}({});
let $78ad46e0d6808149$export$66c6ff50e2fe5ded = /*#__PURE__*/ function(ConfluenceLegacySpacePermissionType) {
    ConfluenceLegacySpacePermissionType["AdministerSpace"] = "ADMINISTER_SPACE";
    ConfluenceLegacySpacePermissionType["ArchivePage"] = "ARCHIVE_PAGE";
    ConfluenceLegacySpacePermissionType["Comment"] = "COMMENT";
    ConfluenceLegacySpacePermissionType["CreateAttachment"] = "CREATE_ATTACHMENT";
    ConfluenceLegacySpacePermissionType["CreateEditPage"] = "CREATE_EDIT_PAGE";
    ConfluenceLegacySpacePermissionType["EditBlog"] = "EDIT_BLOG";
    ConfluenceLegacySpacePermissionType["ExportPage"] = "EXPORT_PAGE";
    ConfluenceLegacySpacePermissionType["ExportSpace"] = "EXPORT_SPACE";
    ConfluenceLegacySpacePermissionType["RemoveAttachment"] = "REMOVE_ATTACHMENT";
    ConfluenceLegacySpacePermissionType["RemoveBlog"] = "REMOVE_BLOG";
    ConfluenceLegacySpacePermissionType["RemoveComment"] = "REMOVE_COMMENT";
    ConfluenceLegacySpacePermissionType["RemoveMail"] = "REMOVE_MAIL";
    ConfluenceLegacySpacePermissionType["RemoveOwnContent"] = "REMOVE_OWN_CONTENT";
    ConfluenceLegacySpacePermissionType["RemovePage"] = "REMOVE_PAGE";
    ConfluenceLegacySpacePermissionType["SetPagePermissions"] = "SET_PAGE_PERMISSIONS";
    ConfluenceLegacySpacePermissionType["ViewSpace"] = "VIEW_SPACE";
    return ConfluenceLegacySpacePermissionType;
}({});
let $78ad46e0d6808149$export$f324862e9abce9a4 = /*#__PURE__*/ function(ConfluenceLegacySpaceRoleType) {
    ConfluenceLegacySpaceRoleType["Custom"] = "CUSTOM";
    ConfluenceLegacySpaceRoleType["System"] = "SYSTEM";
    return ConfluenceLegacySpaceRoleType;
}({});
let $78ad46e0d6808149$export$a816519a4452de22 = /*#__PURE__*/ function(ConfluenceLegacySpaceSidebarLinkType) {
    ConfluenceLegacySpaceSidebarLinkType["ExternalLink"] = "EXTERNAL_LINK";
    ConfluenceLegacySpaceSidebarLinkType["Forge"] = "FORGE";
    ConfluenceLegacySpaceSidebarLinkType["PinnedAttachment"] = "PINNED_ATTACHMENT";
    ConfluenceLegacySpaceSidebarLinkType["PinnedBlogPost"] = "PINNED_BLOG_POST";
    ConfluenceLegacySpaceSidebarLinkType["PinnedPage"] = "PINNED_PAGE";
    ConfluenceLegacySpaceSidebarLinkType["PinnedSpace"] = "PINNED_SPACE";
    ConfluenceLegacySpaceSidebarLinkType["PinnedUserInfo"] = "PINNED_USER_INFO";
    ConfluenceLegacySpaceSidebarLinkType["WebItem"] = "WEB_ITEM";
    return ConfluenceLegacySpaceSidebarLinkType;
}({});
let $78ad46e0d6808149$export$4f08231b454021a7 = /*#__PURE__*/ function(ConfluenceLegacySpaceViewsPersistenceOption) {
    ConfluenceLegacySpaceViewsPersistenceOption["Popularity"] = "POPULARITY";
    ConfluenceLegacySpaceViewsPersistenceOption["RecentlyModified"] = "RECENTLY_MODIFIED";
    ConfluenceLegacySpaceViewsPersistenceOption["RecentlyViewed"] = "RECENTLY_VIEWED";
    ConfluenceLegacySpaceViewsPersistenceOption["TitleAz"] = "TITLE_AZ";
    ConfluenceLegacySpaceViewsPersistenceOption["Tree"] = "TREE";
    return ConfluenceLegacySpaceViewsPersistenceOption;
}({});
let $78ad46e0d6808149$export$b1fc899dd9dab99c = /*#__PURE__*/ function(ConfluenceLegacyStalePageStatus) {
    ConfluenceLegacyStalePageStatus["Archived"] = "ARCHIVED";
    ConfluenceLegacyStalePageStatus["Current"] = "CURRENT";
    ConfluenceLegacyStalePageStatus["Draft"] = "DRAFT";
    return ConfluenceLegacyStalePageStatus;
}({});
let $78ad46e0d6808149$export$52d6eaeb13b767d7 = /*#__PURE__*/ function(ConfluenceLegacyStalePagesSortingType) {
    ConfluenceLegacyStalePagesSortingType["Asc"] = "ASC";
    ConfluenceLegacyStalePagesSortingType["Desc"] = "DESC";
    return ConfluenceLegacyStalePagesSortingType;
}({});
let $78ad46e0d6808149$export$2ef0672a533512e5 = /*#__PURE__*/ function(ConfluenceLegacySummaryType) {
    ConfluenceLegacySummaryType["Blogpost"] = "BLOGPOST";
    ConfluenceLegacySummaryType["Page"] = "PAGE";
    return ConfluenceLegacySummaryType;
}({});
let $78ad46e0d6808149$export$ac9323de0f6ac2f9 = /*#__PURE__*/ function(ConfluenceLegacySystemSpaceHomepageTemplate) {
    ConfluenceLegacySystemSpaceHomepageTemplate["Eap"] = "EAP";
    ConfluenceLegacySystemSpaceHomepageTemplate["Minimal"] = "MINIMAL";
    ConfluenceLegacySystemSpaceHomepageTemplate["Visual"] = "VISUAL";
    return ConfluenceLegacySystemSpaceHomepageTemplate;
}({});
let $78ad46e0d6808149$export$d926f0433bfa5cfe = /*#__PURE__*/ function(ConfluenceLegacyTaskStatus) {
    ConfluenceLegacyTaskStatus["Checked"] = "CHECKED";
    ConfluenceLegacyTaskStatus["Unchecked"] = "UNCHECKED";
    return ConfluenceLegacyTaskStatus;
}({});
let $78ad46e0d6808149$export$e59d52222a05db4a = /*#__PURE__*/ function(ConfluenceLegacyTeamCalendarDayOfWeek) {
    ConfluenceLegacyTeamCalendarDayOfWeek["Friday"] = "FRIDAY";
    ConfluenceLegacyTeamCalendarDayOfWeek["Monday"] = "MONDAY";
    ConfluenceLegacyTeamCalendarDayOfWeek["Saturday"] = "SATURDAY";
    ConfluenceLegacyTeamCalendarDayOfWeek["Sunday"] = "SUNDAY";
    ConfluenceLegacyTeamCalendarDayOfWeek["Thursday"] = "THURSDAY";
    ConfluenceLegacyTeamCalendarDayOfWeek["Tuesday"] = "TUESDAY";
    ConfluenceLegacyTeamCalendarDayOfWeek["Wednesday"] = "WEDNESDAY";
    return ConfluenceLegacyTeamCalendarDayOfWeek;
}({});
let $78ad46e0d6808149$export$6fa4f21ea723a4cf = /*#__PURE__*/ function(ConfluenceLegacyTemplateContentAppearance) {
    ConfluenceLegacyTemplateContentAppearance["Default"] = "DEFAULT";
    ConfluenceLegacyTemplateContentAppearance["FullWidth"] = "FULL_WIDTH";
    return ConfluenceLegacyTemplateContentAppearance;
}({}); /** Provides template information. Useful for in - editor template gallery and more in the future. */  /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$a883f3365032d0b5 = /*#__PURE__*/ function(ConfluenceMutationContentStatus) {
    ConfluenceMutationContentStatus["Current"] = "CURRENT";
    ConfluenceMutationContentStatus["Draft"] = "DRAFT";
    return ConfluenceMutationContentStatus;
}({});
let $78ad46e0d6808149$export$629c17cb184cb2f = /*#__PURE__*/ function(ConfluenceOperationName) {
    ConfluenceOperationName["Administer"] = "ADMINISTER";
    ConfluenceOperationName["Archive"] = "ARCHIVE";
    ConfluenceOperationName["Copy"] = "COPY";
    ConfluenceOperationName["Create"] = "CREATE";
    ConfluenceOperationName["CreateSpace"] = "CREATE_SPACE";
    ConfluenceOperationName["Delete"] = "DELETE";
    ConfluenceOperationName["Export"] = "EXPORT";
    ConfluenceOperationName["Move"] = "MOVE";
    ConfluenceOperationName["Purge"] = "PURGE";
    ConfluenceOperationName["PurgeVersion"] = "PURGE_VERSION";
    ConfluenceOperationName["Read"] = "READ";
    ConfluenceOperationName["Restore"] = "RESTORE";
    ConfluenceOperationName["RestrictContent"] = "RESTRICT_CONTENT";
    ConfluenceOperationName["Update"] = "UPDATE";
    ConfluenceOperationName["Use"] = "USE";
    return ConfluenceOperationName;
}({});
let $78ad46e0d6808149$export$406af9bbda9174f7 = /*#__PURE__*/ function(ConfluenceOperationTarget) {
    ConfluenceOperationTarget["Application"] = "APPLICATION";
    ConfluenceOperationTarget["Attachment"] = "ATTACHMENT";
    ConfluenceOperationTarget["BlogPost"] = "BLOG_POST";
    ConfluenceOperationTarget["Comment"] = "COMMENT";
    ConfluenceOperationTarget["Page"] = "PAGE";
    ConfluenceOperationTarget["Space"] = "SPACE";
    ConfluenceOperationTarget["UserProfile"] = "USER_PROFILE";
    return ConfluenceOperationTarget;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:page:confluence__
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$b9563c27e132ecf3 = /*#__PURE__*/ function(ConfluencePageStatus) {
    ConfluencePageStatus["Archived"] = "ARCHIVED";
    ConfluencePageStatus["Current"] = "CURRENT";
    ConfluencePageStatus["Deleted"] = "DELETED";
    ConfluencePageStatus["Draft"] = "DRAFT";
    ConfluencePageStatus["Historical"] = "HISTORICAL";
    ConfluencePageStatus["Trashed"] = "TRASHED";
    return ConfluencePageStatus;
}({});
let $78ad46e0d6808149$export$c5ec0cc4d455d1c8 = /*#__PURE__*/ function(ConfluencePageSubType) {
    ConfluencePageSubType["Live"] = "LIVE";
    return ConfluencePageSubType;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:content.metadata:confluence__
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$d939b611ae8d039c = /*#__PURE__*/ function(ConfluenceSpaceSettingEditorVersion) {
    ConfluenceSpaceSettingEditorVersion["V1"] = "V1";
    ConfluenceSpaceSettingEditorVersion["V2"] = "V2";
    return ConfluenceSpaceSettingEditorVersion;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:space.setting:confluence__
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$2607d60870895ed3 = /*#__PURE__*/ function(ConfluenceSpaceStatus) {
    ConfluenceSpaceStatus["Archived"] = "ARCHIVED";
    ConfluenceSpaceStatus["Current"] = "CURRENT";
    return ConfluenceSpaceStatus;
}({});
let $78ad46e0d6808149$export$2fabe69f8125d5a7 = /*#__PURE__*/ function(ConfluenceSpaceType) {
    ConfluenceSpaceType["Global"] = "GLOBAL";
    ConfluenceSpaceType["Personal"] = "PERSONAL";
    return ConfluenceSpaceType;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:user:confluence__
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$5053ac532e22e9b7 = /*#__PURE__*/ function(ConfluenceUserType) {
    ConfluenceUserType["Anonymous"] = "ANONYMOUS";
    ConfluenceUserType["Known"] = "KNOWN";
    return ConfluenceUserType;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:space:confluence__
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$62c53e2e83119144 = /*#__PURE__*/ function(ContentPlatformBooleanOperators) {
    ContentPlatformBooleanOperators["And"] = "AND";
    ContentPlatformBooleanOperators["Or"] = "OR";
    return ContentPlatformBooleanOperators;
}({});
let $78ad46e0d6808149$export$70152384a4eb0e06 = /*#__PURE__*/ function(ContentPlatformFieldNames) {
    ContentPlatformFieldNames["Description"] = "DESCRIPTION";
    ContentPlatformFieldNames["Title"] = "TITLE";
    return ContentPlatformFieldNames;
}({});
let $78ad46e0d6808149$export$c05e625f37f1df6a = /*#__PURE__*/ function(ContentPlatformOperators) {
    ContentPlatformOperators["All"] = "ALL";
    ContentPlatformOperators["Any"] = "ANY";
    return ContentPlatformOperators;
}({});
let $78ad46e0d6808149$export$e4bac19bb31c7d1 = /*#__PURE__*/ function(ContentPlatformSearchTypes) {
    ContentPlatformSearchTypes["Contains"] = "CONTAINS";
    ContentPlatformSearchTypes["ExactMatch"] = "EXACT_MATCH";
    return ContentPlatformSearchTypes;
}({}); /** Response from creating a deployment */  /** Response from creating an app deployment url */  /** Response from creating an app environment */  /** Response from creating an app */  /** A response to a tunnel creation request */  /**
 * Establish tunnels for a specific environment of an app.
 *
 * This will redirect all function calls to the provided faas url. This URL must implement the same
 * invocation contract that is used elsewhere in Xen.
 *
 * This will also be used to redirect Custom UI product rendering to the custom ui urls. We separate
 * them by extension key.
 */ 
let $78ad46e0d6808149$export$2f3f99f16bab5cdf = /*#__PURE__*/ function(CustomEntityAttributeType) {
    CustomEntityAttributeType["Any"] = "any";
    CustomEntityAttributeType["Boolean"] = "boolean";
    CustomEntityAttributeType["Float"] = "float";
    CustomEntityAttributeType["Integer"] = "integer";
    CustomEntityAttributeType["String"] = "string";
    return CustomEntityAttributeType;
}({}); /** Definition of an existing custom entity when queried */  /** Definition of an existing custom entity index when queried */ 
let $78ad46e0d6808149$export$54f78149dae8a06c = /*#__PURE__*/ function(CustomEntityIndexStatus) {
    CustomEntityIndexStatus["Active"] = "ACTIVE";
    CustomEntityIndexStatus["Creating"] = "CREATING";
    CustomEntityIndexStatus["Inactive"] = "INACTIVE";
    CustomEntityIndexStatus["Pending"] = "PENDING";
    return CustomEntityIndexStatus;
}({}); /** Generic implementation of MutationResponse for responses that don't need any extra data */ 
let $78ad46e0d6808149$export$aecc53098eb55beb = /*#__PURE__*/ function(CustomEntityStatus) {
    CustomEntityStatus["Active"] = "ACTIVE";
    CustomEntityStatus["Inactive"] = "INACTIVE";
    return CustomEntityStatus;
}({}); /**
 * The customer service organization attribute
 * DEPRECATED: use CustomerServiceCustomDetail instead.
 */ 
let $78ad46e0d6808149$export$17ade050935780b6 = /*#__PURE__*/ function(CustomerServiceAttributeTypeName) {
    CustomerServiceAttributeTypeName["Boolean"] = "BOOLEAN";
    CustomerServiceAttributeTypeName["Date"] = "DATE";
    CustomerServiceAttributeTypeName["Email"] = "EMAIL";
    CustomerServiceAttributeTypeName["Multiselect"] = "MULTISELECT";
    CustomerServiceAttributeTypeName["Number"] = "NUMBER";
    CustomerServiceAttributeTypeName["Phone"] = "PHONE";
    CustomerServiceAttributeTypeName["Select"] = "SELECT";
    CustomerServiceAttributeTypeName["Text"] = "TEXT";
    CustomerServiceAttributeTypeName["Url"] = "URL";
    CustomerServiceAttributeTypeName["User"] = "USER";
    return CustomerServiceAttributeTypeName;
}({}); /** DEPRECATED: use CustomerServiceCustomDetailUpdateInput instead. */  /** DEPRECATED: use CustomerServiceCustomDetailUpdatePayload instead. */  /** DEPRECATED: use CustomerServiceCustomDetailUpdateTypeInput instead. */  /**
 * The customer service organization attribute with a value
 * DEPRECATED: use CustomerServiceCustomDetailValue instead.
 */ 
let $78ad46e0d6808149$export$98afe1d41a26dd3b = /*#__PURE__*/ function(CustomerServiceContextType) {
    CustomerServiceContextType["Default"] = "DEFAULT";
    CustomerServiceContextType["Issue"] = "ISSUE";
    return CustomerServiceContextType;
}({}); /** The customer service entity custom detail */  /** Config metadata for a custom detail */ 
let $78ad46e0d6808149$export$65378626fab83b8 = /*#__PURE__*/ function(CustomerServiceCustomDetailCreateErrorCode) {
    CustomerServiceCustomDetailCreateErrorCode["ColorNotSaved"] = "COLOR_NOT_SAVED";
    return CustomerServiceCustomDetailCreateErrorCode;
}({}); /**
 * #########################
 *  Error extensions
 * #########################
 */ 
let $78ad46e0d6808149$export$b39410ef8fd0f614 = /*#__PURE__*/ function(CustomerServiceCustomDetailTypeName) {
    CustomerServiceCustomDetailTypeName["Boolean"] = "BOOLEAN";
    CustomerServiceCustomDetailTypeName["Date"] = "DATE";
    CustomerServiceCustomDetailTypeName["Email"] = "EMAIL";
    CustomerServiceCustomDetailTypeName["Multiselect"] = "MULTISELECT";
    CustomerServiceCustomDetailTypeName["Number"] = "NUMBER";
    CustomerServiceCustomDetailTypeName["Phone"] = "PHONE";
    CustomerServiceCustomDetailTypeName["Select"] = "SELECT";
    CustomerServiceCustomDetailTypeName["Text"] = "TEXT";
    CustomerServiceCustomDetailTypeName["Url"] = "URL";
    CustomerServiceCustomDetailTypeName["User"] = "USER";
    return CustomerServiceCustomDetailTypeName;
}({}); /** The customer service organization attribute with a value */  /** The customer service custom details defined on an entity */  /** The available entities */ 
let $78ad46e0d6808149$export$c8c77ee10baacd37 = /*#__PURE__*/ function(CustomerServiceCustomDetailsEntityType) {
    CustomerServiceCustomDetailsEntityType["Customer"] = "CUSTOMER";
    CustomerServiceCustomDetailsEntityType["Entitlement"] = "ENTITLEMENT";
    CustomerServiceCustomDetailsEntityType["Organization"] = "ORGANIZATION";
    return CustomerServiceCustomDetailsEntityType;
}({}); /**
 * #########################
 *  Query Responses
 * #########################
 */ 
let $78ad46e0d6808149$export$c982791253b48a4e = /*#__PURE__*/ function(CustomerServiceLinkEntityType) {
    CustomerServiceLinkEntityType["Customer"] = "CUSTOMER";
    CustomerServiceLinkEntityType["Organization"] = "ORGANIZATION";
    return CustomerServiceLinkEntityType;
}({}); /**
 * #########################
 *  Query Responses
 * #########################
 */ 
let $78ad46e0d6808149$export$beae497f7881e8b9 = /*#__PURE__*/ function(CustomerServiceNoteEntity) {
    CustomerServiceNoteEntity["Customer"] = "CUSTOMER";
    CustomerServiceNoteEntity["Organization"] = "ORGANIZATION";
    return CustomerServiceNoteEntity;
}({}); /**
 * ###############################
 *  Base objects for notes
 * ###############################
 */ 
let $78ad46e0d6808149$export$950a886e1d68d5 = /*#__PURE__*/ function(CustomerServicePermissionGroupType) {
    CustomerServicePermissionGroupType["Admins"] = "ADMINS";
    CustomerServicePermissionGroupType["AdminsAgents"] = "ADMINS_AGENTS";
    CustomerServicePermissionGroupType["AdminsAgentsCollaborators"] = "ADMINS_AGENTS_COLLABORATORS";
    return CustomerServicePermissionGroupType;
}({}); /**
 * ###############################
 *  Base objects for platform values
 * ###############################
 *  Note: Add any additional platform values to this union
 */ 
let $78ad46e0d6808149$export$94dacf0afef67abf = /*#__PURE__*/ function(DataClassificationPolicyDecisionStatus) {
    DataClassificationPolicyDecisionStatus["Allowed"] = "ALLOWED";
    DataClassificationPolicyDecisionStatus["Blocked"] = "BLOCKED";
    return DataClassificationPolicyDecisionStatus;
}({});
let $78ad46e0d6808149$export$e3d8cf42d600c426 = /*#__PURE__*/ function(DataResidencyResponse) {
    DataResidencyResponse["AppDoesNotSupportDr"] = "APP_DOES_NOT_SUPPORT_DR";
    DataResidencyResponse["NotApplicable"] = "NOT_APPLICABLE";
    DataResidencyResponse["StoredExternalToAtlassian"] = "STORED_EXTERNAL_TO_ATLASSIAN";
    DataResidencyResponse["StoredInAtlassianAndDrNotSupported"] = "STORED_IN_ATLASSIAN_AND_DR_NOT_SUPPORTED";
    DataResidencyResponse["StoredInAtlassianAndDrSupported"] = "STORED_IN_ATLASSIAN_AND_DR_SUPPORTED";
    return DataResidencyResponse;
}({}); /** Time ranges of invocation date. */  /** Response from deleting an app */  /** Generic implementation of MutationResponse for responses that don't need any extra data */  /** Accepts input to delete an external alias. */  /** The payload returned from deleting the external alias of a component. */  /** Accepts input for deleting an existing component. */  /** Accepts input to delete a component link. */  /** The payload retuned after deleting a component link. */  /** The payload returned from deleting an existing component. */  /** Input to delete a component type. */  /** The payload returned after deleting the component type. */  /** Accepts input for deleting an existing relationship between two components. */  /** The payload returned from deleting an existing component. */  /** The payload returned from deleting a scorecard criterion. */  /** Accepts input for deleting a starred component. */  /** Payload returned from deleting a starred component. */  /** Input to delete an individual user defined parameter. */  /** The request input for deleting relationship properties */  /** The response payload of deleting DevOps Service Entity Properties */  /** The request input for deleting a relationship between a DevOps Service and a Jira Project */  /** The request input for deleting a relationship between a DevOps Service and an Opsgenie Team */  /** The response payload of deleting a relationship between a DevOps Service and an Opsgenie Team */  /** The request input for deleting a relationship between a DevOps Service and a Repository */  /** The request input for deleting DevOps Service Entity Properties */  /** The response payload of deleting DevOps Service Entity Properties */  /** The request input for deleting a DevOps Service */  /** The response payload of deleting a DevOps Service */  /** The request input for deleting a DevOps Service Relationship */  /** The request input for deleting a relationship between a Jira project and a repository */  /** Delete sprint */  /** Response from creating an webtrigger url */  /**
 * This object models the Continuous Delivery (CD) Pipeline concept, an automated process (usually comprised of multiple stages)
 * for getting software from version control right through to the production environment.
 */ 
let $78ad46e0d6808149$export$a12a01ce2571070a = /*#__PURE__*/ function(DeploymentState) {
    DeploymentState["Cancelled"] = "CANCELLED";
    DeploymentState["Failed"] = "FAILED";
    DeploymentState["InProgress"] = "IN_PROGRESS";
    DeploymentState["Pending"] = "PENDING";
    DeploymentState["RolledBack"] = "ROLLED_BACK";
    DeploymentState["Successful"] = "SUCCESSFUL";
    DeploymentState["Unknown"] = "UNKNOWN";
    return DeploymentState;
}({}); /**
 * This object models a deployment in the Continuous Delivery (CD) Pipeline concept, an automated process (usually comprised of
 * multiple stages) for getting software from version control right through to the production environment.
 */ 
let $78ad46e0d6808149$export$63bd3fb0666e773f = /*#__PURE__*/ function(DevAiAutofixScanSortField) {
    DevAiAutofixScanSortField["StartDate"] = "START_DATE";
    return DevAiAutofixScanSortField;
}({});
let $78ad46e0d6808149$export$f25325441f229f64 = /*#__PURE__*/ function(DevAiAutofixScanStatus) {
    DevAiAutofixScanStatus["Completed"] = "COMPLETED";
    DevAiAutofixScanStatus["Failed"] = "FAILED";
    DevAiAutofixScanStatus["InProgress"] = "IN_PROGRESS";
    return DevAiAutofixScanStatus;
}({});
let $78ad46e0d6808149$export$d09e4c4b79589a66 = /*#__PURE__*/ function(DevAiAutofixTaskSortField) {
    DevAiAutofixTaskSortField["CreatedAt"] = "CREATED_AT";
    DevAiAutofixTaskSortField["Filename"] = "FILENAME";
    DevAiAutofixTaskSortField["NewCoveragePercentage"] = "NEW_COVERAGE_PERCENTAGE";
    DevAiAutofixTaskSortField["PreviousCoveragePercentage"] = "PREVIOUS_COVERAGE_PERCENTAGE";
    DevAiAutofixTaskSortField["PrimaryLanguage"] = "PRIMARY_LANGUAGE";
    DevAiAutofixTaskSortField["Status"] = "STATUS";
    DevAiAutofixTaskSortField["UpdatedAt"] = "UPDATED_AT";
    return DevAiAutofixTaskSortField;
}({});
let $78ad46e0d6808149$export$265f04bd9f283d5d = /*#__PURE__*/ function(DevAiAutofixTaskStatus) {
    DevAiAutofixTaskStatus["PrDeclined"] = "PR_DECLINED";
    DevAiAutofixTaskStatus["PrMerged"] = "PR_MERGED";
    DevAiAutofixTaskStatus["PrOpened"] = "PR_OPENED";
    DevAiAutofixTaskStatus["WorkflowCancelled"] = "WORKFLOW_CANCELLED";
    DevAiAutofixTaskStatus["WorkflowCompleted"] = "WORKFLOW_COMPLETED";
    DevAiAutofixTaskStatus["WorkflowInprogress"] = "WORKFLOW_INPROGRESS";
    DevAiAutofixTaskStatus["WorkflowPending"] = "WORKFLOW_PENDING";
    return DevAiAutofixTaskStatus;
}({});
let $78ad46e0d6808149$export$e81a3fe0d2b413f = /*#__PURE__*/ function(DevAiScanIntervalUnit) {
    DevAiScanIntervalUnit["Days"] = "DAYS";
    DevAiScanIntervalUnit["Months"] = "MONTHS";
    DevAiScanIntervalUnit["Weeks"] = "WEEKS";
    return DevAiScanIntervalUnit;
}({}); /** Input to enable/disable Autofix for a repository. */ 
let $78ad46e0d6808149$export$bfbfde65991aaecf = /*#__PURE__*/ function(DevAiSupportedRepoFilterOption) {
    DevAiSupportedRepoFilterOption["All"] = "ALL";
    DevAiSupportedRepoFilterOption["DisabledOnly"] = "DISABLED_ONLY";
    DevAiSupportedRepoFilterOption["EnabledOnly"] = "ENABLED_ONLY";
    return DevAiSupportedRepoFilterOption;
}({}); /** Input to trigger an autofix scan of a repository */  /** The return payload for triggering an Autofix repository Scan */  /** Data-Depot Build Provider details. */  /** Data-Depot Build Provider details. */  /** The state of a build. */ 
let $78ad46e0d6808149$export$38ae85b0603265fc = /*#__PURE__*/ function(DevOpsBuildState) {
    DevOpsBuildState["Cancelled"] = "CANCELLED";
    DevOpsBuildState["Failed"] = "FAILED";
    DevOpsBuildState["InProgress"] = "IN_PROGRESS";
    DevOpsBuildState["Pending"] = "PENDING";
    DevOpsBuildState["Successful"] = "SUCCESSFUL";
    DevOpsBuildState["Unknown"] = "UNKNOWN";
    return DevOpsBuildState;
}({});
let $78ad46e0d6808149$export$e81f0008646134d2 = /*#__PURE__*/ function(DevOpsComponentTier) {
    DevOpsComponentTier["Tier_1"] = "TIER_1";
    DevOpsComponentTier["Tier_2"] = "TIER_2";
    DevOpsComponentTier["Tier_3"] = "TIER_3";
    DevOpsComponentTier["Tier_4"] = "TIER_4";
    return DevOpsComponentTier;
}({});
let $78ad46e0d6808149$export$1ecef45184e0481 = /*#__PURE__*/ function(DevOpsComponentType) {
    DevOpsComponentType["Application"] = "APPLICATION";
    DevOpsComponentType["Capability"] = "CAPABILITY";
    DevOpsComponentType["CloudResource"] = "CLOUD_RESOURCE";
    DevOpsComponentType["DataPipeline"] = "DATA_PIPELINE";
    DevOpsComponentType["Library"] = "LIBRARY";
    DevOpsComponentType["MachineLearningModel"] = "MACHINE_LEARNING_MODEL";
    DevOpsComponentType["Other"] = "OTHER";
    DevOpsComponentType["Service"] = "SERVICE";
    DevOpsComponentType["UiElement"] = "UI_ELEMENT";
    DevOpsComponentType["Website"] = "WEBSITE";
    return DevOpsComponentType;
}({}); /** Data-Depot Component Provider details. */  /** Data-Depot Component Provider details. */  /** Data-Depot Component Provider details. */  /** Data-Depot Deployment Provider details. */  /** Data-Depot Deployment Provider details. */  /** ## Data Depot Designs ### */  /** ## Data Depot Designs ### */  /** ## Data Depot Designs ### */  /** Data-Depot Design Provider details. */  /** Data-Depot Design Provider details. */ 
let $78ad46e0d6808149$export$8e9c2240003b2ba6 = /*#__PURE__*/ function(DevOpsDesignStatus) {
    DevOpsDesignStatus["None"] = "NONE";
    DevOpsDesignStatus["ReadyForDevelopment"] = "READY_FOR_DEVELOPMENT";
    DevOpsDesignStatus["Unknown"] = "UNKNOWN";
    return DevOpsDesignStatus;
}({});
let $78ad46e0d6808149$export$279a4200dae77ac6 = /*#__PURE__*/ function(DevOpsDesignType) {
    DevOpsDesignType["Canvas"] = "CANVAS";
    DevOpsDesignType["File"] = "FILE";
    DevOpsDesignType["Group"] = "GROUP";
    DevOpsDesignType["Node"] = "NODE";
    DevOpsDesignType["Other"] = "OTHER";
    DevOpsDesignType["Prototype"] = "PROTOTYPE";
    return DevOpsDesignType;
}({}); /** Data-Depot Dev Info Provider details. */  /** Data-Depot Dev Info Provider details. */  /** Data-Depot Dev Info Provider details. */  /** Document Category */ 
let $78ad46e0d6808149$export$eeb884a29ae659e4 = /*#__PURE__*/ function(DevOpsDocumentCategory) {
    DevOpsDocumentCategory["Archive"] = "ARCHIVE";
    DevOpsDocumentCategory["Audio"] = "AUDIO";
    DevOpsDocumentCategory["Code"] = "CODE";
    DevOpsDocumentCategory["Document"] = "DOCUMENT";
    DevOpsDocumentCategory["Folder"] = "FOLDER";
    DevOpsDocumentCategory["Form"] = "FORM";
    DevOpsDocumentCategory["Image"] = "IMAGE";
    DevOpsDocumentCategory["Other"] = "OTHER";
    DevOpsDocumentCategory["Pdf"] = "PDF";
    DevOpsDocumentCategory["Presentation"] = "PRESENTATION";
    DevOpsDocumentCategory["Shortcut"] = "SHORTCUT";
    DevOpsDocumentCategory["Spreadsheet"] = "SPREADSHEET";
    DevOpsDocumentCategory["Video"] = "VIDEO";
    return DevOpsDocumentCategory;
}({}); /** Data-Depot Documentation Provider details. */  /** Data-Depot Documentation Provider details. */  /** Data-Depot Documentation Provider details. */  /**
 * An environment that a code change can be released to.
 *
 * The release may be via a code deployment or via a feature flag change.
 */ 
let $78ad46e0d6808149$export$d897dc8d29fd16eb = /*#__PURE__*/ function(DevOpsEnvironmentCategory) {
    DevOpsEnvironmentCategory["Development"] = "DEVELOPMENT";
    DevOpsEnvironmentCategory["Production"] = "PRODUCTION";
    DevOpsEnvironmentCategory["Staging"] = "STAGING";
    DevOpsEnvironmentCategory["Testing"] = "TESTING";
    DevOpsEnvironmentCategory["Unmapped"] = "UNMAPPED";
    return DevOpsEnvironmentCategory;
}({});
let $78ad46e0d6808149$export$651219dc3d44cf93 = /*#__PURE__*/ function(DevOpsJiraProjectType) {
    DevOpsJiraProjectType["JiraCore"] = "JIRA_CORE";
    DevOpsJiraProjectType["JiraServicedesk"] = "JIRA_SERVICEDESK";
    DevOpsJiraProjectType["JiraSoftware"] = "JIRA_SOFTWARE";
    return DevOpsJiraProjectType;
}({});
let $78ad46e0d6808149$export$18fde50976ec82dd = /*#__PURE__*/ function(DevOpsMetricsCycleTimePhase) {
    DevOpsMetricsCycleTimePhase["CommitToDeployment"] = "COMMIT_TO_DEPLOYMENT";
    DevOpsMetricsCycleTimePhase["CommitToPr"] = "COMMIT_TO_PR";
    return DevOpsMetricsCycleTimePhase;
}({}); /** #### Response ##### */  /** No results will be returned unless an association type is specified. Currently only 'jiraProjectIds' association type is supported. */  /** No results will be returned unless an association type is specified. Currently only 'jiraProjectIds' association type is supported. */  /** No results will be returned unless an association type is specified. Currently only 'jiraProjectIds' association type is supported. */  /** Unit for specified resolution value. */ 
let $78ad46e0d6808149$export$1f082d6bdd7f11d5 = /*#__PURE__*/ function(DevOpsMetricsResolutionUnit) {
    DevOpsMetricsResolutionUnit["Day"] = "DAY";
    DevOpsMetricsResolutionUnit["Hour"] = "HOUR";
    DevOpsMetricsResolutionUnit["Week"] = "WEEK";
    return DevOpsMetricsResolutionUnit;
}({});
let $78ad46e0d6808149$export$fdde013eb4eeffed = /*#__PURE__*/ function(DevOpsMetricsRollupOption) {
    DevOpsMetricsRollupOption["Mean"] = "MEAN";
    DevOpsMetricsRollupOption["Percentile"] = "PERCENTILE";
    return DevOpsMetricsRollupOption;
}({});
let $78ad46e0d6808149$export$ab7231643ddbb509 = /*#__PURE__*/ function(DevOpsOperationsIncidentSeverity) {
    DevOpsOperationsIncidentSeverity["P1"] = "P1";
    DevOpsOperationsIncidentSeverity["P2"] = "P2";
    DevOpsOperationsIncidentSeverity["P3"] = "P3";
    DevOpsOperationsIncidentSeverity["P4"] = "P4";
    DevOpsOperationsIncidentSeverity["P5"] = "P5";
    DevOpsOperationsIncidentSeverity["Pending"] = "PENDING";
    DevOpsOperationsIncidentSeverity["Unknown"] = "UNKNOWN";
    return DevOpsOperationsIncidentSeverity;
}({});
let $78ad46e0d6808149$export$3ef3f18ee7a943de = /*#__PURE__*/ function(DevOpsOperationsIncidentStatus) {
    DevOpsOperationsIncidentStatus["Open"] = "OPEN";
    DevOpsOperationsIncidentStatus["Resolved"] = "RESOLVED";
    DevOpsOperationsIncidentStatus["Unknown"] = "UNKNOWN";
    return DevOpsOperationsIncidentStatus;
}({}); /** Data-Depot Operations Provider details. */  /** Data-Depot Operations Provider details. */  /** Data-Depot Operations Provider details. */ 
let $78ad46e0d6808149$export$1c5eb757d029c7d0 = /*#__PURE__*/ function(DevOpsPostIncidentReviewStatus) {
    DevOpsPostIncidentReviewStatus["Completed"] = "COMPLETED";
    DevOpsPostIncidentReviewStatus["InProgress"] = "IN_PROGRESS";
    DevOpsPostIncidentReviewStatus["Todo"] = "TODO";
    return DevOpsPostIncidentReviewStatus;
}({});
let $78ad46e0d6808149$export$8fd61af3426661d5 = /*#__PURE__*/ function(DevOpsProjectStatus) {
    DevOpsProjectStatus["Cancelled"] = "CANCELLED";
    DevOpsProjectStatus["Completed"] = "COMPLETED";
    DevOpsProjectStatus["InProgress"] = "IN_PROGRESS";
    DevOpsProjectStatus["Paused"] = "PAUSED";
    DevOpsProjectStatus["Pending"] = "PENDING";
    DevOpsProjectStatus["Unknown"] = "UNKNOWN";
    return DevOpsProjectStatus;
}({});
let $78ad46e0d6808149$export$3ba9c1ac88495bed = /*#__PURE__*/ function(DevOpsProjectTargetDateType) {
    DevOpsProjectTargetDateType["Day"] = "DAY";
    DevOpsProjectTargetDateType["Month"] = "MONTH";
    DevOpsProjectTargetDateType["Quarter"] = "QUARTER";
    DevOpsProjectTargetDateType["Unknown"] = "UNKNOWN";
    return DevOpsProjectTargetDateType;
}({}); /** A provider that a deployment has been done with. */  /** A type to group various URLs of Provider */ 
let $78ad46e0d6808149$export$2190b10e3dc81d80 = /*#__PURE__*/ function(DevOpsProviderNamespace) {
    DevOpsProviderNamespace["Asap"] = "ASAP";
    DevOpsProviderNamespace["Classic"] = "CLASSIC";
    DevOpsProviderNamespace["Forge"] = "FORGE";
    DevOpsProviderNamespace["Oauth"] = "OAUTH";
    return DevOpsProviderNamespace;
}({}); /**
 * Type of a data-depot provider.
 * A provider may belongs to multiple types (e.g an connect-app can send both build and deployment info).
 */ 
let $78ad46e0d6808149$export$e0671d592d4ff2a3 = /*#__PURE__*/ function(DevOpsProviderType) {
    DevOpsProviderType["Build"] = "BUILD";
    DevOpsProviderType["Deployment"] = "DEPLOYMENT";
    DevOpsProviderType["Design"] = "DESIGN";
    DevOpsProviderType["DevopsComponents"] = "DEVOPS_COMPONENTS";
    DevOpsProviderType["DevInfo"] = "DEV_INFO";
    DevOpsProviderType["Documentation"] = "DOCUMENTATION";
    DevOpsProviderType["FeatureFlag"] = "FEATURE_FLAG";
    DevOpsProviderType["Operations"] = "OPERATIONS";
    DevOpsProviderType["Project"] = "PROJECT";
    DevOpsProviderType["RemoteLinks"] = "REMOTE_LINKS";
    DevOpsProviderType["Security"] = "SECURITY";
    return DevOpsProviderType;
}({});
let $78ad46e0d6808149$export$4ccf930134e74702 = /*#__PURE__*/ function(DevOpsPullRequestApprovalStatus) {
    DevOpsPullRequestApprovalStatus["Approved"] = "APPROVED";
    DevOpsPullRequestApprovalStatus["Needswork"] = "NEEDSWORK";
    DevOpsPullRequestApprovalStatus["Unapproved"] = "UNAPPROVED";
    return DevOpsPullRequestApprovalStatus;
}({});
let $78ad46e0d6808149$export$4dec602c1ab1d95e = /*#__PURE__*/ function(DevOpsPullRequestStatus) {
    DevOpsPullRequestStatus["Declined"] = "DECLINED";
    DevOpsPullRequestStatus["Draft"] = "DRAFT";
    DevOpsPullRequestStatus["Merged"] = "MERGED";
    DevOpsPullRequestStatus["Open"] = "OPEN";
    DevOpsPullRequestStatus["Unknown"] = "UNKNOWN";
    return DevOpsPullRequestStatus;
}({});
let $78ad46e0d6808149$export$13a31923d75e3a27 = /*#__PURE__*/ function(DevOpsRelationshipCertainty) {
    DevOpsRelationshipCertainty["Explicit"] = "EXPLICIT";
    DevOpsRelationshipCertainty["Implicit"] = "IMPLICIT";
    return DevOpsRelationshipCertainty;
}({});
let $78ad46e0d6808149$export$c5657a9969e35205 = /*#__PURE__*/ function(DevOpsRelationshipCertaintyFilter) {
    DevOpsRelationshipCertaintyFilter["All"] = "ALL";
    DevOpsRelationshipCertaintyFilter["Explicit"] = "EXPLICIT";
    DevOpsRelationshipCertaintyFilter["Implicit"] = "IMPLICIT";
    return DevOpsRelationshipCertaintyFilter;
}({}); /** Data-Depot Remote Links Provider details. */  /** Data-Depot Remote Links Provider details. */ 
let $78ad46e0d6808149$export$15a0db675256459b = /*#__PURE__*/ function(DevOpsRepositoryHostingProviderFilter) {
    DevOpsRepositoryHostingProviderFilter["All"] = "ALL";
    DevOpsRepositoryHostingProviderFilter["BitbucketCloud"] = "BITBUCKET_CLOUD";
    DevOpsRepositoryHostingProviderFilter["ThirdParty"] = "THIRD_PARTY";
    return DevOpsRepositoryHostingProviderFilter;
}({}); /** Data-Depot Security Provider details. */  /** Data-Depot Security Provider details. */  /** Data-Depot Security Provider details. */  /** Data-Depot Security Provider details. */  /** Data-Depot Security Provider details. */  /** ## Data Depot Security Vulnerabilities ### */  /** ## Data Depot Security Vulnerabilities ### */ 
let $78ad46e0d6808149$export$24e732e98f25b4d9 = /*#__PURE__*/ function(DevOpsSecurityVulnerabilitySeverity) {
    DevOpsSecurityVulnerabilitySeverity["Critical"] = "CRITICAL";
    DevOpsSecurityVulnerabilitySeverity["High"] = "HIGH";
    DevOpsSecurityVulnerabilitySeverity["Low"] = "LOW";
    DevOpsSecurityVulnerabilitySeverity["Medium"] = "MEDIUM";
    DevOpsSecurityVulnerabilitySeverity["Unknown"] = "UNKNOWN";
    return DevOpsSecurityVulnerabilitySeverity;
}({});
let $78ad46e0d6808149$export$a1202d25589419a7 = /*#__PURE__*/ function(DevOpsSecurityVulnerabilityStatus) {
    DevOpsSecurityVulnerabilityStatus["Closed"] = "CLOSED";
    DevOpsSecurityVulnerabilityStatus["Ignored"] = "IGNORED";
    DevOpsSecurityVulnerabilityStatus["Open"] = "OPEN";
    DevOpsSecurityVulnerabilityStatus["Unknown"] = "UNKNOWN";
    return DevOpsSecurityVulnerabilityStatus;
}({}); /** A relationship between DevOps Service and Jira Project Team */  /** A relationship between DevOps Service and Jira Project Team */ 
let $78ad46e0d6808149$export$82bbaba9292627e1 = /*#__PURE__*/ function(DevOpsServiceAndJiraProjectRelationshipType) {
    DevOpsServiceAndJiraProjectRelationshipType["ChangeManagement"] = "CHANGE_MANAGEMENT";
    DevOpsServiceAndJiraProjectRelationshipType["Default"] = "DEFAULT";
    return DevOpsServiceAndJiraProjectRelationshipType;
}({}); /** A relationship between DevOps Service and Opsgenie Team */  /** A relationship between DevOps Service and Opsgenie Team */  /** A relationship between a DevOps Service and a Repository */  /** A relationship between a DevOps Service and a Repository */ 
let $78ad46e0d6808149$export$c3e0b3161314e204 = /*#__PURE__*/ function(DevOpsServiceAndRepositoryRelationshipSortBy) {
    DevOpsServiceAndRepositoryRelationshipSortBy["LastInferredAt"] = "LAST_INFERRED_AT";
    return DevOpsServiceAndRepositoryRelationshipSortBy;
}({}); /** The connection object for a collection of Services. */  /** The request input for DevOps Service Entity Property */  /** The connection object for a collection of DevOps Service relationships. */  /** #################### Enums ##################### */ 
let $78ad46e0d6808149$export$cd3c7b586cbb9da5 = /*#__PURE__*/ function(DevOpsServiceRelationshipType) {
    DevOpsServiceRelationshipType["Contains"] = "CONTAINS";
    DevOpsServiceRelationshipType["DependsOn"] = "DEPENDS_ON";
    return DevOpsServiceRelationshipType;
}({}); /** The filtering input for retrieving services. tierLevelIn must not be empty if provided. */  /** Summary of the builds associated with an entity. */  /** #################### Supporting Types ##################### */  /** Represents a product or tool in a DevOps suite */  /** Represents a product or tool in a DevOps suite */  /** Represents a product or tool in a DevOps suite */  /** Represents a product or tool in a DevOps suite */  /** ######################################### Mutations ########################################## */  /** The integration details for the DevOps tool */  /** A marketplace app integration */  /** An Atlassian product integration */ 
let $78ad46e0d6808149$export$b4d01a63edd297ec = /*#__PURE__*/ function(DevOpsToolIntegrationType) {
    DevOpsToolIntegrationType["Any"] = "ANY";
    DevOpsToolIntegrationType["App"] = "APP";
    DevOpsToolIntegrationType["Exists"] = "EXISTS";
    DevOpsToolIntegrationType["None"] = "NONE";
    DevOpsToolIntegrationType["Product"] = "PRODUCT";
    return DevOpsToolIntegrationType;
}({});
let $78ad46e0d6808149$export$1371117f8b853f61 = /*#__PURE__*/ function(DevOpsToolSortOrder) {
    DevOpsToolSortOrder["Asc"] = "ASC";
    DevOpsToolSortOrder["Desc"] = "DESC";
    return DevOpsToolSortOrder;
}({}); /**
 * A user that could tie to a first-party user and/or a third-party user.
 *
 * - "user" is supplied if it is a first-party user
 * - "thirdPartyUser" is supplied if it is a third-party user
 * - Both "user" and "thirdPartyUser" could be supplied if a user matches both a first-party user and a third-party user
 * - Neither "user" nor "thirdPartyUser" is supplied if the user is not found, but they exist. For example, a Pull Request might have a user, but we just don't know who that user is.
 */ 
let $78ad46e0d6808149$export$861966f1b6eab176 = /*#__PURE__*/ function(DevStatusActivity) {
    DevStatusActivity["BranchOpen"] = "BRANCH_OPEN";
    DevStatusActivity["Commit"] = "COMMIT";
    DevStatusActivity["Deployment"] = "DEPLOYMENT";
    DevStatusActivity["Design"] = "DESIGN";
    DevStatusActivity["PrDeclined"] = "PR_DECLINED";
    DevStatusActivity["PrMerged"] = "PR_MERGED";
    DevStatusActivity["PrOpen"] = "PR_OPEN";
    return DevStatusActivity;
}({});
let $78ad46e0d6808149$export$250c76f3771f8949 = /*#__PURE__*/ function(EcosystemAppNetworkPermissionType) {
    EcosystemAppNetworkPermissionType["Connect"] = "CONNECT";
    return EcosystemAppNetworkPermissionType;
}({});
let $78ad46e0d6808149$export$f432b7347a6f0100 = /*#__PURE__*/ function(EcosystemAppsInstalledInContextsFilterType) {
    EcosystemAppsInstalledInContextsFilterType["Name"] = "NAME";
    EcosystemAppsInstalledInContextsFilterType["OnlyAppIds"] = "ONLY_APP_IDS";
    return EcosystemAppsInstalledInContextsFilterType;
}({});
let $78ad46e0d6808149$export$123dfeb539fdf7e4 = /*#__PURE__*/ function(EcosystemAppsInstalledInContextsSortKey) {
    EcosystemAppsInstalledInContextsSortKey["Name"] = "NAME";
    EcosystemAppsInstalledInContextsSortKey["RelatedApps"] = "RELATED_APPS";
    return EcosystemAppsInstalledInContextsSortKey;
}({}); /** Edit sprint */  /** Estimate object which contains an estimate for a card when it exists */ 
let $78ad46e0d6808149$export$38fe23235d685c0d = /*#__PURE__*/ function(EstimationType) {
    EstimationType["CustomNumberField"] = "CUSTOM_NUMBER_FIELD";
    EstimationType["IssueCount"] = "ISSUE_COUNT";
    EstimationType["OriginalEstimate"] = "ORIGINAL_ESTIMATE";
    EstimationType["StoryPoints"] = "STORY_POINTS";
    return EstimationType;
}({}); /** Compass Events */  /** Compass Events */  /** An arbitrary extension definition as defined by the Ecosystem */  /** An arbitrary extension definition as defined by the Ecosystem */  /** The context in which an extension exists */  /** The context in which an extension exists */  /** The context in which an extension exists */  /** The context in which an extension exists */  /** The context in which an extension exists */  /** The context in which an extension exists */ 
let $78ad46e0d6808149$export$f7fc910e99a97ad = /*#__PURE__*/ function(ExtensionContextsFilterType) {
    ExtensionContextsFilterType["AppIdEnvironmentId"] = "APP_ID_ENVIRONMENT_ID";
    ExtensionContextsFilterType["DataClassificationTag"] = "DATA_CLASSIFICATION_TAG";
    ExtensionContextsFilterType["DefinitionId"] = "DEFINITION_ID";
    ExtensionContextsFilterType["ExtensionType"] = "EXTENSION_TYPE";
    ExtensionContextsFilterType["PrincipalType"] = "PRINCIPAL_TYPE";
    return ExtensionContextsFilterType;
}({}); /**
 * Details about an extension.
 *
 * This information is used to look up the extension within CaaS so that the
 * correct function can be resolved.
 *
 * This will eventually be superseded by an Id.
 */ 
let $78ad46e0d6808149$export$d11f0d213b47454b = /*#__PURE__*/ function(ExternalApprovalStatus) {
    ExternalApprovalStatus["Approved"] = "APPROVED";
    ExternalApprovalStatus["Needswork"] = "NEEDSWORK";
    ExternalApprovalStatus["Unapproved"] = "UNAPPROVED";
    return ExternalApprovalStatus;
}({}); /**
 * Supported associations ATIs in Data Depot
 *   Implemented for hydration
 *     * GRAPH_SERVICE
 *     * JIRA_ISSUE
 *     * JIRA_DOCUMENT
 *     * JIRA_PROJECT
 *     * JIRA_VERSION
 *     * THIRD_PARTY_USER
 *   To be implemented
 *     * COMPASS_EVENT_SOURCE
 *     * COMPASS_COMPONENT
 *     * MERCURY_FOCUS_AREA
 *     * THIRD_PARTY_GROUP
 */ 
let $78ad46e0d6808149$export$a529a83fbd574a83 = /*#__PURE__*/ function(ExternalBuildState) {
    ExternalBuildState["Cancelled"] = "CANCELLED";
    ExternalBuildState["Failed"] = "FAILED";
    ExternalBuildState["InProgress"] = "IN_PROGRESS";
    ExternalBuildState["Pending"] = "PENDING";
    ExternalBuildState["Successful"] = "SUCCESSFUL";
    ExternalBuildState["Unknown"] = "UNKNOWN";
    return ExternalBuildState;
}({});
let $78ad46e0d6808149$export$21df421064bf3919 = /*#__PURE__*/ function(ExternalChangeType) {
    ExternalChangeType["Added"] = "ADDED";
    ExternalChangeType["Copied"] = "COPIED";
    ExternalChangeType["Deleted"] = "DELETED";
    ExternalChangeType["Modified"] = "MODIFIED";
    ExternalChangeType["Moved"] = "MOVED";
    ExternalChangeType["Unknown"] = "UNKNOWN";
    return ExternalChangeType;
}({});
let $78ad46e0d6808149$export$6759ac6277d955dd = /*#__PURE__*/ function(ExternalCommitFlags) {
    ExternalCommitFlags["MergeCommit"] = "MERGE_COMMIT";
    return ExternalCommitFlags;
}({});
let $78ad46e0d6808149$export$bbf4ad4fb3d17b4c = /*#__PURE__*/ function(ExternalConversationType) {
    ExternalConversationType["Channel"] = "CHANNEL";
    ExternalConversationType["DirectMessage"] = "DIRECT_MESSAGE";
    ExternalConversationType["GroupDirectMessage"] = "GROUP_DIRECT_MESSAGE";
    return ExternalConversationType;
}({});
let $78ad46e0d6808149$export$2b3de6bf362bc793 = /*#__PURE__*/ function(ExternalDeploymentState) {
    ExternalDeploymentState["Cancelled"] = "CANCELLED";
    ExternalDeploymentState["Failed"] = "FAILED";
    ExternalDeploymentState["InProgress"] = "IN_PROGRESS";
    ExternalDeploymentState["Pending"] = "PENDING";
    ExternalDeploymentState["RolledBack"] = "ROLLED_BACK";
    ExternalDeploymentState["Successful"] = "SUCCESSFUL";
    ExternalDeploymentState["Unknown"] = "UNKNOWN";
    return ExternalDeploymentState;
}({});
let $78ad46e0d6808149$export$b3dbc3bb1f3d376e = /*#__PURE__*/ function(ExternalDesignStatus) {
    ExternalDesignStatus["None"] = "NONE";
    ExternalDesignStatus["ReadyForDevelopment"] = "READY_FOR_DEVELOPMENT";
    ExternalDesignStatus["Unknown"] = "UNKNOWN";
    return ExternalDesignStatus;
}({});
let $78ad46e0d6808149$export$697e56d9e72094e7 = /*#__PURE__*/ function(ExternalDesignType) {
    ExternalDesignType["Canvas"] = "CANVAS";
    ExternalDesignType["File"] = "FILE";
    ExternalDesignType["Group"] = "GROUP";
    ExternalDesignType["Node"] = "NODE";
    ExternalDesignType["Other"] = "OTHER";
    ExternalDesignType["Prototype"] = "PROTOTYPE";
    return ExternalDesignType;
}({});
let $78ad46e0d6808149$export$febd917fd954ad28 = /*#__PURE__*/ function(ExternalDocumentCategory) {
    ExternalDocumentCategory["Archive"] = "ARCHIVE";
    ExternalDocumentCategory["Audio"] = "AUDIO";
    ExternalDocumentCategory["Code"] = "CODE";
    ExternalDocumentCategory["Document"] = "DOCUMENT";
    ExternalDocumentCategory["Folder"] = "FOLDER";
    ExternalDocumentCategory["Form"] = "FORM";
    ExternalDocumentCategory["Image"] = "IMAGE";
    ExternalDocumentCategory["Other"] = "OTHER";
    ExternalDocumentCategory["Pdf"] = "PDF";
    ExternalDocumentCategory["Presentation"] = "PRESENTATION";
    ExternalDocumentCategory["Shortcut"] = "SHORTCUT";
    ExternalDocumentCategory["Spreadsheet"] = "SPREADSHEET";
    ExternalDocumentCategory["Video"] = "VIDEO";
    ExternalDocumentCategory["WebPage"] = "WEB_PAGE";
    return ExternalDocumentCategory;
}({}); /** Return one or the supported model */ 
let $78ad46e0d6808149$export$58380f2014542325 = /*#__PURE__*/ function(ExternalEnvironmentType) {
    ExternalEnvironmentType["Development"] = "DEVELOPMENT";
    ExternalEnvironmentType["Production"] = "PRODUCTION";
    ExternalEnvironmentType["Staging"] = "STAGING";
    ExternalEnvironmentType["Testing"] = "TESTING";
    ExternalEnvironmentType["Unmapped"] = "UNMAPPED";
    return ExternalEnvironmentType;
}({});
let $78ad46e0d6808149$export$7fbe6f4fd7f8b720 = /*#__PURE__*/ function(ExternalMembershipType) {
    ExternalMembershipType["Private"] = "PRIVATE";
    ExternalMembershipType["Public"] = "PUBLIC";
    ExternalMembershipType["Shared"] = "SHARED";
    return ExternalMembershipType;
}({});
let $78ad46e0d6808149$export$589c937a173b601d = /*#__PURE__*/ function(ExternalPullRequestStatus) {
    ExternalPullRequestStatus["Declined"] = "DECLINED";
    ExternalPullRequestStatus["Draft"] = "DRAFT";
    ExternalPullRequestStatus["Merged"] = "MERGED";
    ExternalPullRequestStatus["Open"] = "OPEN";
    ExternalPullRequestStatus["Unknown"] = "UNKNOWN";
    return ExternalPullRequestStatus;
}({});
let $78ad46e0d6808149$export$6935f9834af32b63 = /*#__PURE__*/ function(ExternalVulnerabilitySeverityLevel) {
    ExternalVulnerabilitySeverityLevel["Critical"] = "CRITICAL";
    ExternalVulnerabilitySeverityLevel["High"] = "HIGH";
    ExternalVulnerabilitySeverityLevel["Low"] = "LOW";
    ExternalVulnerabilitySeverityLevel["Medium"] = "MEDIUM";
    ExternalVulnerabilitySeverityLevel["Unknown"] = "UNKNOWN";
    return ExternalVulnerabilitySeverityLevel;
}({});
let $78ad46e0d6808149$export$4e05add33b7916dd = /*#__PURE__*/ function(ExternalVulnerabilityStatus) {
    ExternalVulnerabilityStatus["Closed"] = "CLOSED";
    ExternalVulnerabilityStatus["Ignored"] = "IGNORED";
    ExternalVulnerabilityStatus["Open"] = "OPEN";
    ExternalVulnerabilityStatus["Unknown"] = "UNKNOWN";
    return ExternalVulnerabilityStatus;
}({});
let $78ad46e0d6808149$export$fe6bc7391e35d6c7 = /*#__PURE__*/ function(ExternalVulnerabilityType) {
    ExternalVulnerabilityType["Dast"] = "DAST";
    ExternalVulnerabilityType["Sast"] = "SAST";
    ExternalVulnerabilityType["Sca"] = "SCA";
    ExternalVulnerabilityType["Unknown"] = "UNKNOWN";
    return ExternalVulnerabilityType;
}({});
let $78ad46e0d6808149$export$2494f7bfd7b17cbf = /*#__PURE__*/ function(ForgeAlertsActivityType) {
    ForgeAlertsActivityType["AlertCreated"] = "ALERT_CREATED";
    ForgeAlertsActivityType["AlertMuted"] = "ALERT_MUTED";
    ForgeAlertsActivityType["AlertOpened"] = "ALERT_OPENED";
    ForgeAlertsActivityType["AlertResolved"] = "ALERT_RESOLVED";
    ForgeAlertsActivityType["AlertSentFiring"] = "ALERT_SENT_FIRING";
    ForgeAlertsActivityType["AlertSentResolved"] = "ALERT_SENT_RESOLVED";
    ForgeAlertsActivityType["AlertUnmuted"] = "ALERT_UNMUTED";
    ForgeAlertsActivityType["AlertUpdated"] = "ALERT_UPDATED";
    return ForgeAlertsActivityType;
}({});
let $78ad46e0d6808149$export$7abb09aca3d3224b = /*#__PURE__*/ function(ForgeAlertsAlertActivityType) {
    ForgeAlertsAlertActivityType["AlertClosed"] = "ALERT_CLOSED";
    ForgeAlertsAlertActivityType["AlertOpen"] = "ALERT_OPEN";
    ForgeAlertsAlertActivityType["EmailSent"] = "EMAIL_SENT";
    ForgeAlertsAlertActivityType["SeverityUpdated"] = "SEVERITY_UPDATED";
    return ForgeAlertsAlertActivityType;
}({});
let $78ad46e0d6808149$export$33c67579a8081e2a = /*#__PURE__*/ function(ForgeAlertsListOrderByColumns) {
    ForgeAlertsListOrderByColumns["AlertId"] = "alertId";
    ForgeAlertsListOrderByColumns["ClosedAt"] = "closedAt";
    ForgeAlertsListOrderByColumns["CreatedAt"] = "createdAt";
    ForgeAlertsListOrderByColumns["Duration"] = "duration";
    ForgeAlertsListOrderByColumns["Severity"] = "severity";
    return ForgeAlertsListOrderByColumns;
}({});
let $78ad46e0d6808149$export$9d3bb71d891b531d = /*#__PURE__*/ function(ForgeAlertsListOrderOptions) {
    ForgeAlertsListOrderOptions["Asc"] = "ASC";
    ForgeAlertsListOrderOptions["Desc"] = "DESC";
    return ForgeAlertsListOrderOptions;
}({});
let $78ad46e0d6808149$export$e762242ac801905f = /*#__PURE__*/ function(ForgeAlertsMetricsDataType) {
    ForgeAlertsMetricsDataType["DateTime"] = "DATE_TIME";
    return ForgeAlertsMetricsDataType;
}({});
let $78ad46e0d6808149$export$84db9ee3d9e00674 = /*#__PURE__*/ function(ForgeAlertsMetricsResolutionUnit) {
    ForgeAlertsMetricsResolutionUnit["Day"] = "DAY";
    ForgeAlertsMetricsResolutionUnit["Hours"] = "HOURS";
    ForgeAlertsMetricsResolutionUnit["Minutes"] = "MINUTES";
    return ForgeAlertsMetricsResolutionUnit;
}({});
let $78ad46e0d6808149$export$804cf64af4f1f8ef = /*#__PURE__*/ function(ForgeAlertsRuleActivityAction) {
    ForgeAlertsRuleActivityAction["Created"] = "CREATED";
    ForgeAlertsRuleActivityAction["Deleted"] = "DELETED";
    ForgeAlertsRuleActivityAction["Disabled"] = "DISABLED";
    ForgeAlertsRuleActivityAction["Enabled"] = "ENABLED";
    ForgeAlertsRuleActivityAction["Updated"] = "UPDATED";
    return ForgeAlertsRuleActivityAction;
}({});
let $78ad46e0d6808149$export$a8eb586b92cbde1f = /*#__PURE__*/ function(ForgeAlertsRuleFilterActions) {
    ForgeAlertsRuleFilterActions["Exclude"] = "EXCLUDE";
    ForgeAlertsRuleFilterActions["Include"] = "INCLUDE";
    return ForgeAlertsRuleFilterActions;
}({});
let $78ad46e0d6808149$export$b8a26accb92dade4 = /*#__PURE__*/ function(ForgeAlertsRuleFilterDimensions) {
    ForgeAlertsRuleFilterDimensions["ErrorTypes"] = "ERROR_TYPES";
    ForgeAlertsRuleFilterDimensions["Functions"] = "FUNCTIONS";
    ForgeAlertsRuleFilterDimensions["Sites"] = "SITES";
    ForgeAlertsRuleFilterDimensions["Versions"] = "VERSIONS";
    return ForgeAlertsRuleFilterDimensions;
}({});
let $78ad46e0d6808149$export$3cd0507df3412180 = /*#__PURE__*/ function(ForgeAlertsRuleMetricType) {
    ForgeAlertsRuleMetricType["InvocationCount"] = "INVOCATION_COUNT";
    ForgeAlertsRuleMetricType["InvocationErrors"] = "INVOCATION_ERRORS";
    ForgeAlertsRuleMetricType["InvocationLatency"] = "INVOCATION_LATENCY";
    ForgeAlertsRuleMetricType["InvocationSuccessRate"] = "INVOCATION_SUCCESS_RATE";
    return ForgeAlertsRuleMetricType;
}({});
let $78ad46e0d6808149$export$49e1bdac0115b9c = /*#__PURE__*/ function(ForgeAlertsRuleSeverity) {
    ForgeAlertsRuleSeverity["Critical"] = "CRITICAL";
    ForgeAlertsRuleSeverity["Major"] = "MAJOR";
    ForgeAlertsRuleSeverity["Minor"] = "MINOR";
    return ForgeAlertsRuleSeverity;
}({});
let $78ad46e0d6808149$export$c665fabcc544b3e1 = /*#__PURE__*/ function(ForgeAlertsRuleWhenConditions) {
    ForgeAlertsRuleWhenConditions["Above"] = "ABOVE";
    ForgeAlertsRuleWhenConditions["AboveOrEqualTo"] = "ABOVE_OR_EQUAL_TO";
    ForgeAlertsRuleWhenConditions["Below"] = "BELOW";
    ForgeAlertsRuleWhenConditions["BelowOrEqualTo"] = "BELOW_OR_EQUAL_TO";
    return ForgeAlertsRuleWhenConditions;
}({});
let $78ad46e0d6808149$export$767f8584da7588f6 = /*#__PURE__*/ function(ForgeAlertsStatus) {
    ForgeAlertsStatus["Closed"] = "CLOSED";
    ForgeAlertsStatus["Firing"] = "FIRING";
    ForgeAlertsStatus["Open"] = "OPEN";
    ForgeAlertsStatus["Resolved"] = "RESOLVED";
    return ForgeAlertsStatus;
}({});
let $78ad46e0d6808149$export$d43e1fd1dac905d1 = /*#__PURE__*/ function(ForgeAuditLogsActionType) {
    ForgeAuditLogsActionType["ContributorAdded"] = "CONTRIBUTOR_ADDED";
    ForgeAuditLogsActionType["ContributorRemoved"] = "CONTRIBUTOR_REMOVED";
    ForgeAuditLogsActionType["ContributorRoleUpdated"] = "CONTRIBUTOR_ROLE_UPDATED";
    ForgeAuditLogsActionType["OwnershipTransferred"] = "OWNERSHIP_TRANSFERRED";
    return ForgeAuditLogsActionType;
}({});
let $78ad46e0d6808149$export$f0a3a970a16c79ec = /*#__PURE__*/ function(ForgeMetricsApiRequestGroupByDimensions) {
    ForgeMetricsApiRequestGroupByDimensions["ContextAri"] = "CONTEXT_ARI";
    ForgeMetricsApiRequestGroupByDimensions["Status"] = "STATUS";
    ForgeMetricsApiRequestGroupByDimensions["Url"] = "URL";
    return ForgeMetricsApiRequestGroupByDimensions;
}({});
let $78ad46e0d6808149$export$ff830a2670c6e0f4 = /*#__PURE__*/ function(ForgeMetricsApiRequestStatus) {
    ForgeMetricsApiRequestStatus["2Xx"] = "_2XX";
    ForgeMetricsApiRequestStatus["4Xx"] = "_4XX";
    ForgeMetricsApiRequestStatus["5Xx"] = "_5XX";
    return ForgeMetricsApiRequestStatus;
}({});
let $78ad46e0d6808149$export$67826916f2c41941 = /*#__PURE__*/ function(ForgeMetricsApiRequestType) {
    ForgeMetricsApiRequestType["Cache"] = "CACHE";
    ForgeMetricsApiRequestType["External"] = "EXTERNAL";
    ForgeMetricsApiRequestType["Product"] = "PRODUCT";
    ForgeMetricsApiRequestType["Sql"] = "SQL";
    return ForgeMetricsApiRequestType;
}({});
let $78ad46e0d6808149$export$6854d9ebadef3813 = /*#__PURE__*/ function(ForgeMetricsChartName) {
    ForgeMetricsChartName["ApiRequestCount_2Xx"] = "API_REQUEST_COUNT_2XX";
    ForgeMetricsChartName["ApiRequestCount_4Xx"] = "API_REQUEST_COUNT_4XX";
    ForgeMetricsChartName["ApiRequestCount_5Xx"] = "API_REQUEST_COUNT_5XX";
    ForgeMetricsChartName["ApiRequestLatency"] = "API_REQUEST_LATENCY";
    ForgeMetricsChartName["InvocationCount"] = "INVOCATION_COUNT";
    ForgeMetricsChartName["InvocationError"] = "INVOCATION_ERROR";
    ForgeMetricsChartName["InvocationLatency"] = "INVOCATION_LATENCY";
    ForgeMetricsChartName["InvocationSuccessRate"] = "INVOCATION_SUCCESS_RATE";
    return ForgeMetricsChartName;
}({});
let $78ad46e0d6808149$export$8220077afa4e34ce = /*#__PURE__*/ function(ForgeMetricsDataType) {
    ForgeMetricsDataType["Category"] = "CATEGORY";
    ForgeMetricsDataType["DateTime"] = "DATE_TIME";
    ForgeMetricsDataType["Numeric"] = "NUMERIC";
    return ForgeMetricsDataType;
}({});
let $78ad46e0d6808149$export$81745303cdddd39e = /*#__PURE__*/ function(ForgeMetricsGroupByDimensions) {
    ForgeMetricsGroupByDimensions["ContextAri"] = "CONTEXT_ARI";
    ForgeMetricsGroupByDimensions["EnvironmentId"] = "ENVIRONMENT_ID";
    ForgeMetricsGroupByDimensions["ErrorType"] = "ERROR_TYPE";
    ForgeMetricsGroupByDimensions["Function"] = "FUNCTION";
    ForgeMetricsGroupByDimensions["UserTier"] = "USER_TIER";
    ForgeMetricsGroupByDimensions["Version"] = "VERSION";
    return ForgeMetricsGroupByDimensions;
}({});
let $78ad46e0d6808149$export$2afbe872edd7ae25 = /*#__PURE__*/ function(ForgeMetricsLabels) {
    ForgeMetricsLabels["ForgeApiRequestCount"] = "FORGE_API_REQUEST_COUNT";
    ForgeMetricsLabels["ForgeApiRequestLatency"] = "FORGE_API_REQUEST_LATENCY";
    ForgeMetricsLabels["ForgeBackendInvocationCount"] = "FORGE_BACKEND_INVOCATION_COUNT";
    ForgeMetricsLabels["ForgeBackendInvocationErrors"] = "FORGE_BACKEND_INVOCATION_ERRORS";
    ForgeMetricsLabels["ForgeBackendInvocationLatency"] = "FORGE_BACKEND_INVOCATION_LATENCY";
    return ForgeMetricsLabels;
}({});
let $78ad46e0d6808149$export$bf91b1fbb61e5286 = /*#__PURE__*/ function(ForgeMetricsResolutionUnit) {
    ForgeMetricsResolutionUnit["Hours"] = "HOURS";
    ForgeMetricsResolutionUnit["Minutes"] = "MINUTES";
    return ForgeMetricsResolutionUnit;
}({});
let $78ad46e0d6808149$export$923266f2817195b3 = /*#__PURE__*/ function(ForgeMetricsSiteFilterCategory) {
    ForgeMetricsSiteFilterCategory["All"] = "ALL";
    ForgeMetricsSiteFilterCategory["HighestInvocationCount"] = "HIGHEST_INVOCATION_COUNT";
    ForgeMetricsSiteFilterCategory["HighestNumberOfErrors"] = "HIGHEST_NUMBER_OF_ERRORS";
    ForgeMetricsSiteFilterCategory["HighestNumberOfUsers"] = "HIGHEST_NUMBER_OF_USERS";
    ForgeMetricsSiteFilterCategory["LowestSuccessRate"] = "LOWEST_SUCCESS_RATE";
    return ForgeMetricsSiteFilterCategory;
}({});
let $78ad46e0d6808149$export$fc8a1cc6d4fd1a88 = /*#__PURE__*/ function(FormStatus) {
    FormStatus["Approved"] = "APPROVED";
    FormStatus["Rejected"] = "REJECTED";
    FormStatus["Saved"] = "SAVED";
    FormStatus["Submitted"] = "SUBMITTED";
    return FormStatus;
}({});
let $78ad46e0d6808149$export$6dc536fb03c01261 = /*#__PURE__*/ function(FortifiedMetricsResolutionUnit) {
    FortifiedMetricsResolutionUnit["Hours"] = "HOURS";
    FortifiedMetricsResolutionUnit["Minutes"] = "MINUTES";
    return FortifiedMetricsResolutionUnit;
}({}); /** The data describing a function invocation. */  /** Which type of trigger */ 
let $78ad46e0d6808149$export$c11461c8b46bd7da = /*#__PURE__*/ function(FunctionTriggerType) {
    FunctionTriggerType["Frontend"] = "FRONTEND";
    FunctionTriggerType["Manual"] = "MANUAL";
    FunctionTriggerType["Product"] = "PRODUCT";
    FunctionTriggerType["Web"] = "WEB";
    return FunctionTriggerType;
}({}); /** Concrete version of MutationErrorExtension that does not include any extra fields */  /** Generic implementation of MutationResponse for responses that don't need any extra data */  /** Concrete version of QueryErrorExtension that does not include any extra fields */  /**
 * Card Creation fields.
 * Only getting used by "jsw-adapted-issue-create-trigger" package
 */ 
let $78ad46e0d6808149$export$7cf25e310e0549b9 = /*#__PURE__*/ function(GrantCheckProduct) {
    GrantCheckProduct["Compass"] = "COMPASS";
    GrantCheckProduct["Confluence"] = "CONFLUENCE";
    GrantCheckProduct["Jira"] = "JIRA";
    GrantCheckProduct["JiraServicedesk"] = "JIRA_SERVICEDESK";
    GrantCheckProduct["Mercury"] = "MERCURY";
    GrantCheckProduct["NoGrantChecks"] = "NO_GRANT_CHECKS";
    GrantCheckProduct["Townsquare"] = "TOWNSQUARE";
    return GrantCheckProduct;
}({}); /** Represents an ati:cloud:confluence:page. Returned by relationship queries */ 
let $78ad46e0d6808149$export$e257ff6d0ceabf65 = /*#__PURE__*/ function(GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum) {
    GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum["Cancelled"] = "CANCELLED";
    GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum["Failed"] = "FAILED";
    GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum["InProgress"] = "IN_PROGRESS";
    GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum["Pending"] = "PENDING";
    GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum["Successful"] = "SUCCESSFUL";
    GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum;
}({});
let $78ad46e0d6808149$export$d67cf8c91eee6c78 = /*#__PURE__*/ function(GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum) {
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Cancelled"] = "CANCELLED";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Failed"] = "FAILED";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["InProgress"] = "IN_PROGRESS";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Pending"] = "PENDING";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["RolledBack"] = "ROLLED_BACK";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Successful"] = "SUCCESSFUL";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum;
}({});
let $78ad46e0d6808149$export$ee2e640b413dd384 = /*#__PURE__*/ function(GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum) {
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum["Development"] = "DEVELOPMENT";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum["Production"] = "PRODUCTION";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum["Staging"] = "STAGING";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum["Testing"] = "TESTING";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum["Unmapped"] = "UNMAPPED";
    return GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum;
}({});
let $78ad46e0d6808149$export$c50c7062a9ebe6be = /*#__PURE__*/ function(GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputPullRequestStatusEnum) {
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Declined"] = "DECLINED";
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Merged"] = "MERGED";
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Open"] = "OPEN";
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputPullRequestStatusEnum;
}({});
let $78ad46e0d6808149$export$a79d08c6a74f2aa7 = /*#__PURE__*/ function(GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum) {
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["Approved"] = "APPROVED";
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["Needswork"] = "NEEDSWORK";
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["Unapproved"] = "UNAPPROVED";
    return GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum;
}({});
let $78ad46e0d6808149$export$6f687fc24be8932d = /*#__PURE__*/ function(GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum) {
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Critical"] = "CRITICAL";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["High"] = "HIGH";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Low"] = "LOW";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Medium"] = "MEDIUM";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum;
}({});
let $78ad46e0d6808149$export$49ff7d43116f0b34 = /*#__PURE__*/ function(GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum) {
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Closed"] = "CLOSED";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Ignored"] = "IGNORED";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Open"] = "OPEN";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum;
}({});
let $78ad46e0d6808149$export$e818e0de20808583 = /*#__PURE__*/ function(GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityTypeEnum) {
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityTypeEnum["Dast"] = "DAST";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityTypeEnum["Sast"] = "SAST";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityTypeEnum["Sca"] = "SCA";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityTypeEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityTypeEnum;
}({});
let $78ad46e0d6808149$export$712746aa2988ba08 = /*#__PURE__*/ function(GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum) {
    GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum["Cancelled"] = "CANCELLED";
    GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum["Failed"] = "FAILED";
    GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum["InProgress"] = "IN_PROGRESS";
    GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum["Pending"] = "PENDING";
    GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum["Successful"] = "SUCCESSFUL";
    GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum;
}({});
let $78ad46e0d6808149$export$f69c5a9b8fd498a0 = /*#__PURE__*/ function(GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum) {
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Cancelled"] = "CANCELLED";
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Failed"] = "FAILED";
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["InProgress"] = "IN_PROGRESS";
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Pending"] = "PENDING";
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["RolledBack"] = "ROLLED_BACK";
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Successful"] = "SUCCESSFUL";
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum;
}({});
let $78ad46e0d6808149$export$ae5cb07efff2d516 = /*#__PURE__*/ function(GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputPullRequestStatusEnum) {
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Declined"] = "DECLINED";
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Merged"] = "MERGED";
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Open"] = "OPEN";
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputPullRequestStatusEnum;
}({});
let $78ad46e0d6808149$export$784f60349b367f9b = /*#__PURE__*/ function(GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum) {
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["Approved"] = "APPROVED";
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["Needswork"] = "NEEDSWORK";
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["Unapproved"] = "UNAPPROVED";
    return GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum;
}({});
let $78ad46e0d6808149$export$e37d41f18a90ba53 = /*#__PURE__*/ function(GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum) {
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Critical"] = "CRITICAL";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["High"] = "HIGH";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Low"] = "LOW";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Medium"] = "MEDIUM";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum;
}({});
let $78ad46e0d6808149$export$f53fed6636725b64 = /*#__PURE__*/ function(GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum) {
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Closed"] = "CLOSED";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Ignored"] = "IGNORED";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Open"] = "OPEN";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum;
}({});
let $78ad46e0d6808149$export$aa057f51e7ce3c82 = /*#__PURE__*/ function(GraphCreateMetadataSprintAssociatedVulnerabilityOutputStatusCategoryEnum) {
    GraphCreateMetadataSprintAssociatedVulnerabilityOutputStatusCategoryEnum["Done"] = "DONE";
    GraphCreateMetadataSprintAssociatedVulnerabilityOutputStatusCategoryEnum["Indeterminate"] = "INDETERMINATE";
    GraphCreateMetadataSprintAssociatedVulnerabilityOutputStatusCategoryEnum["New"] = "NEW";
    GraphCreateMetadataSprintAssociatedVulnerabilityOutputStatusCategoryEnum["Undefined"] = "UNDEFINED";
    return GraphCreateMetadataSprintAssociatedVulnerabilityOutputStatusCategoryEnum;
}({});
let $78ad46e0d6808149$export$28a810288577486f = /*#__PURE__*/ function(GraphCreateMetadataSprintContainsIssueJiraIssueInputStatusCategoryEnum) {
    GraphCreateMetadataSprintContainsIssueJiraIssueInputStatusCategoryEnum["Done"] = "DONE";
    GraphCreateMetadataSprintContainsIssueJiraIssueInputStatusCategoryEnum["Indeterminate"] = "INDETERMINATE";
    GraphCreateMetadataSprintContainsIssueJiraIssueInputStatusCategoryEnum["New"] = "NEW";
    GraphCreateMetadataSprintContainsIssueJiraIssueInputStatusCategoryEnum["Undefined"] = "UNDEFINED";
    return GraphCreateMetadataSprintContainsIssueJiraIssueInputStatusCategoryEnum;
}({});
let $78ad46e0d6808149$export$f863dc0cdc1e6a3 = /*#__PURE__*/ function(GraphCreateMetadataSprintContainsIssueJiraIssueOutputStatusCategoryEnum) {
    GraphCreateMetadataSprintContainsIssueJiraIssueOutputStatusCategoryEnum["Done"] = "DONE";
    GraphCreateMetadataSprintContainsIssueJiraIssueOutputStatusCategoryEnum["Indeterminate"] = "INDETERMINATE";
    GraphCreateMetadataSprintContainsIssueJiraIssueOutputStatusCategoryEnum["New"] = "NEW";
    GraphCreateMetadataSprintContainsIssueJiraIssueOutputStatusCategoryEnum["Undefined"] = "UNDEFINED";
    return GraphCreateMetadataSprintContainsIssueJiraIssueOutputStatusCategoryEnum;
}({}); /** Represents an Generic implementing the Node interface. */  /** Represents an Generic implementing the Node interface. */  /** Represents an ati:cloud:jira:issue. Returned by relationship queries */  /** Represents an ati:cloud:jira:post-incident-review-link implementing the Node interface. */  /** Represents an ati:cloud:jira:post-incident-review-link implementing the Node interface. */  /** Represents an ati:cloud:jira:project implementing the Node interface. */  /** Represents an ati:cloud:jira:security-container implementing the Node interface. */  /** Represents an ati:cloud:jira:sprint. Returned by relationship queries */  /** Represents an ati:cloud:jira:vulnerability implementing the Node interface. */ 
let $78ad46e0d6808149$export$506c56cd93325d6f = /*#__PURE__*/ function(GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum) {
    GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum["Cancelled"] = "CANCELLED";
    GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum["Failed"] = "FAILED";
    GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum["InProgress"] = "IN_PROGRESS";
    GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum["Pending"] = "PENDING";
    GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum["Successful"] = "SUCCESSFUL";
    GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum;
}({});
let $78ad46e0d6808149$export$7ea6916b52f9a466 = /*#__PURE__*/ function(GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum) {
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["Cancelled"] = "CANCELLED";
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["Failed"] = "FAILED";
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["InProgress"] = "IN_PROGRESS";
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["Pending"] = "PENDING";
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["RolledBack"] = "ROLLED_BACK";
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["Successful"] = "SUCCESSFUL";
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum;
}({});
let $78ad46e0d6808149$export$4a73bb7047a59c43 = /*#__PURE__*/ function(GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum) {
    GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum["Development"] = "DEVELOPMENT";
    GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum["Production"] = "PRODUCTION";
    GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum["Staging"] = "STAGING";
    GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum["Testing"] = "TESTING";
    GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum["Unmapped"] = "UNMAPPED";
    return GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum;
}({});
let $78ad46e0d6808149$export$13841098b50a1391 = /*#__PURE__*/ function(GraphQueryMetadataProjectAssociatedPrInputToPullRequestStatusEnum) {
    GraphQueryMetadataProjectAssociatedPrInputToPullRequestStatusEnum["Declined"] = "DECLINED";
    GraphQueryMetadataProjectAssociatedPrInputToPullRequestStatusEnum["Merged"] = "MERGED";
    GraphQueryMetadataProjectAssociatedPrInputToPullRequestStatusEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataProjectAssociatedPrInputToPullRequestStatusEnum["Open"] = "OPEN";
    GraphQueryMetadataProjectAssociatedPrInputToPullRequestStatusEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataProjectAssociatedPrInputToPullRequestStatusEnum;
}({});
let $78ad46e0d6808149$export$b79540fc1cf58152 = /*#__PURE__*/ function(GraphQueryMetadataProjectAssociatedPrInputToReviewerReviewerStatusEnum) {
    GraphQueryMetadataProjectAssociatedPrInputToReviewerReviewerStatusEnum["Approved"] = "APPROVED";
    GraphQueryMetadataProjectAssociatedPrInputToReviewerReviewerStatusEnum["Needswork"] = "NEEDSWORK";
    GraphQueryMetadataProjectAssociatedPrInputToReviewerReviewerStatusEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataProjectAssociatedPrInputToReviewerReviewerStatusEnum["Unapproved"] = "UNAPPROVED";
    return GraphQueryMetadataProjectAssociatedPrInputToReviewerReviewerStatusEnum;
}({});
let $78ad46e0d6808149$export$f73a51516debfebb = /*#__PURE__*/ function(GraphQueryMetadataProjectAssociatedPrInputToReviewermatchTypeEnum) {
    GraphQueryMetadataProjectAssociatedPrInputToReviewermatchTypeEnum["All"] = "ALL";
    GraphQueryMetadataProjectAssociatedPrInputToReviewermatchTypeEnum["Any"] = "ANY";
    GraphQueryMetadataProjectAssociatedPrInputToReviewermatchTypeEnum["None"] = "NONE";
    return GraphQueryMetadataProjectAssociatedPrInputToReviewermatchTypeEnum;
}({});
let $78ad46e0d6808149$export$ffa68ad6c069c08 = /*#__PURE__*/ function(GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum) {
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Critical"] = "CRITICAL";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["High"] = "HIGH";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Low"] = "LOW";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Medium"] = "MEDIUM";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum;
}({});
let $78ad46e0d6808149$export$d9c8a38d7a3c7cc8 = /*#__PURE__*/ function(GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum) {
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Closed"] = "CLOSED";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Ignored"] = "IGNORED";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Open"] = "OPEN";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum;
}({});
let $78ad46e0d6808149$export$5a8ffaaa2ad7aed0 = /*#__PURE__*/ function(GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum) {
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum["Dast"] = "DAST";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum["Sast"] = "SAST";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum["Sca"] = "SCA";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum;
}({});
let $78ad46e0d6808149$export$806eaced01bf01a = /*#__PURE__*/ function(GraphQueryMetadataProjectHasIssueInputRelationshipArimatchTypeEnum) {
    GraphQueryMetadataProjectHasIssueInputRelationshipArimatchTypeEnum["All"] = "ALL";
    GraphQueryMetadataProjectHasIssueInputRelationshipArimatchTypeEnum["Any"] = "ANY";
    GraphQueryMetadataProjectHasIssueInputRelationshipArimatchTypeEnum["None"] = "NONE";
    return GraphQueryMetadataProjectHasIssueInputRelationshipArimatchTypeEnum;
}({});
let $78ad46e0d6808149$export$6ca61b0e0124327a = /*#__PURE__*/ function(GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum) {
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum["Critical"] = "CRITICAL";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum["High"] = "HIGH";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum["Low"] = "LOW";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum["Medium"] = "MEDIUM";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum;
}({});
let $78ad46e0d6808149$export$f5a38573abf93209 = /*#__PURE__*/ function(GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityStatusEnum) {
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityStatusEnum["Closed"] = "CLOSED";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityStatusEnum["Ignored"] = "IGNORED";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityStatusEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityStatusEnum["Open"] = "OPEN";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityStatusEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityStatusEnum;
}({});
let $78ad46e0d6808149$export$e78de564c39ba63a = /*#__PURE__*/ function(GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityTypeEnum) {
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityTypeEnum["Dast"] = "DAST";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityTypeEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityTypeEnum["Sast"] = "SAST";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityTypeEnum["Sca"] = "SCA";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityTypeEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityTypeEnum;
}({});
let $78ad46e0d6808149$export$84e173808cf3fbd = /*#__PURE__*/ function(GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum) {
    GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum["P1"] = "P1";
    GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum["P2"] = "P2";
    GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum["P3"] = "P3";
    GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum["P4"] = "P4";
    GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum["P5"] = "P5";
    return GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum;
}({});
let $78ad46e0d6808149$export$9b119abe5b87afc8 = /*#__PURE__*/ function(GraphQueryMetadataSortEnum) {
    GraphQueryMetadataSortEnum["Asc"] = "ASC";
    GraphQueryMetadataSortEnum["Desc"] = "DESC";
    return GraphQueryMetadataSortEnum;
}({});
let $78ad46e0d6808149$export$c4247d75f3bd62d6 = /*#__PURE__*/ function(GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum) {
    GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum["Cancelled"] = "CANCELLED";
    GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum["Failed"] = "FAILED";
    GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum["InProgress"] = "IN_PROGRESS";
    GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum["Pending"] = "PENDING";
    GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum["Successful"] = "SUCCESSFUL";
    GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum;
}({});
let $78ad46e0d6808149$export$251196d62f47dadc = /*#__PURE__*/ function(GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum) {
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["Cancelled"] = "CANCELLED";
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["Failed"] = "FAILED";
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["InProgress"] = "IN_PROGRESS";
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["Pending"] = "PENDING";
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["RolledBack"] = "ROLLED_BACK";
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["Successful"] = "SUCCESSFUL";
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum;
}({});
let $78ad46e0d6808149$export$ecfd24ecd1c4c396 = /*#__PURE__*/ function(GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum) {
    GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum["Development"] = "DEVELOPMENT";
    GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum["Production"] = "PRODUCTION";
    GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum["Staging"] = "STAGING";
    GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum["Testing"] = "TESTING";
    GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum["Unmapped"] = "UNMAPPED";
    return GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum;
}({});
let $78ad46e0d6808149$export$2b200e1b05f9a91 = /*#__PURE__*/ function(GraphQueryMetadataSprintAssociatedPrInputToPullRequestStatusEnum) {
    GraphQueryMetadataSprintAssociatedPrInputToPullRequestStatusEnum["Declined"] = "DECLINED";
    GraphQueryMetadataSprintAssociatedPrInputToPullRequestStatusEnum["Merged"] = "MERGED";
    GraphQueryMetadataSprintAssociatedPrInputToPullRequestStatusEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSprintAssociatedPrInputToPullRequestStatusEnum["Open"] = "OPEN";
    GraphQueryMetadataSprintAssociatedPrInputToPullRequestStatusEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataSprintAssociatedPrInputToPullRequestStatusEnum;
}({});
let $78ad46e0d6808149$export$3782643d0ae02abe = /*#__PURE__*/ function(GraphQueryMetadataSprintAssociatedPrInputToReviewerReviewerStatusEnum) {
    GraphQueryMetadataSprintAssociatedPrInputToReviewerReviewerStatusEnum["Approved"] = "APPROVED";
    GraphQueryMetadataSprintAssociatedPrInputToReviewerReviewerStatusEnum["Needswork"] = "NEEDSWORK";
    GraphQueryMetadataSprintAssociatedPrInputToReviewerReviewerStatusEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSprintAssociatedPrInputToReviewerReviewerStatusEnum["Unapproved"] = "UNAPPROVED";
    return GraphQueryMetadataSprintAssociatedPrInputToReviewerReviewerStatusEnum;
}({});
let $78ad46e0d6808149$export$522af156c9a19c25 = /*#__PURE__*/ function(GraphQueryMetadataSprintAssociatedPrInputToReviewermatchTypeEnum) {
    GraphQueryMetadataSprintAssociatedPrInputToReviewermatchTypeEnum["All"] = "ALL";
    GraphQueryMetadataSprintAssociatedPrInputToReviewermatchTypeEnum["Any"] = "ANY";
    GraphQueryMetadataSprintAssociatedPrInputToReviewermatchTypeEnum["None"] = "NONE";
    return GraphQueryMetadataSprintAssociatedPrInputToReviewermatchTypeEnum;
}({});
let $78ad46e0d6808149$export$67557b0182f33b6 = /*#__PURE__*/ function(GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategoryEnum) {
    GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategoryEnum["Done"] = "DONE";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategoryEnum["Indeterminate"] = "INDETERMINATE";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategoryEnum["New"] = "NEW";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategoryEnum["Undefined"] = "UNDEFINED";
    return GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategoryEnum;
}({});
let $78ad46e0d6808149$export$46a86c882ece79a0 = /*#__PURE__*/ function(GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum) {
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Critical"] = "CRITICAL";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["High"] = "HIGH";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Low"] = "LOW";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Medium"] = "MEDIUM";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum;
}({});
let $78ad46e0d6808149$export$7fc2bf7b37a3a03c = /*#__PURE__*/ function(GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilityStatusEnum) {
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Closed"] = "CLOSED";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Ignored"] = "IGNORED";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilityStatusEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Open"] = "OPEN";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilityStatusEnum;
}({});
let $78ad46e0d6808149$export$39763c846aa96176 = /*#__PURE__*/ function(GraphQueryMetadataSprintContainsIssueInputToStatusCategoryEnum) {
    GraphQueryMetadataSprintContainsIssueInputToStatusCategoryEnum["Done"] = "DONE";
    GraphQueryMetadataSprintContainsIssueInputToStatusCategoryEnum["Indeterminate"] = "INDETERMINATE";
    GraphQueryMetadataSprintContainsIssueInputToStatusCategoryEnum["New"] = "NEW";
    GraphQueryMetadataSprintContainsIssueInputToStatusCategoryEnum["Undefined"] = "UNDEFINED";
    return GraphQueryMetadataSprintContainsIssueInputToStatusCategoryEnum;
}({}); /** A relationship edge for the relationship type content-referenced-entity */  /** A union of the possible hydration types for content-referenced-entity: [JiraIssue, ConfluencePage, CompassComponent] */  /** A relationship inner edge for the relationship type content-referenced-entity */  /** A node representing a content-referenced-entity relationship, with all metadata (if available) */  /** A union of the possible hydration types for content-referenced-entity: [JiraIssue, ConfluencePage] */  /** A relationship edge for the relationship type focus-area-associated-to-project */  /** A union of the possible hydration types for focus-area-associated-to-project: [DevOpsProjectDetails] */  /** A relationship inner edge for the relationship type focus-area-associated-to-project */  /** A node representing a focus-area-associated-to-project relationship, with all metadata (if available) */  /** A union of the possible hydration types for focus-area-associated-to-project: [MercuryFocusArea] */  /** A relationship edge for the relationship type focus-area-has-atlas-goal */  /** A union of the possible hydration types for focus-area-has-atlas-goal: [TownsquareGoal] */  /** A relationship inner edge for the relationship type focus-area-has-atlas-goal */  /** A node representing a focus-area-has-atlas-goal relationship, with all metadata (if available) */  /** A union of the possible hydration types for focus-area-has-atlas-goal: [MercuryFocusArea] */  /** A relationship edge for the relationship type focus-area-has-focus-area */  /** A union of the possible hydration types for focus-area-has-focus-area: [MercuryFocusArea] */  /** A relationship inner edge for the relationship type focus-area-has-focus-area */  /** A node representing a focus-area-has-focus-area relationship, with all metadata (if available) */  /** A union of the possible hydration types for focus-area-has-focus-area: [MercuryFocusArea] */  /** A relationship edge for the relationship type focus-area-has-project */  /** A union of the possible hydration types for focus-area-has-project: [TownsquareProject, JiraIssue] */  /** A relationship inner edge for the relationship type focus-area-has-project */  /** A node representing a focus-area-has-project relationship, with all metadata (if available) */  /** A union of the possible hydration types for focus-area-has-project: [MercuryFocusArea] */  /** A relationship edge for the relationship type incident-associated-post-incident-review */  /** A union of the possible hydration types for incident-associated-post-incident-review: [JiraIssue] */  /** A relationship inner edge for the relationship type incident-associated-post-incident-review */  /** A relationship edge for the relationship type incident-associated-post-incident-review-link */  /** A union of the possible hydration types for incident-associated-post-incident-review-link: [JiraIssue, JiraPostIncidentReviewLink, DevOpsOperationsPostIncidentReviewDetails] */  /** A relationship inner edge for the relationship type incident-associated-post-incident-review-link */  /** A node representing a incident-associated-post-incident-review-link relationship, with all metadata (if available) */  /** A union of the possible hydration types for incident-associated-post-incident-review-link: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A node representing a incident-associated-post-incident-review relationship, with all metadata (if available) */  /** A union of the possible hydration types for incident-associated-post-incident-review: [JiraIssue] */  /** A relationship edge for the relationship type incident-has-action-item */  /** A union of the possible hydration types for incident-has-action-item: [JiraIssue] */  /** A relationship inner edge for the relationship type incident-has-action-item */  /** A node representing a incident-has-action-item relationship, with all metadata (if available) */  /** A union of the possible hydration types for incident-has-action-item: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A relationship edge for the relationship type incident-linked-jsw-issue */  /** A union of the possible hydration types for incident-linked-jsw-issue: [JiraIssue] */  /** A relationship inner edge for the relationship type incident-linked-jsw-issue */  /** A node representing a incident-linked-jsw-issue relationship, with all metadata (if available) */  /** A union of the possible hydration types for incident-linked-jsw-issue: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A relationship edge for the relationship type issue-associated-build */  /** A relationship inner edge for the relationship type issue-associated-build */  /** A node representing a issue-associated-build relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-build: [JiraIssue] */  /** A relationship edge for the relationship type issue-associated-deployment */  /** A union of the possible hydration types for issue-associated-deployment: [DeploymentSummary] */  /** A relationship inner edge for the relationship type issue-associated-deployment */  /** A node representing a issue-associated-deployment relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-deployment: [JiraIssue] */  /** A relationship edge for the relationship type issue-associated-issue-remote-link */  /** A union of the possible hydration types for issue-associated-issue-remote-link: [JiraIssueRemoteIssueLink, JiraConfluenceRemoteIssueLink, JiraWebRemoteIssueLink, JiraCustomRemoteIssueLink] */  /** A relationship inner edge for the relationship type issue-associated-issue-remote-link */  /** A node representing a issue-associated-issue-remote-link relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-issue-remote-link: [JiraIssue] */  /** A relationship edge for the relationship type jsm-project-associated-service */  /** A union of the possible hydration types for jsm-project-associated-service: [DevOpsService] */  /** A relationship inner edge for the relationship type jsm-project-associated-service */  /** A node representing a jsm-project-associated-service relationship, with all metadata (if available) */  /** A union of the possible hydration types for jsm-project-associated-service: [JiraProject] */  /** A relationship edge for the relationship type media-attached-to-content */  /** A union of the possible hydration types for media-attached-to-content: [JiraIssue, ConfluencePage] */  /** A relationship inner edge for the relationship type media-attached-to-content */  /** A node representing a media-attached-to-content relationship, with all metadata (if available) */  /** A relationship edge for the relationship type security-container-associated-to-vulnerability */  /** A union of the possible hydration types for security-container-associated-to-vulnerability: [DevOpsSecurityVulnerabilityDetails] */  /** A relationship inner edge for the relationship type security-container-associated-to-vulnerability */  /** A node representing a security-container-associated-to-vulnerability relationship, with all metadata (if available) */ 
let $78ad46e0d6808149$export$fb0f42f72b340ab0 = /*#__PURE__*/ function(GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput) {
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["NotSet"] = "NOT_SET";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["P1"] = "P1";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["P2"] = "P2";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["P3"] = "P3";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["P4"] = "P4";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["P5"] = "P5";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["Pending"] = "PENDING";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["Unknown"] = "UNKNOWN";
    return GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput;
}({});
let $78ad46e0d6808149$export$621f4c3ec3f34f6d = /*#__PURE__*/ function(GraphStoreCreateComponentImpactedByIncidentJiraIncidentStatusInput) {
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentStatusInput["Done"] = "DONE";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentStatusInput["Indeterminate"] = "INDETERMINATE";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentStatusInput["New"] = "NEW";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentStatusInput["NotSet"] = "NOT_SET";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentStatusInput["Undefined"] = "UNDEFINED";
    return GraphStoreCreateComponentImpactedByIncidentJiraIncidentStatusInput;
}({});
let $78ad46e0d6808149$export$2cb64a720d855b98 = /*#__PURE__*/ function(GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput) {
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput["Critical"] = "CRITICAL";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput["High"] = "HIGH";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput["Low"] = "LOW";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput["Medium"] = "MEDIUM";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput["NotSet"] = "NOT_SET";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput["Unknown"] = "UNKNOWN";
    return GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput;
}({});
let $78ad46e0d6808149$export$996ea6ee34911f99 = /*#__PURE__*/ function(GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityStatusInput) {
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityStatusInput["Closed"] = "CLOSED";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityStatusInput["Ignored"] = "IGNORED";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityStatusInput["NotSet"] = "NOT_SET";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityStatusInput["Open"] = "OPEN";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityStatusInput["Unknown"] = "UNKNOWN";
    return GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityStatusInput;
}({});
let $78ad46e0d6808149$export$7db5c45cbd7a8d6a = /*#__PURE__*/ function(GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityTypeInput) {
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityTypeInput["Dast"] = "DAST";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityTypeInput["NotSet"] = "NOT_SET";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityTypeInput["Sast"] = "SAST";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityTypeInput["Sca"] = "SCA";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityTypeInput["Unknown"] = "UNKNOWN";
    return GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityTypeInput;
}({}); /** A full relationship edge for the relationship type app-installation-associated-to-operations-workspace */  /** A node representing a app-installation-associated-to-operations-workspace relationship, with all metadata (if available) */  /** A full relationship edge for the relationship type app-installation-associated-to-security-workspace */  /** A node representing a app-installation-associated-to-security-workspace relationship, with all metadata (if available) */  /** A full relationship edge for the relationship type atlas-project-contributes-to-atlas-goal */  /** A union of the possible hydration types for atlas-project-contributes-to-atlas-goal: [TownsquareGoal] */  /** A node representing a atlas-project-contributes-to-atlas-goal relationship, with all metadata (if available) */  /** A union of the possible hydration types for atlas-project-contributes-to-atlas-goal: [TownsquareProject] */  /** A full relationship edge for the relationship type atlas-project-is-tracked-on-jira-epic */  /** A union of the possible hydration types for atlas-project-is-tracked-on-jira-epic: [JiraIssue] */  /** A node representing a atlas-project-is-tracked-on-jira-epic relationship, with all metadata (if available) */  /** A union of the possible hydration types for atlas-project-is-tracked-on-jira-epic: [TownsquareProject] */  /** A full relationship edge for the relationship type component-impacted-by-incident */  /** A union of the possible hydration types for component-impacted-by-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */ 
let $78ad46e0d6808149$export$9887284bd91c5bd3 = /*#__PURE__*/ function(GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput) {
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["NotSet"] = "NOT_SET";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["P1"] = "P1";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["P2"] = "P2";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["P3"] = "P3";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["P4"] = "P4";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["P5"] = "P5";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["Pending"] = "PENDING";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput;
}({});
let $78ad46e0d6808149$export$753e474d0e2d3bcb = /*#__PURE__*/ function(GraphStoreFullComponentImpactedByIncidentJiraIncidentStatusOutput) {
    GraphStoreFullComponentImpactedByIncidentJiraIncidentStatusOutput["Done"] = "DONE";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentStatusOutput["Indeterminate"] = "INDETERMINATE";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentStatusOutput["New"] = "NEW";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentStatusOutput["Undefined"] = "UNDEFINED";
    return GraphStoreFullComponentImpactedByIncidentJiraIncidentStatusOutput;
}({}); /** A node representing a component-impacted-by-incident relationship, with all metadata (if available) */  /** A union of the possible hydration types for component-impacted-by-incident: [CompassComponent, DevOpsOperationsComponentDetails] */  /** A full relationship edge for the relationship type component-linked-jsw-issue */  /** A union of the possible hydration types for component-linked-jsw-issue: [JiraIssue] */  /** A node representing a component-linked-jsw-issue relationship, with all metadata (if available) */  /** A union of the possible hydration types for component-linked-jsw-issue: [CompassComponent, DevOpsService, DevOpsOperationsComponentDetails] */  /** A full relationship edge for the relationship type content-referenced-entity */  /** A union of the possible hydration types for content-referenced-entity: [JiraIssue, ConfluencePage, CompassComponent] */  /** A node representing a content-referenced-entity relationship, with all metadata (if available) */  /** A union of the possible hydration types for content-referenced-entity: [JiraIssue, ConfluencePage] */  /** A full relationship edge for the relationship type incident-associated-post-incident-review */  /** A union of the possible hydration types for incident-associated-post-incident-review: [JiraIssue] */  /** A full relationship edge for the relationship type incident-associated-post-incident-review-link */  /** A union of the possible hydration types for incident-associated-post-incident-review-link: [JiraIssue, JiraPostIncidentReviewLink, DevOpsOperationsPostIncidentReviewDetails] */  /** A node representing a incident-associated-post-incident-review-link relationship, with all metadata (if available) */  /** A union of the possible hydration types for incident-associated-post-incident-review-link: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A node representing a incident-associated-post-incident-review relationship, with all metadata (if available) */  /** A union of the possible hydration types for incident-associated-post-incident-review: [JiraIssue] */  /** A full relationship edge for the relationship type incident-has-action-item */  /** A union of the possible hydration types for incident-has-action-item: [JiraIssue] */  /** A node representing a incident-has-action-item relationship, with all metadata (if available) */  /** A union of the possible hydration types for incident-has-action-item: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A full relationship edge for the relationship type incident-linked-jsw-issue */  /** A union of the possible hydration types for incident-linked-jsw-issue: [JiraIssue] */  /** A node representing a incident-linked-jsw-issue relationship, with all metadata (if available) */  /** A union of the possible hydration types for incident-linked-jsw-issue: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A full relationship edge for the relationship type issue-associated-branch */  /** A node representing a issue-associated-branch relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-branch: [JiraIssue] */ 
let $78ad46e0d6808149$export$983eeb7eafc088a9 = /*#__PURE__*/ function(GraphStoreFullIssueAssociatedBuildBuildStateOutput) {
    GraphStoreFullIssueAssociatedBuildBuildStateOutput["Cancelled"] = "CANCELLED";
    GraphStoreFullIssueAssociatedBuildBuildStateOutput["Failed"] = "FAILED";
    GraphStoreFullIssueAssociatedBuildBuildStateOutput["InProgress"] = "IN_PROGRESS";
    GraphStoreFullIssueAssociatedBuildBuildStateOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedBuildBuildStateOutput["Pending"] = "PENDING";
    GraphStoreFullIssueAssociatedBuildBuildStateOutput["Successful"] = "SUCCESSFUL";
    GraphStoreFullIssueAssociatedBuildBuildStateOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullIssueAssociatedBuildBuildStateOutput;
}({}); /** A full relationship edge for the relationship type issue-associated-build */  /** A node representing a issue-associated-build relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-build: [JiraIssue] */  /** A full relationship edge for the relationship type issue-associated-commit */  /** A node representing a issue-associated-commit relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-commit: [JiraIssue] */ 
let $78ad46e0d6808149$export$6707759160f13c4c = /*#__PURE__*/ function(GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput) {
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["Cancelled"] = "CANCELLED";
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["Failed"] = "FAILED";
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["InProgress"] = "IN_PROGRESS";
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["Pending"] = "PENDING";
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["RolledBack"] = "ROLLED_BACK";
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["Successful"] = "SUCCESSFUL";
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput;
}({}); /** A full relationship edge for the relationship type issue-associated-deployment */  /** A union of the possible hydration types for issue-associated-deployment: [DeploymentSummary] */ 
let $78ad46e0d6808149$export$62f69bc9834c2852 = /*#__PURE__*/ function(GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput) {
    GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput["Development"] = "DEVELOPMENT";
    GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput["Production"] = "PRODUCTION";
    GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput["Staging"] = "STAGING";
    GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput["Testing"] = "TESTING";
    GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput["Unmapped"] = "UNMAPPED";
    return GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput;
}({}); /** A node representing a issue-associated-deployment relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-deployment: [JiraIssue] */ 
let $78ad46e0d6808149$export$a3ef183d8c6ea7f8 = /*#__PURE__*/ function(GraphStoreFullIssueAssociatedDesignDesignStatusOutput) {
    GraphStoreFullIssueAssociatedDesignDesignStatusOutput["None"] = "NONE";
    GraphStoreFullIssueAssociatedDesignDesignStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedDesignDesignStatusOutput["ReadyForDevelopment"] = "READY_FOR_DEVELOPMENT";
    GraphStoreFullIssueAssociatedDesignDesignStatusOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullIssueAssociatedDesignDesignStatusOutput;
}({});
let $78ad46e0d6808149$export$e0814c7e8e75c569 = /*#__PURE__*/ function(GraphStoreFullIssueAssociatedDesignDesignTypeOutput) {
    GraphStoreFullIssueAssociatedDesignDesignTypeOutput["Canvas"] = "CANVAS";
    GraphStoreFullIssueAssociatedDesignDesignTypeOutput["File"] = "FILE";
    GraphStoreFullIssueAssociatedDesignDesignTypeOutput["Group"] = "GROUP";
    GraphStoreFullIssueAssociatedDesignDesignTypeOutput["Node"] = "NODE";
    GraphStoreFullIssueAssociatedDesignDesignTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedDesignDesignTypeOutput["Other"] = "OTHER";
    GraphStoreFullIssueAssociatedDesignDesignTypeOutput["Prototype"] = "PROTOTYPE";
    return GraphStoreFullIssueAssociatedDesignDesignTypeOutput;
}({}); /** A full relationship edge for the relationship type issue-associated-design */  /** A union of the possible hydration types for issue-associated-design: [DevOpsDesign] */  /** A node representing a issue-associated-design relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-design: [JiraIssue] */  /** A full relationship edge for the relationship type issue-associated-feature-flag */  /** A union of the possible hydration types for issue-associated-feature-flag: [DevOpsFeatureFlag] */  /** A node representing a issue-associated-feature-flag relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-feature-flag: [JiraIssue] */  /** A full relationship edge for the relationship type issue-associated-issue-remote-link */  /** A union of the possible hydration types for issue-associated-issue-remote-link: [JiraIssueRemoteIssueLink, JiraConfluenceRemoteIssueLink, JiraWebRemoteIssueLink, JiraCustomRemoteIssueLink] */ 
let $78ad46e0d6808149$export$f82857e2145c8247 = /*#__PURE__*/ function(GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput) {
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["Bamboo"] = "BAMBOO";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["BbPrComment"] = "BB_PR_COMMENT";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["ConfluencePage"] = "CONFLUENCE_PAGE";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["Jira"] = "JIRA";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["Snyk"] = "SNYK";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["Trello"] = "TRELLO";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["WebLink"] = "WEB_LINK";
    return GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput;
}({});
let $78ad46e0d6808149$export$90175675ed9a274f = /*#__PURE__*/ function(GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput) {
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["AddedToIdea"] = "ADDED_TO_IDEA";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["Blocks"] = "BLOCKS";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["Causes"] = "CAUSES";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["Clones"] = "CLONES";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["CreatedFrom"] = "CREATED_FROM";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["Duplicates"] = "DUPLICATES";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["Implements"] = "IMPLEMENTS";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["IsBlockedBy"] = "IS_BLOCKED_BY";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["IsCausedBy"] = "IS_CAUSED_BY";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["IsClonedBy"] = "IS_CLONED_BY";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["IsDuplicatedBy"] = "IS_DUPLICATED_BY";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["IsIdeaFor"] = "IS_IDEA_FOR";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["IsImplementedBy"] = "IS_IMPLEMENTED_BY";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["IsReviewedBy"] = "IS_REVIEWED_BY";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["MentionedIn"] = "MENTIONED_IN";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["MergedFrom"] = "MERGED_FROM";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["MergedInto"] = "MERGED_INTO";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["RelatesTo"] = "RELATES_TO";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["Reviews"] = "REVIEWS";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["SplitFrom"] = "SPLIT_FROM";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["SplitTo"] = "SPLIT_TO";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["WikiPage"] = "WIKI_PAGE";
    return GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput;
}({}); /** A node representing a issue-associated-issue-remote-link relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-issue-remote-link: [JiraIssue] */  /** A full relationship edge for the relationship type issue-associated-pr */  /** A union of the possible hydration types for issue-associated-pr: [DevOpsPullRequestDetails] */  /** A node representing a issue-associated-pr relationship, with all metadata (if available) */ 
let $78ad46e0d6808149$export$947d4abb5daf138e = /*#__PURE__*/ function(GraphStoreFullIssueAssociatedPrPullRequestStatusOutput) {
    GraphStoreFullIssueAssociatedPrPullRequestStatusOutput["Declined"] = "DECLINED";
    GraphStoreFullIssueAssociatedPrPullRequestStatusOutput["Merged"] = "MERGED";
    GraphStoreFullIssueAssociatedPrPullRequestStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedPrPullRequestStatusOutput["Open"] = "OPEN";
    GraphStoreFullIssueAssociatedPrPullRequestStatusOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullIssueAssociatedPrPullRequestStatusOutput;
}({});
let $78ad46e0d6808149$export$e353d7be2a12f0f2 = /*#__PURE__*/ function(GraphStoreFullIssueAssociatedPrReviewerReviewerStatusOutput) {
    GraphStoreFullIssueAssociatedPrReviewerReviewerStatusOutput["Approved"] = "APPROVED";
    GraphStoreFullIssueAssociatedPrReviewerReviewerStatusOutput["Needswork"] = "NEEDSWORK";
    GraphStoreFullIssueAssociatedPrReviewerReviewerStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedPrReviewerReviewerStatusOutput["Unapproved"] = "UNAPPROVED";
    return GraphStoreFullIssueAssociatedPrReviewerReviewerStatusOutput;
}({}); /** A union of the possible hydration types for issue-associated-pr: [JiraIssue] */  /** A full relationship edge for the relationship type issue-associated-remote-link */  /** A node representing a issue-associated-remote-link relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-remote-link: [JiraIssue] */  /** A full relationship edge for the relationship type issue-changes-component */  /** A union of the possible hydration types for issue-changes-component: [CompassComponent] */  /** A node representing a issue-changes-component relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-changes-component: [JiraIssue] */  /** A full relationship edge for the relationship type issue-recursive-associated-pr */  /** A union of the possible hydration types for issue-recursive-associated-pr: [DevOpsPullRequestDetails] */  /** A node representing a issue-recursive-associated-pr relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-recursive-associated-pr: [JiraIssue] */  /** A full relationship edge for the relationship type issue-to-whiteboard */  /** A union of the possible hydration types for issue-to-whiteboard: [ConfluenceWhiteboard] */  /** A node representing a issue-to-whiteboard relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-to-whiteboard: [JiraIssue] */  /** A full relationship edge for the relationship type jira-epic-contributes-to-atlas-goal */  /** A union of the possible hydration types for jira-epic-contributes-to-atlas-goal: [TownsquareGoal] */  /** A node representing a jira-epic-contributes-to-atlas-goal relationship, with all metadata (if available) */  /** A union of the possible hydration types for jira-epic-contributes-to-atlas-goal: [JiraIssue] */  /** A full relationship edge for the relationship type jira-project-associated-atlas-goal */  /** A union of the possible hydration types for jira-project-associated-atlas-goal: [TownsquareGoal] */  /** A node representing a jira-project-associated-atlas-goal relationship, with all metadata (if available) */  /** A union of the possible hydration types for jira-project-associated-atlas-goal: [JiraProject] */  /** A full relationship edge for the relationship type jsm-project-associated-service */  /** A union of the possible hydration types for jsm-project-associated-service: [DevOpsService] */  /** A node representing a jsm-project-associated-service relationship, with all metadata (if available) */  /** A union of the possible hydration types for jsm-project-associated-service: [JiraProject] */  /** A full relationship edge for the relationship type jsw-project-associated-component */  /** A union of the possible hydration types for jsw-project-associated-component: [DevOpsService, CompassComponent, DevOpsOperationsComponentDetails] */  /** A node representing a jsw-project-associated-component relationship, with all metadata (if available) */  /** A union of the possible hydration types for jsw-project-associated-component: [JiraProject] */  /** A full relationship edge for the relationship type jsw-project-associated-incident */  /** A union of the possible hydration types for jsw-project-associated-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */ 
let $78ad46e0d6808149$export$e336ee68867d9184 = /*#__PURE__*/ function(GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput) {
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["NotSet"] = "NOT_SET";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["P1"] = "P1";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["P2"] = "P2";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["P3"] = "P3";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["P4"] = "P4";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["P5"] = "P5";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["Pending"] = "PENDING";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput;
}({});
let $78ad46e0d6808149$export$8a57dccf86b2a6de = /*#__PURE__*/ function(GraphStoreFullJswProjectAssociatedIncidentJiraIncidentStatusOutput) {
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentStatusOutput["Done"] = "DONE";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentStatusOutput["Indeterminate"] = "INDETERMINATE";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentStatusOutput["New"] = "NEW";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentStatusOutput["Undefined"] = "UNDEFINED";
    return GraphStoreFullJswProjectAssociatedIncidentJiraIncidentStatusOutput;
}({}); /** A node representing a jsw-project-associated-incident relationship, with all metadata (if available) */  /** A union of the possible hydration types for jsw-project-associated-incident: [JiraProject] */  /** A full relationship edge for the relationship type jsw-project-shares-component-with-jsm-project */  /** A union of the possible hydration types for jsw-project-shares-component-with-jsm-project: [JiraProject] */  /** A node representing a jsw-project-shares-component-with-jsm-project relationship, with all metadata (if available) */  /** A union of the possible hydration types for jsw-project-shares-component-with-jsm-project: [JiraProject] */  /** A full relationship edge for the relationship type linked-project-has-version */  /** A union of the possible hydration types for linked-project-has-version: [JiraVersion] */  /** A node representing a linked-project-has-version relationship, with all metadata (if available) */  /** A union of the possible hydration types for linked-project-has-version: [JiraProject] */  /** A full relationship edge for the relationship type operations-container-impacted-by-incident */  /** A union of the possible hydration types for operations-container-impacted-by-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A node representing a operations-container-impacted-by-incident relationship, with all metadata (if available) */  /** A union of the possible hydration types for operations-container-impacted-by-incident: [DevOpsService] */  /** A full relationship edge for the relationship type operations-container-improved-by-action-item */  /** A union of the possible hydration types for operations-container-improved-by-action-item: [JiraIssue] */  /** A node representing a operations-container-improved-by-action-item relationship, with all metadata (if available) */  /** A union of the possible hydration types for operations-container-improved-by-action-item: [DevOpsService] */ 
let $78ad46e0d6808149$export$d781aa0d3a6bc4bd = /*#__PURE__*/ function(GraphStoreFullParentDocumentHasChildDocumentCategoryOutput) {
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Archive"] = "ARCHIVE";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Audio"] = "AUDIO";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Code"] = "CODE";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Document"] = "DOCUMENT";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Folder"] = "FOLDER";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Form"] = "FORM";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Image"] = "IMAGE";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["NotSet"] = "NOT_SET";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Other"] = "OTHER";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Pdf"] = "PDF";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Presentation"] = "PRESENTATION";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Shortcut"] = "SHORTCUT";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Spreadsheet"] = "SPREADSHEET";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Video"] = "VIDEO";
    return GraphStoreFullParentDocumentHasChildDocumentCategoryOutput;
}({}); /** A full relationship edge for the relationship type parent-document-has-child-document */  /** A union of the possible hydration types for parent-document-has-child-document: [DevOpsDocument] */  /** A node representing a parent-document-has-child-document relationship, with all metadata (if available) */  /** A union of the possible hydration types for parent-document-has-child-document: [DevOpsDocument] */  /** A full relationship edge for the relationship type parent-issue-has-child-issue */  /** A union of the possible hydration types for parent-issue-has-child-issue: [JiraIssue] */  /** A node representing a parent-issue-has-child-issue relationship, with all metadata (if available) */  /** A union of the possible hydration types for parent-issue-has-child-issue: [JiraIssue] */  /** A full relationship edge for the relationship type pr-in-repo */  /** A union of the possible hydration types for pr-in-repo: [DevOpsRepository] */  /** A node representing a pr-in-repo relationship, with all metadata (if available) */  /** A union of the possible hydration types for pr-in-repo: [DevOpsPullRequestDetails] */  /** A full relationship edge for the relationship type project-associated-branch */  /** A node representing a project-associated-branch relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-branch: [JiraProject] */ 
let $78ad46e0d6808149$export$12686f8906883b4d = /*#__PURE__*/ function(GraphStoreFullProjectAssociatedBuildBuildStateOutput) {
    GraphStoreFullProjectAssociatedBuildBuildStateOutput["Cancelled"] = "CANCELLED";
    GraphStoreFullProjectAssociatedBuildBuildStateOutput["Failed"] = "FAILED";
    GraphStoreFullProjectAssociatedBuildBuildStateOutput["InProgress"] = "IN_PROGRESS";
    GraphStoreFullProjectAssociatedBuildBuildStateOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedBuildBuildStateOutput["Pending"] = "PENDING";
    GraphStoreFullProjectAssociatedBuildBuildStateOutput["Successful"] = "SUCCESSFUL";
    GraphStoreFullProjectAssociatedBuildBuildStateOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullProjectAssociatedBuildBuildStateOutput;
}({}); /** A full relationship edge for the relationship type project-associated-build */  /** A node representing a project-associated-build relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-build: [JiraProject] */ 
let $78ad46e0d6808149$export$1a6794f56a498d8 = /*#__PURE__*/ function(GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput) {
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["Cancelled"] = "CANCELLED";
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["Failed"] = "FAILED";
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["InProgress"] = "IN_PROGRESS";
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["Pending"] = "PENDING";
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["RolledBack"] = "ROLLED_BACK";
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["Successful"] = "SUCCESSFUL";
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput;
}({}); /** A full relationship edge for the relationship type project-associated-deployment */  /** A union of the possible hydration types for project-associated-deployment: [DeploymentSummary] */ 
let $78ad46e0d6808149$export$757f321f826d4b9f = /*#__PURE__*/ function(GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput) {
    GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput["Development"] = "DEVELOPMENT";
    GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput["Production"] = "PRODUCTION";
    GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput["Staging"] = "STAGING";
    GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput["Testing"] = "TESTING";
    GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput["Unmapped"] = "UNMAPPED";
    return GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput;
}({}); /** A node representing a project-associated-deployment relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-deployment: [JiraProject] */  /** A full relationship edge for the relationship type project-associated-feature-flag */  /** A union of the possible hydration types for project-associated-feature-flag: [DevOpsFeatureFlag] */  /** A node representing a project-associated-feature-flag relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-feature-flag: [JiraProject] */  /** A full relationship edge for the relationship type project-associated-incident */  /** A union of the possible hydration types for project-associated-incident: [JiraIssue] */  /** A node representing a project-associated-incident relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-incident: [JiraProject] */  /** A full relationship edge for the relationship type project-associated-opsgenie-team */  /** A union of the possible hydration types for project-associated-opsgenie-team: [OpsgenieTeam] */  /** A node representing a project-associated-opsgenie-team relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-opsgenie-team: [JiraProject] */  /** A full relationship edge for the relationship type project-associated-pr */  /** A union of the possible hydration types for project-associated-pr: [DevOpsPullRequestDetails] */  /** A node representing a project-associated-pr relationship, with all metadata (if available) */ 
let $78ad46e0d6808149$export$bed7454cabd50a99 = /*#__PURE__*/ function(GraphStoreFullProjectAssociatedPrPullRequestStatusOutput) {
    GraphStoreFullProjectAssociatedPrPullRequestStatusOutput["Declined"] = "DECLINED";
    GraphStoreFullProjectAssociatedPrPullRequestStatusOutput["Merged"] = "MERGED";
    GraphStoreFullProjectAssociatedPrPullRequestStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedPrPullRequestStatusOutput["Open"] = "OPEN";
    GraphStoreFullProjectAssociatedPrPullRequestStatusOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullProjectAssociatedPrPullRequestStatusOutput;
}({});
let $78ad46e0d6808149$export$e0795a56969d3929 = /*#__PURE__*/ function(GraphStoreFullProjectAssociatedPrReviewerReviewerStatusOutput) {
    GraphStoreFullProjectAssociatedPrReviewerReviewerStatusOutput["Approved"] = "APPROVED";
    GraphStoreFullProjectAssociatedPrReviewerReviewerStatusOutput["Needswork"] = "NEEDSWORK";
    GraphStoreFullProjectAssociatedPrReviewerReviewerStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedPrReviewerReviewerStatusOutput["Unapproved"] = "UNAPPROVED";
    return GraphStoreFullProjectAssociatedPrReviewerReviewerStatusOutput;
}({}); /** A union of the possible hydration types for project-associated-pr: [JiraProject] */  /** A full relationship edge for the relationship type project-associated-repo */  /** A union of the possible hydration types for project-associated-repo: [DevOpsRepository] */  /** A node representing a project-associated-repo relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-repo: [JiraProject] */  /** A full relationship edge for the relationship type project-associated-service */  /** A union of the possible hydration types for project-associated-service: [DevOpsService] */  /** A node representing a project-associated-service relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-service: [JiraProject] */  /** A full relationship edge for the relationship type project-associated-to-incident */  /** A union of the possible hydration types for project-associated-to-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A node representing a project-associated-to-incident relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-to-incident: [JiraProject] */  /** A full relationship edge for the relationship type project-associated-to-operations-container */  /** A union of the possible hydration types for project-associated-to-operations-container: [DevOpsService] */  /** A node representing a project-associated-to-operations-container relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-to-operations-container: [JiraProject] */  /** A full relationship edge for the relationship type project-associated-to-security-container */  /** A node representing a project-associated-to-security-container relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-to-security-container: [JiraProject] */  /** A full relationship edge for the relationship type project-associated-vulnerability */  /** A union of the possible hydration types for project-associated-vulnerability: [DevOpsSecurityVulnerabilityDetails] */  /** A node representing a project-associated-vulnerability relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-vulnerability: [JiraProject] */ 
let $78ad46e0d6808149$export$c56f5d7588a02f34 = /*#__PURE__*/ function(GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput) {
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput["Critical"] = "CRITICAL";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput["High"] = "HIGH";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput["Low"] = "LOW";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput["Medium"] = "MEDIUM";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput;
}({});
let $78ad46e0d6808149$export$9406f481f6c79a5d = /*#__PURE__*/ function(GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityStatusOutput) {
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityStatusOutput["Closed"] = "CLOSED";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityStatusOutput["Ignored"] = "IGNORED";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityStatusOutput["Open"] = "OPEN";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityStatusOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityStatusOutput;
}({});
let $78ad46e0d6808149$export$d307e59860de1336 = /*#__PURE__*/ function(GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityTypeOutput) {
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityTypeOutput["Dast"] = "DAST";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityTypeOutput["Sast"] = "SAST";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityTypeOutput["Sca"] = "SCA";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityTypeOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityTypeOutput;
}({}); /** A full relationship edge for the relationship type project-disassociated-repo */  /** A union of the possible hydration types for project-disassociated-repo: [DevOpsRepository] */  /** A node representing a project-disassociated-repo relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-disassociated-repo: [JiraProject] */  /** A full relationship edge for the relationship type project-documentation-entity */  /** A union of the possible hydration types for project-documentation-entity: [ConfluenceSpace, ConfluencePage, DevOpsDocument] */  /** A node representing a project-documentation-entity relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-documentation-entity: [JiraProject] */  /** A full relationship edge for the relationship type project-documentation-page */  /** A union of the possible hydration types for project-documentation-page: [ConfluencePage] */  /** A node representing a project-documentation-page relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-documentation-page: [JiraProject] */  /** A full relationship edge for the relationship type project-documentation-space */  /** A union of the possible hydration types for project-documentation-space: [ConfluenceSpace] */  /** A node representing a project-documentation-space relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-documentation-space: [JiraProject] */  /** A full relationship edge for the relationship type project-explicitly-associated-repo */  /** A union of the possible hydration types for project-explicitly-associated-repo: [DevOpsRepository] */  /** A node representing a project-explicitly-associated-repo relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-explicitly-associated-repo: [JiraProject] */  /** A full relationship edge for the relationship type project-has-issue */  /** A union of the possible hydration types for project-has-issue: [JiraIssue] */  /** A node representing a project-has-issue relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-has-issue: [JiraProject] */  /** A full relationship edge for the relationship type project-has-shared-version-with */  /** A union of the possible hydration types for project-has-shared-version-with: [JiraProject] */  /** A node representing a project-has-shared-version-with relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-has-shared-version-with: [JiraProject] */  /** A full relationship edge for the relationship type project-has-version */  /** A union of the possible hydration types for project-has-version: [JiraVersion] */  /** A node representing a project-has-version relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-has-version: [JiraProject] */  /** A full relationship edge for the relationship type security-container-associated-to-vulnerability */  /** A union of the possible hydration types for security-container-associated-to-vulnerability: [DevOpsSecurityVulnerabilityDetails] */  /** A node representing a security-container-associated-to-vulnerability relationship, with all metadata (if available) */ 
let $78ad46e0d6808149$export$ec0309648167c01f = /*#__PURE__*/ function(GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput) {
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput["Critical"] = "CRITICAL";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput["High"] = "HIGH";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput["Low"] = "LOW";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput["Medium"] = "MEDIUM";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput;
}({});
let $78ad46e0d6808149$export$55ab07a5fac6a121 = /*#__PURE__*/ function(GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityStatusOutput) {
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityStatusOutput["Closed"] = "CLOSED";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityStatusOutput["Ignored"] = "IGNORED";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityStatusOutput["Open"] = "OPEN";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityStatusOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityStatusOutput;
}({});
let $78ad46e0d6808149$export$93214a30dc67e249 = /*#__PURE__*/ function(GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityTypeOutput) {
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityTypeOutput["Dast"] = "DAST";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityTypeOutput["Sast"] = "SAST";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityTypeOutput["Sca"] = "SCA";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityTypeOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityTypeOutput;
}({}); /** A full relationship edge for the relationship type service-linked-incident */  /** A union of the possible hydration types for service-linked-incident: [JiraIssue] */ 
let $78ad46e0d6808149$export$cb34d20b583b9880 = /*#__PURE__*/ function(GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput) {
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput["NotSet"] = "NOT_SET";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput["P1"] = "P1";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput["P2"] = "P2";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput["P3"] = "P3";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput["P4"] = "P4";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput["P5"] = "P5";
    return GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput;
}({});
let $78ad46e0d6808149$export$4f97d0efb46b21d7 = /*#__PURE__*/ function(GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentStatusOutput) {
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentStatusOutput["Done"] = "DONE";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentStatusOutput["Indeterminate"] = "INDETERMINATE";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentStatusOutput["New"] = "NEW";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentStatusOutput["Undefined"] = "UNDEFINED";
    return GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentStatusOutput;
}({}); /** A node representing a service-linked-incident relationship, with all metadata (if available) */  /** A union of the possible hydration types for service-linked-incident: [DevOpsService] */ 
let $78ad46e0d6808149$export$1faf908d1ac6334b = /*#__PURE__*/ function(GraphStoreFullSprintAssociatedBuildBuildStateOutput) {
    GraphStoreFullSprintAssociatedBuildBuildStateOutput["Cancelled"] = "CANCELLED";
    GraphStoreFullSprintAssociatedBuildBuildStateOutput["Failed"] = "FAILED";
    GraphStoreFullSprintAssociatedBuildBuildStateOutput["InProgress"] = "IN_PROGRESS";
    GraphStoreFullSprintAssociatedBuildBuildStateOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSprintAssociatedBuildBuildStateOutput["Pending"] = "PENDING";
    GraphStoreFullSprintAssociatedBuildBuildStateOutput["Successful"] = "SUCCESSFUL";
    GraphStoreFullSprintAssociatedBuildBuildStateOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullSprintAssociatedBuildBuildStateOutput;
}({}); /** A full relationship edge for the relationship type sprint-associated-build */  /** A node representing a sprint-associated-build relationship, with all metadata (if available) */ 
let $78ad46e0d6808149$export$5bab79a51fe84df7 = /*#__PURE__*/ function(GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput) {
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["Cancelled"] = "CANCELLED";
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["Failed"] = "FAILED";
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["InProgress"] = "IN_PROGRESS";
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["Pending"] = "PENDING";
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["RolledBack"] = "ROLLED_BACK";
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["Successful"] = "SUCCESSFUL";
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput;
}({}); /** A full relationship edge for the relationship type sprint-associated-deployment */  /** A union of the possible hydration types for sprint-associated-deployment: [DeploymentSummary] */ 
let $78ad46e0d6808149$export$c8f81b6916886c13 = /*#__PURE__*/ function(GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput) {
    GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput["Development"] = "DEVELOPMENT";
    GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput["Production"] = "PRODUCTION";
    GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput["Staging"] = "STAGING";
    GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput["Testing"] = "TESTING";
    GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput["Unmapped"] = "UNMAPPED";
    return GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput;
}({}); /** A node representing a sprint-associated-deployment relationship, with all metadata (if available) */  /** A full relationship edge for the relationship type sprint-associated-pr */  /** A union of the possible hydration types for sprint-associated-pr: [DevOpsPullRequestDetails] */  /** A node representing a sprint-associated-pr relationship, with all metadata (if available) */ 
let $78ad46e0d6808149$export$889f8821445073a8 = /*#__PURE__*/ function(GraphStoreFullSprintAssociatedPrPullRequestStatusOutput) {
    GraphStoreFullSprintAssociatedPrPullRequestStatusOutput["Declined"] = "DECLINED";
    GraphStoreFullSprintAssociatedPrPullRequestStatusOutput["Merged"] = "MERGED";
    GraphStoreFullSprintAssociatedPrPullRequestStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSprintAssociatedPrPullRequestStatusOutput["Open"] = "OPEN";
    GraphStoreFullSprintAssociatedPrPullRequestStatusOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullSprintAssociatedPrPullRequestStatusOutput;
}({});
let $78ad46e0d6808149$export$25d6205b4517999 = /*#__PURE__*/ function(GraphStoreFullSprintAssociatedPrReviewerReviewerStatusOutput) {
    GraphStoreFullSprintAssociatedPrReviewerReviewerStatusOutput["Approved"] = "APPROVED";
    GraphStoreFullSprintAssociatedPrReviewerReviewerStatusOutput["Needswork"] = "NEEDSWORK";
    GraphStoreFullSprintAssociatedPrReviewerReviewerStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSprintAssociatedPrReviewerReviewerStatusOutput["Unapproved"] = "UNAPPROVED";
    return GraphStoreFullSprintAssociatedPrReviewerReviewerStatusOutput;
}({}); /** A full relationship edge for the relationship type sprint-associated-vulnerability */  /** A union of the possible hydration types for sprint-associated-vulnerability: [DevOpsSecurityVulnerabilityDetails] */  /** A node representing a sprint-associated-vulnerability relationship, with all metadata (if available) */ 
let $78ad46e0d6808149$export$f128313c5c33553a = /*#__PURE__*/ function(GraphStoreFullSprintAssociatedVulnerabilityStatusCategoryOutput) {
    GraphStoreFullSprintAssociatedVulnerabilityStatusCategoryOutput["Done"] = "DONE";
    GraphStoreFullSprintAssociatedVulnerabilityStatusCategoryOutput["Indeterminate"] = "INDETERMINATE";
    GraphStoreFullSprintAssociatedVulnerabilityStatusCategoryOutput["New"] = "NEW";
    GraphStoreFullSprintAssociatedVulnerabilityStatusCategoryOutput["Undefined"] = "UNDEFINED";
    return GraphStoreFullSprintAssociatedVulnerabilityStatusCategoryOutput;
}({});
let $78ad46e0d6808149$export$987cd4ea5561fc8e = /*#__PURE__*/ function(GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput) {
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput["Critical"] = "CRITICAL";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput["High"] = "HIGH";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput["Low"] = "LOW";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput["Medium"] = "MEDIUM";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput;
}({});
let $78ad46e0d6808149$export$bf865dbaf78a8d95 = /*#__PURE__*/ function(GraphStoreFullSprintAssociatedVulnerabilityVulnerabilityStatusOutput) {
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilityStatusOutput["Closed"] = "CLOSED";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilityStatusOutput["Ignored"] = "IGNORED";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilityStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilityStatusOutput["Open"] = "OPEN";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilityStatusOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullSprintAssociatedVulnerabilityVulnerabilityStatusOutput;
}({}); /** A full relationship edge for the relationship type sprint-contains-issue */  /** A union of the possible hydration types for sprint-contains-issue: [JiraIssue] */  /** A node representing a sprint-contains-issue relationship, with all metadata (if available) */ 
let $78ad46e0d6808149$export$5296991171ff0fcb = /*#__PURE__*/ function(GraphStoreFullSprintContainsIssueStatusCategoryOutput) {
    GraphStoreFullSprintContainsIssueStatusCategoryOutput["Done"] = "DONE";
    GraphStoreFullSprintContainsIssueStatusCategoryOutput["Indeterminate"] = "INDETERMINATE";
    GraphStoreFullSprintContainsIssueStatusCategoryOutput["New"] = "NEW";
    GraphStoreFullSprintContainsIssueStatusCategoryOutput["Undefined"] = "UNDEFINED";
    return GraphStoreFullSprintContainsIssueStatusCategoryOutput;
}({}); /** A full relationship edge for the relationship type sprint-retrospective-page */  /** A union of the possible hydration types for sprint-retrospective-page: [ConfluencePage] */  /** A node representing a sprint-retrospective-page relationship, with all metadata (if available) */  /** A full relationship edge for the relationship type sprint-retrospective-whiteboard */  /** A union of the possible hydration types for sprint-retrospective-whiteboard: [ConfluenceWhiteboard] */  /** A node representing a sprint-retrospective-whiteboard relationship, with all metadata (if available) */  /** A full relationship edge for the relationship type team-works-on-project */  /** A union of the possible hydration types for team-works-on-project: [JiraProject] */  /** A node representing a team-works-on-project relationship, with all metadata (if available) */  /** A full relationship edge for the relationship type version-associated-branch */  /** A node representing a version-associated-branch relationship, with all metadata (if available) */  /** A union of the possible hydration types for version-associated-branch: [JiraVersion] */  /** A full relationship edge for the relationship type version-associated-build */  /** A node representing a version-associated-build relationship, with all metadata (if available) */  /** A union of the possible hydration types for version-associated-build: [JiraVersion] */  /** A full relationship edge for the relationship type version-associated-commit */  /** A node representing a version-associated-commit relationship, with all metadata (if available) */  /** A union of the possible hydration types for version-associated-commit: [JiraVersion] */  /** A full relationship edge for the relationship type version-associated-deployment */  /** A union of the possible hydration types for version-associated-deployment: [DeploymentSummary] */  /** A node representing a version-associated-deployment relationship, with all metadata (if available) */  /** A union of the possible hydration types for version-associated-deployment: [JiraVersion] */ 
let $78ad46e0d6808149$export$50919f92f150f4c2 = /*#__PURE__*/ function(GraphStoreFullVersionAssociatedDesignDesignStatusOutput) {
    GraphStoreFullVersionAssociatedDesignDesignStatusOutput["None"] = "NONE";
    GraphStoreFullVersionAssociatedDesignDesignStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullVersionAssociatedDesignDesignStatusOutput["ReadyForDevelopment"] = "READY_FOR_DEVELOPMENT";
    GraphStoreFullVersionAssociatedDesignDesignStatusOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullVersionAssociatedDesignDesignStatusOutput;
}({});
let $78ad46e0d6808149$export$a1b88d68d1f49808 = /*#__PURE__*/ function(GraphStoreFullVersionAssociatedDesignDesignTypeOutput) {
    GraphStoreFullVersionAssociatedDesignDesignTypeOutput["Canvas"] = "CANVAS";
    GraphStoreFullVersionAssociatedDesignDesignTypeOutput["File"] = "FILE";
    GraphStoreFullVersionAssociatedDesignDesignTypeOutput["Group"] = "GROUP";
    GraphStoreFullVersionAssociatedDesignDesignTypeOutput["Node"] = "NODE";
    GraphStoreFullVersionAssociatedDesignDesignTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullVersionAssociatedDesignDesignTypeOutput["Other"] = "OTHER";
    GraphStoreFullVersionAssociatedDesignDesignTypeOutput["Prototype"] = "PROTOTYPE";
    return GraphStoreFullVersionAssociatedDesignDesignTypeOutput;
}({}); /** A full relationship edge for the relationship type version-associated-design */  /** A union of the possible hydration types for version-associated-design: [DevOpsDesign] */  /** A node representing a version-associated-design relationship, with all metadata (if available) */  /** A union of the possible hydration types for version-associated-design: [JiraVersion] */  /** A full relationship edge for the relationship type version-associated-feature-flag */  /** A union of the possible hydration types for version-associated-feature-flag: [DevOpsFeatureFlag] */  /** A node representing a version-associated-feature-flag relationship, with all metadata (if available) */  /** A union of the possible hydration types for version-associated-feature-flag: [JiraVersion] */  /** A full relationship edge for the relationship type version-associated-issue */  /** A union of the possible hydration types for version-associated-issue: [JiraIssue] */  /** A node representing a version-associated-issue relationship, with all metadata (if available) */  /** A union of the possible hydration types for version-associated-issue: [JiraVersion] */  /** A full relationship edge for the relationship type version-associated-pull-request */  /** A union of the possible hydration types for version-associated-pull-request: [DevOpsPullRequestDetails] */  /** A node representing a version-associated-pull-request relationship, with all metadata (if available) */  /** A union of the possible hydration types for version-associated-pull-request: [JiraVersion] */  /** A full relationship edge for the relationship type version-associated-remote-link */  /** A node representing a version-associated-remote-link relationship, with all metadata (if available) */  /** A union of the possible hydration types for version-associated-remote-link: [JiraVersion] */  /** A full relationship edge for the relationship type version-user-associated-feature-flag */  /** A union of the possible hydration types for version-user-associated-feature-flag: [DevOpsFeatureFlag] */  /** A node representing a version-user-associated-feature-flag relationship, with all metadata (if available) */  /** A union of the possible hydration types for version-user-associated-feature-flag: [JiraVersion] */  /** A full relationship edge for the relationship type vulnerability-associated-issue */  /** A union of the possible hydration types for vulnerability-associated-issue: [JiraIssue] */  /** A node representing a vulnerability-associated-issue relationship, with all metadata (if available) */  /** A union of the possible hydration types for vulnerability-associated-issue: [DevOpsSecurityVulnerabilityDetails] */ 
let $78ad46e0d6808149$export$fabcab228e2ed9c7 = /*#__PURE__*/ function(GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput) {
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput["Critical"] = "CRITICAL";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput["High"] = "HIGH";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput["Low"] = "LOW";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput["Medium"] = "MEDIUM";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput["NotSet"] = "NOT_SET";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput;
}({});
let $78ad46e0d6808149$export$6e4f0b0ee9bb1b2b = /*#__PURE__*/ function(GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityStatusOutput) {
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityStatusOutput["Closed"] = "CLOSED";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityStatusOutput["Ignored"] = "IGNORED";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityStatusOutput["Open"] = "OPEN";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityStatusOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityStatusOutput;
}({});
let $78ad46e0d6808149$export$4ec664baba8498fa = /*#__PURE__*/ function(GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityTypeOutput) {
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityTypeOutput["Dast"] = "DAST";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityTypeOutput["Sast"] = "SAST";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityTypeOutput["Sca"] = "SCA";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityTypeOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityTypeOutput;
}({});
let $78ad46e0d6808149$export$ca58efde64d86f94 = /*#__PURE__*/ function(GraphStoreIssueAssociatedDeploymentDeploymentState) {
    GraphStoreIssueAssociatedDeploymentDeploymentState["Cancelled"] = "CANCELLED";
    GraphStoreIssueAssociatedDeploymentDeploymentState["Failed"] = "FAILED";
    GraphStoreIssueAssociatedDeploymentDeploymentState["InProgress"] = "IN_PROGRESS";
    GraphStoreIssueAssociatedDeploymentDeploymentState["NotSet"] = "NOT_SET";
    GraphStoreIssueAssociatedDeploymentDeploymentState["Pending"] = "PENDING";
    GraphStoreIssueAssociatedDeploymentDeploymentState["RolledBack"] = "ROLLED_BACK";
    GraphStoreIssueAssociatedDeploymentDeploymentState["Successful"] = "SUCCESSFUL";
    GraphStoreIssueAssociatedDeploymentDeploymentState["Unknown"] = "UNKNOWN";
    return GraphStoreIssueAssociatedDeploymentDeploymentState;
}({});
let $78ad46e0d6808149$export$3ad8a7711584b9be = /*#__PURE__*/ function(GraphStoreIssueAssociatedDeploymentEnvironmentType) {
    GraphStoreIssueAssociatedDeploymentEnvironmentType["Development"] = "DEVELOPMENT";
    GraphStoreIssueAssociatedDeploymentEnvironmentType["NotSet"] = "NOT_SET";
    GraphStoreIssueAssociatedDeploymentEnvironmentType["Production"] = "PRODUCTION";
    GraphStoreIssueAssociatedDeploymentEnvironmentType["Staging"] = "STAGING";
    GraphStoreIssueAssociatedDeploymentEnvironmentType["Testing"] = "TESTING";
    GraphStoreIssueAssociatedDeploymentEnvironmentType["Unmapped"] = "UNMAPPED";
    return GraphStoreIssueAssociatedDeploymentEnvironmentType;
}({}); /** Conditional selection for filter field of issue-associated-deployment relationship queries */  /** Conditional selection for filter field of jsw-project-associated-incident relationship queries */ 
let $78ad46e0d6808149$export$a79c5b827301ce70 = /*#__PURE__*/ function(GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority) {
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["NotSet"] = "NOT_SET";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["P1"] = "P1";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["P2"] = "P2";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["P3"] = "P3";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["P4"] = "P4";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["P5"] = "P5";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["Pending"] = "PENDING";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["Unknown"] = "UNKNOWN";
    return GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority;
}({});
let $78ad46e0d6808149$export$bb923b67e7b3c5a3 = /*#__PURE__*/ function(GraphStoreJswProjectAssociatedIncidentJiraIncidentStatus) {
    GraphStoreJswProjectAssociatedIncidentJiraIncidentStatus["Done"] = "DONE";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentStatus["Indeterminate"] = "INDETERMINATE";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentStatus["New"] = "NEW";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentStatus["NotSet"] = "NOT_SET";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentStatus["Undefined"] = "UNDEFINED";
    return GraphStoreJswProjectAssociatedIncidentJiraIncidentStatus;
}({});
let $78ad46e0d6808149$export$f153746befb8db60 = /*#__PURE__*/ function(GraphStoreProjectAssociatedBuildBuildState) {
    GraphStoreProjectAssociatedBuildBuildState["Cancelled"] = "CANCELLED";
    GraphStoreProjectAssociatedBuildBuildState["Failed"] = "FAILED";
    GraphStoreProjectAssociatedBuildBuildState["InProgress"] = "IN_PROGRESS";
    GraphStoreProjectAssociatedBuildBuildState["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedBuildBuildState["Pending"] = "PENDING";
    GraphStoreProjectAssociatedBuildBuildState["Successful"] = "SUCCESSFUL";
    GraphStoreProjectAssociatedBuildBuildState["Unknown"] = "UNKNOWN";
    return GraphStoreProjectAssociatedBuildBuildState;
}({}); /** Conditional selection for filter field of project-associated-build relationship queries */ 
let $78ad46e0d6808149$export$3d406ab6bd989229 = /*#__PURE__*/ function(GraphStoreProjectAssociatedDeploymentDeploymentState) {
    GraphStoreProjectAssociatedDeploymentDeploymentState["Cancelled"] = "CANCELLED";
    GraphStoreProjectAssociatedDeploymentDeploymentState["Failed"] = "FAILED";
    GraphStoreProjectAssociatedDeploymentDeploymentState["InProgress"] = "IN_PROGRESS";
    GraphStoreProjectAssociatedDeploymentDeploymentState["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedDeploymentDeploymentState["Pending"] = "PENDING";
    GraphStoreProjectAssociatedDeploymentDeploymentState["RolledBack"] = "ROLLED_BACK";
    GraphStoreProjectAssociatedDeploymentDeploymentState["Successful"] = "SUCCESSFUL";
    GraphStoreProjectAssociatedDeploymentDeploymentState["Unknown"] = "UNKNOWN";
    return GraphStoreProjectAssociatedDeploymentDeploymentState;
}({});
let $78ad46e0d6808149$export$1e042c9b11303649 = /*#__PURE__*/ function(GraphStoreProjectAssociatedDeploymentEnvironmentType) {
    GraphStoreProjectAssociatedDeploymentEnvironmentType["Development"] = "DEVELOPMENT";
    GraphStoreProjectAssociatedDeploymentEnvironmentType["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedDeploymentEnvironmentType["Production"] = "PRODUCTION";
    GraphStoreProjectAssociatedDeploymentEnvironmentType["Staging"] = "STAGING";
    GraphStoreProjectAssociatedDeploymentEnvironmentType["Testing"] = "TESTING";
    GraphStoreProjectAssociatedDeploymentEnvironmentType["Unmapped"] = "UNMAPPED";
    return GraphStoreProjectAssociatedDeploymentEnvironmentType;
}({}); /** Conditional selection for filter field of project-associated-deployment relationship queries */  /** Conditional selection for filter field of project-associated-pr relationship queries */ 
let $78ad46e0d6808149$export$4d0f434df5bd5f5d = /*#__PURE__*/ function(GraphStoreProjectAssociatedPrPullRequestStatus) {
    GraphStoreProjectAssociatedPrPullRequestStatus["Declined"] = "DECLINED";
    GraphStoreProjectAssociatedPrPullRequestStatus["Merged"] = "MERGED";
    GraphStoreProjectAssociatedPrPullRequestStatus["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedPrPullRequestStatus["Open"] = "OPEN";
    GraphStoreProjectAssociatedPrPullRequestStatus["Unknown"] = "UNKNOWN";
    return GraphStoreProjectAssociatedPrPullRequestStatus;
}({});
let $78ad46e0d6808149$export$7b819b5db45ec714 = /*#__PURE__*/ function(GraphStoreProjectAssociatedPrReviewerReviewerStatus) {
    GraphStoreProjectAssociatedPrReviewerReviewerStatus["Approved"] = "APPROVED";
    GraphStoreProjectAssociatedPrReviewerReviewerStatus["Needswork"] = "NEEDSWORK";
    GraphStoreProjectAssociatedPrReviewerReviewerStatus["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedPrReviewerReviewerStatus["Unapproved"] = "UNAPPROVED";
    return GraphStoreProjectAssociatedPrReviewerReviewerStatus;
}({}); /** Conditional selection for filter field of project-associated-repo relationship queries */  /** Conditional selection for filter field of project-associated-vulnerability relationship queries */ 
let $78ad46e0d6808149$export$8960ee08b61499ff = /*#__PURE__*/ function(GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity) {
    GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity["Critical"] = "CRITICAL";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity["High"] = "HIGH";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity["Low"] = "LOW";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity["Medium"] = "MEDIUM";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity["Unknown"] = "UNKNOWN";
    return GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity;
}({});
let $78ad46e0d6808149$export$4079472ae478c8b5 = /*#__PURE__*/ function(GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatus) {
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatus["Closed"] = "CLOSED";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatus["Ignored"] = "IGNORED";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatus["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatus["Open"] = "OPEN";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatus["Unknown"] = "UNKNOWN";
    return GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatus;
}({});
let $78ad46e0d6808149$export$52c8ce54b5f1ece6 = /*#__PURE__*/ function(GraphStoreProjectAssociatedVulnerabilityVulnerabilityType) {
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityType["Dast"] = "DAST";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityType["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityType["Sast"] = "SAST";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityType["Sca"] = "SCA";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityType["Unknown"] = "UNKNOWN";
    return GraphStoreProjectAssociatedVulnerabilityVulnerabilityType;
}({}); /** Conditional selection for filter field of project-has-issue relationship queries */  /** Conditional selection for filter field of service-linked-incident relationship queries */ 
let $78ad46e0d6808149$export$50ace2d33df76dc8 = /*#__PURE__*/ function(GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority) {
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority["NotSet"] = "NOT_SET";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority["P1"] = "P1";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority["P2"] = "P2";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority["P3"] = "P3";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority["P4"] = "P4";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority["P5"] = "P5";
    return GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority;
}({});
let $78ad46e0d6808149$export$b9597115770809a4 = /*#__PURE__*/ function(GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatus) {
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatus["Done"] = "DONE";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatus["Indeterminate"] = "INDETERMINATE";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatus["New"] = "NEW";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatus["NotSet"] = "NOT_SET";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatus["Undefined"] = "UNDEFINED";
    return GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatus;
}({}); /** A simplified connection for the relationship type atlas-project-contributes-to-atlas-goal */  /** A simplified edge for the relationship type atlas-project-contributes-to-atlas-goal */  /** A simplified connection for the relationship type atlas-project-contributes-to-atlas-goal */  /** A simplified edge for the relationship type atlas-project-contributes-to-atlas-goal */  /** A union of the possible hydration types for atlas-project-contributes-to-atlas-goal: [TownsquareProject] */  /** A union of the possible hydration types for atlas-project-contributes-to-atlas-goal: [TownsquareGoal] */  /** A simplified connection for the relationship type atlas-project-is-tracked-on-jira-epic */  /** A simplified edge for the relationship type atlas-project-is-tracked-on-jira-epic */  /** A simplified connection for the relationship type atlas-project-is-tracked-on-jira-epic */  /** A simplified edge for the relationship type atlas-project-is-tracked-on-jira-epic */  /** A union of the possible hydration types for atlas-project-is-tracked-on-jira-epic: [TownsquareProject] */  /** A union of the possible hydration types for atlas-project-is-tracked-on-jira-epic: [JiraIssue] */  /** A simplified connection for the relationship type component-impacted-by-incident */  /** A simplified edge for the relationship type component-impacted-by-incident */  /** A simplified connection for the relationship type component-impacted-by-incident */  /** A simplified edge for the relationship type component-impacted-by-incident */  /** A union of the possible hydration types for component-impacted-by-incident: [CompassComponent, DevOpsOperationsComponentDetails] */  /** A union of the possible hydration types for component-impacted-by-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A simplified connection for the relationship type component-link-is-jira-project */  /** A simplified edge for the relationship type component-link-is-jira-project */  /** A union of the possible hydration types for component-link-is-jira-project: [JiraProject] */  /** A simplified connection for the relationship type component-linked-jsw-issue */  /** A simplified edge for the relationship type component-linked-jsw-issue */  /** A simplified connection for the relationship type component-linked-jsw-issue */  /** A simplified edge for the relationship type component-linked-jsw-issue */  /** A union of the possible hydration types for component-linked-jsw-issue: [CompassComponent, DevOpsService, DevOpsOperationsComponentDetails] */  /** A union of the possible hydration types for component-linked-jsw-issue: [JiraIssue] */  /** A simplified connection for the relationship type content-referenced-entity */  /** A simplified edge for the relationship type content-referenced-entity */  /** A simplified connection for the relationship type content-referenced-entity */  /** A simplified edge for the relationship type content-referenced-entity */  /** A union of the possible hydration types for content-referenced-entity: [JiraIssue, ConfluencePage] */  /** A union of the possible hydration types for content-referenced-entity: [JiraIssue, ConfluencePage, CompassComponent] */  /** A simplified connection for the relationship type focus-area-associated-to-project */  /** A simplified edge for the relationship type focus-area-associated-to-project */  /** A simplified connection for the relationship type focus-area-associated-to-project */  /** A simplified edge for the relationship type focus-area-associated-to-project */  /** A union of the possible hydration types for focus-area-associated-to-project: [MercuryFocusArea] */  /** A union of the possible hydration types for focus-area-associated-to-project: [DevOpsProjectDetails] */  /** A simplified connection for the relationship type focus-area-has-atlas-goal */  /** A simplified edge for the relationship type focus-area-has-atlas-goal */  /** A simplified connection for the relationship type focus-area-has-atlas-goal */  /** A simplified edge for the relationship type focus-area-has-atlas-goal */  /** A union of the possible hydration types for focus-area-has-atlas-goal: [MercuryFocusArea] */  /** A union of the possible hydration types for focus-area-has-atlas-goal: [TownsquareGoal] */  /** A simplified connection for the relationship type focus-area-has-focus-area */  /** A simplified edge for the relationship type focus-area-has-focus-area */  /** A simplified connection for the relationship type focus-area-has-focus-area */  /** A simplified edge for the relationship type focus-area-has-focus-area */  /** A union of the possible hydration types for focus-area-has-focus-area: [MercuryFocusArea] */  /** A union of the possible hydration types for focus-area-has-focus-area: [MercuryFocusArea] */  /** A simplified connection for the relationship type focus-area-has-project */  /** A simplified edge for the relationship type focus-area-has-project */  /** A simplified connection for the relationship type focus-area-has-project */  /** A simplified edge for the relationship type focus-area-has-project */  /** A union of the possible hydration types for focus-area-has-project: [MercuryFocusArea] */  /** A union of the possible hydration types for focus-area-has-project: [TownsquareProject, JiraIssue] */  /** A simplified connection for the relationship type incident-associated-post-incident-review */  /** A simplified edge for the relationship type incident-associated-post-incident-review */  /** A simplified connection for the relationship type incident-associated-post-incident-review */  /** A simplified edge for the relationship type incident-associated-post-incident-review */  /** A union of the possible hydration types for incident-associated-post-incident-review: [JiraIssue] */  /** A simplified connection for the relationship type incident-associated-post-incident-review-link */  /** A simplified edge for the relationship type incident-associated-post-incident-review-link */  /** A simplified connection for the relationship type incident-associated-post-incident-review-link */  /** A simplified edge for the relationship type incident-associated-post-incident-review-link */  /** A union of the possible hydration types for incident-associated-post-incident-review-link: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A union of the possible hydration types for incident-associated-post-incident-review-link: [JiraIssue, JiraPostIncidentReviewLink, DevOpsOperationsPostIncidentReviewDetails] */  /** A union of the possible hydration types for incident-associated-post-incident-review: [JiraIssue] */  /** A simplified connection for the relationship type incident-has-action-item */  /** A simplified edge for the relationship type incident-has-action-item */  /** A simplified connection for the relationship type incident-has-action-item */  /** A simplified edge for the relationship type incident-has-action-item */  /** A union of the possible hydration types for incident-has-action-item: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A union of the possible hydration types for incident-has-action-item: [JiraIssue] */  /** A simplified connection for the relationship type incident-linked-jsw-issue */  /** A simplified edge for the relationship type incident-linked-jsw-issue */  /** A simplified connection for the relationship type incident-linked-jsw-issue */  /** A simplified edge for the relationship type incident-linked-jsw-issue */  /** A union of the possible hydration types for incident-linked-jsw-issue: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A union of the possible hydration types for incident-linked-jsw-issue: [JiraIssue] */  /** A simplified connection for the relationship type issue-associated-branch */  /** A simplified edge for the relationship type issue-associated-branch */  /** A union of the possible hydration types for issue-associated-branch: [JiraIssue] */  /** A simplified connection for the relationship type issue-associated-build */  /** A simplified edge for the relationship type issue-associated-build */  /** A union of the possible hydration types for issue-associated-build: [JiraIssue] */  /** A simplified connection for the relationship type issue-associated-commit */  /** A simplified edge for the relationship type issue-associated-commit */  /** A union of the possible hydration types for issue-associated-commit: [JiraIssue] */  /** A simplified connection for the relationship type issue-associated-deployment */  /** A simplified edge for the relationship type issue-associated-deployment */  /** A simplified connection for the relationship type issue-associated-deployment */  /** A simplified edge for the relationship type issue-associated-deployment */  /** A union of the possible hydration types for issue-associated-deployment: [JiraIssue] */  /** A union of the possible hydration types for issue-associated-deployment: [DeploymentSummary] */  /** A simplified connection for the relationship type issue-associated-design */  /** A simplified edge for the relationship type issue-associated-design */  /** A simplified connection for the relationship type issue-associated-design */  /** A simplified edge for the relationship type issue-associated-design */  /** A union of the possible hydration types for issue-associated-design: [JiraIssue] */  /** A union of the possible hydration types for issue-associated-design: [DevOpsDesign] */  /** A simplified connection for the relationship type issue-associated-feature-flag */  /** A simplified edge for the relationship type issue-associated-feature-flag */  /** A simplified connection for the relationship type issue-associated-feature-flag */  /** A simplified edge for the relationship type issue-associated-feature-flag */  /** A union of the possible hydration types for issue-associated-feature-flag: [JiraIssue] */  /** A union of the possible hydration types for issue-associated-feature-flag: [DevOpsFeatureFlag] */  /** A simplified connection for the relationship type issue-associated-issue-remote-link */  /** A simplified edge for the relationship type issue-associated-issue-remote-link */  /** A simplified connection for the relationship type issue-associated-issue-remote-link */  /** A simplified edge for the relationship type issue-associated-issue-remote-link */  /** A union of the possible hydration types for issue-associated-issue-remote-link: [JiraIssue] */  /** A union of the possible hydration types for issue-associated-issue-remote-link: [JiraIssueRemoteIssueLink, JiraConfluenceRemoteIssueLink, JiraWebRemoteIssueLink, JiraCustomRemoteIssueLink] */  /** A simplified connection for the relationship type issue-associated-pr */  /** A simplified edge for the relationship type issue-associated-pr */  /** A simplified connection for the relationship type issue-associated-pr */  /** A simplified edge for the relationship type issue-associated-pr */  /** A union of the possible hydration types for issue-associated-pr: [JiraIssue] */  /** A union of the possible hydration types for issue-associated-pr: [DevOpsPullRequestDetails] */  /** A simplified connection for the relationship type issue-associated-remote-link */  /** A simplified edge for the relationship type issue-associated-remote-link */  /** A union of the possible hydration types for issue-associated-remote-link: [JiraIssue] */  /** A simplified connection for the relationship type issue-changes-component */  /** A simplified edge for the relationship type issue-changes-component */  /** A simplified connection for the relationship type issue-changes-component */  /** A simplified edge for the relationship type issue-changes-component */  /** A union of the possible hydration types for issue-changes-component: [JiraIssue] */  /** A union of the possible hydration types for issue-changes-component: [CompassComponent] */  /** A simplified connection for the relationship type issue-recursive-associated-pr */  /** A simplified edge for the relationship type issue-recursive-associated-pr */  /** A simplified connection for the relationship type issue-recursive-associated-pr */  /** A simplified edge for the relationship type issue-recursive-associated-pr */  /** A union of the possible hydration types for issue-recursive-associated-pr: [JiraIssue] */  /** A union of the possible hydration types for issue-recursive-associated-pr: [DevOpsPullRequestDetails] */  /** A simplified connection for the relationship type issue-to-whiteboard */  /** A simplified edge for the relationship type issue-to-whiteboard */  /** A simplified connection for the relationship type issue-to-whiteboard */  /** A simplified edge for the relationship type issue-to-whiteboard */  /** A union of the possible hydration types for issue-to-whiteboard: [JiraIssue] */  /** A union of the possible hydration types for issue-to-whiteboard: [ConfluenceWhiteboard] */  /** A simplified connection for the relationship type jira-epic-contributes-to-atlas-goal */  /** A simplified edge for the relationship type jira-epic-contributes-to-atlas-goal */  /** A simplified connection for the relationship type jira-epic-contributes-to-atlas-goal */  /** A simplified edge for the relationship type jira-epic-contributes-to-atlas-goal */  /** A union of the possible hydration types for jira-epic-contributes-to-atlas-goal: [JiraIssue] */  /** A union of the possible hydration types for jira-epic-contributes-to-atlas-goal: [TownsquareGoal] */  /** A simplified connection for the relationship type jira-project-associated-atlas-goal */  /** A simplified edge for the relationship type jira-project-associated-atlas-goal */  /** A simplified connection for the relationship type jira-project-associated-atlas-goal */  /** A simplified edge for the relationship type jira-project-associated-atlas-goal */  /** A union of the possible hydration types for jira-project-associated-atlas-goal: [JiraProject] */  /** A union of the possible hydration types for jira-project-associated-atlas-goal: [TownsquareGoal] */  /** A simplified connection for the relationship type jsm-project-associated-service */  /** A simplified edge for the relationship type jsm-project-associated-service */  /** A simplified connection for the relationship type jsm-project-associated-service */  /** A simplified edge for the relationship type jsm-project-associated-service */  /** A union of the possible hydration types for jsm-project-associated-service: [JiraProject] */  /** A union of the possible hydration types for jsm-project-associated-service: [DevOpsService] */  /** A simplified connection for the relationship type jsw-project-associated-component */  /** A simplified edge for the relationship type jsw-project-associated-component */  /** A simplified connection for the relationship type jsw-project-associated-component */  /** A simplified edge for the relationship type jsw-project-associated-component */  /** A union of the possible hydration types for jsw-project-associated-component: [JiraProject] */  /** A union of the possible hydration types for jsw-project-associated-component: [DevOpsService, CompassComponent, DevOpsOperationsComponentDetails] */  /** A simplified connection for the relationship type jsw-project-associated-incident */  /** A simplified edge for the relationship type jsw-project-associated-incident */  /** A simplified connection for the relationship type jsw-project-associated-incident */  /** A simplified edge for the relationship type jsw-project-associated-incident */  /** A union of the possible hydration types for jsw-project-associated-incident: [JiraProject] */  /** A union of the possible hydration types for jsw-project-associated-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A simplified connection for the relationship type jsw-project-shares-component-with-jsm-project */  /** A simplified edge for the relationship type jsw-project-shares-component-with-jsm-project */  /** A simplified connection for the relationship type jsw-project-shares-component-with-jsm-project */  /** A simplified edge for the relationship type jsw-project-shares-component-with-jsm-project */  /** A union of the possible hydration types for jsw-project-shares-component-with-jsm-project: [JiraProject] */  /** A union of the possible hydration types for jsw-project-shares-component-with-jsm-project: [JiraProject] */  /** A simplified connection for the relationship type linked-project-has-version */  /** A simplified edge for the relationship type linked-project-has-version */  /** A simplified connection for the relationship type linked-project-has-version */  /** A simplified edge for the relationship type linked-project-has-version */  /** A union of the possible hydration types for linked-project-has-version: [JiraProject] */  /** A union of the possible hydration types for linked-project-has-version: [JiraVersion] */  /** A simplified connection for the relationship type media-attached-to-content */  /** A simplified edge for the relationship type media-attached-to-content */  /** A union of the possible hydration types for media-attached-to-content: [JiraIssue, ConfluencePage] */  /** A simplified connection for the relationship type operations-container-impacted-by-incident */  /** A simplified edge for the relationship type operations-container-impacted-by-incident */  /** A simplified connection for the relationship type operations-container-impacted-by-incident */  /** A simplified edge for the relationship type operations-container-impacted-by-incident */  /** A union of the possible hydration types for operations-container-impacted-by-incident: [DevOpsService] */  /** A union of the possible hydration types for operations-container-impacted-by-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A simplified connection for the relationship type operations-container-improved-by-action-item */  /** A simplified edge for the relationship type operations-container-improved-by-action-item */  /** A simplified connection for the relationship type operations-container-improved-by-action-item */  /** A simplified edge for the relationship type operations-container-improved-by-action-item */  /** A union of the possible hydration types for operations-container-improved-by-action-item: [DevOpsService] */  /** A union of the possible hydration types for operations-container-improved-by-action-item: [JiraIssue] */  /** A simplified connection for the relationship type parent-document-has-child-document */  /** A simplified edge for the relationship type parent-document-has-child-document */  /** A simplified connection for the relationship type parent-document-has-child-document */  /** A simplified edge for the relationship type parent-document-has-child-document */  /** A union of the possible hydration types for parent-document-has-child-document: [DevOpsDocument] */  /** A union of the possible hydration types for parent-document-has-child-document: [DevOpsDocument] */  /** A simplified connection for the relationship type parent-issue-has-child-issue */  /** A simplified edge for the relationship type parent-issue-has-child-issue */  /** A simplified connection for the relationship type parent-issue-has-child-issue */  /** A simplified edge for the relationship type parent-issue-has-child-issue */  /** A union of the possible hydration types for parent-issue-has-child-issue: [JiraIssue] */  /** A union of the possible hydration types for parent-issue-has-child-issue: [JiraIssue] */  /** A simplified connection for the relationship type pr-in-repo */  /** A simplified edge for the relationship type pr-in-repo */  /** A simplified connection for the relationship type pr-in-repo */  /** A simplified edge for the relationship type pr-in-repo */  /** A union of the possible hydration types for pr-in-repo: [DevOpsPullRequestDetails] */  /** A union of the possible hydration types for pr-in-repo: [DevOpsRepository] */  /** A simplified connection for the relationship type project-associated-branch */  /** A simplified edge for the relationship type project-associated-branch */  /** A union of the possible hydration types for project-associated-branch: [JiraProject] */  /** A simplified connection for the relationship type project-associated-build */  /** A simplified edge for the relationship type project-associated-build */  /** A union of the possible hydration types for project-associated-build: [JiraProject] */  /** A simplified connection for the relationship type project-associated-deployment */  /** A simplified edge for the relationship type project-associated-deployment */  /** A simplified connection for the relationship type project-associated-deployment */  /** A simplified edge for the relationship type project-associated-deployment */  /** A union of the possible hydration types for project-associated-deployment: [JiraProject] */  /** A union of the possible hydration types for project-associated-deployment: [DeploymentSummary] */  /** A simplified connection for the relationship type project-associated-feature-flag */  /** A simplified edge for the relationship type project-associated-feature-flag */  /** A simplified connection for the relationship type project-associated-feature-flag */  /** A simplified edge for the relationship type project-associated-feature-flag */  /** A union of the possible hydration types for project-associated-feature-flag: [JiraProject] */  /** A union of the possible hydration types for project-associated-feature-flag: [DevOpsFeatureFlag] */  /** A simplified connection for the relationship type project-associated-incident */  /** A simplified edge for the relationship type project-associated-incident */  /** A simplified connection for the relationship type project-associated-incident */  /** A simplified edge for the relationship type project-associated-incident */  /** A union of the possible hydration types for project-associated-incident: [JiraProject] */  /** A union of the possible hydration types for project-associated-incident: [JiraIssue] */  /** A simplified connection for the relationship type project-associated-opsgenie-team */  /** A simplified edge for the relationship type project-associated-opsgenie-team */  /** A simplified connection for the relationship type project-associated-opsgenie-team */  /** A simplified edge for the relationship type project-associated-opsgenie-team */  /** A union of the possible hydration types for project-associated-opsgenie-team: [JiraProject] */  /** A union of the possible hydration types for project-associated-opsgenie-team: [OpsgenieTeam] */  /** A simplified connection for the relationship type project-associated-pr */  /** A simplified edge for the relationship type project-associated-pr */  /** A simplified connection for the relationship type project-associated-pr */  /** A simplified edge for the relationship type project-associated-pr */  /** A union of the possible hydration types for project-associated-pr: [JiraProject] */  /** A union of the possible hydration types for project-associated-pr: [DevOpsPullRequestDetails] */  /** A simplified connection for the relationship type project-associated-repo */  /** A simplified edge for the relationship type project-associated-repo */  /** A simplified connection for the relationship type project-associated-repo */  /** A simplified edge for the relationship type project-associated-repo */  /** A union of the possible hydration types for project-associated-repo: [JiraProject] */  /** A union of the possible hydration types for project-associated-repo: [DevOpsRepository] */  /** A simplified connection for the relationship type project-associated-service */  /** A simplified edge for the relationship type project-associated-service */  /** A simplified connection for the relationship type project-associated-service */  /** A simplified edge for the relationship type project-associated-service */  /** A union of the possible hydration types for project-associated-service: [JiraProject] */  /** A union of the possible hydration types for project-associated-service: [DevOpsService] */  /** A simplified connection for the relationship type project-associated-to-incident */  /** A simplified edge for the relationship type project-associated-to-incident */  /** A simplified connection for the relationship type project-associated-to-incident */  /** A simplified edge for the relationship type project-associated-to-incident */  /** A union of the possible hydration types for project-associated-to-incident: [JiraProject] */  /** A union of the possible hydration types for project-associated-to-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A simplified connection for the relationship type project-associated-to-operations-container */  /** A simplified edge for the relationship type project-associated-to-operations-container */  /** A simplified connection for the relationship type project-associated-to-operations-container */  /** A simplified edge for the relationship type project-associated-to-operations-container */  /** A union of the possible hydration types for project-associated-to-operations-container: [JiraProject] */  /** A union of the possible hydration types for project-associated-to-operations-container: [DevOpsService] */  /** A simplified connection for the relationship type project-associated-to-security-container */  /** A simplified edge for the relationship type project-associated-to-security-container */  /** A union of the possible hydration types for project-associated-to-security-container: [JiraProject] */  /** A simplified connection for the relationship type project-associated-vulnerability */  /** A simplified edge for the relationship type project-associated-vulnerability */  /** A simplified connection for the relationship type project-associated-vulnerability */  /** A simplified edge for the relationship type project-associated-vulnerability */  /** A union of the possible hydration types for project-associated-vulnerability: [JiraProject] */  /** A union of the possible hydration types for project-associated-vulnerability: [DevOpsSecurityVulnerabilityDetails] */  /** A simplified connection for the relationship type project-disassociated-repo */  /** A simplified edge for the relationship type project-disassociated-repo */  /** A simplified connection for the relationship type project-disassociated-repo */  /** A simplified edge for the relationship type project-disassociated-repo */  /** A union of the possible hydration types for project-disassociated-repo: [JiraProject] */  /** A union of the possible hydration types for project-disassociated-repo: [DevOpsRepository] */  /** A simplified connection for the relationship type project-documentation-entity */  /** A simplified edge for the relationship type project-documentation-entity */  /** A simplified connection for the relationship type project-documentation-entity */  /** A simplified edge for the relationship type project-documentation-entity */  /** A union of the possible hydration types for project-documentation-entity: [JiraProject] */  /** A union of the possible hydration types for project-documentation-entity: [ConfluenceSpace, ConfluencePage, DevOpsDocument] */  /** A simplified connection for the relationship type project-documentation-page */  /** A simplified edge for the relationship type project-documentation-page */  /** A simplified connection for the relationship type project-documentation-page */  /** A simplified edge for the relationship type project-documentation-page */  /** A union of the possible hydration types for project-documentation-page: [JiraProject] */  /** A union of the possible hydration types for project-documentation-page: [ConfluencePage] */  /** A simplified connection for the relationship type project-documentation-space */  /** A simplified edge for the relationship type project-documentation-space */  /** A simplified connection for the relationship type project-documentation-space */  /** A simplified edge for the relationship type project-documentation-space */  /** A union of the possible hydration types for project-documentation-space: [JiraProject] */  /** A union of the possible hydration types for project-documentation-space: [ConfluenceSpace] */  /** A simplified connection for the relationship type project-explicitly-associated-repo */  /** A simplified edge for the relationship type project-explicitly-associated-repo */  /** A simplified connection for the relationship type project-explicitly-associated-repo */  /** A simplified edge for the relationship type project-explicitly-associated-repo */  /** A union of the possible hydration types for project-explicitly-associated-repo: [JiraProject] */  /** A union of the possible hydration types for project-explicitly-associated-repo: [DevOpsRepository] */  /** A simplified connection for the relationship type project-has-issue */  /** A simplified edge for the relationship type project-has-issue */  /** A simplified connection for the relationship type project-has-issue */  /** A simplified edge for the relationship type project-has-issue */  /** A union of the possible hydration types for project-has-issue: [JiraProject] */  /** A union of the possible hydration types for project-has-issue: [JiraIssue] */  /** A simplified connection for the relationship type project-has-related-work-with-project */  /** A simplified edge for the relationship type project-has-related-work-with-project */  /** A simplified connection for the relationship type project-has-related-work-with-project */  /** A simplified edge for the relationship type project-has-related-work-with-project */  /** A union of the possible hydration types for project-has-related-work-with-project: [JiraProject] */  /** A union of the possible hydration types for project-has-related-work-with-project: [JiraProject] */  /** A simplified connection for the relationship type project-has-shared-version-with */  /** A simplified edge for the relationship type project-has-shared-version-with */  /** A simplified connection for the relationship type project-has-shared-version-with */  /** A simplified edge for the relationship type project-has-shared-version-with */  /** A union of the possible hydration types for project-has-shared-version-with: [JiraProject] */  /** A union of the possible hydration types for project-has-shared-version-with: [JiraProject] */  /** A simplified connection for the relationship type project-has-version */  /** A simplified edge for the relationship type project-has-version */  /** A simplified connection for the relationship type project-has-version */  /** A simplified edge for the relationship type project-has-version */  /** A union of the possible hydration types for project-has-version: [JiraProject] */  /** A union of the possible hydration types for project-has-version: [JiraVersion] */  /** A simplified connection for the relationship type project-linked-to-compass-component */  /** A simplified edge for the relationship type project-linked-to-compass-component */  /** A simplified connection for the relationship type project-linked-to-compass-component */  /** A simplified edge for the relationship type project-linked-to-compass-component */  /** A union of the possible hydration types for project-linked-to-compass-component: [JiraProject] */  /** A union of the possible hydration types for project-linked-to-compass-component: [CompassComponent] */  /** A simplified connection for the relationship type security-container-associated-to-vulnerability */  /** A simplified edge for the relationship type security-container-associated-to-vulnerability */  /** A union of the possible hydration types for security-container-associated-to-vulnerability: [DevOpsSecurityVulnerabilityDetails] */  /** A simplified connection for the relationship type service-associated-deployment */  /** A simplified edge for the relationship type service-associated-deployment */  /** A simplified connection for the relationship type service-associated-deployment */  /** A simplified edge for the relationship type service-associated-deployment */  /** A union of the possible hydration types for service-associated-deployment: [DevOpsService] */  /** A union of the possible hydration types for service-associated-deployment: [DeploymentSummary] */  /** A simplified connection for the relationship type service-linked-incident */  /** A simplified edge for the relationship type service-linked-incident */  /** A simplified connection for the relationship type service-linked-incident */  /** A simplified edge for the relationship type service-linked-incident */  /** A union of the possible hydration types for service-linked-incident: [DevOpsService] */  /** A union of the possible hydration types for service-linked-incident: [JiraIssue] */  /** A simplified connection for the relationship type space-associated-with-project */  /** A simplified edge for the relationship type space-associated-with-project */  /** A simplified connection for the relationship type space-associated-with-project */  /** A simplified edge for the relationship type space-associated-with-project */  /** A union of the possible hydration types for space-associated-with-project: [ConfluenceSpace] */  /** A union of the possible hydration types for space-associated-with-project: [JiraProject] */  /** A simplified connection for the relationship type sprint-associated-deployment */  /** A simplified edge for the relationship type sprint-associated-deployment */  /** A union of the possible hydration types for sprint-associated-deployment: [DeploymentSummary] */  /** A simplified connection for the relationship type sprint-associated-pr */  /** A simplified edge for the relationship type sprint-associated-pr */  /** A union of the possible hydration types for sprint-associated-pr: [DevOpsPullRequestDetails] */  /** A simplified connection for the relationship type sprint-associated-vulnerability */  /** A simplified edge for the relationship type sprint-associated-vulnerability */  /** A union of the possible hydration types for sprint-associated-vulnerability: [DevOpsSecurityVulnerabilityDetails] */  /** A simplified connection for the relationship type sprint-contains-issue */  /** A simplified edge for the relationship type sprint-contains-issue */  /** A union of the possible hydration types for sprint-contains-issue: [JiraIssue] */  /** A simplified connection for the relationship type sprint-retrospective-page */  /** A simplified edge for the relationship type sprint-retrospective-page */  /** A union of the possible hydration types for sprint-retrospective-page: [ConfluencePage] */  /** A simplified connection for the relationship type sprint-retrospective-whiteboard */  /** A simplified edge for the relationship type sprint-retrospective-whiteboard */  /** A union of the possible hydration types for sprint-retrospective-whiteboard: [ConfluenceWhiteboard] */  /** A simplified connection for the relationship type team-owns-component */  /** A simplified edge for the relationship type team-owns-component */  /** A union of the possible hydration types for team-owns-component: [CompassComponent] */  /** A simplified connection for the relationship type team-works-on-project */  /** A simplified edge for the relationship type team-works-on-project */  /** A union of the possible hydration types for team-works-on-project: [JiraProject] */  /** A simplified connection for the relationship type version-associated-branch */  /** A simplified edge for the relationship type version-associated-branch */  /** A union of the possible hydration types for version-associated-branch: [JiraVersion] */  /** A simplified connection for the relationship type version-associated-build */  /** A simplified edge for the relationship type version-associated-build */  /** A union of the possible hydration types for version-associated-build: [JiraVersion] */  /** A simplified connection for the relationship type version-associated-commit */  /** A simplified edge for the relationship type version-associated-commit */  /** A union of the possible hydration types for version-associated-commit: [JiraVersion] */  /** A simplified connection for the relationship type version-associated-deployment */  /** A simplified edge for the relationship type version-associated-deployment */  /** A simplified connection for the relationship type version-associated-deployment */  /** A simplified edge for the relationship type version-associated-deployment */  /** A union of the possible hydration types for version-associated-deployment: [JiraVersion] */  /** A union of the possible hydration types for version-associated-deployment: [DeploymentSummary] */  /** A simplified connection for the relationship type version-associated-design */  /** A simplified edge for the relationship type version-associated-design */  /** A simplified connection for the relationship type version-associated-design */  /** A simplified edge for the relationship type version-associated-design */  /** A union of the possible hydration types for version-associated-design: [JiraVersion] */  /** A union of the possible hydration types for version-associated-design: [DevOpsDesign] */  /** A simplified connection for the relationship type version-associated-feature-flag */  /** A simplified edge for the relationship type version-associated-feature-flag */  /** A simplified connection for the relationship type version-associated-feature-flag */  /** A simplified edge for the relationship type version-associated-feature-flag */  /** A union of the possible hydration types for version-associated-feature-flag: [JiraVersion] */  /** A union of the possible hydration types for version-associated-feature-flag: [DevOpsFeatureFlag] */  /** A simplified connection for the relationship type version-associated-issue */  /** A simplified edge for the relationship type version-associated-issue */  /** A simplified connection for the relationship type version-associated-issue */  /** A simplified edge for the relationship type version-associated-issue */  /** A union of the possible hydration types for version-associated-issue: [JiraVersion] */  /** A union of the possible hydration types for version-associated-issue: [JiraIssue] */  /** A simplified connection for the relationship type version-associated-pull-request */  /** A simplified edge for the relationship type version-associated-pull-request */  /** A simplified connection for the relationship type version-associated-pull-request */  /** A simplified edge for the relationship type version-associated-pull-request */  /** A union of the possible hydration types for version-associated-pull-request: [JiraVersion] */  /** A union of the possible hydration types for version-associated-pull-request: [DevOpsPullRequestDetails] */  /** A simplified connection for the relationship type version-associated-remote-link */  /** A simplified edge for the relationship type version-associated-remote-link */  /** A union of the possible hydration types for version-associated-remote-link: [JiraVersion] */  /** A simplified connection for the relationship type version-user-associated-feature-flag */  /** A simplified edge for the relationship type version-user-associated-feature-flag */  /** A simplified connection for the relationship type version-user-associated-feature-flag */  /** A simplified edge for the relationship type version-user-associated-feature-flag */  /** A union of the possible hydration types for version-user-associated-feature-flag: [JiraVersion] */  /** A union of the possible hydration types for version-user-associated-feature-flag: [DevOpsFeatureFlag] */  /** A simplified connection for the relationship type vulnerability-associated-issue */  /** A simplified edge for the relationship type vulnerability-associated-issue */  /** A simplified connection for the relationship type vulnerability-associated-issue */  /** A simplified edge for the relationship type vulnerability-associated-issue */  /** A union of the possible hydration types for vulnerability-associated-issue: [DevOpsSecurityVulnerabilityDetails] */  /** A union of the possible hydration types for vulnerability-associated-issue: [JiraIssue] */ 
let $78ad46e0d6808149$export$f295a95cd0626a8f = /*#__PURE__*/ function(GraphStoreSprintAssociatedBuildBuildState) {
    GraphStoreSprintAssociatedBuildBuildState["Cancelled"] = "CANCELLED";
    GraphStoreSprintAssociatedBuildBuildState["Failed"] = "FAILED";
    GraphStoreSprintAssociatedBuildBuildState["InProgress"] = "IN_PROGRESS";
    GraphStoreSprintAssociatedBuildBuildState["NotSet"] = "NOT_SET";
    GraphStoreSprintAssociatedBuildBuildState["Pending"] = "PENDING";
    GraphStoreSprintAssociatedBuildBuildState["Successful"] = "SUCCESSFUL";
    GraphStoreSprintAssociatedBuildBuildState["Unknown"] = "UNKNOWN";
    return GraphStoreSprintAssociatedBuildBuildState;
}({}); /** Conditional selection for filter field of sprint-associated-build relationship queries */ 
let $78ad46e0d6808149$export$6df900849642cd1c = /*#__PURE__*/ function(GraphStoreSprintAssociatedDeploymentDeploymentState) {
    GraphStoreSprintAssociatedDeploymentDeploymentState["Cancelled"] = "CANCELLED";
    GraphStoreSprintAssociatedDeploymentDeploymentState["Failed"] = "FAILED";
    GraphStoreSprintAssociatedDeploymentDeploymentState["InProgress"] = "IN_PROGRESS";
    GraphStoreSprintAssociatedDeploymentDeploymentState["NotSet"] = "NOT_SET";
    GraphStoreSprintAssociatedDeploymentDeploymentState["Pending"] = "PENDING";
    GraphStoreSprintAssociatedDeploymentDeploymentState["RolledBack"] = "ROLLED_BACK";
    GraphStoreSprintAssociatedDeploymentDeploymentState["Successful"] = "SUCCESSFUL";
    GraphStoreSprintAssociatedDeploymentDeploymentState["Unknown"] = "UNKNOWN";
    return GraphStoreSprintAssociatedDeploymentDeploymentState;
}({});
let $78ad46e0d6808149$export$9f4efa40f1a0faae = /*#__PURE__*/ function(GraphStoreSprintAssociatedDeploymentEnvironmentType) {
    GraphStoreSprintAssociatedDeploymentEnvironmentType["Development"] = "DEVELOPMENT";
    GraphStoreSprintAssociatedDeploymentEnvironmentType["NotSet"] = "NOT_SET";
    GraphStoreSprintAssociatedDeploymentEnvironmentType["Production"] = "PRODUCTION";
    GraphStoreSprintAssociatedDeploymentEnvironmentType["Staging"] = "STAGING";
    GraphStoreSprintAssociatedDeploymentEnvironmentType["Testing"] = "TESTING";
    GraphStoreSprintAssociatedDeploymentEnvironmentType["Unmapped"] = "UNMAPPED";
    return GraphStoreSprintAssociatedDeploymentEnvironmentType;
}({}); /** Conditional selection for filter field of sprint-associated-deployment relationship queries */  /** Conditional selection for filter field of sprint-associated-pr relationship queries */ 
let $78ad46e0d6808149$export$5ffbe3a12bdc5b6c = /*#__PURE__*/ function(GraphStoreSprintAssociatedPrPullRequestStatus) {
    GraphStoreSprintAssociatedPrPullRequestStatus["Declined"] = "DECLINED";
    GraphStoreSprintAssociatedPrPullRequestStatus["Merged"] = "MERGED";
    GraphStoreSprintAssociatedPrPullRequestStatus["NotSet"] = "NOT_SET";
    GraphStoreSprintAssociatedPrPullRequestStatus["Open"] = "OPEN";
    GraphStoreSprintAssociatedPrPullRequestStatus["Unknown"] = "UNKNOWN";
    return GraphStoreSprintAssociatedPrPullRequestStatus;
}({});
let $78ad46e0d6808149$export$b397a81d3b3345af = /*#__PURE__*/ function(GraphStoreSprintAssociatedPrReviewerReviewerStatus) {
    GraphStoreSprintAssociatedPrReviewerReviewerStatus["Approved"] = "APPROVED";
    GraphStoreSprintAssociatedPrReviewerReviewerStatus["Needswork"] = "NEEDSWORK";
    GraphStoreSprintAssociatedPrReviewerReviewerStatus["NotSet"] = "NOT_SET";
    GraphStoreSprintAssociatedPrReviewerReviewerStatus["Unapproved"] = "UNAPPROVED";
    return GraphStoreSprintAssociatedPrReviewerReviewerStatus;
}({}); /** Conditional selection for filter field of sprint-associated-vulnerability relationship queries */ 
let $78ad46e0d6808149$export$9ee1edc61daf0f8a = /*#__PURE__*/ function(GraphStoreSprintAssociatedVulnerabilityStatusCategory) {
    GraphStoreSprintAssociatedVulnerabilityStatusCategory["Done"] = "DONE";
    GraphStoreSprintAssociatedVulnerabilityStatusCategory["Indeterminate"] = "INDETERMINATE";
    GraphStoreSprintAssociatedVulnerabilityStatusCategory["New"] = "NEW";
    GraphStoreSprintAssociatedVulnerabilityStatusCategory["Undefined"] = "UNDEFINED";
    return GraphStoreSprintAssociatedVulnerabilityStatusCategory;
}({});
let $78ad46e0d6808149$export$67d1797c0aa2ad19 = /*#__PURE__*/ function(GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity) {
    GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity["Critical"] = "CRITICAL";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity["High"] = "HIGH";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity["Low"] = "LOW";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity["Medium"] = "MEDIUM";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity["NotSet"] = "NOT_SET";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity["Unknown"] = "UNKNOWN";
    return GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity;
}({});
let $78ad46e0d6808149$export$e55dd9ead99d6d9f = /*#__PURE__*/ function(GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatus) {
    GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatus["Closed"] = "CLOSED";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatus["Ignored"] = "IGNORED";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatus["NotSet"] = "NOT_SET";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatus["Open"] = "OPEN";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatus["Unknown"] = "UNKNOWN";
    return GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatus;
}({}); /** Conditional selection for filter field of sprint-contains-issue relationship queries */ 
let $78ad46e0d6808149$export$296e777b040fe873 = /*#__PURE__*/ function(GraphStoreSprintContainsIssueStatusCategory) {
    GraphStoreSprintContainsIssueStatusCategory["Done"] = "DONE";
    GraphStoreSprintContainsIssueStatusCategory["Indeterminate"] = "INDETERMINATE";
    GraphStoreSprintContainsIssueStatusCategory["New"] = "NEW";
    GraphStoreSprintContainsIssueStatusCategory["Undefined"] = "UNDEFINED";
    return GraphStoreSprintContainsIssueStatusCategory;
}({});
let $78ad46e0d6808149$export$318f148359ce1fb1 = /*#__PURE__*/ function(GraphStoreVersionAssociatedDesignDesignStatus) {
    GraphStoreVersionAssociatedDesignDesignStatus["None"] = "NONE";
    GraphStoreVersionAssociatedDesignDesignStatus["NotSet"] = "NOT_SET";
    GraphStoreVersionAssociatedDesignDesignStatus["ReadyForDevelopment"] = "READY_FOR_DEVELOPMENT";
    GraphStoreVersionAssociatedDesignDesignStatus["Unknown"] = "UNKNOWN";
    return GraphStoreVersionAssociatedDesignDesignStatus;
}({});
let $78ad46e0d6808149$export$c81e290110aa4fde = /*#__PURE__*/ function(GraphStoreVersionAssociatedDesignDesignType) {
    GraphStoreVersionAssociatedDesignDesignType["Canvas"] = "CANVAS";
    GraphStoreVersionAssociatedDesignDesignType["File"] = "FILE";
    GraphStoreVersionAssociatedDesignDesignType["Group"] = "GROUP";
    GraphStoreVersionAssociatedDesignDesignType["Node"] = "NODE";
    GraphStoreVersionAssociatedDesignDesignType["NotSet"] = "NOT_SET";
    GraphStoreVersionAssociatedDesignDesignType["Other"] = "OTHER";
    GraphStoreVersionAssociatedDesignDesignType["Prototype"] = "PROTOTYPE";
    return GraphStoreVersionAssociatedDesignDesignType;
}({}); /** Conditional selection for filter field of version-associated-design relationship queries */  /**
 * The context object provides essential insights into the users' current experience and operations.
 *
 * The supported product and subproduct keys can be found at https://hello.atlassian.net/wiki/spaces/ECON/pages/2339030895/App+Identifiers
 */ 
let $78ad46e0d6808149$export$b5409d01f4236473 = /*#__PURE__*/ function(GrowthUnifiedProfileAnchorType) {
    GrowthUnifiedProfileAnchorType["Pfm"] = "PFM";
    GrowthUnifiedProfileAnchorType["Seo"] = "SEO";
    return GrowthUnifiedProfileAnchorType;
}({}); /**
 * Channel type, this information will be extracted from the query parameters and other sources, such as ML
 * mapping file
 */ 
let $78ad46e0d6808149$export$d608f92bd278cb63 = /*#__PURE__*/ function(GrowthUnifiedProfileChannelName) {
    GrowthUnifiedProfileChannelName["Comarketing"] = "COMARKETING";
    GrowthUnifiedProfileChannelName["Direct"] = "DIRECT";
    GrowthUnifiedProfileChannelName["Email"] = "EMAIL";
    GrowthUnifiedProfileChannelName["EngagementEngine"] = "ENGAGEMENT_ENGINE";
    GrowthUnifiedProfileChannelName["InProductReferral"] = "IN_PRODUCT_REFERRAL";
    GrowthUnifiedProfileChannelName["Organic"] = "ORGANIC";
    GrowthUnifiedProfileChannelName["Other"] = "OTHER";
    GrowthUnifiedProfileChannelName["PaidAffiliate"] = "PAID_AFFILIATE";
    GrowthUnifiedProfileChannelName["PaidDisplay"] = "PAID_DISPLAY";
    GrowthUnifiedProfileChannelName["PaidReviewSites"] = "PAID_REVIEW_SITES";
    GrowthUnifiedProfileChannelName["PaidSearchBranded"] = "PAID_SEARCH_BRANDED";
    GrowthUnifiedProfileChannelName["PaidSearchNonBranded"] = "PAID_SEARCH_NON_BRANDED";
    GrowthUnifiedProfileChannelName["PaidSocial"] = "PAID_SOCIAL";
    GrowthUnifiedProfileChannelName["ReferralExternal"] = "REFERRAL_EXTERNAL";
    GrowthUnifiedProfileChannelName["ReferralInternal"] = "REFERRAL_INTERNAL";
    GrowthUnifiedProfileChannelName["SelfReferral"] = "SELF_REFERRAL";
    GrowthUnifiedProfileChannelName["SlackAppDirectory"] = "SLACK_APP_DIRECTORY";
    GrowthUnifiedProfileChannelName["Suppress"] = "SUPPRESS";
    GrowthUnifiedProfileChannelName["UnpaidSocial"] = "UNPAID_SOCIAL";
    GrowthUnifiedProfileChannelName["UnpaidVideo"] = "UNPAID_VIDEO";
    return GrowthUnifiedProfileChannelName;
}({});
let $78ad46e0d6808149$export$eb044d0d19d592c7 = /*#__PURE__*/ function(GrowthUnifiedProfileCompanySize) {
    GrowthUnifiedProfileCompanySize["Large"] = "LARGE";
    GrowthUnifiedProfileCompanySize["Medium"] = "MEDIUM";
    GrowthUnifiedProfileCompanySize["Small"] = "SMALL";
    GrowthUnifiedProfileCompanySize["Unknown"] = "UNKNOWN";
    return GrowthUnifiedProfileCompanySize;
}({});
let $78ad46e0d6808149$export$4582f4191dc3bb0e = /*#__PURE__*/ function(GrowthUnifiedProfileCompanyType) {
    GrowthUnifiedProfileCompanyType["Private"] = "PRIVATE";
    GrowthUnifiedProfileCompanyType["Public"] = "PUBLIC";
    return GrowthUnifiedProfileCompanyType;
}({});
let $78ad46e0d6808149$export$28880b034aa5dc30 = /*#__PURE__*/ function(GrowthUnifiedProfileEnrichmentStatus) {
    GrowthUnifiedProfileEnrichmentStatus["Complete"] = "COMPLETE";
    GrowthUnifiedProfileEnrichmentStatus["Error"] = "ERROR";
    GrowthUnifiedProfileEnrichmentStatus["InProgress"] = "IN_PROGRESS";
    GrowthUnifiedProfileEnrichmentStatus["Pending"] = "PENDING";
    return GrowthUnifiedProfileEnrichmentStatus;
}({});
let $78ad46e0d6808149$export$8d96e2c494b1d62c = /*#__PURE__*/ function(GrowthUnifiedProfileEnterpriseAccountStatus) {
    GrowthUnifiedProfileEnterpriseAccountStatus["Bronze"] = "BRONZE";
    GrowthUnifiedProfileEnterpriseAccountStatus["Gam"] = "GAM";
    GrowthUnifiedProfileEnterpriseAccountStatus["Gold"] = "GOLD";
    GrowthUnifiedProfileEnterpriseAccountStatus["Platimun"] = "PLATIMUN";
    GrowthUnifiedProfileEnterpriseAccountStatus["Silver"] = "SILVER";
    return GrowthUnifiedProfileEnterpriseAccountStatus;
}({});
let $78ad46e0d6808149$export$71e2332d6e22a291 = /*#__PURE__*/ function(GrowthUnifiedProfileEntityType) {
    GrowthUnifiedProfileEntityType["AjsAnonymousUser"] = "AJS_ANONYMOUS_USER";
    GrowthUnifiedProfileEntityType["AtlassianAccount"] = "ATLASSIAN_ACCOUNT";
    GrowthUnifiedProfileEntityType["Org"] = "ORG";
    GrowthUnifiedProfileEntityType["Site"] = "SITE";
    return GrowthUnifiedProfileEntityType;
}({});
let $78ad46e0d6808149$export$c49017e7afc08542 = /*#__PURE__*/ function(GrowthUnifiedProfileJtbd) {
    GrowthUnifiedProfileJtbd["Budgets"] = "BUDGETS";
    GrowthUnifiedProfileJtbd["CdWrtng"] = "CD_WRTNG";
    GrowthUnifiedProfileJtbd["ImproveWorkflow"] = "IMPROVE_WORKFLOW";
    GrowthUnifiedProfileJtbd["LaunchCampaigns"] = "LAUNCH_CAMPAIGNS";
    GrowthUnifiedProfileJtbd["MarketingContent"] = "MARKETING_CONTENT";
    GrowthUnifiedProfileJtbd["PlanAndManage"] = "PLAN_AND_MANAGE";
    GrowthUnifiedProfileJtbd["ProjectPlanning"] = "PROJECT_PLANNING";
    GrowthUnifiedProfileJtbd["ProjectProgress"] = "PROJECT_PROGRESS";
    GrowthUnifiedProfileJtbd["Stakeholders"] = "STAKEHOLDERS";
    GrowthUnifiedProfileJtbd["StrategiesAndGoals"] = "STRATEGIES_AND_GOALS";
    GrowthUnifiedProfileJtbd["TrackingRprtng"] = "TRACKING_RPRTNG";
    GrowthUnifiedProfileJtbd["UseKanbanBoard"] = "USE_KANBAN_BOARD";
    return GrowthUnifiedProfileJtbd;
}({});
let $78ad46e0d6808149$export$5990898c79cc1feb = /*#__PURE__*/ function(GrowthUnifiedProfileJiraFamiliarity) {
    GrowthUnifiedProfileJiraFamiliarity["Experience"] = "EXPERIENCE";
    GrowthUnifiedProfileJiraFamiliarity["Middle"] = "MIDDLE";
    GrowthUnifiedProfileJiraFamiliarity["New"] = "NEW";
    return GrowthUnifiedProfileJiraFamiliarity;
}({}); /** onboarding context input for jira */  /** onboarding context type for jira or confluence */  /** onboarding context input for jira or confluence */ 
let $78ad46e0d6808149$export$110930cf5e2a2eff = /*#__PURE__*/ function(GrowthUnifiedProfileTeamType) {
    GrowthUnifiedProfileTeamType["CustomerService"] = "CUSTOMER_SERVICE";
    GrowthUnifiedProfileTeamType["Design"] = "DESIGN";
    GrowthUnifiedProfileTeamType["Finance"] = "FINANCE";
    GrowthUnifiedProfileTeamType["HumanResources"] = "HUMAN_RESOURCES";
    GrowthUnifiedProfileTeamType["ItSupport"] = "IT_SUPPORT";
    GrowthUnifiedProfileTeamType["Legal"] = "LEGAL";
    GrowthUnifiedProfileTeamType["Marketing"] = "MARKETING";
    GrowthUnifiedProfileTeamType["Operations"] = "OPERATIONS";
    GrowthUnifiedProfileTeamType["Other"] = "OTHER";
    GrowthUnifiedProfileTeamType["Sales"] = "SALES";
    GrowthUnifiedProfileTeamType["SoftwareDevelopment"] = "SOFTWARE_DEVELOPMENT";
    return GrowthUnifiedProfileTeamType;
}({}); /** Utm typr will be extracted from the url query parameters */  /**
 * An experience flow that can be presented to a user so that they can perform a given task.
 * The flow never redirects or returns control to the caller, so it should be opened in a new
 * tab if it is desired that the user returns to the referring experience.
 */ 
let $78ad46e0d6808149$export$28f02d0f56367121 = /*#__PURE__*/ function(HelpCenterConversationFailureMessageType) {
    HelpCenterConversationFailureMessageType["ConversationFailureMessage"] = "CONVERSATION_FAILURE_MESSAGE";
    HelpCenterConversationFailureMessageType["ConversationUnhelpfulMessage"] = "CONVERSATION_UNHELPFUL_MESSAGE";
    HelpCenterConversationFailureMessageType["CustomMessage"] = "CUSTOM_MESSAGE";
    return HelpCenterConversationFailureMessageType;
}({}); /**
 * #########################
 *  Mutation Inputs
 * #########################
 */ 
let $78ad46e0d6808149$export$a4bd4d15a9a3d3f1 = /*#__PURE__*/ function(HelpCenterDescriptionType) {
    HelpCenterDescriptionType["PlainText"] = "PLAIN_TEXT";
    HelpCenterDescriptionType["RichText"] = "RICH_TEXT";
    HelpCenterDescriptionType["WikiMarkup"] = "WIKI_MARKUP";
    return HelpCenterDescriptionType;
}({}); /** Media config provides auth credentials and relevant information to upload images for media related elements. */  /** This describes the type of operation for which mediaConfig needs to be generated */ 
let $78ad46e0d6808149$export$9f54202027f49420 = /*#__PURE__*/ function(HelpCenterMediaConfigOperationType) {
    HelpCenterMediaConfigOperationType["BannerUpload"] = "BANNER_UPLOAD";
    HelpCenterMediaConfigOperationType["LogoUpload"] = "LOGO_UPLOAD";
    return HelpCenterMediaConfigOperationType;
}({});
let $78ad46e0d6808149$export$de6d4d4c47123061 = /*#__PURE__*/ function(HelpCenterPortalsSortOrder) {
    HelpCenterPortalsSortOrder["NameAscending"] = "NAME_ASCENDING";
    HelpCenterPortalsSortOrder["Popularity"] = "POPULARITY";
    return HelpCenterPortalsSortOrder;
}({});
let $78ad46e0d6808149$export$10df61f732f39a6d = /*#__PURE__*/ function(HelpCenterPortalsType) {
    HelpCenterPortalsType["Featured"] = "FEATURED";
    HelpCenterPortalsType["Hidden"] = "HIDDEN";
    HelpCenterPortalsType["Visible"] = "VISIBLE";
    return HelpCenterPortalsType;
}({});
let $78ad46e0d6808149$export$98ecf93df3b75669 = /*#__PURE__*/ function(HelpCenterProjectType) {
    HelpCenterProjectType["CustomerService"] = "CUSTOMER_SERVICE";
    HelpCenterProjectType["ServiceDesk"] = "SERVICE_DESK";
    return HelpCenterProjectType;
}({}); /** All available queries on help center service */  /** All available queries on help center service */  /** All available queries on help center service */  /** All available queries on help center service */  /** All available queries on help center service */  /** All available queries on help center service */  /** All available queries on help center service */  /** All available queries on help center service */  /** All available queries on help center service */  /** All available queries on help center service */  /** All available queries on help center service */  /** All available queries on help center service */  /**
 * #########################
 *  Base objects for help-center
 * #########################
 */ 
let $78ad46e0d6808149$export$db18c35dcd3a9e38 = /*#__PURE__*/ function(HelpCenterSortOrder) {
    HelpCenterSortOrder["CreatedDateAscending"] = "CREATED_DATE_ASCENDING";
    HelpCenterSortOrder["CreatedDateDescending"] = "CREATED_DATE_DESCENDING";
    return HelpCenterSortOrder;
}({});
let $78ad46e0d6808149$export$404b16ab15b3352c = /*#__PURE__*/ function(HelpCenterType) {
    HelpCenterType["Advanced"] = "ADVANCED";
    HelpCenterType["Basic"] = "BASIC";
    HelpCenterType["CustomerService"] = "CUSTOMER_SERVICE";
    HelpCenterType["Unified"] = "UNIFIED";
    return HelpCenterType;
}({});
let $78ad46e0d6808149$export$25877d5a420a6e71 = /*#__PURE__*/ function(HelpExternalResourceLinkResourceType) {
    HelpExternalResourceLinkResourceType["Channel"] = "CHANNEL";
    HelpExternalResourceLinkResourceType["Knowledge"] = "KNOWLEDGE";
    HelpExternalResourceLinkResourceType["RequestForm"] = "REQUEST_FORM";
    return HelpExternalResourceLinkResourceType;
}({}); /** Mutation */  /** Mutation */  /** Mutation */  /** Mutation */  /** Query Types */  /** Query Types */  /** Represents a layout in the system. */  /** Represents a layout in the system. */  /** Announcement Atomic Element */  /** Portals List Input */  /** This union represents all the atomic elements. */  /**
 * This input type will be used to mutate Atomic Elements inside Composite Elements.
 * This type is used only inside a Composite Element
 */ 
let $78ad46e0d6808149$export$4f955d957799126e = /*#__PURE__*/ function(HelpLayoutAtomicElementKey) {
    HelpLayoutAtomicElementKey["Announcement"] = "ANNOUNCEMENT";
    HelpLayoutAtomicElementKey["Connect"] = "CONNECT";
    HelpLayoutAtomicElementKey["Editor"] = "EDITOR";
    HelpLayoutAtomicElementKey["Forge"] = "FORGE";
    HelpLayoutAtomicElementKey["Heading"] = "HEADING";
    HelpLayoutAtomicElementKey["Hero"] = "HERO";
    HelpLayoutAtomicElementKey["Image"] = "IMAGE";
    HelpLayoutAtomicElementKey["NoContent"] = "NO_CONTENT";
    HelpLayoutAtomicElementKey["Paragraph"] = "PARAGRAPH";
    HelpLayoutAtomicElementKey["PortalsList"] = "PORTALS_LIST";
    HelpLayoutAtomicElementKey["Search"] = "SEARCH";
    HelpLayoutAtomicElementKey["SuggestedRequestFormsList"] = "SUGGESTED_REQUEST_FORMS_LIST";
    HelpLayoutAtomicElementKey["TopicsList"] = "TOPICS_LIST";
    return HelpLayoutAtomicElementKey;
}({}); /** Represents Atomic Element Types. They are fetched while rendering the catalogue. */  /** Represents Atomic Element Types. They are fetched while rendering the catalogue. */  /** This interface is implemented by all composite elements. */  /** This enum represents all the composite element keys. */ 
let $78ad46e0d6808149$export$576a5650ed3956e9 = /*#__PURE__*/ function(HelpLayoutCompositeElementKey) {
    HelpLayoutCompositeElementKey["LinkCard"] = "LINK_CARD";
    return HelpLayoutCompositeElementKey;
}({}); /** Represents Composite Element Types. They are fetched while rendering the catalogue. */  /** Connect App Element */ 
let $78ad46e0d6808149$export$d614d14eebc9034e = /*#__PURE__*/ function(HelpLayoutConnectElementPages) {
    HelpLayoutConnectElementPages["Approvals"] = "APPROVALS";
    HelpLayoutConnectElementPages["CreateRequest"] = "CREATE_REQUEST";
    HelpLayoutConnectElementPages["HelpCenter"] = "HELP_CENTER";
    HelpLayoutConnectElementPages["MyRequest"] = "MY_REQUEST";
    HelpLayoutConnectElementPages["Portal"] = "PORTAL";
    HelpLayoutConnectElementPages["Profile"] = "PROFILE";
    HelpLayoutConnectElementPages["ViewRequest"] = "VIEW_REQUEST";
    return HelpLayoutConnectElementPages;
}({});
let $78ad46e0d6808149$export$13477f5de7466343 = /*#__PURE__*/ function(HelpLayoutConnectElementType) {
    HelpLayoutConnectElementType["DetailsPanels"] = "detailsPanels";
    HelpLayoutConnectElementType["FooterPanels"] = "footerPanels";
    HelpLayoutConnectElementType["HeaderAndSubheaderPanels"] = "headerAndSubheaderPanels";
    HelpLayoutConnectElementType["HeaderPanels"] = "headerPanels";
    HelpLayoutConnectElementType["OptionPanels"] = "optionPanels";
    HelpLayoutConnectElementType["ProfilePagePanel"] = "profilePagePanel";
    HelpLayoutConnectElementType["PropertyPanels"] = "propertyPanels";
    HelpLayoutConnectElementType["RequestCreatePanel"] = "requestCreatePanel";
    HelpLayoutConnectElementType["SubheaderPanels"] = "subheaderPanels";
    return HelpLayoutConnectElementType;
}({}); /** Connect App Input */  /** Editor Element */  /** Editor Input */  /** This union represents all elements, atomic and composite. */  /** This enum represents all the element category. */ 
let $78ad46e0d6808149$export$66fddc1b3eb3d42f = /*#__PURE__*/ function(HelpLayoutElementCategory) {
    HelpLayoutElementCategory["Basic"] = "BASIC";
    HelpLayoutElementCategory["Navigation"] = "NAVIGATION";
    return HelpLayoutElementCategory;
}({}); /**
 * This input type can mutate both atomic and composite elements. Since there is no polymorphism in input types in graphql.
 * Client will have to send the Key to the element they are mutating and respective config.
 * Only one of the config fields will be specified. "elementTypeKey" should match the config provided.
 */ 
let $78ad46e0d6808149$export$7e4f0d562642895e = /*#__PURE__*/ function(HelpLayoutElementKey) {
    HelpLayoutElementKey["Announcement"] = "ANNOUNCEMENT";
    HelpLayoutElementKey["Connect"] = "CONNECT";
    HelpLayoutElementKey["Editor"] = "EDITOR";
    HelpLayoutElementKey["Forge"] = "FORGE";
    HelpLayoutElementKey["Heading"] = "HEADING";
    HelpLayoutElementKey["Hero"] = "HERO";
    HelpLayoutElementKey["Image"] = "IMAGE";
    HelpLayoutElementKey["LinkCard"] = "LINK_CARD";
    HelpLayoutElementKey["NoContent"] = "NO_CONTENT";
    HelpLayoutElementKey["Paragraph"] = "PARAGRAPH";
    HelpLayoutElementKey["PortalsList"] = "PORTALS_LIST";
    HelpLayoutElementKey["Search"] = "SEARCH";
    HelpLayoutElementKey["SuggestedRequestFormsList"] = "SUGGESTED_REQUEST_FORMS_LIST";
    HelpLayoutElementKey["TopicsList"] = "TOPICS_LIST";
    return HelpLayoutElementKey;
}({}); /** This interface represents all the element types which are supported by this schema. */  /** Forge App Element */ 
let $78ad46e0d6808149$export$443851e78d175634 = /*#__PURE__*/ function(HelpLayoutForgeElementPages) {
    HelpLayoutForgeElementPages["Approvals"] = "approvals";
    HelpLayoutForgeElementPages["CreateRequest"] = "create_request";
    HelpLayoutForgeElementPages["HelpCenter"] = "help_center";
    HelpLayoutForgeElementPages["MyRequests"] = "my_requests";
    HelpLayoutForgeElementPages["Portal"] = "portal";
    HelpLayoutForgeElementPages["Profile"] = "profile";
    HelpLayoutForgeElementPages["ViewRequest"] = "view_request";
    return HelpLayoutForgeElementPages;
}({});
let $78ad46e0d6808149$export$fd51ac42041cdcaa = /*#__PURE__*/ function(HelpLayoutForgeElementType) {
    HelpLayoutForgeElementType["Footer"] = "FOOTER";
    HelpLayoutForgeElementType["HeaderAndSubheader"] = "HEADER_AND_SUBHEADER";
    return HelpLayoutForgeElementType;
}({}); /** Forge App Input */  /** Heading Atomic Element */  /** Heading Input */ 
let $78ad46e0d6808149$export$ddbaabbc700bfb0f = /*#__PURE__*/ function(HelpLayoutHeadingType) {
    HelpLayoutHeadingType["H1"] = "h1";
    HelpLayoutHeadingType["H2"] = "h2";
    HelpLayoutHeadingType["H3"] = "h3";
    HelpLayoutHeadingType["H4"] = "h4";
    HelpLayoutHeadingType["H5"] = "h5";
    HelpLayoutHeadingType["H6"] = "h6";
    return HelpLayoutHeadingType;
}({}); /** Hero Element */  /** Hero Element Input */ 
let $78ad46e0d6808149$export$dc0242f9aced7a72 = /*#__PURE__*/ function(HelpLayoutHorizontalAlignment) {
    HelpLayoutHorizontalAlignment["Center"] = "CENTER";
    HelpLayoutHorizontalAlignment["Left"] = "LEFT";
    HelpLayoutHorizontalAlignment["Right"] = "RIGHT";
    return HelpLayoutHorizontalAlignment;
}({}); /** Image Atomic Element */  /** Image Input */  /** Link card Composite Element */  /** Link card input */  /** Media config provides auth credentials and relevant information to upload images for media related elements. */  /**
 * Namespace top-level field that contain all the mutations available in the schema.
 * https://developer.atlassian.com/platform/graphql-gateway/standards/synthetic-fields/
 */ 
let $78ad46e0d6808149$export$da6edd2e84621f40 = /*#__PURE__*/ function(HelpLayoutProjectType) {
    HelpLayoutProjectType["CustomerService"] = "CUSTOMER_SERVICE";
    HelpLayoutProjectType["ServiceDesk"] = "SERVICE_DESK";
    return HelpLayoutProjectType;
}({}); /**
 * Namespace top-level field that contain all the mutations available in the schema.
 * https://developer.atlassian.com/platform/graphql-gateway/standards/synthetic-fields/
 */ 
let $78ad46e0d6808149$export$29b8c6e9ec83845e = /*#__PURE__*/ function(HelpLayoutVerticalAlignment) {
    HelpLayoutVerticalAlignment["Bottom"] = "BOTTOM";
    HelpLayoutVerticalAlignment["Middle"] = "MIDDLE";
    HelpLayoutVerticalAlignment["Top"] = "TOP";
    return HelpLayoutVerticalAlignment;
}({}); /** This represents the visual properties */  /** This represents the visual config input required during mutation */  /**
 * Any element or type that implements visualEntity will get visual config as a field which contains visual properties.
 * Think of this as visual config provider used to provide config such as border, bg-color and so on.
 */ 
let $78ad46e0d6808149$export$fca880a7c8a28341 = /*#__PURE__*/ function(HelpObjectStoreHelpObjectType) {
    HelpObjectStoreHelpObjectType["Article"] = "ARTICLE";
    HelpObjectStoreHelpObjectType["Channel"] = "CHANNEL";
    HelpObjectStoreHelpObjectType["Portal"] = "PORTAL";
    HelpObjectStoreHelpObjectType["RequestForm"] = "REQUEST_FORM";
    return HelpObjectStoreHelpObjectType;
}({});
let $78ad46e0d6808149$export$5a6a464de3389453 = /*#__PURE__*/ function(HelpObjectStoreJsmEntityType) {
    HelpObjectStoreJsmEntityType["Article"] = "ARTICLE";
    HelpObjectStoreJsmEntityType["Channel"] = "CHANNEL";
    HelpObjectStoreJsmEntityType["Portal"] = "PORTAL";
    HelpObjectStoreJsmEntityType["RequestForm"] = "REQUEST_FORM";
    return HelpObjectStoreJsmEntityType;
}({});
let $78ad46e0d6808149$export$714c6e1043f92681 = /*#__PURE__*/ function(HelpObjectStoreSearchAlgorithm) {
    HelpObjectStoreSearchAlgorithm["KeywordSearchOnIssues"] = "KEYWORD_SEARCH_ON_ISSUES";
    HelpObjectStoreSearchAlgorithm["KeywordSearchOnPortalsBm25"] = "KEYWORD_SEARCH_ON_PORTALS_BM25";
    HelpObjectStoreSearchAlgorithm["KeywordSearchOnPortalsExactMatch"] = "KEYWORD_SEARCH_ON_PORTALS_EXACT_MATCH";
    HelpObjectStoreSearchAlgorithm["KeywordSearchOnRequestTypesBm25"] = "KEYWORD_SEARCH_ON_REQUEST_TYPES_BM25";
    HelpObjectStoreSearchAlgorithm["KeywordSearchOnRequestTypesExactMatch"] = "KEYWORD_SEARCH_ON_REQUEST_TYPES_EXACT_MATCH";
    return HelpObjectStoreSearchAlgorithm;
}({});
let $78ad46e0d6808149$export$82309e1a4e81fdbf = /*#__PURE__*/ function(HelpObjectStoreSearchBackend) {
    HelpObjectStoreSearchBackend["Jira"] = "JIRA";
    HelpObjectStoreSearchBackend["SearchPlatform"] = "SEARCH_PLATFORM";
    return HelpObjectStoreSearchBackend;
}({});
let $78ad46e0d6808149$export$3cd8bacd120e7d23 = /*#__PURE__*/ function(HelpObjectStoreSearchEntityType) {
    HelpObjectStoreSearchEntityType["Article"] = "ARTICLE";
    HelpObjectStoreSearchEntityType["Channel"] = "CHANNEL";
    HelpObjectStoreSearchEntityType["Portal"] = "PORTAL";
    HelpObjectStoreSearchEntityType["RequestForm"] = "REQUEST_FORM";
    return HelpObjectStoreSearchEntityType;
}({});
let $78ad46e0d6808149$export$78a7af08ea3c76ad = /*#__PURE__*/ function(HelpObjectStoreSearchableEntityType) {
    HelpObjectStoreSearchableEntityType["Article"] = "ARTICLE";
    HelpObjectStoreSearchableEntityType["RequestForm"] = "REQUEST_FORM";
    return HelpObjectStoreSearchableEntityType;
}({}); /** Call-to-action link where the notification is directed to. */ 
let $78ad46e0d6808149$export$add9b70bcde2a1e5 = /*#__PURE__*/ function(InfluentsNotificationAppearance) {
    InfluentsNotificationAppearance["Danger"] = "DANGER";
    InfluentsNotificationAppearance["Default"] = "DEFAULT";
    InfluentsNotificationAppearance["Link"] = "LINK";
    InfluentsNotificationAppearance["Primary"] = "PRIMARY";
    InfluentsNotificationAppearance["Subtle"] = "SUBTLE";
    InfluentsNotificationAppearance["Warning"] = "WARNING";
    return InfluentsNotificationAppearance;
}({}); /**
 * A body item can be sent with two types of appearances, PRIMARY and QUOTED.
 * The latter can be used to for sending comment reply style notifications.
 */ 
let $78ad46e0d6808149$export$3f759331ea860587 = /*#__PURE__*/ function(InfluentsNotificationCategory) {
    InfluentsNotificationCategory["Direct"] = "direct";
    InfluentsNotificationCategory["Watching"] = "watching";
    return InfluentsNotificationCategory;
}({}); /**
 * The Entity is what the notification relates to –
 * in most cases it’s the object (page, issue, pull request) that has been interacted with.
 * Clicking the title takes the user to the entity.
 * An entity can have a related icon.
 */ 
let $78ad46e0d6808149$export$d50fb347f614347c = /*#__PURE__*/ function(InfluentsNotificationReadState) {
    InfluentsNotificationReadState["Read"] = "read";
    InfluentsNotificationReadState["Unread"] = "unread";
    return InfluentsNotificationReadState;
}({}); /** Input for the mutation operations (snooze and remove). */ 
let $78ad46e0d6808149$export$2fe6ad0d43104840 = /*#__PURE__*/ function(InsightsApprovalStatus) {
    InsightsApprovalStatus["Approved"] = "APPROVED";
    InsightsApprovalStatus["Needswork"] = "NEEDSWORK";
    InsightsApprovalStatus["Unapproved"] = "UNAPPROVED";
    InsightsApprovalStatus["Unknown"] = "UNKNOWN";
    return InsightsApprovalStatus;
}({}); /** A context of either sprint or project Ari */ 
let $78ad46e0d6808149$export$2aa37f5a6634dc51 = /*#__PURE__*/ function(InsightsEnvironmentType) {
    InsightsEnvironmentType["Development"] = "DEVELOPMENT";
    InsightsEnvironmentType["Production"] = "PRODUCTION";
    InsightsEnvironmentType["Staging"] = "STAGING";
    InsightsEnvironmentType["Testing"] = "TESTING";
    InsightsEnvironmentType["Unmapped"] = "UNMAPPED";
    return InsightsEnvironmentType;
}({}); /** Input for the onboarding mutation operations (purge / snooze / remove). */ 
let $78ad46e0d6808149$export$32b11fa8a4db8f2e = /*#__PURE__*/ function(InsightsNextBestTaskAction) {
    InsightsNextBestTaskAction["Remove"] = "REMOVE";
    InsightsNextBestTaskAction["Snooze"] = "SNOOZE";
    return InsightsNextBestTaskAction;
}({}); /**
 * Defines whether we show the github onboarding UX
 * VISIBLE means JFE should render the onboarding UX
 * HIDDEN means user is already onboarded, do not show UX
 * SNOOZED means user snoozed the recommendation
 * REMOVED means user explicitly hid the recommendation
 */ 
let $78ad46e0d6808149$export$a20071bd470d2580 = /*#__PURE__*/ function(InsightsRecommendationVisibility) {
    InsightsRecommendationVisibility["Hidden"] = "HIDDEN";
    InsightsRecommendationVisibility["Removed"] = "REMOVED";
    InsightsRecommendationVisibility["Snoozed"] = "SNOOZED";
    InsightsRecommendationVisibility["Visible"] = "VISIBLE";
    return InsightsRecommendationVisibility;
}({});
let $78ad46e0d6808149$export$ef229f124986e5a0 = /*#__PURE__*/ function(InsightsTaskType) {
    InsightsTaskType["BlockingIssue"] = "BLOCKING_ISSUE";
    InsightsTaskType["BuildFailed"] = "BUILD_FAILED";
    InsightsTaskType["CritVuln"] = "CRIT_VULN";
    InsightsTaskType["DeploymentFailed"] = "DEPLOYMENT_FAILED";
    InsightsTaskType["PrNeedsWork"] = "PR_NEEDS_WORK";
    InsightsTaskType["PrReview"] = "PR_REVIEW";
    return InsightsTaskType;
}({}); /** Action object stored in the database for the actions snooze/remove task. */ 
let $78ad46e0d6808149$export$8efcfbc5b7f2cb2f = /*#__PURE__*/ function(InsightsVulnerabilityStatus) {
    InsightsVulnerabilityStatus["Closed"] = "CLOSED";
    InsightsVulnerabilityStatus["Ignored"] = "IGNORED";
    InsightsVulnerabilityStatus["Open"] = "OPEN";
    InsightsVulnerabilityStatus["Unknown"] = "UNKNOWN";
    return InsightsVulnerabilityStatus;
}({}); /** The metrics returned on each invocation */  /** The data returned from a function invocation */  /** Input payload for the invoke aux mutation */  /** The response from an AUX effects invocation */  /** Input payload for the invoke mutation */  /** The response from a function invocation */  /** Detailed information of a repository's branch */  /** Short description of a pull request associated with a branch */  /** Detailed information about a build tied to a provider */  /** A build pipeline provider */  /** Information that links a build to a version control system (commits, branches, etc.) */ 
let $78ad46e0d6808149$export$338894d2bcfa1c6c = /*#__PURE__*/ function(IssueDevOpsCommitChangeType) {
    IssueDevOpsCommitChangeType["Added"] = "ADDED";
    IssueDevOpsCommitChangeType["Copied"] = "COPIED";
    IssueDevOpsCommitChangeType["Deleted"] = "DELETED";
    IssueDevOpsCommitChangeType["Modified"] = "MODIFIED";
    IssueDevOpsCommitChangeType["Modify"] = "MODIFY";
    IssueDevOpsCommitChangeType["Moved"] = "MOVED";
    IssueDevOpsCommitChangeType["Unknown"] = "UNKNOWN";
    return IssueDevOpsCommitChangeType;
}({}); /** Detailed information of a commit in a repository */  /** Information of a file modified in a commit */  /** Detailed information of a deployment */ 
let $78ad46e0d6808149$export$99413405dc72cb24 = /*#__PURE__*/ function(IssueDevOpsDeploymentEnvironmentType) {
    IssueDevOpsDeploymentEnvironmentType["Development"] = "DEVELOPMENT";
    IssueDevOpsDeploymentEnvironmentType["Production"] = "PRODUCTION";
    IssueDevOpsDeploymentEnvironmentType["Staging"] = "STAGING";
    IssueDevOpsDeploymentEnvironmentType["Testing"] = "TESTING";
    IssueDevOpsDeploymentEnvironmentType["Unmapped"] = "UNMAPPED";
    return IssueDevOpsDeploymentEnvironmentType;
}({}); /**
 * This object witholds deployment providers essential information,
 * as well as its list of latest deployments per pipeline.
 * A provider without deployments related to the asked issueId will not be returned.
 */ 
let $78ad46e0d6808149$export$df40bbb79dc09c24 = /*#__PURE__*/ function(IssueDevOpsDeploymentState) {
    IssueDevOpsDeploymentState["Cancelled"] = "CANCELLED";
    IssueDevOpsDeploymentState["Failed"] = "FAILED";
    IssueDevOpsDeploymentState["InProgress"] = "IN_PROGRESS";
    IssueDevOpsDeploymentState["Pending"] = "PENDING";
    IssueDevOpsDeploymentState["RolledBack"] = "ROLLED_BACK";
    IssueDevOpsDeploymentState["Successful"] = "SUCCESSFUL";
    IssueDevOpsDeploymentState["Unknown"] = "UNKNOWN";
    return IssueDevOpsDeploymentState;
}({}); /** Aggregates all the instance types (bitbucket, stash, github) and its development information */  /** Information related to the development process of an issue */  /** Information related to the development process of an issue */  /**
 * A set of booleans that indicate if the embedded marketplace
 * should be shown if a user does not have installed providers
 */ 
let $78ad46e0d6808149$export$93807e2ffddb6d99 = /*#__PURE__*/ function(IssueDevOpsPullRequestStatus) {
    IssueDevOpsPullRequestStatus["Declined"] = "DECLINED";
    IssueDevOpsPullRequestStatus["Draft"] = "DRAFT";
    IssueDevOpsPullRequestStatus["Merged"] = "MERGED";
    IssueDevOpsPullRequestStatus["Open"] = "OPEN";
    IssueDevOpsPullRequestStatus["Unknown"] = "UNKNOWN";
    return IssueDevOpsPullRequestStatus;
}({}); /** Detailed information of a VCS repository */  /** Short description of the parent repository from which the fork was made */  /** Short desciption of a review associated with a branch or commit */  /** A summary for the tests results for a particular build */  /** Represents a JSM Incident. */ 
let $78ad46e0d6808149$export$7aab904fe49fa56e = /*#__PURE__*/ function(JsmIncidentLinkDirection) {
    JsmIncidentLinkDirection["Inward"] = "INWARD";
    JsmIncidentLinkDirection["Outward"] = "OUTWARD";
    return JsmIncidentLinkDirection;
}({});
let $78ad46e0d6808149$export$cd35cf091a6250bb = /*#__PURE__*/ function(JsmMajorIncident) {
    JsmMajorIncident["MajorIncident"] = "MAJOR_INCIDENT";
    return JsmMajorIncident;
}({}); /** Represents the Atlassian Document Format content in JSON format. */  /** Represents the Atlassian Document Format content in JSON format. */  /** Input type for ADF values on fields */  /** Shows the Atlassian Intelligence feature to the end user. */  /** The different action types that a user can perform on a global level */ 
let $78ad46e0d6808149$export$b40f2294e83c8458 = /*#__PURE__*/ function(JiraActionType) {
    JiraActionType["CreateCompanyManagedProject"] = "CREATE_COMPANY_MANAGED_PROJECT";
    JiraActionType["CreateProject"] = "CREATE_PROJECT";
    JiraActionType["CreateTeamManagedProject"] = "CREATE_TEAM_MANAGED_PROJECT";
    return JiraActionType;
}({}); /** The input to associate issues with a fix version. */  /** The return payload of associating issues with a fix version. */  /** Input to create a new related work item and associated with a version. */  /** The return payload of creating a new related work item and associating it with a version. */  /** Operations that can be performed on fields like attachments and issuelinks etc. */ 
let $78ad46e0d6808149$export$7dab5913fedb74fb = /*#__PURE__*/ function(JiraAddValueFieldOperations) {
    JiraAddValueFieldOperations["Add"] = "ADD";
    return JiraAddValueFieldOperations;
}({}); /** The list of values for supported fields for the issue */  /** The connection type for JiraAdditionalIssueFields including the pagination information */  /** Represents ADF converted to plain text. */  /** Attributes of user configurations specific to richText field */  /** Attributes of user configurations specific to richText field */  /** Navigation information for the currently logged in user regarding Advanced Roadmaps for Jira */  /**
 * Represents an affected service entity for a Jira Issue.
 * AffectedService provides context on what has been changed.
 */ 
let $78ad46e0d6808149$export$35561b7f9e1f55e5 = /*#__PURE__*/ function(JiraAnnouncementBannerVisibility) {
    JiraAnnouncementBannerVisibility["Private"] = "PRIVATE";
    JiraAnnouncementBannerVisibility["Public"] = "PUBLIC";
    return JiraAnnouncementBannerVisibility;
}({}); /** The approval decision input */  /** Config states for an app with a specific id */  /** Config states for an app with a specific id */  /** Connection object representing config state for a set of jira apps */  /** Connection edge representing config state for one jira app */  /** Represent the config information required for a connect/forge app navigation item or nested link */  /** Represents a connect/forge app top-level navigation item */  /** Represents a connect/forge app nested navigation item */  /** Represents the navigation item type for a specific Connect or Forge app. */  /**
 * Represents a nested section for connect/forge apps
 * A collection of orphan/non-sectioned links will also be grouped as a section without a label
 */ 
let $78ad46e0d6808149$export$ce082fc9df0d76d9 = /*#__PURE__*/ function(JiraAppType) {
    JiraAppType["Connect"] = "CONNECT";
    JiraAppType["Forge"] = "FORGE";
    return JiraAppType;
}({}); /** A list of all UI modifications for an app and environment */  /** Representation of each Jira application/sub-product. */ 
let $78ad46e0d6808149$export$3041ba651e0f5411 = /*#__PURE__*/ function(JiraApplicationKey) {
    JiraApplicationKey["JiraCore"] = "JIRA_CORE";
    JiraApplicationKey["JiraProductDiscovery"] = "JIRA_PRODUCT_DISCOVERY";
    JiraApplicationKey["JiraServiceDesk"] = "JIRA_SERVICE_DESK";
    JiraApplicationKey["JiraSoftware"] = "JIRA_SOFTWARE";
    return JiraApplicationKey;
}({}); /**
 * Jira application properties is effectively a key/value store scoped to a Jira instance. A JiraApplicationProperty
 * represents one of these key/value pairs, along with associated metadata about the property.
 */ 
let $78ad46e0d6808149$export$b45afd01a571a7c3 = /*#__PURE__*/ function(JiraApprovalDecision) {
    JiraApprovalDecision["Approved"] = "APPROVED";
    JiraApprovalDecision["Rejected"] = "REJECTED";
    return JiraApprovalDecision;
}({}); /** The input type to approve access request of connected workspace(organization in Jira term) */  /** The response payload to approve access request of connected workspace(organization in Jira term) */  /** Input type to filter archived issues */  /** Field Options for filter by fields for getting archived issues */  /** Field Options for filter by fields for getting archived issues */  /** Field Options for filter by fields for getting archived issues */  /** Field Options for filter by fields for getting archived issues */  /** Input type for archival date range */  /** Represents a single option value for an asset field. */  /** The connection type for JiraAsset. */  /** An edge in a JiraAsset connection. */  /** Represents the Asset field on a Jira Issue. */  /** Represents the Asset field on a Jira Issue. */  /** Input type for asset field */  /** Input type for asset value */  /**
 * DEPRECATED: Superseded by issue linking
 *
 * Input to assign/unassign a related work item to a user.
 */ 
let $78ad46e0d6808149$export$ff923d46af5bc866 = /*#__PURE__*/ function(JiraAtlassianIntelligenceFeatureEnum) {
    JiraAtlassianIntelligenceFeatureEnum["AiMate"] = "AI_MATE";
    JiraAtlassianIntelligenceFeatureEnum["NaturalLanguageToJql"] = "NATURAL_LANGUAGE_TO_JQL";
    return JiraAtlassianIntelligenceFeatureEnum;
}({}); /** Input used to specify which product or feature to check for Atlassian Intelligence. */  /** Deprecated type. Please use `JiraTeamView` instead. */  /** Deprecated type. */  /** Deprecated type. */  /** Represents the Atlassian team field on a Jira Issue. Allows you to select a team to be associated with an issue. */  /** Represents the Atlassian team field on a Jira Issue. Allows you to select a team to be associated with an issue. */  /** Input type for Atlassian team field */  /** Input type for Atlassian team data */  /** An interface shared across all attachment types. */  /** An interface shared across all attachment types. */  /** A Jira Attachment Background, used only when the entity is of Issue type */  /** The connection type for JiraAttachment. */  /** An edge in a JiraAttachment connection. */  /** Input type for defining the operation on the Attachment field of a Jira issue. */  /** The payload type returned after updating the IssueType field of a Jira issue. */  /** Represents a fixed set of attachments' parents */ 
let $78ad46e0d6808149$export$e58d203181411860 = /*#__PURE__*/ function(JiraAttachmentParentName) {
    JiraAttachmentParentName["Comment"] = "COMMENT";
    JiraAttachmentParentName["Customfield"] = "CUSTOMFIELD";
    JiraAttachmentParentName["Description"] = "DESCRIPTION";
    JiraAttachmentParentName["Environment"] = "ENVIRONMENT";
    JiraAttachmentParentName["Form"] = "FORM";
    JiraAttachmentParentName["Issue"] = "ISSUE";
    JiraAttachmentParentName["Worklog"] = "WORKLOG";
    return JiraAttachmentParentName;
}({}); /** The field for sorting attachments. */ 
let $78ad46e0d6808149$export$4452eb40a75908b1 = /*#__PURE__*/ function(JiraAttachmentSortField) {
    JiraAttachmentSortField["Created"] = "CREATED";
    return JiraAttachmentSortField;
}({}); /** Deprecated type. Please use `attachments` field under `JiraIssue` instead. */  /** Deprecated type. Please use `attachments` field under `JiraIssue` instead. */ 
let $78ad46e0d6808149$export$add469b410e3b948 = /*#__PURE__*/ function(JiraAttachmentsPermissions) {
    JiraAttachmentsPermissions["CreateAttachments"] = "CREATE_ATTACHMENTS";
    JiraAttachmentsPermissions["DeleteOwnAttachments"] = "DELETE_OWN_ATTACHMENTS";
    return JiraAttachmentsPermissions;
}({}); /** The payload response for basic autodev mutations */  /** JiraAutodevCodeChange represents a code change associated with the Autodev Job */  /** JiraAutodevCodeChangeConnection represents the connection object for Code changes associated with the Autodev Job */  /** JiraAutodevCodeChangeEdge represents the code change edge object associated with the Autodev Job */  /** Renamed to JiraAutodevCodeChangeEnumType to be compatible with jira/gira prefix validation */ 
let $78ad46e0d6808149$export$20cf66312c009d2a = /*#__PURE__*/ function(JiraAutodevCodeChangeEnumType) {
    JiraAutodevCodeChangeEnumType["Add"] = "ADD";
    JiraAutodevCodeChangeEnumType["Delete"] = "DELETE";
    JiraAutodevCodeChangeEnumType["Edit"] = "EDIT";
    JiraAutodevCodeChangeEnumType["Other"] = "OTHER";
    return JiraAutodevCodeChangeEnumType;
}({}); /** The payload response for the create an autofix job mutation */  /** Autodev job response */  /** Autodev/acra job connection */  /** Connection edge representing autodev job */  /** Autodev job state */ 
let $78ad46e0d6808149$export$7c2c34d9bc1709c = /*#__PURE__*/ function(JiraAutodevPhase) {
    JiraAutodevPhase["CodeGenerating"] = "CODE_GENERATING";
    JiraAutodevPhase["CodeReview"] = "CODE_REVIEW";
    JiraAutodevPhase["CodeReGenerating"] = "CODE_RE_GENERATING";
    JiraAutodevPhase["PlanGenerating"] = "PLAN_GENERATING";
    JiraAutodevPhase["PlanReview"] = "PLAN_REVIEW";
    JiraAutodevPhase["PlanReGenerating"] = "PLAN_RE_GENERATING";
    return JiraAutodevPhase;
}({}); /** Autodev Job Plan */  /** JiraAutodevPlannedChange represents a planned code change associated with the Autodev Job */  /** JiraAutodevPullRequest represents one pull request associated with the Autodev Job */  /** JiraAutodevPullRequestConnection represents the connection object for Pull requests associated with the Autodev Job */  /** JiraAutodevPullRequestEdge represents the pull request edge object associated with the Autodev Job */  /** Autodev job state */ 
let $78ad46e0d6808149$export$9d46e21e99abf4d9 = /*#__PURE__*/ function(JiraAutodevState) {
    JiraAutodevState["Cancelled"] = "CANCELLED";
    JiraAutodevState["CodeGenerating"] = "CODE_GENERATING";
    JiraAutodevState["CodeGenerationFail"] = "CODE_GENERATION_FAIL";
    JiraAutodevState["CodeGenerationReady"] = "CODE_GENERATION_READY";
    JiraAutodevState["CodeGenerationSuccess"] = "CODE_GENERATION_SUCCESS";
    JiraAutodevState["Created"] = "CREATED";
    JiraAutodevState["PlanGenerating"] = "PLAN_GENERATING";
    JiraAutodevState["PlanGenerationFail"] = "PLAN_GENERATION_FAIL";
    JiraAutodevState["PlanGenerationSuccess"] = "PLAN_GENERATION_SUCCESS";
    JiraAutodevState["PullrequestCreating"] = "PULLREQUEST_CREATING";
    JiraAutodevState["PullrequestCreationFail"] = "PULLREQUEST_CREATION_FAIL";
    JiraAutodevState["PullrequestCreationSuccess"] = "PULLREQUEST_CREATION_SUCCESS";
    JiraAutodevState["Unknown"] = "UNKNOWN";
    return JiraAutodevState;
}({}); /** Autodev job status */ 
let $78ad46e0d6808149$export$b45cf8febb3440fe = /*#__PURE__*/ function(JiraAutodevStatus) {
    JiraAutodevStatus["Cancelled"] = "CANCELLED";
    JiraAutodevStatus["Completed"] = "COMPLETED";
    JiraAutodevStatus["Failed"] = "FAILED";
    JiraAutodevStatus["InProgress"] = "IN_PROGRESS";
    JiraAutodevStatus["Pending"] = "PENDING";
    return JiraAutodevStatus;
}({}); /** JiraAutodevStatusHistoryItem represents one status history item associated with the Autodev Job */  /** JiraAutodevStatusHistoryItemConnection represents the connection object for status history items associated with the Autodev Job */  /** JiraAutodevStatusHistoryItemEdge represents the status history item edge object associated with the Autodev Job */  /** JiraAutodevTaskConnection represents the connection object for individual tasks in the plan for the Autodev Job */  /** Response from creating an autofix job */  /** The input type to create an autofix job */  /** Autofix job response */  /** Autofix job connection */  /** Connection edge representing autofix job */  /** Type of autofix job */ 
let $78ad46e0d6808149$export$ffe042497b182587 = /*#__PURE__*/ function(JiraAutofixJobType) {
    JiraAutofixJobType["InternalRemoveFeatureFlag"] = "INTERNAL_REMOVE_FEATURE_FLAG";
    return JiraAutofixJobType;
}({}); /** Autofix job status */ 
let $78ad46e0d6808149$export$9bc56f5589387f27 = /*#__PURE__*/ function(JiraAutofixStatus) {
    JiraAutofixStatus["Completed"] = "COMPLETED";
    JiraAutofixStatus["Failed"] = "FAILED";
    JiraAutofixStatus["InProgress"] = "IN_PROGRESS";
    JiraAutofixStatus["Pending"] = "PENDING";
    return JiraAutofixStatus;
}({}); /** Represents the four avatar sizes' url. */  /** Interface for backgrounds */  /** The supported background types */ 
let $78ad46e0d6808149$export$2c2631a0fafec4d2 = /*#__PURE__*/ function(JiraBackgroundType) {
    JiraBackgroundType["Attachment"] = "ATTACHMENT";
    JiraBackgroundType["Color"] = "COLOR";
    JiraBackgroundType["Custom"] = "CUSTOM";
    JiraBackgroundType["Gradient"] = "GRADIENT";
    JiraBackgroundType["Unsplash"] = "UNSPLASH";
    return JiraBackgroundType;
}({}); /** Type to hold Jira Background upload token auth details */ 
let $78ad46e0d6808149$export$a91e934e29660252 = /*#__PURE__*/ function(JiraBatchWindowPreference) {
    JiraBatchWindowPreference["DefaultBatching"] = "DEFAULT_BATCHING";
    JiraBatchWindowPreference["FifteenMinutes"] = "FIFTEEN_MINUTES";
    JiraBatchWindowPreference["FiveMinutes"] = "FIVE_MINUTES";
    JiraBatchWindowPreference["NoBatching"] = "NO_BATCHING";
    JiraBatchWindowPreference["OncePerDay"] = "ONCE_PER_DAY";
    JiraBatchWindowPreference["OneDay"] = "ONE_DAY";
    JiraBatchWindowPreference["OneHour"] = "ONE_HOUR";
    JiraBatchWindowPreference["TenMinutes"] = "TEN_MINUTES";
    JiraBatchWindowPreference["ThirtyMinutes"] = "THIRTY_MINUTES";
    return JiraBatchWindowPreference;
}({}); /**
 * The internal BB app which provides devOps capabilities
 * This provider will be filtered out from the list of providers if BB SCM is not installed
 */ 
let $78ad46e0d6808149$export$fffb97f85a99dcd3 = /*#__PURE__*/ function(JiraBitbucketWorkspaceApprovalState) {
    JiraBitbucketWorkspaceApprovalState["Approved"] = "APPROVED";
    JiraBitbucketWorkspaceApprovalState["PendingApproval"] = "PENDING_APPROVAL";
    return JiraBitbucketWorkspaceApprovalState;
}({}); /** Represents a Jira Board */  /** The connection type for JiraBoard */  /** An edge in a JiraBoard connection */  /** Types of containers that boards can be located in */ 
let $78ad46e0d6808149$export$4dc98413456458b = /*#__PURE__*/ function(JiraBoardLocationType) {
    JiraBoardLocationType["Project"] = "PROJECT";
    JiraBoardLocationType["User"] = "USER";
    return JiraBoardLocationType;
}({}); /** Types of Jira boards */ 
let $78ad46e0d6808149$export$97a2fe75628224ea = /*#__PURE__*/ function(JiraBoardType) {
    JiraBoardType["Kanban"] = "KANBAN";
    JiraBoardType["Scrum"] = "SCRUM";
    return JiraBoardType;
}({}); /** Represents a generic boolean field for an Issue. E.g. JSM alert linking. */  /** The input type for scheduling the execution of project cleanup recommendations */  /** The payload type for bulk project archiving and trashing */  /** Retrieves a field which can be bulk edited */  /** Retrieves a connection of fields which can be bulk edited */  /** An edge in a BulkEditFields connection. */  /** Specifies inputs for search on fields and a boolean to override them */  /** Specified bulk edit operation input */  /**
 * Contains all options available for fields with multi select options available
 * This field is required only for 4 system field: Fix Versions, Affects Versions, Label and Component
 */ 
let $78ad46e0d6808149$export$8dcaa522c00e0bea = /*#__PURE__*/ function(JiraBulkEditMultiSelectFieldOptions) {
    JiraBulkEditMultiSelectFieldOptions["Add"] = "ADD";
    JiraBulkEditMultiSelectFieldOptions["Remove"] = "REMOVE";
    JiraBulkEditMultiSelectFieldOptions["RemoveAll"] = "REMOVE_ALL";
    JiraBulkEditMultiSelectFieldOptions["Replace"] = "REPLACE";
    return JiraBulkEditMultiSelectFieldOptions;
}({}); /** Specified bulk operation input */  /** Specified the type of bulk operation */ 
let $78ad46e0d6808149$export$65634ab0c72ca58 = /*#__PURE__*/ function(JiraBulkOperationType) {
    JiraBulkOperationType["BulkEdit"] = "BULK_EDIT";
    JiraBulkOperationType["BulkTransition"] = "BULK_TRANSITION";
    return JiraBulkOperationType;
}({}); /** Retrives a list of transitions for given issues */  /** Retrives a list of transitions for given issues */  /** Retrives a list of transitions for given issues */  /** Retrieves a connection of transitions applicable for a given list of issues */  /** An edge in a bulk transition connection. */  /** Represents the screen layout for a transition and set of issues. */  /** Represents the screen layout for a transition and set of issues. */  /** Input type for bulk transition */  /** Represents CMDB (Configuration Management Database) field on a Jira Issue. */  /** Represents CMDB (Configuration Management Database) field on a Jira Issue. */ 
let $78ad46e0d6808149$export$598ca3e7e63eeac3 = /*#__PURE__*/ function(JiraCalendarMode) {
    JiraCalendarMode["Day"] = "DAY";
    JiraCalendarMode["Month"] = "MONTH";
    JiraCalendarMode["Week"] = "WEEK";
    return JiraCalendarMode;
}({}); /** An edge in a JiraProjectPermission connection. */ 
let $78ad46e0d6808149$export$80636f9ce4ef8927 = /*#__PURE__*/ function(JiraCalendarPermissionKey) {
    JiraCalendarPermissionKey["ManageSprintsPermission"] = "MANAGE_SPRINTS_PERMISSION";
    return JiraCalendarPermissionKey;
}({}); /** View settings for Jira Calendar */ 
let $78ad46e0d6808149$export$56103bfe65fcf045 = /*#__PURE__*/ function(JiraCalendarWeekStart) {
    JiraCalendarWeekStart["Monday"] = "MONDAY";
    JiraCalendarWeekStart["Saturday"] = "SATURDAY";
    JiraCalendarWeekStart["Sunday"] = "SUNDAY";
    return JiraCalendarWeekStart;
}({}); /** Canned response entity created against a project with defined scope. */  /**
 * #########################
 *  Mutation Inputs
 * #########################
 */ 
let $78ad46e0d6808149$export$ce8ee5a026b40f80 = /*#__PURE__*/ function(JiraCannedResponseScope) {
    JiraCannedResponseScope["Personal"] = "PERSONAL";
    JiraCannedResponseScope["Project"] = "PROJECT";
    return JiraCannedResponseScope;
}({});
let $78ad46e0d6808149$export$c55b15b4975ca485 = /*#__PURE__*/ function(JiraCannedResponseSortOrder) {
    JiraCannedResponseSortOrder["Asc"] = "ASC";
    JiraCannedResponseSortOrder["Desc"] = "DESC";
    return JiraCannedResponseSortOrder;
}({}); /**
 * Represents the pair of values (parent & child combination) in a cascading select.
 * This type is used to represent a selected cascading field value on a Jira Issue.
 * Since this is 2 level hierarchy, it is not possible to represent the same underlying
 * type for both single cascadingOption and list of cascadingOptions. Thus, we have created different types.
 */ 
let $78ad46e0d6808149$export$95ff254e6924dc6f = /*#__PURE__*/ function(JiraCascadingSelectOptionType) {
    JiraCascadingSelectOptionType["All"] = "ALL";
    JiraCascadingSelectOptionType["Child"] = "CHILD";
    JiraCascadingSelectOptionType["Parent"] = "PARENT";
    return JiraCascadingSelectOptionType;
}({}); /** An input filter used to specify the cascading options returned. */  /** Represents the check boxes field on a Jira Issue. */  /** Represents the check boxes field on a Jira Issue. */  /** Represents the check boxes field on a Jira Issue. */  /** Input type for defining the operation on the Checkboxes field of a Jira issue. */  /** The payload type returned after updating the Checkboxes field of a Jira issue. */  /**
 * A union type representing childIssues available within a Jira Issue.
 * The *WithinLimit type is used for childIssues with a count that is within a limit specified by the server.
 * The *ExceedsLimit type is used for childIssues with a count that exceeds a limit specified by the server.
 */ 
let $78ad46e0d6808149$export$f34d058fb688acaf = /*#__PURE__*/ function(JiraClassificationLevelSource) {
    JiraClassificationLevelSource["Issue"] = "ISSUE";
    JiraClassificationLevelSource["Project"] = "PROJECT";
    return JiraClassificationLevelSource;
}({}); /** Enum to define the classification level status. */ 
let $78ad46e0d6808149$export$608cba47cc506457 = /*#__PURE__*/ function(JiraClassificationLevelStatus) {
    JiraClassificationLevelStatus["Archived"] = "ARCHIVED";
    JiraClassificationLevelStatus["Draft"] = "DRAFT";
    JiraClassificationLevelStatus["Published"] = "PUBLISHED";
    return JiraClassificationLevelStatus;
}({}); /** Enum to define the classification level type. */ 
let $78ad46e0d6808149$export$a6a7c946782bf432 = /*#__PURE__*/ function(JiraClassificationLevelType) {
    JiraClassificationLevelType["System"] = "SYSTEM";
    JiraClassificationLevelType["User"] = "USER";
    return JiraClassificationLevelType;
}({}); /** Input type for a clearable number field */  /** Represents the attribute associated with the CMDB object. */  /** Represents the attribute associated with the CMDB object. */  /** The connection type for JiraCmdbAttribute. */  /** An edge in a JiraCmdbAttribute connection. */  /** The category of the CMDB attribute that can be created. */ 
let $78ad46e0d6808149$export$aafda693b12c4a20 = /*#__PURE__*/ function(JiraCmdbAttributeType) {
    JiraCmdbAttributeType["BitbucketRepo"] = "BITBUCKET_REPO";
    JiraCmdbAttributeType["Confluence"] = "CONFLUENCE";
    JiraCmdbAttributeType["Default"] = "DEFAULT";
    JiraCmdbAttributeType["Group"] = "GROUP";
    JiraCmdbAttributeType["OpsgenieTeam"] = "OPSGENIE_TEAM";
    JiraCmdbAttributeType["Project"] = "PROJECT";
    JiraCmdbAttributeType["ReferencedObject"] = "REFERENCED_OBJECT";
    JiraCmdbAttributeType["Status"] = "STATUS";
    JiraCmdbAttributeType["User"] = "USER";
    JiraCmdbAttributeType["Version"] = "VERSION";
    return JiraCmdbAttributeType;
}({}); /** Represents a CMDB avatar. */  /** Represents the CMDB Bitbucket Repository. */  /** The connection type for CMDB config attributes. */  /** An edge in a JiraCmdbConfigAttributeConnection. */  /**
 * Represents the CMDB default type.
 * This contains information about what type of default attribute this is.
 * The possible id: name values are as follows:
 *     0: Text
 *     1: Integer
 *     2: Boolean
 *     3: Float
 *     4: Date
 *     6: DateTime
 *     7: URL
 *     8: Email
 *     9: Textarea
 *     10: Select
 *     11: IP Address
 */ 
let $78ad46e0d6808149$export$7341e48e3db8f8f0 = /*#__PURE__*/ function(JiraColorSchemeThemeSetting) {
    JiraColorSchemeThemeSetting["Automatic"] = "AUTOMATIC";
    JiraColorSchemeThemeSetting["Dark"] = "DARK";
    JiraColorSchemeThemeSetting["Light"] = "LIGHT";
    return JiraColorSchemeThemeSetting;
}({}); /** An interface shared across all comment types. */  /** The connection type for JiraComment. */  /** An edge in a JiraComment connection. */  /** The field for sorting comments. */ 
let $78ad46e0d6808149$export$67f08e20644f2173 = /*#__PURE__*/ function(JiraCommentSortField) {
    JiraCommentSortField["Created"] = "CREATED";
    return JiraCommentSortField;
}({}); /**
 * Jira component defines two kinds of Components:
 *     1. Project Components, sub-selection of a project.
 *     2. Global Components, which span across multiple projects.
 * One of the Global Components type is Compass Components.
 */ 
let $78ad46e0d6808149$export$6f50c8d504c17c7a = /*#__PURE__*/ function(JiraConfigFieldType) {
    JiraConfigFieldType["CustomCascadingSelect"] = "CUSTOM_CASCADING_SELECT";
    JiraConfigFieldType["CustomDatetime"] = "CUSTOM_DATETIME";
    JiraConfigFieldType["CustomDatePicker"] = "CUSTOM_DATE_PICKER";
    JiraConfigFieldType["CustomFloat"] = "CUSTOM_FLOAT";
    JiraConfigFieldType["CustomGroupPicker"] = "CUSTOM_GROUP_PICKER";
    JiraConfigFieldType["CustomImportId"] = "CUSTOM_IMPORT_ID";
    JiraConfigFieldType["CustomLabels"] = "CUSTOM_LABELS";
    JiraConfigFieldType["CustomMultiCheckboxes"] = "CUSTOM_MULTI_CHECKBOXES";
    JiraConfigFieldType["CustomMultiGroupPicker"] = "CUSTOM_MULTI_GROUP_PICKER";
    JiraConfigFieldType["CustomMultiSelect"] = "CUSTOM_MULTI_SELECT";
    JiraConfigFieldType["CustomMultiUserPicker"] = "CUSTOM_MULTI_USER_PICKER";
    JiraConfigFieldType["CustomMultiVersion"] = "CUSTOM_MULTI_VERSION";
    JiraConfigFieldType["CustomProject"] = "CUSTOM_PROJECT";
    JiraConfigFieldType["CustomRadioButtons"] = "CUSTOM_RADIO_BUTTONS";
    JiraConfigFieldType["CustomReadonlyField"] = "CUSTOM_READONLY_FIELD";
    JiraConfigFieldType["CustomSelect"] = "CUSTOM_SELECT";
    JiraConfigFieldType["CustomTextarea"] = "CUSTOM_TEXTAREA";
    JiraConfigFieldType["CustomTextField"] = "CUSTOM_TEXT_FIELD";
    JiraConfigFieldType["CustomUrl"] = "CUSTOM_URL";
    JiraConfigFieldType["CustomUserPicker"] = "CUSTOM_USER_PICKER";
    JiraConfigFieldType["CustomVersion"] = "CUSTOM_VERSION";
    JiraConfigFieldType["ServicedeskApprovals"] = "SERVICEDESK_APPROVALS";
    JiraConfigFieldType["ServicedeskCmdbField"] = "SERVICEDESK_CMDB_FIELD";
    JiraConfigFieldType["ServicedeskCustomerOrganizations"] = "SERVICEDESK_CUSTOMER_ORGANIZATIONS";
    JiraConfigFieldType["ServicedeskRequestFeedback"] = "SERVICEDESK_REQUEST_FEEDBACK";
    JiraConfigFieldType["ServicedeskRequestFeedbackDate"] = "SERVICEDESK_REQUEST_FEEDBACK_DATE";
    JiraConfigFieldType["ServicedeskRequestLanguage"] = "SERVICEDESK_REQUEST_LANGUAGE";
    JiraConfigFieldType["ServicedeskRequestParticipants"] = "SERVICEDESK_REQUEST_PARTICIPANTS";
    JiraConfigFieldType["ServicedeskSlaField"] = "SERVICEDESK_SLA_FIELD";
    JiraConfigFieldType["ServicedeskVpOrigin"] = "SERVICEDESK_VP_ORIGIN";
    JiraConfigFieldType["SoftwareEpicColor"] = "SOFTWARE_EPIC_COLOR";
    JiraConfigFieldType["SoftwareEpicIssueColor"] = "SOFTWARE_EPIC_ISSUE_COLOR";
    JiraConfigFieldType["SoftwareEpicLabel"] = "SOFTWARE_EPIC_LABEL";
    JiraConfigFieldType["SoftwareEpicLexoRank"] = "SOFTWARE_EPIC_LEXO_RANK";
    JiraConfigFieldType["SoftwareEpicLink"] = "SOFTWARE_EPIC_LINK";
    JiraConfigFieldType["SoftwareEpicSprint"] = "SOFTWARE_EPIC_SPRINT";
    JiraConfigFieldType["SoftwareEpicStatus"] = "SOFTWARE_EPIC_STATUS";
    JiraConfigFieldType["StandardAffectedVersions"] = "STANDARD_AFFECTED_VERSIONS";
    JiraConfigFieldType["StandardAggregateProgress"] = "STANDARD_AGGREGATE_PROGRESS";
    JiraConfigFieldType["StandardAggregateTimeEstimate"] = "STANDARD_AGGREGATE_TIME_ESTIMATE";
    JiraConfigFieldType["StandardAggregateTimeOriginalEstimate"] = "STANDARD_AGGREGATE_TIME_ORIGINAL_ESTIMATE";
    JiraConfigFieldType["StandardAggregateTimeSpent"] = "STANDARD_AGGREGATE_TIME_SPENT";
    JiraConfigFieldType["StandardAssignee"] = "STANDARD_ASSIGNEE";
    JiraConfigFieldType["StandardAttachment"] = "STANDARD_ATTACHMENT";
    JiraConfigFieldType["StandardComment"] = "STANDARD_COMMENT";
    JiraConfigFieldType["StandardComponents"] = "STANDARD_COMPONENTS";
    JiraConfigFieldType["StandardCreated"] = "STANDARD_CREATED";
    JiraConfigFieldType["StandardCreator"] = "STANDARD_CREATOR";
    JiraConfigFieldType["StandardDescription"] = "STANDARD_DESCRIPTION";
    JiraConfigFieldType["StandardDueDate"] = "STANDARD_DUE_DATE";
    JiraConfigFieldType["StandardEnvironment"] = "STANDARD_ENVIRONMENT";
    JiraConfigFieldType["StandardFixForVersions"] = "STANDARD_FIX_FOR_VERSIONS";
    JiraConfigFieldType["StandardFormToken"] = "STANDARD_FORM_TOKEN";
    JiraConfigFieldType["StandardIssueKey"] = "STANDARD_ISSUE_KEY";
    JiraConfigFieldType["StandardIssueLinks"] = "STANDARD_ISSUE_LINKS";
    JiraConfigFieldType["StandardIssueNumber"] = "STANDARD_ISSUE_NUMBER";
    JiraConfigFieldType["StandardIssueType"] = "STANDARD_ISSUE_TYPE";
    JiraConfigFieldType["StandardLabels"] = "STANDARD_LABELS";
    JiraConfigFieldType["StandardLastViewed"] = "STANDARD_LAST_VIEWED";
    JiraConfigFieldType["StandardParent"] = "STANDARD_PARENT";
    JiraConfigFieldType["StandardPriority"] = "STANDARD_PRIORITY";
    JiraConfigFieldType["StandardProgress"] = "STANDARD_PROGRESS";
    JiraConfigFieldType["StandardProject"] = "STANDARD_PROJECT";
    JiraConfigFieldType["StandardProjectKey"] = "STANDARD_PROJECT_KEY";
    JiraConfigFieldType["StandardReporter"] = "STANDARD_REPORTER";
    JiraConfigFieldType["StandardResolution"] = "STANDARD_RESOLUTION";
    JiraConfigFieldType["StandardResolutionDate"] = "STANDARD_RESOLUTION_DATE";
    JiraConfigFieldType["StandardSecurity"] = "STANDARD_SECURITY";
    JiraConfigFieldType["StandardStatus"] = "STANDARD_STATUS";
    JiraConfigFieldType["StandardSubtasks"] = "STANDARD_SUBTASKS";
    JiraConfigFieldType["StandardSummary"] = "STANDARD_SUMMARY";
    JiraConfigFieldType["StandardThumbnail"] = "STANDARD_THUMBNAIL";
    JiraConfigFieldType["StandardTimetracking"] = "STANDARD_TIMETRACKING";
    JiraConfigFieldType["StandardTimeEstimate"] = "STANDARD_TIME_ESTIMATE";
    JiraConfigFieldType["StandardTimeOriginalEstimate"] = "STANDARD_TIME_ORIGINAL_ESTIMATE";
    JiraConfigFieldType["StandardTimeSpent"] = "STANDARD_TIME_SPENT";
    JiraConfigFieldType["StandardUpdated"] = "STANDARD_UPDATED";
    JiraConfigFieldType["StandardVoters"] = "STANDARD_VOTERS";
    JiraConfigFieldType["StandardVotes"] = "STANDARD_VOTES";
    JiraConfigFieldType["StandardWatchers"] = "STANDARD_WATCHERS";
    JiraConfigFieldType["StandardWatches"] = "STANDARD_WATCHES";
    JiraConfigFieldType["StandardWorklog"] = "STANDARD_WORKLOG";
    JiraConfigFieldType["StandardWorkratio"] = "STANDARD_WORKRATIO";
    JiraConfigFieldType["Unsupported"] = "UNSUPPORTED";
    return JiraConfigFieldType;
}({}); /** JiraConfigState represents the configured status for a workspace for a jira app */  /** Enum representing the configured status for a jira app/workspace */ 
let $78ad46e0d6808149$export$9d90b408b08d33b7 = /*#__PURE__*/ function(JiraConfigStateConfigurationStatus) {
    JiraConfigStateConfigurationStatus["Configured"] = "CONFIGURED";
    JiraConfigStateConfigurationStatus["NotConfigured"] = "NOT_CONFIGURED";
    JiraConfigStateConfigurationStatus["NotInstalled"] = "NOT_INSTALLED";
    JiraConfigStateConfigurationStatus["NotSet"] = "NOT_SET";
    JiraConfigStateConfigurationStatus["PartiallyConfigured"] = "PARTIALLY_CONFIGURED";
    JiraConfigStateConfigurationStatus["ProviderActionConfigured"] = "PROVIDER_ACTION_CONFIGURED";
    JiraConfigStateConfigurationStatus["ProviderActionNotConfigured"] = "PROVIDER_ACTION_NOT_CONFIGURED";
    return JiraConfigStateConfigurationStatus;
}({}); /** Connection object representing config state for a set of jira app workspaces */  /** Connection edge representing config state for one jira app workspace */  /** Enum representing Provider Type of App for Config State Service */ 
let $78ad46e0d6808149$export$227a4b9b7e3c43f7 = /*#__PURE__*/ function(JiraConfigStateProviderType) {
    JiraConfigStateProviderType["Builds"] = "BUILDS";
    JiraConfigStateProviderType["Deployments"] = "DEPLOYMENTS";
    JiraConfigStateProviderType["Designs"] = "DESIGNS";
    JiraConfigStateProviderType["DevelopmentInfo"] = "DEVELOPMENT_INFO";
    JiraConfigStateProviderType["FeatureFlags"] = "FEATURE_FLAGS";
    JiraConfigStateProviderType["RemoteLinks"] = "REMOTE_LINKS";
    JiraConfigStateProviderType["Security"] = "SECURITY";
    JiraConfigStateProviderType["Unknown"] = "UNKNOWN";
    return JiraConfigStateProviderType;
}({}); /** Each individual nav item that is configurable by the user. */  /** Each individual nav item that is configurable by the user. */  /** Represents a datetime field created by Connect App. Note that a connect field's type dynamic. Consumers can use the schema type to determine this is a connect field */  /** Represents a multi-select field created by Connect App. */  /** Represents a multi-select field created by Connect App. */  /** Represents a multi-select field created by Connect App. */  /** Represents a multi-select field created by Connect App. */  /** Represents a multi-select field created by Connect App. */  /** Represents a number field created by Connect App. */  /**
 * Deprecated. Use JiraConnectTextField | JiraConnectNumberField | JiraConnectDateTimeField + isEditable instead
 * Represents a read only field created by Connect App.
 */ 
let $78ad46e0d6808149$export$2eccc11159f64a0b = /*#__PURE__*/ function(JiraContactOrgAdminToEnableAtlassianIntelligenceState) {
    JiraContactOrgAdminToEnableAtlassianIntelligenceState["Available"] = "AVAILABLE";
    JiraContactOrgAdminToEnableAtlassianIntelligenceState["Unavailable"] = "UNAVAILABLE";
    return JiraContactOrgAdminToEnableAtlassianIntelligenceState;
}({}); /** Represents the details of a navigation for a specific container. */  /** Represents the details of a navigation for a specific container. */  /** Represents the details of a navigation for a specific container. */  /** Represents the details of a navigation for a specific container. */  /** Input to query the navigation of a container scoped to a project by its key. */  /**
 * Input to retrieve the navigation details of a container. As per the `@oneOf` directive, Only one of the fields
 * `byScopeId` or `byProjectKey` must be provided.
 */ 
let $78ad46e0d6808149$export$ab94fb316a642cad = /*#__PURE__*/ function(JiraCustomIssueSearchErrorType) {
    JiraCustomIssueSearchErrorType["CustomImplementationError"] = "CUSTOM_IMPLEMENTATION_ERROR";
    JiraCustomIssueSearchErrorType["CustomSearchDisabled"] = "CUSTOM_SEARCH_DISABLED";
    JiraCustomIssueSearchErrorType["InvalidAri"] = "INVALID_ARI";
    JiraCustomIssueSearchErrorType["UnsupportedAri"] = "UNSUPPORTED_ARI";
    return JiraCustomIssueSearchErrorType;
}({}); /** Represents a Jira dashboard */  /**
 * Represents aggregated DataClassification for an issue. Data Classification for Jira provides Jira users and admins with
 * the capability to assign pre-existing classification tags to all Content levels.
 */ 
let $78ad46e0d6808149$export$2ed4618f2653768 = /*#__PURE__*/ function(JiraDeploymentsFeaturePrecondition) {
    JiraDeploymentsFeaturePrecondition["AllSatisfied"] = "ALL_SATISFIED";
    JiraDeploymentsFeaturePrecondition["DeploymentsEmptyState"] = "DEPLOYMENTS_EMPTY_STATE";
    JiraDeploymentsFeaturePrecondition["NotAvailable"] = "NOT_AVAILABLE";
    return JiraDeploymentsFeaturePrecondition;
}({}); /** User actionable error details. */  /** The possible config error type with a provider that feed devinfo details. */ 
let $78ad46e0d6808149$export$956b9378bb62ef88 = /*#__PURE__*/ function(JiraDevInfoConfigErrorType) {
    JiraDevInfoConfigErrorType["Incapable"] = "INCAPABLE";
    JiraDevInfoConfigErrorType["NotConfigured"] = "NOT_CONFIGURED";
    JiraDevInfoConfigErrorType["Unauthorized"] = "UNAUTHORIZED";
    JiraDevInfoConfigErrorType["UnknownConfigError"] = "UNKNOWN_CONFIG_ERROR";
    return JiraDevInfoConfigErrorType;
}({}); /** The input type for a devOps association */  /** The payload type for a devOps association */  /** Details of a created SCM branch associated with a Jira issue. */  /** The types of capabilities a devOps provider can support */ 
let $78ad46e0d6808149$export$35269253edf4bd98 = /*#__PURE__*/ function(JiraDevOpsCapability) {
    JiraDevOpsCapability["Branch"] = "BRANCH";
    JiraDevOpsCapability["Build"] = "BUILD";
    JiraDevOpsCapability["Commit"] = "COMMIT";
    JiraDevOpsCapability["Deployment"] = "DEPLOYMENT";
    JiraDevOpsCapability["FeatureFlag"] = "FEATURE_FLAG";
    JiraDevOpsCapability["PullRequest"] = "PULL_REQUEST";
    JiraDevOpsCapability["Review"] = "REVIEW";
    return JiraDevOpsCapability;
}({}); /** Details of a SCM commit associated with a Jira issue. */  /** The input type for devOps entity associations */  /** Basic person information who created a SCM entity (Pull-request, Branches, or Commit) */ 
let $78ad46e0d6808149$export$62ac5d058da58a8 = /*#__PURE__*/ function(JiraDevOpsInContextConfigPromptLocation) {
    JiraDevOpsInContextConfigPromptLocation["DevelopmentPanel"] = "DEVELOPMENT_PANEL";
    JiraDevOpsInContextConfigPromptLocation["ReleasesPanel"] = "RELEASES_PANEL";
    JiraDevOpsInContextConfigPromptLocation["SecurityPanel"] = "SECURITY_PANEL";
    return JiraDevOpsInContextConfigPromptLocation;
}({}); /** Container for all DevOps data for an issue, to be displayed in the DevOps Panel of an issue */ 
let $78ad46e0d6808149$export$ab235556283af700 = /*#__PURE__*/ function(JiraDevOpsIssuePanelBannerType) {
    JiraDevOpsIssuePanelBannerType["IssueKeyOnboarding"] = "ISSUE_KEY_ONBOARDING";
    return JiraDevOpsIssuePanelBannerType;
}({}); /** The possible States the DevOps Issue Panel can be in */ 
let $78ad46e0d6808149$export$9deab4622c89c42 = /*#__PURE__*/ function(JiraDevOpsIssuePanelState) {
    JiraDevOpsIssuePanelState["DevSummary"] = "DEV_SUMMARY";
    JiraDevOpsIssuePanelState["Hidden"] = "HIDDEN";
    JiraDevOpsIssuePanelState["NotConnected"] = "NOT_CONNECTED";
    return JiraDevOpsIssuePanelState;
}({}); /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Details of a SCM Pull-request associated with a Jira issue */  /** Container for all DevOps related queries in Jira */  /** Container for all DevOps related queries in Jira */  /** Container for all DevOps related queries in Jira */  /** Container for all DevOps related queries in Jira */  /** Container for all DevOps related queries in Jira */  /** Container for all DevOps related queries in Jira */  /** Container for all DevOps related queries in Jira */  /** Container for all DevOps related queries in Jira */  /** Container for all DevOps related queries in Jira */  /** Container for all DevOps related queries in Jira */ 
let $78ad46e0d6808149$export$f72ad11cc7a7d264 = /*#__PURE__*/ function(JiraDevOpsUpdateAssociationsEntityType) {
    JiraDevOpsUpdateAssociationsEntityType["Vulnerability"] = "VULNERABILITY";
    return JiraDevOpsUpdateAssociationsEntityType;
}({}); /** The input type for updating devOps associations */  /** The payload type for updating devOps associations */  /** Represents dev summary for an issue. The identifier for this field is devSummary */  /** The response payload to dismiss the banner that displays workspaces that are pending acceptance of access requests */  /** The response payload to dismiss the banner that displays workspaces that are pending acceptance of access requests */  /** The input type for devops panel banner dismissal */  /** The response payload for devops panel banner dismissal */  /** The response payload to dismiss in-context configuration prompt that is per user setting */  /** The response payload to dismiss in-context configuration prompt that is per user setting */  /** Represents a duration. Typically used for time tracking fields. */  /** Input for OriginalEstimate field */  /** Represents the possible email MIME types. */ 
let $78ad46e0d6808149$export$309a4c314bc40eda = /*#__PURE__*/ function(JiraEmailMimeType) {
    JiraEmailMimeType["Html"] = "HTML";
    JiraEmailMimeType["Text"] = "TEXT";
    return JiraEmailMimeType;
}({}); /** Represents the reason why a connection is empty. */  /** Link to send org admins to enable Atlassian Intelligence. */  /** Input type for Entitlement field */  /** Input type representing a single entitlement */  /** An interface for the return type of any Entity Property */  /** The generic Boolean type for any entity property */  /** The generic integer type for any entity property */  /** The generic JSON type for any entity property, use of this interface is NOT recommended as per https://hello.atlassian.net/wiki/spaces/GT3/pages/2567211252/Avoid+using+JSON+as+a+field+type */  /** The generic String type for any entity property */  /** Scope of values for the Entity (Ex: Field) */ 
let $78ad46e0d6808149$export$2d42aa6ed58ded25 = /*#__PURE__*/ function(JiraEntityScope) {
    JiraEntityScope["Global"] = "GLOBAL";
    JiraEntityScope["Project"] = "PROJECT";
    return JiraEntityScope;
}({}); /** Represents an epic. */  /** The connection type for JiraEpic. */  /** An edge in a JiraEpic connection. */  /** Represents epic link field on a Jira Issue. */  /** Represents epic link field on a Jira Issue. */  /** Input type for epic link field */  /** Input type for epic link field */  /** Represents the Jira time tracking estimate type. */  /**
 * Context where the extensions are supposed to be shown.
 *
 * Provide only the most specific entity. For example, there is no need to provide the project if an issue is given; the project will be inferred from the issue automatically.
 */ 
let $78ad46e0d6808149$export$5c4322ab4b397354 = /*#__PURE__*/ function(JiraFavouriteType) {
    JiraFavouriteType["Board"] = "BOARD";
    JiraFavouriteType["Dashboard"] = "DASHBOARD";
    JiraFavouriteType["Filter"] = "FILTER";
    JiraFavouriteType["Plan"] = "PLAN";
    JiraFavouriteType["Project"] = "PROJECT";
    JiraFavouriteType["Queue"] = "QUEUE";
    return JiraFavouriteType;
}({}); /** Favourite Node which is unique to a favouritable entity and a user and returns if the favourite value is true or false. */  /** Represents a Jira field which includes system fields and custom fields */  /** Represents Association of fields with IssueTypes */  /** The connection type for JiraFieldAssociationWithIssueTypes. */  /** An edge in a JiraFieldAssociationWithIssueTypes connection. */  /** Attributes of field configuration. */  /** A connection to a list of FieldConfigs. */  /** An edge in a JiraIssueFieldConfig connection. */  /** The connection type for JiraProjectAssociatedFields. */  /** An edge in a JiraProjectAssociatedFields connection. */  /** Represents the information for a field being non-editable on Issue screens. */  /** Represents operations allowed on a JiraField */  /** Represents argument input type for `fieldOptions` query to provide capability to filter field options by list of IDs */  /** Enum to define a filter operation on the optionIds in input JiraFieldOptionIdsFilterInput */ 
let $78ad46e0d6808149$export$18f16315d2f9166d = /*#__PURE__*/ function(JiraFieldOptionIdsFilterOperation) {
    JiraFieldOptionIdsFilterOperation["Allow"] = "ALLOW";
    JiraFieldOptionIdsFilterOperation["Exclude"] = "EXCLUDE";
    return JiraFieldOptionIdsFilterOperation;
}({}); /** The representation of fieldset preferences. */  /** The payload returned when a User fieldset preferences has been updated. */  /**
 * The representation of a Jira field-type.
 *
 * E.g. `Short Text`, `Number`, `Version Picker`, `Team` etc.
 */ 
let $78ad46e0d6808149$export$8947915968eda69f = /*#__PURE__*/ function(JiraForgeEnvironmentType) {
    JiraForgeEnvironmentType["Development"] = "DEVELOPMENT";
    JiraForgeEnvironmentType["Production"] = "PRODUCTION";
    JiraForgeEnvironmentType["Staging"] = "STAGING";
    return JiraForgeEnvironmentType;
}({}); /** The definition of a Forge extension in Jira. */  /** Represents a Group field created by Forge App. */  /** Represents a Group field created by Forge App. */  /** Represents a Groups field created by Forge App. */  /** Represents a Groups field created by Forge App. */  /** Represents a Groups field created by Forge App. */  /** Represents a number field created by Forge App. */  /** Represents a object field created by Forge App. */  /** Represents a string field created by Forge App. */  /** Represents a strings field created by Forge App. */  /** Represents a strings field created by Forge App. */  /** Represents a strings field created by Forge App. */  /** Represents a User field created by Forge App. */  /** Represents a User field created by Forge App. */  /** Represents a Users field created by Forge App. */  /** Represents a Users field created by Forge App. */  /** Represents a Users field created by Forge App. */ 
let $78ad46e0d6808149$export$a84cede14c0af3e6 = /*#__PURE__*/ function(JiraFormattingArea) {
    JiraFormattingArea["Cell"] = "CELL";
    JiraFormattingArea["Row"] = "ROW";
    return JiraFormattingArea;
}({});
let $78ad46e0d6808149$export$ac68c28f8148831f = /*#__PURE__*/ function(JiraFormattingColor) {
    JiraFormattingColor["Blue"] = "BLUE";
    JiraFormattingColor["Green"] = "GREEN";
    JiraFormattingColor["Red"] = "RED";
    return JiraFormattingColor;
}({}); /** Rule is evaluated against multiple values. Values order does not matter in this condition. */ 
let $78ad46e0d6808149$export$efa4d82804592bca = /*#__PURE__*/ function(JiraFormattingMultipleValueOperator) {
    JiraFormattingMultipleValueOperator["Contains"] = "CONTAINS";
    JiraFormattingMultipleValueOperator["DoesNotContain"] = "DOES_NOT_CONTAIN";
    JiraFormattingMultipleValueOperator["HasAnyOf"] = "HAS_ANY_OF";
    return JiraFormattingMultipleValueOperator;
}({}); /** Rule doesn't require value. */ 
let $78ad46e0d6808149$export$eca120e5a19089a1 = /*#__PURE__*/ function(JiraFormattingNoValueOperator) {
    JiraFormattingNoValueOperator["IsEmpty"] = "IS_EMPTY";
    JiraFormattingNoValueOperator["IsNotEmpty"] = "IS_NOT_EMPTY";
    return JiraFormattingNoValueOperator;
}({}); /** Rule is evaluated against one value */ 
let $78ad46e0d6808149$export$545873d4d5fe4917 = /*#__PURE__*/ function(JiraFormattingSingleValueOperator) {
    JiraFormattingSingleValueOperator["Contains"] = "CONTAINS";
    JiraFormattingSingleValueOperator["DoesNotContain"] = "DOES_NOT_CONTAIN";
    JiraFormattingSingleValueOperator["DoesNotEqual"] = "DOES_NOT_EQUAL";
    JiraFormattingSingleValueOperator["Equals"] = "EQUALS";
    JiraFormattingSingleValueOperator["GreaterThan"] = "GREATER_THAN";
    JiraFormattingSingleValueOperator["GreaterThanOrEquals"] = "GREATER_THAN_OR_EQUALS";
    JiraFormattingSingleValueOperator["Is"] = "IS";
    JiraFormattingSingleValueOperator["IsAfter"] = "IS_AFTER";
    JiraFormattingSingleValueOperator["IsBefore"] = "IS_BEFORE";
    JiraFormattingSingleValueOperator["IsNot"] = "IS_NOT";
    JiraFormattingSingleValueOperator["IsOnOrAfter"] = "IS_ON_OR_AFTER";
    JiraFormattingSingleValueOperator["IsOnOrBefore"] = "IS_ON_OR_BEFORE";
    JiraFormattingSingleValueOperator["LessThan"] = "LESS_THAN";
    JiraFormattingSingleValueOperator["LessThanOrEquals"] = "LESS_THAN_OR_EQUALS";
    return JiraFormattingSingleValueOperator;
}({}); /** Rule is evaluated against two values. Value order does matter in this condition. */ 
let $78ad46e0d6808149$export$7a46afffd251b41d = /*#__PURE__*/ function(JiraFormattingTwoValueOperator) {
    JiraFormattingTwoValueOperator["IsBetween"] = "IS_BETWEEN";
    JiraFormattingTwoValueOperator["IsNotBetween"] = "IS_NOT_BETWEEN";
    return JiraFormattingTwoValueOperator;
}({}); /** The representation for an generic error when the generated JQL was invalid. */  /** WARNING: This type is deprecated and will be removed in the future. DO NOT USE */  /** The global issue create modal view types. */ 
let $78ad46e0d6808149$export$4a2c19fd597ee77f = /*#__PURE__*/ function(JiraGlobalIssueCreateView) {
    JiraGlobalIssueCreateView["FullModal"] = "FULL_MODAL";
    JiraGlobalIssueCreateView["MiniModal"] = "MINI_MODAL";
    return JiraGlobalIssueCreateView;
}({}); /** A global permission in Jira */  /** All the grants given to a global permission */  /** Different Global permissions that the user can have */ 
let $78ad46e0d6808149$export$c30f06fc4059f363 = /*#__PURE__*/ function(JiraGlobalPermissionType) {
    JiraGlobalPermissionType["Administer"] = "ADMINISTER";
    JiraGlobalPermissionType["UserPicker"] = "USER_PICKER";
    return JiraGlobalPermissionType;
}({}); /** Represents a goal in Jira */  /** The connection type for JiraGoal. */  /** An edge in a JiraGoal connection. */ 
let $78ad46e0d6808149$export$6d47154a1de14240 = /*#__PURE__*/ function(JiraGoalStatus) {
    JiraGoalStatus["Archived"] = "ARCHIVED";
    JiraGoalStatus["AtRisk"] = "AT_RISK";
    JiraGoalStatus["Cancelled"] = "CANCELLED";
    JiraGoalStatus["Completed"] = "COMPLETED";
    JiraGoalStatus["Done"] = "DONE";
    JiraGoalStatus["OffTrack"] = "OFF_TRACK";
    JiraGoalStatus["OnTrack"] = "ON_TRACK";
    JiraGoalStatus["Paused"] = "PAUSED";
    JiraGoalStatus["Pending"] = "PENDING";
    return JiraGoalStatus;
}({}); /** Represents the Goals field on a Jira Issue. */  /** Represents the Goals field on a Jira Issue. */  /** A Jira Background which is a gradient type */  /** The unique key of the grant type such as PROJECT_ROLE. */  /**
 * The grant type key enum represents all the possible grant types available in Jira.
 * A grant type may take an optional parameter value.
 * For example: PROJECT_ROLE grant type takes project role id as parameter. And, PROJECT_LEAD grant type do not.
 *
 * The actual ARI formats are documented on the various concrete grant type values.
 */ 
let $78ad46e0d6808149$export$60b5a68a2a59a819 = /*#__PURE__*/ function(JiraGrantTypeKeyEnum) {
    JiraGrantTypeKeyEnum["AnonymousAccess"] = "ANONYMOUS_ACCESS";
    JiraGrantTypeKeyEnum["AnyLoggedinUserApplicationRole"] = "ANY_LOGGEDIN_USER_APPLICATION_ROLE";
    JiraGrantTypeKeyEnum["ApplicationRole"] = "APPLICATION_ROLE";
    JiraGrantTypeKeyEnum["Assignee"] = "ASSIGNEE";
    JiraGrantTypeKeyEnum["Group"] = "GROUP";
    JiraGrantTypeKeyEnum["MultiGroupPicker"] = "MULTI_GROUP_PICKER";
    JiraGrantTypeKeyEnum["MultiUserPicker"] = "MULTI_USER_PICKER";
    JiraGrantTypeKeyEnum["ProjectLead"] = "PROJECT_LEAD";
    JiraGrantTypeKeyEnum["ProjectRole"] = "PROJECT_ROLE";
    JiraGrantTypeKeyEnum["Reporter"] = "REPORTER";
    JiraGrantTypeKeyEnum["ServiceProjectCustomerPortalAccess"] = "SERVICE_PROJECT_CUSTOMER_PORTAL_ACCESS";
    JiraGrantTypeKeyEnum["User"] = "USER";
    return JiraGrantTypeKeyEnum;
}({}); /** The JiraGrantTypeValue union resolves to one of the concrete types such as JiraDefaultGrantTypeValue, JiraProjectRoleGrantTypeValue. */  /** A type to represent one or more paginated list of one or more permission grant values available for a given grant type. */  /** An edge object representing grant type value information used within connection object. */  /** Represents a Jira Group. */  /** The connection type for JiraGroup. */  /** An edge in a JiraGroupConnection connection. */  /** The GROUP grant type value where group data is provided by identity service. */  /** Input for Groups values on fields */  /** The types of Contexts supported by Groups field. */ 
let $78ad46e0d6808149$export$ebb3bfffea31943a = /*#__PURE__*/ function(JiraGroupsContext) {
    JiraGroupsContext["Group"] = "GROUP";
    JiraGroupsContext["User"] = "USER";
    return JiraGroupsContext;
}({}); /** Represents a multiple selected value on a field. */  /** Represents a multiple selected value on a field. */  /** Represent a selectable options that can be selected on an Issue or a field. */  /** Represent a selectable options that can be selected on an Issue or a field. */  /** Represents a single selected value on a field. */  /** The Jira Home Page that a user can be directed to. */  /** The different home page types a user can be directed to. */ 
let $78ad46e0d6808149$export$42ed5df1bdc10783 = /*#__PURE__*/ function(JiraHomePageType) {
    JiraHomePageType["Dashboards"] = "DASHBOARDS";
    JiraHomePageType["LoginRedirect"] = "LOGIN_REDIRECT";
    JiraHomePageType["ProjectsDirectory"] = "PROJECTS_DIRECTORY";
    JiraHomePageType["YourWork"] = "YOUR_WORK";
    return JiraHomePageType;
}({}); /** The JSM incident priority values */ 
let $78ad46e0d6808149$export$f1e981f4a82c46b7 = /*#__PURE__*/ function(JiraIncidentPriority) {
    JiraIncidentPriority["P1"] = "P1";
    JiraIncidentPriority["P2"] = "P2";
    JiraIncidentPriority["P3"] = "P3";
    JiraIncidentPriority["P4"] = "P4";
    JiraIncidentPriority["P5"] = "P5";
    return JiraIncidentPriority;
}({}); /** This is the input argument for initializing the project notification preferences. */  /** The response for the mutation to update the project notification preferences. */  /**
 * DEPRECATED: Banner experiment is no longer active
 *
 * The precondition state of the install-deployments banner for a particular project and user.
 */ 
let $78ad46e0d6808149$export$c8c1ed3f290ea5bf = /*#__PURE__*/ function(JiraInstallDeploymentsBannerPrecondition) {
    JiraInstallDeploymentsBannerPrecondition["DeploymentsEmptyState"] = "DEPLOYMENTS_EMPTY_STATE";
    JiraInstallDeploymentsBannerPrecondition["FeatureNotEnabled"] = "FEATURE_NOT_ENABLED";
    JiraInstallDeploymentsBannerPrecondition["NotAvailable"] = "NOT_AVAILABLE";
    return JiraInstallDeploymentsBannerPrecondition;
}({}); /**
 * The representation for an invalid JQL error.
 * E.g. 'project = TMP' where 'TMP' has been deleted.
 */ 
let $78ad46e0d6808149$export$ca26010eaa3c3804 = /*#__PURE__*/ function(JiraIssueDeploymentEnvironmentState) {
    JiraIssueDeploymentEnvironmentState["Deployed"] = "DEPLOYED";
    JiraIssueDeploymentEnvironmentState["NotDeployed"] = "NOT_DEPLOYED";
    return JiraIssueDeploymentEnvironmentState;
}({}); /** The SCM entities (pullrequest, branches or commits) associated with a Jira issue. */  /** Lists the summaries available for each type of dev info, for a given issue */  /** Aggregates the `count` of entities for a given provider */  /** Error when querying the JiraIssueDevSummary */  /** Basic information on a provider that triggered an error */  /** Container for the Dev Summary of an issue */  /** An edge in a JiraIssue connection. */  /** Indicates an error occurring during submission or execution of an export task. */  /** The types of events published to the onIssueExported subscription. */  /** Input for the onIssueExported subscription. */  /** A Jira issue export task */  /** Indicates a successful completion of a Jira issue export task. */  /** The progress of a Jira issue export task. */  /** Indicates a successful export task submission. */  /**
 * Represents an export task that was terminated due to an error, cancellation, or dead state.
 * The export result would not be available.
 */ 
let $78ad46e0d6808149$export$55363ce84d2e39d7 = /*#__PURE__*/ function(JiraIssueExportType) {
    JiraIssueExportType["CsvAllFields"] = "CSV_ALL_FIELDS";
    JiraIssueExportType["CsvCurrentFields"] = "CSV_CURRENT_FIELDS";
    JiraIssueExportType["CsvWithBomAllFields"] = "CSV_WITH_BOM_ALL_FIELDS";
    JiraIssueExportType["CsvWithBomCurrentFields"] = "CSV_WITH_BOM_CURRENT_FIELDS";
    return JiraIssueExportType;
}({}); /** Represents the common structure across Issue fields. */  /** Represents the configurations associated with an Issue field. */  /** The connection type for JiraIssueField. */  /** An edge in a JiraIssueField connection. */  /**
 * The issue field grant type used to represent field of an issue.
 * Grant types such as ASSIGNEE, REPORTER, MULTI USER PICKER, and MULTI GROUP PICKER use this grant type value.
 */ 
let $78ad46e0d6808149$export$f02f8d5666a4ac9b = /*#__PURE__*/ function(JiraIssueItemLayoutItemLocationRuleType) {
    JiraIssueItemLayoutItemLocationRuleType["Dates"] = "DATES";
    JiraIssueItemLayoutItemLocationRuleType["MultilineText"] = "MULTILINE_TEXT";
    JiraIssueItemLayoutItemLocationRuleType["Other"] = "OTHER";
    JiraIssueItemLayoutItemLocationRuleType["People"] = "PEOPLE";
    JiraIssueItemLayoutItemLocationRuleType["Timetracking"] = "TIMETRACKING";
    return JiraIssueItemLayoutItemLocationRuleType;
}({}); /** Represents a reference to a panel by panel ID, used for laying out panels on an issue. */  /** The system container types that are available for placing items. */ 
let $78ad46e0d6808149$export$697c16cbeca9bb08 = /*#__PURE__*/ function(JiraIssueItemSystemContainerType) {
    JiraIssueItemSystemContainerType["Content"] = "CONTENT";
    JiraIssueItemSystemContainerType["Context"] = "CONTEXT";
    JiraIssueItemSystemContainerType["HiddenItems"] = "HIDDEN_ITEMS";
    JiraIssueItemSystemContainerType["Primary"] = "PRIMARY";
    JiraIssueItemSystemContainerType["Request"] = "REQUEST";
    JiraIssueItemSystemContainerType["RequestPortal"] = "REQUEST_PORTAL";
    JiraIssueItemSystemContainerType["Secondary"] = "SECONDARY";
    return JiraIssueItemSystemContainerType;
}({}); /** Represents a collection of system container types to be fetched by passing in an issue id. */  /** Represents a collection of system container types to be fetched by passing in an issue key and a cloud id. */  /** Represents a collection of items that are held in a tab container. */  /** Represents the items that can be placed in any tab container. */  /** The connection type for `JiraIssueItemTabContainerItem`. */  /** An edge in a `JiraIssueItemTabContainerItem` connection. */  /** This class contains all the possible states an Issue can be in. */ 
let $78ad46e0d6808149$export$be9310abc07a1404 = /*#__PURE__*/ function(JiraIssueLifecycleState) {
    JiraIssueLifecycleState["Active"] = "ACTIVE";
    JiraIssueLifecycleState["Archived"] = "ARCHIVED";
    return JiraIssueLifecycleState;
}({}); /**
 * Represents a single Issue link containing the link id, link type and destination Issue.
 *
 * For Issue create, JiraIssueLink will be populated with
 * the default IssueLink types in the relatedBy field.
 * The issueLinkId and Issue fields will be null.
 *
 * For Issue view, JiraIssueLink will be populated with
 * the Issue link data available on the Issue.
 * The Issue field will contain a nested JiraIssue that is atmost 1 level deep.
 * The nested JiraIssue will not contain fields that can contain further nesting.
 */ 
let $78ad46e0d6808149$export$230ec0d260fcf9aa = /*#__PURE__*/ function(JiraIssueLinkDirection) {
    JiraIssueLinkDirection["Inward"] = "INWARD";
    JiraIssueLinkDirection["Outward"] = "OUTWARD";
    return JiraIssueLinkDirection;
}({}); /** An edge in a JiraIssueLink connection. */  /** Represents linked issues field on a Jira Issue. */  /** Represents linked issues field on a Jira Issue. */  /** Represents linked issues field on a Jira Issue. */  /** Represents linked issues field on a Jira Issue. */  /** Input type for defining the operation on the IssueLink field of a Jira issue. */  /**
 * Represents the issue link type which includes both inwards and outwards relation names
 * For example: blocks, is blocked by, duplicates, is duplicated by, clones, is cloned by.
 */ 
let $78ad46e0d6808149$export$339e1af59c6eefd6 = /*#__PURE__*/ function(JiraIssueNavigatorSearchLayout) {
    JiraIssueNavigatorSearchLayout["Detail"] = "DETAIL";
    JiraIssueNavigatorSearchLayout["List"] = "LIST";
    return JiraIssueNavigatorSearchLayout;
}({}); /** Summary of the Pull Requests attached to the issue */  /** Container for the summary of the Pull Requests attached to the issue */  /** The container of SCM pull requests info associated with a Jira issue. */  /** Represents issue restriction field on an issue for next gen projects. */  /** Represents issue restriction field on an issue for next gen projects. */  /** Represents issue restriction field on an issue for next gen projects. */  /** Summary of the Reviews attached to the issue */  /** Container for the summary of the Reviews attached to the issue */  /** Represents an issue search result when querying with a JiraFilter. */  /** Represents an issue search result when querying with a JiraFilter. */  /** Represents an issue search result when querying with a JiraFilter. */  /** Represents an issue search result when querying with a set of issue ids. */  /** Represents an issue search result when querying with a set of issue ids. */  /** Represents an issue search result when querying with a set of issue ids. */  /** Represents an issue search result when querying with a Jira Query Language (JQL) string. */  /** Represents an issue search result when querying with a Jira Query Language (JQL) string. */  /** Represents an issue search result when querying with a Jira Query Language (JQL) string. */  /**
 * Represents the contextless content for an issue search result in Jira.
 * There is no JiraIssueSearchView associated with this content and is therefore contextless.
 */ 
let $78ad46e0d6808149$export$7ca831dd5735cc4c = /*#__PURE__*/ function(JiraIssueSearchFieldSetSelectedState) {
    JiraIssueSearchFieldSetSelectedState["All"] = "ALL";
    JiraIssueSearchFieldSetSelectedState["NonSelected"] = "NON_SELECTED";
    JiraIssueSearchFieldSetSelectedState["Selected"] = "SELECTED";
    return JiraIssueSearchFieldSetSelectedState;
}({}); /**
 * A filter for the JiraIssueSearchFieldSet connections.
 * By default, if no fieldSetSelectedState is specified, only SELECTED fields are returned.
 */ 
let $78ad46e0d6808149$export$2df7420a9bb23332 = /*#__PURE__*/ function(JiraIssueTransitionCommentType) {
    JiraIssueTransitionCommentType["InternalNote"] = "INTERNAL_NOTE";
    JiraIssueTransitionCommentType["ReplyToCustomer"] = "REPLY_TO_CUSTOMER";
    return JiraIssueTransitionCommentType;
}({}); /** Input type for field level inputs, which may be required to perform a transition for the issue */  /** Enum representing different types of messages to be shown on modal load screen */ 
let $78ad46e0d6808149$export$dafe05b7c43936e0 = /*#__PURE__*/ function(JiraIssueTransitionLayoutMessageType) {
    JiraIssueTransitionLayoutMessageType["Error"] = "ERROR";
    JiraIssueTransitionLayoutMessageType["Info"] = "INFO";
    JiraIssueTransitionLayoutMessageType["Success"] = "SUCCESS";
    JiraIssueTransitionLayoutMessageType["Warn"] = "WARN";
    return JiraIssueTransitionLayoutMessageType;
}({}); /** Represents the messages to be shown on the Transition Modal Load screen */  /** Represents the issue transition modal load screen */  /** The type for response payload, to be returned after making a transition for the issue */  /** Represents an Issue type, e.g. story, task, bug. */  /** The connection type for JiraIssueType. */  /** An edge in a JiraCommentConnection connection. */  /** Represents an issue type field on a Jira Issue. */  /** Represents an issue type field on a Jira Issue. */  /** Represents an issue type field on a Jira Issue. */  /** Input type for defining the operation on the IssueType field of a Jira issue. */  /** The payload type returned after updating the IssueType field of a Jira issue. */  /** Return only issue types that match this filter */  /**
 * The Jira IssueType hierarchy level.
 * Hierarchy levels represent Issue parent-child relationships using an integer scale.
 */ 
let $78ad46e0d6808149$export$8aef47d2eef7b927 = /*#__PURE__*/ function(JiraIssueViewActivityFeedSortOrder) {
    JiraIssueViewActivityFeedSortOrder["NewestFirst"] = "NEWEST_FIRST";
    JiraIssueViewActivityFeedSortOrder["OldestFirst"] = "OLDEST_FIRST";
    return JiraIssueViewActivityFeedSortOrder;
}({}); /** The options for the selected attachment view. */ 
let $78ad46e0d6808149$export$db6a595e3239346 = /*#__PURE__*/ function(JiraIssueViewAttachmentPanelViewMode) {
    JiraIssueViewAttachmentPanelViewMode["ListView"] = "LIST_VIEW";
    JiraIssueViewAttachmentPanelViewMode["StripView"] = "STRIP_VIEW";
    return JiraIssueViewAttachmentPanelViewMode;
}({}); /** The options for displaying timestamps. */ 
let $78ad46e0d6808149$export$c5dd6014d53eac27 = /*#__PURE__*/ function(JiraIssueViewTimestampDisplayMode) {
    JiraIssueViewTimestampDisplayMode["Absolute"] = "ABSOLUTE";
    JiraIssueViewTimestampDisplayMode["Relative"] = "RELATIVE";
    return JiraIssueViewTimestampDisplayMode;
}({});
let $78ad46e0d6808149$export$ab2f34f07eb5e4b6 = /*#__PURE__*/ function(JiraIteration) {
    JiraIteration["Iteration_1"] = "ITERATION_1";
    JiraIteration["Iteration_2"] = "ITERATION_2";
    JiraIteration["IterationDynamic"] = "ITERATION_DYNAMIC";
    return JiraIteration;
}({}); /** The options for jql builder search mode. */ 
let $78ad46e0d6808149$export$3b5b236cf36c7f9a = /*#__PURE__*/ function(JiraJqlBuilderSearchMode) {
    JiraJqlBuilderSearchMode["Advanced"] = "ADVANCED";
    JiraJqlBuilderSearchMode["Basic"] = "BASIC";
    return JiraJqlBuilderSearchMode;
}({}); /** The representation for Natural Language to JQL generation response */  /** The possible errors that can occur during a JQL generation. */  /** JQL History Node. Includes the jql. */  /** The connection to a list of JQL History. */  /** An edge in a JQL History connection. */  /**
 * The autocomplete types available for Jira fields in the context of the Jira Query Language.
 *
 * This enum also describes which fields have field-value support from this schema.
 */ 
let $78ad46e0d6808149$export$fd281481162cf736 = /*#__PURE__*/ function(JiraJqlAutocompleteType) {
    JiraJqlAutocompleteType["Basic"] = "BASIC";
    JiraJqlAutocompleteType["Cascadingoption"] = "CASCADINGOPTION";
    JiraJqlAutocompleteType["Component"] = "COMPONENT";
    JiraJqlAutocompleteType["Group"] = "GROUP";
    JiraJqlAutocompleteType["Issue"] = "ISSUE";
    JiraJqlAutocompleteType["Issuetype"] = "ISSUETYPE";
    JiraJqlAutocompleteType["JwmCategory"] = "JWM_CATEGORY";
    JiraJqlAutocompleteType["Labels"] = "LABELS";
    JiraJqlAutocompleteType["None"] = "NONE";
    JiraJqlAutocompleteType["Option"] = "OPTION";
    JiraJqlAutocompleteType["Organization"] = "ORGANIZATION";
    JiraJqlAutocompleteType["Priority"] = "PRIORITY";
    JiraJqlAutocompleteType["Project"] = "PROJECT";
    JiraJqlAutocompleteType["Requesttype"] = "REQUESTTYPE";
    JiraJqlAutocompleteType["Resolution"] = "RESOLUTION";
    JiraJqlAutocompleteType["Sprint"] = "SPRINT";
    JiraJqlAutocompleteType["Status"] = "STATUS";
    JiraJqlAutocompleteType["Statuscategory"] = "STATUSCATEGORY";
    JiraJqlAutocompleteType["TicketCategory"] = "TICKET_CATEGORY";
    JiraJqlAutocompleteType["User"] = "USER";
    JiraJqlAutocompleteType["Version"] = "VERSION";
    return JiraJqlAutocompleteType;
}({}); /**
 * Encapsulates queries and fields necessary to power the JQL builder.
 *
 * It also exposes generic JQL capabilities that can be leveraged to power other experiences.
 */ 
let $78ad46e0d6808149$export$4b728896d4330036 = /*#__PURE__*/ function(JiraJqlBuilderMode) {
    JiraJqlBuilderMode["Basic"] = "BASIC";
    JiraJqlBuilderMode["Jql"] = "JQL";
    return JiraJqlBuilderMode;
}({}); /** Represents a field-value for a JQL cascading option field. */  /** Represents a connection of field-values for a JQL cascading option field. */  /** Represents a field-value edge for a JQL cascading option field. */  /** The types of JQL clauses supported by Jira. */ 
let $78ad46e0d6808149$export$cbea312143ae44f9 = /*#__PURE__*/ function(JiraJqlClauseType) {
    JiraJqlClauseType["Any"] = "ANY";
    JiraJqlClauseType["OrderBy"] = "ORDER_BY";
    JiraJqlClauseType["Where"] = "WHERE";
    return JiraJqlClauseType;
}({}); /** Represents a field-value for a JQL component field. */  /** The representation of a Jira field within the context of the Jira Query Language. */  /** Represents a connection of Jira JQL fields. */  /** A union of a Jira JQL field connection and a GraphQL query error. */  /** Represents a Jira JQL field edge. */  /**
 * The representation of a Jira JQL field-type in the context of the Jira Query Language.
 *
 * E.g. `Short Text`, `Number`, `Version Picker`, `Team` etc.
 *
 * Important note: This information only exists for collapsed fields.
 */ 
let $78ad46e0d6808149$export$c4f30303e8f1794 = /*#__PURE__*/ function(JiraJqlFunctionStatus) {
    JiraJqlFunctionStatus["Finished"] = "FINISHED";
    JiraJqlFunctionStatus["Processing"] = "PROCESSING";
    JiraJqlFunctionStatus["Unknown"] = "UNKNOWN";
    return JiraJqlFunctionStatus;
}({}); /** Represents a field-value for a JQL goals field. */  /** Represents a field-value for a JQL group field. */  /** Represents a connection of field-values for a JQL group field. */  /** Represents a field-value edge for a JQL group field. */  /** Represents a JQL query with hydrated fields and field-values. */  /** A union of a Jira JQL hydrated query and a GraphQL query error. */  /** Represents a field-value for a JQL Issue field. */  /** Represents a field-value for a JQL issue type field. */  /** Represents a connection of field-values for a JQL issue type field. */  /** Represents a field-value edge for a JQL issue type field. */  /** A variation of the fieldValues query for retrieving specifically Jira issue type field-values. */  /** A variation of the fieldValues query for retrieving specifically Jira issue type field-values. */  /** A variation of the fieldValues query for retrieving specifically Jira issue type field-values. */  /** A variation of the fieldValues query for retrieving specifically Jira issue type field-values. */  /** Represents a field-value for a JQL label field. */  /**
 * The types of JQL operators supported by Jira.
 *
 * An operator in JQL is one or more symbols or words,which compares the value of a field on its left with one or more values (or functions) on its right,
 * such that only true results are retrieved by the clause.
 *
 * For more information on JQL operators please visit: https://support.atlassian.com/jira-software-cloud/docs/advanced-search-reference-jql-operators.
 */ 
let $78ad46e0d6808149$export$d3fe59ef06ef4fb4 = /*#__PURE__*/ function(JiraJqlOperator) {
    JiraJqlOperator["Changed"] = "CHANGED";
    JiraJqlOperator["Contains"] = "CONTAINS";
    JiraJqlOperator["Equals"] = "EQUALS";
    JiraJqlOperator["GreaterThan"] = "GREATER_THAN";
    JiraJqlOperator["GreaterThanOrEqual"] = "GREATER_THAN_OR_EQUAL";
    JiraJqlOperator["In"] = "IN";
    JiraJqlOperator["Is"] = "IS";
    JiraJqlOperator["IsNot"] = "IS_NOT";
    JiraJqlOperator["LessThan"] = "LESS_THAN";
    JiraJqlOperator["LessThanOrEqual"] = "LESS_THAN_OR_EQUAL";
    JiraJqlOperator["NotContains"] = "NOT_CONTAINS";
    JiraJqlOperator["NotEquals"] = "NOT_EQUALS";
    JiraJqlOperator["NotIn"] = "NOT_IN";
    JiraJqlOperator["Was"] = "WAS";
    JiraJqlOperator["WasIn"] = "WAS_IN";
    JiraJqlOperator["WasNot"] = "WAS_NOT";
    JiraJqlOperator["WasNotIn"] = "WAS_NOT_IN";
    return JiraJqlOperator;
}({}); /** Represents a field-value for a JQL option field. */  /** Represents a connection of field-values for a JQL option field. */  /** Represents a field-value edge for a JQL option field. */  /** Represents a field-value for a JQL plain text field (as opposed to a rich text one) such as summary. */  /** Represents a field-value for a JQL priority field. */  /** Represents a field-value for a JQL project field. */  /** Represents a connection of field-values for a JQL project field. */  /** Represents a field-value edge for a JQL project field. */  /** Represents an error for a JQL query hydration. */  /** Represents a hydrated field for a JQL query. */  /** A union of a JQL query hydrated field and a GraphQL query error. */  /** Represents a hydrated field-value for a given field in the JQL query. */  /** A union of a JQL query hydrated field-value and a GraphQL query error. */  /** Represents a field-value for a JQL resolution field. */  /** The representation of a Jira field in the basic search mode of the JQL builder. */  /** Represents a field-value for a JQL sprint field. */  /** Represents a connection of field-values for a JQL sprint field. */  /** Represents a field-value edge for a JQL sprint field. */  /** Represents a field-value for a JQL status category field. */  /** Represents a field-value for a JQL status field. */ 
let $78ad46e0d6808149$export$b4868a7397b1d1a3 = /*#__PURE__*/ function(JiraJqlSyntaxError) {
    JiraJqlSyntaxError["BadFieldId"] = "BAD_FIELD_ID";
    JiraJqlSyntaxError["BadFunctionArgument"] = "BAD_FUNCTION_ARGUMENT";
    JiraJqlSyntaxError["BadOperator"] = "BAD_OPERATOR";
    JiraJqlSyntaxError["BadPropertyId"] = "BAD_PROPERTY_ID";
    JiraJqlSyntaxError["EmptyField"] = "EMPTY_FIELD";
    JiraJqlSyntaxError["EmptyFunction"] = "EMPTY_FUNCTION";
    JiraJqlSyntaxError["EmptyFunctionArgument"] = "EMPTY_FUNCTION_ARGUMENT";
    JiraJqlSyntaxError["IllegalCharacter"] = "ILLEGAL_CHARACTER";
    JiraJqlSyntaxError["IllegalEscape"] = "ILLEGAL_ESCAPE";
    JiraJqlSyntaxError["IllegalNumber"] = "ILLEGAL_NUMBER";
    JiraJqlSyntaxError["MissingFieldName"] = "MISSING_FIELD_NAME";
    JiraJqlSyntaxError["MissingLogicalOperator"] = "MISSING_LOGICAL_OPERATOR";
    JiraJqlSyntaxError["NoOperator"] = "NO_OPERATOR";
    JiraJqlSyntaxError["NoOrder"] = "NO_ORDER";
    JiraJqlSyntaxError["OperandUnsupported"] = "OPERAND_UNSUPPORTED";
    JiraJqlSyntaxError["PredicateUnsupported"] = "PREDICATE_UNSUPPORTED";
    JiraJqlSyntaxError["ReservedCharacter"] = "RESERVED_CHARACTER";
    JiraJqlSyntaxError["ReservedWord"] = "RESERVED_WORD";
    JiraJqlSyntaxError["UnexpectedText"] = "UNEXPECTED_TEXT";
    JiraJqlSyntaxError["UnfinishedString"] = "UNFINISHED_STRING";
    JiraJqlSyntaxError["Unknown"] = "UNKNOWN";
    return JiraJqlSyntaxError;
}({}); /** Represents a field-value for a JQL user field. */  /** Represents a connection of field-values for a JQL user field. */  /** Represents a field-value edge for a JQL user field. */  /** Represents a field-value for a JQL version field. */  /** Represents a connection of field-values for a JQL version field. */  /** Represents a field-value edge for a JQL version field. */  /**
 * A variation of the fieldValues query for retrieving specifically Jira version field-values.
 *
 * This type provides the capability to retrieve connections of released, unreleased and archived versions.
 *
 * Important note: that released and unreleased versions can be archived and vice versa.
 */ 
let $78ad46e0d6808149$export$586b6450ae834916 = /*#__PURE__*/ function(JiraJqlViewContext) {
    JiraJqlViewContext["JswPlans"] = "JSW_PLANS";
    JiraJqlViewContext["Jwm"] = "JWM";
    JiraJqlViewContext["ShadowRequest"] = "SHADOW_REQUEST";
    return JiraJqlViewContext;
}({}); /** Represents the label of a custom label field. */  /** The connection type for JiraLabel. */  /** An edge in a Jiralabel connection. */  /** Represents a labels field on a Jira Issue. Both system & custom field can be represented by this type. */  /** Represents a labels field on a Jira Issue. Both system & custom field can be represented by this type. */  /** Represents a labels field on a Jira Issue. Both system & custom field can be represented by this type. */  /** Input type for labels field */  /** Represents the data of a single Label */  /** Input type for defining the operation on the Team field of a Jira issue. */  /** The payload type returned after updating the Team field of a Jira issue. */  /** Input to link/unlink an issue to/from a related work item. */  /** The return payload for linking and unlinking an issue to and from a related work item. */ 
let $78ad46e0d6808149$export$29e67496c83af6d9 = /*#__PURE__*/ function(JiraLinkIssuesToIncidentIssueLinkTypeName) {
    JiraLinkIssuesToIncidentIssueLinkTypeName["PostIncidentReviews"] = "POST_INCIDENT_REVIEWS";
    JiraLinkIssuesToIncidentIssueLinkTypeName["Relates"] = "RELATES";
    return JiraLinkIssuesToIncidentIssueLinkTypeName;
}({}); /** Represents the current state of a long running task. */ 
let $78ad46e0d6808149$export$aad956212e1cffd3 = /*#__PURE__*/ function(JiraLongRunningTaskStatus) {
    JiraLongRunningTaskStatus["Cancelled"] = "CANCELLED";
    JiraLongRunningTaskStatus["CancelRequested"] = "CANCEL_REQUESTED";
    JiraLongRunningTaskStatus["Complete"] = "COMPLETE";
    JiraLongRunningTaskStatus["Dead"] = "DEAD";
    JiraLongRunningTaskStatus["Enqueued"] = "ENQUEUED";
    JiraLongRunningTaskStatus["Failed"] = "FAILED";
    JiraLongRunningTaskStatus["Running"] = "RUNNING";
    return JiraLongRunningTaskStatus;
}({}); /** Description of a single file attachment definition. */  /** A connection for JiraMediaAttachmentFile. */  /** An edge in a JiraMediaAttachmentFile connection. */  /** A Jira Background Media, containing a reference to a custom background */  /** Represents a media context used for file uploads. */  /** Contains the information needed for reading uploaded media content in jira on issue create/view screens. */  /** Contains the information needed for reading uploaded media content in jira on issue create/view screens. */  /** Entry of an attachment read token with its respective files accessible. */  /** Entry of an attachment read token with its respective files accessible. */  /** A connection for JiraMediaTokenWithFiles. */  /** An edge in a JiraMediaTokenWithFiles connection. */  /** Contains the information needed for uploading a media content in jira on issue create/view screens. */  /** Contains either the successful fetched media token information or an error. */  /**
 * The input to merge one version with another, which deletes the source version and moves
 * all issues from the source version to the target version.
 */ 
let $78ad46e0d6808149$export$283b57df1581f83e = /*#__PURE__*/ function(JiraMultiValueFieldOperations) {
    JiraMultiValueFieldOperations["Add"] = "ADD";
    JiraMultiValueFieldOperations["Remove"] = "REMOVE";
    JiraMultiValueFieldOperations["Set"] = "SET";
    return JiraMultiValueFieldOperations;
}({}); /** Represents a multiple group picker field on a Jira Issue. */  /** Represents a multiple group picker field on a Jira Issue. */  /** Represents a multiple group picker field on a Jira Issue. */  /** Input type for multiple group picker field */  /** Input type for defining the operation on the MultipleGroupPicker field of a Jira issue. */  /** The payload type returned after updating the MultipleGroupPicker field of a Jira issue. */  /** Input type for multiple select clearable user picker fields */  /** Represents the multi-select field on a Jira Issue. */  /** Represents the multi-select field on a Jira Issue. */  /** Represents the multi-select field on a Jira Issue. */  /** Represents the multi-select field on a Jira Issue. */  /** Represents the multi-select field on a Jira Issue. */  /** Input type for multi select field */  /** Represents a multi select user picker field on a Jira Issue. E.g. custom user picker */  /** Represents a multi select user picker field on a Jira Issue. E.g. custom user picker */  /** Represents a multi select user picker field on a Jira Issue. E.g. custom user picker */  /** Input type for multiple select user picker fields */  /** Input type for defining the operation on MultipleSelectUserPicker field of a Jira issue. */  /** The payload type returned after updating MultipleSelectUserPicker field of a Jira issue. */  /** Represents a multi version picker field on a Jira Issue. E.g. fixVersions and multi version custom field. */  /** Represents a multi version picker field on a Jira Issue. E.g. fixVersions and multi version custom field. */  /** Represents a multi version picker field on a Jira Issue. E.g. fixVersions and multi version custom field. */  /** Represents a multi version picker field on a Jira Issue. E.g. fixVersions and multi version custom field. */  /** Represents a multi version picker field on a Jira Issue. E.g. fixVersions and multi version custom field. */  /** Input type for multiple select version picker fields */  /** Input type for defining the operation on Multiple Version Picker field of a Jira issue. */  /** The payload type returned after updating Multiple Version Picker field of a Jira issue. */  /** The input used for an natural language to JQL conversion */  /** The most general interface for a navigation item. Represents pages a user can navigate to within a scope. */  /** The connection type for navigation items. */  /** The edge type for navigation items. */  /** GraphQL does not allow interfaces inside unions, need to list every implementation explicitly. */  /** General interface to represent a type of navigation item, identified by its `JiraNavigationItemTypeKey`. */  /** Connection of navigation item types. */  /** The edge type for navigation item types. */  /**
 * List of values identifying the known navigation item types. This list is shared between
 * business and software projects but only some are supported by one or the other.
 */ 
let $78ad46e0d6808149$export$36f79c8a08b4e752 = /*#__PURE__*/ function(JiraNavigationItemTypeKey) {
    JiraNavigationItemTypeKey["App"] = "APP";
    JiraNavigationItemTypeKey["Approvals"] = "APPROVALS";
    JiraNavigationItemTypeKey["Apps"] = "APPS";
    JiraNavigationItemTypeKey["ArchivedIssues"] = "ARCHIVED_ISSUES";
    JiraNavigationItemTypeKey["Attachments"] = "ATTACHMENTS";
    JiraNavigationItemTypeKey["Backlog"] = "BACKLOG";
    JiraNavigationItemTypeKey["Board"] = "BOARD";
    JiraNavigationItemTypeKey["Calendar"] = "CALENDAR";
    JiraNavigationItemTypeKey["Code"] = "CODE";
    JiraNavigationItemTypeKey["Components"] = "COMPONENTS";
    JiraNavigationItemTypeKey["Deployments"] = "DEPLOYMENTS";
    JiraNavigationItemTypeKey["Development"] = "DEVELOPMENT";
    JiraNavigationItemTypeKey["Forms"] = "FORMS";
    JiraNavigationItemTypeKey["Goals"] = "GOALS";
    JiraNavigationItemTypeKey["Incidents"] = "INCIDENTS";
    JiraNavigationItemTypeKey["Issues"] = "ISSUES";
    JiraNavigationItemTypeKey["List"] = "LIST";
    JiraNavigationItemTypeKey["OnCall"] = "ON_CALL";
    JiraNavigationItemTypeKey["Pages"] = "PAGES";
    JiraNavigationItemTypeKey["Releases"] = "RELEASES";
    JiraNavigationItemTypeKey["Reports"] = "REPORTS";
    JiraNavigationItemTypeKey["Requests"] = "REQUESTS";
    JiraNavigationItemTypeKey["Security"] = "SECURITY";
    JiraNavigationItemTypeKey["Shortcut"] = "SHORTCUT";
    JiraNavigationItemTypeKey["Shortcuts"] = "SHORTCUTS";
    JiraNavigationItemTypeKey["Summary"] = "SUMMARY";
    JiraNavigationItemTypeKey["Timeline"] = "TIMELINE";
    return JiraNavigationItemTypeKey;
}({}); /** The navigation UI state of the left sidebar and right panels user property */  /** The navigation UI state of the left sidebar and right panels user property */  /** Represents the possible notification categories for notification types. */ 
let $78ad46e0d6808149$export$b4137b99365f6ad8 = /*#__PURE__*/ function(JiraNotificationCategoryType) {
    JiraNotificationCategoryType["CommentChanges"] = "COMMENT_CHANGES";
    JiraNotificationCategoryType["IssueAssigned"] = "ISSUE_ASSIGNED";
    JiraNotificationCategoryType["IssueChanges"] = "ISSUE_CHANGES";
    JiraNotificationCategoryType["IssueMentioned"] = "ISSUE_MENTIONED";
    JiraNotificationCategoryType["IssueMiscellaneous"] = "ISSUE_MISCELLANEOUS";
    JiraNotificationCategoryType["IssueWorklogChanges"] = "ISSUE_WORKLOG_CHANGES";
    return JiraNotificationCategoryType;
}({}); /** Represents a preference for a particular notification channel. */  /** Represents the possible types notification channels. */ 
let $78ad46e0d6808149$export$ec1ac0705bb7ee00 = /*#__PURE__*/ function(JiraNotificationChannelType) {
    JiraNotificationChannelType["Email"] = "EMAIL";
    JiraNotificationChannelType["InProduct"] = "IN_PRODUCT";
    JiraNotificationChannelType["MobilePush"] = "MOBILE_PUSH";
    return JiraNotificationChannelType;
}({}); /** Represents notification preferences across all projects. */  /** Represents options for notifications that don't fit in with the recipient calculation oriented preferences in JiraNotificationPreferences. */  /** Represents a notification preference for a particular notification type. */  /** Represents a notification preferences to be updated. */  /** Represents notification preferences by notification type. */  /** The connection type for JiraNotificationProjectPreferences. */  /** Represents a project's notification preferences. */  /** Represents the possible types of notifications. */ 
let $78ad46e0d6808149$export$6e621da855f29918 = /*#__PURE__*/ function(JiraNotificationType) {
    JiraNotificationType["CommentCreated"] = "COMMENT_CREATED";
    JiraNotificationType["CommentDeleted"] = "COMMENT_DELETED";
    JiraNotificationType["CommentEdited"] = "COMMENT_EDITED";
    JiraNotificationType["IssueAssigned"] = "ISSUE_ASSIGNED";
    JiraNotificationType["IssueCreated"] = "ISSUE_CREATED";
    JiraNotificationType["IssueDeleted"] = "ISSUE_DELETED";
    JiraNotificationType["IssueMoved"] = "ISSUE_MOVED";
    JiraNotificationType["IssueUpdated"] = "ISSUE_UPDATED";
    JiraNotificationType["MentionsCombined"] = "MENTIONS_COMBINED";
    JiraNotificationType["MiscellaneousIssueEventCombined"] = "MISCELLANEOUS_ISSUE_EVENT_COMBINED";
    JiraNotificationType["WorklogCombined"] = "WORKLOG_COMBINED";
    return JiraNotificationType;
}({}); /** Represents a number field on a Jira Issue. E.g. float, story points. */  /** Input type for a number field */  /** An OAuth app which may have permissions to push/read extension data from issues */  /** Mutations */  /** An oauth app which provides devOps capabilities. */  /** The types of events published by the onSuggestedChildIssue subscription. */  /** Represents Jira OpsgenieTeam. */  /** Represents a single option value in a select operation. */  /** The connection type for JiraOption. */  /** An edge in a JiraOption connection. */  /** The input type for opting out of the Not Connected state in the DevOpsPanel */  /** The response payload for opting out of the Not Connected state in the DevOpsPanel */  /** Response for the order formatting rule mutation. */  /** Response for the order formatting rule mutation. */ 
let $78ad46e0d6808149$export$59148652a7cacd91 = /*#__PURE__*/ function(JiraOrganizationApprovalLocation) {
    JiraOrganizationApprovalLocation["DuringInstallationFlow"] = "DURING_INSTALLATION_FLOW";
    JiraOrganizationApprovalLocation["DuringProvisioning"] = "DURING_PROVISIONING";
    JiraOrganizationApprovalLocation["OnAdminScreen"] = "ON_ADMIN_SCREEN";
    JiraOrganizationApprovalLocation["RemindBitbucketApprovalBanner"] = "REMIND_BITBUCKET_APPROVAL_BANNER";
    JiraOrganizationApprovalLocation["Unknown"] = "UNKNOWN";
    return JiraOrganizationApprovalLocation;
}({}); /** Input type for an organization field */  /** Input type for an organization value */  /**
 * Represents the original time estimate field on Jira issue screens. Note that this is the same value as the originalEstimate from JiraTimeTrackingField
 * This field should only be used on issue view because issue view hasn't deprecated the original estimation as a standalone field
 */ 
let $78ad46e0d6808149$export$22ca33290808aca8 = /*#__PURE__*/ function(JiraOverviewPlanMigrationChangeboardingStatus) {
    JiraOverviewPlanMigrationChangeboardingStatus["Completed"] = "COMPLETED";
    JiraOverviewPlanMigrationChangeboardingStatus["Triggered"] = "TRIGGERED";
    return JiraOverviewPlanMigrationChangeboardingStatus;
}({}); /** Describe the state of the overview-plan migration for the calling user. */  /** Result type for the jwmOverviewPlanMigrationState field */  /** The base type cursor data necessary for random access pagination. */  /** This encapsulates all the necessary cursors for random access pagination. */  /** Input type for the parent field of an issue */  /** Input type for defining the operation on the Parent field of a Jira issue. */  /** The payload type returned after updating the Parent field of a Jira issue. */  /** Represents Parent field on a Jira Issue. E.g. JSW Parent, JPO Parent (to be unified). */  /** Represents Parent field on a Jira Issue. E.g. JSW Parent, JPO Parent (to be unified). */  /** The connection type for JiraParentOption. */  /** An edge in a JiraParentOption connection. */  /** Represents flags required to determine parent field visibility */  /** Represents a people picker field on a Jira Issue. */  /** Represents a people picker field on a Jira Issue. */  /** Represents a people picker field on a Jira Issue. */  /** Input type for people field */  /** Input type for defining the operation on People field of a Jira issue. */  /** The payload type returned after updating People field of a Jira issue. */  /**
 * This represents Jira Permission with all Permission level details (To be added)
 * and can be used to determine whether a User has certain permissions.
 * Note: This entity only returns `hasPermission`
 * but in future, it should contain more permission level details like ID, description etc.
 */ 
let $78ad46e0d6808149$export$edf2fc589cbdc = /*#__PURE__*/ function(JiraPermissionMessageTypeEnum) {
    JiraPermissionMessageTypeEnum["Information"] = "INFORMATION";
    JiraPermissionMessageTypeEnum["Warning"] = "WARNING";
    return JiraPermissionMessageTypeEnum;
}({}); /** A permission scheme is a collection of permission grants. */  /** The input type to add new permission grants to the given permission scheme. */  /** The response payload for add permission grants mutation operation for a given permission scheme. */  /** The JiraPermissionSchemeConfiguration represents additional configuration information regarding the permission scheme such as its editability. */  /**
 * The JiraPermissionSchemeGrantGroup is an association between project permission category information and a bounded list of one or more
 * associated permission grant holder. A grant holder represents project permission information and its associated permission grants.
 */ 
let $78ad46e0d6808149$export$a7ab8f3606c74f1 = /*#__PURE__*/ function(JiraPermissionTagEnum) {
    JiraPermissionTagEnum["Deprecated"] = "DEPRECATED";
    JiraPermissionTagEnum["Enterprise"] = "ENTERPRISE";
    JiraPermissionTagEnum["New"] = "NEW";
    return JiraPermissionTagEnum;
}({}); /** The different permission types that a user can perform on a global level */ 
let $78ad46e0d6808149$export$b91894fc36442fca = /*#__PURE__*/ function(JiraPermissionType) {
    JiraPermissionType["BrowseProjects"] = "BROWSE_PROJECTS";
    JiraPermissionType["BulkChange"] = "BULK_CHANGE";
    return JiraPermissionType;
}({}); /** Represents a Jira Plan */  /** The status of a Jira Plan */ 
let $78ad46e0d6808149$export$39bfd317df87a9c = /*#__PURE__*/ function(JiraPlanStatus) {
    JiraPlanStatus["Active"] = "ACTIVE";
    JiraPlanStatus["Archived"] = "ARCHIVED";
    JiraPlanStatus["Trashed"] = "TRASHED";
    return JiraPlanStatus;
}({}); /** Represents a Jira platform attachment. */  /** Represents a Jira platform attachment. */  /** Represents a Jira platform attachment. */  /** Represents a Jira platform attachment. */  /** Represents a Jira platform comment. */  /** A link to a post-incident review (also known as a postmortem). */  /** Represents an issue's priority field */  /** The connection type for JiraPriority. */  /** An edge in a JiraPriority connection. */  /** Represents a priority field on a Jira Issue. */  /** Represents a priority field on a Jira Issue. */  /** Input type for priority field */  /** Representation of each Jira product offering. */ 
let $78ad46e0d6808149$export$62abc5008715ef4b = /*#__PURE__*/ function(JiraProductEnum) {
    JiraProductEnum["JiraProductDiscovery"] = "JIRA_PRODUCT_DISCOVERY";
    JiraProductEnum["JiraServiceManagement"] = "JIRA_SERVICE_MANAGEMENT";
    JiraProductEnum["JiraSoftware"] = "JIRA_SOFTWARE";
    JiraProductEnum["JiraWorkManagement"] = "JIRA_WORK_MANAGEMENT";
    return JiraProductEnum;
}({}); /** Represents proforma-forms. */  /** Represents the proforma-forms field for an Issue. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents whether the user has the specific project permission or not */  /** The different action types that a user can perform on a project */ 
let $78ad46e0d6808149$export$456e2c6faf3dd3d9 = /*#__PURE__*/ function(JiraProjectActionType) {
    JiraProjectActionType["CreateIssues"] = "CREATE_ISSUES";
    JiraProjectActionType["DeleteIssues"] = "DELETE_ISSUES";
    JiraProjectActionType["EditIssues"] = "EDIT_ISSUES";
    JiraProjectActionType["EditProjectConfig"] = "EDIT_PROJECT_CONFIG";
    JiraProjectActionType["LinkIssues"] = "LINK_ISSUES";
    JiraProjectActionType["ScheduleIssues"] = "SCHEDULE_ISSUES";
    JiraProjectActionType["TransitionIssues"] = "TRANSITION_ISSUES";
    JiraProjectActionType["ViewIssues"] = "VIEW_ISSUES";
    JiraProjectActionType["ViewProjectConfig"] = "VIEW_PROJECT_CONFIG";
    return JiraProjectActionType;
}({}); /** A relationship between a Jira Project and Opsgenie Team */  /** A relationship between a Jira Project and Opsgenie Team */  /** A relationship between a Jira project and a repository (Bitbucket or third party). */  /** A relationship between a Jira project and a repository (Bitbucket or third party). */  /** The connection object for a collection of Jira project and repository relationships. */  /** #################### Filtering and Sorting Inputs ##################### */  /** #################### Enums ##################### */ 
let $78ad46e0d6808149$export$6867a13128bb4266 = /*#__PURE__*/ function(JiraProjectAndRepositoryRelationshipSortBy) {
    JiraProjectAndRepositoryRelationshipSortBy["LastInferredAt"] = "LAST_INFERRED_AT";
    return JiraProjectAndRepositoryRelationshipSortBy;
}({}); /** An entry in the activity log table for project role actors. */  /** Connection type for JiraProjectCleanupLogTableEntry. */  /** An edge in a JiraProjectCleanupLogTableEntryConnection. */  /** Project cleanup recommendation. */  /** Recommendation action for a project cleanup. */ 
let $78ad46e0d6808149$export$a2f8423691ae525a = /*#__PURE__*/ function(JiraProjectCleanupRecommendationAction) {
    JiraProjectCleanupRecommendationAction["Archive"] = "ARCHIVE";
    JiraProjectCleanupRecommendationAction["Trash"] = "TRASH";
    return JiraProjectCleanupRecommendationAction;
}({}); /** Connection type for JiraProjectCleanupRecommendation. */  /** An edge in a JiraProjectCleanupRecommendation connection. */  /** A period of time since the project was found stale. */ 
let $78ad46e0d6808149$export$9c0ded90f678acb6 = /*#__PURE__*/ function(JiraProjectCleanupRecommendationStaleSince) {
    JiraProjectCleanupRecommendationStaleSince["OneYear"] = "ONE_YEAR";
    JiraProjectCleanupRecommendationStaleSince["SixMonths"] = "SIX_MONTHS";
    JiraProjectCleanupRecommendationStaleSince["TwoYears"] = "TWO_YEARS";
    return JiraProjectCleanupRecommendationStaleSince;
}({}); /** The status of the project cleanup task. */ 
let $78ad46e0d6808149$export$b2cfde8b20600ddf = /*#__PURE__*/ function(JiraProjectCleanupTaskStatusType) {
    JiraProjectCleanupTaskStatusType["Complete"] = "COMPLETE";
    JiraProjectCleanupTaskStatusType["Error"] = "ERROR";
    JiraProjectCleanupTaskStatusType["InProgress"] = "IN_PROGRESS";
    JiraProjectCleanupTaskStatusType["Pending"] = "PENDING";
    JiraProjectCleanupTaskStatusType["TerminalError"] = "TERMINAL_ERROR";
    return JiraProjectCleanupTaskStatusType;
}({}); /** The connection type for JiraProject. */  /**
 * String formats for DateTime in JiraProject, the format is in the value of the jira.date.time.picker.java.format property
 * Please refer to the "Change date and time formats" section of the "Configure the look and feel of Jira applications" page
 * https://support.atlassian.com/jira-cloud-administration/docs/configure-the-look-and-feel-of-jira-applications/
 */ 
let $78ad46e0d6808149$export$8e4f09e2e6362630 = /*#__PURE__*/ function(JiraProjectDateTimeFormat) {
    JiraProjectDateTimeFormat["CompleteDatetimeFormat"] = "COMPLETE_DATETIME_FORMAT";
    JiraProjectDateTimeFormat["DayFormat"] = "DAY_FORMAT";
    JiraProjectDateTimeFormat["DayMonthYearFormat"] = "DAY_MONTH_YEAR_FORMAT";
    JiraProjectDateTimeFormat["Relative"] = "RELATIVE";
    JiraProjectDateTimeFormat["TimeFormat"] = "TIME_FORMAT";
    return JiraProjectDateTimeFormat;
}({}); /** An edge in a JiraProject connection. */  /**
 * Represents a project field on a Jira Issue.
 * Both the system & custom project field can be represented by this type.
 */ 
let $78ad46e0d6808149$export$341e76c920e0710f = /*#__PURE__*/ function(JiraProjectListRightPanelState) {
    JiraProjectListRightPanelState["Closed"] = "CLOSED";
    JiraProjectListRightPanelState["Open"] = "OPEN";
    return JiraProjectListRightPanelState;
}({}); /** A connection that returns a paginated collection of project template */  /** An edge that contains a project template and a cursor. */  /** Simplified version of a project template. */  /** Whether or not the user has configured notification preferences for the project. */ 
let $78ad46e0d6808149$export$6e766e8806e1db62 = /*#__PURE__*/ function(JiraProjectNotificationConfigurationState) {
    JiraProjectNotificationConfigurationState["Configured"] = "CONFIGURED";
    JiraProjectNotificationConfigurationState["Default"] = "DEFAULT";
    return JiraProjectNotificationConfigurationState;
}({}); /** An edge in a JiraNotificationProjectPreferences connection. */  /** Options to filter based on project properties */  /** The project permission in Jira and it is scoped to projects. */  /**
 * The category of the project permission.
 * The category information is typically seen in the permission scheme Admin UI.
 * It is used to group the project permissions in general and available for connect app developers when registering new project permissions.
 */ 
let $78ad46e0d6808149$export$ecfca2e8f1d416c9 = /*#__PURE__*/ function(JiraProjectPermissionCategoryEnum) {
    JiraProjectPermissionCategoryEnum["Attachments"] = "ATTACHMENTS";
    JiraProjectPermissionCategoryEnum["Comments"] = "COMMENTS";
    JiraProjectPermissionCategoryEnum["Issues"] = "ISSUES";
    JiraProjectPermissionCategoryEnum["Other"] = "OTHER";
    JiraProjectPermissionCategoryEnum["Projects"] = "PROJECTS";
    JiraProjectPermissionCategoryEnum["TimeTracking"] = "TIME_TRACKING";
    JiraProjectPermissionCategoryEnum["VotersAndWatchers"] = "VOTERS_AND_WATCHERS";
    return JiraProjectPermissionCategoryEnum;
}({}); /** The different permissions that the user can have for a project */ 
let $78ad46e0d6808149$export$5b73c005b9475dcb = /*#__PURE__*/ function(JiraProjectPermissionType) {
    JiraProjectPermissionType["AddComments"] = "ADD_COMMENTS";
    JiraProjectPermissionType["AdministerProjects"] = "ADMINISTER_PROJECTS";
    JiraProjectPermissionType["ArchiveIssues"] = "ARCHIVE_ISSUES";
    JiraProjectPermissionType["AssignableUser"] = "ASSIGNABLE_USER";
    JiraProjectPermissionType["AssignIssues"] = "ASSIGN_ISSUES";
    JiraProjectPermissionType["BrowseProjects"] = "BROWSE_PROJECTS";
    JiraProjectPermissionType["CloseIssues"] = "CLOSE_ISSUES";
    JiraProjectPermissionType["CreateAttachments"] = "CREATE_ATTACHMENTS";
    JiraProjectPermissionType["CreateIssues"] = "CREATE_ISSUES";
    JiraProjectPermissionType["DeleteAllAttachments"] = "DELETE_ALL_ATTACHMENTS";
    JiraProjectPermissionType["DeleteAllComments"] = "DELETE_ALL_COMMENTS";
    JiraProjectPermissionType["DeleteAllWorklogs"] = "DELETE_ALL_WORKLOGS";
    JiraProjectPermissionType["DeleteIssues"] = "DELETE_ISSUES";
    JiraProjectPermissionType["DeleteOwnAttachments"] = "DELETE_OWN_ATTACHMENTS";
    JiraProjectPermissionType["DeleteOwnComments"] = "DELETE_OWN_COMMENTS";
    JiraProjectPermissionType["DeleteOwnWorklogs"] = "DELETE_OWN_WORKLOGS";
    JiraProjectPermissionType["EditAllComments"] = "EDIT_ALL_COMMENTS";
    JiraProjectPermissionType["EditAllWorklogs"] = "EDIT_ALL_WORKLOGS";
    JiraProjectPermissionType["EditIssues"] = "EDIT_ISSUES";
    JiraProjectPermissionType["EditIssueLayout"] = "EDIT_ISSUE_LAYOUT";
    JiraProjectPermissionType["EditOwnComments"] = "EDIT_OWN_COMMENTS";
    JiraProjectPermissionType["EditOwnWorklogs"] = "EDIT_OWN_WORKLOGS";
    JiraProjectPermissionType["EditWorkflow"] = "EDIT_WORKFLOW";
    JiraProjectPermissionType["LinkIssues"] = "LINK_ISSUES";
    JiraProjectPermissionType["ManageWatchers"] = "MANAGE_WATCHERS";
    JiraProjectPermissionType["ModifyReporter"] = "MODIFY_REPORTER";
    JiraProjectPermissionType["MoveIssues"] = "MOVE_ISSUES";
    JiraProjectPermissionType["ResolveIssues"] = "RESOLVE_ISSUES";
    JiraProjectPermissionType["ScheduleIssues"] = "SCHEDULE_ISSUES";
    JiraProjectPermissionType["SetIssueSecurity"] = "SET_ISSUE_SECURITY";
    JiraProjectPermissionType["TransitionIssues"] = "TRANSITION_ISSUES";
    JiraProjectPermissionType["UnarchiveIssues"] = "UNARCHIVE_ISSUES";
    JiraProjectPermissionType["ViewDevTools"] = "VIEW_DEV_TOOLS";
    JiraProjectPermissionType["ViewReadonlyWorkflow"] = "VIEW_READONLY_WORKFLOW";
    JiraProjectPermissionType["ViewVotersAndWatchers"] = "VIEW_VOTERS_AND_WATCHERS";
    JiraProjectPermissionType["WorkOnIssues"] = "WORK_ON_ISSUES";
    return JiraProjectPermissionType;
}({}); /** An entry in the activity log table for project role actors. */  /** Connection type for JiraProjectRoleActorLogTableEntry. */  /** An edge in a JiraProjectRoleActorLogTableEntryConnection. */  /** Project role actor recommendation. */  /** Recommendation action for a project role actor. */ 
let $78ad46e0d6808149$export$efb7762c97861711 = /*#__PURE__*/ function(JiraProjectRoleActorRecommendationAction) {
    JiraProjectRoleActorRecommendationAction["Trash"] = "TRASH";
    return JiraProjectRoleActorRecommendationAction;
}({}); /** Connection type for JiraProjectRoleActorRecommendation. */  /** An edge in a JiraProjectRoleActorRecommendation connection. */  /** User status for a project role actor. */ 
let $78ad46e0d6808149$export$b44a05ea54d6beba = /*#__PURE__*/ function(JiraProjectRoleActorUserStatus) {
    JiraProjectRoleActorUserStatus["Deleted"] = "DELETED";
    JiraProjectRoleActorUserStatus["Inactive"] = "INACTIVE";
    return JiraProjectRoleActorUserStatus;
}({}); /** The project role grant type value having the project role information. */  /** The Jira Project Shortcut that can be either a repo or basic shortcut link */  /** The supported different shortcut types */ 
let $78ad46e0d6808149$export$15a3b3ba6d4cada1 = /*#__PURE__*/ function(JiraProjectShortcutType) {
    JiraProjectShortcutType["Repository"] = "REPOSITORY";
    JiraProjectShortcutType["ShortcutLink"] = "SHORTCUT_LINK";
    JiraProjectShortcutType["Unknown"] = "UNKNOWN";
    return JiraProjectShortcutType;
}({});
let $78ad46e0d6808149$export$f4b615b47854d356 = /*#__PURE__*/ function(JiraProjectSortField) {
    JiraProjectSortField["Category"] = "CATEGORY";
    JiraProjectSortField["Favourite"] = "FAVOURITE";
    JiraProjectSortField["Key"] = "KEY";
    JiraProjectSortField["LastIssueUpdatedTime"] = "LAST_ISSUE_UPDATED_TIME";
    JiraProjectSortField["Lead"] = "LEAD";
    JiraProjectSortField["Name"] = "NAME";
    return JiraProjectSortField;
}({}); /** Jira Project statuses. */ 
let $78ad46e0d6808149$export$f24d023940410bd2 = /*#__PURE__*/ function(JiraProjectStatus) {
    JiraProjectStatus["Active"] = "ACTIVE";
    JiraProjectStatus["Archived"] = "ARCHIVED";
    JiraProjectStatus["Deleted"] = "DELETED";
    return JiraProjectStatus;
}({}); /** Jira Project Styles. */ 
let $78ad46e0d6808149$export$7108cef8ee0b9c1d = /*#__PURE__*/ function(JiraProjectStyle) {
    JiraProjectStyle["CompanyManagedProject"] = "COMPANY_MANAGED_PROJECT";
    JiraProjectStyle["TeamManagedProject"] = "TEAM_MANAGED_PROJECT";
    return JiraProjectStyle;
}({}); /** Jira Project types. */ 
let $78ad46e0d6808149$export$af05362339233870 = /*#__PURE__*/ function(JiraProjectType) {
    JiraProjectType["Business"] = "BUSINESS";
    JiraProjectType["CustomerService"] = "CUSTOMER_SERVICE";
    JiraProjectType["ProductDiscovery"] = "PRODUCT_DISCOVERY";
    JiraProjectType["ServiceDesk"] = "SERVICE_DESK";
    JiraProjectType["Software"] = "SOFTWARE";
    return JiraProjectType;
}({}); /**
 * This represents Jira Project Type, for instance, software, business. Details can be
 * found here: https://confluence.atlassian.com/adminjiraserver/jira-applications-and-project-types-overview-938846805.html
 */ 
let $78ad46e0d6808149$export$a8cdf7bc23c30cb9 = /*#__PURE__*/ function(JiraProjectsHelpCenterMappingStatus) {
    JiraProjectsHelpCenterMappingStatus["All"] = "ALL";
    JiraProjectsHelpCenterMappingStatus["Linked"] = "LINKED";
    JiraProjectsHelpCenterMappingStatus["Unlinked"] = "UNLINKED";
    return JiraProjectsHelpCenterMappingStatus;
}({}); /** Basic person information who reviews a pull-request. */  /** Possible states for Pull Requests */ 
let $78ad46e0d6808149$export$e4cb38caa605881 = /*#__PURE__*/ function(JiraPullRequestState) {
    JiraPullRequestState["Declined"] = "DECLINED";
    JiraPullRequestState["Draft"] = "DRAFT";
    JiraPullRequestState["Merged"] = "MERGED";
    JiraPullRequestState["Open"] = "OPEN";
    return JiraPullRequestState;
}({}); /** Represents the radio select field on a Jira Issue. */  /** Represents the radio select field on a Jira Issue. */  /** Represents a direction in the ranking of two issues. */ 
let $78ad46e0d6808149$export$ba97d7c27eb56d75 = /*#__PURE__*/ function(JiraRankMutationEdge) {
    JiraRankMutationEdge["Bottom"] = "BOTTOM";
    JiraRankMutationEdge["Top"] = "TOP";
    return JiraRankMutationEdge;
}({}); /** Input for ranking issues against one another using a rank field. */  /** Payload returned when `rankIssues` responds. */  /** Input for ranking a navigation item. Only pass one of beforeItemId or afterItemId. */  /** Response for the rank navigation item mutation. */  /** Response for the rank navigation item mutation. */  /** Input type for the recentItems' filter. */  /** Category of recommendation */ 
let $78ad46e0d6808149$export$8b4c07c95d919811 = /*#__PURE__*/ function(JiraRecommendationCategory) {
    JiraRecommendationCategory["CustomField"] = "CUSTOM_FIELD";
    JiraRecommendationCategory["IssueArchival"] = "ISSUE_ARCHIVAL";
    JiraRecommendationCategory["ProjectCleanup"] = "PROJECT_CLEANUP";
    JiraRecommendationCategory["ProjectRoleActor"] = "PROJECT_ROLE_ACTOR";
    return JiraRecommendationCategory;
}({}); /**
 * The release notes configuration for a version describing how to display properties,
 * types and keys for an issue
 *
 * This configuration is typically saved whenever a new release note is generated on a
 * per version basis.
 */ 
let $78ad46e0d6808149$export$88911ff8dc5ac51b = /*#__PURE__*/ function(JiraReleaseNotesIssueKeyConfig) {
    JiraReleaseNotesIssueKeyConfig["Linked"] = "LINKED";
    JiraReleaseNotesIssueKeyConfig["None"] = "NONE";
    JiraReleaseNotesIssueKeyConfig["Unlinked"] = "UNLINKED";
    return JiraReleaseNotesIssueKeyConfig;
}({}); /**
 * Used for specifying whether or not epics that haven't been released should be included
 * in the results.
 *
 * For an epic to be considered as released, at least one of the issues or subtasks within
 * it must have been released.
 */ 
let $78ad46e0d6808149$export$bb6f763ecaab7945 = /*#__PURE__*/ function(JiraReleasesEpicReleaseStatusFilter) {
    JiraReleasesEpicReleaseStatusFilter["Released"] = "RELEASED";
    JiraReleasesEpicReleaseStatusFilter["ReleasedAndUnreleased"] = "RELEASED_AND_UNRELEASED";
    return JiraReleasesEpicReleaseStatusFilter;
}({}); /**
 * Used for specifying whether or not issues that haven't been released should be included
 * in the results.
 */ 
let $78ad46e0d6808149$export$fe2e4a5cf13d7781 = /*#__PURE__*/ function(JiraReleasesIssueReleaseStatusFilter) {
    JiraReleasesIssueReleaseStatusFilter["Released"] = "RELEASED";
    JiraReleasesIssueReleaseStatusFilter["ReleasedAndUnreleased"] = "RELEASED_AND_UNRELEASED";
    JiraReleasesIssueReleaseStatusFilter["Unreleased"] = "UNRELEASED";
    return JiraReleasesIssueReleaseStatusFilter;
}({}); /**
 * Represents the remaining time estimate field on Jira issue screens and in the time tracking modal. Note that this is the same value as the remainingEstimate
 * from JiraTimeTrackingField.
 */ 
let $78ad46e0d6808149$export$d0483c6fd1bb3a85 = /*#__PURE__*/ function(JiraResourceUsageCustomFieldRecommendationAction) {
    JiraResourceUsageCustomFieldRecommendationAction["Trash"] = "TRASH";
    return JiraResourceUsageCustomFieldRecommendationAction;
}({}); /** Connection type for JiraResourceUsageCustomFieldRecommendation. */  /** An edge in a JiraResourceUsageCustomFieldRecommendation connection. */  /**
 * A resource usage metric is a measurement of a resource that may cause
 * performance degradation.
 */ 
let $78ad46e0d6808149$export$6b943f296ac5a6bd = /*#__PURE__*/ function(JiraResourceUsageRecommendationStatus) {
    JiraResourceUsageRecommendationStatus["Archived"] = "ARCHIVED";
    JiraResourceUsageRecommendationStatus["Executed"] = "EXECUTED";
    JiraResourceUsageRecommendationStatus["New"] = "NEW";
    JiraResourceUsageRecommendationStatus["Obsolete"] = "OBSOLETE";
    JiraResourceUsageRecommendationStatus["Trashed"] = "TRASHED";
    return JiraResourceUsageRecommendationStatus;
}({}); /** Possible states for Reviews */ 
let $78ad46e0d6808149$export$daac6ca3443a8579 = /*#__PURE__*/ function(JiraReviewState) {
    JiraReviewState["Approval"] = "APPROVAL";
    JiraReviewState["Closed"] = "CLOSED";
    JiraReviewState["Dead"] = "DEAD";
    JiraReviewState["Draft"] = "DRAFT";
    JiraReviewState["Rejected"] = "REJECTED";
    JiraReviewState["Review"] = "REVIEW";
    JiraReviewState["Summarize"] = "SUMMARIZE";
    JiraReviewState["Unknown"] = "UNKNOWN";
    return JiraReviewState;
}({}); /** Represents the rich text format of a rich text field. */  /** Represents a rich text field on a Jira Issue. E.g. description, environment. */  /** Input type for rich text fields. Supports both text area and wiki text fields */  /** Input type for rich text field */  /** The state information for a Jira right panel */  /** The connection type for JiraRightPanelState. */  /** An edge in a JiraRightPanelState connection. */  /** Represents a Jira ProjectRole. */  /** The connection type for JiraRole. */  /** An edge in a JiraRoleConnection connection. */  /** Represents a Jira Scenario */  /** Jira Plan ScenarioIssue node. */  /** Jira Plan ScenarioIssue node. */  /** The connection type for JiraScenarioIssueLike. */  /** The connection type for JiraScenarioIssueLike. */  /** An edge in a JiraScenarioIssueLike connection. */  /** Plan scenario data for the issue. */  /** Plan scenario data for the issue. */  /** Types of scenarios that can be an issue. */ 
let $78ad46e0d6808149$export$ac4d9d3c50ca05e6 = /*#__PURE__*/ function(JiraScenarioType) {
    JiraScenarioType["Added"] = "ADDED";
    JiraScenarioType["Deleted"] = "DELETED";
    JiraScenarioType["Deletedfromjira"] = "DELETEDFROMJIRA";
    JiraScenarioType["Updated"] = "UPDATED";
    return JiraScenarioType;
}({}); /** Response for ScheduleCalendarIssue mutation. */  /** Response for ScheduleCalendarIssueV2 mutation. */  /** Repository information provided by data-providers. */  /** Represents the abstraction over list of tabs shown on the Transition modal */  /** Represents the abstraction over list of tabs shown on the Transition modal */  /** Represents the field level details or error received */  /** Represents the contents of the tab */  /** Represent the field in context of the tabs in Issue Transition modal */  /** Represents tab of an Issue Transition Screen */  /** Represents tab of an Issue Transition Screen */  /** Represents list of tabs for transition modal */  /** Type contains information about the tab and its position */  /** Currently supported searchable entities in Jira. */  /** The connection type for JiraSearchableEntity. */  /** An edge in a JiraSearchableEntityConnection connection. */  /** The entity types of searchable items. */ 
let $78ad46e0d6808149$export$fd023c605588471d = /*#__PURE__*/ function(JiraSearchableEntityType) {
    JiraSearchableEntityType["Board"] = "BOARD";
    JiraSearchableEntityType["Dashboard"] = "DASHBOARD";
    JiraSearchableEntityType["Filter"] = "FILTER";
    JiraSearchableEntityType["Issue"] = "ISSUE";
    JiraSearchableEntityType["Plan"] = "PLAN";
    JiraSearchableEntityType["Project"] = "PROJECT";
    JiraSearchableEntityType["Queue"] = "QUEUE";
    return JiraSearchableEntityType;
}({}); /** Represents the security levels on an Issue. */  /** The connection type for JiraSecurityLevel. */  /** An edge in a JiraSecurityLevel connection. */  /** Represents security level field on a Jira Issue. Issue Security allows you to control who can and cannot view issues. */  /** Represents security level field on a Jira Issue. Issue Security allows you to control who can and cannot view issues. */  /** Input type for defining the operation on the Security Level field of a Jira issue. */  /** The payload type returned after updating the Security Level field of a Jira issue. */  /** Input type for security level field */  /** The connection type for JiraHasSelectableValue. */  /** An edge in a JiraHasSelectableValueOptions connection. */  /** Input type for selected option */  /**
 * The representation for a server error
 * E.g. database connection exception.
 */ 
let $78ad46e0d6808149$export$40c351d91e581267 = /*#__PURE__*/ function(JiraServiceManagementApprovalDecisionResponseType) {
    JiraServiceManagementApprovalDecisionResponseType["Approved"] = "approved";
    JiraServiceManagementApprovalDecisionResponseType["Declined"] = "declined";
    JiraServiceManagementApprovalDecisionResponseType["Pending"] = "pending";
    return JiraServiceManagementApprovalDecisionResponseType;
}({}); /** Represents the Approval custom field on an Issue in a JSM project. */  /** Represents the Approval custom field on an Issue in a JSM project. */  /** Represent whether approval can be achieved or not. */ 
let $78ad46e0d6808149$export$f2800242314330d1 = /*#__PURE__*/ function(JiraServiceManagementApprovalState) {
    JiraServiceManagementApprovalState["InsufficientApprovers"] = "INSUFFICIENT_APPROVERS";
    JiraServiceManagementApprovalState["Ok"] = "OK";
    return JiraServiceManagementApprovalState;
}({}); /** Represents details of the approval status. */  /** The user and decision that approved the approval. */  /** The connection type for JiraServiceManagementApprover. */  /** An edge in a JiraServiceManagementApprover connection. */  /** Approver principals are either users or groups that may decide on an approval. */  /** The connection type for JiraServiceManagementApproverPrincipal. */  /** An edge in a JiraServiceManagementApproverPrincipal connection. */  /** Represents the configuration details of the users providing approval. */  /**
 * Represents an attachment within a JiraServiceManagement project.
 * @deprecated: This type is unused as JSM Attachments has no distinct field attributes from the common type JiraAttachment
 */ 
let $78ad46e0d6808149$export$9c65915394dd59bf = /*#__PURE__*/ function(JiraServiceManagementCommentVisibility) {
    JiraServiceManagementCommentVisibility["Internal"] = "INTERNAL";
    JiraServiceManagementCommentVisibility["VisibleToHelpseeker"] = "VISIBLE_TO_HELPSEEKER";
    return JiraServiceManagementCommentVisibility;
}({}); /** Represents an approval that is completed. */  /** Represents an approval that is completed. */  /** The connection type for JiraServiceManagementCompletedApproval. */  /** An edge in a JiraServiceManagementCompletedApproval connection. */  /** Represent the input data for create workflow and associate it to the issue type. */  /** Represents payload of create and associate workflow mutation. */  /** Input for FORM_TEMPLATE_REFERENCE or REQUEST_TYPE_TEMPLATE_REFERENCE JiraServiceManagementCreateRequestTypeFromTemplateRequestFormInputType. */  /** This enum represents different input variation for the "request form" part of the new request type to be created. */ 
let $78ad46e0d6808149$export$bd4a236d84b2f605 = /*#__PURE__*/ function(JiraServiceManagementCreateRequestTypeFromTemplateRequestFormInputType) {
    JiraServiceManagementCreateRequestTypeFromTemplateRequestFormInputType["FormTemplateReference"] = "FORM_TEMPLATE_REFERENCE";
    JiraServiceManagementCreateRequestTypeFromTemplateRequestFormInputType["RequestTypeTemplateReference"] = "REQUEST_TYPE_TEMPLATE_REFERENCE";
    return JiraServiceManagementCreateRequestTypeFromTemplateRequestFormInputType;
}({}); /** This enum represent different action variation for workflow. */ 
let $78ad46e0d6808149$export$f35e6061c0db2138 = /*#__PURE__*/ function(JiraServiceManagementCreateRequestTypeFromTemplateWorkflowAction) {
    JiraServiceManagementCreateRequestTypeFromTemplateWorkflowAction["Share"] = "SHARE";
    return JiraServiceManagementCreateRequestTypeFromTemplateWorkflowAction;
}({}); /** This enum represent different input variation for workflow which will be associated with the new request type to be created. */ 
let $78ad46e0d6808149$export$bfa88ab509b645e1 = /*#__PURE__*/ function(JiraServiceManagementCreateRequestTypeFromTemplateWorkflowInputType) {
    JiraServiceManagementCreateRequestTypeFromTemplateWorkflowInputType["ReferenceThroughIssueType"] = "REFERENCE_THROUGH_ISSUE_TYPE";
    return JiraServiceManagementCreateRequestTypeFromTemplateWorkflowInputType;
}({}); /** Input for CreateRequestTypeFromTemplateWorkflowInputType.REFERENCE_THROUGH_ISSUE_TYPE . */  /** Date Preview Field */  /**
 * Represents a datetime field on an Issue in a JSM project.
 * Deprecated: Please use `JiraDateTimePickerField`.
 */ 
let $78ad46e0d6808149$export$ddab2c249424d3a2 = /*#__PURE__*/ function(JiraServiceManagementMajorIncident) {
    JiraServiceManagementMajorIncident["MajorIncident"] = "MAJOR_INCIDENT";
    return JiraServiceManagementMajorIncident;
}({}); /** Represents the major incident field for an Issue in a JSM project. */  /** MultiCheckboxes Field */  /**
 * Multiselect Preview Field
 * Allows users to select more than one option from a list.
 */ 
let $78ad46e0d6808149$export$e93d85fe60017d05 = /*#__PURE__*/ function(JiraServiceManagementPractice) {
    JiraServiceManagementPractice["ChangeManagement"] = "CHANGE_MANAGEMENT";
    JiraServiceManagementPractice["DeveloperEscalation"] = "DEVELOPER_ESCALATION";
    JiraServiceManagementPractice["IncidentManagement"] = "INCIDENT_MANAGEMENT";
    JiraServiceManagementPractice["PostIncidentReview"] = "POST_INCIDENT_REVIEW";
    JiraServiceManagementPractice["ProblemManagement"] = "PROBLEM_MANAGEMENT";
    JiraServiceManagementPractice["ServiceRequest"] = "SERVICE_REQUEST";
    return JiraServiceManagementPractice;
}({}); /**
 * Preview Option
 * Represents a single option in a drop-down list
 */ 
let $78ad46e0d6808149$export$3292ab1fe1c3cdee = /*#__PURE__*/ function(JiraServiceManagementRendererType) {
    JiraServiceManagementRendererType["AtlassianWikiRendererType"] = "ATLASSIAN_WIKI_RENDERER_TYPE";
    JiraServiceManagementRendererType["JiraTextRendererType"] = "JIRA_TEXT_RENDERER_TYPE";
    return JiraServiceManagementRendererType;
}({}); /** Represents the Request Feedback custom field on an Issue in a JSM project. */  /** Represents the Request Language field on an Issue in a JSM project. */  /** Requests the request type structure on an Issue. */  /** The connection type for JiraServiceManagementRequestType. */  /** An edge in a JiraServiceManagementIssueType connection. */  /** Represents the request type field for an Issue in a JSM project. */  /** Represents the request type field for an Issue in a JSM project. */  /**
 * Request Type Field Common
 * These are properties common to each request form field.
 */ 
let $78ad46e0d6808149$export$34d7d8d807e96acf = /*#__PURE__*/ function(JiraShareableEntityGrant) {
    JiraShareableEntityGrant["AnonymousAccess"] = "ANONYMOUS_ACCESS";
    JiraShareableEntityGrant["AnyLoggedinUserApplicationRole"] = "ANY_LOGGEDIN_USER_APPLICATION_ROLE";
    JiraShareableEntityGrant["Group"] = "GROUP";
    JiraShareableEntityGrant["Project"] = "PROJECT";
    JiraShareableEntityGrant["ProjectRole"] = "PROJECT_ROLE";
    JiraShareableEntityGrant["ProjectUnknown"] = "PROJECT_UNKNOWN";
    JiraShareableEntityGrant["User"] = "USER";
    return JiraShareableEntityGrant;
}({}); /** GROUP grant type. */  /** Input for the group that will be granted permission. */  /** PROJECT grant type. */  /** Input for the project ID, members of which will be granted permission. */  /** PROJECT_ROLE grant type. */  /**
 * Input for the id of the role.
 * Users with the specified role will be granted permission.
 */ 
let $78ad46e0d6808149$export$1f76696f6d16d0a3 = /*#__PURE__*/ function(JiraSingleValueFieldOperations) {
    JiraSingleValueFieldOperations["Set"] = "SET";
    return JiraSingleValueFieldOperations;
}({}); /** Represents a version field on a Jira Issue. E.g. custom version picker field. */  /** Represents a version field on a Jira Issue. E.g. custom version picker field. */  /** Represents a version field on a Jira Issue. E.g. custom version picker field. */  /** Input type for single select version picker fields */  /** Input type for defining the operation on the SingleVersionPicker field of a Jira issue. */  /** The payload type returned after updating the SingleVersionPicker field of a Jira issue. */  /** Board and project scope navigation items in JSW. */  /** Custom input definition for Jira Software issue search. */  /**
 * Additional context for Jira Software custom issue search, optionally constraining the search
 * by adding additional clauses to the search query.
 */ 
let $78ad46e0d6808149$export$8da1ba7785d00ed1 = /*#__PURE__*/ function(JiraSoftwareIssueSearchCustomInputContext) {
    JiraSoftwareIssueSearchCustomInputContext["Backlog"] = "BACKLOG";
    JiraSoftwareIssueSearchCustomInputContext["Board"] = "BOARD";
    JiraSoftwareIssueSearchCustomInputContext["None"] = "NONE";
    return JiraSoftwareIssueSearchCustomInputContext;
}({}); /** Types of Jira built in jira pages available for navigation */ 
let $78ad46e0d6808149$export$50c12a2a3005ac54 = /*#__PURE__*/ function(JiraSoftwareSimpleNavigationItemEnum) {
    JiraSoftwareSimpleNavigationItemEnum["JswBacklog"] = "JSW_BACKLOG";
    JiraSoftwareSimpleNavigationItemEnum["JswBoard"] = "JSW_BOARD";
    JiraSoftwareSimpleNavigationItemEnum["JswCalendar"] = "JSW_CALENDAR";
    JiraSoftwareSimpleNavigationItemEnum["JswCode"] = "JSW_CODE";
    JiraSoftwareSimpleNavigationItemEnum["JswComponents"] = "JSW_COMPONENTS";
    JiraSoftwareSimpleNavigationItemEnum["JswDeployments"] = "JSW_DEPLOYMENTS";
    JiraSoftwareSimpleNavigationItemEnum["JswGoals"] = "JSW_GOALS";
    JiraSoftwareSimpleNavigationItemEnum["JswIncidents"] = "JSW_INCIDENTS";
    JiraSoftwareSimpleNavigationItemEnum["JswIssues"] = "JSW_ISSUES";
    JiraSoftwareSimpleNavigationItemEnum["JswList"] = "JSW_LIST";
    JiraSoftwareSimpleNavigationItemEnum["JswOnCall"] = "JSW_ON_CALL";
    JiraSoftwareSimpleNavigationItemEnum["JswPages"] = "JSW_PAGES";
    JiraSoftwareSimpleNavigationItemEnum["JswReleases"] = "JSW_RELEASES";
    JiraSoftwareSimpleNavigationItemEnum["JswReports"] = "JSW_REPORTS";
    JiraSoftwareSimpleNavigationItemEnum["JswRequests"] = "JSW_REQUESTS";
    JiraSoftwareSimpleNavigationItemEnum["JswSecurity"] = "JSW_SECURITY";
    JiraSoftwareSimpleNavigationItemEnum["JswShortcuts"] = "JSW_SHORTCUTS";
    JiraSoftwareSimpleNavigationItemEnum["JswTimeline"] = "JSW_TIMELINE";
    return JiraSoftwareSimpleNavigationItemEnum;
}({}); /** Represents the sprint field of an issue. */  /** Represents the sprint field of an issue. */  /** The connection type for JiraSprint. */  /** An edge in a JiraSprint connection. */  /** Represents sprint field on a Jira Issue. */  /** Represents sprint field on a Jira Issue. */  /** Represents sprint field on a Jira Issue. */  /** Input type for sprint field */  /** Input type for sprints */  /** Represents progress of a sprint */  /** Represents progress of a sprint */  /** Represents the state of the sprint. */ 
let $78ad46e0d6808149$export$4b13eb4595f55ffa = /*#__PURE__*/ function(JiraSprintState) {
    JiraSprintState["Active"] = "ACTIVE";
    JiraSprintState["Closed"] = "CLOSED";
    JiraSprintState["Future"] = "FUTURE";
    return JiraSprintState;
}({}); /** Represents the status field of an issue. */  /** Represents the category of a status. */  /** Color of the status category. */ 
let $78ad46e0d6808149$export$539cfae207f2a8d6 = /*#__PURE__*/ function(JiraStatusCategoryColor) {
    JiraStatusCategoryColor["BlueGray"] = "BLUE_GRAY";
    JiraStatusCategoryColor["Brown"] = "BROWN";
    JiraStatusCategoryColor["Green"] = "GREEN";
    JiraStatusCategoryColor["MediumGray"] = "MEDIUM_GRAY";
    JiraStatusCategoryColor["WarmRed"] = "WARM_RED";
    JiraStatusCategoryColor["Yellow"] = "YELLOW";
    return JiraStatusCategoryColor;
}({}); /** Represents Status Category field. */  /** Represents the status category wise estimate counts */  /** The connection type for JiraStatusCategoryProgress. */  /** An edge in a JiraStatusCategoryProgress connection. */  /** Represents Status field. */  /** Represents Status field. */  /** This is an input argument client will have to give in order to perform bulk edit submit */  /** Response returned by the backend to client after performing bulk operation */  /** Progress object containing taskId for the submitted bulk operation */  /** Deprecated type. Please use `childIssues` field under `JiraIssue` instead. */  /** Deprecated type. Please use `childIssues` field under `JiraIssue` instead. */  /** Represents an error that occurred during the suggest child issues feature */  /** Represents the status of the suggest child issues feature */  /** The type representing the status of the suggest child issues feature */ 
let $78ad46e0d6808149$export$f61057e011c8c809 = /*#__PURE__*/ function(JiraSuggestedChildIssueStatusType) {
    JiraSuggestedChildIssueStatusType["Complete"] = "COMPLETE";
    JiraSuggestedChildIssueStatusType["RefiningSuggestedIssues"] = "REFINING_SUGGESTED_ISSUES";
    JiraSuggestedChildIssueStatusType["ReformattingIssues"] = "REFORMATTING_ISSUES";
    JiraSuggestedChildIssueStatusType["RemovingDuplicateIssues"] = "REMOVING_DUPLICATE_ISSUES";
    JiraSuggestedChildIssueStatusType["RetrievingSourceContext"] = "RETRIEVING_SOURCE_CONTEXT";
    JiraSuggestedChildIssueStatusType["SuggestingInitialIssues"] = "SUGGESTING_INITIAL_ISSUES";
    return JiraSuggestedChildIssueStatusType;
}({}); /** Represents a suggested child issue */  /** Represents the different types of errors that will be returned by the suggest child issues feature */ 
let $78ad46e0d6808149$export$f7abe62a0ee830d = /*#__PURE__*/ function(JiraSuggestedIssueErrorType) {
    JiraSuggestedIssueErrorType["CommunicationsError"] = "COMMUNICATIONS_ERROR";
    JiraSuggestedIssueErrorType["NotEnoughInformation"] = "NOT_ENOUGH_INFORMATION";
    JiraSuggestedIssueErrorType["NoFurtherSuggestions"] = "NO_FURTHER_SUGGESTIONS";
    JiraSuggestedIssueErrorType["Unclassified"] = "UNCLASSIFIED";
    JiraSuggestedIssueErrorType["UnethicalContent"] = "UNETHICAL_CONTENT";
    return JiraSuggestedIssueErrorType;
}({}); /** Represents the common structure across Issue fields value suggestion. */ 
let $78ad46e0d6808149$export$6edac7c7d2e8c8c9 = /*#__PURE__*/ function(JiraSuggestedIssueFieldValueError) {
    JiraSuggestedIssueFieldValueError["HaveRequiredField"] = "HAVE_REQUIRED_FIELD";
    JiraSuggestedIssueFieldValueError["IsSubTask"] = "IS_SUB_TASK";
    JiraSuggestedIssueFieldValueError["NotEnoughInformation"] = "NOT_ENOUGH_INFORMATION";
    JiraSuggestedIssueFieldValueError["NoFurtherSuggestions"] = "NO_FURTHER_SUGGESTIONS";
    JiraSuggestedIssueFieldValueError["SuggestionIsNotEnabled"] = "SUGGESTION_IS_NOT_ENABLED";
    JiraSuggestedIssueFieldValueError["Unclassified"] = "UNCLASSIFIED";
    return JiraSuggestedIssueFieldValueError;
}({}); /** The result of a suggested issue field value query */  /**
 * Represents an issue supplied to the suggest child issues feature to prevent semantically similar issues from being
 * suggested
 */ 
let $78ad46e0d6808149$export$edaa045cf8e612c1 = /*#__PURE__*/ function(JiraTimeFormat) {
    JiraTimeFormat["Days"] = "DAYS";
    JiraTimeFormat["Hours"] = "HOURS";
    JiraTimeFormat["Pretty"] = "PRETTY";
    return JiraTimeFormat;
}({}); /** Represents the time tracking field on Jira issue screens. */  /** Input for TimeTracking field */  /** Represents the type for representing global time tracking settings. */  /**
 * Different time units supported for entering & displaying time tracking related data.
 * Get the currently configured default duration to use when parsing duration string for time tracking.
 */ 
let $78ad46e0d6808149$export$98bcea6c013bc229 = /*#__PURE__*/ function(JiraTimeUnit) {
    JiraTimeUnit["Day"] = "DAY";
    JiraTimeUnit["Hour"] = "HOUR";
    JiraTimeUnit["Minute"] = "MINUTE";
    JiraTimeUnit["Week"] = "WEEK";
    return JiraTimeUnit;
}({}); /** The connection type for JiraTransition. */  /** An edge in a JiraTransition connection. */  /** Input type for transition screen when fields have to be edited */  /** Enum representing different sort options for transitions. */ 
let $78ad46e0d6808149$export$f68bbce1273585a7 = /*#__PURE__*/ function(JiraTransitionSortOption) {
    JiraTransitionSortOption["OpsBar"] = "OPS_BAR";
    JiraTransitionSortOption["OpsBarThenStatusCategory"] = "OPS_BAR_THEN_STATUS_CATEGORY";
    return JiraTransitionSortOption;
}({}); /** The representation for an error message that can be exposed to the UI. */ 
let $78ad46e0d6808149$export$8cb0419b0b598690 = /*#__PURE__*/ function(JiraUiModificationsViewType) {
    JiraUiModificationsViewType["Gic"] = "GIC";
    JiraUiModificationsViewType["IssueTransition"] = "IssueTransition";
    JiraUiModificationsViewType["IssueView"] = "IssueView";
    return JiraUiModificationsViewType;
}({}); /** Input for attributing Unsplash images */  /** The response for the attributeUnsplashImage mutation */  /** The result of an Unsplash image search */  /**
 * The input for searching Unsplash images. Uses Unsplash's API definition for pagination
 * https://unsplash.com/documentation#parameters-16
 */ 
let $78ad46e0d6808149$export$5e761940e4c8e671 = /*#__PURE__*/ function(JiraVersionApproverStatus) {
    JiraVersionApproverStatus["Approved"] = "APPROVED";
    JiraVersionApproverStatus["Declined"] = "DECLINED";
    JiraVersionApproverStatus["Pending"] = "PENDING";
    return JiraVersionApproverStatus;
}({}); /**
 * Marketplace connect app iframe data for Version details page's top right corner extension
 * point(location: atl.jira.releasereport.top.right.panels)
 * If options is null, parsing string json into json object failed while mapping.
 */ 
let $78ad46e0d6808149$export$ec4fbd90ada48f79 = /*#__PURE__*/ function(JiraVersionDetailsCollapsedUi) {
    JiraVersionDetailsCollapsedUi["Description"] = "DESCRIPTION";
    JiraVersionDetailsCollapsedUi["Issues"] = "ISSUES";
    JiraVersionDetailsCollapsedUi["IssueAssociatedDesigns"] = "ISSUE_ASSOCIATED_DESIGNS";
    JiraVersionDetailsCollapsedUi["ProgressCard"] = "PROGRESS_CARD";
    JiraVersionDetailsCollapsedUi["RelatedWork"] = "RELATED_WORK";
    JiraVersionDetailsCollapsedUi["RichTextSection"] = "RICH_TEXT_SECTION";
    JiraVersionDetailsCollapsedUi["RightSidebar"] = "RIGHT_SIDEBAR";
    return JiraVersionDetailsCollapsedUi;
}({}); /** The connection type for JiraVersionDriver. */  /** An edge in a JiraVersionDriver connection. */  /** An edge in a JiraVersion connection. */  /** Input for Versions values on fields */  /** The table column enum of version details page. */ 
let $78ad46e0d6808149$export$41dca0c2bc0964ff = /*#__PURE__*/ function(JiraVersionIssueTableColumn) {
    JiraVersionIssueTableColumn["BuildStatus"] = "BUILD_STATUS";
    JiraVersionIssueTableColumn["DeploymentStatus"] = "DEPLOYMENT_STATUS";
    JiraVersionIssueTableColumn["DevelopmentStatus"] = "DEVELOPMENT_STATUS";
    JiraVersionIssueTableColumn["FeatureFlagStatus"] = "FEATURE_FLAG_STATUS";
    JiraVersionIssueTableColumn["IssueAssignee"] = "ISSUE_ASSIGNEE";
    JiraVersionIssueTableColumn["IssuePriority"] = "ISSUE_PRIORITY";
    JiraVersionIssueTableColumn["IssueStatus"] = "ISSUE_STATUS";
    JiraVersionIssueTableColumn["MoreAction"] = "MORE_ACTION";
    JiraVersionIssueTableColumn["Warnings"] = "WARNINGS";
    return JiraVersionIssueTableColumn;
}({}); /** Type for the result of an update operation to an issue in a version */  /** The filter for a version's issues */ 
let $78ad46e0d6808149$export$2f70e0a7311bc8e6 = /*#__PURE__*/ function(JiraVersionIssuesFilter) {
    JiraVersionIssuesFilter["All"] = "ALL";
    JiraVersionIssuesFilter["Done"] = "DONE";
    JiraVersionIssuesFilter["FailingBuild"] = "FAILING_BUILD";
    JiraVersionIssuesFilter["InProgress"] = "IN_PROGRESS";
    JiraVersionIssuesFilter["OpenPullRequest"] = "OPEN_PULL_REQUEST";
    JiraVersionIssuesFilter["OpenReview"] = "OPEN_REVIEW";
    JiraVersionIssuesFilter["Todo"] = "TODO";
    JiraVersionIssuesFilter["UnreviewedCode"] = "UNREVIEWED_CODE";
    return JiraVersionIssuesFilter;
}({}); /** Fields that can be used to sort issues returned on the version. */ 
let $78ad46e0d6808149$export$70909551a8657943 = /*#__PURE__*/ function(JiraVersionIssuesSortField) {
    JiraVersionIssuesSortField["Assignee"] = "ASSIGNEE";
    JiraVersionIssuesSortField["Created"] = "CREATED";
    JiraVersionIssuesSortField["Key"] = "KEY";
    JiraVersionIssuesSortField["Priority"] = "PRIORITY";
    JiraVersionIssuesSortField["Status"] = "STATUS";
    JiraVersionIssuesSortField["Type"] = "TYPE";
    return JiraVersionIssuesSortField;
}({}); /** The sort criteria used for a version's issues */ 
let $78ad46e0d6808149$export$e857541964b7b4a4 = /*#__PURE__*/ function(JiraVersionIssuesStatusCategories) {
    JiraVersionIssuesStatusCategories["Done"] = "DONE";
    JiraVersionIssuesStatusCategories["InProgress"] = "IN_PROGRESS";
    JiraVersionIssuesStatusCategories["Todo"] = "TODO";
    return JiraVersionIssuesStatusCategories;
}({}); /** Type representing cross project version changes in a plan scenario */  /** Jira version related work type, which is used to associate "smart links" with a given Jira version. */  /** The connection type for JiraVersionRelatedWork. */  /** An edge in a JiraVersionRelatedWork connection. */  /** Jira version related work type, which is used to associate "smart links" with a given Jira version. */  /** Jira version related work type, which is used to associate "smart links" with a given Jira version. */  /** Enumeration of the kinds of Jira version related work items. */ 
let $78ad46e0d6808149$export$df98b03ce20f1d71 = /*#__PURE__*/ function(JiraVersionRelatedWorkType) {
    JiraVersionRelatedWorkType["ConfluenceReleaseNotes"] = "CONFLUENCE_RELEASE_NOTES";
    JiraVersionRelatedWorkType["GenericLink"] = "GENERIC_LINK";
    JiraVersionRelatedWorkType["NativeReleaseNotes"] = "NATIVE_RELEASE_NOTES";
    return JiraVersionRelatedWorkType;
}({}); /** Jira version related work type, which is used to associate "smart links" with a given Jira version. */  /** The connection type for JiraVersionRelatedWork. */  /** An edge in a JiraVersionRelatedWork connection. */  /** The input for fetching a preview of the release notes */  /** Types of Release Notes that are available */ 
let $78ad46e0d6808149$export$f1ccce3810e15115 = /*#__PURE__*/ function(JiraVersionReleaseNotesType) {
    JiraVersionReleaseNotesType["ConfluenceReleaseNote"] = "CONFLUENCE_RELEASE_NOTE";
    JiraVersionReleaseNotesType["NativeReleaseNote"] = "NATIVE_RELEASE_NOTE";
    return JiraVersionReleaseNotesType;
}({}); /** Contains either the successful fetched version information or an error. */  /** Version rich text section */  /** The argument for sorting project versions. */ 
let $78ad46e0d6808149$export$14819bc3909a411 = /*#__PURE__*/ function(JiraVersionSortField) {
    JiraVersionSortField["Description"] = "DESCRIPTION";
    JiraVersionSortField["Name"] = "NAME";
    JiraVersionSortField["ReleaseDate"] = "RELEASE_DATE";
    JiraVersionSortField["Sequence"] = "SEQUENCE";
    JiraVersionSortField["StartDate"] = "START_DATE";
    return JiraVersionSortField;
}({}); /** The status of a version field. */ 
let $78ad46e0d6808149$export$661a9c551e5e752c = /*#__PURE__*/ function(JiraVersionStatus) {
    JiraVersionStatus["Archived"] = "ARCHIVED";
    JiraVersionStatus["Released"] = "RELEASED";
    JiraVersionStatus["Unreleased"] = "UNRELEASED";
    return JiraVersionStatus;
}({}); /** The connection type for Jira Version approver suggestion */  /** The edge type for Jira Version approver suggestion */  /** The input to update approval description */  /** The return payload of updating an approval description */  /** The input to update approval status */  /** The return payload of updating an approval description */  /** GraphQL input shape for updating an entire(all fields) version object */  /**
 * The warning configuration to be updated for version details page warning report.
 * Applicable values will have their value updated. Null values will default to true.
 */ 
let $78ad46e0d6808149$export$fc74821556ba9086 = /*#__PURE__*/ function(JiraVersionWarningCategories) {
    JiraVersionWarningCategories["FailingBuild"] = "FAILING_BUILD";
    JiraVersionWarningCategories["OpenPullRequest"] = "OPEN_PULL_REQUEST";
    JiraVersionWarningCategories["OpenReview"] = "OPEN_REVIEW";
    JiraVersionWarningCategories["UnreviewedCode"] = "UNREVIEWED_CODE";
    return JiraVersionWarningCategories;
}({}); /** The warning configuration to generate version details page warning report. */  /** The warning config for version details page to generate warning report. Depending on tenant settings and providers installed, some warning config could be in NOT_APPLICABLE state. */ 
let $78ad46e0d6808149$export$953aa8fa6e3444b5 = /*#__PURE__*/ function(JiraVersionWarningConfigState) {
    JiraVersionWarningConfigState["Disabled"] = "DISABLED";
    JiraVersionWarningConfigState["Enabled"] = "ENABLED";
    JiraVersionWarningConfigState["NotApplicable"] = "NOT_APPLICABLE";
    return JiraVersionWarningConfigState;
}({}); /** Input for the view that can be shared across multiple products, i.e., Jira Calendar */  /** The reason why an extension shouldn't be visible in the given context. */ 
let $78ad46e0d6808149$export$d93e6e69204ae0db = /*#__PURE__*/ function(JiraVisibilityControlMechanism) {
    JiraVisibilityControlMechanism["AppAccessRules"] = "AppAccessRules";
    JiraVisibilityControlMechanism["DisplayConditions"] = "DisplayConditions";
    return JiraVisibilityControlMechanism;
}({}); /** Represents the votes information of an Issue. */  /** Represents a votes field on a Jira Issue. */  /** Represents a votes field on a Jira Issue. */  /** Operations that can be performed on vote field. */ 
let $78ad46e0d6808149$export$b1636d2c563ea928 = /*#__PURE__*/ function(JiraVotesOperations) {
    JiraVotesOperations["Add"] = "ADD";
    JiraVotesOperations["Remove"] = "REMOVE";
    return JiraVotesOperations;
}({}); /** Represents the watches information. */  /** Represents the Watches system field. */  /** Represents the Watches system field. */  /** Represents the Watches system field. */  /** Operations that can be performed on watches field. */ 
let $78ad46e0d6808149$export$859195aa80d24a0e = /*#__PURE__*/ function(JiraWatchesOperations) {
    JiraWatchesOperations["Add"] = "ADD";
    JiraWatchesOperations["Remove"] = "REMOVE";
    return JiraWatchesOperations;
}({}); /** Represents a WorkCategory. */  /** Represents the WorkCategory field on an Issue. */  /** The connection type for JiraWorklog. */  /** An edge in a JiraWorkLog connection. */  /** Represents the log work field on jira issue screens. Used to log time while working on issues */  /** A Jira Work Management Attachment Background, used only when the entity is of Issue type */  /** Interface for backgrounds in JWM */  /** The supported background types */ 
let $78ad46e0d6808149$export$bba45fb1219c9de3 = /*#__PURE__*/ function(JiraWorkManagementBackgroundType) {
    JiraWorkManagementBackgroundType["Attachment"] = "ATTACHMENT";
    JiraWorkManagementBackgroundType["Color"] = "COLOR";
    JiraWorkManagementBackgroundType["Custom"] = "CUSTOM";
    JiraWorkManagementBackgroundType["Gradient"] = "GRADIENT";
    return JiraWorkManagementBackgroundType;
}({}); /** Type to hold Jira Work Management Background upload token auth details */  /** A Jira Work Management Background which is a solid color type */  /** Input for creating a Jira Work Management Custom Background */  /** The response for the jwmCreateCustomBackground mutation */  /** Represents the input data required for JWM issue creation. */  /** Represents the payload of the JWM Create Issue mutation. */  /** Input for creating a Jira Work Management Overview. */  /** Input for creating a saved view. */  /** Response for the create saved view mutation. */  /** The type for a Jira Work Management Custom Background, which is associated with a Media API file */  /** The type for a Jira Work Management Custom Background, which is associated with a Media API file */  /** The connection type for Jira Work Management Custom Background. */  /** The edge type for Jira Work Management Custom Background. */  /** Represents the input data required for Jwm Delete Attachment mutation. */  /** Represents the payload of the Jwm Delete Attachment mutation. */  /** The input for deleting a custom background */  /** The response for the jwmDeleteCustomBackground mutation */  /** Input for deleting a Jira Work Management Overview. */  /** A node that represents a Jira Work Management form and all the configuration associated with it. */  /** Represents a Jira Issue Field and its alias within the form. */  /** Response for the create Jira Work Management Overview mutation. */  /** Response for the delete Jira Work Management Overview mutation. */  /** Represents a Jira Work Management Overview. This is currently used in Jira Work Management as a collection of Projects. */  /** Represents a Jira Work Management Overview. This is currently used in Jira Work Management as a collection of Projects. */  /** Represents a Jira Work Management Overview. This is currently used in Jira Work Management as a collection of Projects. */  /** The connection type for Jira Work Management Overview. */  /** The edge type for Jira Work Management Overview. */  /** Response for the update Jira Work Management Overview mutation. */  /** A Jira Work Management Background which is a gradient type */  /** A Jira Work Management Media Background Media, containing a reference to a custom background */  /** Represents the input data to rank an issue upon creation. */  /** The input for deleting an active background */  /** The response for the jwmRemoveActiveBackground mutation */  /** The general concrete type for navigation items in JWM. Represents a saved view in the horizontal navigation. */  /** Represents a type of saved view, identified by its `JiraNavigationItemTypeKey`. */  /** The connection type for saved view types. */  /** The edge type for saved view types. */  /** The response for the jwmUpdateActiveBackground mutation */  /** The input for updating a Jira Work Management Background */  /** The input for updating a custom background */  /** The returned payload when updating a custom background */  /** Input for updating a Jira Work Management Overview. */ 
let $78ad46e0d6808149$export$2eb64d234500f795 = /*#__PURE__*/ function(JiraWorkManagementUserLicenseSeatEdition) {
    JiraWorkManagementUserLicenseSeatEdition["Free"] = "FREE";
    JiraWorkManagementUserLicenseSeatEdition["Premium"] = "PREMIUM";
    JiraWorkManagementUserLicenseSeatEdition["Standard"] = "STANDARD";
    return JiraWorkManagementUserLicenseSeatEdition;
}({}); /** Represents a Jira worklog. */  /** Accepted Worklog adjustments */ 
let $78ad46e0d6808149$export$6ff2b5b641c7145c = /*#__PURE__*/ function(JiraWorklogAdjustmentEstimateOperation) {
    JiraWorklogAdjustmentEstimateOperation["Auto"] = "AUTO";
    JiraWorklogAdjustmentEstimateOperation["Leave"] = "LEAVE";
    JiraWorklogAdjustmentEstimateOperation["Manual"] = "MANUAL";
    JiraWorklogAdjustmentEstimateOperation["New"] = "NEW";
    return JiraWorklogAdjustmentEstimateOperation;
}({}); /** Input type for defining the operation on the Worklog field of a Jira issue. */ 
let $78ad46e0d6808149$export$becc47419f149198 = /*#__PURE__*/ function(JsmChatChannelType) {
    JsmChatChannelType["Agent"] = "AGENT";
    JsmChatChannelType["Request"] = "REQUEST";
    return JsmChatChannelType;
}({});
let $78ad46e0d6808149$export$a89b8ac8c955a6b8 = /*#__PURE__*/ function(JsmChatConnectedApps) {
    JsmChatConnectedApps["Slack"] = "SLACK";
    JsmChatConnectedApps["Teams"] = "TEAMS";
    return JsmChatConnectedApps;
}({});
let $78ad46e0d6808149$export$80c78efe35efe1e8 = /*#__PURE__*/ function(JsmChatConversationMessageContentType) {
    JsmChatConversationMessageContentType["Adf"] = "ADF";
    return JsmChatConversationMessageContentType;
}({});
let $78ad46e0d6808149$export$b48e72793880c81d = /*#__PURE__*/ function(JsmChatConversationUserRole) {
    JsmChatConversationUserRole["JsmAgent"] = "JSM_Agent";
    JsmChatConversationUserRole["Participant"] = "Participant";
    JsmChatConversationUserRole["Reporter"] = "Reporter";
    JsmChatConversationUserRole["VirtualAgent"] = "VirtualAgent";
    return JsmChatConversationUserRole;
}({});
let $78ad46e0d6808149$export$f209cecbea0db715 = /*#__PURE__*/ function(JsmChatMessageSource) {
    JsmChatMessageSource["Email"] = "EMAIL";
    return JsmChatMessageSource;
}({});
let $78ad46e0d6808149$export$6c33ffba63a39eab = /*#__PURE__*/ function(JsmChatMessageType) {
    JsmChatMessageType["Adf"] = "ADF";
    return JsmChatMessageType;
}({}); /** The response when a subscription is established. */ 
let $78ad46e0d6808149$export$237aec910e197d97 = /*#__PURE__*/ function(KnowledgeDiscoveryDefinitionScope) {
    KnowledgeDiscoveryDefinitionScope["Blogpost"] = "BLOGPOST";
    KnowledgeDiscoveryDefinitionScope["Organization"] = "ORGANIZATION";
    KnowledgeDiscoveryDefinitionScope["Page"] = "PAGE";
    KnowledgeDiscoveryDefinitionScope["Project"] = "PROJECT";
    KnowledgeDiscoveryDefinitionScope["Space"] = "SPACE";
    return KnowledgeDiscoveryDefinitionScope;
}({});
let $78ad46e0d6808149$export$d2d7439a14c13cac = /*#__PURE__*/ function(KnowledgeDiscoveryEntityType) {
    KnowledgeDiscoveryEntityType["ConfluenceBlogpost"] = "CONFLUENCE_BLOGPOST";
    KnowledgeDiscoveryEntityType["ConfluenceDocument"] = "CONFLUENCE_DOCUMENT";
    KnowledgeDiscoveryEntityType["ConfluencePage"] = "CONFLUENCE_PAGE";
    KnowledgeDiscoveryEntityType["ConfluenceSpace"] = "CONFLUENCE_SPACE";
    KnowledgeDiscoveryEntityType["JiraProject"] = "JIRA_PROJECT";
    KnowledgeDiscoveryEntityType["KeyPhrase"] = "KEY_PHRASE";
    KnowledgeDiscoveryEntityType["Topic"] = "TOPIC";
    KnowledgeDiscoveryEntityType["User"] = "USER";
    return KnowledgeDiscoveryEntityType;
}({});
let $78ad46e0d6808149$export$4c5402ac41e05bd0 = /*#__PURE__*/ function(KnowledgeDiscoveryKeyPhraseCategory) {
    KnowledgeDiscoveryKeyPhraseCategory["Acronym"] = "ACRONYM";
    KnowledgeDiscoveryKeyPhraseCategory["Other"] = "OTHER";
    KnowledgeDiscoveryKeyPhraseCategory["Project"] = "PROJECT";
    KnowledgeDiscoveryKeyPhraseCategory["Team"] = "TEAM";
    return KnowledgeDiscoveryKeyPhraseCategory;
}({});
let $78ad46e0d6808149$export$5fc610914b028d97 = /*#__PURE__*/ function(KnowledgeDiscoveryKeyPhraseInputTextFormat) {
    KnowledgeDiscoveryKeyPhraseInputTextFormat["Adf"] = "ADF";
    KnowledgeDiscoveryKeyPhraseInputTextFormat["Plain"] = "PLAIN";
    return KnowledgeDiscoveryKeyPhraseInputTextFormat;
}({});
let $78ad46e0d6808149$export$be3a90b14f5b3f96 = /*#__PURE__*/ function(KnowledgeDiscoverySearchQueryClassification) {
    KnowledgeDiscoverySearchQueryClassification["KeywordOrAcronym"] = "KEYWORD_OR_ACRONYM";
    KnowledgeDiscoverySearchQueryClassification["NaturalLanguageQuery"] = "NATURAL_LANGUAGE_QUERY";
    KnowledgeDiscoverySearchQueryClassification["None"] = "NONE";
    KnowledgeDiscoverySearchQueryClassification["Person"] = "PERSON";
    KnowledgeDiscoverySearchQueryClassification["Team"] = "TEAM";
    return KnowledgeDiscoverySearchQueryClassification;
}({});
let $78ad46e0d6808149$export$3b6332b650771b7c = /*#__PURE__*/ function(KnowledgeDiscoverySummaryLength) {
    KnowledgeDiscoverySummaryLength["Large"] = "LARGE";
    KnowledgeDiscoverySummaryLength["Medium"] = "MEDIUM";
    KnowledgeDiscoverySummaryLength["Small"] = "SMALL";
    return KnowledgeDiscoverySummaryLength;
}({});
let $78ad46e0d6808149$export$476bafd4888ee246 = /*#__PURE__*/ function(KnowledgeDiscoveryTopicType) {
    KnowledgeDiscoveryTopicType["Area"] = "AREA";
    KnowledgeDiscoveryTopicType["Company"] = "COMPANY";
    KnowledgeDiscoveryTopicType["Event"] = "EVENT";
    KnowledgeDiscoveryTopicType["Process"] = "PROCESS";
    KnowledgeDiscoveryTopicType["Program"] = "PROGRAM";
    KnowledgeDiscoveryTopicType["Team"] = "TEAM";
    return KnowledgeDiscoveryTopicType;
}({});
let $78ad46e0d6808149$export$522f238043d058cb = /*#__PURE__*/ function(LicenseOverrideState) {
    LicenseOverrideState["Active"] = "ACTIVE";
    LicenseOverrideState["Advanced"] = "ADVANCED";
    LicenseOverrideState["Inactive"] = "INACTIVE";
    LicenseOverrideState["Standard"] = "STANDARD";
    LicenseOverrideState["Trial"] = "TRIAL";
    return LicenseOverrideState;
}({}); /**
 * See https://developer.atlassian.com/platform/graphql-gateway/schemas/lifecycle-support/#lifecycle-stages for more
 * information on how to use these stages and what they mean in detail.
 * | Lifecycle            | Visible in Prod | Needs `@optIn` directive |                     Allow third parties                       |
 * |----------------------|:---------------:|:------------------------:|:-------------------------------------------------------------:|
 * | STAGING              |       No        |            No            | By default no. Can enable via `allowThirdParties` directive   |
 * | EXPERIMENTAL         |       Yes       |           Yes            | By default no. Can enable via `allowThirdParties` directive   |
 * | BETA                 |       Yes       |           Yes            |                       Always                                  |
 * | PRODUCTION (default) |       Yes       |            No            |                       Always                                  |
 */ 
let $78ad46e0d6808149$export$3b3519737999098f = /*#__PURE__*/ function(LifecycleStage) {
    LifecycleStage["Beta"] = "BETA";
    LifecycleStage["Experimental"] = "EXPERIMENTAL";
    LifecycleStage["Production"] = "PRODUCTION";
    LifecycleStage["Staging"] = "STAGING";
    return LifecycleStage;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __identity:atlassian-external__
 * * __read:account__
 */ 
let $78ad46e0d6808149$export$f02742739c4d10 = /*#__PURE__*/ function(LpCertSortField) {
    LpCertSortField["ActiveDate"] = "ACTIVE_DATE";
    LpCertSortField["ExpireDate"] = "EXPIRE_DATE";
    LpCertSortField["Id"] = "ID";
    LpCertSortField["ImageUrl"] = "IMAGE_URL";
    LpCertSortField["Name"] = "NAME";
    LpCertSortField["NameAbbr"] = "NAME_ABBR";
    LpCertSortField["PublicUrl"] = "PUBLIC_URL";
    LpCertSortField["Status"] = "STATUS";
    LpCertSortField["Type"] = "TYPE";
    return LpCertSortField;
}({});
let $78ad46e0d6808149$export$a8eb0a5903a5312c = /*#__PURE__*/ function(LpCertStatus) {
    LpCertStatus["Active"] = "ACTIVE";
    LpCertStatus["Expired"] = "EXPIRED";
    return LpCertStatus;
}({});
let $78ad46e0d6808149$export$9999af1e50a41e44 = /*#__PURE__*/ function(LpCertType) {
    LpCertType["Badge"] = "BADGE";
    LpCertType["Certification"] = "CERTIFICATION";
    LpCertType["Standing"] = "STANDING";
    return LpCertType;
}({}); /** Certmetrics credentials: certifications/badges/standings */  /** Course progress: Information of courses progress */ 
let $78ad46e0d6808149$export$a8f04761d618cfe2 = /*#__PURE__*/ function(LpCourseSortField) {
    LpCourseSortField["CompletedDate"] = "COMPLETED_DATE";
    LpCourseSortField["CourseId"] = "COURSE_ID";
    LpCourseSortField["Id"] = "ID";
    LpCourseSortField["Status"] = "STATUS";
    LpCourseSortField["Title"] = "TITLE";
    LpCourseSortField["Url"] = "URL";
    return LpCourseSortField;
}({});
let $78ad46e0d6808149$export$b2608a9d91a1b256 = /*#__PURE__*/ function(LpCourseStatus) {
    LpCourseStatus["Completed"] = "COMPLETED";
    LpCourseStatus["InProgress"] = "IN_PROGRESS";
    return LpCourseStatus;
}({}); /** Learner/atlassian user */  /** Learner/atlassian user */  /** Learner/atlassian user */  /** Learner/atlassian user */  /** Lesson progress: Information of lessons progress */ 
let $78ad46e0d6808149$export$dcfe2c64979f9e2c = /*#__PURE__*/ function(LpSortOrder) {
    LpSortOrder["Asc"] = "ASC";
    LpSortOrder["Desc"] = "DESC";
    return LpSortOrder;
}({}); /** A piece of code that modifies the functionality or look and feel of Atlassian products */  /** A piece of code that modifies the functionality or look and feel of Atlassian products */  /** A piece of code that modifies the functionality or look and feel of Atlassian products */  /** Category associated with an app */  /** A connection providing cursor-based pagination for a list of apps. */  /** An entry in a paginated list of apps. */  /** All deployment related properties for an app version */  /** Step for installing the instructional app */  /** Marketplace app's distribution information */  /** Payment model for integrating an app with an Atlassian product. */ 
let $78ad46e0d6808149$export$f25ba44b203e3645 = /*#__PURE__*/ function(MarketplaceAppPaymentModel) {
    MarketplaceAppPaymentModel["Free"] = "FREE";
    MarketplaceAppPaymentModel["PaidViaAtlassian"] = "PAID_VIA_ATLASSIAN";
    MarketplaceAppPaymentModel["PaidViaPartner"] = "PAID_VIA_PARTNER";
    return MarketplaceAppPaymentModel;
}({}); /** Marketplace App Programs that this Marketplace App has enrolled into. */  /** Summary of the reviews for an app */  /** App trust information for a marketplace entity */  /** App trust information or associated error in querying */  /** Version of App in Marketplace system */  /** License type for an app version */  /** Visibility of the Marketplace app's version */ 
let $78ad46e0d6808149$export$6e069b93ed3dba5f = /*#__PURE__*/ function(MarketplaceAppVersionVisibility) {
    MarketplaceAppVersionVisibility["Private"] = "PRIVATE";
    MarketplaceAppVersionVisibility["Public"] = "PUBLIC";
    return MarketplaceAppVersionVisibility;
}({}); /** Information of watchers of a Marketplace app */  /** Filters to apply when querying for my apps. */  /** Billing cycle for which pricing plan applies */ 
let $78ad46e0d6808149$export$dafb60ab7ab08188 = /*#__PURE__*/ function(MarketplaceBillingCycle) {
    MarketplaceBillingCycle["Annual"] = "ANNUAL";
    MarketplaceBillingCycle["Monthly"] = "MONTHLY";
    return MarketplaceBillingCycle;
}({}); /** Details of Bug bounty program */  /** Cloud app deployment properties */  /** Details of Cloud fortified program. */ 
let $78ad46e0d6808149$export$468594da24feab1 = /*#__PURE__*/ function(MarketplaceCloudFortifiedStatus) {
    MarketplaceCloudFortifiedStatus["Applied"] = "APPLIED";
    MarketplaceCloudFortifiedStatus["Approved"] = "APPROVED";
    MarketplaceCloudFortifiedStatus["NotAParticipant"] = "NOT_A_PARTICIPANT";
    MarketplaceCloudFortifiedStatus["Rejected"] = "REJECTED";
    return MarketplaceCloudFortifiedStatus;
}({}); /** Connect app deployment properties */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** --------------------------------------------------------------------------------------------- */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */ 
let $78ad46e0d6808149$export$c1efd3e80d58f939 = /*#__PURE__*/ function(MarketplaceConsoleAppSoftwareVersionLicenseTypeId) {
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["Asl"] = "ASL";
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["AtlassianClosedSource"] = "ATLASSIAN_CLOSED_SOURCE";
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["Bsd"] = "BSD";
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["Commercial"] = "COMMERCIAL";
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["CommercialFree"] = "COMMERCIAL_FREE";
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["Epl"] = "EPL";
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["Gpl"] = "GPL";
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["Lgpl"] = "LGPL";
    return MarketplaceConsoleAppSoftwareVersionLicenseTypeId;
}({}); /** This file defines the GQL type definition for the AppSoftwareVersionListing used in the marketplace console */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */ 
let $78ad46e0d6808149$export$fb9cecbbd253ebc0 = /*#__PURE__*/ function(MarketplaceConsoleAppSoftwareVersionState) {
    MarketplaceConsoleAppSoftwareVersionState["Active"] = "ACTIVE";
    MarketplaceConsoleAppSoftwareVersionState["Approved"] = "APPROVED";
    MarketplaceConsoleAppSoftwareVersionState["Archived"] = "ARCHIVED";
    MarketplaceConsoleAppSoftwareVersionState["AutoApproved"] = "AUTO_APPROVED";
    MarketplaceConsoleAppSoftwareVersionState["Draft"] = "DRAFT";
    MarketplaceConsoleAppSoftwareVersionState["Rejected"] = "REJECTED";
    MarketplaceConsoleAppSoftwareVersionState["Submitted"] = "SUBMITTED";
    return MarketplaceConsoleAppSoftwareVersionState;
}({}); /** --------------------------------------------------------------------------------------------- */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** Represents an artifact which was uploaded from local file system or remote URL */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */ 
let $78ad46e0d6808149$export$9de5cbe727291181 = /*#__PURE__*/ function(MarketplaceConsoleDevSpaceProgram) {
    MarketplaceConsoleDevSpaceProgram["AtlassianParter"] = "ATLASSIAN_PARTER";
    MarketplaceConsoleDevSpaceProgram["FreeLicense"] = "FREE_LICENSE";
    MarketplaceConsoleDevSpaceProgram["MarketplacePartner"] = "MARKETPLACE_PARTNER";
    MarketplaceConsoleDevSpaceProgram["SolutionPartner"] = "SOLUTION_PARTNER";
    return MarketplaceConsoleDevSpaceProgram;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */ 
let $78ad46e0d6808149$export$2f6a1d40840e6e7a = /*#__PURE__*/ function(MarketplaceConsoleDevSpaceTier) {
    MarketplaceConsoleDevSpaceTier["Gold"] = "GOLD";
    MarketplaceConsoleDevSpaceTier["Platinum"] = "PLATINUM";
    MarketplaceConsoleDevSpaceTier["Silver"] = "SILVER";
    return MarketplaceConsoleDevSpaceTier;
}({}); /** --------------------------------------------------------------------------------------------- */ 
let $78ad46e0d6808149$export$63c7f04a210975b2 = /*#__PURE__*/ function(MarketplaceConsoleEditionType) {
    MarketplaceConsoleEditionType["Advanced"] = "ADVANCED";
    MarketplaceConsoleEditionType["Standard"] = "STANDARD";
    return MarketplaceConsoleEditionType;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** --------------------------------------------------------------------------------------------- */ 
let $78ad46e0d6808149$export$26ce6a16987d908d = /*#__PURE__*/ function(MarketplaceConsoleEditionsActivationStatus) {
    MarketplaceConsoleEditionsActivationStatus["Approved"] = "APPROVED";
    MarketplaceConsoleEditionsActivationStatus["Pending"] = "PENDING";
    MarketplaceConsoleEditionsActivationStatus["Rejected"] = "REJECTED";
    return MarketplaceConsoleEditionsActivationStatus;
}({}); /** --------------------------------------------------------------------------------------------- */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /**
 * The file contains the common types that are used across
 * different parts of the Marketplace Console BFF GQL schema.
 */ 
let $78ad46e0d6808149$export$14f32a11a50ded19 = /*#__PURE__*/ function(MarketplaceConsoleHosting) {
    MarketplaceConsoleHosting["Cloud"] = "CLOUD";
    MarketplaceConsoleHosting["DataCenter"] = "DATA_CENTER";
    MarketplaceConsoleHosting["Server"] = "SERVER";
    return MarketplaceConsoleHosting;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** Ref: https://hello.atlassian.net/wiki/spaces/~549868828/pages/2204917928/Rollout+Plan+Blocking+RuBy+partners+access+to+Marketplace */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */ 
let $78ad46e0d6808149$export$5636d960d9fd9d0a = /*#__PURE__*/ function(MarketplaceConsoleLegacyMongoPluginHiddenIn) {
    MarketplaceConsoleLegacyMongoPluginHiddenIn["HiddenInSiteAndAppMarketplace"] = "HIDDEN_IN_SITE_AND_APP_MARKETPLACE";
    MarketplaceConsoleLegacyMongoPluginHiddenIn["HiddenInSiteOnly"] = "HIDDEN_IN_SITE_ONLY";
    return MarketplaceConsoleLegacyMongoPluginHiddenIn;
}({}); /** --------------------------------------------------------------------------------------------- */ 
let $78ad46e0d6808149$export$b16d3f44b490e152 = /*#__PURE__*/ function(MarketplaceConsoleLegacyMongoStatus) {
    MarketplaceConsoleLegacyMongoStatus["Notassigned"] = "NOTASSIGNED";
    MarketplaceConsoleLegacyMongoStatus["Private"] = "PRIVATE";
    MarketplaceConsoleLegacyMongoStatus["Public"] = "PUBLIC";
    MarketplaceConsoleLegacyMongoStatus["Readytolaunch"] = "READYTOLAUNCH";
    MarketplaceConsoleLegacyMongoStatus["Rejected"] = "REJECTED";
    MarketplaceConsoleLegacyMongoStatus["Submitted"] = "SUBMITTED";
    return MarketplaceConsoleLegacyMongoStatus;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** Represents details of a link */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** Namespace for Console related mutations */  /** Namespace for Console related mutations */  /** Namespace for Console related mutations */  /** Namespace for Console related mutations */  /** Namespace for Console related mutations */  /** Namespace for Console related mutations */  /** Namespace for Console related mutations */  /** Namespace for Console related mutations */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** --------------------------------------------------------------------------------------------- */ 
let $78ad46e0d6808149$export$a3c494bbbdf25ee3 = /*#__PURE__*/ function(MarketplaceConsoleParentSoftwareState) {
    MarketplaceConsoleParentSoftwareState["Active"] = "ACTIVE";
    MarketplaceConsoleParentSoftwareState["Archived"] = "ARCHIVED";
    MarketplaceConsoleParentSoftwareState["Draft"] = "DRAFT";
    return MarketplaceConsoleParentSoftwareState;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** --------------------------------------------------------------------------------------------- */ 
let $78ad46e0d6808149$export$1393796fd66f6532 = /*#__PURE__*/ function(MarketplaceConsolePaymentModel) {
    MarketplaceConsolePaymentModel["Free"] = "FREE";
    MarketplaceConsolePaymentModel["PaidViaAtlassian"] = "PAID_VIA_ATLASSIAN";
    MarketplaceConsolePaymentModel["PaidViaVendor"] = "PAID_VIA_VENDOR";
    return MarketplaceConsolePaymentModel;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */ 
let $78ad46e0d6808149$export$7e092f87e8d91044 = /*#__PURE__*/ function(MarketplaceConsolePricingCurrency) {
    MarketplaceConsolePricingCurrency["Jpy"] = "JPY";
    MarketplaceConsolePricingCurrency["Usd"] = "USD";
    return MarketplaceConsolePricingCurrency;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */ 
let $78ad46e0d6808149$export$4c5c05b960837cad = /*#__PURE__*/ function(MarketplaceConsolePricingPlanStatus) {
    MarketplaceConsolePricingPlanStatus["Draft"] = "DRAFT";
    MarketplaceConsolePricingPlanStatus["Live"] = "LIVE";
    MarketplaceConsolePricingPlanStatus["Pending"] = "PENDING";
    return MarketplaceConsolePricingPlanStatus;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** --------------------------------------------------------------------------------------------- */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Represents links pertaining to a remotely fetched artifact */  /** Represents an artifact which was fetched from a remote URL */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** --------------------------------------------------------------------------------------------- */  /** --------------------------------------------------------------------------------------------- */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** Status of an entity in Marketplace system */ 
let $78ad46e0d6808149$export$8b7b15f5e0317b5a = /*#__PURE__*/ function(MarketplaceEntityStatus) {
    MarketplaceEntityStatus["Active"] = "ACTIVE";
    MarketplaceEntityStatus["Archived"] = "ARCHIVED";
    return MarketplaceEntityStatus;
}({}); /** An image file in Atlassian Marketplace system */  /** Instructional app deployment properties */  /** Image to be displayed on a listing in Marketplace */  /** Status of app’s listing in Marketplace. */ 
let $78ad46e0d6808149$export$1a1d4383d2498aa8 = /*#__PURE__*/ function(MarketplaceListingStatus) {
    MarketplaceListingStatus["Private"] = "PRIVATE";
    MarketplaceListingStatus["Public"] = "PUBLIC";
    MarketplaceListingStatus["ReadyToLaunch"] = "READY_TO_LAUNCH";
    MarketplaceListingStatus["Rejected"] = "REJECTED";
    MarketplaceListingStatus["Submitted"] = "SUBMITTED";
    return MarketplaceListingStatus;
}({}); /** Marketplace location */ 
let $78ad46e0d6808149$export$25ad001a38719422 = /*#__PURE__*/ function(MarketplaceLocation) {
    MarketplaceLocation["InProduct"] = "IN_PRODUCT";
    MarketplaceLocation["Website"] = "WEBSITE";
    return MarketplaceLocation;
}({}); /** Marketplace Partners provide apps and integrations available for purchase on the Atlassian Marketplace that extend the power of Atlassian products. */  /** Marketplace Partner's address */  /** Marketplace Partner's contact information */  /** Marketplace Programs that this Marketplace Partner has participated in. */  /** Marketplace Partner's support information. */  /** Marketplace Partner's support availability information */  /** Marketplace Partner's support contact information */  /** Marketplace Partner's support holiday */  /** Tells whether support is on holiday only one time or if it repeats annually. */ 
let $78ad46e0d6808149$export$96bfc8c3eec61fd0 = /*#__PURE__*/ function(MarketplacePartnerSupportHolidayFrequency) {
    MarketplacePartnerSupportHolidayFrequency["Annual"] = "ANNUAL";
    MarketplacePartnerSupportHolidayFrequency["OneTime"] = "ONE_TIME";
    return MarketplacePartnerSupportHolidayFrequency;
}({}); /** Marketplace Partner's tier */ 
let $78ad46e0d6808149$export$4f999921e3690a15 = /*#__PURE__*/ function(MarketplacePartnerTierType) {
    MarketplacePartnerTierType["Gold"] = "GOLD";
    MarketplacePartnerTierType["Platinum"] = "PLATINUM";
    MarketplacePartnerTierType["Silver"] = "SILVER";
    return MarketplacePartnerTierType;
}({}); /** Tells if the Marketplace partner is an Atlassian’s internal one. */ 
let $78ad46e0d6808149$export$8fec59d6f9a79101 = /*#__PURE__*/ function(MarketplacePartnerType) {
    MarketplacePartnerType["AtlassianInternal"] = "ATLASSIAN_INTERNAL";
    return MarketplacePartnerType;
}({}); /** Plugins1 app deployment properties */  /** Plugins2 app deployment properties */  /** Pricing items based on tiers */  /** Pricing plan for a marketplace entity */  /** Option parameters to fetch pricing plan for a marketplace entity */  /** Status of the plan : LIVE, PENDING or DRAFT */ 
let $78ad46e0d6808149$export$72afefd58b6b80d0 = /*#__PURE__*/ function(MarketplacePricingPlanStatus) {
    MarketplacePricingPlanStatus["Draft"] = "DRAFT";
    MarketplacePricingPlanStatus["Live"] = "LIVE";
    MarketplacePricingPlanStatus["Pending"] = "PENDING";
    return MarketplacePricingPlanStatus;
}({}); /** Mode of the tier : GRADUATED (progressive PUP), VOLUME (constant for all users) */ 
let $78ad46e0d6808149$export$3c578ff2609d82d7 = /*#__PURE__*/ function(MarketplacePricingTierMode) {
    MarketplacePricingTierMode["Graduated"] = "GRADUATED";
    MarketplacePricingTierMode["Volume"] = "VOLUME";
    return MarketplacePricingTierMode;
}({}); /** Policy of the tier : BLOCK (FLAT) or PER_UNIT (PUP) */ 
let $78ad46e0d6808149$export$7edcca7ce5991948 = /*#__PURE__*/ function(MarketplacePricingTierPolicy) {
    MarketplacePricingTierPolicy["Block"] = "BLOCK";
    MarketplacePricingTierPolicy["PerUnit"] = "PER_UNIT";
    return MarketplacePricingTierPolicy;
}({}); /** Type of the tier */ 
let $78ad46e0d6808149$export$645f0980d82252ac = /*#__PURE__*/ function(MarketplacePricingTierType) {
    MarketplacePricingTierType["RemoteAgentTiered"] = "REMOTE_AGENT_TIERED";
    MarketplacePricingTierType["UserTiered"] = "USER_TIERED";
    return MarketplacePricingTierType;
}({});
let $78ad46e0d6808149$export$2cbd5d0207702c5 = /*#__PURE__*/ function(MarketplaceProgramStatus) {
    MarketplaceProgramStatus["Applied"] = "APPLIED";
    MarketplaceProgramStatus["Approved"] = "APPROVED";
    MarketplaceProgramStatus["NotAParticipant"] = "NOT_A_PARTICIPANT";
    MarketplaceProgramStatus["Rejected"] = "REJECTED";
    return MarketplaceProgramStatus;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /**
 * Metadata for algolia which can be used by the UI to fetch
 * app tiles data corresponding to a collection, category etc.
 *
 * Will be deprecated when search service starts providing app tiles data
 * in which case, BFF should integrate with search service to return the app tiles
 * data directly
 */ 
let $78ad46e0d6808149$export$da28f7301ad006a5 = /*#__PURE__*/ function(MarketplaceStoreDeveloperSpaceStatus) {
    MarketplaceStoreDeveloperSpaceStatus["Active"] = "ACTIVE";
    MarketplaceStoreDeveloperSpaceStatus["Archived"] = "ARCHIVED";
    MarketplaceStoreDeveloperSpaceStatus["Inactive"] = "INACTIVE";
    return MarketplaceStoreDeveloperSpaceStatus;
}({}); /** --------------------------------------------------------------------------------------------- */ 
let $78ad46e0d6808149$export$b36f406ff2fbbafe = /*#__PURE__*/ function(MarketplaceStoreHomePageHighlightedSectionVariation) {
    MarketplaceStoreHomePageHighlightedSectionVariation["Prominent"] = "PROMINENT";
    return MarketplaceStoreHomePageHighlightedSectionVariation;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /**
 * These breakpoints map to the breakpoints on the client
 * eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required
 */ 
let $78ad46e0d6808149$export$f6c61b63a81bc74a = /*#__PURE__*/ function(MarketplaceStoreInstallAppStatus) {
    MarketplaceStoreInstallAppStatus["InProgress"] = "IN_PROGRESS";
    MarketplaceStoreInstallAppStatus["Pending"] = "PENDING";
    MarketplaceStoreInstallAppStatus["ProvisioningFailure"] = "PROVISIONING_FAILURE";
    MarketplaceStoreInstallAppStatus["Success"] = "SUCCESS";
    MarketplaceStoreInstallAppStatus["TimedOut"] = "TIMED_OUT";
    return MarketplaceStoreInstallAppStatus;
}({}); /** Input for specifying the target or "site" of an app installation. */  /** Products onto which an app can be installed */ 
let $78ad46e0d6808149$export$36ca2010d8fa9f9a = /*#__PURE__*/ function(MarketplaceStoreInstallationTargetProduct) {
    MarketplaceStoreInstallationTargetProduct["Compass"] = "COMPASS";
    MarketplaceStoreInstallationTargetProduct["Confluence"] = "CONFLUENCE";
    MarketplaceStoreInstallationTargetProduct["Jira"] = "JIRA";
    return MarketplaceStoreInstallationTargetProduct;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /**
 * This is a top level mutation type under which all of Marketplace Store's supported mutations
 * will reside. It is namespaced to avoid conflicts with other Atlassian mutations.
 */ 
let $78ad46e0d6808149$export$ebb4384456a718fc = /*#__PURE__*/ function(MarketplaceStorePartnerEnrollmentProgram) {
    MarketplaceStorePartnerEnrollmentProgram["MarketplacePartner"] = "MARKETPLACE_PARTNER";
    MarketplaceStorePartnerEnrollmentProgram["SolutionPartner"] = "SOLUTION_PARTNER";
    return MarketplaceStorePartnerEnrollmentProgram;
}({});
let $78ad46e0d6808149$export$e29b364dec316f58 = /*#__PURE__*/ function(MarketplaceStorePartnerEnrollmentProgramValue) {
    MarketplaceStorePartnerEnrollmentProgramValue["Gold"] = "GOLD";
    MarketplaceStorePartnerEnrollmentProgramValue["Platinum"] = "PLATINUM";
    MarketplaceStorePartnerEnrollmentProgramValue["Silver"] = "SILVER";
    return MarketplaceStorePartnerEnrollmentProgramValue;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */ 
let $78ad46e0d6808149$export$9f0778caa5aa9129 = /*#__PURE__*/ function(MarketplaceStorePartnerSupportAvailabilityDay) {
    MarketplaceStorePartnerSupportAvailabilityDay["Friday"] = "FRIDAY";
    MarketplaceStorePartnerSupportAvailabilityDay["Monday"] = "MONDAY";
    MarketplaceStorePartnerSupportAvailabilityDay["Saturday"] = "SATURDAY";
    MarketplaceStorePartnerSupportAvailabilityDay["Sunday"] = "SUNDAY";
    MarketplaceStorePartnerSupportAvailabilityDay["Thursday"] = "THURSDAY";
    MarketplaceStorePartnerSupportAvailabilityDay["Tuesday"] = "TUESDAY";
    MarketplaceStorePartnerSupportAvailabilityDay["Wednesday"] = "WEDNESDAY";
    return MarketplaceStorePartnerSupportAvailabilityDay;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /**
 * This is a top level query "namespace" under which all of Marketplace Store's supported queries
 * will reside. The namespace allows us to avoid conflicts with other Atlassian queries.
 * Only queries within this namespace will be available on the Atlassian GraphQL Gateway.
 */ 
let $78ad46e0d6808149$export$2dd83c49139620d1 = /*#__PURE__*/ function(MembershipRole) {
    MembershipRole["Admin"] = "ADMIN";
    MembershipRole["Regular"] = "REGULAR";
    return MembershipRole;
}({}); /** The settings which a team can have describing how members are added to the team */ 
let $78ad46e0d6808149$export$86e062496769357c = /*#__PURE__*/ function(MembershipSetting) {
    MembershipSetting["MemberInvite"] = "MEMBER_INVITE";
    MembershipSetting["Open"] = "OPEN";
    return MembershipSetting;
}({}); /** The states that a member can have within a team */ 
let $78ad46e0d6808149$export$74cd14b61afb55b0 = /*#__PURE__*/ function(MembershipState) {
    MembershipState["Alumni"] = "ALUMNI";
    MembershipState["FullMember"] = "FULL_MEMBER";
    MembershipState["Invited"] = "INVITED";
    MembershipState["RequestingToJoin"] = "REQUESTING_TO_JOIN";
    return MembershipState;
}({}); /**
 * ------------------------------------------------------
 *  Watch/Unwatch Focus Area mutations
 * ------------------------------------------------------
 */ 
let $78ad46e0d6808149$export$973400a550f738ec = /*#__PURE__*/ function(MercuryAggregatedHeadcountSortField) {
    MercuryAggregatedHeadcountSortField["FilledPositions"] = "FILLED_POSITIONS";
    MercuryAggregatedHeadcountSortField["OpenPositions"] = "OPEN_POSITIONS";
    MercuryAggregatedHeadcountSortField["TotalHeadcount"] = "TOTAL_HEADCOUNT";
    return MercuryAggregatedHeadcountSortField;
}({}); /** Counts by Focus Area Status at the level of a Portfolio */  /**
 * ------------------------------------------------------
 *  Focus Area
 * ------------------------------------------------------
 */ 
let $78ad46e0d6808149$export$bc3e48f4065d763e = /*#__PURE__*/ function(MercuryEntityType) {
    MercuryEntityType["Comment"] = "COMMENT";
    MercuryEntityType["FocusArea"] = "FOCUS_AREA";
    MercuryEntityType["FocusAreaStatusUpdate"] = "FOCUS_AREA_STATUS_UPDATE";
    MercuryEntityType["Program"] = "PROGRAM";
    MercuryEntityType["ProgramStatusUpdate"] = "PROGRAM_STATUS_UPDATE";
    return MercuryEntityType;
}({}); /** ADF holding the about content within the editor */ 
let $78ad46e0d6808149$export$b8aac8b3d4a5c526 = /*#__PURE__*/ function(MercuryFocusAreaHealthColor) {
    MercuryFocusAreaHealthColor["Green"] = "GREEN";
    MercuryFocusAreaHealthColor["Red"] = "RED";
    MercuryFocusAreaHealthColor["Yellow"] = "YELLOW";
    return MercuryFocusAreaHealthColor;
}({});
let $78ad46e0d6808149$export$aabad147dc044911 = /*#__PURE__*/ function(MercuryFocusAreaHierarchySortField) {
    MercuryFocusAreaHierarchySortField["HierarchyLevel"] = "HIERARCHY_LEVEL";
    MercuryFocusAreaHierarchySortField["Name"] = "NAME";
    return MercuryFocusAreaHierarchySortField;
}({});
let $78ad46e0d6808149$export$a1abf0dad11e643b = /*#__PURE__*/ function(MercuryFocusAreaSortField) {
    MercuryFocusAreaSortField["Budget"] = "BUDGET";
    MercuryFocusAreaSortField["FocusAreaType"] = "FOCUS_AREA_TYPE";
    MercuryFocusAreaSortField["HasParent"] = "HAS_PARENT";
    MercuryFocusAreaSortField["HierarchyLevel"] = "HIERARCHY_LEVEL";
    MercuryFocusAreaSortField["LastUpdated"] = "LAST_UPDATED";
    MercuryFocusAreaSortField["Name"] = "NAME";
    MercuryFocusAreaSortField["Spend"] = "SPEND";
    MercuryFocusAreaSortField["Status"] = "STATUS";
    MercuryFocusAreaSortField["TargetDate"] = "TARGET_DATE";
    MercuryFocusAreaSortField["Watching"] = "WATCHING";
    return MercuryFocusAreaSortField;
}({}); /** Counts by different Focus Area status */  /**
 * ------------------------------------------------------
 *  Atlassian Intelligence
 * ------------------------------------------------------
 */ 
let $78ad46e0d6808149$export$64e01af19826bbd8 = /*#__PURE__*/ function(MercuryFocusAreaTeamAllocationAggregationSortField) {
    MercuryFocusAreaTeamAllocationAggregationSortField["FilledPositions"] = "FILLED_POSITIONS";
    MercuryFocusAreaTeamAllocationAggregationSortField["OpenPositions"] = "OPEN_POSITIONS";
    MercuryFocusAreaTeamAllocationAggregationSortField["TeamName"] = "TEAM_NAME";
    MercuryFocusAreaTeamAllocationAggregationSortField["TotalPositions"] = "TOTAL_POSITIONS";
    return MercuryFocusAreaTeamAllocationAggregationSortField;
}({}); /** Aggregation of headcount and positions for a focus area and its children. */  /**
 * ------------------------------------------------------
 *  Focus Area links
 * ------------------------------------------------------
 */ 
let $78ad46e0d6808149$export$ae3bb205c58a2aef = /*#__PURE__*/ function(MercuryProviderConfigurationStatus) {
    MercuryProviderConfigurationStatus["Connected"] = "CONNECTED";
    MercuryProviderConfigurationStatus["SignUp"] = "SIGN_UP";
    return MercuryProviderConfigurationStatus;
}({}); /**
 * ----------------------------------------
 *  Provider Pagination
 * ----------------------------------------
 */ 
let $78ad46e0d6808149$export$3733411202b02987 = /*#__PURE__*/ function(MercuryProviderWorkErrorType) {
    MercuryProviderWorkErrorType["Invalid"] = "INVALID";
    MercuryProviderWorkErrorType["NotFound"] = "NOT_FOUND";
    MercuryProviderWorkErrorType["NoPermissions"] = "NO_PERMISSIONS";
    return MercuryProviderWorkErrorType;
}({});
let $78ad46e0d6808149$export$9f4b40ce69c1d6a5 = /*#__PURE__*/ function(MercuryProviderWorkStatusColor) {
    MercuryProviderWorkStatusColor["Blue"] = "BLUE";
    MercuryProviderWorkStatusColor["Gray"] = "GRAY";
    MercuryProviderWorkStatusColor["Green"] = "GREEN";
    MercuryProviderWorkStatusColor["Red"] = "RED";
    MercuryProviderWorkStatusColor["Yellow"] = "YELLOW";
    return MercuryProviderWorkStatusColor;
}({});
let $78ad46e0d6808149$export$26be07f0f07696ad = /*#__PURE__*/ function(MercuryProviderWorkTargetDateType) {
    MercuryProviderWorkTargetDateType["Day"] = "DAY";
    MercuryProviderWorkTargetDateType["Month"] = "MONTH";
    MercuryProviderWorkTargetDateType["Quarter"] = "QUARTER";
    return MercuryProviderWorkTargetDateType;
}({}); /**
 * ----------------------------------------
 *  Preference Mutations
 * ----------------------------------------
 */ 
let $78ad46e0d6808149$export$5615eb511c3f7b44 = /*#__PURE__*/ function(MercuryTargetDateType) {
    MercuryTargetDateType["Day"] = "DAY";
    MercuryTargetDateType["Month"] = "MONTH";
    MercuryTargetDateType["Quarter"] = "QUARTER";
    return MercuryTargetDateType;
}({}); /** Team's capacity for allocation to a focus area. */ 
let $78ad46e0d6808149$export$6eb0d144e13a497b = /*#__PURE__*/ function(MercuryTeamFocusAreaAllocationSortField) {
    MercuryTeamFocusAreaAllocationSortField["FilledPositions"] = "FILLED_POSITIONS";
    MercuryTeamFocusAreaAllocationSortField["OpenPositions"] = "OPEN_POSITIONS";
    return MercuryTeamFocusAreaAllocationSortField;
}({}); /**
 * ------------------------------------------------------
 *  Team
 * ------------------------------------------------------
 */ 
let $78ad46e0d6808149$export$8c8ab86a3ad574d9 = /*#__PURE__*/ function(MercuryTeamSortField) {
    MercuryTeamSortField["Name"] = "NAME";
    return MercuryTeamSortField;
}({}); /**
 * ----------------------------------------
 *  Focus Area workflow mutations
 * ----------------------------------------
 */ 
let $78ad46e0d6808149$export$e5ba5b8b5f2756a8 = /*#__PURE__*/ function(MigrationEventStatus) {
    MigrationEventStatus["Cancelled"] = "CANCELLED";
    MigrationEventStatus["Cancelling"] = "CANCELLING";
    MigrationEventStatus["Failed"] = "FAILED";
    MigrationEventStatus["Incomplete"] = "INCOMPLETE";
    MigrationEventStatus["InProgress"] = "IN_PROGRESS";
    MigrationEventStatus["Paused"] = "PAUSED";
    MigrationEventStatus["Ready"] = "READY";
    MigrationEventStatus["Skipped"] = "SKIPPED";
    MigrationEventStatus["Success"] = "SUCCESS";
    MigrationEventStatus["TimedOut"] = "TIMED_OUT";
    return MigrationEventStatus;
}({}); /** An enum of the possible types of a migration event. */ 
let $78ad46e0d6808149$export$6b9f180c97bd81c9 = /*#__PURE__*/ function(MigrationEventType) {
    MigrationEventType["Container"] = "CONTAINER";
    MigrationEventType["Migration"] = "MIGRATION";
    MigrationEventType["Transfer"] = "TRANSFER";
    return MigrationEventType;
}({}); /** A type that represents a migrationPlanningService event. */  /** The top-level migrationPlanningService subscription type. */  /** The top-level migrationPlanningService subscription type. */  /** A type that represents a migration progress event. */  /** The top-level migration query type. */  /** The top-level migration query type. */  /** The top-level migration subscription type. */  /** The top-level migration subscription type. */  /** The top-level migration subscription type. */  /** Card mutations response */  /** Move sprint down */  /** Move sprint up */  /** An error that has occurred in response to a mutation */  /**
 * A error type that can be returned in response to a failed mutation
 *
 * This extension carries additional categorisation information about the error
 */ 
let $78ad46e0d6808149$export$a7e8a9c9b5c9e259 = /*#__PURE__*/ function(NadelHydrationTemplate) {
    NadelHydrationTemplate["NadelPlaceholder"] = "NADEL_PLACEHOLDER";
    return NadelHydrationTemplate;
}({}); /** Minimal details required to create a new card (as opposed to Card which is everything). */ 
let $78ad46e0d6808149$export$e129faa8dbff76aa = /*#__PURE__*/ function(NlpDisclaimer) {
    NlpDisclaimer["WhoQuestion"] = "WHO_QUESTION";
    return NlpDisclaimer;
}({});
let $78ad46e0d6808149$export$c5b04a82c748b9bd = /*#__PURE__*/ function(NlpErrorState) {
    NlpErrorState["AcceptableUseViolations"] = "ACCEPTABLE_USE_VIOLATIONS";
    NlpErrorState["AiDisabled"] = "AI_DISABLED";
    NlpErrorState["NoAnswer"] = "NO_ANSWER";
    NlpErrorState["NoAnswerHydration"] = "NO_ANSWER_HYDRATION";
    NlpErrorState["NoAnswerKeywords"] = "NO_ANSWER_KEYWORDS";
    NlpErrorState["NoAnswerOpenAiResponseErr"] = "NO_ANSWER_OPEN_AI_RESPONSE_ERR";
    NlpErrorState["NoAnswerRelevantContent"] = "NO_ANSWER_RELEVANT_CONTENT";
    NlpErrorState["NoAnswerSearchResults"] = "NO_ANSWER_SEARCH_RESULTS";
    NlpErrorState["NoAnswerWhoQuestion"] = "NO_ANSWER_WHO_QUESTION";
    NlpErrorState["OpenaiRateLimitUserAbuse"] = "OPENAI_RATE_LIMIT_USER_ABUSE";
    NlpErrorState["SubjectiveQuery"] = "SUBJECTIVE_QUERY";
    return NlpErrorState;
}({}); /** For Reading Aids */ 
let $78ad46e0d6808149$export$db433339b7e07571 = /*#__PURE__*/ function(NlpGetKeywordsTextFormat) {
    NlpGetKeywordsTextFormat["Adf"] = "ADF";
    NlpGetKeywordsTextFormat["PlainText"] = "PLAIN_TEXT";
    return NlpGetKeywordsTextFormat;
}({}); /** Result for Q&A Searches */ 
let $78ad46e0d6808149$export$b1971cd5d32db392 = /*#__PURE__*/ function(NlpSearchResultFormat) {
    NlpSearchResultFormat["Adf"] = "ADF";
    NlpSearchResultFormat["Json"] = "JSON";
    NlpSearchResultFormat["Markdown"] = "MARKDOWN";
    NlpSearchResultFormat["PlainText"] = "PLAIN_TEXT";
    return NlpSearchResultFormat;
}({});
let $78ad46e0d6808149$export$3f22e424998acb73 = /*#__PURE__*/ function(NlpSearchResultType) {
    NlpSearchResultType["Blogpost"] = "blogpost";
    NlpSearchResultType["Page"] = "page";
    NlpSearchResultType["User"] = "user";
    return NlpSearchResultType;
}({}); /**
 * From the [relay Node specification](https://relay.dev/graphql/objectidentification.htm#sec-Node-Interface)
 *
 * The server must provide an interface called `Node`. That interface must include exactly one field, called `id` that returns a non-null `ID`.
 *
 * This `id` should be a globally unique identifier for this object, and given just this `id`, the server should be able to refetch the object.
 */ 
let $78ad46e0d6808149$export$d197034e0ce6cbfa = /*#__PURE__*/ function(PeapProgramStatus) {
    PeapProgramStatus["Abandoned"] = "ABANDONED";
    PeapProgramStatus["Active"] = "ACTIVE";
    PeapProgramStatus["Ended"] = "ENDED";
    PeapProgramStatus["New"] = "NEW";
    PeapProgramStatus["Planned"] = "PLANNED";
    return PeapProgramStatus;
}({}); /** Query Parameters when looking for EAPs */  /**
 * input PEAPUserSiteEnrollmentMutationInput {
 *   programId: ID!
 *   cloudId: ID! #@ARI(....)
 *   desiredStatus: Boolean!
 * }
 * input PEAPOrgEnrollmentMutationInput {
 *   programId: ID!
 *   orgId: ID! @ARI(type: "org", owner: "platform")
 *   desiredStatus: Boolean!
 * }
 * input PEAPOrgUserEnrollmentMutationInput {
 *   programId: ID!
 *   orgId: ID! @ARI(type: "org", owner: "platform")
 *   desiredStatus: Boolean!
 * }
 */ 
let $78ad46e0d6808149$export$20d511023e79b2f8 = /*#__PURE__*/ function(PartnerBtfLicenseType) {
    PartnerBtfLicenseType["Academic"] = "ACADEMIC";
    PartnerBtfLicenseType["Commercial"] = "COMMERCIAL";
    PartnerBtfLicenseType["Evaluation"] = "EVALUATION";
    PartnerBtfLicenseType["Starter"] = "STARTER";
    return PartnerBtfLicenseType;
}({});
let $78ad46e0d6808149$export$d8bdcda0cbd9a410 = /*#__PURE__*/ function(PartnerCloudLicenseType) {
    PartnerCloudLicenseType["Academic"] = "ACADEMIC";
    PartnerCloudLicenseType["Commercial"] = "COMMERCIAL";
    PartnerCloudLicenseType["Community"] = "COMMUNITY";
    PartnerCloudLicenseType["Demonstration"] = "DEMONSTRATION";
    PartnerCloudLicenseType["Developer"] = "DEVELOPER";
    PartnerCloudLicenseType["Evaluation"] = "EVALUATION";
    PartnerCloudLicenseType["Free"] = "FREE";
    PartnerCloudLicenseType["OpenSource"] = "OPEN_SOURCE";
    PartnerCloudLicenseType["Starter"] = "STARTER";
    return PartnerCloudLicenseType;
}({});
let $78ad46e0d6808149$export$f0c4b6a2f4cddbe1 = /*#__PURE__*/ function(PartnerCurrency) {
    PartnerCurrency["Jpy"] = "JPY";
    PartnerCurrency["Usd"] = "USD";
    return PartnerCurrency;
}({});
let $78ad46e0d6808149$export$e141851b33100510 = /*#__PURE__*/ function(PartnerInvoiceJsonCurrency) {
    PartnerInvoiceJsonCurrency["Aud"] = "AUD";
    PartnerInvoiceJsonCurrency["Eur"] = "EUR";
    PartnerInvoiceJsonCurrency["Gbp"] = "GBP";
    PartnerInvoiceJsonCurrency["Jpy"] = "JPY";
    PartnerInvoiceJsonCurrency["Usd"] = "USD";
    return PartnerInvoiceJsonCurrency;
}({}); /** --------------------------------------------------------------------------------------------- */  /** Search for available product offerings */  /** The general shape of a mutation response. */  /** ## Plan mode create cards ### */ 
let $78ad46e0d6808149$export$f2dc2b898b108911 = /*#__PURE__*/ function(PlanModeDestination) {
    PlanModeDestination["Backlog"] = "BACKLOG";
    PlanModeDestination["Board"] = "BOARD";
    PlanModeDestination["Sprint"] = "SPRINT";
    return PlanModeDestination;
}({}); /** # Types */ 
let $78ad46e0d6808149$export$2cbcdf3f71413e2f = /*#__PURE__*/ function(PolarisCommentKind) {
    PolarisCommentKind["PlayContribution"] = "PLAY_CONTRIBUTION";
    PolarisCommentKind["View"] = "VIEW";
    return PolarisCommentKind;
}({}); /** # Types */ 
let $78ad46e0d6808149$export$fb5683d231e089bf = /*#__PURE__*/ function(PolarisFieldType) {
    PolarisFieldType["PolarisIdeaDateField"] = "PolarisIdeaDateField";
    PolarisFieldType["PolarisIdeaDateTimeField"] = "PolarisIdeaDateTimeField";
    PolarisFieldType["PolarisIdeaExternalReferenceField"] = "PolarisIdeaExternalReferenceField";
    PolarisFieldType["PolarisIdeaExternalReferencePropertyField"] = "PolarisIdeaExternalReferencePropertyField";
    PolarisFieldType["PolarisIdeaIntervalField"] = "PolarisIdeaIntervalField";
    PolarisFieldType["PolarisIdeaLabelsField"] = "PolarisIdeaLabelsField";
    PolarisFieldType["PolarisIdeaNumberField"] = "PolarisIdeaNumberField";
    PolarisFieldType["PolarisIdeaOptionField"] = "PolarisIdeaOptionField";
    PolarisFieldType["PolarisIdeaOptionsField"] = "PolarisIdeaOptionsField";
    PolarisFieldType["PolarisIdeaPlayField"] = "PolarisIdeaPlayField";
    PolarisFieldType["PolarisIdeaReactionsField"] = "PolarisIdeaReactionsField";
    PolarisFieldType["PolarisIdeaStringField"] = "PolarisIdeaStringField";
    PolarisFieldType["PolarisIdeaUserField"] = "PolarisIdeaUserField";
    PolarisFieldType["PolarisIdeaUsersField"] = "PolarisIdeaUsersField";
    PolarisFieldType["PolarisJiraField"] = "PolarisJiraField";
    return PolarisFieldType;
}({}); /** # Types */  /**
 * An PolarisIdeaField is a unit of information that can be instantiated
 * for an PolarisIdea.
 */ 
let $78ad46e0d6808149$export$123c361c0586acd4 = /*#__PURE__*/ function(PolarisPlayKind) {
    PolarisPlayKind["PolarisBudgetAllocationPlay"] = "PolarisBudgetAllocationPlay";
    return PolarisPlayKind;
}({}); /**
 * ======================================
 *   _____             _    _
 *  |  __ \           | |  (_)
 *  | |__) |__ _ _ __ | | ___ _ __   __ _
 *  |  _  // _` | '_ \| |/ / | '_ \ / _` |
 *  | | \ \ (_| | | | |   <| | | | | (_| |
 *  |_|  \_\__,_|_| |_|_|\_\_|_| |_|\__, |
 *                                   __/ |
 *                                  |___/
 *  Mutations
 */ 
let $78ad46e0d6808149$export$ec111ec92c0d7d70 = /*#__PURE__*/ function(PolarisRefreshError) {
    PolarisRefreshError["InternalError"] = "INTERNAL_ERROR";
    PolarisRefreshError["InvalidSnippet"] = "INVALID_SNIPPET";
    PolarisRefreshError["NeedAuth"] = "NEED_AUTH";
    PolarisRefreshError["NotFound"] = "NOT_FOUND";
    return PolarisRefreshError;
}({}); /** # Types */ 
let $78ad46e0d6808149$export$f3e14b5f4d20c3d5 = /*#__PURE__*/ function(PolarisResolvedObjectAuthType) {
    PolarisResolvedObjectAuthType["ApiKey"] = "API_KEY";
    PolarisResolvedObjectAuthType["Oauth2"] = "OAUTH2";
    return PolarisResolvedObjectAuthType;
}({}); /** # Types */ 
let $78ad46e0d6808149$export$57783d255575ae4b = /*#__PURE__*/ function(PolarisSnippetPropertyKind) {
    PolarisSnippetPropertyKind["Labels"] = "LABELS";
    PolarisSnippetPropertyKind["Number"] = "NUMBER";
    PolarisSnippetPropertyKind["Rating"] = "RATING";
    return PolarisSnippetPropertyKind;
}({});
let $78ad46e0d6808149$export$bda785e7d71f1240 = /*#__PURE__*/ function(PolarisSortOrder) {
    PolarisSortOrder["Asc"] = "ASC";
    PolarisSortOrder["Desc"] = "DESC";
    return PolarisSortOrder;
}({});
let $78ad46e0d6808149$export$14a23e97810cf04b = /*#__PURE__*/ function(PolarisTimelineMode) {
    PolarisTimelineMode["Months"] = "MONTHS";
    PolarisTimelineMode["Quarters"] = "QUARTERS";
    PolarisTimelineMode["Years"] = "YEARS";
    return PolarisTimelineMode;
}({});
let $78ad46e0d6808149$export$2b6d541a0ba09b1f = /*#__PURE__*/ function(PolarisValueOperator) {
    PolarisValueOperator["Eq"] = "EQ";
    PolarisValueOperator["Gt"] = "GT";
    PolarisValueOperator["Gte"] = "GTE";
    PolarisValueOperator["Lt"] = "LT";
    PolarisValueOperator["Lte"] = "LTE";
    return PolarisValueOperator;
}({});
let $78ad46e0d6808149$export$dbd70c8a392059ec = /*#__PURE__*/ function(PolarisViewFieldRollupType) {
    PolarisViewFieldRollupType["Avg"] = "AVG";
    PolarisViewFieldRollupType["Count"] = "COUNT";
    PolarisViewFieldRollupType["Empty"] = "EMPTY";
    PolarisViewFieldRollupType["Filled"] = "FILLED";
    PolarisViewFieldRollupType["Max"] = "MAX";
    PolarisViewFieldRollupType["Median"] = "MEDIAN";
    PolarisViewFieldRollupType["Min"] = "MIN";
    PolarisViewFieldRollupType["Range"] = "RANGE";
    PolarisViewFieldRollupType["Sum"] = "SUM";
    return PolarisViewFieldRollupType;
}({}); /** # Types */ 
let $78ad46e0d6808149$export$54183e329a6730fd = /*#__PURE__*/ function(PolarisViewFilterKind) {
    PolarisViewFilterKind["FieldIdentity"] = "FIELD_IDENTITY";
    PolarisViewFilterKind["FieldNumeric"] = "FIELD_NUMERIC";
    PolarisViewFilterKind["Interval"] = "INTERVAL";
    PolarisViewFilterKind["Text"] = "TEXT";
    return PolarisViewFilterKind;
}({});
let $78ad46e0d6808149$export$d6c8f262b1709692 = /*#__PURE__*/ function(PolarisViewFilterOperator) {
    PolarisViewFilterOperator["EndAfterNow"] = "END_AFTER_NOW";
    PolarisViewFilterOperator["EndBeforeNow"] = "END_BEFORE_NOW";
    PolarisViewFilterOperator["Eq"] = "EQ";
    PolarisViewFilterOperator["Gt"] = "GT";
    PolarisViewFilterOperator["Gte"] = "GTE";
    PolarisViewFilterOperator["Lt"] = "LT";
    PolarisViewFilterOperator["Lte"] = "LTE";
    PolarisViewFilterOperator["Neq"] = "NEQ";
    PolarisViewFilterOperator["StartAfterNow"] = "START_AFTER_NOW";
    PolarisViewFilterOperator["StartBeforeNow"] = "START_BEFORE_NOW";
    return PolarisViewFilterOperator;
}({});
let $78ad46e0d6808149$export$2503fee82ee05536 = /*#__PURE__*/ function(PolarisViewLayoutType) {
    PolarisViewLayoutType["Compact"] = "COMPACT";
    PolarisViewLayoutType["Detailed"] = "DETAILED";
    PolarisViewLayoutType["Summary"] = "SUMMARY";
    return PolarisViewLayoutType;
}({}); /** # Types */ 
let $78ad46e0d6808149$export$975689d1b7b4351b = /*#__PURE__*/ function(PolarisViewSetType) {
    PolarisViewSetType["Capture"] = "CAPTURE";
    PolarisViewSetType["Custom"] = "CUSTOM";
    PolarisViewSetType["Deliver"] = "DELIVER";
    PolarisViewSetType["Prioritize"] = "PRIORITIZE";
    PolarisViewSetType["Section"] = "SECTION";
    PolarisViewSetType["Single"] = "SINGLE";
    PolarisViewSetType["System"] = "SYSTEM";
    return PolarisViewSetType;
}({});
let $78ad46e0d6808149$export$6d557cf9ccdcf3b3 = /*#__PURE__*/ function(PolarisViewSortMode) {
    PolarisViewSortMode["FieldsSort"] = "FIELDS_SORT";
    PolarisViewSortMode["ProjectRank"] = "PROJECT_RANK";
    PolarisViewSortMode["ViewRank"] = "VIEW_RANK";
    return PolarisViewSortMode;
}({});
let $78ad46e0d6808149$export$9dec0b77614b677b = /*#__PURE__*/ function(PolarisVisualizationType) {
    PolarisVisualizationType["Board"] = "BOARD";
    PolarisVisualizationType["Matrix"] = "MATRIX";
    PolarisVisualizationType["Table"] = "TABLE";
    PolarisVisualizationType["Timeline"] = "TIMELINE";
    PolarisVisualizationType["Twoxtwo"] = "TWOXTWO";
    return PolarisVisualizationType;
}({}); /**
 * Principals types that App can allow for unlicensed access. This maps to different type of users in product.
 * For example - in case of JSM users can be UNLICENSED, CUSTOMER and ANONYMOUS.
 * UNLICENSED is Atlassian Account users who do not have a license on the underlying product where the extension is rendering
 * CUSTOMER - A site-specific Customer Account (accountId in format qm:{uuid}:{uuid} see https://developer.atlassian.com/platform/identity/rest/v1/))
 * ANONYMOUS - An invocation by a user that is not authenticated i.e. a Public JSM Portal/Confluence Space/Jira Project etc
 */ 
let $78ad46e0d6808149$export$39adac38571da5a2 = /*#__PURE__*/ function(PrincipalType) {
    PrincipalType["Anonymous"] = "ANONYMOUS";
    PrincipalType["Customer"] = "CUSTOMER";
    PrincipalType["Unlicensed"] = "UNLICENSED";
    return PrincipalType;
}({}); /** Listing data for a product */  /** Listing data for a product */  /** Listing data for a product */  /** Product Listing Information or associated error in querying */  /** Accepts input to find pull requests based on the status and time range. */  /** Entry point for query suggestion */  /** Entry point for query suggestion */  /** Metadata on any analytics related fields, these do not affect the search */  /** Filters to apply to query suggestions */ 
let $78ad46e0d6808149$export$e0affd64059d9f82 = /*#__PURE__*/ function(RateLimitingCurrency) {
    RateLimitingCurrency["CannedResponseMutationCurrency"] = "CANNED_RESPONSE_MUTATION_CURRENCY";
    RateLimitingCurrency["CannedResponseQueryCurrency"] = "CANNED_RESPONSE_QUERY_CURRENCY";
    RateLimitingCurrency["CompassSynchronizeLinkAssociationsCurrency"] = "COMPASS_SYNCHRONIZE_LINK_ASSOCIATIONS_CURRENCY";
    RateLimitingCurrency["DevopsContainerRelationshipsReadCurrency"] = "DEVOPS_CONTAINER_RELATIONSHIPS_READ_CURRENCY";
    RateLimitingCurrency["DevopsContainerRelationshipsWriteCurrency"] = "DEVOPS_CONTAINER_RELATIONSHIPS_WRITE_CURRENCY";
    RateLimitingCurrency["DevopsServiceReadCurrency"] = "DEVOPS_SERVICE_READ_CURRENCY";
    RateLimitingCurrency["DevopsServiceWriteCurrency"] = "DEVOPS_SERVICE_WRITE_CURRENCY";
    RateLimitingCurrency["ExportMetricsCurrency"] = "EXPORT_METRICS_CURRENCY";
    RateLimitingCurrency["ForgeAlertsCurrency"] = "FORGE_ALERTS_CURRENCY";
    RateLimitingCurrency["ForgeAppContributorCurrency"] = "FORGE_APP_CONTRIBUTOR_CURRENCY";
    RateLimitingCurrency["ForgeAuditLogsCurrency"] = "FORGE_AUDIT_LOGS_CURRENCY";
    RateLimitingCurrency["ForgeMetricsCurrency"] = "FORGE_METRICS_CURRENCY";
    RateLimitingCurrency["HelpCenterCurrency"] = "HELP_CENTER_CURRENCY";
    RateLimitingCurrency["HelpLayoutCurrency"] = "HELP_LAYOUT_CURRENCY";
    RateLimitingCurrency["HelpObjectStoreCurrency"] = "HELP_OBJECT_STORE_CURRENCY";
    RateLimitingCurrency["KnowledgeBaseCurrency"] = "KNOWLEDGE_BASE_CURRENCY";
    RateLimitingCurrency["PolarisBetaUserCurrency"] = "POLARIS_BETA_USER_CURRENCY";
    RateLimitingCurrency["PolarisCollabTokenQueryCurrency"] = "POLARIS_COLLAB_TOKEN_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisCommentCurrency"] = "POLARIS_COMMENT_CURRENCY";
    RateLimitingCurrency["PolarisCurrency"] = "POLARIS_CURRENCY";
    RateLimitingCurrency["PolarisFieldCurrency"] = "POLARIS_FIELD_CURRENCY";
    RateLimitingCurrency["PolarisIdeaCurrency"] = "POLARIS_IDEA_CURRENCY";
    RateLimitingCurrency["PolarisIdeaTemplatesQueryCurrency"] = "POLARIS_IDEA_TEMPLATES_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisIdeaTemplateCurrency"] = "POLARIS_IDEA_TEMPLATE_CURRENCY";
    RateLimitingCurrency["PolarisInsightsQueryCurrency"] = "POLARIS_INSIGHTS_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisInsightsWithErrorsQueryCurrency"] = "POLARIS_INSIGHTS_WITH_ERRORS_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisInsightCurrency"] = "POLARIS_INSIGHT_CURRENCY";
    RateLimitingCurrency["PolarisInsightQueryCurrency"] = "POLARIS_INSIGHT_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisLabelsQueryCurrency"] = "POLARIS_LABELS_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisOnboardingCurrency"] = "POLARIS_ONBOARDING_CURRENCY";
    RateLimitingCurrency["PolarisPlayCurrency"] = "POLARIS_PLAY_CURRENCY";
    RateLimitingCurrency["PolarisProjectConfigCurrency"] = "POLARIS_PROJECT_CONFIG_CURRENCY";
    RateLimitingCurrency["PolarisProjectQueryCurrency"] = "POLARIS_PROJECT_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisRankingCurrency"] = "POLARIS_RANKING_CURRENCY";
    RateLimitingCurrency["PolarisReactionCurrency"] = "POLARIS_REACTION_CURRENCY";
    RateLimitingCurrency["PolarisSnippetCurrency"] = "POLARIS_SNIPPET_CURRENCY";
    RateLimitingCurrency["PolarisSnippetPropertiesConfigQueryCurrency"] = "POLARIS_SNIPPET_PROPERTIES_CONFIG_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisTermsConsentQueryCurrency"] = "POLARIS_TERMS_CONSENT_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisUnfurlCurrency"] = "POLARIS_UNFURL_CURRENCY";
    RateLimitingCurrency["PolarisViewsetCurrency"] = "POLARIS_VIEWSET_CURRENCY";
    RateLimitingCurrency["PolarisViewArrangementInfoQueryCurrency"] = "POLARIS_VIEW_ARRANGEMENT_INFO_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisViewCurrency"] = "POLARIS_VIEW_CURRENCY";
    RateLimitingCurrency["PolarisViewQueryCurrency"] = "POLARIS_VIEW_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisWriteCurrency"] = "POLARIS_WRITE_CURRENCY";
    RateLimitingCurrency["ShepherdDefaultCurrency"] = "SHEPHERD_DEFAULT_CURRENCY";
    RateLimitingCurrency["ShepherdMultipleReadsCurrency"] = "SHEPHERD_MULTIPLE_READS_CURRENCY";
    RateLimitingCurrency["ShepherdReadAlertCurrency"] = "SHEPHERD_READ_ALERT_CURRENCY";
    RateLimitingCurrency["TeamsCurrency"] = "TEAMS_CURRENCY";
    RateLimitingCurrency["TeamMembersCurrency"] = "TEAM_MEMBERS_CURRENCY";
    RateLimitingCurrency["TeamMembersV2Currency"] = "TEAM_MEMBERS_V2_CURRENCY";
    RateLimitingCurrency["TeamRoleGrantsMutatePrincipalsCurrency"] = "TEAM_ROLE_GRANTS_MUTATE_PRINCIPALS_CURRENCY";
    RateLimitingCurrency["TeamRoleGrantsQueryPrincipalsCurrency"] = "TEAM_ROLE_GRANTS_QUERY_PRINCIPALS_CURRENCY";
    RateLimitingCurrency["TeamSearchCurrency"] = "TEAM_SEARCH_CURRENCY";
    RateLimitingCurrency["TeamSearchV2Currency"] = "TEAM_SEARCH_V2_CURRENCY";
    RateLimitingCurrency["TeamV2Currency"] = "TEAM_V2_CURRENCY";
    RateLimitingCurrency["TestingService"] = "TESTING_SERVICE";
    RateLimitingCurrency["TrelloCurrency"] = "TRELLO_CURRENCY";
    RateLimitingCurrency["TrelloMutationCurrency"] = "TRELLO_MUTATION_CURRENCY";
    return RateLimitingCurrency;
}({}); /** Represents a status object from a workflow in Jira without any calculcated fields */  /**
 * Establish tunnels for a specific environment of an app.
 *
 * This will create a cloudflare tunnel for forge app debugging
 */ 
let $78ad46e0d6808149$export$4df1ed283b73df16 = /*#__PURE__*/ function(RoadmapChildIssuePlanningMode) {
    RoadmapChildIssuePlanningMode["Date"] = "DATE";
    RoadmapChildIssuePlanningMode["Disabled"] = "DISABLED";
    RoadmapChildIssuePlanningMode["Sprint"] = "SPRINT";
    return RoadmapChildIssuePlanningMode;
}({}); /** Relay connection definition for a roadmap item */  /** Relay edge definition for a roadmap item */  /** Details of a component */  /** Content of a valid roadmap */  /** Content of a valid roadmap */  /** Content of a valid roadmap */  /** Details of a custom filter */  /** Details about dependency configuration for roadmaps */  /** Details of a roadmap */  /** View settings for epics on the roadmap */ 
let $78ad46e0d6808149$export$1c9f5b28aa44f22d = /*#__PURE__*/ function(RoadmapEpicView) {
    RoadmapEpicView["All"] = "ALL";
    RoadmapEpicView["Completed"] = "COMPLETED";
    RoadmapEpicView["Incomplete"] = "INCOMPLETE";
    return RoadmapEpicView;
}({}); /** Configuration values for the external system(s) behind the roadmap data */  /** Details of a field derived from JQL */  /** Field configuration */  /** Details about filter configuration for roadmaps */  /** Describes a problem with the roadmaps that needs to be resolved in order to successfully fetch the content */  /** Link to a documentation page relevant to the healthcheck */  /** Healthcheck resolution action */  /** Details about hierarchy configuration for roadmaps */  /** The roadmap item data */  /** Relay connection definition for a roadmap item */  /** Relay edge definition for a roadmap item */  /** Details of the status an item has */  /** Details of the category that a status belongs to */  /** Information about the type of a roadmap Item */  /** Relay connection definition for a roadmap item */  /** Relay edge definition for a roadmap item */  /** View settings for hierarchy level one items on the roadmap */ 
let $78ad46e0d6808149$export$7f14fc5a386166cb = /*#__PURE__*/ function(RoadmapLevelOneView) {
    RoadmapLevelOneView["Complete1M"] = "COMPLETE1M";
    RoadmapLevelOneView["Complete3M"] = "COMPLETE3M";
    RoadmapLevelOneView["Complete6M"] = "COMPLETE6M";
    RoadmapLevelOneView["Complete9M"] = "COMPLETE9M";
    RoadmapLevelOneView["Complete12M"] = "COMPLETE12M";
    RoadmapLevelOneView["Incomplete"] = "INCOMPLETE";
    return RoadmapLevelOneView;
}({}); /**
 * ###########################################################################
 * ####################### END ROADMAP QUERIES TYPES #########################
 * ###########################################################################
 * ###########################################################################
 * ######### BELOW HERE ARE THE TYPES SUPPORTING ROADMAPS MUTATIONS ##########
 * ###########################################################################
 */ 
let $78ad46e0d6808149$export$6df418813509b448 = /*#__PURE__*/ function(RoadmapPaletteColor) {
    RoadmapPaletteColor["Blue"] = "BLUE";
    RoadmapPaletteColor["DarkBlue"] = "DARK_BLUE";
    RoadmapPaletteColor["DarkGreen"] = "DARK_GREEN";
    RoadmapPaletteColor["DarkGrey"] = "DARK_GREY";
    RoadmapPaletteColor["DarkOrange"] = "DARK_ORANGE";
    RoadmapPaletteColor["DarkPurple"] = "DARK_PURPLE";
    RoadmapPaletteColor["DarkTeal"] = "DARK_TEAL";
    RoadmapPaletteColor["DarkYellow"] = "DARK_YELLOW";
    RoadmapPaletteColor["Green"] = "GREEN";
    RoadmapPaletteColor["Grey"] = "GREY";
    RoadmapPaletteColor["Orange"] = "ORANGE";
    RoadmapPaletteColor["Purple"] = "PURPLE";
    RoadmapPaletteColor["Teal"] = "TEAL";
    RoadmapPaletteColor["Yellow"] = "YELLOW";
    return RoadmapPaletteColor;
}({}); /** Aggregated progress of child issues */  /** Details of a project for a roadmap */  /** Configuration details specific to a project */  /** Information about the permissions available for the roadmap project for the current user */  /** Details about how valid the roadmap project is */  /** Details of a quick filter */ 
let $78ad46e0d6808149$export$718224d6d55ce2e9 = /*#__PURE__*/ function(RoadmapRankPosition) {
    RoadmapRankPosition["After"] = "AFTER";
    RoadmapRankPosition["Before"] = "BEFORE";
    return RoadmapRankPosition;
}({}); /** Input for setting up a project with a roadmap */  /** Input for a single roadmap schedule item. */  /** Input of a roadmap schedule items mutation. */  /** Details of a roadmap sprint */  /** States that a sprint can be in */ 
let $78ad46e0d6808149$export$8fd1e37e60920853 = /*#__PURE__*/ function(RoadmapSprintState) {
    RoadmapSprintState["Active"] = "ACTIVE";
    RoadmapSprintState["Closed"] = "CLOSED";
    RoadmapSprintState["Future"] = "FUTURE";
    return RoadmapSprintState;
}({}); /** Details of the roadmap status category */  /** Subtask issues */  /** Subtask issues and its status category details */  /** Defines the available timeline modes */ 
let $78ad46e0d6808149$export$d1eb62afe3c5898c = /*#__PURE__*/ function(RoadmapTimelineMode) {
    RoadmapTimelineMode["Months"] = "MONTHS";
    RoadmapTimelineMode["Quarters"] = "QUARTERS";
    RoadmapTimelineMode["Weeks"] = "WEEKS";
    return RoadmapTimelineMode;
}({}); /** Input of a roadmap update item mutation. */  /** Input for updating roadmap settings */  /** Any user specific configuration for the roadmap */  /** Details of a version */  /** Avaliable version statuses */ 
let $78ad46e0d6808149$export$e12a64c0aae94c50 = /*#__PURE__*/ function(RoadmapVersionStatus) {
    RoadmapVersionStatus["Archived"] = "ARCHIVED";
    RoadmapVersionStatus["Released"] = "RELEASED";
    RoadmapVersionStatus["Unreleased"] = "UNRELEASED";
    return RoadmapVersionStatus;
}({}); /** View settings for items on the roadmap */  /** Top level grouping of potential roadmap queries */  /** Top level grouping of potential roadmap queries */  /** Top level grouping of potential roadmap queries */  /** Top level grouping of potential roadmap queries */  /** Top level grouping of potential roadmap queries */  /** Top level grouping of potential roadmap queries */  /** Top level grouping of potential roadmap queries */  /** Top level grouping of potential roadmap queries */  /** A type that represents a sandbox product. */  /** A type that represents a sandbox event. */  /** An enum of the possible values of a sandbox event result. */ 
let $78ad46e0d6808149$export$74a8f61d42003686 = /*#__PURE__*/ function(SandboxEventResult) {
    SandboxEventResult["Failed"] = "failed";
    SandboxEventResult["Incomplete"] = "incomplete";
    SandboxEventResult["Successful"] = "successful";
    SandboxEventResult["Unknown"] = "unknown";
    return SandboxEventResult;
}({}); /** An enum of the possible values of a sandbox event source. */ 
let $78ad46e0d6808149$export$fc03b8f4df65e1a2 = /*#__PURE__*/ function(SandboxEventSource) {
    SandboxEventSource["Admin"] = "admin";
    SandboxEventSource["System"] = "system";
    SandboxEventSource["User"] = "user";
    return SandboxEventSource;
}({}); /** An enum of the possible values of a sandbox event status. */ 
let $78ad46e0d6808149$export$c4acd5ebccb10941 = /*#__PURE__*/ function(SandboxEventStatus) {
    SandboxEventStatus["AwaitingReplay"] = "awaiting_replay";
    SandboxEventStatus["Cancelled"] = "cancelled";
    SandboxEventStatus["Completed"] = "completed";
    SandboxEventStatus["Started"] = "started";
    return SandboxEventStatus;
}({}); /** An enum of the possible values of a sandbox event type. */ 
let $78ad46e0d6808149$export$e370ebae241bc22f = /*#__PURE__*/ function(SandboxEventType) {
    SandboxEventType["Create"] = "create";
    SandboxEventType["DataClone"] = "data_clone";
    SandboxEventType["DataCloneSelective"] = "data_clone_selective";
    SandboxEventType["HardDelete"] = "hard_delete";
    SandboxEventType["Reset"] = "reset";
    SandboxEventType["Reshard"] = "reshard";
    SandboxEventType["Rollback"] = "rollback";
    SandboxEventType["SoftDelete"] = "soft_delete";
    return SandboxEventType;
}({}); /** The top-level sandbox query type. */  /** The top-level sandbox query type. */  /** The top-level sandbox subscription type. */  /** The top-level sandbox subscription type. */ 
let $78ad46e0d6808149$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["AdminContainer"] = "ADMIN_CONTAINER";
    Scope["ApiAccess"] = "API_ACCESS";
    Scope["ApplicationRoleRead"] = "APPLICATION_ROLE_READ";
    Scope["AsyncTaskDelete"] = "ASYNC_TASK_DELETE";
    Scope["AttachmentDelete"] = "ATTACHMENT_DELETE";
    Scope["AttachmentRead"] = "ATTACHMENT_READ";
    Scope["AttachmentWrite"] = "ATTACHMENT_WRITE";
    Scope["AuditLogRead"] = "AUDIT_LOG_READ";
    Scope["AuthConfluenceUser"] = "AUTH_CONFLUENCE_USER";
    Scope["AvatarDelete"] = "AVATAR_DELETE";
    Scope["AvatarRead"] = "AVATAR_READ";
    Scope["AvatarWrite"] = "AVATAR_WRITE";
    Scope["CatalogRead"] = "CATALOG_READ";
    Scope["CommentDelete"] = "COMMENT_DELETE";
    Scope["CommentPropertyDelete"] = "COMMENT_PROPERTY_DELETE";
    Scope["CommentPropertyRead"] = "COMMENT_PROPERTY_READ";
    Scope["CommentPropertyWrite"] = "COMMENT_PROPERTY_WRITE";
    Scope["CommentRead"] = "COMMENT_READ";
    Scope["CommentWrite"] = "COMMENT_WRITE";
    Scope["CompassAtlassianExternal"] = "COMPASS_ATLASSIAN_EXTERNAL";
    Scope["ConfluenceAtlassianExternal"] = "CONFLUENCE_ATLASSIAN_EXTERNAL";
    Scope["CustomFieldContextualConfigurationRead"] = "CUSTOM_FIELD_CONTEXTUAL_CONFIGURATION_READ";
    Scope["CustomFieldContextualConfigurationWrite"] = "CUSTOM_FIELD_CONTEXTUAL_CONFIGURATION_WRITE";
    Scope["DashboardDelete"] = "DASHBOARD_DELETE";
    Scope["DashboardPropertyDelete"] = "DASHBOARD_PROPERTY_DELETE";
    Scope["DashboardPropertyRead"] = "DASHBOARD_PROPERTY_READ";
    Scope["DashboardPropertyWrite"] = "DASHBOARD_PROPERTY_WRITE";
    Scope["DashboardRead"] = "DASHBOARD_READ";
    Scope["DashboardWrite"] = "DASHBOARD_WRITE";
    Scope["DeleteConfluenceAttachment"] = "DELETE_CONFLUENCE_ATTACHMENT";
    Scope["DeleteConfluenceBlogpost"] = "DELETE_CONFLUENCE_BLOGPOST";
    Scope["DeleteConfluenceComment"] = "DELETE_CONFLUENCE_COMMENT";
    Scope["DeleteConfluenceCustomContent"] = "DELETE_CONFLUENCE_CUSTOM_CONTENT";
    Scope["DeleteConfluencePage"] = "DELETE_CONFLUENCE_PAGE";
    Scope["DeleteConfluenceSpace"] = "DELETE_CONFLUENCE_SPACE";
    Scope["DeleteJswBoardScopeAdmin"] = "DELETE_JSW_BOARD_SCOPE_ADMIN";
    Scope["DeleteJswSprint"] = "DELETE_JSW_SPRINT";
    Scope["DeleteOrganization"] = "DELETE_ORGANIZATION";
    Scope["DeleteOrganizationProperty"] = "DELETE_ORGANIZATION_PROPERTY";
    Scope["DeleteOrganizationUser"] = "DELETE_ORGANIZATION_USER";
    Scope["DeleteRequesttypeProperty"] = "DELETE_REQUESTTYPE_PROPERTY";
    Scope["DeleteRequestFeedback"] = "DELETE_REQUEST_FEEDBACK";
    Scope["DeleteRequestNotification"] = "DELETE_REQUEST_NOTIFICATION";
    Scope["DeleteRequestParticipant"] = "DELETE_REQUEST_PARTICIPANT";
    Scope["DeleteServicedeskCustomer"] = "DELETE_SERVICEDESK_CUSTOMER";
    Scope["DeleteServicedeskOrganization"] = "DELETE_SERVICEDESK_ORGANIZATION";
    Scope["DeleteServicedeskProperty"] = "DELETE_SERVICEDESK_PROPERTY";
    Scope["FieldConfigurationDelete"] = "FIELD_CONFIGURATION_DELETE";
    Scope["FieldConfigurationRead"] = "FIELD_CONFIGURATION_READ";
    Scope["FieldConfigurationSchemeDelete"] = "FIELD_CONFIGURATION_SCHEME_DELETE";
    Scope["FieldConfigurationSchemeRead"] = "FIELD_CONFIGURATION_SCHEME_READ";
    Scope["FieldConfigurationSchemeWrite"] = "FIELD_CONFIGURATION_SCHEME_WRITE";
    Scope["FieldConfigurationWrite"] = "FIELD_CONFIGURATION_WRITE";
    Scope["FieldDefaultValueRead"] = "FIELD_DEFAULT_VALUE_READ";
    Scope["FieldDefaultValueWrite"] = "FIELD_DEFAULT_VALUE_WRITE";
    Scope["FieldDelete"] = "FIELD_DELETE";
    Scope["FieldOptionsRead"] = "FIELD_OPTIONS_READ";
    Scope["FieldOptionDelete"] = "FIELD_OPTION_DELETE";
    Scope["FieldOptionRead"] = "FIELD_OPTION_READ";
    Scope["FieldOptionWrite"] = "FIELD_OPTION_WRITE";
    Scope["FieldRead"] = "FIELD_READ";
    Scope["FieldWrite"] = "FIELD_WRITE";
    Scope["FilterColumnDelete"] = "FILTER_COLUMN_DELETE";
    Scope["FilterColumnRead"] = "FILTER_COLUMN_READ";
    Scope["FilterColumnWrite"] = "FILTER_COLUMN_WRITE";
    Scope["FilterDefaultShareScopeRead"] = "FILTER_DEFAULT_SHARE_SCOPE_READ";
    Scope["FilterDefaultShareScopeWrite"] = "FILTER_DEFAULT_SHARE_SCOPE_WRITE";
    Scope["FilterDelete"] = "FILTER_DELETE";
    Scope["FilterRead"] = "FILTER_READ";
    Scope["FilterWrite"] = "FILTER_WRITE";
    Scope["GroupDelete"] = "GROUP_DELETE";
    Scope["GroupRead"] = "GROUP_READ";
    Scope["GroupWrite"] = "GROUP_WRITE";
    Scope["IdentityAtlassianExternal"] = "IDENTITY_ATLASSIAN_EXTERNAL";
    Scope["InstanceConfigurationRead"] = "INSTANCE_CONFIGURATION_READ";
    Scope["InstanceConfigurationWrite"] = "INSTANCE_CONFIGURATION_WRITE";
    Scope["IssueAdjustmentsDelete"] = "ISSUE_ADJUSTMENTS_DELETE";
    Scope["IssueAdjustmentsRead"] = "ISSUE_ADJUSTMENTS_READ";
    Scope["IssueAdjustmentsWrite"] = "ISSUE_ADJUSTMENTS_WRITE";
    Scope["IssueChangelogRead"] = "ISSUE_CHANGELOG_READ";
    Scope["IssueDelete"] = "ISSUE_DELETE";
    Scope["IssueDetailsRead"] = "ISSUE_DETAILS_READ";
    Scope["IssueEventRead"] = "ISSUE_EVENT_READ";
    Scope["IssueFieldValuesRead"] = "ISSUE_FIELD_VALUES_READ";
    Scope["IssueLinkDelete"] = "ISSUE_LINK_DELETE";
    Scope["IssueLinkRead"] = "ISSUE_LINK_READ";
    Scope["IssueLinkTypeDelete"] = "ISSUE_LINK_TYPE_DELETE";
    Scope["IssueLinkTypeRead"] = "ISSUE_LINK_TYPE_READ";
    Scope["IssueLinkTypeWrite"] = "ISSUE_LINK_TYPE_WRITE";
    Scope["IssueLinkWrite"] = "ISSUE_LINK_WRITE";
    Scope["IssueMetaRead"] = "ISSUE_META_READ";
    Scope["IssuePropertyDelete"] = "ISSUE_PROPERTY_DELETE";
    Scope["IssuePropertyRead"] = "ISSUE_PROPERTY_READ";
    Scope["IssuePropertyWrite"] = "ISSUE_PROPERTY_WRITE";
    Scope["IssueRead"] = "ISSUE_READ";
    Scope["IssueRemoteLinkDelete"] = "ISSUE_REMOTE_LINK_DELETE";
    Scope["IssueRemoteLinkRead"] = "ISSUE_REMOTE_LINK_READ";
    Scope["IssueRemoteLinkWrite"] = "ISSUE_REMOTE_LINK_WRITE";
    Scope["IssueSecurityLevelRead"] = "ISSUE_SECURITY_LEVEL_READ";
    Scope["IssueSecuritySchemeRead"] = "ISSUE_SECURITY_SCHEME_READ";
    Scope["IssueStatusRead"] = "ISSUE_STATUS_READ";
    Scope["IssueTimeTrackingRead"] = "ISSUE_TIME_TRACKING_READ";
    Scope["IssueTimeTrackingWrite"] = "ISSUE_TIME_TRACKING_WRITE";
    Scope["IssueTransitionRead"] = "ISSUE_TRANSITION_READ";
    Scope["IssueTypeDelete"] = "ISSUE_TYPE_DELETE";
    Scope["IssueTypeHierarchyRead"] = "ISSUE_TYPE_HIERARCHY_READ";
    Scope["IssueTypePropertyDelete"] = "ISSUE_TYPE_PROPERTY_DELETE";
    Scope["IssueTypePropertyRead"] = "ISSUE_TYPE_PROPERTY_READ";
    Scope["IssueTypePropertyWrite"] = "ISSUE_TYPE_PROPERTY_WRITE";
    Scope["IssueTypeRead"] = "ISSUE_TYPE_READ";
    Scope["IssueTypeSchemeDelete"] = "ISSUE_TYPE_SCHEME_DELETE";
    Scope["IssueTypeSchemeRead"] = "ISSUE_TYPE_SCHEME_READ";
    Scope["IssueTypeSchemeWrite"] = "ISSUE_TYPE_SCHEME_WRITE";
    Scope["IssueTypeScreenSchemeDelete"] = "ISSUE_TYPE_SCREEN_SCHEME_DELETE";
    Scope["IssueTypeScreenSchemeRead"] = "ISSUE_TYPE_SCREEN_SCHEME_READ";
    Scope["IssueTypeScreenSchemeWrite"] = "ISSUE_TYPE_SCREEN_SCHEME_WRITE";
    Scope["IssueTypeWrite"] = "ISSUE_TYPE_WRITE";
    Scope["IssueVotesRead"] = "ISSUE_VOTES_READ";
    Scope["IssueVoteRead"] = "ISSUE_VOTE_READ";
    Scope["IssueVoteWrite"] = "ISSUE_VOTE_WRITE";
    Scope["IssueWatcherRead"] = "ISSUE_WATCHER_READ";
    Scope["IssueWatcherWrite"] = "ISSUE_WATCHER_WRITE";
    Scope["IssueWorklogDelete"] = "ISSUE_WORKLOG_DELETE";
    Scope["IssueWorklogPropertyDelete"] = "ISSUE_WORKLOG_PROPERTY_DELETE";
    Scope["IssueWorklogPropertyRead"] = "ISSUE_WORKLOG_PROPERTY_READ";
    Scope["IssueWorklogPropertyWrite"] = "ISSUE_WORKLOG_PROPERTY_WRITE";
    Scope["IssueWorklogRead"] = "ISSUE_WORKLOG_READ";
    Scope["IssueWorklogWrite"] = "ISSUE_WORKLOG_WRITE";
    Scope["IssueWrite"] = "ISSUE_WRITE";
    Scope["JiraAtlassianExternal"] = "JIRA_ATLASSIAN_EXTERNAL";
    Scope["JiraExpressionsRead"] = "JIRA_EXPRESSIONS_READ";
    Scope["JqlRead"] = "JQL_READ";
    Scope["JqlValidate"] = "JQL_VALIDATE";
    Scope["LabelRead"] = "LABEL_READ";
    Scope["LicenseRead"] = "LICENSE_READ";
    Scope["ManageApp"] = "MANAGE_APP";
    Scope["ManageDirectory"] = "MANAGE_DIRECTORY";
    Scope["ManageJiraConfiguration"] = "MANAGE_JIRA_CONFIGURATION";
    Scope["ManageJiraDataProvider"] = "MANAGE_JIRA_DATA_PROVIDER";
    Scope["ManageJiraProject"] = "MANAGE_JIRA_PROJECT";
    Scope["ManageJiraWebhook"] = "MANAGE_JIRA_WEBHOOK";
    Scope["ManageOrg"] = "MANAGE_ORG";
    Scope["ManageOrgPublicApis"] = "MANAGE_ORG_PUBLIC_APIS";
    Scope["ManageServicedeskCustomer"] = "MANAGE_SERVICEDESK_CUSTOMER";
    Scope["MigrateConfluence"] = "MIGRATE_CONFLUENCE";
    Scope["NotificationSchemeRead"] = "NOTIFICATION_SCHEME_READ";
    Scope["NotificationSend"] = "NOTIFICATION_SEND";
    Scope["PermissionDelete"] = "PERMISSION_DELETE";
    Scope["PermissionRead"] = "PERMISSION_READ";
    Scope["PermissionSchemeDelete"] = "PERMISSION_SCHEME_DELETE";
    Scope["PermissionSchemeRead"] = "PERMISSION_SCHEME_READ";
    Scope["PermissionSchemeWrite"] = "PERMISSION_SCHEME_WRITE";
    Scope["PermissionWrite"] = "PERMISSION_WRITE";
    Scope["PriorityRead"] = "PRIORITY_READ";
    Scope["ProjectAvatarDelete"] = "PROJECT_AVATAR_DELETE";
    Scope["ProjectAvatarRead"] = "PROJECT_AVATAR_READ";
    Scope["ProjectAvatarWrite"] = "PROJECT_AVATAR_WRITE";
    Scope["ProjectCategoryDelete"] = "PROJECT_CATEGORY_DELETE";
    Scope["ProjectCategoryRead"] = "PROJECT_CATEGORY_READ";
    Scope["ProjectCategoryWrite"] = "PROJECT_CATEGORY_WRITE";
    Scope["ProjectComponentDelete"] = "PROJECT_COMPONENT_DELETE";
    Scope["ProjectComponentRead"] = "PROJECT_COMPONENT_READ";
    Scope["ProjectComponentWrite"] = "PROJECT_COMPONENT_WRITE";
    Scope["ProjectDelete"] = "PROJECT_DELETE";
    Scope["ProjectEmailRead"] = "PROJECT_EMAIL_READ";
    Scope["ProjectEmailWrite"] = "PROJECT_EMAIL_WRITE";
    Scope["ProjectFeatureRead"] = "PROJECT_FEATURE_READ";
    Scope["ProjectFeatureWrite"] = "PROJECT_FEATURE_WRITE";
    Scope["ProjectPropertyDelete"] = "PROJECT_PROPERTY_DELETE";
    Scope["ProjectPropertyRead"] = "PROJECT_PROPERTY_READ";
    Scope["ProjectPropertyWrite"] = "PROJECT_PROPERTY_WRITE";
    Scope["ProjectRead"] = "PROJECT_READ";
    Scope["ProjectRoleDelete"] = "PROJECT_ROLE_DELETE";
    Scope["ProjectRoleRead"] = "PROJECT_ROLE_READ";
    Scope["ProjectRoleWrite"] = "PROJECT_ROLE_WRITE";
    Scope["ProjectTypeRead"] = "PROJECT_TYPE_READ";
    Scope["ProjectVersionDelete"] = "PROJECT_VERSION_DELETE";
    Scope["ProjectVersionRead"] = "PROJECT_VERSION_READ";
    Scope["ProjectVersionWrite"] = "PROJECT_VERSION_WRITE";
    Scope["ProjectWrite"] = "PROJECT_WRITE";
    Scope["PullRequest"] = "PULL_REQUEST";
    Scope["PullRequestWrite"] = "PULL_REQUEST_WRITE";
    Scope["ReadAccount"] = "READ_ACCOUNT";
    Scope["ReadCompassAttentionItem"] = "READ_COMPASS_ATTENTION_ITEM";
    Scope["ReadCompassComponent"] = "READ_COMPASS_COMPONENT";
    Scope["ReadCompassEvent"] = "READ_COMPASS_EVENT";
    Scope["ReadCompassMetric"] = "READ_COMPASS_METRIC";
    Scope["ReadCompassScorecard"] = "READ_COMPASS_SCORECARD";
    Scope["ReadConfluenceAttachment"] = "READ_CONFLUENCE_ATTACHMENT";
    Scope["ReadConfluenceAuditLog"] = "READ_CONFLUENCE_AUDIT_LOG";
    Scope["ReadConfluenceBlogpost"] = "READ_CONFLUENCE_BLOGPOST";
    Scope["ReadConfluenceComment"] = "READ_CONFLUENCE_COMMENT";
    Scope["ReadConfluenceConfiguration"] = "READ_CONFLUENCE_CONFIGURATION";
    Scope["ReadConfluenceContentAnalytics"] = "READ_CONFLUENCE_CONTENT_ANALYTICS";
    Scope["ReadConfluenceContentMetadata"] = "READ_CONFLUENCE_CONTENT_METADATA";
    Scope["ReadConfluenceContentPermission"] = "READ_CONFLUENCE_CONTENT_PERMISSION";
    Scope["ReadConfluenceContentProperty"] = "READ_CONFLUENCE_CONTENT_PROPERTY";
    Scope["ReadConfluenceContentRestriction"] = "READ_CONFLUENCE_CONTENT_RESTRICTION";
    Scope["ReadConfluenceCustomContent"] = "READ_CONFLUENCE_CUSTOM_CONTENT";
    Scope["ReadConfluenceGroup"] = "READ_CONFLUENCE_GROUP";
    Scope["ReadConfluenceInlineTask"] = "READ_CONFLUENCE_INLINE_TASK";
    Scope["ReadConfluenceLabel"] = "READ_CONFLUENCE_LABEL";
    Scope["ReadConfluencePage"] = "READ_CONFLUENCE_PAGE";
    Scope["ReadConfluenceRelation"] = "READ_CONFLUENCE_RELATION";
    Scope["ReadConfluenceSpace"] = "READ_CONFLUENCE_SPACE";
    Scope["ReadConfluenceSpacePermission"] = "READ_CONFLUENCE_SPACE_PERMISSION";
    Scope["ReadConfluenceSpaceProperty"] = "READ_CONFLUENCE_SPACE_PROPERTY";
    Scope["ReadConfluenceSpaceSetting"] = "READ_CONFLUENCE_SPACE_SETTING";
    Scope["ReadConfluenceTemplate"] = "READ_CONFLUENCE_TEMPLATE";
    Scope["ReadConfluenceUser"] = "READ_CONFLUENCE_USER";
    Scope["ReadConfluenceUserProperty"] = "READ_CONFLUENCE_USER_PROPERTY";
    Scope["ReadConfluenceWatcher"] = "READ_CONFLUENCE_WATCHER";
    Scope["ReadContainer"] = "READ_CONTAINER";
    Scope["ReadCustomer"] = "READ_CUSTOMER";
    Scope["ReadDesign"] = "READ_DESIGN";
    Scope["ReadJiraUser"] = "READ_JIRA_USER";
    Scope["ReadJiraWork"] = "READ_JIRA_WORK";
    Scope["ReadJswBoardScope"] = "READ_JSW_BOARD_SCOPE";
    Scope["ReadJswBoardScopeAdmin"] = "READ_JSW_BOARD_SCOPE_ADMIN";
    Scope["ReadJswBuild"] = "READ_JSW_BUILD";
    Scope["ReadJswDeployment"] = "READ_JSW_DEPLOYMENT";
    Scope["ReadJswEpic"] = "READ_JSW_EPIC";
    Scope["ReadJswFeatureFlag"] = "READ_JSW_FEATURE_FLAG";
    Scope["ReadJswIssue"] = "READ_JSW_ISSUE";
    Scope["ReadJswRemoteLink"] = "READ_JSW_REMOTE_LINK";
    Scope["ReadJswSourceCode"] = "READ_JSW_SOURCE_CODE";
    Scope["ReadJswSprint"] = "READ_JSW_SPRINT";
    Scope["ReadKnowledgebase"] = "READ_KNOWLEDGEBASE";
    Scope["ReadMe"] = "READ_ME";
    Scope["ReadMercury"] = "READ_MERCURY";
    Scope["ReadNotifications"] = "READ_NOTIFICATIONS";
    Scope["ReadOrganization"] = "READ_ORGANIZATION";
    Scope["ReadOrganizationProperty"] = "READ_ORGANIZATION_PROPERTY";
    Scope["ReadOrganizationUser"] = "READ_ORGANIZATION_USER";
    Scope["ReadQueue"] = "READ_QUEUE";
    Scope["ReadRequest"] = "READ_REQUEST";
    Scope["ReadRequesttype"] = "READ_REQUESTTYPE";
    Scope["ReadRequesttypeProperty"] = "READ_REQUESTTYPE_PROPERTY";
    Scope["ReadRequestAction"] = "READ_REQUEST_ACTION";
    Scope["ReadRequestApproval"] = "READ_REQUEST_APPROVAL";
    Scope["ReadRequestAttachment"] = "READ_REQUEST_ATTACHMENT";
    Scope["ReadRequestComment"] = "READ_REQUEST_COMMENT";
    Scope["ReadRequestFeedback"] = "READ_REQUEST_FEEDBACK";
    Scope["ReadRequestNotification"] = "READ_REQUEST_NOTIFICATION";
    Scope["ReadRequestParticipant"] = "READ_REQUEST_PARTICIPANT";
    Scope["ReadRequestSla"] = "READ_REQUEST_SLA";
    Scope["ReadRequestStatus"] = "READ_REQUEST_STATUS";
    Scope["ReadServicedesk"] = "READ_SERVICEDESK";
    Scope["ReadServicedeskCustomer"] = "READ_SERVICEDESK_CUSTOMER";
    Scope["ReadServicedeskOrganization"] = "READ_SERVICEDESK_ORGANIZATION";
    Scope["ReadServicedeskProperty"] = "READ_SERVICEDESK_PROPERTY";
    Scope["ReadServicedeskRequest"] = "READ_SERVICEDESK_REQUEST";
    Scope["ReadTeam"] = "READ_TEAM";
    Scope["ReadTeamMembers"] = "READ_TEAM_MEMBERS";
    Scope["ReadTownsquareComment"] = "READ_TOWNSQUARE_COMMENT";
    Scope["ReadTownsquareGoal"] = "READ_TOWNSQUARE_GOAL";
    Scope["ReadTownsquareProject"] = "READ_TOWNSQUARE_PROJECT";
    Scope["ReadTownsquareWorkspace"] = "READ_TOWNSQUARE_WORKSPACE";
    Scope["ResolutionRead"] = "RESOLUTION_READ";
    Scope["ScreenableFieldDelete"] = "SCREENABLE_FIELD_DELETE";
    Scope["ScreenableFieldRead"] = "SCREENABLE_FIELD_READ";
    Scope["ScreenableFieldWrite"] = "SCREENABLE_FIELD_WRITE";
    Scope["ScreenDelete"] = "SCREEN_DELETE";
    Scope["ScreenFieldRead"] = "SCREEN_FIELD_READ";
    Scope["ScreenRead"] = "SCREEN_READ";
    Scope["ScreenSchemeDelete"] = "SCREEN_SCHEME_DELETE";
    Scope["ScreenSchemeRead"] = "SCREEN_SCHEME_READ";
    Scope["ScreenSchemeWrite"] = "SCREEN_SCHEME_WRITE";
    Scope["ScreenTabDelete"] = "SCREEN_TAB_DELETE";
    Scope["ScreenTabRead"] = "SCREEN_TAB_READ";
    Scope["ScreenTabWrite"] = "SCREEN_TAB_WRITE";
    Scope["ScreenWrite"] = "SCREEN_WRITE";
    Scope["StatusRead"] = "STATUS_READ";
    Scope["StorageApp"] = "STORAGE_APP";
    Scope["TrelloAtlassianExternal"] = "TRELLO_ATLASSIAN_EXTERNAL";
    Scope["UserColumnsRead"] = "USER_COLUMNS_READ";
    Scope["UserConfigurationDelete"] = "USER_CONFIGURATION_DELETE";
    Scope["UserConfigurationRead"] = "USER_CONFIGURATION_READ";
    Scope["UserConfigurationWrite"] = "USER_CONFIGURATION_WRITE";
    Scope["UserPropertyDelete"] = "USER_PROPERTY_DELETE";
    Scope["UserPropertyRead"] = "USER_PROPERTY_READ";
    Scope["UserPropertyWrite"] = "USER_PROPERTY_WRITE";
    Scope["UserRead"] = "USER_READ";
    Scope["ViewUserprofile"] = "VIEW_USERPROFILE";
    Scope["WebhookDelete"] = "WEBHOOK_DELETE";
    Scope["WebhookRead"] = "WEBHOOK_READ";
    Scope["WebhookWrite"] = "WEBHOOK_WRITE";
    Scope["WorkflowDelete"] = "WORKFLOW_DELETE";
    Scope["WorkflowPropertyDelete"] = "WORKFLOW_PROPERTY_DELETE";
    Scope["WorkflowPropertyRead"] = "WORKFLOW_PROPERTY_READ";
    Scope["WorkflowPropertyWrite"] = "WORKFLOW_PROPERTY_WRITE";
    Scope["WorkflowRead"] = "WORKFLOW_READ";
    Scope["WorkflowSchemeDelete"] = "WORKFLOW_SCHEME_DELETE";
    Scope["WorkflowSchemeRead"] = "WORKFLOW_SCHEME_READ";
    Scope["WorkflowSchemeWrite"] = "WORKFLOW_SCHEME_WRITE";
    Scope["WorkflowWrite"] = "WORKFLOW_WRITE";
    Scope["WriteCompassComponent"] = "WRITE_COMPASS_COMPONENT";
    Scope["WriteCompassEvent"] = "WRITE_COMPASS_EVENT";
    Scope["WriteCompassMetric"] = "WRITE_COMPASS_METRIC";
    Scope["WriteCompassScorecard"] = "WRITE_COMPASS_SCORECARD";
    Scope["WriteConfluenceAttachment"] = "WRITE_CONFLUENCE_ATTACHMENT";
    Scope["WriteConfluenceAuditLog"] = "WRITE_CONFLUENCE_AUDIT_LOG";
    Scope["WriteConfluenceBlogpost"] = "WRITE_CONFLUENCE_BLOGPOST";
    Scope["WriteConfluenceComment"] = "WRITE_CONFLUENCE_COMMENT";
    Scope["WriteConfluenceConfiguration"] = "WRITE_CONFLUENCE_CONFIGURATION";
    Scope["WriteConfluenceContentProperty"] = "WRITE_CONFLUENCE_CONTENT_PROPERTY";
    Scope["WriteConfluenceContentRestriction"] = "WRITE_CONFLUENCE_CONTENT_RESTRICTION";
    Scope["WriteConfluenceCustomContent"] = "WRITE_CONFLUENCE_CUSTOM_CONTENT";
    Scope["WriteConfluenceGroup"] = "WRITE_CONFLUENCE_GROUP";
    Scope["WriteConfluenceInlineTask"] = "WRITE_CONFLUENCE_INLINE_TASK";
    Scope["WriteConfluenceLabel"] = "WRITE_CONFLUENCE_LABEL";
    Scope["WriteConfluencePage"] = "WRITE_CONFLUENCE_PAGE";
    Scope["WriteConfluenceRelation"] = "WRITE_CONFLUENCE_RELATION";
    Scope["WriteConfluenceSpace"] = "WRITE_CONFLUENCE_SPACE";
    Scope["WriteConfluenceSpacePermission"] = "WRITE_CONFLUENCE_SPACE_PERMISSION";
    Scope["WriteConfluenceSpaceProperty"] = "WRITE_CONFLUENCE_SPACE_PROPERTY";
    Scope["WriteConfluenceSpaceSetting"] = "WRITE_CONFLUENCE_SPACE_SETTING";
    Scope["WriteConfluenceTemplate"] = "WRITE_CONFLUENCE_TEMPLATE";
    Scope["WriteConfluenceUserProperty"] = "WRITE_CONFLUENCE_USER_PROPERTY";
    Scope["WriteConfluenceWatcher"] = "WRITE_CONFLUENCE_WATCHER";
    Scope["WriteContainer"] = "WRITE_CONTAINER";
    Scope["WriteCustomer"] = "WRITE_CUSTOMER";
    Scope["WriteDesign"] = "WRITE_DESIGN";
    Scope["WriteJiraWork"] = "WRITE_JIRA_WORK";
    Scope["WriteJswBoardScope"] = "WRITE_JSW_BOARD_SCOPE";
    Scope["WriteJswBoardScopeAdmin"] = "WRITE_JSW_BOARD_SCOPE_ADMIN";
    Scope["WriteJswBuild"] = "WRITE_JSW_BUILD";
    Scope["WriteJswDeployment"] = "WRITE_JSW_DEPLOYMENT";
    Scope["WriteJswEpic"] = "WRITE_JSW_EPIC";
    Scope["WriteJswFeatureFlag"] = "WRITE_JSW_FEATURE_FLAG";
    Scope["WriteJswIssue"] = "WRITE_JSW_ISSUE";
    Scope["WriteJswRemoteLink"] = "WRITE_JSW_REMOTE_LINK";
    Scope["WriteJswSourceCode"] = "WRITE_JSW_SOURCE_CODE";
    Scope["WriteJswSprint"] = "WRITE_JSW_SPRINT";
    Scope["WriteMercury"] = "WRITE_MERCURY";
    Scope["WriteNotifications"] = "WRITE_NOTIFICATIONS";
    Scope["WriteOrganization"] = "WRITE_ORGANIZATION";
    Scope["WriteOrganizationProperty"] = "WRITE_ORGANIZATION_PROPERTY";
    Scope["WriteOrganizationUser"] = "WRITE_ORGANIZATION_USER";
    Scope["WriteRequest"] = "WRITE_REQUEST";
    Scope["WriteRequesttype"] = "WRITE_REQUESTTYPE";
    Scope["WriteRequesttypeProperty"] = "WRITE_REQUESTTYPE_PROPERTY";
    Scope["WriteRequestApproval"] = "WRITE_REQUEST_APPROVAL";
    Scope["WriteRequestAttachment"] = "WRITE_REQUEST_ATTACHMENT";
    Scope["WriteRequestComment"] = "WRITE_REQUEST_COMMENT";
    Scope["WriteRequestFeedback"] = "WRITE_REQUEST_FEEDBACK";
    Scope["WriteRequestNotification"] = "WRITE_REQUEST_NOTIFICATION";
    Scope["WriteRequestParticipant"] = "WRITE_REQUEST_PARTICIPANT";
    Scope["WriteRequestStatus"] = "WRITE_REQUEST_STATUS";
    Scope["WriteServicedesk"] = "WRITE_SERVICEDESK";
    Scope["WriteServicedeskCustomer"] = "WRITE_SERVICEDESK_CUSTOMER";
    Scope["WriteServicedeskOrganization"] = "WRITE_SERVICEDESK_ORGANIZATION";
    Scope["WriteServicedeskProperty"] = "WRITE_SERVICEDESK_PROPERTY";
    Scope["WriteServicedeskRequest"] = "WRITE_SERVICEDESK_REQUEST";
    Scope["WriteTownsquareGoal"] = "WRITE_TOWNSQUARE_GOAL";
    Scope["WriteTownsquareProject"] = "WRITE_TOWNSQUARE_PROJECT";
    Scope["WriteTownsquareRelationship"] = "WRITE_TOWNSQUARE_RELATIONSHIP";
    return Scope;
}({}); /** The AB test context that can be associated to a specific principal/scope. */  /** Metadata on any analytics related fields, these do not affect the search */ 
let $78ad46e0d6808149$export$58320bdd6b26937a = /*#__PURE__*/ function(SearchBoardProductType) {
    SearchBoardProductType["Business"] = "BUSINESS";
    SearchBoardProductType["Software"] = "SOFTWARE";
    return SearchBoardProductType;
}({});
let $78ad46e0d6808149$export$75fb70288e44d634 = /*#__PURE__*/ function(SearchConfluenceDocumentStatus) {
    SearchConfluenceDocumentStatus["Archived"] = "ARCHIVED";
    SearchConfluenceDocumentStatus["Current"] = "CURRENT";
    SearchConfluenceDocumentStatus["Draft"] = "DRAFT";
    return SearchConfluenceDocumentStatus;
}({}); /**
 * Add only product specific properties below. Generic properties must be in the SearchResult
 *
 * CONFLUENCE
 */ 
let $78ad46e0d6808149$export$641731d7c91b88de = /*#__PURE__*/ function(SearchConfluenceRangeField) {
    SearchConfluenceRangeField["Created"] = "CREATED";
    SearchConfluenceRangeField["Lastmodified"] = "LASTMODIFIED";
    return SearchConfluenceRangeField;
}({});
let $78ad46e0d6808149$export$3646d7b76c420c42 = /*#__PURE__*/ function(SearchContainerStatus) {
    SearchContainerStatus["Archived"] = "ARCHIVED";
    SearchContainerStatus["Current"] = "CURRENT";
    return SearchContainerStatus;
}({}); /** Context for the search experiment */  /** Filters to apply to a search */ 
let $78ad46e0d6808149$export$981cf94add4585a6 = /*#__PURE__*/ function(SearchIssueStatusCategory) {
    SearchIssueStatusCategory["Done"] = "DONE";
    SearchIssueStatusCategory["Open"] = "OPEN";
    return SearchIssueStatusCategory;
}({}); /** L2 Feature Provider */ 
let $78ad46e0d6808149$export$395d337d64b9f57f = /*#__PURE__*/ function(SearchProjectType) {
    SearchProjectType["Business"] = "business";
    SearchProjectType["ProductDiscovery"] = "product_discovery";
    SearchProjectType["ServiceDesk"] = "service_desk";
    SearchProjectType["Software"] = "software";
    return SearchProjectType;
}({}); /** Entry point for all searches */  /** Entry point for all searches */  /** Entry point for all searches */  /** Filters to apply to recent query */  /** Search Result type */  /** Atlas */  /** Bitbucket */  /** Compass */  /** Google */  /** TeamworkGraph type search results */  /** Jira */  /** Jira */  /** Microsoft Document */  /** Slack */  /** Trello */ 
let $78ad46e0d6808149$export$95cacd63dfd98bee = /*#__PURE__*/ function(SearchResultType) {
    SearchResultType["Attachment"] = "attachment";
    SearchResultType["Blogpost"] = "blogpost";
    SearchResultType["Board"] = "board";
    SearchResultType["Comment"] = "comment";
    SearchResultType["Component"] = "component";
    SearchResultType["Dashboard"] = "dashboard";
    SearchResultType["Database"] = "database";
    SearchResultType["Document"] = "document";
    SearchResultType["Embed"] = "embed";
    SearchResultType["Filter"] = "filter";
    SearchResultType["Folder"] = "folder";
    SearchResultType["Goal"] = "goal";
    SearchResultType["Issue"] = "issue";
    SearchResultType["Learning"] = "learning";
    SearchResultType["Message"] = "message";
    SearchResultType["Page"] = "page";
    SearchResultType["Plan"] = "plan";
    SearchResultType["Presentation"] = "presentation";
    SearchResultType["Project"] = "project";
    SearchResultType["Question"] = "question";
    SearchResultType["Repository"] = "repository";
    SearchResultType["Space"] = "space";
    SearchResultType["Spreadsheet"] = "spreadsheet";
    SearchResultType["Tag"] = "tag";
    SearchResultType["Unrecognised"] = "unrecognised";
    SearchResultType["Whiteboard"] = "whiteboard";
    return SearchResultType;
}({}); /** Fields used to sort the query */  /** SearchSortOrder describes the sorting order of the query. */ 
let $78ad46e0d6808149$export$3cf9b6ba26bc95c6 = /*#__PURE__*/ function(SearchSortOrder) {
    SearchSortOrder["Asc"] = "ASC";
    SearchSortOrder["Desc"] = "DESC";
    return SearchSortOrder;
}({});
let $78ad46e0d6808149$export$1eed0ec46c1a7935 = /*#__PURE__*/ function(SearchThirdPartyRangeField) {
    SearchThirdPartyRangeField["Created"] = "CREATED";
    SearchThirdPartyRangeField["Lastmodified"] = "LASTMODIFIED";
    return SearchThirdPartyRangeField;
}({}); /** Generic implementation of MutationResponse for responses that don't need any extra data */  /** Generic implementation of MutationResponse for responses that don't need any extra data */  /** Estimation Mutation */  /** Swimlane Mutations */  /** The kind of action that was performed and caused or contributed to an alert */ 
let $78ad46e0d6808149$export$34f9eb005ab98ff7 = /*#__PURE__*/ function(ShepherdActionType) {
    ShepherdActionType["Activate"] = "ACTIVATE";
    ShepherdActionType["Archive"] = "ARCHIVE";
    ShepherdActionType["Crawl"] = "CRAWL";
    ShepherdActionType["Create"] = "CREATE";
    ShepherdActionType["Deactivate"] = "DEACTIVATE";
    ShepherdActionType["Delete"] = "DELETE";
    ShepherdActionType["Download"] = "DOWNLOAD";
    ShepherdActionType["Export"] = "EXPORT";
    ShepherdActionType["Grant"] = "GRANT";
    ShepherdActionType["Install"] = "INSTALL";
    ShepherdActionType["Login"] = "LOGIN";
    ShepherdActionType["LoginAs"] = "LOGIN_AS";
    ShepherdActionType["Publish"] = "PUBLISH";
    ShepherdActionType["Read"] = "READ";
    ShepherdActionType["Revoke"] = "REVOKE";
    ShepherdActionType["Search"] = "SEARCH";
    ShepherdActionType["Uninstall"] = "UNINSTALL";
    ShepherdActionType["Update"] = "UPDATE";
    return ShepherdActionType;
}({}); /** Represents the pertinent fields of specific events (from the Audit Log, for example) matching given search criteria. */  /** ShepherdActivityHighlight captures a pointer to some user activity that is relevant for an alert. */  /** Contextual information about the activity that originated the alert. */  /** Single data point about distribution of numerical data related to the activity */  /** Represents an actor in the Shepherd system. */  /** Represents an actor in the Shepherd system. */ 
let $78ad46e0d6808149$export$54f03cbb2a3e778f = /*#__PURE__*/ function(ShepherdActorOrgStatus) {
    ShepherdActorOrgStatus["Active"] = "ACTIVE";
    ShepherdActorOrgStatus["Deactivated"] = "DEACTIVATED";
    ShepherdActorOrgStatus["Suspended"] = "SUSPENDED";
    return ShepherdActorOrgStatus;
}({}); /** Represents access to a product for an actor in the Shepherd system. */  /** #### Types: Alert ##### */ 
let $78ad46e0d6808149$export$ec1710c62a266610 = /*#__PURE__*/ function(ShepherdAlertDetectionCategory) {
    ShepherdAlertDetectionCategory["Data"] = "DATA";
    ShepherdAlertDetectionCategory["Threat"] = "THREAT";
    return ShepherdAlertDetectionCategory;
}({}); /** Represents metadata that adds context to the alert */ 
let $78ad46e0d6808149$export$48343fd5997afd49 = /*#__PURE__*/ function(ShepherdAlertStatus) {
    ShepherdAlertStatus["InProgress"] = "IN_PROGRESS";
    ShepherdAlertStatus["Triaged"] = "TRIAGED";
    ShepherdAlertStatus["TriagedExpectedActivity"] = "TRIAGED_EXPECTED_ACTIVITY";
    ShepherdAlertStatus["TriagedTruePositive"] = "TRIAGED_TRUE_POSITIVE";
    ShepherdAlertStatus["Untriaged"] = "UNTRIAGED";
    return ShepherdAlertStatus;
}({}); /**
 * Contains supporting information useful for evaluating an alert.
 * Today it attaches the concept of a "highlight" to alerts. It can be extended to hold additional highlights or
 * other types of information.
 */ 
let $78ad46e0d6808149$export$78b33ffe8847c025 = /*#__PURE__*/ function(ShepherdAlertTemplateType) {
    ShepherdAlertTemplateType["AddedConfluenceGlobalPermission"] = "ADDED_CONFLUENCE_GLOBAL_PERMISSION";
    ShepherdAlertTemplateType["AddedConfluenceSpacePermission"] = "ADDED_CONFLUENCE_SPACE_PERMISSION";
    ShepherdAlertTemplateType["AddedDomain"] = "ADDED_DOMAIN";
    ShepherdAlertTemplateType["AddedJiraGlobalPermission"] = "ADDED_JIRA_GLOBAL_PERMISSION";
    ShepherdAlertTemplateType["AddedOrgadmin"] = "ADDED_ORGADMIN";
    ShepherdAlertTemplateType["BitbucketRepositoryPrivacy"] = "BITBUCKET_REPOSITORY_PRIVACY";
    ShepherdAlertTemplateType["BitbucketWorkspacePrivacy"] = "BITBUCKET_WORKSPACE_PRIVACY";
    ShepherdAlertTemplateType["ClassificationLevelArchived"] = "CLASSIFICATION_LEVEL_ARCHIVED";
    ShepherdAlertTemplateType["ClassificationLevelPublished"] = "CLASSIFICATION_LEVEL_PUBLISHED";
    ShepherdAlertTemplateType["ConfluenceCustomDetection"] = "CONFLUENCE_CUSTOM_DETECTION";
    ShepherdAlertTemplateType["ConfluenceDataDiscovery"] = "CONFLUENCE_DATA_DISCOVERY";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryAtlassianToken"] = "CONFLUENCE_DATA_DISCOVERY_ATLASSIAN_TOKEN";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryAuTfn"] = "CONFLUENCE_DATA_DISCOVERY_AU_TFN";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryAwsKeys"] = "CONFLUENCE_DATA_DISCOVERY_AWS_KEYS";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryCreditCard"] = "CONFLUENCE_DATA_DISCOVERY_CREDIT_CARD";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryCrypto"] = "CONFLUENCE_DATA_DISCOVERY_CRYPTO";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryIban"] = "CONFLUENCE_DATA_DISCOVERY_IBAN";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryJwtKey"] = "CONFLUENCE_DATA_DISCOVERY_JWT_KEY";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryPassword"] = "CONFLUENCE_DATA_DISCOVERY_PASSWORD";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryPrivateKey"] = "CONFLUENCE_DATA_DISCOVERY_PRIVATE_KEY";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryUsSsn"] = "CONFLUENCE_DATA_DISCOVERY_US_SSN";
    ShepherdAlertTemplateType["ConfluencePageCrawling"] = "CONFLUENCE_PAGE_CRAWLING";
    ShepherdAlertTemplateType["ConfluencePageExports"] = "CONFLUENCE_PAGE_EXPORTS";
    ShepherdAlertTemplateType["ConfluenceSiteBackupDownloaded"] = "CONFLUENCE_SITE_BACKUP_DOWNLOADED";
    ShepherdAlertTemplateType["ConfluenceSpaceExports"] = "CONFLUENCE_SPACE_EXPORTS";
    ShepherdAlertTemplateType["ConfluenceSuspiciousSearch"] = "CONFLUENCE_SUSPICIOUS_SEARCH";
    ShepherdAlertTemplateType["CreatedAuthPolicy"] = "CREATED_AUTH_POLICY";
    ShepherdAlertTemplateType["CreatedPolicy"] = "CREATED_POLICY";
    ShepherdAlertTemplateType["CreatedSamlConfig"] = "CREATED_SAML_CONFIG";
    ShepherdAlertTemplateType["CreatedTunnel"] = "CREATED_TUNNEL";
    ShepherdAlertTemplateType["CreatedUserProvisioning"] = "CREATED_USER_PROVISIONING";
    ShepherdAlertTemplateType["DataSecurityPolicyActivated"] = "DATA_SECURITY_POLICY_ACTIVATED";
    ShepherdAlertTemplateType["DataSecurityPolicyDeactivated"] = "DATA_SECURITY_POLICY_DEACTIVATED";
    ShepherdAlertTemplateType["DataSecurityPolicyDeleted"] = "DATA_SECURITY_POLICY_DELETED";
    ShepherdAlertTemplateType["DataSecurityPolicyUpdated"] = "DATA_SECURITY_POLICY_UPDATED";
    ShepherdAlertTemplateType["Default"] = "DEFAULT";
    ShepherdAlertTemplateType["DeletedAuthPolicy"] = "DELETED_AUTH_POLICY";
    ShepherdAlertTemplateType["DeletedDomain"] = "DELETED_DOMAIN";
    ShepherdAlertTemplateType["DeletedPolicy"] = "DELETED_POLICY";
    ShepherdAlertTemplateType["DeletedTunnel"] = "DELETED_TUNNEL";
    ShepherdAlertTemplateType["EcosystemAuditLogInstallationCreated"] = "ECOSYSTEM_AUDIT_LOG_INSTALLATION_CREATED";
    ShepherdAlertTemplateType["EcosystemAuditLogInstallationDeleted"] = "ECOSYSTEM_AUDIT_LOG_INSTALLATION_DELETED";
    ShepherdAlertTemplateType["EcosystemAuditLogUserGrantCreated"] = "ECOSYSTEM_AUDIT_LOG_USER_GRANT_CREATED";
    ShepherdAlertTemplateType["EducationalAlert"] = "EDUCATIONAL_ALERT";
    ShepherdAlertTemplateType["EnableScimSync"] = "ENABLE_SCIM_SYNC";
    ShepherdAlertTemplateType["ExportedOrgeventscsv"] = "EXPORTED_ORGEVENTSCSV";
    ShepherdAlertTemplateType["GrantAssignedJiraPermissionScheme"] = "GRANT_ASSIGNED_JIRA_PERMISSION_SCHEME";
    ShepherdAlertTemplateType["IdentityPasswordResetCompletedUser"] = "IDENTITY_PASSWORD_RESET_COMPLETED_USER";
    ShepherdAlertTemplateType["ImpossibleTravel"] = "IMPOSSIBLE_TRAVEL";
    ShepherdAlertTemplateType["InitiatedGsyncConnection"] = "INITIATED_GSYNC_CONNECTION";
    ShepherdAlertTemplateType["JiraCustomDetection"] = "JIRA_CUSTOM_DETECTION";
    ShepherdAlertTemplateType["JiraDataDiscoveryAtlassianToken"] = "JIRA_DATA_DISCOVERY_ATLASSIAN_TOKEN";
    ShepherdAlertTemplateType["JiraDataDiscoveryAuTfn"] = "JIRA_DATA_DISCOVERY_AU_TFN";
    ShepherdAlertTemplateType["JiraDataDiscoveryAwsKeys"] = "JIRA_DATA_DISCOVERY_AWS_KEYS";
    ShepherdAlertTemplateType["JiraDataDiscoveryCreditCard"] = "JIRA_DATA_DISCOVERY_CREDIT_CARD";
    ShepherdAlertTemplateType["JiraDataDiscoveryCrypto"] = "JIRA_DATA_DISCOVERY_CRYPTO";
    ShepherdAlertTemplateType["JiraDataDiscoveryIban"] = "JIRA_DATA_DISCOVERY_IBAN";
    ShepherdAlertTemplateType["JiraDataDiscoveryJwtKey"] = "JIRA_DATA_DISCOVERY_JWT_KEY";
    ShepherdAlertTemplateType["JiraDataDiscoveryPassword"] = "JIRA_DATA_DISCOVERY_PASSWORD";
    ShepherdAlertTemplateType["JiraDataDiscoveryPrivateKey"] = "JIRA_DATA_DISCOVERY_PRIVATE_KEY";
    ShepherdAlertTemplateType["JiraDataDiscoveryUsSsn"] = "JIRA_DATA_DISCOVERY_US_SSN";
    ShepherdAlertTemplateType["JiraIssueCrawling"] = "JIRA_ISSUE_CRAWLING";
    ShepherdAlertTemplateType["LoginFromMaliciousIpAddress"] = "LOGIN_FROM_MALICIOUS_IP_ADDRESS";
    ShepherdAlertTemplateType["LoginFromTorExitNode"] = "LOGIN_FROM_TOR_EXIT_NODE";
    ShepherdAlertTemplateType["OrgLoggedInAsUser"] = "ORG_LOGGED_IN_AS_USER";
    ShepherdAlertTemplateType["ProjectClassificationLevelDecreased"] = "PROJECT_CLASSIFICATION_LEVEL_DECREASED";
    ShepherdAlertTemplateType["ProjectClassificationLevelIncreased"] = "PROJECT_CLASSIFICATION_LEVEL_INCREASED";
    ShepherdAlertTemplateType["RotateScimDirectoryToken"] = "ROTATE_SCIM_DIRECTORY_TOKEN";
    ShepherdAlertTemplateType["SpaceClassificationLevelDecreased"] = "SPACE_CLASSIFICATION_LEVEL_DECREASED";
    ShepherdAlertTemplateType["SpaceClassificationLevelIncreased"] = "SPACE_CLASSIFICATION_LEVEL_INCREASED";
    ShepherdAlertTemplateType["TestAlert"] = "TEST_ALERT";
    ShepherdAlertTemplateType["TokenCreated"] = "TOKEN_CREATED";
    ShepherdAlertTemplateType["TokenRevoked"] = "TOKEN_REVOKED";
    ShepherdAlertTemplateType["UpdatedAuthPolicy"] = "UPDATED_AUTH_POLICY";
    ShepherdAlertTemplateType["UpdatedPolicy"] = "UPDATED_POLICY";
    ShepherdAlertTemplateType["UpdatedSamlConfig"] = "UPDATED_SAML_CONFIG";
    ShepherdAlertTemplateType["UserAddedToBeacon"] = "USER_ADDED_TO_BEACON";
    ShepherdAlertTemplateType["UserGrantedRole"] = "USER_GRANTED_ROLE";
    ShepherdAlertTemplateType["UserRemovedFromBeacon"] = "USER_REMOVED_FROM_BEACON";
    ShepherdAlertTemplateType["UserRevokedRole"] = "USER_REVOKED_ROLE";
    ShepherdAlertTemplateType["VerifiedDomainVerification"] = "VERIFIED_DOMAIN_VERIFICATION";
    return ShepherdAlertTemplateType;
}({}); /** Placeholder type to enable eventually adding pagination via the relay connection pattern (https://relay.dev/graphql/connections.htm). */  /** #### Types: Query Results ##### */ 
let $78ad46e0d6808149$export$9dd0637f1b429aee = /*#__PURE__*/ function(ShepherdAtlassianProduct) {
    ShepherdAtlassianProduct["AdminHub"] = "ADMIN_HUB";
    ShepherdAtlassianProduct["Bitbucket"] = "BITBUCKET";
    ShepherdAtlassianProduct["Confluence"] = "CONFLUENCE";
    ShepherdAtlassianProduct["GuardDetect"] = "GUARD_DETECT";
    ShepherdAtlassianProduct["JiraSoftware"] = "JIRA_SOFTWARE";
    ShepherdAtlassianProduct["Marketplace"] = "MARKETPLACE";
    return ShepherdAtlassianProduct;
}({}); /** Represent metadata for the alert grouped by category */ 
let $78ad46e0d6808149$export$4ee416f20f5a941a = /*#__PURE__*/ function(ShepherdClassificationLevelColor) {
    ShepherdClassificationLevelColor["Blue"] = "BLUE";
    ShepherdClassificationLevelColor["BlueBold"] = "BLUE_BOLD";
    ShepherdClassificationLevelColor["Green"] = "GREEN";
    ShepherdClassificationLevelColor["Grey"] = "GREY";
    ShepherdClassificationLevelColor["Lime"] = "LIME";
    ShepherdClassificationLevelColor["Navy"] = "NAVY";
    ShepherdClassificationLevelColor["None"] = "NONE";
    ShepherdClassificationLevelColor["Orange"] = "ORANGE";
    ShepherdClassificationLevelColor["Purple"] = "PURPLE";
    ShepherdClassificationLevelColor["Red"] = "RED";
    ShepherdClassificationLevelColor["RedBold"] = "RED_BOLD";
    ShepherdClassificationLevelColor["Teal"] = "TEAL";
    ShepherdClassificationLevelColor["Yellow"] = "YELLOW";
    return ShepherdClassificationLevelColor;
}({});
let $78ad46e0d6808149$export$dddaf5557f82edf7 = /*#__PURE__*/ function(ShepherdClassificationStatus) {
    ShepherdClassificationStatus["Archived"] = "ARCHIVED";
    ShepherdClassificationStatus["Draft"] = "DRAFT";
    ShepherdClassificationStatus["Published"] = "PUBLISHED";
    return ShepherdClassificationStatus;
}({}); /** ##### Input ###### */  /** #### Payload ##### */  /** Represents the current user in the Shepherd system. */  /** Configuration for a custom content scanning detection. A list of rules that will be matched against content. */  /** A user created detection. Currently only custom content scanning is supported. */ 
let $78ad46e0d6808149$export$f961d21a5cd3eed7 = /*#__PURE__*/ function(ShepherdCustomScanningMatchType) {
    ShepherdCustomScanningMatchType["Regex"] = "REGEX";
    ShepherdCustomScanningMatchType["String"] = "STRING";
    ShepherdCustomScanningMatchType["Word"] = "WORD";
    return ShepherdCustomScanningMatchType;
}({}); /** GraphQL doesn't allow unions in input types so this is to allow for different rule types in the future. */  /** A rule to match against content. Contains a term an whether it's a string match or word match. */  /** Input type for a rule to match against content. Contains a term an whether it's a string match or word match. */  /** This would represent a detection in beacon, each detection possibly containing a set of settings */  /** Represents an individual exclusion. */  /** Setting that contains exclusion configuration so that a detection can filter out unwanted alerts for customers. */  /** An individual resource exclusion */ 
let $78ad46e0d6808149$export$db4af14fade5e4e5 = /*#__PURE__*/ function(ShepherdDetectionScanningFrequency) {
    ShepherdDetectionScanningFrequency["RealTime"] = "REAL_TIME";
    ShepherdDetectionScanningFrequency["Scheduled"] = "SCHEDULED";
    return ShepherdDetectionScanningFrequency;
}({}); /** Describes the data the setting can hold. */  /** Represents specific metadata that adds context to DSP list changes */  /** A highlight contains contextual information produced by the detection that created the alert. */  /**
 * A highlight contains contextual information produced by the detection that created the alert.
 * One field is required and only one can be informed at a time.
 */ 
let $78ad46e0d6808149$export$2f9e73ea31c391f3 = /*#__PURE__*/ function(ShepherdLoginDeviceType) {
    ShepherdLoginDeviceType["Computer"] = "COMPUTER";
    ShepherdLoginDeviceType["Console"] = "CONSOLE";
    ShepherdLoginDeviceType["Embedded"] = "EMBEDDED";
    ShepherdLoginDeviceType["Mobile"] = "MOBILE";
    ShepherdLoginDeviceType["SmartTv"] = "SMART_TV";
    ShepherdLoginDeviceType["Tablet"] = "TABLET";
    ShepherdLoginDeviceType["Wearable"] = "WEARABLE";
    return ShepherdLoginDeviceType;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** #### Types: Mutation ##### */ 
let $78ad46e0d6808149$export$c8dd2e548b70194f = /*#__PURE__*/ function(ShepherdMutationErrorType) {
    ShepherdMutationErrorType["BadRequest"] = "BAD_REQUEST";
    ShepherdMutationErrorType["InternalServerError"] = "INTERNAL_SERVER_ERROR";
    ShepherdMutationErrorType["NoProductAccess"] = "NO_PRODUCT_ACCESS";
    ShepherdMutationErrorType["Unauthorized"] = "UNAUTHORIZED";
    return ShepherdMutationErrorType;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** #### Types: Query ##### */ 
let $78ad46e0d6808149$export$60854452710d481b = /*#__PURE__*/ function(ShepherdQueryErrorType) {
    ShepherdQueryErrorType["BadRequest"] = "BAD_REQUEST";
    ShepherdQueryErrorType["InternalServerError"] = "INTERNAL_SERVER_ERROR";
    ShepherdQueryErrorType["NoProductAccess"] = "NO_PRODUCT_ACCESS";
    ShepherdQueryErrorType["Unauthorized"] = "UNAUTHORIZED";
    return ShepherdQueryErrorType;
}({}); /** A rate type detection has 3 modes, LOW will produce the most alerts, HIGH will product the least alerts */ 
let $78ad46e0d6808149$export$359aa80f049e8938 = /*#__PURE__*/ function(ShepherdRateThresholdValue) {
    ShepherdRateThresholdValue["High"] = "HIGH";
    ShepherdRateThresholdValue["Low"] = "LOW";
    ShepherdRateThresholdValue["Medium"] = "MEDIUM";
    return ShepherdRateThresholdValue;
}({});
let $78ad46e0d6808149$export$8bcebd025de2c46b = /*#__PURE__*/ function(ShepherdRemediationActionType) {
    ShepherdRemediationActionType["AnonAccessDspRemediation"] = "ANON_ACCESS_DSP_REMEDIATION";
    ShepherdRemediationActionType["ApplyClassificationRemediation"] = "APPLY_CLASSIFICATION_REMEDIATION";
    ShepherdRemediationActionType["AppsAccessDspRemediation"] = "APPS_ACCESS_DSP_REMEDIATION";
    ShepherdRemediationActionType["ArchiveRestoreClassificationRemediation"] = "ARCHIVE_RESTORE_CLASSIFICATION_REMEDIATION";
    ShepherdRemediationActionType["BlockchainExplorerRemediation"] = "BLOCKCHAIN_EXPLORER_REMEDIATION";
    ShepherdRemediationActionType["BlockIpAllowlistRemediation"] = "BLOCK_IP_ALLOWLIST_REMEDIATION";
    ShepherdRemediationActionType["ClassificationLevelChangeRemediation"] = "CLASSIFICATION_LEVEL_CHANGE_REMEDIATION";
    ShepherdRemediationActionType["ConfluenceAnonAccessRemediation"] = "CONFLUENCE_ANON_ACCESS_REMEDIATION";
    ShepherdRemediationActionType["DeleteDataRemediation"] = "DELETE_DATA_REMEDIATION";
    ShepherdRemediationActionType["DeleteFilesRemediation"] = "DELETE_FILES_REMEDIATION";
    ShepherdRemediationActionType["EditCustomDetectionRemediation"] = "EDIT_CUSTOM_DETECTION_REMEDIATION";
    ShepherdRemediationActionType["ExcludePageRemediation"] = "EXCLUDE_PAGE_REMEDIATION";
    ShepherdRemediationActionType["ExcludeUserRemediation"] = "EXCLUDE_USER_REMEDIATION";
    ShepherdRemediationActionType["ExportsDspRemediation"] = "EXPORTS_DSP_REMEDIATION";
    ShepherdRemediationActionType["ExportDspRemediation"] = "EXPORT_DSP_REMEDIATION";
    ShepherdRemediationActionType["ExportSpacePermissionsRemediation"] = "EXPORT_SPACE_PERMISSIONS_REMEDIATION";
    ShepherdRemediationActionType["JiraGlobalPermissionsRemediation"] = "JIRA_GLOBAL_PERMISSIONS_REMEDIATION";
    ShepherdRemediationActionType["KeyOwnerRemediation"] = "KEY_OWNER_REMEDIATION";
    ShepherdRemediationActionType["LimitJiraPermissionsRemediation"] = "LIMIT_JIRA_PERMISSIONS_REMEDIATION";
    ShepherdRemediationActionType["ManageAppsRemediation"] = "MANAGE_APPS_REMEDIATION";
    ShepherdRemediationActionType["ManageDomainRemediation"] = "MANAGE_DOMAIN_REMEDIATION";
    ShepherdRemediationActionType["ManageDspRemediation"] = "MANAGE_DSP_REMEDIATION";
    ShepherdRemediationActionType["PublicAccessDspRemediation"] = "PUBLIC_ACCESS_DSP_REMEDIATION";
    ShepherdRemediationActionType["ResetAccountPasswordRemediation"] = "RESET_ACCOUNT_PASSWORD_REMEDIATION";
    ShepherdRemediationActionType["RestoreAccessRemediation"] = "RESTORE_ACCESS_REMEDIATION";
    ShepherdRemediationActionType["ReviewAccessRemediation"] = "REVIEW_ACCESS_REMEDIATION";
    ShepherdRemediationActionType["ReviewApiKeysRemediation"] = "REVIEW_API_KEYS_REMEDIATION";
    ShepherdRemediationActionType["ReviewApiTokensRemediation"] = "REVIEW_API_TOKENS_REMEDIATION";
    ShepherdRemediationActionType["ReviewAuditLogRemediation"] = "REVIEW_AUDIT_LOG_REMEDIATION";
    ShepherdRemediationActionType["ReviewAuthPolicyRemediation"] = "REVIEW_AUTH_POLICY_REMEDIATION";
    ShepherdRemediationActionType["ReviewGsyncRemediation"] = "REVIEW_GSYNC_REMEDIATION";
    ShepherdRemediationActionType["ReviewIpAllowlistRemediation"] = "REVIEW_IP_ALLOWLIST_REMEDIATION";
    ShepherdRemediationActionType["ReviewIssueRemediation"] = "REVIEW_ISSUE_REMEDIATION";
    ShepherdRemediationActionType["ReviewOtherAuthPoliciesRemediation"] = "REVIEW_OTHER_AUTH_POLICIES_REMEDIATION";
    ShepherdRemediationActionType["ReviewOtherIpAllowlistRemediation"] = "REVIEW_OTHER_IP_ALLOWLIST_REMEDIATION";
    ShepherdRemediationActionType["ReviewPageRemediation"] = "REVIEW_PAGE_REMEDIATION";
    ShepherdRemediationActionType["ReviewSamlRemediation"] = "REVIEW_SAML_REMEDIATION";
    ShepherdRemediationActionType["ReviewScimRemediation"] = "REVIEW_SCIM_REMEDIATION";
    ShepherdRemediationActionType["ReviewTunnelsConfigurationRemediation"] = "REVIEW_TUNNELS_CONFIGURATION_REMEDIATION";
    ShepherdRemediationActionType["ReviewTunnelsRemediation"] = "REVIEW_TUNNELS_REMEDIATION";
    ShepherdRemediationActionType["RevokeAccessRemediation"] = "REVOKE_ACCESS_REMEDIATION";
    ShepherdRemediationActionType["RevokeApiKeyRemediation"] = "REVOKE_API_KEY_REMEDIATION";
    ShepherdRemediationActionType["RevokeApiTokensRemediation"] = "REVOKE_API_TOKENS_REMEDIATION";
    ShepherdRemediationActionType["SpacePermissionsRemediation"] = "SPACE_PERMISSIONS_REMEDIATION";
    ShepherdRemediationActionType["SuspendActorRemediation"] = "SUSPEND_ACTOR_REMEDIATION";
    ShepherdRemediationActionType["SuspendSubjectRemediation"] = "SUSPEND_SUBJECT_REMEDIATION";
    ShepherdRemediationActionType["TurnOffJiraPermissionsRemediation"] = "TURN_OFF_JIRA_PERMISSIONS_REMEDIATION";
    ShepherdRemediationActionType["TwoStepPolicyRemediation"] = "TWO_STEP_POLICY_REMEDIATION";
    ShepherdRemediationActionType["ViewSpacePermissionsRemediation"] = "VIEW_SPACE_PERMISSIONS_REMEDIATION";
    return ShepherdRemediationActionType;
}({}); /** Represents a resource that was acted upon at a specific time */ 
let $78ad46e0d6808149$export$e0c4be2f8b0999ce = /*#__PURE__*/ function(ShepherdSearchOrigin) {
    ShepherdSearchOrigin["AdvancedSearch"] = "ADVANCED_SEARCH";
    ShepherdSearchOrigin["Ai"] = "AI";
    ShepherdSearchOrigin["QuickSearch"] = "QUICK_SEARCH";
    return ShepherdSearchOrigin;
}({}); /** Provides all necessary metadata about a search query */  /** Represents a slack subscription in the Shepherd system. */  /** The resource was acted on */  /** The resource was acted on */  /** Common interface for all subscriptions. */  /**
 * Use a type instead of an interface.
 *
 * "Edge type must be an Object type."
 * See: https://github.com/B2o5T/graphql-eslint/blob/master/docs/rules/relay-edge-types.md
 */ 
let $78ad46e0d6808149$export$8f5af6e8802c488 = /*#__PURE__*/ function(ShepherdSubscriptionStatus) {
    ShepherdSubscriptionStatus["Active"] = "ACTIVE";
    ShepherdSubscriptionStatus["Inactive"] = "INACTIVE";
    return ShepherdSubscriptionStatus;
}({}); /** Represents a point in time or an interval (when `end` is present) */  /** Time or interval */  /** Represents a user in the Shepherd system. */  /** Represents the possible vortexMode values for a workspace. */ 
let $78ad46e0d6808149$export$80ad4b94a728f2e2 = /*#__PURE__*/ function(ShepherdVortexModeStatus) {
    ShepherdVortexModeStatus["Disabled"] = "DISABLED";
    ShepherdVortexModeStatus["Enabled"] = "ENABLED";
    return ShepherdVortexModeStatus;
}({}); /** Represents type of Webhook payload */ 
let $78ad46e0d6808149$export$cfc31900765a3ba4 = /*#__PURE__*/ function(ShepherdWebhookDestinationType) {
    ShepherdWebhookDestinationType["Default"] = "DEFAULT";
    ShepherdWebhookDestinationType["MicrosoftTeams"] = "MICROSOFT_TEAMS";
    return ShepherdWebhookDestinationType;
}({}); /** Represents a webhook subscription in the Shepherd system. */  /**
 * Represents type of Webhook
 * DEPRECATED: Use destinationType instead.
 */ 
let $78ad46e0d6808149$export$2e013066679d73f8 = /*#__PURE__*/ function(ShepherdWebhookType) {
    ShepherdWebhookType["Custom"] = "CUSTOM";
    ShepherdWebhookType["MicrosoftTeams"] = "MICROSOFT_TEAMS";
    ShepherdWebhookType["Slack"] = "SLACK";
    return ShepherdWebhookType;
}({}); /** Represents a workspace in the Shepherd system. */  /** Represents a workspace in the Shepherd system. */  /** Represents a workspace in the Shepherd system. */  /**
 * Contains the setting value for a detection
 * While we currently only have one detection type (threshold), if we add more in the future there would be more fields
 * on this type, only one of which should be populated at a time.
 */ 
let $78ad46e0d6808149$export$c32ed3061693e3f1 = /*#__PURE__*/ function(SoftwareCardsDestinationEnum) {
    SoftwareCardsDestinationEnum["Backlog"] = "BACKLOG";
    SoftwareCardsDestinationEnum["ExistingSprint"] = "EXISTING_SPRINT";
    SoftwareCardsDestinationEnum["NewSprint"] = "NEW_SPRINT";
    return SoftwareCardsDestinationEnum;
}({}); /** Node for querying any report page's data */  /** The sort direction of the collection */ 
let $78ad46e0d6808149$export$79e2d9500680dd96 = /*#__PURE__*/ function(SortDirection) {
    SortDirection["Asc"] = "ASC";
    SortDirection["Desc"] = "DESC";
    return SortDirection;
}({});
let $78ad46e0d6808149$export$7ae723045d45777a = /*#__PURE__*/ function(SortOrder) {
    SortOrder["Asc"] = "ASC";
    SortOrder["Desc"] = "DESC";
    return SortOrder;
}({});
let $78ad46e0d6808149$export$88ef8388f421e95e = /*#__PURE__*/ function(SprintReportsEstimationStatisticType) {
    SprintReportsEstimationStatisticType["IssueCount"] = "ISSUE_COUNT";
    SprintReportsEstimationStatisticType["OriginalEstimate"] = "ORIGINAL_ESTIMATE";
    SprintReportsEstimationStatisticType["StoryPoints"] = "STORY_POINTS";
    return SprintReportsEstimationStatisticType;
}({});
let $78ad46e0d6808149$export$f37cb7e02dc42251 = /*#__PURE__*/ function(SprintState) {
    SprintState["Active"] = "ACTIVE";
    SprintState["Closed"] = "CLOSED";
    SprintState["Future"] = "FUTURE";
    return SprintState;
}({}); /** Start sprint */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** Top level wrapper for CSP Support Request queries API */  /** Top level wrapper for CSP Support Request queries API */  /** A comment for the request. These are non-hierarchical comments and are only linked to a single request. */  /** A DateTime type for the request, this contains multiple formats of datetime */  /** Enum that specify the data type of the field. */ 
let $78ad46e0d6808149$export$db58b0fec288f2d5 = /*#__PURE__*/ function(SupportRequestFieldDataType) {
    SupportRequestFieldDataType["Boolean"] = "BOOLEAN";
    SupportRequestFieldDataType["Date"] = "DATE";
    SupportRequestFieldDataType["Number"] = "NUMBER";
    SupportRequestFieldDataType["String"] = "STRING";
    return SupportRequestFieldDataType;
}({}); /** The value of the field. This has been kept as a seperate type for extensibility, such as including icons. */  /** Query parameter for how this user has access to the request, e.g. they were the reporter or added as a participant. */ 
let $78ad46e0d6808149$export$5d395d1469cf6904 = /*#__PURE__*/ function(SupportRequestNamedContactOperation) {
    SupportRequestNamedContactOperation["Add"] = "ADD";
    SupportRequestNamedContactOperation["Remove"] = "REMOVE";
    return SupportRequestNamedContactOperation;
}({}); /** A user (customer or agent) of the support system. */  /** A user (customer or agent) of the support system. */  /** A user (customer or agent) of the support system. */  /** Query parameter for how this user has access to the request, e.g. they were the reporter or added as a participant. */ 
let $78ad46e0d6808149$export$15d04aa1faaca584 = /*#__PURE__*/ function(SupportRequestQueryOwnership) {
    SupportRequestQueryOwnership["Participant"] = "PARTICIPANT";
    SupportRequestQueryOwnership["Reporter"] = "REPORTER";
    return SupportRequestQueryOwnership;
}({}); /** The general category for the status of the ticket. */ 
let $78ad46e0d6808149$export$cf9ba11854f7cb39 = /*#__PURE__*/ function(SupportRequestQueryStatusCategory) {
    SupportRequestQueryStatusCategory["Done"] = "DONE";
    SupportRequestQueryStatusCategory["Open"] = "OPEN";
    return SupportRequestQueryStatusCategory;
}({}); /** The general category for the status of the ticket. */ 
let $78ad46e0d6808149$export$21de27a5998af787 = /*#__PURE__*/ function(SupportRequestStatusCategory) {
    SupportRequestStatusCategory["Done"] = "DONE";
    SupportRequestStatusCategory["InProgress"] = "IN_PROGRESS";
    SupportRequestStatusCategory["Open"] = "OPEN";
    return SupportRequestStatusCategory;
}({}); /** The supported usertype of user in system */ 
let $78ad46e0d6808149$export$4e3e0500b62d4705 = /*#__PURE__*/ function(SupportRequestUserType) {
    SupportRequestUserType["Customer"] = "CUSTOMER";
    SupportRequestUserType["Partner"] = "PARTNER";
    return SupportRequestUserType;
}({}); /** --------------------------------------------------------------------------------------------- */  /** --------------------------------------------------------------------------------------------- */  /** How to group cards on the board into swimlanes */ 
let $78ad46e0d6808149$export$39b890c79449a0 = /*#__PURE__*/ function(SwimlaneStrategy) {
    SwimlaneStrategy["Assignee"] = "ASSIGNEE";
    SwimlaneStrategy["Issuechildren"] = "ISSUECHILDREN";
    SwimlaneStrategy["Issueparent"] = "ISSUEPARENT";
    SwimlaneStrategy["None"] = "NONE";
    return SwimlaneStrategy;
}({}); /** Team returned in a team query */  /** Team returned in a team query */  /** Returns the details of the team member and details about their membership within a team */  /** The connection entity for the members of a team for pagination */  /** The connection entity for the members of a team for pagination */  /** Returns the details of the team member and details about their membership within a team */  /** Member filter used as input on team search filter */  /** The roles that a member can have within a team */ 
let $78ad46e0d6808149$export$6a422ea3acdf9d9b = /*#__PURE__*/ function(TeamMembershipRole) {
    TeamMembershipRole["Admin"] = "ADMIN";
    TeamMembershipRole["Regular"] = "REGULAR";
    return TeamMembershipRole;
}({}); /** The settings which a team can have describing how members are added to the team */ 
let $78ad46e0d6808149$export$93b1c6cf9d16dce6 = /*#__PURE__*/ function(TeamMembershipSettings) {
    TeamMembershipSettings["External"] = "EXTERNAL";
    TeamMembershipSettings["MemberInvite"] = "MEMBER_INVITE";
    TeamMembershipSettings["Open"] = "OPEN";
    return TeamMembershipSettings;
}({}); /** The states that a member can have within a team */ 
let $78ad46e0d6808149$export$f627e98535fb8637 = /*#__PURE__*/ function(TeamMembershipState) {
    TeamMembershipState["Alumni"] = "ALUMNI";
    TeamMembershipState["FullMember"] = "FULL_MEMBER";
    TeamMembershipState["RequestingToJoin"] = "REQUESTING_TO_JOIN";
    return TeamMembershipState;
}({});
let $78ad46e0d6808149$export$76b040ede9e99a0e = /*#__PURE__*/ function(TeamRole) {
    TeamRole["TeamsAdmin"] = "TEAMS_ADMIN";
    TeamRole["TeamsObserver"] = "TEAMS_OBSERVER";
    TeamRole["TeamsUser"] = "TEAMS_USER";
    return TeamRole;
}({}); /** Enum representing the search fields for teams. */ 
let $78ad46e0d6808149$export$3d32048696128045 = /*#__PURE__*/ function(TeamSearchField) {
    TeamSearchField["Description"] = "DESCRIPTION";
    TeamSearchField["Name"] = "NAME";
    return TeamSearchField;
}({}); /** Team filter used as input on team search */  /** Team returned in search */  /** The result of the search for teams. */  /** The result of the search for teams. */  /** An edge from a team search */  /** An edge from a team search */  /** Team returned in search */  /** Team sort used as input on team search */  /** Team sort fields */ 
let $78ad46e0d6808149$export$c701f1c8ac34f3b8 = /*#__PURE__*/ function(TeamSortField) {
    TeamSortField["DisplayName"] = "DISPLAY_NAME";
    TeamSortField["Id"] = "ID";
    TeamSortField["State"] = "STATE";
    return TeamSortField;
}({}); /** Team Sort Order */ 
let $78ad46e0d6808149$export$cecdee868554f386 = /*#__PURE__*/ function(TeamSortOrder) {
    TeamSortOrder["Asc"] = "ASC";
    TeamSortOrder["Desc"] = "DESC";
    return TeamSortOrder;
}({}); /** The states that a team can have */ 
let $78ad46e0d6808149$export$c5c56131401e0716 = /*#__PURE__*/ function(TeamState) {
    TeamState["Active"] = "ACTIVE";
    TeamState["Disbanded"] = "DISBANDED";
    TeamState["Purged"] = "PURGED";
    return TeamState;
}({}); /** The states that a team can have */ 
let $78ad46e0d6808149$export$15fa8968cce33b6 = /*#__PURE__*/ function(TeamStateV2) {
    TeamStateV2["Active"] = "ACTIVE";
    TeamStateV2["Purged"] = "PURGED";
    return TeamStateV2;
}({}); /** Team returned in a team query */  /** Team returned in a team query */  /** The input for a Third Party Repository */  /**
 * This represent a third party user
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __identity:atlassian-external__
 * * __read:account__
 */ 
let $78ad46e0d6808149$export$be996b3d78d87257 = /*#__PURE__*/ function(ToolchainAssociateEntitiesErrorCode) {
    ToolchainAssociateEntitiesErrorCode["EntityRejected"] = "ENTITY_REJECTED";
    ToolchainAssociateEntitiesErrorCode["EntityUrlInvalid"] = "ENTITY_URL_INVALID";
    ToolchainAssociateEntitiesErrorCode["ProviderEntityFetchForbidden"] = "PROVIDER_ENTITY_FETCH_FORBIDDEN";
    ToolchainAssociateEntitiesErrorCode["ProviderEntityNotFound"] = "PROVIDER_ENTITY_NOT_FOUND";
    ToolchainAssociateEntitiesErrorCode["ProviderError"] = "PROVIDER_ERROR";
    ToolchainAssociateEntitiesErrorCode["ProviderInputInvalid"] = "PROVIDER_INPUT_INVALID";
    return ToolchainAssociateEntitiesErrorCode;
}({}); /** This is a union of all the consumer schemas supported by the associate container API */  /** This is a union of all the consumer schemas supported by the associate entity API */ 
let $78ad46e0d6808149$export$96ad634185a48695 = /*#__PURE__*/ function(ToolchainCheckAuthErrorCode) {
    ToolchainCheckAuthErrorCode["ProviderError"] = "PROVIDER_ERROR";
    return ToolchainCheckAuthErrorCode;
}({}); /** This is a union of all the auth types supported by the check auth API and query error if check auth is unsuccessful */ 
let $78ad46e0d6808149$export$a675cf96020918d = /*#__PURE__*/ function(ToolchainCreateContainerErrorCode) {
    ToolchainCreateContainerErrorCode["ProviderContainerAlreadyExists"] = "PROVIDER_CONTAINER_ALREADY_EXISTS";
    ToolchainCreateContainerErrorCode["ProviderContainerCreateForbidden"] = "PROVIDER_CONTAINER_CREATE_FORBIDDEN";
    ToolchainCreateContainerErrorCode["ProviderError"] = "PROVIDER_ERROR";
    ToolchainCreateContainerErrorCode["ProviderInputInvalid"] = "PROVIDER_INPUT_INVALID";
    ToolchainCreateContainerErrorCode["ProviderWorkspaceNotFound"] = "PROVIDER_WORKSPACE_NOT_FOUND";
    return ToolchainCreateContainerErrorCode;
}({}); /** Either both `cloudId` and 'providerId', or 'workspaceId' must be specified. */ 
let $78ad46e0d6808149$export$911f961eae9c7bb3 = /*#__PURE__*/ function(ToolchainDisassociateEntitiesErrorCode) {
    ToolchainDisassociateEntitiesErrorCode["UnknownAssociation"] = "UNKNOWN_ASSOCIATION";
    return ToolchainDisassociateEntitiesErrorCode;
}({}); /**
 * Type of a data-depot provider.
 * A provider may belongs to multiple types (e.g an connect-app can send both build and deployment info).
 */ 
let $78ad46e0d6808149$export$a76864a49f160fd1 = /*#__PURE__*/ function(ToolchainProviderType) {
    ToolchainProviderType["Build"] = "BUILD";
    ToolchainProviderType["Deployment"] = "DEPLOYMENT";
    ToolchainProviderType["Design"] = "DESIGN";
    ToolchainProviderType["DevopsComponents"] = "DEVOPS_COMPONENTS";
    ToolchainProviderType["DevInfo"] = "DEV_INFO";
    ToolchainProviderType["Documentation"] = "DOCUMENTATION";
    ToolchainProviderType["FeatureFlag"] = "FEATURE_FLAG";
    ToolchainProviderType["Operations"] = "OPERATIONS";
    ToolchainProviderType["RemoteLinks"] = "REMOTE_LINKS";
    ToolchainProviderType["Security"] = "SECURITY";
    return ToolchainProviderType;
}({});
let $78ad46e0d6808149$export$358b14067bcbe24d = /*#__PURE__*/ function(ToolchainSyncState) {
    ToolchainSyncState["Complete"] = "COMPLETE";
    ToolchainSyncState["Error"] = "ERROR";
    ToolchainSyncState["InProgress"] = "IN_PROGRESS";
    return ToolchainSyncState;
}({});
let $78ad46e0d6808149$export$74b7a9159262d2e = /*#__PURE__*/ function(ToolchainWorkspaceConnectionErrorCode) {
    ToolchainWorkspaceConnectionErrorCode["ProviderActionError"] = "PROVIDER_ACTION_ERROR";
    ToolchainWorkspaceConnectionErrorCode["ProviderNotSupported"] = "PROVIDER_NOT_SUPPORTED";
    return ToolchainWorkspaceConnectionErrorCode;
}({});
let $78ad46e0d6808149$export$e2d891f9dd055fc4 = /*#__PURE__*/ function(TownsquareGoalSortEnum) {
    TownsquareGoalSortEnum["CreationDateAsc"] = "CREATION_DATE_ASC";
    TownsquareGoalSortEnum["CreationDateDesc"] = "CREATION_DATE_DESC";
    TownsquareGoalSortEnum["HierarchyAsc"] = "HIERARCHY_ASC";
    TownsquareGoalSortEnum["HierarchyDesc"] = "HIERARCHY_DESC";
    TownsquareGoalSortEnum["HierarchyLevelAsc"] = "HIERARCHY_LEVEL_ASC";
    TownsquareGoalSortEnum["HierarchyLevelDesc"] = "HIERARCHY_LEVEL_DESC";
    TownsquareGoalSortEnum["IdAsc"] = "ID_ASC";
    TownsquareGoalSortEnum["IdDesc"] = "ID_DESC";
    TownsquareGoalSortEnum["LatestUpdateDateAsc"] = "LATEST_UPDATE_DATE_ASC";
    TownsquareGoalSortEnum["LatestUpdateDateDesc"] = "LATEST_UPDATE_DATE_DESC";
    TownsquareGoalSortEnum["NameAsc"] = "NAME_ASC";
    TownsquareGoalSortEnum["NameDesc"] = "NAME_DESC";
    TownsquareGoalSortEnum["ProjectCountAsc"] = "PROJECT_COUNT_ASC";
    TownsquareGoalSortEnum["ProjectCountDesc"] = "PROJECT_COUNT_DESC";
    TownsquareGoalSortEnum["ScoreAsc"] = "SCORE_ASC";
    TownsquareGoalSortEnum["ScoreDesc"] = "SCORE_DESC";
    TownsquareGoalSortEnum["TargetDateAsc"] = "TARGET_DATE_ASC";
    TownsquareGoalSortEnum["TargetDateDesc"] = "TARGET_DATE_DESC";
    TownsquareGoalSortEnum["WatchingAsc"] = "WATCHING_ASC";
    TownsquareGoalSortEnum["WatchingDesc"] = "WATCHING_DESC";
    return TownsquareGoalSortEnum;
}({});
let $78ad46e0d6808149$export$114cd33b2bd21562 = /*#__PURE__*/ function(TownsquareGoalStateValue) {
    TownsquareGoalStateValue["Archived"] = "archived";
    TownsquareGoalStateValue["AtRisk"] = "at_risk";
    TownsquareGoalStateValue["Cancelled"] = "cancelled";
    TownsquareGoalStateValue["Done"] = "done";
    TownsquareGoalStateValue["OffTrack"] = "off_track";
    TownsquareGoalStateValue["OnTrack"] = "on_track";
    TownsquareGoalStateValue["Paused"] = "paused";
    TownsquareGoalStateValue["Pending"] = "pending";
    return TownsquareGoalStateValue;
}({});
let $78ad46e0d6808149$export$d857eec43cac6124 = /*#__PURE__*/ function(TownsquareGoalTypeState) {
    TownsquareGoalTypeState["Disabled"] = "DISABLED";
    TownsquareGoalTypeState["Enabled"] = "ENABLED";
    return TownsquareGoalTypeState;
}({});
let $78ad46e0d6808149$export$8aa4fdb7ade2bdbb = /*#__PURE__*/ function(TownsquareProjectSortEnum) {
    TownsquareProjectSortEnum["CreationDateAsc"] = "CREATION_DATE_ASC";
    TownsquareProjectSortEnum["CreationDateDesc"] = "CREATION_DATE_DESC";
    TownsquareProjectSortEnum["IdAsc"] = "ID_ASC";
    TownsquareProjectSortEnum["IdDesc"] = "ID_DESC";
    TownsquareProjectSortEnum["LatestUpdateDateAsc"] = "LATEST_UPDATE_DATE_ASC";
    TownsquareProjectSortEnum["LatestUpdateDateDesc"] = "LATEST_UPDATE_DATE_DESC";
    TownsquareProjectSortEnum["NameAsc"] = "NAME_ASC";
    TownsquareProjectSortEnum["NameDesc"] = "NAME_DESC";
    TownsquareProjectSortEnum["StartDateAsc"] = "START_DATE_ASC";
    TownsquareProjectSortEnum["StartDateDesc"] = "START_DATE_DESC";
    TownsquareProjectSortEnum["StatusAsc"] = "STATUS_ASC";
    TownsquareProjectSortEnum["StatusDesc"] = "STATUS_DESC";
    TownsquareProjectSortEnum["TargetDateAsc"] = "TARGET_DATE_ASC";
    TownsquareProjectSortEnum["TargetDateDesc"] = "TARGET_DATE_DESC";
    TownsquareProjectSortEnum["WatchingAsc"] = "WATCHING_ASC";
    TownsquareProjectSortEnum["WatchingDesc"] = "WATCHING_DESC";
    return TownsquareProjectSortEnum;
}({});
let $78ad46e0d6808149$export$ee344fc0997809d6 = /*#__PURE__*/ function(TownsquareProjectStateValue) {
    TownsquareProjectStateValue["Archived"] = "archived";
    TownsquareProjectStateValue["AtRisk"] = "at_risk";
    TownsquareProjectStateValue["Cancelled"] = "cancelled";
    TownsquareProjectStateValue["Done"] = "done";
    TownsquareProjectStateValue["OffTrack"] = "off_track";
    TownsquareProjectStateValue["OnTrack"] = "on_track";
    TownsquareProjectStateValue["Paused"] = "paused";
    TownsquareProjectStateValue["Pending"] = "pending";
    return TownsquareProjectStateValue;
}({}); /**
 * These are the currently supported relationships. The relationships are directional in the ARI Graph Store, so the order of "from" and "to" does matter.
 *
 *
 * | From           |   | To         |
 * |----------------|---|------------|
 * | Atlas Project  | → | Jira Issue |
 * | Jira Issue     | → | Atlas Goal |
 */ 
let $78ad46e0d6808149$export$84f5d3c1f2497f3c = /*#__PURE__*/ function(TownsquareTargetDateType) {
    TownsquareTargetDateType["Day"] = "DAY";
    TownsquareTargetDateType["Month"] = "MONTH";
    TownsquareTargetDateType["Quarter"] = "QUARTER";
    return TownsquareTargetDateType;
}({}); /** Collection of AI preferences */  /** An Attachment on a Trello Card */  /** Trello attachment connection */  /** Trello attachment edge */  /** The primary board component which contains lists and cards. */  /** The primary board component which contains lists and cards. */  /** The primary board component which contains lists and cards. */  /** The primary board component which contains lists and cards. */  /** The primary board component which contains lists and cards. */  /** The primary board component which contains lists and cards. */  /** The primary board component which contains lists and cards. */  /** The primary board component which contains lists and cards. */  /** Attachment limits for the board */  /** Collection of attributes representing the board background. */  /** Limits that apply to the board itself */  /** Card limits for the board */  /** CheckItem limits for the board */  /** Checklist limits for the board */  /** CustomFieldOption limits for the board */  /** CustomField limits for the board */  /** Represents a basic relationship between a node and a TrelloBoard. */  /** Label limits for the board */  /** Collection of limits that apply to a TrelloBoard */  /** List limits for the board */  /** Represents a relationship between a board and a member */  /** Filter input for TrelloBoard.members */  /** Metadata about a relationship between a member and a board */  /** Membership types for a TrelloBoard */ 
let $78ad46e0d6808149$export$532fae07bf79d169 = /*#__PURE__*/ function(TrelloBoardMembershipType) {
    TrelloBoardMembershipType["Admin"] = "ADMIN";
    TrelloBoardMembershipType["Normal"] = "NORMAL";
    TrelloBoardMembershipType["Observer"] = "OBSERVER";
    return TrelloBoardMembershipType;
}({}); /** Connection type to represent board memberships */  /** Connection type between a board and its powerUps */  /**
 * Represents a basic relationship between a node and a TrelloPowerUp.
 * The fields promotional, objectId, and memberId are null if the
 * powerUp is not enabled on the board
 */ 
let $78ad46e0d6808149$export$e19d69c6b75aa26f = /*#__PURE__*/ function(TrelloCardCoverBrightness) {
    TrelloCardCoverBrightness["Dark"] = "DARK";
    TrelloCardCoverBrightness["Light"] = "LIGHT";
    return TrelloCardCoverBrightness;
}({}); /** TrelloCardCover color */ 
let $78ad46e0d6808149$export$b1a4da8c2172956c = /*#__PURE__*/ function(TrelloCardCoverColor) {
    TrelloCardCoverColor["Black"] = "BLACK";
    TrelloCardCoverColor["Blue"] = "BLUE";
    TrelloCardCoverColor["Green"] = "GREEN";
    TrelloCardCoverColor["Lime"] = "LIME";
    TrelloCardCoverColor["Orange"] = "ORANGE";
    TrelloCardCoverColor["Pink"] = "PINK";
    TrelloCardCoverColor["Purple"] = "PURPLE";
    TrelloCardCoverColor["Red"] = "RED";
    TrelloCardCoverColor["Sky"] = "SKY";
    TrelloCardCoverColor["Yellow"] = "YELLOW";
    return TrelloCardCoverColor;
}({}); /** TrelloCardCover size */ 
let $78ad46e0d6808149$export$17aa2e5fc86f2e30 = /*#__PURE__*/ function(TrelloCardCoverSize) {
    TrelloCardCoverSize["Full"] = "FULL";
    TrelloCardCoverSize["Normal"] = "NORMAL";
    return TrelloCardCoverSize;
}({}); /** The cover of a trello card. */  /** Information about the due property of a TrelloCard */  /** Represents a basic relationship between a node and a TrelloCard. */  /** TrelloCard external sources, from which cards can be generated */ 
let $78ad46e0d6808149$export$a209f50d5cb5f744 = /*#__PURE__*/ function(TrelloCardExternalSource) {
    TrelloCardExternalSource["Email"] = "EMAIL";
    return TrelloCardExternalSource;
}({}); /** Trello Card Limit */  /** Limits for a card */  /** TrelloCard location information */  /** Special TrelloCard roles */ 
let $78ad46e0d6808149$export$3246e4d5604c366a = /*#__PURE__*/ function(TrelloCardRole) {
    TrelloCardRole["Board"] = "BOARD";
    TrelloCardRole["Link"] = "LINK";
    TrelloCardRole["Mirror"] = "MIRROR";
    TrelloCardRole["Separator"] = "SEPARATOR";
    return TrelloCardRole;
}({}); /** The updated card fields within a TrelloBoardUpdated event. */  /** Connection type emulating relay-style paging for list data on TrelloBoardUpdated events */  /** Trello card viewer for card front badges */  /** A Trello checklist */  /** Connection type between a container and its checklists. */  /** Represents a basic relationship between a node and a TrelloChecklist. */  /** A Trello Custom Field */  /** Custom field connection */  /** Display options for the custom field. */  /** Custom field edge. */  /** A Trello Custom Field item */  /** Connection type between an entity and its Custom Field items. */  /** Represents a basic relationship between a node and a TrelloCustomFieldItem. */  /** Information describing the value of a Custom Field item. */  /** An option for a custom field (e.g. a dropdown option) */  /** The value of the custom field option. */  /** User-generated description of a Trello entity */  /** The data required to render custom emoji in description fields on Trello entities */  /** Connection type between a description data and its set of custom emojis */  /** Represents a basic relationship between a node and a TrelloDescriptionCustomEmoji. */  /** Custom data used to render the description of certain Trello entities */  /** Custom data used to render the description of certain Trello entities */  /** A Trello Enterprise. */  /** Collection of preferences for the enterprise */  /** A Trello Image Preview */  /** Connection type between an object that contains an image and its previews. */  /** Represents a basic relationship between a node and a TrelloImagePreview. */  /**
 * Connection type between an object that contains an image and its previews, modified
 * for subscriptions
 */ 
let $78ad46e0d6808149$export$d6da0c6d5fb213f0 = /*#__PURE__*/ function(TrelloPowerUpDataAccess) {
    TrelloPowerUpDataAccess["Private"] = "PRIVATE";
    TrelloPowerUpDataAccess["Shared"] = "SHARED";
    return TrelloPowerUpDataAccess;
}({}); /** Connection type between an entity and its powerUpData entries. */  /** Represents a basic relationship between a node and a TrelloPowerUpData. */  /** Filters to apply when querying powerUpData. */  /** TrelloPowerUpData scope */ 
let $78ad46e0d6808149$export$bc6cfd4fe0c319ad = /*#__PURE__*/ function(TrelloPowerUpDataScope) {
    TrelloPowerUpDataScope["Board"] = "BOARD";
    TrelloPowerUpDataScope["Card"] = "CARD";
    TrelloPowerUpDataScope["Organization"] = "ORGANIZATION";
    return TrelloPowerUpDataScope;
}({}); /** Represents the icon for this powerUp */  /** The updated powerUp ID on the card */  /**
 * This is a top level query type under which all of Trello's supported queries
 * are under. It is used to group Trello's GraphQL queries from other Atlassian
 * queries.
 */ 
let $78ad46e0d6808149$export$1ee95821123803e6 = /*#__PURE__*/ function(TrelloSupportedPlannerProviders) {
    TrelloSupportedPlannerProviders["Google"] = "GOOGLE";
    return TrelloSupportedPlannerProviders;
}({}); /** Information for which switcher views are enabled for this board. */  /** Tag (or Collection). Used to group related entities in a workspace. */  /** A generic connection type to related Tags. */  /** A generic edge between an entity and a related Tag. */  /** The categories for the Trello template gallery. */  /** Connection type between the Template Gallery and the related Board Templates. */  /** Filters to apply when querying the Template Gallery. */  /** Information about a Template Gallery Item. */  /**
 * Statistics of the template gallery item such as view count and number of times
 * it's been copied.
 */ 
let $78ad46e0d6808149$export$d563dba18e915a44 = /*#__PURE__*/ function(TrelloWorkspaceMembershipType) {
    TrelloWorkspaceMembershipType["Admin"] = "ADMIN";
    TrelloWorkspaceMembershipType["Normal"] = "NORMAL";
    return TrelloWorkspaceMembershipType;
}({}); /** Connection type to represent workspace memberships */  /** Collection of preferences for the workspace. */  /** Product tiers for a TrelloWorkspace */ 
let $78ad46e0d6808149$export$c8c804aa42adf4e6 = /*#__PURE__*/ function(TrelloWorkspaceTier) {
    TrelloWorkspaceTier["Paid"] = "PAID";
    return TrelloWorkspaceTier;
}({}); /** Handles detaching a dataManager from a Component */  /** Response from editing an app contributor role */  /** Input payload for enrolling scopes to an app environment */  /** Response from enrolling scopes into an app environment */  /** Input payload for updating an Atlassian OAuth Client mutation */  /** Response from updating an oauth client */  /** Accepts input to update a data manager on a component. */  /** The payload returned from updating a data manager of a component. */  /** Accepts input for updating an existing component. */  /** Accepts input for updating a component link. */  /** The payload returned after updating a component link. */  /** The payload returned from updating an existing component. */  /** Accepts input for updating an existing component's type. */  /** Input to update the metadata for a component type. */  /** The result from updating the metadata for a component type. */  /** The payload returned from updating a component's type. */  /** Accepts input to update a field. */  /** Accepts input to a update a scorecard criterion representing the presence of a description. */  /** Accepts input to update a scorecard criterion representing the presence of a field, for example, 'Has Tier'. */  /** Accepts input to update a scorecard criterion representing the presence of a link, for example, 'Has Repository' or 'Has Documentation'. */  /** Accepts input to update a scorecard criterion checking the value of a specified metric ID. */  /** Accepts input to a update a scorecard criterion representing the presence of an owner. */  /** Accepts details of the link to be updated. */  /** The payload returned from updating a scorecard criterion. */  /** The input sent when updating user defined parameters. */  /** The payload returned from updating user defined parameters. */  /**
 * ###################################################################################################################
 *  COMPASS API SPEC
 * ###################################################################################################################
 */ 
let $78ad46e0d6808149$export$8808d536a6b2ef88 = /*#__PURE__*/ function(UserInstallationRuleValue) {
    UserInstallationRuleValue["Allow"] = "allow";
    UserInstallationRuleValue["Deny"] = "deny";
    return UserInstallationRuleValue;
}({});
let $78ad46e0d6808149$export$4789b44fbe86836 = /*#__PURE__*/ function(VirtualAgentConversationActionType) {
    VirtualAgentConversationActionType["AiAnswered"] = "AI_ANSWERED";
    VirtualAgentConversationActionType["Matched"] = "MATCHED";
    VirtualAgentConversationActionType["Unhandled"] = "UNHANDLED";
    return VirtualAgentConversationActionType;
}({});
let $78ad46e0d6808149$export$e372c28ac4fddc25 = /*#__PURE__*/ function(VirtualAgentConversationCsatOptionType) {
    VirtualAgentConversationCsatOptionType["CsatOption_1"] = "CSAT_OPTION_1";
    VirtualAgentConversationCsatOptionType["CsatOption_2"] = "CSAT_OPTION_2";
    VirtualAgentConversationCsatOptionType["CsatOption_3"] = "CSAT_OPTION_3";
    VirtualAgentConversationCsatOptionType["CsatOption_4"] = "CSAT_OPTION_4";
    VirtualAgentConversationCsatOptionType["CsatOption_5"] = "CSAT_OPTION_5";
    return VirtualAgentConversationCsatOptionType;
}({});
let $78ad46e0d6808149$export$620fe609179029be = /*#__PURE__*/ function(VirtualAgentConversationState) {
    VirtualAgentConversationState["Closed"] = "CLOSED";
    VirtualAgentConversationState["Escalated"] = "ESCALATED";
    VirtualAgentConversationState["Open"] = "OPEN";
    VirtualAgentConversationState["Resolved"] = "RESOLVED";
    return VirtualAgentConversationState;
}({}); /** Accepts input for creating a VirtualAgent Configuration. */  /**
 * A temporary type for VirtualAgentIntentProjection until it's properly migrated over to Verbena
 * Do not diverge it from the original
 */ 
let $78ad46e0d6808149$export$68d524b762f21460 = /*#__PURE__*/ function(VirtualAgentIntentTemplateType) {
    VirtualAgentIntentTemplateType["Discovered"] = "DISCOVERED";
    VirtualAgentIntentTemplateType["Shared"] = "SHARED";
    VirtualAgentIntentTemplateType["Standard"] = "STANDARD";
    return VirtualAgentIntentTemplateType;
}({}); /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Query API. */  /** The top level wrapper for the Virtual Agent Query API. */  /** The top level wrapper for the Virtual Agent Query API. */  /** Accepts input for updating an existing VirtualAgent Configuration. */  /** User facing validation error. On the FE this mutation error will not go to Sentry */ 
let $78ad46e0d6808149$export$f794720beec52585 = /*#__PURE__*/ function(WorkSuggestionsAction) {
    WorkSuggestionsAction["Remove"] = "REMOVE";
    WorkSuggestionsAction["Snooze"] = "SNOOZE";
    return WorkSuggestionsAction;
}({}); /** Input for the mutation operations (snooze and remove). */ 
let $78ad46e0d6808149$export$fcfd01bc876454f4 = /*#__PURE__*/ function(WorkSuggestionsApprovalStatus) {
    WorkSuggestionsApprovalStatus["Approved"] = "APPROVED";
    WorkSuggestionsApprovalStatus["Needswork"] = "NEEDSWORK";
    WorkSuggestionsApprovalStatus["Unapproved"] = "UNAPPROVED";
    WorkSuggestionsApprovalStatus["Unknown"] = "UNKNOWN";
    return WorkSuggestionsApprovalStatus;
}({});
let $78ad46e0d6808149$export$4dffae97a15618f = /*#__PURE__*/ function(WorkSuggestionsAutoDevJobState) {
    WorkSuggestionsAutoDevJobState["Cancelled"] = "CANCELLED";
    WorkSuggestionsAutoDevJobState["CodeGenerating"] = "CODE_GENERATING";
    WorkSuggestionsAutoDevJobState["CodeGenerationFail"] = "CODE_GENERATION_FAIL";
    WorkSuggestionsAutoDevJobState["CodeGenerationReady"] = "CODE_GENERATION_READY";
    WorkSuggestionsAutoDevJobState["CodeGenerationSuccess"] = "CODE_GENERATION_SUCCESS";
    WorkSuggestionsAutoDevJobState["Created"] = "CREATED";
    WorkSuggestionsAutoDevJobState["PlanGenerating"] = "PLAN_GENERATING";
    WorkSuggestionsAutoDevJobState["PlanGenerationFail"] = "PLAN_GENERATION_FAIL";
    WorkSuggestionsAutoDevJobState["PlanGenerationSuccess"] = "PLAN_GENERATION_SUCCESS";
    WorkSuggestionsAutoDevJobState["PullrequestCreating"] = "PULLREQUEST_CREATING";
    WorkSuggestionsAutoDevJobState["PullrequestCreationFail"] = "PULLREQUEST_CREATION_FAIL";
    WorkSuggestionsAutoDevJobState["PullrequestCreationSuccess"] = "PULLREQUEST_CREATION_SUCCESS";
    WorkSuggestionsAutoDevJobState["Unknown"] = "UNKNOWN";
    return WorkSuggestionsAutoDevJobState;
}({}); /** projectAri is always required, but sprintAri can also be specified */ 
let $78ad46e0d6808149$export$4f315a2279163c82 = /*#__PURE__*/ function(WorkSuggestionsEnvironmentType) {
    WorkSuggestionsEnvironmentType["Development"] = "DEVELOPMENT";
    WorkSuggestionsEnvironmentType["Production"] = "PRODUCTION";
    WorkSuggestionsEnvironmentType["Staging"] = "STAGING";
    WorkSuggestionsEnvironmentType["Testing"] = "TESTING";
    WorkSuggestionsEnvironmentType["Unmapped"] = "UNMAPPED";
    return WorkSuggestionsEnvironmentType;
}({}); /** An interface for all suggestion types supported by Periscope page */  /** Response for the recent pull requests suggestions */  /** Input for the mutation operations (save user profile). */  /** Action object stored in the database for the actions snooze/remove task. */  /**
 * Persona for the user profile.
 * For example: DEVELOPER
 */ 
let $78ad46e0d6808149$export$6d0f92f77f50b1c2 = /*#__PURE__*/ function(WorkSuggestionsUserPersona) {
    WorkSuggestionsUserPersona["Developer"] = "DEVELOPER";
    return WorkSuggestionsUserPersona;
}({}); /** User profile type for the user */ 
let $78ad46e0d6808149$export$88e2a9ce86b144d3 = /*#__PURE__*/ function(WorkSuggestionsVulnerabilityStatus) {
    WorkSuggestionsVulnerabilityStatus["Closed"] = "CLOSED";
    WorkSuggestionsVulnerabilityStatus["Ignored"] = "IGNORED";
    WorkSuggestionsVulnerabilityStatus["Open"] = "OPEN";
    WorkSuggestionsVulnerabilityStatus["Unknown"] = "UNKNOWN";
    return WorkSuggestionsVulnerabilityStatus;
}({}); /** An Applied Directive is an instances of a directive as applied to a schema element. This type is NOT specified by the graphql specification presently. */  /** Directive arguments can have names and values.  The values are in graphql SDL syntax printed as a string. This type is NOT specified by the graphql specification presently. */ 
let $78ad46e0d6808149$export$32baded4868555f5 = /*#__PURE__*/ function(SourceBillingType) {
    SourceBillingType["Ccp"] = "CCP";
    SourceBillingType["Hams"] = "HAMS";
    return SourceBillingType;
}({});

});

parcelRegister("bTrQR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a8a6f8777a3fdf8$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $ighTk = parcelRequire("ighTk");
function $8a8a6f8777a3fdf8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8a8a6f8777a3fdf8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8a8a6f8777a3fdf8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8a8a6f8777a3fdf8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/* Module-scoped config. */ const $8a8a6f8777a3fdf8$var$loggerConfig = {
    mode: 'sentry'
};
const $8a8a6f8777a3fdf8$export$229f4b2b611b052d = ()=>{
    if (window.location.href.includes('emcee')) return window.location.hash.split('#')[1];
};
const $8a8a6f8777a3fdf8$var$logLevelToSentrySeverity = (logLevel)=>{
    const logLevelToSentryLevelMappings = {
        info: 'info',
        warn: 'warning',
        error: 'error'
    };
    return logLevelToSentryLevelMappings[logLevel];
};
const $8a8a6f8777a3fdf8$export$bfcc8eb13073c803 = (options)=>{
    const { mode: mode = 'sentry', context: context = {} } = options || {};
    $8a8a6f8777a3fdf8$var$loggerConfig.mode = mode;
    $8a8a6f8777a3fdf8$var$loggerConfig.context = context;
};
const $8a8a6f8777a3fdf8$export$a4f9dc99be407671 = (context)=>{
    $8a8a6f8777a3fdf8$var$loggerConfig.context = context;
};
const $8a8a6f8777a3fdf8$export$4c8db6aea605e98 = ()=>{
    $8a8a6f8777a3fdf8$var$loggerConfig.context = {};
};
const $8a8a6f8777a3fdf8$var$sendData = (level, location, message, data)=>{
    const eventData = data || {};
    const { mode: mode, context: context = {} } = $8a8a6f8777a3fdf8$var$loggerConfig;
    if (mode === 'console') console[level]($8a8a6f8777a3fdf8$var$_objectSpread($8a8a6f8777a3fdf8$var$_objectSpread({}, eventData), {}, {
        location: location,
        message: message,
        context: context
    }));
    else {
        var _getSentryClient;
        (_getSentryClient = (0, $ighTk.default)()) === null || _getSentryClient === void 0 || _getSentryClient.withScope((scope)=>{
            var _getSentryClient2;
            const { tags: tags = {} } = eventData;
            scope.clear();
            Object.entries(tags).forEach((_ref)=>{
                let [tagKey, tagValue] = _ref;
                scope.setTag(tagKey, tagValue);
            });
            // To override emcee iframe url
            const pathname = $8a8a6f8777a3fdf8$export$229f4b2b611b052d();
            if (pathname) scope.setTag('url', pathname);
            scope.setTag('location', location);
            scope.setTag('structuredLog', 'true');
            scope.setExtra('eventData', eventData);
            (_getSentryClient2 = (0, $ighTk.default)()) === null || _getSentryClient2 === void 0 || _getSentryClient2.captureMessage("".concat(location, ": ").concat(message), $8a8a6f8777a3fdf8$var$logLevelToSentrySeverity(level));
            console[level]("".concat(location, ": ").concat(message));
        });
    }
};
const $8a8a6f8777a3fdf8$var$info = (location, message, eventData)=>{
    $8a8a6f8777a3fdf8$var$sendData('info', location, message, eventData);
};
const $8a8a6f8777a3fdf8$var$warn = (location, message, eventData)=>{
    $8a8a6f8777a3fdf8$var$sendData('warn', location, message, eventData);
};
const $8a8a6f8777a3fdf8$var$error = (location, message, eventData)=>{
    $8a8a6f8777a3fdf8$var$sendData('error', location, message, eventData);
};
var $8a8a6f8777a3fdf8$export$2e2bcd8739ae039 = {
    info: $8a8a6f8777a3fdf8$var$info,
    warn: $8a8a6f8777a3fdf8$var$warn,
    error: $8a8a6f8777a3fdf8$var$error
};

});
parcelRegister("ighTk", function(module, exports) {

$parcel$export(module.exports, "resetSentryClient", () => $d4b7997452326403$export$8a6de2d979474935);
$parcel$export(module.exports, "default", () => $d4b7997452326403$export$2e2bcd8739ae039);
$parcel$export(module.exports, "setSentryClient", () => $d4b7997452326403$export$7d446c6f4e54de82);
let $d4b7997452326403$var$sentryInstance = null;
function $d4b7997452326403$export$8a6de2d979474935() {
    $d4b7997452326403$var$sentryInstance = null;
    delete window.__MARKETPLACE_SENTRY_INSTANCE__;
}
function $d4b7997452326403$export$2e2bcd8739ae039() {
    var _sentryInstance;
    let throwException = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    const instance = (_sentryInstance = $d4b7997452326403$var$sentryInstance) !== null && _sentryInstance !== void 0 ? _sentryInstance : window.__MARKETPLACE_SENTRY_INSTANCE__;
    if (!instance && throwException) console.error('Called sentry method without first calling `init`');
    return instance;
}
function $d4b7997452326403$export$7d446c6f4e54de82(client) {
    let attachToWindow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (attachToWindow) {
        window.__MARKETPLACE_SENTRY_INSTANCE__ = client;
        return window.__MARKETPLACE_SENTRY_INSTANCE__;
    }
    $d4b7997452326403$var$sentryInstance = client;
    return $d4b7997452326403$var$sentryInstance;
}

});



parcelRegister("iW4kt", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc91007814345ce6$export$2e2bcd8739ae039);

var $bwPfh = parcelRequire("bwPfh");

var $5zQU9 = parcelRequire("5zQU9");

var $jYVKV = parcelRequire("jYVKV");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $5YKni = parcelRequire("5YKni");
const $dc91007814345ce6$var$_excluded = [
    "children"
];
function $dc91007814345ce6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dc91007814345ce6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dc91007814345ce6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dc91007814345ce6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $dc91007814345ce6$export$2e2bcd8739ae039 extends $eUqFw.Component {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "onEvent", (event)=>{
            const _this$props = this.props, { children: children } = _this$props, attributes = (0, $bwPfh.default)(_this$props, $dc91007814345ce6$var$_excluded);
            event.update((payload)=>$dc91007814345ce6$var$_objectSpread($dc91007814345ce6$var$_objectSpread({}, payload), {}, {
                    attributes: $dc91007814345ce6$var$_objectSpread($dc91007814345ce6$var$_objectSpread({}, payload.attributes), attributes)
                }));
        });
    }
    render() {
        return /*#__PURE__*/ $eUqFw.createElement((0, $jYVKV.default), {
            channel: (0, $5YKni.EVENT_CHANNEL),
            onEvent: this.onEvent
        }, this.props.children);
    }
}
(0, $5zQU9.default)($dc91007814345ce6$export$2e2bcd8739ae039, "propTypes", {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node.isRequired
});

});
parcelRegister("bwPfh", function(module, exports) {

$parcel$export(module.exports, "default", () => $864a6f28f9285041$export$2e2bcd8739ae039);

var $6XgOP = parcelRequire("6XgOP");
function $864a6f28f9285041$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $6XgOP.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], t.indexOf(o) >= 0 || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});


parcelRegister("ieOz2", function(module, exports) {

$parcel$export(module.exports, "default", () => $d470c1cdfeeb1097$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $lgRZl = parcelRequire("lgRZl");

var $f2QOW = parcelRequire("f2QOW");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $5YKni = parcelRequire("5YKni");

var $6jEcw = parcelRequire("6jEcw");

var $90ON9 = parcelRequire("90ON9");

var $4KyM2 = parcelRequire("4KyM2");

var $kLILm = parcelRequire("kLILm");
class $d470c1cdfeeb1097$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        var _this$props$hit, _this$props$hit2;
        const analyticsContextAttributes = {
            source: (0, $5YKni.ANALYTICS_EVENT_SOURCE_APP_TILE),
            appName: (_this$props$hit = this.props.hit) === null || _this$props$hit === void 0 ? void 0 : _this$props$hit.getIn([
                'name'
            ]),
            vendorName: (_this$props$hit2 = this.props.hit) === null || _this$props$hit2 === void 0 ? void 0 : _this$props$hit2.getIn([
                'vendor',
                'name'
            ])
        };
        return this.props.screenClass === 'xs' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kLILm.default), {
            colSpan: this.props.colSpan,
            contentOverride: this.props.contentOverride,
            fromSearch: this.props.fromSearch,
            hit: this.props.hit,
            hitContext: this.props.hitContext,
            perspective: this.props.perspective,
            screenClass: this.props.screenClass,
            hasCloudSecurityBadge: this.props.hasCloudSecurityBadge,
            hasCloudFortifiedBadge: this.props.hasCloudFortifiedBadge,
            filters: this.props.filters,
            sectionTitle: this.props.sectionTitle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f2QOW.default), {
            attributes: analyticsContextAttributes
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4KyM2.default), {
            colSpan: this.props.colSpan,
            contentOverride: this.props.contentOverride,
            fromSearch: this.props.fromSearch,
            hit: this.props.hit,
            hitContext: this.props.hitContext,
            onCategoryClick: this.props.onCategoryClick,
            perspective: this.props.perspective,
            screenClass: this.props.screenClass,
            stateChangeRequested: this.props.stateChangeRequested,
            overrideLargeHitRightContent: this.props.overrideLargeHitRightContent,
            hasCloudSecurityBadge: this.props.hasCloudSecurityBadge,
            hasCloudFortifiedBadge: this.props.hasCloudFortifiedBadge,
            filters: this.props.filters,
            sectionTitle: this.props.sectionTitle
        }));
    }
}
(0, $5zQU9.default)($d470c1cdfeeb1097$export$2e2bcd8739ae039, "propTypes", {
    colSpan: (0, $90ON9.default).colSpan.isRequired,
    contentOverride: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node,
    fromSearch: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
    hit: (0, $lgRZl.default).requiredIf((0, $90ON9.default).hit(), (props)=>!props.contentOverride),
    hitContext: (0, $lgRZl.default).requiredIf((0, $90ON9.default).hitContext, (props)=>!props.contentOverride),
    onCategoryClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    perspective: (0, $6jEcw.default).perspective,
    screenClass: (0, $90ON9.default).screenClass.isRequired,
    stateChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    overrideLargeHitRightContent: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    hasCloudSecurityBadge: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    hasCloudFortifiedBadge: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    filters: (0, $90ON9.default).filters,
    sectionTitle: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string
});

});
parcelRegister("f2QOW", function(module, exports) {

$parcel$export(module.exports, "MARKETPLACE_ANALYTICS_CONTEXT_NAMESPACE", () => $af4003f95e63f44c$export$62dccf523df3e44b);
$parcel$export(module.exports, "default", () => $af4003f95e63f44c$export$2e2bcd8739ae039);
// eslint-disable-next-line no-restricted-imports

var $aw5Sy = parcelRequire("aw5Sy");

var $eUqFw = parcelRequire("eUqFw");
const $af4003f95e63f44c$export$62dccf523df3e44b = 'marketplaceCtx';
const $af4003f95e63f44c$var$MarketplaceAnalyticsContext = (props)=>{
    const { attributes: attributes = {}, properties: properties = {}, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: {
            [$af4003f95e63f44c$export$62dccf523df3e44b]: {
                attributes: attributes,
                properties: properties
            }
        }
    }, children);
};
var $af4003f95e63f44c$export$2e2bcd8739ae039 = $af4003f95e63f44c$var$MarketplaceAnalyticsContext;

});

parcelRegister("4KyM2", function(module, exports) {

$parcel$export(module.exports, "default", () => $37566ea4338deec6$export$2e2bcd8739ae039);

var $ivYBE = parcelRequire("ivYBE");
var $37566ea4338deec6$export$2e2bcd8739ae039 = (0, $ivYBE.default);

});
parcelRegister("ivYBE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7aa2267046a5aad$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $ffiyv = parcelRequire("ffiyv");

var $ivTMz = parcelRequire("ivTMz");

var $j0gMm = parcelRequire("j0gMm");

var $f7YGc = parcelRequire("f7YGc");
var $lgRZl = parcelRequire("lgRZl");
var $Lig7B = parcelRequire("Lig7B");
var $hxCMl = parcelRequire("hxCMl");

var $inwKI = parcelRequire("inwKI");

var $3BBSQ = parcelRequire("3BBSQ");
var $8sH3O = parcelRequire("8sH3O");
var $5YcrV = parcelRequire("5YcrV");
var $3ihpf = parcelRequire("3ihpf");
var $8xfj9 = parcelRequire("8xfj9");

var $jdjb1 = parcelRequire("jdjb1");

var $76fzC = parcelRequire("76fzC");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $6jEcw = parcelRequire("6jEcw");

var $90ON9 = parcelRequire("90ON9");

var $8wSvA = parcelRequire("8wSvA");

var $23J4Z = parcelRequire("23J4Z");

var $2AdLY = parcelRequire("2AdLY");

var $kXHwt = parcelRequire("kXHwt");
function $d7aa2267046a5aad$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d7aa2267046a5aad$export$a4cdd86caeeed29c = (0, $3UXZ8.default)("div", {
    target: "e1p4sqm40",
    label: "LargeHitContainer"
})({
    name: "1g4yje1",
    styles: "display:flex;flex-direction:column;height:100%;"
});
const $d7aa2267046a5aad$export$bfc559a6587679fa = /*#__PURE__*/ (0, $3UXZ8.default)((0, $8sH3O.default), {
    target: "e1p4sqm41",
    label: "LargeHitStyled"
})("display:flex;flex-direction:column;padding:0;height:100%;background:", "var(--ds-surface-overlay, ".concat((0, $j0gMm.N0), ")"), ";a{text-decoration:none;&:hover,&:focus{text-decoration:none;}}");
const $d7aa2267046a5aad$export$29c0e362412a40fd = /*#__PURE__*/ (0, $3UXZ8.default)((0, $2AdLY.default), {
    target: "e1p4sqm42",
    label: "HitLinkStyled"
})({
    name: "1xgo7sw",
    styles: "display:flex;flex-direction:column;max-height:290px;padding:var(--ds-space-200, 16px) var(--ds-space-150, 12px) 10px;flex-grow:1;"
});
const $d7aa2267046a5aad$export$9204afa15bdaec56 = (0, $3UXZ8.default)("div", {
    target: "e1p4sqm43",
    label: "HeadingContainer"
})({
    name: "1tu59u4",
    styles: "flex:0 0 auto;"
});
const $d7aa2267046a5aad$export$4b2c32e08f77ff18 = (0, $3UXZ8.default)("div", {
    target: "e1p4sqm44",
    label: "Body"
})("display:flex;flex-direction:column;color:", "var(--ds-text-subtle, ".concat((0, $j0gMm.N500), ")"), ";font-size:14px;overflow:hidden;word-wrap:break-word;line-height:", 18 / 14, ";", (0, $jdjb1.multilineEllipsis)(3, "var(--ds-space-800, 64px)"), "");
const $d7aa2267046a5aad$export$aab12223ec536033 = (0, $3UXZ8.default)("div", {
    target: "e1p4sqm45",
    label: "CategoriesContainer"
})({
    name: "1l4a28d",
    styles: "min-height:16px;max-height:16px;margin-top:var(--ds-space-050, 4px);"
});
const $d7aa2267046a5aad$export$a06f1c675e846f6f = (0, $3UXZ8.default)("div", {
    target: "e1p4sqm46",
    label: "Footer"
})({
    name: "cjkuwg",
    styles: "display:flex;flex-direction:row;min-height:22px;max-height:22px;margin-top:var(--ds-space-150, 12px);"
});
const $d7aa2267046a5aad$export$1a18b36cd550751e = (0, $3UXZ8.default)("div", {
    target: "e1p4sqm47",
    label: "FooterRightContainer"
})("flex:1 1 auto;margin-left:5px;text-align:right;", (0, $jdjb1.ellipsis), "");
const $d7aa2267046a5aad$export$7488dbc17290f084 = (0, $3UXZ8.default)("div", {
    target: "e1p4sqm48",
    label: "LargeHitVendorStyled"
})({
    name: "1ed1egu",
    styles: "padding-top:5px;font-size:14px;"
});
const $d7aa2267046a5aad$export$83a341453e49cfdc = (0, $3UXZ8.default)("span", {
    target: "e1p4sqm49",
    label: "Installs"
})("color:", "var(--ds-text-subtlest, ".concat((0, $j0gMm.N100), ")"), ";font-size:12px;");
const $d7aa2267046a5aad$export$3b754b8c8a8062da = /*#__PURE__*/ (0, $3UXZ8.default)((0, $5YcrV.default), {
    target: "e1p4sqm410",
    label: "CloudFortifiedAppBadgeStyled"
})("display:flex;justify-content:center;align-items:center;border-top:1px solid ", "var(--ds-border, ".concat((0, $j0gMm.N30), ")"), ";padding:var(--ds-space-100, 8px) 0;font-size:14px;border-radius:0 0 ", (0, $ivTMz.borderRadius)(), "px ", (0, $ivTMz.borderRadius)(), "px;");
const $d7aa2267046a5aad$export$177cf549479db0d9 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $3ihpf.default), {
    target: "e1p4sqm411",
    label: "CloudSecurityParticipantBadgeStyled"
})("display:flex;justify-content:center;border-top:1px solid ", "var(--ds-border, ".concat((0, $j0gMm.N30), ")"), ";padding:var(--ds-space-100, 8px) 0;font-size:14px;");
const $d7aa2267046a5aad$export$93a18d2ec5ed521f = /*#__PURE__*/ (0, $3UXZ8.default)((0, $hxCMl.default), {
    target: "e1p4sqm412",
    label: "StatelessColStyled"
})({
    name: "ud5h78",
    styles: "margin-bottom:var(--ds-space-250, 20px);"
});
function $d7aa2267046a5aad$export$2e2bcd8739ae039(props) {
    (0, $eUqFw.useEffect)(()=>{
        if (props.hitContext && props.hitContext.get('onHitMount')) props.hitContext.get('onHitMount')({
            hit: props.hit
        });
    }, []);
    const { replaceCategoriesOnAppTilesWithVendorName: replaceCategoriesOnAppTilesWithVendorName } = (0, $inwKI.useFeatureFlags)();
    const onRatingsClick = ()=>{
        props.hitContext.get('onRatingsClick')({
            hit: props.hit
        });
    };
    const certificationBadge = (hasCloudSecurityBadge, hasCloudFortifiedBadge)=>{
        if (hasCloudFortifiedBadge) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d7aa2267046a5aad$export$3b754b8c8a8062da, {
            showLabel: true,
            source: (0, $5YcrV.CloudFortifiedAppBadgeSources).AppTile
        });
        return hasCloudSecurityBadge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d7aa2267046a5aad$export$177cf549479db0d9, {
            showLabel: true
        });
    };
    const renderHitContents = ()=>{
        var _props$hit$getIn;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d7aa2267046a5aad$export$bfc559a6587679fa, {
            testId: "app-tile",
            badgeVariant: resolveAppTileBadgeVariant()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d7aa2267046a5aad$export$29c0e362412a40fd, {
            fromSearch: props.fromSearch,
            hit: props.hit,
            hitContext: props.hitContext,
            perspective: props.perspective,
            filters: props.filters,
            sectionTitle: props.sectionTitle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d7aa2267046a5aad$export$9204afa15bdaec56, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kXHwt.default), {
            fromSearch: props.fromSearch,
            hit: props.hit,
            hitImageHrefResolver: props.hitContext.get('hitImageHrefResolver')
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d7aa2267046a5aad$export$4b2c32e08f77ff18, null, resolveTagLine()), replaceCategoriesOnAppTilesWithVendorName ? props.hit.get('vendor') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d7aa2267046a5aad$export$7488dbc17290f084, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8xfj9.default), {
            name: props.hit.getIn([
                'vendor',
                'name'
            ]),
            pathname: "/vendors/".concat(props.hit.getIn([
                'vendor',
                'id'
            ])),
            partnerTierType: (_props$hit$getIn = props.hit.getIn([
                'vendor',
                'partnerTier',
                'type'
            ])) === null || _props$hit$getIn === void 0 ? void 0 : _props$hit$getIn.toUpperCase()
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d7aa2267046a5aad$export$aab12223ec536033, null, props.hit.get('categories') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $23J4Z.default), {
            categories: props.hit.get('categories'),
            onCategoryClick: props.onCategoryClick,
            perspective: props.perspective
        }) : undefined), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d7aa2267046a5aad$export$a06f1c675e846f6f, null, props.hit.get('ratings') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $Lig7B.default), {
            onClick: props.hitContext.get('onRatingsClick') && onRatingsClick,
            ratings: props.hit.get('ratings').toJS()
        }) : undefined, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d7aa2267046a5aad$export$1a18b36cd550751e, null, resolveRightContent()))), certificationBadge(props.hasCloudSecurityBadge, props.hasCloudFortifiedBadge));
    };
    const resolveTagLine = ()=>{
        if (props.hit.get('tagLine')) {
            const highlightedText = (0, $8wSvA.createHighlights)(props.hit, 'tagLine', 'tokenizedTagLine');
            return highlightedText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3BBSQ.AppTileHighlightedText), {
                highlightedText: highlightedText,
                originalText: props.hit.get('tagLine')
            }) : props.hit.get('tagLine');
        }
    };
    const hasMarketingLabel = (marketingLabels, labelToFilter)=>{
        return marketingLabels && marketingLabels.some((label)=>label === labelToFilter);
    };
    const resolveAppTileBadgeVariant = ()=>{
        let badgeVariant;
        const marketingLabels = props.hit.get('marketingLabels');
        if (hasMarketingLabel(marketingLabels, 'Spotlight')) badgeVariant = 'spotlight';
        else if (hasMarketingLabel(marketingLabels, 'Bestseller')) badgeVariant = 'bestSeller';
        else if (hasMarketingLabel(marketingLabels, 'Rising Star')) badgeVariant = 'risingStar';
        else {
            const releaseDate = props.hit.get('releaseDate');
            badgeVariant = Math.abs((0, $76fzC).differenceInDaysToNow(releaseDate)) < 14 ? 'new' : undefined;
        }
        return badgeVariant;
    };
    const resolveRightContent = ()=>{
        const isBundled = props.hit.getIn([
            'distribution',
            'bundled'
        ]);
        const overriddenContent = props.overrideLargeHitRightContent(props.hit.get('addonKey'));
        if (overriddenContent) return overriddenContent;
        else {
            if (isBundled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                appearance: "default"
            }, "Preinstalled");
            const installs = props.hit.getIn([
                'distribution',
                'activeInstalls'
            ]);
            const downloads = props.hit.getIn([
                'distribution',
                'downloads'
            ]);
            if (installs || downloads) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d7aa2267046a5aad$export$83a341453e49cfdc, null, installs ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, (0, $f7YGc).shortFormat(installs), " install", installs > 1 ? 's' : '') : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, (0, $f7YGc).shortFormat(downloads), " download", downloads > 1 ? 's' : ''));
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d7aa2267046a5aad$export$93a18d2ec5ed521f, {
        gutterWidth: 20,
        xl: props.colSpan.getIn([
            'largeHits',
            'xl'
        ]) || 4,
        lg: props.colSpan.getIn([
            'largeHits',
            'lg'
        ]) || 4,
        md: props.colSpan.getIn([
            'largeHits',
            'md'
        ]) || 4,
        sm: props.colSpan.getIn([
            'largeHits',
            'sm'
        ]) || 6,
        xs: props.colSpan.getIn([
            'largeHits',
            'xs'
        ]) || 12,
        screenClass: props.screenClass
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d7aa2267046a5aad$export$a4cdd86caeeed29c, null, props.contentOverride || renderHitContents()));
}
$d7aa2267046a5aad$export$2e2bcd8739ae039.propTypes = {
    colSpan: (0, $90ON9.default).colSpan.isRequired,
    contentOverride: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node,
    fromSearch: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
    hit: (0, $lgRZl.default).requiredIf((0, $90ON9.default).hit(), (props)=>!props.contentOverride),
    hitContext: (0, $lgRZl.default).requiredIf((0, $90ON9.default).hitContext, (props)=>!props.contentOverride),
    onCategoryClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    perspective: (0, $6jEcw.default).perspective,
    screenClass: (0, $90ON9.default).screenClass.isRequired,
    stateChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    overrideLargeHitRightContent: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    hasCloudSecurityBadge: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    hasCloudFortifiedBadge: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    badgeVariant: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    filters: (0, $90ON9.default).filters,
    sectionTitle: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string
};
$d7aa2267046a5aad$export$2e2bcd8739ae039.defaultProps = {
    overrideLargeHitRightContent: ()=>{
    /* do nothing by default */ }
};

});
parcelRegister("f7YGc", function(module, exports) {

$parcel$export(module.exports, "longFormat", () => $b03694281b9bb755$export$8425645f696d2172);
$parcel$export(module.exports, "longCurrencyFormat", () => $b03694281b9bb755$export$cc801163984d8dcc);
$parcel$export(module.exports, "shortFormat", () => $b03694281b9bb755$export$e4ad565cfdf0f5ad);
$parcel$export(module.exports, "shortCurrencyFormat", () => $b03694281b9bb755$export$d305380cf8231832);

var $9IgQE = parcelRequire("9IgQE");
const $b03694281b9bb755$export$8425645f696d2172 = (number)=>(0, (/*@__PURE__*/$parcel$interopDefault($9IgQE)))(number).format('0,0');
const $b03694281b9bb755$export$cc801163984d8dcc = (number)=>(0, (/*@__PURE__*/$parcel$interopDefault($9IgQE)))(number).format('$0,0');
const $b03694281b9bb755$export$e4ad565cfdf0f5ad = (number)=>(0, (/*@__PURE__*/$parcel$interopDefault($9IgQE)))(number).format('0[.]0a');
const $b03694281b9bb755$export$d305380cf8231832 = (number)=>(0, (/*@__PURE__*/$parcel$interopDefault($9IgQE)))(number).format('$0[.]00a');

});
parcelRegister("9IgQE", function(module, exports) {
/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */ (function(global, factory) {
    if (typeof define === 'function' && define.amd) define(factory);
    else if (0, module.exports) module.exports = factory();
    else global.numeral = factory();
})(module.exports, function() {
    /************************************
        Variables
    ************************************/ var numeral, _, VERSION = '2.0.6', formats = {}, locales = {}, defaults = {
        currentLocale: 'en',
        zeroFormat: null,
        nullFormat: null,
        defaultFormat: '0,0',
        scalePercentBy100: true
    }, options = {
        currentLocale: defaults.currentLocale,
        zeroFormat: defaults.zeroFormat,
        nullFormat: defaults.nullFormat,
        defaultFormat: defaults.defaultFormat,
        scalePercentBy100: defaults.scalePercentBy100
    };
    /************************************
        Constructors
    ************************************/ // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;
        this._value = number;
    }
    numeral = function(input) {
        var value, kind, unformatFunction, regexp;
        if (numeral.isNumeral(input)) value = input.value();
        else if (input === 0 || typeof input === 'undefined') value = 0;
        else if (input === null || _.isNaN(input)) value = null;
        else if (typeof input === 'string') {
            if (options.zeroFormat && input === options.zeroFormat) value = 0;
            else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) value = null;
            else {
                for(kind in formats){
                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;
                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;
                        break;
                    }
                }
                unformatFunction = unformatFunction || numeral._.stringToNumber;
                value = unformatFunction(input);
            }
        } else value = Number(input) || null;
        return new Numeral(input, value);
    };
    // version number
    numeral.version = VERSION;
    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };
    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale], negP = false, optDec = false, leadingCount = 0, abbr = '', trillion = 1000000000000, billion = 1000000000, million = 1000000, thousand = 1000, decimal = '', neg = false, abbrForce, abs, min, max, power, int, precision, signed, thousands, output;
            // make sure we never format a null value
            value = value || 0;
            abs = Math.abs(value);
            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, '(')) {
                negP = true;
                format = format.replace(/[\(|\)]/g, '');
            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
                format = format.replace(/[\+|\-]/g, '');
            }
            // see if abbreviation is wanted
            if (numeral._.includes(format, 'a')) {
                abbrForce = format.match(/a(k|m|b|t)?/);
                abbrForce = abbrForce ? abbrForce[1] : false;
                // check for space before abbreviation
                if (numeral._.includes(format, ' a')) abbr = ' ';
                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');
                if (abs >= trillion && !abbrForce || abbrForce === 't') {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }
            // check for optional decimals
            if (numeral._.includes(format, '[.]')) {
                optDec = true;
                format = format.replace('[.]', '.');
            }
            // break number and format
            int = value.toString().split('.')[0];
            precision = format.split('.')[1];
            thousands = format.indexOf(',');
            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;
            if (precision) {
                if (numeral._.includes(precision, '[')) {
                    precision = precision.replace(']', '');
                    precision = precision.split('[');
                    decimal = numeral._.toFixed(value, precision[0].length + precision[1].length, roundingFunction, precision[1].length);
                } else decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                int = decimal.split('.')[0];
                if (numeral._.includes(decimal, '.')) decimal = locale.delimiters.decimal + decimal.split('.')[1];
                else decimal = '';
                if (optDec && Number(decimal.slice(1)) === 0) decimal = '';
            } else int = numeral._.toFixed(value, 0, roundingFunction);
            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);
                switch(abbr){
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }
            // format number
            if (numeral._.includes(int, '-')) {
                int = int.slice(1);
                neg = true;
            }
            if (int.length < leadingCount) for(var i = leadingCount - int.length; i > 0; i--)int = '0' + int;
            if (thousands > -1) int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
            if (format.indexOf('.') === 0) int = '';
            output = int + decimal + (abbr ? abbr : '');
            if (negP) output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
            else {
                if (signed >= 0) output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
                else if (neg) output = '-' + output;
            }
            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale], stringOriginal = string, abbreviations = {
                thousand: 3,
                million: 6,
                billion: 9,
                trillion: 12
            }, abbreviation, value, i, regexp;
            if (options.zeroFormat && string === options.zeroFormat) value = 0;
            else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) value = null;
            else {
                value = 1;
                if (locale.delimiters.decimal !== '.') string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
                for(abbreviation in abbreviations){
                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');
                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }
                // check for negative number
                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;
                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, '');
                value *= Number(string);
            }
            return value;
        },
        isNaN: function(value) {
            return typeof value === 'number' && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/ ) {
            if (this === null) throw new TypeError('Array.prototype.reduce called on null or undefined');
            if (typeof callback !== 'function') throw new TypeError(callback + ' is not a function');
            var t = Object(array), len = t.length >>> 0, k = 0, value;
            if (arguments.length === 3) value = arguments[2];
            else {
                while(k < len && !(k in t))k++;
                if (k >= len) throw new TypeError('Reduce of empty array with no initial value');
                value = t[k++];
            }
            for(; k < len; k++)if (k in t) value = callback(value, t[k], k, t);
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */ multiplier: function(x) {
            var parts = x.toString().split('.');
            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */ correctionFactor: function() {
            var args = Array.prototype.slice.call(arguments);
            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */ toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split('.'), minDecimals = maxDecimals - (optionals || 0), boundedPrecision, optionalsRegExp, power, output;
            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            else boundedPrecision = minDecimals;
            power = Math.pow(10, boundedPrecision);
            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);
            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
                output = output.replace(optionalsRegExp, '');
            }
            return output;
        }
    };
    // avaliable options
    numeral.options = options;
    // avaliable formats
    numeral.formats = formats;
    // avaliable formats
    numeral.locales = locales;
    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) options.currentLocale = key.toLowerCase();
        return options.currentLocale;
    };
    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) return locales[options.currentLocale];
        key = key.toLowerCase();
        if (!locales[key]) throw new Error('Unknown locale : ' + key);
        return locales[key];
    };
    numeral.reset = function() {
        for(var property in defaults)options[property] = defaults[property];
    };
    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof format === 'string' ? format : null;
    };
    numeral.nullFormat = function(format) {
        options.nullFormat = typeof format === 'string' ? format : null;
    };
    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof format === 'string' ? format : '0.0';
    };
    numeral.register = function(type, name, format) {
        name = name.toLowerCase();
        if (this[type + 's'][name]) throw new TypeError(name + ' ' + type + ' already registered.');
        this[type + 's'][name] = format;
        return format;
    };
    numeral.validate = function(val, culture) {
        var _decimalSep, _thousandSep, _currSymbol, _valArray, _abbrObj, _thousandRegEx, localeData, temp;
        //coerce val to string
        if (typeof val !== 'string') {
            val += '';
            if (console.warn) console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
        }
        //trim whitespaces from either sides
        val = val.trim();
        //if val is just digits return true
        if (!!val.match(/^\d+$/)) return true;
        //if val is empty return false
        if (val === '') return false;
        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }
        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === '.') _thousandSep = '\\.';
        else _thousandSep = localeData.delimiters.thousands;
        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) return false;
        }
        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) return false;
        }
        _thousandRegEx = new RegExp(_thousandSep + '{2}');
        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) return false;
            else {
                if (_valArray.length < 2) return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx);
                else {
                    if (_valArray[0].length === 1) return !!_valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
                    else return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
                }
            }
        }
        return false;
    };
    /************************************
        Numeral Prototype
    ************************************/ numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value, format = inputString || options.defaultFormat, kind, output, formatFunction;
            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;
            // format based on value
            if (value === 0 && options.zeroFormat !== null) output = options.zeroFormat;
            else if (value === null && options.nullFormat !== null) output = options.nullFormat;
            else {
                for(kind in formats)if (format.match(formats[kind].regexps.format)) {
                    formatFunction = formats[kind].format;
                    break;
                }
                formatFunction = formatFunction || numeral._.numberToFormat;
                output = formatFunction(value, format, roundingFunction);
            }
            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);
            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);
            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }
            this._value = _.reduce([
                this._value,
                value
            ], cback, 0) / corrFactor;
            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);
            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }
            this._value = _.reduce([
                value
            ], cback, Math.round(this._value * corrFactor)) / corrFactor;
            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }
            this._value = _.reduce([
                this._value,
                value
            ], cback, 1);
            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }
            this._value = _.reduce([
                this._value,
                value
            ], cback);
            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };
    /************************************
        Default Locale && Format
    ************************************/ numeral.register('locale', 'en', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function(number) {
            var b = number % 10;
            return ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });
    (function() {
        numeral.register('format', 'bps', {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, ' BPS') ? ' ' : '', output;
                value = value * 10000;
                // check for space before BPS
                format = format.replace(/\s?BPS/, '');
                output = numeral._.numberToFormat(value, format, roundingFunction);
                if (numeral._.includes(output, ')')) {
                    output = output.split('');
                    output.splice(-1, 0, space + 'BPS');
                    output = output.join('');
                } else output = output + space + 'BPS';
                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
    })();
    (function() {
        var decimal = {
            base: 1000,
            suffixes: [
                'B',
                'KB',
                'MB',
                'GB',
                'TB',
                'PB',
                'EB',
                'ZB',
                'YB'
            ]
        }, binary = {
            base: 1024,
            suffixes: [
                'B',
                'KiB',
                'MiB',
                'GiB',
                'TiB',
                'PiB',
                'EiB',
                'ZiB',
                'YiB'
            ]
        };
        var allSuffixes = decimal.suffixes.concat(binary.suffixes.filter(function(item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join('|');
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';
        numeral.register('format', 'bytes', {
            regexps: {
                format: /([0\s]i?b)/,
                unformat: new RegExp(unformatRegex)
            },
            format: function(value, format, roundingFunction) {
                var output, bytes = numeral._.includes(format, 'ib') ? binary : decimal, suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '', power, min, max;
                // check for space before
                format = format.replace(/\s?i?b/, '');
                for(power = 0; power <= bytes.suffixes.length; power++){
                    min = Math.pow(bytes.base, power);
                    max = Math.pow(bytes.base, power + 1);
                    if (value === null || value === 0 || value >= min && value < max) {
                        suffix += bytes.suffixes[power];
                        if (min > 0) value = value / min;
                        break;
                    }
                }
                output = numeral._.numberToFormat(value, format, roundingFunction);
                return output + suffix;
            },
            unformat: function(string) {
                var value = numeral._.stringToNumber(string), power, bytesMultiplier;
                if (value) {
                    for(power = decimal.suffixes.length - 1; power >= 0; power--){
                        if (numeral._.includes(string, decimal.suffixes[power])) {
                            bytesMultiplier = Math.pow(decimal.base, power);
                            break;
                        }
                        if (numeral._.includes(string, binary.suffixes[power])) {
                            bytesMultiplier = Math.pow(binary.base, power);
                            break;
                        }
                    }
                    value *= bytesMultiplier || 1;
                }
                return value;
            }
        });
    })();
    (function() {
        numeral.register('format', 'currency', {
            regexps: {
                format: /(\$)/
            },
            format: function(value, format, roundingFunction) {
                var locale = numeral.locales[numeral.options.currentLocale], symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                }, output, symbol, i;
                // strip format of spaces and $
                format = format.replace(/\s?\$\s?/, '');
                // format the number
                output = numeral._.numberToFormat(value, format, roundingFunction);
                // update the before and after based on value
                if (value >= 0) {
                    symbols.before = symbols.before.replace(/[\-\(]/, '');
                    symbols.after = symbols.after.replace(/[\-\)]/, '');
                } else if (value < 0 && !numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '(')) symbols.before = '-' + symbols.before;
                // loop through each before symbol
                for(i = 0; i < symbols.before.length; i++){
                    symbol = symbols.before[i];
                    switch(symbol){
                        case '$':
                            output = numeral._.insert(output, locale.currency.symbol, i);
                            break;
                        case ' ':
                            output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
                            break;
                    }
                }
                // loop through each after symbol
                for(i = symbols.after.length - 1; i >= 0; i--){
                    symbol = symbols.after[i];
                    switch(symbol){
                        case '$':
                            output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                            break;
                        case ' ':
                            output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                            break;
                    }
                }
                return output;
            }
        });
    })();
    (function() {
        numeral.register('format', 'exponential', {
            regexps: {
                format: /(e\+|e-)/,
                unformat: /(e\+|e-)/
            },
            format: function(value, format, roundingFunction) {
                var output, exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0', parts = exponential.split('e');
                format = format.replace(/e[\+|\-]{1}0/, '');
                output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);
                return output + 'e' + parts[1];
            },
            unformat: function(string) {
                var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'), value = Number(parts[0]), power = Number(parts[1]);
                power = numeral._.includes(string, 'e-') ? power *= -1 : power;
                function cback(accum, curr, currI, O) {
                    var corrFactor = numeral._.correctionFactor(accum, curr), num = accum * corrFactor * (curr * corrFactor) / (corrFactor * corrFactor);
                    return num;
                }
                return numeral._.reduce([
                    value,
                    Math.pow(10, power)
                ], cback, 1);
            }
        });
    })();
    (function() {
        numeral.register('format', 'ordinal', {
            regexps: {
                format: /(o)/
            },
            format: function(value, format, roundingFunction) {
                var locale = numeral.locales[numeral.options.currentLocale], output, ordinal = numeral._.includes(format, ' o') ? ' ' : '';
                // check for space before
                format = format.replace(/\s?o/, '');
                ordinal += locale.ordinal(value);
                output = numeral._.numberToFormat(value, format, roundingFunction);
                return output + ordinal;
            }
        });
    })();
    (function() {
        numeral.register('format', 'percentage', {
            regexps: {
                format: /(%)/,
                unformat: /(%)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, ' %') ? ' ' : '', output;
                if (numeral.options.scalePercentBy100) value = value * 100;
                // check for space before %
                format = format.replace(/\s?\%/, '');
                output = numeral._.numberToFormat(value, format, roundingFunction);
                if (numeral._.includes(output, ')')) {
                    output = output.split('');
                    output.splice(-1, 0, space + '%');
                    output = output.join('');
                } else output = output + space + '%';
                return output;
            },
            unformat: function(string) {
                var number = numeral._.stringToNumber(string);
                if (numeral.options.scalePercentBy100) return number * 0.01;
                return number;
            }
        });
    })();
    (function() {
        numeral.register('format', 'time', {
            regexps: {
                format: /(:)/,
                unformat: /(:)/
            },
            format: function(value, format, roundingFunction) {
                var hours = Math.floor(value / 60 / 60), minutes = Math.floor((value - hours * 3600) / 60), seconds = Math.round(value - hours * 3600 - minutes * 60);
                return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
            },
            unformat: function(string) {
                var timeArray = string.split(':'), seconds = 0;
                // turn hours and minutes into seconds and add them all up
                if (timeArray.length === 3) {
                    // hours
                    seconds = seconds + Number(timeArray[0]) * 3600;
                    // minutes
                    seconds = seconds + Number(timeArray[1]) * 60;
                    // seconds
                    seconds = seconds + Number(timeArray[2]);
                } else if (timeArray.length === 2) {
                    // minutes
                    seconds = seconds + Number(timeArray[0]) * 60;
                    // seconds
                    seconds = seconds + Number(timeArray[1]);
                }
                return Number(seconds);
            }
        });
    })();
    return numeral;
});

});


parcelRegister("Lig7B", function(module, exports) {

$parcel$export(module.exports, "default", () => $08e28dc35f711e9a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $KC0XU = parcelRequire("KC0XU");
const $08e28dc35f711e9a$var$RatingsWithMinimum = (props)=>{
    const { ratings: ratings, ratings: { numRatings: numRatings }, onClick: onClick, showRatingCount: showRatingCount, numericRatingStyles: numericRatingStyles } = props;
    if (numRatings < 3) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $KC0XU.default), {
        onClick: onClick,
        ratings: ratings,
        showRatingCount: showRatingCount,
        numericRatingStyles: numericRatingStyles
    });
};
$08e28dc35f711e9a$var$RatingsWithMinimum.defaultProps = {
    showRatingCount: true
};
var $08e28dc35f711e9a$export$2e2bcd8739ae039 = $08e28dc35f711e9a$var$RatingsWithMinimum;

});
parcelRegister("KC0XU", function(module, exports) {

$parcel$export(module.exports, "default", () => $08c1c8e4d0196956$export$2e2bcd8739ae039);

var $9nkwJ = parcelRequire("9nkwJ");

var $hlWtt = parcelRequire("hlWtt");

var $9rIMC = parcelRequire("9rIMC");

var $eUqFw = parcelRequire("eUqFw");

var $f7YGc = parcelRequire("f7YGc");

var $jwyfr = parcelRequire("jwyfr");

var $g29Wx = parcelRequire("g29Wx");

var $v9N0g = parcelRequire("v9N0g");

var $coqei = parcelRequire("coqei");
const $08c1c8e4d0196956$var$Ratings = (props)=>{
    const { onClick: onClick, ratings: ratings, showRatingCount: showRatingCount = true, showNumericRating: showNumericRating = true, numericRatingStyles: numericRatingStyles } = props;
    const getStars = (clickable)=>(0, $v9N0g.getStarVariations)(ratings).map((variation, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g29Wx.StarIconContainer), {
                key: index,
                clickable: clickable,
                variation: variation,
                "data-testid": "star-rating-".concat(variation)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hlWtt))), {
                label: ""
            })));
    const onRatingsClick = (e)=>{
        if (onClick) (0, $9rIMC).maybeOpenInNewTab(e, ()=>{
            e.stopPropagation();
            onClick();
        });
    };
    const clickable = !!onClick;
    const stars = getStars(clickable);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g29Wx.RatingContainer), {
        onClick: onRatingsClick,
        clickable: clickable,
        "aria-label": "Star Ratings"
    }, !!ratings.numRatings && showNumericRating && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g29Wx.NumericRatingContainer), {
        "data-testid": (0, $jwyfr.NUMERIC_RATING_TESTID),
        overrideStyles: numericRatingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g29Wx.AverageNumericRating), {
        overrideStyles: numericRatingStyles
    }, (0, $v9N0g.getRoundedRating)(ratings.avgStars)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, "/"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, (0, $jwyfr.TOTAL_STARS))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $coqei.StarGradients), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g29Wx.AverageRating), {
        "data-testid": (0, $jwyfr.STAR_RATINGS_TESTID)
    }, stars), !ratings.numRatings && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g29Wx.NoReviewText), null, "No reviews yet"), !!ratings.numRatings && showRatingCount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g29Wx.RatingsCount), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), null, "".concat((0, $f7YGc.shortFormat)(ratings.numRatings)))));
};
var $08c1c8e4d0196956$export$2e2bcd8739ae039 = $08c1c8e4d0196956$var$Ratings;

});
parcelRegister("9nkwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $00d99ab26ca06411$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $aG4Mw = parcelRequire("aG4Mw");
function $00d99ab26ca06411$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $00d99ab26ca06411$var$boxStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius.200',
    display: 'inline-flex',
    blockSize: 'min-content',
    flexShrink: 0 // Text component can wrap text, this ensures it doesn't wrap in flex containers.
});
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they should not change based on theme, and there are no appropriate color tokens.
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ const $00d99ab26ca06411$var$neutral300 = '#DDDEE1';
const $00d99ab26ca06411$var$red300 = '#FD9891';
const $00d99ab26ca06411$var$blue300 = '#8FB8F6';
const $00d99ab26ca06411$var$neutral1000 = '#292A2E';
const $00d99ab26ca06411$var$styles = {
    root: {
        name: "85bcg3",
        styles: "display:inline-flex;box-sizing:border-box;min-width:var(--ds-space-300, 24px);justify-content:center;flex-shrink:0;block-size:min-content;border-radius:var(--ds-border-radius-050, 2px);padding-inline:var(--ds-space-050, 4px)"
    },
    added: {
        name: "4x7cmh",
        styles: "background-color:var(--ds-background-success, #DCFFF1);color:var(--ds-text, #172B4D)"
    },
    default: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$neutral300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    important: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$red300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    primary: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$blue300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    primaryInverted: {
        name: "1425qmy",
        styles: "background-color:var(--ds-surface, #FFFFFF);color:var(--ds-text-brand, #0C66E4)"
    },
    removed: {
        name: "10hiq01",
        styles: "background-color:var(--ds-background-danger, #FFECEB);color:var(--ds-text, #172B4D)"
    }
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const $00d99ab26ca06411$var$Badge = /*#__PURE__*/ (0, $eUqFw.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    if ((0, $XHGTv.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-testid": testId,
        css: [
            $00d99ab26ca06411$var$styles.root,
            $00d99ab26ca06411$var$styles[appearance]
        ],
        style: {
            background: style?.backgroundColor,
            color: style?.color
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        size: "small",
        align: "center",
        color: "inherit"
    }, typeof children === 'number' && max ? (0, $aG4Mw.formatValue)(children, max) : children));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        testId: testId,
        as: "span",
        backgroundColor: $00d99ab26ca06411$var$backgroundColors[appearance],
        xcss: $00d99ab26ca06411$var$boxStyles,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        paddingInline: "space.075"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        size: "UNSAFE_small",
        align: "center",
        color: style?.color ? 'inherit' : $00d99ab26ca06411$var$textColors[appearance]
    }, typeof children === 'number' && max ? (0, $aG4Mw.formatValue)(children, max) : children));
});
$00d99ab26ca06411$var$Badge.displayName = 'Badge';
var $00d99ab26ca06411$export$2e2bcd8739ae039 = $00d99ab26ca06411$var$Badge;
const $00d99ab26ca06411$var$backgroundColors = {
    added: 'color.background.success',
    default: 'color.background.neutral',
    important: 'color.background.danger.bold',
    primary: 'color.background.brand.bold',
    primaryInverted: 'elevation.surface',
    removed: 'color.background.danger'
};
const $00d99ab26ca06411$var$textColors = {
    added: 'color.text.success',
    default: 'color.text',
    important: 'color.text.inverse',
    primary: 'color.text.inverse',
    primaryInverted: 'color.text.brand',
    removed: 'color.text.danger'
};

});
parcelRegister("aG4Mw", function(module, exports) {

$parcel$export(module.exports, "formatValue", () => $a8e5bba3d913fce3$export$7c4d25c0c3217d8c);
function $a8e5bba3d913fce3$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $a8e5bba3d913fce3$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $a8e5bba3d913fce3$var$getSafeValue(value);
    const safeMax = $a8e5bba3d913fce3$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("9rIMC", function(module, exports) {

$parcel$export(module.exports, "maybeOpenInNewTab", () => $6e095fb112aa4bef$export$f0d8de8635f8e7e9);
$parcel$export(module.exports, "setTargetForAllLinks", () => $6e095fb112aa4bef$export$c3bafcaa9fe2e252);
function $6e095fb112aa4bef$export$f0d8de8635f8e7e9(e, execWhenNotNewTabAction) {
    if (!e) execWhenNotNewTabAction();
    else if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) {
        e.preventDefault();
        execWhenNotNewTabAction();
    }
}
const $6e095fb112aa4bef$export$c3bafcaa9fe2e252 = (ele, target)=>{
    if (ele) {
        const links = [
            ...ele.getElementsByTagName('a')
        ];
        links.forEach((a)=>{
            a.setAttribute('target', target);
            if (target === '_blank') a.setAttribute('rel', 'noopener noreferrer');
        });
    }
};

});

parcelRegister("jwyfr", function(module, exports) {

$parcel$export(module.exports, "TOTAL_STARS", () => $e36b9270a51c36a3$export$8cb47a0365023893);
$parcel$export(module.exports, "STAR_RATINGS_TESTID", () => $e36b9270a51c36a3$export$8740eabc94da0660);
$parcel$export(module.exports, "NUMERIC_RATING_TESTID", () => $e36b9270a51c36a3$export$ef523ba528d58576);
$parcel$export(module.exports, "YELLOW_STAR", () => $e36b9270a51c36a3$export$f184eda4b0b77bc);
$parcel$export(module.exports, "GREY_STAR", () => $e36b9270a51c36a3$export$94b653fff3d5e100);
$parcel$export(module.exports, "DISABLED_STAR", () => $e36b9270a51c36a3$export$81dd0c41798198d4);
$parcel$export(module.exports, "QUARTER_STAR", () => $e36b9270a51c36a3$export$5ba14a4123b4d7e7);
$parcel$export(module.exports, "QUARTER_STAR_GRADIENT_ID", () => $e36b9270a51c36a3$export$7a173ef8f4ab2536);
$parcel$export(module.exports, "QUARTER_STAR_GRADIENT_HOVER_ID", () => $e36b9270a51c36a3$export$3879bdb57085600b);
$parcel$export(module.exports, "HALF_STAR", () => $e36b9270a51c36a3$export$c0557090bfd42e78);
$parcel$export(module.exports, "HALF_STAR_GRADIENT_ID", () => $e36b9270a51c36a3$export$8587a005cca6e251);
$parcel$export(module.exports, "HALF_STAR_GRADIENT_HOVER_ID", () => $e36b9270a51c36a3$export$cd10504e797b759d);
$parcel$export(module.exports, "THREE_QUARTER_STAR", () => $e36b9270a51c36a3$export$a908142c7b579a36);
$parcel$export(module.exports, "THREE_QUARTER_STAR_GRADIENT_ID", () => $e36b9270a51c36a3$export$656b127be67bb0a1);
$parcel$export(module.exports, "THREE_QUARTER_STAR_GRADIENT_HOVER_ID", () => $e36b9270a51c36a3$export$d0d735bd13762d53);
$parcel$export(module.exports, "STAR_FILL_MAP", () => $e36b9270a51c36a3$export$fe8acbce00b8388b);

var $j0gMm = parcelRequire("j0gMm");
const $e36b9270a51c36a3$export$8cb47a0365023893 = 4;
const $e36b9270a51c36a3$export$8740eabc94da0660 = 'star-ratings';
const $e36b9270a51c36a3$export$ef523ba528d58576 = 'numeric-rating';
const $e36b9270a51c36a3$export$f184eda4b0b77bc = 'yellowStar';
const $e36b9270a51c36a3$export$94b653fff3d5e100 = 'greyStar';
const $e36b9270a51c36a3$export$81dd0c41798198d4 = 'disabledStar';
const $e36b9270a51c36a3$export$5ba14a4123b4d7e7 = 'quarterStar';
const $e36b9270a51c36a3$export$7a173ef8f4ab2536 = 'amktCommonQuarterStar';
const $e36b9270a51c36a3$export$3879bdb57085600b = 'amktCommonQuarterStarHover';
const $e36b9270a51c36a3$export$c0557090bfd42e78 = 'halfStar';
const $e36b9270a51c36a3$export$8587a005cca6e251 = 'amktCommonHalfStar';
const $e36b9270a51c36a3$export$cd10504e797b759d = 'amktCommonHalfStarHover';
const $e36b9270a51c36a3$export$a908142c7b579a36 = 'threeQuarterStar';
const $e36b9270a51c36a3$export$656b127be67bb0a1 = 'amktCommonThreeQuarterStar';
const $e36b9270a51c36a3$export$d0d735bd13762d53 = 'amktCommonThreeQuarterStarHover';
const $e36b9270a51c36a3$export$fe8acbce00b8388b = {
    [$e36b9270a51c36a3$export$f184eda4b0b77bc]: {
        fill: "var(--ds-icon-accent-orange, ".concat((0, $j0gMm.R300), ")"),
        fillHover: "var(--ds-background-accent-orange-bolder, ".concat((0, $j0gMm.R400), ")")
    },
    [$e36b9270a51c36a3$export$94b653fff3d5e100]: {
        fill: "var(--ds-background-accent-gray-bolder, ".concat((0, $j0gMm.N600), ")"),
        fillHover: "var(--ds-background-accent-gray-bolder-hovered, ".concat((0, $j0gMm.N100), ")")
    },
    [$e36b9270a51c36a3$export$5ba14a4123b4d7e7]: {
        fill: "url(#".concat($e36b9270a51c36a3$export$7a173ef8f4ab2536, ")"),
        fillHover: "url(#".concat($e36b9270a51c36a3$export$3879bdb57085600b, ")")
    },
    [$e36b9270a51c36a3$export$c0557090bfd42e78]: {
        fill: "url(#".concat($e36b9270a51c36a3$export$8587a005cca6e251, ")"),
        fillHover: "url(#".concat($e36b9270a51c36a3$export$cd10504e797b759d, ")")
    },
    [$e36b9270a51c36a3$export$a908142c7b579a36]: {
        fill: "url(#".concat($e36b9270a51c36a3$export$656b127be67bb0a1, ")"),
        fillHover: "url(#".concat($e36b9270a51c36a3$export$d0d735bd13762d53, ")")
    },
    [$e36b9270a51c36a3$export$81dd0c41798198d4]: {
        fill: "var(--ds-icon-disabled, ".concat((0, $j0gMm.N70A), ")")
    }
};

});

parcelRegister("g29Wx", function(module, exports) {

$parcel$export(module.exports, "AverageRating", () => $bac48bbba69b5bae$export$9765b38cba07b8b9);
$parcel$export(module.exports, "RatingsCount", () => $bac48bbba69b5bae$export$7490f2556754ce37);
$parcel$export(module.exports, "RatingContainer", () => $bac48bbba69b5bae$export$ea0e22a430af9019);
$parcel$export(module.exports, "StarIconContainer", () => $bac48bbba69b5bae$export$a6a73f636a2683f4);
$parcel$export(module.exports, "StarGradientContainer", () => $bac48bbba69b5bae$export$aff3f8e463c240a6);
$parcel$export(module.exports, "NoReviewText", () => $bac48bbba69b5bae$export$ff6c83e6916ea5bc);
$parcel$export(module.exports, "AverageNumericRating", () => $bac48bbba69b5bae$export$e381297bd872844d);
$parcel$export(module.exports, "NumericRatingContainer", () => $bac48bbba69b5bae$export$36bec2463c85305d);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $jwyfr = parcelRequire("jwyfr");
function $bac48bbba69b5bae$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bac48bbba69b5bae$export$9765b38cba07b8b9 = (0, $3UXZ8.default)("span", {
    target: "e1csono30",
    label: "AverageRating"
})({
    name: "10p9k66",
    styles: "vertical-align:middle;display:inline-flex;flex-wrap:nowrap;"
});
const $bac48bbba69b5bae$export$7490f2556754ce37 = (0, $3UXZ8.default)("span", {
    target: "e1csono31",
    label: "RatingsCount"
})({
    name: "z0txda",
    styles: "margin-left:var(--ds-space-050, 4px);"
});
const $bac48bbba69b5bae$export$ea0e22a430af9019 = (0, $3UXZ8.default)("button", {
    target: "e1csono32",
    label: "RatingContainer"
})("background:none;border:none;padding:0;display:flex;align-items:center;flex:1 0 auto;margin-left:var(--ds-space-negative-050, -4px);height:fit-content;", (props)=>{
    if (props.clickable) return "\n                &:hover {\n                    cursor: pointer;\n                }\n            ";
}, "");
const $bac48bbba69b5bae$export$a6a73f636a2683f4 = (0, $3UXZ8.default)("span", {
    target: "e1csono33",
    label: "StarIconContainer"
})("display:inline-block;vertical-align:middle;line-height:1;svg{width:24px;height:24px;}path{fill:", (props)=>(0, $jwyfr.STAR_FILL_MAP)[props.variation].fill, ";}", $bac48bbba69b5bae$export$ea0e22a430af9019, ":hover &{path{", (props)=>props.clickable ? "fill:  ".concat((0, $jwyfr.STAR_FILL_MAP)[props.variation].fillHover) : "", "}}&:not(:first-of-type){margin-left:-3px;}");
const $bac48bbba69b5bae$export$aff3f8e463c240a6 = (0, $3UXZ8.default)("svg", {
    target: "e1csono34",
    label: "StarGradientContainer"
})({
    name: "zm89ux",
    styles: "width:0;height:0;position:absolute;"
});
const $bac48bbba69b5bae$export$ff6c83e6916ea5bc = (0, $3UXZ8.default)("span", {
    target: "e1csono35",
    label: "NoReviewText"
})("font-size:14px;color:", "var(--ds-text-subtle, ".concat((0, $j0gMm.N500), ")"), ";");
const $bac48bbba69b5bae$export$e381297bd872844d = (0, $3UXZ8.default)("span", {
    target: "e1csono36",
    label: "AverageNumericRating"
})("font-weight:600;font-size:", (props)=>{
    var _props$overrideStyles;
    return ((_props$overrideStyles = props.overrideStyles) === null || _props$overrideStyles === void 0 ? void 0 : _props$overrideStyles.avgNumFontSize) || 14;
}, "px;");
const $bac48bbba69b5bae$export$36bec2463c85305d = (0, $3UXZ8.default)("span", {
    target: "e1csono37",
    label: "NumericRatingContainer"
})("display:flex;align-items:center;color:", "var(--ds-text, ".concat((0, $j0gMm.N800), ")"), ";gap:", (props)=>{
    var _props$overrideStyles2;
    return ((_props$overrideStyles2 = props.overrideStyles) === null || _props$overrideStyles2 === void 0 ? void 0 : _props$overrideStyles2.gap) || '0px';
}, ";font-weight:", (props)=>{
    var _props$overrideStyles3;
    return ((_props$overrideStyles3 = props.overrideStyles) === null || _props$overrideStyles3 === void 0 ? void 0 : _props$overrideStyles3.fontWeight) || 400;
}, ";font-size:", (props)=>{
    var _props$overrideStyles4;
    return ((_props$overrideStyles4 = props.overrideStyles) === null || _props$overrideStyles4 === void 0 ? void 0 : _props$overrideStyles4.fontSize) || 14;
}, "px;margin-left:var(--ds-space-050, 4px);");

});

parcelRegister("v9N0g", function(module, exports) {

$parcel$export(module.exports, "getStarVariations", () => $05da7d54c5db5a85$export$2463346a7bf59173);
$parcel$export(module.exports, "getRoundedRating", () => $05da7d54c5db5a85$export$258e17a1bfb65cc4);

var $5zQU9 = parcelRequire("5zQU9");

var $jwyfr = parcelRequire("jwyfr");
function $05da7d54c5db5a85$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $05da7d54c5db5a85$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $05da7d54c5db5a85$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $05da7d54c5db5a85$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $05da7d54c5db5a85$export$e20af336285857cb = (val)=>{
    if (val >= 0.875) return 1;
    else if (val >= 0.625) return 0.75;
    else if (val >= 0.375) return 0.5;
    else if (val >= 0.125) return 0.25;
    return 0;
};
const $05da7d54c5db5a85$export$e7373081cdd0df48 = (averageStars)=>{
    const integer = Math.trunc(averageStars);
    const decimal = averageStars % 1;
    return integer + $05da7d54c5db5a85$export$e20af336285857cb(decimal);
};
const $05da7d54c5db5a85$export$c3b5857cf6a23fc = {
    0: {},
    0.25: {
        quarterStarsCount: 1
    },
    0.5: {
        halfStarsCount: 1
    },
    0.75: {
        threeQuarterStarsCount: 1
    }
};
const $05da7d54c5db5a85$export$a00beb5a07c70ef1 = (averageStars)=>{
    const discreteRating = $05da7d54c5db5a85$export$e7373081cdd0df48(averageStars);
    const yellowStarsCount = Math.trunc(discreteRating);
    const partiallyFilledStarsCount = Math.ceil(discreteRating % 1);
    const partiallyFilledStars = $05da7d54c5db5a85$export$c3b5857cf6a23fc[discreteRating % 1];
    const greyStarsCount = (0, $jwyfr.TOTAL_STARS) - yellowStarsCount - partiallyFilledStarsCount;
    return $05da7d54c5db5a85$var$_objectSpread({
        yellowStarsCount: yellowStarsCount,
        greyStarsCount: greyStarsCount
    }, partiallyFilledStars);
};
const $05da7d54c5db5a85$export$2463346a7bf59173 = (ratings)=>{
    if (!ratings.numRatings) return [
        (0, $jwyfr.DISABLED_STAR)
    ];
    const { yellowStarsCount: yellowStarsCount, quarterStarsCount: quarterStarsCount = 0, halfStarsCount: halfStarsCount = 0, threeQuarterStarsCount: threeQuarterStarsCount = 0, greyStarsCount: greyStarsCount } = $05da7d54c5db5a85$export$a00beb5a07c70ef1(ratings.avgStars);
    return [
        ...new Array(yellowStarsCount).fill((0, $jwyfr.YELLOW_STAR)),
        ...new Array(quarterStarsCount).fill((0, $jwyfr.QUARTER_STAR)),
        ...new Array(halfStarsCount).fill((0, $jwyfr.HALF_STAR)),
        ...new Array(threeQuarterStarsCount).fill((0, $jwyfr.THREE_QUARTER_STAR)),
        ...new Array(greyStarsCount).fill((0, $jwyfr.GREY_STAR))
    ];
};
const $05da7d54c5db5a85$export$258e17a1bfb65cc4 = (rating)=>Number(rating.toFixed(1));

});

parcelRegister("coqei", function(module, exports) {

$parcel$export(module.exports, "StarGradients", () => $905c128e7a489545$export$9e5638a6deed949e);

var $eUqFw = parcelRequire("eUqFw");

var $jwyfr = parcelRequire("jwyfr");

var $g29Wx = parcelRequire("g29Wx");
const $905c128e7a489545$var$STAR_GRADIENT_CONFIG = [
    {
        starType: (0, $jwyfr.QUARTER_STAR),
        id: (0, $jwyfr.QUARTER_STAR_GRADIENT_ID),
        hoverId: (0, $jwyfr.QUARTER_STAR_GRADIENT_HOVER_ID),
        offset: '25%'
    },
    {
        startType: (0, $jwyfr.HALF_STAR),
        id: (0, $jwyfr.HALF_STAR_GRADIENT_ID),
        hoverId: (0, $jwyfr.HALF_STAR_GRADIENT_HOVER_ID),
        offset: '50%'
    },
    {
        starType: (0, $jwyfr.THREE_QUARTER_STAR),
        id: (0, $jwyfr.THREE_QUARTER_STAR_GRADIENT_ID),
        hoverId: (0, $jwyfr.THREE_QUARTER_STAR_GRADIENT_HOVER_ID),
        offset: '75%'
    }
];
const $905c128e7a489545$export$9e5638a6deed949e = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, $905c128e7a489545$var$STAR_GRADIENT_CONFIG.map((_ref)=>{
        let { id: id, hoverId: hoverId, offset: offset } = _ref;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g29Wx.StarGradientContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
            id: id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
            offset: offset,
            stopColor: (0, $jwyfr.STAR_FILL_MAP)[0, $jwyfr.YELLOW_STAR].fill
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
            offset: offset,
            stopColor: (0, $jwyfr.STAR_FILL_MAP)[0, $jwyfr.GREY_STAR].fill
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g29Wx.StarGradientContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
            id: hoverId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
            offset: offset,
            stopColor: (0, $jwyfr.STAR_FILL_MAP)[0, $jwyfr.YELLOW_STAR].fillHover
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
            offset: offset,
            stopColor: (0, $jwyfr.STAR_FILL_MAP)[0, $jwyfr.GREY_STAR].fillHover
        }))));
    }));
};

});



parcelRegister("hxCMl", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc5399619ca3744b$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $4IPhO = parcelRequire("4IPhO");

var $lgRZl = parcelRequire("lgRZl");
const $cc5399619ca3744b$var$DEFAULT_GRID_COLUMNS = 12;
class $cc5399619ca3744b$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const { children: children, className: className, xs: xs, sm: sm, md: md, lg: lg, xl: xl } = this.props;
        const style = (0, (/*@__PURE__*/$parcel$interopDefault($4IPhO)))({
            width: {
                xs: xs,
                sm: sm,
                md: md,
                lg: lg,
                xl: xl
            },
            screenClass: this.props.screenClass,
            gutterWidth: this.props.gutterWidth,
            gridColumns: $cc5399619ca3744b$var$DEFAULT_GRID_COLUMNS,
            moreStyle: {
                overflow: 'visible'
            }
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: className,
            style: style
        }, children);
    }
}
(0, $5zQU9.default)($cc5399619ca3744b$export$2e2bcd8739ae039, "propTypes", {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    screenClass: (0, $lgRZl.default).screenClass.isRequired,
    gutterWidth: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    xs: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    sm: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    md: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    lg: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    xl: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number
});
(0, $5zQU9.default)($cc5399619ca3744b$export$2e2bcd8739ae039, "defaultProps", {
    children: null,
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    xl: 12
});

});
parcelRegister("4IPhO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $j4Wxq = parcelRequire("j4Wxq");
function $37030ddd36a9f945$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $37030ddd36a9f945$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $37030ddd36a9f945$var$ownKeys(Object(source), true).forEach(function(key) {
            $37030ddd36a9f945$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $37030ddd36a9f945$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $37030ddd36a9f945$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $37030ddd36a9f945$var$hasWidth = function hasWidth(widths) {
    return Object.keys(widths).reduce(function(acc, cur) {
        return acc || widths[cur];
    }, false);
};
var $37030ddd36a9f945$var$getWidth = function getWidth(width, gridColumns) {
    if (typeof width !== 'number') return undefined;
    var normalizedWidth = Math.max(0, Math.min(gridColumns, width));
    return "".concat(100 / gridColumns * normalizedWidth, "%");
};
var $37030ddd36a9f945$var$_default = function _default(_ref) {
    var _ref$forceWidth = _ref.forceWidth, forceWidth = _ref$forceWidth === void 0 ? null : _ref$forceWidth, _ref$width = _ref.width, width = _ref$width === void 0 ? {} : _ref$width, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? {} : _ref$offset, _ref$pull = _ref.pull, pull = _ref$pull === void 0 ? {} : _ref$pull, _ref$push = _ref.push, push = _ref$push === void 0 ? {} : _ref$push, debug = _ref.debug, screenClass = _ref.screenClass, gutterWidth = _ref.gutterWidth, moreStyle = _ref.moreStyle, gridColumns = _ref.gridColumns;
    var styles = {
        boxSizing: 'border-box',
        minHeight: 1,
        position: 'relative',
        paddingLeft: gutterWidth / 2,
        paddingRight: gutterWidth / 2,
        width: '100%'
    };
    if (debug) {
        styles.outline = '1px solid silver';
        styles.background = 'rgba(0,0,0,.05)';
        styles.lineHeight = '32px';
    }
    styles.flexBasis = '100%';
    styles.flexGrow = 0;
    styles.flexShrink = 0;
    styles.maxWidth = '100%';
    styles.marginLeft = '0%';
    styles.right = 'auto';
    styles.left = 'auto';
    $j4Wxq.screenClasses.forEach(function(size, index) {
        if ($j4Wxq.screenClasses.indexOf(screenClass) >= index) {
            var currentWidth = $37030ddd36a9f945$var$getWidth(width[size], gridColumns);
            var isSizedToContent = width[size] === 'content';
            styles.flexBasis = isSizedToContent ? 'auto' : currentWidth || styles.flexBasis;
            styles.width = styles.flexBasis;
            styles.maxWidth = currentWidth || styles.maxWidth;
            styles.marginLeft = $37030ddd36a9f945$var$getWidth(offset[size], gridColumns) || styles.marginLeft;
            styles.right = $37030ddd36a9f945$var$getWidth(pull[size], gridColumns) || styles.right;
            styles.left = $37030ddd36a9f945$var$getWidth(push[size], gridColumns) || styles.left;
        }
    });
    if (!$37030ddd36a9f945$var$hasWidth(width)) {
        styles.flexBasis = 0;
        styles.flexGrow = 1;
    }
    if (forceWidth) {
        styles.flexBasis = 'unset';
        styles.flexGrow = 'unset';
        styles.flexShrink = 'unset';
        styles.width = forceWidth;
    }
    return $37030ddd36a9f945$var$_objectSpread($37030ddd36a9f945$var$_objectSpread({}, styles), moreStyle);
};
module.exports.default = $37030ddd36a9f945$var$_default;

});
parcelRegister("j4Wxq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useScreenClass = module.exports.screenClasses = void 0;

var $eUqFw = parcelRequire("eUqFw");

var $ET433 = parcelRequire("ET433");

var $8A7Vu = parcelRequire("8A7Vu");
function $de3bcc7ef89f62c7$var$_slicedToArray(arr, i) {
    return $de3bcc7ef89f62c7$var$_arrayWithHoles(arr) || $de3bcc7ef89f62c7$var$_iterableToArrayLimit(arr, i) || $de3bcc7ef89f62c7$var$_unsupportedIterableToArray(arr, i) || $de3bcc7ef89f62c7$var$_nonIterableRest();
}
function $de3bcc7ef89f62c7$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $de3bcc7ef89f62c7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $de3bcc7ef89f62c7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $de3bcc7ef89f62c7$var$_arrayLikeToArray(o, minLen);
}
function $de3bcc7ef89f62c7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $de3bcc7ef89f62c7$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $de3bcc7ef89f62c7$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $de3bcc7ef89f62c7$var$getViewPort = function getViewPort(source) {
    if (source && source.current && source.current.clientWidth) return source.current.clientWidth;
    if (typeof $8A7Vu.Window !== 'undefined' && $8A7Vu.Window.innerWidth) return $8A7Vu.Window.innerWidth;
    return null;
};
var $de3bcc7ef89f62c7$var$screenClasses = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl',
    'xxl'
];
module.exports.screenClasses = $de3bcc7ef89f62c7$var$screenClasses;
var $de3bcc7ef89f62c7$var$useScreenClass = function useScreenClass(source, fallbackScreenClass) {
    var getScreenClass = function getScreenClass() {
        var _getConfiguration = (0, $ET433.getConfiguration)(), breakpoints = _getConfiguration.breakpoints, defaultScreenClass = _getConfiguration.defaultScreenClass, maxScreenClass = _getConfiguration.maxScreenClass;
        var newScreenClass = defaultScreenClass;
        var viewport = $de3bcc7ef89f62c7$var$getViewPort(source);
        if (viewport) {
            newScreenClass = 'xs';
            if (breakpoints[0] && viewport >= breakpoints[0]) newScreenClass = 'sm';
            if (breakpoints[1] && viewport >= breakpoints[1]) newScreenClass = 'md';
            if (breakpoints[2] && viewport >= breakpoints[2]) newScreenClass = 'lg';
            if (breakpoints[3] && viewport >= breakpoints[3]) newScreenClass = 'xl';
            if (breakpoints[4] && viewport >= breakpoints[4]) newScreenClass = 'xxl';
        } else if (fallbackScreenClass) newScreenClass = fallbackScreenClass;
        var newScreenClassIndex = $de3bcc7ef89f62c7$var$screenClasses.indexOf(newScreenClass);
        var maxScreenClassIndex = $de3bcc7ef89f62c7$var$screenClasses.indexOf(maxScreenClass);
        if (maxScreenClassIndex >= 0 && newScreenClassIndex > maxScreenClassIndex) newScreenClass = $de3bcc7ef89f62c7$var$screenClasses[maxScreenClassIndex];
        return newScreenClass;
    };
    var _useState = (0, $eUqFw.useState)(function() {
        return getScreenClass();
    }), _useState2 = $de3bcc7ef89f62c7$var$_slicedToArray(_useState, 2), screenClass = _useState2[0], setScreenClass = _useState2[1];
    (0, $eUqFw.useEffect)(function() {
        var handleWindowResized = function handleWindowResized() {
            return setScreenClass(getScreenClass());
        };
        $8A7Vu.Window.addEventListener('resize', handleWindowResized, false);
        return function() {
            $8A7Vu.Window.removeEventListener('resize', handleWindowResized, false);
        };
    }, []);
    return screenClass;
};
module.exports.useScreenClass = $de3bcc7ef89f62c7$var$useScreenClass;

});
parcelRegister("ET433", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setConfiguration = module.exports.getConfiguration = void 0;
function $07ae7329db35275e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $07ae7329db35275e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $07ae7329db35275e$var$ownKeys(Object(source), true).forEach(function(key) {
            $07ae7329db35275e$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $07ae7329db35275e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $07ae7329db35275e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $07ae7329db35275e$var$configuration = {
    breakpoints: [
        576,
        768,
        992,
        1200,
        1600
    ],
    containerWidths: [
        540,
        750,
        960,
        1140,
        1540
    ],
    gutterWidth: 30,
    gridColumns: 12,
    defaultScreenClass: 'xxl',
    maxScreenClass: 'xxl'
};
var $07ae7329db35275e$var$getConfiguration = function getConfiguration() {
    return $07ae7329db35275e$var$configuration;
};
module.exports.getConfiguration = $07ae7329db35275e$var$getConfiguration;
var $07ae7329db35275e$var$setConfiguration = function setConfiguration(newConfiguration) {
    $07ae7329db35275e$var$configuration = $07ae7329db35275e$var$_objectSpread($07ae7329db35275e$var$_objectSpread({}, $07ae7329db35275e$var$configuration), newConfiguration);
};
module.exports.setConfiguration = $07ae7329db35275e$var$setConfiguration;

});

parcelRegister("8A7Vu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Div", {
    enumerable: true,
    get: function get() {
        return $63f7d5853c53700c$var$_Div.default;
    }
});
Object.defineProperty(module.exports, "Span", {
    enumerable: true,
    get: function get() {
        return $63f7d5853c53700c$var$_Span.default;
    }
});
Object.defineProperty(module.exports, "Window", {
    enumerable: true,
    get: function get() {
        return $63f7d5853c53700c$var$_Window.default;
    }
});

var $63f7d5853c53700c$var$_Div = $63f7d5853c53700c$var$_interopRequireDefault((parcelRequire("hJQ9s")));

var $63f7d5853c53700c$var$_Span = $63f7d5853c53700c$var$_interopRequireDefault((parcelRequire("jecJY")));

var $63f7d5853c53700c$var$_Window = $63f7d5853c53700c$var$_interopRequireDefault((parcelRequire("3wHEH")));
function $63f7d5853c53700c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("hJQ9s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $ce9f17d7ebefbcb1$var$_default = 'div';
module.exports.default = $ce9f17d7ebefbcb1$var$_default;

});

parcelRegister("jecJY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $dff93524f79b65cf$var$_default = 'span';
module.exports.default = $dff93524f79b65cf$var$_default;

});

parcelRegister("3wHEH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/* global window */ var $2916395300190687$var$_default = typeof window !== 'undefined' ? window : undefined;
module.exports.default = $2916395300190687$var$_default;

});





parcelRegister("3BBSQ", function(module, exports) {

$parcel$export(module.exports, "AppTileHighlightedText", () => $2a0236b61eb86ec3$export$2f2d27674dcbd0cc);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $g5DHJ = parcelRequire("g5DHJ");

var $eUqFw = parcelRequire("eUqFw");
function $2a0236b61eb86ec3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2a0236b61eb86ec3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2a0236b61eb86ec3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2a0236b61eb86ec3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $2a0236b61eb86ec3$export$73b5d8f6bf77aa3b = (0, $3UXZ8.default)("span", {
    target: "ef1epbp0",
    label: "SearchHighlight"
})("color:", "var(--ds-text, ".concat((0, $j0gMm.N900), ")"), ";font-weight:700;", (props)=>props.overrideStyles && $2a0236b61eb86ec3$var$_objectSpread({}, props.overrideStyles), "");
const $2a0236b61eb86ec3$var$ALGOLIA_HIGHLIGHT_REGEX = /<algoliaHighlight>(.+?)<\/algoliaHighlight>/g;
const $2a0236b61eb86ec3$export$2f2d27674dcbd0cc = (_ref)=>{
    let { highlightedText: highlightedText, originalText: originalText, overrideStyles: overrideStyles } = _ref;
    const highlightMatches = ()=>{
        let matches;
        // Resolve all the unique highlights
        let highlights = (0, $g5DHJ.Set)();
        while((matches = $2a0236b61eb86ec3$var$ALGOLIA_HIGHLIGHT_REGEX.exec(highlightedText)) !== null)highlights = highlights.add(matches[1]);
        // For each of the unique highlights
        return highlights.reduce((acc, h)=>// For each of the already accumulated highlights and raw text
            acc.flatMap((a)=>// If the accumulated item is a string (i.e. non-highlighted)
                typeof a === 'string' ? // Create a list of this item split by the highlighted text
                (0, $g5DHJ.List)(a.split(h)).flatMap((s)=>// For each of the split parts of the item, if it is valued include it, otherwise don't
                    (s ? (0, $g5DHJ.List)([
                        s
                    ]) : (0, $g5DHJ.List)()).push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a0236b61eb86ec3$export$73b5d8f6bf77aa3b, {
                        overrideStyles: overrideStyles
                    }, h)))// Remove the last one since it is not correct (we blindly append the highlight text to the end,
                // but actually only want it between split items
                .butLast() : // If it is not a string, this is already highlighted text and we don't need to do anything so
                // just return a list of the item (since we are flatMapping).
                (0, $g5DHJ.List)([
                    a
                ])), // Initial value of the accumulator is a list of the actual text of what we are highlighting
        (0, $g5DHJ.List)([
            originalText
        ]))// Once we have resolve all highlights and non-highlighted text, wrap in spans with a key (since we need keys)
        .map((s, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                key: i
            }, s));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, highlightMatches());
};

});

parcelRegister("8sH3O", function(module, exports) {

$parcel$export(module.exports, "default", () => $6292572f3f362d16$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $ivTMz = parcelRequire("ivTMz");
var $62HOr = parcelRequire("62HOr");

var $ibjku = parcelRequire("ibjku");

var $eUqFw = parcelRequire("eUqFw");

var $1r1q4 = parcelRequire("1r1q4");
const $6292572f3f362d16$var$StyledClickableCard = /*#__PURE__*/ (0, $ibjku.css)("cursor:pointer;transition:box-shadow 0.1s;&:hover{", (0, $62HOr).e300(), "};label:StyledClickableCard;");
const $6292572f3f362d16$export$94fdbc1f5368d5e4 = (0, $3UXZ8.default)("div", {
    target: "e1i5f6pi0",
    label: "StyledCard"
})("padding:10px 15px;border-radius:", (0, $ivTMz.borderRadius)(), "px;color:inherit;position:relative;", (0, $62HOr).e100(), ";", (props)=>props.clickable ? $6292572f3f362d16$var$StyledClickableCard : '', ";");
function $6292572f3f362d16$export$2e2bcd8739ae039(_ref) {
    let { children: children, className: className, clickable: clickable = true, testId: testId, badgeVariant: badgeVariant } = _ref;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6292572f3f362d16$export$94fdbc1f5368d5e4, {
        className: className,
        clickable: clickable,
        "data-testid": testId
    }, badgeVariant && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1r1q4.default), {
        badgeVariant: badgeVariant
    }), children);
}

});
parcelRegister("62HOr", function(module, exports) {

$parcel$export(module.exports, "e100", () => $4664ea3c79447258$export$b390b459b8b8d8d0);
$parcel$export(module.exports, "e200", () => $4664ea3c79447258$export$3c35fb2adfe0992);
$parcel$export(module.exports, "e300", () => $4664ea3c79447258$export$f330dca4c33ed51f);
$parcel$export(module.exports, "e400", () => $4664ea3c79447258$export$3c7c047ca0ed675e);
$parcel$export(module.exports, "e500", () => $4664ea3c79447258$export$e6af781b0d301e56);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $j0gMm = parcelRequire("j0gMm");

var $kvIKC = parcelRequire("kvIKC");
const $4664ea3c79447258$export$b390b459b8b8d8d0 = (0, $kvIKC.default)({
    light: `box-shadow: ${`var(--ds-shadow-raised, ${`0 1px 1px ${(0, $j0gMm.N50A)}, 0 0 1px 1px ${(0, $j0gMm.N40A)}`})`};`,
    dark: `box-shadow: ${`var(--ds-shadow-raised, ${`0 1px 1px ${(0, $j0gMm.DN50A)}, 0 0 1px 1px ${(0, $j0gMm.DN40A)}`})`};`
});
const $4664ea3c79447258$export$3c35fb2adfe0992 = (0, $kvIKC.default)({
    light: `box-shadow: ${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $j0gMm.N50A)}, 0 0 1px ${(0, $j0gMm.N60A)}`})`};`,
    dark: `box-shadow: ${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $j0gMm.DN50A)}, 0 0 1px ${(0, $j0gMm.DN60A)}`})`};`
});
const $4664ea3c79447258$export$f330dca4c33ed51f = (0, $kvIKC.default)({
    light: `box-shadow: ${`var(--ds-shadow-overlay, ${`0 8px 16px -4px ${(0, $j0gMm.N50A)}, 0 0 1px ${(0, $j0gMm.N60A)}`})`};`,
    dark: `box-shadow: ${`var(--ds-shadow-overlay, ${`0 8px 16px -4px ${(0, $j0gMm.DN50A)}, 0 0 1px ${(0, $j0gMm.DN60A)}`})`};`
});
const $4664ea3c79447258$export$3c7c047ca0ed675e = (0, $kvIKC.default)({
    light: `box-shadow: ${`var(--ds-shadow-overlay, ${`0 12px 24px -6px ${(0, $j0gMm.N50A)}, 0 0 1px ${(0, $j0gMm.N60A)}`})`};`,
    dark: `box-shadow: ${`var(--ds-shadow-overlay, ${`0 12px 24px -6px ${(0, $j0gMm.DN50A)}, 0 0 1px ${(0, $j0gMm.DN60A)}`})`};`
});
const $4664ea3c79447258$export$e6af781b0d301e56 = (0, $kvIKC.default)({
    light: `box-shadow: ${`var(--ds-shadow-overlay, ${`0 20px 32px -8px ${(0, $j0gMm.N50A)}, 0 0 1px ${(0, $j0gMm.N60A)}`})`};`,
    dark: `box-shadow: ${`var(--ds-shadow-overlay, ${`0 20px 32px -8px ${(0, $j0gMm.DN50A)}, 0 0 1px ${(0, $j0gMm.DN60A)}`})`};`
});

});

parcelRegister("1r1q4", function(module, exports) {

$parcel$export(module.exports, "default", () => $10b969ec6374db28$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $hvUUg = parcelRequire("hvUUg");

var $ibjku = parcelRequire("ibjku");

var $eUqFw = parcelRequire("eUqFw");
const $10b969ec6374db28$export$37acb3580601e69a = /*#__PURE__*/ (0, $ibjku.css)((0, $hvUUg.CharlieFontFamily), ";box-sizing:border-box;position:absolute;right:0px;border-radius:0px 3px 0px 12px;padding:0px var(--ds-space-150, 12px) var(--ds-space-025, 2px) var(--ds-space-150, 12px);font-size:13px;word-spacing:1px;;label:Badge;");
const $10b969ec6374db28$export$78604ebaa20070be = (0, $3UXZ8.default)("div", {
    target: "eh3pdla0",
    label: "StaffPickBadge"
})($10b969ec6374db28$export$37acb3580601e69a, ";font-weight:400;background:", "var(--ds-background-accent-purple-bolder, ".concat((0, $j0gMm.P400), ")"), ";color:", "var(--ds-text-inverse, ".concat((0, $j0gMm.N0), ")"), ";");
const $10b969ec6374db28$export$43fbb77c138b6530 = (0, $3UXZ8.default)("div", {
    target: "eh3pdla1",
    label: "RisingStarBadge"
})($10b969ec6374db28$export$37acb3580601e69a, ";font-weight:400;background:", "var(--ds-background-accent-blue-bolder, ".concat((0, $j0gMm.B400), ")"), ";color:", "var(--ds-text-inverse, ".concat((0, $j0gMm.N0), ")"), ";");
const $10b969ec6374db28$export$da75d320d418532d = (0, $3UXZ8.default)("div", {
    target: "eh3pdla2",
    label: "BestSellerBadge"
})($10b969ec6374db28$export$37acb3580601e69a, ";font-weight:400;background:", "var(--ds-background-accent-green-bolder, ".concat((0, $j0gMm.G400), ")"), ";color:", "var(--ds-text-inverse, ".concat((0, $j0gMm.N0), ")"), ";");
const $10b969ec6374db28$export$34f0e43b54903c1a = (0, $3UXZ8.default)("div", {
    target: "eh3pdla3",
    label: "SpotlightBadge"
})($10b969ec6374db28$export$37acb3580601e69a, ";font-weight:400;background:", "var(--ds-background-accent-purple-bolder, ".concat((0, $j0gMm.P400), ")"), ";color:", "var(--ds-text-inverse, ".concat((0, $j0gMm.N0), ")"), ";");
const $10b969ec6374db28$export$46d88e67b10ab119 = (0, $3UXZ8.default)("div", {
    target: "eh3pdla4",
    label: "NewBadge"
})($10b969ec6374db28$export$37acb3580601e69a, ";background:", "var(--ds-background-accent-purple-subtlest, ".concat((0, $j0gMm.P50), ")"), ";font-weight:600;color:", "var(--ds-text-accent-purple, ".concat((0, $j0gMm.P400), ")"), ";");
function $10b969ec6374db28$export$2e2bcd8739ae039(_ref) {
    let { badgeVariant: badgeVariant } = _ref;
    switch(badgeVariant){
        case 'staffPick':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($10b969ec6374db28$export$78604ebaa20070be, null, "STAFF PICK");
        case 'spotlight':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($10b969ec6374db28$export$34f0e43b54903c1a, null, "SPOTLIGHT");
        case 'bestSeller':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($10b969ec6374db28$export$da75d320d418532d, null, "BESTSELLER");
        case 'risingStar':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($10b969ec6374db28$export$43fbb77c138b6530, null, "RISING STAR");
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($10b969ec6374db28$export$46d88e67b10ab119, null, "NEW");
    }
}

});


parcelRegister("5YcrV", function(module, exports) {

$parcel$export(module.exports, "CloudFortifiedAppBadgeSources", () => $458c36893034c4de$export$faf8b8eedbcaaaed);
$parcel$export(module.exports, "default", () => $458c36893034c4de$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $hvUUg = parcelRequire("hvUUg");
var $gykb8 = parcelRequire("gykb8");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $259xn = parcelRequire("259xn");

var $kt9Cs = parcelRequire("kt9Cs");

var $eUqFw = parcelRequire("eUqFw");

var $4lmb9 = parcelRequire("4lmb9");

var $7BUhe = parcelRequire("7BUhe");

var $8PT8s = parcelRequire("8PT8s");

var $e8A8d = parcelRequire("e8A8d");

var $kNAhC = parcelRequire("kNAhC");

var $3ihpf = parcelRequire("3ihpf");

var $3ogmU = parcelRequire("3ogmU");
function $458c36893034c4de$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $458c36893034c4de$var$ANALYTICS_SUBJECT_ID_VIEW_MORE_LINK = 'viewMoreLink';
const $458c36893034c4de$var$ToolTipContainer = (0, $3UXZ8.default)("div", {
    target: "e4w3pke0",
    label: "ToolTipContainer"
})("line-height:1.5;margin-top:0;max-width:16.375rem;color:", "var(--ds-text, ".concat((0, $j0gMm).N600, ")"), ";");
const $458c36893034c4de$export$56c0d5a1e737357d = (0, $3UXZ8.default)("p", {
    target: "e4w3pke1",
    label: "P"
})({
    name: "gr2y0k",
    styles: "display:flex;align-items:center;margin:var(--ds-space-100, 8px) 0 0;"
});
const $458c36893034c4de$var$BadgeLabel = (0, $3UXZ8.default)("span", {
    target: "e4w3pke2",
    label: "BadgeLabel"
})("margin-left:var(--ds-space-050, 4px);", (0, $hvUUg.CharlieFontFamily), " color:", (_ref)=>{
    let { showAetherAppListingPage: showAetherAppListingPage } = _ref;
    return showAetherAppListingPage ? "var(--ds-text-subtle)" : "var(--ds-text)";
}, ";word-spacing:1px;font-weight:", (_ref2)=>{
    let { showAetherAppListingPage: showAetherAppListingPage } = _ref2;
    return showAetherAppListingPage ? '600' : '400';
}, ";font-size:", (_ref3)=>{
    let { showAetherAppListingPage: showAetherAppListingPage } = _ref3;
    return showAetherAppListingPage ? '1rem' : '0.875rem';
}, ";");
const $458c36893034c4de$var$BadgeContainer = (0, $3UXZ8.default)("button", {
    target: "e4w3pke3",
    label: "BadgeContainer"
})({
    name: "vk8q2x",
    styles: "all:unset;display:flex;align-items:center;width:100%;"
});
const $458c36893034c4de$var$StyledCloudSecurityParticipantBadgeContainer = (0, $3UXZ8.default)("span", {
    target: "e4w3pke4",
    label: "StyledCloudSecurityParticipantBadgeContainer"
})({
    name: "1ii4fqw",
    styles: "display:inline-block;line-height:1;margin-right:var(--ds-space-100, 8px);"
});
const $458c36893034c4de$export$faf8b8eedbcaaaed = Object.freeze({
    AppListing: 'app-listing-badge',
    AppTile: 'app-tile-badge'
});
const $458c36893034c4de$var$CloudFortifiedSupportIconContainer = (0, $3UXZ8.default)("span", {
    target: "e4w3pke5",
    label: "CloudFortifiedSupportIconContainer"
})({
    name: "1ww2aq1",
    styles: "margin-right:var(--ds-space-100, 8px);"
});
const $458c36893034c4de$var$CloudFortifiedReliabilityIconContainer = (0, $3UXZ8.default)("span", {
    target: "e4w3pke6",
    label: "CloudFortifiedReliabilityIconContainer"
})({
    name: "1ww2aq1",
    styles: "margin-right:var(--ds-space-100, 8px);"
});
function $458c36893034c4de$export$2e2bcd8739ae039(_ref4) {
    let { className: className, showLabel: showLabel, source: source, showAetherAppListingPage: showAetherAppListingPage } = _ref4;
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    if (!showLabel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8PT8s.default), {
        className: className,
        label: "Cloud Fortified App badge"
    });
    const stopEventPropagation = (e)=>e.stopPropagation();
    const onViewDetailsClick = (e)=>{
        fireAnalyticsEvent({
            eventType: (0, $gaiog.LinkClickedEvent),
            actionSubjectId: $458c36893034c4de$var$ANALYTICS_SUBJECT_ID_VIEW_MORE_LINK,
            attributes: {
                label: e.target.text,
                eventContainer: (0, $gaiog.EVENT_CONTAINER_CLOUD_FORTIFIED_TOOLTIP)
            }
        });
    };
    const faqPageLink = source ? (0, (/*@__PURE__*/$parcel$interopDefault($kt9Cs))).stringifyUrl({
        url: (0, $259xn.default).cloudFortified.faq,
        query: {
            source: source
        }
    }) : (0, $259xn.default).cloudFortified.faq;
    const tooltipContentV1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($458c36893034c4de$var$ToolTipContainer, {
        "data-testid": (0, $7BUhe.TEST_IDS).CLOUD_FORTIFIED_TOOLTIP
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, "Cloud Fortified"), " apps offer additional security, reliability and support through:", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($458c36893034c4de$export$56c0d5a1e737357d, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($458c36893034c4de$var$StyledCloudSecurityParticipantBadgeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ihpf.default), {
        showLabel: false,
        iconColor: (0, $3ihpf.CloudSecurityParticipantIconColor).secondary
    })), "Cloud security participation"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($458c36893034c4de$export$56c0d5a1e737357d, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($458c36893034c4de$var$CloudFortifiedReliabilityIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e8A8d.default), {
        label: "Cloud Fortified Reliability badge"
    })), "Reliability checks"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($458c36893034c4de$export$56c0d5a1e737357d, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($458c36893034c4de$var$CloudFortifiedSupportIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kNAhC.default), {
        label: "Cloud Fortified Support badge"
    })), "24hr support response time"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($458c36893034c4de$export$56c0d5a1e737357d, null, "and more."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($458c36893034c4de$export$56c0d5a1e737357d, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gykb8.default), {
        target: "_blank",
        href: faqPageLink,
        onClick: onViewDetailsClick
    }, "Learn about the Cloud Fortified apps program")));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4lmb9.default), {
        content: showAetherAppListingPage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ogmU.default), {
            faqPageLink: faqPageLink,
            onViewDetailsClick: onViewDetailsClick
        }) : tooltipContentV1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($458c36893034c4de$var$BadgeContainer, {
        tabIndex: -1,
        className: className,
        onClick: stopEventPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8PT8s.default), {
        showAetherAppListingPage: showAetherAppListingPage,
        label: "Cloud Fortified app badge"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($458c36893034c4de$var$BadgeLabel, {
        showAetherAppListingPage: showAetherAppListingPage
    }, "CLOUD FORTIFIED"))));
}

});
parcelRegister("gykb8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0cf7960612c47df$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $ibjku = parcelRequire("ibjku");
const $c0cf7960612c47df$export$3aa88e89e7885d6a = /*#__PURE__*/ (0, $ibjku.css)("color:", "var(--ds-link, ".concat((0, $j0gMm.B400), ")"), ";text-decoration:none;cursor:pointer;&:hover{color:", "var(--ds-link, ".concat((0, $j0gMm.B300), ")"), ";}&:active{color:", "var(--ds-link-pressed, ".concat((0, $j0gMm.B500), ")"), ";}&:hover,&:active{outline:0;text-decoration:underline;};label:linkCss;");
var $c0cf7960612c47df$export$2e2bcd8739ae039 = (0, $3UXZ8.default)("a", {
    target: "e1xywzwe0"
})($c0cf7960612c47df$export$3aa88e89e7885d6a, "");

});

parcelRegister("259xn", function(module, exports) {

$parcel$export(module.exports, "default", () => $184372504a3f2102$export$2e2bcd8739ae039);
var $184372504a3f2102$export$2e2bcd8739ae039 = {
    cloudFortified: {
        faq: 'https://www.atlassian.com/trust/marketplace',
        supportRequirements: 'https://developer.atlassian.com/platform/marketplace/cloud-fortified-apps-program-support-requirements'
    },
    bugBountyProgramDetails: 'https://www.atlassian.com/licensing/marketplace#what-is-the-marketplace-bug-bounty-program'
};

});

parcelRegister("kt9Cs", function(module, exports) {

$parcel$export(module.exports, "extract", () => $ee6dfa4355bf821c$export$f9380c9a627682d3, (v) => $ee6dfa4355bf821c$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $ee6dfa4355bf821c$export$98e6a39c04603d36, (v) => $ee6dfa4355bf821c$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $ee6dfa4355bf821c$export$fac44ee5b035f737, (v) => $ee6dfa4355bf821c$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $ee6dfa4355bf821c$export$7a5253c0f62e0150, (v) => $ee6dfa4355bf821c$export$7a5253c0f62e0150 = v);
$parcel$export(module.exports, "stringifyUrl", () => $ee6dfa4355bf821c$export$a8c1621ea79325d3, (v) => $ee6dfa4355bf821c$export$a8c1621ea79325d3 = v);
$parcel$export(module.exports, "pick", () => $ee6dfa4355bf821c$export$357523c63a2253b9, (v) => $ee6dfa4355bf821c$export$357523c63a2253b9 = v);
$parcel$export(module.exports, "exclude", () => $ee6dfa4355bf821c$export$44c361b8ec72ef7f, (v) => $ee6dfa4355bf821c$export$44c361b8ec72ef7f = v);
var $ee6dfa4355bf821c$export$f9380c9a627682d3;
var $ee6dfa4355bf821c$export$98e6a39c04603d36;
var $ee6dfa4355bf821c$export$fac44ee5b035f737;
var $ee6dfa4355bf821c$export$7a5253c0f62e0150;
var $ee6dfa4355bf821c$export$a8c1621ea79325d3;
var $ee6dfa4355bf821c$export$357523c63a2253b9;
var $ee6dfa4355bf821c$export$44c361b8ec72ef7f;
'use strict';

var $hXDaG = parcelRequire("hXDaG");

var $bJEvY = parcelRequire("bJEvY");

var $9CHQr = parcelRequire("9CHQr");

var $aARfw = parcelRequire("aARfw");
const $ee6dfa4355bf821c$var$isNullOrUndefined = (value)=>value === null || value === undefined;
function $ee6dfa4355bf821c$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $ee6dfa4355bf821c$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $ee6dfa4355bf821c$var$encode(key, options),
                            '[',
                            $ee6dfa4355bf821c$var$encode(index, options),
                            ']=',
                            $ee6dfa4355bf821c$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $ee6dfa4355bf821c$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $ee6dfa4355bf821c$var$encode(key, options),
                            '[]=',
                            $ee6dfa4355bf821c$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
            return (key)=>(result, value)=>{
                    if (value === null || value === undefined || value.length === 0) return result;
                    if (result.length === 0) return [
                        [
                            $ee6dfa4355bf821c$var$encode(key, options),
                            '=',
                            $ee6dfa4355bf821c$var$encode(value, options)
                        ].join('')
                    ];
                    return [
                        [
                            result,
                            $ee6dfa4355bf821c$var$encode(value, options)
                        ].join(options.arrayFormatSeparator)
                    ];
                };
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $ee6dfa4355bf821c$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $ee6dfa4355bf821c$var$encode(key, options),
                            '=',
                            $ee6dfa4355bf821c$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $ee6dfa4355bf821c$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $ee6dfa4355bf821c$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $ee6dfa4355bf821c$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$ee6dfa4355bf821c$var$decode(item, options)) : value === null ? value : $ee6dfa4355bf821c$var$decode(value, options);
                accumulator[key] = newValue;
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $ee6dfa4355bf821c$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $ee6dfa4355bf821c$var$encode(value, options) {
    if (options.encode) return options.strict ? $hXDaG(value) : encodeURIComponent(value);
    return value;
}
function $ee6dfa4355bf821c$var$decode(value, options) {
    if (options.decode) return $bJEvY(value);
    return value;
}
function $ee6dfa4355bf821c$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $ee6dfa4355bf821c$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $ee6dfa4355bf821c$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $ee6dfa4355bf821c$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $ee6dfa4355bf821c$var$extract(input) {
    input = $ee6dfa4355bf821c$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $ee6dfa4355bf821c$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $ee6dfa4355bf821c$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $ee6dfa4355bf821c$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $ee6dfa4355bf821c$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $9CHQr(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator'
        ].includes(options.arrayFormat) ? value : $ee6dfa4355bf821c$var$decode(value, options);
        formatter($ee6dfa4355bf821c$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $ee6dfa4355bf821c$var$parseValue(value[k], options);
        else ret[key] = $ee6dfa4355bf821c$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $ee6dfa4355bf821c$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$ee6dfa4355bf821c$export$f9380c9a627682d3 = $ee6dfa4355bf821c$var$extract;
$ee6dfa4355bf821c$export$98e6a39c04603d36 = $ee6dfa4355bf821c$var$parse;
$ee6dfa4355bf821c$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $ee6dfa4355bf821c$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $ee6dfa4355bf821c$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $ee6dfa4355bf821c$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $ee6dfa4355bf821c$var$encode(key, options);
        if (Array.isArray(value)) return value.reduce(formatter(key), []).join('&');
        return $ee6dfa4355bf821c$var$encode(key, options) + '=' + $ee6dfa4355bf821c$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$ee6dfa4355bf821c$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $9CHQr(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $ee6dfa4355bf821c$var$parse($ee6dfa4355bf821c$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $ee6dfa4355bf821c$var$decode(hash, options)
    } : {});
};
$ee6dfa4355bf821c$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true
    }, options);
    const url = $ee6dfa4355bf821c$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $ee6dfa4355bf821c$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $ee6dfa4355bf821c$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $ee6dfa4355bf821c$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $ee6dfa4355bf821c$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${$ee6dfa4355bf821c$var$encode(object.fragmentIdentifier, options)}`;
    return `${url}${queryString}${hash}`;
};
$ee6dfa4355bf821c$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $ee6dfa4355bf821c$export$7a5253c0f62e0150(input, options);
    return $ee6dfa4355bf821c$export$a8c1621ea79325d3({
        url: url,
        query: $aARfw(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$ee6dfa4355bf821c$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $ee6dfa4355bf821c$export$357523c63a2253b9(input, exclusionFilter, options);
};

});

parcelRegister("4lmb9", function(module, exports) {

$parcel$export(module.exports, "default", () => $329a53df95c5a343$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $eRsJy = parcelRequire("eRsJy");

var $eUqFw = parcelRequire("eUqFw");
function $329a53df95c5a343$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $329a53df95c5a343$export$e72bfb66b5de904f = (0, $3UXZ8.default)("span", {
    target: "e1l6eq9s0",
    label: "RichTooltipContainer"
})({
    name: "1c3h18e",
    styles: "flex:1 0 auto;"
});
const $329a53df95c5a343$var$RICH_TOOLTIP_CLASS = 'rich_tooltip__container';
class $329a53df95c5a343$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "showTimerId", void 0);
        (0, $5zQU9.default)(this, "hideTimerId", void 0);
        (0, $5zQU9.default)(this, "isFocused", void 0);
        (0, $5zQU9.default)(this, "state", {
            isOpen: false
        });
        (0, $5zQU9.default)(this, "handleFocusChange", (e)=>{
            const isTooltipChild = (target)=>!(target instanceof HTMLElement) || !target.closest(".".concat($329a53df95c5a343$var$RICH_TOOLTIP_CLASS));
            if (isTooltipChild(e.target)) {
                this.isFocused = false;
                this.setState({
                    isOpen: false
                });
            }
        });
        (0, $5zQU9.default)(this, "handleMouseEnter", ()=>{
            clearTimeout(this.hideTimerId);
            this.showTimerId = setTimeout(()=>{
                this.setState({
                    isOpen: true
                });
            }, this.props.delay);
        });
        (0, $5zQU9.default)(this, "handleMouseLeave", ()=>{
            if (this.isFocused) return;
            clearTimeout(this.showTimerId);
            // Add a delay, allowing some time for the cursor to
            // hop onto the tooltip area without close being triggered
            this.hideTimerId = setTimeout(()=>{
                this.setState({
                    isOpen: false
                });
            }, 150);
        });
        (0, $5zQU9.default)(this, "handleFocus", ()=>{
            this.isFocused = true;
            this.setState({
                isOpen: true
            });
        });
        (0, $5zQU9.default)(this, "onClose", ()=>{
            this.isFocused = false;
            this.setState({
                isOpen: false
            });
        });
        (0, $5zQU9.default)(this, "handleContentBlur", ()=>{
            if (!this.props.disableBlurEvent) this.onClose();
        });
    }
    componentDidMount() {
        document.addEventListener('focus', this.handleFocusChange, true);
    }
    componentWillUnmount() {
        document.removeEventListener('focus', this.handleFocusChange, true);
    }
    render() {
        const { isOpen: isOpen } = this.state;
        const { children: children, content: content } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($329a53df95c5a343$export$e72bfb66b5de904f, {
            className: $329a53df95c5a343$var$RICH_TOOLTIP_CLASS,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eRsJy.default), {
            content: content,
            isOpen: isOpen,
            onClose: this.onClose,
            onContentBlur: this.handleContentBlur,
            testId: "inline-dialog"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            tabIndex: 0,
            onFocus: this.handleFocus,
            role: "tooltip"
        }, children)));
    }
}
(0, $5zQU9.default)($329a53df95c5a343$export$2e2bcd8739ae039, "defaultProps", {
    delay: 200
});

});
parcelRegister("eRsJy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad1c4dd89bf46491$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $5Q9wj = parcelRequire("5Q9wj");

var $KWaBz = parcelRequire("KWaBz");
var $3MxTX = parcelRequire("3MxTX");

var $XHGTv = parcelRequire("XHGTv");

var $8nlzU = parcelRequire("8nlzU");
var $i6BC8 = parcelRequire("i6BC8");
var $6frYP = parcelRequire("6frYP");

var $8zWvy = parcelRequire("8zWvy");

var $iekpz = parcelRequire("iekpz");
const $ad1c4dd89bf46491$var$packageName = "@atlaskit/inline-dialog";
const $ad1c4dd89bf46491$var$packageVersion = "14.3.1";
const $ad1c4dd89bf46491$var$checkIsChildOfPortal = (node)=>{
    if (!node) return false;
    return node.classList && node.classList.contains('atlaskit-portal-container') || $ad1c4dd89bf46491$var$checkIsChildOfPortal(node.parentElement);
};
// escape close manager for layering
const $ad1c4dd89bf46491$var$EscapeCloseManager = ({ handleClose: handleClose })=>{
    (0, $3MxTX.useCloseOnEscapePress)({
        onClose: handleClose
    });
    // only create a dummy component for using ths hook in class component
    return (0, $byn9U.jsx)("span", null);
};
const $ad1c4dd89bf46491$export$513033cc22e3bc20 = /*#__PURE__*/ (0, $eUqFw.memo)(function InlineDialog({ isOpen: isOpen = false, onContentBlur: onContentBlur = (0, $5Q9wj.default), onContentClick: onContentClick = (0, $5Q9wj.default), onContentFocus: onContentFocus = (0, $5Q9wj.default), onClose: onClose = (0, $5Q9wj.default), placement: placement = 'bottom-start', strategy: strategy = 'fixed', testId: testId, content: content, children: children }) {
    const containerRef = (0, $eUqFw.useRef)(null);
    const triggerRef = (0, $eUqFw.useRef)(null);
    // we put this into a ref to avoid handleCloseRequest having this as a dependency
    const onCloseRef = (0, $eUqFw.useRef)(onClose);
    const isLayeringEnabled = (0, $XHGTv.fg)('platform.design-system-team.inline-message-layering_wfp1p') && isOpen;
    (0, $eUqFw.useEffect)(()=>{
        onCloseRef.current = onClose;
    });
    const handleCloseRequest = (0, $eUqFw.useCallback)((event)=>{
        const { target: target } = event;
        // checks for when target is not HTMLElement
        if (!(target instanceof HTMLElement)) return;
        // TODO: This is to handle the case where the target is no longer in the DOM.
        // This happens with react-select in datetime picker. There might be other
        // edge cases for this.
        if (!document.body.contains(target)) return;
        if (isLayeringEnabled) {
            var _onCloseRef$current;
            (_onCloseRef$current = onCloseRef.current) === null || _onCloseRef$current === void 0 || _onCloseRef$current.call(onCloseRef, {
                isOpen: false,
                event: event
            });
            return;
        }
        // handles the case where inline dialog opens portalled elements such as modal
        if ($ad1c4dd89bf46491$var$checkIsChildOfPortal(target)) return;
        // call onClose if the click originated from outside the dialog
        if (containerRef.current && !containerRef.current.contains(target)) {
            var _onCloseRef$current2;
            (_onCloseRef$current2 = onCloseRef.current) === null || _onCloseRef$current2 === void 0 || _onCloseRef$current2.call(onCloseRef, {
                isOpen: false,
                event: event
            });
        }
    }, [
        isLayeringEnabled
    ]);
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        var _containerRef$current;
        // exit if we click outside but on the trigger — it can handle the clicks itself
        if (triggerRef.current && triggerRef.current.contains(event.target)) return;
        // if feature flag is enabled we won't file the close event when clicking inside dialog
        if (isLayeringEnabled && (_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(event.target)) return;
        handleCloseRequest(event);
    }, [
        handleCloseRequest,
        isLayeringEnabled
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isOpen) return;
        return (0, $74BVL.bind)(window, {
            type: 'click',
            listener: handleClick,
            options: {
                capture: true
            }
        });
    }, [
        isOpen,
        handleClick
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Escape') handleCloseRequest(event);
    }, [
        handleCloseRequest
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // if layering is enabled, we will use useCloseOnEscapePress hook instead
        if (!isOpen || isLayeringEnabled) return;
        const unbind = (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: handleKeyDown,
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        isOpen,
        handleKeyDown,
        isLayeringEnabled
    ]);
    const popper = isOpen ? (0, $byn9U.jsx)((0, $i6BC8.Popper), {
        placement: placement,
        strategy: strategy
    }, ({ ref: ref, style: style })=>(0, $byn9U.jsx)((0, $iekpz.Container), {
            onBlur: onContentBlur,
            onFocus: onContentFocus,
            onClick: onContentClick,
            ref: (node)=>{
                if (node) {
                    containerRef.current = node;
                    if (typeof ref === 'function') ref(node);
                    else ref.current = node;
                }
            },
            style: style,
            testId: testId
        }, content)) : null;
    return (0, $byn9U.jsx)((0, $8nlzU.Manager), null, (0, $byn9U.jsx)((0, $6frYP.Reference), null, ({ ref: ref })=>(0, $byn9U.jsx)((0, $8zWvy.default), {
            innerRef: (node)=>{
                triggerRef.current = node;
                if (typeof ref === 'function') ref(node);
                else ref.current = node;
            // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            },
            hasNodeResolver: !(0, $XHGTv.fg)('dsp-19516-design-system-portal-logic-update')
        }, (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children))), isLayeringEnabled ? (0, $byn9U.jsx)((0, $KWaBz.UNSAFE_LAYERING), {
        isDisabled: false
    }, popper, (0, $byn9U.jsx)($ad1c4dd89bf46491$var$EscapeCloseManager, {
        handleClose: handleCloseRequest
    })) : popper);
});
$ad1c4dd89bf46491$export$513033cc22e3bc20.displayName = 'InlineDialog';
const $ad1c4dd89bf46491$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
/**
 * __Inline dialog__
 *
 * _We are planning on deprecating Inline dialog. We recommend using the Popup component instead._
 *
 * An inline dialog is a pop-up container for small amounts of information. It can also contain controls.
 *
 * - [Examples](https://atlassian.design/components/inline-dialog/examples)
 * - [Code](https://atlassian.design/components/inline-dialog/code)
 * - [Usage](https://atlassian.design/components/inline-dialog/usage)
 */ const $ad1c4dd89bf46491$var$InlineDialog = (0, $1ngde.default)({
    componentName: 'inlineDialog',
    packageName: $ad1c4dd89bf46491$var$packageName,
    packageVersion: $ad1c4dd89bf46491$var$packageVersion
})((0, $2jDha.default)({
    onClose: $ad1c4dd89bf46491$var$createAndFireEventOnAtlaskit({
        action: 'closed',
        actionSubject: 'inlineDialog',
        attributes: {
            componentName: 'inlineDialog',
            packageName: $ad1c4dd89bf46491$var$packageName,
            packageVersion: $ad1c4dd89bf46491$var$packageVersion
        }
    })
})($ad1c4dd89bf46491$export$513033cc22e3bc20));
var $ad1c4dd89bf46491$export$2e2bcd8739ae039 = $ad1c4dd89bf46491$var$InlineDialog;

});
parcelRegister("KWaBz", function(module, exports) {

$parcel$export(module.exports, "LevelContext", () => $08d16b5a411cd6b7$export$650d12d3c2ddb8fc);
$parcel$export(module.exports, "TopLevelContext", () => $08d16b5a411cd6b7$export$48b383b280e20440);
$parcel$export(module.exports, "UNSAFE_LAYERING", () => $08d16b5a411cd6b7$export$a183686c3f6f4ea8);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $08d16b5a411cd6b7$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $eUqFw.createContext)(0);
const $08d16b5a411cd6b7$export$48b383b280e20440 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    topLevelRef: {
        current: null
    },
    setTopLevel: (0, $5Q9wj.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ const $08d16b5a411cd6b7$var$LevelProvider = ({ children: children, currentLevel: currentLevel })=>{
    const { setTopLevel: setTopLevel, topLevelRef: topLevelRef } = (0, $eUqFw.useContext)($08d16b5a411cd6b7$export$48b383b280e20440);
    if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
    (0, $eUqFw.useEffect)(()=>{
        // avoid immediate cleanup using setTimeout when component unmount
        // this will make sure non-top layer components can get the correct top level value
        // when multiple layers trigger onClose in sequence.
        // From React 17, the useEffect cleanup functions are delayed till the commit phase is completed. In other words, the useEffect cleanup functions run asynchronously - for example, if the component is unmounting, the cleanup runs after the screen has been updated.
        // TODO revisit after we migrate to react 18. https://product-fabric.atlassian.net/browse/DSP-13139
        return ()=>{
            setTimeout(()=>{
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($08d16b5a411cd6b7$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ const $08d16b5a411cd6b7$var$LayeringProvider = ({ children: children })=>{
    const topLevelRef = (0, $eUqFw.useRef)(0);
    const value = (0, $eUqFw.useMemo)(()=>({
            topLevelRef: topLevelRef,
            setTopLevel: (level)=>{
                topLevelRef.current = level;
            }
        }), [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($08d16b5a411cd6b7$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
const $08d16b5a411cd6b7$export$a183686c3f6f4ea8 = ({ children: children, isDisabled: isDisabled = true })=>{
    const currentLevel = (0, $eUqFw.useContext)($08d16b5a411cd6b7$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    const isNested = currentLevel > 0;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($08d16b5a411cd6b7$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($08d16b5a411cd6b7$var$LayeringProvider, null, content);
};

});

parcelRegister("3MxTX", function(module, exports) {

$parcel$export(module.exports, "useCloseOnEscapePress", () => $2c1026ea90ae8f60$export$4a4bf067ea9e7886);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $KWaBz = parcelRequire("KWaBz");
const $2c1026ea90ae8f60$var$ESCAPE = 'Escape';
function $2c1026ea90ae8f60$export$4a4bf067ea9e7886({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $eUqFw.useRef)(false);
    const { isLayerDisabled: isLayerDisabled } = $2c1026ea90ae8f60$export$cec37b93989366d4();
    const onKeyDown = (0, $eUqFw.useCallback)((e)=>{
        const isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $2c1026ea90ae8f60$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    const onKeyUp = (0, $eUqFw.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $2c1026ea90ae8f60$export$cec37b93989366d4() {
    const currentLevel = (0, $eUqFw.useContext)((0, $KWaBz.LevelContext));
    const { topLevelRef: topLevelRef } = (0, $eUqFw.useContext)((0, $KWaBz.TopLevelContext));
    const isLayerDisabled = (0, $eUqFw.useCallback)(()=>{
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    };
}

});

parcelRegister("8zWvy", function(module, exports) {

$parcel$export(module.exports, "default", () => $63eefa122eb901b1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lbDTY = parcelRequire("lbDTY");
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {(instance: HTMLDivElement) => void} props.innerRef - A ref callback to get the instance of the HTMLDivElement.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
 */ const $63eefa122eb901b1$var$NodeResolverWrapper = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
    if (hasNodeResolver) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbDTY))), {
        innerRef: innerRef
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: (node)=>innerRef(node)
    }, children);
};
var $63eefa122eb901b1$export$2e2bcd8739ae039 = $63eefa122eb901b1$var$NodeResolverWrapper;

});

parcelRegister("iekpz", function(module, exports) {

$parcel$export(module.exports, "Container", () => $d4595e182c0900fd$export$42a852a2b6b56249);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");


var $lcnyw = parcelRequire("lcnyw");
const $d4595e182c0900fd$var$CSS_THEME_BACKGROUND = '--theme-background';
const $d4595e182c0900fd$var$CSS_THEME_COLOR = '--theme-color';
const $d4595e182c0900fd$var$CSS_THEME_BOX_SHADOW = '--theme-box-shadow';
const $d4595e182c0900fd$var$containerStyles = (0, $byn9U.css)({
    boxSizing: 'content-box',
    maxWidth: `${448}px`,
    maxHeight: `${448}px`,
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"}`,
    zIndex: (0, $lcnyw.layers).dialog(),
    background: `var(${$d4595e182c0900fd$var$CSS_THEME_BACKGROUND})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(${$d4595e182c0900fd$var$CSS_THEME_BOX_SHADOW})`,
    color: `var(${$d4595e182c0900fd$var$CSS_THEME_COLOR})`,
    '&:focus': {
        outline: 'none'
    }
});
const $d4595e182c0900fd$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, onBlur: onBlur, onClick: onClick, onFocus: onFocus, style: style, testId: testId }, ref)=>{
    return(// Unfortunately, these are used for products to pass through. Inline Dialog is being deprecated anyway
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    (0, $byn9U.jsx)("div", {
        css: $d4595e182c0900fd$var$containerStyles,
        "data-testid": testId,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        ref: ref,
        style: {
            [$d4595e182c0900fd$var$CSS_THEME_BACKGROUND]: `var(--ds-surface-overlay, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
            [$d4595e182c0900fd$var$CSS_THEME_COLOR]: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$fbda843f0a27fe96)})`,
            [$d4595e182c0900fd$var$CSS_THEME_BOX_SHADOW]: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $73a5c9d720aa66e1$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}`})`,
            ...style
        }
    }, children));
});

});
var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';




parcelRegister("7BUhe", function(module, exports) {

$parcel$export(module.exports, "TEST_IDS", () => $58a7a48ce1c17f4e$export$a2b4f255152a6585);
const $58a7a48ce1c17f4e$export$a2b4f255152a6585 = {
    PARTNER_DETAILS: 'partner-details',
    CLOUD_SECURITY_PARTICIPANT_TOOLTIP: 'cloud-security-participant__tooltip',
    CLOUD_SECURITY_PARTICIPANT_TOOLTIP_V2: 'cloud-security-participant__tooltip_v2',
    CLOUD_FORTIFIED_TOOLTIP: 'cloud-fortified__tooltip',
    CLOUD_FORTIFIED_TOOLTIP_V2: 'cloud-fortified__tooltip_v2',
    CLOUD_FORTIFIED_INFO_MODAL: 'cloudfortified-info-modal',
    CERTIFICATION_SECTION: 'certification-section',
    APP_HEADER_LOZENGES: 'app-header__lozenges',
    APP_HEADER: 'app-header',
    APP_HEADER_ICON: 'app-header__icon',
    APP_HEADER_APP_NAME: 'app-header__app-name',
    APP_HEADER_COMPATIBILITIES: 'app-header__compatibilities',
    APP_HEADER_RATINGS: 'app-header__ratings',
    APP_HEADER_INSTALL_COUNT: 'app-header__install-count',
    APP_HEADER_CERTIFICATION: 'app-header__certification',
    APP_HEADER_STAFF_PICK: 'app-header__staff-pick',
    APP_HEADER_INJECTION: 'app-header__injection'
};

});

parcelRegister("8PT8s", function(module, exports) {

$parcel$export(module.exports, "default", () => $66eddaea9416f040$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $2ziLQ = parcelRequire("2ziLQ");

var $j0gMm = parcelRequire("j0gMm");

var $eUqFw = parcelRequire("eUqFw");
const $66eddaea9416f040$var$CloudFortifiedAppIcon = (props)=>{
    const CloudFortifiedGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
            className: props.className,
            width: props.showAetherAppListingPage ? '20' : '24',
            height: props.showAetherAppListingPage ? '20' : '24',
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.33103 2H7.64138C7.8242 2 7.97241 2.14289 7.97241 2.31915V4.44681H9.95862V2.31915C9.95862 2.14289 10.1068 2 10.2897 2H13.6C13.7828 2 13.931 2.14289 13.931 2.31915V4.44681H15.9172V2.31915C15.9172 2.14289 16.0655 2 16.2483 2H19.669C19.8518 2 20 2.14289 20 2.31915V9.65168C20 9.73992 19.9621 9.82421 19.8953 9.88455L18.0081 11.5897C17.9413 11.65 17.9034 11.7343 17.9034 11.8226V17.3672L18.4618 21.2746C18.5167 21.6581 18.2076 22 17.806 22H6.08368C5.68211 22 5.373 21.6581 5.42781 21.2746L5.98621 17.3672V11.8175C5.98621 11.7322 5.95084 11.6505 5.88798 11.5906L4.19645 9.97734C4.07074 9.85745 4 9.69405 4 9.52356V2.31915C4 2.14289 4.14821 2 4.33103 2ZM10.3584 16.6809H13.5313C13.7521 16.6809 13.931 16.5083 13.931 16.2955V13.7447C13.931 13.0375 13.5267 12.3879 12.8795 12.0551C12.2953 11.7547 11.5943 11.7547 11.0101 12.0551C10.3629 12.3879 9.95862 13.0375 9.95862 13.7447V16.2955C9.95862 16.5083 10.1376 16.6809 10.3584 16.6809Z",
            fill: "currentColor"
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.Icon), (0, $kU09D.default)({
        glyph: CloudFortifiedGlyph,
        primaryColor: "var(--ds-icon-brand, ".concat((0, $j0gMm.B400), ")")
    }, props));
};
var $66eddaea9416f040$export$2e2bcd8739ae039 = $66eddaea9416f040$var$CloudFortifiedAppIcon;

});

parcelRegister("e8A8d", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4add704019c82c4$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $2ziLQ = parcelRequire("2ziLQ");

var $j0gMm = parcelRequire("j0gMm");

var $eUqFw = parcelRequire("eUqFw");
const $a4add704019c82c4$var$CloudFortifiedReliabilityIcon = (props)=>{
    const CloudFortifiedReliabilityGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
            className: props.className,
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
            d: "M21.9226 13.25H17.625C17.349 13.25 17.1057 13.069 17.0264 12.8046L15.823 8.79346L13.8584 17.1432C13.7938 17.4178 13.5531 17.6151 13.2711 17.6246C12.989 17.6342 12.7356 17.4535 12.6526 17.1838L10.6114 10.5498L9.43402 12.9045C9.33715 13.0983 9.14686 13.228 8.93113 13.2475C8.71539 13.2669 8.50497 13.1733 8.375 13L7 11.1667L5.625 13C5.50697 13.1574 5.32172 13.25 5.125 13.25H2.07737C2.69249 18.1829 6.90048 22 12 22C17.0995 22 21.3075 18.1829 21.9226 13.25Z",
            fill: "currentColor"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
            d: "M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12H4.8125L6.5 9.75C6.61803 9.59262 6.80328 9.5 7 9.5C7.19672 9.5 7.38197 9.59262 7.5 9.75L8.76824 11.441L10.191 8.59549C10.3052 8.36702 10.547 8.23106 10.8015 8.25213C11.0561 8.2732 11.2722 8.44706 11.3474 8.6912L13.1695 14.6132L15.1416 6.23185C15.2064 5.95637 15.4483 5.75883 15.7311 5.75028C16.014 5.74174 16.2673 5.92434 16.3486 6.19541L18.09 12H22Z",
            fill: "currentColor"
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.Icon), (0, $kU09D.default)({
        glyph: CloudFortifiedReliabilityGlyph,
        primaryColor: "var(--ds-icon, ".concat((0, $j0gMm.N500), ")")
    }, props));
};
var $a4add704019c82c4$export$2e2bcd8739ae039 = $a4add704019c82c4$var$CloudFortifiedReliabilityIcon;

});

parcelRegister("kNAhC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f24487531c098250$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $2ziLQ = parcelRequire("2ziLQ");

var $j0gMm = parcelRequire("j0gMm");

var $eUqFw = parcelRequire("eUqFw");
const $f24487531c098250$var$CloudFortifiedSupportIcon = (props)=>{
    const CloudFortifiedSupportGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
            className: props.className,
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM5.33333 12C5.33333 8.324 8.324 5.33333 12 5.33333C15.676 5.33333 18.6667 8.324 18.6667 12V14.762C18.6667 15.4447 18.0687 16 17.3333 16C17.3333 17.4707 16.1373 18.6667 14.6667 18.6667H11.6667C11.1144 18.6667 10.6667 18.219 10.6667 17.6667C10.6667 17.1144 11.1144 16.6667 11.6667 16.6667H13.3333V17.3333H14.6667C15.402 17.3333 16 16.7353 16 16V11.9047C16 11.7279 16.0702 11.5583 16.1953 11.4333C16.3203 11.3082 16.4899 11.238 16.6667 11.238H17.272C16.9013 8.658 14.6813 6.66667 12 6.66667C9.31867 6.66667 7.09867 8.658 6.728 11.238H7.33333C7.51015 11.238 7.67971 11.3082 7.80474 11.4333C7.92976 11.5583 8 11.7279 8 11.9047V15.3333C8 15.5101 7.92976 15.6797 7.80474 15.8047C7.67971 15.9298 7.51015 16 7.33333 16H6.66667C5.93133 16 5.33333 15.4447 5.33333 14.762V12Z",
            fill: "currentColor"
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.Icon), (0, $kU09D.default)({
        glyph: CloudFortifiedSupportGlyph,
        primaryColor: "var(--ds-icon, ".concat((0, $j0gMm.N500), ")")
    }, props));
};
var $f24487531c098250$export$2e2bcd8739ae039 = $f24487531c098250$var$CloudFortifiedSupportIcon;

});

parcelRegister("3ihpf", function(module, exports) {

$parcel$export(module.exports, "CloudSecurityParticipantIconColor", () => $26608e112b48d193$export$31cb4060a77ad5a0);
$parcel$export(module.exports, "CLOUD_SECURITY_BADGE_LABEL", () => $26608e112b48d193$export$bcd38832e93f158e);
$parcel$export(module.exports, "default", () => $26608e112b48d193$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $j0gMm = parcelRequire("j0gMm");

var $hvUUg = parcelRequire("hvUUg");
var $gykb8 = parcelRequire("gykb8");

var $eUqFw = parcelRequire("eUqFw");

var $4lmb9 = parcelRequire("4lmb9");

var $7BUhe = parcelRequire("7BUhe");

var $g1o8Q = parcelRequire("g1o8Q");

var $f9qVk = parcelRequire("f9qVk");

var $2C2Cj = parcelRequire("2C2Cj");
function $26608e112b48d193$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $26608e112b48d193$var$StyledParagraph = (0, $3UXZ8.default)("p", {
    target: "e1g39hrb0",
    label: "StyledParagraph"
})({
    name: "i38rxf",
    styles: "margin-top:0;margin-bottom:var(--ds-space-100, 8px);"
});
const $26608e112b48d193$var$BadgeText = (0, $3UXZ8.default)("span", {
    target: "e1g39hrb1",
    label: "BadgeText"
})((0, $hvUUg.CharlieFontFamily), " text-transform:uppercase;margin-left:var(--ds-space-050, 4px);color:", (_ref)=>{
    let { showAetherAppListingPage: showAetherAppListingPage } = _ref;
    return showAetherAppListingPage ? "var(--ds-text-subtle)" : "var(--ds-text)";
}, ";word-spacing:1px;white-space:nowrap;font-weight:", (_ref2)=>{
    let { showAetherAppListingPage: showAetherAppListingPage } = _ref2;
    return showAetherAppListingPage ? '600' : '400';
}, ";font-size:", (_ref3)=>{
    let { showAetherAppListingPage: showAetherAppListingPage } = _ref3;
    return showAetherAppListingPage ? '1rem' : '14px';
}, ";");
const $26608e112b48d193$var$BadgeContainer = (0, $3UXZ8.default)("button", {
    target: "e1g39hrb2",
    label: "BadgeContainer"
})({
    name: "18gbust",
    styles: "all:unset;width:100%;display:flex;align-items:center;"
});
const $26608e112b48d193$var$P = (0, $3UXZ8.default)("p", {
    target: "e1g39hrb3",
    label: "P"
})({
    name: "bjwoin",
    styles: "display:flex;align-items:inherit;margin:0 0 var(--ds-space-150, 12px);"
});
const $26608e112b48d193$var$TooltipContainer = (0, $3UXZ8.default)("div", {
    target: "e1g39hrb4",
    label: "TooltipContainer"
})("max-width:16rem;color:", "var(--ds-text, ".concat((0, $j0gMm).N600, ")"), ";");
const $26608e112b48d193$var$Span = (0, $3UXZ8.default)("span", {
    target: "e1g39hrb5",
    label: "Span"
})({
    name: "ob0vux",
    styles: "margin-left:var(--ds-space-100, 8px);max-width:11rem;"
});
const $26608e112b48d193$export$31cb4060a77ad5a0 = {
    primary: "var(--ds-icon-brand, ".concat((0, $j0gMm.B400), ")"),
    secondary: "var(--ds-icon, ".concat((0, $j0gMm.N500), ")")
};
const $26608e112b48d193$export$bcd38832e93f158e = 'Cloud Security Participant';
function $26608e112b48d193$export$2e2bcd8739ae039(_ref4) {
    let { className: className, showLabel: showLabel, iconSize: iconSize, iconColor: iconColor, showAetherAppListingPage: showAetherAppListingPage } = _ref4;
    const badgeIconColor = iconColor ? iconColor : $26608e112b48d193$export$31cb4060a77ad5a0.primary;
    if (!showLabel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f9qVk.default), {
        label: "".concat($26608e112b48d193$export$bcd38832e93f158e, " badge"),
        size: iconSize,
        primaryColor: badgeIconColor
    });
    const stopEventPropagation = (e)=>e.stopPropagation();
    const link = 'https://www.atlassian.com/licensing/marketplace#what-is-the-marketplace-bug-bounty-program';
    const tooltipContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($26608e112b48d193$var$TooltipContainer, {
        "data-testid": (0, $7BUhe.TEST_IDS).CLOUD_SECURITY_PARTICIPANT_TOOLTIP
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($26608e112b48d193$var$StyledParagraph, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, "Cloud Security participant"), " apps offer verified security through:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($26608e112b48d193$var$P, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g1o8Q.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($26608e112b48d193$var$Span, null, "Participation in the Marketplace Bug Bounty program")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gykb8.default), {
        target: "_blank",
        href: link,
        onClick: stopEventPropagation
    }, "Learn about the Marketplace Bug Bounty program"));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4lmb9.default), {
        content: showAetherAppListingPage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2C2Cj.default), {
            learnMoreLink: link
        }) : tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($26608e112b48d193$var$BadgeContainer, {
        tabIndex: -1,
        className: className,
        onClick: stopEventPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f9qVk.default), {
        label: "".concat($26608e112b48d193$export$bcd38832e93f158e, " badge"),
        size: iconSize,
        primaryColor: badgeIconColor,
        showAetherAppListingPage: showAetherAppListingPage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($26608e112b48d193$var$BadgeText, {
        showAetherAppListingPage: showAetherAppListingPage
    }, $26608e112b48d193$export$bcd38832e93f158e))));
}

});
parcelRegister("g1o8Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba9f775c19c361c0$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $aWvIp = parcelRequire("aWvIp");

var $j0gMm = parcelRequire("j0gMm");

var $eUqFw = parcelRequire("eUqFw");
function $ba9f775c19c361c0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/* CSS transform added because icon is not centered by default*/ const $ba9f775c19c361c0$var$CheckCircleIconContainer = (0, $3UXZ8.default)("div", {
    target: "e1d73sv30",
    label: "CheckCircleIconContainer"
})({
    name: "1mzw1zc",
    styles: "display:flex;height:20px;"
});
function $ba9f775c19c361c0$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ba9f775c19c361c0$var$CheckCircleIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
        primaryColor: (0, $j0gMm.G400),
        label: "Check Circle"
    }));
}

});

parcelRegister("f9qVk", function(module, exports) {

$parcel$export(module.exports, "default", () => $b07c94bb50af0f90$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $2ziLQ = parcelRequire("2ziLQ");

var $eUqFw = parcelRequire("eUqFw");
const $b07c94bb50af0f90$var$CloudSecurityParticipantIcon = (props)=>{
    const CloudSecurityParticipantGlyph = (customGlyphProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", (0, $kU09D.default)({
            width: props.showAetherAppListingPage ? '20' : '24',
            height: props.showAetherAppListingPage ? '20' : '24',
            viewBox: "0 0 24 24"
        }, customGlyphProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.6051 2.11511C11.8188 1.94054 12.1318 1.94075 12.3453 2.11552C14.2453 3.67094 18.1926 4.96529 19.8264 5.45653C20.2591 5.58663 20.5595 5.98264 20.5567 6.43444C20.5165 12.8551 19.8453 18.4583 12.3203 21.4067C12.0977 21.4939 11.8421 21.4939 11.6195 21.4067C4.09451 18.4584 3.42328 12.8552 3.38308 6.43461C3.38025 5.98273 3.68081 5.58667 4.1136 5.45667C5.74876 4.96549 9.7011 3.67085 11.6051 2.11511ZM8.42778 10.7852C8.61008 10.7917 8.78245 10.8699 8.9074 11.0027L11.0515 13.3303C11.9236 12.4727 12.7945 11.6141 13.6642 10.7543L13.6919 10.7266C14.5358 9.89447 15.3756 9.05817 16.2112 8.21772C16.3408 8.0904 16.5152 8.01914 16.6968 8.0193C16.8785 8.01945 17.0528 8.09102 17.1822 8.21856C17.3115 8.3461 17.3856 8.51938 17.3883 8.70101C17.391 8.88265 17.3222 9.05807 17.1967 9.18943C16.3572 10.0343 15.5133 10.8748 14.665 11.7108L14.6373 11.7385C13.7297 12.6353 12.8209 13.5312 11.9111 14.4259L11.6592 14.6744C11.3152 15.0176 10.7616 15.0176 10.3899 14.6536L7.89001 11.9412C7.76761 11.806 7.70356 11.6279 7.71178 11.4457C7.72001 11.2634 7.79984 11.0918 7.93392 10.9681C8.068 10.8444 8.24548 10.7787 8.42778 10.7852Z"
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.Icon), (0, $kU09D.default)({
        glyph: CloudSecurityParticipantGlyph
    }, props));
};
var $b07c94bb50af0f90$export$2e2bcd8739ae039 = $b07c94bb50af0f90$var$CloudSecurityParticipantIcon;

});

parcelRegister("2C2Cj", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e7129118bafaf97$export$2e2bcd8739ae039);
/* CloudSecurityParticipantTooltipV2.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $kU09D = parcelRequire("kU09D");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $cCrLo = parcelRequire("cCrLo");
var $ixQHh = parcelRequire("ixQHh");

var $7BUhe = parcelRequire("7BUhe");

var $f9qVk = parcelRequire("f9qVk");
const $1e7129118bafaf97$var$_excluded = [
    "as",
    "style"
], $1e7129118bafaf97$var$_excluded2 = [
    "as",
    "style"
], $1e7129118bafaf97$var$_excluded3 = [
    "as",
    "style"
], $1e7129118bafaf97$var$_excluded4 = [
    "as",
    "style"
];
const $1e7129118bafaf97$var$Container = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $1e7129118bafaf97$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1tad",
            __cmplp.className
        ])
    }));
});
const $1e7129118bafaf97$var$BoldText = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodySmall), style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $1e7129118bafaf97$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1nu9 _k48pni7l",
            __cmplp.className
        ])
    }));
});
const $1e7129118bafaf97$var$DetailsContainer = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $1e7129118bafaf97$var$_excluded3);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkxjmg _otyrxjmg _1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    }));
});
const $1e7129118bafaf97$var$DetailsText = (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodySmall), style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $1e7129118bafaf97$var$_excluded4);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _18u01eps",
            __cmplp.className
        ])
    }));
});
const $1e7129118bafaf97$var$CloudSecurityParticipantTooltipV2 = (_ref5)=>{
    let { learnMoreLink: learnMoreLink } = _ref5;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1e7129118bafaf97$var$Container, {
        "data-testid": (0, $7BUhe.TEST_IDS).CLOUD_SECURITY_PARTICIPANT_TOOLTIP_V2
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cCrLo.BodySmall), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1e7129118bafaf97$var$BoldText, null, "Cloud Security Participant"), " apps offer verified security through:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1e7129118bafaf97$var$DetailsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f9qVk.default), {
        label: "Cloud Security Participant Badge",
        size: "medium",
        primaryColor: "var(--ds-icon)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1e7129118bafaf97$var$DetailsText, null, "Participation in the Marketplace Bug Bounty program")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ixQHh.LinkWithIcon), {
        href: learnMoreLink,
        type: "external",
        size: "small"
    }, "Know more about the Bug bounty program"));
};
var $1e7129118bafaf97$export$2e2bcd8739ae039 = $1e7129118bafaf97$var$CloudSecurityParticipantTooltipV2;

});
parcelRegister("cCrLo", function(module, exports) {

$parcel$export(module.exports, "H3", () => $92fe91e6af513127$export$746be9e3a3dfff1f);
$parcel$export(module.exports, "H4", () => $92fe91e6af513127$export$cc5e069d64fda823);
$parcel$export(module.exports, "H5", () => $92fe91e6af513127$export$88ef9fdaf11f7a1f);
$parcel$export(module.exports, "H6", () => $92fe91e6af513127$export$a559fb8039b06400);
$parcel$export(module.exports, "EyebrowSmall", () => $92fe91e6af513127$export$b23b65e5c526dfb2);
$parcel$export(module.exports, "BodySmall", () => $92fe91e6af513127$export$476b59e00e6c3fbd);
$parcel$export(module.exports, "BodyNormal", () => $92fe91e6af513127$export$2c8d5c6cefa197f7);
$parcel$export(module.exports, "FinePrint", () => $92fe91e6af513127$export$56ff71eb7b6bd339);
/* Typography.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $kU09D = parcelRequire("kU09D");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");


const $92fe91e6af513127$var$_excluded = [
    "as",
    "style"
], $92fe91e6af513127$var$_excluded2 = [
    "as",
    "style"
], $92fe91e6af513127$var$_excluded3 = [
    "as",
    "style"
], $92fe91e6af513127$var$_excluded4 = [
    "as",
    "style"
], $92fe91e6af513127$var$_excluded5 = [
    "as",
    "style"
], $92fe91e6af513127$var$_excluded6 = [
    "as",
    "style"
], $92fe91e6af513127$var$_excluded7 = [
    "as",
    "style"
], $92fe91e6af513127$var$_excluded8 = [
    "as",
    "style"
], $92fe91e6af513127$var$_excluded9 = [
    "as",
    "style"
], $92fe91e6af513127$var$_excluded10 = [
    "as",
    "style"
], $92fe91e6af513127$var$_excluded11 = [
    "as",
    "style"
], $92fe91e6af513127$var$_excluded12 = [
    "as",
    "style"
], $92fe91e6af513127$var$_excluded13 = [
    "as",
    "style"
], $92fe91e6af513127$var$_excluded14 = [
    "as",
    "style"
];
const $92fe91e6af513127$var$baseStyles = {
    color: "var(--ds-text)"
};
const $92fe91e6af513127$export$5523b16adee8048 = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "h1", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $92fe91e6af513127$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1blv _ect4khal _1wyb8pqr _vwz41p2n _k48pni7l _1s18yn4p _17gqqf5o _3p1cne5d _py5o1qiw",
            __cmplp.className
        ])
    }));
});
const $92fe91e6af513127$export$cb94397127ac9363 = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "h2", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $92fe91e6af513127$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1blv _ect4khal _1wybviql _vwz411uf _k48pni7l _1s18ahaf _17gq13ei _3p1c1ihe _py5o18a8",
            __cmplp.className
        ])
    }));
});
const $92fe91e6af513127$export$746be9e3a3dfff1f = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = "h3", style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $92fe91e6af513127$var$_excluded3);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1blv _ect4khal _1wyb1k8s _vwz4l07h _k48pni7l _1dyzdrct _1s181m1q _17gqc5mb _3p1c1kjp _py5o1nre",
            __cmplp.className
        ])
    }));
});
const $92fe91e6af513127$export$cc5e069d64fda823 = (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = "h4", style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $92fe91e6af513127$var$_excluded4);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1blv _ect4khal _1wyb1k92 _vwz41slo _k48pni7l _1dyzdrct _1s18imiu _17gq1m1q _3p1c1lzw _py5o1ds4",
            __cmplp.className
        ])
    }));
});
const $92fe91e6af513127$export$88ef9fdaf11f7a1f = (0, $eUqFw.forwardRef)((_ref5, __cmplr)=>{
    let { as: C = "h5", style: __cmpls } = _ref5, __cmplp = (0, $bwPfh.default)(_ref5, $92fe91e6af513127$var$_excluded5);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1blv _ect4khal _1wyb1cby _vwz41slo _k48pni7l _1dyzdrct _3p1c1uvp _py5o1nsk",
            __cmplp.className
        ])
    }));
});
const $92fe91e6af513127$export$a559fb8039b06400 = (0, $eUqFw.forwardRef)((_ref6, __cmplr)=>{
    let { as: C = "h6", style: __cmpls } = _ref6, __cmplp = (0, $bwPfh.default)(_ref6, $92fe91e6af513127$var$_excluded6);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1blv _ect4khal _1wyb1j6v _vwz41k8s _k48pni7l _1dyzdrct _1p1dglyw",
            __cmplp.className
        ])
    }));
});
const $92fe91e6af513127$export$b23b65e5c526dfb2 = (0, $eUqFw.forwardRef)((_ref7, __cmplr)=>{
    let { as: C = "p", style: __cmpls } = _ref7, __cmplp = (0, $bwPfh.default)(_ref7, $92fe91e6af513127$var$_excluded7);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1blv _ect4khal _1p1dangw _1wyboqnp _vwz47vkz",
            __cmplp.className
        ])
    }));
});
const $92fe91e6af513127$export$bf81649988183949 = (0, $eUqFw.forwardRef)((_ref8, __cmplr)=>{
    let { as: C = "p", style: __cmpls } = _ref8, __cmplp = (0, $bwPfh.default)(_ref8, $92fe91e6af513127$var$_excluded8);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1blv _ect4khal _1p1dangw _1wyboxwj _vwz4f6fq",
            __cmplp.className
        ])
    }));
});
const $92fe91e6af513127$export$476b59e00e6c3fbd = (0, $eUqFw.forwardRef)((_ref9, __cmplr)=>{
    let { as: C = "p", style: __cmpls } = _ref9, __cmplp = (0, $bwPfh.default)(_ref9, $92fe91e6af513127$var$_excluded9);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1blv _ect41sdi _1wyboxwj _vwz4gktf",
            __cmplp.className
        ])
    }));
});
const $92fe91e6af513127$export$2c8d5c6cefa197f7 = (0, $eUqFw.forwardRef)((_ref10, __cmplr)=>{
    let { as: C = "p", style: __cmpls } = _ref10, __cmplp = (0, $bwPfh.default)(_ref10, $92fe91e6af513127$var$_excluded10);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1blv _ect41sdi _1wyb1j6v _vwz41tcg",
            __cmplp.className
        ])
    }));
});
const $92fe91e6af513127$export$ea6aee68c7b1694f = (0, $eUqFw.forwardRef)((_ref11, __cmplr)=>{
    let { as: C = "p", style: __cmpls } = _ref11, __cmplp = (0, $bwPfh.default)(_ref11, $92fe91e6af513127$var$_excluded11);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1blv _ect4khal _1wyb1cby _vwz41slo _3p1c1qiz _py5o1r6l",
            __cmplp.className
        ])
    }));
});
const $92fe91e6af513127$var$PullQuoteSmall = (0, $eUqFw.forwardRef)((_ref12, __cmplr)=>{
    let { as: C = "p", style: __cmpls } = _ref12, __cmplp = (0, $bwPfh.default)(_ref12, $92fe91e6af513127$var$_excluded12);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1blv _ect4khal _k48powjs _1wyb1k92 _vwz41f4h _1s181k8s _17gqviql _3p1c1ryw _py5o18o1",
            __cmplp.className
        ])
    }));
});
const $92fe91e6af513127$var$PullQuoteLarge = (0, $eUqFw.forwardRef)((_ref13, __cmplr)=>{
    let { as: C = "p", style: __cmpls } = _ref13, __cmplp = (0, $bwPfh.default)(_ref13, $92fe91e6af513127$var$_excluded13);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1blv _ect4khal _k48pb4wl _1wyb1m1q _vwz48pqr _1s18viql _17gqyn4p _3p1c1knc _py5ov4nf _duivowjs",
            __cmplp.className
        ])
    }));
});
const $92fe91e6af513127$export$56ff71eb7b6bd339 = (0, $eUqFw.forwardRef)((_ref14, __cmplr)=>{
    let { as: C = "p", style: __cmpls } = _ref14, __cmplp = (0, $bwPfh.default)(_ref14, $92fe91e6af513127$var$_excluded14);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1blv _ect41sdi _1wybud5o _vwz41j6v _1s18oqnp _17gq1cby",
            __cmplp.className
        ])
    }));
});
const $92fe91e6af513127$export$71f050e2efa708bb = (_ref15)=>{
    let { size: size, children: children } = _ref15;
    switch(size){
        case 'small':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($92fe91e6af513127$export$b23b65e5c526dfb2, null, children);
        case 'medium':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($92fe91e6af513127$export$bf81649988183949, null, children);
    }
};
const $92fe91e6af513127$export$f32a6ca59ed1d5d5 = (_ref16)=>{
    let { size: size, children: children } = _ref16;
    switch(size){
        case 'small':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($92fe91e6af513127$var$PullQuoteSmall, null, children);
        case 'large':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($92fe91e6af513127$var$PullQuoteLarge, null, children);
    }
};
 /*
  Though we have started using @compiled/react, we are not using it in a perfect way.
  We are still following the styled components way of writing css that is having some limitations like:
  - component composition doesn't work
  - functions interpolation doesn't work. Explicitly declaring the rule name is required.
  Also, the recommended way of using @compiled/react is to use the css prop. But we are not using it.
  We might have to relook our way of writing css with @compiled/react in future.
  More details inside -> https://ecosystem.atlassian.net/browse/MC-4428
*/  // const BodySmallStyles = {
 //   fontSize: '0.875rem',
 //   lineHeight: '20px',
 // };
 // const Body = ({
 //   size,
 //   children,
 //   style,
 //   className,
 // }: {
 //   size: string;
 //   children: ReactNode;
 //   style?: any;
 //   className?: any;
 // }) => {
 //   switch (size) {
 //     case 'small':
 //       return (
 //         <ClassNames>
 //           {({ css }) => (
 //             <p
 //               style={style}
 //               className={ax([css(BodySmallStyles), css(charlieDisplayFontFamily), className])}
 //             >
 //               {children}
 //             </p>
 //           )}
 //         </ClassNames>
 //       );
 //     case 'medium':
 //       return <BodyMedium>{children}</BodyMedium>;
 //     case 'large':
 //       return <BodyLarge>{children}</BodyLarge>;
 //   }
 // };

});

parcelRegister("ixQHh", function(module, exports) {

$parcel$export(module.exports, "SubtleLink", () => $d8042f95a3a0adea$export$902dde2c01bb0707);
$parcel$export(module.exports, "Link", () => $d8042f95a3a0adea$export$a6c7ac8248d6e38a);
$parcel$export(module.exports, "ExternalLink", () => $d8042f95a3a0adea$export$b2bf131c9f9cce5d);
$parcel$export(module.exports, "LinkWithIcon", () => $d8042f95a3a0adea$export$e67e718b4b9e91b1);
/* Links.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $kU09D = parcelRequire("kU09D");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");


var $h5JnE = parcelRequire("h5JnE");

var $bBqrH = parcelRequire("bBqrH");

var $lMIGT = parcelRequire("lMIGT");
const $d8042f95a3a0adea$var$_excluded = [
    "as",
    "style"
], $d8042f95a3a0adea$var$_excluded2 = [
    "as",
    "style"
], $d8042f95a3a0adea$var$_excluded3 = [
    "as",
    "style"
], $d8042f95a3a0adea$var$_excluded4 = [
    "as",
    "style"
], $d8042f95a3a0adea$var$_excluded5 = [
    "as",
    "style"
], $d8042f95a3a0adea$var$_excluded6 = [
    "size",
    "type",
    "children",
    "href",
    "onClick",
    "dataTestId"
];
function $d8042f95a3a0adea$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d8042f95a3a0adea$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d8042f95a3a0adea$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d8042f95a3a0adea$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $d8042f95a3a0adea$var$getExternalLinkAttributes = (text)=>{
    const linkText = typeof text === 'string' ? "".concat(text, " ") : '';
    return {
        target: '_blank',
        rel: 'external noopener noreferrer',
        'aria-label': "".concat(linkText, "open in new window")
    };
};
const $d8042f95a3a0adea$export$902dde2c01bb0707 = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "a", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $d8042f95a3a0adea$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ect41sdi _syaz1blv _vwz4gktf _4bfu18uv _1hmsglyw _ajmmnqa1 _1bas14y2 _1ygb4suz _30l31qtk _9oik18uv _1bnxglyw _jf4cnqa1 _9h8h1vef _1nrm18uv _c2waglyw _1iohnqa1",
            __cmplp.size === 'small' ? "_1wyboxwj" : "_1wyb1j6v",
            __cmplp.size === 'small' ? "_k48p1nn1" : "_k48pni7l",
            __cmplp.className
        ])
    }));
});
const $d8042f95a3a0adea$export$a6c7ac8248d6e38a = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "a", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $d8042f95a3a0adea$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ect41sdi _syaz1qtk _vwz4gktf _1bas14y2 _1ygb4suz _9h8h1vef",
            __cmplp.size === 'small' ? "_1wyboxwj" : "_1wyb1j6v",
            __cmplp.size === 'small' ? "_k48p1nn1" : "_k48pni7l",
            __cmplp.className
        ])
    }));
});
const $d8042f95a3a0adea$var$LinkWithIconStyles = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = $d8042f95a3a0adea$export$a6c7ac8248d6e38a, style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $d8042f95a3a0adea$var$_excluded3);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1jmq18uv _apju8stv _ku3unqa1 _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    }));
});
const $d8042f95a3a0adea$export$b2bf131c9f9cce5d = (props)=>{
    const externalAttributes = $d8042f95a3a0adea$var$getExternalLinkAttributes(props['aria-label'] || props.children);
    const linkProps = $d8042f95a3a0adea$var$_objectSpread($d8042f95a3a0adea$var$_objectSpread($d8042f95a3a0adea$var$_objectSpread({}, props), externalAttributes), {}, {
        size: props.size || 'medium'
    });
    return linkProps.type === 'subtle' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d8042f95a3a0adea$export$902dde2c01bb0707, linkProps, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d8042f95a3a0adea$export$a6c7ac8248d6e38a, linkProps, props.children);
};
const $d8042f95a3a0adea$var$LinkWithIconWrapper = (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = "span", style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $d8042f95a3a0adea$var$_excluded4);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _y3gn1e5h _t4pt1hna",
            __cmplp.className
        ])
    }));
});
const $d8042f95a3a0adea$var$LastWordWithIcon = (0, $eUqFw.forwardRef)((_ref5, __cmplr)=>{
    let { as: C = "span", style: __cmpls } = _ref5, __cmplp = (0, $bwPfh.default)(_ref5, $d8042f95a3a0adea$var$_excluded5);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c _1e0c116y _4cvr1h6o",
            __cmplp.className
        ])
    }));
});
const $d8042f95a3a0adea$export$dbeaa712979697c5 = (props)=>{
    const externalAttributes = $d8042f95a3a0adea$var$getExternalLinkAttributes(props['aria-label'] || props.children);
    const linkProps = $d8042f95a3a0adea$var$_objectSpread($d8042f95a3a0adea$var$_objectSpread({}, props), externalAttributes);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d8042f95a3a0adea$export$902dde2c01bb0707, linkProps, props.children);
};
const $d8042f95a3a0adea$export$e67e718b4b9e91b1 = (_ref6)=>{
    let { size: size, type: type = 'internal', children: children, href: href, onClick: onClick, dataTestId: dataTestId } = _ref6, props = (0, $bwPfh.default)(_ref6, $d8042f95a3a0adea$var$_excluded6);
    let linkProps = $d8042f95a3a0adea$var$_objectSpread({
        href: href,
        onClick: onClick
    }, props);
    let icon;
    if (type === 'external') {
        icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h5JnE.DiagonalUpwardArrowIcon), null);
        const externalAttributes = $d8042f95a3a0adea$var$getExternalLinkAttributes(children);
        linkProps = $d8042f95a3a0adea$var$_objectSpread($d8042f95a3a0adea$var$_objectSpread({}, externalAttributes), linkProps);
    } else if (type === 'internal') icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bBqrH.RightArrowIcon), null);
    if (typeof children === 'string') {
        const words = children.split(' ');
        const lastWord = words.pop();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d8042f95a3a0adea$var$LinkWithIconStyles, (0, $kU09D.default)({
            size: size
        }, linkProps, {
            "data-testid": dataTestId || (0, $lMIGT.TEST_IDS).APP_LINK_WITH_ICON
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d8042f95a3a0adea$var$LinkWithIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: "linkText"
        }, words.join(' ')), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d8042f95a3a0adea$var$LastWordWithIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: "linkText"
        }, lastWord), icon)));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d8042f95a3a0adea$var$LinkWithIconStyles, (0, $kU09D.default)({
        size: size
    }, linkProps, {
        "data-testid": (0, $lMIGT.TEST_IDS).APP_LINK_WITH_ICON
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: "linkText"
    }, children), icon);
};

});
parcelRegister("h5JnE", function(module, exports) {

$parcel$export(module.exports, "DiagonalUpwardArrowIcon", () => $c7161aef6d89c8e1$export$de97d9835adee853);

var $eUqFw = parcelRequire("eUqFw");
const $c7161aef6d89c8e1$export$de97d9835adee853 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.51111 6V8.55066H13.6467L6.37368 15.8217C5.87544 16.32 5.87544 17.1277 6.37368 17.6259C6.62366 17.8742 6.94845 18 7.27665 18C7.60315 18 7.92794 17.8742 8.17791 17.6259L15.4493 10.3548V14.4886H18V6H9.51111Z",
        fill: "currentColor"
    }));
};

});

parcelRegister("bBqrH", function(module, exports) {

$parcel$export(module.exports, "RightArrowIcon", () => $8727a9ffd5a6c357$export$fec93b5f1e2bccb4);

var $eUqFw = parcelRequire("eUqFw");
const $8727a9ffd5a6c357$export$fec93b5f1e2bccb4 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.6018 6L13.1295 7.80314L15.5162 10.7245H5.5407C4.96623 10.7245 4.5 11.2956 4.5 11.9992C4.5 12.7027 4.96623 13.2738 5.5407 13.2738H15.5162L13.1295 16.1969L14.6018 18L19.5 11.9992L14.6018 6Z",
        fill: "currentColor"
    }));
};

});

parcelRegister("lMIGT", function(module, exports) {

$parcel$export(module.exports, "TEST_IDS", () => $fdc0bf52b05494d5$export$a2b4f255152a6585);
const $fdc0bf52b05494d5$export$a2b4f255152a6585 = {
    APP_GO_BACK_LINK: 'app-go-back-link',
    APP_SUPPORT_LINK: 'app-support-link',
    APP_STATUS_LINK: 'app-status-link',
    APP_LINK_WITH_ICON: 'app-link-with-icon',
    FACET_DROPDOWN_TRIGGERS: 'facet-dropdown--trigger'
};

});




parcelRegister("3ogmU", function(module, exports) {

$parcel$export(module.exports, "default", () => $27804f69534737fb$export$2e2bcd8739ae039);
/* CloudFortifiedAppTooltipV2.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $kU09D = parcelRequire("kU09D");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $cCrLo = parcelRequire("cCrLo");
var $ixQHh = parcelRequire("ixQHh");

var $7BUhe = parcelRequire("7BUhe");

var $e8A8d = parcelRequire("e8A8d");

var $kNAhC = parcelRequire("kNAhC");

var $f9qVk = parcelRequire("f9qVk");
const $27804f69534737fb$var$_excluded = [
    "as",
    "style"
], $27804f69534737fb$var$_excluded2 = [
    "as",
    "style"
], $27804f69534737fb$var$_excluded3 = [
    "as",
    "style"
], $27804f69534737fb$var$_excluded4 = [
    "as",
    "style"
], $27804f69534737fb$var$_excluded5 = [
    "as",
    "style"
];
const $27804f69534737fb$var$Container = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $27804f69534737fb$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1tad",
            __cmplp.className
        ])
    }));
});
const $27804f69534737fb$var$BoldText = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodySmall), style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $27804f69534737fb$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1nu9 _k48pni7l",
            __cmplp.className
        ])
    }));
});
const $27804f69534737fb$var$DetailsContainer = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $27804f69534737fb$var$_excluded3);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkxjmg _otyrxjmg _1e0c1txw _2lx21bp4 _1p571eps",
            __cmplp.className
        ])
    }));
});
const $27804f69534737fb$var$DetailsRow = (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $27804f69534737fb$var$_excluded4);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    }));
});
const $27804f69534737fb$var$DetailsText = (0, $eUqFw.forwardRef)((_ref5, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodySmall), style: __cmpls } = _ref5, __cmplp = (0, $bwPfh.default)(_ref5, $27804f69534737fb$var$_excluded5);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _18u01eps",
            __cmplp.className
        ])
    }));
});
const $27804f69534737fb$var$CloudFortifiedAppTooltipV2 = (_ref6)=>{
    let { onViewDetailsClick: onViewDetailsClick, faqPageLink: faqPageLink } = _ref6;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($27804f69534737fb$var$Container, {
        "data-testid": (0, $7BUhe.TEST_IDS).CLOUD_FORTIFIED_TOOLTIP_V2
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cCrLo.BodySmall), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($27804f69534737fb$var$BoldText, null, "Cloud Fortified"), " apps offer additional security, reliability, and support through:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($27804f69534737fb$var$DetailsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($27804f69534737fb$var$DetailsRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f9qVk.default), {
        label: "Cloud Security Participant Badge",
        size: "medium",
        primaryColor: "var(--ds-icon)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($27804f69534737fb$var$DetailsText, null, "Cloud security participation")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($27804f69534737fb$var$DetailsRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e8A8d.default), {
        label: "Cloud Fortified Reliability badge"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($27804f69534737fb$var$DetailsText, null, "Timely reliability checks")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($27804f69534737fb$var$DetailsRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kNAhC.default), {
        label: "Cloud Fortified Support badge"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($27804f69534737fb$var$DetailsText, null, "24hr support response time and more"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ixQHh.LinkWithIcon), {
        type: "external",
        size: "small",
        href: faqPageLink,
        onClick: onViewDetailsClick
    }, "More details"));
};
var $27804f69534737fb$export$2e2bcd8739ae039 = $27804f69534737fb$var$CloudFortifiedAppTooltipV2;

});


parcelRegister("8xfj9", function(module, exports) {

$parcel$export(module.exports, "resolvePartnerTier", () => $636d47a2eec1a784$export$5a849d5aaf447b77);
$parcel$export(module.exports, "default", () => $636d47a2eec1a784$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $9l6Pq = parcelRequire("9l6Pq");

var $ammkg = parcelRequire("ammkg");

var $eUqFw = parcelRequire("eUqFw");

var $cmZSX = parcelRequire("cmZSX");

var $4lmb9 = parcelRequire("4lmb9");

var $l501X = parcelRequire("l501X");

var $7BUhe = parcelRequire("7BUhe");

var $jdjb1 = parcelRequire("jdjb1");

var $fI3dH = parcelRequire("fI3dH");

var $aqC9O = parcelRequire("aqC9O");

var $4Ekia = parcelRequire("4Ekia");
function $636d47a2eec1a784$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $636d47a2eec1a784$export$a33d9f95d57cad28 = 'partnerName';
const $636d47a2eec1a784$export$bbc7eef4cce3da2c = 'https://developer.atlassian.com/platform/marketplace/marketplace-partner-program/';
const $636d47a2eec1a784$export$878bbd785b35ed1e = 'https://developer.atlassian.com/platform/marketplace/marketplace-security-bug-bounty-program/';
const $636d47a2eec1a784$export$32d72254fe4d6919 = (0, $3UXZ8.default)("div", {
    target: "emh330k0",
    label: "PartnerDetailsContainer"
})((props)=>({
        color: props.showAetherAppListingPage ? "var(--ds-text-subtle)" : "var(--ds-text, ".concat((0, $j0gMm.N300), ")"),
        display: 'flex',
        lineHeight: '1.5rem'
    }), "");
const $636d47a2eec1a784$export$33463a3675a65980 = (0, $3UXZ8.default)("div", {
    target: "emh330k1",
    label: "PartnerTierDescription"
})({
    name: "1v5z18m",
    styles: "width:300px;"
});
const $636d47a2eec1a784$export$7e3913cd0c2fa379 = (0, $3UXZ8.default)("img", {
    target: "emh330k2",
    label: "PartnerBadgeWrapper"
})({
    name: "1y2hais",
    styles: "padding-left:5px;vertical-align:middle;"
});
const $636d47a2eec1a784$export$3463702bb58e307a = (0, $3UXZ8.default)("span", {
    target: "emh330k3",
    label: "PartnerNameContainer"
})((0, $jdjb1.ellipsis), (props)=>({
        fontWeight: props.showAetherAppListingPage ? 600 : 400,
        a: {
            '&:hover, &:focus': {
                textDecoration: 'underline'
            }
        }
    }), "");
const $636d47a2eec1a784$var$PartnerTiers = {
    goldMarketplacePartner: {
        label: (0, $ammkg.MarketplacePartnerTierType).Gold,
        badge: (0, (/*@__PURE__*/$parcel$interopDefault($fI3dH)))
    },
    platinumMarketplacePartner: {
        label: (0, $ammkg.MarketplacePartnerTierType).Platinum,
        badge: (0, (/*@__PURE__*/$parcel$interopDefault($aqC9O)))
    },
    silverMarketplacePartner: {
        label: (0, $ammkg.MarketplacePartnerTierType).Silver,
        badge: (0, (/*@__PURE__*/$parcel$interopDefault($4Ekia)))
    }
};
const $636d47a2eec1a784$export$5a849d5aaf447b77 = (partnerTier)=>{
    switch(partnerTier){
        case 'SILVER':
            return $636d47a2eec1a784$var$PartnerTiers.silverMarketplacePartner;
        case 'GOLD':
            return $636d47a2eec1a784$var$PartnerTiers.goldMarketplacePartner;
        case 'PLATINUM':
            return $636d47a2eec1a784$var$PartnerTiers.platinumMarketplacePartner;
        default:
            return null;
    }
};
const $636d47a2eec1a784$export$abec1d4f7cef555e = (partnerTier)=>{
    const { showUpdatedPartnerTierMessage: showUpdatedPartnerTierMessage } = (0, $9l6Pq.useStatsig)();
    const partnerTierType = $636d47a2eec1a784$export$5a849d5aaf447b77(partnerTier);
    if (!partnerTierType) return null;
    const type = partnerTierType.label.toString().charAt(0) + partnerTierType.label.toString().slice(1).toLowerCase();
    const shouldShowUpdatedPartnerTierMessage = showUpdatedPartnerTierMessage();
    const DESCRIPTION = shouldShowUpdatedPartnerTierMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, "This ", type, " Marketplace partner participates in Atlassian's", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l501X.default), {
        href: $636d47a2eec1a784$export$878bbd785b35ed1e
    }, "Marketplace Security Bug Bounty Program"), ", and invests in Cloud and Data Center versions of their most popular server apps.") : "".concat(type, " Marketplace Partners have met enhanced Atlassian requirements by investing in areas such as creating Cloud and Data Center app versions for their popular server apps and participating in Marketplace security programs, among others.");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4lmb9.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($636d47a2eec1a784$export$33463a3675a65980, null, DESCRIPTION, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l501X.default), {
            href: $636d47a2eec1a784$export$bbc7eef4cce3da2c
        }, shouldShowUpdatedPartnerTierMessage ? 'About Marketplace partner program' : 'Learn more about Marketplace partner program'))),
        disableBlurEvent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($636d47a2eec1a784$export$7e3913cd0c2fa379, {
        alt: "".concat(type, " Marketplace Partner"),
        src: partnerTierType.badge
    }));
};
const $636d47a2eec1a784$var$HeaderPartnerDetails = (props)=>{
    const { name: name, link: link, pathname: pathname, partnerTierType: partnerTierType, showAetherAppListingPage: showAetherAppListingPage } = props;
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const onNameClick = (e)=>{
        fireAnalyticsEvent({
            eventType: (0, $gaiog.ButtonClickedEvent),
            actionSubjectId: $636d47a2eec1a784$export$a33d9f95d57cad28
        });
        e === null || e === void 0 || e.stopPropagation();
    };
    if (!name) return null;
    if (!link && !pathname) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($636d47a2eec1a784$export$32d72254fe4d6919, {
        showAetherAppListingPage: showAetherAppListingPage,
        "data-testid": (0, $7BUhe.TEST_IDS).PARTNER_DETAILS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, "by\xA0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($636d47a2eec1a784$export$3463702bb58e307a, {
        showAetherAppListingPage: showAetherAppListingPage
    }, name), partnerTierType && $636d47a2eec1a784$export$abec1d4f7cef555e(partnerTierType));
    if (link) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($636d47a2eec1a784$export$32d72254fe4d6919, {
        showAetherAppListingPage: showAetherAppListingPage,
        "data-testid": (0, $7BUhe.TEST_IDS).PARTNER_DETAILS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, "by\xA0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($636d47a2eec1a784$export$3463702bb58e307a, {
        showAetherAppListingPage: showAetherAppListingPage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l501X.default), {
        href: link,
        onClick: onNameClick
    }, name)), partnerTierType && $636d47a2eec1a784$export$abec1d4f7cef555e(partnerTierType));
    let path = '';
    if (pathname) path = pathname;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($636d47a2eec1a784$export$32d72254fe4d6919, {
        showAetherAppListingPage: showAetherAppListingPage,
        "data-testid": (0, $7BUhe.TEST_IDS).PARTNER_DETAILS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, "by\xA0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($636d47a2eec1a784$export$3463702bb58e307a, {
        showAetherAppListingPage: showAetherAppListingPage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cmZSX.default), {
        to: path,
        onClick: onNameClick
    }, name)), partnerTierType && $636d47a2eec1a784$export$abec1d4f7cef555e(partnerTierType));
};
var $636d47a2eec1a784$export$2e2bcd8739ae039 = $636d47a2eec1a784$var$HeaderPartnerDetails;

});
parcelRegister("cmZSX", function(module, exports) {

$parcel$export(module.exports, "default", () => $90178b3d4e48f04f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $h8TzT = parcelRequire("h8TzT");

var $gSncF = parcelRequire("gSncF");
var $90178b3d4e48f04f$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $90178b3d4e48f04f$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $90178b3d4e48f04f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $90178b3d4e48f04f$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $90178b3d4e48f04f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $90178b3d4e48f04f$var$isModifiedEvent = function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};
/**
 * The public API for rendering a history-aware <a>.
 */ var $90178b3d4e48f04f$var$Link = function(_React$Component) {
    $90178b3d4e48f04f$var$_inherits(Link, _React$Component);
    function Link() {
        var _temp, _this, _ret;
        $90178b3d4e48f04f$var$_classCallCheck(this, Link);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $90178b3d4e48f04f$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.handleClick = function(event) {
            if (_this.props.onClick) _this.props.onClick(event);
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && // ignore everything but left clicks
            !_this.props.target && // let browser handle "target=_blank" etc.
            !$90178b3d4e48f04f$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                var history = _this.context.router.history;
                var _this$props = _this.props, replace = _this$props.replace, to = _this$props.to;
                if (replace) history.replace(to);
                else history.push(to);
            }
        }, _temp), $90178b3d4e48f04f$var$_possibleConstructorReturn(_this, _ret);
    }
    Link.prototype.render = function render() {
        var _props = this.props, replace = _props.replace, to = _props.to, innerRef = _props.innerRef, props = $90178b3d4e48f04f$var$_objectWithoutProperties(_props, [
            "replace",
            "to",
            "innerRef"
        ]); // eslint-disable-line no-unused-vars
        (0, (/*@__PURE__*/$parcel$interopDefault($h8TzT)))(this.context.router, "You should not use <Link> outside a <Router>");
        (0, (/*@__PURE__*/$parcel$interopDefault($h8TzT)))(to !== undefined, 'You must specify the "to" property');
        var history = this.context.router.history;
        var location = typeof to === "string" ? (0, $gSncF.createLocation)(to, null, null, history.location) : to;
        var href = history.createHref(location);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", $90178b3d4e48f04f$var$_extends({}, props, {
            onClick: this.handleClick,
            href: href,
            ref: innerRef
        }));
    };
    return Link;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component);
$90178b3d4e48f04f$var$Link.propTypes = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    target: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
    ]).isRequired,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
    ])
};
$90178b3d4e48f04f$var$Link.defaultProps = {
    replace: false
};
$90178b3d4e48f04f$var$Link.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).shape({
        history: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).shape({
            push: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
            replace: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
            createHref: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired
        }).isRequired
    }).isRequired
};
var $90178b3d4e48f04f$export$2e2bcd8739ae039 = $90178b3d4e48f04f$var$Link;

});

parcelRegister("l501X", function(module, exports) {

$parcel$export(module.exports, "default", () => $f58a16ade376eabb$export$2e2bcd8739ae039);

var $gykb8 = parcelRequire("gykb8");

var $eUqFw = parcelRequire("eUqFw");
const $f58a16ade376eabb$var$ExternalLink = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gykb8.default), {
        className: props.className,
        href: props.href,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: props.onClick,
        title: props.title,
        "data-testid": props['data-testid']
    }, props.children);
var $f58a16ade376eabb$export$2e2bcd8739ae039 = $f58a16ade376eabb$var$ExternalLink;

});

parcelRegister("jdjb1", function(module, exports) {

$parcel$export(module.exports, "multilineEllipsis", () => $dfce1b59b04c2ad5$export$139cbccd083cc2ff);
$parcel$export(module.exports, "ellipsis", () => $dfce1b59b04c2ad5$export$a5b94313d6908893);

var $ivTMz = parcelRequire("ivTMz");

var $ibjku = parcelRequire("ibjku");
function $dfce1b59b04c2ad5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dfce1b59b04c2ad5$export$3f4d05b455b17f33 = ()=>"Charlie Display', ".concat((0, $ivTMz.fontFamily)());
const $dfce1b59b04c2ad5$export$139cbccd083cc2ff = (noOfLines, fallbackMaxHeight)=>/*#__PURE__*/ (0, $ibjku.css)("display:-webkit-box;-webkit-line-clamp:", noOfLines, ";overflow:hidden;-webkit-box-orient:vertical;max-height:", fallbackMaxHeight, ";");
const $dfce1b59b04c2ad5$export$a5b94313d6908893 = {
    name: "irnju7-ellipsis",
    styles: "text-overflow:ellipsis;white-space:nowrap;overflow:hidden;;label:ellipsis;"
};
const $dfce1b59b04c2ad5$export$79a2fb060a0872a6 = {
    'text-overflow': 'ellipsis',
    'white-space': 'nowrap',
    overflow: 'hidden'
};

});

parcelRegister("fI3dH", function(module, exports) {
module.exports = new URL("GoldMiniPartnerBadge.static.5f3b45ae.svg", import.meta.url).toString();

});

parcelRegister("aqC9O", function(module, exports) {
module.exports = new URL("PlatinumMiniPartnerBadge.static.37515d24.svg", import.meta.url).toString();

});

parcelRegister("4Ekia", function(module, exports) {
module.exports = new URL("SilverMiniPartnerBadge.static.873be33b.svg", import.meta.url).toString();

});


parcelRegister("76fzC", function(module, exports) {

$parcel$export(module.exports, "formatDayOfWeek", () => $52b52c7fd4cb6b92$export$f484d8a20c1ae790);
$parcel$export(module.exports, "toWeekdayRanges", () => $52b52c7fd4cb6b92$export$1cc0e6cb49769df6);
$parcel$export(module.exports, "to12HourFormat", () => $52b52c7fd4cb6b92$export$a8078872fdc7223f);
$parcel$export(module.exports, "longDate", () => $52b52c7fd4cb6b92$export$73df931598513ca3);
$parcel$export(module.exports, "subtractDateByDays", () => $52b52c7fd4cb6b92$export$e30f1a20d59dd134);
$parcel$export(module.exports, "isFutureDate", () => $52b52c7fd4cb6b92$export$3c3ec13c4ecfb550);
$parcel$export(module.exports, "ISOFormatHyphenatedDate", () => $52b52c7fd4cb6b92$export$ffdb6493ffaf1eaa);
$parcel$export(module.exports, "differenceInDaysToNow", () => $52b52c7fd4cb6b92$export$c1d4577b61060cb1);
$parcel$export(module.exports, "weekdayToISODayNumber", () => $52b52c7fd4cb6b92$export$1721a40b71c1546e);
$parcel$export(module.exports, "getUtcTime", () => $52b52c7fd4cb6b92$export$ce02ba817385328);
$parcel$export(module.exports, "getUtcLongDate", () => $52b52c7fd4cb6b92$export$9a1b4f0fb6d8f159);
$parcel$export(module.exports, "getDay", () => $52b52c7fd4cb6b92$export$1b64bc9c5306ed54);
$parcel$export(module.exports, "differenceInDaysOrMonths", () => $52b52c7fd4cb6b92$export$6ce82cc6568079c);
$parcel$export(module.exports, "parseDateString", () => $52b52c7fd4cb6b92$export$e684af8cfb294f41);
$parcel$export(module.exports, "calculateDateRange", () => $52b52c7fd4cb6b92$export$c0560fec2aaf785f);
$parcel$export(module.exports, "formatDate", () => $52b52c7fd4cb6b92$export$3ae94a2503e890a1);
$parcel$export(module.exports, "formatDateObject", () => $52b52c7fd4cb6b92$export$f51d97cc5465fda6);
$parcel$export(module.exports, "dateToISODayNumber", () => $52b52c7fd4cb6b92$export$4f59265c40720700);

var $d2wNG = parcelRequire("d2wNG");
var $1raUW = parcelRequire("1raUW");
var $EN9B6 = parcelRequire("EN9B6");
var $dpnxM = parcelRequire("dpnxM");
var $7ueqz = parcelRequire("7ueqz");
var $5YjhU = parcelRequire("5YjhU");
var $2u0SN = parcelRequire("2u0SN");
var $fiOXn = parcelRequire("fiOXn");

var $bTrQR = parcelRequire("bTrQR");
const $52b52c7fd4cb6b92$export$f484d8a20c1ae790 = (day, short)=>(0, $EN9B6.default)((0, $2u0SN.default)(new Date(), day), short ? 'iii' : 'iiii');
const $52b52c7fd4cb6b92$export$1cc0e6cb49769df6 = (days, options)=>{
    const orderedDays = [
        ...days
    ].sort(); // sort() mutates the array, hence making a copy
    const { shortDaysOfWeek: shortDaysOfWeek = true } = options || {};
    const ranges = [
        []
    ];
    let currentRange = 0;
    /* This loop puts the days into ranges, example:
    days: [2,3,5,6]
    ranges: [[2,3],[5,6]]
  */ for(let i = 0; i < orderedDays.length; i += 1){
        ranges[currentRange].push(orderedDays[i]);
        if (orderedDays[i + 1] !== orderedDays[i] + 1 && i !== orderedDays.length - 1) {
            currentRange += 1;
            ranges[currentRange] = [];
        }
    }
    // flatten ranges of the day "orders" back into day name ranges
    // ranges: [[2,3],[5,6]]
    // result: ["Tue-Wed","Fri-Sat"]
    return ranges.map((range)=>{
        const startDay = $52b52c7fd4cb6b92$export$f484d8a20c1ae790(range[0], shortDaysOfWeek);
        const endDay = $52b52c7fd4cb6b92$export$f484d8a20c1ae790(range[range.length - 1], shortDaysOfWeek);
        return startDay === endDay ? startDay : [
            startDay,
            endDay
        ].join('-');
    });
};
const $52b52c7fd4cb6b92$export$a8078872fdc7223f = (time)=>{
    const date = (0, $5YjhU.default)(time, 'HH:mm', new Date());
    return (0, $EN9B6.default)(date, 'h:mm aa');
};
const $52b52c7fd4cb6b92$export$73df931598513ca3 = (date, formatString)=>(0, $EN9B6.default)(new Date(date), formatString || 'MMM do yyyy');
const $52b52c7fd4cb6b92$export$e30f1a20d59dd134 = (date, days)=>(0, $fiOXn.default)(new Date(date), {
        days: days
    });
const $52b52c7fd4cb6b92$export$3c3ec13c4ecfb550 = (date)=>(0, $dpnxM.default)(date);
const $52b52c7fd4cb6b92$export$ffdb6493ffaf1eaa = (date)=>(0, $EN9B6.default)(new Date(date), 'yyyy-MM-dd');
const $52b52c7fd4cb6b92$export$c1d4577b61060cb1 = (date)=>(0, $d2wNG.default)(date, Date.now());
const $52b52c7fd4cb6b92$export$1721a40b71c1546e = (day)=>{
    const days = [
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
        'sunday'
    ];
    return days.findIndex((dayName)=>dayName === day.toLocaleLowerCase()) + 1;
};
function $52b52c7fd4cb6b92$export$ce02ba817385328(unixTime) {
    const date = new Date(unixTime);
    const hours = date.getUTCHours();
    const hour = (hours % 12).toString().padStart(2, '0');
    const meridiem = hours < 12 ? 'a.m.' : 'p.m.';
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');
    return "".concat(hour, ":").concat(minutes, " ").concat(meridiem);
}
function $52b52c7fd4cb6b92$export$9a1b4f0fb6d8f159(unixTime) {
    const date = new Date(unixTime);
    const day = date.getUTCDate();
    const month = date.toLocaleString('en-US', {
        month: 'long'
    });
    const year = date.getUTCFullYear();
    return "".concat(month, " ").concat(day, ", ").concat(year);
}
function $52b52c7fd4cb6b92$export$1b64bc9c5306ed54(unixTime) {
    const date = new Date(unixTime);
    const dayIndex = date.getDay();
    const days = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ];
    // Get the day name using the day index
    const dayName = days[dayIndex];
    return dayName;
}
function $52b52c7fd4cb6b92$export$6ce82cc6568079c(endDate, startDate) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        pluralizeUnits: true,
        countUnitSeparator: ' '
    };
    const monthsDiff = (0, $1raUW.default)(endDate, startDate);
    const daysDiff = (0, $d2wNG.default)(endDate, startDate);
    const pluralize = (unit, count)=>count > 1 ? unit + 's' : unit;
    if (monthsDiff > 0) return "".concat(monthsDiff).concat(options.countUnitSeparator).concat(options.pluralizeUnits ? pluralize('month', monthsDiff) : 'month');
    else return "".concat(daysDiff).concat(options.countUnitSeparator).concat(options.pluralizeUnits ? pluralize('day', daysDiff) : 'day');
}
const $52b52c7fd4cb6b92$export$e684af8cfb294f41 = function parseDateString(dateString) {
    let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'marketplace';
    const date = (0, $5YjhU.default)(dateString, 'yyyy-MM-dd', new Date());
    if (!(0, $7ueqz.default)(date)) {
        (0, $bTrQR.default).error(context, 'Error in creating Date object');
        return new Date();
    }
    return date;
};
const $52b52c7fd4cb6b92$export$c0560fec2aaf785f = (daysAgo)=>{
    const dateNow = Date.now();
    return {
        startDate: $52b52c7fd4cb6b92$export$ffdb6493ffaf1eaa($52b52c7fd4cb6b92$export$e30f1a20d59dd134(dateNow, daysAgo)),
        endDate: $52b52c7fd4cb6b92$export$ffdb6493ffaf1eaa($52b52c7fd4cb6b92$export$e30f1a20d59dd134(dateNow, 1))
    };
};
const $52b52c7fd4cb6b92$export$3ae94a2503e890a1 = function formatDate(dateString, formatString) {
    let context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'marketplace';
    const date = Date.parse(dateString);
    if (!Number.isNaN(date)) {
        const dateObject = $52b52c7fd4cb6b92$export$e684af8cfb294f41(dateString, context);
        return (0, $EN9B6.default)(dateObject, formatString);
    } else return dateString;
};
const $52b52c7fd4cb6b92$export$f51d97cc5465fda6 = (date, formatString)=>{
    return (0, $EN9B6.default)(date, formatString);
};
const $52b52c7fd4cb6b92$export$4f59265c40720700 = (date)=>{
    const days = [
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
        'sunday'
    ];
    const dayName = (0, $EN9B6.default)(date, 'iiii').toLowerCase();
    return days.findIndex((day)=>day === dayName) + 1;
};

});

parcelRegister("8wSvA", function(module, exports) {

$parcel$export(module.exports, "createHighlights", () => $635b9828183a846c$export$be36e179709c50d0);
function $635b9828183a846c$export$be36e179709c50d0(hit, fieldName, tokensFieldName) {
    const tokensHighlights = hit.getIn([
        '_highlightResult',
        tokensFieldName
    ]);
    return tokensHighlights ? tokensHighlights.filter((h)=>h.get('matchLevel') !== 'none').map((h)=>h.get('value')).push(hit.getIn([
        '_highlightResult',
        fieldName,
        'value'
    ])).join(' ') : hit.getIn([
        '_highlightResult',
        fieldName,
        'value'
    ]);
}

});

parcelRegister("23J4Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $17fed46c6f140672$export$2e2bcd8739ae039);

var $1qPAw = parcelRequire("1qPAw");
var $17fed46c6f140672$export$2e2bcd8739ae039 = (0, $1qPAw.default);

});
parcelRegister("1qPAw", function(module, exports) {

$parcel$export(module.exports, "default", () => $10b03c7a78b09173$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $jdjb1 = parcelRequire("jdjb1");

var $fEeDC = parcelRequire("fEeDC");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $6jEcw = parcelRequire("6jEcw");

var $b8jn7 = parcelRequire("b8jn7");
const $10b03c7a78b09173$var$CategoriesStyled = (0, $3UXZ8.default)("div", {
    target: "eb1o6oq0",
    label: "CategoriesStyled"
})((0, $jdjb1.ellipsis), " height:18px;font-size:12px;color:", "var(--ds-text-subtlest, ".concat((0, $j0gMm.N100), ")"), ";");
class $10b03c7a78b09173$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($10b03c7a78b09173$var$CategoriesStyled, null, this.props.categories.map((category, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                key: i
            }, i > 0 ? ', ' : '', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b8jn7.default), {
                name: category,
                onClick: this.props.onCategoryClick,
                perspective: this.props.perspective
            }))));
    }
}
(0, $5zQU9.default)($10b03c7a78b09173$export$2e2bcd8739ae039, "propTypes", {
    categories: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).list.isRequired,
    onCategoryClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    perspective: (0, $6jEcw.default).perspective
});

});
parcelRegister("b8jn7", function(module, exports) {

$parcel$export(module.exports, "default", () => $81af77ec8b70d2e4$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");
parcelRequire("ibjku");

var $g5DHJ = parcelRequire("g5DHJ");

var $eUqFw = parcelRequire("eUqFw");

var $5YKni = parcelRequire("5YKni");

var $fCICH = parcelRequire("fCICH");
function $81af77ec8b70d2e4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $81af77ec8b70d2e4$var$_ref = {
    name: "da5mst-CategoryStyled",
    styles: "&:hover{text-decoration:underline;};label:CategoryStyled;"
};
const $81af77ec8b70d2e4$var$CategoryStyled = (0, $3UXZ8.default)("span", {
    target: "e4f8r6y0",
    label: "CategoryStyled"
})("font-size:12px;list-style:none;", (props)=>props.clickable ? $81af77ec8b70d2e4$var$_ref : '', "");
class $81af77ec8b70d2e4$var$Category extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "onClick", (e)=>{
            if (this.props.onClick) {
                e.preventDefault();
                e.stopPropagation();
                this.props.onClick({
                    newFilters: (0, $g5DHJ.Map)({
                        [(0, $fCICH.getFilters)().get('category').get('key')]: this.props.name
                    })
                });
                this.props.fireAnalyticsEvent({
                    eventType: (0, $gaiog.FilterClickedEvent),
                    actionSubjectId: (0, $5YKni.ANALYTICS_SUBJECT_ID_TILE_CATEGORY_FILTER),
                    objectType: (0, $5YKni.OBJECT_TYPE_FILTER),
                    objectId: (0, $fCICH.getFilters)().get('category').get('key'),
                    source: (0, $5YKni.EVENT_SOURCE),
                    attributes: {
                        currentPerspective: this.props.perspective,
                        filterValue: this.props.name,
                        selected: true
                    }
                }, (0, $5YKni.EVENT_CHANNEL));
            }
        });
    }
    render() {
        return(/*#__PURE__*/ // eslint-disable-next-line styled-components-a11y/click-events-have-key-events, styled-components-a11y/no-static-element-interactions
        (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($81af77ec8b70d2e4$var$CategoryStyled, {
            clickable: !!this.props.onClick,
            onClick: this.onClick
        }, this.props.name));
    }
}
var $81af77ec8b70d2e4$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($81af77ec8b70d2e4$var$Category);

});



parcelRegister("2AdLY", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e19a08f31c2c8e3$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $gykb8 = parcelRequire("gykb8");

var $9osuT = parcelRequire("9osuT");

var $9rIMC = parcelRequire("9rIMC");

var $hjlb6 = parcelRequire("hjlb6");

var $eUqFw = parcelRequire("eUqFw");

var $5YKni = parcelRequire("5YKni");
function $1e19a08f31c2c8e3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1e19a08f31c2c8e3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1e19a08f31c2c8e3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1e19a08f31c2c8e3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1e19a08f31c2c8e3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1e19a08f31c2c8e3$var$isLeftClick = (event)=>event.button === 0;
const $1e19a08f31c2c8e3$export$29c0e362412a40fd = /*#__PURE__*/ (0, $3UXZ8.default)((0, $gykb8.default), {
    target: "envz1090",
    label: "HitLinkStyled"
})({
    name: "1iwiupw",
    styles: "color:inherit;&:hover,&:active,&:focus{text-decoration:none;}"
});
class $1e19a08f31c2c8e3$var$HitLink extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "onClick", (event)=>{
            var _this$props$filters;
            const ecosystemCloudAppData = this.props.hit.version.get('cloud');
            const ecosystemCloudAppId = ecosystemCloudAppData === null || ecosystemCloudAppData === void 0 ? void 0 : ecosystemCloudAppData.get('cloudAppId');
            const productKeys = this.props.hit.getIn([
                'version',
                'compatibilities'
            ]).map((a)=>a.get('applicationName'));
            this.props.fireAnalyticsEvent({
                eventType: (0, $5YKni.TileClickedEvent),
                actionSubjectId: $1e19a08f31c2c8e3$var$isLeftClick(event) ? (0, $5YKni.ANALYTICS_SUBJECT_ID_HIT) : (0, $5YKni.ANALYTICS_SUBJECT_ID_RIGHT_CLICK_HIT),
                objectType: (0, $5YKni.OBJECT_TYPE_APP),
                objectId: this.props.hit.get('addonKey'),
                source: this.props.perspective,
                attributes: $1e19a08f31c2c8e3$var$_objectSpread($1e19a08f31c2c8e3$var$_objectSpread({
                    currentPerspective: this.props.perspective,
                    hitGroup: this.props.hitContext.get('hitGroup')
                }, ecosystemCloudAppId && {
                    isEcosystemCloudApp: true,
                    ecosystemCloudAppId: ecosystemCloudAppId
                }), {}, {
                    isPaidApp: this.props.hit.getIn([
                        'version',
                        'paid'
                    ]),
                    productKeys: productKeys === null || productKeys === void 0 ? void 0 : productKeys.toJS(),
                    filters: (_this$props$filters = this.props.filters) === null || _this$props$filters === void 0 ? void 0 : _this$props$filters.toJS(),
                    sectionTitle: this.props.sectionTitle
                })
            }, (0, $5YKni.EVENT_CHANNEL));
            if ($1e19a08f31c2c8e3$var$isLeftClick(event)) (0, $9rIMC).maybeOpenInNewTab(event, ()=>{
                this.props.hitContext.get('onHitClick')({
                    hit: this.props.hit
                }, event);
            });
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1e19a08f31c2c8e3$export$29c0e362412a40fd, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))(this.props.extraClasses, this.props.className),
            href: this.props.hitContext.get('hitHrefResolver')({
                hit: this.props.hit
            }),
            onClick: this.onClick,
            onContextMenu: this.onClick
        }, this.props.children);
    }
}
var $1e19a08f31c2c8e3$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($1e19a08f31c2c8e3$var$HitLink);

});

parcelRegister("kXHwt", function(module, exports) {

$parcel$export(module.exports, "default", () => $f42b14121d8411ab$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $62cXe = parcelRequire("62cXe");

var $j0gMm = parcelRequire("j0gMm");

var $8gcXz = parcelRequire("8gcXz");

var $3BBSQ = parcelRequire("3BBSQ");
var $8U0Ec = parcelRequire("8U0Ec");
var $jC9Rj = parcelRequire("jC9Rj");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $90ON9 = parcelRequire("90ON9");

var $8wSvA = parcelRequire("8wSvA");

var $k5pOx = parcelRequire("k5pOx");
function $f42b14121d8411ab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f42b14121d8411ab$export$e6ff31bff12b7ff4 = (0, $3UXZ8.default)("div", {
    target: "e1fkgwv50",
    label: "Logo"
})({
    name: "4dguu7",
    styles: "display:flex;flex-direction:row;justify-content:start;position:relative;width:72px;height:72px;border-radius:var(--ds-border-radius-100, 3px);overflow:hidden;&:hover{cursor:pointer;}"
});
const $f42b14121d8411ab$export$3f3deff8b74a6b4f = (0, $3UXZ8.default)("div", {
    target: "e1fkgwv51",
    label: "HitHeadingStyled"
})({
    name: "j7qwjs",
    styles: "display:flex;flex-direction:column;"
});
const $f42b14121d8411ab$export$ef41ebc44b9c1fe4 = (0, $3UXZ8.default)("img", {
    target: "e1fkgwv52",
    label: "LogoImage"
})("width:100%;height:100%;color:", (0, $j0gMm.N500), ";");
const $f42b14121d8411ab$export$4836b6f4d0c0d87f = (0, $3UXZ8.default)("div", {
    target: "e1fkgwv53",
    label: "TopVendorContainer"
})({
    name: "949zxw",
    styles: "right:var(--ds-space-150, 12px);top:-0.75rem;position:relative;width:0;"
});
const $f42b14121d8411ab$export$a7235ebc5e93af41 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $jC9Rj.default), {
    target: "e1fkgwv54",
    label: "TopVendorBadgeStyled"
})({
    name: "1tueaee",
    styles: "z-index:10;width:24px;height:24px;"
});
const $f42b14121d8411ab$export$eda0685f2d9ca1b9 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $8gcXz.H3), {
    target: "e1fkgwv55",
    label: "NameHeader"
})((props)=>props.mixin(), ";color:", "var(--ds-text, ".concat((0, $j0gMm.N800), ")"), ";font-weight:600;overflow:hidden;text-overflow:ellipsis;margin:var(--ds-space-200, 16px) 0 var(--ds-space-100, 8px);line-height:1.42857143;max-height:var(--ds-space-600, 48px);");
class $f42b14121d8411ab$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const highlightedText = (0, $8wSvA.createHighlights)(this.props.hit, 'name', 'tokenizedName');
        const logoImage = this.props.hitImageHrefResolver({
            hit: this.props.hit
        }) || (0, (/*@__PURE__*/$parcel$interopDefault($k5pOx)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f42b14121d8411ab$export$3f3deff8b74a6b4f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f42b14121d8411ab$export$e6ff31bff12b7ff4, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8U0Ec.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f42b14121d8411ab$export$ef41ebc44b9c1fe4, {
            alt: highlightedText,
            loading: "lazy",
            src: logoImage
        })), this.props.hit.getIn([
            'vendor',
            'isTopVendor'
        ]) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f42b14121d8411ab$export$4836b6f4d0c0d87f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f42b14121d8411ab$export$a7235ebc5e93af41, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f42b14121d8411ab$export$eda0685f2d9ca1b9, {
            mixin: (0, $62cXe).h500
        }, highlightedText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3BBSQ.AppTileHighlightedText), {
            highlightedText: highlightedText,
            originalText: this.props.hit.get('name')
        }) : this.props.hit.get('name')));
    }
}
(0, $5zQU9.default)($f42b14121d8411ab$export$2e2bcd8739ae039, "propTypes", {
    fromSearch: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
    hit: (0, $90ON9.default).hit().isRequired,
    hitImageHrefResolver: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired
});

});
parcelRegister("62cXe", function(module, exports) {

$parcel$export(module.exports, "fontFallback", () => $464cfa778ce4f1f2$export$2a99220fb32ec798);
$parcel$export(module.exports, "headingSizes", () => $464cfa778ce4f1f2$export$bc02e067df412c3b);
$parcel$export(module.exports, "h900", () => $464cfa778ce4f1f2$export$bdb8f897727a9c67);
$parcel$export(module.exports, "h800", () => $464cfa778ce4f1f2$export$3953fb6fbd158d23);
$parcel$export(module.exports, "h700", () => $464cfa778ce4f1f2$export$e4f993a313607daa);
$parcel$export(module.exports, "h600", () => $464cfa778ce4f1f2$export$1e8b2acea3fb3119);
$parcel$export(module.exports, "h500", () => $464cfa778ce4f1f2$export$85aa43a9b9f06707);
$parcel$export(module.exports, "h400", () => $464cfa778ce4f1f2$export$fcb7764b80bd908f);
$parcel$export(module.exports, "h300", () => $464cfa778ce4f1f2$export$a0e59c3bbc05e815);
$parcel$export(module.exports, "h200", () => $464cfa778ce4f1f2$export$7ccf32eb2150ac7e);
$parcel$export(module.exports, "h100", () => $464cfa778ce4f1f2$export$dfc0e69214efdc3c);

var $j0gMm = parcelRequire("j0gMm");

var $ivTMz = parcelRequire("ivTMz");
const $464cfa778ce4f1f2$export$2a99220fb32ec798 = {
    heading: {
        xxlarge: 'normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xlarge: 'normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        large: 'normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xsmall: 'normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xxsmall: 'normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    },
    body: {
        large: 'normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        UNSAFE_small: 'normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    }
};
const $464cfa778ce4f1f2$var$baseHeading = (size, lineHeight)=>({
        fontSize: `${size / 14}em`,
        fontStyle: 'inherit',
        lineHeight: lineHeight / size
    });
const $464cfa778ce4f1f2$export$bc02e067df412c3b = {
    h900: {
        size: 35,
        lineHeight: 40
    },
    h800: {
        size: 29,
        lineHeight: 32
    },
    h700: {
        size: 24,
        lineHeight: 28
    },
    h600: {
        size: 20,
        lineHeight: 24
    },
    h500: {
        size: 16,
        lineHeight: 20
    },
    h400: {
        size: 14,
        lineHeight: 16
    },
    h300: {
        size: 12,
        lineHeight: 16
    },
    h200: {
        size: 12,
        lineHeight: 16
    },
    h100: {
        size: 11,
        lineHeight: 16
    }
};
const $464cfa778ce4f1f2$export$bdb8f897727a9c67 = (props = {})=>({
        ...$464cfa778ce4f1f2$var$baseHeading($464cfa778ce4f1f2$export$bc02e067df412c3b.h900.size, $464cfa778ce4f1f2$export$bc02e067df412c3b.h900.lineHeight),
        color: `var(--ds-text, ${(0, $j0gMm.heading)(props)})`,
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: `-0.01em`,
        marginTop: `${(0, $ivTMz.gridSize)() * 6.5}px`
    });
const $464cfa778ce4f1f2$export$3953fb6fbd158d23 = (props = {})=>({
        ...$464cfa778ce4f1f2$var$baseHeading($464cfa778ce4f1f2$export$bc02e067df412c3b.h800.size, $464cfa778ce4f1f2$export$bc02e067df412c3b.h800.lineHeight),
        color: `var(--ds-text, ${(0, $j0gMm.heading)(props)})`,
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: `-0.01em`,
        marginTop: `${(0, $ivTMz.gridSize)() * 5}px`
    });
const $464cfa778ce4f1f2$export$e4f993a313607daa = (props = {})=>({
        ...$464cfa778ce4f1f2$var$baseHeading($464cfa778ce4f1f2$export$bc02e067df412c3b.h700.size, $464cfa778ce4f1f2$export$bc02e067df412c3b.h700.lineHeight),
        color: `var(--ds-text, ${(0, $j0gMm.heading)(props)})`,
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: `-0.01em`,
        marginTop: `${(0, $ivTMz.gridSize)() * 5}px`
    });
const $464cfa778ce4f1f2$export$1e8b2acea3fb3119 = (props = {})=>({
        ...$464cfa778ce4f1f2$var$baseHeading($464cfa778ce4f1f2$export$bc02e067df412c3b.h600.size, $464cfa778ce4f1f2$export$bc02e067df412c3b.h600.lineHeight),
        color: `var(--ds-text, ${(0, $j0gMm.heading)(props)})`,
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: `-0.008em`,
        marginTop: `${(0, $ivTMz.gridSize)() * 3.5}px`
    });
const $464cfa778ce4f1f2$export$85aa43a9b9f06707 = (props = {})=>({
        ...$464cfa778ce4f1f2$var$baseHeading($464cfa778ce4f1f2$export$bc02e067df412c3b.h500.size, $464cfa778ce4f1f2$export$bc02e067df412c3b.h500.lineHeight),
        color: `var(--ds-text, ${(0, $j0gMm.heading)(props)})`,
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: `-0.006em`,
        marginTop: `${(0, $ivTMz.gridSize)() * 3}px`
    });
const $464cfa778ce4f1f2$export$fcb7764b80bd908f = (props = {})=>({
        ...$464cfa778ce4f1f2$var$baseHeading($464cfa778ce4f1f2$export$bc02e067df412c3b.h400.size, $464cfa778ce4f1f2$export$bc02e067df412c3b.h400.lineHeight),
        color: `var(--ds-text, ${(0, $j0gMm.heading)(props)})`,
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: `-0.003em`,
        marginTop: `${(0, $ivTMz.gridSize)() * 2}px`
    });
const $464cfa778ce4f1f2$export$a0e59c3bbc05e815 = (props = {})=>({
        ...$464cfa778ce4f1f2$var$baseHeading($464cfa778ce4f1f2$export$bc02e067df412c3b.h300.size, $464cfa778ce4f1f2$export$bc02e067df412c3b.h300.lineHeight),
        color: `var(--ds-text, ${(0, $j0gMm.heading)(props)})`,
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: `${(0, $ivTMz.gridSize)() * 2.5}px`,
        textTransform: 'uppercase'
    });
const $464cfa778ce4f1f2$export$7ccf32eb2150ac7e = (props = {})=>({
        ...$464cfa778ce4f1f2$var$baseHeading($464cfa778ce4f1f2$export$bc02e067df412c3b.h200.size, $464cfa778ce4f1f2$export$bc02e067df412c3b.h200.lineHeight),
        color: `var(--ds-text-subtlest, ${(0, $j0gMm.subtleHeading)(props)})`,
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: `${(0, $ivTMz.gridSize)() * 2}px`
    });
const $464cfa778ce4f1f2$export$dfc0e69214efdc3c = (props = {})=>({
        ...$464cfa778ce4f1f2$var$baseHeading($464cfa778ce4f1f2$export$bc02e067df412c3b.h100.size, $464cfa778ce4f1f2$export$bc02e067df412c3b.h100.lineHeight),
        color: `var(--ds-text-subtlest, ${(0, $j0gMm.subtleHeading)(props)})`,
        fontWeight: "var(--ds-font-weight-bold, 700)",
        marginTop: `${(0, $ivTMz.gridSize)() * 2}px`
    });

});

parcelRegister("8gcXz", function(module, exports) {

$parcel$export(module.exports, "baseHeadingsCss", () => $6039deebad083d08$export$38c21f0e09ea380e);
$parcel$export(module.exports, "H1", () => $6039deebad083d08$export$5523b16adee8048);
$parcel$export(module.exports, "h2Css", () => $6039deebad083d08$export$1099dd8523c836a1);
$parcel$export(module.exports, "H2", () => $6039deebad083d08$export$cb94397127ac9363);
$parcel$export(module.exports, "h3Css", () => $6039deebad083d08$export$4c070d318b3e6c6b);
$parcel$export(module.exports, "H3", () => $6039deebad083d08$export$746be9e3a3dfff1f);
$parcel$export(module.exports, "H4", () => $6039deebad083d08$export$cc5e069d64fda823);
$parcel$export(module.exports, "h5Css", () => $6039deebad083d08$export$47aaf3a45d11f623);
$parcel$export(module.exports, "H5", () => $6039deebad083d08$export$88ef9fdaf11f7a1f);
$parcel$export(module.exports, "h6Css", () => $6039deebad083d08$export$29a24c7e0a822a0d);
$parcel$export(module.exports, "H6", () => $6039deebad083d08$export$a559fb8039b06400);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");
var $ivTMz = parcelRequire("ivTMz");

var $ibjku = parcelRequire("ibjku");

var $hvUUg = parcelRequire("hvUUg");
const $6039deebad083d08$export$38c21f0e09ea380e = /*#__PURE__*/ (0, $ibjku.css)("color:", "var(--ds-text, ".concat((0, $j0gMm).N700, ")"), ";font-family:'Charlie Display',", (0, $ivTMz.fontFamily)(), ";font-weight:600;;label:baseHeadingsCss;");
const $6039deebad083d08$export$74619e1c6d9d9b34 = /*#__PURE__*/ (0, $ibjku.css)($6039deebad083d08$export$38c21f0e09ea380e, " font-size:52px;line-height:60px;margin-bottom:var(--ds-space-300, 24px);;label:h1Css;");
const $6039deebad083d08$export$5523b16adee8048 = (0, $3UXZ8.default)("h1", {
    target: "e1q0b7mc0",
    label: "H1"
})($6039deebad083d08$export$74619e1c6d9d9b34, "");
const $6039deebad083d08$export$1099dd8523c836a1 = /*#__PURE__*/ (0, $ibjku.css)($6039deebad083d08$export$38c21f0e09ea380e, " font-size:36px;line-height:44px;margin-bottom:var(--ds-space-300, 24px);;label:h2Css;");
const $6039deebad083d08$export$cb94397127ac9363 = (0, $3UXZ8.default)("h2", {
    target: "e1q0b7mc1",
    label: "H2"
})($6039deebad083d08$export$1099dd8523c836a1, "");
const $6039deebad083d08$export$4c070d318b3e6c6b = /*#__PURE__*/ (0, $ibjku.css)($6039deebad083d08$export$38c21f0e09ea380e, " font-size:24px;letter-spacing:0.3px;line-height:32px;margin-bottom:var(--ds-space-300, 24px);;label:h3Css;");
const $6039deebad083d08$export$746be9e3a3dfff1f = (0, $3UXZ8.default)("h3", {
    target: "e1q0b7mc2",
    label: "H3"
})($6039deebad083d08$export$4c070d318b3e6c6b, "");
const $6039deebad083d08$export$670093d479e4c626 = /*#__PURE__*/ (0, $ibjku.css)($6039deebad083d08$export$38c21f0e09ea380e, " font-size:20px;", (0, $hvUUg.baseLineHeight), ";letter-spacing:0;;label:h4Css;");
const $6039deebad083d08$export$cc5e069d64fda823 = (0, $3UXZ8.default)("h4", {
    target: "e1q0b7mc3",
    label: "H4"
})($6039deebad083d08$export$670093d479e4c626, "");
const $6039deebad083d08$export$47aaf3a45d11f623 = /*#__PURE__*/ (0, $ibjku.css)($6039deebad083d08$export$38c21f0e09ea380e, " font-size:20px;", (0, $hvUUg.baseLineHeight), ";margin-bottom:var(--ds-space-300, 24px);letter-spacing:0.3px;;label:h5Css;");
const $6039deebad083d08$export$88ef9fdaf11f7a1f = (0, $3UXZ8.default)("h5", {
    target: "e1q0b7mc4",
    label: "H5"
})($6039deebad083d08$export$47aaf3a45d11f623, "");
const $6039deebad083d08$export$29a24c7e0a822a0d = /*#__PURE__*/ (0, $ibjku.css)($6039deebad083d08$export$38c21f0e09ea380e, " font-size:12px;line-height:18px;margin-bottom:var(--ds-space-200, 16px);text-transform:uppercase;letter-spacing:1px;;label:h6Css;");
const $6039deebad083d08$export$a559fb8039b06400 = (0, $3UXZ8.default)("h6", {
    target: "e1q0b7mc5",
    label: "H6"
})($6039deebad083d08$export$29a24c7e0a822a0d, "");

});

parcelRegister("8U0Ec", function(module, exports) {

$parcel$export(module.exports, "default", () => $67b40e3a6c755658$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $lAV1A = parcelRequire("lAV1A");

var $eUqFw = parcelRequire("eUqFw");
const $67b40e3a6c755658$export$398a70353a4cf5f3 = "\nbackground: rgba(255,255,255,0.89);\nborder-radius: 3px;\nbox-sizing: border-box;\npadding: 12.5%;\n";
const $67b40e3a6c755658$var$Background = (0, $3UXZ8.default)("div", {
    target: "e1lk71cd0",
    label: "Background"
})("width:100%;height:100%;", (props)=>props.isDarkMode ? $67b40e3a6c755658$export$398a70353a4cf5f3 : '', "");
function $67b40e3a6c755658$export$2e2bcd8739ae039(props) {
    const theme = (0, $lAV1A.default)();
    const isDarkMode = (theme === null || theme === void 0 ? void 0 : theme.colorMode) === 'dark';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($67b40e3a6c755658$var$Background, {
        "data-testid": "dark-modo-logo-bg",
        isDarkMode: isDarkMode
    }, props.children);
}

});
parcelRegister("lAV1A", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb8931ab47177118$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $k6OHd = parcelRequire("k6OHd");

var $cHqPT = parcelRequire("cHqPT");
/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ const $fb8931ab47177118$var$useThemeObserver = ()=>{
    const [theme, setTheme] = (0, $eUqFw.useState)((0, $k6OHd.default)());
    (0, $eUqFw.useEffect)(()=>{
        const observer = new (0, $cHqPT.default)((theme)=>setTheme(theme));
        observer.observe();
        return ()=>observer.disconnect();
    }, []);
    return theme;
};
var $fb8931ab47177118$export$2e2bcd8739ae039 = $fb8931ab47177118$var$useThemeObserver;

});
parcelRegister("k6OHd", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea3bb15dbb905771$export$2e2bcd8739ae039);

var $axYky = parcelRequire("axYky");

var $5IQVo = parcelRequire("5IQVo");

var $2l4Xw = parcelRequire("2l4Xw");
const $ea3bb15dbb905771$var$isThemeColorMode = (colorMode)=>{
    return (0, $5IQVo.themeColorModes).find((mode)=>mode === colorMode) !== undefined;
};
const $ea3bb15dbb905771$var$getGlobalTheme = ()=>{
    if (typeof document === 'undefined') return {};
    const element = document.documentElement;
    const colorMode = element.getAttribute((0, $axYky.COLOR_MODE_ATTRIBUTE)) || '';
    const theme = element.getAttribute((0, $axYky.THEME_DATA_ATTRIBUTE)) || '';
    return {
        ...(0, $2l4Xw.themeStringToObject)(theme),
        ...$ea3bb15dbb905771$var$isThemeColorMode(colorMode) && {
            colorMode: colorMode
        }
    };
};
var $ea3bb15dbb905771$export$2e2bcd8739ae039 = $ea3bb15dbb905771$var$getGlobalTheme;

});
parcelRegister("axYky", function(module, exports) {

$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $7adbc8d9611938f1$export$4ef52930e33717cd);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $7adbc8d9611938f1$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $7adbc8d9611938f1$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $7adbc8d9611938f1$export$352e418ed5b6193a);
$parcel$export(module.exports, "TOKEN_NOT_FOUND_CSS_VAR", () => $7adbc8d9611938f1$export$dddac1532e822863);
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $7adbc8d9611938f1$export$9d7b58831ae93caa);
const $7adbc8d9611938f1$export$4ef52930e33717cd = 'data-theme';
const $7adbc8d9611938f1$export$a00eac3f8684bcd0 = 'data-color-mode';
const $7adbc8d9611938f1$export$2112803007239c61 = 'data-contrast-mode';
const $7adbc8d9611938f1$export$352e418ed5b6193a = 'data-custom-theme';
const $7adbc8d9611938f1$export$2faeed762aac6741 = 'light';
const $7adbc8d9611938f1$export$6f0c6fb8c80fcc92 = 'ds';
const $7adbc8d9611938f1$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
const $7adbc8d9611938f1$export$dddac1532e822863 = `--${$7adbc8d9611938f1$export$6f0c6fb8c80fcc92}-token-not-found`;
const $7adbc8d9611938f1$export$9d7b58831ae93caa = `--${$7adbc8d9611938f1$export$6f0c6fb8c80fcc92}-elevation-surface-current`;

});

parcelRegister("5IQVo", function(module, exports) {

$parcel$export(module.exports, "themeColorModes", () => $42aa1d91cefcf17e$export$83993de8eb66733);
$parcel$export(module.exports, "themeIds", () => $42aa1d91cefcf17e$export$7d43e72a58e3283f);
$parcel$export(module.exports, "themeStateDefaults", () => $42aa1d91cefcf17e$export$9aedcfa7336a207);
$parcel$export(module.exports, "default", () => $42aa1d91cefcf17e$export$2e2bcd8739ae039);
/**
 * This file contains the source of truth for themes and all associated meta data.
 */ /**
 * Themes: The internal identifier of a theme.
 * These ids are what the actual theme files/folders are called.
 * style-dictionary will attempt to locate these in the file-system.
 */ /**
 * ThemeOverrides: The internal identifier of a theme override. Which are themes that contain
 * a subset of tokens intended to override an existing theme. These ids are what the actual
 * theme files/folders are called. style-dictionary will attempt to locate these in the file-system.
 * Theme overrides are temporary and there may not be any defined at times.
 */ /**
 * Theme kinds: The type of theme.
 * Some themes are entirely focused on Color, whilst others are purely focused on spacing.
 * In the future other types may be introduced such as typography.
 */ /**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ const $42aa1d91cefcf17e$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
const $42aa1d91cefcf17e$export$8ce7e340c74e86c5 = [
    'more',
    'no-preference',
    'auto'
];
const $42aa1d91cefcf17e$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'light-brand-refresh',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'dark-brand-refresh',
    'legacy-light',
    'legacy-dark',
    'spacing',
    'shape',
    'typography-adg3',
    'typography-modernized',
    'typography-refreshed'
];
const $42aa1d91cefcf17e$export$ba8a43b83ecc69f8 = [];
const $42aa1d91cefcf17e$export$92ba366331403db2 = [
    ...$42aa1d91cefcf17e$export$7d43e72a58e3283f,
    ...$42aa1d91cefcf17e$export$ba8a43b83ecc69f8
];
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ const $42aa1d91cefcf17e$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-legacy-light': {
        id: 'legacy-light',
        displayName: 'Light Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-legacy-dark': {
        id: 'legacy-dark',
        displayName: 'Dark Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography-adg3': {
        id: 'typography-adg3',
        displayName: 'ADG3 Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Atlassian Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-typography-modernized': {
        id: 'typography-modernized',
        displayName: 'Atlassian Typography (Modernized)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-typography-refreshed': {
        id: 'typography-refreshed',
        displayName: 'Atlassian Typography (Refreshed)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-light-brand-refresh': {
        id: 'light-brand-refresh',
        displayName: 'Light theme (Brand refresh)',
        palette: 'brandRefreshPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-dark-brand-refresh': {
        id: 'dark-brand-refresh',
        displayName: 'Dark theme (Brand refresh)',
        palette: 'brandRefreshPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    }
};
const $42aa1d91cefcf17e$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: undefined,
    spacing: 'spacing',
    typography: undefined,
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $42aa1d91cefcf17e$export$2e2bcd8739ae039 = $42aa1d91cefcf17e$var$themeConfig;

});

parcelRegister("2l4Xw", function(module, exports) {

$parcel$export(module.exports, "themeStringToObject", () => $1b4163b1766a770b$export$f19b488f7c0547ee);
$parcel$export(module.exports, "themeObjectToString", () => $1b4163b1766a770b$export$62c37ab81302621a);

var $5IQVo = parcelRequire("5IQVo");
const $1b4163b1766a770b$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape'
];
const $1b4163b1766a770b$var$customThemeOptions = 'UNSAFE_themeOptions';
const $1b4163b1766a770b$var$isThemeKind = (themeKind)=>{
    return $1b4163b1766a770b$var$themeKinds.find((kind)=>kind === themeKind) !== undefined;
};
const $1b4163b1766a770b$var$isThemeIds = (themeId)=>{
    return (0, $5IQVo.themeIds).find((id)=>id === themeId) !== undefined;
};
const $1b4163b1766a770b$var$isColorMode = (modeId)=>{
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
const $1b4163b1766a770b$export$f19b488f7c0547ee = (themeState)=>{
    return themeState.split(' ').map((theme)=>theme.split(/:(.*)/s)).reduce((themeObject, [kind, id])=>{
        if (kind === 'colorMode' && $1b4163b1766a770b$var$isColorMode(id)) themeObject[kind] = id;
        if ($1b4163b1766a770b$var$isThemeKind(kind) && $1b4163b1766a770b$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $1b4163b1766a770b$var$customThemeOptions) try {
            themeObject[$1b4163b1766a770b$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
const $1b4163b1766a770b$export$62c37ab81302621a = (themeState)=>Object.entries(themeState).reduce((themeString, [kind, id])=>{
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $1b4163b1766a770b$var$isColorMode(id) || // custom theme state
        kind === $1b4163b1766a770b$var$customThemeOptions && typeof id === 'object' || // other theme states
        $1b4163b1766a770b$var$isThemeKind(kind) && typeof id === 'string' && $1b4163b1766a770b$var$isThemeIds(id)) return themeString + `${themeString ? ' ' : ''}` + `${kind}:${typeof id === 'object' ? JSON.stringify(id) : id}`;
        return themeString;
    }, '');

});


parcelRegister("cHqPT", function(module, exports) {

$parcel$export(module.exports, "default", () => $93ee51407198d51a$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $axYky = parcelRequire("axYky");

var $k6OHd = parcelRequire("k6OHd");
class $93ee51407198d51a$export$2e2bcd8739ae039 {
    constructor(callback){
        (0, $5zQU9.default)(this, "legacyObserver", null);
        this.callback = callback;
        $93ee51407198d51a$export$2e2bcd8739ae039.callbacks.add(callback);
    }
    observe() {
        if (!$93ee51407198d51a$export$2e2bcd8739ae039.observer) {
            $93ee51407198d51a$export$2e2bcd8739ae039.observer = new MutationObserver(()=>{
                const theme = (0, $k6OHd.default)();
                $93ee51407198d51a$export$2e2bcd8739ae039.callbacks.forEach((callback)=>callback(theme));
            });
            // Observer only needs to be configured once
            $93ee51407198d51a$export$2e2bcd8739ae039.observer.observe(document.documentElement, {
                attributeFilter: [
                    (0, $axYky.THEME_DATA_ATTRIBUTE),
                    (0, $axYky.COLOR_MODE_ATTRIBUTE)
                ]
            });
        }
    }
    disconnect() {
        if (this.callback) $93ee51407198d51a$export$2e2bcd8739ae039.callbacks.delete(this.callback);
        if ($93ee51407198d51a$export$2e2bcd8739ae039.callbacks.size === 0 && $93ee51407198d51a$export$2e2bcd8739ae039.observer) {
            $93ee51407198d51a$export$2e2bcd8739ae039.observer.disconnect();
            $93ee51407198d51a$export$2e2bcd8739ae039.observer = null;
        }
    }
}
(0, $5zQU9.default)($93ee51407198d51a$export$2e2bcd8739ae039, "observer", null);
(0, $5zQU9.default)($93ee51407198d51a$export$2e2bcd8739ae039, "callbacks", new Set());

});



parcelRegister("jC9Rj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e47936b24729a92e$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $gykb8 = parcelRequire("gykb8");

var $eUqFw = parcelRequire("eUqFw");

var $4lmb9 = parcelRequire("4lmb9");

var $2e8x7 = parcelRequire("2e8x7");
function $e47936b24729a92e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e47936b24729a92e$var$StyledImg = (0, $3UXZ8.default)("img", {
    target: "e1aam84i0",
    label: "StyledImg"
})({
    name: "fopvyl",
    styles: "width:18px;height:18px;vertical-align:text-top;"
});
const $e47936b24729a92e$var$StyledParagraph = (0, $3UXZ8.default)("p", {
    target: "e1aam84i1",
    label: "StyledParagraph"
})({
    name: "9uewxx",
    styles: "margin-top:0;margin-bottom:10px;max-width:250px;"
});
const $e47936b24729a92e$var$StyledLink = /*#__PURE__*/ (0, $3UXZ8.default)((0, $gykb8.default), {
    target: "e1aam84i2",
    label: "StyledLink"
})({
    name: "15ult4h",
    styles: "margin-left:5px;color:inherit;font-weight:500;"
});
function $e47936b24729a92e$export$2e2bcd8739ae039(_ref) {
    let { vendorName: vendorName, className: className, showLabel: showLabel } = _ref;
    if (!showLabel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e47936b24729a92e$var$StyledImg, {
        alt: "Top Vendor",
        className: className,
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2e8x7))),
        title: "Top Vendor"
    });
    const tooltipContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e47936b24729a92e$var$StyledParagraph, null, vendorName, " is a Top Vendor. Top Vendors have high standards for app quality, reliability, and support."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gykb8.default), {
        target: "_blank",
        href: "https://www.atlassian.com/licensing/marketplace#generalmarketplacequestions-7"
    }, "Learn more"));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4lmb9.default), {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e47936b24729a92e$var$StyledImg, {
        alt: "Top Vendor",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2e8x7)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e47936b24729a92e$var$StyledLink, {
        target: "_blank",
        href: "https://www.atlassian.com/licensing/marketplace#generalmarketplacequestions-7"
    }, "Top Vendor")));
}

});
parcelRegister("2e8x7", function(module, exports) {
module.exports = new URL("top-vendor-badge.d27cc922.svg", import.meta.url).toString();

});


parcelRegister("k5pOx", function(module, exports) {
module.exports = new URL("icon-default-grey.2a68d370.png", import.meta.url).toString();

});




parcelRegister("kLILm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1eaeb666c71200e$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $ivTMz = parcelRequire("ivTMz");
var $62HOr = parcelRequire("62HOr");

var $j0gMm = parcelRequire("j0gMm");

var $hvUUg = parcelRequire("hvUUg");
var $lgRZl = parcelRequire("lgRZl");
var $Lig7B = parcelRequire("Lig7B");
var $hxCMl = parcelRequire("hxCMl");

var $inwKI = parcelRequire("inwKI");

var $3ihpf = parcelRequire("3ihpf");
var $5YcrV = parcelRequire("5YcrV");
var $8xfj9 = parcelRequire("8xfj9");

var $hgNMk = parcelRequire("hgNMk");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $6jEcw = parcelRequire("6jEcw");

var $90ON9 = parcelRequire("90ON9");

var $23J4Z = parcelRequire("23J4Z");

var $2AdLY = parcelRequire("2AdLY");

var $k5pOx = parcelRequire("k5pOx");
function $f1eaeb666c71200e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f1eaeb666c71200e$var$SmallHitContainer = (0, $3UXZ8.default)("div", {
    target: "e1xfsn510",
    label: "SmallHitContainer"
})({
    name: "ud5h78",
    styles: "margin-bottom:var(--ds-space-250, 20px);"
});
const $f1eaeb666c71200e$var$SmallHitStyled = (0, $3UXZ8.default)("div", {
    target: "e1xfsn511",
    label: "SmallHitStyled"
})("cursor:pointer;border-radius:", (0, $ivTMz.borderRadius)(), "px;padding:var(--ds-space-025, 2px);text-decoration:none;background:", (0, $j0gMm.N0), ";padding:var(--ds-space-150, 12px) var(--ds-space-150, 12px) var(--ds-space-025, 2px) var(--ds-space-150, 12px);transition:box-shadow 0.1s;&:hover{", (0, $62HOr).e300(), "}");
const $f1eaeb666c71200e$var$HitLinkStyled = /*#__PURE__*/ (0, $3UXZ8.default)((0, $2AdLY.default), {
    target: "e1xfsn512",
    label: "HitLinkStyled"
})({
    name: "123c98n",
    styles: "text-decoration:none;&:hover,&:focus,&:-webkit-any-link{text-decoration:none;}"
});
const $f1eaeb666c71200e$var$SmallHitContent = (0, $3UXZ8.default)("div", {
    target: "e1xfsn513",
    label: "SmallHitContent"
})({
    name: "1xfbt88",
    styles: "display:flex;min-height:74px;"
});
const $f1eaeb666c71200e$var$LogoImage = (0, $3UXZ8.default)("img", {
    target: "e1xfsn514",
    label: "LogoImage"
})({
    name: "fxzd9f",
    styles: "width:46px;height:46px;&:hover{cursor:pointer;}"
});
const $f1eaeb666c71200e$var$SmallHitLogo = (0, $3UXZ8.default)("div", {
    target: "e1xfsn515",
    label: "SmallHitLogo"
})("display:flex;flex:0 0 auto;margin:0 var(--ds-space-100, 8px) 0 0;position:relative;width:46px;height:46px;& ", $f1eaeb666c71200e$var$LogoImage, "{box-sizing:content-box;}");
const $f1eaeb666c71200e$var$CloudSecurityParticipantIconStyled = /*#__PURE__*/ (0, $3UXZ8.default)((0, $3ihpf.default), {
    target: "e1xfsn516",
    label: "CloudSecurityParticipantIconStyled"
})({
    name: "12ld2x7",
    styles: "z-index:10;width:14px;height:16px;"
});
const $f1eaeb666c71200e$var$CertificationContainer = (0, $3UXZ8.default)("div", {
    target: "e1xfsn517",
    label: "CertificationContainer"
})({
    name: "hk313c",
    styles: "display:flex;flex-direction:row;align-items:center;margin-bottom:3px;"
});
const $f1eaeb666c71200e$var$SmallHitDetailsContainer = (0, $3UXZ8.default)("div", {
    target: "e1xfsn518",
    label: "SmallHitDetailsContainer"
})({
    name: "18yctn0",
    styles: "display:flex;flex:0 1 auto;margin-left:5px;min-width:0;"
});
const $f1eaeb666c71200e$var$SmallHitDetails = (0, $3UXZ8.default)("div", {
    target: "e1xfsn519",
    label: "SmallHitDetails"
})({
    name: "1b4gndf",
    styles: "display:flex;flex-direction:column;margin-bottom:auto;min-width:1px;"
});
const $f1eaeb666c71200e$var$SmallHitHeading = (0, $3UXZ8.default)("div", {
    target: "e1xfsn5110",
    label: "SmallHitHeading"
})((0, $hvUUg.CharlieFontFamily), ";font-weight:600;font-size:16px;line-height:1.2;flex:1 0 auto;max-height:46px;overflow:hidden;margin-bottom:5px;");
const $f1eaeb666c71200e$var$SmallHitCategories = (0, $3UXZ8.default)("div", {
    target: "e1xfsn5111",
    label: "SmallHitCategories"
})({
    name: "1tu59u4",
    styles: "flex:0 0 auto;"
});
const $f1eaeb666c71200e$var$SmallHitVendorStyled = (0, $3UXZ8.default)("div", {
    target: "e1xfsn5112",
    label: "SmallHitVendorStyled"
})("height:22px;font-size:13px;color:", (0, $j0gMm.N100), ";");
const $f1eaeb666c71200e$var$SmallHitRatings = (0, $3UXZ8.default)("div", {
    target: "e1xfsn5113",
    label: "SmallHitRatings"
})({
    name: "1tu59u4",
    styles: "flex:0 0 auto;"
});
const $f1eaeb666c71200e$var$CertificationTitle = (0, $3UXZ8.default)("span", {
    target: "e1xfsn5114",
    label: "CertificationTitle"
})((0, $hvUUg.CharlieFontFamily), " font-size:14px;line-height:1;text-transform:uppercase;color:", (0, $j0gMm.N600), ";margin-left:var(--ds-space-025, 2px);");
const $f1eaeb666c71200e$var$CloudFortifiedIconStyled = /*#__PURE__*/ (0, $3UXZ8.default)((0, $5YcrV.default), {
    target: "e1xfsn5115",
    label: "CloudFortifiedIconStyled"
})({
    name: "3o0h5k",
    styles: "width:16px;height:16px;"
});
function $f1eaeb666c71200e$export$2e2bcd8739ae039(props) {
    const { replaceCategoriesOnAppTilesWithVendorName: replaceCategoriesOnAppTilesWithVendorName } = (0, $inwKI.useFeatureFlags)();
    const certificationBadge = (hasCloudSecurityBadge, hasCloudFortifiedBadge)=>{
        if (hasCloudFortifiedBadge) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f1eaeb666c71200e$var$CertificationContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f1eaeb666c71200e$var$CloudFortifiedIconStyled, {
            showLabel: false
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f1eaeb666c71200e$var$CertificationTitle, null, "Cloud Fortified"));
        if (hasCloudSecurityBadge) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f1eaeb666c71200e$var$CertificationContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f1eaeb666c71200e$var$CloudSecurityParticipantIconStyled, {
            iconSize: "small"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f1eaeb666c71200e$var$CertificationTitle, null, (0, $3ihpf.CLOUD_SECURITY_BADGE_LABEL)));
        return null;
    };
    function renderHitContents() {
        var _props$hit$getIn;
        const logoImage = props.hitContext.get('hitImageHrefResolver')({
            hit: props.hit
        }) || (0, (/*@__PURE__*/$parcel$interopDefault($k5pOx)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f1eaeb666c71200e$var$SmallHitStyled, {
            "data-testid": "small-hit"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f1eaeb666c71200e$var$HitLinkStyled, {
            fromSearch: props.fromSearch,
            hitContext: props.hitContext,
            hit: props.hit,
            perspective: props.perspective,
            filters: props.filters,
            sectionTitle: props.sectionTitle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f1eaeb666c71200e$var$SmallHitContent, {
            title: props.hit.get('name')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f1eaeb666c71200e$var$SmallHitLogo, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f1eaeb666c71200e$var$LogoImage, {
            loading: "lazy",
            src: logoImage,
            alt: props.hit.get('name')
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f1eaeb666c71200e$var$SmallHitDetailsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f1eaeb666c71200e$var$SmallHitDetails, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f1eaeb666c71200e$var$SmallHitHeading, null, props.screenClass === 'xs' ? props.hit.get('name') : (0, $hgNMk.trimAfter)(props.hit.get('name'), 42)), certificationBadge(props.hasCloudSecurityBadge, props.hasCloudFortifiedBadge), replaceCategoriesOnAppTilesWithVendorName ? props.hit.get('vendor') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f1eaeb666c71200e$var$SmallHitVendorStyled, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8xfj9.default), {
            name: props.hit.getIn([
                'vendor',
                'name'
            ]),
            partnerTierType: (_props$hit$getIn = props.hit.getIn([
                'vendor',
                'partnerTier',
                'type'
            ])) === null || _props$hit$getIn === void 0 ? void 0 : _props$hit$getIn.toUpperCase()
        })) : props.hit.get('categories') && props.hit.get('categories').size > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f1eaeb666c71200e$var$SmallHitCategories, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $23J4Z.default), {
            categories: props.hit.get('categories')
        })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f1eaeb666c71200e$var$SmallHitRatings, null, props.hit.get('ratings') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $Lig7B.default), {
            ratings: props.hit.get('ratings').toJS(),
            showRatingCount: false,
            numericRatingStyles: {
                fontSize: 13,
                avgNumFontSize: 13
            }
        }) : undefined))))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hxCMl.default), {
        xl: props.colSpan.getIn([
            'smallHits',
            'xl'
        ]) || 4,
        lg: props.colSpan.getIn([
            'smallHits',
            'lg'
        ]) || 4,
        md: props.colSpan.getIn([
            'smallHits',
            'md'
        ]) || 4,
        sm: props.colSpan.getIn([
            'smallHits',
            'sm'
        ]) || 12,
        xs: props.colSpan.getIn([
            'smallHits',
            'xs'
        ]) || 12,
        gutterWidth: 20,
        screenClass: props.screenClass
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f1eaeb666c71200e$var$SmallHitContainer, null, props.contentOverride || renderHitContents()));
}
$f1eaeb666c71200e$export$2e2bcd8739ae039.propTypes = {
    colSpan: (0, $90ON9.default).colSpan,
    contentOverride: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node,
    fromSearch: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
    hit: (0, $lgRZl.default).requiredIf((0, $90ON9.default).hit(), (props)=>!props.contentOverride),
    hitContext: (0, $lgRZl.default).requiredIf((0, $90ON9.default).hitContext, (props)=>!props.contentOverride),
    perspective: (0, $6jEcw.default).perspective,
    screenClass: (0, $90ON9.default).screenClass.isRequired,
    hasCloudSecurityBadge: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    hasCloudFortifiedBadge: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    filters: (0, $90ON9.default).filters,
    sectionTitle: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string
};

});
parcelRegister("hgNMk", function(module, exports) {

$parcel$export(module.exports, "trimAfter", () => $c92a8b3e8a1db66c$export$6069abcbf3229af7);
$parcel$export(module.exports, "pluralize", () => $c92a8b3e8a1db66c$export$cefb40c9962541b5);
$parcel$export(module.exports, "tryParseJSON", () => $c92a8b3e8a1db66c$export$a011e92e61f46a0f);
$parcel$export(module.exports, "removeDuplicates", () => $c92a8b3e8a1db66c$export$2e2262a44ac61957);
const $c92a8b3e8a1db66c$export$6069abcbf3229af7 = (str, threshold)=>str.length > threshold ? "".concat(str.substring(0, threshold), "...") : str;
const $c92a8b3e8a1db66c$export$cefb40c9962541b5 = (word, count, inclusive, pluralWord)=>{
    const finalPluralWord = pluralWord ? pluralWord : "".concat(word, "s");
    const finalWord = count === 1 ? word : finalPluralWord;
    return inclusive ? "".concat(count, " ").concat(finalWord) : finalWord;
};
function $c92a8b3e8a1db66c$export$a011e92e61f46a0f(maybeJSON) {
    if (typeof maybeJSON !== 'string') return {
        success: false,
        result: null
    };
    try {
        const json = JSON.parse(maybeJSON);
        return {
            success: true,
            result: json
        };
    } catch (_unused) {
        return {
            success: false,
            result: null
        };
    }
}
const $c92a8b3e8a1db66c$export$2e2262a44ac61957 = (arr)=>{
    return arr.filter((item, index)=>arr.indexOf(item) === index);
};
const $c92a8b3e8a1db66c$export$ee5543708084e0d = (str)=>{
    return str.trim().toLowerCase().replace(/([^A-Z0-9]+)(.)/gi, // match multiple non-letter/numbers followed by any character
    function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return args[2].toUpperCase(); //3rd index is the character we need to transform uppercase
    });
};

});








parcelRegister("lqDCJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f99ac319f84df5ed$export$2e2bcd8739ae039);

var $8x3tg = parcelRequire("8x3tg");

var $ayd98 = parcelRequire("ayd98");
const $f99ac319f84df5ed$var$store = (0, $8x3tg.combineReducers)({
    search: (0, $ayd98.default)
});
var $f99ac319f84df5ed$export$2e2bcd8739ae039 = $f99ac319f84df5ed$var$store;

});
parcelRegister("8x3tg", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.combineReducers = undefined;

var $4mhi4 = parcelRequire("4mhi4");
var $63641912f63d9f10$var$_combineReducers3 = $63641912f63d9f10$var$_interopRequireDefault($4mhi4);
function $63641912f63d9f10$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.combineReducers = $63641912f63d9f10$var$_combineReducers3.default;

});
parcelRegister("4mhi4", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $g5DHJ = parcelRequire("g5DHJ");
var $32c6a1030e5b2a5f$var$_immutable2 = $32c6a1030e5b2a5f$var$_interopRequireDefault($g5DHJ);

var $eZN8G = parcelRequire("eZN8G");
function $32c6a1030e5b2a5f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = function(reducers) {
    var getDefaultState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $32c6a1030e5b2a5f$var$_immutable2.default.Map;
    var reducerKeys = Object.keys(reducers);
    // eslint-disable-next-line space-infix-ops
    return function() {
        var inputState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultState();
        var action = arguments[1];
        var warningMessage;
        return inputState.withMutations(function(temporaryState) {
            reducerKeys.forEach(function(reducerName) {
                var reducer = reducers[reducerName];
                var currentDomainState = temporaryState.get(reducerName);
                var nextDomainState = reducer(currentDomainState, action);
                (0, $eZN8G.validateNextState)(nextDomainState, reducerName, action);
                temporaryState.set(reducerName, nextDomainState);
            });
        });
    };
};
module.exports = module.exports['default'];

});
parcelRegister("eZN8G", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateNextState = module.exports.getUnexpectedInvocationParameterMessage = module.exports.getStateName = undefined;

var $26hZy = parcelRequire("26hZy");
var $aeace12de0098e50$var$_getStateName3 = $aeace12de0098e50$var$_interopRequireDefault($26hZy);

var $lWF4j = parcelRequire("lWF4j");
var $aeace12de0098e50$var$_getUnexpectedInvocationParameterMessage3 = $aeace12de0098e50$var$_interopRequireDefault($lWF4j);

var $1R4n3 = parcelRequire("1R4n3");
var $aeace12de0098e50$var$_validateNextState3 = $aeace12de0098e50$var$_interopRequireDefault($1R4n3);
function $aeace12de0098e50$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.getStateName = $aeace12de0098e50$var$_getStateName3.default;
module.exports.getUnexpectedInvocationParameterMessage = $aeace12de0098e50$var$_getUnexpectedInvocationParameterMessage3.default;
module.exports.validateNextState = $aeace12de0098e50$var$_validateNextState3.default;

});
parcelRegister("26hZy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function(action) {
    return action && action.type === '@@redux/INIT' ? 'initialState argument passed to createStore' : 'previous state received by the reducer';
};
module.exports = module.exports['default'];

});

parcelRegister("lWF4j", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $g5DHJ = parcelRequire("g5DHJ");
var $041f773629ff88b2$var$_immutable2 = $041f773629ff88b2$var$_interopRequireDefault($g5DHJ);

var $26hZy = parcelRequire("26hZy");
var $041f773629ff88b2$var$_getStateName2 = $041f773629ff88b2$var$_interopRequireDefault($26hZy);
function $041f773629ff88b2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = function(state, reducers, action) {
    var reducerNames = Object.keys(reducers);
    if (!reducerNames.length) return 'Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.';
    var stateName = (0, $041f773629ff88b2$var$_getStateName2.default)(action);
    if ($041f773629ff88b2$var$_immutable2.default.isImmutable ? !$041f773629ff88b2$var$_immutable2.default.isImmutable(state) : !$041f773629ff88b2$var$_immutable2.default.Iterable.isIterable(state)) return 'The ' + stateName + ' is of unexpected type. Expected argument to be an instance of Immutable.Collection or Immutable.Record with the following properties: "' + reducerNames.join('", "') + '".';
    var unexpectedStatePropertyNames = state.toSeq().keySeq().toArray().filter(function(name) {
        return !reducers.hasOwnProperty(name);
    });
    if (unexpectedStatePropertyNames.length > 0) return 'Unexpected ' + (unexpectedStatePropertyNames.length === 1 ? 'property' : 'properties') + ' "' + unexpectedStatePropertyNames.join('", "') + '" found in ' + stateName + '. Expected to find one of the known reducer property names instead: "' + reducerNames.join('", "') + '". Unexpected properties will be ignored.';
    return null;
};
module.exports = module.exports['default'];

});

parcelRegister("1R4n3", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function(nextState, reducerName, action) {
    // eslint-disable-next-line no-undefined
    if (nextState === undefined) throw new Error('Reducer "' + reducerName + '" returned undefined when handling "' + action.type + '" action. To ignore an action, you must explicitly return the previous state.');
};
module.exports = module.exports['default'];

});




parcelRegister("ayd98", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ae746ebfd9b4a1d$export$2e2bcd8739ae039);

var $g5DHJ = parcelRequire("g5DHJ");

var $408r2 = parcelRequire("408r2");

var $kKkev = parcelRequire("kKkev");
const $7ae746ebfd9b4a1d$var$initialState = (0, $g5DHJ.Map)({
    currentPage: undefined,
    dataError: false,
    dataErrorMessages: (0, $g5DHJ.List)(),
    initialized: false,
    loadingFreshSearchResults: false,
    loadingMoreResults: false,
    moreResultsDataError: false,
    moreResultsDataErrorMessages: (0, $g5DHJ.List)(),
    searchInProgress: false,
    currentSearchId: undefined,
    searchResults: (0, $g5DHJ.Map)({
        hits: undefined,
        numberOfHits: undefined,
        numberOfPages: undefined
    })
});
function $7ae746ebfd9b4a1d$var$appendSearchResults(_ref) {
    let { oldSearchResults: oldSearchResults, newSearchResults: newSearchResults } = _ref;
    return (0, $g5DHJ.Map)({
        hits: oldSearchResults.get('hits').concat(newSearchResults.get('hits')),
        numberOfHits: newSearchResults.get('numberOfHits'),
        numberOfPages: newSearchResults.get('numberOfPages')
    });
}
function $7ae746ebfd9b4a1d$export$2e2bcd8739ae039() {
    let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $7ae746ebfd9b4a1d$var$initialState;
    let action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $408r2.RESET_STATE:
            return $7ae746ebfd9b4a1d$var$initialState;
        case 0, $kKkev.RETRIEVE_FRESH_SEARCH_RESULTS:
            return state.set('pendingSearchId', action.searchId).set('searchInProgress', true).set('loadingFreshSearchResults', true);
        case 0, $kKkev.RECEIVE_FRESH_SEARCH_RESULTS:
            return state.get('pendingSearchId') === action.searchId ? state.set('pendingSearchId', undefined).set('currentSearchId', action.searchId).set('initialized', true).set('searchInProgress', false).set('searchResults', action.searchResults).set('loadingFreshSearchResults', false).set('dataError', false).set('dataErrorMessages', (0, $g5DHJ.List)()).set('currentPage', 0) : state;
        case 0, $kKkev.DATA_ERROR_FRESH_SEARCH_RESULTS:
            return state.update('searchResults', (searchResults)=>searchResults.set('hits', undefined).set('numberOfHits', 0).set('numberOfPages', 0)).set('searchInProgress', false).set('dataError', true).set('dataErrorMessages', action.dataErrorMessages);
        case 0, $kKkev.RETRIEVE_MORE_SEARCH_RESULTS:
            return state.set('searchInProgress', true).set('loadingMoreResults', true);
        case 0, $kKkev.RECEIVE_MORE_SEARCH_RESULTS:
            return state.set('searchInProgress', false).set('loadingMoreResults', false).set('searchResults', $7ae746ebfd9b4a1d$var$appendSearchResults({
                oldSearchResults: state.get('searchResults'),
                newSearchResults: action.searchResults
            })).set('moreResultsDataError', false).set('moreResultsDataErrorMessages', (0, $g5DHJ.List)()).set('currentPage', action.page);
        case 0, $kKkev.DATA_ERROR_MORE_SEARCH_RESULTS:
            return state.set('searchInProgress', false).set('loadingMoreResults', false).set('moreResultsDataError', true).set('moreResultsDataErrorMessages', action.dataErrorMessages);
        default:
            return state;
    }
}

});
parcelRegister("408r2", function(module, exports) {

$parcel$export(module.exports, "RESET_STATE", () => $2e9db4926d009086$export$7431817582ed8a25);
$parcel$export(module.exports, "resetState", () => $2e9db4926d009086$export$8e84bad0b35de9e8);
const $2e9db4926d009086$export$7431817582ed8a25 = 'GENERAL_RESET_STATE';
function $2e9db4926d009086$export$8e84bad0b35de9e8() {
    return {
        type: $2e9db4926d009086$export$7431817582ed8a25
    };
}

});




parcelRegister("8J0kb", function(module, exports) {

$parcel$export(module.exports, "AppInstallAnalyticsListener", () => $65a2c72b94d01e9b$export$f57e454728b785c6);

var $jYVKV = parcelRequire("jYVKV");

var $46iLW = parcelRequire("46iLW");
var $eqVJB = parcelRequire("eqVJB");

var $eUqFw = parcelRequire("eUqFw");

var $5JCOp = parcelRequire("5JCOp");

var $bwjZm = parcelRequire("bwjZm");
const $65a2c72b94d01e9b$export$3ab626b13e803edd = new Set([
    'marketplace'
]);
function $65a2c72b94d01e9b$export$f57e454728b785c6(props) {
    const onEvent = (event, channel)=>{
        const gasEvent = event;
        if (channel && $65a2c72b94d01e9b$export$3ab626b13e803edd.has(channel)) {
            const { payload: payload, context: context } = gasEvent;
            const marketplaceContext = (0, $46iLW.getMergedMarketplaceContext)(context);
            if (payload.eventType.type === (0, $eqVJB.SCREEN_EVENT_TYPE)) {
                const screenEventPayload = payload;
                const finalEvent = (0, $bwjZm.getScreenViewEvent)({
                    marketplaceContext: marketplaceContext,
                    payload: screenEventPayload
                });
                return (0, $5JCOp.sendPageViewEvent)(finalEvent);
            }
            const nonScreenEventPayload = payload;
            const eventArgs = {
                marketplaceContext: marketplaceContext,
                payload: nonScreenEventPayload
            };
            const finalEvent = (0, $bwjZm.getNonScreenEvent)(eventArgs);
            (0, $5JCOp.sendEvent)(finalEvent);
        }
    };
    return /*#__PURE__*/ $eUqFw.createElement((0, $jYVKV.default), {
        channel: "marketplace",
        onEvent: onEvent
    }, props.children);
}

});
parcelRegister("46iLW", function(module, exports) {

$parcel$export(module.exports, "getMergedMarketplaceContext", () => $2fc648bcf8033ef2$export$df9eeec778c4dbf4);

var $7IZKi = parcelRequire("7IZKi");

var $f2QOW = parcelRequire("f2QOW");
const $2fc648bcf8033ef2$export$6d214f22a21009c2 = (analyticsContext)=>{
    return analyticsContext.map((contextItem)=>{
        return contextItem[0, $f2QOW.MARKETPLACE_ANALYTICS_CONTEXT_NAMESPACE]; // contextItem[MARKETPLACE_ANALYTICS_CONTEXT_NAMESPACE] should always be of MarketplaceAnalyticsContextItem type.
    }).filter(Boolean);
};
const $2fc648bcf8033ef2$export$df9eeec778c4dbf4 = (analyticsContext)=>{
    const allContexts = $2fc648bcf8033ef2$export$6d214f22a21009c2(analyticsContext);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7IZKi)))([
        {
            attributes: {},
            properties: {}
        },
        ...allContexts
    ]);
};

});
parcelRegister("7IZKi", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");

var $59fc89db827939ef$var$func = $jFIrw('mergeAll', (parcelRequire("2vzCR")));

$59fc89db827939ef$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $59fc89db827939ef$var$func;

});
parcelRegister("jFIrw", function(module, exports) {

var $imppR = parcelRequire("imppR");

var $a02m0 = parcelRequire("a02m0");
/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */ function $e524521dc9be9d0c$var$convert(name, func, options) {
    return $imppR($a02m0, name, func, options);
}
module.exports = $e524521dc9be9d0c$var$convert;

});
parcelRegister("imppR", function(module, exports) {

var $89eBv = parcelRequire("89eBv");

var $l6Yg9 = parcelRequire("l6Yg9");
/** Built-in value reference. */ var $d5ddff315914c7cb$var$push = Array.prototype.push;
/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */ function $d5ddff315914c7cb$var$baseArity(func, n) {
    return n == 2 ? function(a, b) {
        return func.apply(undefined, arguments);
    } : function(a) {
        return func.apply(undefined, arguments);
    };
}
/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */ function $d5ddff315914c7cb$var$baseAry(func, n) {
    return n == 2 ? function(a, b) {
        return func(a, b);
    } : function(a) {
        return func(a);
    };
}
/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */ function $d5ddff315914c7cb$var$cloneArray(array) {
    var length = array ? array.length : 0, result = Array(length);
    while(length--)result[length] = array[length];
    return result;
}
/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */ function $d5ddff315914c7cb$var$createCloner(func) {
    return function(object) {
        return func({}, object);
    };
}
/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */ function $d5ddff315914c7cb$var$flatSpread(func, start) {
    return function() {
        var length = arguments.length, lastIndex = length - 1, args = Array(length);
        while(length--)args[length] = arguments[length];
        var array = args[start], otherArgs = args.slice(0, start);
        if (array) $d5ddff315914c7cb$var$push.apply(otherArgs, array);
        if (start != lastIndex) $d5ddff315914c7cb$var$push.apply(otherArgs, args.slice(start + 1));
        return func.apply(this, otherArgs);
    };
}
/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */ function $d5ddff315914c7cb$var$wrapImmutable(func, cloner) {
    return function() {
        var length = arguments.length;
        if (!length) return;
        var args = Array(length);
        while(length--)args[length] = arguments[length];
        var result = args[0] = cloner.apply(undefined, args);
        func.apply(undefined, args);
        return result;
    };
}
/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */ function $d5ddff315914c7cb$var$baseConvert(util, name, func, options) {
    var isLib = typeof name == 'function', isObj = name === Object(name);
    if (isObj) {
        options = func;
        func = name;
        name = undefined;
    }
    if (func == null) throw new TypeError;
    options || (options = {});
    var config = {
        'cap': 'cap' in options ? options.cap : true,
        'curry': 'curry' in options ? options.curry : true,
        'fixed': 'fixed' in options ? options.fixed : true,
        'immutable': 'immutable' in options ? options.immutable : true,
        'rearg': 'rearg' in options ? options.rearg : true
    };
    var defaultHolder = isLib ? func : $l6Yg9, forceCurry = 'curry' in options && options.curry, forceFixed = 'fixed' in options && options.fixed, forceRearg = 'rearg' in options && options.rearg, pristine = isLib ? func.runInContext() : undefined;
    var helpers = isLib ? func : {
        'ary': util.ary,
        'assign': util.assign,
        'clone': util.clone,
        'curry': util.curry,
        'forEach': util.forEach,
        'isArray': util.isArray,
        'isError': util.isError,
        'isFunction': util.isFunction,
        'isWeakMap': util.isWeakMap,
        'iteratee': util.iteratee,
        'keys': util.keys,
        'rearg': util.rearg,
        'toInteger': util.toInteger,
        'toPath': util.toPath
    };
    var ary = helpers.ary, assign = helpers.assign, clone = helpers.clone, curry = helpers.curry, each = helpers.forEach, isArray = helpers.isArray, isError = helpers.isError, isFunction = helpers.isFunction, isWeakMap = helpers.isWeakMap, keys = helpers.keys, rearg = helpers.rearg, toInteger = helpers.toInteger, toPath = helpers.toPath;
    var aryMethodKeys = keys($89eBv.aryMethod);
    var wrappers = {
        'castArray': function(castArray) {
            return function() {
                var value = arguments[0];
                return isArray(value) ? castArray($d5ddff315914c7cb$var$cloneArray(value)) : castArray.apply(undefined, arguments);
            };
        },
        'iteratee': function(iteratee) {
            return function() {
                var func = arguments[0], arity = arguments[1], result = iteratee(func, arity), length = result.length;
                if (config.cap && typeof arity == 'number') {
                    arity = arity > 2 ? arity - 2 : 1;
                    return length && length <= arity ? result : $d5ddff315914c7cb$var$baseAry(result, arity);
                }
                return result;
            };
        },
        'mixin': function(mixin) {
            return function(source) {
                var func = this;
                if (!isFunction(func)) return mixin(func, Object(source));
                var pairs = [];
                each(keys(source), function(key) {
                    if (isFunction(source[key])) pairs.push([
                        key,
                        func.prototype[key]
                    ]);
                });
                mixin(func, Object(source));
                each(pairs, function(pair) {
                    var value = pair[1];
                    if (isFunction(value)) func.prototype[pair[0]] = value;
                    else delete func.prototype[pair[0]];
                });
                return func;
            };
        },
        'nthArg': function(nthArg) {
            return function(n) {
                var arity = n < 0 ? 1 : toInteger(n) + 1;
                return curry(nthArg(n), arity);
            };
        },
        'rearg': function(rearg) {
            return function(func, indexes) {
                var arity = indexes ? indexes.length : 0;
                return curry(rearg(func, indexes), arity);
            };
        },
        'runInContext': function(runInContext) {
            return function(context) {
                return $d5ddff315914c7cb$var$baseConvert(util, runInContext(context), options);
            };
        }
    };
    /*--------------------------------------------------------------------------*/ /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */ function castCap(name, func) {
        if (config.cap) {
            var indexes = $89eBv.iterateeRearg[name];
            if (indexes) return iterateeRearg(func, indexes);
            var n = !isLib && $89eBv.iterateeAry[name];
            if (n) return iterateeAry(func, n);
        }
        return func;
    }
    /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castCurry(name, func, n) {
        return forceCurry || config.curry && n > 1 ? curry(func, n) : func;
    }
    /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */ function castFixed(name, func, n) {
        if (config.fixed && (forceFixed || !$89eBv.skipFixed[name])) {
            var data = $89eBv.methodSpread[name], start = data && data.start;
            return start === undefined ? ary(func, n) : $d5ddff315914c7cb$var$flatSpread(func, start);
        }
        return func;
    }
    /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castRearg(name, func, n) {
        return config.rearg && n > 1 && (forceRearg || !$89eBv.skipRearg[name]) ? rearg(func, $89eBv.methodRearg[name] || $89eBv.aryRearg[n]) : func;
    }
    /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */ function cloneByPath(object, path) {
        path = toPath(path);
        var index = -1, length = path.length, lastIndex = length - 1, result = clone(Object(object)), nested = result;
        while(nested != null && ++index < length){
            var key = path[index], value = nested[key];
            if (value != null && !(isFunction(value) || isError(value) || isWeakMap(value))) nested[key] = clone(index == lastIndex ? value : Object(value));
            nested = nested[key];
        }
        return result;
    }
    /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */ function convertLib(options) {
        return _.runInContext.convert(options)(undefined);
    }
    /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */ function createConverter(name, func) {
        var realName = $89eBv.aliasToReal[name] || name, methodName = $89eBv.remap[realName] || realName, oldOptions = options;
        return function(options) {
            var newUtil = isLib ? pristine : helpers, newFunc = isLib ? pristine[methodName] : func, newOptions = assign(assign({}, oldOptions), options);
            return $d5ddff315914c7cb$var$baseConvert(newUtil, realName, newFunc, newOptions);
        };
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */ function iterateeAry(func, n) {
        return overArg(func, function(func) {
            return typeof func == 'function' ? $d5ddff315914c7cb$var$baseAry(func, n) : func;
        });
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */ function iterateeRearg(func, indexes) {
        return overArg(func, function(func) {
            var n = indexes.length;
            return $d5ddff315914c7cb$var$baseArity(rearg($d5ddff315914c7cb$var$baseAry(func, n), indexes), n);
        });
    }
    /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function() {
            var length = arguments.length;
            if (!length) return func();
            var args = Array(length);
            while(length--)args[length] = arguments[length];
            var index = config.rearg ? 0 : length - 1;
            args[index] = transform(args[index]);
            return func.apply(undefined, args);
        };
    }
    /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */ function wrap(name, func, placeholder) {
        var result, realName = $89eBv.aliasToReal[name] || name, wrapped = func, wrapper = wrappers[realName];
        if (wrapper) wrapped = wrapper(func);
        else if (config.immutable) {
            if ($89eBv.mutate.array[realName]) wrapped = $d5ddff315914c7cb$var$wrapImmutable(func, $d5ddff315914c7cb$var$cloneArray);
            else if ($89eBv.mutate.object[realName]) wrapped = $d5ddff315914c7cb$var$wrapImmutable(func, $d5ddff315914c7cb$var$createCloner(func));
            else if ($89eBv.mutate.set[realName]) wrapped = $d5ddff315914c7cb$var$wrapImmutable(func, cloneByPath);
        }
        each(aryMethodKeys, function(aryKey) {
            each($89eBv.aryMethod[aryKey], function(otherName) {
                if (realName == otherName) {
                    var data = $89eBv.methodSpread[realName], afterRearg = data && data.afterRearg;
                    result = afterRearg ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey) : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);
                    result = castCap(realName, result);
                    result = castCurry(realName, result, aryKey);
                    return false;
                }
            });
            return !result;
        });
        result || (result = wrapped);
        if (result == func) result = forceCurry ? curry(result, 1) : function() {
            return func.apply(this, arguments);
        };
        result.convert = createConverter(realName, func);
        result.placeholder = func.placeholder = placeholder;
        return result;
    }
    /*--------------------------------------------------------------------------*/ if (!isObj) return wrap(name, func, defaultHolder);
    var _ = func;
    // Convert methods by ary cap.
    var pairs = [];
    each(aryMethodKeys, function(aryKey) {
        each($89eBv.aryMethod[aryKey], function(key) {
            var func = _[$89eBv.remap[key] || key];
            if (func) pairs.push([
                key,
                wrap(key, func, _)
            ]);
        });
    });
    // Convert remaining methods.
    each(keys(_), function(key) {
        var func = _[key];
        if (typeof func == 'function') {
            var length = pairs.length;
            while(length--){
                if (pairs[length][0] == key) return;
            }
            func.convert = createConverter(key, func);
            pairs.push([
                key,
                func
            ]);
        }
    });
    // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
    each(pairs, function(pair) {
        _[pair[0]] = pair[1];
    });
    _.convert = convertLib;
    _.placeholder = _;
    // Assign aliases.
    each(keys(_), function(key) {
        each($89eBv.realToAlias[key] || [], function(alias) {
            _[alias] = _[key];
        });
    });
    return _;
}
module.exports = $d5ddff315914c7cb$var$baseConvert;

});
parcelRegister("89eBv", function(module, exports) {

$parcel$export(module.exports, "aliasToReal", () => $5eea7e08a1db1590$export$bd0f5e6e44efa6b4, (v) => $5eea7e08a1db1590$export$bd0f5e6e44efa6b4 = v);
$parcel$export(module.exports, "aryMethod", () => $5eea7e08a1db1590$export$85c665b4d7da9cb4, (v) => $5eea7e08a1db1590$export$85c665b4d7da9cb4 = v);
$parcel$export(module.exports, "aryRearg", () => $5eea7e08a1db1590$export$42564e045b285e32, (v) => $5eea7e08a1db1590$export$42564e045b285e32 = v);
$parcel$export(module.exports, "iterateeAry", () => $5eea7e08a1db1590$export$81e17196e6a22b07, (v) => $5eea7e08a1db1590$export$81e17196e6a22b07 = v);
$parcel$export(module.exports, "iterateeRearg", () => $5eea7e08a1db1590$export$30975ceb42167ebd, (v) => $5eea7e08a1db1590$export$30975ceb42167ebd = v);
$parcel$export(module.exports, "methodRearg", () => $5eea7e08a1db1590$export$8ceb0ad7e94d3801, (v) => $5eea7e08a1db1590$export$8ceb0ad7e94d3801 = v);
$parcel$export(module.exports, "methodSpread", () => $5eea7e08a1db1590$export$fbaeb3f87df3cf26, (v) => $5eea7e08a1db1590$export$fbaeb3f87df3cf26 = v);
$parcel$export(module.exports, "mutate", () => $5eea7e08a1db1590$export$57e795267c26e600, (v) => $5eea7e08a1db1590$export$57e795267c26e600 = v);
$parcel$export(module.exports, "realToAlias", () => $5eea7e08a1db1590$export$1eb71a7e27943e71, (v) => $5eea7e08a1db1590$export$1eb71a7e27943e71 = v);
$parcel$export(module.exports, "remap", () => $5eea7e08a1db1590$export$aee1dbae5de2db9d, (v) => $5eea7e08a1db1590$export$aee1dbae5de2db9d = v);
$parcel$export(module.exports, "skipFixed", () => $5eea7e08a1db1590$export$87ffbe4821a5d5e0, (v) => $5eea7e08a1db1590$export$87ffbe4821a5d5e0 = v);
$parcel$export(module.exports, "skipRearg", () => $5eea7e08a1db1590$export$b4d07413ce528c90, (v) => $5eea7e08a1db1590$export$b4d07413ce528c90 = v);
/** Used to map aliases to their real names. */ var $5eea7e08a1db1590$export$bd0f5e6e44efa6b4;
/** Used to map ary to method names. */ var $5eea7e08a1db1590$export$85c665b4d7da9cb4;
/** Used to map ary to rearg configs. */ var $5eea7e08a1db1590$export$42564e045b285e32;
/** Used to map method names to their iteratee ary. */ var $5eea7e08a1db1590$export$81e17196e6a22b07;
/** Used to map method names to iteratee rearg configs. */ var $5eea7e08a1db1590$export$30975ceb42167ebd;
/** Used to map method names to rearg configs. */ var $5eea7e08a1db1590$export$8ceb0ad7e94d3801;
/** Used to map method names to spread configs. */ var $5eea7e08a1db1590$export$fbaeb3f87df3cf26;
/** Used to identify methods which mutate arrays or objects. */ var $5eea7e08a1db1590$export$57e795267c26e600;
/** Used to map real names to their aliases. */ var $5eea7e08a1db1590$export$1eb71a7e27943e71;
/** Used to map method names to other names. */ var $5eea7e08a1db1590$export$aee1dbae5de2db9d;
/** Used to track methods that skip fixing their arity. */ var $5eea7e08a1db1590$export$87ffbe4821a5d5e0;
/** Used to track methods that skip rearranging arguments. */ var $5eea7e08a1db1590$export$b4d07413ce528c90;
$5eea7e08a1db1590$export$bd0f5e6e44efa6b4 = {
    // Lodash aliases.
    'each': 'forEach',
    'eachRight': 'forEachRight',
    'entries': 'toPairs',
    'entriesIn': 'toPairsIn',
    'extend': 'assignIn',
    'extendAll': 'assignInAll',
    'extendAllWith': 'assignInAllWith',
    'extendWith': 'assignInWith',
    'first': 'head',
    // Methods that are curried variants of others.
    'conforms': 'conformsTo',
    'matches': 'isMatch',
    'property': 'get',
    // Ramda aliases.
    '__': 'placeholder',
    'F': 'stubFalse',
    'T': 'stubTrue',
    'all': 'every',
    'allPass': 'overEvery',
    'always': 'constant',
    'any': 'some',
    'anyPass': 'overSome',
    'apply': 'spread',
    'assoc': 'set',
    'assocPath': 'set',
    'complement': 'negate',
    'compose': 'flowRight',
    'contains': 'includes',
    'dissoc': 'unset',
    'dissocPath': 'unset',
    'dropLast': 'dropRight',
    'dropLastWhile': 'dropRightWhile',
    'equals': 'isEqual',
    'identical': 'eq',
    'indexBy': 'keyBy',
    'init': 'initial',
    'invertObj': 'invert',
    'juxt': 'over',
    'omitAll': 'omit',
    'nAry': 'ary',
    'path': 'get',
    'pathEq': 'matchesProperty',
    'pathOr': 'getOr',
    'paths': 'at',
    'pickAll': 'pick',
    'pipe': 'flow',
    'pluck': 'map',
    'prop': 'get',
    'propEq': 'matchesProperty',
    'propOr': 'getOr',
    'props': 'at',
    'symmetricDifference': 'xor',
    'symmetricDifferenceBy': 'xorBy',
    'symmetricDifferenceWith': 'xorWith',
    'takeLast': 'takeRight',
    'takeLastWhile': 'takeRightWhile',
    'unapply': 'rest',
    'unnest': 'flatten',
    'useWith': 'overArgs',
    'where': 'conformsTo',
    'whereEq': 'isMatch',
    'zipObj': 'zipObject'
};
$5eea7e08a1db1590$export$85c665b4d7da9cb4 = {
    '1': [
        'assignAll',
        'assignInAll',
        'attempt',
        'castArray',
        'ceil',
        'create',
        'curry',
        'curryRight',
        'defaultsAll',
        'defaultsDeepAll',
        'floor',
        'flow',
        'flowRight',
        'fromPairs',
        'invert',
        'iteratee',
        'memoize',
        'method',
        'mergeAll',
        'methodOf',
        'mixin',
        'nthArg',
        'over',
        'overEvery',
        'overSome',
        'rest',
        'reverse',
        'round',
        'runInContext',
        'spread',
        'template',
        'trim',
        'trimEnd',
        'trimStart',
        'uniqueId',
        'words',
        'zipAll'
    ],
    '2': [
        'add',
        'after',
        'ary',
        'assign',
        'assignAllWith',
        'assignIn',
        'assignInAllWith',
        'at',
        'before',
        'bind',
        'bindAll',
        'bindKey',
        'chunk',
        'cloneDeepWith',
        'cloneWith',
        'concat',
        'conformsTo',
        'countBy',
        'curryN',
        'curryRightN',
        'debounce',
        'defaults',
        'defaultsDeep',
        'defaultTo',
        'delay',
        'difference',
        'divide',
        'drop',
        'dropRight',
        'dropRightWhile',
        'dropWhile',
        'endsWith',
        'eq',
        'every',
        'filter',
        'find',
        'findIndex',
        'findKey',
        'findLast',
        'findLastIndex',
        'findLastKey',
        'flatMap',
        'flatMapDeep',
        'flattenDepth',
        'forEach',
        'forEachRight',
        'forIn',
        'forInRight',
        'forOwn',
        'forOwnRight',
        'get',
        'groupBy',
        'gt',
        'gte',
        'has',
        'hasIn',
        'includes',
        'indexOf',
        'intersection',
        'invertBy',
        'invoke',
        'invokeMap',
        'isEqual',
        'isMatch',
        'join',
        'keyBy',
        'lastIndexOf',
        'lt',
        'lte',
        'map',
        'mapKeys',
        'mapValues',
        'matchesProperty',
        'maxBy',
        'meanBy',
        'merge',
        'mergeAllWith',
        'minBy',
        'multiply',
        'nth',
        'omit',
        'omitBy',
        'overArgs',
        'pad',
        'padEnd',
        'padStart',
        'parseInt',
        'partial',
        'partialRight',
        'partition',
        'pick',
        'pickBy',
        'propertyOf',
        'pull',
        'pullAll',
        'pullAt',
        'random',
        'range',
        'rangeRight',
        'rearg',
        'reject',
        'remove',
        'repeat',
        'restFrom',
        'result',
        'sampleSize',
        'some',
        'sortBy',
        'sortedIndex',
        'sortedIndexOf',
        'sortedLastIndex',
        'sortedLastIndexOf',
        'sortedUniqBy',
        'split',
        'spreadFrom',
        'startsWith',
        'subtract',
        'sumBy',
        'take',
        'takeRight',
        'takeRightWhile',
        'takeWhile',
        'tap',
        'throttle',
        'thru',
        'times',
        'trimChars',
        'trimCharsEnd',
        'trimCharsStart',
        'truncate',
        'union',
        'uniqBy',
        'uniqWith',
        'unset',
        'unzipWith',
        'without',
        'wrap',
        'xor',
        'zip',
        'zipObject',
        'zipObjectDeep'
    ],
    '3': [
        'assignInWith',
        'assignWith',
        'clamp',
        'differenceBy',
        'differenceWith',
        'findFrom',
        'findIndexFrom',
        'findLastFrom',
        'findLastIndexFrom',
        'getOr',
        'includesFrom',
        'indexOfFrom',
        'inRange',
        'intersectionBy',
        'intersectionWith',
        'invokeArgs',
        'invokeArgsMap',
        'isEqualWith',
        'isMatchWith',
        'flatMapDepth',
        'lastIndexOfFrom',
        'mergeWith',
        'orderBy',
        'padChars',
        'padCharsEnd',
        'padCharsStart',
        'pullAllBy',
        'pullAllWith',
        'rangeStep',
        'rangeStepRight',
        'reduce',
        'reduceRight',
        'replace',
        'set',
        'slice',
        'sortedIndexBy',
        'sortedLastIndexBy',
        'transform',
        'unionBy',
        'unionWith',
        'update',
        'xorBy',
        'xorWith',
        'zipWith'
    ],
    '4': [
        'fill',
        'setWith',
        'updateWith'
    ]
};
$5eea7e08a1db1590$export$42564e045b285e32 = {
    '2': [
        1,
        0
    ],
    '3': [
        2,
        0,
        1
    ],
    '4': [
        3,
        2,
        0,
        1
    ]
};
$5eea7e08a1db1590$export$81e17196e6a22b07 = {
    'dropRightWhile': 1,
    'dropWhile': 1,
    'every': 1,
    'filter': 1,
    'find': 1,
    'findFrom': 1,
    'findIndex': 1,
    'findIndexFrom': 1,
    'findKey': 1,
    'findLast': 1,
    'findLastFrom': 1,
    'findLastIndex': 1,
    'findLastIndexFrom': 1,
    'findLastKey': 1,
    'flatMap': 1,
    'flatMapDeep': 1,
    'flatMapDepth': 1,
    'forEach': 1,
    'forEachRight': 1,
    'forIn': 1,
    'forInRight': 1,
    'forOwn': 1,
    'forOwnRight': 1,
    'map': 1,
    'mapKeys': 1,
    'mapValues': 1,
    'partition': 1,
    'reduce': 2,
    'reduceRight': 2,
    'reject': 1,
    'remove': 1,
    'some': 1,
    'takeRightWhile': 1,
    'takeWhile': 1,
    'times': 1,
    'transform': 2
};
$5eea7e08a1db1590$export$30975ceb42167ebd = {
    'mapKeys': [
        1
    ],
    'reduceRight': [
        1,
        0
    ]
};
$5eea7e08a1db1590$export$8ceb0ad7e94d3801 = {
    'assignInAllWith': [
        1,
        0
    ],
    'assignInWith': [
        1,
        2,
        0
    ],
    'assignAllWith': [
        1,
        0
    ],
    'assignWith': [
        1,
        2,
        0
    ],
    'differenceBy': [
        1,
        2,
        0
    ],
    'differenceWith': [
        1,
        2,
        0
    ],
    'getOr': [
        2,
        1,
        0
    ],
    'intersectionBy': [
        1,
        2,
        0
    ],
    'intersectionWith': [
        1,
        2,
        0
    ],
    'isEqualWith': [
        1,
        2,
        0
    ],
    'isMatchWith': [
        2,
        1,
        0
    ],
    'mergeAllWith': [
        1,
        0
    ],
    'mergeWith': [
        1,
        2,
        0
    ],
    'padChars': [
        2,
        1,
        0
    ],
    'padCharsEnd': [
        2,
        1,
        0
    ],
    'padCharsStart': [
        2,
        1,
        0
    ],
    'pullAllBy': [
        2,
        1,
        0
    ],
    'pullAllWith': [
        2,
        1,
        0
    ],
    'rangeStep': [
        1,
        2,
        0
    ],
    'rangeStepRight': [
        1,
        2,
        0
    ],
    'setWith': [
        3,
        1,
        2,
        0
    ],
    'sortedIndexBy': [
        2,
        1,
        0
    ],
    'sortedLastIndexBy': [
        2,
        1,
        0
    ],
    'unionBy': [
        1,
        2,
        0
    ],
    'unionWith': [
        1,
        2,
        0
    ],
    'updateWith': [
        3,
        1,
        2,
        0
    ],
    'xorBy': [
        1,
        2,
        0
    ],
    'xorWith': [
        1,
        2,
        0
    ],
    'zipWith': [
        1,
        2,
        0
    ]
};
$5eea7e08a1db1590$export$fbaeb3f87df3cf26 = {
    'assignAll': {
        'start': 0
    },
    'assignAllWith': {
        'start': 0
    },
    'assignInAll': {
        'start': 0
    },
    'assignInAllWith': {
        'start': 0
    },
    'defaultsAll': {
        'start': 0
    },
    'defaultsDeepAll': {
        'start': 0
    },
    'invokeArgs': {
        'start': 2
    },
    'invokeArgsMap': {
        'start': 2
    },
    'mergeAll': {
        'start': 0
    },
    'mergeAllWith': {
        'start': 0
    },
    'partial': {
        'start': 1
    },
    'partialRight': {
        'start': 1
    },
    'without': {
        'start': 1
    },
    'zipAll': {
        'start': 0
    }
};
$5eea7e08a1db1590$export$57e795267c26e600 = {
    'array': {
        'fill': true,
        'pull': true,
        'pullAll': true,
        'pullAllBy': true,
        'pullAllWith': true,
        'pullAt': true,
        'remove': true,
        'reverse': true
    },
    'object': {
        'assign': true,
        'assignAll': true,
        'assignAllWith': true,
        'assignIn': true,
        'assignInAll': true,
        'assignInAllWith': true,
        'assignInWith': true,
        'assignWith': true,
        'defaults': true,
        'defaultsAll': true,
        'defaultsDeep': true,
        'defaultsDeepAll': true,
        'merge': true,
        'mergeAll': true,
        'mergeAllWith': true,
        'mergeWith': true
    },
    'set': {
        'set': true,
        'setWith': true,
        'unset': true,
        'update': true,
        'updateWith': true
    }
};
$5eea7e08a1db1590$export$1eb71a7e27943e71 = function() {
    var hasOwnProperty = Object.prototype.hasOwnProperty, object = $5eea7e08a1db1590$export$bd0f5e6e44efa6b4, result = {};
    for(var key in object){
        var value = object[key];
        if (hasOwnProperty.call(result, value)) result[value].push(key);
        else result[value] = [
            key
        ];
    }
    return result;
}();
$5eea7e08a1db1590$export$aee1dbae5de2db9d = {
    'assignAll': 'assign',
    'assignAllWith': 'assignWith',
    'assignInAll': 'assignIn',
    'assignInAllWith': 'assignInWith',
    'curryN': 'curry',
    'curryRightN': 'curryRight',
    'defaultsAll': 'defaults',
    'defaultsDeepAll': 'defaultsDeep',
    'findFrom': 'find',
    'findIndexFrom': 'findIndex',
    'findLastFrom': 'findLast',
    'findLastIndexFrom': 'findLastIndex',
    'getOr': 'get',
    'includesFrom': 'includes',
    'indexOfFrom': 'indexOf',
    'invokeArgs': 'invoke',
    'invokeArgsMap': 'invokeMap',
    'lastIndexOfFrom': 'lastIndexOf',
    'mergeAll': 'merge',
    'mergeAllWith': 'mergeWith',
    'padChars': 'pad',
    'padCharsEnd': 'padEnd',
    'padCharsStart': 'padStart',
    'propertyOf': 'get',
    'rangeStep': 'range',
    'rangeStepRight': 'rangeRight',
    'restFrom': 'rest',
    'spreadFrom': 'spread',
    'trimChars': 'trim',
    'trimCharsEnd': 'trimEnd',
    'trimCharsStart': 'trimStart',
    'zipAll': 'zip'
};
$5eea7e08a1db1590$export$87ffbe4821a5d5e0 = {
    'castArray': true,
    'flow': true,
    'flowRight': true,
    'iteratee': true,
    'mixin': true,
    'rearg': true,
    'runInContext': true
};
$5eea7e08a1db1590$export$b4d07413ce528c90 = {
    'add': true,
    'assign': true,
    'assignIn': true,
    'bind': true,
    'bindKey': true,
    'concat': true,
    'difference': true,
    'divide': true,
    'eq': true,
    'gt': true,
    'gte': true,
    'isEqual': true,
    'lt': true,
    'lte': true,
    'matchesProperty': true,
    'merge': true,
    'multiply': true,
    'overArgs': true,
    'partial': true,
    'partialRight': true,
    'propertyOf': true,
    'random': true,
    'range': true,
    'rangeRight': true,
    'subtract': true,
    'zip': true,
    'zipObject': true,
    'zipObjectDeep': true
};

});

parcelRegister("l6Yg9", function(module, exports) {
/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */ module.exports = {};

});


parcelRegister("a02m0", function(module, exports) {














module.exports = {
    'ary': (parcelRequire("iX5mF")),
    'assign': (parcelRequire("k1JQY")),
    'clone': (parcelRequire("E0NNP")),
    'curry': (parcelRequire("cleLA")),
    'forEach': (parcelRequire("9Kzih")),
    'isArray': (parcelRequire("1c8hB")),
    'isError': (parcelRequire("dbogu")),
    'isFunction': (parcelRequire("eoCgY")),
    'isWeakMap': (parcelRequire("a1CHL")),
    'iteratee': (parcelRequire("akHxB")),
    'keys': (parcelRequire("fCpZe")),
    'rearg': (parcelRequire("k5dRT")),
    'toInteger': (parcelRequire("hNahz")),
    'toPath': (parcelRequire("d0KBl"))
};

});
parcelRegister("iX5mF", function(module, exports) {

var $xQ3hV = parcelRequire("xQ3hV");
/** Used to compose bitmasks for function metadata. */ var $dcc1e600da485164$var$WRAP_ARY_FLAG = 128;
/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */ function $dcc1e600da485164$var$ary(func, n, guard) {
    n = guard ? undefined : n;
    n = func && n == null ? func.length : n;
    return $xQ3hV(func, $dcc1e600da485164$var$WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}
module.exports = $dcc1e600da485164$var$ary;

});
parcelRegister("xQ3hV", function(module, exports) {

var $2n5KA = parcelRequire("2n5KA");

var $ajgvA = parcelRequire("ajgvA");

var $4sFI9 = parcelRequire("4sFI9");

var $dJxZV = parcelRequire("dJxZV");

var $3slGh = parcelRequire("3slGh");

var $6bTTb = parcelRequire("6bTTb");

var $fHM5F = parcelRequire("fHM5F");

var $bV9co = parcelRequire("bV9co");

var $3mXyn = parcelRequire("3mXyn");

var $hNahz = parcelRequire("hNahz");
/** Error message constants. */ var $065b75a1a2ef24b3$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to compose bitmasks for function metadata. */ var $065b75a1a2ef24b3$var$WRAP_BIND_FLAG = 1, $065b75a1a2ef24b3$var$WRAP_BIND_KEY_FLAG = 2, $065b75a1a2ef24b3$var$WRAP_CURRY_FLAG = 8, $065b75a1a2ef24b3$var$WRAP_CURRY_RIGHT_FLAG = 16, $065b75a1a2ef24b3$var$WRAP_PARTIAL_FLAG = 32, $065b75a1a2ef24b3$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $065b75a1a2ef24b3$var$nativeMax = Math.max;
/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $065b75a1a2ef24b3$var$createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
    var isBindKey = bitmask & $065b75a1a2ef24b3$var$WRAP_BIND_KEY_FLAG;
    if (!isBindKey && typeof func != 'function') throw new TypeError($065b75a1a2ef24b3$var$FUNC_ERROR_TEXT);
    var length = partials ? partials.length : 0;
    if (!length) {
        bitmask &= ~($065b75a1a2ef24b3$var$WRAP_PARTIAL_FLAG | $065b75a1a2ef24b3$var$WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
    }
    ary = ary === undefined ? ary : $065b75a1a2ef24b3$var$nativeMax($hNahz(ary), 0);
    arity = arity === undefined ? arity : $hNahz(arity);
    length -= holders ? holders.length : 0;
    if (bitmask & $065b75a1a2ef24b3$var$WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials, holdersRight = holders;
        partials = holders = undefined;
    }
    var data = isBindKey ? undefined : $6bTTb(func);
    var newData = [
        func,
        bitmask,
        thisArg,
        partials,
        holders,
        partialsRight,
        holdersRight,
        argPos,
        ary,
        arity
    ];
    if (data) $fHM5F(newData, data);
    func = newData[0];
    bitmask = newData[1];
    thisArg = newData[2];
    partials = newData[3];
    holders = newData[4];
    arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : $065b75a1a2ef24b3$var$nativeMax(newData[9] - length, 0);
    if (!arity && bitmask & ($065b75a1a2ef24b3$var$WRAP_CURRY_FLAG | $065b75a1a2ef24b3$var$WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~($065b75a1a2ef24b3$var$WRAP_CURRY_FLAG | $065b75a1a2ef24b3$var$WRAP_CURRY_RIGHT_FLAG);
    if (!bitmask || bitmask == $065b75a1a2ef24b3$var$WRAP_BIND_FLAG) var result = $ajgvA(func, bitmask, thisArg);
    else if (bitmask == $065b75a1a2ef24b3$var$WRAP_CURRY_FLAG || bitmask == $065b75a1a2ef24b3$var$WRAP_CURRY_RIGHT_FLAG) result = $4sFI9(func, bitmask, arity);
    else if ((bitmask == $065b75a1a2ef24b3$var$WRAP_PARTIAL_FLAG || bitmask == ($065b75a1a2ef24b3$var$WRAP_BIND_FLAG | $065b75a1a2ef24b3$var$WRAP_PARTIAL_FLAG)) && !holders.length) result = $3slGh(func, bitmask, thisArg, partials);
    else result = $dJxZV.apply(undefined, newData);
    var setter = data ? $2n5KA : $bV9co;
    return $3mXyn(setter(result, newData), func, bitmask);
}
module.exports = $065b75a1a2ef24b3$var$createWrap;

});
parcelRegister("2n5KA", function(module, exports) {

var $3QMTK = parcelRequire("3QMTK");

var $beYtW = parcelRequire("beYtW");
/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $1ba230a38b363991$var$baseSetData = !$beYtW ? $3QMTK : function(func, data) {
    $beYtW.set(func, data);
    return func;
};
module.exports = $1ba230a38b363991$var$baseSetData;

});

parcelRegister("ajgvA", function(module, exports) {

var $4ptXN = parcelRequire("4ptXN");

var $c1MCs = parcelRequire("c1MCs");
/** Used to compose bitmasks for function metadata. */ var $78187bf3ce07aa33$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $78187bf3ce07aa33$var$createBind(func, bitmask, thisArg) {
    var isBind = bitmask & $78187bf3ce07aa33$var$WRAP_BIND_FLAG, Ctor = $4ptXN(func);
    function wrapper() {
        var fn = this && this !== $c1MCs && this instanceof wrapper ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
    }
    return wrapper;
}
module.exports = $78187bf3ce07aa33$var$createBind;

});
parcelRegister("4ptXN", function(module, exports) {

var $9F9XB = parcelRequire("9F9XB");

var $feGjZ = parcelRequire("feGjZ");
/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */ function $3360bd57e2c33b86$var$createCtor(Ctor) {
    return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch(args.length){
            case 0:
                return new Ctor;
            case 1:
                return new Ctor(args[0]);
            case 2:
                return new Ctor(args[0], args[1]);
            case 3:
                return new Ctor(args[0], args[1], args[2]);
            case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = $9F9XB(Ctor.prototype), result = Ctor.apply(thisBinding, args);
        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return $feGjZ(result) ? result : thisBinding;
    };
}
module.exports = $3360bd57e2c33b86$var$createCtor;

});


parcelRegister("4sFI9", function(module, exports) {

var $5VdlS = parcelRequire("5VdlS");

var $4ptXN = parcelRequire("4ptXN");

var $dJxZV = parcelRequire("dJxZV");

var $lOKcz = parcelRequire("lOKcz");

var $9xQzO = parcelRequire("9xQzO");

var $kBgrU = parcelRequire("kBgrU");

var $c1MCs = parcelRequire("c1MCs");
/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $33fa21eee8bcca6f$var$createCurry(func, bitmask, arity) {
    var Ctor = $4ptXN(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length, placeholder = $9xQzO(wrapper);
        while(index--)args[index] = arguments[index];
        var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : $kBgrU(args, placeholder);
        length -= holders.length;
        if (length < arity) return $lOKcz(func, bitmask, $dJxZV, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
        var fn = this && this !== $c1MCs && this instanceof wrapper ? Ctor : func;
        return $5VdlS(fn, this, args);
    }
    return wrapper;
}
module.exports = $33fa21eee8bcca6f$var$createCurry;

});
parcelRegister("dJxZV", function(module, exports) {

var $98OfC = parcelRequire("98OfC");

var $aoNSM = parcelRequire("aoNSM");

var $24kQN = parcelRequire("24kQN");

var $4ptXN = parcelRequire("4ptXN");

var $lOKcz = parcelRequire("lOKcz");

var $9xQzO = parcelRequire("9xQzO");

var $jtjhF = parcelRequire("jtjhF");

var $kBgrU = parcelRequire("kBgrU");

var $c1MCs = parcelRequire("c1MCs");
/** Used to compose bitmasks for function metadata. */ var $9ff9d999ee3e5b26$var$WRAP_BIND_FLAG = 1, $9ff9d999ee3e5b26$var$WRAP_BIND_KEY_FLAG = 2, $9ff9d999ee3e5b26$var$WRAP_CURRY_FLAG = 8, $9ff9d999ee3e5b26$var$WRAP_CURRY_RIGHT_FLAG = 16, $9ff9d999ee3e5b26$var$WRAP_ARY_FLAG = 128, $9ff9d999ee3e5b26$var$WRAP_FLIP_FLAG = 512;
/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $9ff9d999ee3e5b26$var$createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
    var isAry = bitmask & $9ff9d999ee3e5b26$var$WRAP_ARY_FLAG, isBind = bitmask & $9ff9d999ee3e5b26$var$WRAP_BIND_FLAG, isBindKey = bitmask & $9ff9d999ee3e5b26$var$WRAP_BIND_KEY_FLAG, isCurried = bitmask & ($9ff9d999ee3e5b26$var$WRAP_CURRY_FLAG | $9ff9d999ee3e5b26$var$WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & $9ff9d999ee3e5b26$var$WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : $4ptXN(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length;
        while(index--)args[index] = arguments[index];
        if (isCurried) var placeholder = $9xQzO(wrapper), holdersCount = $24kQN(args, placeholder);
        if (partials) args = $98OfC(args, partials, holders, isCurried);
        if (partialsRight) args = $aoNSM(args, partialsRight, holdersRight, isCurried);
        length -= holdersCount;
        if (isCurried && length < arity) {
            var newHolders = $kBgrU(args, placeholder);
            return $lOKcz(func, bitmask, $9ff9d999ee3e5b26$var$createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
        }
        var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
        length = args.length;
        if (argPos) args = $jtjhF(args, argPos);
        else if (isFlip && length > 1) args.reverse();
        if (isAry && ary < length) args.length = ary;
        if (this && this !== $c1MCs && this instanceof wrapper) fn = Ctor || $4ptXN(fn);
        return fn.apply(thisBinding, args);
    }
    return wrapper;
}
module.exports = $9ff9d999ee3e5b26$var$createHybrid;

});
parcelRegister("98OfC", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6a7bd72e71453dbc$var$nativeMax = Math.max;
/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $6a7bd72e71453dbc$var$composeArgs(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = $6a7bd72e71453dbc$var$nativeMax(argsLength - holdersLength, 0), result = Array(leftLength + rangeLength), isUncurried = !isCurried;
    while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
    while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
    while(rangeLength--)result[leftIndex++] = args[argsIndex++];
    return result;
}
module.exports = $6a7bd72e71453dbc$var$composeArgs;

});

parcelRegister("aoNSM", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7922d6e81726c41f$var$nativeMax = Math.max;
/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $7922d6e81726c41f$var$composeArgsRight(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = $7922d6e81726c41f$var$nativeMax(argsLength - holdersLength, 0), result = Array(rangeLength + rightLength), isUncurried = !isCurried;
    while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
    var offset = argsIndex;
    while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
    while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
    return result;
}
module.exports = $7922d6e81726c41f$var$composeArgsRight;

});

parcelRegister("24kQN", function(module, exports) {
/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */ function $181c20ffe0a73f5e$var$countHolders(array, placeholder) {
    var length = array.length, result = 0;
    while(length--)if (array[length] === placeholder) ++result;
    return result;
}
module.exports = $181c20ffe0a73f5e$var$countHolders;

});

parcelRegister("lOKcz", function(module, exports) {

var $cp9gS = parcelRequire("cp9gS");

var $bV9co = parcelRequire("bV9co");

var $3mXyn = parcelRequire("3mXyn");
/** Used to compose bitmasks for function metadata. */ var $fe221b32db6745a2$var$WRAP_BIND_FLAG = 1, $fe221b32db6745a2$var$WRAP_BIND_KEY_FLAG = 2, $fe221b32db6745a2$var$WRAP_CURRY_BOUND_FLAG = 4, $fe221b32db6745a2$var$WRAP_CURRY_FLAG = 8, $fe221b32db6745a2$var$WRAP_PARTIAL_FLAG = 32, $fe221b32db6745a2$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $fe221b32db6745a2$var$createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
    var isCurry = bitmask & $fe221b32db6745a2$var$WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
    bitmask |= isCurry ? $fe221b32db6745a2$var$WRAP_PARTIAL_FLAG : $fe221b32db6745a2$var$WRAP_PARTIAL_RIGHT_FLAG;
    bitmask &= ~(isCurry ? $fe221b32db6745a2$var$WRAP_PARTIAL_RIGHT_FLAG : $fe221b32db6745a2$var$WRAP_PARTIAL_FLAG);
    if (!(bitmask & $fe221b32db6745a2$var$WRAP_CURRY_BOUND_FLAG)) bitmask &= ~($fe221b32db6745a2$var$WRAP_BIND_FLAG | $fe221b32db6745a2$var$WRAP_BIND_KEY_FLAG);
    var newData = [
        func,
        bitmask,
        thisArg,
        newPartials,
        newHolders,
        newPartialsRight,
        newHoldersRight,
        argPos,
        ary,
        arity
    ];
    var result = wrapFunc.apply(undefined, newData);
    if ($cp9gS(func)) $bV9co(result, newData);
    result.placeholder = placeholder;
    return $3mXyn(result, func, bitmask);
}
module.exports = $fe221b32db6745a2$var$createRecurry;

});
parcelRegister("bV9co", function(module, exports) {

var $2n5KA = parcelRequire("2n5KA");

var $d1V3m = parcelRequire("d1V3m");
/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $8adc2746a2aa5eeb$var$setData = $d1V3m($2n5KA);
module.exports = $8adc2746a2aa5eeb$var$setData;

});

parcelRegister("3mXyn", function(module, exports) {

var $4pgZb = parcelRequire("4pgZb");

var $1k0ou = parcelRequire("1k0ou");

var $ly0Gc = parcelRequire("ly0Gc");

var $7YePn = parcelRequire("7YePn");
/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */ function $27419f3ed4dc5d4c$var$setWrapToString(wrapper, reference, bitmask) {
    var source = reference + '';
    return $ly0Gc(wrapper, $1k0ou(source, $7YePn($4pgZb(source), bitmask)));
}
module.exports = $27419f3ed4dc5d4c$var$setWrapToString;

});
parcelRegister("4pgZb", function(module, exports) {
/** Used to match wrap detail comments. */ var $3356ac43c54e635f$var$reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, $3356ac43c54e635f$var$reSplitDetails = /,? & /;
/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */ function $3356ac43c54e635f$var$getWrapDetails(source) {
    var match = source.match($3356ac43c54e635f$var$reWrapDetails);
    return match ? match[1].split($3356ac43c54e635f$var$reSplitDetails) : [];
}
module.exports = $3356ac43c54e635f$var$getWrapDetails;

});

parcelRegister("1k0ou", function(module, exports) {
/** Used to match wrap detail comments. */ var $0f67f6f702bebdca$var$reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */ function $0f67f6f702bebdca$var$insertWrapDetails(source, details) {
    var length = details.length;
    if (!length) return source;
    var lastIndex = length - 1;
    details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
    details = details.join(length > 2 ? ', ' : ' ');
    return source.replace($0f67f6f702bebdca$var$reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}
module.exports = $0f67f6f702bebdca$var$insertWrapDetails;

});

parcelRegister("7YePn", function(module, exports) {

var $9Kzih = parcelRequire("9Kzih");

var $lqZWH = parcelRequire("lqZWH");
/** Used to compose bitmasks for function metadata. */ var $5cd9a37742eb8774$var$WRAP_BIND_FLAG = 1, $5cd9a37742eb8774$var$WRAP_BIND_KEY_FLAG = 2, $5cd9a37742eb8774$var$WRAP_CURRY_FLAG = 8, $5cd9a37742eb8774$var$WRAP_CURRY_RIGHT_FLAG = 16, $5cd9a37742eb8774$var$WRAP_PARTIAL_FLAG = 32, $5cd9a37742eb8774$var$WRAP_PARTIAL_RIGHT_FLAG = 64, $5cd9a37742eb8774$var$WRAP_ARY_FLAG = 128, $5cd9a37742eb8774$var$WRAP_REARG_FLAG = 256, $5cd9a37742eb8774$var$WRAP_FLIP_FLAG = 512;
/** Used to associate wrap methods with their bit flags. */ var $5cd9a37742eb8774$var$wrapFlags = [
    [
        'ary',
        $5cd9a37742eb8774$var$WRAP_ARY_FLAG
    ],
    [
        'bind',
        $5cd9a37742eb8774$var$WRAP_BIND_FLAG
    ],
    [
        'bindKey',
        $5cd9a37742eb8774$var$WRAP_BIND_KEY_FLAG
    ],
    [
        'curry',
        $5cd9a37742eb8774$var$WRAP_CURRY_FLAG
    ],
    [
        'curryRight',
        $5cd9a37742eb8774$var$WRAP_CURRY_RIGHT_FLAG
    ],
    [
        'flip',
        $5cd9a37742eb8774$var$WRAP_FLIP_FLAG
    ],
    [
        'partial',
        $5cd9a37742eb8774$var$WRAP_PARTIAL_FLAG
    ],
    [
        'partialRight',
        $5cd9a37742eb8774$var$WRAP_PARTIAL_RIGHT_FLAG
    ],
    [
        'rearg',
        $5cd9a37742eb8774$var$WRAP_REARG_FLAG
    ]
];
/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */ function $5cd9a37742eb8774$var$updateWrapDetails(details, bitmask) {
    $9Kzih($5cd9a37742eb8774$var$wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if (bitmask & pair[1] && !$lqZWH(details, value)) details.push(value);
    });
    return details.sort();
}
module.exports = $5cd9a37742eb8774$var$updateWrapDetails;

});



parcelRegister("9xQzO", function(module, exports) {
/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */ function $6f2ffabf17208972$var$getHolder(func) {
    var object = func;
    return object.placeholder;
}
module.exports = $6f2ffabf17208972$var$getHolder;

});

parcelRegister("jtjhF", function(module, exports) {

var $b69Sx = parcelRequire("b69Sx");

var $3hFfZ = parcelRequire("3hFfZ");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e2cfaf2379d6eef4$var$nativeMin = Math.min;
/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */ function $e2cfaf2379d6eef4$var$reorder(array, indexes) {
    var arrLength = array.length, length = $e2cfaf2379d6eef4$var$nativeMin(indexes.length, arrLength), oldArray = $b69Sx(array);
    while(length--){
        var index = indexes[length];
        array[length] = $3hFfZ(index, arrLength) ? oldArray[index] : undefined;
    }
    return array;
}
module.exports = $e2cfaf2379d6eef4$var$reorder;

});

parcelRegister("kBgrU", function(module, exports) {
/** Used as the internal argument placeholder. */ var $eff405cccdf3a041$var$PLACEHOLDER = '__lodash_placeholder__';
/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */ function $eff405cccdf3a041$var$replaceHolders(array, placeholder) {
    var index = -1, length = array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value === placeholder || value === $eff405cccdf3a041$var$PLACEHOLDER) {
            array[index] = $eff405cccdf3a041$var$PLACEHOLDER;
            result[resIndex++] = index;
        }
    }
    return result;
}
module.exports = $eff405cccdf3a041$var$replaceHolders;

});



parcelRegister("3slGh", function(module, exports) {

var $5VdlS = parcelRequire("5VdlS");

var $4ptXN = parcelRequire("4ptXN");

var $c1MCs = parcelRequire("c1MCs");
/** Used to compose bitmasks for function metadata. */ var $2844ce06b6725f7d$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */ function $2844ce06b6725f7d$var$createPartial(func, bitmask, thisArg, partials) {
    var isBind = bitmask & $2844ce06b6725f7d$var$WRAP_BIND_FLAG, Ctor = $4ptXN(func);
    function wrapper() {
        var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = this && this !== $c1MCs && this instanceof wrapper ? Ctor : func;
        while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
        while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
        return $5VdlS(fn, isBind ? thisArg : this, args);
    }
    return wrapper;
}
module.exports = $2844ce06b6725f7d$var$createPartial;

});

parcelRegister("fHM5F", function(module, exports) {

var $98OfC = parcelRequire("98OfC");

var $aoNSM = parcelRequire("aoNSM");

var $kBgrU = parcelRequire("kBgrU");
/** Used as the internal argument placeholder. */ var $b6f02cf0a655a19e$var$PLACEHOLDER = '__lodash_placeholder__';
/** Used to compose bitmasks for function metadata. */ var $b6f02cf0a655a19e$var$WRAP_BIND_FLAG = 1, $b6f02cf0a655a19e$var$WRAP_BIND_KEY_FLAG = 2, $b6f02cf0a655a19e$var$WRAP_CURRY_BOUND_FLAG = 4, $b6f02cf0a655a19e$var$WRAP_CURRY_FLAG = 8, $b6f02cf0a655a19e$var$WRAP_ARY_FLAG = 128, $b6f02cf0a655a19e$var$WRAP_REARG_FLAG = 256;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b6f02cf0a655a19e$var$nativeMin = Math.min;
/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */ function $b6f02cf0a655a19e$var$mergeData(data, source) {
    var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < ($b6f02cf0a655a19e$var$WRAP_BIND_FLAG | $b6f02cf0a655a19e$var$WRAP_BIND_KEY_FLAG | $b6f02cf0a655a19e$var$WRAP_ARY_FLAG);
    var isCombo = srcBitmask == $b6f02cf0a655a19e$var$WRAP_ARY_FLAG && bitmask == $b6f02cf0a655a19e$var$WRAP_CURRY_FLAG || srcBitmask == $b6f02cf0a655a19e$var$WRAP_ARY_FLAG && bitmask == $b6f02cf0a655a19e$var$WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == ($b6f02cf0a655a19e$var$WRAP_ARY_FLAG | $b6f02cf0a655a19e$var$WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == $b6f02cf0a655a19e$var$WRAP_CURRY_FLAG;
    // Exit early if metadata can't be merged.
    if (!(isCommon || isCombo)) return data;
    // Use source `thisArg` if available.
    if (srcBitmask & $b6f02cf0a655a19e$var$WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & $b6f02cf0a655a19e$var$WRAP_BIND_FLAG ? 0 : $b6f02cf0a655a19e$var$WRAP_CURRY_BOUND_FLAG;
    }
    // Compose partial arguments.
    var value = source[3];
    if (value) {
        var partials = data[3];
        data[3] = partials ? $98OfC(partials, value, source[4]) : value;
        data[4] = partials ? $kBgrU(data[3], $b6f02cf0a655a19e$var$PLACEHOLDER) : source[4];
    }
    // Compose partial right arguments.
    value = source[5];
    if (value) {
        partials = data[5];
        data[5] = partials ? $aoNSM(partials, value, source[6]) : value;
        data[6] = partials ? $kBgrU(data[5], $b6f02cf0a655a19e$var$PLACEHOLDER) : source[6];
    }
    // Use source `argPos` if available.
    value = source[7];
    if (value) data[7] = value;
    // Use source `ary` if it's smaller.
    if (srcBitmask & $b6f02cf0a655a19e$var$WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : $b6f02cf0a655a19e$var$nativeMin(data[8], source[8]);
    // Use source `arity` if one is not provided.
    if (data[9] == null) data[9] = source[9];
    // Use source `func` and merge bitmasks.
    data[0] = source[0];
    data[1] = newBitmask;
    return data;
}
module.exports = $b6f02cf0a655a19e$var$mergeData;

});



parcelRegister("E0NNP", function(module, exports) {

var $ee7Ev = parcelRequire("ee7Ev");
/** Used to compose bitmasks for cloning. */ var $07845bdb18fff27f$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $07845bdb18fff27f$var$clone(value) {
    return $ee7Ev(value, $07845bdb18fff27f$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $07845bdb18fff27f$var$clone;

});

parcelRegister("cleLA", function(module, exports) {

var $xQ3hV = parcelRequire("xQ3hV");
/** Used to compose bitmasks for function metadata. */ var $8fc2e687045586ce$var$WRAP_CURRY_FLAG = 8;
/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */ function $8fc2e687045586ce$var$curry(func, arity, guard) {
    arity = guard ? undefined : arity;
    var result = $xQ3hV(func, $8fc2e687045586ce$var$WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
    result.placeholder = $8fc2e687045586ce$var$curry.placeholder;
    return result;
}
// Assign default placeholders.
$8fc2e687045586ce$var$curry.placeholder = {};
module.exports = $8fc2e687045586ce$var$curry;

});

parcelRegister("dbogu", function(module, exports) {

var $2OY5s = parcelRequire("2OY5s");

var $hYEMs = parcelRequire("hYEMs");

var $jtsd5 = parcelRequire("jtsd5");
/** `Object#toString` result references. */ var $998f1ff604abccc1$var$domExcTag = '[object DOMException]', $998f1ff604abccc1$var$errorTag = '[object Error]';
/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */ function $998f1ff604abccc1$var$isError(value) {
    if (!$hYEMs(value)) return false;
    var tag = $2OY5s(value);
    return tag == $998f1ff604abccc1$var$errorTag || tag == $998f1ff604abccc1$var$domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !$jtsd5(value);
}
module.exports = $998f1ff604abccc1$var$isError;

});

parcelRegister("a1CHL", function(module, exports) {

var $fjnSB = parcelRequire("fjnSB");

var $hYEMs = parcelRequire("hYEMs");
/** `Object#toString` result references. */ var $74c80559f18c75f2$var$weakMapTag = '[object WeakMap]';
/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */ function $74c80559f18c75f2$var$isWeakMap(value) {
    return $hYEMs(value) && $fjnSB(value) == $74c80559f18c75f2$var$weakMapTag;
}
module.exports = $74c80559f18c75f2$var$isWeakMap;

});

parcelRegister("akHxB", function(module, exports) {

var $ee7Ev = parcelRequire("ee7Ev");

var $7qARj = parcelRequire("7qARj");
/** Used to compose bitmasks for cloning. */ var $785d8bf9eb54b1a7$var$CLONE_DEEP_FLAG = 1;
/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */ function $785d8bf9eb54b1a7$var$iteratee(func) {
    return $7qARj(typeof func == 'function' ? func : $ee7Ev(func, $785d8bf9eb54b1a7$var$CLONE_DEEP_FLAG));
}
module.exports = $785d8bf9eb54b1a7$var$iteratee;

});

parcelRegister("k5dRT", function(module, exports) {

var $xQ3hV = parcelRequire("xQ3hV");

var $224h2 = parcelRequire("224h2");
/** Used to compose bitmasks for function metadata. */ var $e9ef0836fe6d24f1$var$WRAP_REARG_FLAG = 256;
/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */ var $e9ef0836fe6d24f1$var$rearg = $224h2(function(func, indexes) {
    return $xQ3hV(func, $e9ef0836fe6d24f1$var$WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});
module.exports = $e9ef0836fe6d24f1$var$rearg;

});

parcelRegister("d0KBl", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $b69Sx = parcelRequire("b69Sx");

var $1c8hB = parcelRequire("1c8hB");

var $8aco7 = parcelRequire("8aco7");

var $1xzs7 = parcelRequire("1xzs7");

var $cNyDu = parcelRequire("cNyDu");

var $1uqnh = parcelRequire("1uqnh");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $978f6c7ba8ca5ebf$var$toPath(value) {
    if ($1c8hB(value)) return $kJvGp(value, $cNyDu);
    return $8aco7(value) ? [
        value
    ] : $b69Sx($1xzs7($1uqnh(value)));
}
module.exports = $978f6c7ba8ca5ebf$var$toPath;

});





parcelRegister("5JCOp", function(module, exports) {

$parcel$export(module.exports, "initializeBackends", () => $42cf42f9cef2069d$export$8ede10fee0643ed7);
$parcel$export(module.exports, "sendEvent", () => $42cf42f9cef2069d$export$7329bcdc3edcd90e);
$parcel$export(module.exports, "sendPageViewEvent", () => $42cf42f9cef2069d$export$a0769f17975cb672);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $3DsUo = parcelRequire("3DsUo");

var $01SeN = parcelRequire("01SeN");
const $42cf42f9cef2069d$var$BACKENDS = (0, $g5DHJ.List)([
    new (0, $01SeN.default)()
]);
function $42cf42f9cef2069d$export$8ede10fee0643ed7(hostInfo, userId) {
    return Promise.all($42cf42f9cef2069d$var$BACKENDS.map((b)=>(0, $3DsUo.reflect)(b.initialize(hostInfo, userId)).then((r)=>{
            r.swap().map((error)=>{
                console.error('Analytics error', error);
            });
            return r;
        })).toArray()).then((responses)=>{
        const errResponse = (0, $bWAru.Option).of(responses.find((r)=>r.fold((value)=>value, ()=>false)));
        return errResponse.map((er)=>Promise.reject(er)).getOrElseL(()=>Promise.resolve());
    });
}
function $42cf42f9cef2069d$export$7329bcdc3edcd90e(event) {
    $42cf42f9cef2069d$var$BACKENDS.forEach((b)=>b.sendEvent(event));
}
function $42cf42f9cef2069d$export$a0769f17975cb672(pageViewEvent) {
    $42cf42f9cef2069d$var$BACKENDS.forEach((b)=>b.sendPageViewEvent(pageViewEvent));
}

});
parcelRegister("5jwNO", function(module, exports) {
$parcel$export(module.exports, "Either", () => (parcelRequire("bWAru")).Either);
$parcel$export(module.exports, "Option", () => (parcelRequire("bWAru")).Option);
/*!
 * Copyright (c) 2017-2018 by The Funfix Project Developers.
 * Some rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("7ARg3");
parcelRequire("4grBR");
parcelRequire("bWAru");

var $iMUUJ = parcelRequire("iMUUJ");

});
parcelRegister("7ARg3", function(module, exports) {

$parcel$export(module.exports, "is", () => $587535221f74d65c$export$226b3eccf92c9ed9);
$parcel$export(module.exports, "hashCode", () => $587535221f74d65c$export$d41d9ab3de2def3d);
/*!
 * Copyright (c) 2017-2018 by The Funfix Project Developers.
 * Some rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Test if the given reference is a value object.
 *
 * Value objects are objects that implement the [[IEquals]]
 * interface.
 *
 * @param ref is the reference to test
 */ function $587535221f74d65c$export$b24f7407c77e5bd(ref) {
    return !!(ref && typeof ref.equals === "function" && typeof ref.hashCode === "function");
}
function $587535221f74d65c$export$226b3eccf92c9ed9(lh, rh) {
    if (lh === rh || lh !== lh && rh !== rh) return true;
    if (!lh || !rh) return false;
    /* istanbul ignore else */ /* tslint:disable-next-line:strict-type-predicates */ if (typeof lh.valueOf === "function" && typeof rh.valueOf === "function") {
        const lh2 = lh.valueOf();
        const rh2 = rh.valueOf();
        if (lh2 === rh2 || lh2 !== lh2 && rh2 !== rh2) return true;
        if (!lh2 || !rh2) return false;
    }
    // noinspection PointlessBooleanExpressionJS
    return !!($587535221f74d65c$export$b24f7407c77e5bd(lh) && lh.equals(rh));
}
function $587535221f74d65c$export$e9bab7fafb253603(lh, rh) {
    return $587535221f74d65c$export$226b3eccf92c9ed9(lh, rh);
}
const $587535221f74d65c$export$280f210877e5565b = {
    equals: $587535221f74d65c$export$e9bab7fafb253603
};
function $587535221f74d65c$export$d41d9ab3de2def3d(ref) {
    if (typeof ref === "number") return ref & ref;
    /* istanbul ignore else */ if (typeof ref.valueOf === "function") {
        const v = ref.valueOf();
        if (v !== ref) return $587535221f74d65c$export$d41d9ab3de2def3d(v);
    }
    if ($587535221f74d65c$export$b24f7407c77e5bd(ref)) return ref.hashCode();
    return $587535221f74d65c$export$39e05520a596a3da(String(ref));
}
function $587535221f74d65c$export$39e05520a596a3da(str) {
    let hash = 0;
    /* tslint:disable-next-line:strict-type-predicates */ if (str == null || str.length === 0) return hash;
    for(let i = 0; i < str.length; i++){
        const character = str.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
}
function $587535221f74d65c$export$d560c7e4a29451c2(a) {
    return a;
}
function $587535221f74d65c$export$6ccb92ce135089b4(derivedCtor, baseCtors) {
    baseCtors.forEach((baseCtor)=>{
        Object.getOwnPropertyNames(baseCtor.prototype).forEach((name)=>{
            if (!derivedCtor.prototype[name]) derivedCtor.prototype[name] = baseCtor.prototype[name];
        });
    });
}

});

parcelRegister("4grBR", function(module, exports) {

$parcel$export(module.exports, "NoSuchElementError", () => $31ae12baa758f3ba$export$48d368d160387990);
/*!
 * Copyright (c) 2017-2018 by The Funfix Project Developers.
 * Some rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A composite error represents a list of errors that were caught
 * while executing logic which delays re-throwing of errors.
 */ class $31ae12baa758f3ba$export$6fbeb926bac523c3 extends Error {
    constructor(errors){
        let reasons = "";
        for (const e of errors.slice(0, 2)){
            let message = "";
            if (e instanceof Error) message = `${e.name}(${e.message})`;
            else message = `${e}`;
            reasons += ", " + message;
        }
        reasons = reasons.slice(2);
        if (errors.length > 2) reasons = reasons + ", ...";
        super(reasons);
        this.name = "CompositeError";
        this.errorsRef = errors;
        // Workaround to make `instanceof` work in ES5
        const self = this;
        self.constructor = $31ae12baa758f3ba$export$6fbeb926bac523c3;
        self.__proto__ = $31ae12baa758f3ba$export$6fbeb926bac523c3.prototype;
    }
    /**
     * Returns the full list of caught errors.
     */ errors() {
        return this.errorsRef.slice();
    }
}
class $31ae12baa758f3ba$export$4a48f57740b5ad1e extends Error {
    constructor(message){
        super(message);
        this.name = "DummyError";
        // Workaround to make `instanceof` work in ES5
        const self = this;
        self.constructor = $31ae12baa758f3ba$export$4a48f57740b5ad1e;
        self.__proto__ = $31ae12baa758f3ba$export$4a48f57740b5ad1e.prototype;
    }
}
class $31ae12baa758f3ba$export$48d368d160387990 extends Error {
    constructor(message){
        super(message);
        this.name = "NoSuchElementError";
        // Workaround to make `instanceof` work in ES5
        const self = this;
        self.constructor = $31ae12baa758f3ba$export$48d368d160387990;
        self.__proto__ = $31ae12baa758f3ba$export$48d368d160387990.prototype;
    }
}
class $31ae12baa758f3ba$export$e6c18cacaad31d56 extends Error {
    constructor(message){
        super(message);
        this.name = "IllegalInheritanceError";
        // Workaround to make `instanceof` work in ES5
        const self = this;
        self.constructor = $31ae12baa758f3ba$export$e6c18cacaad31d56;
        self.__proto__ = $31ae12baa758f3ba$export$e6c18cacaad31d56.prototype;
    }
}
class $31ae12baa758f3ba$export$25b19446f82d7080 extends Error {
    constructor(message){
        super(message);
        this.name = "IllegalStateError";
        // Workaround to make `instanceof` work in ES5
        const self = this;
        self.constructor = $31ae12baa758f3ba$export$25b19446f82d7080;
        self.__proto__ = $31ae12baa758f3ba$export$25b19446f82d7080.prototype;
    }
}
class $31ae12baa758f3ba$export$10a4c2bfc9c71dbd extends Error {
    constructor(message){
        super(message);
        this.name = "IllegalArgumentError";
        // Workaround to make `instanceof` work in ES5
        const self = this;
        self.constructor = $31ae12baa758f3ba$export$10a4c2bfc9c71dbd;
        self.__proto__ = $31ae12baa758f3ba$export$10a4c2bfc9c71dbd.prototype;
    }
}
class $31ae12baa758f3ba$export$e162153238934121 extends Error {
    constructor(message){
        super(message);
        this.name = "NotImplementedError";
        // Workaround to make `instanceof` work in ES5
        const self = this;
        self.constructor = $31ae12baa758f3ba$export$e162153238934121;
        self.__proto__ = $31ae12baa758f3ba$export$e162153238934121.prototype;
    }
}
class $31ae12baa758f3ba$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super(message);
        this.name = "TimeoutError";
        // Workaround to make `instanceof` work in ES5
        const self = this;
        self.constructor = $31ae12baa758f3ba$export$66d311bf29d5c89c;
        self.__proto__ = $31ae12baa758f3ba$export$66d311bf29d5c89c.prototype;
    }
}

});

parcelRegister("bWAru", function(module, exports) {

$parcel$export(module.exports, "Either", () => $8b21612c25971c7b$export$37cbe166bfc81b63);
$parcel$export(module.exports, "Option", () => $8b21612c25971c7b$export$36d18380658d5d20);
/*!
 * Copyright (c) 2017-2018 by The Funfix Project Developers.
 * Some rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $7ARg3 = parcelRequire("7ARg3");

var $4grBR = parcelRequire("4grBR");

var $iMUUJ = parcelRequire("iMUUJ");
class $8b21612c25971c7b$export$37cbe166bfc81b63 {
    constructor(value, tag){
        this._isRight = tag === "right";
        this.value = value;
    }
    /**
     * Returns `true` if this is a `left`, `false` otherwise.
     *
     * ```typescript
     * Left("hello").isLeft() // true
     * Right(10).isLeft() // false
     * ```
     */ isLeft() {
        return !this._isRight;
    }
    /**
     * Returns `true` if this is a `right`, `false` otherwise.
     *
     * ```typescript
     * Left("hello").isRight() // false
     * Right(10).isRight() // true
     * ```
     */ isRight() {
        return this._isRight;
    }
    /**
     * Returns true if this is a Right and its value is equal to `elem`
     * (as determined by the `equals` protocol), returns `false` otherwise.
     *
     * ```typescript
     * // True
     * Right("something").contains("something")
     *
     * // False because the values are different
     * Right("something").contains("anything") // false
     *
     * // False because the source is a `left`
     * Left("something").contains("something") // false
     * ```
     */ contains(elem) {
        return this._isRight && $7ARg3.is(this.value, elem);
    }
    /**
     * Returns `false` if the source is a `left`, or returns the result
     * of the application of the given predicate to the `right` value.
     *
     * ```typescript
     * // True, because it is a right and predicate holds
     * Right(20).exists(n => n > 10)
     *
     * // False, because the predicate returns false
     * Right(10).exists(n => n % 2 != 0)
     *
     * // False, because it is a left
     * Left(10).exists(n => n == 10)
     * ```
     */ exists(p) {
        return this._isRight && p(this.value);
    }
    /**
     * Filters `right` values with the given predicate, returning
     * the value generated by `zero` in case the source is a `right`
     * value and the predicate doesn't hold.
     *
     * Possible outcomes:
     *
     *  - Returns the existing value of `right` if this is a `right` value and the
     *    given predicate `p` holds for it
     *  - Returns `Left(zero())` if this is a `right` value
     *    and the given predicate `p` does not hold
     *  - Returns the current "left" value, if the source is a `Left`
     *
     * ```typescript
     * Right(12).filterOrElse(x => x > 10, () => -1) // Right(12)
     * Right(7).filterOrElse(x => x > 10, () => -1)  // Left(-1)
     * Left(7).filterOrElse(x => false, () => -1)    // Left(7)
     * ```
     */ filterOrElse(p, zero) {
        return this._isRight ? p(this.value) ? this : $8b21612c25971c7b$export$37c4d04eafdc5515(zero()) : this;
    }
    /**
     * Binds the given function across `right` values.
     *
     * This operation is the monadic "bind" operation.
     * It can be used to *chain* multiple `Either` references.
     */ flatMap(f) {
        return this._isRight ? f(this.value) : this;
    }
    /** Alias for [[flatMap]]. */ chain(f) {
        return this.flatMap(f);
    }
    /**
     * `Applicative` apply operator.
     *
     * Resembles {@link map}, but the passed mapping function is
     * lifted in the `Either` context.
     */ ap(ff) {
        return ff.flatMap((f)=>this.map(f));
    }
    /**
     * Applies the `left` function to [[Left]] values, and the
     * `right` function to [[Right]] values and returns the result.
     *
     * ```typescript
     * const maybeNum: Either<string, number> =
     *   tryParseInt("not a number")
     *
     * const result: string =
     *   maybeNum.fold(
     *     str => `Could not parse string: ${str}`,
     *     num => `Success: ${num}`
     *   )
     * ```
     */ fold(left, right) {
        return this._isRight ? right(this.value) : left(this.value);
    }
    /**
     * Returns true if the source is a `left` or returns
     * the result of the application of the given predicate to the
     * `right` value.
     *
     * ```typescript
     * // True, because it is a `left`
     * Left("hello").forAll(x => x > 10)
     *
     * // True, because the predicate holds
     * Right(20).forAll(x => x > 10)
     *
     * // False, it's a right and the predicate doesn't hold
     * Right(7).forAll(x => x > 10)
     * ```
     */ forAll(p) {
        return !this._isRight || p(this.value);
    }
    /**
     * Returns the `Right` value, if the source has one,
     * otherwise throws an exception.
     *
     * WARNING!
     *
     * This function is partial, the `Either` must be a `Right`, otherwise
     * a runtime exception will get thrown. Use with care.
     *
     * @throws [[NoSuchElementError]] in case the the `Either` is a `Left`
     */ get() {
        if (this._isRight) return this.value;
        throw new (0, $4grBR.NoSuchElementError)("left.get()");
    }
    /**
     * Returns the value from this `right` or the given `fallback`
     * value if this is a `left`.
     *
     * ```typescript
     * Right(10).getOrElse(27) // 10
     * Left(10).getOrElse(27)  // 27
     * ```
     */ getOrElse(fallback) {
        return this._isRight ? this.value : fallback;
    }
    /**
     * Returns the value from this `right` or a value generated
     * by the given `thunk` if this is a `left`.
     *
     * ```typescript
     * Right(10).getOrElseL(() => 27) // 10
     * Left(10).getOrElseL(() => 27)  // 27
     * ```
     */ getOrElseL(thunk) {
        return this._isRight ? this.value : thunk();
    }
    /**
     * Transform the source if it is a `right` with the given
     * mapping function.
     *
     * ```typescript
     * Right(10).map(x => x + 17) // right(27)
     * Left(10).map(x => x + 17)  // left(10)
     * ```
     */ map(f) {
        return this._isRight ? $8b21612c25971c7b$export$19db0165690c701a(f(this.value)) : this;
    }
    /**
     * Executes the given side-effecting function if the
     * source is a `right` value.
     *
     * ```typescript
     * Right(12).forAll(console.log) // prints 12
     * Left(10).forAll(console.log)  // silent
     * ```
     */ forEach(cb) {
        if (this._isRight) cb(this.value);
    }
    /**
     * If this is a `left`, then return the left value as a `right`
     * or vice versa.
     *
     * ```typescript
     * Right(10).swap() // left(10)
     * Left(20).swap()  // right(20)
     * ```
     */ swap() {
        return this._isRight ? $8b21612c25971c7b$export$37c4d04eafdc5515(this.value) : $8b21612c25971c7b$export$19db0165690c701a(this.value);
    }
    /**
     * Returns an `Option.some(right)` if the source is a `right` value,
     * or `Option.none` in case the source is a `left` value.
     */ toOption() {
        return this._isRight ? $8b21612c25971c7b$export$9f9d0139d032da4f(this.value) : $8b21612c25971c7b$export$57ca7e07b341709d;
    }
    /**
     * Implements {@link IEquals.equals}.
     *
     * @param that is the right hand side of the equality check
     */ equals(that) {
        // tslint:disable-next-line:strict-type-predicates
        if (that == null) return false;
        return this._isRight === that._isRight && $7ARg3.is(this.value, that.value);
    }
    /** Implements {@link IEquals.hashCode}. */ hashCode() {
        return this._isRight ? $7ARg3.hashCode(this.value) << 2 : $7ARg3.hashCode(this.value) << 3;
    }
    /**
     * Builds a pure `Either` value.
     *
     * This operation is the pure `Applicative` operation for lifting
     * a value in the `Either` context.
     */ static pure(value) {
        return new $8b21612c25971c7b$export$8cd6fcff08338c9a(value);
    }
    /**
     * Builds a left value, equivalent with {@link Left}.
     */ static left(value) {
        return $8b21612c25971c7b$export$37c4d04eafdc5515(value);
    }
    /**
     * Builds a right value, equivalent with {@link Right}.
     */ static right(value) {
        return $8b21612c25971c7b$export$19db0165690c701a(value);
    }
    /**
     * Maps 2 `Either` values by the mapping function, returning a new
     * `Either` reference that is a `Right` only if both `Either` values are
     * `Right` values, otherwise it returns the first `Left` value noticed.
     *
     * ```typescript
     * // Yields Right(3)
     * Try.map2(Right(1), Right(2),
     *   (a, b) => a + b
     * )
     *
     * // Yields Left, because the second arg is a Left
     * Try.map2(Right(1), Left("error"),
     *   (a, b) => a + b
     * )
     * ```
     *
     * This operation is the `Applicative.map2`.
     */ static map2(fa1, fa2, f) {
        if (fa1.isLeft()) return fa1;
        if (fa2.isLeft()) return fa2;
        return $8b21612c25971c7b$export$19db0165690c701a(f(fa1.value, fa2.value));
    }
    /**
     * Maps 3 `Either` values by the mapping function, returning a new
     * `Either` reference that is a `Right` only if all 3 `Either` values are
     * `Right` values, otherwise it returns the first `Left` value noticed.
     *
     * ```typescript
     * // Yields Right(6)
     * Try.map3(Right(1), Right(2), Right(3),
     *   (a, b, c) => a + b + c
     * )
     *
     * // Yields Left, because the second arg is a Left
     * Try.map3(Right(1), Left("error"), Right(3),
     *   (a, b, c) => a + b + c
     * )
     * ```
     */ static map3(fa1, fa2, fa3, f) {
        if (fa1.isLeft()) return fa1;
        if (fa2.isLeft()) return fa2;
        if (fa3.isLeft()) return fa3;
        return $8b21612c25971c7b$export$19db0165690c701a(f(fa1.value, fa2.value, fa3.value));
    }
    /**
     * Maps 4 `Either` values by the mapping function, returning a new
     * `Either` reference that is a `Right` only if all 4 `Either` values are
     * `Right` values, otherwise it returns the first `Left` value noticed.
     *
     * ```typescript
     * // Yields Right(10)
     * Try.map4(Right(1), Right(2), Right(3), Right(4),
     *   (a, b, c, d) => a + b + c + d
     * )
     *
     * // Yields Left, because the second arg is a Left
     * Try.map4(Right(1), Left("error"), Right(3), Right(4),
     *   (a, b, c, d) => a + b + c + d
     * )
     * ```
     */ static map4(fa1, fa2, fa3, fa4, f) {
        if (fa1.isLeft()) return fa1;
        if (fa2.isLeft()) return fa2;
        if (fa3.isLeft()) return fa3;
        if (fa4.isLeft()) return fa4;
        return $8b21612c25971c7b$export$19db0165690c701a(f(fa1.value, fa2.value, fa3.value, fa4.value));
    }
    /**
     * Maps 5 `Either` values by the mapping function, returning a new
     * `Either` reference that is a `Right` only if all 5 `Either` values are
     * `Right` values, otherwise it returns the first `Left` value noticed.
     *
     * ```typescript
     * // Yields Right(15)
     * Try.map5(Right(1), Right(2), Right(3), Right(4), Right(5),
     *   (a, b, c, d, e) => a + b + c + d + e
     * )
     *
     * // Yields Left, because the second arg is a Left
     * Try.map5(Right(1), Left("error"), Right(3), Right(4), Right(5),
     *   (a, b, c, d, e) => a + b + c + d + e
     * )
     * ```
     */ static map5(fa1, fa2, fa3, fa4, fa5, f) {
        if (fa1.isLeft()) return fa1;
        if (fa2.isLeft()) return fa2;
        if (fa3.isLeft()) return fa3;
        if (fa4.isLeft()) return fa4;
        if (fa5.isLeft()) return fa5;
        return $8b21612c25971c7b$export$19db0165690c701a(f(fa1.value, fa2.value, fa3.value, fa4.value, fa5.value));
    }
    /**
     * Maps 6 `Either` values by the mapping function, returning a new
     * `Either` reference that is a `Right` only if all 6 `Either` values are
     * `Right` values, otherwise it returns the first `Left` value noticed.
     *
     * ```typescript
     * // Yields Right(21)
     * Try.map5(Right(1), Right(2), Right(3), Right(4), Right(5), Right(6),
     *   (a, b, c, d, e, f) => a + b + c + d + e + f
     * )
     *
     * // Yields Left, because the second arg is a Left
     * Try.map5(Right(1), Left("error"), Right(3), Right(4), Right(5), Right(6),
     *   (a, b, c, d, e, f) => a + b + c + d + e + f
     * )
     * ```
     */ static map6(fa1, fa2, fa3, fa4, fa5, fa6, f) {
        if (fa1.isLeft()) return fa1;
        if (fa2.isLeft()) return fa2;
        if (fa3.isLeft()) return fa3;
        if (fa4.isLeft()) return fa4;
        if (fa5.isLeft()) return fa5;
        if (fa6.isLeft()) return fa6;
        return $8b21612c25971c7b$export$19db0165690c701a(f(fa1.value, fa2.value, fa3.value, fa4.value, fa5.value, fa6.value));
    }
    /**
     * Keeps calling `f` until a `Right(b)` is returned.
     *
     * Based on Phil Freeman's
     * [Stack Safety for Free]{@link http://functorial.com/stack-safety-for-free/index.pdf}.
     *
     * Described in `FlatMap.tailRecM`.
     */ static tailRecM(a, f) {
        let cursor = a;
        while(true){
            const result = f(cursor);
            if (!result.isRight()) return result;
            const some = result.value;
            if (some.isRight()) return $8b21612c25971c7b$export$19db0165690c701a(some.value);
            cursor = some.value;
        }
    }
}
class $8b21612c25971c7b$export$500560ce56dda718 extends $8b21612c25971c7b$export$37cbe166bfc81b63 {
    constructor(value){
        super(value, "left");
    }
}
function $8b21612c25971c7b$export$37c4d04eafdc5515(value) {
    return new $8b21612c25971c7b$export$500560ce56dda718(value);
}
class $8b21612c25971c7b$export$8cd6fcff08338c9a extends $8b21612c25971c7b$export$37cbe166bfc81b63 {
    constructor(value){
        super(value, "right");
    }
}
function $8b21612c25971c7b$export$19db0165690c701a(value) {
    return new $8b21612c25971c7b$export$8cd6fcff08338c9a(value);
}
const $8b21612c25971c7b$export$e772b5f99e4d377d = {
    // Setoid
    equals: (x, y)=>x ? x.equals(y) : !y,
    // Functor
    map: (f, fa)=>fa.map(f),
    // Apply
    ap: (ff, fa)=>fa.ap(ff),
    // Applicative
    of: $8b21612c25971c7b$export$37cbe166bfc81b63.pure,
    // Chain
    chain: (f, fa)=>fa.flatMap(f),
    // ChainRec
    chainRec: (f, a)=>$8b21612c25971c7b$export$37cbe166bfc81b63.tailRecM(a, (a)=>f($8b21612c25971c7b$export$37cbe166bfc81b63.left, $8b21612c25971c7b$export$37cbe166bfc81b63.right, a))
};
// Registers Fantasy-Land compatible symbols
(0, $iMUUJ.fantasyLandRegister)($8b21612c25971c7b$export$37cbe166bfc81b63, $8b21612c25971c7b$export$e772b5f99e4d377d, $8b21612c25971c7b$export$e772b5f99e4d377d);
class $8b21612c25971c7b$export$36d18380658d5d20 {
    constructor(ref, isEmpty){
        /* tslint:disable-next-line:strict-type-predicates */ this._isEmpty = isEmpty != null ? isEmpty : ref === null || ref === undefined;
        this.value = ref;
    }
    /**
     * Returns the option's value.
     *
     * WARNING!
     *
     * This function is partial, the option must be non-empty, otherwise
     * a runtime exception will get thrown. Use with care.
     *
     * @throws [[NoSuchElementError]] in case the option is empty
     */ get() {
        if (!this._isEmpty) return this.value;
        throw new (0, $4grBR.NoSuchElementError)("Option.get");
    }
    /**
     * Returns the option's value if the option is nonempty, otherwise
     * return the given `fallback`.
     *
     * See [[Option.getOrElseL]] for a lazy alternative.
     */ getOrElse(fallback) {
        if (!this._isEmpty) return this.value;
        else return fallback;
    }
    /**
     * Returns the option's value if the option is nonempty, otherwise
     * return `null`.
     * ```
     */ orNull() {
        return !this._isEmpty ? this.value : null;
    }
    /**
     * Returns the option's value if the option is nonempty, otherwise
     * return `undefined`.
     */ orUndefined() {
        return !this._isEmpty ? this.value : undefined;
    }
    /**
     * Returns the option's value if the option is nonempty, otherwise
     * return the result of evaluating `thunk`.
     *
     * See [[Option.getOrElse]] for a strict alternative.
     */ getOrElseL(thunk) {
        if (!this._isEmpty) return this.value;
        else return thunk();
    }
    /**
     * Returns this option if it is nonempty, otherwise returns the
     * given `fallback`.
     */ orElse(fallback) {
        if (!this._isEmpty) return this;
        else return fallback;
    }
    /**
     * Returns this option if it is nonempty, otherwise returns the
     * given result of evaluating the given `thunk`.
     *
     * @param thunk a no-params function that gets evaluated and
     *        whose result is returned in case this option is empty
     */ orElseL(thunk) {
        if (!this._isEmpty) return this;
        else return thunk();
    }
    /**
     * Returns `true` if the option is empty, `false` otherwise.
     */ isEmpty() {
        return this._isEmpty;
    }
    /**
     * Returns `true` if the option is not empty, `false` otherwise.
     */ nonEmpty() {
        return !this._isEmpty;
    }
    /**
     * Returns an option containing the result of applying `f` to
     * this option's value, or an empty option if the source is empty.
     *
     * NOTE: this is similar with `flatMap`, except with `map` the
     * result of `f` doesn't need to be wrapped in an `Option`.
     *
     * @param f the mapping function that will transform the value
     *          of this option if nonempty.
     *
     * @return a new option instance containing the value of the
     *         source mapped by the given function
     */ map(f) {
        return this._isEmpty ? $8b21612c25971c7b$export$57ca7e07b341709d : $8b21612c25971c7b$export$9f9d0139d032da4f(f(this.value));
    }
    /**
     * Returns the result of applying `f` to this option's value if
     * the option is nonempty, otherwise returns an empty option.
     *
     * NOTE: this is similar with `map`, except that `flatMap` the
     * result returned by `f` is expected to be boxed in an `Option`
     * already.
     *
     * Example:
     *
     * ```typescript
     * const opt = Option.of(10)
     *
     * opt.flatMap(num => {
     *   if (num % 2 == 0)
     *     Some(num + 1)
     *   else
     *     None
     * })
     * ```
     *
     * @param f the mapping function that will transform the value
     *          of this option if nonempty.
     *
     * @return a new option instance containing the value of the
     *         source mapped by the given function
     */ flatMap(f) {
        if (this._isEmpty) return $8b21612c25971c7b$export$57ca7e07b341709d;
        else return f(this.value);
    }
    /** Alias for [[flatMap]]. */ chain(f) {
        return this.flatMap(f);
    }
    /**
     * `Applicative` apply operator.
     *
     * Resembles {@link map}, but the passed mapping function is
     * lifted in the `Either` context.
     */ ap(ff) {
        return ff.flatMap((f)=>this.map(f));
    }
    filter(p) {
        if (this._isEmpty || !p(this.value)) return $8b21612c25971c7b$export$57ca7e07b341709d;
        else return this;
    }
    /**
     * Returns the result of applying `f` to this option's value,
     * or in case the option is empty, the return the result of
     * evaluating the `fallback` function.
     *
     * This function is equivalent with:
     *
     * ```typescript
     * opt.map(f).getOrElseL(fallback)
     * ```
     *
     * @param fallback is the function to be evaluated in case this
     *        option is empty
     *
     * @param f is the mapping function for transforming this option's
     *        value in case it is nonempty
     */ fold(fallback, f) {
        if (this._isEmpty) return fallback();
        return f(this.value);
    }
    /**
     * Returns true if this option is nonempty and the value it
     * holds is equal to the given `elem`.
     */ contains(elem) {
        return !this._isEmpty && $7ARg3.is(this.value, elem);
    }
    /**
     * Returns `true` if this option is nonempty and the given
     * predicate returns `true` when applied on this option's value.
     *
     * @param p is the predicate function to test
     */ exists(p) {
        return !this._isEmpty && p(this.value);
    }
    /**
     * Returns true if this option is empty or the given predicate
     * returns `true` when applied on this option's value.
     *
     * @param p is the predicate function to test
     */ forAll(p) {
        return this._isEmpty || p(this.value);
    }
    /**
     * Apply the given procedure `cb` to the option's value if
     * this option is nonempty, otherwise do nothing.
     *
     * @param cb the procedure to apply
     */ forEach(cb) {
        if (!this._isEmpty) cb(this.value);
    }
    /**
     * Implements {@link IEquals.equals}.
     *
     * @param that is the right hand side of the equality check
     */ equals(that) {
        // tslint:disable-next-line:strict-type-predicates
        if (that == null) return false;
        if (this.nonEmpty() && that.nonEmpty()) return $7ARg3.is(this.value, that.value);
        return this.isEmpty() && that.isEmpty();
    }
    // Implemented from IEquals
    hashCode() {
        if (this._isEmpty) return 2433880;
        else if (this.value == null) return 9735524;
        else return $7ARg3.hashCode(this.value) << 2;
    }
    /**
     * Builds an [[Option]] reference that contains the given value.
     *
     * If the given value is `null` or `undefined` then the returned
     * option will be empty.
     */ static of(value) {
        return value != null ? $8b21612c25971c7b$export$9f9d0139d032da4f(value) : $8b21612c25971c7b$export$57ca7e07b341709d;
    }
    /**
     * Builds an [[Option]] reference that contains the given reference.
     *
     * Note that `value` is allowed to be `null` or `undefined`, the
     * returned option will still be non-empty. Use [[Option.of]]
     * if you want to avoid this problem. This means:
     *
     * ```typescript
     * const opt = Some<number | null>(null)
     *
     * opt.isEmpty()
     * //=> false
     *
     * opt.get()
     * //=> null
     * ```
     */ static some(value) {
        return new $8b21612c25971c7b$export$36d18380658d5d20(value, false);
    }
    /**
     * Returns an empty [[Option]].
     *
     * NOTE: Because `Option` is immutable, this function returns the
     * same cached reference is on different calls.
     */ static none() {
        return $8b21612c25971c7b$export$57ca7e07b341709d;
    }
    /**
     * Returns an empty [[Option]].
     *
     * Similar to [[Option.none]], but this one allows specifying a
     * type parameter (in the context of TypeScript or Flow or other
     * type system).
     *
     * NOTE: Because `Option` is immutable, this function returns the
     * same cached reference is on different calls.
     */ static empty() {
        return $8b21612c25971c7b$export$57ca7e07b341709d;
    }
    /**
     * Alias for [[Some]].
     */ static pure(value) {
        return $8b21612c25971c7b$export$9f9d0139d032da4f(value);
    }
    /**
     * Maps 2 optional values by the mapping function, returning a new
     * optional reference that is `Some` only if both option values are
     * `Some`, otherwise it returns a `None`.
     *
     * ```typescript
     * // Yields Some(3)
     * Option.map2(Some(1), Some(2),
     *   (a, b) => a + b
     * )
     *
     * // Yields None, because the second arg is None
     * Option.map2(Some(1), None,
     *   (a, b) => a + b
     * )
     * ```
     *
     * This operation is the `Applicative.map2`.
     */ static map2(fa1, fa2, f) {
        return fa1.nonEmpty() && fa2.nonEmpty() ? $8b21612c25971c7b$export$9f9d0139d032da4f(f(fa1.value, fa2.value)) : $8b21612c25971c7b$export$57ca7e07b341709d;
    }
    /**
     * Maps 3 optional values by the mapping function, returning a new
     * optional reference that is `Some` only if all 3 option values are
     * `Some`, otherwise it returns a `None`.
     *
     * ```typescript
     * // Yields Some(6)
     * Option.map3(Some(1), Some(2), Some(3),
     *   (a, b, c) => a + b + c
     * )
     *
     * // Yields None, because the second arg is None
     * Option.map3(Some(1), None, Some(3),
     *   (a, b, c) => a + b + c
     * )
     * ```
     */ static map3(fa1, fa2, fa3, f) {
        return fa1.nonEmpty() && fa2.nonEmpty() && fa3.nonEmpty() ? $8b21612c25971c7b$export$9f9d0139d032da4f(f(fa1.value, fa2.value, fa3.value)) : $8b21612c25971c7b$export$57ca7e07b341709d;
    }
    /**
     * Maps 4 optional values by the mapping function, returning a new
     * optional reference that is `Some` only if all 4 option values are
     * `Some`, otherwise it returns a `None`.
     *
     * ```typescript
     * // Yields Some(10)
     * Option.map4(Some(1), Some(2), Some(3), Some(4),
     *   (a, b, c, d) => a + b + c + d
     * )
     *
     * // Yields None, because the second arg is None
     * Option.map4(Some(1), None, Some(3), Some(4),
     *   (a, b, c, d) => a + b + c + d
     * )
     * ```
     */ static map4(fa1, fa2, fa3, fa4, f) {
        return fa1.nonEmpty() && fa2.nonEmpty() && fa3.nonEmpty() && fa4.nonEmpty() ? $8b21612c25971c7b$export$9f9d0139d032da4f(f(fa1.value, fa2.value, fa3.value, fa4.value)) : $8b21612c25971c7b$export$57ca7e07b341709d;
    }
    /**
     * Maps 5 optional values by the mapping function, returning a new
     * optional reference that is `Some` only if all 5 option values are
     * `Some`, otherwise it returns a `None`.
     *
     * ```typescript
     * // Yields Some(15)
     * Option.map5(Some(1), Some(2), Some(3), Some(4), Some(5),
     *   (a, b, c, d, e) => a + b + c + d + e
     * )
     *
     * // Yields None, because the second arg is None
     * Option.map5(Some(1), None, Some(3), Some(4), Some(5),
     *   (a, b, c, d, e) => a + b + c + d + e
     * )
     * ```
     */ static map5(fa1, fa2, fa3, fa4, fa5, f) {
        return fa1.nonEmpty() && fa2.nonEmpty() && fa3.nonEmpty() && fa4.nonEmpty() && fa5.nonEmpty() ? $8b21612c25971c7b$export$9f9d0139d032da4f(f(fa1.value, fa2.value, fa3.value, fa4.value, fa5.value)) : $8b21612c25971c7b$export$57ca7e07b341709d;
    }
    /**
     * Maps 6 optional values by the mapping function, returning a new
     * optional reference that is `Some` only if all 6 option values are
     * `Some`, otherwise it returns a `None`.
     *
     * ```typescript
     * // Yields Some(21)
     * Option.map6(Some(1), Some(2), Some(3), Some(4), Some(5), Some(6),
     *   (a, b, c, d, e, f) => a + b + c + d + e + f
     * )
     *
     * // Yields None, because the second arg is None
     * Option.map6(Some(1), None, Some(3), Some(4), Some(5), Some(6),
     *   (a, b, c, d, e, f) => a + b + c + d + e + f
     * )
     * ```
     */ static map6(fa1, fa2, fa3, fa4, fa5, fa6, f) {
        return fa1.nonEmpty() && fa2.nonEmpty() && fa3.nonEmpty() && fa4.nonEmpty() && fa5.nonEmpty() && fa6.nonEmpty() ? $8b21612c25971c7b$export$9f9d0139d032da4f(f(fa1.value, fa2.value, fa3.value, fa4.value, fa5.value, fa6.value)) : $8b21612c25971c7b$export$57ca7e07b341709d;
    }
    /**
     * Keeps calling `f` until a `Right(b)` is returned.
     *
     * Based on Phil Freeman's
     * [Stack Safety for Free]{@link http://functorial.com/stack-safety-for-free/index.pdf}.
     *
     * Described in `FlatMap.tailRecM`.
     */ static tailRecM(a, f) {
        let cursor = a;
        while(true){
            const result = f(cursor);
            if (result.nonEmpty()) {
                const some = result.value;
                if (some.isRight()) return $8b21612c25971c7b$export$9f9d0139d032da4f(some.value);
                cursor = some.value;
            } else return $8b21612c25971c7b$export$57ca7e07b341709d;
        }
    }
}
class $8b21612c25971c7b$export$c279cda0429c6dbe extends $8b21612c25971c7b$export$36d18380658d5d20 {
    constructor(value){
        super(value, false);
    }
}
function $8b21612c25971c7b$export$9f9d0139d032da4f(value) {
    return new $8b21612c25971c7b$export$c279cda0429c6dbe(value);
}
class $8b21612c25971c7b$export$ee2288f2b4bc04c4 extends $8b21612c25971c7b$export$36d18380658d5d20 {
    constructor(){
        super(undefined, true);
    }
}
const $8b21612c25971c7b$export$57ca7e07b341709d = new $8b21612c25971c7b$export$ee2288f2b4bc04c4();
const $8b21612c25971c7b$export$dae05fd938c910bc = {
    // Setoid
    equals: (x, y)=>x ? x.equals(y) : !y,
    // Functor
    map: (f, fa)=>fa.map(f),
    // Apply
    ap: (ff, fa)=>fa.ap(ff),
    // Applicative
    of: $8b21612c25971c7b$export$36d18380658d5d20.pure,
    // Chain
    chain: (f, fa)=>fa.flatMap(f),
    // ChainRec
    chainRec: (f, a)=>$8b21612c25971c7b$export$36d18380658d5d20.tailRecM(a, (a)=>f($8b21612c25971c7b$export$37cbe166bfc81b63.left, $8b21612c25971c7b$export$37cbe166bfc81b63.right, a))
};
// Registers Fantasy-Land compatible symbols
(0, $iMUUJ.fantasyLandRegister)($8b21612c25971c7b$export$36d18380658d5d20, $8b21612c25971c7b$export$dae05fd938c910bc, $8b21612c25971c7b$export$dae05fd938c910bc);
class $8b21612c25971c7b$export$fa957d01b0310fd7 {
    constructor(value, tag){
        this._isSuccess = tag === "success";
        this.value = value;
    }
    /**
     * Returns `true` if the source is a [[Success]] result,
     * or `false` in case it is a [[Failure]].
     */ isSuccess() {
        return this._isSuccess;
    }
    /**
     * Returns `true` if the source is a [[Failure]],
     * or `false` in case it is a [[Success]] result.
     */ isFailure() {
        return !this._isSuccess;
    }
    /**
     * Returns a Try's successful value if it's a [[Success]] reference,
     * otherwise throws an exception if it's a [[Failure]].
     *
     * WARNING!
     *
     * This function is partial, the option must be non-empty, otherwise
     * a runtime exception will get thrown. Use with care.
     */ get() {
        if (!this._isSuccess) throw this.value;
        return this.value;
    }
    /**
     * Returns the value from a `Success` or the given `fallback`
     * value if this is a `Failure`.
     *
     * ```typescript
     * Success(10).getOrElse(27) // 10
     * Failure("error").getOrElse(27)  // 27
     * ```
     */ getOrElse(fallback) {
        return this._isSuccess ? this.value : fallback;
    }
    /**
     * Returns the value from a `Success` or the value generated
     * by a given `thunk` in case this is a `Failure`.
     *
     * ```typescript
     * Success(10).getOrElseL(() => 27) // 10
     * Failure("error").getOrElseL(() => 27)  // 27
     * ```
     */ getOrElseL(thunk) {
        return this._isSuccess ? this.value : thunk();
    }
    /**
     * Returns the current value if it's a [[Success]], or
     * if the source is a [[Failure]] then return `null`.
     *
     * ```typescript
     * Success(10).orNull()      // 10
     * Failure("error").orNull() // null
     * ```
     *
     * This can be useful for use-cases such as:
     *
     * ```typescript
     * Try.of(() => dict.user.profile.name).orNull()
     * ```
     */ orNull() {
        return this._isSuccess ? this.value : null;
    }
    /**
     * Returns the current value if it's a [[Success]], or
     * if the source is a [[Failure]] then return `undefined`.
     *
     * ```typescript
     * Success(10).orUndefined()      // 10
     * Failure("error").orUndefined() // undefined
     * ```
     *
     * This can be useful for use-cases such as:
     *
     * ```typescript
     * Try.of(() => dict.user.profile.name).orUndefined()
     * ```
     */ orUndefined() {
        return this._isSuccess ? this.value : undefined;
    }
    /**
     * Returns the current value if it's a [[Success]], or if
     * the source is a [[Failure]] then return the `fallback`.
     *
     * ```typescript
     * Success(10).orElse(Success(17))      // 10
     * Failure("error").orElse(Success(17)) // 17
     * ```
     */ orElse(fallback) {
        if (this._isSuccess) return this;
        return fallback;
    }
    /**
     * Returns the current value if it's a [[Success]], or if the source
     * is a [[Failure]] then return the value generated by the given
     * `thunk`.
     *
     * ```typescript
     * Success(10).orElseL(() => Success(17))      // 10
     * Failure("error").orElseL(() => Success(17)) // 17
     * ```
     */ orElseL(thunk) {
        if (this._isSuccess) return this;
        return thunk();
    }
    /**
     * Inverts this `Try`. If this is a [[Failure]], returns its exception wrapped
     * in a [[Success]]. If this is a `Success`, returns a `Failure` containing a
     * [[NoSuchElementError]].
     */ failed() {
        return this._isSuccess ? $8b21612c25971c7b$export$5ebc9a4af3ac0850(new (0, $4grBR.NoSuchElementError)("try.failed()")) : $8b21612c25971c7b$export$ffa3d9fee6fd705a(this.value);
    }
    /**
     * Applies the `failure` function to [[Failure]] values, and the
     * `success` function to [[Success]] values and returns the result.
     *
     * ```typescript
     * const maybeNum: Try<number> =
     *   tryParseInt("not a number")
     *
     * const result: string =
     *   maybeNum.fold(
     *     error => `Could not parse string: ${error}`,
     *     num => `Success: ${num}`
     *   )
     * ```
     */ fold(failure, success) {
        return this._isSuccess ? success(this.value) : failure(this.value);
    }
    filter(p) {
        if (!this._isSuccess) return this;
        try {
            if (p(this.value)) return this;
            return $8b21612c25971c7b$export$5ebc9a4af3ac0850(new (0, $4grBR.NoSuchElementError)(`Predicate does not hold for ${this.value}`));
        } catch (e) {
            return $8b21612c25971c7b$export$5ebc9a4af3ac0850(e);
        }
    }
    /**
     * Returns the given function applied to the value if this is
     * a [[Success]] or returns `this` if this is a [[Failure]].
     *
     * This operation is the monadic "bind" operation.
     * It can be used to *chain* multiple `Try` references.
     *
     * ```typescript
     * Try.of(() => parse(s1)).flatMap(num1 =>
     *   Try.of(() => parse(s2)).map(num2 =>
     *     num1 / num2
     *   ))
     * ```
     */ flatMap(f) {
        if (!this._isSuccess) return this;
        try {
            return f(this.value);
        } catch (e) {
            return $8b21612c25971c7b$export$5ebc9a4af3ac0850(e);
        }
    }
    /** Alias for [[flatMap]]. */ chain(f) {
        return this.flatMap(f);
    }
    /**
     * `Applicative` apply operator.
     *
     * Resembles {@link map}, but the passed mapping function is
     * lifted in the `Either` context.
     */ ap(ff) {
        return ff.flatMap((f)=>this.map(f));
    }
    /**
     * Returns a `Try` containing the result of applying `f` to
     * this option's value, but only if it's a `Success`, or
     * returns the current `Failure` without any modifications.
     *
     * NOTE: this is similar with `flatMap`, except with `map` the
     * result of `f` doesn't need to be wrapped in a `Try`.
     *
     * @param f the mapping function that will transform the value
     *          of this `Try` if successful.
     *
     * @return a new `Try` instance containing the value of the
     *         source mapped by the given function
     */ map(f) {
        return this._isSuccess ? $8b21612c25971c7b$export$fa957d01b0310fd7.of(()=>f(this.value)) : this;
    }
    /**
     * Applies the given function `cb` if this is a [[Success]], otherwise
     * returns `void` if this is a [[Failure]].
     */ forEach(cb) {
        if (this._isSuccess) cb(this.value);
    }
    /**
     * Applies the given function `f` if this is a `Failure`, otherwise
     * returns `this` if this is a `Success`.
     *
     * This is like `map` for the exception.
     *
     * In the following example, if the `user.profile.email` exists,
     * then it is returned as a successful value, otherwise
     *
     * ```typescript
     * Try.of(() => user.profile.email).recover(e => {
     *   // Access error? Default to empty.
     *   if (e instanceof TypeError) return ""
     *   throw e // We don't know what it is, rethrow
     * })
     *
     * Note that on rethrow, the error is being caught in `recover` and
     * it still returns it as a `Failure(e)`.
     * ```
     */ recover(f) {
        return this._isSuccess ? this : $8b21612c25971c7b$export$fa957d01b0310fd7.of(()=>f(this.value));
    }
    /**
     * Applies the given function `f` if this is a `Failure`, otherwise
     * returns `this` if this is a `Success`.
     *
     * This is like `map` for the exception.
     *
     * In the following example, if the `user.profile.email` exists,
     * then it is returned as a successful value, otherwise
     *
     * ```typescript
     * Try.of(() => user.profile.email).recover(e => {
     *   // Access error? Default to empty.
     *   if (e instanceof TypeError) return ""
     *   throw e // We don't know what it is, rethrow
     * })
     *
     * Note that on rethrow, the error is being caught in `recover` and
     * it still returns it as a `Failure(e)`.
     * ```
     */ recoverWith(f) {
        try {
            return this._isSuccess ? this : f(this.value);
        } catch (e) {
            return $8b21612c25971c7b$export$5ebc9a4af3ac0850(e);
        }
    }
    /**
     * Transforms the source into an [[Option]].
     *
     * In case the source is a `Success(v)`, then it gets translated
     * into a `Some(v)`. If the source is a `Failure(e)`, then a `None`
     * value is returned.
     *
     * ```typescript
     * Success("value").toOption() // Some("value")
     * Failure("error").toOption() // None
     * ```
     */ toOption() {
        return this._isSuccess ? $8b21612c25971c7b$export$9f9d0139d032da4f(this.value) : $8b21612c25971c7b$export$57ca7e07b341709d;
    }
    /**
     * Transforms the source into an [[Either]].
     *
     * In case the source is a `Success(v)`, then it gets translated
     * into a `Right(v)`. If the source is a `Failure(e)`, then a `Left(e)`
     * value is returned.
     *
     * ```typescript
     * Success("value").toEither() // Right("value")
     * Failure("error").toEither() // Left("error")
     * ```
     */ toEither() {
        return this._isSuccess ? $8b21612c25971c7b$export$19db0165690c701a(this.value) : $8b21612c25971c7b$export$37c4d04eafdc5515(this.value);
    }
    /**
     * Implements {@link IEquals.equals} with overridable equality for `A`.
     */ equals(that) {
        // tslint:disable-next-line:strict-type-predicates
        if (that == null) return false;
        return this._isSuccess ? that._isSuccess && $7ARg3.is(this.value, that.value) : !that._isSuccess && $7ARg3.is(this.value, that.value);
    }
    // Implemented from IEquals
    hashCode() {
        return this._isSuccess ? $7ARg3.hashCode(this.value) : $7ARg3.hashCode(this.value);
    }
    /**
     * Evaluates the given `thunk` and returns either a [[Success]],
     * in case the evaluation succeeded, or a [[Failure]], in case
     * an exception was thrown.
     *
     * Example:
     *
     * ```typescript
     * let effect = 0
     *
     * const e = Try.of(() => { effect += 1; return effect })
     * e.get() // 1
     * ```
     */ static of(thunk) {
        try {
            return $8b21612c25971c7b$export$ffa3d9fee6fd705a(thunk());
        } catch (e) {
            return $8b21612c25971c7b$export$5ebc9a4af3ac0850(e);
        }
    }
    /** Alias of [[Try.success]]. */ static pure(value) {
        return $8b21612c25971c7b$export$fa957d01b0310fd7.success(value);
    }
    /**
     * Shorthand for `now(undefined as void)`, always returning
     * the same reference as optimization.
     */ static unit() {
        return $8b21612c25971c7b$var$tryUnitRef;
    }
    /**
     * Returns a [[Try]] reference that represents a successful result
     * (i.e. wrapped in [[Success]]).
     */ static success(value) {
        return $8b21612c25971c7b$export$ffa3d9fee6fd705a(value);
    }
    /**
     * Returns a [[Try]] reference that represents a failure
     * (i.e. an exception wrapped in [[Failure]]).
     */ static failure(e) {
        return $8b21612c25971c7b$export$5ebc9a4af3ac0850(e);
    }
    /**
     * Alias for {@link Try.failure} and {@link Failure},
     * wrapping any throwable into a `Try` value.
     */ static raise(e) {
        return $8b21612c25971c7b$export$5ebc9a4af3ac0850(e);
    }
    /**
     * Maps 2 `Try` values by the mapping function, returning a new
     * `Try` reference that is a `Success` only if both `Try` values are
     * a `Success`, otherwise it returns the first `Failure` noticed.
     *
     * ```typescript
     * // Yields Success(3)
     * Try.map2(Success(1), Success(2),
     *   (a, b) => a + b
     * )
     *
     * // Yields Failure, because the second arg is a Failure
     * Try.map2(Success(1), Failure("error"),
     *   (a, b) => a + b
     * )
     * ```
     *
     * This operation is the `Applicative.map2`.
     */ static map2(fa1, fa2, f) {
        if (fa1.isFailure()) return fa1;
        if (fa2.isFailure()) return fa2;
        try {
            return $8b21612c25971c7b$export$ffa3d9fee6fd705a(f(fa1.value, fa2.value));
        } catch (e) {
            return $8b21612c25971c7b$export$5ebc9a4af3ac0850(e);
        }
    }
    /**
     * Maps 3 `Try` values by the mapping function, returning a new
     * `Try` reference that is a `Success` only if all 3 `Try` values are
     * a `Success`, otherwise it returns the first `Failure` noticed.
     *
     * ```typescript
     * // Yields Success(6)
     * Try.map3(Success(1), Success(2), Success(3),
     *   (a, b, c) => {
     *     return a + b + c
     *   }
     * )
     *
     * // Yields Failure, because the second arg is a Failure
     * Try.map3(
     *   Success(1),
     *   Failure("error"),
     *   Success(3),
     *
     *   (a, b, c) => {
     *     return a + b + c
     *   }
     * )
     * ```
     */ static map3(fa1, fa2, fa3, f) {
        if (fa1.isFailure()) return fa1;
        if (fa2.isFailure()) return fa2;
        if (fa3.isFailure()) return fa3;
        try {
            return $8b21612c25971c7b$export$ffa3d9fee6fd705a(f(fa1.value, fa2.value, fa3.value));
        } catch (e) {
            return $8b21612c25971c7b$export$5ebc9a4af3ac0850(e);
        }
    }
    /**
     * Maps 4 `Try` values by the mapping function, returning a new
     * `Try` reference that is a `Success` only if all 4 `Try` values are
     * a `Success`, otherwise it returns the first `Failure` noticed.
     *
     * ```typescript
     * // Yields Success(10)
     * Try.map4(Success(1), Success(2), Success(3), Success(4),
     *   (a, b, c, d) => {
     *     return a + b + c + d
     *   }
     * )
     *
     * // Yields Failure, because the second arg is a Failure
     * Try.map3(
     *   Success(1),
     *   Failure("error"),
     *   Success(3),
     *   Success(4),
     *
     *   (a, b, c, d) => {
     *     return a + b + c + d
     *   }
     * )
     * ```
     */ static map4(fa1, fa2, fa3, fa4, f) {
        if (fa1.isFailure()) return fa1;
        if (fa2.isFailure()) return fa2;
        if (fa3.isFailure()) return fa3;
        if (fa4.isFailure()) return fa4;
        try {
            return $8b21612c25971c7b$export$ffa3d9fee6fd705a(f(fa1.value, fa2.value, fa3.value, fa4.value));
        } catch (e) {
            return $8b21612c25971c7b$export$5ebc9a4af3ac0850(e);
        }
    }
    /**
     * Maps 5 `Try` values by the mapping function, returning a new
     * `Try` reference that is a `Success` only if all 5 `Try` values are
     * a `Success`, otherwise it returns the first `Failure` noticed.
     *
     * ```typescript
     * // Yields Success(15)
     * Try.map5(
     *   Success(1),
     *   Success(2),
     *   Success(3),
     *   Success(4),
     *   Success(5),
     *
     *   (a, b, c, d, e) => {
     *     return a + b + c + d + e
     *   }
     * )
     *
     * // Yields Failure, because the second arg is a Failure
     * Try.map5(
     *   Success(1),
     *   Failure("error"),
     *   Success(3),
     *   Success(4),
     *   Success(5),
     *
     *   (a, b, c, d, e) => {
     *     return a + b + c + d + e
     *   }
     * )
     * ```
     */ static map5(fa1, fa2, fa3, fa4, fa5, f) {
        if (fa1.isFailure()) return fa1;
        if (fa2.isFailure()) return fa2;
        if (fa3.isFailure()) return fa3;
        if (fa4.isFailure()) return fa4;
        if (fa5.isFailure()) return fa5;
        try {
            return $8b21612c25971c7b$export$ffa3d9fee6fd705a(f(fa1.value, fa2.value, fa3.value, fa4.value, fa5.value));
        } catch (e) {
            return $8b21612c25971c7b$export$5ebc9a4af3ac0850(e);
        }
    }
    /**
     * Maps 6 `Try` values by the mapping function, returning a new
     * `Try` reference that is a `Success` only if all 6 `Try` values are
     * a `Success`, otherwise it returns the first `Failure` noticed.
     *
     * ```typescript
     * // Yields Success(21)
     * Try.map6(
     *   Success(1),
     *   Success(2),
     *   Success(3),
     *   Success(4),
     *   Success(5),
     *   Success(6),
     *
     *   (a, b, c, d, e, f) => {
     *     return a + b + c + d + e + f
     *   }
     * )
     *
     * // Yields Failure, because the second arg is a Failure
     * Try.map6(
     *   Success(1),
     *   Failure("error"),
     *   Success(3),
     *   Success(4),
     *   Success(5),
     *   Success(6),
     *
     *   (a, b, c, d, e, f) => {
     *     return a + b + c + d + e + f
     *   }
     * )
     * ```
     */ static map6(fa1, fa2, fa3, fa4, fa5, fa6, f) {
        if (fa1.isFailure()) return fa1;
        if (fa2.isFailure()) return fa2;
        if (fa3.isFailure()) return fa3;
        if (fa4.isFailure()) return fa4;
        if (fa5.isFailure()) return fa5;
        if (fa6.isFailure()) return fa6;
        try {
            return $8b21612c25971c7b$export$ffa3d9fee6fd705a(f(fa1.value, fa2.value, fa3.value, fa4.value, fa5.value, fa6.value));
        } catch (e) {
            return $8b21612c25971c7b$export$5ebc9a4af3ac0850(e);
        }
    }
    /**
     * Keeps calling `f` until a `Right(b)` is returned.
     *
     * Based on Phil Freeman's
     * [Stack Safety for Free]{@link http://functorial.com/stack-safety-for-free/index.pdf}.
     *
     * Described in `FlatMap.tailRecM`.
     */ static tailRecM(a, f) {
        let cursor = a;
        while(true)try {
            const result = f(cursor);
            if (result.isFailure()) return result;
            const some = result.get();
            if (some.isRight()) return $8b21612c25971c7b$export$ffa3d9fee6fd705a(some.value);
            cursor = some.value;
        } catch (e) {
            return $8b21612c25971c7b$export$5ebc9a4af3ac0850(e);
        }
    }
}
class $8b21612c25971c7b$export$a78bea8ed2ae2fde extends $8b21612c25971c7b$export$fa957d01b0310fd7 {
    constructor(value){
        super(value, "success");
    }
}
function $8b21612c25971c7b$export$ffa3d9fee6fd705a(value) {
    return new $8b21612c25971c7b$export$a78bea8ed2ae2fde(value);
}
class $8b21612c25971c7b$export$a432f16a0795683f extends $8b21612c25971c7b$export$fa957d01b0310fd7 {
    constructor(value){
        super(value, "failure");
    }
}
function $8b21612c25971c7b$export$5ebc9a4af3ac0850(e) {
    return new $8b21612c25971c7b$export$a432f16a0795683f(e);
}
const $8b21612c25971c7b$export$93cc75c33014d88a = {
    // Setoid
    equals: (x, y)=>x ? x.equals(y) : !y,
    // Functor
    map: (f, fa)=>fa.map(f),
    // Apply
    ap: (ff, fa)=>fa.ap(ff),
    // Applicative
    of: $8b21612c25971c7b$export$fa957d01b0310fd7.pure,
    // Chain
    chain: (f, fa)=>fa.flatMap(f),
    // ChainRec
    chainRec: (f, a)=>$8b21612c25971c7b$export$fa957d01b0310fd7.tailRecM(a, (a)=>f($8b21612c25971c7b$export$37cbe166bfc81b63.left, $8b21612c25971c7b$export$37cbe166bfc81b63.right, a))
};
// Registers Fantasy-Land compatible symbols
(0, $iMUUJ.fantasyLandRegister)($8b21612c25971c7b$export$fa957d01b0310fd7, $8b21612c25971c7b$export$93cc75c33014d88a, $8b21612c25971c7b$export$93cc75c33014d88a);
/**
 * Reusable reference, to use in {@link Try.unit}.
 *
 * @private
 * @hidden
 */ const $8b21612c25971c7b$var$tryUnitRef = $8b21612c25971c7b$export$ffa3d9fee6fd705a(undefined);

});
parcelRegister("iMUUJ", function(module, exports) {

$parcel$export(module.exports, "fantasyLandRegister", () => $dad8dba3f9875d28$export$366e3fc13367d41c);
/*!
 * Copyright (c) 2017-2018 by The Funfix Project Developers.
 * Some rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Given a function, converts it into a method where `this` gets
 * passed around as the last argument.
 */ function $dad8dba3f9875d28$export$8532f18845d94af4(f) {
    return function() {
        const args = Array.prototype.slice.call(arguments);
        args.push(this);
        return f.apply(undefined, args);
    };
}
function $dad8dba3f9875d28$export$366e3fc13367d41c(cls, monad, setoid) {
    const c = cls;
    const p = c.prototype;
    const fl = "fantasy-land/";
    const equals = "equals";
    const flEquals = fl + equals;
    const map = "map";
    const flMap = fl + map;
    const ap = "ap";
    const flAp = fl + ap;
    const flOf = fl + "of";
    const chain = "chain";
    const flChain = fl + chain;
    const chainRec = "chainRec";
    const flChainRec = fl + chainRec;
    // Setoid
    if (p[equals]) p[flEquals] = p[equals];
    else /* istanbul ignore else */ if (setoid) p[flEquals] = $dad8dba3f9875d28$export$8532f18845d94af4(setoid.equals);
    // Functor
    if (p[map]) p[flMap] = p[map];
    else /* istanbul ignore else */ if (monad) p[flMap] = $dad8dba3f9875d28$export$8532f18845d94af4(monad.map);
    // Apply
    if (p[ap]) p[flAp] = p[ap];
    else /* istanbul ignore else */ if (monad) p[flAp] = $dad8dba3f9875d28$export$8532f18845d94af4(monad.ap);
    // Applicative
    if (c["pure"]) c[flOf] = c["pure"];
    else /* istanbul ignore else */ if (monad) c[flOf] = monad.of;
    // Chain
    if (p[chain]) p[flChain] = p[chain];
    else /* istanbul ignore else */ if (monad) p[flChain] = $dad8dba3f9875d28$export$8532f18845d94af4(monad.chain);
    // ChainRec
    if (c[chainRec]) c[flChainRec] = c[chainRec];
    else /* istanbul ignore else */ if (monad) c[flChainRec] = monad.chainRec;
}

});



parcelRegister("3DsUo", function(module, exports) {

$parcel$export(module.exports, "reflect", () => $2a5b7041164d4a1c$export$9debe8cffacea23);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");
function $2a5b7041164d4a1c$export$9debe8cffacea23(promise) {
    return promise.then((data)=>(0, $bWAru.Either).right(data)).catch((error)=>(0, $bWAru.Either).left(error));
}

});

parcelRegister("01SeN", function(module, exports) {

$parcel$export(module.exports, "default", () => $005a2a8f473d4f7f$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $5YKni = parcelRequire("5YKni");

var $lLYAL = parcelRequire("lLYAL");

var $lNaxt = parcelRequire("lNaxt");

var $1C9jQ = parcelRequire("1C9jQ");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $7YbkQ = parcelRequire("7YbkQ");

var $7Uh51 = parcelRequire("7Uh51");

var $gIQkA = parcelRequire("gIQkA");
class $005a2a8f473d4f7f$export$2e2bcd8739ae039 {
    constructor(){
        (0, $5zQU9.default)(this, "analyticsClient", null);
        (0, $5zQU9.default)(this, "eventsTable", (0, $g5DHJ.Map)());
    }
    initialize(hostInfo, userId) {
        return new Promise((resolve)=>{
            const client = (0, $7YbkQ.default).get();
            const cloudId = (0, $lLYAL.parse)(hostInfo.globalContext.id).cloudId;
            const orgId = hostInfo.globalContext.orgId;
            const workspaceAri = (0, $lLYAL.parse)(hostInfo.globalContext.workspaceAri).toString();
            client.setTenantInfo((0, $1C9jQ.tenantType).CLOUD_ID, cloudId);
            client.setOrgInfo(orgId);
            client.setWorkspaceInfo(workspaceAri);
            client.setUserInfo((0, $1C9jQ.userType).ATLASSIAN_ACCOUNT, userId);
            this.eventsTable = (0, $7Uh51.allAnalyticsEvents).concat((0, $5YKni.default)).reduce((table, e)=>table.setIn([
                    e.action,
                    e.actionSubject
                ], (0, $lNaxt.foldAnalyticsEventType)(e.type)(()=>client.sendTrackEvent, ()=>client.sendUIEvent, ()=>client.sendOperationalEvent)), this.eventsTable);
            this.analyticsClient = client;
            resolve();
        });
    }
    sendPageViewEvent(pageViewEvent) {
        if (this.analyticsClient) {
            const analyticsClient = this.analyticsClient;
            if (!(0, $gIQkA.allAnalyticsSources).some((source)=>source.name === pageViewEvent.name)) throw new Error("Unregistered source: ".concat(pageViewEvent.name, ". Add to analytics/Sources.js!"));
            analyticsClient.sendScreenEvent({
                name: pageViewEvent.name,
                attributes: pageViewEvent.attributes
            });
        }
    }
    sendEvent(event) {
        if (this.analyticsClient) (0, $bWAru.Option).of(this.eventsTable.getIn([
            event.action,
            event.actionSubject
        ])).map((send)=>send(event)).orElseL(()=>{
            throw new Error("Unregistered event: ".concat(event.actionSubject, " ").concat(event.action, ". Add to analytics/Events.js!"));
        });
    }
}

});
parcelRegister("lLYAL", function(module, exports) {
"use strict";
var $fd9cfd0bb813c6d0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fd9cfd0bb813c6d0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fd9cfd0bb813c6d0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseEncoded = module.exports.parse = void 0;


$fd9cfd0bb813c6d0$var$__exportStar((parcelRequire("83g6W")), module.exports);

$fd9cfd0bb813c6d0$var$__exportStar((parcelRequire("h8Lnt")), module.exports);

$fd9cfd0bb813c6d0$var$__exportStar((parcelRequire("oXPmI")), module.exports);
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $fd9cfd0bb813c6d0$var$parse(ariString) {
    return (parcelRequire("oXPmI")).ResourceIdentifier.parse(ariString);
}
module.exports.parse = $fd9cfd0bb813c6d0$var$parse;
/**
 * Parse a URL encoded string as an Ari
 *
 * @param {string} encodedAriString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $fd9cfd0bb813c6d0$var$parseEncoded(encodedAriString) {
    return (parcelRequire("oXPmI")).ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $fd9cfd0bb813c6d0$var$parseEncoded;

});
parcelRegister("oXPmI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ResourceIdentifier = module.exports.InvalidAriError = void 0;

var $cTNF8 = parcelRequire("cTNF8");
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ class $04b0a67ef92fd3ed$var$InvalidAriError extends Error {
    /**
     * Construct an InvalidAriError given an error message
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {string|undefined} description - The error message
     */ constructor(ariString, description){
        super(`Invalid ari string: ${ariString}${description ? '. ' + description : ''}`);
        this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(this, $04b0a67ef92fd3ed$var$InvalidAriError.prototype);
    }
    /**
     * Construct an InvalidAriError given some constraint violations
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
     */ static withConstraintViolations(ariString, violations) {
        return new $04b0a67ef92fd3ed$var$InvalidAriError(ariString, violations.map((v)=>v.toString()).join('\n'));
    }
}
module.exports.InvalidAriError = $04b0a67ef92fd3ed$var$InvalidAriError;
function $04b0a67ef92fd3ed$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
const $04b0a67ef92fd3ed$var$basicCharConstraint = (0, $cTNF8.pattern)(/^[a-z][a-z.-]*$/);
/**
 * resourceType allows for capitalized letters to support Identity ARIs (`ari:cloud:identity::userGrant/<...>`)
 * It's a violation of the spec, but we still need to support that.
 * See https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0
 */ const $04b0a67ef92fd3ed$var$resourceTypeCharConstraints = (0, $cTNF8.pattern)(/^[a-z][a-z.-]*$/i);
const $04b0a67ef92fd3ed$var$resourceOwnerConstraints = [
    (0, $cTNF8.lengthBetween)(3, 255),
    $04b0a67ef92fd3ed$var$basicCharConstraint
];
const $04b0a67ef92fd3ed$var$resourceTypeConstraints = [
    (0, $cTNF8.lengthBetween)(3, 255),
    $04b0a67ef92fd3ed$var$resourceTypeCharConstraints
];
const $04b0a67ef92fd3ed$var$cloudIdConstraints = [
    (0, $cTNF8.lengthBetween)(3, 255)
];
const $04b0a67ef92fd3ed$var$siteResourceType = 'site';
const $04b0a67ef92fd3ed$var$resourceIdChars = /[\w-._~:@#]/.source;
const $04b0a67ef92fd3ed$var$resourceIdConstraints = [
    (0, $cTNF8.pattern)(new RegExp(`^${$04b0a67ef92fd3ed$var$resourceIdChars}+(/${$04b0a67ef92fd3ed$var$resourceIdChars}*)*(;v=${$04b0a67ef92fd3ed$var$resourceIdChars}*)*$`))
];
/**
 * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
 * (like those for site wide ARIs) are upgraded to their latest form.
 */ function $04b0a67ef92fd3ed$var$upgrade(values) {
    const { resourceId: resourceId, resourceOwner: resourceOwner, cloudId: cloudId } = values;
    // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $04b0a67ef92fd3ed$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
class $04b0a67ef92fd3ed$var$ResourceIdentifier {
    get cloudId() {
        if (this.resourceType === $04b0a67ef92fd3ed$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
        return this.internalCloudId;
    }
    /**
     * Create a new Ari
     *
     * Only the resourceOwner is a required field, any other field can be omitted.
     * Older format types are converted on creation
     *
     * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
     * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
     * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
     * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
     *
     * @throws {InvalidAriError} if the provided segments fail to pass validation
     */ constructor(values){
        const { resourceId: resourceId, resourceOwner: resourceOwner, resourceType: resourceType, cloudId: cloudId } = $04b0a67ef92fd3ed$var$upgrade(values);
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    /**
     * Parse a string as an Ari
     *
     * @param {string} ariString - the string to parse
     * @returns {Ari} the parsed ari
     * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
     */ static parse(ariString) {
        if (!ariString) throw new $04b0a67ef92fd3ed$var$InvalidAriError(ariString);
        const match = new RegExp(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/).exec(ariString);
        if (!match || match.length !== 5) throw new $04b0a67ef92fd3ed$var$InvalidAriError(ariString);
        const terms = match.map((a)=>a && a.length > 0 ? a : undefined);
        const resourceOwner = terms[1];
        if (!resourceOwner) throw new $04b0a67ef92fd3ed$var$InvalidAriError(ariString);
        return new $04b0a67ef92fd3ed$var$ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    }
    static parseEncoded(encodedAriString) {
        return $04b0a67ef92fd3ed$var$ResourceIdentifier.parse(decodeURIComponent(encodedAriString));
    }
    /**
     * Converts this Ari to a string.
     */ toString() {
        if (!this.ariString) {
            const resourceId = this.resourceType === $04b0a67ef92fd3ed$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            const resourceType = this.resourceType || '';
            const sanitizedCloudId = this.resourceType === $04b0a67ef92fd3ed$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = `ari:cloud:${this.resourceOwner}:${sanitizedCloudId}:${resourceType}/${resourceId}`;
        }
        return this.ariString;
    }
    /**
     * Converts this object to its json representation
     */ toJSON() {
        return this.toString();
    }
    /**
     * Checks if this context is the same as another context
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
     */ equals(other) {
        return other instanceof $04b0a67ef92fd3ed$var$ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    }
    /**
     * This method checks if the current context contains the other context.
     *
     * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
     * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
     *
     * @param {Ari} other
     * @returns {boolean}
     */ contains(other) {
        return this.matches(new $04b0a67ef92fd3ed$var$ResourceIdentifier(other));
    }
    /**
     * Checks if this context is the same as or contains the provided context.
     *
     * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
     *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
     *
     * e.g.
     * ```
     * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
     * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
     */ matches(other) {
        return $04b0a67ef92fd3ed$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $04b0a67ef92fd3ed$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $04b0a67ef92fd3ed$var$siteResourceType && !!other.resourceType || $04b0a67ef92fd3ed$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $04b0a67ef92fd3ed$var$siteResourceType && !!other.resourceType || $04b0a67ef92fd3ed$var$matchesSegment(this.resourceId, other.resourceId));
    }
    validateSiteWide() {
        const { resourceType: resourceType, cloudId: cloudId } = this;
        if (resourceType === $04b0a67ef92fd3ed$var$siteResourceType && !cloudId) return new $cTNF8.GeneralValidationError('site wide ARIs must have a cloudId');
    }
    validate() {
        const constraintViolations = [
            (0, $cTNF8.validateField)(this, 'resourceOwner', $04b0a67ef92fd3ed$var$resourceOwnerConstraints),
            (0, $cTNF8.validateField)(this, 'resourceType', $04b0a67ef92fd3ed$var$resourceTypeConstraints),
            (0, $cTNF8.validateField)(this, 'resourceId', $04b0a67ef92fd3ed$var$resourceIdConstraints),
            (0, $cTNF8.validateField)(this, 'cloudId', $04b0a67ef92fd3ed$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $04b0a67ef92fd3ed$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $04b0a67ef92fd3ed$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    }
    urlEncode() {
        return encodeURIComponent(this.toString());
    }
    urlDecode() {
        return decodeURIComponent(this.toString());
    }
}
module.exports.ResourceIdentifier = $04b0a67ef92fd3ed$var$ResourceIdentifier;

});
parcelRegister("cTNF8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateField = module.exports.pattern = module.exports.lengthBetween = module.exports.ConstraintViolation = module.exports.GeneralValidationError = module.exports.RegexConstraint = module.exports.LengthConstraint = void 0;

var $M3rLj = parcelRequire("M3rLj");
class $9641250ab9e6873a$var$LengthConstraint {
    constructor(min, max){
        this.min = min;
        this.max = max;
    }
    get description() {
        return `length must be between ${this.min} and ${this.max}`;
    }
    isValid(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    }
}
module.exports.LengthConstraint = $9641250ab9e6873a$var$LengthConstraint;
class $9641250ab9e6873a$var$RegexConstraint {
    constructor(regex){
        this.regex = regex;
    }
    get description() {
        return `value must match regex ${this.regex.source}`;
    }
    isValid(value) {
        return !value || this.regex.test(value);
    }
}
module.exports.RegexConstraint = $9641250ab9e6873a$var$RegexConstraint;
class $9641250ab9e6873a$var$GeneralValidationError {
    constructor(error){
        this.error = error;
    }
    toString() {
        return this.error;
    }
}
module.exports.GeneralValidationError = $9641250ab9e6873a$var$GeneralValidationError;
class $9641250ab9e6873a$var$ConstraintViolation {
    constructor(fieldName, value, constraints){
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    toString() {
        const constraintSummary = this.constraints.map((c)=>`  - ${c.description}`).join('\n');
        return `'${this.value}' is not a valid value for ${this.fieldName} as it violates the following constraints:\n${constraintSummary}`;
    }
}
module.exports.ConstraintViolation = $9641250ab9e6873a$var$ConstraintViolation;
function $9641250ab9e6873a$var$lengthBetween(min, max) {
    return new $9641250ab9e6873a$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $9641250ab9e6873a$var$lengthBetween;
function $9641250ab9e6873a$var$pattern(regex) {
    return new $9641250ab9e6873a$var$RegexConstraint(regex);
}
module.exports.pattern = $9641250ab9e6873a$var$pattern;
function $9641250ab9e6873a$var$validateField(object, fieldName, constraints) {
    const value = object[fieldName];
    const violatedConstraints = constraints.map((c)=>{
        return c.isValid(value) ? undefined : c;
    }).filter($M3rLj.isDefined);
    return violatedConstraints.length > 0 ? new $9641250ab9e6873a$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $9641250ab9e6873a$var$validateField;

});
parcelRegister("M3rLj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasValueAtKey = module.exports.hasPresentKey = module.exports.isFilled = module.exports.isDefined = module.exports.isPresent = void 0;
function $0907284485cca5f4$var$isPresent(t) {
    return t !== undefined && t !== null;
}
module.exports.isPresent = $0907284485cca5f4$var$isPresent;
function $0907284485cca5f4$var$isDefined(t) {
    return t !== undefined;
}
module.exports.isDefined = $0907284485cca5f4$var$isDefined;
function $0907284485cca5f4$var$isFilled(t) {
    return t !== null;
}
module.exports.isFilled = $0907284485cca5f4$var$isFilled;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a defined non-null value under the key `k`.
 *
 * @example
 * ```ts
 * const filesWithUrl = files.filter(file => file.url);
 * files[0].url // In this case, TS might still treat this as undefined/null
 *
 * const filesWithUrl = files.filter(hasPresentKey("url"));
 * files[0].url // TS will know that this is present
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $0907284485cca5f4$var$hasPresentKey(k) {
    return function(a) {
        return a[k] !== undefined && a[k] !== null;
    };
}
module.exports.hasPresentKey = $0907284485cca5f4$var$hasPresentKey;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a specific value V under a key `k`.
 *
 * @example
 * ```ts
 * type File = { type: "image", imageUrl: string } | { type: "pdf", pdfUrl: string };
 * const files: File[] = [];
 *
 * const imageFiles = files.filter(file => file.type === "image");
 * files[0].type // In this case, TS will still treat it  as `"image" | "pdf"`
 *
 * const filesWithUrl = files.filter(hasValueKey("type", "image" as const));
 * files[0].type // TS will now know that this is "image"
 * files[0].imageUrl // TS will know this is present, because already it excluded the other union members.
 *
 * Note: the cast `as const` is necessary, otherwise TS will only know that type is a string.
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $0907284485cca5f4$var$hasValueAtKey(k, v) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(a) {
        return a[k] === v;
    };
}
module.exports.hasValueAtKey = $0907284485cca5f4$var$hasValueAtKey;

});



parcelRegister("83g6W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NotExpectedAppFamilyAriTypeError = module.exports.NotAppFamilyAriError = module.exports.AppFamilyAriError = void 0;
class $5dcb19db99e9de10$var$AppFamilyAriError extends Error {
    constructor(message, cause){
        super(message);
        this.cause = cause;
    }
}
module.exports.AppFamilyAriError = $5dcb19db99e9de10$var$AppFamilyAriError;
class $5dcb19db99e9de10$var$NotAppFamilyAriError extends $5dcb19db99e9de10$var$AppFamilyAriError {
    constructor(ari, reason){
        super(`ari is not a valid App family ari: ${ari.toString()} as ${reason}`);
        this.reason = reason;
    }
}
module.exports.NotAppFamilyAriError = $5dcb19db99e9de10$var$NotAppFamilyAriError;
class $5dcb19db99e9de10$var$NotExpectedAppFamilyAriTypeError extends $5dcb19db99e9de10$var$AppFamilyAriError {
    constructor(type, ari, cause){
        super(`App family ari (${ari.toString()}) is not of expected type: ${type}`, cause);
        this.cause = cause;
    }
}
module.exports.NotExpectedAppFamilyAriTypeError = $5dcb19db99e9de10$var$NotExpectedAppFamilyAriTypeError;

});

parcelRegister("h8Lnt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createAppAri = module.exports.parseAppAri = void 0;

var $h05ek = parcelRequire("h05ek");
/**
 * throws NotAppFamilyAriError if not a valid app family ari
 */ function $c7a7ef3503da1acb$var$parseAppAri(ari) {
    return $h05ek.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $c7a7ef3503da1acb$var$parseAppAri;
function $c7a7ef3503da1acb$var$createAppAri(json) {
    return new $h05ek.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $c7a7ef3503da1acb$var$createAppAri;

});
parcelRegister("h05ek", function(module, exports) {
"use strict";
var $c6067e522af1a0ae$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c6067e522af1a0ae$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c6067e522af1a0ae$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c6067e522af1a0ae$var$__createBinding(result, mod, k);
    }
    $c6067e522af1a0ae$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AppFamilyAriImpl = void 0;

const $c6067e522af1a0ae$var$AppFamilyAriModule = $c6067e522af1a0ae$var$__importStar((parcelRequire("kmdLH")));

var $83g6W = parcelRequire("83g6W");

var $cTNF8 = parcelRequire("cTNF8");

var $oXPmI = parcelRequire("oXPmI");
const $c6067e522af1a0ae$var$versionPrefix = ';v=';
const $c6067e522af1a0ae$var$uuidRegExpString = '[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}';
const $c6067e522af1a0ae$var$uuidConstraints = [
    (0, $cTNF8.pattern)(new RegExp(`^${$c6067e522af1a0ae$var$uuidRegExpString}$`, 'i'))
];
const $c6067e522af1a0ae$var$extensionGroupIdConstraints = [
    (0, $cTNF8.pattern)(new RegExp(`^(${$c6067e522af1a0ae$var$uuidRegExpString}|static)$`, 'i'))
];
function $c6067e522af1a0ae$var$stripToUndefined(str) {
    if (!str) return undefined;
    const trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}
class $c6067e522af1a0ae$var$AppFamilyAriImpl {
    constructor(json){
        this.json = json;
        this.validate();
    }
    get appId() {
        return this.json.appId;
    }
    get environmentId() {
        return this.json.environmentId;
    }
    get versionId() {
        return this.json.versionId;
    }
    get version() {
        return this.json.version;
    }
    get extensionGroupId() {
        return this.json.extensionGroupId;
    }
    get extensionKey() {
        return this.json.extensionKey;
    }
    toJSON() {
        return this.json;
    }
    /* eslint-disable complexity */ static parse(ari) {
        const { resourceOwner: resourceOwner, resourceType: resourceType, resourceId: resourceId } = ari;
        if (resourceOwner !== $c6067e522af1a0ae$var$AppFamilyAriModule.resourceOwner) throw new $83g6W.NotAppFamilyAriError(ari, `resourceOwner (${resourceOwner}) must be ${$c6067e522af1a0ae$var$AppFamilyAriModule.resourceOwner}`);
        if (!resourceType || !$c6067e522af1a0ae$var$AppFamilyAriModule.isAppFamilyResourceType(resourceType)) throw new $83g6W.NotAppFamilyAriError(ari, `resourceType must be one of ${$c6067e522af1a0ae$var$AppFamilyAriModule.appFamilyResourceTypes}`);
        if (!resourceId) throw new $83g6W.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        const versionIndex = resourceId.indexOf($c6067e522af1a0ae$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($c6067e522af1a0ae$var$versionPrefix) > versionIndex) throw new $83g6W.NotAppFamilyAriError(ari, 'can only include one version suffix');
        const [mainResourceId, version] = resourceId.split($c6067e522af1a0ae$var$versionPrefix);
        const segments = mainResourceId.split('/').map($c6067e522af1a0ae$var$stripToUndefined);
        if (segments.length > 4) throw new $83g6W.NotAppFamilyAriError(ari, `no path segments can be added after extensionKey ${segments.slice(4)}`);
        const [appId, environmentId, providedExtensionGroupId, extensionKey] = segments;
        const versionId = resourceType === $c6067e522af1a0ae$var$AppFamilyAriModule.appEnvironmentVersionResourceType ? providedExtensionGroupId : undefined;
        if (!appId) throw new $83g6W.NotAppFamilyAriError(ari, 'appId must be included');
        const extensionGroupId = providedExtensionGroupId || (resourceType === $c6067e522af1a0ae$var$AppFamilyAriModule.extensionGroupResourceType || resourceType === $c6067e522af1a0ae$var$AppFamilyAriModule.extensionResourceType ? 'static' : undefined);
        if (resourceType === $c6067e522af1a0ae$var$AppFamilyAriModule.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $83g6W.NotAppFamilyAriError(ari, `environmentId, extensionGroupId, extensionKey must all be provided for resourceType ${$c6067e522af1a0ae$var$AppFamilyAriModule.extensionResourceType}`);
        else if (resourceType === $c6067e522af1a0ae$var$AppFamilyAriModule.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $83g6W.NotAppFamilyAriError(ari, `environmentId, extensionGroupId must all be provided for resourceType ${$c6067e522af1a0ae$var$AppFamilyAriModule.extensionGroupResourceType}`);
        else if (resourceType === $c6067e522af1a0ae$var$AppFamilyAriModule.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $83g6W.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$c6067e522af1a0ae$var$AppFamilyAriModule.environmentResourceType}`);
        else if (resourceType === $c6067e522af1a0ae$var$AppFamilyAriModule.appEnvironmentVersionResourceType && (!environmentId || !versionId || extensionKey)) throw new $83g6W.NotAppFamilyAriError(ari, `environmentId and versionID must be provided for resourceType ${$c6067e522af1a0ae$var$AppFamilyAriModule.appEnvironmentVersionResourceType}`);
        else if (resourceType === $c6067e522af1a0ae$var$AppFamilyAriModule.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $83g6W.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$c6067e522af1a0ae$var$AppFamilyAriModule.environmentResourceType}`);
        if (resourceType === $c6067e522af1a0ae$var$AppFamilyAriModule.appEnvironmentVersionResourceType) return new $c6067e522af1a0ae$var$AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            versionId: versionId
        });
        return new $c6067e522af1a0ae$var$AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            versionId: versionId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    }
    /* eslint-enable complexity */ asAppAri() {
        return this.returnIf(()=>this.isAppAri(), 'app');
    }
    asAppEnvironmentAri() {
        return this.returnIf(()=>this.isAppEnvironmentAri(), 'environment');
    }
    asAppEnvironmentVersionAri() {
        return this.returnIf(()=>this.isAppEnvironmentVersionAri(), 'app-environment-version');
    }
    asExtensionGroupAri() {
        return this.returnIf(()=>this.isExtensionGroupAri(), 'extension-group');
    }
    asExtensionAri() {
        return this.returnIf(()=>this.isExtensionAri(), 'extension');
    }
    isAppAri() {
        return !this.isAtLeastAppEnvironmentAri;
    }
    isAppEnvironmentAri() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    }
    isAppEnvironmentVersionAri() {
        return this.isAtLeastAppEnvironmentVersionAri;
    }
    isExtensionGroupAri() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    }
    isExtensionAri() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    }
    returnIf(check, type) {
        if (!check()) throw new $83g6W.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    }
    get isAtLeastAppEnvironmentAri() {
        return this.environmentId !== undefined;
    }
    get isAtLeastAppEnvironmentVersionAri() {
        return this.versionId !== undefined;
    }
    get isAtLeastExtensionGroupAri() {
        return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
    }
    validate() {
        const constraintViolations = [
            (0, $cTNF8.validateField)(this, 'environmentId', $c6067e522af1a0ae$var$uuidConstraints),
            (0, $cTNF8.validateField)(this, 'appId', $c6067e522af1a0ae$var$uuidConstraints),
            (0, $cTNF8.validateField)(this, 'extensionGroupId', $c6067e522af1a0ae$var$extensionGroupIdConstraints),
            (0, $cTNF8.validateField)(this, 'versionId', $c6067e522af1a0ae$var$uuidConstraints)
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $oXPmI.InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
    }
    toAri() {
        const resourceOwner = $c6067e522af1a0ae$var$AppFamilyAriModule.resourceOwner;
        const { versionId: versionId } = this.toJSON();
        const { appId: appId, environmentId: environmentId, extensionGroupId: extensionGroupId, extensionKey: extensionKey, version: version } = this.toJSON();
        function withVersion(segments) {
            const path = segments.join('/');
            if (!version) return path;
            else return `${path}${$c6067e522af1a0ae$var$versionPrefix}${version}`;
        }
        if (this.isExtensionAri()) return new $oXPmI.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $c6067e522af1a0ae$var$AppFamilyAriModule.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $oXPmI.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $c6067e522af1a0ae$var$AppFamilyAriModule.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentVersionAri()) return new $oXPmI.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $c6067e522af1a0ae$var$AppFamilyAriModule.appEnvironmentVersionResourceType,
            resourceId: [
                appId,
                environmentId,
                versionId
            ].join('/')
        });
        else if (this.isAppEnvironmentAri()) return new $oXPmI.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $c6067e522af1a0ae$var$AppFamilyAriModule.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $oXPmI.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $c6067e522af1a0ae$var$AppFamilyAriModule.appResourceType,
            resourceId: appId
        });
    }
    toString() {
        return this.toAri().toString();
    }
}
module.exports.AppFamilyAriImpl = $c6067e522af1a0ae$var$AppFamilyAriImpl;

});
parcelRegister("kmdLH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.appFamilyResourceTypes = module.exports.isAppFamilyResourceType = module.exports.extensionResourceType = module.exports.extensionGroupResourceType = module.exports.appEnvironmentVersionResourceType = module.exports.environmentResourceType = module.exports.appResourceType = module.exports.resourceOwner = void 0;
module.exports.resourceOwner = 'ecosystem';
module.exports.appResourceType = 'app';
module.exports.environmentResourceType = 'environment';
module.exports.appEnvironmentVersionResourceType = 'app-environment-version';
module.exports.extensionGroupResourceType = 'extension-group';
module.exports.extensionResourceType = 'extension';
const $ed208ad414f2be3e$var$isAppFamilyResourceType = function(type) {
    switch(type){
        case module.exports.resourceOwner:
        case module.exports.appResourceType:
        case module.exports.environmentResourceType:
        case module.exports.appEnvironmentVersionResourceType:
        case module.exports.extensionGroupResourceType:
        case module.exports.extensionResourceType:
            return true;
    }
    return false;
};
module.exports.isAppFamilyResourceType = $ed208ad414f2be3e$var$isAppFamilyResourceType;
module.exports.appFamilyResourceTypes = [
    module.exports.appResourceType,
    module.exports.environmentResourceType,
    module.exports.appEnvironmentVersionResourceType,
    module.exports.extensionGroupResourceType,
    module.exports.extensionResourceType
];

});




parcelRegister("7YbkQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cd6edf1c9b232c2$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $dNAsL = parcelRequire("dNAsL");
var $1C9jQ = parcelRequire("1C9jQ");

var $bPtM5 = parcelRequire("bPtM5");
const $5cd6edf1c9b232c2$var$STARGATE_PROXY_PATH = '/gateway/api/gasv3/api/v1';
class $5cd6edf1c9b232c2$var$AnalyticsClient {
    static init(config, hostConfig, hostInfo) {
        if (this._client) return this._client;
        const origin = navigator.userAgent.includes('Electron/') ? (0, $1C9jQ.originType).DESKTOP : (0, $1C9jQ.originType).WEB;
        const analyticsWebClientUrl = new URL($5cd6edf1c9b232c2$var$STARGATE_PROXY_PATH, hostInfo.baseUrl);
        this._client = new (0, $dNAsL.default)({
            env: config.analytics.productAnalytics.env,
            product: hostConfig.analytics.productName,
            subproduct: hostConfig.analytics.getSubproduct(hostInfo.subproduct),
            origin: origin
        }, {
            useLegacyUrl: config.analytics.productAnalytics.env === 'local' || config.analytics.productAnalytics.env === 'dev',
            /*  RequestURL for GASv3 events is set using window.location.host by default in '@atlassiansox/analytics-web-client'
          This won't work for Emcee Connect as window.location.host doesn't give you the actual hostname.
          apiHost property is passed to override the default behaviour
      */ apiHost: (0, $bPtM5.isEmceeConnect)() ? analyticsWebClientUrl.host + analyticsWebClientUrl.pathname : null
        });
    }
    static get() {
        if (this._client) return this._client;
        throw new Error('Analytics client should be initialised before it is fetched!');
    }
}
(0, $5zQU9.default)($5cd6edf1c9b232c2$var$AnalyticsClient, "_client", null);
var $5cd6edf1c9b232c2$export$2e2bcd8739ae039 = $5cd6edf1c9b232c2$var$AnalyticsClient;

});
parcelRegister("bPtM5", function(module, exports) {

$parcel$export(module.exports, "isEmceeConnect", () => $89cb8dc0a88c7bbc$export$ece6f27231ad5967);
$parcel$export(module.exports, "navigateToProductUrl", () => $89cb8dc0a88c7bbc$export$92b2fd45b013ad9a);
$parcel$export(module.exports, "getLocation", () => $89cb8dc0a88c7bbc$export$e7fd20fad3cf4b5f);

var $5zQU9 = parcelRequire("5zQU9");
function $89cb8dc0a88c7bbc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $89cb8dc0a88c7bbc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $89cb8dc0a88c7bbc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $89cb8dc0a88c7bbc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/* global  __EMCEE_CONNECT__ */ const $89cb8dc0a88c7bbc$export$ece6f27231ad5967 = ()=>typeof __EMCEE_CONNECT__ !== 'undefined';
const $89cb8dc0a88c7bbc$export$92b2fd45b013ad9a = (_ref)=>{
    let { url: url, isRelativeUrl: isRelativeUrl } = _ref;
    if ($89cb8dc0a88c7bbc$export$ece6f27231ad5967()) window.AP.navigator.go('site', $89cb8dc0a88c7bbc$var$_objectSpread({}, isRelativeUrl ? {
        relativeUrl: url
    } : {
        absoluteUrl: url
    }));
    else window.location.href = url;
};
const $89cb8dc0a88c7bbc$export$e7fd20fad3cf4b5f = (callback)=>{
    if ($89cb8dc0a88c7bbc$export$ece6f27231ad5967()) window.AP.getLocation((location)=>{
        callback(location);
    });
    else callback(window.location.href);
};

});


parcelRegister("7Uh51", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_EVENT_CONTAINER_NAV_BAR", () => $5c1b031836ec9da9$export$8155c7a1f67ba4c5);
$parcel$export(module.exports, "ANALYTICS_EVENT_CONTAINER_EMCEE_OVERVIEW_TAB", () => $5c1b031836ec9da9$export$48ad8e05066f53e6);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_ALREADY_INSTALLED_CTA", () => $5c1b031836ec9da9$export$85290fcf2d3d5966);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_DISCOVER", () => $5c1b031836ec9da9$export$f8119b3d88e10685);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MANAGE", () => $5c1b031836ec9da9$export$91fe9a96912c98d2);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_APP_NAME", () => $5c1b031836ec9da9$export$efcd5b53aa309a95);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_BYO_TILE", () => $5c1b031836ec9da9$export$7b79d3513c5f83a2);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_CONTEXT_NAME", () => $5c1b031836ec9da9$export$c7dc90e3b66873c9);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_FLAG_ACTION", () => $5c1b031836ec9da9$export$59c18c166acca460);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_INSTALL", () => $5c1b031836ec9da9$export$9e17d36621b76a56);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_INSTALL_CANCEL", () => $5c1b031836ec9da9$export$f0f67d2875e68305);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_INSTALL_CLOSE", () => $5c1b031836ec9da9$export$7b5e03e0c5812a3b);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_TOKEN_DONE", () => $5c1b031836ec9da9$export$270a1e79c00649c);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_UPGRADE", () => $5c1b031836ec9da9$export$6e4e80d1ba540e87);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_LEARN_MORE", () => $5c1b031836ec9da9$export$dec9b5f504a4f005);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_CREATE_TOKEN", () => $5c1b031836ec9da9$export$533aa25b0f64b1ce);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MANAGE_ACTION_CANCEL", () => $5c1b031836ec9da9$export$e3d2695a26495109);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MANAGE_ACTION_CONFIRM", () => $5c1b031836ec9da9$export$a5418ae81f0a1efb);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MANAGE_APPS_ACTION", () => $5c1b031836ec9da9$export$8a82f4124654702f);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MANAGE_CONFIGURE", () => $5c1b031836ec9da9$export$cfb4d761ccf3da11);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MANAGE_MENU_OPEN", () => $5c1b031836ec9da9$export$3f3b324e296d8106);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MORE_RESULTS", () => $5c1b031836ec9da9$export$42d84d76d71ca474);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_NAV_BAR_CUSTOM_APP", () => $5c1b031836ec9da9$export$d5d31009a4d09a00);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_NAV_BAR_VIEW_SWITCHER", () => $5c1b031836ec9da9$export$8ac0d3dba7bb30fb);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_PRIVACY_POLICY", () => $5c1b031836ec9da9$export$3fee338e51e0f2b8);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_REVOKE_USER_GRANT", () => $5c1b031836ec9da9$export$67dca9531683d445);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_TERMS_OF_USE", () => $5c1b031836ec9da9$export$6836c15d9fe977bc);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MANAGE_LOG_ACCESS", () => $5c1b031836ec9da9$export$e83f1d83f40bcc59);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MARKETPLACE_TERMS_OF_USE", () => $5c1b031836ec9da9$export$7e0507c2b4a6497e);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_USER_GRANT_DETAILS", () => $5c1b031836ec9da9$export$f4f54bad79415400);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_VIEW_APP_DETAILS", () => $5c1b031836ec9da9$export$9fa47efaf29714c4);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_VIEW_APP_PRICING_DETAILS", () => $5c1b031836ec9da9$export$424eb23af5705b80);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_DISCOVER_APP_LISTING", () => $5c1b031836ec9da9$export$abbbc55ea1030a15);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_VIEW_MORE_ON_MARKETPLACE_LINK", () => $5c1b031836ec9da9$export$697304b6031576f7);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_FEEDBACK_CLICKED_BUTTON", () => $5c1b031836ec9da9$export$cda08e0ffa558148);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_FEEDBACK_SUBMIT_BUTTON", () => $5c1b031836ec9da9$export$9e97585e2f6f1bc6);
$parcel$export(module.exports, "ANALYTICS_OBJECT_TYPE_APP_LISTING", () => $5c1b031836ec9da9$export$974332797d985e3d);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_EMCEE_APP_LISTING_TAB", () => $5c1b031836ec9da9$export$6a1972228cdc0e40);
$parcel$export(module.exports, "ANALYTICS_OBJECT_TYPE_APP_REQUESTS", () => $5c1b031836ec9da9$export$14952f525b4ec13d);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MANAGE_APP_REQUESTS", () => $5c1b031836ec9da9$export$e38503968cb69ac4);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_REJECT_REQUEST", () => $5c1b031836ec9da9$export$dfb42288a456d21e);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_APPROVE_REQUEST", () => $5c1b031836ec9da9$export$c273006c951aabf8);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_REQUEST_APP", () => $5c1b031836ec9da9$export$1ac89c346c8a29a6);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_REQUEST_APP_CANCELED", () => $5c1b031836ec9da9$export$2b20df3caf0e919d);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_REQUEST_APP_SUBMITTED", () => $5c1b031836ec9da9$export$faca5110ba0e1832);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_REJECT_REQUEST_CANCEL", () => $5c1b031836ec9da9$export$dcc3b1ce5b2be311);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_REJECT_REQUEST_SUBMIT", () => $5c1b031836ec9da9$export$5e3747f5ff311c7f);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_APP_REQUEST_COMMENTS_CANCEL", () => $5c1b031836ec9da9$export$c074bd251be39dd9);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_APP_REQUEST_COMMENTS_VIEW_APP_DETAILS", () => $5c1b031836ec9da9$export$159343082f417408);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_APP_REQUEST_COUNT", () => $5c1b031836ec9da9$export$a2e7721e2ee7f217);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MANAGE_APP_REQUESTS_FILTER", () => $5c1b031836ec9da9$export$3d2cbf0ee048c459);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MANAGE_APP_REQUESTS_TABLE", () => $5c1b031836ec9da9$export$3db60103da471976);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MANAGE_APP_REQUESTS_SEARCH", () => $5c1b031836ec9da9$export$bc979781d6e779f3);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_RUSSIAN_USER_BLOCKED", () => $5c1b031836ec9da9$export$98242f7110de4e13);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MANAGE_APP_PROMOTIONS", () => $5c1b031836ec9da9$export$95630fa5a29d1b5d);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MANAGE_APP_PROMOTIONS_FILTER", () => $5c1b031836ec9da9$export$882d7d784f0faf15);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_TOGGLE_APPS_IN_PROMOTION", () => $5c1b031836ec9da9$export$48950fcdf326d2f3);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_APPLY_PROMOTION", () => $5c1b031836ec9da9$export$cc9ba089edaf63d9);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_EMPTY_VIEW_APPLY_PROMOTION", () => $5c1b031836ec9da9$export$649b2766a433a3ce);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MISSING_INSTALLED_APPS", () => $5c1b031836ec9da9$export$f9736834cd311afd);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_CANCEL_APPLY_PROMOTION_MODAL", () => $5c1b031836ec9da9$export$5b08d2e121390a81);
$parcel$export(module.exports, "ANALYTICS_CATEGORY_INSTALL", () => $5c1b031836ec9da9$export$b29b10ad080cb537);
$parcel$export(module.exports, "ANALYTICS_CATEGORY_UNINSTALL", () => $5c1b031836ec9da9$export$4a1bd1f65c6904a5);
$parcel$export(module.exports, "ANALYTICS_CATEGORY_TOKENS", () => $5c1b031836ec9da9$export$66685693430a26b3);
$parcel$export(module.exports, "ANALYTICS_CATEGORY_NAVIGATION", () => $5c1b031836ec9da9$export$7d3d53f70c302f29);
$parcel$export(module.exports, "ANALYTICS_CATEGORY_MARKETPLACE_APP_INSTALL", () => $5c1b031836ec9da9$export$b1a737d5067f19e4);
$parcel$export(module.exports, "ANALYTICS_CATEGORY_MARKETPLACE_APP_REQUEST", () => $5c1b031836ec9da9$export$b7822b2d343b27ad);
$parcel$export(module.exports, "AppInstalledEvent", () => $5c1b031836ec9da9$export$10ccc4c2817321e0);
$parcel$export(module.exports, "AppInstallFailedEvent", () => $5c1b031836ec9da9$export$e9789ec6a84855e0);
$parcel$export(module.exports, "AppUpgradedEvent", () => $5c1b031836ec9da9$export$c1492a5362b9db64);
$parcel$export(module.exports, "AppUpgradeFailedEvent", () => $5c1b031836ec9da9$export$8b3e30e8c7ba952f);
$parcel$export(module.exports, "AppRemovedEvent", () => $5c1b031836ec9da9$export$c51684a3728317dc);
$parcel$export(module.exports, "AppRemoveFailedEvent", () => $5c1b031836ec9da9$export$5f38461f66654c89);
$parcel$export(module.exports, "ExpandableSectionCollapsedEvent", () => $5c1b031836ec9da9$export$95f46e52463e9417);
$parcel$export(module.exports, "ExpandableSectionExpandedEvent", () => $5c1b031836ec9da9$export$31d0466fabf3f6c6);
$parcel$export(module.exports, "FetchAppDetailsFailedEvent", () => $5c1b031836ec9da9$export$a0290c56305f0d86);
$parcel$export(module.exports, "TokenGeneratedEvent", () => $5c1b031836ec9da9$export$1fcb3a859e45c921);
$parcel$export(module.exports, "TokenGenerateFailedEvent", () => $5c1b031836ec9da9$export$2dc6e288474a47c6);
$parcel$export(module.exports, "TokenRegenerateFailedEvent", () => $5c1b031836ec9da9$export$f388bf878e841bf1);
$parcel$export(module.exports, "TokenRemovedEvent", () => $5c1b031836ec9da9$export$de5f971e01f037e5);
$parcel$export(module.exports, "TokenRemoveFailedEvent", () => $5c1b031836ec9da9$export$c7df4b692c1ea194);
$parcel$export(module.exports, "TokenRegeneratedEvent", () => $5c1b031836ec9da9$export$e6b697718122cfe1);
$parcel$export(module.exports, "UserGrantRemovedEvent", () => $5c1b031836ec9da9$export$29c5fffeda04799f);
$parcel$export(module.exports, "UserGrantRemoveFailedEvent", () => $5c1b031836ec9da9$export$258901979691b2a7);
$parcel$export(module.exports, "DynamicTableSorted", () => $5c1b031836ec9da9$export$e5a796d2dc45d9ce);
$parcel$export(module.exports, "DynamicTablePageChanged", () => $5c1b031836ec9da9$export$435535f2f114ba70);
$parcel$export(module.exports, "AppRequestedEvent", () => $5c1b031836ec9da9$export$e5dd6b4ca35b8111);
$parcel$export(module.exports, "AppRequestFailedEvent", () => $5c1b031836ec9da9$export$45f1a82ef3f0a818);
$parcel$export(module.exports, "AppPromotionValidated", () => $5c1b031836ec9da9$export$bbd19682b12b034);
$parcel$export(module.exports, "AppPromotionRedeemed", () => $5c1b031836ec9da9$export$88567da0815ae8ce);
$parcel$export(module.exports, "AppPromotionRedeemFailedEvent", () => $5c1b031836ec9da9$export$d55434075b08ecbf);
$parcel$export(module.exports, "AppInstallPermissionEvaluationFailed", () => $5c1b031836ec9da9$export$e73b1e241e47726b);
$parcel$export(module.exports, "AppRequestButtonViewed", () => $5c1b031836ec9da9$export$c3fff01552fc8373);
$parcel$export(module.exports, "AppInstallBlockedForRussianUserEvent", () => $5c1b031836ec9da9$export$7cd0941ebba56522);
$parcel$export(module.exports, "allAnalyticsEvents", () => $5c1b031836ec9da9$export$df30d4c85d3bbbeb);

var $gaiog = parcelRequire("gaiog");
var $lNaxt = parcelRequire("lNaxt");

var $g5DHJ = parcelRequire("g5DHJ");
const $5c1b031836ec9da9$export$8155c7a1f67ba4c5 = (0, $gaiog.makeEventContainer)('emceeNavBar');
const $5c1b031836ec9da9$export$48ad8e05066f53e6 = (0, $gaiog.makeEventContainer)('emceeOverviewTab');
// Analytics Actions
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_GENERATED = (0, $gaiog.makeAnalyticsAction)('generated');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_GENERATE_FAILED = (0, $gaiog.makeAnalyticsAction)('generateFailed');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_INSTALLED = (0, $gaiog.makeAnalyticsAction)('installed');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_INSTALL_FAILED = (0, $gaiog.makeAnalyticsAction)('installFailed');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_UPGRADED = (0, $gaiog.makeAnalyticsAction)('upgraded');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_UPGRADE_FAILED = (0, $gaiog.makeAnalyticsAction)('upgradeFailed');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_REGENERATED = (0, $gaiog.makeAnalyticsAction)('regenerated');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_REGENERATE_FAILED = (0, $gaiog.makeAnalyticsAction)('regenerateFailed');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_FIRST_MEANINGFUL_PAINT_COMPLETED = (0, $gaiog.makeAnalyticsAction)('firstMeaningfulPaintCompleted');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_SORTED = (0, $gaiog.makeAnalyticsAction)('sorted');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_APP_REQUESTED = (0, $gaiog.makeAnalyticsAction)('requested');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_APP_REQUEST_FAILED = (0, $gaiog.makeAnalyticsAction)('requestFailed');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_APP_PROMOTION_REDEEMED_FAILED = (0, $gaiog.makeAnalyticsAction)('redeemPromotionFailed');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_APP_PROMOTION_REDEEMED = (0, $gaiog.makeAnalyticsAction)('promotionRedeemed');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_APP_PROMOTION_VALIDATED = (0, $gaiog.makeAnalyticsAction)('promotionValidated');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_APP_REQUEST_BUTTON_VIEWED = (0, $gaiog.makeAnalyticsAction)('requestButtonViewed');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_APP_INSTALL_PERMISSION_EVALUATION_FAILED = (0, $gaiog.makeAnalyticsAction)('installPermissionEvaluationFailed');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_FEATURE_EXPOSED = (0, $gaiog.makeAnalyticsAction)('exposed');
const $5c1b031836ec9da9$export$db23786aad95018a = (0, $gaiog.makeAnalyticsAction)('viewed');
const $5c1b031836ec9da9$export$cc8e7fae1116fc7b = (0, $gaiog.makeAnalyticsAction)('entered');
const $5c1b031836ec9da9$export$e6ff11761cb083ce = (0, $gaiog.makeAnalyticsAction)('rendered');
// Analytics Action Subjects
const $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_EXPANDABLE_SECTION = (0, $gaiog.makeAnalyticsActionSubject)('expandableSection');
const $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_TOKEN = (0, $gaiog.makeAnalyticsActionSubject)('token');
const $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_USER_GRANT = (0, $gaiog.makeAnalyticsActionSubject)('userGrant');
const $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_DYNAMIC_TABLE = (0, $gaiog.makeAnalyticsActionSubject)('dynamicTable');
const $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_FEATURE = (0, $gaiog.makeAnalyticsActionSubject)('feature');
const $5c1b031836ec9da9$export$85290fcf2d3d5966 = 'alreadyInstalledCTA';
const $5c1b031836ec9da9$export$f8119b3d88e10685 = 'discover';
const $5c1b031836ec9da9$export$91fe9a96912c98d2 = 'manage';
const $5c1b031836ec9da9$export$efcd5b53aa309a95 = 'appName';
const $5c1b031836ec9da9$export$7b79d3513c5f83a2 = 'byoTile';
const $5c1b031836ec9da9$export$c7dc90e3b66873c9 = 'contextName';
const $5c1b031836ec9da9$export$59c18c166acca460 = 'flagAction';
const $5c1b031836ec9da9$export$9e17d36621b76a56 = 'install';
const $5c1b031836ec9da9$export$f0f67d2875e68305 = 'installCancel';
const $5c1b031836ec9da9$export$7b5e03e0c5812a3b = 'installClose';
const $5c1b031836ec9da9$export$270a1e79c00649c = 'tokenDone';
const $5c1b031836ec9da9$export$6e4e80d1ba540e87 = 'upgrade';
const $5c1b031836ec9da9$export$dec9b5f504a4f005 = 'learnMore';
const $5c1b031836ec9da9$export$533aa25b0f64b1ce = 'createToken';
const $5c1b031836ec9da9$export$e3d2695a26495109 = 'manageActionCancel';
const $5c1b031836ec9da9$export$a5418ae81f0a1efb = 'manageActionConfirm';
const $5c1b031836ec9da9$export$8a82f4124654702f = 'manageAppsAction';
const $5c1b031836ec9da9$export$cfb4d761ccf3da11 = 'manageConfigure';
const $5c1b031836ec9da9$export$3f3b324e296d8106 = 'manageMenuOpen';
const $5c1b031836ec9da9$export$42d84d76d71ca474 = 'moreResults';
const $5c1b031836ec9da9$export$d5d31009a4d09a00 = 'navBarCustomApp';
const $5c1b031836ec9da9$export$8ac0d3dba7bb30fb = 'navBarViewSwitcher';
const $5c1b031836ec9da9$export$3fee338e51e0f2b8 = 'privacyPolicy';
const $5c1b031836ec9da9$export$67dca9531683d445 = 'revokeUserGrant';
const $5c1b031836ec9da9$export$6836c15d9fe977bc = 'termsOfUse';
const $5c1b031836ec9da9$export$e83f1d83f40bcc59 = 'manageLogAccess';
const $5c1b031836ec9da9$export$7e0507c2b4a6497e = 'marketplaceTermsOfUse';
const $5c1b031836ec9da9$export$f4f54bad79415400 = 'userGrantDetails';
const $5c1b031836ec9da9$export$9fa47efaf29714c4 = 'viewAppDetails';
const $5c1b031836ec9da9$export$424eb23af5705b80 = 'viewAppPricingDetails';
const $5c1b031836ec9da9$export$a33d9f95d57cad28 = 'partnerName';
const $5c1b031836ec9da9$export$abbbc55ea1030a15 = 'discoverAppListing';
const $5c1b031836ec9da9$export$6020eacd09143189 = 'perfMetrics';
const $5c1b031836ec9da9$export$2c9c5ee2d68b11cb = 'installDeterminingModal';
const $5c1b031836ec9da9$export$91782083c4c1f37b = 'installModal';
const $5c1b031836ec9da9$export$697304b6031576f7 = 'viewMoreOnMarketplaceLink';
const $5c1b031836ec9da9$export$cda08e0ffa558148 = 'emceeFeedbackButton';
const $5c1b031836ec9da9$export$9e97585e2f6f1bc6 = 'emceeFeedbackSubmitButton';
const $5c1b031836ec9da9$export$bcfbaf5a28647621 = (0, $gaiog.makeAnalyticsActionSubject)('searchOverlay');
const $5c1b031836ec9da9$export$f49811924c23f531 = (0, $gaiog.makeAnalyticsActionSubject)('searchEmbedded');
const $5c1b031836ec9da9$export$2c845c02055cfe32 = (0, $gaiog.makeAnalyticsActionSubject)('error');
const $5c1b031836ec9da9$export$2dfd3d1dcf2c7652 = (0, $gaiog.makeAnalyticsActionSubject)('navigationItem');
const $5c1b031836ec9da9$export$292cd545f4464697 = (0, $gaiog.makeAnalyticsActionSubject)('screenViewed');
const $5c1b031836ec9da9$export$8372f7a903a3e882 = (0, $gaiog.makeAnalyticsActionSubject)('filter');
const $5c1b031836ec9da9$export$b5beeddca34af740 = (0, $gaiog.makeAnalyticsActionSubject)('sort');
const $5c1b031836ec9da9$export$84007be1e3689955 = (0, $gaiog.makeAnalyticsActionSubject)('tiles');
const $5c1b031836ec9da9$export$974332797d985e3d = 'appListing';
const $5c1b031836ec9da9$export$6a1972228cdc0e40 = 'emceeAppListingTab';
const $5c1b031836ec9da9$export$14952f525b4ec13d = 'appRequests';
const $5c1b031836ec9da9$export$e38503968cb69ac4 = 'manageAppRequests';
const $5c1b031836ec9da9$export$dfb42288a456d21e = 'rejectRequest';
const $5c1b031836ec9da9$export$c273006c951aabf8 = 'approveRequest';
const $5c1b031836ec9da9$export$1ac89c346c8a29a6 = 'requestApp';
const $5c1b031836ec9da9$export$2b20df3caf0e919d = 'requestAppCancelled';
const $5c1b031836ec9da9$export$faca5110ba0e1832 = 'requestAppSubmitted';
const $5c1b031836ec9da9$export$dcc3b1ce5b2be311 = 'rejectRequestCancelled';
const $5c1b031836ec9da9$export$5e3747f5ff311c7f = 'rejectRequestSubmitted';
const $5c1b031836ec9da9$export$c074bd251be39dd9 = 'appRequestCommentsCancel';
const $5c1b031836ec9da9$export$159343082f417408 = 'viewAppDetails';
const $5c1b031836ec9da9$export$a2e7721e2ee7f217 = 'requestCount';
const $5c1b031836ec9da9$export$3d2cbf0ee048c459 = 'manageAppRequestsFilter';
const $5c1b031836ec9da9$export$3db60103da471976 = 'manageAppRequestsTable';
const $5c1b031836ec9da9$export$bc979781d6e779f3 = 'manageAppRequestsSearch';
const $5c1b031836ec9da9$export$cedc7c71e0f0775d = 'manageAppRequestsPage';
const $5c1b031836ec9da9$export$98242f7110de4e13 = 'blockedRussianUser';
const $5c1b031836ec9da9$export$21b98987e67ce12c = 'appPromotions';
const $5c1b031836ec9da9$export$95630fa5a29d1b5d = 'manageAppPromotions';
const $5c1b031836ec9da9$export$882d7d784f0faf15 = 'manageAppPromotionsFilter';
const $5c1b031836ec9da9$export$48950fcdf326d2f3 = 'toggleAppsInPromotion';
const $5c1b031836ec9da9$export$cc9ba089edaf63d9 = 'applyPromotion';
const $5c1b031836ec9da9$export$649b2766a433a3ce = 'emptyViewApplyPromotion';
const $5c1b031836ec9da9$export$f9736834cd311afd = 'missingInstalledApps';
const $5c1b031836ec9da9$export$5b08d2e121390a81 = 'cancelApplyPromotionModal';
const $5c1b031836ec9da9$export$b29b10ad080cb537 = (0, $gaiog.makeAnalyticsCategory)('EmceeInstall');
const $5c1b031836ec9da9$export$4a1bd1f65c6904a5 = (0, $gaiog.makeAnalyticsCategory)('EmceeUninstall');
const $5c1b031836ec9da9$export$66685693430a26b3 = (0, $gaiog.makeAnalyticsCategory)('EmceeTokens');
const $5c1b031836ec9da9$export$7d3d53f70c302f29 = (0, $gaiog.makeAnalyticsCategory)('EmceeNavigation');
const $5c1b031836ec9da9$export$b1a737d5067f19e4 = (0, $gaiog.makeAnalyticsCategory)('MarketplaceAppInstall');
const $5c1b031836ec9da9$export$b7822b2d343b27ad = (0, $gaiog.makeAnalyticsCategory)('MarketplaceAppRequest');
const $5c1b031836ec9da9$export$ef6019d585de2438 = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_FEATURE_EXPOSED,
    actionSubject: $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_FEATURE,
    details: 'Feature exposed to user',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$10ccc4c2817321e0 = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_INSTALLED,
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_APP),
    details: 'App installation succeeds',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$e9789ec6a84855e0 = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_INSTALL_FAILED,
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_APP),
    details: 'Error occurs while installing an app',
    type: (0, $lNaxt.OPERATIONAL_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$c1492a5362b9db64 = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_UPGRADED,
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_APP),
    details: 'User upgrades an app in Embedded Marketplace',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$8b3e30e8c7ba952f = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_UPGRADE_FAILED,
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_APP),
    details: 'Error occurs while upgrading an app in Embedded Marketplace',
    type: (0, $lNaxt.OPERATIONAL_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$c51684a3728317dc = {
    action: (0, $gaiog.ANALYTICS_ACTION_REMOVED),
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_APP),
    details: 'User uninstalls an app in Embedded Marketplace',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$5f38461f66654c89 = {
    action: (0, $gaiog.ANALYTICS_ACTION_REMOVE_FAILED),
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_APP),
    details: 'Error occurs while uninstalling an app through Embedded Marketplace',
    type: (0, $lNaxt.OPERATIONAL_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$95f46e52463e9417 = {
    action: (0, $gaiog.ANALYTICS_ACTION_COLLAPSED),
    actionSubject: $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_EXPANDABLE_SECTION,
    details: 'User collapsed an expandable section',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$31d0466fabf3f6c6 = {
    action: (0, $gaiog.ANALYTICS_ACTION_EXPANDED),
    actionSubject: $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_EXPANDABLE_SECTION,
    details: 'User expanded an expandable section',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$a0290c56305f0d86 = {
    action: (0, $gaiog.ANALYTICS_ACTION_FETCH_FAILED),
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_APP),
    details: 'Error occurs while fetching app details in Embedded Marketplace install dialog',
    type: (0, $lNaxt.OPERATIONAL_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$1fcb3a859e45c921 = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_GENERATED,
    actionSubject: $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_TOKEN,
    details: 'A token was generated',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$2dc6e288474a47c6 = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_GENERATE_FAILED,
    actionSubject: $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_TOKEN,
    details: 'An error occurred while generating a token',
    type: (0, $lNaxt.OPERATIONAL_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$f388bf878e841bf1 = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_REGENERATE_FAILED,
    actionSubject: $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_TOKEN,
    details: 'An error occurred while regenerating a token',
    type: (0, $lNaxt.OPERATIONAL_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$de5f971e01f037e5 = {
    action: (0, $gaiog.ANALYTICS_ACTION_REMOVED),
    actionSubject: $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_TOKEN,
    details: 'A token was removed/revoked',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$c7df4b692c1ea194 = {
    action: (0, $gaiog.ANALYTICS_ACTION_REMOVE_FAILED),
    actionSubject: $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_TOKEN,
    details: 'An error occurred while removing a token',
    type: (0, $lNaxt.OPERATIONAL_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$e6b697718122cfe1 = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_REGENERATED,
    actionSubject: $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_TOKEN,
    details: 'A token was regenerated',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$29c5fffeda04799f = {
    action: (0, $gaiog.ANALYTICS_ACTION_REMOVED),
    actionSubject: $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_USER_GRANT,
    details: 'A user grant was successfully revoked',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$258901979691b2a7 = {
    action: (0, $gaiog.ANALYTICS_ACTION_REMOVE_FAILED),
    actionSubject: $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_USER_GRANT,
    details: 'An error occurred while revoking a user grant',
    type: (0, $lNaxt.OPERATIONAL_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$7e2ac8c4f8d47a78 = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_FIRST_MEANINGFUL_PAINT_COMPLETED,
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_UI),
    details: 'First meaningful paint completed',
    type: (0, $lNaxt.OPERATIONAL_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$e5a796d2dc45d9ce = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_SORTED,
    actionSubject: $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_DYNAMIC_TABLE,
    details: 'When dynamic table is sorted',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$435535f2f114ba70 = {
    action: (0, $gaiog.ANALYTICS_ACTION_CHANGED),
    actionSubject: $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_DYNAMIC_TABLE,
    details: 'Page number changed in a dynamic table',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$e5dd6b4ca35b8111 = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_APP_REQUESTED,
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_APP),
    details: 'End user requests admin to install an app',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$45f1a82ef3f0a818 = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_APP_REQUEST_FAILED,
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_APP),
    details: 'Error occurs while end user requesting admin to install an app',
    type: (0, $lNaxt.OPERATIONAL_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$bbd19682b12b034 = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_APP_PROMOTION_VALIDATED,
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_APP),
    details: 'When user validated a promo code successfully',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$88567da0815ae8ce = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_APP_PROMOTION_REDEEMED,
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_APP),
    details: 'When user redeemed a promo code successfully',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$d55434075b08ecbf = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_APP_PROMOTION_REDEEMED_FAILED,
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_APP),
    details: 'Error occurs while redeeming promotion code',
    type: (0, $lNaxt.OPERATIONAL_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$e73b1e241e47726b = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_APP_INSTALL_PERMISSION_EVALUATION_FAILED,
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_APP),
    details: 'When app install permission evaluation is failed',
    type: (0, $lNaxt.OPERATIONAL_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$c3fff01552fc8373 = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_APP_REQUEST_BUTTON_VIEWED,
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_APP),
    details: 'When app request button is viewed',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$7cd0941ebba56522 = {
    action: (0, $gaiog.ANALYTICS_ACTION_CLICKED),
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_BUTTON),
    details: 'Prevented app install for Russia',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$eef4c4c219985794 = {
    action: $5c1b031836ec9da9$export$db23786aad95018a,
    actionSubject: $5c1b031836ec9da9$export$bcfbaf5a28647621,
    details: 'User has viewed the search overlay',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$95c08a8a1d00d5d9 = {
    action: (0, $gaiog.ANALYTICS_ACTION_CLICKED),
    actionSubject: $5c1b031836ec9da9$export$bcfbaf5a28647621,
    details: 'User has selected a suggestion',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$5f2ac52054ff0703 = {
    action: $5c1b031836ec9da9$export$cc8e7fae1116fc7b,
    actionSubject: $5c1b031836ec9da9$export$bcfbaf5a28647621,
    details: 'User pressed an enter key',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$3b5c1a8abac22038 = {
    action: $5c1b031836ec9da9$export$db23786aad95018a,
    actionSubject: $5c1b031836ec9da9$export$f49811924c23f531,
    details: 'User has viewed the search overlay',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$835e2ca6154629af = {
    action: (0, $gaiog.ANALYTICS_ACTION_CLICKED),
    actionSubject: $5c1b031836ec9da9$export$f49811924c23f531,
    details: 'User has selected a suggestion',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$a0ce8ac2d8f9789f = {
    action: $5c1b031836ec9da9$export$e6ff11761cb083ce,
    actionSubject: $5c1b031836ec9da9$export$84007be1e3689955,
    details: 'Marketplace app tiles were rendered and are now visible to the user',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$57e303b46a8f8ad2 = {
    action: (0, $gaiog.ANALYTICS_ACTION_CLICKED),
    actionSubject: $5c1b031836ec9da9$export$2dfd3d1dcf2c7652,
    details: 'User clicked a navbar item',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$f015ff8244e789d5 = {
    action: $5c1b031836ec9da9$export$cc8e7fae1116fc7b,
    actionSubject: $5c1b031836ec9da9$export$f49811924c23f531,
    details: 'User pressed an enter key',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$15a0a93c7224b959 = {
    action: (0, $gaiog.ANALYTICS_ACTION_CLICKED),
    actionSubject: $5c1b031836ec9da9$export$8372f7a903a3e882,
    details: 'User has cleared a selected filter for the app search',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$3024be86a7637e37 = {
    action: $5c1b031836ec9da9$export$e6ff11761cb083ce,
    actionSubject: $5c1b031836ec9da9$export$2c845c02055cfe32,
    details: 'An error state has been rendered',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$b30d9e3d99fe197b = {
    action: (0, $gaiog.ANALYTICS_ACTION_CLICKED),
    actionSubject: $5c1b031836ec9da9$export$b5beeddca34af740,
    details: 'User has selected a sort option',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$df30d4c85d3bbbeb = (0, $g5DHJ.Set)([
    $5c1b031836ec9da9$export$10ccc4c2817321e0,
    $5c1b031836ec9da9$export$e9789ec6a84855e0,
    $5c1b031836ec9da9$export$c1492a5362b9db64,
    $5c1b031836ec9da9$export$8b3e30e8c7ba952f,
    $5c1b031836ec9da9$export$c51684a3728317dc,
    $5c1b031836ec9da9$export$5f38461f66654c89,
    $5c1b031836ec9da9$export$435535f2f114ba70,
    (0, $gaiog.BreadcrumbClickedEvent),
    (0, $gaiog.ButtonClickedEvent),
    (0, $gaiog.ImageClickedEvent),
    $5c1b031836ec9da9$export$95f46e52463e9417,
    $5c1b031836ec9da9$export$31d0466fabf3f6c6,
    $5c1b031836ec9da9$export$ef6019d585de2438,
    $5c1b031836ec9da9$export$a0290c56305f0d86,
    (0, $gaiog.MenuItemClickedEvent),
    (0, $gaiog.TileClickedEvent),
    $5c1b031836ec9da9$export$1fcb3a859e45c921,
    $5c1b031836ec9da9$export$2dc6e288474a47c6,
    $5c1b031836ec9da9$export$e6b697718122cfe1,
    $5c1b031836ec9da9$export$f388bf878e841bf1,
    $5c1b031836ec9da9$export$de5f971e01f037e5,
    $5c1b031836ec9da9$export$c7df4b692c1ea194,
    $5c1b031836ec9da9$export$29c5fffeda04799f,
    $5c1b031836ec9da9$export$258901979691b2a7,
    $5c1b031836ec9da9$export$7e2ac8c4f8d47a78,
    $5c1b031836ec9da9$export$e5a796d2dc45d9ce,
    (0, $gaiog.SearchSubmittedEvent),
    (0, $gaiog.FilterClickedEvent),
    $5c1b031836ec9da9$export$e5dd6b4ca35b8111,
    $5c1b031836ec9da9$export$45f1a82ef3f0a818,
    $5c1b031836ec9da9$export$c3fff01552fc8373,
    $5c1b031836ec9da9$export$e73b1e241e47726b,
    $5c1b031836ec9da9$export$bbd19682b12b034,
    $5c1b031836ec9da9$export$88567da0815ae8ce,
    $5c1b031836ec9da9$export$d55434075b08ecbf,
    $5c1b031836ec9da9$export$7cd0941ebba56522,
    (0, $gaiog.TabClickedEvent),
    (0, $gaiog.LinkClickedEvent),
    $5c1b031836ec9da9$export$eef4c4c219985794,
    $5c1b031836ec9da9$export$95c08a8a1d00d5d9,
    $5c1b031836ec9da9$export$5f2ac52054ff0703,
    $5c1b031836ec9da9$export$3b5c1a8abac22038,
    $5c1b031836ec9da9$export$835e2ca6154629af,
    $5c1b031836ec9da9$export$f015ff8244e789d5,
    $5c1b031836ec9da9$export$a0ce8ac2d8f9789f,
    $5c1b031836ec9da9$export$57e303b46a8f8ad2,
    $5c1b031836ec9da9$export$15a0a93c7224b959,
    $5c1b031836ec9da9$export$3024be86a7637e37,
    $5c1b031836ec9da9$export$b30d9e3d99fe197b
]);

});

parcelRegister("gIQkA", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_SCREEN_DISCOVER", () => $c2c959452d1d6b1b$export$24f1b87b13ba61e3);
$parcel$export(module.exports, "ANALYTICS_SCREEN_SEARCH", () => $c2c959452d1d6b1b$export$278ec038bb4ad100);
$parcel$export(module.exports, "ANALYTICS_SCREEN_MANAGE", () => $c2c959452d1d6b1b$export$67243ab0bb3d7e47);
$parcel$export(module.exports, "ANALYTICS_SCREEN_MANAGE_APP", () => $c2c959452d1d6b1b$export$72fb2e30225c98ea);
$parcel$export(module.exports, "ANALYTICS_SCREEN_APP_LISTING", () => $c2c959452d1d6b1b$export$8e7eb5f7cbc03cbf);
$parcel$export(module.exports, "ANALYTICS_SCREEN_MANAGE_APP_REQUESTS", () => $c2c959452d1d6b1b$export$6d0e0ddf2da79435);
$parcel$export(module.exports, "ANALYTICS_SCREEN_MANAGE_PROMOTIONS", () => $c2c959452d1d6b1b$export$29d38ded3cc8a77a);
$parcel$export(module.exports, "ANALYTICS_MODAL_DETERMINING", () => $c2c959452d1d6b1b$export$318fe07bee4f4c7d);
$parcel$export(module.exports, "ANALYTICS_MODAL_INSTALL", () => $c2c959452d1d6b1b$export$a30961778d560f2b);
$parcel$export(module.exports, "ANALYTICS_MODAL_NO_INSTALL_PERMISSION", () => $c2c959452d1d6b1b$export$eec1aa7a61f8149b);
$parcel$export(module.exports, "ANALYTICS_MODAL_CUSTOM_INSTALL", () => $c2c959452d1d6b1b$export$5e00e0e71660e711);
$parcel$export(module.exports, "ANALYTICS_MODAL_CREATE_TOKEN", () => $c2c959452d1d6b1b$export$e4d83c14bb42342d);
$parcel$export(module.exports, "ANALYTICS_MODAL_INSTRUCTIONAL", () => $c2c959452d1d6b1b$export$2f15ba413294aeca);
$parcel$export(module.exports, "ANALYTICS_MODAL_UPGRADE", () => $c2c959452d1d6b1b$export$c9fc5fbc78e644);
$parcel$export(module.exports, "ANALYTICS_MODAL_UNINSTALL_SITE", () => $c2c959452d1d6b1b$export$9aba89b9dc1262de);
$parcel$export(module.exports, "ANALYTICS_MODAL_REQUEST_APP", () => $c2c959452d1d6b1b$export$e128d54ee9d235cf);
$parcel$export(module.exports, "ANALYTICS_MODAL_APPLY_PROMOTIONS", () => $c2c959452d1d6b1b$export$9957d6c8a82195a9);
$parcel$export(module.exports, "ANALYTICS_MODAL_SHOW_TOKEN", () => $c2c959452d1d6b1b$export$aed94a083655c805);
$parcel$export(module.exports, "ANALYTICS_MODAL_APP_REQUEST_COMMENTS_MODAL", () => $c2c959452d1d6b1b$export$dcda41a7b128398);
$parcel$export(module.exports, "ANALYTICS_MODAL_REJECT_REQUEST", () => $c2c959452d1d6b1b$export$3ad5792c5779b5cb);
$parcel$export(module.exports, "ANALYTICS_MODAL_STANDALONE_INSTALL_DETERMINING", () => $c2c959452d1d6b1b$export$3c7698c820ea35b4);
$parcel$export(module.exports, "ANALYTICS_MODAL_STANDALONE_INSTALL", () => $c2c959452d1d6b1b$export$5d5b3d45f5aaffb2);
$parcel$export(module.exports, "ANALYTICS_MODAL_STANDALONE_INSTRUCTIONAL_APP_INSTALL", () => $c2c959452d1d6b1b$export$4bd9df6e7f499a4b);
$parcel$export(module.exports, "ANALYTICS_MODAL_STANDALONE_APP_REQUEST", () => $c2c959452d1d6b1b$export$61e3d8121e1d0224);
$parcel$export(module.exports, "allAnalyticsSources", () => $c2c959452d1d6b1b$export$4765ce0d523b143b);

var $eqVJB = parcelRequire("eqVJB");

var $g5DHJ = parcelRequire("g5DHJ");
const $c2c959452d1d6b1b$export$24f1b87b13ba61e3 = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceDiscoverScreen'),
    details: "Front-page 'Marketplace apps' view"
};
const $c2c959452d1d6b1b$export$278ec038bb4ad100 = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceSearchScreen'),
    details: 'Search results'
};
const $c2c959452d1d6b1b$export$67243ab0bb3d7e47 = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceManageScreen'),
    details: "'Manage apps' view"
};
const $c2c959452d1d6b1b$export$72fb2e30225c98ea = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceManageAppScreen'),
    details: 'Manage permissions etc. for a single app'
};
const $c2c959452d1d6b1b$export$8e7eb5f7cbc03cbf = {
    /* the analytics source value of `embeddedMarketplaceAppListingScreen` is used in vendor-service's Segment integration with partners.
  Any change to this value should be accompanied by a corresponding update in vendor-service.*/ name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceAppListingScreen'),
    details: 'Details for a single app on Marketplace'
};
const $c2c959452d1d6b1b$export$6d0e0ddf2da79435 = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceMangeAppRequestsScreen'),
    details: 'A dashboard for the admins to manage the App requests'
};
const $c2c959452d1d6b1b$export$29d38ded3cc8a77a = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceManagePromotionsScreen'),
    details: 'A dashboard for the admins to manage the Promotions'
};
const $c2c959452d1d6b1b$export$cfd261bc93c4dfa = (0, $g5DHJ.Set)([
    $c2c959452d1d6b1b$export$24f1b87b13ba61e3,
    $c2c959452d1d6b1b$export$278ec038bb4ad100,
    $c2c959452d1d6b1b$export$67243ab0bb3d7e47,
    $c2c959452d1d6b1b$export$72fb2e30225c98ea,
    $c2c959452d1d6b1b$export$8e7eb5f7cbc03cbf,
    $c2c959452d1d6b1b$export$6d0e0ddf2da79435,
    $c2c959452d1d6b1b$export$29d38ded3cc8a77a
]);
const $c2c959452d1d6b1b$export$318fe07bee4f4c7d = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceInstallDeterminingModal'),
    details: 'Dialog displayed while determining which install dialog to use'
};
const $c2c959452d1d6b1b$export$a30961778d560f2b = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceInstallModal'),
    details: 'Install dialog for Two Legged apps and deep-linked installs'
};
const $c2c959452d1d6b1b$export$eec1aa7a61f8149b = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceNoInstallPermissionModal'),
    details: 'Install dialog for Two Legged apps and deep-linked installs but the user does not have install permissions'
};
const $c2c959452d1d6b1b$export$5e00e0e71660e711 = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceInstallCustomModal'),
    details: "Custom app dialog with the 'Installation URL' tab selected"
};
const $c2c959452d1d6b1b$export$e4d83c14bb42342d = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceCreateTokenModal'),
    details: "Custom app dialog with the 'API tokens' tab selected"
};
const $c2c959452d1d6b1b$export$2f15ba413294aeca = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceInstallInstructionalModal'),
    details: 'Install dialog for Marketplace listings that are just instructions to follow'
};
const $c2c959452d1d6b1b$export$c9fc5fbc78e644 = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceUpgradeModal'),
    details: 'Upgrade dialog for Two Legged apps'
};
const $c2c959452d1d6b1b$export$9aba89b9dc1262de = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceUninstallFromSiteConfirmModal'),
    details: 'Dialog confirming if you want to uninstall an app from the whole site'
};
const $c2c959452d1d6b1b$export$e128d54ee9d235cf = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceRequestAppModal'),
    details: 'Request app dialog when the user clicks on request app button'
};
const $c2c959452d1d6b1b$export$9957d6c8a82195a9 = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceApplyPromotionModal'),
    details: 'Apply promotions dialog when the user clicks on apply promotions button'
};
const $c2c959452d1d6b1b$export$aed94a083655c805 = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceShowTokenModal'),
    details: 'Dialog displaying a token and how to use it'
};
const $c2c959452d1d6b1b$export$dcda41a7b128398 = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceAppRequestCommentsModal'),
    details: 'Dialog displaying the request comments from end users to the admin'
};
const $c2c959452d1d6b1b$export$3ad5792c5779b5cb = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceRejectRequestModal'),
    details: 'Modal when admin replies and rejects requests for an app'
};
const $c2c959452d1d6b1b$export$6ffde31c344c6e55 = (0, $g5DHJ.Set)([
    $c2c959452d1d6b1b$export$318fe07bee4f4c7d,
    $c2c959452d1d6b1b$export$eec1aa7a61f8149b,
    $c2c959452d1d6b1b$export$a30961778d560f2b,
    $c2c959452d1d6b1b$export$5e00e0e71660e711,
    $c2c959452d1d6b1b$export$e4d83c14bb42342d,
    $c2c959452d1d6b1b$export$2f15ba413294aeca,
    $c2c959452d1d6b1b$export$c9fc5fbc78e644,
    $c2c959452d1d6b1b$export$9aba89b9dc1262de,
    $c2c959452d1d6b1b$export$aed94a083655c805,
    $c2c959452d1d6b1b$export$e128d54ee9d235cf,
    $c2c959452d1d6b1b$export$dcda41a7b128398,
    $c2c959452d1d6b1b$export$3ad5792c5779b5cb,
    $c2c959452d1d6b1b$export$9957d6c8a82195a9
]);
const $c2c959452d1d6b1b$export$3c7698c820ea35b4 = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('marketplaceInstallDeterminingModal'),
    details: 'Dialog displayed while determining which install dialog to use',
    type: (0, $eqVJB.SCREEN_EVENT_TYPE)
};
const $c2c959452d1d6b1b$export$5d5b3d45f5aaffb2 = {
    /* the analytics source value of `marketplaceInstallModal` is used in vendor-service's Segment integration with partners.
  Any change to this value should be accompanied by a corresponding update in vendor-service.*/ name: (0, $eqVJB.makeAnalyticsSourceID)('marketplaceInstallModal'),
    details: 'Dialog displayed for installable apps with scopes information and other app details',
    type: (0, $eqVJB.SCREEN_EVENT_TYPE)
};
const $c2c959452d1d6b1b$export$4bd9df6e7f499a4b = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('marketplaceInstallInstructionalModal'),
    details: 'Dialog displayed for instructional apps that are just instructions to follow',
    type: (0, $eqVJB.SCREEN_EVENT_TYPE)
};
const $c2c959452d1d6b1b$export$61e3d8121e1d0224 = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('marketplaceAppRequestModal'),
    details: 'Dialog displayed for requestable apps with app details',
    type: (0, $eqVJB.SCREEN_EVENT_TYPE)
};
const $c2c959452d1d6b1b$export$6573b0643eb8f1a4 = (0, $g5DHJ.Set)([
    $c2c959452d1d6b1b$export$3c7698c820ea35b4,
    $c2c959452d1d6b1b$export$5d5b3d45f5aaffb2,
    $c2c959452d1d6b1b$export$4bd9df6e7f499a4b,
    $c2c959452d1d6b1b$export$61e3d8121e1d0224
]);
const $c2c959452d1d6b1b$export$4765ce0d523b143b = $c2c959452d1d6b1b$export$cfd261bc93c4dfa.concat($c2c959452d1d6b1b$export$6ffde31c344c6e55).concat($c2c959452d1d6b1b$export$6573b0643eb8f1a4);

});



parcelRegister("bwjZm", function(module, exports) {

$parcel$export(module.exports, "getScreenViewEvent", () => $86323032c7595c38$export$8378d1ba108f66d1);
$parcel$export(module.exports, "getNonScreenEvent", () => $86323032c7595c38$export$2cedbd7eb17ed333);

var $2vzCR = parcelRequire("2vzCR");

var $7Uh51 = parcelRequire("7Uh51");
const $86323032c7595c38$export$8378d1ba108f66d1 = (_ref)=>{
    let { marketplaceContext: marketplaceContext, payload: payload, baseAttributes: baseAttributes = {}, analyticsRouteParams: analyticsRouteParams = {} } = _ref;
    const { attributes: payloadAttributes, eventType: { name: name, details: details } } = payload;
    const { attributes: contextAttributes } = marketplaceContext;
    const attributes = (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, analyticsRouteParams, baseAttributes, contextAttributes, payloadAttributes);
    return {
        name: name,
        details: details,
        attributes: attributes
    };
};
const $86323032c7595c38$export$2cedbd7eb17ed333 = (_ref2)=>{
    let { marketplaceContext: marketplaceContext, payload: payload, source: source, baseAttributes: baseAttributes = {} } = _ref2;
    const { tags: tags = [], eventType: { actionSubject: actionSubject, action: action }, actionSubjectId: actionSubjectId, objectId: objectId, objectType: objectType, source: payloadSource, attributes: payloadAttributes } = payload;
    const { attributes: contextAttributes, properties: contextProperties } = marketplaceContext;
    const attributes = (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, baseAttributes, contextAttributes, payloadAttributes);
    const baseProperties = {
        category: (0, $7Uh51.ANALYTICS_CATEGORY_NAVIGATION),
        source: (payloadSource === null || payloadSource === void 0 ? void 0 : payloadSource.name) || (source === null || source === void 0 ? void 0 : source.name) || contextProperties.source,
        tags: tags
    };
    // containerId, containerType, source cannot be overridden by the payload
    const payloadProperties = {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        objectId: objectId,
        objectType: objectType
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, baseProperties, contextProperties, payloadProperties, // attributes were previously merged
    {
        attributes: attributes
    });
};

});


parcelRegister("5E4rM", function(module, exports) {

$parcel$export(module.exports, "InstallationLockProvider", () => $41c4234a416d1aa9$export$bdeb2e34b6f84425);
$parcel$export(module.exports, "useInstallationLock", () => $41c4234a416d1aa9$export$9f39065591191e00);

var $eUqFw = parcelRequire("eUqFw");
const $41c4234a416d1aa9$var$InstallContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(null);
function $41c4234a416d1aa9$export$bdeb2e34b6f84425(props) {
    function installationReducer(state, action) {
        switch(action.type){
            case 'set_install_in_progress':
                return {
                    installationInProgressAppKey: action.payload.appKey
                };
            case 'clear_install_in_progress':
                return {
                    installationInProgressAppKey: null
                };
            case 'installation_success':
                if (props.onInstallSuccess) props.onInstallSuccess({
                    installedApp: action.payload.installedApp,
                    enableDeprecatedInstallationsGQL: action.payload.enableDeprecatedInstallationsGQL
                });
                return {
                    installationInProgressAppKey: null
                };
            default:
                return state;
        }
    }
    const [installationState, dispatch] = (0, $eUqFw.useReducer)((0, $eUqFw.useMemo)(()=>installationReducer, [
        props.onInstallSuccess
    ]), {
        installationInProgressAppKey: null
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($41c4234a416d1aa9$var$InstallContext.Provider, {
        value: {
            installationState: installationState,
            dispatch: dispatch
        }
    }, props.children);
}
function $41c4234a416d1aa9$export$9f39065591191e00() {
    const contextValue = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext($41c4234a416d1aa9$var$InstallContext);
    if (!contextValue) throw new Error('useInstallationLock must be used from within InstallationLockProvider');
    return contextValue;
}

});

parcelRegister("8un0w", function(module, exports) {

$parcel$export(module.exports, "default", () => $da3e17e369dbbaa5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $etqm0 = parcelRequire("etqm0");
/**
 * Adds analytics events to the given callbacks without altering the original behavior
 * Callback is expected to have analyticsEvent as a last argument
 * @example
 * ```tsx
 *  // will fire "select" event when onSelect is called
 *  fileWithUIAnalytics({ onSelect: 'select' })
 *
 *  // will fire "select" event with extra attributes
 *  fileWithUIAnalytics({ onSelect: (value) => ({ name: 'select', value: value}) }
 *  ```
 */ const $da3e17e369dbbaa5$var$fireWithUIAnalytics = (ConnectedProps)=>{
    // sort the keys so we can set the deps of useMemo
    const providedKeys = Object.keys(ConnectedProps).sort();
    /**
	 * We implement a custom caching mechanism rather than memoizeOne. We got
	 * more ops/sec this way and we only need to bust the changing props cache
	 * instead of destroying all references on a single prop change.
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedMappedProps = {}; /*    the actual prop value */ 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedConnectedProps = {}; /* the connected prop value (the callback) */ 
    const getStateFromMappedProps = (mapped)=>{
        providedKeys.forEach((key, index)=>{
            // firstly check the cache if the prop has changed before creating
            // any new connected props
            const prop = mapped[index];
            if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
            cachedMappedProps[key] = prop;
            // @ts-expect-error - TS7019 - Rest parameter 'attrs' implicitly has an 'any[]' type.
            cachedConnectedProps[key] = (...attrs)=>{
                // assume that analytics event is always the last one (it should be by convention)
                const analyticsEvent = attrs[attrs.length - 1].clone();
                const connectedProp = ConnectedProps[key];
                // example: { onSelect: 'select' }
                if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                    name: connectedProp,
                    analyticsType: (0, $etqm0.UI_EVENT_TYPE)
                }).fire();
                else if (typeof connectedProp === 'function') {
                    const update = connectedProp(...attrs);
                    analyticsEvent.update({
                        ...update,
                        analyticsType: (0, $etqm0.UI_EVENT_TYPE)
                    }).fire();
                }
                if (typeof prop === 'function') prop(...attrs);
            };
        });
        return cachedConnectedProps;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (WrappedComponent)=>// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any,@typescript-eslint/consistent-type-assertions
        class WithAnalytics extends (0, $eUqFw.Component) {
            static{
                // Note: This seems to render weirdly in the chrome debugger. May need to change the string formatting to work around it
                this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
            }
            render() {
                const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                // @ts-expect-error TS2322: Type {} is not assignable to type
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                    ...this.props,
                    ...newMappedProps
                });
            }
        }; // eslint-disable-line @typescript-eslint/no-explicit-any
};
var $da3e17e369dbbaa5$export$2e2bcd8739ae039 = $da3e17e369dbbaa5$var$fireWithUIAnalytics;

});

parcelRegister("eodt0", function(module, exports) {

$parcel$export(module.exports, "useMarketPlaceDialog", () => $b72697409850a24e$export$55c88bc2ed61177);

var $eUqFw = parcelRequire("eUqFw");

var $7QscL = parcelRequire("7QscL");

var $8J0kb = parcelRequire("8J0kb");
var $hdXYz = parcelRequire("hdXYz");
var $lOrRB = parcelRequire("lOrRB");

var $9n12n = parcelRequire("9n12n");

var $eI5EY = parcelRequire("eI5EY");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $jD3pk = parcelRequire("jD3pk");

var $4rWQe = parcelRequire("4rWQe");

var $dWLk9 = parcelRequire("dWLk9");

var $3e9vj = parcelRequire("3e9vj");

var $c7H0g = parcelRequire("c7H0g");

var $1R3n5 = parcelRequire("1R3n5");

var $jFk3s = parcelRequire("jFk3s");

var $atoE9 = parcelRequire("atoE9");

var $h2CmH = parcelRequire("h2CmH");
const $b72697409850a24e$export$55c88bc2ed61177 = ({ requestLocation: requestLocation, enablePostInstallModal: enablePostInstallModal = true, onDismissSuccessModal: onDismissSuccessModal })=>{
    const [isAppRequestDialogOpen, setIsAppRequestDialogOpen] = (0, $eUqFw.useState)(false);
    const [isInstallationStatusModalShown, setIsInstallationStatusModalShown] = (0, $eUqFw.useState)(false);
    const [installationStatusConfig, setInstallationStatusConfig] = (0, $eUqFw.useState)({
        modalState: 'IN_PROGRESS'
    });
    const [selectedApp, setSelectedApp] = (0, $eUqFw.useState)(null);
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onRequestSuccess = (0, $eUqFw.useRef)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const activationId = (0, $4rWQe.useActivationId)();
    const environment = (0, $3e9vj.useEnvironment)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const spi = (0, $7QscL.default)({
        baseUrl: `${window.location.origin}`,
        product: 'jira',
        subproduct: 'jira-software',
        cloudId: cloudId ?? '',
        environment: environment,
        gqlGatewayUrl: `${window.location.origin}${(0, $atoE9.GRAPHQL_GATEWAY_PATH)}`,
        orgId: orgId,
        activationId: activationId
    });
    const { installerElement: installerElement, installApp: installApp } = (0, $lOrRB.useMarketplaceAppInstall)(spi, (0, $hdXYz.getAppInstallConfigForEnv)(environment), requestLocation);
    const openInstallationStatusModal = (flag)=>{
        setInstallationStatusConfig((0, $h2CmH.createInstallationStatusConfig)(flag));
        setIsInstallationStatusModalShown(true);
    };
    const closeInstallationStatusModal = ()=>{
        setInstallationStatusConfig({
            modalState: 'IN_PROGRESS'
        });
        setIsInstallationStatusModalShown(false);
    };
    const flags = {
        show: (flag)=>(0, $h2CmH.handleAppInstallFlagShow)({
                flag: flag,
                enablePostInstallModal: enablePostInstallModal,
                openInstallationStatusModal: openInstallationStatusModal,
                closeInstallationStatusModal: closeInstallationStatusModal,
                showFlag: showFlag
            }),
        dismiss: (id)=>dismissFlag((0, $eo17r.toFlagId)(id))
    };
    const installMarketplaceApp = ({ appKey: appKey, onInstallSuccess: onInstallSuccess, onInstallStarted: onInstallStarted, onSuccess: onSuccess, onFailure: onFailure })=>installApp(appKey, {
            flags: flags,
            onInstallSuccess: (args)=>{
                onSuccess?.();
                onInstallSuccess?.(args);
            },
            onInstallFailure: ()=>onFailure?.(),
            onInstallStarted: (args)=>onInstallStarted?.(args),
            suppressProgressFlag: !enablePostInstallModal
        });
    const openMarketplaceDialog = ({ appKey: appKey, appName: appName, isAppFree: isAppFree, onSuccess: onSuccess, onInstallSuccess: onInstallSuccess, onInstallStarted: onInstallStarted, onFailure: onFailure })=>{
        setSelectedApp({
            appKey: appKey,
            displayName: appName
        });
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'installProvider', {
            isAdmin: isSiteAdmin || isAdmin,
            providerName: appName,
            appKey: appKey
        });
        // Set the onSuccess callback for AppRequestDialog
        if (!onRequestSuccess.current) onRequestSuccess.current = onSuccess;
        if (isSiteAdmin || isAdmin && isAppFree) installMarketplaceApp({
            appKey: appKey,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onInstallSuccess: onInstallSuccess,
            onInstallStarted: onInstallStarted
        });
        else setIsAppRequestDialogOpen(true);
    };
    const marketplaceDialog = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, installerElement, enablePostInstallModal && isInstallationStatusModalShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jFk3s.default), {
        setModalShown: setIsInstallationStatusModalShown,
        modalState: installationStatusConfig.modalState,
        appName: selectedApp?.displayName ?? '',
        configurationUrl: installationStatusConfig.configurationUrl,
        onTryAgain: installationStatusConfig.onTryAgain,
        analyticsAttributes: {
            appKey: selectedApp?.appKey,
            installLocation: requestLocation
        },
        ...(0, $eI5EY.fg)('jira_improve_scm_onboarding_gate') && {
            onDismissSuccessModal: onDismissSuccessModal
        }
    }), isAppRequestDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8J0kb.AppInstallAnalyticsListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9n12n.default), {
        config: (0, $hdXYz.getAppInstallConfigForEnv)(environment),
        appKey: selectedApp?.appKey,
        spi: spi,
        onClose: ()=>setIsAppRequestDialogOpen(false),
        onRequestSuccess: onRequestSuccess.current,
        requestLocation: requestLocation,
        flags: flags
    })));
    return {
        openMarketplaceDialog: openMarketplaceDialog,
        marketplaceDialog: marketplaceDialog
    };
};

});
parcelRegister("7QscL", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b63449f55e56987$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $bwnaU = parcelRequire("bwnaU");

var $7jpYj = parcelRequire("7jpYj");

var $d1veh = parcelRequire("d1veh");

var $7tJ3W = parcelRequire("7tJ3W");

var $4J2mT = parcelRequire("4J2mT");

var $lpNoO = parcelRequire("lpNoO");
function $5b63449f55e56987$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5b63449f55e56987$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5b63449f55e56987$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5b63449f55e56987$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5b63449f55e56987$export$2e2bcd8739ae039 = (config)=>$5b63449f55e56987$var$_objectSpread($5b63449f55e56987$var$_objectSpread($5b63449f55e56987$var$_objectSpread($5b63449f55e56987$var$_objectSpread($5b63449f55e56987$var$_objectSpread($5b63449f55e56987$var$_objectSpread({}, (0, $bwnaU.default)(config)), (0, $d1veh.default)(config)), (0, $7jpYj.default)(config)), (0, $7tJ3W.default)(config)), (0, $4J2mT.default)(config)), (0, $lpNoO.default)(config));

});
parcelRegister("bwnaU", function(module, exports) {

$parcel$export(module.exports, "default", () => $8634a8e970498002$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $je2Cw = parcelRequire("je2Cw");

var $lLYAL = parcelRequire("lLYAL");

var $9z6QH = parcelRequire("9z6QH");

var $1w7m1 = parcelRequire("1w7m1");

var $cVLrH = parcelRequire("cVLrH");
var $i0EDR = parcelRequire("i0EDR");

var $bTrQR = parcelRequire("bTrQR");

var $gQV53 = parcelRequire("gQV53");

var $axFWr = parcelRequire("axFWr");

var $6poH2 = parcelRequire("6poH2");

var $QaRKt = parcelRequire("QaRKt");

var $dDuCy = parcelRequire("dDuCy");

var $c0juV = parcelRequire("c0juV");

var $56eyA = parcelRequire("56eyA");
var $8634a8e970498002$var$_class;
const $8634a8e970498002$var$isInstallable = (upmAvailableApp)=>upmAvailableApp.remoteInstallable || upmAvailableApp.preinstalled;
async function $8634a8e970498002$var$_getInstalledAddonInternal(addonId, environment, upmBaseUrl, gqlGatewayUrl, getInstalledAddonFlags) {
    const shouldRetryForLicenseDetails = getInstalledAddonFlags === null || getInstalledAddonFlags === void 0 ? void 0 : getInstalledAddonFlags.retryForLicenseDetails;
    const [marketplaceApp, upmInstalledApp, installedMarketplacePlugin] = await Promise.all([
        (0, $QaRKt.getRawCloudMarketplaceAppByKey)((0, $c0juV.makeAppKey)(addonId.key), gqlGatewayUrl),
        (0, $56eyA.getInstalledAppFromUpm)(upmBaseUrl, addonId.key),
        (0, $56eyA.getInstalledMarketplacePluginFromUpm)(upmBaseUrl, addonId.key, shouldRetryForLicenseDetails)
    ]);
    return (0, $gQV53.toInstalledAddon)(marketplaceApp, upmInstalledApp, installedMarketplacePlugin, environment).fold((l)=>Promise.reject(l), (installedAddon)=>installedAddon);
}
function $8634a8e970498002$var$getAllInstalledAppsFromMarketplace(upmBaseUrl, upmInstalledApps, gqlGatewayUrl) {
    return upmInstalledApps.map((upmInstalledApp)=>(0, $QaRKt.getRawCloudMarketplaceAppByKey)(upmInstalledApp.key, gqlGatewayUrl).catch((error)=>error));
}
async function $8634a8e970498002$var$getAllInstalledAddonsInternal(environment, upmBaseUrl, gqlGatewayUrl) {
    const [upmInstalledApps, installedMarketplaceResponse] = await Promise.all([
        (0, $56eyA.getAllInstalledAppsFromUpm)(upmBaseUrl),
        (0, $56eyA.getInstalledMarketplaceFromUpm)(upmBaseUrl)
    ]);
    const marketplaceApps = await Promise.all($8634a8e970498002$var$getAllInstalledAppsFromMarketplace(upmBaseUrl, upmInstalledApps, gqlGatewayUrl));
    const installedMarketplacePlugins = (0, $gQV53.arrayToMap)(installedMarketplaceResponse.plugins, (app)=>app.key);
    const marketplaceAppsMap = (0, $gQV53.arrayToMap)(marketplaceApps, (app)=>app.appKey);
    const installedAddons = upmInstalledApps.reduce((acc, upmInstalledApp)=>{
        const installedMarketplacePlugin = installedMarketplacePlugins[upmInstalledApp.key];
        const marketplaceApp = marketplaceAppsMap[upmInstalledApp.key];
        if (marketplaceApp && installedMarketplacePlugin) return [
            ...acc,
            ...(0, $gQV53.toInstalledAddon)(marketplaceApp, upmInstalledApp, installedMarketplacePlugin, environment).map((ia)=>[
                    ia
                ]).getOrElse([])
        ];
        else {
            console.error("Marketplace API or Installed Marketplace API didn't return a response for ".concat(upmInstalledApp.key));
            return acc;
        }
    }, []);
    return installedAddons;
}
let $8634a8e970498002$var$Addons = ($8634a8e970498002$var$_class = class Addons {
    constructor(config){
        (0, $5zQU9.default)(this, "config", void 0);
        (0, $5zQU9.default)(this, "upmBaseUrl", void 0);
        this.config = config;
        this.upmBaseUrl = this.config.baseUrl;
    }
    async getInstalledAddons(_options) {
        const environment = (0, $6poH2.default)(this.config);
        const allInstalledAddonsInternalPromise = $8634a8e970498002$var$getAllInstalledAddonsInternal(environment, this.upmBaseUrl, this.config.gqlGatewayUrl);
        const allInstalledEcosystemCloudAppsPromise = (0, $QaRKt.fetchAllInstalledEcosystemCloudApps)(this.config, _options.flags);
        return Promise.allSettled([
            allInstalledAddonsInternalPromise,
            allInstalledEcosystemCloudAppsPromise
        ]).then((_ref)=>{
            let [allInstalledAddonsInternalResponse, allInstalledEcosystemCloudAppsResponse] = _ref;
            const allInstalledAddonsInternal = allInstalledAddonsInternalResponse.status === 'fulfilled' ? allInstalledAddonsInternalResponse.value : [];
            const allInstalledEcosystemCloudApps = allInstalledEcosystemCloudAppsResponse.status === 'fulfilled' ? allInstalledEcosystemCloudAppsResponse.value : [];
            const installedApps = [
                ...allInstalledAddonsInternal,
                ...allInstalledEcosystemCloudApps
            ];
            return {
                values: installedApps,
                totalCount: installedApps.length,
                pageSize: installedApps.length
            };
        });
    }
    uninstallAddon(_options) {
        return Promise.reject();
    }
    // eslint-disable-next-line max-lines-per-function
    async installAddon(addon, installationTargetInfo, installAddonOptions) {
        const { billing: billing } = installationTargetInfo;
        const isAddonPaid = addon.paymentModel !== 'free';
        const billingSystemIsCCP = billing.system === (0, $cVLrH.BillingSystem).CCP;
        const useStoreBffForInstallation = billingSystemIsCCP && (isAddonPaid || installationTargetInfo.productName === (0, $i0EDR.CompatibleProductId).COMPASS);
        const provisionAppViaCCP = billingSystemIsCCP && isAddonPaid;
        const tasks = {
            requestAppProvisioning: async (appKey)=>{
                try {
                    return await (0, $9z6QH.requestAppProvisioning)({
                        cloudId: (0, $lLYAL.parse)(installationTargetInfo.contextId).cloudId,
                        appKey: appKey,
                        productName: installationTargetInfo.productName
                    });
                } catch (error) {
                    let errorJson = {};
                    if (typeof error.error === 'string') errorJson.error = error.error;
                    else try {
                        errorJson = await error.error.json();
                    } catch (e) {
                        (0, $bTrQR.default).error('install-app-parse-error', "requestAppProvisioning Failed to parse error", {
                            error: error
                        });
                    }
                    let code = 'AppProvisioningError';
                    if (errorJson.error === 'APP_REACTIVATION_NOT_SUPPORTED') code = 'APP_REACTIVATION_NOT_SUPPORTED';
                    throw new (0, $1w7m1.AppInstallError)({
                        addon: addon.identifier,
                        code: code,
                        message: "Provisioning of app failed for ".concat(addon.identifier.toString()),
                        source: error
                    });
                }
            },
            getTokenFromUPM: async ()=>{
                try {
                    return await (0, $gQV53.getTokenFromUPM)(this.upmBaseUrl);
                } catch (error) {
                    throw new (0, $1w7m1.AppInstallError)({
                        addon: addon.identifier,
                        code: 'UPMTokenFetchError',
                        message: "Fetching token from UPM failed for ".concat(addon.identifier.toString()),
                        source: error
                    });
                }
            },
            postInstallToUPM: async (token, key, provisioningRequestId, cmtEligible)=>{
                try {
                    return await (0, $gQV53.postInstallToUPM)(this.upmBaseUrl, token, key, provisioningRequestId, cmtEligible);
                } catch (error) {
                    let errorJson = {};
                    if (typeof error.error === 'string') errorJson.errorMessage = error.error;
                    else try {
                        errorJson = await error.error.json();
                    } catch (e) {
                        (0, $bTrQR.default).error('install-app-parse-error', "postInstallToUPM Failed to parse error", {
                            error: error
                        });
                    }
                    throw new (0, $1w7m1.AppInstallError)({
                        addon: addon.identifier,
                        code: errorJson.subCode || errorJson.contentType || 'UnknownUPMInstallSubscribeError',
                        message: errorJson.errorMessage,
                        source: error
                    });
                }
            },
            waitForPendingUPMTask: async (taskResponse)=>{
                try {
                    return await (0, $gQV53.waitForPendingUPMTask)(this.upmBaseUrl, taskResponse.links.self, 2000);
                } catch (error) {
                    throw new (0, $1w7m1.AppInstallError)({
                        addon: addon.identifier,
                        code: error.subCode || 'UPMInstallPostError',
                        message: error.errorMessage || "Failed while polling for app installation status for ".concat(addon.identifier.toString()),
                        source: error
                    });
                }
            },
            getInstalledAddonInternal: async (keyIdentifier)=>{
                try {
                    const environment = (0, $6poH2.default)(this.config);
                    const getInstalledAddonFlags = {
                        retryForLicenseDetails: isAddonPaid && (installAddonOptions === null || installAddonOptions === void 0 ? void 0 : installAddonOptions.retryForLicenseDetails)
                    };
                    return await $8634a8e970498002$var$_getInstalledAddonInternal(keyIdentifier, environment, this.upmBaseUrl, this.config.gqlGatewayUrl, getInstalledAddonFlags);
                } catch (error) {
                    throw new (0, $1w7m1.AppInstallError)({
                        addon: addon.identifier,
                        code: 'FetchAddonInternalError',
                        message: "Failed while constructing a app object post installation success for ".concat(addon.identifier.toString()),
                        source: error
                    });
                }
            },
            provisionAndInstallAddonByARIViaCCP: async (ariIdentifier, installConfig, enableDeprecatedInstallationsGQL)=>{
                try {
                    var _cloudAppData$data$ex, _cloudAppData$data$ex2, _cloudAppData$data, _cloudAppData$data$ec, _cloudAppData$data$ec2;
                    const provisionRequestId = await tasks.requestAppProvisioning(ariIdentifier.appKey);
                    const cloudAppData = await (0, $QaRKt.getInstalledEcosystemCloudAppFromCaaS)(ariIdentifier, installConfig, enableDeprecatedInstallationsGQL);
                    const appInstallationNode = enableDeprecatedInstallationsGQL ? (_cloudAppData$data$ex = cloudAppData.data.extensionContexts) === null || _cloudAppData$data$ex === void 0 ? void 0 : (_cloudAppData$data$ex2 = _cloudAppData$data$ex[0].installations.nodes) === null || _cloudAppData$data$ex2 === void 0 ? void 0 : _cloudAppData$data$ex2[0] : (_cloudAppData$data = cloudAppData.data) === null || _cloudAppData$data === void 0 ? void 0 : (_cloudAppData$data$ec = _cloudAppData$data.ecosystem) === null || _cloudAppData$data$ec === void 0 ? void 0 : (_cloudAppData$data$ec2 = _cloudAppData$data$ec.appInstallationsByContext.nodes) === null || _cloudAppData$data$ec2 === void 0 ? void 0 : _cloudAppData$data$ec2[0];
                    if (appInstallationNode) {
                        var _cloudAppData$data$ex3;
                        await (0, $9z6QH.pollCloudAppProvisioningStatus)(provisionRequestId);
                        const extensionContext = (_cloudAppData$data$ex3 = cloudAppData.data.extensionContexts) === null || _cloudAppData$data$ex3 === void 0 ? void 0 : _cloudAppData$data$ex3[0];
                        const productExtensions = installConfig.product === (0, $i0EDR.CompatibleProductId).Jira ? extensionContext.adminPageExtensions : extensionContext.globalSettingsExtensions;
                        return (0, $axFWr.toInstalledEcosystemCloudAddon)(installConfig.product, installConfig.baseUrl, appInstallationNode, productExtensions.filter((extension)=>extension.installationId === appInstallationNode.id));
                    } else return (0, $QaRKt.handleInstallAddonByARI)(ariIdentifier, this.config, {
                        addon: addon.identifier,
                        contextId: installationTargetInfo.contextId,
                        relayState: installationTargetInfo.relayState,
                        enableDeprecatedInstallationsGQL: enableDeprecatedInstallationsGQL
                    }, provisionRequestId);
                } catch (error) {
                    throw new (0, $1w7m1.AppInstallError)({
                        addon: addon.identifier,
                        code: (error === null || error === void 0 ? void 0 : error.code) || 'AppProvisioningError',
                        message: "Provisioning of app failed for ".concat(ariIdentifier.appKey),
                        source: error
                    });
                }
            }
        };
        const installAddonByKey = async (keyIdentifier)=>{
            const { key: appKey } = keyIdentifier;
            const legacyProvisionAndInstallByKey = async ()=>{
                const provisioningRequestId = provisionAppViaCCP ? await tasks.requestAppProvisioning(appKey) : undefined;
                const token = await tasks.getTokenFromUPM();
                const pir = await tasks.postInstallToUPM(token, appKey, provisioningRequestId, installationTargetInfo.cmtEligible);
                await tasks.waitForPendingUPMTask(pir);
            };
            if (useStoreBffForInstallation) await (0, $dDuCy.installAddonViaStoreBFF)({
                appKey: appKey,
                installationTargetInfo: installationTargetInfo
            }, {
                gqlGatewayUrl: this.config.gqlGatewayUrl
            });
            else await legacyProvisionAndInstallByKey();
            return tasks.getInstalledAddonInternal(keyIdentifier);
        };
        async function installAddonByUrl(_) {
            throw new (0, $1w7m1.AppInstallError)({
                message: 'Marketplace SPI function [InstallAddon with InstallByUrl] not implemented',
                addon: addon.identifier,
                code: 'MethodNotImplementedError'
            });
        }
        const installAddonByARI = async (ariIdentifier)=>{
            const ecosystemInstallAddonOptions = {
                addon: addon.identifier,
                contextId: installationTargetInfo.contextId,
                relayState: installationTargetInfo.relayState,
                enableReactivateForgeAppFromEmcee: installAddonOptions === null || installAddonOptions === void 0 ? void 0 : installAddonOptions.enableReactivateForgeAppFromEmcee,
                enableDeprecatedInstallationsGQL: installAddonOptions === null || installAddonOptions === void 0 ? void 0 : installAddonOptions.enableDeprecatedInstallationsGQL
            };
            const legacyProvisionAndInstallByARI = async ()=>{
                if (provisionAppViaCCP) return tasks.provisionAndInstallAddonByARIViaCCP(ariIdentifier, this.config, installAddonOptions === null || installAddonOptions === void 0 ? void 0 : installAddonOptions.enableDeprecatedInstallationsGQL);
                return (0, $QaRKt.handleInstallAddonByARI)(ariIdentifier, this.config, ecosystemInstallAddonOptions);
            };
            if (useStoreBffForInstallation) {
                await (0, $dDuCy.installAddonViaStoreBFF)({
                    appKey: ariIdentifier.appKey,
                    installationTargetInfo: installationTargetInfo
                }, {
                    gqlGatewayUrl: this.config.gqlGatewayUrl
                });
                return (0, $QaRKt.getInstalledEcosystemCloudAppOrThrowInstallError)(ariIdentifier, this.config, ecosystemInstallAddonOptions);
            }
            return legacyProvisionAndInstallByARI();
        };
        return (0, $gQV53.foldInstallableAddonIdentifier)(addon.identifier)(installAddonByKey, installAddonByUrl, installAddonByARI);
    }
    upgradeAddon(_options) {
        return Promise.reject();
    }
    uninstallAddonFromSite(_options) {
        return Promise.reject();
    }
    createContainerToken(_options) {
        return Promise.reject();
    }
    getInstalledAddon(options) {
        const environment = (0, $6poH2.default)(this.config);
        const { gqlGatewayUrl: gqlGatewayUrl } = this.config;
        return (0, $gQV53.foldInstallableAddonIdentifier)(options.addon)(async (keyIdentifier)=>$8634a8e970498002$var$_getInstalledAddonInternal(keyIdentifier, environment, this.upmBaseUrl, gqlGatewayUrl, options.flags).catch((error)=>{
                if (error.source.status === 404) return {
                    status: 'NOT_FOUND',
                    error: error
                };
                throw error;
            }), (_)=>Promise.reject('Marketplace SPI function [getInstalledAddon with InstallByUrl] not implemented'), async (ariIdentifier)=>{
            try {
                return await (0, $QaRKt.getInstalledEcosystemCloudApp)(ariIdentifier, this.config, options.flags);
            } catch (_unused) {
                return {
                    status: 'NOT_FOUND',
                    error: {
                        meta: {
                            appKey: ariIdentifier.appKey
                        }
                    }
                };
            }
        });
    }
    getInstallableAddon(options) {
        const { hostCmtEnabled: hostCmtEnabled = false } = options;
        return (0, $gQV53.foldInstallableAddonIdentifier)(options.addon)(async (keyIdentifier)=>{
            const upmAvailableApp = await (0, $56eyA.getAvailableAppFromUpm)(this.upmBaseUrl, keyIdentifier.key, hostCmtEnabled);
            return $8634a8e970498002$var$isInstallable(upmAvailableApp) ? (0, $gQV53.toInstallableAddonFromUpmAvailableApp)(upmAvailableApp) : // Pass raw upmAvailableApp in case app can't be installed, allowing consumer to decide how to handle it
            Promise.reject({
                upmAvailableApp: upmAvailableApp,
                message: 'Requested add-on is not installable'
            });
        }, (_)=>Promise.reject('Marketplace SPI function [getInstallableAddon with InstallByUrl] not implemented'), async (ariIdentifier)=>{
            const marketplaceApp = await (0, $QaRKt.getRawCloudMarketplaceAppByKey)((0, $c0juV.makeAppKey)(ariIdentifier.appKey), this.config.gqlGatewayUrl);
            return (0, $axFWr.toEcosystemCloudInstallableAddon)(marketplaceApp);
        });
    }
    rotateContainerToken(_options) {
        return Promise.reject();
    }
}, (0, $je2Cw.default)($8634a8e970498002$var$_class.prototype, "getInstalledAddons", [
    (0, $gQV53.returnsPromise)
], Object.getOwnPropertyDescriptor($8634a8e970498002$var$_class.prototype, "getInstalledAddons"), $8634a8e970498002$var$_class.prototype), (0, $je2Cw.default)($8634a8e970498002$var$_class.prototype, "uninstallAddon", [
    (0, $gQV53.returnsPromise),
    (0, $gQV53.unsupported)
], Object.getOwnPropertyDescriptor($8634a8e970498002$var$_class.prototype, "uninstallAddon"), $8634a8e970498002$var$_class.prototype), (0, $je2Cw.default)($8634a8e970498002$var$_class.prototype, "installAddon", [
    (0, $gQV53.returnsPromise),
    (0, $gQV53.throwsAppError)
], Object.getOwnPropertyDescriptor($8634a8e970498002$var$_class.prototype, "installAddon"), $8634a8e970498002$var$_class.prototype), (0, $je2Cw.default)($8634a8e970498002$var$_class.prototype, "upgradeAddon", [
    (0, $gQV53.returnsPromise),
    (0, $gQV53.unsupported)
], Object.getOwnPropertyDescriptor($8634a8e970498002$var$_class.prototype, "upgradeAddon"), $8634a8e970498002$var$_class.prototype), (0, $je2Cw.default)($8634a8e970498002$var$_class.prototype, "uninstallAddonFromSite", [
    (0, $gQV53.returnsPromise),
    (0, $gQV53.unsupported)
], Object.getOwnPropertyDescriptor($8634a8e970498002$var$_class.prototype, "uninstallAddonFromSite"), $8634a8e970498002$var$_class.prototype), (0, $je2Cw.default)($8634a8e970498002$var$_class.prototype, "createContainerToken", [
    (0, $gQV53.returnsPromise),
    (0, $gQV53.unsupported)
], Object.getOwnPropertyDescriptor($8634a8e970498002$var$_class.prototype, "createContainerToken"), $8634a8e970498002$var$_class.prototype), (0, $je2Cw.default)($8634a8e970498002$var$_class.prototype, "getInstalledAddon", [
    (0, $gQV53.returnsPromise)
], Object.getOwnPropertyDescriptor($8634a8e970498002$var$_class.prototype, "getInstalledAddon"), $8634a8e970498002$var$_class.prototype), (0, $je2Cw.default)($8634a8e970498002$var$_class.prototype, "getInstallableAddon", [
    (0, $gQV53.returnsPromise)
], Object.getOwnPropertyDescriptor($8634a8e970498002$var$_class.prototype, "getInstallableAddon"), $8634a8e970498002$var$_class.prototype), (0, $je2Cw.default)($8634a8e970498002$var$_class.prototype, "rotateContainerToken", [
    (0, $gQV53.returnsPromise),
    (0, $gQV53.unsupported)
], Object.getOwnPropertyDescriptor($8634a8e970498002$var$_class.prototype, "rotateContainerToken"), $8634a8e970498002$var$_class.prototype), $8634a8e970498002$var$_class);
var $8634a8e970498002$export$2e2bcd8739ae039 = (config)=>(0, $gQV53.instanceToModule)(new $8634a8e970498002$var$Addons(config));

});
parcelRegister("je2Cw", function(module, exports) {

$parcel$export(module.exports, "default", () => $dff15b7171da0eff$export$2e2bcd8739ae039);
function $dff15b7171da0eff$export$2e2bcd8739ae039(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a;
}

});

parcelRegister("9z6QH", function(module, exports) {

$parcel$export(module.exports, "requestAppProvisioning", () => $6f6cb203a1121d19$export$cf54dee9c9b16e76);
$parcel$export(module.exports, "pollCloudAppProvisioningStatus", () => $6f6cb203a1121d19$export$d9c3f5e94f8e1adc);

var $dO8LH = parcelRequire("dO8LH");

var $eE56D = parcelRequire("eE56D");
const $6f6cb203a1121d19$export$cf54dee9c9b16e76 = (appProvisioningRequest)=>(0, $dO8LH.fetchOk)("/gateway/api/marketplace/internal/demand/app-provision", {
        method: 'POST',
        body: JSON.stringify(appProvisioningRequest),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((response)=>response.json()).then((response)=>response.provisioningRequestId);
const $6f6cb203a1121d19$export$b47ba6e8d4012f84 = (maximumDurationInMinutes, pollAfter)=>maximumDurationInMinutes * 60000 / pollAfter;
async function $6f6cb203a1121d19$export$d9c3f5e94f8e1adc(provisioningRequestId) {
    const pollAfter = 5000;
    const options = {
        retries: $6f6cb203a1121d19$export$b47ba6e8d4012f84(4, pollAfter),
        retryDelay: pollAfter,
        accept: (response)=>response.json().then((bodyJSON)=>{
                var _bodyJSON$payload$dat;
                const appProvisioningStatus = (_bodyJSON$payload$dat = bodyJSON.payload.data.resourcePackages) === null || _bodyJSON$payload$dat === void 0 ? void 0 : _bodyJSON$payload$dat[0].action.status;
                return appProvisioningStatus === (0, $eE56D.AppProvisionStatus).IN_PROGRESS ? Promise.reject(new Error('Request pending')) : Promise.resolve();
            })
    };
    const response = await (0, $dO8LH.fetchOk)("/gateway/api/marketplace/internal/demand/app-provision/status/".concat(provisioningRequestId), options);
    const responseJSON = await response.json();
    const appProvisioningStatus = responseJSON.payload.data.resourcePackages[0].action.status;
    if (appProvisioningStatus === (0, $eE56D.AppProvisionStatus).SUCCESS) return Promise.resolve((0, $eE56D.AppProvisionStatus).SUCCESS);
    else throw new Error("Polling for app provision status failed for provisioningRequestId: ".concat(provisioningRequestId));
}

});
parcelRegister("dO8LH", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $a0d6bf0ff7a4b6b0$export$e7aa7bc5c1b3cfb3);
$parcel$export(module.exports, "fetchOk", () => $a0d6bf0ff7a4b6b0$export$3783294069ccd537);

var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");
const $a0d6bf0ff7a4b6b0$var$_excluded = [
    "retries",
    "accept",
    "retryDelay"
];
function $a0d6bf0ff7a4b6b0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a0d6bf0ff7a4b6b0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a0d6bf0ff7a4b6b0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a0d6bf0ff7a4b6b0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 *
 * Code taken from : https://github.com/jonbern/fetch-retry
 *
 * This is a wrapper for isomorphic-fetch with retry and accept
 *
 * Updated the code to have a accept param :
 * this is to retry when the response returned is not acceptable and we want to retry,
 * even if the response was 2XX, or 4XX or 5XX
 *
 * @param url
 * @param options
 *      retry: Int
 *      retryDelay: Int : milliseconds
 *      accept: (response) => Promise<void> : Will retry if the Promise is rejected
 * @return {Promise}
 */ function $a0d6bf0ff7a4b6b0$export$e7aa7bc5c1b3cfb3(url) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const defaultAccept = ()=>Promise.resolve();
    const { retries: retries = 0, accept: accept = defaultAccept, retryDelay: retryDelay = 0 } = options, fetchOptions = (0, $bwPfh.default)(options, $a0d6bf0ff7a4b6b0$var$_excluded);
    return new Promise((resolve, reject)=>{
        const wrappedFetch = function wrappedFetch(n) {
            fetch(url, fetchOptions).then((r)=>accept(r.clone()).then((_)=>resolve(r))).catch((error)=>{
                if (n > 0) setTimeout(()=>{
                    wrappedFetch(--n);
                }, retryDelay);
                else reject({
                    url: url,
                    error: error,
                    status: error.status || 'unknown'
                });
            });
        };
        wrappedFetch(retries);
    });
}
/**
 * Function for accept param in fetch(), that only resolves when the response is ok and rejects in any other response
 */ const $a0d6bf0ff7a4b6b0$export$df53d19c6ff4368d = (resp)=>resp.ok === true ? Promise.resolve() : Promise.reject(resp);
function $a0d6bf0ff7a4b6b0$export$3783294069ccd537(url) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return $a0d6bf0ff7a4b6b0$export$e7aa7bc5c1b3cfb3(url, $a0d6bf0ff7a4b6b0$var$_objectSpread($a0d6bf0ff7a4b6b0$var$_objectSpread({}, options), {}, {
        accept: (resp)=>$a0d6bf0ff7a4b6b0$export$df53d19c6ff4368d(resp).then(()=>{
                const accept = options.accept;
                return (accept ? accept : ()=>Promise.resolve())(resp);
            })
    })).catch((error)=>Promise.reject(error));
}

});

parcelRegister("eE56D", function(module, exports) {

$parcel$export(module.exports, "AppProvisionStatus", () => $aa98c316006568ae$export$f4aeb6fbad2e1f13);
const $aa98c316006568ae$export$f4aeb6fbad2e1f13 = Object.freeze({
    SUCCESS: 'SUCCESS',
    IN_PROGRESS: 'IN_PROGRESS'
});

});


parcelRegister("1w7m1", function(module, exports) {

$parcel$export(module.exports, "AppInstallError", () => $11ae7bf9df1a9c3d$export$8682a08cd10649cb);
$parcel$export(module.exports, "makeAppFetchError", () => $11ae7bf9df1a9c3d$export$fda0731393a9b06c);

var $h1LeU = parcelRequire("h1LeU");
const $11ae7bf9df1a9c3d$export$8682a08cd10649cb = (0, $h1LeU.default)('AppInstallError', (_ref)=>{
    let { code: code, message: message, addon: addon, source: source, requestId: requestId } = _ref;
    return {
        code: code,
        message: message,
        source: source,
        meta: {
            addon: addon,
            requestId: requestId
        }
    };
});
const $11ae7bf9df1a9c3d$export$fda0731393a9b06c = (name)=>{
    return (0, $h1LeU.default)(name, (_ref2)=>{
        let { source: source, appKey: appKey, requestId: requestId } = _ref2;
        return {
            code: 'FetchError',
            message: "Failed to fetch app details for ".concat(appKey),
            source: source,
            meta: {
                appKey: appKey,
                requestId: requestId
            }
        };
    });
};

});
parcelRegister("h1LeU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6572c6c8af98ca4$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $3pDAB = parcelRequire("3pDAB");
const $c6572c6c8af98ca4$var$_excluded = [
    "code",
    "message",
    "meta",
    "source"
];
function $c6572c6c8af98ca4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c6572c6c8af98ca4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c6572c6c8af98ca4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c6572c6c8af98ca4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * Wraps a passed function after dynamically
 * setting the function name. The function name
 * is minification-proof.
 */ function $c6572c6c8af98ca4$var$withName(name, fn) {
    function wrappedFunction() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return fn.apply(this, args);
    }
    Object.defineProperty(wrappedFunction, 'name', {
        value: name
    });
    return wrappedFunction;
}
// If a transform function is specified, the fields passed
// to the error constructor should match fields passed to the
// transform function. Else they should match standard `ErrorFields`
/**
 * Factory function for creating new error types.
 * Takes an optional transform function that is expected
 * to return standard ErrorFields.
 *
 * @example
 * const SimpleError = createErrorType('SimpleError')
 * throw new SimpleError({ code: 'code', message: 'something went wrong'})
 * ----
 * type BuiltErrorFields = { foo: string }
 * const BuiltError =  createErrorType<BuiltErrorFields>('BuiltError', ({ foo }) => ({ code: foo, message: 'bar' }))
 * throw new BuiltError({ foo: 'baz'})
 */ const $c6572c6c8af98ca4$var$createErrorType = (type, transform)=>{
    // MC-2850 To-do fix the typing for "this"
    const CustomError = $c6572c6c8af98ca4$var$withName(type, function(params) {
        const finalParams = transform ? transform(params) : params;
        const { code: code, message: message, meta: meta, source: source } = finalParams, other = (0, $bwPfh.default)(finalParams, $c6572c6c8af98ca4$var$_excluded);
        this.code = code;
        this.message = message;
        this.id = (0, $3pDAB.nanoid)(9);
        this.type = type;
        this.source = source;
        this.meta = $c6572c6c8af98ca4$var$_objectSpread($c6572c6c8af98ca4$var$_objectSpread({}, meta), other);
        this.toJSON = ()=>$c6572c6c8af98ca4$var$_objectSpread({
                id: this.id,
                code: this.code,
                type: this.type,
                message: this.message,
                meta: this.meta
            }, this.source && {
                source: this.source.toJSON ? this.source.toJSON() : this.source.message ? this.source.message : this.source
            });
        this.toString = ()=>JSON.stringify(this.toJSON());
        if (Object.prototype.hasOwnProperty.call(Error, 'captureStackTrace')) Error.captureStackTrace(this, CustomError);
        else this.stack = new Error(message).stack;
    });
    if (typeof Object.setPrototypeOf === 'function') Object.setPrototypeOf(CustomError.prototype, Error.prototype);
    else CustomError.prototype = Object.create(Error.prototype, {
        constructor: {
            value: CustomError
        }
    });
    return CustomError;
};
var $c6572c6c8af98ca4$export$2e2bcd8739ae039 = $c6572c6c8af98ca4$var$createErrorType;

});
parcelRegister("3pDAB", function(module, exports) {

$parcel$export(module.exports, "nanoid", () => $27c26a7ee1643e03$export$ac4959f4f1338dfc);

var $9tgjU = parcelRequire("9tgjU");
let $27c26a7ee1643e03$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $27c26a7ee1643e03$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = '';
        while(true){
            let bytes = getRandom(step);
            let j = step;
            while(j--){
                id += alphabet[bytes[j] & mask] || '';
                if (id.length === size) return id;
            }
        }
    };
};
let $27c26a7ee1643e03$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$27c26a7ee1643e03$export$a5cee9e955a615e5(alphabet, size, $27c26a7ee1643e03$export$4385e60b38654f68);
let $27c26a7ee1643e03$export$ac4959f4f1338dfc = (size = 21)=>crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte)=>{
        byte &= 63;
        if (byte < 36) id += byte.toString(36);
        else if (byte < 62) id += (byte - 26).toString(36).toUpperCase();
        else if (byte > 62) id += '-';
        else id += '_';
        return id;
    }, '');

});
parcelRegister("9tgjU", function(module, exports) {
let $6e537b4cb9d9fe59$export$2b646eea95309f00 = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';

});




parcelRegister("cVLrH", function(module, exports) {

$parcel$export(module.exports, "BillingSystem", () => $969f9caa081b5f8c$export$b98d8c55ee048af0);
const $969f9caa081b5f8c$export$b98d8c55ee048af0 = Object.freeze({
    CCP: 'CCP',
    HAMS: 'HAMS'
});

});

parcelRegister("i0EDR", function(module, exports) {

$parcel$export(module.exports, "CompatibleProductId", () => $d1c7c0b9cbcf61d0$export$df338930ef01ceeb);
$parcel$export(module.exports, "CompatibleProductName", () => $d1c7c0b9cbcf61d0$export$43260f31e4024012);
const $d1c7c0b9cbcf61d0$export$34a11a76909ead13 = Object.freeze({
    JIRA: 'JIRA',
    CONFLUENCE: 'CONFLUENCE',
    CRUCIBLE: 'CRUCIBLE',
    BAMBOO: 'BAMBOO',
    CROWD: 'CROWD',
    BITBUCKET: 'BITBUCKET',
    OPSGENIE: 'OPSGENIE',
    STATUS_PAGE: 'STATUS_PAGE',
    TOWNSQUARE: 'TOWNSQUARE',
    COMPASS: 'COMPASS',
    FISHEYE: 'FISHEYE',
    JIRA_SERVICE_MANAGEMENT: 'JIRA_SERVICE_MANAGEMENT'
});
const $d1c7c0b9cbcf61d0$export$df338930ef01ceeb = Object.freeze({
    Jira: 'jira',
    Confluence: 'confluence',
    Crucible: 'crucible',
    Bamboo: 'bamboo',
    Crowd: 'crowd',
    Bitbucket: 'bitbucket',
    Opsgenie: 'opsgenie',
    StatusPage: 'status_page',
    Townsquare: 'townsquare',
    Hipchat: 'hipchat',
    COMPASS: 'compass',
    Fisheye: 'fisheye',
    JiraServiceManagement: 'jira-service-management'
});
const $d1c7c0b9cbcf61d0$export$43260f31e4024012 = {
    [$d1c7c0b9cbcf61d0$export$df338930ef01ceeb.Jira]: 'Jira',
    [$d1c7c0b9cbcf61d0$export$df338930ef01ceeb.Confluence]: 'Confluence',
    [$d1c7c0b9cbcf61d0$export$df338930ef01ceeb.JiraServiceManagement]: 'Jira Service Management',
    [$d1c7c0b9cbcf61d0$export$df338930ef01ceeb.Fisheye]: 'Fisheye',
    [$d1c7c0b9cbcf61d0$export$df338930ef01ceeb.Crucible]: 'Crucible',
    [$d1c7c0b9cbcf61d0$export$df338930ef01ceeb.Bitbucket]: 'Bitbucket',
    [$d1c7c0b9cbcf61d0$export$df338930ef01ceeb.Crowd]: 'Crowd',
    [$d1c7c0b9cbcf61d0$export$df338930ef01ceeb.Bamboo]: 'Bamboo',
    [$d1c7c0b9cbcf61d0$export$df338930ef01ceeb.COMPASS]: 'Compass'
};

});

parcelRegister("gQV53", function(module, exports) {

$parcel$export(module.exports, "buildContext", () => $c44dc7ac64a27d3b$export$3a7fe28f9bf4f3d9);
$parcel$export(module.exports, "returnsPromise", () => $c44dc7ac64a27d3b$export$51b23e8c35a8720b);
$parcel$export(module.exports, "throwsAppError", () => $c44dc7ac64a27d3b$export$2c3b49b874dfe566);
$parcel$export(module.exports, "unsupported", () => $c44dc7ac64a27d3b$export$98e633703a635f);
$parcel$export(module.exports, "instanceToModule", () => $c44dc7ac64a27d3b$export$e7303cbbda2866c6);
$parcel$export(module.exports, "getTokenFromUPM", () => $c44dc7ac64a27d3b$export$9e329766bd383c22);
$parcel$export(module.exports, "getUPMCredentials", () => $c44dc7ac64a27d3b$export$9f0387e1e9b3eead);
$parcel$export(module.exports, "postInstallToUPM", () => $c44dc7ac64a27d3b$export$183c3dd865ccae70);
$parcel$export(module.exports, "foldInstallableAddonIdentifier", () => $c44dc7ac64a27d3b$export$d74e456828fa5d02);
$parcel$export(module.exports, "foldPermissionIdentifier", () => $c44dc7ac64a27d3b$export$7adbfe43d093f2b9);
$parcel$export(module.exports, "calculateRetries", () => $c44dc7ac64a27d3b$export$b47ba6e8d4012f84);
$parcel$export(module.exports, "waitForPendingUPMTask", () => $c44dc7ac64a27d3b$export$4fcc92cf5ecc9986);
$parcel$export(module.exports, "setProp", () => $c44dc7ac64a27d3b$export$8a39838a0f735648);
$parcel$export(module.exports, "toInstallableAddonFromUpmAvailableApp", () => $c44dc7ac64a27d3b$export$6a97a6c22226d99);
$parcel$export(module.exports, "toInstalledAddon", () => $c44dc7ac64a27d3b$export$43197df0fd5cbe13);
$parcel$export(module.exports, "arrayToMap", () => $c44dc7ac64a27d3b$export$8ff5edbc8a5b1a81);
$parcel$export(module.exports, "transformToPaymentModel", () => $c44dc7ac64a27d3b$export$581b3b2292f173ff);

var $5zQU9 = parcelRequire("5zQU9");

var $dO8LH = parcelRequire("dO8LH");

var $9fEFB = parcelRequire("9fEFB");

var $iZFTO = parcelRequire("iZFTO");

var $kt9Cs = parcelRequire("kt9Cs");

var $dx2bt = parcelRequire("dx2bt");

var $c0juV = parcelRequire("c0juV");
function $c44dc7ac64a27d3b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c44dc7ac64a27d3b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c44dc7ac64a27d3b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c44dc7ac64a27d3b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $c44dc7ac64a27d3b$export$5ee183ee125d017c = (productName)=>{
    switch(productName){
        case 'jira':
            return 'Jira';
        case 'confluence':
            return 'Confluence';
        case 'compass':
            return 'Compass';
        default:
            throw new Error("Unsupported product name: ".concat(productName));
    }
};
const $c44dc7ac64a27d3b$export$3a7fe28f9bf4f3d9 = (config)=>{
    return {
        name: $c44dc7ac64a27d3b$export$5ee183ee125d017c(config.product),
        type: 'application',
        id: "ari:cloud:".concat(config.product, ":").concat(config.cloudId, ":/"),
        orgId: config.orgId,
        // To understand wrokspaceAri format visit - // https://developer.atlassian.com/platform/atlassian-resource-identifier/resource-owners/registry/#ati%3Acloud%3Ajira%3Aworkspace
        workspaceAri: "ari:cloud:".concat(config.product, ":").concat(config.cloudId, ":workspace/").concat(config.activationId)
    };
};
function $c44dc7ac64a27d3b$export$51b23e8c35a8720b(target, key, descriptor) {
    descriptor.value.returnsPromise = true;
    descriptor.enumerable = true;
    return descriptor;
}
function $c44dc7ac64a27d3b$export$2c3b49b874dfe566(target, key, descriptor) {
    const fn = descriptor.value;
    // eslint-disable-next-line eqeqeq
    const isPromise = (val)=>Promise.resolve(val) == val;
    descriptor.value = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        const result = fn.apply(this, args);
        if (isPromise(result)) return result.then((resolvedValue)=>resolvedValue).catch((error)=>{
            if (error.toJSON) throw error.toJSON();
            else throw error;
        });
        else return result;
    };
    return descriptor;
}
function $c44dc7ac64a27d3b$export$98e633703a635f(target, key, descriptor) {
    const name = descriptor.value.name;
    descriptor.value = ()=>Promise.reject("Marketplace SPI function [".concat(name, "] not implemented"));
    return descriptor;
}
function $c44dc7ac64a27d3b$export$e7303cbbda2866c6(instance) {
    const module = {};
    const prototype = Object.getPrototypeOf(instance);
    Object.keys(prototype).forEach((key)=>{
        module[key] = prototype[key].bind(instance);
        module[key].returnsPromise = prototype[key].returnsPromise;
    });
    return module;
}
async function $c44dc7ac64a27d3b$export$9e329766bd383c22(upm) {
    const options = {
        retries: 2,
        retryDelay: 3000,
        credentials: $c44dc7ac64a27d3b$export$9f0387e1e9b3eead(upm)
    };
    const response = await (0, $dO8LH.fetchOk)("".concat(upm, "/rest/plugins/1.0/upm-token"), $c44dc7ac64a27d3b$var$_objectSpread({
        method: 'HEAD'
    }, options));
    return response.headers.get('upm-token');
}
async function $c44dc7ac64a27d3b$export$183c3dd865ccae70(upm, token, appKey, provisioningRequestId, cmtEligible) {
    const options = {
        method: 'POST',
        credentials: $c44dc7ac64a27d3b$export$9f0387e1e9b3eead(upm),
        headers: new window.Headers({
            'content-type': (0, $dx2bt.REMOTE_INSTALL_JSON)
        })
    };
    return (await (0, $dO8LH.fetchOk)("".concat(upm, "/rest/plugins/1.0/apps/install-subscribe?").concat((0, (/*@__PURE__*/$parcel$interopDefault($kt9Cs))).stringify({
        addonKey: appKey,
        token: token,
        provisioningRequestId: provisioningRequestId,
        cmtEligible: cmtEligible
    })), options)).json();
}
const $c44dc7ac64a27d3b$export$d74e456828fa5d02 = (addonIdentifier)=>(key, url, ari)=>{
        if (addonIdentifier.key) return key(addonIdentifier);
        else if (addonIdentifier.url) return url(addonIdentifier);
        else if (addonIdentifier.ari) return ari(addonIdentifier);
        else throw new Error('Invalid identifier');
    };
const $c44dc7ac64a27d3b$export$7adbfe43d093f2b9 = (addonIdentifier)=>(key, ari)=>{
        if (addonIdentifier.details.ecosystemCloudAppId) return ari(addonIdentifier);
        else return key(addonIdentifier);
    };
const $c44dc7ac64a27d3b$export$b47ba6e8d4012f84 = (maximumDurationInMinutes, pollAfter)=>maximumDurationInMinutes * 60000 / pollAfter;
async function $c44dc7ac64a27d3b$export$4fcc92cf5ecc9986(upm, uri, pollAfter) {
    const options = {
        retries: $c44dc7ac64a27d3b$export$b47ba6e8d4012f84(4.33, pollAfter),
        retryDelay: pollAfter,
        credentials: $c44dc7ac64a27d3b$export$9f0387e1e9b3eead(upm),
        accept: (response)=>response.json().then((bodyJSON)=>{
                var _bodyJSON$status;
                return (_bodyJSON$status = bodyJSON.status) !== null && _bodyJSON$status !== void 0 && _bodyJSON$status.done ? Promise.resolve() : Promise.reject(new Error('Request pending'));
            })
    };
    const response = await (0, $dO8LH.fetchOk)(uri, options);
    const responseJSON = await response.json();
    const contentTypeHeader = response.headers.get('content-type');
    const headerHasInstallComplete = (contentTypeHeader === null || contentTypeHeader === void 0 ? void 0 : contentTypeHeader.indexOf((0, $dx2bt.INSTALL_COMPLETE_JSON))) !== -1;
    if (headerHasInstallComplete) return responseJSON;
    else return Promise.reject($c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread({}, responseJSON.status), {}, {
        contentTypeHeader: contentTypeHeader
    }));
}
const $c44dc7ac64a27d3b$export$5e09a4327db89926 = (marketplaceApp, environment)=>{
    var _marketplaceApp$logo$;
    const { version: version, partner: partner } = marketplaceApp;
    const links = (0, $9fEFB.linkTemplates)({
        adminHubBaseUrl: environment.adminHubBaseUrl,
        mpacBaseUrl: environment.mpacBaseUrl,
        mpacCdnBaseUrl: environment.mpacCdnBaseUrl,
        macBaseUrl: environment.macBaseUrl,
        wacBaseUrl: environment.wacBaseUrl,
        atlassianCommunityBaseUrl: environment.atlassianCommunityBaseUrl
    });
    return $c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread({
        key: marketplaceApp.appKey,
        name: marketplaceApp.name,
        origin: 'marketplace',
        description: marketplaceApp.tagline || ''
    }, $c44dc7ac64a27d3b$export$8a39838a0f735648('version', version === null || version === void 0 ? void 0 : version.version)), $c44dc7ac64a27d3b$export$8a39838a0f735648('vendor', partner === null || partner === void 0 ? void 0 : partner.name)), $c44dc7ac64a27d3b$export$8a39838a0f735648('vendorLink', partner ? links.partnerDetails.expand({
        id: partner.id,
        slug: partner.slug
    }) : undefined)), $c44dc7ac64a27d3b$export$8a39838a0f735648('icon', marketplaceApp.logo ? links.mediaFile.expand({
        imageId: ((_marketplaceApp$logo$ = marketplaceApp.logo.highResolution) === null || _marketplaceApp$logo$ === void 0 ? void 0 : _marketplaceApp$logo$.id) || marketplaceApp.logo.original.id
    }) : undefined)), $c44dc7ac64a27d3b$export$8a39838a0f735648('privacyPolicy', marketplaceApp.privacyPolicyUrl)), $c44dc7ac64a27d3b$export$8a39838a0f735648('eula', version === null || version === void 0 ? void 0 : version.endUserLicenseAgreementUrl)), {}, {
        vendorType: (partner === null || partner === void 0 ? void 0 : partner.partnerType) === 'ATLASSIAN_INTERNAL' ? 'internal' : 'thirdParty',
        metadata: undefined
    });
};
const $c44dc7ac64a27d3b$var$resolveScopes = (marketplaceApp)=>{
    var _marketplaceApp$versi;
    // let scopes;
    // if(marketplaceApp.version?.deployment) {
    //   {scopes} = (marketplaceApp.version?.deployment);
    // }
    const { scopes: scopes } = ((_marketplaceApp$versi = marketplaceApp.version) === null || _marketplaceApp$versi === void 0 ? void 0 : _marketplaceApp$versi.deployment) || {};
    return scopes ? scopes.map((a)=>a.id) : [];
};
const $c44dc7ac64a27d3b$export$96613f433d2dc4e1 = (upmAvailableApp)=>{
    var _upmAvailableApp$vend, _upmAvailableApp$vend2, _upmAvailableApp$logo;
    return $c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread({
        key: upmAvailableApp.key,
        name: upmAvailableApp.name,
        origin: 'marketplace',
        description: upmAvailableApp.summary,
        version: upmAvailableApp.version
    }, $c44dc7ac64a27d3b$export$8a39838a0f735648('vendor', (_upmAvailableApp$vend = upmAvailableApp.vendor) === null || _upmAvailableApp$vend === void 0 ? void 0 : _upmAvailableApp$vend.name)), $c44dc7ac64a27d3b$export$8a39838a0f735648('vendorLink', (_upmAvailableApp$vend2 = upmAvailableApp.vendor) === null || _upmAvailableApp$vend2 === void 0 ? void 0 : _upmAvailableApp$vend2.marketplaceLink)), $c44dc7ac64a27d3b$export$8a39838a0f735648('vendorType', upmAvailableApp.vendor ? upmAvailableApp.vendor.isAtlassian ? 'internal' : 'thirdParty' : undefined)), $c44dc7ac64a27d3b$export$8a39838a0f735648('icon', (_upmAvailableApp$logo = upmAvailableApp.logo) === null || _upmAvailableApp$logo === void 0 ? void 0 : _upmAvailableApp$logo.link)), $c44dc7ac64a27d3b$export$8a39838a0f735648('privacyPolicy', upmAvailableApp.links.privacy)), $c44dc7ac64a27d3b$export$8a39838a0f735648('eula', upmAvailableApp.links.eula)), {}, {
        metadata: undefined
    });
};
const $c44dc7ac64a27d3b$export$473c8c83f60f5929 = (upmAvailableApp)=>({
        isEligible: Boolean(upmAvailableApp.cmtEligible),
        btfSenEndDate: upmAvailableApp.btfSenEndDate ? new Date(upmAvailableApp.btfSenEndDate) : undefined
    });
const $c44dc7ac64a27d3b$export$6a97a6c22226d99 = (upmAvailableApp)=>({
        details: $c44dc7ac64a27d3b$export$96613f433d2dc4e1(upmAvailableApp),
        preinstalled: upmAvailableApp.preinstalled,
        scopes: (upmAvailableApp.permissions || []).map((p)=>p.key),
        metadata: undefined,
        eligibleForFreeOnSandbox: upmAvailableApp.eligibleForFreeOnSandbox,
        cloudMigrationTrial: $c44dc7ac64a27d3b$export$473c8c83f60f5929(upmAvailableApp)
    });
function $c44dc7ac64a27d3b$export$8a39838a0f735648(prop, value) {
    return value !== undefined && value !== null ? {
        [prop]: value
    } : {};
}
function $c44dc7ac64a27d3b$export$8d07be9e36a46378(marketplaceApp, environment, getStartedUrl, configureUrl, manageUrl, paymentModel) {
    return $c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread({
        details: $c44dc7ac64a27d3b$export$5e09a4327db89926(marketplaceApp, environment),
        scopes: $c44dc7ac64a27d3b$var$resolveScopes(marketplaceApp),
        enabled: true,
        latestVersion: true,
        installationId: marketplaceApp.appKey
    }, $c44dc7ac64a27d3b$export$8a39838a0f735648('getStartedUrl', getStartedUrl)), $c44dc7ac64a27d3b$export$8a39838a0f735648('configureUrl', configureUrl)), $c44dc7ac64a27d3b$export$8a39838a0f735648('manageAppUrl', manageUrl)), {}, {
        paymentModel: paymentModel,
        installTime: new Date(),
        authType: {
            type: '2LO'
        },
        metadata: undefined
    });
}
function $c44dc7ac64a27d3b$export$43197df0fd5cbe13(marketplaceApp, upmInstalledApp, installedMarketplacePlugin, environment) {
    var _upmInstalledApp$link, _upmInstalledApp$link2, _upmInstalledApp$link3;
    const getStartedUrl = (_upmInstalledApp$link = upmInstalledApp.links) === null || _upmInstalledApp$link === void 0 ? void 0 : _upmInstalledApp$link.postInstall;
    const configureUrl = (_upmInstalledApp$link2 = upmInstalledApp.links) === null || _upmInstalledApp$link2 === void 0 ? void 0 : _upmInstalledApp$link2.configure;
    const manageAppUrl = (_upmInstalledApp$link3 = upmInstalledApp.links) === null || _upmInstalledApp$link3 === void 0 ? void 0 : _upmInstalledApp$link3.manage;
    return $c44dc7ac64a27d3b$export$7bfa491acf3d6091(installedMarketplacePlugin, marketplaceApp).map((spiPaymentModel)=>$c44dc7ac64a27d3b$export$8d07be9e36a46378(marketplaceApp, environment, getStartedUrl, configureUrl, manageAppUrl, spiPaymentModel));
}
const $c44dc7ac64a27d3b$export$46b1f780882f13c2 = {
    type: 'free'
};
const $c44dc7ac64a27d3b$export$9c59fa02e3730dbe = (sr)=>({
        type: 'paid',
        licenseType: sr
    });
const $c44dc7ac64a27d3b$var$getEvaluationLicenseType = (expiry, isAutoRenewal)=>expiry != null ? (0, $iZFTO.Either).right({
        type: 'evaluation',
        expiry: expiry,
        isAutoRenewal: isAutoRenewal
    }) : (0, $iZFTO.Either).left('Unable to get Expiry date for evaluation license');
const $c44dc7ac64a27d3b$var$getSubscriptionLicenseType = (endDate, isAutoRenewal)=>isAutoRenewal ? (0, $iZFTO.Either).right({
        type: 'subscription',
        renewalType: {
            isAutoRenewal: true
        }
    }) : endDate != null ? (0, $iZFTO.Either).right({
        type: 'subscription',
        renewalType: {
            isAutoRenewal: false,
            endDate: endDate
        }
    }) : (0, $iZFTO.Either).left('Unable to get end date for subscription license');
const $c44dc7ac64a27d3b$export$7bfa491acf3d6091 = (imp, mp)=>{
    var _mp$version;
    const paymentModel = (_mp$version = mp.version) === null || _mp$version === void 0 ? void 0 : _mp$version.paymentModel;
    if (!paymentModel) return (0, $iZFTO.Either).left('Unable to get payment model from marketplace');
    return (0, $c0juV.foldPaymentModel)(paymentModel)(()=>(0, $iZFTO.Either).right($c44dc7ac64a27d3b$export$46b1f780882f13c2), ()=>{
        var _imp$licenseDetails, _imp$licenseDetails2, _imp$licenseDetails3;
        const evaluation = (_imp$licenseDetails = imp.licenseDetails) === null || _imp$licenseDetails === void 0 ? void 0 : _imp$licenseDetails.evaluation;
        const autoRenewal = (_imp$licenseDetails2 = imp.licenseDetails) === null || _imp$licenseDetails2 === void 0 ? void 0 : _imp$licenseDetails2.autoRenewal;
        const expiryDate = (_imp$licenseDetails3 = imp.licenseDetails) === null || _imp$licenseDetails3 === void 0 ? void 0 : _imp$licenseDetails3.expiryDate;
        if (evaluation != null && autoRenewal != null) {
            var _imp$licenseDetails4;
            return evaluation ? $c44dc7ac64a27d3b$var$getEvaluationLicenseType(expiryDate, autoRenewal).map($c44dc7ac64a27d3b$export$9c59fa02e3730dbe) : $c44dc7ac64a27d3b$var$getSubscriptionLicenseType((_imp$licenseDetails4 = imp.licenseDetails) === null || _imp$licenseDetails4 === void 0 ? void 0 : _imp$licenseDetails4.subscriptionEndDate, autoRenewal).map($c44dc7ac64a27d3b$export$9c59fa02e3730dbe);
        } else return (0, $iZFTO.Either).left('Unable to get subscription information from UPM');
    }, ()=>(0, $iZFTO.Either).left('Cannot get subscription information for a PvV app'));
};
function $c44dc7ac64a27d3b$export$9f0387e1e9b3eead(upmBaseUrl) {
    return upmBaseUrl === '' ? 'same-origin' : 'include';
}
const $c44dc7ac64a27d3b$export$8ff5edbc8a5b1a81 = (array, getKeyFunction)=>array.reduce((acc, value)=>{
        acc[getKeyFunction(value)] = value;
        return acc;
    }, {});
const $c44dc7ac64a27d3b$export$581b3b2292f173ff = (version, marketplaceInstallation)=>{
    var _marketplaceInstallat, _marketplaceInstallat2;
    let type = {
        type: 'free'
    };
    const trialEndDate = (_marketplaceInstallat = marketplaceInstallation.license) === null || _marketplaceInstallat === void 0 ? void 0 : _marketplaceInstallat.trialEndDate;
    const isEvaluation = (_marketplaceInstallat2 = marketplaceInstallation.license) === null || _marketplaceInstallat2 === void 0 ? void 0 : _marketplaceInstallat2.isEvaluation;
    if (version.paymentModel === 'PAID_VIA_ATLASSIAN') {
        if (isEvaluation && trialEndDate) {
            type = {
                type: 'paid',
                licenseType: {
                    type: 'evaluation',
                    expiry: Date.parse(trialEndDate),
                    isAutoRenewal: true
                }
            };
            return type;
        }
        type = {
            type: 'paid',
            licenseType: {
                type: 'subscription',
                renewalType: {
                    isAutoRenewal: true
                }
            }
        };
    }
    return type;
};

});
parcelRegister("9fEFB", function(module, exports) {

$parcel$export(module.exports, "appDetailsLink", () => $6bc50ffb339ccad0$export$2af744f50ccb482a);
$parcel$export(module.exports, "appListingLink", () => $6bc50ffb339ccad0$export$e62f9cc984625834);
$parcel$export(module.exports, "mediaImageLink", () => $6bc50ffb339ccad0$export$b638f7d0a6d44986);
$parcel$export(module.exports, "linkTemplates", () => $6bc50ffb339ccad0$export$9e66cf49300a220c);

var $asbhz = parcelRequire("asbhz");
const $6bc50ffb339ccad0$export$4d75019b4283ecea = function adminHubLink() {
    let adminHubBaseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(adminHubBaseUrl);
};
const $6bc50ffb339ccad0$export$de647789330ef8b6 = function archivePartnerLink() {
    let mpacBaseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse("".concat(mpacBaseUrl, "/archive/vendors/{partnerId}"));
};
const $6bc50ffb339ccad0$export$2af744f50ccb482a = function appDetailsLink() {
    let mpacBaseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse("".concat(mpacBaseUrl, "/plugins/{appKey}/overview"));
};
const $6bc50ffb339ccad0$export$9c10277230abad0d = function appRatingLink() {
    let mpacBaseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(mpacBaseUrl + '/plugins/{appKey}/reviews');
};
const $6bc50ffb339ccad0$export$943308b735a87d70 = function appIconLink() {
    let mpacBaseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(mpacBaseUrl + '/plugins/{appKey}/icon');
};
const $6bc50ffb339ccad0$export$e62f9cc984625834 = function appListingLink() {
    let mpacBaseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse("".concat(mpacBaseUrl, "/apps/{appId}/{slug}?hosting={hosting}&tab={tab}"));
};
const $6bc50ffb339ccad0$export$7902720f9d6d3285 = function archivedAppLink() {
    let mpacBaseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse("".concat(mpacBaseUrl, "/archive/{appId}"));
};
const $6bc50ffb339ccad0$export$c267fb62c4d84d76 = function partnerDetailsLink() {
    let mpacBaseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(mpacBaseUrl + '/vendors/{id}/{slug}');
};
const $6bc50ffb339ccad0$export$b638f7d0a6d44986 = function mediaImageLink() {
    let mpacCdnBaseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(mpacCdnBaseUrl + '/files/{imageId}?fileType=image&mode=full-fit');
};
const $6bc50ffb339ccad0$var$EmptyLinkTemplate = {
    expand: ()=>''
};
const $6bc50ffb339ccad0$export$9e66cf49300a220c = (_ref)=>{
    let { adminHubBaseUrl: adminHubBaseUrl, mpacBaseUrl: mpacBaseUrl, mpacCdnBaseUrl: mpacCdnBaseUrl, macBaseUrl: macBaseUrl, wacBaseUrl: wacBaseUrl, atlassianCommunityBaseUrl: atlassianCommunityBaseUrl } = _ref;
    return {
        adminHub: (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(adminHubBaseUrl),
        marketplaceTermsOfUse: (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(wacBaseUrl + '/licensing/marketplace/termsofuse/'),
        appDetails: $6bc50ffb339ccad0$export$2af744f50ccb482a(mpacBaseUrl),
        appPricingDetails: (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(mpacBaseUrl + '/plugins/{appKey}/pricing'),
        mediaFile: (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(mpacCdnBaseUrl + '/files/{imageId}'),
        mediaImage: $6bc50ffb339ccad0$export$b638f7d0a6d44986(mpacCdnBaseUrl),
        appHostingDetails: (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(mpacBaseUrl + '/plugins/{appKey}/{hosting}/overview'),
        appIcon: $6bc50ffb339ccad0$export$943308b735a87d70(mpacBaseUrl),
        appRating: $6bc50ffb339ccad0$export$9c10277230abad0d(mpacBaseUrl),
        appManageLink: (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(mpacBaseUrl + '/manage/apps/{appId}'),
        appShortLink: (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(mpacBaseUrl + '/{appId}'),
        managePrivateListing: (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(mpacBaseUrl + '/manage/apps/{appId}/private-listings'),
        partnerDetails: $6bc50ffb339ccad0$export$c267fb62c4d84d76(mpacBaseUrl),
        appCreateCommunityQuestionLink: (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse("".concat(atlassianCommunityBaseUrl, "/t5/custom/page/page-id/create-post-step-1?add-tags=atlassian-marketplace,addon-{appKey},{hosting}")),
        appVersionHistory: (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(mpacBaseUrl + '/apps/{appId}/{appSlug}/version-history?versionHistoryHosting={hosting}'),
        artifactDownload: (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(mpacBaseUrl + '/download/apps/{appId}/version/{buildNumber}'),
        descriptorDownload: (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(mpacBaseUrl + '/download/apps/{appId}/version/{buildNumber}/descriptor'),
        appListingCanonical: (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse("".concat(mpacBaseUrl, "/apps/{appId}/{slug}")),
        appListing: $6bc50ffb339ccad0$export$e62f9cc984625834(mpacBaseUrl),
        trialLicenseActivation: macBaseUrl ? (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(macBaseUrl + '/addon/try/{hamsAppKey}') : $6bc50ffb339ccad0$var$EmptyLinkTemplate,
        licensePurchase: wacBaseUrl ? (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(wacBaseUrl + '/purchase/addon/{hamsAppKey}') : $6bc50ffb339ccad0$var$EmptyLinkTemplate
    };
};
const $6bc50ffb339ccad0$export$7c41ce19876991bc = ()=>({
        // Todo - specify return type of manageAppsTabRoutes
        appPricing: (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse('/manage/apps/{appKey}/pricing')
    });
const $6bc50ffb339ccad0$export$2d5f19459b59e72b = (link)=>{
    return /\/apps\/\d+\/[^/]+?/.test(link);
};

});

parcelRegister("iZFTO", function(module, exports) {

$parcel$export(module.exports, "Either", () => $dd3e6cce71afb005$export$37cbe166bfc81b63);
function $dd3e6cce71afb005$export$b24f7407c77e5bd(ref) {
    return !!(ref && typeof ref.equals === "function" && typeof ref.hashCode === "function");
}
function $dd3e6cce71afb005$export$226b3eccf92c9ed9(lh, rh) {
    if (lh === rh || lh !== lh && rh !== rh) return true;
    if (!lh || !rh) return false;
    if (typeof lh.valueOf === "function" && typeof rh.valueOf === "function") {
        var lh2 = lh.valueOf();
        var rh2 = rh.valueOf();
        if (lh2 === rh2 || lh2 !== lh2 && rh2 !== rh2) return true;
        if (!lh2 || !rh2) return false;
    }
    return !!($dd3e6cce71afb005$export$b24f7407c77e5bd(lh) && lh.equals(rh));
}
function $dd3e6cce71afb005$export$e9bab7fafb253603(lh, rh) {
    return $dd3e6cce71afb005$export$226b3eccf92c9ed9(lh, rh);
}
var $dd3e6cce71afb005$export$280f210877e5565b = {
    equals: $dd3e6cce71afb005$export$e9bab7fafb253603
};
function $dd3e6cce71afb005$export$d41d9ab3de2def3d(ref) {
    if (typeof ref === "number") return ref & ref;
    if (typeof ref.valueOf === "function") {
        var v = ref.valueOf();
        if (v !== ref) return $dd3e6cce71afb005$export$d41d9ab3de2def3d(v);
    }
    if ($dd3e6cce71afb005$export$b24f7407c77e5bd(ref)) return ref.hashCode();
    return $dd3e6cce71afb005$export$39e05520a596a3da(String(ref));
}
function $dd3e6cce71afb005$export$39e05520a596a3da(str) {
    var hash = 0;
    if (str == null || str.length === 0) return hash;
    for(var i = 0; i < str.length; i++){
        var character = str.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash;
    }
    return hash;
}
function $dd3e6cce71afb005$export$d560c7e4a29451c2(a) {
    return a;
}
function $dd3e6cce71afb005$export$6ccb92ce135089b4(derivedCtor, baseCtors) {
    baseCtors.forEach(function(baseCtor) {
        Object.getOwnPropertyNames(baseCtor.prototype).forEach(function(name) {
            if (!derivedCtor.prototype[name]) derivedCtor.prototype[name] = baseCtor.prototype[name];
        });
    });
}
var $dd3e6cce71afb005$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $dd3e6cce71afb005$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $dd3e6cce71afb005$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $dd3e6cce71afb005$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $dd3e6cce71afb005$export$6fbeb926bac523c3 = function(_Error) {
    $dd3e6cce71afb005$var$inherits(CompositeError, _Error);
    function CompositeError(errors) {
        $dd3e6cce71afb005$var$classCallCheck(this, CompositeError);
        var reasons = "";
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
            for(var _iterator = errors.slice(0, 2)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var e = _step.value;
                var message = "";
                if (e instanceof Error) message = e.name + "(" + e.message + ")";
                else message = "" + e;
                reasons += ", " + message;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
            } finally{
                if (_didIteratorError) throw _iteratorError;
            }
        }
        reasons = reasons.slice(2);
        if (errors.length > 2) reasons = reasons + ", ...";
        var _this = $dd3e6cce71afb005$var$possibleConstructorReturn(this, (CompositeError.__proto__ || Object.getPrototypeOf(CompositeError)).call(this, reasons));
        _this.name = "CompositeError";
        _this.errorsRef = errors;
        var self = _this;
        self.constructor = CompositeError;
        self.__proto__ = CompositeError.prototype;
        return _this;
    }
    $dd3e6cce71afb005$var$createClass(CompositeError, [
        {
            key: "errors",
            value: function errors() {
                return this.errorsRef.slice();
            }
        }
    ]);
    return CompositeError;
}(Error);
var $dd3e6cce71afb005$export$4a48f57740b5ad1e = function(_Error2) {
    $dd3e6cce71afb005$var$inherits(DummyError, _Error2);
    function DummyError(message) {
        $dd3e6cce71afb005$var$classCallCheck(this, DummyError);
        var _this2 = $dd3e6cce71afb005$var$possibleConstructorReturn(this, (DummyError.__proto__ || Object.getPrototypeOf(DummyError)).call(this, message));
        _this2.name = "DummyError";
        var self = _this2;
        self.constructor = DummyError;
        self.__proto__ = DummyError.prototype;
        return _this2;
    }
    return DummyError;
}(Error);
var $dd3e6cce71afb005$export$48d368d160387990 = function(_Error3) {
    $dd3e6cce71afb005$var$inherits(NoSuchElementError, _Error3);
    function NoSuchElementError(message) {
        $dd3e6cce71afb005$var$classCallCheck(this, NoSuchElementError);
        var _this3 = $dd3e6cce71afb005$var$possibleConstructorReturn(this, (NoSuchElementError.__proto__ || Object.getPrototypeOf(NoSuchElementError)).call(this, message));
        _this3.name = "NoSuchElementError";
        var self = _this3;
        self.constructor = NoSuchElementError;
        self.__proto__ = NoSuchElementError.prototype;
        return _this3;
    }
    return NoSuchElementError;
}(Error);
var $dd3e6cce71afb005$export$e6c18cacaad31d56 = function(_Error4) {
    $dd3e6cce71afb005$var$inherits(IllegalInheritanceError, _Error4);
    function IllegalInheritanceError(message) {
        $dd3e6cce71afb005$var$classCallCheck(this, IllegalInheritanceError);
        var _this4 = $dd3e6cce71afb005$var$possibleConstructorReturn(this, (IllegalInheritanceError.__proto__ || Object.getPrototypeOf(IllegalInheritanceError)).call(this, message));
        _this4.name = "IllegalInheritanceError";
        var self = _this4;
        self.constructor = IllegalInheritanceError;
        self.__proto__ = IllegalInheritanceError.prototype;
        return _this4;
    }
    return IllegalInheritanceError;
}(Error);
var $dd3e6cce71afb005$export$25b19446f82d7080 = function(_Error5) {
    $dd3e6cce71afb005$var$inherits(IllegalStateError, _Error5);
    function IllegalStateError(message) {
        $dd3e6cce71afb005$var$classCallCheck(this, IllegalStateError);
        var _this5 = $dd3e6cce71afb005$var$possibleConstructorReturn(this, (IllegalStateError.__proto__ || Object.getPrototypeOf(IllegalStateError)).call(this, message));
        _this5.name = "IllegalStateError";
        var self = _this5;
        self.constructor = IllegalStateError;
        self.__proto__ = IllegalStateError.prototype;
        return _this5;
    }
    return IllegalStateError;
}(Error);
var $dd3e6cce71afb005$export$10a4c2bfc9c71dbd = function(_Error6) {
    $dd3e6cce71afb005$var$inherits(IllegalArgumentError, _Error6);
    function IllegalArgumentError(message) {
        $dd3e6cce71afb005$var$classCallCheck(this, IllegalArgumentError);
        var _this6 = $dd3e6cce71afb005$var$possibleConstructorReturn(this, (IllegalArgumentError.__proto__ || Object.getPrototypeOf(IllegalArgumentError)).call(this, message));
        _this6.name = "IllegalArgumentError";
        var self = _this6;
        self.constructor = IllegalArgumentError;
        self.__proto__ = IllegalArgumentError.prototype;
        return _this6;
    }
    return IllegalArgumentError;
}(Error);
var $dd3e6cce71afb005$export$e162153238934121 = function(_Error7) {
    $dd3e6cce71afb005$var$inherits(NotImplementedError, _Error7);
    function NotImplementedError(message) {
        $dd3e6cce71afb005$var$classCallCheck(this, NotImplementedError);
        var _this7 = $dd3e6cce71afb005$var$possibleConstructorReturn(this, (NotImplementedError.__proto__ || Object.getPrototypeOf(NotImplementedError)).call(this, message));
        _this7.name = "NotImplementedError";
        var self = _this7;
        self.constructor = NotImplementedError;
        self.__proto__ = NotImplementedError.prototype;
        return _this7;
    }
    return NotImplementedError;
}(Error);
var $dd3e6cce71afb005$export$66d311bf29d5c89c = function(_Error8) {
    $dd3e6cce71afb005$var$inherits(TimeoutError, _Error8);
    function TimeoutError(message) {
        $dd3e6cce71afb005$var$classCallCheck(this, TimeoutError);
        var _this8 = $dd3e6cce71afb005$var$possibleConstructorReturn(this, (TimeoutError.__proto__ || Object.getPrototypeOf(TimeoutError)).call(this, message));
        _this8.name = "TimeoutError";
        var self = _this8;
        self.constructor = TimeoutError;
        self.__proto__ = TimeoutError.prototype;
        return _this8;
    }
    return TimeoutError;
}(Error);
function $dd3e6cce71afb005$var$convertToMethod(f) {
    return function() {
        var args = Array.prototype.slice.call(arguments);
        args.push(this);
        return f.apply(undefined, args);
    };
}
function $dd3e6cce71afb005$var$fantasyLandRegister(cls, monad, setoid) {
    var c = cls;
    var p = c.prototype;
    var fl = "fantasy-land/";
    var equals = "equals";
    var flEquals = fl + equals;
    var map = "map";
    var flMap = fl + map;
    var ap = "ap";
    var flAp = fl + ap;
    var flOf = fl + "of";
    var chain = "chain";
    var flChain = fl + chain;
    var chainRec = "chainRec";
    var flChainRec = fl + chainRec;
    if (p[equals]) p[flEquals] = p[equals];
    else if (setoid) p[flEquals] = $dd3e6cce71afb005$var$convertToMethod(setoid.equals);
    if (p[map]) p[flMap] = p[map];
    else if (monad) p[flMap] = $dd3e6cce71afb005$var$convertToMethod(monad.map);
    if (p[ap]) p[flAp] = p[ap];
    else if (monad) p[flAp] = $dd3e6cce71afb005$var$convertToMethod(monad.ap);
    if (c["pure"]) c[flOf] = c["pure"];
    else if (monad) c[flOf] = monad.of;
    if (p[chain]) p[flChain] = p[chain];
    else if (monad) p[flChain] = $dd3e6cce71afb005$var$convertToMethod(monad.chain);
    if (c[chainRec]) c[flChainRec] = c[chainRec];
    else if (monad) c[flChainRec] = monad.chainRec;
}
var $dd3e6cce71afb005$export$37fdcdf447590763 = Object.freeze({
    convertToMethod: $dd3e6cce71afb005$var$convertToMethod,
    fantasyLandRegister: $dd3e6cce71afb005$var$fantasyLandRegister
});
var $dd3e6cce71afb005$export$37cbe166bfc81b63 = function() {
    function Either(value, tag) {
        $dd3e6cce71afb005$var$classCallCheck(this, Either);
        this._isRight = tag === "right";
        this.value = value;
    }
    $dd3e6cce71afb005$var$createClass(Either, [
        {
            key: "isLeft",
            value: function isLeft() {
                return !this._isRight;
            }
        },
        {
            key: "isRight",
            value: function isRight() {
                return this._isRight;
            }
        },
        {
            key: "contains",
            value: function contains(elem) {
                return this._isRight && $dd3e6cce71afb005$export$226b3eccf92c9ed9(this.value, elem);
            }
        },
        {
            key: "exists",
            value: function exists(p) {
                return this._isRight && p(this.value);
            }
        },
        {
            key: "filterOrElse",
            value: function filterOrElse(p, zero) {
                return this._isRight ? p(this.value) ? this : $dd3e6cce71afb005$export$37c4d04eafdc5515(zero()) : this;
            }
        },
        {
            key: "flatMap",
            value: function flatMap(f) {
                return this._isRight ? f(this.value) : this;
            }
        },
        {
            key: "chain",
            value: function chain(f) {
                return this.flatMap(f);
            }
        },
        {
            key: "ap",
            value: function ap(ff) {
                var _this = this;
                return ff.flatMap(function(f) {
                    return _this.map(f);
                });
            }
        },
        {
            key: "fold",
            value: function fold(left, right) {
                return this._isRight ? right(this.value) : left(this.value);
            }
        },
        {
            key: "forAll",
            value: function forAll(p) {
                return !this._isRight || p(this.value);
            }
        },
        {
            key: "get",
            value: function get$$1() {
                if (this._isRight) return this.value;
                throw new $dd3e6cce71afb005$export$48d368d160387990("left.get()");
            }
        },
        {
            key: "getOrElse",
            value: function getOrElse(fallback) {
                return this._isRight ? this.value : fallback;
            }
        },
        {
            key: "getOrElseL",
            value: function getOrElseL(thunk) {
                return this._isRight ? this.value : thunk();
            }
        },
        {
            key: "map",
            value: function map(f) {
                return this._isRight ? $dd3e6cce71afb005$export$19db0165690c701a(f(this.value)) : this;
            }
        },
        {
            key: "forEach",
            value: function forEach(cb) {
                if (this._isRight) cb(this.value);
            }
        },
        {
            key: "swap",
            value: function swap() {
                return this._isRight ? $dd3e6cce71afb005$export$37c4d04eafdc5515(this.value) : $dd3e6cce71afb005$export$19db0165690c701a(this.value);
            }
        },
        {
            key: "toOption",
            value: function toOption() {
                return this._isRight ? $dd3e6cce71afb005$export$9f9d0139d032da4f(this.value) : $dd3e6cce71afb005$export$57ca7e07b341709d;
            }
        },
        {
            key: "equals",
            value: function equals$$1(that) {
                if (that == null) return false;
                return this._isRight === that._isRight && $dd3e6cce71afb005$export$226b3eccf92c9ed9(this.value, that.value);
            }
        },
        {
            key: "hashCode",
            value: function hashCode$$1() {
                return this._isRight ? $dd3e6cce71afb005$export$d41d9ab3de2def3d(this.value) << 2 : $dd3e6cce71afb005$export$d41d9ab3de2def3d(this.value) << 3;
            }
        }
    ], [
        {
            key: "pure",
            value: function pure(value) {
                return new $dd3e6cce71afb005$export$8cd6fcff08338c9a(value);
            }
        },
        {
            key: "left",
            value: function left(value) {
                return $dd3e6cce71afb005$export$37c4d04eafdc5515(value);
            }
        },
        {
            key: "right",
            value: function right(value) {
                return $dd3e6cce71afb005$export$19db0165690c701a(value);
            }
        },
        {
            key: "map2",
            value: function map2(fa1, fa2, f) {
                if (fa1.isLeft()) return fa1;
                if (fa2.isLeft()) return fa2;
                return $dd3e6cce71afb005$export$19db0165690c701a(f(fa1.value, fa2.value));
            }
        },
        {
            key: "map3",
            value: function map3(fa1, fa2, fa3, f) {
                if (fa1.isLeft()) return fa1;
                if (fa2.isLeft()) return fa2;
                if (fa3.isLeft()) return fa3;
                return $dd3e6cce71afb005$export$19db0165690c701a(f(fa1.value, fa2.value, fa3.value));
            }
        },
        {
            key: "map4",
            value: function map4(fa1, fa2, fa3, fa4, f) {
                if (fa1.isLeft()) return fa1;
                if (fa2.isLeft()) return fa2;
                if (fa3.isLeft()) return fa3;
                if (fa4.isLeft()) return fa4;
                return $dd3e6cce71afb005$export$19db0165690c701a(f(fa1.value, fa2.value, fa3.value, fa4.value));
            }
        },
        {
            key: "map5",
            value: function map5(fa1, fa2, fa3, fa4, fa5, f) {
                if (fa1.isLeft()) return fa1;
                if (fa2.isLeft()) return fa2;
                if (fa3.isLeft()) return fa3;
                if (fa4.isLeft()) return fa4;
                if (fa5.isLeft()) return fa5;
                return $dd3e6cce71afb005$export$19db0165690c701a(f(fa1.value, fa2.value, fa3.value, fa4.value, fa5.value));
            }
        },
        {
            key: "map6",
            value: function map6(fa1, fa2, fa3, fa4, fa5, fa6, f) {
                if (fa1.isLeft()) return fa1;
                if (fa2.isLeft()) return fa2;
                if (fa3.isLeft()) return fa3;
                if (fa4.isLeft()) return fa4;
                if (fa5.isLeft()) return fa5;
                if (fa6.isLeft()) return fa6;
                return $dd3e6cce71afb005$export$19db0165690c701a(f(fa1.value, fa2.value, fa3.value, fa4.value, fa5.value, fa6.value));
            }
        },
        {
            key: "tailRecM",
            value: function tailRecM(a, f) {
                var cursor = a;
                while(true){
                    var result = f(cursor);
                    if (!result.isRight()) return result;
                    var some = result.value;
                    if (some.isRight()) return $dd3e6cce71afb005$export$19db0165690c701a(some.value);
                    cursor = some.value;
                }
            }
        }
    ]);
    return Either;
}();
var $dd3e6cce71afb005$export$500560ce56dda718 = function(_Either) {
    $dd3e6cce71afb005$var$inherits(TLeft, _Either);
    function TLeft(value) {
        $dd3e6cce71afb005$var$classCallCheck(this, TLeft);
        return $dd3e6cce71afb005$var$possibleConstructorReturn(this, (TLeft.__proto__ || Object.getPrototypeOf(TLeft)).call(this, value, "left"));
    }
    return TLeft;
}($dd3e6cce71afb005$export$37cbe166bfc81b63);
function $dd3e6cce71afb005$export$37c4d04eafdc5515(value) {
    return new $dd3e6cce71afb005$export$500560ce56dda718(value);
}
var $dd3e6cce71afb005$export$8cd6fcff08338c9a = function(_Either2) {
    $dd3e6cce71afb005$var$inherits(TRight, _Either2);
    function TRight(value) {
        $dd3e6cce71afb005$var$classCallCheck(this, TRight);
        return $dd3e6cce71afb005$var$possibleConstructorReturn(this, (TRight.__proto__ || Object.getPrototypeOf(TRight)).call(this, value, "right"));
    }
    return TRight;
}($dd3e6cce71afb005$export$37cbe166bfc81b63);
function $dd3e6cce71afb005$export$19db0165690c701a(value) {
    return new $dd3e6cce71afb005$export$8cd6fcff08338c9a(value);
}
var $dd3e6cce71afb005$export$e772b5f99e4d377d = {
    equals: function equals$$1(x, y) {
        return x ? x.equals(y) : !y;
    },
    map: function map(f, fa) {
        return fa.map(f);
    },
    ap: function ap(ff, fa) {
        return fa.ap(ff);
    },
    of: $dd3e6cce71afb005$export$37cbe166bfc81b63.pure,
    chain: function chain(f, fa) {
        return fa.flatMap(f);
    },
    chainRec: function chainRec(f, a) {
        return $dd3e6cce71afb005$export$37cbe166bfc81b63.tailRecM(a, function(a) {
            return f($dd3e6cce71afb005$export$37cbe166bfc81b63.left, $dd3e6cce71afb005$export$37cbe166bfc81b63.right, a);
        });
    }
};
$dd3e6cce71afb005$var$fantasyLandRegister($dd3e6cce71afb005$export$37cbe166bfc81b63, $dd3e6cce71afb005$export$e772b5f99e4d377d, $dd3e6cce71afb005$export$e772b5f99e4d377d);
var $dd3e6cce71afb005$export$36d18380658d5d20 = function() {
    function Option(ref, isEmpty) {
        $dd3e6cce71afb005$var$classCallCheck(this, Option);
        this._isEmpty = isEmpty != null ? isEmpty : ref === null || ref === undefined;
        this.value = ref;
    }
    $dd3e6cce71afb005$var$createClass(Option, [
        {
            key: "get",
            value: function get$$1() {
                if (!this._isEmpty) return this.value;
                throw new $dd3e6cce71afb005$export$48d368d160387990("Option.get");
            }
        },
        {
            key: "getOrElse",
            value: function getOrElse(fallback) {
                if (!this._isEmpty) return this.value;
                else return fallback;
            }
        },
        {
            key: "orNull",
            value: function orNull() {
                return !this._isEmpty ? this.value : null;
            }
        },
        {
            key: "orUndefined",
            value: function orUndefined() {
                return !this._isEmpty ? this.value : undefined;
            }
        },
        {
            key: "getOrElseL",
            value: function getOrElseL(thunk) {
                if (!this._isEmpty) return this.value;
                else return thunk();
            }
        },
        {
            key: "orElse",
            value: function orElse(fallback) {
                if (!this._isEmpty) return this;
                else return fallback;
            }
        },
        {
            key: "orElseL",
            value: function orElseL(thunk) {
                if (!this._isEmpty) return this;
                else return thunk();
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this._isEmpty;
            }
        },
        {
            key: "nonEmpty",
            value: function nonEmpty() {
                return !this._isEmpty;
            }
        },
        {
            key: "map",
            value: function map(f) {
                return this._isEmpty ? $dd3e6cce71afb005$export$57ca7e07b341709d : $dd3e6cce71afb005$export$9f9d0139d032da4f(f(this.value));
            }
        },
        {
            key: "flatMap",
            value: function flatMap(f) {
                if (this._isEmpty) return $dd3e6cce71afb005$export$57ca7e07b341709d;
                else return f(this.value);
            }
        },
        {
            key: "chain",
            value: function chain(f) {
                return this.flatMap(f);
            }
        },
        {
            key: "ap",
            value: function ap(ff) {
                var _this4 = this;
                return ff.flatMap(function(f) {
                    return _this4.map(f);
                });
            }
        },
        {
            key: "filter",
            value: function filter(p) {
                if (this._isEmpty || !p(this.value)) return $dd3e6cce71afb005$export$57ca7e07b341709d;
                else return this;
            }
        },
        {
            key: "fold",
            value: function fold(fallback, f) {
                if (this._isEmpty) return fallback();
                return f(this.value);
            }
        },
        {
            key: "contains",
            value: function contains(elem) {
                return !this._isEmpty && $dd3e6cce71afb005$export$226b3eccf92c9ed9(this.value, elem);
            }
        },
        {
            key: "exists",
            value: function exists(p) {
                return !this._isEmpty && p(this.value);
            }
        },
        {
            key: "forAll",
            value: function forAll(p) {
                return this._isEmpty || p(this.value);
            }
        },
        {
            key: "forEach",
            value: function forEach(cb) {
                if (!this._isEmpty) cb(this.value);
            }
        },
        {
            key: "equals",
            value: function equals$$1(that) {
                if (that == null) return false;
                if (this.nonEmpty() && that.nonEmpty()) return $dd3e6cce71afb005$export$226b3eccf92c9ed9(this.value, that.value);
                return this.isEmpty() && that.isEmpty();
            }
        },
        {
            key: "hashCode",
            value: function hashCode$$1() {
                if (this._isEmpty) return 2433880;
                else if (this.value == null) return 9735524;
                else return $dd3e6cce71afb005$export$d41d9ab3de2def3d(this.value) << 2;
            }
        }
    ], [
        {
            key: "of",
            value: function of(value) {
                return value != null ? $dd3e6cce71afb005$export$9f9d0139d032da4f(value) : $dd3e6cce71afb005$export$57ca7e07b341709d;
            }
        },
        {
            key: "some",
            value: function some(value) {
                return new Option(value, false);
            }
        },
        {
            key: "none",
            value: function none() {
                return $dd3e6cce71afb005$export$57ca7e07b341709d;
            }
        },
        {
            key: "empty",
            value: function empty() {
                return $dd3e6cce71afb005$export$57ca7e07b341709d;
            }
        },
        {
            key: "pure",
            value: function pure(value) {
                return $dd3e6cce71afb005$export$9f9d0139d032da4f(value);
            }
        },
        {
            key: "map2",
            value: function map2(fa1, fa2, f) {
                return fa1.nonEmpty() && fa2.nonEmpty() ? $dd3e6cce71afb005$export$9f9d0139d032da4f(f(fa1.value, fa2.value)) : $dd3e6cce71afb005$export$57ca7e07b341709d;
            }
        },
        {
            key: "map3",
            value: function map3(fa1, fa2, fa3, f) {
                return fa1.nonEmpty() && fa2.nonEmpty() && fa3.nonEmpty() ? $dd3e6cce71afb005$export$9f9d0139d032da4f(f(fa1.value, fa2.value, fa3.value)) : $dd3e6cce71afb005$export$57ca7e07b341709d;
            }
        },
        {
            key: "map4",
            value: function map4(fa1, fa2, fa3, fa4, f) {
                return fa1.nonEmpty() && fa2.nonEmpty() && fa3.nonEmpty() && fa4.nonEmpty() ? $dd3e6cce71afb005$export$9f9d0139d032da4f(f(fa1.value, fa2.value, fa3.value, fa4.value)) : $dd3e6cce71afb005$export$57ca7e07b341709d;
            }
        },
        {
            key: "map5",
            value: function map5(fa1, fa2, fa3, fa4, fa5, f) {
                return fa1.nonEmpty() && fa2.nonEmpty() && fa3.nonEmpty() && fa4.nonEmpty() && fa5.nonEmpty() ? $dd3e6cce71afb005$export$9f9d0139d032da4f(f(fa1.value, fa2.value, fa3.value, fa4.value, fa5.value)) : $dd3e6cce71afb005$export$57ca7e07b341709d;
            }
        },
        {
            key: "map6",
            value: function map6(fa1, fa2, fa3, fa4, fa5, fa6, f) {
                return fa1.nonEmpty() && fa2.nonEmpty() && fa3.nonEmpty() && fa4.nonEmpty() && fa5.nonEmpty() && fa6.nonEmpty() ? $dd3e6cce71afb005$export$9f9d0139d032da4f(f(fa1.value, fa2.value, fa3.value, fa4.value, fa5.value, fa6.value)) : $dd3e6cce71afb005$export$57ca7e07b341709d;
            }
        },
        {
            key: "tailRecM",
            value: function tailRecM(a, f) {
                var cursor = a;
                while(true){
                    var result = f(cursor);
                    if (result.nonEmpty()) {
                        var some = result.value;
                        if (some.isRight()) return $dd3e6cce71afb005$export$9f9d0139d032da4f(some.value);
                        cursor = some.value;
                    } else return $dd3e6cce71afb005$export$57ca7e07b341709d;
                }
            }
        }
    ]);
    return Option;
}();
var $dd3e6cce71afb005$export$c279cda0429c6dbe = function(_Option) {
    $dd3e6cce71afb005$var$inherits(TSome, _Option);
    function TSome(value) {
        $dd3e6cce71afb005$var$classCallCheck(this, TSome);
        return $dd3e6cce71afb005$var$possibleConstructorReturn(this, (TSome.__proto__ || Object.getPrototypeOf(TSome)).call(this, value, false));
    }
    return TSome;
}($dd3e6cce71afb005$export$36d18380658d5d20);
function $dd3e6cce71afb005$export$9f9d0139d032da4f(value) {
    return new $dd3e6cce71afb005$export$c279cda0429c6dbe(value);
}
var $dd3e6cce71afb005$export$ee2288f2b4bc04c4 = function(_Option2) {
    $dd3e6cce71afb005$var$inherits(TNone, _Option2);
    function TNone() {
        $dd3e6cce71afb005$var$classCallCheck(this, TNone);
        return $dd3e6cce71afb005$var$possibleConstructorReturn(this, (TNone.__proto__ || Object.getPrototypeOf(TNone)).call(this, undefined, true));
    }
    return TNone;
}($dd3e6cce71afb005$export$36d18380658d5d20);
var $dd3e6cce71afb005$export$57ca7e07b341709d = new $dd3e6cce71afb005$export$ee2288f2b4bc04c4();
var $dd3e6cce71afb005$export$dae05fd938c910bc = {
    equals: function equals$$1(x, y) {
        return x ? x.equals(y) : !y;
    },
    map: function map(f, fa) {
        return fa.map(f);
    },
    ap: function ap(ff, fa) {
        return fa.ap(ff);
    },
    of: $dd3e6cce71afb005$export$36d18380658d5d20.pure,
    chain: function chain(f, fa) {
        return fa.flatMap(f);
    },
    chainRec: function chainRec(f, a) {
        return $dd3e6cce71afb005$export$36d18380658d5d20.tailRecM(a, function(a) {
            return f($dd3e6cce71afb005$export$37cbe166bfc81b63.left, $dd3e6cce71afb005$export$37cbe166bfc81b63.right, a);
        });
    }
};
$dd3e6cce71afb005$var$fantasyLandRegister($dd3e6cce71afb005$export$36d18380658d5d20, $dd3e6cce71afb005$export$dae05fd938c910bc, $dd3e6cce71afb005$export$dae05fd938c910bc);
var $dd3e6cce71afb005$export$fa957d01b0310fd7 = function() {
    function Try(value, tag) {
        $dd3e6cce71afb005$var$classCallCheck(this, Try);
        this._isSuccess = tag === "success";
        this.value = value;
    }
    $dd3e6cce71afb005$var$createClass(Try, [
        {
            key: "isSuccess",
            value: function isSuccess() {
                return this._isSuccess;
            }
        },
        {
            key: "isFailure",
            value: function isFailure() {
                return !this._isSuccess;
            }
        },
        {
            key: "get",
            value: function get$$1() {
                if (!this._isSuccess) throw this.value;
                return this.value;
            }
        },
        {
            key: "getOrElse",
            value: function getOrElse(fallback) {
                return this._isSuccess ? this.value : fallback;
            }
        },
        {
            key: "getOrElseL",
            value: function getOrElseL(thunk) {
                return this._isSuccess ? this.value : thunk();
            }
        },
        {
            key: "orNull",
            value: function orNull() {
                return this._isSuccess ? this.value : null;
            }
        },
        {
            key: "orUndefined",
            value: function orUndefined() {
                return this._isSuccess ? this.value : undefined;
            }
        },
        {
            key: "orElse",
            value: function orElse(fallback) {
                if (this._isSuccess) return this;
                return fallback;
            }
        },
        {
            key: "orElseL",
            value: function orElseL(thunk) {
                if (this._isSuccess) return this;
                return thunk();
            }
        },
        {
            key: "failed",
            value: function failed() {
                return this._isSuccess ? $dd3e6cce71afb005$export$5ebc9a4af3ac0850(new $dd3e6cce71afb005$export$48d368d160387990("try.failed()")) : $dd3e6cce71afb005$export$ffa3d9fee6fd705a(this.value);
            }
        },
        {
            key: "fold",
            value: function fold(failure, success) {
                return this._isSuccess ? success(this.value) : failure(this.value);
            }
        },
        {
            key: "filter",
            value: function filter(p) {
                if (!this._isSuccess) return this;
                try {
                    if (p(this.value)) return this;
                    return $dd3e6cce71afb005$export$5ebc9a4af3ac0850(new $dd3e6cce71afb005$export$48d368d160387990("Predicate does not hold for " + this.value));
                } catch (e) {
                    return $dd3e6cce71afb005$export$5ebc9a4af3ac0850(e);
                }
            }
        },
        {
            key: "flatMap",
            value: function flatMap(f) {
                if (!this._isSuccess) return this;
                try {
                    return f(this.value);
                } catch (e) {
                    return $dd3e6cce71afb005$export$5ebc9a4af3ac0850(e);
                }
            }
        },
        {
            key: "chain",
            value: function chain(f) {
                return this.flatMap(f);
            }
        },
        {
            key: "ap",
            value: function ap(ff) {
                var _this7 = this;
                return ff.flatMap(function(f) {
                    return _this7.map(f);
                });
            }
        },
        {
            key: "map",
            value: function map(f) {
                var _this8 = this;
                return this._isSuccess ? Try.of(function() {
                    return f(_this8.value);
                }) : this;
            }
        },
        {
            key: "forEach",
            value: function forEach(cb) {
                if (this._isSuccess) cb(this.value);
            }
        },
        {
            key: "recover",
            value: function recover(f) {
                var _this9 = this;
                return this._isSuccess ? this : Try.of(function() {
                    return f(_this9.value);
                });
            }
        },
        {
            key: "recoverWith",
            value: function recoverWith(f) {
                try {
                    return this._isSuccess ? this : f(this.value);
                } catch (e) {
                    return $dd3e6cce71afb005$export$5ebc9a4af3ac0850(e);
                }
            }
        },
        {
            key: "toOption",
            value: function toOption() {
                return this._isSuccess ? $dd3e6cce71afb005$export$9f9d0139d032da4f(this.value) : $dd3e6cce71afb005$export$57ca7e07b341709d;
            }
        },
        {
            key: "toEither",
            value: function toEither() {
                return this._isSuccess ? $dd3e6cce71afb005$export$19db0165690c701a(this.value) : $dd3e6cce71afb005$export$37c4d04eafdc5515(this.value);
            }
        },
        {
            key: "equals",
            value: function equals$$1(that) {
                if (that == null) return false;
                return this._isSuccess ? that._isSuccess && $dd3e6cce71afb005$export$226b3eccf92c9ed9(this.value, that.value) : !that._isSuccess && $dd3e6cce71afb005$export$226b3eccf92c9ed9(this.value, that.value);
            }
        },
        {
            key: "hashCode",
            value: function hashCode$$1() {
                return this._isSuccess ? $dd3e6cce71afb005$export$d41d9ab3de2def3d(this.value) : $dd3e6cce71afb005$export$d41d9ab3de2def3d(this.value);
            }
        }
    ], [
        {
            key: "of",
            value: function of(thunk) {
                try {
                    return $dd3e6cce71afb005$export$ffa3d9fee6fd705a(thunk());
                } catch (e) {
                    return $dd3e6cce71afb005$export$5ebc9a4af3ac0850(e);
                }
            }
        },
        {
            key: "pure",
            value: function pure(value) {
                return Try.success(value);
            }
        },
        {
            key: "unit",
            value: function unit() {
                return $dd3e6cce71afb005$var$tryUnitRef;
            }
        },
        {
            key: "success",
            value: function success(value) {
                return $dd3e6cce71afb005$export$ffa3d9fee6fd705a(value);
            }
        },
        {
            key: "failure",
            value: function failure(e) {
                return $dd3e6cce71afb005$export$5ebc9a4af3ac0850(e);
            }
        },
        {
            key: "raise",
            value: function raise(e) {
                return $dd3e6cce71afb005$export$5ebc9a4af3ac0850(e);
            }
        },
        {
            key: "map2",
            value: function map2(fa1, fa2, f) {
                if (fa1.isFailure()) return fa1;
                if (fa2.isFailure()) return fa2;
                try {
                    return $dd3e6cce71afb005$export$ffa3d9fee6fd705a(f(fa1.value, fa2.value));
                } catch (e) {
                    return $dd3e6cce71afb005$export$5ebc9a4af3ac0850(e);
                }
            }
        },
        {
            key: "map3",
            value: function map3(fa1, fa2, fa3, f) {
                if (fa1.isFailure()) return fa1;
                if (fa2.isFailure()) return fa2;
                if (fa3.isFailure()) return fa3;
                try {
                    return $dd3e6cce71afb005$export$ffa3d9fee6fd705a(f(fa1.value, fa2.value, fa3.value));
                } catch (e) {
                    return $dd3e6cce71afb005$export$5ebc9a4af3ac0850(e);
                }
            }
        },
        {
            key: "map4",
            value: function map4(fa1, fa2, fa3, fa4, f) {
                if (fa1.isFailure()) return fa1;
                if (fa2.isFailure()) return fa2;
                if (fa3.isFailure()) return fa3;
                if (fa4.isFailure()) return fa4;
                try {
                    return $dd3e6cce71afb005$export$ffa3d9fee6fd705a(f(fa1.value, fa2.value, fa3.value, fa4.value));
                } catch (e) {
                    return $dd3e6cce71afb005$export$5ebc9a4af3ac0850(e);
                }
            }
        },
        {
            key: "map5",
            value: function map5(fa1, fa2, fa3, fa4, fa5, f) {
                if (fa1.isFailure()) return fa1;
                if (fa2.isFailure()) return fa2;
                if (fa3.isFailure()) return fa3;
                if (fa4.isFailure()) return fa4;
                if (fa5.isFailure()) return fa5;
                try {
                    return $dd3e6cce71afb005$export$ffa3d9fee6fd705a(f(fa1.value, fa2.value, fa3.value, fa4.value, fa5.value));
                } catch (e) {
                    return $dd3e6cce71afb005$export$5ebc9a4af3ac0850(e);
                }
            }
        },
        {
            key: "map6",
            value: function map6(fa1, fa2, fa3, fa4, fa5, fa6, f) {
                if (fa1.isFailure()) return fa1;
                if (fa2.isFailure()) return fa2;
                if (fa3.isFailure()) return fa3;
                if (fa4.isFailure()) return fa4;
                if (fa5.isFailure()) return fa5;
                if (fa6.isFailure()) return fa6;
                try {
                    return $dd3e6cce71afb005$export$ffa3d9fee6fd705a(f(fa1.value, fa2.value, fa3.value, fa4.value, fa5.value, fa6.value));
                } catch (e) {
                    return $dd3e6cce71afb005$export$5ebc9a4af3ac0850(e);
                }
            }
        },
        {
            key: "tailRecM",
            value: function tailRecM(a, f) {
                var cursor = a;
                while(true)try {
                    var result = f(cursor);
                    if (result.isFailure()) return result;
                    var some = result.get();
                    if (some.isRight()) return $dd3e6cce71afb005$export$ffa3d9fee6fd705a(some.value);
                    cursor = some.value;
                } catch (e) {
                    return $dd3e6cce71afb005$export$5ebc9a4af3ac0850(e);
                }
            }
        }
    ]);
    return Try;
}();
var $dd3e6cce71afb005$export$a78bea8ed2ae2fde = function(_Try) {
    $dd3e6cce71afb005$var$inherits(TSuccess, _Try);
    function TSuccess(value) {
        $dd3e6cce71afb005$var$classCallCheck(this, TSuccess);
        return $dd3e6cce71afb005$var$possibleConstructorReturn(this, (TSuccess.__proto__ || Object.getPrototypeOf(TSuccess)).call(this, value, "success"));
    }
    return TSuccess;
}($dd3e6cce71afb005$export$fa957d01b0310fd7);
function $dd3e6cce71afb005$export$ffa3d9fee6fd705a(value) {
    return new $dd3e6cce71afb005$export$a78bea8ed2ae2fde(value);
}
var $dd3e6cce71afb005$export$a432f16a0795683f = function(_Try2) {
    $dd3e6cce71afb005$var$inherits(TFailure, _Try2);
    function TFailure(value) {
        $dd3e6cce71afb005$var$classCallCheck(this, TFailure);
        return $dd3e6cce71afb005$var$possibleConstructorReturn(this, (TFailure.__proto__ || Object.getPrototypeOf(TFailure)).call(this, value, "failure"));
    }
    return TFailure;
}($dd3e6cce71afb005$export$fa957d01b0310fd7);
function $dd3e6cce71afb005$export$5ebc9a4af3ac0850(e) {
    return new $dd3e6cce71afb005$export$a432f16a0795683f(e);
}
var $dd3e6cce71afb005$export$93cc75c33014d88a = {
    equals: function equals$$1(x, y) {
        return x ? x.equals(y) : !y;
    },
    map: function map(f, fa) {
        return fa.map(f);
    },
    ap: function ap(ff, fa) {
        return fa.ap(ff);
    },
    of: $dd3e6cce71afb005$export$fa957d01b0310fd7.pure,
    chain: function chain(f, fa) {
        return fa.flatMap(f);
    },
    chainRec: function chainRec(f, a) {
        return $dd3e6cce71afb005$export$fa957d01b0310fd7.tailRecM(a, function(a) {
            return f($dd3e6cce71afb005$export$37cbe166bfc81b63.left, $dd3e6cce71afb005$export$37cbe166bfc81b63.right, a);
        });
    }
};
$dd3e6cce71afb005$var$fantasyLandRegister($dd3e6cce71afb005$export$fa957d01b0310fd7, $dd3e6cce71afb005$export$93cc75c33014d88a, $dd3e6cce71afb005$export$93cc75c33014d88a);
var $dd3e6cce71afb005$var$tryUnitRef = $dd3e6cce71afb005$export$ffa3d9fee6fd705a(undefined);

});

parcelRegister("dx2bt", function(module, exports) {

$parcel$export(module.exports, "supports", () => $9da00d21ad2c1ecb$export$cde6a56f9669daf6);
$parcel$export(module.exports, "REMOTE_INSTALL_JSON", () => $9da00d21ad2c1ecb$export$e74094f901f05524);
$parcel$export(module.exports, "INSTALL_COMPLETE_JSON", () => $9da00d21ad2c1ecb$export$79b565e847152e77);
const $9da00d21ad2c1ecb$export$cde6a56f9669daf6 = {
    context: false,
    accessToken: false,
    enabled: false
};
const $9da00d21ad2c1ecb$export$e74094f901f05524 = 'application/vnd.atl.plugins.remote.install+json';
const $9da00d21ad2c1ecb$export$79b565e847152e77 = 'application/vnd.atl.plugins.install.complete+json';

});

parcelRegister("c0juV", function(module, exports) {

$parcel$export(module.exports, "foldPaymentModel", () => $8bd49bfafd6cd548$export$78cb43db1b1a42b1);
$parcel$export(module.exports, "makeAppKey", () => $8bd49bfafd6cd548$export$a7c7d13152440f84);

var $gC8Po = parcelRequire("gC8Po");
const $8bd49bfafd6cd548$export$78cb43db1b1a42b1 = (p)=>(free, atlassian, vendor)=>{
        switch(p){
            case 'PAID_VIA_ATLASSIAN':
                return atlassian();
            case 'FREE':
                return free();
            case 'PAID_VIA_PARTNER':
                return vendor();
            default:
                throw (0, $gC8Po.default).unexpectedCase(p);
        }
    };
function $8bd49bfafd6cd548$export$a7c7d13152440f84(key) {
    return key;
}

});


parcelRegister("axFWr", function(module, exports) {

$parcel$export(module.exports, "toEcosystemCloudInstallableAddon", () => $7acd852c5628e3a1$export$394991f9b972c6a4);
$parcel$export(module.exports, "toInstalledEcosystemCloudAddon", () => $7acd852c5628e3a1$export$ce01f52a54887770);
$parcel$export(module.exports, "transformInstalledCloudAppsGraphqlApiData", () => $7acd852c5628e3a1$export$f49eb39039925455);
$parcel$export(module.exports, "postGraphQlRequest", () => $7acd852c5628e3a1$export$e6c424c5ceed2a1d);
$parcel$export(module.exports, "getRequestId", () => $7acd852c5628e3a1$export$710171574ebc9a51);
$parcel$export(module.exports, "checkEcosystemCloudAppInstallStatus", () => $7acd852c5628e3a1$export$67cda7b0efd06daa);
$parcel$export(module.exports, "buildSiteContext", () => $7acd852c5628e3a1$export$cf58998fb66fd1de);

var $5zQU9 = parcelRequire("5zQU9");

var $dO8LH = parcelRequire("dO8LH");

var $i0EDR = parcelRequire("i0EDR");

var $fBab0 = parcelRequire("fBab0");

var $fcWBJ = parcelRequire("fcWBJ");

var $gQV53 = parcelRequire("gQV53");

var $kihdI = parcelRequire("kihdI");
function $7acd852c5628e3a1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7acd852c5628e3a1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7acd852c5628e3a1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7acd852c5628e3a1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7acd852c5628e3a1$var$appInstallationTask = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "appInstallationTask"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    },
                    directives: []
                }
            ],
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "appInstallationTask"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "state"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "errors"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ],
    loc: {
        start: 0,
        end: 571,
        source: {
            body: "# If you are making any change here\n# Do thoroughly read our graphql contribution guidelines\n# https://bitbucket.org/atlassian-marketplace/marketplace-frontend/src/master/docs/working-with-graphql.md\n\nmutation ecosystemCloudAppInstall($input: AppInstallationInput!) {\n  installApp(input: $input) {\n    success\n    installationId\n    taskId\n    errors {\n      message\n      extensions {\n        statusCode\n        errorType\n      }\n    }\n  }\n}\n\nquery appInstallationTask($id: ID!) {\n  appInstallationTask(id: $id) {\n    id\n    state\n    errors {\n      message\n    }\n  }\n}\n",
            name: "GraphQL request",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    }
};
const $7acd852c5628e3a1$export$394991f9b972c6a4 = (marketplaceApp)=>{
    var _marketplaceApp$versi;
    const cloudAppsDeployment = (_marketplaceApp$versi = marketplaceApp.version) === null || _marketplaceApp$versi === void 0 ? void 0 : _marketplaceApp$versi.deployment;
    const details = {
        key: marketplaceApp.appKey,
        name: marketplaceApp.name,
        description: marketplaceApp.tagline || '',
        metadata: {},
        ecosystemCloudAppId: cloudAppsDeployment.cloudAppId
    };
    const installableAddon = {
        details: details,
        preinstalled: false,
        scopes: cloudAppsDeployment.scopes.map((s)=>s.capability),
        metadata: undefined,
        eligibleForFreeOnSandbox: false,
        // defaulted to false for the forge apps as they are not eligible for free installation on sandbox
        cloudMigrationTrial: {
            isEligible: false
        }
    };
    return installableAddon;
};
const $7acd852c5628e3a1$export$ce01f52a54887770 = (product, baseUrl, marketplaceInstallation, appGlobalSettingsExtensions)=>{
    var _marketplaceInstallat, _marketplaceAppData$v, _marketplaceAppData$v2;
    const marketplaceAppData = (_marketplaceInstallat = marketplaceInstallation.app) === null || _marketplaceInstallat === void 0 ? void 0 : _marketplaceInstallat.marketplaceApp;
    const getStartedExtension = appGlobalSettingsExtensions.find((extension)=>{
        var _extension$properties;
        return (_extension$properties = extension.properties) === null || _extension$properties === void 0 ? void 0 : _extension$properties.useAsGetStarted;
    });
    const configExtension = appGlobalSettingsExtensions.find((extension)=>{
        var _extension$properties2;
        return ((_extension$properties2 = extension.properties) === null || _extension$properties2 === void 0 ? void 0 : _extension$properties2.useAsConfig) || extension.type === 'compass:adminPage';
    });
    const version = marketplaceAppData && ((_marketplaceAppData$v = marketplaceAppData.versions.edges) === null || _marketplaceAppData$v === void 0 ? void 0 : (_marketplaceAppData$v2 = _marketplaceAppData$v[0]) === null || _marketplaceAppData$v2 === void 0 ? void 0 : _marketplaceAppData$v2.node);
    if (marketplaceAppData && version) {
        var _marketplaceInstallat2;
        const details = {
            key: marketplaceAppData.appKey,
            name: marketplaceAppData.name,
            description: marketplaceAppData.tagline || '',
            metadata: undefined
        };
        const marketplaceCloudAppDeployment = version.deployment;
        const authType = {
            type: '2LO'
        };
        const paymentModel = (0, $gQV53.transformToPaymentModel)(version, marketplaceInstallation);
        const { getStartedUrl: getStartedUrl, configureUrl: configureUrl } = (0, $kihdI.buildProductCloudAppUrls)({
            product: product,
            baseUrl: baseUrl,
            getStartedExtension: getStartedExtension,
            configExtension: configExtension
        });
        const manageAppUrl = product === (0, $i0EDR.CompatibleProductId).COMPASS ? configureUrl : "".concat(baseUrl, "/plugins/servlet/upm#manage/").concat(marketplaceAppData.appKey);
        return $7acd852c5628e3a1$var$_objectSpread($7acd852c5628e3a1$var$_objectSpread($7acd852c5628e3a1$var$_objectSpread({
            authType: authType,
            details: details,
            installationId: marketplaceInstallation.id,
            enabled: true,
            manageAppUrl: manageAppUrl
        }, (0, $gQV53.setProp)('getStartedUrl', getStartedUrl)), (0, $gQV53.setProp)('configureUrl', configureUrl)), {}, {
            installTime: new Date(marketplaceInstallation.createdAt),
            scopes: marketplaceCloudAppDeployment.scopes.map((s)=>s.capability),
            latestVersion: !!((_marketplaceInstallat2 = marketplaceInstallation.appEnvironmentVersion) !== null && _marketplaceInstallat2 !== void 0 && _marketplaceInstallat2.isLatest),
            paymentModel: paymentModel,
            metadata: undefined
        });
    }
    throw new Error("Marketplace app data not present in installed app ".concat(marketplaceInstallation.id));
};
const $7acd852c5628e3a1$export$f49eb39039925455 = (product, baseUrl, appInstallations, globalSettingsExtensions)=>{
    const globalSettingsExtensionsAppGroups = (0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(globalSettingsExtensions, (extension)=>extension.installationId);
    return appInstallations.filter((appInstall)=>{
        var _appInstall$app;
        return (_appInstall$app = appInstall.app) === null || _appInstall$app === void 0 ? void 0 : _appInstall$app.marketplaceApp;
    }).map((appInstall)=>$7acd852c5628e3a1$export$ce01f52a54887770(product, baseUrl, appInstall, globalSettingsExtensionsAppGroups[appInstall.id] || []));
};
const $7acd852c5628e3a1$export$e6c424c5ceed2a1d = async (payload, gqlGatewayUrl)=>{
    const { query: query, variables: variables, options: options = {} } = payload;
    const requestPayload = $7acd852c5628e3a1$var$_objectSpread($7acd852c5628e3a1$var$_objectSpread({}, options), {}, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'atl-client-name': 'marketplace-amkt-upm-spi-impl'
        },
        body: JSON.stringify({
            query: query,
            variables: variables
        })
    });
    const response = await (0, $dO8LH.fetchOk)(gqlGatewayUrl, requestPayload);
    return response.json();
};
const $7acd852c5628e3a1$export$710171574ebc9a51 = (response)=>{
    var _response$extensions, _response$extensions$;
    return (response === null || response === void 0 ? void 0 : (_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : (_response$extensions$ = _response$extensions.gateway) === null || _response$extensions$ === void 0 ? void 0 : _response$extensions$.request_id) || '';
};
const $7acd852c5628e3a1$export$67cda7b0efd06daa = async (taskId, gqlGatewayUrl)=>{
    const query = (0, $fBab0.print)($7acd852c5628e3a1$var$appInstallationTask);
    const variables = {
        id: taskId
    };
    const pollAfter = 5000;
    const options = {
        retries: (0, $gQV53.calculateRetries)(2, pollAfter),
        retryDelay: pollAfter,
        accept: (response)=>response.json().then((bodyJSON)=>{
                var _bodyJSON$data, _bodyJSON$data$appIns;
                const appInstallationState = bodyJSON === null || bodyJSON === void 0 ? void 0 : (_bodyJSON$data = bodyJSON.data) === null || _bodyJSON$data === void 0 ? void 0 : (_bodyJSON$data$appIns = _bodyJSON$data.appInstallationTask) === null || _bodyJSON$data$appIns === void 0 ? void 0 : _bodyJSON$data$appIns.state;
                return appInstallationState === 'COMPLETE' || appInstallationState === 'FAILED' ? Promise.resolve() : Promise.reject(new Error('Request pending'));
            })
    };
    const responseJSON = await $7acd852c5628e3a1$export$e6c424c5ceed2a1d({
        query: query,
        variables: variables,
        options: options
    }, gqlGatewayUrl);
    const requestId = $7acd852c5628e3a1$export$710171574ebc9a51(responseJSON);
    if (!responseJSON.data) {
        // requestId here can be used to trace the cause of issue in splunk logs for this query
        const error = new Error("App Installation Task Failed for taskId: ".concat(taskId));
        error.cause = requestId;
        throw error;
    }
    const data = $7acd852c5628e3a1$var$_objectSpread($7acd852c5628e3a1$var$_objectSpread({}, responseJSON.data), {}, {
        requestId: requestId
    });
    return data;
};
const $7acd852c5628e3a1$export$cf58998fb66fd1de = (product, cloudId, activationId)=>"ari:cloud:".concat(product, ":").concat(cloudId, ":workspace/").concat(activationId);

});
parcelRegister("fBab0", function(module, exports) {

$parcel$export(module.exports, "print", () => $a0933ad212682f70$export$c2d084dc44961371);

var $d0WTt = parcelRequire("d0WTt");

var $ePVkt = parcelRequire("ePVkt");

var $AQHCf = parcelRequire("AQHCf");
function $a0933ad212682f70$export$c2d084dc44961371(ast) {
    return (0, $AQHCf.visit)(ast, $a0933ad212682f70$var$printDocASTReducer);
}
const $a0933ad212682f70$var$MAX_LINE_LENGTH = 80;
const $a0933ad212682f70$var$printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>'$' + node.name
    },
    // Document
    Document: {
        leave: (node)=>$a0933ad212682f70$var$join(node.definitions, '\n\n')
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = $a0933ad212682f70$var$wrap('(', $a0933ad212682f70$var$join(node.variableDefinitions, ', '), ')');
            const prefix = $a0933ad212682f70$var$join([
                node.operation,
                $a0933ad212682f70$var$join([
                    node.name,
                    varDefs
                ]),
                $a0933ad212682f70$var$join(node.directives, ' ')
            ], ' '); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable: variable, type: type, defaultValue: defaultValue, directives: directives })=>variable + ': ' + type + $a0933ad212682f70$var$wrap(' = ', defaultValue) + $a0933ad212682f70$var$wrap(' ', $a0933ad212682f70$var$join(directives, ' '))
    },
    SelectionSet: {
        leave: ({ selections: selections })=>$a0933ad212682f70$var$block(selections)
    },
    Field: {
        leave ({ alias: alias, name: name, arguments: args, directives: directives, selectionSet: selectionSet }) {
            const prefix = $a0933ad212682f70$var$wrap('', alias, ': ') + name;
            let argsLine = prefix + $a0933ad212682f70$var$wrap('(', $a0933ad212682f70$var$join(args, ', '), ')');
            if (argsLine.length > $a0933ad212682f70$var$MAX_LINE_LENGTH) argsLine = prefix + $a0933ad212682f70$var$wrap('(\n', $a0933ad212682f70$var$indent($a0933ad212682f70$var$join(args, '\n')), '\n)');
            return $a0933ad212682f70$var$join([
                argsLine,
                $a0933ad212682f70$var$join(directives, ' '),
                selectionSet
            ], ' ');
        }
    },
    Argument: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name: name, directives: directives })=>'...' + name + $a0933ad212682f70$var$wrap(' ', $a0933ad212682f70$var$join(directives, ' '))
    },
    InlineFragment: {
        leave: ({ typeCondition: typeCondition, directives: directives, selectionSet: selectionSet })=>$a0933ad212682f70$var$join([
                '...',
                $a0933ad212682f70$var$wrap('on ', typeCondition),
                $a0933ad212682f70$var$join(directives, ' '),
                selectionSet
            ], ' ')
    },
    FragmentDefinition: {
        leave: ({ name: name, typeCondition: typeCondition, variableDefinitions: variableDefinitions, directives: directives, selectionSet: selectionSet })=>// or removed in the future.
            `fragment ${name}${$a0933ad212682f70$var$wrap('(', $a0933ad212682f70$var$join(variableDefinitions, ', '), ')')} ` + `on ${typeCondition} ${$a0933ad212682f70$var$wrap('', $a0933ad212682f70$var$join(directives, ' '), ' ')}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value: value })=>value
    },
    FloatValue: {
        leave: ({ value: value })=>value
    },
    StringValue: {
        leave: ({ value: value, block: isBlockString })=>isBlockString ? (0, $d0WTt.printBlockString)(value) : (0, $ePVkt.printString)(value)
    },
    BooleanValue: {
        leave: ({ value: value })=>value ? 'true' : 'false'
    },
    NullValue: {
        leave: ()=>'null'
    },
    EnumValue: {
        leave: ({ value: value })=>value
    },
    ListValue: {
        leave: ({ values: values })=>'[' + $a0933ad212682f70$var$join(values, ', ') + ']'
    },
    ObjectValue: {
        leave: ({ fields: fields })=>'{' + $a0933ad212682f70$var$join(fields, ', ') + '}'
    },
    ObjectField: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Directive
    Directive: {
        leave: ({ name: name, arguments: args })=>'@' + name + $a0933ad212682f70$var$wrap('(', $a0933ad212682f70$var$join(args, ', '), ')')
    },
    // Type
    NamedType: {
        leave: ({ name: name })=>name
    },
    ListType: {
        leave: ({ type: type })=>'[' + type + ']'
    },
    NonNullType: {
        leave: ({ type: type })=>type + '!'
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description: description, directives: directives, operationTypes: operationTypes })=>$a0933ad212682f70$var$wrap('', description, '\n') + $a0933ad212682f70$var$join([
                'schema',
                $a0933ad212682f70$var$join(directives, ' '),
                $a0933ad212682f70$var$block(operationTypes)
            ], ' ')
    },
    OperationTypeDefinition: {
        leave: ({ operation: operation, type: type })=>operation + ': ' + type
    },
    ScalarTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$a0933ad212682f70$var$wrap('', description, '\n') + $a0933ad212682f70$var$join([
                'scalar',
                name,
                $a0933ad212682f70$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$a0933ad212682f70$var$wrap('', description, '\n') + $a0933ad212682f70$var$join([
                'type',
                name,
                $a0933ad212682f70$var$wrap('implements ', $a0933ad212682f70$var$join(interfaces, ' & ')),
                $a0933ad212682f70$var$join(directives, ' '),
                $a0933ad212682f70$var$block(fields)
            ], ' ')
    },
    FieldDefinition: {
        leave: ({ description: description, name: name, arguments: args, type: type, directives: directives })=>$a0933ad212682f70$var$wrap('', description, '\n') + name + ($a0933ad212682f70$var$hasMultilineItems(args) ? $a0933ad212682f70$var$wrap('(\n', $a0933ad212682f70$var$indent($a0933ad212682f70$var$join(args, '\n')), '\n)') : $a0933ad212682f70$var$wrap('(', $a0933ad212682f70$var$join(args, ', '), ')')) + ': ' + type + $a0933ad212682f70$var$wrap(' ', $a0933ad212682f70$var$join(directives, ' '))
    },
    InputValueDefinition: {
        leave: ({ description: description, name: name, type: type, defaultValue: defaultValue, directives: directives })=>$a0933ad212682f70$var$wrap('', description, '\n') + $a0933ad212682f70$var$join([
                name + ': ' + type,
                $a0933ad212682f70$var$wrap('= ', defaultValue),
                $a0933ad212682f70$var$join(directives, ' ')
            ], ' ')
    },
    InterfaceTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$a0933ad212682f70$var$wrap('', description, '\n') + $a0933ad212682f70$var$join([
                'interface',
                name,
                $a0933ad212682f70$var$wrap('implements ', $a0933ad212682f70$var$join(interfaces, ' & ')),
                $a0933ad212682f70$var$join(directives, ' '),
                $a0933ad212682f70$var$block(fields)
            ], ' ')
    },
    UnionTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, types: types })=>$a0933ad212682f70$var$wrap('', description, '\n') + $a0933ad212682f70$var$join([
                'union',
                name,
                $a0933ad212682f70$var$join(directives, ' '),
                $a0933ad212682f70$var$wrap('= ', $a0933ad212682f70$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, values: values })=>$a0933ad212682f70$var$wrap('', description, '\n') + $a0933ad212682f70$var$join([
                'enum',
                name,
                $a0933ad212682f70$var$join(directives, ' '),
                $a0933ad212682f70$var$block(values)
            ], ' ')
    },
    EnumValueDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$a0933ad212682f70$var$wrap('', description, '\n') + $a0933ad212682f70$var$join([
                name,
                $a0933ad212682f70$var$join(directives, ' ')
            ], ' ')
    },
    InputObjectTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, fields: fields })=>$a0933ad212682f70$var$wrap('', description, '\n') + $a0933ad212682f70$var$join([
                'input',
                name,
                $a0933ad212682f70$var$join(directives, ' '),
                $a0933ad212682f70$var$block(fields)
            ], ' ')
    },
    DirectiveDefinition: {
        leave: ({ description: description, name: name, arguments: args, repeatable: repeatable, locations: locations })=>$a0933ad212682f70$var$wrap('', description, '\n') + 'directive @' + name + ($a0933ad212682f70$var$hasMultilineItems(args) ? $a0933ad212682f70$var$wrap('(\n', $a0933ad212682f70$var$indent($a0933ad212682f70$var$join(args, '\n')), '\n)') : $a0933ad212682f70$var$wrap('(', $a0933ad212682f70$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $a0933ad212682f70$var$join(locations, ' | ')
    },
    SchemaExtension: {
        leave: ({ directives: directives, operationTypes: operationTypes })=>$a0933ad212682f70$var$join([
                'extend schema',
                $a0933ad212682f70$var$join(directives, ' '),
                $a0933ad212682f70$var$block(operationTypes)
            ], ' ')
    },
    ScalarTypeExtension: {
        leave: ({ name: name, directives: directives })=>$a0933ad212682f70$var$join([
                'extend scalar',
                name,
                $a0933ad212682f70$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$a0933ad212682f70$var$join([
                'extend type',
                name,
                $a0933ad212682f70$var$wrap('implements ', $a0933ad212682f70$var$join(interfaces, ' & ')),
                $a0933ad212682f70$var$join(directives, ' '),
                $a0933ad212682f70$var$block(fields)
            ], ' ')
    },
    InterfaceTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$a0933ad212682f70$var$join([
                'extend interface',
                name,
                $a0933ad212682f70$var$wrap('implements ', $a0933ad212682f70$var$join(interfaces, ' & ')),
                $a0933ad212682f70$var$join(directives, ' '),
                $a0933ad212682f70$var$block(fields)
            ], ' ')
    },
    UnionTypeExtension: {
        leave: ({ name: name, directives: directives, types: types })=>$a0933ad212682f70$var$join([
                'extend union',
                name,
                $a0933ad212682f70$var$join(directives, ' '),
                $a0933ad212682f70$var$wrap('= ', $a0933ad212682f70$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeExtension: {
        leave: ({ name: name, directives: directives, values: values })=>$a0933ad212682f70$var$join([
                'extend enum',
                name,
                $a0933ad212682f70$var$join(directives, ' '),
                $a0933ad212682f70$var$block(values)
            ], ' ')
    },
    InputObjectTypeExtension: {
        leave: ({ name: name, directives: directives, fields: fields })=>$a0933ad212682f70$var$join([
                'extend input',
                name,
                $a0933ad212682f70$var$join(directives, ' '),
                $a0933ad212682f70$var$block(fields)
            ], ' ')
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $a0933ad212682f70$var$join(maybeArray, separator = '') {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function $a0933ad212682f70$var$block(array) {
    return $a0933ad212682f70$var$wrap('{\n', $a0933ad212682f70$var$indent($a0933ad212682f70$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $a0933ad212682f70$var$wrap(start, maybeString, end = '') {
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $a0933ad212682f70$var$indent(str) {
    return $a0933ad212682f70$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $a0933ad212682f70$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes('\n'))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}

});
parcelRegister("d0WTt", function(module, exports) {

$parcel$export(module.exports, "printBlockString", () => $984f27a019dca981$export$adb6ca997eeb1f45);

var $dzN5z = parcelRequire("dzN5z");
function $984f27a019dca981$export$d5ee19b441e8d2ae(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $984f27a019dca981$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $984f27a019dca981$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $dzN5z.isWhiteSpace)(str.charCodeAt(i)))++i;
    return i;
}
function $984f27a019dca981$export$40862a63ef85e395(value) {
    if (value === '') return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function $984f27a019dca981$export$adb6ca997eeb1f45(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $dzN5z.isWhiteSpace)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith('\\');
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ''; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $dzN5z.isWhiteSpace)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += '\n';
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += '\n';
    return '"""' + result + '"""';
}

});
parcelRegister("dzN5z", function(module, exports) {

$parcel$export(module.exports, "isWhiteSpace", () => $dc76f141e87ad1a9$export$3c52dd84024ae72c);
/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $dc76f141e87ad1a9$export$3c52dd84024ae72c(code) {
    return code === 0x0009 || code === 0x0020;
}
function $dc76f141e87ad1a9$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $dc76f141e87ad1a9$export$79c5d5217943d6a7(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function $dc76f141e87ad1a9$export$45a677ea7cb6d5c8(code) {
    return $dc76f141e87ad1a9$export$79c5d5217943d6a7(code) || code === 0x005f;
}
function $dc76f141e87ad1a9$export$d3f406ff46035894(code) {
    return $dc76f141e87ad1a9$export$79c5d5217943d6a7(code) || $dc76f141e87ad1a9$export$727d9dbc4fbb948f(code) || code === 0x005f;
}

});


parcelRegister("ePVkt", function(module, exports) {

$parcel$export(module.exports, "printString", () => $451e8d75efc537c6$export$3cdec7cf614a0ecc);
/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ function $451e8d75efc537c6$export$3cdec7cf614a0ecc(str) {
    return `"${str.replace($451e8d75efc537c6$var$escapedRegExp, $451e8d75efc537c6$var$escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex
const $451e8d75efc537c6$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $451e8d75efc537c6$var$escapedReplacer(str) {
    return $451e8d75efc537c6$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const $451e8d75efc537c6$var$escapeSequences = [
    '\\u0000',
    '\\u0001',
    '\\u0002',
    '\\u0003',
    '\\u0004',
    '\\u0005',
    '\\u0006',
    '\\u0007',
    '\\b',
    '\\t',
    '\\n',
    '\\u000B',
    '\\f',
    '\\r',
    '\\u000E',
    '\\u000F',
    '\\u0010',
    '\\u0011',
    '\\u0012',
    '\\u0013',
    '\\u0014',
    '\\u0015',
    '\\u0016',
    '\\u0017',
    '\\u0018',
    '\\u0019',
    '\\u001A',
    '\\u001B',
    '\\u001C',
    '\\u001D',
    '\\u001E',
    '\\u001F',
    '',
    '',
    '\\"',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\\\',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\u007F',
    '\\u0080',
    '\\u0081',
    '\\u0082',
    '\\u0083',
    '\\u0084',
    '\\u0085',
    '\\u0086',
    '\\u0087',
    '\\u0088',
    '\\u0089',
    '\\u008A',
    '\\u008B',
    '\\u008C',
    '\\u008D',
    '\\u008E',
    '\\u008F',
    '\\u0090',
    '\\u0091',
    '\\u0092',
    '\\u0093',
    '\\u0094',
    '\\u0095',
    '\\u0096',
    '\\u0097',
    '\\u0098',
    '\\u0099',
    '\\u009A',
    '\\u009B',
    '\\u009C',
    '\\u009D',
    '\\u009E',
    '\\u009F'
];

});

parcelRegister("AQHCf", function(module, exports) {

$parcel$export(module.exports, "visit", () => $92cb342f4758688e$export$bf638b60ea8b89b7);

var $8pITG = parcelRequire("8pITG");

var $4gMxR = parcelRequire("4gMxR");

var $I6z1b = parcelRequire("I6z1b");

var $5LGT1 = parcelRequire("5LGT1");
const $92cb342f4758688e$export$a89c95c098ac2a58 = Object.freeze({});
function $92cb342f4758688e$export$bf638b60ea8b89b7(root, visitor, visitorKeys = (0, $I6z1b.QueryDocumentKeys)) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values((0, $5LGT1.Kind)))enterLeaveMap.set(kind, $92cb342f4758688e$export$736de8489257458(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = Object.defineProperties({}, Object.getOwnPropertyDescriptors(node));
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $I6z1b.isNode)(node) || (0, $8pITG.devAssert)(false, `Invalid AST Node: ${(0, $4gMxR.inspect)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $92cb342f4758688e$export$a89c95c098ac2a58) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $I6z1b.isNode)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
function $92cb342f4758688e$export$728beebeea393478(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values((0, $5LGT1.Kind))){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter, leave: leave } = $92cb342f4758688e$export$736de8489257458(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $92cb342f4758688e$export$a89c95c098ac2a58) skipping[i] = $92cb342f4758688e$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $92cb342f4758688e$export$a89c95c098ac2a58) skipping[i] = $92cb342f4758688e$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
function $92cb342f4758688e$export$736de8489257458(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === 'object') // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === 'function') // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
function $92cb342f4758688e$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    const { enter: enter, leave: leave } = $92cb342f4758688e$export$736de8489257458(visitor, kind);
    return isLeaving ? leave : enter;
}

});
parcelRegister("8pITG", function(module, exports) {

$parcel$export(module.exports, "devAssert", () => $d43a108bedc8bf17$export$b6cb5906f04696c8);
function $d43a108bedc8bf17$export$b6cb5906f04696c8(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("4gMxR", function(module, exports) {

$parcel$export(module.exports, "inspect", () => $3b7c607a0d7898ba$export$9dec5d1b3b6a130d);
const $3b7c607a0d7898ba$var$MAX_ARRAY_LENGTH = 10;
const $3b7c607a0d7898ba$var$MAX_RECURSIVE_DEPTH = 2;
function $3b7c607a0d7898ba$export$9dec5d1b3b6a130d(value) {
    return $3b7c607a0d7898ba$var$formatValue(value, []);
}
function $3b7c607a0d7898ba$var$formatValue(value, seenValues) {
    switch(typeof value){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? `[function ${value.name}]` : '[function]';
        case 'object':
            return $3b7c607a0d7898ba$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $3b7c607a0d7898ba$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return 'null';
    if (previouslySeenValues.includes(value)) return '[Circular]';
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($3b7c607a0d7898ba$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === 'string' ? jsonValue : $3b7c607a0d7898ba$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $3b7c607a0d7898ba$var$formatArray(value, seenValues);
    return $3b7c607a0d7898ba$var$formatObject(value, seenValues);
}
function $3b7c607a0d7898ba$var$isJSONable(value) {
    return typeof value.toJSON === 'function';
}
function $3b7c607a0d7898ba$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return '{}';
    if (seenValues.length > $3b7c607a0d7898ba$var$MAX_RECURSIVE_DEPTH) return '[' + $3b7c607a0d7898ba$var$getObjectTag(object) + ']';
    const properties = entries.map(([key, value])=>key + ': ' + $3b7c607a0d7898ba$var$formatValue(value, seenValues));
    return '{ ' + properties.join(', ') + ' }';
}
function $3b7c607a0d7898ba$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $3b7c607a0d7898ba$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    const len = Math.min($3b7c607a0d7898ba$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($3b7c607a0d7898ba$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return '[' + items.join(', ') + ']';
}
function $3b7c607a0d7898ba$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        const name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});

parcelRegister("I6z1b", function(module, exports) {

$parcel$export(module.exports, "QueryDocumentKeys", () => $b9638c572a76d886$export$4fcd777a40ccf407);
$parcel$export(module.exports, "isNode", () => $b9638c572a76d886$export$8ee0fc9ee280b4ee);
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $b9638c572a76d886$export$18a2be9195644f38 {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    get [Symbol.toStringTag]() {
        return 'Location';
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
}
class $b9638c572a76d886$export$50792b0e93539fde {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    get [Symbol.toStringTag]() {
        return 'Token';
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
}
const $b9638c572a76d886$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
const $b9638c572a76d886$var$kindValues = new Set(Object.keys($b9638c572a76d886$export$4fcd777a40ccf407));
function $b9638c572a76d886$export$8ee0fc9ee280b4ee(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === 'string' && $b9638c572a76d886$var$kindValues.has(maybeKind);
}
/** Name */ var $b9638c572a76d886$export$f58c50edb4aef9d4;
(function(OperationTypeNode) {
    OperationTypeNode['QUERY'] = 'query';
    OperationTypeNode['MUTATION'] = 'mutation';
    OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})($b9638c572a76d886$export$f58c50edb4aef9d4 || ($b9638c572a76d886$export$f58c50edb4aef9d4 = {}));

});

parcelRegister("5LGT1", function(module, exports) {

$parcel$export(module.exports, "Kind", () => $e1db618492f1a48b$export$a84bdc57c5122798);
/**
 * The set of allowed kind values for AST nodes.
 */ var $e1db618492f1a48b$export$a84bdc57c5122798;
(function(Kind) {
    Kind['NAME'] = 'Name';
    Kind['DOCUMENT'] = 'Document';
    Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
    Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
    Kind['SELECTION_SET'] = 'SelectionSet';
    Kind['FIELD'] = 'Field';
    Kind['ARGUMENT'] = 'Argument';
    Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
    Kind['INLINE_FRAGMENT'] = 'InlineFragment';
    Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
    Kind['VARIABLE'] = 'Variable';
    Kind['INT'] = 'IntValue';
    Kind['FLOAT'] = 'FloatValue';
    Kind['STRING'] = 'StringValue';
    Kind['BOOLEAN'] = 'BooleanValue';
    Kind['NULL'] = 'NullValue';
    Kind['ENUM'] = 'EnumValue';
    Kind['LIST'] = 'ListValue';
    Kind['OBJECT'] = 'ObjectValue';
    Kind['OBJECT_FIELD'] = 'ObjectField';
    Kind['DIRECTIVE'] = 'Directive';
    Kind['NAMED_TYPE'] = 'NamedType';
    Kind['LIST_TYPE'] = 'ListType';
    Kind['NON_NULL_TYPE'] = 'NonNullType';
    Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
    Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
    Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
    Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
    Kind['FIELD_DEFINITION'] = 'FieldDefinition';
    Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
    Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
    Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
    Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
    Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
    Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
    Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
    Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
    Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
    Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
    Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
    Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
    Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
    Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
})($e1db618492f1a48b$export$a84bdc57c5122798 || ($e1db618492f1a48b$export$a84bdc57c5122798 = {}));
 /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 
});



parcelRegister("kihdI", function(module, exports) {

$parcel$export(module.exports, "buildProductCloudAppUrls", () => $ec62d8ac49648d14$export$ab0204850de84d84);

var $i0EDR = parcelRequire("i0EDR");
const $ec62d8ac49648d14$export$ab0204850de84d84 = (_ref)=>{
    let { product: product, baseUrl: baseUrl, getStartedExtension: getStartedExtension, configExtension: configExtension } = _ref;
    if (product === (0, $i0EDR.CompatibleProductId).Confluence) return {
        getStartedUrl: getStartedExtension && "".concat(baseUrl, "/admin/forge?id=").concat(encodeURIComponent(getStartedExtension.id)),
        configureUrl: configExtension && "".concat(baseUrl, "/admin/forge?id=").concat(encodeURIComponent(configExtension.id))
    };
    if (product === (0, $i0EDR.CompatibleProductId).Jira) return {
        getStartedUrl: getStartedExtension && $ec62d8ac49648d14$var$buildJiraExtensionSettingsPath(baseUrl, getStartedExtension, 'get-started'),
        configureUrl: configExtension && $ec62d8ac49648d14$var$buildJiraExtensionSettingsPath(baseUrl, configExtension, 'configure')
    };
    if (product === (0, $i0EDR.CompatibleProductId).COMPASS) {
        const configureUrl = configExtension && $ec62d8ac49648d14$var$buildCompassExtensionSettingsPath(baseUrl, configExtension.id);
        return {
            configureUrl: configureUrl
        };
    }
    return {};
};
const $ec62d8ac49648d14$var$buildJiraExtensionSettingsPath = (baseUrl, extension, settingsType)=>{
    // exntension.id example: ari:cloud:ecosystem::extension/appId/envId/static/hello-world-admin-page
    const [, appId, envId] = extension.id.split('/');
    return "".concat(baseUrl, "/jira/settings/apps/").concat(settingsType, "/").concat(appId, "/").concat(envId);
};
const $ec62d8ac49648d14$var$buildCompassExtensionSettingsPath = (baseUrl, extension)=>{
    /* The redirection link for configure in compass uses base64 conversion of the extension.id which is done with
    btoa() function.
    Read: https://developer.mozilla.org/en-US/docs/Web/API/btoa
   */ const encodedAppAri = encodeURIComponent("b:".concat(btoa(extension)));
    return "".concat(baseUrl, "/compass/apps/").concat(encodedAppAri);
};

});


parcelRegister("6poH2", function(module, exports) {

$parcel$export(module.exports, "default", () => $4aa83b6a58d62a52$export$2e2bcd8739ae039);
const $4aa83b6a58d62a52$var$prodEnv = {
    adminHubBaseUrl: 'https://admin.atlassian.com',
    mpacBaseUrl: 'https://marketplace.atlassian.com',
    mpacCdnBaseUrl: 'https://marketplace.atlassian.com',
    atlassianCommunityBaseUrl: 'https://community.stg.atlassian.com',
    macBaseUrl: 'https://my.atlassian.com',
    wacBaseUrl: 'https://www.atlassian.com',
    ecosystemCloudEnvKey: 'production'
};
const $4aa83b6a58d62a52$var$stagingEnv = {
    adminHubBaseUrl: 'https://admin.stg.atlassian.com',
    mpacBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
    mpacCdnBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
    macBaseUrl: 'https://my.stg.internal.atlassian.com',
    wacBaseUrl: 'https://qa-wac.internal.atlassian.com',
    atlassianCommunityBaseUrl: 'https://community.stg.atlassian.com',
    ecosystemCloudEnvKey: 'production'
};
const $4aa83b6a58d62a52$var$localEnv = {
    adminHubBaseUrl: 'https://admin.stg.atlassian.com',
    mpacBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
    mpacCdnBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
    macBaseUrl: 'https://my.stg.internal.atlassian.com',
    wacBaseUrl: 'https://qa-wac.internal.atlassian.com',
    atlassianCommunityBaseUrl: 'https://community.stg.atlassian.com',
    ecosystemCloudEnvKey: 'production'
};
var $4aa83b6a58d62a52$export$2e2bcd8739ae039 = (config)=>{
    switch(config.environment){
        case 'prod':
            return $4aa83b6a58d62a52$var$prodEnv;
        case 'staging':
            return $4aa83b6a58d62a52$var$stagingEnv;
        case 'local':
            return $4aa83b6a58d62a52$var$localEnv;
        default:
            console.error('Unable to configure marketplace env: ' + config.environment);
            return $4aa83b6a58d62a52$var$prodEnv;
    }
};

});

parcelRegister("QaRKt", function(module, exports) {

$parcel$export(module.exports, "getRawCloudMarketplaceAppByKey", () => $09cd492ff2df40e2$export$6b17afb8693d5324);
$parcel$export(module.exports, "getInstalledEcosystemCloudAppFromCaaS", () => $09cd492ff2df40e2$export$8712abd2e6bd944d);
$parcel$export(module.exports, "getInstalledEcosystemCloudApp", () => $09cd492ff2df40e2$export$d20f2968c1baec15);
$parcel$export(module.exports, "fetchAllInstalledEcosystemCloudApps", () => $09cd492ff2df40e2$export$d286412e060e80fe);
$parcel$export(module.exports, "getInstalledEcosystemCloudAppOrThrowInstallError", () => $09cd492ff2df40e2$export$c24ba89f6d4f98e3);
$parcel$export(module.exports, "handleInstallAddonByARI", () => $09cd492ff2df40e2$export$cad10fadc88b1e5d);

var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $1w7m1 = parcelRequire("1w7m1");

var $i0EDR = parcelRequire("i0EDR");

var $bTrQR = parcelRequire("bTrQR");

var $fBab0 = parcelRequire("fBab0");

var $axFWr = parcelRequire("axFWr");

var $6poH2 = parcelRequire("6poH2");

var $c0juV = parcelRequire("c0juV");
const $09cd492ff2df40e2$var$_excluded = [
    "versions"
];
function $09cd492ff2df40e2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $09cd492ff2df40e2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $09cd492ff2df40e2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $09cd492ff2df40e2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $09cd492ff2df40e2$var$ecosystemCloudAppInstall = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "ecosystemCloudAppInstall"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "AppInstallationInput"
                            }
                        }
                    },
                    directives: []
                }
            ],
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "installApp"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "success"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "installationId"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "taskId"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "errors"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "extensions"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "statusCode"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "errorType"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ],
    loc: {
        start: 0,
        end: 571,
        source: {
            body: "# If you are making any change here\n# Do thoroughly read our graphql contribution guidelines\n# https://bitbucket.org/atlassian-marketplace/marketplace-frontend/src/master/docs/working-with-graphql.md\n\nmutation ecosystemCloudAppInstall($input: AppInstallationInput!) {\n  installApp(input: $input) {\n    success\n    installationId\n    taskId\n    errors {\n      message\n      extensions {\n        statusCode\n        errorType\n      }\n    }\n  }\n}\n\nquery appInstallationTask($id: ID!) {\n  appInstallationTask(id: $id) {\n    id\n    state\n    errors {\n      message\n    }\n  }\n}\n",
            name: "GraphQL request",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    }
};
var $09cd492ff2df40e2$var$ecosystemCloudAppSubscribe = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "ecosystemCloudAppSubscribe"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "AppSubscribeInput"
                            }
                        }
                    },
                    directives: []
                }
            ],
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "subscribeToApp"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "success"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "installation"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "taskId"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "errors"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "extensions"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "statusCode"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "errorType"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ],
    loc: {
        start: 0,
        end: 461,
        source: {
            body: "# If you are making any change here\n# Do thoroughly read our graphql contribution guidelines\n# https://bitbucket.org/atlassian-marketplace/marketplace-frontend/src/master/docs/working-with-graphql.md\n\nmutation ecosystemCloudAppSubscribe($input: AppSubscribeInput!) {\n  subscribeToApp(input: $input) {\n    success\n    installation {\n      id\n    }\n    taskId\n    errors {\n      message\n      extensions {\n        statusCode\n        errorType\n      }\n    }\n  }\n}\n",
            name: "GraphQL request",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    }
};
var $09cd492ff2df40e2$var$getEcosystemCloudAppInstallation = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "getEcosystemCloudAppInstallation"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "context"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    },
                    directives: []
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "appId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    },
                    directives: []
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "environmentType"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "AppEnvironmentType"
                        }
                    },
                    directives: []
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "useDeprecatedQuery"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Boolean"
                            }
                        }
                    },
                    directives: []
                }
            ],
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "extensionContexts"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "contextIds"
                                },
                                value: {
                                    kind: "ListValue",
                                    values: [
                                        {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "context"
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "installations"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "filter"
                                            },
                                            value: {
                                                kind: "ObjectValue",
                                                fields: [
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "appId"
                                                        },
                                                        value: {
                                                            kind: "Variable",
                                                            name: {
                                                                kind: "Name",
                                                                value: "appId"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "environmentType"
                                                        },
                                                        value: {
                                                            kind: "Variable",
                                                            name: {
                                                                kind: "Name",
                                                                value: "environmentType"
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    ],
                                    directives: [
                                        {
                                            kind: "Directive",
                                            name: {
                                                kind: "Name",
                                                value: "include"
                                            },
                                            arguments: [
                                                {
                                                    kind: "Argument",
                                                    name: {
                                                        kind: "Name",
                                                        value: "if"
                                                    },
                                                    value: {
                                                        kind: "Variable",
                                                        name: {
                                                            kind: "Name",
                                                            value: "useDeprecatedQuery"
                                                        }
                                                    }
                                                }
                                            ]
                                        }
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "extensionContextsNodes"
                                                },
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "globalSettingsExtensions"
                                    },
                                    directives: []
                                },
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "adminPageExtensions"
                                    },
                                    directives: []
                                },
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "compassAdminPageExtensions"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "ecosystem"
                        },
                        arguments: [],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "skip"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "if"
                                        },
                                        value: {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "useDeprecatedQuery"
                                            }
                                        }
                                    }
                                ]
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "appInstallationsByContext"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "filter"
                                            },
                                            value: {
                                                kind: "ObjectValue",
                                                fields: [
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "appInstallations"
                                                        },
                                                        value: {
                                                            kind: "ObjectValue",
                                                            fields: [
                                                                {
                                                                    kind: "ObjectField",
                                                                    name: {
                                                                        kind: "Name",
                                                                        value: "contexts"
                                                                    },
                                                                    value: {
                                                                        kind: "ListValue",
                                                                        values: [
                                                                            {
                                                                                kind: "Variable",
                                                                                name: {
                                                                                    kind: "Name",
                                                                                    value: "context"
                                                                                }
                                                                            }
                                                                        ]
                                                                    }
                                                                }
                                                            ]
                                                        }
                                                    },
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "apps"
                                                        },
                                                        value: {
                                                            kind: "ObjectValue",
                                                            fields: [
                                                                {
                                                                    kind: "ObjectField",
                                                                    name: {
                                                                        kind: "Name",
                                                                        value: "ids"
                                                                    },
                                                                    value: {
                                                                        kind: "ListValue",
                                                                        values: [
                                                                            {
                                                                                kind: "Variable",
                                                                                name: {
                                                                                    kind: "Name",
                                                                                    value: "appId"
                                                                                }
                                                                            }
                                                                        ]
                                                                    }
                                                                }
                                                            ]
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    ],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "appInstallationsByContextNodes"
                                                },
                                                directives: []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "extensionContextsNodes"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "AppInstallationConnection"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "nodes"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "appEnvironmentVersion"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "isLatest"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "requiresLicense"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "app"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "marketplaceApp"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "appKey"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "name"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "tagline"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "createdAt"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "versions"
                                                            },
                                                            arguments: [
                                                                {
                                                                    kind: "Argument",
                                                                    name: {
                                                                        kind: "Name",
                                                                        value: "filter"
                                                                    },
                                                                    value: {
                                                                        kind: "ObjectValue",
                                                                        fields: [
                                                                            {
                                                                                kind: "ObjectField",
                                                                                name: {
                                                                                    kind: "Name",
                                                                                    value: "productHostingOptions"
                                                                                },
                                                                                value: {
                                                                                    kind: "ListValue",
                                                                                    values: [
                                                                                        {
                                                                                            kind: "EnumValue",
                                                                                            value: "CLOUD"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            },
                                                                            {
                                                                                kind: "ObjectField",
                                                                                name: {
                                                                                    kind: "Name",
                                                                                    value: "visibility"
                                                                                },
                                                                                value: {
                                                                                    kind: "EnumValue",
                                                                                    value: "PUBLIC"
                                                                                }
                                                                            }
                                                                        ]
                                                                    }
                                                                }
                                                            ],
                                                            directives: [],
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "edges"
                                                                        },
                                                                        arguments: [],
                                                                        directives: [],
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "node"
                                                                                    },
                                                                                    arguments: [],
                                                                                    directives: [],
                                                                                    selectionSet: {
                                                                                        kind: "SelectionSet",
                                                                                        selections: [
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "paymentModel"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: []
                                                                                            },
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "deployment"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: [],
                                                                                                selectionSet: {
                                                                                                    kind: "SelectionSet",
                                                                                                    selections: [
                                                                                                        {
                                                                                                            kind: "InlineFragment",
                                                                                                            typeCondition: {
                                                                                                                kind: "NamedType",
                                                                                                                name: {
                                                                                                                    kind: "Name",
                                                                                                                    value: "MarketplaceCloudAppDeployment"
                                                                                                                }
                                                                                                            },
                                                                                                            directives: [],
                                                                                                            selectionSet: {
                                                                                                                kind: "SelectionSet",
                                                                                                                selections: [
                                                                                                                    {
                                                                                                                        kind: "Field",
                                                                                                                        name: {
                                                                                                                            kind: "Name",
                                                                                                                            value: "cloudAppId"
                                                                                                                        },
                                                                                                                        arguments: [],
                                                                                                                        directives: []
                                                                                                                    },
                                                                                                                    {
                                                                                                                        kind: "Field",
                                                                                                                        name: {
                                                                                                                            kind: "Name",
                                                                                                                            value: "scopes"
                                                                                                                        },
                                                                                                                        arguments: [],
                                                                                                                        directives: [],
                                                                                                                        selectionSet: {
                                                                                                                            kind: "SelectionSet",
                                                                                                                            selections: [
                                                                                                                                {
                                                                                                                                    kind: "Field",
                                                                                                                                    name: {
                                                                                                                                        kind: "Name",
                                                                                                                                        value: "id"
                                                                                                                                    },
                                                                                                                                    arguments: [],
                                                                                                                                    directives: []
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    kind: "Field",
                                                                                                                                    name: {
                                                                                                                                        kind: "Name",
                                                                                                                                        value: "name"
                                                                                                                                    },
                                                                                                                                    arguments: [],
                                                                                                                                    directives: []
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    kind: "Field",
                                                                                                                                    name: {
                                                                                                                                        kind: "Name",
                                                                                                                                        value: "capability"
                                                                                                                                    },
                                                                                                                                    arguments: [],
                                                                                                                                    directives: []
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    }
                                                                                                                ]
                                                                                                            }
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "license"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "active"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "type"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "supportEntitlementNumber"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "trialEndDate"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "isEvaluation"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "createdAt"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "globalSettingsExtensions"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "ExtensionContext"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "globalSettingsExtensions"
                        },
                        name: {
                            kind: "Name",
                            value: "extensionsByType"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "type"
                                },
                                value: {
                                    kind: "StringValue",
                                    value: "confluence:globalSettings",
                                    block: false
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "extensionTypeFields"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "adminPageExtensions"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "ExtensionContext"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "adminPageExtensions"
                        },
                        name: {
                            kind: "Name",
                            value: "extensionsByType"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "type"
                                },
                                value: {
                                    kind: "StringValue",
                                    value: "jira:adminPage",
                                    block: false
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "extensionTypeFields"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "compassAdminPageExtensions"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "ExtensionContext"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "compassAdminPageExtensions"
                        },
                        name: {
                            kind: "Name",
                            value: "extensionsByType"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "type"
                                },
                                value: {
                                    kind: "StringValue",
                                    value: "compass:adminPage",
                                    block: false
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "extensionTypeFields"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "appInstallationsByContextNodes"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "AppInstallationByIndexConnection"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "nodes"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "appEnvironmentVersion"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "isLatest"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "requiresLicense"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "installationContext"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "app"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "marketplaceApp"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "name"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "appKey"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "tagline"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "createdAt"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "versions"
                                                            },
                                                            arguments: [
                                                                {
                                                                    kind: "Argument",
                                                                    name: {
                                                                        kind: "Name",
                                                                        value: "filter"
                                                                    },
                                                                    value: {
                                                                        kind: "ObjectValue",
                                                                        fields: [
                                                                            {
                                                                                kind: "ObjectField",
                                                                                name: {
                                                                                    kind: "Name",
                                                                                    value: "productHostingOptions"
                                                                                },
                                                                                value: {
                                                                                    kind: "ListValue",
                                                                                    values: [
                                                                                        {
                                                                                            kind: "EnumValue",
                                                                                            value: "CLOUD"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            },
                                                                            {
                                                                                kind: "ObjectField",
                                                                                name: {
                                                                                    kind: "Name",
                                                                                    value: "visibility"
                                                                                },
                                                                                value: {
                                                                                    kind: "EnumValue",
                                                                                    value: "PUBLIC"
                                                                                }
                                                                            }
                                                                        ]
                                                                    }
                                                                }
                                                            ],
                                                            directives: [],
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "edges"
                                                                        },
                                                                        arguments: [],
                                                                        directives: [],
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "node"
                                                                                    },
                                                                                    arguments: [],
                                                                                    directives: [],
                                                                                    selectionSet: {
                                                                                        kind: "SelectionSet",
                                                                                        selections: [
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "paymentModel"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: []
                                                                                            },
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "deployment"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: [],
                                                                                                selectionSet: {
                                                                                                    kind: "SelectionSet",
                                                                                                    selections: [
                                                                                                        {
                                                                                                            kind: "InlineFragment",
                                                                                                            typeCondition: {
                                                                                                                kind: "NamedType",
                                                                                                                name: {
                                                                                                                    kind: "Name",
                                                                                                                    value: "MarketplaceCloudAppDeployment"
                                                                                                                }
                                                                                                            },
                                                                                                            directives: [],
                                                                                                            selectionSet: {
                                                                                                                kind: "SelectionSet",
                                                                                                                selections: [
                                                                                                                    {
                                                                                                                        kind: "Field",
                                                                                                                        name: {
                                                                                                                            kind: "Name",
                                                                                                                            value: "cloudAppId"
                                                                                                                        },
                                                                                                                        arguments: [],
                                                                                                                        directives: []
                                                                                                                    },
                                                                                                                    {
                                                                                                                        kind: "Field",
                                                                                                                        name: {
                                                                                                                            kind: "Name",
                                                                                                                            value: "scopes"
                                                                                                                        },
                                                                                                                        arguments: [],
                                                                                                                        directives: [],
                                                                                                                        selectionSet: {
                                                                                                                            kind: "SelectionSet",
                                                                                                                            selections: [
                                                                                                                                {
                                                                                                                                    kind: "Field",
                                                                                                                                    name: {
                                                                                                                                        kind: "Name",
                                                                                                                                        value: "id"
                                                                                                                                    },
                                                                                                                                    arguments: [],
                                                                                                                                    directives: []
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    kind: "Field",
                                                                                                                                    name: {
                                                                                                                                        kind: "Name",
                                                                                                                                        value: "name"
                                                                                                                                    },
                                                                                                                                    arguments: [],
                                                                                                                                    directives: []
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    kind: "Field",
                                                                                                                                    name: {
                                                                                                                                        kind: "Name",
                                                                                                                                        value: "capability"
                                                                                                                                    },
                                                                                                                                    arguments: [],
                                                                                                                                    directives: []
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    }
                                                                                                                ]
                                                                                                            }
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "license"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "active"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "type"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "supportEntitlementNumber"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "trialEndDate"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "isEvaluation"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "createdAt"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "pageInfo"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "hasNextPage"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "endCursor"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "extensionTypeFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Extension"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "environmentId"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "environmentType"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "properties"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "type"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "appVersion"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "installationId"
                        },
                        arguments: [],
                        directives: []
                    }
                ]
            }
        }
    ],
    loc: {
        start: 0,
        end: 4200,
        source: {
            body: "# If you are making any change here\n# Do thoroughly read our graphql contribution guidelines\n# https://bitbucket.org/atlassian-marketplace/marketplace-frontend/src/master/docs/working-with-graphql.md\nquery getEcosystemCloudAppInstallations(\n  $context: ID!\n  $after: String\n  $useDeprecatedQuery: Boolean!\n) {\n  extensionContexts(contextIds: [$context]) {\n    id\n\n    # TODO: MC-3960 - cleanup once migrated\n    # eslint-disable-next-line @graphql-eslint/no-deprecated\n    installations(after: $after) @include(if: $useDeprecatedQuery) {\n      ...extensionContextsNodes\n      ...pageInfo\n    }\n    ...globalSettingsExtensions\n    ...adminPageExtensions\n    ...compassAdminPageExtensions\n  }\n  ecosystem @skip(if: $useDeprecatedQuery) {\n    appInstallationsByContext(\n      filter: { appInstallations: { contexts: [$context] } }\n      after: $after\n    ) {\n      ...appInstallationsByContextNodes\n    }\n  }\n}\n\nquery getEcosystemCloudAppInstallation(\n  $context: ID!\n  $appId: ID!\n  $environmentType: AppEnvironmentType\n  $useDeprecatedQuery: Boolean!\n) {\n  extensionContexts(contextIds: [$context]) {\n    id\n\n    # TODO: MC-3960 - cleanup once migrated\n    # eslint-disable-next-line @graphql-eslint/no-deprecated\n    installations(filter: { appId: $appId, environmentType: $environmentType })\n      @include(if: $useDeprecatedQuery) {\n      ...extensionContextsNodes\n    }\n    ...globalSettingsExtensions\n    ...adminPageExtensions\n    ...compassAdminPageExtensions\n  }\n  ecosystem @skip(if: $useDeprecatedQuery) {\n    appInstallationsByContext(\n      filter: { appInstallations: { contexts: [$context] }, apps: { ids: [$appId] } }\n    ) {\n      ...appInstallationsByContextNodes\n    }\n  }\n}\n\nfragment extensionContextsNodes on AppInstallationConnection {\n  nodes {\n    id\n    appEnvironmentVersion {\n      isLatest\n      requiresLicense\n    }\n    app {\n      marketplaceApp {\n        appKey\n        name\n        tagline\n        createdAt\n        versions(filter: { productHostingOptions: [CLOUD], visibility: PUBLIC }) {\n          edges {\n            node {\n              paymentModel\n              deployment {\n                ... on MarketplaceCloudAppDeployment {\n                  cloudAppId\n                  scopes {\n                    id\n                    name\n                    capability\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    license {\n      active\n      type\n      supportEntitlementNumber\n      trialEndDate\n      isEvaluation\n    }\n    createdAt\n  }\n}\n\nfragment appInstallationsByContextNodes on AppInstallationByIndexConnection {\n  nodes {\n    id\n    appEnvironmentVersion {\n      isLatest\n      requiresLicense\n    }\n    installationContext\n    app {\n      marketplaceApp {\n        name\n        appKey\n        tagline\n        createdAt\n        versions(filter: { productHostingOptions: [CLOUD], visibility: PUBLIC }) {\n          edges {\n            node {\n              paymentModel\n              deployment {\n                ... on MarketplaceCloudAppDeployment {\n                  cloudAppId\n                  scopes {\n                    id\n                    name\n                    capability\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    license {\n      active\n      type\n      supportEntitlementNumber\n      trialEndDate\n      isEvaluation\n    }\n    createdAt\n  }\n  pageInfo {\n    hasNextPage\n    endCursor\n  }\n}\n\nfragment pageInfo on AppInstallationConnection {\n  pageInfo {\n    hasNextPage\n    endCursor\n  }\n}\n\nfragment globalSettingsExtensions on ExtensionContext {\n  globalSettingsExtensions: extensionsByType(type: \"confluence:globalSettings\") {\n    ...extensionTypeFields\n  }\n}\n\nfragment adminPageExtensions on ExtensionContext {\n  adminPageExtensions: extensionsByType(type: \"jira:adminPage\") {\n    ...extensionTypeFields\n  }\n}\n\nfragment compassAdminPageExtensions on ExtensionContext {\n  compassAdminPageExtensions: extensionsByType(type: \"compass:adminPage\") {\n    ...extensionTypeFields\n  }\n}\n\nfragment extensionTypeFields on Extension {\n  id\n  environmentId\n  environmentType\n  properties\n  type\n  appVersion\n  installationId\n}\n",
            name: "GraphQL request",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    }
};
var $09cd492ff2df40e2$var$getEcosystemCloudAppInstallations = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "getEcosystemCloudAppInstallations"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "context"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    },
                    directives: []
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "after"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "String"
                        }
                    },
                    directives: []
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "useDeprecatedQuery"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Boolean"
                            }
                        }
                    },
                    directives: []
                }
            ],
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "extensionContexts"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "contextIds"
                                },
                                value: {
                                    kind: "ListValue",
                                    values: [
                                        {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "context"
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "installations"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "after"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "after"
                                                }
                                            }
                                        }
                                    ],
                                    directives: [
                                        {
                                            kind: "Directive",
                                            name: {
                                                kind: "Name",
                                                value: "include"
                                            },
                                            arguments: [
                                                {
                                                    kind: "Argument",
                                                    name: {
                                                        kind: "Name",
                                                        value: "if"
                                                    },
                                                    value: {
                                                        kind: "Variable",
                                                        name: {
                                                            kind: "Name",
                                                            value: "useDeprecatedQuery"
                                                        }
                                                    }
                                                }
                                            ]
                                        }
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "extensionContextsNodes"
                                                },
                                                directives: []
                                            },
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "pageInfo"
                                                },
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "globalSettingsExtensions"
                                    },
                                    directives: []
                                },
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "adminPageExtensions"
                                    },
                                    directives: []
                                },
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "compassAdminPageExtensions"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "ecosystem"
                        },
                        arguments: [],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "skip"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "if"
                                        },
                                        value: {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "useDeprecatedQuery"
                                            }
                                        }
                                    }
                                ]
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "appInstallationsByContext"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "filter"
                                            },
                                            value: {
                                                kind: "ObjectValue",
                                                fields: [
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "appInstallations"
                                                        },
                                                        value: {
                                                            kind: "ObjectValue",
                                                            fields: [
                                                                {
                                                                    kind: "ObjectField",
                                                                    name: {
                                                                        kind: "Name",
                                                                        value: "contexts"
                                                                    },
                                                                    value: {
                                                                        kind: "ListValue",
                                                                        values: [
                                                                            {
                                                                                kind: "Variable",
                                                                                name: {
                                                                                    kind: "Name",
                                                                                    value: "context"
                                                                                }
                                                                            }
                                                                        ]
                                                                    }
                                                                }
                                                            ]
                                                        }
                                                    }
                                                ]
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "after"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "after"
                                                }
                                            }
                                        }
                                    ],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "appInstallationsByContextNodes"
                                                },
                                                directives: []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "extensionContextsNodes"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "AppInstallationConnection"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "nodes"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "appEnvironmentVersion"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "isLatest"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "requiresLicense"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "app"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "marketplaceApp"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "appKey"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "name"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "tagline"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "createdAt"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "versions"
                                                            },
                                                            arguments: [
                                                                {
                                                                    kind: "Argument",
                                                                    name: {
                                                                        kind: "Name",
                                                                        value: "filter"
                                                                    },
                                                                    value: {
                                                                        kind: "ObjectValue",
                                                                        fields: [
                                                                            {
                                                                                kind: "ObjectField",
                                                                                name: {
                                                                                    kind: "Name",
                                                                                    value: "productHostingOptions"
                                                                                },
                                                                                value: {
                                                                                    kind: "ListValue",
                                                                                    values: [
                                                                                        {
                                                                                            kind: "EnumValue",
                                                                                            value: "CLOUD"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            },
                                                                            {
                                                                                kind: "ObjectField",
                                                                                name: {
                                                                                    kind: "Name",
                                                                                    value: "visibility"
                                                                                },
                                                                                value: {
                                                                                    kind: "EnumValue",
                                                                                    value: "PUBLIC"
                                                                                }
                                                                            }
                                                                        ]
                                                                    }
                                                                }
                                                            ],
                                                            directives: [],
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "edges"
                                                                        },
                                                                        arguments: [],
                                                                        directives: [],
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "node"
                                                                                    },
                                                                                    arguments: [],
                                                                                    directives: [],
                                                                                    selectionSet: {
                                                                                        kind: "SelectionSet",
                                                                                        selections: [
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "paymentModel"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: []
                                                                                            },
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "deployment"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: [],
                                                                                                selectionSet: {
                                                                                                    kind: "SelectionSet",
                                                                                                    selections: [
                                                                                                        {
                                                                                                            kind: "InlineFragment",
                                                                                                            typeCondition: {
                                                                                                                kind: "NamedType",
                                                                                                                name: {
                                                                                                                    kind: "Name",
                                                                                                                    value: "MarketplaceCloudAppDeployment"
                                                                                                                }
                                                                                                            },
                                                                                                            directives: [],
                                                                                                            selectionSet: {
                                                                                                                kind: "SelectionSet",
                                                                                                                selections: [
                                                                                                                    {
                                                                                                                        kind: "Field",
                                                                                                                        name: {
                                                                                                                            kind: "Name",
                                                                                                                            value: "cloudAppId"
                                                                                                                        },
                                                                                                                        arguments: [],
                                                                                                                        directives: []
                                                                                                                    },
                                                                                                                    {
                                                                                                                        kind: "Field",
                                                                                                                        name: {
                                                                                                                            kind: "Name",
                                                                                                                            value: "scopes"
                                                                                                                        },
                                                                                                                        arguments: [],
                                                                                                                        directives: [],
                                                                                                                        selectionSet: {
                                                                                                                            kind: "SelectionSet",
                                                                                                                            selections: [
                                                                                                                                {
                                                                                                                                    kind: "Field",
                                                                                                                                    name: {
                                                                                                                                        kind: "Name",
                                                                                                                                        value: "id"
                                                                                                                                    },
                                                                                                                                    arguments: [],
                                                                                                                                    directives: []
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    kind: "Field",
                                                                                                                                    name: {
                                                                                                                                        kind: "Name",
                                                                                                                                        value: "name"
                                                                                                                                    },
                                                                                                                                    arguments: [],
                                                                                                                                    directives: []
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    kind: "Field",
                                                                                                                                    name: {
                                                                                                                                        kind: "Name",
                                                                                                                                        value: "capability"
                                                                                                                                    },
                                                                                                                                    arguments: [],
                                                                                                                                    directives: []
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    }
                                                                                                                ]
                                                                                                            }
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "license"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "active"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "type"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "supportEntitlementNumber"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "trialEndDate"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "isEvaluation"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "createdAt"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "pageInfo"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "AppInstallationConnection"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "pageInfo"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "hasNextPage"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "endCursor"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "globalSettingsExtensions"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "ExtensionContext"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "globalSettingsExtensions"
                        },
                        name: {
                            kind: "Name",
                            value: "extensionsByType"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "type"
                                },
                                value: {
                                    kind: "StringValue",
                                    value: "confluence:globalSettings",
                                    block: false
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "extensionTypeFields"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "adminPageExtensions"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "ExtensionContext"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "adminPageExtensions"
                        },
                        name: {
                            kind: "Name",
                            value: "extensionsByType"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "type"
                                },
                                value: {
                                    kind: "StringValue",
                                    value: "jira:adminPage",
                                    block: false
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "extensionTypeFields"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "compassAdminPageExtensions"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "ExtensionContext"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "compassAdminPageExtensions"
                        },
                        name: {
                            kind: "Name",
                            value: "extensionsByType"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "type"
                                },
                                value: {
                                    kind: "StringValue",
                                    value: "compass:adminPage",
                                    block: false
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "extensionTypeFields"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "appInstallationsByContextNodes"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "AppInstallationByIndexConnection"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "nodes"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "appEnvironmentVersion"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "isLatest"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "requiresLicense"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "installationContext"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "app"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "marketplaceApp"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "name"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "appKey"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "tagline"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "createdAt"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "versions"
                                                            },
                                                            arguments: [
                                                                {
                                                                    kind: "Argument",
                                                                    name: {
                                                                        kind: "Name",
                                                                        value: "filter"
                                                                    },
                                                                    value: {
                                                                        kind: "ObjectValue",
                                                                        fields: [
                                                                            {
                                                                                kind: "ObjectField",
                                                                                name: {
                                                                                    kind: "Name",
                                                                                    value: "productHostingOptions"
                                                                                },
                                                                                value: {
                                                                                    kind: "ListValue",
                                                                                    values: [
                                                                                        {
                                                                                            kind: "EnumValue",
                                                                                            value: "CLOUD"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            },
                                                                            {
                                                                                kind: "ObjectField",
                                                                                name: {
                                                                                    kind: "Name",
                                                                                    value: "visibility"
                                                                                },
                                                                                value: {
                                                                                    kind: "EnumValue",
                                                                                    value: "PUBLIC"
                                                                                }
                                                                            }
                                                                        ]
                                                                    }
                                                                }
                                                            ],
                                                            directives: [],
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "edges"
                                                                        },
                                                                        arguments: [],
                                                                        directives: [],
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "node"
                                                                                    },
                                                                                    arguments: [],
                                                                                    directives: [],
                                                                                    selectionSet: {
                                                                                        kind: "SelectionSet",
                                                                                        selections: [
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "paymentModel"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: []
                                                                                            },
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "deployment"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: [],
                                                                                                selectionSet: {
                                                                                                    kind: "SelectionSet",
                                                                                                    selections: [
                                                                                                        {
                                                                                                            kind: "InlineFragment",
                                                                                                            typeCondition: {
                                                                                                                kind: "NamedType",
                                                                                                                name: {
                                                                                                                    kind: "Name",
                                                                                                                    value: "MarketplaceCloudAppDeployment"
                                                                                                                }
                                                                                                            },
                                                                                                            directives: [],
                                                                                                            selectionSet: {
                                                                                                                kind: "SelectionSet",
                                                                                                                selections: [
                                                                                                                    {
                                                                                                                        kind: "Field",
                                                                                                                        name: {
                                                                                                                            kind: "Name",
                                                                                                                            value: "cloudAppId"
                                                                                                                        },
                                                                                                                        arguments: [],
                                                                                                                        directives: []
                                                                                                                    },
                                                                                                                    {
                                                                                                                        kind: "Field",
                                                                                                                        name: {
                                                                                                                            kind: "Name",
                                                                                                                            value: "scopes"
                                                                                                                        },
                                                                                                                        arguments: [],
                                                                                                                        directives: [],
                                                                                                                        selectionSet: {
                                                                                                                            kind: "SelectionSet",
                                                                                                                            selections: [
                                                                                                                                {
                                                                                                                                    kind: "Field",
                                                                                                                                    name: {
                                                                                                                                        kind: "Name",
                                                                                                                                        value: "id"
                                                                                                                                    },
                                                                                                                                    arguments: [],
                                                                                                                                    directives: []
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    kind: "Field",
                                                                                                                                    name: {
                                                                                                                                        kind: "Name",
                                                                                                                                        value: "name"
                                                                                                                                    },
                                                                                                                                    arguments: [],
                                                                                                                                    directives: []
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    kind: "Field",
                                                                                                                                    name: {
                                                                                                                                        kind: "Name",
                                                                                                                                        value: "capability"
                                                                                                                                    },
                                                                                                                                    arguments: [],
                                                                                                                                    directives: []
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    }
                                                                                                                ]
                                                                                                            }
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "license"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "active"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "type"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "supportEntitlementNumber"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "trialEndDate"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "isEvaluation"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "createdAt"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "pageInfo"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "hasNextPage"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "endCursor"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "extensionTypeFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Extension"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "environmentId"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "environmentType"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "properties"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "type"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "appVersion"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "installationId"
                        },
                        arguments: [],
                        directives: []
                    }
                ]
            }
        }
    ],
    loc: {
        start: 0,
        end: 4200,
        source: {
            body: "# If you are making any change here\n# Do thoroughly read our graphql contribution guidelines\n# https://bitbucket.org/atlassian-marketplace/marketplace-frontend/src/master/docs/working-with-graphql.md\nquery getEcosystemCloudAppInstallations(\n  $context: ID!\n  $after: String\n  $useDeprecatedQuery: Boolean!\n) {\n  extensionContexts(contextIds: [$context]) {\n    id\n\n    # TODO: MC-3960 - cleanup once migrated\n    # eslint-disable-next-line @graphql-eslint/no-deprecated\n    installations(after: $after) @include(if: $useDeprecatedQuery) {\n      ...extensionContextsNodes\n      ...pageInfo\n    }\n    ...globalSettingsExtensions\n    ...adminPageExtensions\n    ...compassAdminPageExtensions\n  }\n  ecosystem @skip(if: $useDeprecatedQuery) {\n    appInstallationsByContext(\n      filter: { appInstallations: { contexts: [$context] } }\n      after: $after\n    ) {\n      ...appInstallationsByContextNodes\n    }\n  }\n}\n\nquery getEcosystemCloudAppInstallation(\n  $context: ID!\n  $appId: ID!\n  $environmentType: AppEnvironmentType\n  $useDeprecatedQuery: Boolean!\n) {\n  extensionContexts(contextIds: [$context]) {\n    id\n\n    # TODO: MC-3960 - cleanup once migrated\n    # eslint-disable-next-line @graphql-eslint/no-deprecated\n    installations(filter: { appId: $appId, environmentType: $environmentType })\n      @include(if: $useDeprecatedQuery) {\n      ...extensionContextsNodes\n    }\n    ...globalSettingsExtensions\n    ...adminPageExtensions\n    ...compassAdminPageExtensions\n  }\n  ecosystem @skip(if: $useDeprecatedQuery) {\n    appInstallationsByContext(\n      filter: { appInstallations: { contexts: [$context] }, apps: { ids: [$appId] } }\n    ) {\n      ...appInstallationsByContextNodes\n    }\n  }\n}\n\nfragment extensionContextsNodes on AppInstallationConnection {\n  nodes {\n    id\n    appEnvironmentVersion {\n      isLatest\n      requiresLicense\n    }\n    app {\n      marketplaceApp {\n        appKey\n        name\n        tagline\n        createdAt\n        versions(filter: { productHostingOptions: [CLOUD], visibility: PUBLIC }) {\n          edges {\n            node {\n              paymentModel\n              deployment {\n                ... on MarketplaceCloudAppDeployment {\n                  cloudAppId\n                  scopes {\n                    id\n                    name\n                    capability\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    license {\n      active\n      type\n      supportEntitlementNumber\n      trialEndDate\n      isEvaluation\n    }\n    createdAt\n  }\n}\n\nfragment appInstallationsByContextNodes on AppInstallationByIndexConnection {\n  nodes {\n    id\n    appEnvironmentVersion {\n      isLatest\n      requiresLicense\n    }\n    installationContext\n    app {\n      marketplaceApp {\n        name\n        appKey\n        tagline\n        createdAt\n        versions(filter: { productHostingOptions: [CLOUD], visibility: PUBLIC }) {\n          edges {\n            node {\n              paymentModel\n              deployment {\n                ... on MarketplaceCloudAppDeployment {\n                  cloudAppId\n                  scopes {\n                    id\n                    name\n                    capability\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    license {\n      active\n      type\n      supportEntitlementNumber\n      trialEndDate\n      isEvaluation\n    }\n    createdAt\n  }\n  pageInfo {\n    hasNextPage\n    endCursor\n  }\n}\n\nfragment pageInfo on AppInstallationConnection {\n  pageInfo {\n    hasNextPage\n    endCursor\n  }\n}\n\nfragment globalSettingsExtensions on ExtensionContext {\n  globalSettingsExtensions: extensionsByType(type: \"confluence:globalSettings\") {\n    ...extensionTypeFields\n  }\n}\n\nfragment adminPageExtensions on ExtensionContext {\n  adminPageExtensions: extensionsByType(type: \"jira:adminPage\") {\n    ...extensionTypeFields\n  }\n}\n\nfragment compassAdminPageExtensions on ExtensionContext {\n  compassAdminPageExtensions: extensionsByType(type: \"compass:adminPage\") {\n    ...extensionTypeFields\n  }\n}\n\nfragment extensionTypeFields on Extension {\n  id\n  environmentId\n  environmentType\n  properties\n  type\n  appVersion\n  installationId\n}\n",
            name: "GraphQL request",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    }
};
var $09cd492ff2df40e2$var$GetMarketplaceAppByKey = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetMarketplaceAUSIAppByKey"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "appKey"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    },
                    directives: []
                }
            ],
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "marketplaceAppByKey"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "appKey"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "appKey"
                                    }
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AUSIApp"
                                    },
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "versions"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "filter"
                                            },
                                            value: {
                                                kind: "ObjectValue",
                                                fields: [
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "productHostingOptions"
                                                        },
                                                        value: {
                                                            kind: "ListValue",
                                                            values: [
                                                                {
                                                                    kind: "EnumValue",
                                                                    value: "CLOUD"
                                                                }
                                                            ]
                                                        }
                                                    },
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "visibility"
                                                        },
                                                        value: {
                                                            kind: "EnumValue",
                                                            value: "PUBLIC"
                                                        }
                                                    }
                                                ]
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "first"
                                            },
                                            value: {
                                                kind: "IntValue",
                                                value: "1"
                                            }
                                        }
                                    ],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "edges"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "node"
                                                            },
                                                            arguments: [],
                                                            directives: [],
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "FragmentSpread",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "AUSIAppVersion"
                                                                        },
                                                                        directives: []
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AUSIApp"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceApp"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "appKey"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "appId"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "tagline"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "privacyPolicyUrl"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "logo"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AUSIAppLogo"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "partner"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AUSIAppPartner"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AUSIAppVersion"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceAppVersion"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "version"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "learnMoreUrl"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "endUserLicenseAgreementUrl"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "paymentModel"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "deployment"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                        kind: "NamedType",
                                        name: {
                                            kind: "Name",
                                            value: "MarketplaceConnectAppDeployment"
                                        }
                                    },
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "scopes"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                        kind: "NamedType",
                                        name: {
                                            kind: "Name",
                                            value: "MarketplaceCloudAppDeployment"
                                        }
                                    },
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "cloudAppId"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "cloudAppVersionId"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "scopes"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "name"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "capability"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AUSIAppLogo"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceListingImage"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "original"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "highResolution"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AUSIAppPartner"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplacePartner"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "slug"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "partnerType"
                        },
                        arguments: [],
                        directives: []
                    }
                ]
            }
        }
    ],
    loc: {
        start: 0,
        end: 1237,
        source: {
            body: "# If you are making any change here\n# Do thoroughly read our graphql contribution guidelines\n# https://bitbucket.org/atlassian-marketplace/marketplace-frontend/src/master/docs/working-with-graphql.md\n\nquery GetMarketplaceAUSIAppByKey($appKey: String!) {\n  marketplaceAppByKey(appKey: $appKey) {\n    ...AUSIApp\n    versions(filter: { productHostingOptions: [CLOUD], visibility: PUBLIC }, first: 1) {\n      edges {\n        node {\n          ...AUSIAppVersion\n        }\n      }\n    }\n  }\n}\n\nfragment AUSIAppPartner on MarketplacePartner {\n  name\n  id\n  slug\n  partnerType\n}\n\nfragment AUSIApp on MarketplaceApp {\n  name\n  appKey\n  appId\n  tagline\n  privacyPolicyUrl\n  createdAt\n  logo {\n    ...AUSIAppLogo\n  }\n  partner {\n    ...AUSIAppPartner\n  }\n}\n\nfragment AUSIAppLogo on MarketplaceListingImage {\n  original {\n    id\n  }\n\n  highResolution {\n    id\n  }\n}\n\nfragment AUSIAppVersion on MarketplaceAppVersion {\n  version\n  learnMoreUrl\n  endUserLicenseAgreementUrl\n  paymentModel\n  deployment {\n    ... on MarketplaceConnectAppDeployment {\n      scopes {\n        id\n      }\n    }\n\n    ... on MarketplaceCloudAppDeployment {\n      cloudAppId\n      cloudAppVersionId\n      scopes {\n        id\n        name\n        capability\n      }\n    }\n  }\n}\n",
            name: "GraphQL request",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    }
};
const $09cd492ff2df40e2$export$6b17afb8693d5324 = async (appKey, gqlGatewayUrl)=>{
    const query = (0, $fBab0.print)($09cd492ff2df40e2$var$GetMarketplaceAppByKey);
    const variables = {
        appKey: appKey
    };
    try {
        const responseJSON = await (0, $axFWr.postGraphQlRequest)({
            query: query,
            variables: variables
        }, gqlGatewayUrl);
        const response = responseJSON.data;
        if (response && response.marketplaceAppByKey) {
            var _versions$edges, _versions$edges$;
            const _response$marketplace = response.marketplaceAppByKey, { versions: versions } = _response$marketplace, appProps = (0, $bwPfh.default)(_response$marketplace, $09cd492ff2df40e2$var$_excluded);
            const rawCloudMarketplaceApp = $09cd492ff2df40e2$var$_objectSpread($09cd492ff2df40e2$var$_objectSpread({}, appProps), {}, {
                version: versions === null || versions === void 0 ? void 0 : (_versions$edges = versions.edges) === null || _versions$edges === void 0 ? void 0 : (_versions$edges$ = _versions$edges[0]) === null || _versions$edges$ === void 0 ? void 0 : _versions$edges$.node
            });
            return Promise.resolve(rawCloudMarketplaceApp);
        } else throw new Error('No app found for ' + appKey + 'and the responseJSON.data is ' + JSON.stringify(responseJSON.data));
    } catch (error) {
        const MarketplaceAppByKeyError = (0, $1w7m1.makeAppFetchError)('MarketplaceAppByKeyError');
        throw new MarketplaceAppByKeyError({
            source: error,
            appKey: appKey
        });
    }
};
const $09cd492ff2df40e2$export$b4c382bfffac831e = async (keyIdentifier, cloudVersionId, contextId, environment, gqlGatewayUrl, provisionRequestId)=>{
    const query = (0, $fBab0.print)($09cd492ff2df40e2$var$ecosystemCloudAppInstall);
    const { ecosystemCloudEnvKey: ecosystemCloudEnvKey } = environment;
    const variables = {
        input: {
            installationContext: contextId,
            appId: keyIdentifier.ari,
            environmentKey: ecosystemCloudEnvKey,
            async: true,
            versionId: cloudVersionId,
            provisionRequestId: provisionRequestId
        }
    };
    const defaultErrorMsg = "Ecosystem cloud app installation failed for appId: ".concat(keyIdentifier.ari);
    try {
        var _responseJSON$data, _responseJSON$data$in;
        const responseJSON = await (0, $axFWr.postGraphQlRequest)({
            query: query,
            variables: variables
        }, gqlGatewayUrl);
        if (!((_responseJSON$data = responseJSON.data) !== null && _responseJSON$data !== void 0 && (_responseJSON$data$in = _responseJSON$data.installApp) !== null && _responseJSON$data$in !== void 0 && _responseJSON$data$in.success)) {
            var _responseJSON$data2, _responseJSON$data2$i, _responseJSON$data2$i2;
            throw (_responseJSON$data2 = responseJSON.data) === null || _responseJSON$data2 === void 0 ? void 0 : (_responseJSON$data2$i = _responseJSON$data2.installApp) === null || _responseJSON$data2$i === void 0 ? void 0 : (_responseJSON$data2$i2 = _responseJSON$data2$i.errors) === null || _responseJSON$data2$i2 === void 0 ? void 0 : _responseJSON$data2$i2[0];
        }
        return responseJSON.data;
    } catch (error) {
        var _error$extensions;
        throw new (0, $1w7m1.AppInstallError)({
            addon: keyIdentifier,
            code: (error === null || error === void 0 ? void 0 : (_error$extensions = error.extensions) === null || _error$extensions === void 0 ? void 0 : _error$extensions.errorType) || 'InstallAppFailure',
            message: (error === null || error === void 0 ? void 0 : error.message) || defaultErrorMsg,
            source: error
        });
    }
};
const $09cd492ff2df40e2$export$5f1aa3602816b978 = async (keyIdentifier, contextId, environment, gqlGatewayUrl)=>{
    const query = (0, $fBab0.print)($09cd492ff2df40e2$var$ecosystemCloudAppSubscribe);
    const { ecosystemCloudEnvKey: ecosystemCloudEnvKey } = environment;
    const variables = {
        input: {
            installationContext: contextId,
            appId: keyIdentifier.ari,
            envKey: ecosystemCloudEnvKey
        }
    };
    const defaultErrorMsg = "Ecosystem cloud app subscription failed for appId: ".concat(keyIdentifier.ari);
    try {
        var _responseJSON$data3, _responseJSON$data3$s;
        const responseJSON = await (0, $axFWr.postGraphQlRequest)({
            query: query,
            variables: variables
        }, gqlGatewayUrl);
        if (!((_responseJSON$data3 = responseJSON.data) !== null && _responseJSON$data3 !== void 0 && (_responseJSON$data3$s = _responseJSON$data3.subscribeToApp) !== null && _responseJSON$data3$s !== void 0 && _responseJSON$data3$s.success)) {
            var _responseJSON$data4, _responseJSON$data4$s, _responseJSON$data4$s2;
            throw (_responseJSON$data4 = responseJSON.data) === null || _responseJSON$data4 === void 0 ? void 0 : (_responseJSON$data4$s = _responseJSON$data4.subscribeToApp) === null || _responseJSON$data4$s === void 0 ? void 0 : (_responseJSON$data4$s2 = _responseJSON$data4$s.errors) === null || _responseJSON$data4$s2 === void 0 ? void 0 : _responseJSON$data4$s2[0];
        }
        return responseJSON.data;
    } catch (error) {
        var _error$extensions2;
        throw new (0, $1w7m1.AppInstallError)({
            addon: keyIdentifier,
            code: (error === null || error === void 0 ? void 0 : (_error$extensions2 = error.extensions) === null || _error$extensions2 === void 0 ? void 0 : _error$extensions2.errorType) || 'SubscribeAppFailure',
            message: (error === null || error === void 0 ? void 0 : error.message) || defaultErrorMsg,
            source: error
        });
    }
};
const $09cd492ff2df40e2$export$8712abd2e6bd944d = async (ariIdentifier, installConfig, enableDeprecatedInstallationsGQL)=>{
    const query = (0, $fBab0.print)($09cd492ff2df40e2$var$getEcosystemCloudAppInstallation);
    const environment = (0, $6poH2.default)(installConfig);
    const { product: product, cloudId: cloudId, gqlGatewayUrl: gqlGatewayUrl, activationId: activationId } = installConfig;
    const appId = ariIdentifier.ari;
    const useDeprecatedQuery = Boolean(enableDeprecatedInstallationsGQL);
    const variables = {
        appId: appId,
        context: (0, $axFWr.buildSiteContext)(product, cloudId, activationId),
        environment: environment.ecosystemCloudEnvKey,
        useDeprecatedQuery: useDeprecatedQuery
    };
    if (useDeprecatedQuery) (0, $bTrQR.default).info('getEcosystemCloudAppInstallation', 'Requested installations using deprecated query');
    const cloudAppData = await (0, $axFWr.postGraphQlRequest)({
        query: query,
        variables: variables
    }, gqlGatewayUrl);
    return cloudAppData;
};
const $09cd492ff2df40e2$export$d20f2968c1baec15 = async (ariIdentifier, installConfig, flags)=>{
    const { product: product, baseUrl: baseUrl } = installConfig;
    const appId = ariIdentifier.ari;
    const defaultErrorMsg = "No ecosystem cloud app found for appId: ".concat(appId);
    try {
        var _cloudAppData$errors, _cloudAppData$data$ex, _cloudAppData$data, _cloudAppData$data$ec, _cloudAppData$data$ex2, _cloudAppData$data$ex3, _cloudAppData$data$ex4;
        const cloudAppData = await $09cd492ff2df40e2$export$8712abd2e6bd944d(ariIdentifier, installConfig, flags === null || flags === void 0 ? void 0 : flags.enableDeprecatedInstallationsGQL);
        const requestId = (0, $axFWr.getRequestId)(cloudAppData);
        if ((_cloudAppData$errors = cloudAppData.errors) !== null && _cloudAppData$errors !== void 0 && _cloudAppData$errors.length || !cloudAppData.data.extensionContexts) {
            var _cloudAppData$errors2;
            throw new Error(((_cloudAppData$errors2 = cloudAppData.errors) === null || _cloudAppData$errors2 === void 0 ? void 0 : _cloudAppData$errors2[0].message) || defaultErrorMsg, {
                cause: requestId
            });
        }
        const installations = flags !== null && flags !== void 0 && flags.enableDeprecatedInstallationsGQL ? (_cloudAppData$data$ex = cloudAppData.data.extensionContexts) === null || _cloudAppData$data$ex === void 0 ? void 0 : _cloudAppData$data$ex[0].installations : (_cloudAppData$data = cloudAppData.data) === null || _cloudAppData$data === void 0 ? void 0 : (_cloudAppData$data$ec = _cloudAppData$data.ecosystem) === null || _cloudAppData$data$ec === void 0 ? void 0 : _cloudAppData$data$ec.appInstallationsByContext;
        const globalSettingsExtensions = (_cloudAppData$data$ex2 = cloudAppData.data.extensionContexts) === null || _cloudAppData$data$ex2 === void 0 ? void 0 : _cloudAppData$data$ex2[0].globalSettingsExtensions;
        const adminPageExtensions = (_cloudAppData$data$ex3 = cloudAppData.data.extensionContexts) === null || _cloudAppData$data$ex3 === void 0 ? void 0 : _cloudAppData$data$ex3[0].adminPageExtensions;
        const compassAdminPageExtensions = (_cloudAppData$data$ex4 = cloudAppData.data.extensionContexts) === null || _cloudAppData$data$ex4 === void 0 ? void 0 : _cloudAppData$data$ex4[0].compassAdminPageExtensions;
        let productExtensions;
        if (product === (0, $i0EDR.CompatibleProductId).Jira) productExtensions = adminPageExtensions;
        else if (product === (0, $i0EDR.CompatibleProductId).Confluence) productExtensions = globalSettingsExtensions;
        else productExtensions = compassAdminPageExtensions;
        if (!installations.nodes.length) throw new Error("No app installation was found by identifier ".concat(ariIdentifier.ari), {
            cause: requestId
        });
        let appInstallation;
        if (flags && flags.enableReactivateForgeAppFromEmcee) {
            var _installations$nodes$, _installations$nodes$2;
            const isPaidApp = (_installations$nodes$ = installations.nodes[0].appEnvironmentVersion) === null || _installations$nodes$ === void 0 ? void 0 : _installations$nodes$.requiresLicense;
            const isLicenseActive = (_installations$nodes$2 = installations.nodes[0].license) === null || _installations$nodes$2 === void 0 ? void 0 : _installations$nodes$2.active;
            if (isPaidApp && isLicenseActive || !isPaidApp) appInstallation = installations.nodes[0];
            else throw new Error("No app subscription was found by identifier ".concat(ariIdentifier.ari), {
                cause: requestId
            });
        } else appInstallation = installations.nodes[0];
        return (0, $axFWr.toInstalledEcosystemCloudAddon)(product, baseUrl, appInstallation, productExtensions.filter((extension)=>extension.installationId === appInstallation.id));
    } catch (error) {
        const MarketplaceAppByAriError = (0, $1w7m1.makeAppFetchError)('MarketplaceAppByAriError');
        throw new MarketplaceAppByAriError({
            source: error,
            appKey: ariIdentifier.appKey,
            requestId: error === null || error === void 0 ? void 0 : error.cause
        });
    }
};
const $09cd492ff2df40e2$var$getInstalledEcosystemCloudApps = async (installConfig, after, flags)=>{
    const { product: product, cloudId: cloudId, baseUrl: baseUrl, gqlGatewayUrl: gqlGatewayUrl, activationId: activationId } = installConfig;
    const query = (0, $fBab0.print)($09cd492ff2df40e2$var$getEcosystemCloudAppInstallations);
    const useDeprecatedQuery = Boolean(flags === null || flags === void 0 ? void 0 : flags.enableDeprecatedInstallationsGQL);
    const variables = {
        context: (0, $axFWr.buildSiteContext)(product, cloudId, activationId),
        after: after,
        useDeprecatedQuery: useDeprecatedQuery
    };
    if (useDeprecatedQuery) (0, $bTrQR.default).info('getEcosystemCloudAppInstallations', 'Requested installations using deprecated query');
    const defaultErrorMsg = 'Failed to fetch installed Ecosystem Cloud Apps';
    try {
        var _cloudAppsData$data, _cloudAppsData$data$e, _cloudAppsData$data2, _cloudAppsData$data2$, _cloudAppsData$data3, _cloudAppsData$data3$, _cloudAppsData$data4, _cloudAppsData$data4$, _cloudAppsData$data5, _cloudAppsData$data5$;
        // @Todo remove double await https://ecosystem.atlassian.net/browse/FMI-520
        const cloudAppsData = await await (0, $axFWr.postGraphQlRequest)({
            query: query,
            variables: variables
        }, gqlGatewayUrl);
        const extensionContextInstallation = flags !== null && flags !== void 0 && flags.enableDeprecatedInstallationsGQL ? (_cloudAppsData$data = cloudAppsData.data) === null || _cloudAppsData$data === void 0 ? void 0 : (_cloudAppsData$data$e = _cloudAppsData$data.extensionContexts) === null || _cloudAppsData$data$e === void 0 ? void 0 : _cloudAppsData$data$e[0].installations : (_cloudAppsData$data2 = cloudAppsData.data) === null || _cloudAppsData$data2 === void 0 ? void 0 : (_cloudAppsData$data2$ = _cloudAppsData$data2.ecosystem) === null || _cloudAppsData$data2$ === void 0 ? void 0 : _cloudAppsData$data2$.appInstallationsByContext;
        const globalSettingsExtensions = (_cloudAppsData$data3 = cloudAppsData.data) === null || _cloudAppsData$data3 === void 0 ? void 0 : (_cloudAppsData$data3$ = _cloudAppsData$data3.extensionContexts) === null || _cloudAppsData$data3$ === void 0 ? void 0 : _cloudAppsData$data3$[0].globalSettingsExtensions;
        const adminPageExtensions = (_cloudAppsData$data4 = cloudAppsData.data) === null || _cloudAppsData$data4 === void 0 ? void 0 : (_cloudAppsData$data4$ = _cloudAppsData$data4.extensionContexts) === null || _cloudAppsData$data4$ === void 0 ? void 0 : _cloudAppsData$data4$[0].adminPageExtensions;
        const compassAdminPageExtensions = (_cloudAppsData$data5 = cloudAppsData.data) === null || _cloudAppsData$data5 === void 0 ? void 0 : (_cloudAppsData$data5$ = _cloudAppsData$data5.extensionContexts) === null || _cloudAppsData$data5$ === void 0 ? void 0 : _cloudAppsData$data5$[0].compassAdminPageExtensions;
        let productExtensions;
        if (product === (0, $i0EDR.CompatibleProductId).Jira) productExtensions = adminPageExtensions;
        else if (product === (0, $i0EDR.CompatibleProductId).Confluence) productExtensions = globalSettingsExtensions;
        else productExtensions = compassAdminPageExtensions;
        if (!extensionContextInstallation) {
            var _cloudAppsData$errors;
            throw new Error(((_cloudAppsData$errors = cloudAppsData.errors) === null || _cloudAppsData$errors === void 0 ? void 0 : _cloudAppsData$errors[0].message) || defaultErrorMsg);
        }
        const installedAddons = (0, $axFWr.transformInstalledCloudAppsGraphqlApiData)(product, baseUrl, flags && flags.enableReactivateForgeAppFromEmcee ? (extensionContextInstallation.nodes || []).filter((node)=>{
            var _node$appEnvironmentV, _node$license;
            const isPaidApp = (_node$appEnvironmentV = node.appEnvironmentVersion) === null || _node$appEnvironmentV === void 0 ? void 0 : _node$appEnvironmentV.requiresLicense;
            const isLicenseActive = (_node$license = node.license) === null || _node$license === void 0 ? void 0 : _node$license.active;
            return node.app && (isPaidApp && isLicenseActive || !isPaidApp);
        }) : (extensionContextInstallation.nodes || []).filter((node)=>node.app), productExtensions.slice() // use .slice to create new mutable array for flow
        );
        return {
            installedAddons: installedAddons,
            hasNextPage: !!extensionContextInstallation.pageInfo.hasNextPage,
            endCursor: extensionContextInstallation.pageInfo.endCursor
        };
    } catch (error) {
        console.error('Failed to fetch installed Ecosystem Cloud Apps:', error);
        return {
            installedAddons: [],
            hasNextPage: false
        };
    }
};
const $09cd492ff2df40e2$export$d286412e060e80fe = async function fetchAllInstalledEcosystemCloudApps(installConfig, flags, endCursor) {
    let allInstalledEcosystemCloudApps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    try {
        const ecosystemCloudAppResponse = await $09cd492ff2df40e2$var$getInstalledEcosystemCloudApps(installConfig, endCursor, flags);
        const allUpdatedInstalledEcosystemCloudApps = [
            ...allInstalledEcosystemCloudApps,
            ...ecosystemCloudAppResponse.installedAddons
        ];
        if (ecosystemCloudAppResponse.hasNextPage && ecosystemCloudAppResponse.endCursor) return await fetchAllInstalledEcosystemCloudApps(installConfig, flags, ecosystemCloudAppResponse.endCursor, allUpdatedInstalledEcosystemCloudApps);
        return allUpdatedInstalledEcosystemCloudApps;
    } catch (_unused) {
        return allInstalledEcosystemCloudApps;
    }
};
/* For forge apps, some errors from downstream service are not mapped to error code at CaaS.
We do this explicitly here in order to ignore certain non actionable errors from SLO

Known issue: Keeping this list up to date is not easy as there is no list available from CaaS.
*/ const $09cd492ff2df40e2$var$mapEcosystemCloudAppFailuresToErrorCode = (errors)=>{
    const errorsMap = {
        'COFS failure, account pending renewal': 'account.pending.renewal',
        'An unexpected error occurred': 'unexpected.error',
        'Error sending connect plugin lifecycle event callback: product/site does not exist or has been deactivated': 'app.deactivated',
        'Error sending connect plugin lifecycle event callback: A permission sync is already running on the tenant': 'app.install.inprogress',
        'Failed to license app for product jira because this app has not been configured to support this product': 'app.misconfigured',
        'Failed to license app for product confluence because this app has not been configured to support this product': 'app.misconfigured'
    };
    const UNKNOWN_ERROR_CODE = 'unknown.error.code';
    return (errors === null || errors === void 0 ? void 0 : errors[0].message) && errorsMap[errors[0].message] || UNKNOWN_ERROR_CODE;
};
const $09cd492ff2df40e2$export$ddea117e2d623b52 = {
    postInstallToEcosystemCloud: async (keyIdentifier, cloudVersionId, siteBaseUrl, environment, contextId, gqlGatewayUrl, provisionRequestId)=>{
        const ecosystemCloudInstallResponse = await $09cd492ff2df40e2$export$b4c382bfffac831e(keyIdentifier, cloudVersionId, contextId, environment, gqlGatewayUrl, provisionRequestId);
        const installAppData = ecosystemCloudInstallResponse.installApp;
        const defaultErrorMsg = "Ecosystem cloud app installation failed for appId: ".concat(keyIdentifier.ari);
        if (installAppData && !installAppData.success) {
            var _installAppData$error, _installAppData$error2, _installAppData$error3, _installAppData$error4;
            throw new (0, $1w7m1.AppInstallError)({
                addon: keyIdentifier,
                code: ((_installAppData$error = installAppData.errors) === null || _installAppData$error === void 0 ? void 0 : (_installAppData$error2 = _installAppData$error[0].extensions) === null || _installAppData$error2 === void 0 ? void 0 : _installAppData$error2.errorType) || 'InstallAppFailure',
                message: ((_installAppData$error3 = installAppData.errors) === null || _installAppData$error3 === void 0 ? void 0 : _installAppData$error3[0].message) || defaultErrorMsg,
                source: (_installAppData$error4 = installAppData.errors) === null || _installAppData$error4 === void 0 ? void 0 : _installAppData$error4[0]
            });
        }
        return installAppData;
    },
    subscribeToEcosystemCloud: async (keyIdentifier, environment, contextId, gqlGatewayUrl)=>{
        const ecosystemCloudSubscribeResponse = await $09cd492ff2df40e2$export$5f1aa3602816b978(keyIdentifier, contextId, environment, gqlGatewayUrl);
        const subscribeAppData = ecosystemCloudSubscribeResponse.subscribeToApp;
        const defaultErrorMsg = "Ecosystem cloud app installation failed for appId: ".concat(keyIdentifier.ari);
        if (subscribeAppData && !subscribeAppData.success) {
            var _subscribeAppData$err, _subscribeAppData$err2, _subscribeAppData$err3, _subscribeAppData$err4;
            throw new (0, $1w7m1.AppInstallError)({
                addon: keyIdentifier,
                code: ((_subscribeAppData$err = subscribeAppData.errors) === null || _subscribeAppData$err === void 0 ? void 0 : (_subscribeAppData$err2 = _subscribeAppData$err[0].extensions) === null || _subscribeAppData$err2 === void 0 ? void 0 : _subscribeAppData$err2.errorType) || 'SubscribeAppFailure',
                message: ((_subscribeAppData$err3 = subscribeAppData.errors) === null || _subscribeAppData$err3 === void 0 ? void 0 : _subscribeAppData$err3[0].message) || defaultErrorMsg,
                source: (_subscribeAppData$err4 = subscribeAppData.errors) === null || _subscribeAppData$err4 === void 0 ? void 0 : _subscribeAppData$err4[0]
            });
        }
        return subscribeAppData;
    },
    pollEcosystemCloudAppInstallStatus: async (taskId, siteBaseUrl, gqlGatewayUrl, options)=>{
        try {
            const pollingResponse = await (0, $axFWr.checkEcosystemCloudAppInstallStatus)(taskId, gqlGatewayUrl);
            const pollStatus = pollingResponse.appInstallationTask;
            if (pollStatus && pollStatus.state === 'PENDING' || pollStatus && pollStatus.state === 'RUNNING') throw new (0, $1w7m1.AppInstallError)({
                addon: options.addon,
                code: 'EcosystemCloudInstallPollFailure',
                message: "AppInstallationTask in polling response not completed, current state:".concat(pollStatus.state),
                requestId: pollingResponse === null || pollingResponse === void 0 ? void 0 : pollingResponse.requestId
            });
            else if (pollStatus && pollStatus.state === 'COMPLETE') return true;
            else throw new (0, $1w7m1.AppInstallError)({
                addon: options.addon,
                code: "EcosystemCloudInstallPollFailure-".concat($09cd492ff2df40e2$var$mapEcosystemCloudAppFailuresToErrorCode(pollStatus === null || pollStatus === void 0 ? void 0 : pollStatus.errors)),
                message: "AppInstallationTask state is failed due to ".concat(JSON.stringify((pollStatus === null || pollStatus === void 0 ? void 0 : pollStatus.errors) || []) || 'unknown reason'),
                requestId: pollingResponse === null || pollingResponse === void 0 ? void 0 : pollingResponse.requestId
            });
        } catch (error) {
            if (error instanceof (0, $1w7m1.AppInstallError)) throw error;
            throw new (0, $1w7m1.AppInstallError)({
                addon: options.addon,
                code: 'AppInstallationTaskFailedError',
                message: "Failed while polling for app installation status for ".concat(options.addon.toString()),
                source: error,
                requestId: error === null || error === void 0 ? void 0 : error.cause
            });
        }
    }
};
const $09cd492ff2df40e2$export$9501823dbb04cc30 = async (ariIdentifier, config, options)=>{
    var _cloudAppData$errors3, _cloudAppData$data$ex5, _cloudAppData$data2, _cloudAppData$data2$e, _installations$nodes;
    const { baseUrl: baseUrl, gqlGatewayUrl: gqlGatewayUrl } = config;
    const environment = (0, $6poH2.default)(config);
    const cloudAppData = await $09cd492ff2df40e2$export$8712abd2e6bd944d(ariIdentifier, config, options === null || options === void 0 ? void 0 : options.enableDeprecatedInstallationsGQL);
    if ((_cloudAppData$errors3 = cloudAppData.errors) !== null && _cloudAppData$errors3 !== void 0 && _cloudAppData$errors3.length || !cloudAppData.data.extensionContexts) {
        var _cloudAppData$errors4;
        throw new Error((_cloudAppData$errors4 = cloudAppData.errors) === null || _cloudAppData$errors4 === void 0 ? void 0 : _cloudAppData$errors4[0].message);
    }
    const installations = options !== null && options !== void 0 && options.enableDeprecatedInstallationsGQL ? (_cloudAppData$data$ex5 = cloudAppData.data.extensionContexts) === null || _cloudAppData$data$ex5 === void 0 ? void 0 : _cloudAppData$data$ex5[0].installations : (_cloudAppData$data2 = cloudAppData.data) === null || _cloudAppData$data2 === void 0 ? void 0 : (_cloudAppData$data2$e = _cloudAppData$data2.ecosystem) === null || _cloudAppData$data2$e === void 0 ? void 0 : _cloudAppData$data2$e.appInstallationsByContext;
    if ((_installations$nodes = installations.nodes) !== null && _installations$nodes !== void 0 && _installations$nodes.length) {
        var _appInstallation$appE, _appInstallation$lice;
        const appInstallation = installations.nodes[0];
        const isPaidApp = (_appInstallation$appE = appInstallation.appEnvironmentVersion) === null || _appInstallation$appE === void 0 ? void 0 : _appInstallation$appE.requiresLicense;
        const isLicenseActive = (_appInstallation$lice = appInstallation.license) === null || _appInstallation$lice === void 0 ? void 0 : _appInstallation$lice.active;
        if (isPaidApp && !isLicenseActive) {
            const subscribeAppData = await $09cd492ff2df40e2$export$ddea117e2d623b52.subscribeToEcosystemCloud(ariIdentifier, environment, options.contextId, gqlGatewayUrl);
            if (subscribeAppData !== null && subscribeAppData !== void 0 && subscribeAppData.taskId) await $09cd492ff2df40e2$export$ddea117e2d623b52.pollEcosystemCloudAppInstallStatus(subscribeAppData.taskId, baseUrl, gqlGatewayUrl, options);
            try {
                const installedApp = await $09cd492ff2df40e2$export$d20f2968c1baec15(ariIdentifier, config, {
                    enableReactivateForgeAppFromEmcee: options.enableReactivateForgeAppFromEmcee,
                    enableDeprecatedInstallationsGQL: options.enableDeprecatedInstallationsGQL
                });
                return installedApp;
            } catch (error) {
                var _error$meta;
                throw new (0, $1w7m1.AppInstallError)({
                    addon: options.addon,
                    code: 'EcosystemCloudAppFetchFailed',
                    message: "Unable to fetch ecosystem cloud app with identifier ".concat(ariIdentifier.ari),
                    requestId: error === null || error === void 0 ? void 0 : (_error$meta = error.meta) === null || _error$meta === void 0 ? void 0 : _error$meta.requestId
                });
            }
        }
    }
    return Promise.resolve();
};
const $09cd492ff2df40e2$export$c24ba89f6d4f98e3 = async (ariIdentifier, config, options)=>{
    try {
        return $09cd492ff2df40e2$export$d20f2968c1baec15(ariIdentifier, config, {
            enableReactivateForgeAppFromEmcee: options.enableReactivateForgeAppFromEmcee,
            enableDeprecatedInstallationsGQL: options.enableDeprecatedInstallationsGQL
        });
    } catch (error) {
        var _error$meta2;
        throw new (0, $1w7m1.AppInstallError)({
            addon: options.addon,
            code: 'EcosystemCloudAppFetchFailed',
            message: "Unable to fetch ecosystem cloud app with identifier ".concat(ariIdentifier.ari),
            requestId: error === null || error === void 0 ? void 0 : (_error$meta2 = error.meta) === null || _error$meta2 === void 0 ? void 0 : _error$meta2.requestId
        });
    }
};
const $09cd492ff2df40e2$export$cad10fadc88b1e5d = async (ariIdentifier, config, options, provisionRequestId)=>{
    var _MarketplaceApp$versi;
    const { baseUrl: baseUrl, gqlGatewayUrl: gqlGatewayUrl } = config;
    const environment = (0, $6poH2.default)(config);
    const MarketplaceApp = await $09cd492ff2df40e2$export$6b17afb8693d5324((0, $c0juV.makeAppKey)(ariIdentifier.appKey), gqlGatewayUrl);
    const cloudVersionId = (_MarketplaceApp$versi = MarketplaceApp.version.deployment) === null || _MarketplaceApp$versi === void 0 ? void 0 : _MarketplaceApp$versi.cloudAppVersionId;
    if (!cloudVersionId) throw new (0, $1w7m1.AppInstallError)({
        addon: options.addon,
        code: 'CloudVersionIdFetchError',
        message: "CloudVersionId is not present for version specific installation ".concat(options.addon.toString())
    });
    if (options.enableReactivateForgeAppFromEmcee) {
        const subscribeAppResult = await $09cd492ff2df40e2$export$9501823dbb04cc30(ariIdentifier, config, options);
        if (subscribeAppResult) return subscribeAppResult;
    }
    const installedApp = await $09cd492ff2df40e2$export$ddea117e2d623b52.postInstallToEcosystemCloud(ariIdentifier, cloudVersionId, baseUrl, environment, options.contextId, gqlGatewayUrl, provisionRequestId);
    if (installedApp !== null && installedApp !== void 0 && installedApp.taskId) await $09cd492ff2df40e2$export$ddea117e2d623b52.pollEcosystemCloudAppInstallStatus(installedApp.taskId, baseUrl, gqlGatewayUrl, options);
    return $09cd492ff2df40e2$export$c24ba89f6d4f98e3(ariIdentifier, config, options);
};

});

parcelRegister("dDuCy", function(module, exports) {

$parcel$export(module.exports, "installAddonViaStoreBFF", () => $9ed6ab8771e7a5c0$export$975d542216447854);

var $lLYAL = parcelRequire("lLYAL");

var $1w7m1 = parcelRequire("1w7m1");

var $ammkg = parcelRequire("ammkg");

var $fBab0 = parcelRequire("fBab0");

var $gQV53 = parcelRequire("gQV53");

var $axFWr = parcelRequire("axFWr");

var $9y1TQ = parcelRequire("9y1TQ");
var $9ed6ab8771e7a5c0$var$GetInstallStatus = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetInstallStatus"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "taskId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    },
                    directives: []
                }
            ],
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "marketplaceStore"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "installAppStatus"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "id"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "taskId"
                                                }
                                            }
                                        }
                                    ],
                                    directives: [
                                        {
                                            kind: "Directive",
                                            name: {
                                                kind: "Name",
                                                value: "optIn"
                                            },
                                            arguments: [
                                                {
                                                    kind: "Argument",
                                                    name: {
                                                        kind: "Name",
                                                        value: "to"
                                                    },
                                                    value: {
                                                        kind: "StringValue",
                                                        value: "MarketplaceStoreInstallAppM1",
                                                        block: false
                                                    }
                                                }
                                            ]
                                        }
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "InstallResult"
                                                },
                                                directives: []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "InstallResult"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceStoreInstallAppResponse"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "taskId"
                        },
                        name: {
                            kind: "Name",
                            value: "id"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "status"
                        },
                        arguments: [],
                        directives: []
                    }
                ]
            }
        }
    ],
    loc: {
        start: 0,
        end: 458,
        source: {
            body: "fragment InstallResult on MarketplaceStoreInstallAppResponse {\n  taskId: id\n  status\n}\n\nmutation InstallApp($input: MarketplaceStoreInstallAppInput!) {\n  marketplaceStore {\n    installApp(input: $input) @optIn(to: \"MarketplaceStoreInstallAppM1\") {\n      ...InstallResult\n    }\n  }\n}\n\nquery GetInstallStatus($taskId: ID!) {\n  marketplaceStore {\n    installAppStatus(id: $taskId) @optIn(to: \"MarketplaceStoreInstallAppM1\") {\n      ...InstallResult\n    }\n  }\n}\n",
            name: "GraphQL request",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    }
};
var $9ed6ab8771e7a5c0$var$InstallApp = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "InstallApp"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "MarketplaceStoreInstallAppInput"
                            }
                        }
                    },
                    directives: []
                }
            ],
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "marketplaceStore"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "installApp"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "input"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "input"
                                                }
                                            }
                                        }
                                    ],
                                    directives: [
                                        {
                                            kind: "Directive",
                                            name: {
                                                kind: "Name",
                                                value: "optIn"
                                            },
                                            arguments: [
                                                {
                                                    kind: "Argument",
                                                    name: {
                                                        kind: "Name",
                                                        value: "to"
                                                    },
                                                    value: {
                                                        kind: "StringValue",
                                                        value: "MarketplaceStoreInstallAppM1",
                                                        block: false
                                                    }
                                                }
                                            ]
                                        }
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "InstallResult"
                                                },
                                                directives: []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "InstallResult"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceStoreInstallAppResponse"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "taskId"
                        },
                        name: {
                            kind: "Name",
                            value: "id"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "status"
                        },
                        arguments: [],
                        directives: []
                    }
                ]
            }
        }
    ],
    loc: {
        start: 0,
        end: 458,
        source: {
            body: "fragment InstallResult on MarketplaceStoreInstallAppResponse {\n  taskId: id\n  status\n}\n\nmutation InstallApp($input: MarketplaceStoreInstallAppInput!) {\n  marketplaceStore {\n    installApp(input: $input) @optIn(to: \"MarketplaceStoreInstallAppM1\") {\n      ...InstallResult\n    }\n  }\n}\n\nquery GetInstallStatus($taskId: ID!) {\n  marketplaceStore {\n    installAppStatus(id: $taskId) @optIn(to: \"MarketplaceStoreInstallAppM1\") {\n      ...InstallResult\n    }\n  }\n}\n",
            name: "GraphQL request",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    }
};
const $9ed6ab8771e7a5c0$var$ProductNameToTargetProductMap = {
    confluence: (0, $ammkg.MarketplaceStoreInstallationTargetProduct).Confluence,
    jira: (0, $ammkg.MarketplaceStoreInstallationTargetProduct).Jira,
    compass: (0, $ammkg.MarketplaceStoreInstallationTargetProduct).Compass
};
const $9ed6ab8771e7a5c0$var$executeInstallAppMutation = async (variables, gqlGatewayUrl)=>{
    var _data$marketplaceStor, _data$marketplaceStor2;
    const mutation = (0, $fBab0.print)($9ed6ab8771e7a5c0$var$InstallApp);
    let graphqlResult;
    const { input: { appKey: appKey } } = variables;
    try {
        graphqlResult = await (0, $axFWr.postGraphQlRequest)({
            query: mutation,
            variables: variables
        }, gqlGatewayUrl);
    } catch (error) {
        throw (0, $9y1TQ.appInstallErrorFromGraphQLFetchError)(appKey, 'trigger', error);
    }
    const { data: data, errors: errors, extensions: extensions } = graphqlResult;
    if (data !== null && data !== void 0 && (_data$marketplaceStor = data.marketplaceStore) !== null && _data$marketplaceStor !== void 0 && (_data$marketplaceStor2 = _data$marketplaceStor.installApp) !== null && _data$marketplaceStor2 !== void 0 && _data$marketplaceStor2.taskId) {
        var _data$marketplaceStor3;
        return data === null || data === void 0 ? void 0 : (_data$marketplaceStor3 = data.marketplaceStore) === null || _data$marketplaceStor3 === void 0 ? void 0 : _data$marketplaceStor3.installApp;
    }
    // we're here cause something went wrong and we weren't able to get a taskId
    throw (0, $9y1TQ.appInstallErrorFromGraphQLErrorResponse)(appKey, 'trigger', errors, extensions);
};
const $9ed6ab8771e7a5c0$var$pollAppInstallStatus = async (args)=>{
    var _data$marketplaceStor6, _data$marketplaceStor7;
    const { appKey: appKey, taskId: taskId, gqlGatewayUrl: gqlGatewayUrl } = args;
    const query = (0, $fBab0.print)($9ed6ab8771e7a5c0$var$GetInstallStatus);
    const variables = {
        taskId: taskId
    };
    const pollAfter = 5000;
    const maxMinutesToWait = 5;
    const options = {
        retries: (0, $gQV53.calculateRetries)(maxMinutesToWait, pollAfter),
        retryDelay: pollAfter,
        accept: async (response)=>{
            var _data$marketplaceStor4, _data$marketplaceStor5;
            const { data: data } = await response.json();
            const installStatus = data === null || data === void 0 ? void 0 : (_data$marketplaceStor4 = data.marketplaceStore) === null || _data$marketplaceStor4 === void 0 ? void 0 : (_data$marketplaceStor5 = _data$marketplaceStor4.installAppStatus) === null || _data$marketplaceStor5 === void 0 ? void 0 : _data$marketplaceStor5.status;
            if (installStatus === (0, $ammkg.MarketplaceStoreInstallAppStatus).Pending || installStatus === (0, $ammkg.MarketplaceStoreInstallAppStatus).InProgress) throw new Error('App install still in progress');
        }
    };
    let graphqlResult;
    try {
        graphqlResult = await (0, $axFWr.postGraphQlRequest)({
            query: query,
            variables: variables,
            options: options
        }, gqlGatewayUrl);
    } catch (error) {
        throw (0, $9y1TQ.appInstallErrorFromGraphQLFetchError)(appKey, 'poll', error, taskId);
    }
    const { data: data, errors: errors, extensions: extensions } = graphqlResult;
    if ((data === null || data === void 0 ? void 0 : (_data$marketplaceStor6 = data.marketplaceStore) === null || _data$marketplaceStor6 === void 0 ? void 0 : (_data$marketplaceStor7 = _data$marketplaceStor6.installAppStatus) === null || _data$marketplaceStor7 === void 0 ? void 0 : _data$marketplaceStor7.status) === (0, $ammkg.MarketplaceStoreInstallAppStatus).Success) {
        var _data$marketplaceStor8;
        return data === null || data === void 0 ? void 0 : (_data$marketplaceStor8 = data.marketplaceStore) === null || _data$marketplaceStor8 === void 0 ? void 0 : _data$marketplaceStor8.installAppStatus;
    }
    // we're here cause something went wrong
    throw (0, $9y1TQ.appInstallErrorFromGraphQLErrorResponse)(appKey, 'poll', errors, extensions, taskId);
};
const $9ed6ab8771e7a5c0$export$975d542216447854 = async (installAddonDetails, config)=>{
    const { gqlGatewayUrl: gqlGatewayUrl } = config;
    const { appKey: appKey, installationTargetInfo: installationTargetInfo } = installAddonDetails;
    const { contextId: contextId, productName: productName } = installationTargetInfo;
    const { cloudId: cloudId } = (0, $lLYAL.parse)(contextId);
    const targetProduct = $9ed6ab8771e7a5c0$var$ProductNameToTargetProductMap[productName];
    if (!cloudId) throw new (0, $1w7m1.AppInstallError)({
        addon: {
            key: appKey
        },
        code: (0, $9y1TQ.ErrorCode).InvalidInstallationTargetInfo,
        message: "Unable to parse cloudId from installationTargetInfo.contextId: ".concat(contextId)
    });
    if (!targetProduct) throw new (0, $1w7m1.AppInstallError)({
        addon: {
            key: appKey
        },
        code: (0, $9y1TQ.ErrorCode).InvalidInstallationTargetInfo,
        message: "Invalid productName: ".concat(productName)
    });
    const { taskId: taskId } = await $9ed6ab8771e7a5c0$var$executeInstallAppMutation({
        input: {
            appKey: appKey,
            target: {
                cloudId: cloudId,
                product: targetProduct
            }
        }
    }, gqlGatewayUrl);
    return $9ed6ab8771e7a5c0$var$pollAppInstallStatus({
        appKey: appKey,
        taskId: taskId,
        gqlGatewayUrl: gqlGatewayUrl
    });
};

});
parcelRegister("9y1TQ", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", () => $6f38c34300a9988c$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "appInstallErrorFromGraphQLFetchError", () => $6f38c34300a9988c$export$6f90b36850979bb8);
$parcel$export(module.exports, "appInstallErrorFromGraphQLErrorResponse", () => $6f38c34300a9988c$export$d2e572bf56497e18);

var $1w7m1 = parcelRequire("1w7m1");
let $6f38c34300a9988c$export$d4e71bc0b80dc0fb = /*#__PURE__*/ function(ErrorCode) {
    ErrorCode["InvalidInstallationTargetInfo"] = "InvalidInstallationTargetInfo";
    ErrorCode["FallbackStoreBFFErrorCode"] = "UnknownErrorInMarketplaceStoreAppInstall";
    ErrorCode["AppAlreadyProvisioned"] = "APP_ALREADY_PROVISIONED";
    ErrorCode["GraphQLFetchError"] = "GraphQLFetchError";
    return ErrorCode;
}({});
const $6f38c34300a9988c$var$appendTaskId = (message, taskId)=>{
    if (taskId) return "".concat(message, " [taskId: ").concat(taskId, "]");
    return message;
};
const $6f38c34300a9988c$export$6f90b36850979bb8 = (appKey, operation, source, taskId)=>{
    const message = operation === 'trigger' ? "Failed to trigger installation for app with key ".concat(appKey) : "Unknown error getting installation status for app with key ".concat(appKey);
    throw new (0, $1w7m1.AppInstallError)({
        addon: {
            key: appKey
        },
        code: $6f38c34300a9988c$export$d4e71bc0b80dc0fb.GraphQLFetchError,
        message: $6f38c34300a9988c$var$appendTaskId(message, taskId),
        source: source
    });
};
const $6f38c34300a9988c$export$d2e572bf56497e18 = (appKey, operation, errors, extensions, taskId)=>{
    var _error$extensions, _extensions$gateway, _error$message;
    const error = errors === null || errors === void 0 ? void 0 : errors[0];
    const errorCode = (error === null || error === void 0 ? void 0 : (_error$extensions = error.extensions) === null || _error$extensions === void 0 ? void 0 : _error$extensions.code) || $6f38c34300a9988c$export$d4e71bc0b80dc0fb.FallbackStoreBFFErrorCode;
    const requestId = extensions === null || extensions === void 0 ? void 0 : (_extensions$gateway = extensions.gateway) === null || _extensions$gateway === void 0 ? void 0 : _extensions$gateway.request_id;
    const message = (_error$message = error === null || error === void 0 ? void 0 : error.message) !== null && _error$message !== void 0 ? _error$message : operation === 'trigger' ? "Error triggering installation for app with key ".concat(appKey) : "Error getting installation status for app with key ".concat(appKey);
    throw new (0, $1w7m1.AppInstallError)({
        addon: {
            key: appKey
        },
        code: errorCode,
        message: $6f38c34300a9988c$var$appendTaskId(message, taskId),
        source: error,
        requestId: requestId
    });
};

});


parcelRegister("56eyA", function(module, exports) {

$parcel$export(module.exports, "getInstalledAppFromUpm", () => $3b68cdff11d9fe6c$export$f8f9f9ee7ac59403);
$parcel$export(module.exports, "getInstallPermissions", () => $3b68cdff11d9fe6c$export$69e4ce869d45957f);
$parcel$export(module.exports, "getInstalledMarketplacePluginFromUpm", () => $3b68cdff11d9fe6c$export$7dddfef125b8b373);
$parcel$export(module.exports, "getAvailableAppFromUpm", () => $3b68cdff11d9fe6c$export$a4ff2c0f02e68c0b);
$parcel$export(module.exports, "getInstalledMarketplaceFromUpm", () => $3b68cdff11d9fe6c$export$7203b6ab97ad4508);
$parcel$export(module.exports, "getAllInstalledAppsFromUpm", () => $3b68cdff11d9fe6c$export$204e4607d8fa2086);
$parcel$export(module.exports, "getHostStatusFromUpm", () => $3b68cdff11d9fe6c$export$ee0bd730334c3b4);

var $dO8LH = parcelRequire("dO8LH");

var $1w7m1 = parcelRequire("1w7m1");

var $bTrQR = parcelRequire("bTrQR");

var $kt9Cs = parcelRequire("kt9Cs");

var $gQV53 = parcelRequire("gQV53");
const $3b68cdff11d9fe6c$var$defaultOptions = (upmBaseUrl)=>({
        credentials: (0, $gQV53.getUPMCredentials)(upmBaseUrl)
    });
const $3b68cdff11d9fe6c$var$getInstallPermissionsUrl = (upmBaseUrl, appKey)=>"".concat(upmBaseUrl, "/rest/plugins/1.0/apps/install-subscribe/permission?addonKey=").concat(appKey);
const $3b68cdff11d9fe6c$var$getInstalledPluginUrl = (upmBaseUrl, appKey)=>"".concat(upmBaseUrl, "/rest/plugins/1.0/").concat(appKey, "-key");
const $3b68cdff11d9fe6c$var$getInstalledMarketplacePluginUrl = (upmBaseUrl, appKey)=>"".concat(upmBaseUrl, "/rest/plugins/1.0/").concat(appKey, "/marketplace");
const $3b68cdff11d9fe6c$var$getAvailablePluginUrl = (upmBaseUrl, appKey, query)=>"".concat(upmBaseUrl, "/rest/plugins/1.0/available/").concat(appKey, "-key").concat(query ? "?".concat(query) : '');
const $3b68cdff11d9fe6c$var$getAllInstalledMarketplacePluginsUrl = (upmBaseUrl)=>"".concat(upmBaseUrl, "/rest/plugins/1.0/installed-marketplace");
const $3b68cdff11d9fe6c$var$getHostStatusUrl = (upmBaseUrl)=>"".concat(upmBaseUrl, "/rest/plugins/1.0/host-status");
const $3b68cdff11d9fe6c$var$getAllInstalledPluginsUrl = (upmBaseUrl)=>"".concat(upmBaseUrl, "/rest/plugins/1.0/");
async function $3b68cdff11d9fe6c$export$f8f9f9ee7ac59403(upmBaseUrl, appKey) {
    try {
        const result = await (0, $dO8LH.fetchOk)($3b68cdff11d9fe6c$var$getInstalledPluginUrl(upmBaseUrl, appKey), $3b68cdff11d9fe6c$var$defaultOptions(upmBaseUrl));
        const response = await result.json();
        return {
            links: {
                postInstall: response.links['post-install'],
                configure: response.links.configure,
                manage: response.links.manage
            },
            key: response.key
        };
    } catch (error) {
        const InstalledAppFromUPMError = (0, $1w7m1.makeAppFetchError)('InstalledAppFromUPMError');
        throw new InstalledAppFromUPMError({
            source: error,
            appKey: appKey
        });
    }
}
async function $3b68cdff11d9fe6c$export$69e4ce869d45957f(upmBaseUrl, appKey) {
    const response = await (0, $dO8LH.fetch)($3b68cdff11d9fe6c$var$getInstallPermissionsUrl(upmBaseUrl, appKey), $3b68cdff11d9fe6c$var$defaultOptions(upmBaseUrl));
    if (response.status >= 200 && response.status <= 299) return Promise.resolve(true);
    else if (response.status === 401 || response.status === 403) return Promise.resolve(false);
    else return Promise.reject("".concat(response.status, ": ").concat(response.statusText));
}
const $3b68cdff11d9fe6c$var$fetchInstalledMarketplacePluginFromUpm = (upmBaseUrl, appKey, options)=>(0, $dO8LH.fetchOk)($3b68cdff11d9fe6c$var$getInstalledMarketplacePluginUrl(upmBaseUrl, appKey), options).then((response)=>response.json());
const $3b68cdff11d9fe6c$export$e5eee0dc3e886151 = (upmBaseUrl, shouldRetryForLicenseDetails)=>{
    const pollAfter = 3000;
    const optionsForRetry = {
        retries: (0, $gQV53.calculateRetries)(0.16, pollAfter),
        retryDelay: pollAfter,
        credentials: (0, $gQV53.getUPMCredentials)(upmBaseUrl),
        accept: (response)=>response.json().then((bodyJSON)=>{
                if (bodyJSON.licenseDetails === undefined) {
                    (0, $bTrQR.default).info('upmApi', "Retries failed for fetching license details of the app : ".concat(bodyJSON.appKey, " "));
                    throw new Error('Error in fetching license details');
                }
            })
    };
    const optionsForNoRetry = $3b68cdff11d9fe6c$var$defaultOptions(upmBaseUrl);
    if (shouldRetryForLicenseDetails) return optionsForRetry;
    else return optionsForNoRetry;
};
const $3b68cdff11d9fe6c$export$7dddfef125b8b373 = async (upmBaseUrl, appKey, shouldRetryForLicenseDetails)=>{
    try {
        const options = $3b68cdff11d9fe6c$export$e5eee0dc3e886151(upmBaseUrl, shouldRetryForLicenseDetails);
        const result = await $3b68cdff11d9fe6c$var$fetchInstalledMarketplacePluginFromUpm(upmBaseUrl, appKey, options);
        return result;
    } catch (error) {
        const InstalledMarketplacePluginUPMError = (0, $1w7m1.makeAppFetchError)('InstalledMarketplacePluginUPMError');
        throw new InstalledMarketplacePluginUPMError({
            source: error,
            appKey: appKey
        });
    }
};
const $3b68cdff11d9fe6c$export$a4ff2c0f02e68c0b = (upmBaseUrl, appKey, hostCmtEnabled)=>(0, $dO8LH.fetchOk)($3b68cdff11d9fe6c$var$getAvailablePluginUrl(upmBaseUrl, appKey, (0, (/*@__PURE__*/$parcel$interopDefault($kt9Cs))).stringify({
        hostCmtEnabled: hostCmtEnabled
    })), $3b68cdff11d9fe6c$var$defaultOptions(upmBaseUrl)).then((r)=>r.json());
const $3b68cdff11d9fe6c$export$7203b6ab97ad4508 = (upmBaseUrl)=>(0, $dO8LH.fetchOk)($3b68cdff11d9fe6c$var$getAllInstalledMarketplacePluginsUrl(upmBaseUrl), $3b68cdff11d9fe6c$var$defaultOptions(upmBaseUrl)).then((r)=>r.json());
async function $3b68cdff11d9fe6c$export$204e4607d8fa2086(upmBaseUrl) {
    const result = await (0, $dO8LH.fetchOk)($3b68cdff11d9fe6c$var$getAllInstalledPluginsUrl(upmBaseUrl), $3b68cdff11d9fe6c$var$defaultOptions(upmBaseUrl));
    const response = await result.json();
    return response.plugins.filter((app)=>(app.userInstalled || app.usesLicensing) && app.name !== 'Embedded Marketplace').map((app)=>({
            links: {
                postInstall: app.links['post-install'],
                configure: app.links.configure,
                manage: app.links.manage
            },
            key: app.key
        }));
}
const $3b68cdff11d9fe6c$export$ee0bd730334c3b4 = (upmBaseUrl)=>(0, $dO8LH.fetchOk)($3b68cdff11d9fe6c$var$getHostStatusUrl(upmBaseUrl), $3b68cdff11d9fe6c$var$defaultOptions(upmBaseUrl)).then((r)=>r.json());

});


parcelRegister("7jpYj", function(module, exports) {

$parcel$export(module.exports, "default", () => $552e742e5c09f50f$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $je2Cw = parcelRequire("je2Cw");

var $gQV53 = parcelRequire("gQV53");
var $552e742e5c09f50f$var$_class;
let $552e742e5c09f50f$var$Contexts = ($552e742e5c09f50f$var$_class = class Contexts {
    constructor(config){
        (0, $5zQU9.default)(this, "config", void 0);
        this.config = config;
    }
    getMostRecentContext() {
        return Promise.reject();
    }
    getContextInstallationForInstalledAddonContext(_options) {
        return Promise.reject();
    }
    getContextInstallationsForInstalledAddon(_options) {
        return Promise.reject();
    }
    getContext(_options) {
        return Promise.reject();
    }
    getContexts(_options) {
        return Promise.reject();
    }
}, (0, $je2Cw.default)($552e742e5c09f50f$var$_class.prototype, "getMostRecentContext", [
    (0, $gQV53.returnsPromise),
    (0, $gQV53.unsupported)
], Object.getOwnPropertyDescriptor($552e742e5c09f50f$var$_class.prototype, "getMostRecentContext"), $552e742e5c09f50f$var$_class.prototype), (0, $je2Cw.default)($552e742e5c09f50f$var$_class.prototype, "getContextInstallationForInstalledAddonContext", [
    (0, $gQV53.returnsPromise),
    (0, $gQV53.unsupported)
], Object.getOwnPropertyDescriptor($552e742e5c09f50f$var$_class.prototype, "getContextInstallationForInstalledAddonContext"), $552e742e5c09f50f$var$_class.prototype), (0, $je2Cw.default)($552e742e5c09f50f$var$_class.prototype, "getContextInstallationsForInstalledAddon", [
    (0, $gQV53.returnsPromise),
    (0, $gQV53.unsupported)
], Object.getOwnPropertyDescriptor($552e742e5c09f50f$var$_class.prototype, "getContextInstallationsForInstalledAddon"), $552e742e5c09f50f$var$_class.prototype), (0, $je2Cw.default)($552e742e5c09f50f$var$_class.prototype, "getContext", [
    (0, $gQV53.returnsPromise),
    (0, $gQV53.unsupported)
], Object.getOwnPropertyDescriptor($552e742e5c09f50f$var$_class.prototype, "getContext"), $552e742e5c09f50f$var$_class.prototype), (0, $je2Cw.default)($552e742e5c09f50f$var$_class.prototype, "getContexts", [
    (0, $gQV53.returnsPromise),
    (0, $gQV53.unsupported)
], Object.getOwnPropertyDescriptor($552e742e5c09f50f$var$_class.prototype, "getContexts"), $552e742e5c09f50f$var$_class.prototype), $552e742e5c09f50f$var$_class);
var $552e742e5c09f50f$export$2e2bcd8739ae039 = (config)=>(0, $gQV53.instanceToModule)(new $552e742e5c09f50f$var$Contexts(config));

});

parcelRegister("d1veh", function(module, exports) {

$parcel$export(module.exports, "default", () => $97b397d9781ce20f$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $je2Cw = parcelRequire("je2Cw");

var $lyT6v = parcelRequire("lyT6v");

var $gQV53 = parcelRequire("gQV53");

var $dx2bt = parcelRequire("dx2bt");

var $56eyA = parcelRequire("56eyA");
var $97b397d9781ce20f$var$_class;
function $97b397d9781ce20f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $97b397d9781ce20f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $97b397d9781ce20f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $97b397d9781ce20f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
let $97b397d9781ce20f$var$Extra = ($97b397d9781ce20f$var$_class = class Extra {
    constructor(config){
        (0, $5zQU9.default)(this, "config", void 0);
        this.config = config;
    }
    getHostInfo() {
        return Promise.resolve($97b397d9781ce20f$var$_objectSpread($97b397d9781ce20f$var$_objectSpread({
            supports: $dx2bt.supports,
            product: this.config.product
        }, this.config.subproduct ? {
            subproduct: this.config.subproduct
        } : {}), {}, {
            baseUrl: this.config.baseUrl,
            globalContext: (0, $gQV53.buildContext)(this.config)
        }));
    }
    async getHostPricingInfo() {
        if (this.config.product === 'compass') {
            const hostBillingSystem = await (0, $lyT6v.getHostBillingSystem)(this.config.cloudId);
            /* This is being done only for compass apps, excluding billingSystem property
      all the other properties are mocked with dummy data as compass installation doesn't need any of those
      as all the compass apps are free for now. */ return {
                instanceType: 'production',
                evaluation: false,
                currentLicensedUsers: 0,
                renewalType: 'auto',
                maximumLicensedUsers: 0,
                billingCurrency: 'USD',
                subscriptionPeriod: 'monthly',
                hostCmtEnabled: false,
                billingSystem: hostBillingSystem.billingSystem
            };
        }
        const hostStatus = await (0, $56eyA.getHostStatusFromUpm)(this.config.baseUrl);
        return {
            instanceType: hostStatus.instanceType,
            billingSystem: hostStatus.billingSystem,
            evaluation: hostStatus.hostLicense.evaluation,
            currentLicensedUsers: hostStatus.upmLicensedHostUsers,
            renewalType: hostStatus.hostLicense.autoRenewal ? 'auto' : 'quote',
            maximumLicensedUsers: hostStatus.hostLicense.maximumNumberOfUsers,
            billingCurrency: hostStatus.billingCurrency,
            subscriptionPeriod: Object.prototype.hasOwnProperty.call(hostStatus.hostLicense, 'subscriptionAnnual') ? hostStatus.hostLicense.subscriptionAnnual ? 'annual' : 'monthly' : 'monthly',
            hostCmtEnabled: Boolean(hostStatus.hostCmtEnabled)
        };
    }
}, (0, $je2Cw.default)($97b397d9781ce20f$var$_class.prototype, "getHostInfo", [
    (0, $gQV53.returnsPromise)
], Object.getOwnPropertyDescriptor($97b397d9781ce20f$var$_class.prototype, "getHostInfo"), $97b397d9781ce20f$var$_class.prototype), (0, $je2Cw.default)($97b397d9781ce20f$var$_class.prototype, "getHostPricingInfo", [
    (0, $gQV53.returnsPromise)
], Object.getOwnPropertyDescriptor($97b397d9781ce20f$var$_class.prototype, "getHostPricingInfo"), $97b397d9781ce20f$var$_class.prototype), $97b397d9781ce20f$var$_class);
var $97b397d9781ce20f$export$2e2bcd8739ae039 = (config)=>(0, $gQV53.instanceToModule)(new $97b397d9781ce20f$var$Extra(config));

});
parcelRegister("lyT6v", function(module, exports) {

$parcel$export(module.exports, "getHostBillingSystem", () => $fb278475ce5c6093$export$94e02b5509a97c9a);

var $5zQU9 = parcelRequire("5zQU9");

var $dO8LH = parcelRequire("dO8LH");
function $fb278475ce5c6093$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fb278475ce5c6093$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fb278475ce5c6093$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fb278475ce5c6093$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $fb278475ce5c6093$var$defaultDemandApiConfig = {
    credentials: 'include',
    headers: {
        'Content-Type': 'application/json'
    }
};
const $fb278475ce5c6093$var$demandServicePath = '/gateway/api/marketplace/internal/demand';
const $fb278475ce5c6093$var$getSiteDetailsUrl = (mpacBaseUrl, cloudId)=>"".concat(mpacBaseUrl).concat($fb278475ce5c6093$var$demandServicePath, "/site-details/cloud-id/").concat(cloudId);
const $fb278475ce5c6093$export$94e02b5509a97c9a = (cloudId)=>(0, $dO8LH.fetchOk)("/gateway/api/marketplace/internal/demand/billing-system/".concat(cloudId)).then((response)=>response.json());
const $fb278475ce5c6093$export$763ef3b9199a11b4 = async (mpacBaseUrl, cloudId)=>{
    return (await (0, $dO8LH.fetchOk)($fb278475ce5c6093$var$getSiteDetailsUrl(mpacBaseUrl, cloudId), $fb278475ce5c6093$var$_objectSpread({
        method: 'GET'
    }, $fb278475ce5c6093$var$defaultDemandApiConfig))).json();
};

});


parcelRegister("7tJ3W", function(module, exports) {

$parcel$export(module.exports, "default", () => $571e324d87bae977$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $je2Cw = parcelRequire("je2Cw");

var $c0UlX = parcelRequire("c0UlX");
var $1oMwC = parcelRequire("1oMwC");
var $6u78H = parcelRequire("6u78H");

var $ammkg = parcelRequire("ammkg");

var $gQV53 = parcelRequire("gQV53");

var $QaRKt = parcelRequire("QaRKt");

var $c0juV = parcelRequire("c0juV");

var $56eyA = parcelRequire("56eyA");
var $571e324d87bae977$var$_class;
const $571e324d87bae977$var$formatInstallPermissionToSPI = (canInstallApp)=>canInstallApp ? {
        allowed: true
    } : {
        allowed: false,
        message: 'No addon manage permission',
        key: 'noAddonManagePermission'
    };
const $571e324d87bae977$var$checkInstallPermissionFromStargate = (config, marketplaceApp, installPermission)=>{
    const product = config.product;
    if ((0, $1oMwC.isCompatibleMarketplaceProduct)(product)) {
        var _marketplaceApp$versi;
        const paymentModel = (_marketplaceApp$versi = marketplaceApp.version) === null || _marketplaceApp$versi === void 0 ? void 0 : _marketplaceApp$versi.paymentModel;
        return paymentModel === (0, $ammkg.MarketplaceAppPaymentModel).Free ? installPermission !== (0, $c0UlX.AppInstallPermission).CANNOT_INSTALL : installPermission === (0, $c0UlX.AppInstallPermission).CAN_INSTALL_FREE_AND_PAID;
    }
    return false;
};
let $571e324d87bae977$var$Permissions = ($571e324d87bae977$var$_class = class Permissions {
    constructor(config){
        (0, $5zQU9.default)(this, "config", void 0);
        this.config = config;
    }
    async hasInstallPermission(options) {
        return (0, $gQV53.foldPermissionIdentifier)(options.addon)(async (keyIdentifier)=>{
            const response = await (0, $56eyA.getInstallPermissions)(this.config.baseUrl, keyIdentifier.details.key);
            return $571e324d87bae977$var$formatInstallPermissionToSPI(response);
        }, async (ariIdentifier)=>{
            const { gqlGatewayUrl: gqlGatewayUrl } = this.config;
            const product = this.config.product;
            if ((0, $1oMwC.isCompatibleMarketplaceProduct)(product)) {
                const starGateUrl = this.config.environment === 'local' ? "".concat(this.config.baseUrl, "/gateway/api") : '/gateway/api';
                const [marketplaceApp, installPermission] = await Promise.all([
                    (0, $QaRKt.getRawCloudMarketplaceAppByKey)((0, $c0juV.makeAppKey)(ariIdentifier.details.key), gqlGatewayUrl),
                    new (0, $6u78H.default)(starGateUrl).marketplace.appInstallPermission(product, this.config.cloudId)
                ]);
                const permission = $571e324d87bae977$var$checkInstallPermissionFromStargate(this.config, marketplaceApp, installPermission);
                return $571e324d87bae977$var$formatInstallPermissionToSPI(permission);
            } else return $571e324d87bae977$var$formatInstallPermissionToSPI(false);
        });
    }
    hasUninstallPermission(_options) {
        return Promise.reject();
    }
}, (0, $je2Cw.default)($571e324d87bae977$var$_class.prototype, "hasInstallPermission", [
    (0, $gQV53.returnsPromise)
], Object.getOwnPropertyDescriptor($571e324d87bae977$var$_class.prototype, "hasInstallPermission"), $571e324d87bae977$var$_class.prototype), (0, $je2Cw.default)($571e324d87bae977$var$_class.prototype, "hasUninstallPermission", [
    (0, $gQV53.returnsPromise),
    (0, $gQV53.unsupported)
], Object.getOwnPropertyDescriptor($571e324d87bae977$var$_class.prototype, "hasUninstallPermission"), $571e324d87bae977$var$_class.prototype), $571e324d87bae977$var$_class);
var $571e324d87bae977$export$2e2bcd8739ae039 = (config)=>(0, $gQV53.instanceToModule)(new $571e324d87bae977$var$Permissions(config));

});
parcelRegister("c0UlX", function(module, exports) {

$parcel$export(module.exports, "MarketplaceProduct", () => $8bf132ac2f5aa45a$export$f43438c1653c8a7f);
$parcel$export(module.exports, "AppInstallPermission", () => $8bf132ac2f5aa45a$export$6a17a2610f6da8f7);
$parcel$export(module.exports, "StargateCloudProduct", () => $8bf132ac2f5aa45a$export$9024016c479bb2b5);
$parcel$export(module.exports, "StargateAPIErrorCode", () => $8bf132ac2f5aa45a$export$5be4334c4ffb02d2);
$parcel$export(module.exports, "StargatePermissionId", () => $8bf132ac2f5aa45a$export$f9ee0408cd98bfae);
/* MC-2850 Use enums for these to simplify the types */ const $8bf132ac2f5aa45a$export$f43438c1653c8a7f = Object.freeze({
    JIRA: 'jira',
    CONFLUENCE: 'confluence',
    COMPASS: 'compass'
});
const $8bf132ac2f5aa45a$export$6a17a2610f6da8f7 = Object.freeze({
    CAN_INSTALL_FREE_AND_PAID: 'CAN_INSTALL_FREE_AND_PAID',
    CAN_INSTALL_FREE_ONLY: 'CAN_INSTALL_FREE_ONLY',
    CANNOT_INSTALL: 'CANNOT_INSTALL'
});
const $8bf132ac2f5aa45a$export$9024016c479bb2b5 = Object.freeze({
    HIPCHAT: 'hipchat.cloud',
    JIRA_CORE: 'jira-core.ondemand',
    JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
    JIRA_SOFTWARE: 'jira-software.ondemand',
    CONFLUENCE: 'confluence.ondemand',
    COMPASS: 'compass'
});
const $8bf132ac2f5aa45a$export$5be4334c4ffb02d2 = Object.freeze({
    UNAUTHORIZED: 'UNAUTHORIZED_ERROR',
    UNKNOWN: 'UNKNOWN_ERROR'
});
const $8bf132ac2f5aa45a$export$f9ee0408cd98bfae = Object.freeze({
    ADD_PRODUCTS: 'add-products',
    /** @deprecated Legacy. Use `ADD_PRODUCTS` instead */ ADD_PRODUCT: 'addProduct',
    INVITE_USERS: 'invite-users',
    MANAGE: 'manage',
    WRITE: 'write'
});

});

parcelRegister("1oMwC", function(module, exports) {

$parcel$export(module.exports, "toStargateProducts", () => $104dac6fa2ab9eb5$export$af73be4b3ce86fd4);
$parcel$export(module.exports, "isCompatibleMarketplaceProduct", () => $104dac6fa2ab9eb5$export$176cda4e1d690b30);
$parcel$export(module.exports, "toMarketplaceProducts", () => $104dac6fa2ab9eb5$export$6434c425ac61cf94);

var $c0UlX = parcelRequire("c0UlX");
const $104dac6fa2ab9eb5$var$marketplaceStargateProductMapping = Object.freeze({
    [(0, $c0UlX.MarketplaceProduct).JIRA]: [
        (0, $c0UlX.StargateCloudProduct).JIRA_CORE,
        (0, $c0UlX.StargateCloudProduct).JIRA_SERVICE_DESK,
        (0, $c0UlX.StargateCloudProduct).JIRA_SOFTWARE
    ],
    [(0, $c0UlX.MarketplaceProduct).CONFLUENCE]: [
        (0, $c0UlX.StargateCloudProduct).CONFLUENCE
    ],
    [(0, $c0UlX.MarketplaceProduct).COMPASS]: [
        (0, $c0UlX.StargateCloudProduct).COMPASS
    ]
});
const $104dac6fa2ab9eb5$var$toMarketplaceProduct = (stargateProduct)=>{
    const marketplaceProducts = Object.keys($104dac6fa2ab9eb5$var$marketplaceStargateProductMapping);
    return marketplaceProducts.find((product)=>$104dac6fa2ab9eb5$var$marketplaceStargateProductMapping[product].includes(stargateProduct));
};
const $104dac6fa2ab9eb5$export$af73be4b3ce86fd4 = (marketplaceProducts)=>marketplaceProducts.flatMap((product)=>$104dac6fa2ab9eb5$var$marketplaceStargateProductMapping[product]).filter((product)=>!!product);
const $104dac6fa2ab9eb5$export$176cda4e1d690b30 = (marketplaceProduct)=>marketplaceProduct === 'jira' || marketplaceProduct === 'confluence' || marketplaceProduct === 'compass';
const $104dac6fa2ab9eb5$export$6434c425ac61cf94 = (stargateProducts)=>{
    const marketplaceProducts = new Set();
    stargateProducts.forEach((stargateProduct)=>{
        const marketplaceProduct = $104dac6fa2ab9eb5$var$toMarketplaceProduct(stargateProduct);
        if (marketplaceProduct) marketplaceProducts.add(marketplaceProduct);
    });
    return [
        ...marketplaceProducts
    ];
};

});

parcelRegister("6u78H", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b8b1522bc0df4cd$export$2e2bcd8739ae039);

var $f5aYf = parcelRequire("f5aYf");


var $4b8b1522bc0df4cd$export$2e2bcd8739ae039 = (0, $f5aYf.default);

});
parcelRegister("f5aYf", function(module, exports) {

$parcel$export(module.exports, "default", () => $afafd5384b9407b2$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
parcelRequire("jULLl");
var $jGreP = parcelRequire("jGreP");

var $gsf25 = parcelRequire("gsf25");

var $2c2FY = parcelRequire("2c2FY");

var $c0UlX = parcelRequire("c0UlX");
class $afafd5384b9407b2$export$2e2bcd8739ae039 {
    constructor(baseUrl){
        (0, $5zQU9.default)(this, "_api", void 0);
        (0, $5zQU9.default)(this, "marketplace", (0, $2c2FY.default)(this));
        this._api = (0, $jGreP.default).create({
            prefixUrl: baseUrl
        });
    }
    /**
   * Get available sites for the logged in Atlassian Account session
   * @throws {StargateAPIError}
   */ async availableSites(products) {
        try {
            return await this._api.post('available-sites', {
                json: {
                    products: products
                }
            }).json();
        } catch (error) {
            const { status: status, response: response } = await (0, $gsf25.parseError)(error);
            throw (0, $gsf25.makeAPIError)({
                name: 'AvailableSitesError',
                code: status === 401 ? (0, $c0UlX.StargateAPIErrorCode).UNAUTHORIZED : (0, $c0UlX.StargateAPIErrorCode).UNKNOWN,
                response: response
            });
        }
    }
    /**
   * Get whether a user has a permission for a particular resource
   * @throws {StargateAPIError}
   */ async permitted(permissionId, resourceId) {
        try {
            return await this._api.post('permissions/permitted', {
                json: {
                    permissionId: permissionId,
                    resourceId: resourceId
                }
            }).json();
        } catch (error) {
            const { status: status, response: response } = await (0, $gsf25.parseError)(error);
            throw (0, $gsf25.makeAPIError)({
                name: 'PermittedError',
                code: status === 401 ? (0, $c0UlX.StargateAPIErrorCode).UNAUTHORIZED : (0, $c0UlX.StargateAPIErrorCode).UNKNOWN,
                response: response
            });
        }
    }
}

});
parcelRegister("jULLl", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("jGreP")).default);

var $jGreP = parcelRequire("jGreP");

});
parcelRegister("jGreP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e54711839dd73311$export$2e2bcd8739ae039);
/*! MIT License © Sindre Sorhus */ const $e54711839dd73311$var$globals = {};
const $e54711839dd73311$var$getGlobal = (property)=>{
    /* istanbul ignore next */ if (typeof self !== 'undefined' && self && property in self) return self;
    /* istanbul ignore next */ if (typeof window !== 'undefined' && window && property in window) return window;
    if (typeof $parcel$global !== 'undefined' && $parcel$global && property in $parcel$global) return $parcel$global;
    /* istanbul ignore next */ if (typeof globalThis !== 'undefined' && globalThis) return globalThis;
};
const $e54711839dd73311$var$globalProperties = [
    'Headers',
    'Request',
    'Response',
    'ReadableStream',
    'fetch',
    'AbortController',
    'FormData'
];
for (const property of $e54711839dd73311$var$globalProperties)Object.defineProperty($e54711839dd73311$var$globals, property, {
    get () {
        const globalObject = $e54711839dd73311$var$getGlobal(property);
        const value = globalObject && globalObject[property];
        return typeof value === 'function' ? value.bind(globalObject) : value;
    }
});
const $e54711839dd73311$var$isObject = (value)=>value !== null && typeof value === 'object';
const $e54711839dd73311$var$supportsAbortController = typeof $e54711839dd73311$var$globals.AbortController === 'function';
const $e54711839dd73311$var$supportsStreams = typeof $e54711839dd73311$var$globals.ReadableStream === 'function';
const $e54711839dd73311$var$deepMerge = (...sources)=>{
    let returnValue = {};
    for (const source of sources){
        if (Array.isArray(source)) {
            if (!Array.isArray(returnValue)) returnValue = [];
            returnValue = [
                ...returnValue,
                ...source
            ];
        } else if ($e54711839dd73311$var$isObject(source)) for (let [key, value] of Object.entries(source)){
            if ($e54711839dd73311$var$isObject(value) && Reflect.has(returnValue, key)) value = $e54711839dd73311$var$deepMerge(returnValue[key], value);
            returnValue = {
                ...returnValue,
                [key]: value
            };
        }
    }
    return returnValue;
};
const $e54711839dd73311$var$requestMethods = [
    'get',
    'post',
    'put',
    'patch',
    'head',
    'delete'
];
const $e54711839dd73311$var$responseTypes = {
    json: 'application/json',
    text: 'text/*',
    formData: 'multipart/form-data',
    arrayBuffer: '*/*',
    blob: '*/*'
};
const $e54711839dd73311$var$retryMethods = [
    'get',
    'put',
    'head',
    'delete',
    'options',
    'trace'
];
const $e54711839dd73311$var$retryStatusCodes = [
    408,
    413,
    429,
    500,
    502,
    503,
    504
];
const $e54711839dd73311$var$retryAfterStatusCodes = [
    413,
    429,
    503
];
const $e54711839dd73311$var$stop = Symbol('stop');
class $e54711839dd73311$export$aa9d629c530f62a7 extends Error {
    constructor(response){
        super(response.statusText);
        this.name = 'HTTPError';
        this.response = response;
    }
}
class $e54711839dd73311$export$66d311bf29d5c89c extends Error {
    constructor(){
        super('Request timed out');
        this.name = 'TimeoutError';
    }
}
const $e54711839dd73311$var$delay = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
// `Promise.race()` workaround (#91)
const $e54711839dd73311$var$timeout = (promise, ms, abortController)=>new Promise((resolve, reject)=>{
        const timeoutID = setTimeout(()=>{
            if (abortController) abortController.abort();
            reject(new $e54711839dd73311$export$66d311bf29d5c89c());
        }, ms);
        /* eslint-disable promise/prefer-await-to-then */ promise.then(resolve).catch(reject).then(()=>{
            clearTimeout(timeoutID);
        });
    /* eslint-enable promise/prefer-await-to-then */ });
const $e54711839dd73311$var$normalizeRequestMethod = (input)=>$e54711839dd73311$var$requestMethods.includes(input) ? input.toUpperCase() : input;
const $e54711839dd73311$var$defaultRetryOptions = {
    limit: 2,
    methods: $e54711839dd73311$var$retryMethods,
    statusCodes: $e54711839dd73311$var$retryStatusCodes,
    afterStatusCodes: $e54711839dd73311$var$retryAfterStatusCodes
};
const $e54711839dd73311$var$normalizeRetryOptions = (retry = {})=>{
    if (typeof retry === 'number') return {
        ...$e54711839dd73311$var$defaultRetryOptions,
        limit: retry
    };
    if (retry.methods && !Array.isArray(retry.methods)) throw new Error('retry.methods must be an array');
    if (retry.statusCodes && !Array.isArray(retry.statusCodes)) throw new Error('retry.statusCodes must be an array');
    return {
        ...$e54711839dd73311$var$defaultRetryOptions,
        ...retry,
        afterStatusCodes: $e54711839dd73311$var$retryAfterStatusCodes
    };
};
// The maximum value of a 32bit int (see issue #117)
const $e54711839dd73311$var$maxSafeTimeout = 2147483647;
class $e54711839dd73311$var$Ky {
    constructor(input, options = {}){
        this._retryCount = 0;
        this._input = input;
        this._options = {
            // TODO: credentials can be removed when the spec change is implemented in all browsers. Context: https://www.chromestatus.com/feature/4539473312350208
            credentials: this._input.credentials || 'same-origin',
            ...options,
            hooks: $e54711839dd73311$var$deepMerge({
                beforeRequest: [],
                beforeRetry: [],
                afterResponse: []
            }, options.hooks),
            method: $e54711839dd73311$var$normalizeRequestMethod(options.method || this._input.method),
            prefixUrl: String(options.prefixUrl || ''),
            retry: $e54711839dd73311$var$normalizeRetryOptions(options.retry),
            throwHttpErrors: options.throwHttpErrors !== false,
            timeout: typeof options.timeout === 'undefined' ? 10000 : options.timeout
        };
        if (typeof this._input !== 'string' && !(this._input instanceof URL || this._input instanceof $e54711839dd73311$var$globals.Request)) throw new TypeError('`input` must be a string, URL, or Request');
        if (this._options.prefixUrl && typeof this._input === 'string') {
            if (this._input.startsWith('/')) throw new Error('`input` must not begin with a slash when using `prefixUrl`');
            if (!this._options.prefixUrl.endsWith('/')) this._options.prefixUrl += '/';
            this._input = this._options.prefixUrl + this._input;
        }
        if ($e54711839dd73311$var$supportsAbortController) {
            this.abortController = new $e54711839dd73311$var$globals.AbortController();
            if (this._options.signal) {
                this._options.signal.addEventListener('abort', ()=>{
                    this.abortController.abort();
                });
                this._options.signal = this.abortController.signal;
            }
        }
        this.request = new $e54711839dd73311$var$globals.Request(this._input, this._options);
        if (this._options.searchParams) {
            const url = new URL(this.request.url);
            url.search = new URLSearchParams(this._options.searchParams);
            this.request = new $e54711839dd73311$var$globals.Request(new $e54711839dd73311$var$globals.Request(url, this.request), this._options);
        }
        if (this._options.json !== undefined) {
            this._options.body = JSON.stringify(this._options.json);
            this.request.headers.set('content-type', 'application/json');
            this.request = new $e54711839dd73311$var$globals.Request(this.request, {
                body: this._options.body
            });
        }
        const fn = async ()=>{
            if (this._options.timeout > $e54711839dd73311$var$maxSafeTimeout) throw new RangeError(`The \`timeout\` option cannot be greater than ${$e54711839dd73311$var$maxSafeTimeout}`);
            await $e54711839dd73311$var$delay(1);
            let response = await this._fetch();
            for (const hook of this._options.hooks.afterResponse){
                // eslint-disable-next-line no-await-in-loop
                const modifiedResponse = await hook(this.request, this._options, response.clone());
                if (modifiedResponse instanceof $e54711839dd73311$var$globals.Response) response = modifiedResponse;
            }
            if (!response.ok && this._options.throwHttpErrors) throw new $e54711839dd73311$export$aa9d629c530f62a7(response);
            // If `onDownloadProgress` is passed, it uses the stream API internally
            /* istanbul ignore next */ if (this._options.onDownloadProgress) {
                if (typeof this._options.onDownloadProgress !== 'function') throw new TypeError('The `onDownloadProgress` option must be a function');
                if (!$e54711839dd73311$var$supportsStreams) throw new Error('Streams are not supported in your environment. `ReadableStream` is missing.');
                return this._stream(response.clone(), this._options.onDownloadProgress);
            }
            return response;
        };
        const isRetriableMethod = this._options.retry.methods.includes(this.request.method.toLowerCase());
        const result = isRetriableMethod ? this._retry(fn) : fn();
        for (const [type, mimeType] of Object.entries($e54711839dd73311$var$responseTypes))result[type] = async ()=>{
            this.request.headers.set('accept', this.request.headers.get('accept') || mimeType);
            const response = (await result).clone();
            return type === 'json' && response.status === 204 ? '' : response[type]();
        };
        return result;
    }
    _calculateRetryDelay(error) {
        this._retryCount++;
        if (this._retryCount < this._options.retry.limit && !(error instanceof $e54711839dd73311$export$66d311bf29d5c89c)) {
            if (error instanceof $e54711839dd73311$export$aa9d629c530f62a7) {
                if (!this._options.retry.statusCodes.includes(error.response.status)) return 0;
                const retryAfter = error.response.headers.get('Retry-After');
                if (retryAfter && this._options.retry.afterStatusCodes.includes(error.response.status)) {
                    let after = Number(retryAfter);
                    if (Number.isNaN(after)) after = Date.parse(retryAfter) - Date.now();
                    else after *= 1000;
                    if (typeof this._options.retry.maxRetryAfter !== 'undefined' && after > this._options.retry.maxRetryAfter) return 0;
                    return after;
                }
                if (error.response.status === 413) return 0;
            }
            const BACKOFF_FACTOR = 0.3;
            return BACKOFF_FACTOR * 2 ** (this._retryCount - 1) * 1000;
        }
        return 0;
    }
    async _retry(fn) {
        try {
            return await fn();
        } catch (error) {
            const ms = Math.min(this._calculateRetryDelay(error), $e54711839dd73311$var$maxSafeTimeout);
            if (ms !== 0 && this._retryCount > 0) {
                await $e54711839dd73311$var$delay(ms);
                for (const hook of this._options.hooks.beforeRetry){
                    // eslint-disable-next-line no-await-in-loop
                    const hookResult = await hook(this.request, this._options, error, this._retryCount);
                    // If `stop` is returned from the hook, the retry process is stopped
                    if (hookResult === $e54711839dd73311$var$stop) return;
                }
                return this._retry(fn);
            }
            if (this._options.throwHttpErrors) throw error;
        }
    }
    async _fetch() {
        for (const hook of this._options.hooks.beforeRequest){
            // eslint-disable-next-line no-await-in-loop
            const result = await hook(this.request, this._options);
            if (result instanceof Request) {
                this.request = result;
                break;
            }
            if (result instanceof Response) return result;
        }
        if (this._options.timeout === false) return $e54711839dd73311$var$globals.fetch(this.request);
        return $e54711839dd73311$var$timeout($e54711839dd73311$var$globals.fetch(this.request), this._options.timeout, this.abortController);
    }
    /* istanbul ignore next */ _stream(response, onDownloadProgress) {
        const totalBytes = Number(response.headers.get('content-length')) || 0;
        let transferredBytes = 0;
        return new $e54711839dd73311$var$globals.Response(new $e54711839dd73311$var$globals.ReadableStream({
            start (controller) {
                const reader = response.body.getReader();
                if (onDownloadProgress) onDownloadProgress({
                    percent: 0,
                    transferredBytes: 0,
                    totalBytes: totalBytes
                }, new Uint8Array());
                async function read() {
                    const { done: done, value: value } = await reader.read();
                    if (done) {
                        controller.close();
                        return;
                    }
                    if (onDownloadProgress) {
                        transferredBytes += value.byteLength;
                        const percent = totalBytes === 0 ? 0 : transferredBytes / totalBytes;
                        onDownloadProgress({
                            percent: percent,
                            transferredBytes: transferredBytes,
                            totalBytes: totalBytes
                        }, value);
                    }
                    controller.enqueue(value);
                    read();
                }
                read();
            }
        }));
    }
}
const $e54711839dd73311$var$validateAndMerge = (...sources)=>{
    for (const source of sources){
        if ((!$e54711839dd73311$var$isObject(source) || Array.isArray(source)) && typeof source !== 'undefined') throw new TypeError('The `options` argument must be an object');
    }
    return $e54711839dd73311$var$deepMerge({}, ...sources);
};
const $e54711839dd73311$var$createInstance = (defaults)=>{
    const ky = (input, options)=>new $e54711839dd73311$var$Ky(input, $e54711839dd73311$var$validateAndMerge(defaults, options));
    for (const method of $e54711839dd73311$var$requestMethods)ky[method] = (input, options)=>new $e54711839dd73311$var$Ky(input, $e54711839dd73311$var$validateAndMerge(defaults, options, {
            method: method
        }));
    ky.create = (newDefaults)=>$e54711839dd73311$var$createInstance($e54711839dd73311$var$validateAndMerge(newDefaults));
    ky.extend = (newDefaults)=>$e54711839dd73311$var$createInstance($e54711839dd73311$var$validateAndMerge(defaults, newDefaults));
    ky.stop = $e54711839dd73311$var$stop;
    return ky;
};
var $e54711839dd73311$export$2e2bcd8739ae039 = $e54711839dd73311$var$createInstance();

});


parcelRegister("gsf25", function(module, exports) {

$parcel$export(module.exports, "parseError", () => $bfaaec0c999e8fbf$export$e80a9284539c1797);
$parcel$export(module.exports, "makeAPIError", () => $bfaaec0c999e8fbf$export$d5526006016d9ee2);

var $h1LeU = parcelRequire("h1LeU");
async function $bfaaec0c999e8fbf$export$e80a9284539c1797(error) {
    var _error$response;
    let response;
    if (error.response) try {
        response = await error.response.json();
    } catch (_unused) {
        try {
            response = await error.response.text();
        } catch (_unused2) {
            console.error('parseError: failed to parse response', error);
        }
    }
    return {
        status: (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status,
        response: response
    };
}
function $bfaaec0c999e8fbf$export$d5526006016d9ee2(_ref) {
    let { name: name, code: code, response: response } = _ref;
    const APIError = (0, $h1LeU.default)(name);
    return new APIError({
        code: code,
        message: "".concat(name, " error"),
        meta: {
            response: response
        }
    });
}

});

parcelRegister("2c2FY", function(module, exports) {

$parcel$export(module.exports, "default", () => $198ec72bb799401e$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $c0UlX = parcelRequire("c0UlX");

var $1oMwC = parcelRequire("1oMwC");
function $198ec72bb799401e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $198ec72bb799401e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $198ec72bb799401e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $198ec72bb799401e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $198ec72bb799401e$export$2e2bcd8739ae039(self) {
    return {
        async appInstallPermission (product, cloudId) {
            const productAdminPermittedPromise = self.permitted((0, $c0UlX.StargatePermissionId).MANAGE, "ari:cloud:".concat(product, "::site/").concat(cloudId));
            const siteAdminPermittedPromise = self.permitted((0, $c0UlX.StargatePermissionId).MANAGE, "ari:cloud:platform::site/".concat(cloudId));
            const [productAdminPermission, siteAdminPermission] = await Promise.all([
                productAdminPermittedPromise,
                siteAdminPermittedPromise
            ]);
            return siteAdminPermission.permitted ? (0, $c0UlX.AppInstallPermission).CAN_INSTALL_FREE_AND_PAID : productAdminPermission.permitted ? (0, $c0UlX.AppInstallPermission).CAN_INSTALL_FREE_ONLY : (0, $c0UlX.AppInstallPermission).CANNOT_INSTALL;
        },
        async availableSites (products) {
            const stargateProducts = (0, $1oMwC.toStargateProducts)(products);
            const { sites: sites } = await self.availableSites(stargateProducts);
            const marketplaceSites = sites.map((site)=>$198ec72bb799401e$var$_objectSpread($198ec72bb799401e$var$_objectSpread({}, site), {}, {
                    products: (0, $1oMwC.toMarketplaceProducts)(site.products)
                }));
            return {
                sites: marketplaceSites
            };
        }
    };
}

});




parcelRegister("4J2mT", function(module, exports) {

$parcel$export(module.exports, "default", () => $370d33b009b124df$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $je2Cw = parcelRequire("je2Cw");

var $dO8LH = parcelRequire("dO8LH");

var $k4nIh = parcelRequire("k4nIh");

var $gQV53 = parcelRequire("gQV53");
var $370d33b009b124df$var$_class;
const $370d33b009b124df$var$getStargateMarketplaceUrl = (siteBaseUrl, stargatePath)=>"".concat(siteBaseUrl, "/gateway/api/marketplace").concat(stargatePath);
let $370d33b009b124df$var$StargateMarketplaceApi = ($370d33b009b124df$var$_class = class StargateMarketplaceApi {
    constructor(config){
        (0, $5zQU9.default)(this, "config", void 0);
        (0, $5zQU9.default)(this, "siteBaseUrl", void 0);
        this.config = config;
        // Stargate APIs are available only on the base url excluding wiki
        this.siteBaseUrl = new (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(this.config.baseUrl).origin;
    }
    async fetchOk(url, options) {
        let response;
        try {
            response = await (0, $dO8LH.fetchOk)($370d33b009b124df$var$getStargateMarketplaceUrl(this.siteBaseUrl, url), options);
            const responseJson = await response.json();
            return Promise.resolve(responseJson);
        } catch (error) {
            if (response && response.ok) return Promise.resolve({
                status: response.status
            });
            return Promise.reject(error);
        }
    }
    async fetch(url, options) {
        return (0, $dO8LH.fetch)($370d33b009b124df$var$getStargateMarketplaceUrl(this.siteBaseUrl, url), options);
    }
}, (0, $je2Cw.default)($370d33b009b124df$var$_class.prototype, "fetchOk", [
    (0, $gQV53.returnsPromise)
], Object.getOwnPropertyDescriptor($370d33b009b124df$var$_class.prototype, "fetchOk"), $370d33b009b124df$var$_class.prototype), (0, $je2Cw.default)($370d33b009b124df$var$_class.prototype, "fetch", [
    (0, $gQV53.returnsPromise)
], Object.getOwnPropertyDescriptor($370d33b009b124df$var$_class.prototype, "fetch"), $370d33b009b124df$var$_class.prototype), $370d33b009b124df$var$_class);
var $370d33b009b124df$export$2e2bcd8739ae039 = (config)=>(0, $gQV53.instanceToModule)(new $370d33b009b124df$var$StargateMarketplaceApi(config));

});

parcelRegister("lpNoO", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9724069834fcc01$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $je2Cw = parcelRequire("je2Cw");

var $dO8LH = parcelRequire("dO8LH");

var $gQV53 = parcelRequire("gQV53");
var $f9724069834fcc01$var$_class;
let $f9724069834fcc01$var$User = ($f9724069834fcc01$var$_class = class User {
    constructor(config){
        (0, $5zQU9.default)(this, "config", void 0);
        this.config = config;
    }
    async getCurrentUser() {
        const response = await (0, $dO8LH.fetchOk)('/gateway/api/me');
        const result = await response.json();
        return {
            atlassianAccountId: result.account_id,
            name: result.name,
            avatarUrl: result.picture,
            email: result.email
        };
    }
    revokeUserGrant(_options) {
        return Promise.reject();
    }
}, (0, $je2Cw.default)($f9724069834fcc01$var$_class.prototype, "getCurrentUser", [
    (0, $gQV53.returnsPromise)
], Object.getOwnPropertyDescriptor($f9724069834fcc01$var$_class.prototype, "getCurrentUser"), $f9724069834fcc01$var$_class.prototype), (0, $je2Cw.default)($f9724069834fcc01$var$_class.prototype, "revokeUserGrant", [
    (0, $gQV53.returnsPromise),
    (0, $gQV53.unsupported)
], Object.getOwnPropertyDescriptor($f9724069834fcc01$var$_class.prototype, "revokeUserGrant"), $f9724069834fcc01$var$_class.prototype), $f9724069834fcc01$var$_class);
var $f9724069834fcc01$export$2e2bcd8739ae039 = (config)=>(0, $gQV53.instanceToModule)(new $f9724069834fcc01$var$User(config));

});


parcelRegister("hdXYz", function(module, exports) {

$parcel$export(module.exports, "getAppInstallConfigForEnv", () => $c8a22c837d65b323$export$7d6ff3253552718a);
$parcel$export(module.exports, "default", () => $c8a22c837d65b323$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $je5kZ = parcelRequire("je5kZ");

var $96IgR = parcelRequire("96IgR");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $j0gMm = parcelRequire("j0gMm");

var $kU8RF = parcelRequire("kU8RF");

var $9e16A = parcelRequire("9e16A");

var $inwKI = parcelRequire("inwKI");

var $beqRW = parcelRequire("beqRW");
var $5s4ZL = parcelRequire("5s4ZL");

var $eUqFw = parcelRequire("eUqFw");

var $i7RVQ = parcelRequire("i7RVQ");

var $4s0An = parcelRequire("4s0An");

var $k5vUT = parcelRequire("k5vUT");

var $iEgm6 = parcelRequire("iEgm6");

var $2FaVi = parcelRequire("2FaVi");

var $2dt3P = parcelRequire("2dt3P");

var $05YC4 = parcelRequire("05YC4");

var $eJGKo = parcelRequire("eJGKo");

var $g9u53 = parcelRequire("g9u53");

var $iEdQ1 = parcelRequire("iEdQ1");
function $c8a22c837d65b323$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c8a22c837d65b323$export$7326e6d938a8137b = (0, $3UXZ8.default)("img", {
    target: "ea12xvj0",
    label: "ErrorImage"
})({
    name: "k9yj44",
    styles: "margin:auto;margin-top:var(--ds-space-500, 40px);margin-bottom:50px;width:125px;height:105px;"
});
const $c8a22c837d65b323$var$FallbackUIContentWrapper = (0, $3UXZ8.default)("div", {
    target: "ea12xvj1",
    label: "FallbackUIContentWrapper"
})({
    name: "1ydity8",
    styles: "max-width:650px;min-height:300px;margin:auto;display:flex;flex-direction:column;align-items:center;"
});
const $c8a22c837d65b323$var$DialogContentWrapper = (0, $3UXZ8.default)("div", {
    target: "ea12xvj2",
    label: "DialogContentWrapper"
})({
    name: "1t9oc18",
    styles: "max-width:650px;min-height:300px;margin:auto;"
});
const $c8a22c837d65b323$var$FallbackUIContent = (0, $3UXZ8.default)("div", {
    target: "ea12xvj3",
    label: "FallbackUIContent"
})({
    name: "u4p24i",
    styles: "display:flex;flex-direction:row;align-items:center;"
});
function $c8a22c837d65b323$var$foldPromiseState(promiseState, onError, onPending, onResultRetrieved) {
    const { pending: pending, error: error, result: result } = promiseState;
    if (error) return onError();
    if (pending) return onPending();
    return onResultRetrieved(result);
}
const $c8a22c837d65b323$export$7d6ff3253552718a = (environment)=>{
    const applicationConfig = (0, $iEgm6.getApplicationConfigForEnv)(environment);
    const appInstallConfig = {
        adminHubBaseUrl: applicationConfig.adminHubBaseUrl,
        mpacBaseUrl: applicationConfig.mpacBaseUrl,
        mpacCdnBaseUrl: applicationConfig.mpacCdnBaseUrl,
        macBaseUrl: applicationConfig.macBaseUrl,
        wacBaseUrl: applicationConfig.wacBaseUrl,
        atlassianCommunityBaseUrl: applicationConfig.atlassianCommunityBaseUrl,
        graphQLGatewayUrl: applicationConfig.graphQLGatewayUrl,
        sentryConfig: applicationConfig.sentry,
        analytics: applicationConfig.analytics,
        environment: environment,
        algoliaConfig: applicationConfig.algolia
    };
    return appInstallConfig;
};
const $c8a22c837d65b323$var$resolveDialog = (_ref)=>{
    let { mpacBaseUrl: mpacBaseUrl, appInstallBaseData: appInstallBaseData, links: links, onInstallClick: onInstallClick, onClose: onClose, onRendered: onRendered, featureFlags: featureFlags, isInstallInProgress: isInstallInProgress, appDetailsFromSearchResponse: appDetailsFromSearchResponse } = _ref;
    const { hostData: hostData, installMode: installMode, scopesLookup: scopesLookup, forgeAppEgressAddresses: forgeAppEgressAddresses } = appInstallBaseData;
    const { hostInfo: hostInfo, hostConfig: hostConfig, hostLicense: hostLicense } = hostData;
    if (![
        (0, $4s0An.INSTALLABLE_APP_DEFAULT_INSTALL_MODE),
        (0, $k5vUT.INSTRUCTIONAL_INSTALL_MODE)
    ].includes(installMode.type)) throw new Error("AppInstallDialog: Unhandled installMode received ".concat(installMode.type));
    const { content: content, footerLeft: footerLeft, footerCenter: footerCenter, footerRight: footerRight, errorDetails: errorDetails, privacyInformation: privacyInformation } = installMode.type === (0, $k5vUT.INSTRUCTIONAL_INSTALL_MODE) ? (0, $g9u53.default)({
        closeInstallDialog: onClose,
        appDetailsFromSearchResponse: appDetailsFromSearchResponse,
        instructionalInstallMode: installMode,
        links: links,
        onRendered: onRendered
    }) : (0, $eJGKo.default)({
        closeInstallDialog: onClose,
        context: hostInfo.globalContext,
        defaultInstallMode: installMode,
        hostConfig: hostConfig,
        appDetailsFromSearchResponse: appDetailsFromSearchResponse,
        hostPricing: {
            pending: false,
            result: hostLicense,
            error: null
        },
        installApp: onInstallClick,
        hostInfo: hostInfo,
        links: links,
        mpacBaseUrl: mpacBaseUrl,
        scopesLookup: scopesLookup,
        onRendered: onRendered,
        featureFlags: featureFlags,
        isInstallInProgress: isInstallInProgress,
        forgeAppEgressAddresses: forgeAppEgressAddresses
    });
    const modalDialogContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2dt3P.default), {
        installMode: installMode,
        content: content,
        errorDetails: errorDetails
    });
    const modalDialogFooter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $05YC4.default), {
        footerLeft: footerLeft,
        footerCenter: footerCenter,
        footerRight: footerRight,
        privacyInformation: privacyInformation
    });
    const getModalDialogHeading = ()=>installMode.type === (0, $k5vUT.INSTRUCTIONAL_INSTALL_MODE) ? 'Installation instructions' : "Add to ".concat(hostConfig.installationLocation);
    return {
        modalDialogHeading: getModalDialogHeading(),
        modalDialogContent: modalDialogContent,
        modalDialogFooter: modalDialogFooter
    };
};
function $c8a22c837d65b323$var$AppInstallDialog(_ref2) {
    let { onClose: onClose, appInstallConfig: appInstallConfig, onInstallClick: _onInstallClick, baseData: baseData, appKey: appKey, onRendered: onRendered, isInstallInProgress: isInstallInProgress } = _ref2;
    const featureFlags = (0, $inwKI.useFeatureFlags)();
    const links = (0, $iEdQ1.useLinkTemplates)({
        adminHubBaseUrl: appInstallConfig.adminHubBaseUrl,
        mpacBaseUrl: appInstallConfig.mpacBaseUrl,
        mpacCdnBaseUrl: appInstallConfig.mpacCdnBaseUrl,
        macBaseUrl: appInstallConfig.macBaseUrl,
        wacBaseUrl: appInstallConfig.wacBaseUrl,
        atlassianCommunityBaseUrl: appInstallConfig.atlassianCommunityBaseUrl
    });
    const appDetailsFromSearchResponse = (0, $9e16A.useGetAppDetailsFromSearch)({
        algoliaConfig: appInstallConfig.algoliaConfig,
        appKey: appKey
    });
    const { modalDialogHeading: modalDialogHeading, modalDialogContent: modalDialogContent, modalDialogFooter: modalDialogFooter } = $c8a22c837d65b323$var$foldPromiseState(baseData, ()=>{
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2FaVi.default), {
            icon: "error"
        }, "We ran into a little trouble");
        return {
            modalDialogHeading: 'Error',
            modalDialogContent: content,
            modalDialogFooter: null
        };
    }, ()=>({
            modalDialogHeading: 'Loading...',
            modalDialogContent: null,
            modalDialogFooter: null
        }), (result)=>{
        return $c8a22c837d65b323$var$resolveDialog({
            mpacBaseUrl: appInstallConfig.mpacBaseUrl,
            appInstallBaseData: result,
            links: links,
            onInstallClick: ()=>_onInstallClick(result.appIdentifier),
            onClose: onClose,
            onRendered: onRendered,
            featureFlags: featureFlags,
            isInstallInProgress: isInstallInProgress,
            appDetailsFromSearchResponse: appDetailsFromSearchResponse
        });
    });
    const fallbackUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        width: "large",
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, "Error in App Installation"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($je5kZ))), {
        label: "Close"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c8a22c837d65b323$var$FallbackUIContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c8a22c837d65b323$export$7326e6d938a8137b, {
        alt: "Error",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5s4ZL)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c8a22c837d65b323$var$FallbackUIContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        primaryColor: "var(--ds-icon-danger, ".concat((0, $j0gMm.R400), ")")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, "Try again later.")))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $beqRW.default), {
        boundaryName: "marketplaceAppInstallDialog",
        fallback: fallbackUI
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        width: "large",
        onClose: onClose,
        testId: (0, $i7RVQ.SELECTORS).TEST_ID_APP_INSTALL_DIALOG
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, modalDialogHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c8a22c837d65b323$var$DialogContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kU8RF.default), {
        active: baseData.pending,
        delay: 1000,
        size: 50
    }, modalDialogContent))), modalDialogFooter));
}
var $c8a22c837d65b323$export$2e2bcd8739ae039 = $c8a22c837d65b323$var$AppInstallDialog;

});
parcelRegister("je5kZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dff3771012ed2785$var$_react = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $dff3771012ed2785$var$_close = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("02Sz7")));
function $dff3771012ed2785$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dff3771012ed2785$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $dff3771012ed2785$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $dff3771012ed2785$var$_close.default
    }));
$dff3771012ed2785$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $dff3771012ed2785$var$_default = module.exports.default = $dff3771012ed2785$var$EditorCloseIcon;

});

parcelRegister("9e16A", function(module, exports) {

$parcel$export(module.exports, "useGetAppDetailsFromSearch", () => $6b76475531771fe7$export$702f0d5605b87956);

var $9l6Pq = parcelRequire("9l6Pq");

var $bTrQR = parcelRequire("bTrQR");
var $fBO3c = parcelRequire("fBO3c");

var $6BoHr = parcelRequire("6BoHr");

var $eUqFw = parcelRequire("eUqFw");
const $6b76475531771fe7$export$702f0d5605b87956 = (_ref)=>{
    let { appId: appId, appKey: appKey, algoliaConfig: algoliaConfig } = _ref;
    const [appData, setAppData] = (0, $eUqFw.useState)(null);
    const [appDataStatus, setAppDataStatus] = (0, $eUqFw.useState)('idle');
    const { environment: algoliaEnvironment, applicationId: applicationId, apiKey: apiKey } = algoliaConfig;
    const searchClient = (0, (/*@__PURE__*/$parcel$interopDefault($6BoHr)))(applicationId, apiKey);
    const { enableAlgoliaCallOnAppListingAndDialogs: enableAlgoliaCallOnAppListingAndDialogs } = (0, $9l6Pq.useStatsig)();
    const isAlgoliaSearchEnabled = enableAlgoliaCallOnAppListingAndDialogs();
    const shouldFetchAppData = isAlgoliaSearchEnabled && (appId || appKey);
    (0, $eUqFw.useEffect)(()=>{
        async function getAppData() {
            try {
                if (!shouldFetchAppData) return;
                const indexName = (0, $fBO3c.resolveAlgoliaSearchIndex)(algoliaEnvironment, true);
                const searchParams = {};
                if (appKey) searchParams.facetFilters = [
                    "addonKey:".concat(appKey)
                ];
                if (appId) searchParams.numericFilters = "addonId=".concat(appId);
                setAppDataStatus('loading');
                const response = await searchClient.search([
                    {
                        indexName: indexName,
                        params: searchParams
                    }
                ]);
                const { hits: hits } = response.results[0];
                if (hits && hits.length > 0) {
                    setAppData(hits[0]);
                    setAppDataStatus('resolved');
                } else {
                    setAppDataStatus('rejected');
                    (0, $bTrQR.default).error('useGetAppDetailsFromSearch', "Empty results from algolia for ".concat(appId || appKey));
                }
            } catch (error) {
                setAppDataStatus('rejected');
                (0, $bTrQR.default).error('useGetAppDetailsFromSearch', "Failed to fetch app data from algolia for ".concat(appId || appKey), {
                    error: error
                });
            }
        }
        getAppData();
    }, [
        algoliaEnvironment,
        appId,
        appKey
    ]);
    const loading = appDataStatus === 'loading';
    const error = appDataStatus === 'rejected';
    return {
        loading: loading,
        error: error,
        appData: appData
    };
};

});
parcelRegister("fBO3c", function(module, exports) {

$parcel$export(module.exports, "resolveAlgoliaSearchIndex", () => $02eeba5de57cfa2c$export$7b251f7b2bf1fd0a);

var $cZdP1 = parcelRequire("cZdP1");
function $02eeba5de57cfa2c$export$7b251f7b2bf1fd0a(environment) {
    let enableV2SearchIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let indexSuffix = arguments.length > 2 ? arguments[2] : undefined;
    const index = enableV2SearchIndex ? (0, $cZdP1.searchIndicesV2) : (0, $cZdP1.searchIndicesV1);
    return "".concat(index[environment].indexName).concat(indexSuffix ? "_".concat(indexSuffix) : '');
}

});
parcelRegister("cZdP1", function(module, exports) {

$parcel$export(module.exports, "searchIndicesV1", () => $9745e74503740f1b$export$1cce0c12da2f23c3);
$parcel$export(module.exports, "searchIndicesV2", () => $9745e74503740f1b$export$ba433f7d838a8998);

var $1fIAX = parcelRequire("1fIAX");
const $9745e74503740f1b$export$1cce0c12da2f23c3 = {
    [(0, $1fIAX.AlgoliaEnvironment).DEV]: {
        indexName: 'marketplace_plugins_dev'
    },
    [(0, $1fIAX.AlgoliaEnvironment).STG]: {
        indexName: 'marketplace_plugins_stg'
    },
    [(0, $1fIAX.AlgoliaEnvironment).PROD]: {
        indexName: 'marketplace_plugins_prod'
    }
};
const $9745e74503740f1b$export$ba433f7d838a8998 = {
    [(0, $1fIAX.AlgoliaEnvironment).DEV]: {
        indexName: 'marketplace_plugins_dev_v2'
    },
    [(0, $1fIAX.AlgoliaEnvironment).STG]: {
        indexName: 'marketplace_plugins_stg_v2'
    },
    [(0, $1fIAX.AlgoliaEnvironment).PROD]: {
        indexName: 'marketplace_plugins_prod_v2'
    }
};

});
parcelRegister("1fIAX", function(module, exports) {

$parcel$export(module.exports, "AlgoliaEnvironment", () => $0e99c8d163642c80$export$9270e4dc8b1c78c5);
$parcel$export(module.exports, "Source", () => $0e99c8d163642c80$export$1d2df86270c81ecb);
const $0e99c8d163642c80$export$9270e4dc8b1c78c5 = Object.freeze({
    DEV: 'dev',
    STG: 'stg',
    PROD: 'prod'
});
const $0e99c8d163642c80$export$1d2df86270c81ecb = Object.freeze({
    MPAC: 'MPAC',
    PRODUCT: 'PRODUCT'
});

});



parcelRegister("6BoHr", function(module, exports) {
'use strict';

var $eQwxt = parcelRequire("eQwxt");

var $bRA3t = parcelRequire("bRA3t");
module.exports = $bRA3t($eQwxt, 'Browser (lite)');

});


parcelRegister("beqRW", function(module, exports) {

$parcel$export(module.exports, "default", () => $82d5d8254d40bc01$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $fUOHe = parcelRequire("fUOHe");

var $bTrQR = parcelRequire("bTrQR");

var $eUqFw = parcelRequire("eUqFw");
class $82d5d8254d40bc01$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "state", {
            hasError: false
        });
    }
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error, errorInfo) {
        (0, $bTrQR.default).error("".concat(this.props.boundaryName, " Error Boundary"), 'Error in render', {
            error: error,
            extraInfo: {
                componentStack: errorInfo.componentStack
            }
        });
        (0, $fUOHe.default).fireComponentBoundaryError(this.props.boundaryName, error);
    }
    render() {
        if (this.state.hasError) return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("5s4ZL", function(module, exports) {
module.exports = new URL("Tools.65e8a1d6.svg", import.meta.url).toString();

});

parcelRegister("i7RVQ", function(module, exports) {

$parcel$export(module.exports, "SELECTORS", () => $d322b73872530a73$export$6d10441bd0a505b0);
/**
 * DOM Selectors which are used either in pollinators or other scripts
 * outside this repo and should be updated/cleaned up in those consumers
 * before changing here.
 * Ex – `INPUT_NAME_<..>`, `TEST_ID_<..>`, `ID_<...>`, `CLASSNAME_<...>`
 */ const $d322b73872530a73$export$6d10441bd0a505b0 = Object.freeze({
    /** Name of the app install dialog in emcee, used in pollinators */ TEST_ID_APP_INSTALL_DIALOG: 'marketplace-app-install-dialog',
    TEST_ID_CMT_SECTION_MESSAGE: 'marketplace-app-cmt-section-message'
});

});

parcelRegister("4s0An", function(module, exports) {

$parcel$export(module.exports, "INSTALLABLE_APP_DEFAULT_INSTALL_MODE", () => $33da3b41923c0162$export$63b88c9b5076aeae);
$parcel$export(module.exports, "makeInstallableAppDefaultInstallMode", () => $33da3b41923c0162$export$ddfcb64563ebca44);

var $eNZVr = parcelRequire("eNZVr");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $hCQtM = parcelRequire("hCQtM");

var $ifMZN = parcelRequire("ifMZN");

var $9eIgo = parcelRequire("9eIgo");
const $33da3b41923c0162$export$63b88c9b5076aeae = 'INSTALLABLE_APP_DEFAULT';
const $33da3b41923c0162$export$ddfcb64563ebca44 = (0, $g5DHJ.Record)({
    type: $33da3b41923c0162$export$63b88c9b5076aeae,
    installableApp: (0, $hCQtM.makeInstallableApp)(),
    installableAppId: (0, $ifMZN.makeInstallableAppByKeyIdentifier)(),
    installPermission: (0, $bWAru.Either).left((0, $eNZVr.makePermissionCheckResultFailure)()),
    installedApp: (0, $bWAru.Option).empty(),
    relayState: undefined,
    status: (0, $9eIgo.makePendingConfirmationInstallStatus)()
});

});
parcelRegister("eNZVr", function(module, exports) {

$parcel$export(module.exports, "makePermissionCheckResultFailure", () => $ac75ad66bec14724$export$635a8be87e249253);
$parcel$export(module.exports, "makePermissionCheckResultFromSPI", () => $ac75ad66bec14724$export$720fec40f8bf8dbe);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $8wTgI = parcelRequire("8wTgI");
const $ac75ad66bec14724$export$635a8be87e249253 = (0, $g5DHJ.Record)({
    allowed: false,
    message: '',
    key: 'noAddonManagePermission'
});
const $ac75ad66bec14724$export$fa307e2d7dba298d = (0, $g5DHJ.Record)({
    allowed: true
});
const $ac75ad66bec14724$export$720fec40f8bf8dbe = (pc)=>(0, $8wTgI.foldSPIPermissionCheckResult)(pc)((s)=>(0, $bWAru.Either).right($ac75ad66bec14724$export$fa307e2d7dba298d(s)), (f)=>(0, $bWAru.Either).left($ac75ad66bec14724$export$635a8be87e249253(f)));

});
parcelRegister("8wTgI", function(module, exports) {

$parcel$export(module.exports, "foldSPIPermissionCheckResult", () => $635c2f1bc8e803d0$export$ef36bc99c71dc4db);
const $635c2f1bc8e803d0$export$ef36bc99c71dc4db = (pc)=>(a, b)=>pc.allowed === true ? a(pc) : b(pc);

});


parcelRegister("hCQtM", function(module, exports) {

$parcel$export(module.exports, "makeInstallableApp", () => $cd4eb18df34cf788$export$13c6497ddb9cd56c);
$parcel$export(module.exports, "makeInstallableAppFromSPIInstallableAddonAndMarketplaceAppData", () => $cd4eb18df34cf788$export$7b9fa3e4886032de);

var $7r0ma = parcelRequire("7r0ma");

var $8kbfx = parcelRequire("8kbfx");

var $g5DHJ = parcelRequire("g5DHJ");
const $cd4eb18df34cf788$export$13c6497ddb9cd56c = (0, $g5DHJ.Record)({
    details: (0, $7r0ma.makeSPIAppDisplayDetails)((0, $7r0ma.makeAppDisplayDetails)()),
    marketplaceAppDetails: (0, $7r0ma.makeMarketplaceAppDisplayDetails)((0, $7r0ma.makeAppDisplayDetails)()),
    scopes: (0, $g5DHJ.List)(),
    eligibleForFreeOnSandbox: false,
    cloudMigrationTrial: {
        isEligible: false
    }
});
const $cd4eb18df34cf788$export$7b9fa3e4886032de = (installableAddon, marketplaceApp, mpacBaseUrl)=>$cd4eb18df34cf788$export$13c6497ddb9cd56c({
        details: (0, $7r0ma.makeSPIAppDisplayDetailsFromSPIAddonDisplayDetails)(installableAddon.details),
        marketplaceAppDetails: (0, $7r0ma.makeMarketplaceAppDisplayDetailsFromMarketplaceApp)({
            marketplaceApp: marketplaceApp,
            mpacBaseUrl: mpacBaseUrl
        }),
        scopes: (0, $g5DHJ.List)(installableAddon.scopes).map((0, $8kbfx.makeScopeKey)),
        eligibleForFreeOnSandbox: installableAddon.eligibleForFreeOnSandbox,
        cloudMigrationTrial: installableAddon.cloudMigrationTrial
    });

});
parcelRegister("7r0ma", function(module, exports) {

$parcel$export(module.exports, "makeAppDisplayDetails", () => $569b54cdbb73178d$export$f0e73010cd102562);
$parcel$export(module.exports, "makeMarketplaceAppDisplayDetails", () => $569b54cdbb73178d$export$8502fd07df5b19ab);
$parcel$export(module.exports, "makeSPIAppDisplayDetails", () => $569b54cdbb73178d$export$b2a5f7b9f9f20a63);
$parcel$export(module.exports, "makeSPIAppDisplayDetailsFromSPIAddonDisplayDetails", () => $569b54cdbb73178d$export$73ca5f8a7e36e64);
$parcel$export(module.exports, "makeMarketplaceAppDisplayDetailsFromMarketplaceApp", () => $569b54cdbb73178d$export$7ff370aec992029a);

var $6UgUw = parcelRequire("6UgUw");
var $ly50n = parcelRequire("ly50n");

var $c9Mth = parcelRequire("c9Mth");

var $g5DHJ = parcelRequire("g5DHJ");
const $569b54cdbb73178d$var$makeAppDistribution = (0, $g5DHJ.Record)({
    downloadCount: 0,
    installationCount: 0,
    isPreinstalled: false,
    isPreinstalledInAnyHosting: false
});
const $569b54cdbb73178d$export$d233a2c59f71a595 = (marketplaceApp)=>{
    var _marketplaceApp$_embe;
    const { downloads: downloads, totalInstalls: totalInstalls, bundled: bundled, bundledCloud: bundledCloud } = ((_marketplaceApp$_embe = marketplaceApp._embedded) === null || _marketplaceApp$_embe === void 0 ? void 0 : _marketplaceApp$_embe.distribution) || {};
    return $569b54cdbb73178d$var$makeAppDistribution({
        downloadCount: downloads,
        installationCount: totalInstalls,
        isPreinstalled: bundledCloud,
        isPreinstalledInAnyHosting: bundledCloud || bundled || false
    });
};
const $569b54cdbb73178d$export$1b7bf106d42aa1ab = (0, $g5DHJ.Record)({
    title: '',
    explanation: '',
    thumbnail: '',
    screenshot: '',
    body: ''
});
const $569b54cdbb73178d$export$b711a51bc42b686f = (0, $g5DHJ.Record)({
    caption: '',
    screenshot: ''
});
const $569b54cdbb73178d$export$f0e73010cd102562 = (0, $g5DHJ.Record)({
    key: (0, $ly50n.makeAppKey)(''),
    icon: undefined,
    metadata: {},
    origin: undefined,
    name: '',
    version: undefined,
    vendor: (0, $6UgUw.makeVendor)(),
    privacyPolicy: undefined,
    eula: undefined,
    tagLine: '',
    youtubeId: undefined,
    heroImage: undefined,
    highlights: [],
    screenshots: [],
    moreDetails: undefined,
    isConnectApp: false,
    paymentModel: undefined,
    ratings: {
        avgStars: 0,
        numRatings: 0
    },
    ecosystemCloudAppId: '',
    programs: undefined,
    distribution: $569b54cdbb73178d$var$makeAppDistribution()
});
const $569b54cdbb73178d$export$8502fd07df5b19ab = (value)=>value;
const $569b54cdbb73178d$export$b2a5f7b9f9f20a63 = (value)=>value;
const $569b54cdbb73178d$var$getImageUrl = (links)=>links && links._links ? (links._links.highRes || links._links.unscaled || links._links.image).href : undefined;
const $569b54cdbb73178d$var$getHighlights = (highlights)=>highlights ? highlights.map((highlight)=>{
        var _highlight$_embedded, _highlight$_embedded2;
        return $569b54cdbb73178d$export$1b7bf106d42aa1ab({
            title: highlight.title,
            explanation: highlight.explanation,
            body: highlight.body,
            thumbnail: $569b54cdbb73178d$var$getImageUrl((_highlight$_embedded = highlight._embedded) === null || _highlight$_embedded === void 0 ? void 0 : _highlight$_embedded.thumbnail),
            screenshot: $569b54cdbb73178d$var$getImageUrl((_highlight$_embedded2 = highlight._embedded) === null || _highlight$_embedded2 === void 0 ? void 0 : _highlight$_embedded2.screenshot)
        });
    }) : [];
const $569b54cdbb73178d$var$getScreenshots = (screenshots)=>screenshots ? screenshots.map((highlight)=>{
        var _highlight$_embedded3;
        return $569b54cdbb73178d$export$b711a51bc42b686f({
            caption: highlight.caption,
            screenshot: $569b54cdbb73178d$var$getImageUrl((_highlight$_embedded3 = highlight._embedded) === null || _highlight$_embedded3 === void 0 ? void 0 : _highlight$_embedded3.image)
        });
    }) : [];
const $569b54cdbb73178d$export$73ca5f8a7e36e64 = (addonDisplayDetails)=>$569b54cdbb73178d$export$f0e73010cd102562({
        key: (0, $ly50n.makeAppKey)(addonDisplayDetails.key),
        icon: addonDisplayDetails.icon,
        metadata: addonDisplayDetails.metadata,
        origin: addonDisplayDetails.origin,
        name: addonDisplayDetails.name,
        version: addonDisplayDetails.version,
        vendor: (0, $6UgUw.makeVendor)({
            name: addonDisplayDetails.vendor,
            link: (0, $c9Mth).validateSafeAbsoluteUrl(addonDisplayDetails.vendorLink),
            // Eventually VendorType should not be optional in SPI AddonDisplayDetails, we should update marketplace-spi after DAC-3300
            vendorType: addonDisplayDetails.vendorType || (0, $6UgUw.defaultVendorType)
        }),
        privacyPolicy: (0, $c9Mth).validateSafeAbsoluteUrl(addonDisplayDetails.privacyPolicy),
        eula: (0, $c9Mth).validateSafeAbsoluteUrl(addonDisplayDetails.eula),
        ecosystemCloudAppId: addonDisplayDetails.ecosystemCloudAppId
    });
const $569b54cdbb73178d$export$7ff370aec992029a = (_ref)=>{
    var _marketplaceApp$_embe2, _marketplaceApp$_embe3, _marketplaceApp$_embe4, _marketplaceApp$_embe5, _marketplaceApp$vendo, _marketplaceApp$_embe6, _marketplaceApp$_embe7, _marketplaceApp$_embe8, _marketplaceApp$_embe9, _marketplaceApp$_embe10, _marketplaceApp$_embe11, _marketplaceApp$_embe12, _marketplaceApp$_embe13, _marketplaceApp$_embe14, _marketplaceApp$_embe15, _marketplaceApp$_embe16, _marketplaceApp$_embe17, _marketplaceApp$_embe18, _marketplaceApp$_embe19, _marketplaceApp$_embe20, _marketplaceApp$_embe21, _marketplaceApp$_embe22, _marketplaceApp$_embe23, _marketplaceApp$_embe24, _marketplaceApp$_embe25, _marketplaceApp$_embe26, _marketplaceApp$_embe27, _marketplaceApp$_embe28, _marketplaceApp$_embe29, _marketplaceApp$_embe30, _marketplaceApp$_embe31, _marketplaceApp$_embe32, _marketplaceApp$_embe33;
    let { mpacBaseUrl: mpacBaseUrl, marketplaceApp: marketplaceApp } = _ref;
    return $569b54cdbb73178d$export$8502fd07df5b19ab($569b54cdbb73178d$export$f0e73010cd102562({
        key: marketplaceApp.key,
        icon: (_marketplaceApp$_embe2 = marketplaceApp._embedded) === null || _marketplaceApp$_embe2 === void 0 ? void 0 : (_marketplaceApp$_embe3 = _marketplaceApp$_embe2.logo) === null || _marketplaceApp$_embe3 === void 0 ? void 0 : _marketplaceApp$_embe3._links.image.href,
        origin: 'marketplace',
        name: marketplaceApp.name,
        vendor: (0, $6UgUw.makeVendorFromMarketplaceApp)({
            marketplaceApp: marketplaceApp,
            mpacBaseUrl: mpacBaseUrl
        }),
        version: (_marketplaceApp$_embe4 = marketplaceApp._embedded) === null || _marketplaceApp$_embe4 === void 0 ? void 0 : (_marketplaceApp$_embe5 = _marketplaceApp$_embe4.version) === null || _marketplaceApp$_embe5 === void 0 ? void 0 : _marketplaceApp$_embe5.name,
        privacyPolicy: (0, $c9Mth).validateSafeAbsoluteUrl((_marketplaceApp$vendo = marketplaceApp.vendorLinks) === null || _marketplaceApp$vendo === void 0 ? void 0 : _marketplaceApp$vendo.privacy),
        eula: (0, $c9Mth).validateSafeAbsoluteUrl((_marketplaceApp$_embe6 = marketplaceApp._embedded) === null || _marketplaceApp$_embe6 === void 0 ? void 0 : (_marketplaceApp$_embe7 = _marketplaceApp$_embe6.version) === null || _marketplaceApp$_embe7 === void 0 ? void 0 : (_marketplaceApp$_embe8 = _marketplaceApp$_embe7.vendorLinks) === null || _marketplaceApp$_embe8 === void 0 ? void 0 : _marketplaceApp$_embe8.eula),
        tagLine: marketplaceApp.tagLine,
        youtubeId: (_marketplaceApp$_embe9 = marketplaceApp._embedded) === null || _marketplaceApp$_embe9 === void 0 ? void 0 : (_marketplaceApp$_embe10 = _marketplaceApp$_embe9.version) === null || _marketplaceApp$_embe10 === void 0 ? void 0 : _marketplaceApp$_embe10.youtubeId,
        heroImage: $569b54cdbb73178d$var$getImageUrl((_marketplaceApp$_embe11 = marketplaceApp._embedded) === null || _marketplaceApp$_embe11 === void 0 ? void 0 : (_marketplaceApp$_embe12 = _marketplaceApp$_embe11.version) === null || _marketplaceApp$_embe12 === void 0 ? void 0 : (_marketplaceApp$_embe13 = _marketplaceApp$_embe12._embedded) === null || _marketplaceApp$_embe13 === void 0 ? void 0 : _marketplaceApp$_embe13.hero),
        highlights: $569b54cdbb73178d$var$getHighlights((_marketplaceApp$_embe14 = marketplaceApp._embedded) === null || _marketplaceApp$_embe14 === void 0 ? void 0 : (_marketplaceApp$_embe15 = _marketplaceApp$_embe14.version) === null || _marketplaceApp$_embe15 === void 0 ? void 0 : (_marketplaceApp$_embe16 = _marketplaceApp$_embe15._embedded) === null || _marketplaceApp$_embe16 === void 0 ? void 0 : _marketplaceApp$_embe16.highlights),
        screenshots: $569b54cdbb73178d$var$getScreenshots((_marketplaceApp$_embe17 = marketplaceApp._embedded) === null || _marketplaceApp$_embe17 === void 0 ? void 0 : (_marketplaceApp$_embe18 = _marketplaceApp$_embe17.version) === null || _marketplaceApp$_embe18 === void 0 ? void 0 : (_marketplaceApp$_embe19 = _marketplaceApp$_embe18._embedded) === null || _marketplaceApp$_embe19 === void 0 ? void 0 : _marketplaceApp$_embe19.screenshots),
        moreDetails: (_marketplaceApp$_embe20 = marketplaceApp._embedded) === null || _marketplaceApp$_embe20 === void 0 ? void 0 : (_marketplaceApp$_embe21 = _marketplaceApp$_embe20.version) === null || _marketplaceApp$_embe21 === void 0 ? void 0 : (_marketplaceApp$_embe22 = _marketplaceApp$_embe21.text) === null || _marketplaceApp$_embe22 === void 0 ? void 0 : _marketplaceApp$_embe22.moreDetails,
        isConnectApp: (_marketplaceApp$_embe23 = marketplaceApp._embedded) === null || _marketplaceApp$_embe23 === void 0 ? void 0 : (_marketplaceApp$_embe24 = _marketplaceApp$_embe23.version) === null || _marketplaceApp$_embe24 === void 0 ? void 0 : _marketplaceApp$_embe24.deployment.connect,
        paymentModel: (_marketplaceApp$_embe25 = marketplaceApp._embedded) === null || _marketplaceApp$_embe25 === void 0 ? void 0 : (_marketplaceApp$_embe26 = _marketplaceApp$_embe25.version) === null || _marketplaceApp$_embe26 === void 0 ? void 0 : _marketplaceApp$_embe26.paymentModel,
        ratings: {
            avgStars: ((_marketplaceApp$_embe27 = marketplaceApp._embedded) === null || _marketplaceApp$_embe27 === void 0 ? void 0 : (_marketplaceApp$_embe28 = _marketplaceApp$_embe27.reviews) === null || _marketplaceApp$_embe28 === void 0 ? void 0 : _marketplaceApp$_embe28.averageStars) || 0,
            numRatings: ((_marketplaceApp$_embe29 = marketplaceApp._embedded) === null || _marketplaceApp$_embe29 === void 0 ? void 0 : (_marketplaceApp$_embe30 = _marketplaceApp$_embe29.reviews) === null || _marketplaceApp$_embe30 === void 0 ? void 0 : _marketplaceApp$_embe30.count) || 0
        },
        ecosystemCloudAppId: (_marketplaceApp$_embe31 = marketplaceApp._embedded) === null || _marketplaceApp$_embe31 === void 0 ? void 0 : (_marketplaceApp$_embe32 = _marketplaceApp$_embe31.version) === null || _marketplaceApp$_embe32 === void 0 ? void 0 : (_marketplaceApp$_embe33 = _marketplaceApp$_embe32.cloud) === null || _marketplaceApp$_embe33 === void 0 ? void 0 : _marketplaceApp$_embe33.appId,
        programs: marketplaceApp.programs,
        distribution: $569b54cdbb73178d$export$d233a2c59f71a595(marketplaceApp)
    }));
};

});
parcelRegister("6UgUw", function(module, exports) {

$parcel$export(module.exports, "defaultVendorType", () => $5075172522147306$export$3e11b43dfede5c7c);
$parcel$export(module.exports, "makeVendor", () => $5075172522147306$export$4549ccc66ac8e089);
$parcel$export(module.exports, "makeVendorFromMarketplaceApp", () => $5075172522147306$export$525bb0a8dc0fe384);

var $c9Mth = parcelRequire("c9Mth");

var $g5DHJ = parcelRequire("g5DHJ");
const $5075172522147306$export$3e11b43dfede5c7c = 'thirdParty';
const $5075172522147306$export$4549ccc66ac8e089 = (0, $g5DHJ.Record)({
    id: 0,
    name: null,
    link: null,
    vendorType: $5075172522147306$export$3e11b43dfede5c7c,
    topVendorStatus: undefined
});
const $5075172522147306$export$525bb0a8dc0fe384 = (_ref)=>{
    var _marketplaceApp$_embe, _vendor$_links$altern, _vendor$_links$self$h, _vendor$_links$self, _marketplaceApp$_embe2, _marketplaceApp$_embe3, _marketplaceApp$_embe4, _marketplaceApp$_embe5, _marketplaceApp$_embe6, _marketplaceApp$_embe7;
    let { marketplaceApp: marketplaceApp, mpacBaseUrl: mpacBaseUrl } = _ref;
    const vendor = (_marketplaceApp$_embe = marketplaceApp._embedded) === null || _marketplaceApp$_embe === void 0 ? void 0 : _marketplaceApp$_embe.vendor;
    const vendorLink = vendor === null || vendor === void 0 ? void 0 : (_vendor$_links$altern = vendor._links.alternate) === null || _vendor$_links$altern === void 0 ? void 0 : _vendor$_links$altern.href;
    const id = (_vendor$_links$self$h = vendor === null || vendor === void 0 ? void 0 : (_vendor$_links$self = vendor._links.self) === null || _vendor$_links$self === void 0 ? void 0 : _vendor$_links$self.href.split('/').pop()) !== null && _vendor$_links$self$h !== void 0 ? _vendor$_links$self$h : '0';
    return $5075172522147306$export$4549ccc66ac8e089({
        id: Number.parseInt(id, 10),
        name: vendor === null || vendor === void 0 ? void 0 : vendor.name,
        link: vendorLink ? (0, $c9Mth).validateSafeAbsoluteUrl(mpacBaseUrl + vendorLink) : null,
        vendorType: (_marketplaceApp$_embe2 = marketplaceApp._embedded) !== null && _marketplaceApp$_embe2 !== void 0 && (_marketplaceApp$_embe3 = _marketplaceApp$_embe2.vendor) !== null && _marketplaceApp$_embe3 !== void 0 && _marketplaceApp$_embe3.isAtlassian ? 'internal' : 'thirdParty',
        topVendorStatus: (_marketplaceApp$_embe4 = marketplaceApp._embedded) === null || _marketplaceApp$_embe4 === void 0 ? void 0 : (_marketplaceApp$_embe5 = _marketplaceApp$_embe4.vendor) === null || _marketplaceApp$_embe5 === void 0 ? void 0 : (_marketplaceApp$_embe6 = _marketplaceApp$_embe5.programs) === null || _marketplaceApp$_embe6 === void 0 ? void 0 : (_marketplaceApp$_embe7 = _marketplaceApp$_embe6.topVendor) === null || _marketplaceApp$_embe7 === void 0 ? void 0 : _marketplaceApp$_embe7.status
    });
};

});
parcelRegister("c9Mth", function(module, exports) {

$parcel$export(module.exports, "foldImmutableQueryValue", () => $8d9becace223ea55$export$ec2cc0d104405d89);
$parcel$export(module.exports, "resolveImmutableQuery", () => $8d9becace223ea55$export$2f29c6d56345bc56);
$parcel$export(module.exports, "resolveSearchFromImmutableQuery", () => $8d9becace223ea55$export$9e7e24308e926219);
$parcel$export(module.exports, "resolveUrlFromTemplateAndParameters", () => $8d9becace223ea55$export$10644f36e75cf071);
$parcel$export(module.exports, "transformUriTemplateToRoutePath", () => $8d9becace223ea55$export$245832c1b751eda7);
$parcel$export(module.exports, "transformRoutePathToUriTemplate", () => $8d9becace223ea55$export$938373130bd7fa6a);
$parcel$export(module.exports, "validateSafeAbsoluteUrl", () => $8d9becace223ea55$export$4e26b30a7632545f);
$parcel$export(module.exports, "updateQueryParam", () => $8d9becace223ea55$export$7ae7176e19061de2);
$parcel$export(module.exports, "unsetQueryParam", () => $8d9becace223ea55$export$948ccc3319401bd9);
$parcel$export(module.exports, "getLocationPath", () => $8d9becace223ea55$export$3cb209e120f6c244);
$parcel$export(module.exports, "getSupportTicketNumber", () => $8d9becace223ea55$export$27993c66b241fcf3);
$parcel$export(module.exports, "joinPathNames", () => $8d9becace223ea55$export$36dee12cc8f9a22a);
$parcel$export(module.exports, "removeDomainFromUrl", () => $8d9becace223ea55$export$daba15f6f1abfa21);
$parcel$export(module.exports, "removeQueryParamsFromUrl", () => $8d9becace223ea55$export$8189558ac52562eb);

var $bwPfh = parcelRequire("bwPfh");

var $5zQU9 = parcelRequire("5zQU9");

var $g5DHJ = parcelRequire("g5DHJ");

var $kt9Cs = parcelRequire("kt9Cs");

var $k4nIh = parcelRequire("k4nIh");

var $asbhz = parcelRequire("asbhz");
function $8d9becace223ea55$var$_toPropertyKey(t) {
    var i = $8d9becace223ea55$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $8d9becace223ea55$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $8d9becace223ea55$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8d9becace223ea55$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8d9becace223ea55$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8d9becace223ea55$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8d9becace223ea55$export$ec2cc0d104405d89(iqv) {
    return function(string, set) {
        if (typeof iqv === 'string') return string(iqv);
        else if ((0, $g5DHJ.Set).isSet(iqv)) return set(iqv);
        else throw new TypeError("foldResolvedImmutableQueryValue is not comprehensive in ResolvedImmutableQueryValue: ".concat(JSON.stringify(iqv)));
    };
}
function $8d9becace223ea55$export$2f29c6d56345bc56(search) {
    const immutableMap = (0, $g5DHJ.fromJS)((0, (/*@__PURE__*/$parcel$interopDefault($kt9Cs))).parse(search), (_key, value)=>(0, $g5DHJ.Collection).isIndexed(value) ? value.toSet() : value.toMap());
    return immutableMap;
}
function $8d9becace223ea55$export$9e7e24308e926219(query) {
    const stringifiedQuery = $8d9becace223ea55$var$stringifyImmutableQuery(query);
    return stringifiedQuery ? "?".concat(stringifiedQuery) : '';
}
const $8d9becace223ea55$var$filterEmptyStringsFromQuery = (queryObject)=>{
    return Object.entries(queryObject).filter((_ref)=>{
        let [_, v] = _ref;
        return !(typeof v === 'string' && v.trim() === '');
    }).reduce((res, _ref2)=>{
        let [k, _] = _ref2;
        res[k] = queryObject[k];
        return res;
    }, {});
};
function $8d9becace223ea55$var$stringifyImmutableQuery(query) {
    const queryObject = query && query.toJS();
    return queryObject ? (0, (/*@__PURE__*/$parcel$interopDefault($kt9Cs))).stringify($8d9becace223ea55$var$filterEmptyStringsFromQuery(queryObject)) : '';
}
function $8d9becace223ea55$export$10644f36e75cf071(options) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(options.template).expand(options.parameters);
}
function $8d9becace223ea55$export$245832c1b751eda7(_ref3) {
    let { template: template } = _ref3;
    return template.replace(/{([^{}]+)}/g, (_, expression)=>":".concat(expression));
}
function $8d9becace223ea55$export$938373130bd7fa6a(_ref4) {
    let { routePath: routePath } = _ref4;
    return routePath// Remove route regex from the path ( <>/:param((\d+)) -> <>/:param )
    .replace(/ *\([^)]*\) */g, '')// convert Route Parameters to URI template expression ( <>/:param -> <>/{param} )
    .replace(/:([^/]+)/g, (_, expression)=>"{".concat(expression, "}"));
}
function $8d9becace223ea55$export$4e26b30a7632545f(url) {
    if (!url) return null;
    const urlObj = new (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(url, {});
    const scheme = urlObj.protocol.toLowerCase();
    switch(scheme){
        case 'http:':
        case 'https:':
            return url;
        default:
            return null;
    }
}
const $8d9becace223ea55$export$7ae7176e19061de2 = (url, paramName, paramValue)=>{
    const newUrl = new (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(url, {}, true);
    const { query: query, pathname: pathname, hash: hash } = newUrl;
    const urlPath = new (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))('', {});
    urlPath.set('query', $8d9becace223ea55$var$_objectSpread($8d9becace223ea55$var$_objectSpread({}, query), {}, {
        [paramName]: paramValue
    })).set('pathname', pathname).set('hash', hash);
    return urlPath.toString();
};
const $8d9becace223ea55$export$948ccc3319401bd9 = (url, paramName)=>{
    const newUrl = new (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(url, {}, true);
    const { query: query, pathname: pathname, hash: hash } = newUrl;
    const { [paramName]: _paramToRemove } = query, otherQueryParams = (0, $bwPfh.default)(query, [
        paramName
    ].map($8d9becace223ea55$var$_toPropertyKey));
    const urlPath = new (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))('', {});
    urlPath.set('query', $8d9becace223ea55$var$_objectSpread({}, otherQueryParams)).set('pathname', pathname).set('hash', hash);
    return urlPath.toString();
};
const $8d9becace223ea55$export$3cb209e120f6c244 = ()=>window.location.hash.split('#')[1].split('?')[0];
const $8d9becace223ea55$export$27993c66b241fcf3 = (url)=>url.split('/').pop();
const $8d9becace223ea55$export$36dee12cc8f9a22a = (pathNames)=>{
    const fullPath = pathNames.join('/');
    return fullPath.replace(/\/+/g, '/');
};
const $8d9becace223ea55$export$daba15f6f1abfa21 = (url)=>{
    const urlObject = new (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(url);
    return urlObject.pathname + urlObject.query;
};
const $8d9becace223ea55$export$8189558ac52562eb = (url)=>{
    const urlObject = new (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(url);
    return urlObject.origin + urlObject.pathname;
};

});


parcelRegister("ly50n", function(module, exports) {

$parcel$export(module.exports, "makeAppKey", () => $fb00a7da88133565$export$a7c7d13152440f84);
function $fb00a7da88133565$export$a7c7d13152440f84(key) {
    return key;
}

});


parcelRegister("8kbfx", function(module, exports) {

$parcel$export(module.exports, "makeScopeKey", () => $60f8eaeb36e9d466$export$e049bf165fbb6578);
$parcel$export(module.exports, "makeMarketplaceScope", () => $60f8eaeb36e9d466$export$d50933cc710a588);

var $g5DHJ = parcelRequire("g5DHJ");
function $60f8eaeb36e9d466$export$e049bf165fbb6578(scopeKey) {
    return scopeKey;
}
const $60f8eaeb36e9d466$var$MarketplaceScopeConstructor = (0, $g5DHJ.Record)({
    name: '',
    description: ''
});
const $60f8eaeb36e9d466$export$ccf2bd8e90818e80 = $60f8eaeb36e9d466$var$MarketplaceScopeConstructor();
const $60f8eaeb36e9d466$export$d50933cc710a588 = (a)=>$60f8eaeb36e9d466$var$MarketplaceScopeConstructor(a);

});


parcelRegister("ifMZN", function(module, exports) {

$parcel$export(module.exports, "ARI_TYPE", () => $d49fa239b51927ba$export$2c1aa78a79edb5c3);
$parcel$export(module.exports, "makeInstallableAppByKeyIdentifier", () => $d49fa239b51927ba$export$7bc350d6508c98cc);
$parcel$export(module.exports, "makeInstallableAppByAriIdentifier", () => $d49fa239b51927ba$export$c7ac7a03375590c6);
$parcel$export(module.exports, "makeInstallableAppByUrlIdentifier", () => $d49fa239b51927ba$export$b136e6eaf82351b3);
$parcel$export(module.exports, "foldInstallableAppIdentifier", () => $d49fa239b51927ba$export$343702c798450eb0);
$parcel$export(module.exports, "toSPIInstallableAddonIdentifier", () => $d49fa239b51927ba$export$274519655fcb8b0f);

var $cjFit = parcelRequire("cjFit");

var $ly50n = parcelRequire("ly50n");

var $g5DHJ = parcelRequire("g5DHJ");
const $d49fa239b51927ba$export$30af7111f72c7a22 = 'KEY';
const $d49fa239b51927ba$var$URL_TYPE = 'URL';
const $d49fa239b51927ba$export$2c1aa78a79edb5c3 = 'ARI';
const $d49fa239b51927ba$export$7bc350d6508c98cc = (0, $g5DHJ.Record)({
    type: $d49fa239b51927ba$export$30af7111f72c7a22,
    key: (0, $ly50n.makeAppKey)('')
});
const $d49fa239b51927ba$export$c7ac7a03375590c6 = (0, $g5DHJ.Record)({
    type: $d49fa239b51927ba$export$2c1aa78a79edb5c3,
    ari: (0, $ly50n.makeAppKey)(''),
    appKey: (0, $ly50n.makeAppKey)('')
});
const $d49fa239b51927ba$export$b136e6eaf82351b3 = (0, $g5DHJ.Record)({
    type: $d49fa239b51927ba$var$URL_TYPE,
    url: (0, $cjFit.nonEmptyString)('url') // Invalid, but need a default
});
function $d49fa239b51927ba$export$343702c798450eb0(appIdentifier) {
    return function(key, url, ari) {
        switch(appIdentifier.type){
            case $d49fa239b51927ba$export$30af7111f72c7a22:
                return key(appIdentifier);
            case $d49fa239b51927ba$var$URL_TYPE:
                return url(appIdentifier);
            case $d49fa239b51927ba$export$2c1aa78a79edb5c3:
                return ari(appIdentifier);
            default:
                // Flow compile-time validation that we've handled every discover item
                // prettier-ignore
                appIdentifier;
                return undefined;
        }
    };
}
const $d49fa239b51927ba$export$274519655fcb8b0f = (appIdentifier)=>$d49fa239b51927ba$export$343702c798450eb0(appIdentifier)((installableAppByKeyIdentifier)=>({
            key: installableAppByKeyIdentifier.key
        }), (installableAppByUrlIdentifier)=>({
            url: installableAppByUrlIdentifier.url
        }), (installableAppByAriIdentifier)=>({
            ari: installableAppByAriIdentifier.ari,
            appKey: installableAppByAriIdentifier.appKey
        }));

});
parcelRegister("cjFit", function(module, exports) {

$parcel$export(module.exports, "nonEmptyString", () => $8f774b1ea4e8709c$export$cf37a15c1da41d8f);
$parcel$export(module.exports, "emptyString", () => $8f774b1ea4e8709c$export$1643ccb46f49255c);
const $8f774b1ea4e8709c$export$cf37a15c1da41d8f = (s)=>{
    if (!s || !s.length) return $8f774b1ea4e8709c$export$1643ccb46f49255c;
    else return s;
};
const $8f774b1ea4e8709c$export$1643ccb46f49255c = null;

});


parcelRegister("9eIgo", function(module, exports) {

$parcel$export(module.exports, "IN_PROGRESS_INSTALL_STATUS", () => $6b97c1a45df17aa2$export$2d86fa0e1233e6ff);
$parcel$export(module.exports, "COMPLETE_INSTALL_STATUS", () => $6b97c1a45df17aa2$export$c5d9a2deec84162e);
$parcel$export(module.exports, "makePendingConfirmationInstallStatus", () => $6b97c1a45df17aa2$export$337a1cd9ea7d6721);
$parcel$export(module.exports, "makeInProgressInstallStatus", () => $6b97c1a45df17aa2$export$30eca8cef4b8d8c1);
$parcel$export(module.exports, "makeCompleteInstallStatus", () => $6b97c1a45df17aa2$export$7e1674eb10a9ae8);
$parcel$export(module.exports, "foldInstallStatus", () => $6b97c1a45df17aa2$export$cdd26f446a29d129);
$parcel$export(module.exports, "isInstallStatusLoading", () => $6b97c1a45df17aa2$export$4fc9385e90d58a79);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");
const $6b97c1a45df17aa2$export$483f8ecb0166e62f = 'PENDING_ACCEPT';
const $6b97c1a45df17aa2$export$2d86fa0e1233e6ff = 'IN_PROGRESS';
const $6b97c1a45df17aa2$export$c5d9a2deec84162e = 'COMPLETE';
const $6b97c1a45df17aa2$export$337a1cd9ea7d6721 = (0, $g5DHJ.Record)({
    type: $6b97c1a45df17aa2$export$483f8ecb0166e62f
});
const $6b97c1a45df17aa2$export$30eca8cef4b8d8c1 = (0, $g5DHJ.Record)({
    type: $6b97c1a45df17aa2$export$2d86fa0e1233e6ff
});
const $6b97c1a45df17aa2$export$7e1674eb10a9ae8 = (0, $g5DHJ.Record)({
    type: $6b97c1a45df17aa2$export$c5d9a2deec84162e,
    result: (0, $bWAru.Either).left('error') // Not really a valid default, but need to provide one
});
function $6b97c1a45df17aa2$export$cdd26f446a29d129(installStatus, pendingConfirmation, installing, complete) {
    switch(installStatus.type){
        case $6b97c1a45df17aa2$export$483f8ecb0166e62f:
            return pendingConfirmation(installStatus);
        case $6b97c1a45df17aa2$export$2d86fa0e1233e6ff:
            return installing(installStatus);
        case $6b97c1a45df17aa2$export$c5d9a2deec84162e:
            return complete(installStatus);
        default:
            // Flow compile-time validation that we've handled every discover item
            // prettier-ignore
            installStatus;
            return undefined;
    }
}
function $6b97c1a45df17aa2$export$4fc9385e90d58a79(installStatus) {
    return $6b97c1a45df17aa2$export$cdd26f446a29d129(installStatus, ()=>false, ()=>true, ()=>false);
}

});


parcelRegister("k5vUT", function(module, exports) {

$parcel$export(module.exports, "INSTRUCTIONAL_INSTALL_MODE", () => $e9fd084069ae88d2$export$32b60382a8108b14);
$parcel$export(module.exports, "makeInstructionalInstallMode", () => $e9fd084069ae88d2$export$b03b57253a091763);

var $g5DHJ = parcelRequire("g5DHJ");

var $irBem = parcelRequire("irBem");
const $e9fd084069ae88d2$export$32b60382a8108b14 = 'INSTRUCTIONAL';
const $e9fd084069ae88d2$export$b03b57253a091763 = (0, $g5DHJ.Record)({
    type: $e9fd084069ae88d2$export$32b60382a8108b14,
    instructionalApp: (0, $irBem.makeInstructionalApp)()
});

});
parcelRegister("irBem", function(module, exports) {

$parcel$export(module.exports, "makeInstallInstructionsStep", () => $d6d7a0d73be3ed6e$export$47a653b32b096653);
$parcel$export(module.exports, "makeInstructionalApp", () => $d6d7a0d73be3ed6e$export$31c1267eb7789c1e);

var $7r0ma = parcelRequire("7r0ma");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");
const $d6d7a0d73be3ed6e$export$47a653b32b096653 = (0, $g5DHJ.Record)({
    image: undefined,
    bodyHTML: ''
});
const $d6d7a0d73be3ed6e$export$31c1267eb7789c1e = (0, $g5DHJ.Record)({
    details: (0, $7r0ma.makeMarketplaceAppDisplayDetails)((0, $7r0ma.makeAppDisplayDetails)()),
    learnMoreLink: (0, $bWAru.Option).empty(),
    steps: (0, $g5DHJ.List)()
});

});


parcelRegister("iEgm6", function(module, exports) {

$parcel$export(module.exports, "preventDefault", () => $d938a645954b3a98$export$fa3b29edae795ef4);
$parcel$export(module.exports, "resolveFieldWithFallback", () => $d938a645954b3a98$export$6a5792c6e27b1800);
$parcel$export(module.exports, "getApplicationConfigForEnv", () => $d938a645954b3a98$export$80d83565c33cd5d6);
$parcel$export(module.exports, "mapBootstrapEnvToDeployEnv", () => $d938a645954b3a98$export$6b882a98975effc4);
/* eslint-disable import/default -- Rule isn't able to locate CJS style exports */ 
var $gz4uF = parcelRequire("gz4uF");

var $lPbX1 = parcelRequire("lPbX1");

var $648aQ = parcelRequire("648aQ");

var $jnh8o = parcelRequire("jnh8o");
function $d938a645954b3a98$export$83358b067e369e2d() {
/* do nothing */ }
function $d938a645954b3a98$export$fa3b29edae795ef4(e) {
    e.preventDefault();
}
function $d938a645954b3a98$export$6a5792c6e27b1800(resolve, maybePrimary, fallback) {
    return resolve(maybePrimary || fallback);
}
const $d938a645954b3a98$export$80d83565c33cd5d6 = (environment)=>{
    switch(environment){
        case 'local':
            return 0, $lPbX1.default;
        case 'dev':
            return 0, $gz4uF.default;
        case 'staging':
            return 0, $jnh8o.default;
        case 'prod':
            return 0, $648aQ.default;
        default:
            throw new Error('Invalid environment provided: ' + environment);
    }
};
const $d938a645954b3a98$export$6b882a98975effc4 = (environment)=>{
    switch(environment){
        case 'local':
            return 'local';
        case 'dev':
            return 'development';
        case 'staging':
            return 'staging';
        case 'prod':
            return 'production';
        default:
            console.error('Invalid environment provided: ' + environment);
            return 'production';
    }
};

});
parcelRegister("gz4uF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0f366942bec1deb$export$2e2bcd8739ae039);

var $aE09X = parcelRequire("aE09X");
const $c0f366942bec1deb$var$developmentConfig = {
    feedbackCollectorApiKeys: {
        privacyAndSecurity: {
            entrypointId: 'a1b01fe7-d62a-402c-8523-0d3edd4ffede'
        },
        generalFeedback: {
            entrypointId: '382c9b92-a4ff-45d1-bd4d-237ce0f5ac9f'
        }
    },
    stargateBaseUrl: 'https://api.stg.atlassian.com',
    adminHubBaseUrl: 'https://admin.stg.atlassian.com',
    algolia: {
        applicationId: '7LVR1JKTDF',
        apiKey: 'a341f16064d5bffd0ef8ea56b8099661',
        environment: 'stg'
    },
    analytics: {
        productAnalytics: {
            env: 'dev'
        }
    },
    featureFlags: {
        apiKey: '455fa60a-debf-4a78-8ec0-7fef7a97ae70',
        environment: (0, $aE09X.EnvironmentType).DEV
    },
    feedbackGatewayBaseUrl: 'https://marketplace.stg.internal.atlassian.com/gateway/api',
    mpacBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
    mpacCdnBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
    sentry: {
        dsn: 'https://7dffd006b22a440ebf23b41ff691432e@sentry.io/1464982',
        environment: 'development'
    },
    showDevtools: true,
    metal: {
        id: '26e25bc0-12d0-41d7-a9ec-1e080b812477',
        env: 'dev'
    },
    host: 'https://emcee.dev.internal.atlassian.com',
    graphQLGatewayUrl: 'https://api.stg.atlassian.com/graphql',
    atlassianCommunityBaseUrl: 'https://community.stg.atlassian.com',
    macBaseUrl: 'https://my.stg.internal.atlassian.com',
    wacBaseUrl: 'https://qa-wac.internal.atlassian.com',
    environment: 'dev'
};
var $c0f366942bec1deb$export$2e2bcd8739ae039 = $c0f366942bec1deb$var$developmentConfig;

});
parcelRegister("aE09X", function(module, exports) {

$parcel$export(module.exports, "Identifiers", () => $d3a0d334dab80550$export$9c27ea27f5856c02);
$parcel$export(module.exports, "EvaluationReason", () => $d3a0d334dab80550$export$c62558b199e46828);
$parcel$export(module.exports, "EvaluationErrorKind", () => $d3a0d334dab80550$export$d7bcec3eec83269a);
$parcel$export(module.exports, "ExposureType", () => $d3a0d334dab80550$export$5cea6b86291cee7a);
$parcel$export(module.exports, "EnvironmentType", () => $d3a0d334dab80550$export$76c40c36845e9385);
$parcel$export(module.exports, "PerimeterType", () => $d3a0d334dab80550$export$c42b7bbc5e7ba555);
$parcel$export(module.exports, "ReadyReason", () => $d3a0d334dab80550$export$efeb3009918d958);
$parcel$export(module.exports, "LogLevel", () => $d3a0d334dab80550$export$243e62d78d3b544d);
var $d3a0d334dab80550$export$9c27ea27f5856c02;
(function(Identifiers) {
    Identifiers["ANALYTICS_ANONYMOUS_ID"] = "analyticsAnonymousId";
    Identifiers["ATLASSIAN_ACCOUNT_ID"] = "atlassianAccountId";
    Identifiers["ATLASSIAN_ORG_ID"] = "atlassianOrgId";
    Identifiers["TENANT_ID"] = "tenantId";
    Identifiers["TRELLO_ANONYMOUS_ID"] = "trelloAnonymousId";
    Identifiers["TRELLO_USER_ID"] = "trelloUserId";
    Identifiers["FF_CLIENT_ANONYMOUS_ID"] = "ffClientAnonymousId";
})($d3a0d334dab80550$export$9c27ea27f5856c02 || ($d3a0d334dab80550$export$9c27ea27f5856c02 = {}));
var $d3a0d334dab80550$export$c62558b199e46828;
(function(EvaluationReason) {
    EvaluationReason["OFF"] = "OFF";
    EvaluationReason["FALLTHROUGH"] = "FALLTHROUGH";
    EvaluationReason["RULE_MATCH"] = "RULE_MATCH";
    EvaluationReason["TARGET_MATCH"] = "TARGET_MATCH";
    EvaluationReason["PREREQUISITE_FAILED"] = "PREREQUISITE_FAILED";
    EvaluationReason["ERROR"] = "ERROR";
    EvaluationReason["INELIGIBLE"] = "INELIGIBLE";
    EvaluationReason["OVERRIDE"] = "OVERRIDE";
})($d3a0d334dab80550$export$c62558b199e46828 || ($d3a0d334dab80550$export$c62558b199e46828 = {}));
var $d3a0d334dab80550$export$d7bcec3eec83269a;
(function(EvaluationErrorKind) {
    EvaluationErrorKind["CLIENT_NOT_READY"] = "CLIENT_NOT_READY";
    EvaluationErrorKind["FLAG_NOT_FOUND"] = "FLAG_NOT_FOUND";
    EvaluationErrorKind["WRONG_TYPE"] = "WRONG_TYPE";
    EvaluationErrorKind["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    EvaluationErrorKind["SERVER_ERROR"] = "SERVER_ERROR";
    EvaluationErrorKind["OTHER"] = "OTHER";
})($d3a0d334dab80550$export$d7bcec3eec83269a || ($d3a0d334dab80550$export$d7bcec3eec83269a = {}));
var $d3a0d334dab80550$export$5cea6b86291cee7a;
(function(ExposureType) {
    // Consumer sets shouldSendExposureEvent to true
    ExposureType["OptIn"] = "optInExposure";
    // Consumer does not pass in shouldSendExposureEvent (fired as part of TAC)
    ExposureType["Automatic"] = "autoExposure";
    // Consumer sent custom attributes along with the request (this is used in addition to the above)
    ExposureType["HasCustomAttributes"] = "hasCustomAttributes";
})($d3a0d334dab80550$export$5cea6b86291cee7a || ($d3a0d334dab80550$export$5cea6b86291cee7a = {}));
var $d3a0d334dab80550$export$76c40c36845e9385;
(function(EnvironmentType) {
    EnvironmentType["LOCAL"] = "local";
    EnvironmentType["DEV"] = "dev";
    EnvironmentType["STAGING"] = "staging";
    EnvironmentType["PROD"] = "prod";
})($d3a0d334dab80550$export$76c40c36845e9385 || ($d3a0d334dab80550$export$76c40c36845e9385 = {}));
var $d3a0d334dab80550$export$c42b7bbc5e7ba555;
(function(PerimeterType) {
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
})($d3a0d334dab80550$export$c42b7bbc5e7ba555 || ($d3a0d334dab80550$export$c42b7bbc5e7ba555 = {}));
var $d3a0d334dab80550$export$efeb3009918d958;
(function(ReadyReason) {
    ReadyReason["CACHE"] = "CACHE";
    ReadyReason["FETCH"] = "FETCH";
    ReadyReason["CLIENT_ERROR"] = "CLIENT_ERROR";
    ReadyReason["SERVER_ERROR"] = "SERVER_ERROR";
})($d3a0d334dab80550$export$efeb3009918d958 || ($d3a0d334dab80550$export$efeb3009918d958 = {}));
var $d3a0d334dab80550$export$243e62d78d3b544d;
(function(LogLevel) {
    // Dont use 0 to prevent falsy values
    LogLevel[LogLevel["DEBUG"] = 1] = "DEBUG";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["LOG"] = 3] = "LOG";
    LogLevel[LogLevel["WARN"] = 4] = "WARN";
    LogLevel[LogLevel["ERROR"] = 5] = "ERROR";
})($d3a0d334dab80550$export$243e62d78d3b544d || ($d3a0d334dab80550$export$243e62d78d3b544d = {}));

});


parcelRegister("lPbX1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe37a19d954bf7ce$export$2e2bcd8739ae039);

var $aE09X = parcelRequire("aE09X");
var $8tM2T = parcelRequire("8tM2T");
const $fe37a19d954bf7ce$var$localConfig = {
    feedbackCollectorApiKeys: {
        privacyAndSecurity: {
            entrypointId: 'a1b01fe7-d62a-402c-8523-0d3edd4ffede'
        },
        generalFeedback: {
            entrypointId: '382c9b92-a4ff-45d1-bd4d-237ce0f5ac9f'
        }
    },
    stargateBaseUrl: 'https://api.stg.atlassian.com',
    adminHubBaseUrl: 'https://admin.stg.atlassian.com',
    algolia: {
        applicationId: '7LVR1JKTDF',
        apiKey: '15f50298dd61ef869dcbf0db33add5fd',
        environment: 'stg'
    },
    sentry: {
        dsn: 'https://7dffd006b22a440ebf23b41ff691432e@sentry.io/1464982',
        environment: 'local'
    },
    analytics: {
        productAnalytics: {
            env: 'local'
        }
    },
    host: '',
    featureFlags: {
        apiKey: '455fa60a-debf-4a78-8ec0-7fef7a97ae70',
        environment: (0, $aE09X.EnvironmentType).DEV
    },
    statsig: {
        // confluence dev -- 1a9e352b-a0c4-4678-8f09-6a43d1e2b0cc
        // jira dev -- 8da3f751-e5a7-4a9c-8d33-425bf098fbe8
        // compass dev -- a78a83e2-f9e2-46e6-8ac9-046360f8a1ba
        clientKey: '8da3f751-e5a7-4a9c-8d33-425bf098fbe8',
        environment: (0, $8tM2T.FeatureGateEnvironment).Development,
        targetApp: 'jira_web' // options are jira_web, confluence_web, compass_web
    },
    mpacBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
    feedbackGatewayBaseUrl: 'https://marketplace.stg.internal.atlassian.com/gateway/api',
    mpacCdnBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
    showDevtools: true,
    metal: {
        id: '26e25bc0-12d0-41d7-a9ec-1e080b812477',
        env: 'local'
    },
    graphQLGatewayUrl: 'https://api.stg.atlassian.com/graphql',
    atlassianCommunityBaseUrl: 'https://community.stg.atlassian.com',
    macBaseUrl: 'https://my.stg.internal.atlassian.com',
    wacBaseUrl: 'https://qa-wac.internal.atlassian.com',
    environment: 'local'
};
var $fe37a19d954bf7ce$export$2e2bcd8739ae039 = $fe37a19d954bf7ce$var$localConfig;

});

parcelRegister("648aQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $46a974fbd3669134$export$2e2bcd8739ae039);

var $aE09X = parcelRequire("aE09X");
const $46a974fbd3669134$var$productionConfig = {
    feedbackCollectorApiKeys: {
        privacyAndSecurity: {
            entrypointId: 'a1b01fe7-d62a-402c-8523-0d3edd4ffede'
        },
        generalFeedback: {
            entrypointId: '382c9b92-a4ff-45d1-bd4d-237ce0f5ac9f'
        }
    },
    stargateBaseUrl: 'https://api.atlassian.com',
    adminHubBaseUrl: 'https://admin.atlassian.com',
    algolia: {
        applicationId: '7LVR1JKTDF',
        apiKey: '7a76648b718415a8c56fb8fa211c9a95',
        environment: 'prod'
    },
    analytics: {
        productAnalytics: {
            env: 'prod'
        }
    },
    featureFlags: {
        apiKey: '1f5d5f93-c052-4372-bc81-a99b00e04bc0',
        environment: (0, $aE09X.EnvironmentType).PROD
    },
    mpacBaseUrl: 'https://marketplace.atlassian.com',
    feedbackGatewayBaseUrl: 'https://marketplace.atlassian.com/gateway/api',
    mpacCdnBaseUrl: 'https://marketplace.atlassian.com',
    sentry: {
        dsn: 'https://7dffd006b22a440ebf23b41ff691432e@sentry.io/1464982',
        environment: 'production'
    },
    showDevtools: false,
    host: 'https://emcee.atlassian.com',
    metal: {
        id: '26e25bc0-12d0-41d7-a9ec-1e080b812477',
        env: 'prod'
    },
    graphQLGatewayUrl: 'https://api.atlassian.com/graphql',
    atlassianCommunityBaseUrl: 'https://community.atlassian.com',
    macBaseUrl: 'https://my.atlassian.com',
    wacBaseUrl: 'https://www.atlassian.com',
    environment: 'prod'
};
var $46a974fbd3669134$export$2e2bcd8739ae039 = $46a974fbd3669134$var$productionConfig;

});

parcelRegister("jnh8o", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1ad74d5a9c32760$export$2e2bcd8739ae039);

var $aE09X = parcelRequire("aE09X");
const $e1ad74d5a9c32760$var$stagingConfig = {
    feedbackCollectorApiKeys: {
        privacyAndSecurity: {
            entrypointId: 'a1b01fe7-d62a-402c-8523-0d3edd4ffede'
        },
        generalFeedback: {
            entrypointId: '382c9b92-a4ff-45d1-bd4d-237ce0f5ac9f'
        }
    },
    stargateBaseUrl: 'https://api.stg.atlassian.com',
    adminHubBaseUrl: 'https://admin.stg.atlassian.com',
    algolia: {
        applicationId: '7LVR1JKTDF',
        apiKey: 'f12b1855dca7e6694da17dcfd66e90a8',
        environment: 'stg'
    },
    analytics: {
        productAnalytics: {
            env: 'staging'
        }
    },
    featureFlags: {
        apiKey: '3f02f534-555d-43d9-97d2-55ea3802d0d2',
        environment: (0, $aE09X.EnvironmentType).STAGING
    },
    mpacBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
    feedbackGatewayBaseUrl: 'https://marketplace.stg.internal.atlassian.com/gateway/api',
    mpacCdnBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
    sentry: {
        dsn: 'https://7dffd006b22a440ebf23b41ff691432e@sentry.io/1464982',
        environment: 'staging'
    },
    showDevtools: Boolean(undefined),
    host: 'https://emcee.stg.internal.atlassian.com',
    metal: {
        id: '26e25bc0-12d0-41d7-a9ec-1e080b812477',
        env: 'staging'
    },
    graphQLGatewayUrl: 'https://api.stg.atlassian.com/graphql',
    atlassianCommunityBaseUrl: 'https://community.stg.atlassian.com',
    macBaseUrl: 'https://my.stg.internal.atlassian.com',
    wacBaseUrl: 'https://qa-wac.internal.atlassian.com',
    environment: 'staging'
};
var $e1ad74d5a9c32760$export$2e2bcd8739ae039 = $e1ad74d5a9c32760$var$stagingConfig;

});


parcelRegister("2FaVi", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f07e23c3e013e3f$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $aWvIp = parcelRequire("aWvIp");

var $blejQ = parcelRequire("blejQ");

var $96IgR = parcelRequire("96IgR");

var $j0gMm = parcelRequire("j0gMm");

var $eUqFw = parcelRequire("eUqFw");
function $1f07e23c3e013e3f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1f07e23c3e013e3f$var$BannerAndIconContainer = (0, $3UXZ8.default)("div", {
    target: "e34h9jk0",
    label: "BannerAndIconContainer"
})({
    name: "1uuw7ai",
    styles: "display:flex;margin:10px 0;"
});
const $1f07e23c3e013e3f$var$IconContainer = (0, $3UXZ8.default)("div", {
    target: "e34h9jk1",
    label: "IconContainer"
})("color:", (props)=>props.color, ";flex:0;min-width:32px;");
const $1f07e23c3e013e3f$var$TextContainer = (0, $3UXZ8.default)("div", {
    target: "e34h9jk2",
    label: "TextContainer"
})({
    name: "bbvf7x",
    styles: "flex:1 0 0;padding-top:3px;"
});
class $1f07e23c3e013e3f$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    render() {
        let Icon;
        let iconColor;
        switch(this.props.icon){
            case 'error':
                Icon = (0, (/*@__PURE__*/$parcel$interopDefault($96IgR)));
                iconColor = (0, $j0gMm.R300);
                break;
            case 'warning':
                Icon = (0, (/*@__PURE__*/$parcel$interopDefault($blejQ)));
                iconColor = (0, $j0gMm.Y500);
                break;
            case 'success':
                Icon = (0, (/*@__PURE__*/$parcel$interopDefault($aWvIp)));
                iconColor = (0, $j0gMm.G300);
                break;
            default:
                console.error("Unknown Icon '".concat(this.props.icon, "', must be error, warning, success. Defaulting to success."));
                Icon = (0, (/*@__PURE__*/$parcel$interopDefault($aWvIp)));
                iconColor = (0, $j0gMm.G300);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f07e23c3e013e3f$var$BannerAndIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f07e23c3e013e3f$var$IconContainer, {
            color: iconColor
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
            size: "medium",
            label: this.props.icon
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f07e23c3e013e3f$var$TextContainer, null, this.props.children));
    }
}

});
parcelRegister("blejQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $841cc35b0ae95138$var$_react = $841cc35b0ae95138$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $841cc35b0ae95138$var$_warning = $841cc35b0ae95138$var$_interopRequireDefault((parcelRequire("ewJfY")));
function $841cc35b0ae95138$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $841cc35b0ae95138$var$EditorWarningIcon = (props)=>/*#__PURE__*/ $841cc35b0ae95138$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m13.31 5.343 7.359 13.17A1 1 0 0 1 19.796 20H4.204a1 1 0 0 1-.873-1.488l7.36-13.169a1.5 1.5 0 0 1 2.618 0M12 8.5a1.09 1.09 0 0 0-1.081 1.239l.513 3.766a.573.573 0 0 0 1.136 0l.513-3.766A1.09 1.09 0 0 0 12 8.5m0 8.63a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"/></svg>`
    }, props, {
        newIcon: $841cc35b0ae95138$var$_warning.default
    }));
$841cc35b0ae95138$var$EditorWarningIcon.displayName = 'EditorWarningIcon';
var $841cc35b0ae95138$var$_default = module.exports.default = $841cc35b0ae95138$var$EditorWarningIcon;

});


parcelRegister("2dt3P", function(module, exports) {

$parcel$export(module.exports, "default", () => $19d3568c2a1cb723$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $kU8RF = parcelRequire("kU8RF");

var $eUqFw = parcelRequire("eUqFw");

var $i7hUf = parcelRequire("i7hUf");

var $2FaVi = parcelRequire("2FaVi");

var $jooEA = parcelRequire("jooEA");
function $19d3568c2a1cb723$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $19d3568c2a1cb723$export$f1b333dd56782094 = (0, $3UXZ8.default)("div", {
    target: "ex6c2xf0",
    label: "ErrorHeading"
})({
    name: "in3yi3",
    styles: "font-weight:bold;"
});
const $19d3568c2a1cb723$export$f57711b96c55e5ec = (0, $3UXZ8.default)("div", {
    target: "ex6c2xf1",
    label: "ErrorSubdescription"
})("color:", (0, $j0gMm.N80), ";");
function $19d3568c2a1cb723$export$2e2bcd8739ae039(_ref) {
    let { installMode: installMode, errorDetails: errorDetails, content: content } = _ref;
    /*
   * Need to display the SpinnerMask here rather than in the individual install dialogs' content
   * so that we can ensure that we end the spinner animation cleanly.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kU8RF.default), {
        active: (0, $i7hUf.foldInstallMode)(installMode)((determiningInstallMode)=>!determiningInstallMode.error, ()=>false, ()=>false, ()=>false, ()=>false, ()=>false),
        delay: 1000,
        size: 50
    }, errorDetails.map((ec)=>/*#__PURE__*/ // eslint-disable-next-line react/jsx-key
        (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2FaVi.default), {
            icon: "error"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jooEA.default), {
            errorDetails: ec
        }))).orNull(), content);
}

});
parcelRegister("i7hUf", function(module, exports) {

$parcel$export(module.exports, "foldInstallMode", () => $d306c544bb56b97c$export$9c5311127f778044);

var $9Qzgt = parcelRequire("9Qzgt");

var $8ZSlI = parcelRequire("8ZSlI");

var $249j9 = parcelRequire("249j9");

var $4s0An = parcelRequire("4s0An");

var $gR0l9 = parcelRequire("gR0l9");

var $k5vUT = parcelRequire("k5vUT");
function $d306c544bb56b97c$export$9c5311127f778044(installMode) {
    return function(determining, asp, instructional, installableAppDefault, installableAppByManualUrl, installableAppUpgrade) {
        switch(installMode.type){
            case 0, $8ZSlI.DETERMINING_INSTALL_MODE:
                return determining(installMode);
            case 0, $9Qzgt.APP_SPECIFIC_PASSWORD_INSTALL_MODE:
                return asp(installMode);
            case 0, $k5vUT.INSTRUCTIONAL_INSTALL_MODE:
                return instructional(installMode);
            case 0, $4s0An.INSTALLABLE_APP_DEFAULT_INSTALL_MODE:
                return installableAppDefault(installMode);
            case 0, $249j9.INSTALLABLE_APP_BY_MANUAL_URL_INSTALL_MODE:
                return installableAppByManualUrl(installMode);
            case 0, $gR0l9.INSTALLABLE_APP_UPGRADE_INSTALL_MODE:
                return installableAppUpgrade(installMode);
            default:
                // Flow compile-time validation that we've handled every discover item
                // prettier-ignore
                installMode;
                return undefined;
        }
    };
}

});
parcelRegister("9Qzgt", function(module, exports) {

$parcel$export(module.exports, "APP_SPECIFIC_PASSWORD_INSTALL_MODE", () => $72b45335ac2f6a9a$export$9cb515f69b706cd0);
$parcel$export(module.exports, "makeAppSpecificPassword", () => $72b45335ac2f6a9a$export$fff6f05231d143cd);
$parcel$export(module.exports, "makeAppSpecificPasswordInstallMode", () => $72b45335ac2f6a9a$export$11021b8ea655afdf);

var $cjFit = parcelRequire("cjFit");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $9eIgo = parcelRequire("9eIgo");
const $72b45335ac2f6a9a$export$9cb515f69b706cd0 = 'APP_SPECIFIC_PASSWORD';
const $72b45335ac2f6a9a$export$fff6f05231d143cd = (0, $g5DHJ.Record)({
    name: (0, $cjFit.nonEmptyString)('name'),
    // Invalid, but need a default
    status: (0, $9eIgo.makePendingConfirmationInstallStatus)()
});
const $72b45335ac2f6a9a$export$11021b8ea655afdf = (0, $g5DHJ.Record)({
    type: $72b45335ac2f6a9a$export$9cb515f69b706cd0,
    appSpecificPassword: (0, $bWAru.Option).empty()
});

});

parcelRegister("8ZSlI", function(module, exports) {

$parcel$export(module.exports, "DETERMINING_INSTALL_MODE", () => $68ce2dd850cfe612$export$506414a7e1b36cd3);
$parcel$export(module.exports, "makeDeterminingInstallMode", () => $68ce2dd850cfe612$export$7660d47c48dc9770);

var $g5DHJ = parcelRequire("g5DHJ");
const $68ce2dd850cfe612$export$506414a7e1b36cd3 = 'DETERMINING';
const $68ce2dd850cfe612$export$7660d47c48dc9770 = (0, $g5DHJ.Record)({
    type: $68ce2dd850cfe612$export$506414a7e1b36cd3,
    error: undefined,
    retrievalId: 0
});

});

parcelRegister("249j9", function(module, exports) {

$parcel$export(module.exports, "INSTALLABLE_APP_BY_MANUAL_URL_INSTALL_MODE", () => $18132cdaf7d3c162$export$e8f423240d2d9429);
$parcel$export(module.exports, "makeInstallableAppByManualUrl", () => $18132cdaf7d3c162$export$6542ad248273e702);
$parcel$export(module.exports, "makeInstallableAppByManualUrlInstallMode", () => $18132cdaf7d3c162$export$8a4eafb48d07657);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $ifMZN = parcelRequire("ifMZN");

var $9eIgo = parcelRequire("9eIgo");
const $18132cdaf7d3c162$export$e8f423240d2d9429 = 'INSTALLABLE_APP_BY_MANUAL_URL';
const $18132cdaf7d3c162$export$6542ad248273e702 = (0, $g5DHJ.Record)({
    installableApp: (0, $bWAru.Option).empty(),
    installableAppByUrlId: (0, $ifMZN.makeInstallableAppByUrlIdentifier)(),
    installedApp: (0, $bWAru.Option).empty(),
    retrievalId: 0,
    status: (0, $9eIgo.makePendingConfirmationInstallStatus)()
});
const $18132cdaf7d3c162$export$8a4eafb48d07657 = (0, $g5DHJ.Record)({
    type: $18132cdaf7d3c162$export$e8f423240d2d9429,
    installableAppByManualUrl: (0, $bWAru.Option).empty()
});

});

parcelRegister("gR0l9", function(module, exports) {

$parcel$export(module.exports, "INSTALLABLE_APP_UPGRADE_INSTALL_MODE", () => $c451dc250aa0bd01$export$1fd9fc9af34de98e);
$parcel$export(module.exports, "makeInstallableAppUpgradeInstallMode", () => $c451dc250aa0bd01$export$fb25e9237d7af4b4);

var $4gzHi = parcelRequire("4gzHi");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $ifMZN = parcelRequire("ifMZN");

var $9eIgo = parcelRequire("9eIgo");
const $c451dc250aa0bd01$export$1fd9fc9af34de98e = 'INSTALLABLE_APP_UPGRADE';
const $c451dc250aa0bd01$export$fb25e9237d7af4b4 = (0, $g5DHJ.Record)({
    type: $c451dc250aa0bd01$export$1fd9fc9af34de98e,
    installableAppByKeyId: (0, $ifMZN.makeInstallableAppByKeyIdentifier)(),
    installableAppToUpgradeTo: (0, $bWAru.Option).empty(),
    installedApp: (0, $4gzHi._makeInstalledApp)(),
    retrievalId: 0,
    status: (0, $9eIgo.makePendingConfirmationInstallStatus)()
});

});
parcelRegister("4gzHi", function(module, exports) {

$parcel$export(module.exports, "_makeInstalledApp", () => $31b458c829d86ba2$export$8ee10d0985daad93);
$parcel$export(module.exports, "makeInstalledAppFromSPIInstalledApp", () => $31b458c829d86ba2$export$7f8bc2bf680f0db4);

var $lQqqi = parcelRequire("lQqqi");
var $8kbfx = parcelRequire("8kbfx");
var $iyohm = parcelRequire("iyohm");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $7r0ma = parcelRequire("7r0ma");

var $Xg3T7 = parcelRequire("Xg3T7");
const $31b458c829d86ba2$export$de7a72915f1a9a78 = (installationId)=>installationId;
const $31b458c829d86ba2$export$8ee10d0985daad93 = (0, $g5DHJ.Record)({
    // Casting to any here since it's a bit too much overhead to define a massive default for something we never interact with
    _original: {},
    authType: (0, $lQqqi.makeTwoLeggedAuthType)(),
    configureUrl: undefined,
    details: (0, $7r0ma.makeSPIAppDisplayDetails)((0, $7r0ma.makeAppDisplayDetails)()),
    getStartedUrl: undefined,
    installationId: '',
    installTime: new Date(),
    installUser: undefined,
    manageAppUrl: undefined,
    marketplaceAppDetails: undefined,
    scopes: (0, $g5DHJ.List)(),
    uninstallInProgress: false,
    upgradeAvailable: false,
    paymentModel: (0, $bWAru.Either).left((0, $Xg3T7.makeFreePaymentModel)())
});
const $31b458c829d86ba2$export$bc7992b6d64fb144 = $31b458c829d86ba2$export$8ee10d0985daad93;
const $31b458c829d86ba2$export$7f8bc2bf680f0db4 = (installedAddon)=>$31b458c829d86ba2$export$bc7992b6d64fb144({
        _original: installedAddon,
        authType: (0, $lQqqi.makeAuthTypeFromSPIAuthType)(installedAddon.authType),
        configureUrl: installedAddon.configureUrl,
        details: (0, $7r0ma.makeSPIAppDisplayDetailsFromSPIAddonDisplayDetails)(installedAddon.details),
        getStartedUrl: installedAddon.getStartedUrl,
        installationId: installedAddon.installationId,
        installTime: installedAddon.installTime,
        installUser: installedAddon.installUser ? (0, $iyohm.makeUserFromSPIUser)(installedAddon.installUser) : undefined,
        manageAppUrl: installedAddon.manageAppUrl,
        scopes: (0, $g5DHJ.List)(installedAddon.scopes).map((0, $8kbfx.makeScopeKey)),
        uninstallInProgress: false,
        upgradeAvailable: !installedAddon.latestVersion,
        paymentModel: (0, $Xg3T7.makePaymentModelFromSPIPaymentModel)(installedAddon.paymentModel)
    });

});
parcelRegister("lQqqi", function(module, exports) {

$parcel$export(module.exports, "makeTwoLeggedAuthType", () => $fe72f3647b54c516$export$6d29d4c11d9b8376);
$parcel$export(module.exports, "foldAuthType", () => $fe72f3647b54c516$export$8115abb41319a3c8);
$parcel$export(module.exports, "makeAuthTypeFromSPIAuthType", () => $fe72f3647b54c516$export$f8c4efe8924e0819);

var $g5DHJ = parcelRequire("g5DHJ");

var $k0za9 = parcelRequire("k0za9");
const $fe72f3647b54c516$var$ASP_AUTH_TYPE = 'ASP';
const $fe72f3647b54c516$var$TWO_LEGGED_AUTH_TYPE = '2LO';
const $fe72f3647b54c516$var$THREE_LEGGED_AUTH_TYPE = '3LO';
const $fe72f3647b54c516$export$3c87d1b2b0775bd6 = (0, $g5DHJ.Record)({
    type: $fe72f3647b54c516$var$ASP_AUTH_TYPE
});
const $fe72f3647b54c516$export$6d29d4c11d9b8376 = (0, $g5DHJ.Record)({
    type: $fe72f3647b54c516$var$TWO_LEGGED_AUTH_TYPE
});
const $fe72f3647b54c516$export$d5c5ddf1a25c3256 = (0, $g5DHJ.Record)({
    type: $fe72f3647b54c516$var$THREE_LEGGED_AUTH_TYPE,
    grants: (0, $g5DHJ.List)()
});
function $fe72f3647b54c516$export$8115abb41319a3c8(authType) {
    return function(asp, twoLegged, threeLegged) {
        switch(authType.type){
            case $fe72f3647b54c516$var$ASP_AUTH_TYPE:
                return asp(authType);
            case $fe72f3647b54c516$var$TWO_LEGGED_AUTH_TYPE:
                return twoLegged(authType);
            case $fe72f3647b54c516$var$THREE_LEGGED_AUTH_TYPE:
                return threeLegged(authType);
            default:
                authType;
                return undefined;
        }
    };
}
const $fe72f3647b54c516$export$f8c4efe8924e0819 = (spiAuthType)=>{
    switch(spiAuthType.type){
        case 'ASP':
            return $fe72f3647b54c516$export$3c87d1b2b0775bd6();
        case '2LO':
            return $fe72f3647b54c516$export$6d29d4c11d9b8376();
        case '3LO':
            return $fe72f3647b54c516$export$d5c5ddf1a25c3256({
                grants: (0, $g5DHJ.List)(spiAuthType.grants).map((0, $k0za9.makeUserGrantFromSPIUserGrant))
            });
        default:
            spiAuthType; // to check that all cases are covered
            return undefined;
    }
};

});
parcelRegister("k0za9", function(module, exports) {

$parcel$export(module.exports, "makeUserGrantFromSPIUserGrant", () => $e90f154bf5c62f07$export$6c336a743fa72373);

var $g5DHJ = parcelRequire("g5DHJ");

var $8kbfx = parcelRequire("8kbfx");

var $iyohm = parcelRequire("iyohm");
const $e90f154bf5c62f07$export$165a600004d75fa9 = (0, $g5DHJ.Record)({
    scopes: (0, $g5DHJ.List)(),
    revokeInProgress: false,
    time: new Date(),
    user: (0, $iyohm._makeUser)() // Using internal unsafe constructor for default
});
const $e90f154bf5c62f07$export$6c336a743fa72373 = (spiUserGrant)=>$e90f154bf5c62f07$export$165a600004d75fa9({
        user: (0, $iyohm.makeUserFromSPIUser)(spiUserGrant.user),
        scopes: (0, $g5DHJ.List)(spiUserGrant.scopes).map((0, $8kbfx.makeScopeKey)),
        time: spiUserGrant.time
    });

});
parcelRegister("iyohm", function(module, exports) {

$parcel$export(module.exports, "makeUserId", () => $d81e3c4cbde33f2e$export$64cebb1eac286868);
$parcel$export(module.exports, "_makeUser", () => $d81e3c4cbde33f2e$export$9bc63df8e2f0a0c6);
$parcel$export(module.exports, "makeUserFromSPIUser", () => $d81e3c4cbde33f2e$export$41ce4899f8b30dcb);

var $g5DHJ = parcelRequire("g5DHJ");
function $d81e3c4cbde33f2e$export$64cebb1eac286868(userId) {
    return userId;
}
const $d81e3c4cbde33f2e$export$9bc63df8e2f0a0c6 = (0, $g5DHJ.Record)({
    // Casting to any here since it's a bit too much overhead to define a massive default for something we never interact with
    _original: {},
    atlassianAccountId: $d81e3c4cbde33f2e$export$64cebb1eac286868(''),
    avatarUrl: undefined,
    mention: undefined,
    name: ''
});
const $d81e3c4cbde33f2e$export$4e4c41e4152a9f8a = $d81e3c4cbde33f2e$export$9bc63df8e2f0a0c6;
const $d81e3c4cbde33f2e$export$41ce4899f8b30dcb = (spiUser)=>$d81e3c4cbde33f2e$export$4e4c41e4152a9f8a({
        _original: spiUser,
        atlassianAccountId: $d81e3c4cbde33f2e$export$64cebb1eac286868(spiUser.atlassianAccountId),
        avatarUrl: spiUser.avatarUrl,
        mention: spiUser.mention,
        name: spiUser.name
    });

});



parcelRegister("Xg3T7", function(module, exports) {

$parcel$export(module.exports, "makeFreePaymentModel", () => $0b21f852d3fbd4cb$export$685ce76b5d1b91db);
$parcel$export(module.exports, "makePaymentModelFromSPIPaymentModel", () => $0b21f852d3fbd4cb$export$f2061a27ae983327);

var $gC8Po = parcelRequire("gC8Po");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $dWeBB = parcelRequire("dWeBB");

var $668Xv = parcelRequire("668Xv");
const $0b21f852d3fbd4cb$export$685ce76b5d1b91db = (0, $g5DHJ.Record)({
    type: 'free'
});
const $0b21f852d3fbd4cb$export$cf4ca76d2a45cbe5 = (0, $g5DHJ.Record)({
    type: 'paid',
    licenseType: (0, $bWAru.Either).left((0, $668Xv.makeEvaluationLicenseType)())
});
const $0b21f852d3fbd4cb$export$6ca88fe7466617e6 = (a)=>$0b21f852d3fbd4cb$export$cf4ca76d2a45cbe5({
        type: 'paid',
        licenseType: (0, $dWeBB.foldLicenseType)(a.licenseType)((e)=>(0, $bWAru.Either).left((0, $668Xv.makeEvaluationLicenseType)(e)), (s)=>(0, $bWAru.Either).right((0, $668Xv.makeSubscriptionLicenseType)(s)))
    });
const $0b21f852d3fbd4cb$export$f2061a27ae983327 = (a)=>{
    switch(a.type){
        case 'free':
            return (0, $bWAru.Either).left($0b21f852d3fbd4cb$export$685ce76b5d1b91db(a));
        case 'paid':
            return (0, $bWAru.Either).right($0b21f852d3fbd4cb$export$6ca88fe7466617e6(a));
        default:
            throw (0, $gC8Po.default).unexpectedCase(a);
    }
};

});
parcelRegister("dWeBB", function(module, exports) {

$parcel$export(module.exports, "foldLicenseType", () => $a25c057b8af177be$export$485b10ad458c54a3);

var $gC8Po = parcelRequire("gC8Po");
const $a25c057b8af177be$export$485b10ad458c54a3 = (a)=>(evaluation, subscription)=>{
        switch(a.type){
            case 'evaluation':
                return evaluation(a);
            case 'subscription':
                return subscription(a);
            default:
                throw (0, $gC8Po.default).unexpectedCase(a);
        }
    };

});

parcelRegister("668Xv", function(module, exports) {

$parcel$export(module.exports, "makeEvaluationLicenseType", () => $470a40a257b09961$export$5bfcfec195bfaecf);
$parcel$export(module.exports, "makeSubscriptionLicenseType", () => $470a40a257b09961$export$ab7d4d2edd11ac8a);

var $g5DHJ = parcelRequire("g5DHJ");
const $470a40a257b09961$export$5bfcfec195bfaecf = (0, $g5DHJ.Record)({
    type: 'evaluation',
    expiry: -1,
    isAutoRenewal: false
});
const $470a40a257b09961$export$f80f13b77a421a99 = (0, $g5DHJ.Record)({
    isAutoRenewal: true
});
const $470a40a257b09961$export$c7294c35415980d3 = (0, $g5DHJ.Record)({
    isAutoRenewal: false,
    endDate: -1
});
const $470a40a257b09961$export$ab7d4d2edd11ac8a = (0, $g5DHJ.Record)({
    type: 'subscription',
    renewalType: $470a40a257b09961$export$f80f13b77a421a99()
});

});





parcelRegister("jooEA", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1e361ec2421ea2e$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $eUqFw = parcelRequire("eUqFw");
function $e1e361ec2421ea2e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e1e361ec2421ea2e$export$f1b333dd56782094 = (0, $3UXZ8.default)("div", {
    target: "e1lynmon0",
    label: "ErrorHeading"
})({
    name: "in3yi3",
    styles: "font-weight:bold;"
});
const $e1e361ec2421ea2e$export$f57711b96c55e5ec = (0, $3UXZ8.default)("div", {
    target: "e1lynmon1",
    label: "ErrorSubdescription"
})("color:", (0, $j0gMm.N80), ";");
class $e1e361ec2421ea2e$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "render", ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e1e361ec2421ea2e$export$f1b333dd56782094, null, this.props.errorDetails.translation.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, this.props.errorDetails.translation.description), this.props.errorDetails.translation.showTID ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e1e361ec2421ea2e$export$f57711b96c55e5ec, null, "TID: ", this.props.errorDetails.tid, ", Type: ", this.props.errorDetails.type) : null));
    }
}

});


parcelRegister("05YC4", function(module, exports) {

$parcel$export(module.exports, "default", () => $0004a30948cdcacf$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $eUqFw = parcelRequire("eUqFw");
function $0004a30948cdcacf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0004a30948cdcacf$export$651095642c93be3d = (0, $3UXZ8.default)("div", {
    target: "e8pyone0",
    label: "FooterContainer"
})("border-top:2px solid ", "var(--ds-border, ".concat((0, $j0gMm.N30), ")"), ";display:flex;padding:25px var(--ds-space-250, 20px);align-items:center;");
const $0004a30948cdcacf$export$ebe8d15c5d116a5d = (0, $3UXZ8.default)("div", {
    target: "e8pyone1",
    label: "FooterCenterContainer"
})({
    name: "ydhtu0",
    styles: "display:flex;flex:1 0 auto;margin:0 var(--ds-space-200, 16px);"
});
const $0004a30948cdcacf$export$ffda048559b3b0a4 = (0, $3UXZ8.default)("div", {
    target: "e8pyone2",
    label: "FooterItemInner"
})({
    name: "1d3j0nz",
    styles: "flex:1;margin:auto 0;"
});
function $0004a30948cdcacf$export$2e2bcd8739ae039(_ref) {
    let { footerLeft: footerLeft, footerCenter: footerCenter, footerRight: footerRight, privacyInformation: privacyInformation } = _ref;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, privacyInformation, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0004a30948cdcacf$export$651095642c93be3d, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0004a30948cdcacf$export$ffda048559b3b0a4, null, footerLeft)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0004a30948cdcacf$export$ebe8d15c5d116a5d, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0004a30948cdcacf$export$ffda048559b3b0a4, null, footerCenter)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0004a30948cdcacf$export$ffda048559b3b0a4, null, footerRight))));
}

});

parcelRegister("eJGKo", function(module, exports) {

$parcel$export(module.exports, "default", () => $aba66d62ff33ccf7$export$2e2bcd8739ae039);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $eUqFw = parcelRequire("eUqFw");

var $gIQkA = parcelRequire("gIQkA");

var $9eIgo = parcelRequire("9eIgo");

var $hsaiM = parcelRequire("hsaiM");

var $dvM4B = parcelRequire("dvM4B");

var $1BmPt = parcelRequire("1BmPt");

var $jnM8o = parcelRequire("jnM8o");

var $2bemU = parcelRequire("2bemU");

var $lgdWX = parcelRequire("lgdWX");

var $8vnXh = parcelRequire("8vnXh");

var $4LsDF = parcelRequire("4LsDF");
const $aba66d62ff33ccf7$var$resolveDialogDefault = // eslint-disable-next-line max-lines-per-function
(_ref)=>{
    let { closeInstallDialog: closeInstallDialog, context: context, defaultInstallMode: defaultInstallMode, hostConfig: hostConfig, appDetailsFromSearchResponse: appDetailsFromSearchResponse, hostInfo: hostInfo, hostPricing: hostPricing, installApp: installApp, links: links, scopesLookup: scopesLookup, mpacBaseUrl: mpacBaseUrl, onRendered: onRendered, featureFlags: featureFlags, isInstallInProgress: isInstallInProgress, forgeAppEgressAddresses: forgeAppEgressAddresses } = _ref;
    return {
        analyticsSourceModal: defaultInstallMode.installPermission.fold(()=>(0, $gIQkA.ANALYTICS_MODAL_NO_INSTALL_PERMISSION), ()=>(0, $gIQkA.ANALYTICS_MODAL_INSTALL)),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LsDF.default), {
            hostPricing: hostPricing,
            installableApp: defaultInstallMode.installableApp,
            installedApp: defaultInstallMode.installedApp,
            links: links,
            appDetailsFromSearchResponse: appDetailsFromSearchResponse,
            scopesLookup: scopesLookup,
            mpacBaseUrl: mpacBaseUrl,
            onRendered: onRendered,
            forgeAppEgressAddresses: forgeAppEgressAddresses
        }),
        heading: "Add to ".concat(hostConfig.installationLocation),
        footerLeft: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jnM8o.default), {
            context: context,
            marketplaceAppDetails: defaultInstallMode.installableApp.marketplaceAppDetails,
            links: links
        }),
        footerCenter: defaultInstallMode.installedApp.fold(()=>defaultInstallMode.installPermission.fold(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1BmPt.default), null), ()=>null), ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2bemU.default), {
                hostConfig: hostConfig
            })),
        privacyInformation: defaultInstallMode.installedApp.fold(()=>defaultInstallMode.installPermission.fold(()=>null, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8vnXh.default), {
                    context: context,
                    installableAppId: defaultInstallMode.installableAppId,
                    links: links,
                    marketplaceAppDetails: defaultInstallMode.installableApp.marketplaceAppDetails
                })), ()=>null),
        footerRight: defaultInstallMode.installPermission.fold((_)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dvM4B.default), {
                onClick: closeInstallDialog
            }), (_)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgdWX.default), {
                closeInstallDialog: closeInstallDialog,
                context: context,
                hostConfig: hostConfig,
                installableAppInstallMode: defaultInstallMode,
                installApp: installApp,
                hostInfo: hostInfo,
                mpacBaseUrl: mpacBaseUrl,
                isInstallInProgress: isInstallInProgress
            })),
        preventDialogClosing: (0, $9eIgo.isInstallStatusLoading)(defaultInstallMode.status),
        errorDetails: (0, $9eIgo.foldInstallStatus)(defaultInstallMode.status, ()=>(0, $bWAru.Option).empty(), ()=>(0, $bWAru.Option).empty(), (complete)=>complete.result.fold((error)=>(0, $bWAru.Option).some((0, $hsaiM.getErrorDetails)(error, hostConfig, {
                    showCustomBackendErrorsFromUpm: featureFlags.showCustomBackendErrorsFromUpm
                })), ()=>(0, $bWAru.Option).empty()))
    };
};
var $aba66d62ff33ccf7$export$2e2bcd8739ae039 = $aba66d62ff33ccf7$var$resolveDialogDefault;

});
parcelRegister("hsaiM", function(module, exports) {

$parcel$export(module.exports, "getRequestId", () => $cb4d0af07cec0c15$export$710171574ebc9a51);
$parcel$export(module.exports, "getErrorDetails", () => $cb4d0af07cec0c15$export$33e83b6fee5d732d);

var $bH0OB = parcelRequire("bH0OB");
function $cb4d0af07cec0c15$export$710171574ebc9a51() {
    return Math.floor(Date.now() / Math.random());
}
function $cb4d0af07cec0c15$export$33e83b6fee5d732d(error, hostConfig, featureFlags) {
    const defaultConfig = hostConfig.errors.get('default');
    if (!defaultConfig) throw new Error('No default config for error messages specified');
    try {
        if (typeof error === 'string') {
            let translatedError;
            if (featureFlags.showCustomBackendErrorsFromUpm) {
                const err = hostConfig.errors.get(error) || defaultConfig;
                return (0, $bH0OB.makeErrorDetails)({
                    translation: err.set('showTID', false),
                    tid: err.tid,
                    type: err.type
                });
            } else {
                const messageJSON = JSON.parse(error);
                translatedError = hostConfig.errors.get(messageJSON.type) || defaultConfig;
                return (0, $bH0OB.makeErrorDetails)({
                    translation: translatedError,
                    tid: messageJSON.tid || 'None',
                    type: messageJSON.type || 'None'
                });
            }
        } else {
            const translatedError = defaultConfig.set('description', error.errorMessage).set('showTID', false);
            return (0, $bH0OB.makeErrorDetails)({
                translation: translatedError,
                tid: 'None',
                type: 'None'
            });
        }
    } catch (_unused) {
        return (0, $bH0OB.makeErrorDetails)({
            translation: defaultConfig.set('showTID', false)
        });
    }
}

});
parcelRegister("bH0OB", function(module, exports) {

$parcel$export(module.exports, "makeErrorDetails", () => $883457b9ef8c9812$export$5db1c49bc5885c4c);

var $g5DHJ = parcelRequire("g5DHJ");

var $bdw66 = parcelRequire("bdw66");
const $883457b9ef8c9812$export$5db1c49bc5885c4c = (0, $g5DHJ.Record)({
    translation: (0, $bdw66.makeErrorTranslation)(),
    tid: undefined,
    type: undefined
});

});
parcelRegister("bdw66", function(module, exports) {

$parcel$export(module.exports, "makeErrorTranslation", () => $82a9ce7fbeb321ec$export$684bfd87ebfc9317);

var $g5DHJ = parcelRequire("g5DHJ");
const $82a9ce7fbeb321ec$export$684bfd87ebfc9317 = (0, $g5DHJ.Record)({
    title: '',
    description: '',
    validationError: false,
    showTID: false,
    actions: null
});

});



parcelRegister("dvM4B", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d6375f87d7adde2$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $eamSf = parcelRequire("eamSf");
class $9d6375f87d7adde2$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "render", ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eamSf.SecondaryCTAWithAnalytics), {
                actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_INSTALL_CLOSE),
                isDisabled: false,
                onClick: this.props.onClick
            }, "Close"));
    }
}

});
parcelRegister("eamSf", function(module, exports) {

$parcel$export(module.exports, "default", () => $a503be23a84b5dbc$export$2e2bcd8739ae039);
$parcel$export(module.exports, "SecondaryCTAWithAnalytics", () => $a503be23a84b5dbc$export$56331e51db449374);

var $5zQU9 = parcelRequire("5zQU9");

var $9oiuL = parcelRequire("9oiuL");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $eUqFw = parcelRequire("eUqFw");
class $a503be23a84b5dbc$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "render", ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9oiuL.default), {
                isDisabled: this.props.isDisabled,
                appearance: "subtle-link",
                onClick: this.props.onClick
            }, this.props.children));
    }
}
(0, $5zQU9.default)($a503be23a84b5dbc$export$2e2bcd8739ae039, "defaultProps", {
    isDisabled: false
});
class $a503be23a84b5dbc$export$e784f0e8b7a89e69 extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "onClick", ()=>{
            this.props.fireAnalyticsEvent({
                eventType: (0, $gaiog.ButtonClickedEvent),
                actionSubjectId: this.props.actionSubjectId
            });
            this.props.onClick();
        });
        (0, $5zQU9.default)(this, "render", ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a503be23a84b5dbc$export$2e2bcd8739ae039, {
                isDisabled: this.props.isDisabled,
                onClick: this.onClick
            }, this.props.children));
    }
}
const $a503be23a84b5dbc$export$56331e51db449374 = (0, $9osuT.withAnalytics)($a503be23a84b5dbc$export$e784f0e8b7a89e69);

});


parcelRegister("1BmPt", function(module, exports) {

$parcel$export(module.exports, "default", () => $12aaf48f770e385c$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $eUqFw = parcelRequire("eUqFw");

var $60WbV = parcelRequire("60WbV");
function $12aaf48f770e385c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $12aaf48f770e385c$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $60WbV.default), {
    target: "eku53uu0",
    label: "Container"
})({
    name: "xi606m",
    styles: "text-align:center;"
});
class $12aaf48f770e385c$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "render", ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($12aaf48f770e385c$export$42a852a2b6b56249, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $60WbV.BoldHeader), null, "Want this app?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, "Please contact your site administrator.")));
    }
}

});
parcelRegister("60WbV", function(module, exports) {

$parcel$export(module.exports, "BoldHeader", () => $460fe1c3fe98c862$export$3b6bea7d20e57bcc);
$parcel$export(module.exports, "default", () => $460fe1c3fe98c862$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");
function $460fe1c3fe98c862$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $460fe1c3fe98c862$export$3b6bea7d20e57bcc = (0, $3UXZ8.default)("div", {
    target: "exk6e660",
    label: "BoldHeader"
})({
    name: "in3yi3",
    styles: "font-weight:bold;"
});
var $460fe1c3fe98c862$export$2e2bcd8739ae039 = (0, $3UXZ8.default)("div", {
    target: "exk6e661"
})({
    name: "hhlnwx",
    styles: "font-size:11px;line-height:1.2;margin-left:auto;text-align:right;"
});

});


parcelRegister("jnM8o", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1c580cb71eac65f$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $l501X = parcelRequire("l501X");

var $eUqFw = parcelRequire("eUqFw");

var $8KCrk = parcelRequire("8KCrk");

var $7Uh51 = parcelRequire("7Uh51");

var $ifMZN = parcelRequire("ifMZN");
const $e1c580cb71eac65f$export$d3c6d76fe0bcbd = /*#__PURE__*/ (0, $3UXZ8.default)((0, $l501X.default), {
    target: "e1e9elcm0",
    label: "AppDetailsExternalLink"
})("font-weight:400;font-size:14px;color:", "var(--ds-link, ".concat((0, $j0gMm.B400), ")"), ";");
class $e1c580cb71eac65f$export$67af75784bc0a345 extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "onClick", ()=>{
            this.props.fireAnalyticsEvent((0, $8KCrk.makeAnalyticsForInstallableAppIdentifier)((0, $gaiog.ButtonClickedEvent), (0, $7Uh51.ANALYTICS_SUBJECT_ID_VIEW_APP_DETAILS), (0, $ifMZN.makeInstallableAppByKeyIdentifier)({
                key: this.props.marketplaceAppDetails.key
            })).toObject());
        });
        (0, $5zQU9.default)(this, "render", ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e1c580cb71eac65f$export$d3c6d76fe0bcbd, {
                href: this.props.links.appDetails.expand({
                    appKey: this.props.marketplaceAppDetails.key
                }),
                onClick: this.onClick
            }, "App Info"));
    }
}
var $e1c580cb71eac65f$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($e1c580cb71eac65f$export$67af75784bc0a345);

});
parcelRegister("8KCrk", function(module, exports) {

$parcel$export(module.exports, "makeAnalyticsForInstallableAppIdentifier", () => $65f06fecbeee8532$export$e8a3862ff6e101fd);
$parcel$export(module.exports, "makeAnalyticsForInstalledApp", () => $65f06fecbeee8532$export$33836459a61b055c);

var $5zQU9 = parcelRequire("5zQU9");

var $dKnCb = parcelRequire("dKnCb");

var $lQqqi = parcelRequire("lQqqi");

var $ifMZN = parcelRequire("ifMZN");

var $iEgm6 = parcelRequire("iEgm6");

var $7Uh51 = parcelRequire("7Uh51");
function $65f06fecbeee8532$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $65f06fecbeee8532$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $65f06fecbeee8532$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $65f06fecbeee8532$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $65f06fecbeee8532$export$e8a3862ff6e101fd(eventType, actionSubjectId, installableAppId, extraAttributes) {
    return (0, $dKnCb.makeAnalyticsData)({
        eventType: eventType,
        actionSubjectId: actionSubjectId,
        objectType: 'app',
        objectId: (0, $ifMZN.foldInstallableAppIdentifier)(installableAppId)((installableAppByKeyId)=>installableAppByKeyId.key, (installableAppByUrlId)=>installableAppByUrlId.url, (installableAppByARI)=>installableAppByARI.appKey),
        attributes: extraAttributes,
        category: (0, $7Uh51.ANALYTICS_CATEGORY_NAVIGATION)
    });
}
function $65f06fecbeee8532$export$33836459a61b055c(eventType, actionSubjectId, installedApp, extraAttributes) {
    return (0, $lQqqi.foldAuthType)(installedApp.authType)((_)=>(0, $dKnCb.makeAnalyticsData)({
            eventType: eventType,
            actionSubjectId: actionSubjectId,
            objectType: 'token',
            attributes: $65f06fecbeee8532$var$_objectSpread($65f06fecbeee8532$var$_objectSpread({}, extraAttributes), {}, {
                authType: 'token'
            }),
            category: (0, $7Uh51.ANALYTICS_CATEGORY_NAVIGATION)
        }), (_)=>(0, $dKnCb.makeAnalyticsData)({
            eventType: eventType,
            actionSubjectId: actionSubjectId,
            objectType: 'app',
            objectId: installedApp.details.key,
            attributes: $65f06fecbeee8532$var$_objectSpread($65f06fecbeee8532$var$_objectSpread({}, extraAttributes), {}, {
                name: (0, $iEgm6.resolveFieldWithFallback)((add)=>add.name, installedApp.marketplaceAppDetails, installedApp.details),
                oauthClientId: installedApp.details.metadata.oauthClientId,
                authType: '2LO'
            }),
            category: (0, $7Uh51.ANALYTICS_CATEGORY_NAVIGATION)
        }), (_)=>(0, $dKnCb.makeAnalyticsData)({
            eventType: eventType,
            actionSubjectId: actionSubjectId,
            objectType: 'app',
            objectId: installedApp.details.key,
            attributes: $65f06fecbeee8532$var$_objectSpread($65f06fecbeee8532$var$_objectSpread({}, extraAttributes), {}, {
                name: (0, $iEgm6.resolveFieldWithFallback)((add)=>add.name, installedApp.marketplaceAppDetails, installedApp.details),
                oauthClientId: installedApp.details.metadata.oauthClientId,
                authType: '3LO'
            }),
            category: (0, $7Uh51.ANALYTICS_CATEGORY_NAVIGATION)
        }));
}

});
parcelRegister("dKnCb", function(module, exports) {

$parcel$export(module.exports, "makeAnalyticsData", () => $a021e3a4fe2b65f6$export$4481143bd398ebbf);

var $g5DHJ = parcelRequire("g5DHJ");

var $gaiog = parcelRequire("gaiog");
const $a021e3a4fe2b65f6$var$defaultAnalyticsDataProps = {
    eventType: (0, $gaiog.ButtonClickedEvent),
    actionSubjectId: '',
    attributes: undefined,
    category: undefined,
    containerId: undefined,
    containerType: undefined,
    objectId: undefined,
    objectType: undefined,
    tags: undefined
};
const $a021e3a4fe2b65f6$var$defaultAnalyticsData = (0, $g5DHJ.Record)($a021e3a4fe2b65f6$var$defaultAnalyticsDataProps);
const $a021e3a4fe2b65f6$export$4481143bd398ebbf = (a)=>$a021e3a4fe2b65f6$var$defaultAnalyticsData(a);

});



parcelRegister("2bemU", function(module, exports) {

$parcel$export(module.exports, "default", () => $1967c128e47ba144$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $60WbV = parcelRequire("60WbV");
class $1967c128e47ba144$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $60WbV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $60WbV.BoldHeader), null, "We're seeing double!"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, "This app is already added to ", this.props.hostConfig.installationLocation, "."));
    }
}

});

parcelRegister("lgdWX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7a5e9bdf7a06a8c$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $buxnS = parcelRequire("buxnS");

var $inwKI = parcelRequire("inwKI");

var $g01ln = parcelRequire("g01ln");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $eUqFw = parcelRequire("eUqFw");

var $8KCrk = parcelRequire("8KCrk");

var $7Uh51 = parcelRequire("7Uh51");

var $2BZA2 = parcelRequire("2BZA2");

var $9eIgo = parcelRequire("9eIgo");

var $f6zt8 = parcelRequire("f6zt8");

var $9KoF2 = parcelRequire("9KoF2");
function $f7a5e9bdf7a06a8c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f7a5e9bdf7a06a8c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f7a5e9bdf7a06a8c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f7a5e9bdf7a06a8c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $f7a5e9bdf7a06a8c$var$MANUAL_URL_PRIMARY_CTA_LABEL = 'Get it now';
const $f7a5e9bdf7a06a8c$var$FREE_PRIMARY_CTA_LABEL = 'Get it now';
const $f7a5e9bdf7a06a8c$var$PAID_PRIMARY_CTA_LABEL = 'Start free trial';
const $f7a5e9bdf7a06a8c$var$ADD_TO_SANDBOX_CTA_LABEL = 'Add to sandbox';
const $f7a5e9bdf7a06a8c$var$CLOUD_MIGRATION_TRIAL_CTA_LABEL = 'Activate trial';
const $f7a5e9bdf7a06a8c$export$7afaf246bc005f03 = (props)=>{
    const { enableCloudFortifiedAppsDiscovery: enableCloudFortifiedAppsDiscovery } = (0, $inwKI.useFeatureFlags)();
    const installApp = (installableApp, installableAppId, label, relayState)=>()=>{
            const ecosystemCloudAppId = installableApp.marketplaceAppDetails.ecosystemCloudAppId;
            const installAppArgs = {
                context: props.context,
                hostConfig: props.hostConfig,
                hostInfo: props.hostInfo,
                installableApp: installableApp,
                installableAppId: installableAppId,
                relayState: relayState
            };
            props.fireAnalyticsEvent((0, $8KCrk.makeAnalyticsForInstallableAppIdentifier)((0, $gaiog.ButtonClickedEvent), (0, $7Uh51.ANALYTICS_SUBJECT_ID_INSTALL), installableAppId, $f7a5e9bdf7a06a8c$var$_objectSpread($f7a5e9bdf7a06a8c$var$_objectSpread({
                label: label
            }, ecosystemCloudAppId && {
                isEcosystemCloudApp: true,
                ecosystemCloudAppId: ecosystemCloudAppId
            }), {}, {
                hasCloudFortifiedBadge: enableCloudFortifiedAppsDiscovery && (0, $f6zt8.isInstallableAppCloudFortified)(installableApp)
            })).toObject());
            props.installApp(installAppArgs);
        };
    const onClickAlreadyInstalledCTA = (installableAppId, label, url)=>()=>{
            props.fireAnalyticsEvent((0, $8KCrk.makeAnalyticsForInstallableAppIdentifier)((0, $gaiog.ButtonClickedEvent), (0, $7Uh51.ANALYTICS_SUBJECT_ID_ALREADY_INSTALLED_CTA), installableAppId, {
                label: label
            }).toObject());
            (0, $g01ln).openPage(url, '_top');
        };
    const resolveAlreadyInstalledPrimaryCTALink = (installedApp)=>{
        let ctaLink;
        if (installedApp.getStartedUrl) ctaLink = {
            label: 'Get started',
            url: installedApp.getStartedUrl
        };
        else if (installedApp.configureUrl) ctaLink = {
            label: 'Configure',
            url: installedApp.configureUrl
        };
        else if (installedApp.manageAppUrl) ctaLink = {
            label: 'Manage app',
            url: installedApp.manageAppUrl
        };
        return (0, $bWAru.Option).of(ctaLink);
    };
    const resolveDefaultPrimaryCTAText = (defaultInstallMode)=>{
        if (defaultInstallMode.installableApp.eligibleForFreeOnSandbox) return $f7a5e9bdf7a06a8c$var$ADD_TO_SANDBOX_CTA_LABEL;
        if ((0, $buxnS.isFreeApp)(defaultInstallMode.installableApp.marketplaceAppDetails.paymentModel)) return $f7a5e9bdf7a06a8c$var$FREE_PRIMARY_CTA_LABEL;
        if (defaultInstallMode.installableApp.cloudMigrationTrial.isEligible) return $f7a5e9bdf7a06a8c$var$CLOUD_MIGRATION_TRIAL_CTA_LABEL;
        return $f7a5e9bdf7a06a8c$var$PAID_PRIMARY_CTA_LABEL;
    };
    const resolveConfirmCancelForAppByKey = (installableAppDefault, isPrimaryDisabled, isInstallInProgress)=>{
        const primaryCTALabel = resolveDefaultPrimaryCTAText(installableAppDefault);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9KoF2.default), {
            closeInstallDialog: props.closeInstallDialog,
            isLoading: isInstallInProgress(),
            isPrimaryDisabled: isPrimaryDisabled,
            onPrimaryCTAClick: installApp(installableAppDefault.installableApp, installableAppDefault.installableAppId, primaryCTALabel, installableAppDefault.relayState),
            primaryCTALabel: primaryCTALabel,
            primaryButtonId: "install-app-dialog__install-confirm-btn" // used in pollinator test
        });
    };
    const resolveConfirmCancelForAppByUrl = (installableAppByManualUrl, isPrimaryDisabled)=>installableAppByManualUrl.installableApp.flatMap((ia)=>ia.toOption()).map((ia)=>/*#__PURE__*/ // eslint-disable-next-line react/jsx-key
            (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9KoF2.default), {
                closeInstallDialog: props.closeInstallDialog,
                isLoading: (0, $9eIgo.isInstallStatusLoading)(installableAppByManualUrl.status),
                isPrimaryDisabled: isPrimaryDisabled,
                onPrimaryCTAClick: installApp(ia, installableAppByManualUrl.installableAppByUrlId, $f7a5e9bdf7a06a8c$var$MANUAL_URL_PRIMARY_CTA_LABEL),
                primaryCTALabel: $f7a5e9bdf7a06a8c$var$MANUAL_URL_PRIMARY_CTA_LABEL
            }));
    return (0, $2BZA2.foldInstallInstallableAppInstallMode)(props.installableAppInstallMode)((installableAppDefault)=>installableAppDefault.installedApp.fold(()=>resolveConfirmCancelForAppByKey(installableAppDefault, false, props.isInstallInProgress), (ia)=>resolveAlreadyInstalledPrimaryCTALink(ia).map((cta)=>/*#__PURE__*/ // eslint-disable-next-line react/jsx-key
                (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9KoF2.default), {
                    closeInstallDialog: props.closeInstallDialog,
                    isLoading: false,
                    isPrimaryDisabled: false,
                    onPrimaryCTAClick: onClickAlreadyInstalledCTA(installableAppDefault.installableAppId, cta.label, cta.url),
                    primaryCTALabel: cta.label
                })).getOrElseL(()=>resolveConfirmCancelForAppByKey(installableAppDefault, true, props.isInstallInProgress))), (installableAppByManualUrl)=>installableAppByManualUrl.installableAppByManualUrl.flatMap((iabmu)=>iabmu.installedApp.fold(()=>resolveConfirmCancelForAppByUrl(iabmu, false), (ia)=>resolveAlreadyInstalledPrimaryCTALink(ia).map((cta)=>/*#__PURE__*/ // eslint-disable-next-line react/jsx-key
                    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9KoF2.default), {
                        closeInstallDialog: props.closeInstallDialog,
                        isLoading: false,
                        isPrimaryDisabled: false,
                        onPrimaryCTAClick: onClickAlreadyInstalledCTA(iabmu.installableAppByUrlId, cta.label, cta.url),
                        primaryCTALabel: cta.label
                    })).orElseL(()=>resolveConfirmCancelForAppByUrl(iabmu, true)))).getOrElseL(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9KoF2.default), {
                closeInstallDialog: props.closeInstallDialog,
                isLoading: false,
                isPrimaryDisabled: true,
                primaryCTALabel: $f7a5e9bdf7a06a8c$var$MANUAL_URL_PRIMARY_CTA_LABEL
            })));
};
var $f7a5e9bdf7a06a8c$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($f7a5e9bdf7a06a8c$export$7afaf246bc005f03);

});
parcelRegister("buxnS", function(module, exports) {

$parcel$export(module.exports, "FREE_PRICING", () => $85dc64769961e885$export$16444ae3d9981448);
$parcel$export(module.exports, "PAID_PRICING", () => $85dc64769961e885$export$4ef8826da1f1ebe6);
$parcel$export(module.exports, "isFreeApp", () => $85dc64769961e885$export$58b14254be35765b);
$parcel$export(module.exports, "foldPaymentModel", () => $85dc64769961e885$export$78cb43db1b1a42b1);

var $gC8Po = parcelRequire("gC8Po");
const $85dc64769961e885$export$16444ae3d9981448 = 'FREE';
const $85dc64769961e885$export$4ef8826da1f1ebe6 = 'PAID';
const $85dc64769961e885$export$58b14254be35765b = (p)=>p === 'free';
const $85dc64769961e885$export$78cb43db1b1a42b1 = (p)=>(free, atlassian, vendor)=>{
        switch(p){
            case 'atlassian':
                return atlassian();
            case 'free':
                return free();
            case 'vendor':
                return vendor();
            default:
                throw (0, $gC8Po.default).unexpectedCase(p);
        }
    };

});

parcelRegister("g01ln", function(module, exports) {

$parcel$export(module.exports, "TOP_WINDOW", () => $ba5db0425d554fd3$export$f90ae0252d3d8848);
$parcel$export(module.exports, "BLANK_WINDOW", () => $ba5db0425d554fd3$export$ccc35a87fa5a77);
$parcel$export(module.exports, "SELF_WINDOW", () => $ba5db0425d554fd3$export$96ffa9b89b9d7be1);
$parcel$export(module.exports, "PARENT_WINDOW", () => $ba5db0425d554fd3$export$b8a3742426ce0d81);
$parcel$export(module.exports, "openPage", () => $ba5db0425d554fd3$export$af53621bd3f7dae0);
$parcel$export(module.exports, "redirectTo", () => $ba5db0425d554fd3$export$2d47ce6f15e624e5);
const $ba5db0425d554fd3$export$f90ae0252d3d8848 = '_top';
const $ba5db0425d554fd3$export$ccc35a87fa5a77 = '_blank';
const $ba5db0425d554fd3$export$96ffa9b89b9d7be1 = '_self';
const $ba5db0425d554fd3$export$b8a3742426ce0d81 = '_parent';
function $ba5db0425d554fd3$export$af53621bd3f7dae0(url, windowName) {
    window.open(url, windowName);
}
const $ba5db0425d554fd3$export$2d47ce6f15e624e5 = (url)=>{
    window.location.href = url;
};

});

parcelRegister("2BZA2", function(module, exports) {

$parcel$export(module.exports, "foldInstallInstallableAppInstallMode", () => $1e6ece0c6760f697$export$3594cec58e92bc36);

var $249j9 = parcelRequire("249j9");

var $4s0An = parcelRequire("4s0An");
function $1e6ece0c6760f697$export$3594cec58e92bc36(installableAppInstallMode) {
    return function foldInstallInstallableAppInstallModeInner(installableAppDefault, installableAppByManualUrl) {
        switch(installableAppInstallMode.type){
            case 0, $4s0An.INSTALLABLE_APP_DEFAULT_INSTALL_MODE:
                return installableAppDefault(installableAppInstallMode);
            case 0, $249j9.INSTALLABLE_APP_BY_MANUAL_URL_INSTALL_MODE:
                return installableAppByManualUrl(installableAppInstallMode);
            default:
                // Flow compile-time validation that we've handled every discover item
                // prettier-ignore
                installableAppInstallMode;
                return undefined;
        }
    };
}

});

parcelRegister("f6zt8", function(module, exports) {

$parcel$export(module.exports, "isInstallableAppCloudFortified", () => $aff2edf57b11cb5e$export$91ec17b5900e958f);

var $kafab = parcelRequire("kafab");
const $aff2edf57b11cb5e$export$91ec17b5900e958f = (installableApp)=>installableApp.marketplaceAppDetails.getIn([
        'programs',
        'cloudFortified',
        'status'
    ]) === (0, $kafab.CloudFortifiedStatusValues).Approved;

});

parcelRegister("9KoF2", function(module, exports) {

$parcel$export(module.exports, "default", () => $718b8a15a62c51ee$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $9goJJ = parcelRequire("9goJJ");

var $bPByu = parcelRequire("bPByu");

var $eUqFw = parcelRequire("eUqFw");

var $h6MeC = parcelRequire("h6MeC");
class $718b8a15a62c51ee$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "render", ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9goJJ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bPByu.default), {
                isLoading: this.props.isLoading,
                isDisabled: this.props.isPrimaryDisabled,
                onClick: this.props.onPrimaryCTAClick,
                buttonId: this.props.primaryButtonId
            }, this.props.primaryCTALabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h6MeC.default), {
                isDisabled: this.props.isLoading,
                onClick: this.props.closeInstallDialog
            }, "Cancel")));
    }
}
(0, $5zQU9.default)($718b8a15a62c51ee$export$2e2bcd8739ae039, "defaultProps", {
    isPrimaryDisabled: false
});

});
parcelRegister("9goJJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6be8cbd7a5aa8b5f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
const $6be8cbd7a5aa8b5f$var$buttonGroupStyles = (0, $byn9U.css)({
    display: 'inline-flex',
    gap: "var(--ds-space-050, 4px)",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> *': {
        flex: '1 0 auto'
    }
});
function $6be8cbd7a5aa8b5f$export$2e2bcd8739ae039({ appearance: appearance, children: children, testId: testId, label: label, titleId: titleId }) {
    return (0, $byn9U.jsx)("div", {
        css: $6be8cbd7a5aa8b5f$var$buttonGroupStyles,
        "data-testid": testId,
        role: "group",
        "aria-label": label,
        "aria-labelledby": titleId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children), (child, idx)=>{
        if (!child) return null;
        return (0, $byn9U.jsx)((0, $eUqFw.Fragment), {
            key: idx
        }, appearance ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
            appearance: appearance
        }) : child);
    }));
}

});

parcelRegister("bPByu", function(module, exports) {

$parcel$export(module.exports, "default", () => $02390ed1d3838c59$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $cQKn6 = parcelRequire("cQKn6");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");
function $02390ed1d3838c59$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $02390ed1d3838c59$export$1efc9061e8e8902f = (0, $3UXZ8.default)("div", {
    target: "eewegni0",
    label: "PrimaryCTAContainer"
})({
    name: "17gow3k",
    styles: "min-width:106px;"
});
class $02390ed1d3838c59$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "render", ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02390ed1d3838c59$export$1efc9061e8e8902f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cQKn6.default), {
                appearance: "primary",
                href: this.props.href,
                isLoading: this.props.isLoading,
                isDisabled: this.props.isDisabled,
                onClick: this.props.onClick,
                shouldFitContainer: true,
                id: this.props.buttonId,
                testId: this.props.testId
            }, this.props.children)));
    }
}
(0, $5zQU9.default)($02390ed1d3838c59$export$2e2bcd8739ae039, "propTypes", {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node.isRequired,
    href: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
});
(0, $5zQU9.default)($02390ed1d3838c59$export$2e2bcd8739ae039, "defaultProps", {
    isDisabled: false,
    isLoading: false
});

});
parcelRegister("cQKn6", function(module, exports) {

$parcel$export(module.exports, "default", () => $95ae4fc9520c42ab$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $9oiuL = parcelRequire("9oiuL");

var $5nZDj = parcelRequire("5nZDj");
/**
 * __Loading button__
 *
 * CAUTION: Legacy loading buttons will soon be deprecated. Please use the new Button components from `@atlaskit/button/new` with the `isLoading` prop.
 *
 * A small wrapper around Button that allows you to show an @atlaskit/spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * - [Examples](https://atlassian.design/components/button/examples#loading-button)
 */ const $95ae4fc9520c42ab$var$LoadingButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function LoadingButton({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, isLoading: isLoading = false, spacing: spacing, ...rest }, ref) {
    // Button already has React.memo, so just leaning on that
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9oiuL.default), (0, $kU09D.default)({}, rest, {
        ref: ref,
        appearance: appearance,
        "aria-disabled": isLoading || undefined,
        isDisabled: isDisabled,
        isSelected: isSelected,
        overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5nZDj.default), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null,
        spacing: spacing
    }));
});
// Tools including enzyme rely on components having a display name
$95ae4fc9520c42ab$var$LoadingButton.displayName = 'LoadingButton';
var $95ae4fc9520c42ab$export$2e2bcd8739ae039 = $95ae4fc9520c42ab$var$LoadingButton;

});
parcelRegister("5nZDj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ebee8c55e1da628$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");
function $3ebee8c55e1da628$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $3ebee8c55e1da628$export$2e2bcd8739ae039({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, spacing: spacing = 'default' }) {
    const size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: size,
        label: ", Loading",
        appearance: $3ebee8c55e1da628$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});



parcelRegister("h6MeC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c74869a01a50e9b4$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $9osuT = parcelRequire("9osuT");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $eamSf = parcelRequire("eamSf");
function $c74869a01a50e9b4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c74869a01a50e9b4$export$2fa8dd9cd9f42da9 = (0, $3UXZ8.default)("div", {
    target: "e16wejgc0",
    label: "CancelButtonContainer"
})({
    name: "vxcmzt",
    styles: "display:inline-flex;"
});
class $c74869a01a50e9b4$export$bf56b42dddb5cdfe extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "render", ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c74869a01a50e9b4$export$2fa8dd9cd9f42da9, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eamSf.SecondaryCTAWithAnalytics), {
                actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_INSTALL_CANCEL),
                isDisabled: this.props.isDisabled,
                onClick: this.props.onClick
            }, "Cancel")));
    }
}
var $c74869a01a50e9b4$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($c74869a01a50e9b4$export$bf56b42dddb5cdfe);

});



parcelRegister("8vnXh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6313ccf24adc6de1$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $l501X = parcelRequire("l501X");

var $eUqFw = parcelRequire("eUqFw");

var $8KCrk = parcelRequire("8KCrk");

var $7Uh51 = parcelRequire("7Uh51");
const $6313ccf24adc6de1$export$42a852a2b6b56249 = (0, $3UXZ8.default)("div", {
    target: "ed46tot0",
    label: "Container"
})("background-color:", "var(--ds-background-accent-gray-subtlest, ".concat((0, $j0gMm.N20), ")"), ";padding:10px var(--ds-space-250, 20px);font-size:11px;line-height:1.5;");
const $6313ccf24adc6de1$var$manageLogAccessLink = 'https://support.atlassian.com/security-and-access-policies/docs/manage-your-users-third-party-apps';
class $6313ccf24adc6de1$export$c559aa613c1114c extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "privacyPolicyAnalytics", ()=>this.fireLinkUIAnalyticsEvent((0, $7Uh51.ANALYTICS_SUBJECT_ID_PRIVACY_POLICY)));
        (0, $5zQU9.default)(this, "eulaAnalytics", ()=>this.fireLinkUIAnalyticsEvent((0, $7Uh51.ANALYTICS_SUBJECT_ID_TERMS_OF_USE)));
        (0, $5zQU9.default)(this, "manageLogAccessAnalytics", ()=>this.fireLinkUIAnalyticsEvent((0, $7Uh51.ANALYTICS_SUBJECT_ID_MANAGE_LOG_ACCESS)));
        (0, $5zQU9.default)(this, "marketplaceTermsOfUseAnalytics", ()=>this.fireLinkUIAnalyticsEvent((0, $7Uh51.ANALYTICS_SUBJECT_ID_MARKETPLACE_TERMS_OF_USE)));
        (0, $5zQU9.default)(this, "fireLinkUIAnalyticsEvent", (actionSubjectId)=>this.props.fireAnalyticsEvent((0, $8KCrk.makeAnalyticsForInstallableAppIdentifier)((0, $gaiog.ButtonClickedEvent), actionSubjectId, this.props.installableAppId).toObject()));
        (0, $5zQU9.default)(this, "marketplaceTermsOfUse", (appName, links)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", null, "permit Atlassian to share anonymized data with ", appName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", null, "agree to Atlassian Marketplace's", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l501X.default), {
                href: links.marketplaceTermsOfUse.expand({}),
                onClick: this.marketplaceTermsOfUseAnalytics
            }, "terms of use"))));
        (0, $5zQU9.default)(this, "vendorTermsOfUse", (vendorName, eula, privacyPolicy)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", null, "agree to ", vendorName, "'s", ' ', eula ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l501X.default), {
                href: eula,
                onClick: this.eulaAnalytics
            }, "terms of use") : null, eula && privacyPolicy ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, " and ") : null, privacyPolicy ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l501X.default), {
                href: privacyPolicy,
                onClick: this.privacyPolicyAnalytics
            }, "privacy policy") : null));
        (0, $5zQU9.default)(this, "forgeManageLogAccess", (vendorName, links)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", null, "agree to enabling ", vendorName, "'s access to log data for this app. You can", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l501X.default), {
                href: $6313ccf24adc6de1$var$manageLogAccessLink,
                onClick: this.manageLogAccessAnalytics
            }, "disable this access, or download logs"), ' ', "at any time, from", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l501X.default), {
                href: links.adminHub.expand({})
            }, "admin.atlassian.com")));
        (0, $5zQU9.default)(this, "termsOfUseMsg", (links, marketplaceAppDetails)=>{
            const { eula: eula, isConnectApp: isConnectApp, name: appName, privacyPolicy: privacyPolicy, vendor: { name: vendorName } } = marketplaceAppDetails;
            const marketplaceTermsOfUsePolicy = this.marketplaceTermsOfUse(appName, links);
            const vendorTermsOfUsePolicy = this.vendorTermsOfUse(vendorName, eula, privacyPolicy);
            const forgeManageLogAccessPolicy = this.forgeManageLogAccess(vendorName, links);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, "By installing this app, you:", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("ul", null, marketplaceTermsOfUsePolicy, eula || privacyPolicy ? vendorTermsOfUsePolicy : null, isConnectApp ? null : forgeManageLogAccessPolicy));
        });
    }
    render() {
        const { marketplaceAppDetails: marketplaceAppDetails } = this.props;
        const { eula: eula, privacyPolicy: privacyPolicy, vendor: { name: vendorName, vendorType: vendorType } } = marketplaceAppDetails;
        const termsOfUseMsg = this.termsOfUseMsg(this.props.links, marketplaceAppDetails);
        if (vendorType === 'internal') return null;
        if (!vendorName) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6313ccf24adc6de1$export$42a852a2b6b56249, null, "This third party vendor has not provided a privacy policy or terms of use. Atlassian's Privacy Policy is not applicable to the use of this app.");
        if (privacyPolicy && eula) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6313ccf24adc6de1$export$42a852a2b6b56249, null, termsOfUseMsg);
        else if (privacyPolicy && !eula) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6313ccf24adc6de1$export$42a852a2b6b56249, null, termsOfUseMsg, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, vendorName, " has not provided any terms of use explaining your rights to use the app or how ", vendorName, " may restrict your use of the app. By installing this app, you acknowledge and agree that ", vendorName, " may restrict or prohibit your use of the app at any time."));
        else if (eula && !privacyPolicy) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6313ccf24adc6de1$export$42a852a2b6b56249, null, termsOfUseMsg, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, vendorName, " has not provided a privacy policy explaining how this app will use your data. By installing this app, you acknowledge and agree this app may have unrestricted use of your data. If you do not agree, you should not install this app."));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6313ccf24adc6de1$export$42a852a2b6b56249, null, termsOfUseMsg, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, "This vendor has not provided terms of use or a privacy policy explaining how they will use your data. By installing this app, you acknowledge and agree this app may have unrestricted use of your data and/or ", vendorName, " may restrict or prohibit your use of the app at any time. If you do not agree, you should not install this app."));
    }
}
var $6313ccf24adc6de1$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($6313ccf24adc6de1$export$c559aa613c1114c);

});

parcelRegister("4LsDF", function(module, exports) {

$parcel$export(module.exports, "default", () => $3781c4452577a9ec$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $eUqFw = parcelRequire("eUqFw");

var $abBcx = parcelRequire("abBcx");

var $izRAm = parcelRequire("izRAm");
function $3781c4452577a9ec$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3781c4452577a9ec$export$9fea3e4644be20cb = (0, $3UXZ8.default)("div", {
    target: "e1ojqmi90",
    label: "ScopesDiv"
})({
    name: "493ori",
    styles: "margin-top:25px;"
});
const $3781c4452577a9ec$var$DialogDefaultContent = (props)=>{
    const { hostPricing: hostPricing, installableApp: installableApp, mpacBaseUrl: mpacBaseUrl, links: links, installedApp: installedApp, scopesLookup: scopesLookup, onRendered: onRendered, forgeAppEgressAddresses: forgeAppEgressAddresses, appDetailsFromSearchResponse: appDetailsFromSearchResponse } = props;
    (0, $eUqFw.useEffect)(()=>{
        if (typeof onRendered === 'function') onRendered();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3781c4452577a9ec$export$9fea3e4644be20cb, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izRAm.default), {
        appDetailsHeaderInjection: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $abBcx.default), {
            hostPricing: hostPricing,
            appKey: installableApp.details.key,
            links: links,
            installedApp: installedApp,
            paymentModel: installableApp.marketplaceAppDetails.paymentModel,
            mpacBaseUrl: mpacBaseUrl,
            eligibleForFreeOnSandbox: installableApp.eligibleForFreeOnSandbox,
            cloudMigrationTrial: installableApp.cloudMigrationTrial,
            showAetherAppListingPage: false
        }),
        installableApp: (0, $bWAru.Option).some((0, $bWAru.Either).right(installableApp)),
        links: links,
        appDetailsFromSearchResponse: appDetailsFromSearchResponse,
        scopesLookup: scopesLookup,
        forgeAppEgressAddresses: forgeAppEgressAddresses
    }));
};
var $3781c4452577a9ec$export$2e2bcd8739ae039 = $3781c4452577a9ec$var$DialogDefaultContent;

});
parcelRegister("abBcx", function(module, exports) {

$parcel$export(module.exports, "default", () => $76a7c9df086ff06a$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $3UXZ8 = parcelRequire("3UXZ8");

var $3JHWU = parcelRequire("3JHWU");
var $buxnS = parcelRequire("buxnS");

var $9l6Pq = parcelRequire("9l6Pq");

var $jlbX6 = parcelRequire("jlbX6");

var $bqcaO = parcelRequire("bqcaO");

var $9c9Gu = parcelRequire("9c9Gu");

var $eUqFw = parcelRequire("eUqFw");

var $3pGnh = parcelRequire("3pGnh");

var $3DsUo = parcelRequire("3DsUo");

var $j5L3j = parcelRequire("j5L3j");

var $9ePvD = parcelRequire("9ePvD");
function $76a7c9df086ff06a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $76a7c9df086ff06a$export$52e284bf30d0364a = (0, $3UXZ8.default)("span", {
    target: "e1ppm99b0",
    label: "LoadingText"
})({
    name: "odz94x",
    styles: "margin-top:5px;"
});
function $76a7c9df086ff06a$var$usePricing(props) {
    const { result: result } = props.hostPricing;
    const billingCurrency = result ? result.billingCurrency || (0, $jlbX6.DEFAULT_CURRENCY_CODE) : undefined;
    const fetchAppPricing = async ()=>{
        if ((0, $buxnS.isFreeApp)(props.paymentModel) || props.paymentModel === (0, $j5L3j.AppListingPaymentModel).PAID_VIA_PARTNER) return (0, $3pGnh.makeAppPricingFromMarketplaceAppData)(props.paymentModel);
        else if (billingCurrency) {
            const marketplaceAppPricing = await (0, $3DsUo.reflect)((0, $3JHWU.getMarketplaceAppPricing)(props.mpacBaseUrl, props.appKey, billingCurrency));
            return (0, $3pGnh.makeAppPricingFromMarketplaceAppData)(props.paymentModel, marketplaceAppPricing);
        }
    };
    return (0, $9c9Gu).usePromise(fetchAppPricing, [
        props.hostPricing,
        props.mpacBaseUrl,
        props.paymentModel
    ], !!billingCurrency);
}
function $76a7c9df086ff06a$export$2e2bcd8739ae039(props) {
    const { enableAetherAppListingPage: enableAetherAppListingPage } = (0, $9l6Pq.useStatsig)();
    const showAetherAppListingPage = enableAetherAppListingPage();
    const { result: result } = $76a7c9df086ff06a$var$usePricing({
        hostPricing: props.hostPricing,
        mpacBaseUrl: props.mpacBaseUrl,
        paymentModel: props.paymentModel,
        appKey: props.appKey
    });
    if (!result) return showAetherAppListingPage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bqcaO.Stripe), {
        width: "5rem",
        height: "0.875rem",
        marginTop: "var(--ds-space-075)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($76a7c9df086ff06a$export$52e284bf30d0364a, null, "Loading price...");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9ePvD.Pricing), (0, $kU09D.default)({}, props, {
        appPricing: result
    }));
}

});
parcelRegister("3JHWU", function(module, exports) {

$parcel$export(module.exports, "getMarketplaceAppPricing", () => $2b87aa71ffdb6665$export$3638efcc7a4cba3a);

var $dO8LH = parcelRequire("dO8LH");

var $5MLUk = parcelRequire("5MLUk");
const $2b87aa71ffdb6665$export$5741cde02fa8bdb2 = function getRawMarketplaceAppPricing(mpacBaseUrl, appKey) {
    let currencyCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'USD';
    let hostingType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'cloud';
    return (0, $dO8LH.fetchOk)("".concat(mpacBaseUrl, "/rest/2/addons/").concat(appKey, "/pricing/").concat(hostingType, "/live?currencyCode=").concat(currencyCode)).then((response)=>response.json());
};
const $2b87aa71ffdb6665$export$3638efcc7a4cba3a = (mpacBaseUrl, appKey, currencyCode)=>$2b87aa71ffdb6665$export$5741cde02fa8bdb2(mpacBaseUrl, appKey, currencyCode).then((0, $5MLUk.makeMarketplaceAppPricingFromRawAppPricing));

});
parcelRegister("5MLUk", function(module, exports) {

$parcel$export(module.exports, "makeMarketplaceAppPricingFromRawAppPricing", () => $01164cc9c614298b$export$d18a011bd791d92e);

var $g5DHJ = parcelRequire("g5DHJ");
const $01164cc9c614298b$export$a7f1631fa3f7ab30 = (marketplaceAppPricingItem)=>marketplaceAppPricingItem;
const $01164cc9c614298b$export$6885271f60b909fb = (marketplaceAppPricingItem)=>marketplaceAppPricingItem;
const $01164cc9c614298b$export$d710e3c1fca1c8f8 = (0, $g5DHJ.Record)({
    items: [],
    perUnitItems: undefined
});
const $01164cc9c614298b$var$formatAppPricingItem = (items)=>items.map((appPricingItem)=>({
            monthsValid: appPricingItem.monthsValid,
            unitCount: appPricingItem.unitCount,
            amount: appPricingItem.localCurrencyAmount,
            currencyCode: appPricingItem.localCurrency
        }));
const $01164cc9c614298b$export$d18a011bd791d92e = (rawMarketplaceAppPricing)=>$01164cc9c614298b$export$d710e3c1fca1c8f8({
        items: $01164cc9c614298b$var$formatAppPricingItem(rawMarketplaceAppPricing.items),
        perUnitItems: $01164cc9c614298b$var$formatAppPricingItem(rawMarketplaceAppPricing.perUnitItems || [])
    });

});


parcelRegister("jlbX6", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CURRENCY_CODE", () => $e1493ff2bb363f90$export$c852e1f5bb177898);
$parcel$export(module.exports, "formatPrice", () => $e1493ff2bb363f90$export$c86caf1be068fb8d);
$parcel$export(module.exports, "makePricingExplanationForUninstalled", () => $e1493ff2bb363f90$export$ff597d64488abe76);
$parcel$export(module.exports, "makePricingExplanationForEvaluation", () => $e1493ff2bb363f90$export$3b2cde94409ad0b9);
$parcel$export(module.exports, "makePricingExplanationForSubscription", () => $e1493ff2bb363f90$export$1a0388b7db68f038);

var $76fzC = parcelRequire("76fzC");

var $6wqPF = parcelRequire("6wqPF");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $5eIIT = parcelRequire("5eIIT");

var $8CEbA = parcelRequire("8CEbA");
const $e1493ff2bb363f90$export$c852e1f5bb177898 = 'USD';
const $e1493ff2bb363f90$var$USD_LOCALE = 'en-us';
const $e1493ff2bb363f90$export$c86caf1be068fb8d = function formatPrice(amount, currencyCode) {
    let minimumFractionDigits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    const currencyDisplayFormat = currencyCode === 'USD' ? 'code' : 'symbol';
    return amount.toLocaleString($e1493ff2bb363f90$var$USD_LOCALE, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: minimumFractionDigits,
        currencyDisplay: currencyDisplayFormat,
        maximumFractionDigits: 2
    });
};
const $e1493ff2bb363f90$var$getSubscriptionText = (appPricing, currentUsers, estimate, subscriptionPeriod)=>{
    const userRange = (0, $5eIIT.default)(appPricing, currentUsers).fold((error)=>{
        console.error('Error when resolving app pricing tiers', error);
        return '';
    }, (tiers)=>{
        const lowerBound = tiers.lower.map((t)=>t.unitCount + 1).getOrElse(1);
        const upperBound = (0, $bWAru.Option).some(tiers.upper.unitCount).filter((u)=>u !== Number.POSITIVE_INFINITY);
        return " of ".concat(lowerBound.toString()).concat(upperBound.map((ub)=>"-".concat(ub)).getOrElse('+'), " users");
    });
    // Licensed users can be 0 when the
    // instance is under evaluation
    if (currentUsers) {
        const formattedPrice = $e1493ff2bb363f90$export$c86caf1be068fb8d(estimate.amount / currentUsers, estimate.currencyCode);
        return (0, $8CEbA.foldSubscriptionPeriod)(subscriptionPeriod, ()=>"monthly plan".concat(userRange, " at ").concat(formattedPrice, " per user/month"), ()=>"annual plan".concat(userRange, " at ").concat(formattedPrice, " per user/year"));
    } else return (0, $8CEbA.foldSubscriptionPeriod)(subscriptionPeriod, ()=>"monthly plan".concat(userRange), ()=>"annual plan".concat(userRange));
};
const $e1493ff2bb363f90$export$ff597d64488abe76 = function makePricingExplanationForUninstalled(appPricing, currentUsers, estimate, subscriptionPeriod, cloudMigrationTrial) {
    let showAetherAppListingPage = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    const subscriptionText = $e1493ff2bb363f90$var$getSubscriptionText(appPricing, currentUsers, estimate, subscriptionPeriod);
    if (cloudMigrationTrial !== null && cloudMigrationTrial !== void 0 && cloudMigrationTrial.isEligible && cloudMigrationTrial !== null && cloudMigrationTrial !== void 0 && cloudMigrationTrial.btfSenEndDate) {
        const expiry = showAetherAppListingPage ? (0, $76fzC).formatDateObject(cloudMigrationTrial.btfSenEndDate, 'MMM dd, yyyy') : (0, $76fzC).longDate(cloudMigrationTrial.btfSenEndDate);
        return "If you proceed, your Cloud Migration Trial starts today and will end on ".concat(expiry, ". ") + "Post which, this estimate will be valid, which is customized for your ".concat(subscriptionText, ".");
    } else {
        const expiry = showAetherAppListingPage ? (0, $76fzC).formatDateObject((0, $6wqPF.default)(Date.now(), 30), 'MMM dd, yyyy') : (0, $76fzC).longDate((0, $6wqPF.default)(Date.now(), 30));
        return "If you proceed, your free trial starts today and will end on ".concat(expiry, ".\n    This estimate is customized for your ").concat(subscriptionText, ".");
    }
};
const $e1493ff2bb363f90$export$3b2cde94409ad0b9 = (appPricing, currentUsers, estimate, subscriptionPeriod, trialEndDate)=>{
    const subscriptionText = $e1493ff2bb363f90$var$getSubscriptionText(appPricing, currentUsers, estimate, subscriptionPeriod);
    return "This estimate is customized for your ".concat(subscriptionText, ". Your free trial will end on ").concat(trialEndDate, ".");
};
const $e1493ff2bb363f90$export$1a0388b7db68f038 = (appPricing, currentUsers, estimate, subscriptionPeriod)=>{
    const subscriptionText = $e1493ff2bb363f90$var$getSubscriptionText(appPricing, currentUsers, estimate, subscriptionPeriod);
    return "This estimate is customized for your ".concat(subscriptionText);
};

});
parcelRegister("5eIIT", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d00f3a085af4896$export$2e2bcd8739ae039);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");
const $3d00f3a085af4896$var$findBetweenTiers = (pricingItems, numUsers)=>pricingItems.reduce((foundBetweenTiers, pricingItem, index, iter)=>foundBetweenTiers.orElseL(()=>pricingItem.unitCount >= numUsers ? (0, $bWAru.Option).some({
                lower: (0, $bWAru.Option).of(index === 0 ? null : iter.get(index - 1)),
                upper: pricingItem
            }) : (0, $bWAru.Option).empty()), (0, $bWAru.Option).empty()).map((0, $bWAru.Either).right).getOrElse((0, $bWAru.Either).left('Number of users does not fall between any tiers'));
var $3d00f3a085af4896$export$2e2bcd8739ae039 = $3d00f3a085af4896$var$findBetweenTiers;

});

parcelRegister("8CEbA", function(module, exports) {

$parcel$export(module.exports, "foldSubscriptionPeriod", () => $64710b7025d67455$export$98e46c241cb63383);

var $gC8Po = parcelRequire("gC8Po");
function $64710b7025d67455$export$98e46c241cb63383(subscriptionPeriod, monthly, annual) {
    switch(subscriptionPeriod){
        case 'monthly':
            return monthly();
        case 'annual':
            return annual();
        default:
            throw (0, $gC8Po.default).unexpectedCase(subscriptionPeriod);
    }
}

});


parcelRegister("bqcaO", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $850b90d1da6073df$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "MatchingLabelSkeleton", () => $850b90d1da6073df$export$310b762e4d9bd182);
$parcel$export(module.exports, "Stripe", () => $850b90d1da6073df$export$3c7919ca4c48cda4);
$parcel$export(module.exports, "AppListing2LineSkeleton", () => $850b90d1da6073df$export$7073bd4814843a30);
/* Skeletons.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $kU09D = parcelRequire("kU09D");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");


var $4V4Mb = parcelRequire("4V4Mb");
var $kBUpw = parcelRequire("kBUpw");

var $ivTMz = parcelRequire("ivTMz");
const $850b90d1da6073df$var$_excluded = [
    "as",
    "style"
], $850b90d1da6073df$var$_excluded2 = [
    "as",
    "style"
], $850b90d1da6073df$var$_excluded3 = [
    "as",
    "style"
], $850b90d1da6073df$var$_excluded4 = [
    "as",
    "style"
], $850b90d1da6073df$var$_excluded5 = [
    "as",
    "style"
];
function $850b90d1da6073df$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $850b90d1da6073df$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $850b90d1da6073df$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $850b90d1da6073df$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $850b90d1da6073df$var$shimmer = (0, $ivTMz.skeletonShimmer)();
const $850b90d1da6073df$export$8f31e4c4a37b8e9c = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $850b90d1da6073df$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_j7hq19hg _bfhk1mnh _5sag12o8 _tip812c5 _1pglp3kn _7hjf1yy8",
            __cmplp.className
        ])
    }));
});
const $850b90d1da6073df$export$310b762e4d9bd182 = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = $850b90d1da6073df$export$8f31e4c4a37b8e9c, style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $850b90d1da6073df$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rkoi2wt _1bsb1178 _4t3i1crf _bfhk1mnh _5sag12o8 _tip812c5 _1pglp3kn _7hjf1yy8 _1kkm1y44 _14b5r4m3 _1xloftgi _2oz41v6z _10jx33sj _15ri163w _glte1osq _165tdlk8",
            __cmplp.className
        ])
    }));
});
const $850b90d1da6073df$export$3c7919ca4c48cda4 = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    var _cmplp$width, _cmplp$height, _cmplp$borderRadius, _cmplp$marginTop, _cmplp$marginBottom;
    let { as: C = $850b90d1da6073df$export$8f31e4c4a37b8e9c, style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $850b90d1da6073df$var$_excluded3);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: $850b90d1da6073df$var$_objectSpread($850b90d1da6073df$var$_objectSpread({}, __cmpls), {}, {
            "--_pcenyd": (0, $9t7rW.default)((_cmplp$width = __cmplp.width) !== null && _cmplp$width !== void 0 ? _cmplp$width : '100%'),
            "--_16reqip": (0, $9t7rW.default)((_cmplp$height = __cmplp.height) !== null && _cmplp$height !== void 0 ? _cmplp$height : '16px'),
            "--_6bkswh": (0, $9t7rW.default)((_cmplp$borderRadius = __cmplp.borderRadius) !== null && _cmplp$borderRadius !== void 0 ? _cmplp$borderRadius : "var(--ds-border-radius-200, 8px)"),
            "--_xpa7ji": (0, $9t7rW.default)((_cmplp$marginTop = __cmplp.marginTop) !== null && _cmplp$marginTop !== void 0 ? _cmplp$marginTop : "var(--ds-space-0)"),
            "--_1rp2pwe": (0, $9t7rW.default)((_cmplp$marginBottom = __cmplp.marginBottom) !== null && _cmplp$marginBottom !== void 0 ? _cmplp$marginBottom : "var(--ds-space-0)"),
            "--_1m0m4uv": (0, $9t7rW.default)(__cmplp.maxWidth)
        }),
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbn9jh _4t3i10e5 _2rko1lfe _19pkyt99 _otyr1jhp _p12foqa0",
            __cmplp.className
        ])
    }));
});
const $850b90d1da6073df$var$Container = (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $850b90d1da6073df$var$_excluded4);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    }));
});
const $850b90d1da6073df$export$3d85b21940800888 = (_ref5)=>{
    let { testId: testId } = _ref5;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($850b90d1da6073df$var$Container, {
        "data-testId": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($850b90d1da6073df$export$3c7919ca4c48cda4, {
        width: "60%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kBUpw.Show), {
        above: "sm"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($850b90d1da6073df$export$3c7919ca4c48cda4, {
        height: "14px",
        width: "90%",
        marginTop: "var(--ds-space-300)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4V4Mb.Hide), {
        above: "sm"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($850b90d1da6073df$export$3c7919ca4c48cda4, {
        height: "14px",
        marginTop: "var(--ds-space-250)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($850b90d1da6073df$export$3c7919ca4c48cda4, {
        height: "14px",
        marginTop: "var(--ds-space-250)"
    })));
};
const $850b90d1da6073df$var$AppListing2LineSkeletonContainer = (0, $eUqFw.forwardRef)((_ref6, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref6, __cmplp = (0, $bwPfh.default)(_ref6, $850b90d1da6073df$var$_excluded5);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1tke1414 _1bsbhv4l _1qwo1osq",
            __cmplp.className
        ])
    }));
});
const $850b90d1da6073df$export$7073bd4814843a30 = (_ref7)=>{
    let { testId: testId } = _ref7;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($850b90d1da6073df$var$AppListing2LineSkeletonContainer, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($850b90d1da6073df$export$3c7919ca4c48cda4, {
        width: "55%",
        height: "1rem",
        marginTop: "var(--ds-space-500)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($850b90d1da6073df$export$3c7919ca4c48cda4, {
        width: "100%",
        height: "1rem",
        marginTop: "var(--ds-space-300)"
    }));
};

});
parcelRegister("4V4Mb", function(module, exports) {

$parcel$export(module.exports, "Hide", () => $395030ba9d3389ad$export$bed28288a051538);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $aokGA = parcelRequire("aokGA");
const $395030ba9d3389ad$var$hideAboveQueries = (0, $aokGA.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'none'
});
const $395030ba9d3389ad$var$hideBelowQueries = (0, $aokGA.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'none'
});
const $395030ba9d3389ad$export$bed28288a051538 = ({ above: above, below: below, children: children, as: AsElement = 'div' })=>{
    return (0, $byn9U.jsx)(AsElement, {
        css: [
            above && $395030ba9d3389ad$var$hideAboveQueries[above],
            below && $395030ba9d3389ad$var$hideBelowQueries[below]
        ]
    }, children);
};

});
parcelRegister("aokGA", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_buildAboveMediaQueryCSS", () => $790c310db9873a98$export$918f8818cfbbeb2c);
$parcel$export(module.exports, "UNSAFE_buildBelowMediaQueryCSS", () => $790c310db9873a98$export$b2a4e2b0c6417297);

var $byn9U = parcelRequire("byn9U");

var $iVK5n = parcelRequire("iVK5n");

var $8oBYp = parcelRequire("8oBYp");
const $790c310db9873a98$export$918f8818cfbbeb2c = (input)=>{
    return (0, $iVK5n.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: (0, $byn9U.css)({
                [(0, $8oBYp.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};
const $790c310db9873a98$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $iVK5n.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: (0, $byn9U.css)({
                // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
                [(0, $8oBYp.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};

});
parcelRegister("iVK5n", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_BREAKPOINTS_ORDERED_LIST", () => $dc814c86c76c6737$export$2d293d9871c38e91);
/**
 * Our internal configuration for breakpoints configuration.
 *
 * We explicitly use `-0.01rem` for "max" values to both ensure we do not overlap our media queries, but also don't skip any fractional pixels.  There is a chance this is not safe in some browsers, eg. Safari has weird rounding.
 * @see: https://tzi.fr/css/prevent-double-breakpoint/
 *
 * @experimental Unsafe for direct consumption outside of the design system itself; please use our `media` export instead for media queries.
 */ const $dc814c86c76c6737$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '109.99rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $dc814c86c76c6737$export$2d293d9871c38e91 = Object.keys($dc814c86c76c6737$export$e5ee4fe8b989fd09);
const $dc814c86c76c6737$export$b7ed752a57b4177b = $dc814c86c76c6737$export$2d293d9871c38e91[0];

});

parcelRegister("8oBYp", function(module, exports) {

$parcel$export(module.exports, "media", () => $61ce05535b72c208$export$987d49ffe1b0900f);
$parcel$export(module.exports, "UNSAFE_media", () => $61ce05535b72c208$export$c881183ca713c214);
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see https://compiledcssinjs.com/docs/atomic-css#selector-specificity
 */ const $61ce05535b72c208$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 109.99rem)',
        xl: '@media (min-width: 110rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110rem)'
    }
};
const $61ce05535b72c208$export$c881183ca713c214 = $61ce05535b72c208$export$987d49ffe1b0900f;

});



parcelRegister("kBUpw", function(module, exports) {

$parcel$export(module.exports, "Show", () => $f01305541cbcc9ff$export$f6a3d19be20f5819);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $aokGA = parcelRequire("aokGA");
const $f01305541cbcc9ff$var$showAboveQueries = (0, $aokGA.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $f01305541cbcc9ff$var$showBelowQueries = (0, $aokGA.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $f01305541cbcc9ff$var$defaultHiddenStyles = (0, $byn9U.css)({
    display: 'none'
});
const $f01305541cbcc9ff$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div' })=>{
    return (0, $byn9U.jsx)(AsElement, {
        css: [
            $f01305541cbcc9ff$var$defaultHiddenStyles,
            above && $f01305541cbcc9ff$var$showAboveQueries[above],
            below && $f01305541cbcc9ff$var$showBelowQueries[below]
        ]
    }, children);
};

});


parcelRegister("9c9Gu", function(module, exports) {

$parcel$export(module.exports, "useLocalStorage", () => (parcelRequire("7UjlI")).useLocalStorage);
$parcel$export(module.exports, "usePrevious", () => (parcelRequire("7UjlI")).usePrevious);
$parcel$export(module.exports, "usePromise", () => (parcelRequire("7UjlI")).usePromise);

var $7UjlI = parcelRequire("7UjlI");

});
parcelRegister("7UjlI", function(module, exports) {

$parcel$export(module.exports, "usePromise", () => $5c1cc5baa5827c56$export$dd6b79aaabe7bc37);
$parcel$export(module.exports, "usePrevious", () => $5c1cc5baa5827c56$export$5cae361ad82dce8b);
$parcel$export(module.exports, "useLocalStorage", () => $5c1cc5baa5827c56$export$86e2cef2561044ac);

var $eUqFw = parcelRequire("eUqFw");

var $ebb1z = parcelRequire("ebb1z");
function $5c1cc5baa5827c56$var$promiseReducer(_state, action) {
    switch(action.type){
        case 'pending':
            return {
                pending: true,
                result: null,
                error: null,
                refresh: null
            };
        case 'fulfilled':
            return {
                pending: false,
                result: action.payload,
                refresh: action.refresh
            };
        default:
            return {
                pending: false,
                error: action.payload,
                refresh: action.refresh
            };
    }
}
function $5c1cc5baa5827c56$export$dd6b79aaabe7bc37(promiseFn) {
    let memoizeOn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    let runPromise = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    const initialState = {
        result: null,
        error: null,
        pending: true,
        refresh: null
    };
    const [state, dispatch] = (0, $eUqFw.useReducer)($5c1cc5baa5827c56$var$promiseReducer, initialState);
    const promiseExecuter = ()=>{
        dispatch({
            type: 'pending'
        });
        promiseFn().then((result)=>dispatch({
                type: 'fulfilled',
                payload: result,
                refresh: promiseExecuter
            })).catch((error)=>dispatch({
                type: 'error',
                payload: error,
                refresh: promiseExecuter
            }));
    };
    (0, $eUqFw.useEffect)(()=>{
        if (runPromise) promiseExecuter();
    }, memoizeOn);
    return state;
}
function $5c1cc5baa5827c56$export$5cae361ad82dce8b(value) {
    const ref = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}
function $5c1cc5baa5827c56$export$86e2cef2561044ac(key, defaultValue) {
    const isStorageSupported = (0, $ebb1z.getLocalStorageSupport)();
    const value = (0, $ebb1z.getFromStorage)(key);
    const [localState, updateLocalState] = (0, $eUqFw.useState)(value === null || value === undefined ? defaultValue : (0, $ebb1z.tryParse)(value));
    const onLocalStorageChange = (0, $eUqFw.useCallback)((event)=>{
        if ((0, $ebb1z.isTypeOfLocalStorageChanged)(event) && event.detail.key === key) updateLocalState(event.detail.value);
    }, [
        updateLocalState,
        key
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isStorageSupported) return;
        window.addEventListener((0, $ebb1z.LOCAL_STORAGE_CHANGE_EVENT_NAME), onLocalStorageChange);
        return ()=>{
            window.removeEventListener((0, $ebb1z.LOCAL_STORAGE_CHANGE_EVENT_NAME), onLocalStorageChange);
        };
    }, [
        onLocalStorageChange
    ]);
    const writeState = (0, $eUqFw.useCallback)((newValue)=>(0, $ebb1z.writeStorage)(key, newValue), [
        key
    ]);
    const deleteState = (0, $eUqFw.useCallback)(()=>(0, $ebb1z.deleteFromStorage)(key), [
        key
    ]);
    const state = localState !== null && localState !== void 0 ? localState : defaultValue;
    return {
        state: state,
        isLocalStorageSupported: isStorageSupported,
        writeState: writeState,
        deleteState: deleteState
    };
}

});
parcelRegister("ebb1z", function(module, exports) {

$parcel$export(module.exports, "LOCAL_STORAGE_CHANGE_EVENT_NAME", () => $a52aa4f9822e2605$export$f34e2fac54530283);
$parcel$export(module.exports, "isGivenStorageSupported", () => $a52aa4f9822e2605$export$205353b6505417a5);
$parcel$export(module.exports, "getLocalStorageSupport", () => $a52aa4f9822e2605$export$f3d0784f7aa42f59);
$parcel$export(module.exports, "isTypeOfLocalStorageChanged", () => $a52aa4f9822e2605$export$d5ee54606f404fe7);
$parcel$export(module.exports, "tryParse", () => $a52aa4f9822e2605$export$468ff95b83d315e5);
$parcel$export(module.exports, "writeStorage", () => $a52aa4f9822e2605$export$330a8aa32aa99ddb);
$parcel$export(module.exports, "deleteFromStorage", () => $a52aa4f9822e2605$export$9139156688d13b77);
$parcel$export(module.exports, "getFromStorage", () => $a52aa4f9822e2605$export$e4c9b9bae9539063);
const $a52aa4f9822e2605$export$f34e2fac54530283 = 'onLocalStorageChange';
const $a52aa4f9822e2605$export$205353b6505417a5 = (givenStorage)=>(function() {
        let supported = false;
        let calculated = false;
        return function() {
            try {
                if (calculated) return supported;
                if (!$a52aa4f9822e2605$var$isBrowser()) return false;
                const key = 'storageTest';
                givenStorage.setItem(key, key);
                const result = givenStorage.getItem(key) === key;
                givenStorage.removeItem(key);
                supported = result && !!givenStorage;
                calculated = true;
                return supported;
            } catch (_unused) {
                supported = false;
                calculated = true;
                return supported;
            }
        };
    })();
const $a52aa4f9822e2605$export$f3d0784f7aa42f59 = ()=>$a52aa4f9822e2605$export$205353b6505417a5(window.localStorage)();
const $a52aa4f9822e2605$var$isBrowser = ()=>{
    return typeof window !== 'undefined' && typeof window.document !== 'undefined';
};
function $a52aa4f9822e2605$export$d5ee54606f404fe7(evt) {
    return !!evt && evt.type === $a52aa4f9822e2605$export$f34e2fac54530283;
}
function $a52aa4f9822e2605$export$468ff95b83d315e5(value) {
    try {
        return JSON.parse(value);
    } catch (_unused2) {
        return value;
    }
}
function $a52aa4f9822e2605$export$330a8aa32aa99ddb(key, value) {
    if (!$a52aa4f9822e2605$export$f3d0784f7aa42f59()) return;
    window.localStorage.setItem(key, typeof value === 'object' ? JSON.stringify(value) : "".concat(String(value)));
    window.dispatchEvent(new CustomEvent($a52aa4f9822e2605$export$f34e2fac54530283, {
        detail: {
            key: key,
            value: value
        }
    }));
}
function $a52aa4f9822e2605$export$9139156688d13b77(key) {
    if (!$a52aa4f9822e2605$export$f3d0784f7aa42f59()) return;
    window.localStorage.removeItem(key);
    window.dispatchEvent(new CustomEvent($a52aa4f9822e2605$export$f34e2fac54530283, {
        detail: {
            key: key,
            value: null
        }
    }));
}
function $a52aa4f9822e2605$export$e4c9b9bae9539063(key) {
    if (!$a52aa4f9822e2605$export$f3d0784f7aa42f59()) return;
    return window.localStorage.getItem(key);
}

});



parcelRegister("3pGnh", function(module, exports) {

$parcel$export(module.exports, "foldAppPricing", () => $27c49397666be7f2$export$bb612f7936b8d5cb);
$parcel$export(module.exports, "makeAppPricingFromMarketplaceAppData", () => $27c49397666be7f2$export$1390d9b85b4d7a68);

var $buxnS = parcelRequire("buxnS");

parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");
const $27c49397666be7f2$export$1cd676682f55cf4f = 'FREE';
const $27c49397666be7f2$var$PAID_PRICING_TYPE = 'PAID';
const $27c49397666be7f2$export$83f7c2f33b89d1b4 = (0, $g5DHJ.Record)({
    type: $27c49397666be7f2$export$1cd676682f55cf4f
});
const $27c49397666be7f2$export$a7f097d1d985d3f1 = (0, $g5DHJ.Record)({
    amount: 0,
    currencyCode: '',
    unitCount: 0,
    type: (0, $09427d726d6fc2a7$export$b3cd817f06e4fc99)
});
const $27c49397666be7f2$export$355e61c6f0a18c9d = (0, $g5DHJ.Record)({
    type: $27c49397666be7f2$var$PAID_PRICING_TYPE,
    annual: (0, $g5DHJ.List)(),
    monthly: (0, $g5DHJ.List)()
});
function $27c49397666be7f2$export$bb612f7936b8d5cb(appPricing) {
    return function foldAppPricingInner(free, paid) {
        switch(appPricing.type){
            case $27c49397666be7f2$export$1cd676682f55cf4f:
                return free(appPricing);
            case $27c49397666be7f2$var$PAID_PRICING_TYPE:
                return paid(appPricing);
            default:
                // Flow compile-time validation that we've handled every pricing type
                // prettier-ignore
                appPricing;
                return undefined;
        }
    };
}
const $27c49397666be7f2$var$parseUnitCount = (unitCount)=>unitCount === -1 ? Number.POSITIVE_INFINITY : unitCount;
const $27c49397666be7f2$var$makeFlatRatePricingItemFromMarketplaceAppFlatRatePricingItem = (flatRateItem)=>$27c49397666be7f2$export$a7f097d1d985d3f1({
        amount: flatRateItem.amount,
        currencyCode: flatRateItem.currencyCode,
        unitCount: $27c49397666be7f2$var$parseUnitCount(flatRateItem.unitCount),
        type: (0, $09427d726d6fc2a7$export$d43def0adf0a1960)
    });
const $27c49397666be7f2$var$resolveMonthlyItems = (flatRateItems, perUnitItems)=>flatRateItems.filter((i)=>i.monthsValid === 1).map($27c49397666be7f2$var$makeFlatRatePricingItemFromMarketplaceAppFlatRatePricingItem).concat(perUnitItems.filter((i)=>i.monthsValid === 1).map((perUnitItem)=>$27c49397666be7f2$export$a7f097d1d985d3f1({
            amount: perUnitItem.amount,
            currencyCode: perUnitItem.currencyCode,
            unitCount: $27c49397666be7f2$var$parseUnitCount(perUnitItem.unitCount),
            type: (0, $09427d726d6fc2a7$export$b3cd817f06e4fc99)
        })));
const $27c49397666be7f2$var$resolveAnnualItems = (flatRateItems)=>flatRateItems.filter((i)=>i.monthsValid === 12).map($27c49397666be7f2$var$makeFlatRatePricingItemFromMarketplaceAppFlatRatePricingItem);
const $27c49397666be7f2$export$1390d9b85b4d7a68 = (paymentModel, marketplaceAppPricing)=>(0, $bWAru.Option).of(paymentModel).map((pm)=>(0, $buxnS.foldPaymentModel)(pm)(()=>(0, $bWAru.Either).right($27c49397666be7f2$export$83f7c2f33b89d1b4()), ()=>{
            if (!marketplaceAppPricing) return (0, $bWAru.Either).left('marketplaceAppPricing must be supplied for paid apps');
            return marketplaceAppPricing.fold((marketplaceAppPricingErrorResponse)=>(0, $bWAru.Either).left("Error while resolving pricing for paid app: ".concat(marketplaceAppPricingErrorResponse)), (marketplaceAppPricingRes)=>{
                const flatRateItems = (0, $g5DHJ.List)(marketplaceAppPricingRes.items);
                return (0, $bWAru.Either).right($27c49397666be7f2$export$355e61c6f0a18c9d({
                    annual: $27c49397666be7f2$var$resolveAnnualItems(flatRateItems),
                    monthly: $27c49397666be7f2$var$resolveMonthlyItems(flatRateItems, (0, $bWAru.Option).of(marketplaceAppPricingRes.perUnitItems).map((0, $g5DHJ.List)).getOrElse((0, $g5DHJ.List)()))
                }));
            });
        }, ()=>(0, $bWAru.Either).left((0, $09427d726d6fc2a7$export$817d7ae484ee652b)))).getOrElse((0, $bWAru.Either).left('paymentModel or parent data items not present'));

});
const $09427d726d6fc2a7$export$d43def0adf0a1960 = 'FLAT_RATE';
const $09427d726d6fc2a7$export$b3cd817f06e4fc99 = 'PER_UNIT';
const $09427d726d6fc2a7$export$817d7ae484ee652b = 'Paid via Vendor pricing is not supported'; // Infinite unit count should be represented by Infinity


parcelRegister("j5L3j", function(module, exports) {

$parcel$export(module.exports, "fetchMarketplaceAppData", () => $de62fb8e83260f76$export$f22bb6e36e44df10);
$parcel$export(module.exports, "getAppDeploymentType", () => $de62fb8e83260f76$export$38246f684b6faaa);
$parcel$export(module.exports, "getInstallableAddon", () => $de62fb8e83260f76$export$38c692b915985870);
$parcel$export(module.exports, "AppListingPaymentModel", () => $de62fb8e83260f76$export$f5314416ada80b0f);
$parcel$export(module.exports, "mapAppListingPaymentModel", () => $de62fb8e83260f76$export$8f4d2fa3ad726412);

var $ly50n = parcelRequire("ly50n");

var $4gzHi = parcelRequire("4gzHi");

var $kafab = parcelRequire("kafab");

var $ammkg = parcelRequire("ammkg");

var $ifMZN = parcelRequire("ifMZN");

var $55gtq = parcelRequire("55gtq");

var $3DsUo = parcelRequire("3DsUo");
const $de62fb8e83260f76$var$makeCloudMigrationTrialFromNonInstallableApp = (upmAvailableApp)=>{
    return {
        isEligible: Boolean(upmAvailableApp.cmtEligible),
        btfSenEndDate: upmAvailableApp.btfSenEndDate ? new Date(upmAvailableApp.btfSenEndDate) : undefined
    };
};
// TODO add types
const $de62fb8e83260f76$var$getInstallableIdentifier = (appKey, deploymentType, marketplaceApp)=>{
    if (marketplaceApp !== null && marketplaceApp !== void 0 && marketplaceApp.cloudAppVersions && deploymentType === (0, $kafab.AppDeployment).ECOSYSTEM_CLOUD) {
        var _marketplaceApp$cloud, _marketplaceApp$cloud2, _marketplaceApp$cloud3;
        const appDeployment = (_marketplaceApp$cloud = marketplaceApp.cloudAppVersions.edges) === null || _marketplaceApp$cloud === void 0 ? void 0 : (_marketplaceApp$cloud2 = _marketplaceApp$cloud[0]) === null || _marketplaceApp$cloud2 === void 0 ? void 0 : (_marketplaceApp$cloud3 = _marketplaceApp$cloud2.node) === null || _marketplaceApp$cloud3 === void 0 ? void 0 : _marketplaceApp$cloud3.deployment;
        const ari = appDeployment === null || appDeployment === void 0 ? void 0 : appDeployment.cloudAppId;
        return (0, $ifMZN.makeInstallableAppByAriIdentifier)({
            ari: (0, $ly50n.makeAppKey)(ari),
            appKey: (0, $ly50n.makeAppKey)(appKey || '')
        });
    } else return (0, $ifMZN.makeInstallableAppByKeyIdentifier)({
        key: (0, $ly50n.makeAppKey)(appKey)
    });
};
async function $de62fb8e83260f76$export$f22bb6e36e44df10(_ref) {
    let { appKey: appKey, fetchInstalledApp: fetchInstalledApp, contextId: contextId, deploymentType: deploymentType, marketplaceApp: marketplaceApp, flags: flags, hostCmtEnabled: hostCmtEnabled } = _ref;
    const installableAddonPromise = (0, $55gtq.default)().getInstallableAddon({
        addon: (0, $ifMZN.toSPIInstallableAddonIdentifier)($de62fb8e83260f76$var$getInstallableIdentifier(appKey, deploymentType, marketplaceApp)),
        hostCmtEnabled: hostCmtEnabled
    });
    const permissionCheckPromise = ()=>(0, $3DsUo.reflect)(installableAddonPromise.then((ia)=>(0, $55gtq.default)().hasInstallPermission({
                addon: ia
            })));
    const installedAppPromise = ()=>(0, $55gtq.default)().getInstalledAddon({
            contextId: contextId,
            addon: (0, $ifMZN.toSPIInstallableAddonIdentifier)($de62fb8e83260f76$var$getInstallableIdentifier(appKey, deploymentType, marketplaceApp)),
            flags: flags
        }).then((installedAddonResult)=>{
            return installedAddonResult.status === 'NOT_FOUND' ? null : installedAddonResult;
        })// eslint-disable-next-line promise/no-return-wrap
        .catch(()=>Promise.resolve(null));
    const sandboxEligibilityPromise = installableAddonPromise.then((installableAddon)=>installableAddon.eligibleForFreeOnSandbox).catch(()=>false);
    const cloudMigrationTrialPromise = installableAddonPromise.then((installableAddon)=>installableAddon.cloudMigrationTrial)// Incase app is non-installable but still eligible for cloudMigrationTrial
    .catch(function() {
        let { upmAvailableApp: upmAvailableApp } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (upmAvailableApp) return $de62fb8e83260f76$var$makeCloudMigrationTrialFromNonInstallableApp(upmAvailableApp);
        return {
            isEligible: false
        };
    });
    const [eligibleForFreeOnSandbox, installPermission, installedAddon, cloudMigrationTrial] = await Promise.all([
        sandboxEligibilityPromise,
        permissionCheckPromise(),
        fetchInstalledApp ? installedAppPromise() : null,
        cloudMigrationTrialPromise
    ]);
    return {
        installedApp: installedAddon ? (0, $4gzHi.makeInstalledAppFromSPIInstalledApp)(installedAddon) : undefined,
        installPermission: installPermission,
        eligibleForFreeOnSandbox: eligibleForFreeOnSandbox,
        cloudMigrationTrial: cloudMigrationTrial
    };
}
const $de62fb8e83260f76$export$38246f684b6faaa = (appListing)=>{
    var _appListing$cloudAppV, _appListing$cloudAppV2;
    const appVersion = (_appListing$cloudAppV = appListing.cloudAppVersions.edges) === null || _appListing$cloudAppV === void 0 ? void 0 : (_appListing$cloudAppV2 = _appListing$cloudAppV[0]) === null || _appListing$cloudAppV2 === void 0 ? void 0 : _appListing$cloudAppV2.node;
    return appVersion === null || appVersion === void 0 ? void 0 : appVersion.deployment.__typename;
};
const $de62fb8e83260f76$export$38c692b915985870 = (appDeployment, appKey)=>{
    if (appDeployment !== null && appDeployment !== void 0 && appDeployment.cloudAppId) return (0, $ifMZN.makeInstallableAppByAriIdentifier)({
        ari: (0, $ly50n.makeAppKey)(appDeployment.cloudAppId || ''),
        appKey: (0, $ly50n.makeAppKey)(appKey || '')
    });
    else return (0, $ifMZN.makeInstallableAppByKeyIdentifier)({
        key: (0, $ly50n.makeAppKey)(appKey || '')
    });
};
const $de62fb8e83260f76$export$f5314416ada80b0f = {
    [(0, $ammkg.MarketplaceAppPaymentModel).Free]: 'free',
    [(0, $ammkg.MarketplaceAppPaymentModel).PaidViaAtlassian]: 'atlassian',
    [(0, $ammkg.MarketplaceAppPaymentModel).PaidViaPartner]: 'vendor'
};
const $de62fb8e83260f76$export$8f4d2fa3ad726412 = (paymentModel)=>paymentModel ? $de62fb8e83260f76$export$f5314416ada80b0f[paymentModel] : undefined;

});
parcelRegister("55gtq", function(module, exports) {

$parcel$export(module.exports, "initSPI", () => $3b3a32b16add3d34$export$f5ac63195542f1d4);
$parcel$export(module.exports, "default", () => $3b3a32b16add3d34$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $fUOHe = parcelRequire("fUOHe");

var $f6dG7 = parcelRequire("f6dG7");

var $33x9K = parcelRequire("33x9K");
function $3b3a32b16add3d34$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3b3a32b16add3d34$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3b3a32b16add3d34$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3b3a32b16add3d34$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
let $3b3a32b16add3d34$var$InternalSPI;
function $3b3a32b16add3d34$var$instrumentFn(methodName, successful, duration) {
    (0, $fUOHe.default).task({
        task: (0, $f6dG7.LABEL_CAAS_SPI_METHOD_EXECUTION),
        taskId: methodName,
        successful: successful,
        duration: duration
    });
}
function $3b3a32b16add3d34$var$wrapObjectOfFunctions(stringToFunctionMap) {
    return Object.keys(stringToFunctionMap).reduce((acc, k)=>$3b3a32b16add3d34$var$_objectSpread($3b3a32b16add3d34$var$_objectSpread({}, acc), {}, {
            [k]: (0, $33x9K.instrumentAsync)(stringToFunctionMap[k], $3b3a32b16add3d34$var$instrumentFn, k)
        }), {});
}
function $3b3a32b16add3d34$var$wrapIfPresent(stringToFunctionMap) {
    if (stringToFunctionMap) return $3b3a32b16add3d34$var$wrapObjectOfFunctions(stringToFunctionMap);
    else throw new Error('Unable to find SPI.');
}
function $3b3a32b16add3d34$export$b0f0114b07655e4c() {
    $3b3a32b16add3d34$var$InternalSPI = undefined;
}
function $3b3a32b16add3d34$export$f5ac63195542f1d4(spi) {
    if ($3b3a32b16add3d34$var$InternalSPI) return $3b3a32b16add3d34$var$InternalSPI;
    $3b3a32b16add3d34$var$InternalSPI = $3b3a32b16add3d34$var$wrapIfPresent(spi);
    // For use in pollinator tests
    window.__EMCEE__SPI__ = $3b3a32b16add3d34$var$InternalSPI;
    return $3b3a32b16add3d34$var$InternalSPI;
}
const $3b3a32b16add3d34$var$getSPI = ()=>{
    if ($3b3a32b16add3d34$var$InternalSPI) return $3b3a32b16add3d34$var$InternalSPI;
    else throw new Error('getSPI called before the SPI initializing the SPI using initSPI');
};
var $3b3a32b16add3d34$export$2e2bcd8739ae039 = $3b3a32b16add3d34$var$getSPI;

});
parcelRegister("f6dG7", function(module, exports) {

$parcel$export(module.exports, "LABEL_CAAS_SPI_METHOD_EXECUTION", () => $02d639ea7ac2fa54$export$1473baf6b30e691f);
/**
 * The different tasks (SLI) we track for our SLOs. Each task may have success, error or performance
 * measurements associated with it.
 */ const $02d639ea7ac2fa54$export$cfc9f501e2dafa5 = Object.freeze({
    ViewAppsList: 'view-apps-list'
});
const $02d639ea7ac2fa54$export$1473baf6b30e691f = 'caas-spi-execution';

});

parcelRegister("33x9K", function(module, exports) {

$parcel$export(module.exports, "instrumentAsync", () => $239b5f057b453ebb$export$2194fbfc0b60415d);
/**
 * Instruments a promise returning function,
 * returning time take to execute and success / failure
 */ function $239b5f057b453ebb$export$2194fbfc0b60415d(task, measurementFn, taskName) {
    return function() {
        const start = performance.now();
        let isSuccess = false;
        return task(...arguments).then((results)=>{
            isSuccess = true;
            return results;
        }, (error)=>{
            isSuccess = false;
            throw error;
        }).finally(()=>{
            if (Array.isArray(measurementFn)) measurementFn.forEach((fn)=>fn(taskName, isSuccess, performance.now() - start));
            else measurementFn(taskName, isSuccess, performance.now() - start);
        });
    };
}

});



parcelRegister("9ePvD", function(module, exports) {

$parcel$export(module.exports, "Pricing", () => $6b9d6086e24a99a3$export$bc75f5ddb26aac73);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $eUqFw = parcelRequire("eUqFw");

var $3pGnh = parcelRequire("3pGnh");

var $bwqfS = parcelRequire("bwqfS");
function $6b9d6086e24a99a3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6b9d6086e24a99a3$var$FreePricingNew = (0, $3UXZ8.default)("div", {
    target: "eyastdp0",
    label: "FreePricingNew"
})("color:", "var(--ds-text-subtlest, ".concat((0, $j0gMm.N400), ")"), ";");
const $6b9d6086e24a99a3$export$7e910a136527e839 = (0, $3UXZ8.default)("div", {
    target: "eyastdp1",
    label: "FreePricing"
})("color:", "var(--ds-text, ".concat((0, $j0gMm.N400), ")"), ";text-transform:uppercase;");
const $6b9d6086e24a99a3$export$4faac3888fb5e689 = (0, $3UXZ8.default)("div", {
    target: "eyastdp2",
    label: "PricingContainer"
})({
    name: "8xl60i",
    styles: "margin-top:auto;"
});
const $6b9d6086e24a99a3$export$bc75f5ddb26aac73 = (_ref)=>{
    let { hostPricing: hostPricing, appPricing: appPricing, installedApp: installedApp, links: links, appKey: appKey, hideTryFreeHeading: hideTryFreeHeading, className: className, isInstallButtonVisible: isInstallButtonVisible, eligibleForFreeOnSandbox: eligibleForFreeOnSandbox, cloudMigrationTrial: cloudMigrationTrial, showAetherAppListingPage: showAetherAppListingPage } = _ref;
    const renderPaidPricingContent = (paidAppPricing, paidPaymentModel)=>{
        const { pending: pending, result: result } = hostPricing;
        if (pending) return 'Loading price...';
        if (result) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bwqfS.default), {
            hideTryFreeHeading: hideTryFreeHeading,
            appKey: appKey,
            hostPricing: result,
            paidPaymentModel: paidPaymentModel,
            links: links,
            paidAppPricing: paidAppPricing,
            isInstallButtonVisible: isInstallButtonVisible,
            eligibleForFreeOnSandbox: eligibleForFreeOnSandbox,
            cloudMigrationTrial: cloudMigrationTrial,
            showAetherAppListingPage: showAetherAppListingPage
        });
        return null;
    };
    const renderFreeOrPaidPricingContent = ()=>appPricing.fold((err)=>{
            if (err === (0, $09427d726d6fc2a7$export$817d7ae484ee652b)) return null;
            return 'Unknown price';
        }, (pricing)=>(0, $3pGnh.foldAppPricing)(pricing)(()=>showAetherAppListingPage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6b9d6086e24a99a3$var$FreePricingNew, null, "Free") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6b9d6086e24a99a3$export$7e910a136527e839, null, "Free"), (p)=>renderPaidPricingContent(p, installedApp.flatMap((ia)=>ia.paymentModel.fold((_)=>(0, $bWAru.Option).empty(), (m)=>(0, $bWAru.Option).some(m)))) || 'Unknown price'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6b9d6086e24a99a3$export$4faac3888fb5e689, {
        className: className
    }, renderFreeOrPaidPricingContent());
};
var $6b9d6086e24a99a3$export$2e2bcd8739ae039 = $6b9d6086e24a99a3$export$bc75f5ddb26aac73;

});
parcelRegister("bwqfS", function(module, exports) {

$parcel$export(module.exports, "default", () => $86370c8f43fb08da$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $jgrQL = parcelRequire("jgrQL");

var $aUqTb = parcelRequire("aUqTb");

var $j0gMm = parcelRequire("j0gMm");

var $oXxJm = parcelRequire("oXxJm");
var $8CEbA = parcelRequire("8CEbA");
var $jlbX6 = parcelRequire("jlbX6");

var $4lmb9 = parcelRequire("4lmb9");

var $76fzC = parcelRequire("76fzC");

var $eUqFw = parcelRequire("eUqFw");

var $7zfnY = parcelRequire("7zfnY");
function $86370c8f43fb08da$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $86370c8f43fb08da$export$35e29d8d331f85bd = 'Get started';
const $86370c8f43fb08da$export$580ff1957ec26b68 = 'Try free';
const $86370c8f43fb08da$export$c192f14007e5a4b4 = (0, $3UXZ8.default)("div", {
    target: "e12z2c0d0",
    label: "PaidPricingContainer"
})({
    name: "xi606m",
    styles: "text-align:center;"
});
const $86370c8f43fb08da$export$1d76000680ea0e29 = (0, $3UXZ8.default)("div", {
    target: "e12z2c0d1",
    label: "PriceHeading"
})("color:", "var(--ds-text, ".concat((0, $j0gMm.N700), ")"), ";font-weight:700;text-transform:uppercase;text-align:center;");
const $86370c8f43fb08da$export$541d39676097f853 = (0, $3UXZ8.default)("div", {
    target: "e12z2c0d2",
    label: "EstimateContainer"
})("color:", "var(--ds-text, ".concat((0, $j0gMm.N400), ")"), ";display:flex;align-items:center;&:hover{background-color:", (props)=>props.hoverable ? "var(--ds-background-neutral-subtle-hovered, ".concat((0, $j0gMm.N30), ")") : 'auto', ";cursor:", (props)=>props.hoverable ? 'pointer' : 'auto', ";}");
const $86370c8f43fb08da$export$fae8a6d44ed6841a = (0, $3UXZ8.default)("div", {
    target: "e12z2c0d3",
    label: "EstimateText"
})("color:", "var(--ds-text, ".concat((0, $j0gMm.N400), ")"), ";font-size:16px;font-weight:600;line-height:24px;");
const $86370c8f43fb08da$export$4181d0431eaf95d5 = (0, $3UXZ8.default)("p", {
    target: "e12z2c0d4",
    label: "PricingSubtext"
})("margin-top:0;font-size:12px;text-align:center;color:", "var(--ds-text-accent-teal-bolder, ".concat((0, $j0gMm.N500), ")"), ";");
const $86370c8f43fb08da$export$48450bd55c69ef28 = (0, $3UXZ8.default)("div", {
    target: "e12z2c0d5",
    label: "PricingSubtextContainer"
})("color:var(--ds-text-subtlest);text-align:center;font-size:12px;font-weight:400;line-height:18px;display:flex;padding-left:var(--ds-space-050, 4px);justify-content:center;align-items:center;&:hover{background-color:", (props)=>props.hoverable ? "var(--ds-surface-hovered)" : 'auto', ";cursor:", (props)=>props.hoverable ? 'pointer' : 'auto', ";border-radius:3px;}");
$86370c8f43fb08da$export$2e2bcd8739ae039.defaultProps = {
    hideTryFreeHeading: false
};
function $86370c8f43fb08da$var$getPriceHeading(hideTryFreeHeading, eligibleForFreeOnSandbox) {
    if (hideTryFreeHeading) return null;
    if (eligibleForFreeOnSandbox) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($86370c8f43fb08da$export$1d76000680ea0e29, null, $86370c8f43fb08da$export$35e29d8d331f85bd);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($86370c8f43fb08da$export$1d76000680ea0e29, null, $86370c8f43fb08da$export$580ff1957ec26b68);
}
const $86370c8f43fb08da$var$resolvePricingSubtext = (eligibleForFreeOnSandbox, cloudMigrationTrial)=>{
    if (eligibleForFreeOnSandbox) return 'already purchased';
    const duration = cloudMigrationTrial !== null && cloudMigrationTrial !== void 0 && cloudMigrationTrial.isEligible && cloudMigrationTrial !== null && cloudMigrationTrial !== void 0 && cloudMigrationTrial.btfSenEndDate ? (0, $76fzC).differenceInDaysOrMonths(cloudMigrationTrial.btfSenEndDate, new Date()) : '30-day';
    return "after ".concat(duration, " trial");
};
const $86370c8f43fb08da$var$resolvePricingSubtextNew = (eligibleForFreeOnSandbox, cloudMigrationTrial)=>{
    if (eligibleForFreeOnSandbox) return 'App purchased';
    const duration = cloudMigrationTrial !== null && cloudMigrationTrial !== void 0 && cloudMigrationTrial.isEligible && cloudMigrationTrial !== null && cloudMigrationTrial !== void 0 && cloudMigrationTrial.btfSenEndDate ? (0, $76fzC).differenceInDaysOrMonths(cloudMigrationTrial.btfSenEndDate, new Date(), {
        pluralizeUnits: false,
        countUnitSeparator: '-'
    }) : '30-day';
    return "Estimate after ".concat(duration, " free trial");
};
function $86370c8f43fb08da$export$2e2bcd8739ae039(props) {
    const resolveBillingPeriodUnit = ()=>(0, $8CEbA.foldSubscriptionPeriod)(props.hostPricing.subscriptionPeriod, ()=>'month', ()=>'year');
    const resolvePricingItems = ()=>(0, $8CEbA.foldSubscriptionPeriod)(props.hostPricing.subscriptionPeriod, ()=>props.paidAppPricing.monthly, ()=>props.paidAppPricing.annual);
    const resolveEstimateContainer = (estimate)=>{
        const amount = props.eligibleForFreeOnSandbox ? 0 : estimate.amount;
        const formattedPrice = (0, $jlbX6.formatPrice)(amount, estimate.currencyCode);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($86370c8f43fb08da$export$541d39676097f853, {
            hoverable: true
        }, "Estimated ", formattedPrice, " / ", resolveBillingPeriodUnit(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jgrQL))), {
            label: "Editor Info Icon"
        }));
    };
    const resolveEstimateContainerNew = (estimate)=>{
        const amount = props.eligibleForFreeOnSandbox ? 0 : estimate.amount;
        const formattedPrice = (0, $jlbX6.formatPrice)(amount, estimate.currencyCode);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($86370c8f43fb08da$export$fae8a6d44ed6841a, null, formattedPrice, " / ", resolveBillingPeriodUnit());
    };
    const resolvePricingExplanation = (estimate)=>props.paidPaymentModel.fold(()=>(0, $jlbX6.makePricingExplanationForUninstalled)(resolvePricingItems(), props.hostPricing.currentLicensedUsers, estimate, props.hostPricing.subscriptionPeriod, props.cloudMigrationTrial, props.showAetherAppListingPage), (pm)=>pm.licenseType.fold((evaluation)=>(0, $jlbX6.makePricingExplanationForEvaluation)(resolvePricingItems(), props.hostPricing.currentLicensedUsers, estimate, props.hostPricing.subscriptionPeriod, (0, $76fzC).longDate(evaluation.expiry)), ()=>(0, $jlbX6.makePricingExplanationForSubscription)(resolvePricingItems(), props.hostPricing.currentLicensedUsers, estimate, props.hostPricing.subscriptionPeriod)));
    if (props.showAetherAppListingPage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($86370c8f43fb08da$export$c192f14007e5a4b4, null, (0, $oXxJm.default)(resolvePricingItems(), props.hostPricing.currentLicensedUsers).fold((error)=>{
        console.error('Error when resolving price', error);
        return 'Unknown price';
    }, (estimate)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, resolveEstimateContainerNew(estimate), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4lmb9.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7zfnY.default), {
                appKey: props.appKey,
                links: props.links,
                description: resolvePricingExplanation(estimate),
                isInstallButtonVisible: props.isInstallButtonVisible,
                eligibleForFreeOnSandbox: props.eligibleForFreeOnSandbox,
                cloudMigrationTrial: props.cloudMigrationTrial,
                showAetherAppListingPage: props.showAetherAppListingPage
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($86370c8f43fb08da$export$48450bd55c69ef28, {
            hoverable: true
        }, $86370c8f43fb08da$var$resolvePricingSubtextNew(props.eligibleForFreeOnSandbox, props.cloudMigrationTrial), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aUqTb))), {
            label: "Editor Info Panel"
        }))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($86370c8f43fb08da$export$c192f14007e5a4b4, null, $86370c8f43fb08da$var$getPriceHeading(props.hideTryFreeHeading, props.eligibleForFreeOnSandbox), (0, $oXxJm.default)(resolvePricingItems(), props.hostPricing.currentLicensedUsers).fold((error)=>{
        console.error('Error when resolving price', error);
        return 'Unknown price';
    }, (estimate)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4lmb9.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7zfnY.default), {
                appKey: props.appKey,
                links: props.links,
                description: resolvePricingExplanation(estimate),
                isInstallButtonVisible: props.isInstallButtonVisible,
                eligibleForFreeOnSandbox: props.eligibleForFreeOnSandbox,
                cloudMigrationTrial: props.cloudMigrationTrial,
                showAetherAppListingPage: props.showAetherAppListingPage
            })
        }, resolveEstimateContainer(estimate)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($86370c8f43fb08da$export$4181d0431eaf95d5, null, $86370c8f43fb08da$var$resolvePricingSubtext(props.eligibleForFreeOnSandbox, props.cloudMigrationTrial)))));
}

});
parcelRegister("jgrQL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e0651d627acb5549$var$_react = $e0651d627acb5549$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $e0651d627acb5549$var$_information = $e0651d627acb5549$var$_interopRequireDefault((parcelRequire("h6FFs")));
function $e0651d627acb5549$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e0651d627acb5549$var$EditorInfoIcon = (props)=>/*#__PURE__*/ $e0651d627acb5549$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m0-8.5a1 1 0 0 0-1 1V15a1 1 0 0 0 2 0v-2.5a1 1 0 0 0-1-1m0-1.125a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75"/></svg>`
    }, props, {
        newIcon: $e0651d627acb5549$var$_information.default
    }));
$e0651d627acb5549$var$EditorInfoIcon.displayName = 'EditorInfoIcon';
var $e0651d627acb5549$var$_default = module.exports.default = $e0651d627acb5549$var$EditorInfoIcon;

});
parcelRegister("h6FFs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6db48d6c22f8d07c19434865c237f982>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c743518dce4b322a$var$_react = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c743518dce4b322a$var$_UNSAFE_baseNew = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c743518dce4b322a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c743518dce4b322a$var$InformationIcon = (props)=>/*#__PURE__*/ $c743518dce4b322a$var$_react.default.createElement($c743518dce4b322a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$c743518dce4b322a$var$InformationIcon.displayName = 'InformationIcon';
var $c743518dce4b322a$var$_default = module.exports.default = $c743518dce4b322a$var$InformationIcon;

});


parcelRegister("aUqTb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f13fdf9f823d771$var$_react = $7f13fdf9f823d771$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $7f13fdf9f823d771$var$_information = $7f13fdf9f823d771$var$_interopRequireDefault((parcelRequire("h6FFs")));
function $7f13fdf9f823d771$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7f13fdf9f823d771$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $7f13fdf9f823d771$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-6a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $7f13fdf9f823d771$var$_information.default
    }));
$7f13fdf9f823d771$var$EditorPanelIcon.displayName = 'EditorPanelIcon';
var $7f13fdf9f823d771$var$_default = module.exports.default = $7f13fdf9f823d771$var$EditorPanelIcon;

});

parcelRegister("oXxJm", function(module, exports) {

$parcel$export(module.exports, "default", () => $04b06e035f9c18ff$export$2e2bcd8739ae039);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $4Gi93 = parcelRequire("4Gi93");
const $04b06e035f9c18ff$var$validatePricingItems = (pricingItems)=>{
    const sortedPricingItems = pricingItems.sort((a, b)=>a.unitCount - b.unitCount);
    return (0, $bWAru.Option).of(sortedPricingItems.find((pi, index, iter)=>(0, $4Gi93.foldPricingItem)(pi)(()=>(0, $bWAru.Option).of(index === 0 ? null : iter.get(index - 1)).filter((previous)=>(0, $4Gi93.foldPricingItem)(previous)(()=>false, ()=>true)).getOrElse(false), ()=>false))).map(()=>(0, $bWAru.Either).left('flatRate pricing items can only be the first pricing items')).getOrElseL(()=>(0, $bWAru.Either).right(sortedPricingItems));
};
const $04b06e035f9c18ff$var$separateFlatRateAndPerUnitPricingItems = (pricingItems)=>pricingItems.reduce((_ref, pi)=>{
        let { flatRatePricingItems: flatRatePricingItems, perUnitPricingItems: perUnitPricingItems } = _ref;
        return (0, $4Gi93.foldPricingItem)(pi)((frpi)=>({
                flatRatePricingItems: flatRatePricingItems.push(frpi),
                perUnitPricingItems: perUnitPricingItems
            }), (pupi)=>({
                flatRatePricingItems: flatRatePricingItems,
                perUnitPricingItems: perUnitPricingItems.push(pupi)
            }));
    }, {
        flatRatePricingItems: (0, $g5DHJ.List)(),
        perUnitPricingItems: (0, $g5DHJ.List)()
    });
const $04b06e035f9c18ff$var$calculatePerUnitPrice = (perUnitPricingItems, activeUsers)=>{
    const { amount: amount, usersRemaining: usersRemaining, currencyCode: currencyCode } = perUnitPricingItems.reduce((calculationReduction, perUnitPricingItem)=>{
        const numberOfUsersToChargeAtThisTier = Math.min(calculationReduction.usersRemaining, perUnitPricingItem.unitCount - calculationReduction.previousPricingItemUnitCount);
        return {
            amount: calculationReduction.amount + numberOfUsersToChargeAtThisTier * perUnitPricingItem.amount,
            usersRemaining: calculationReduction.usersRemaining - numberOfUsersToChargeAtThisTier,
            previousPricingItemUnitCount: perUnitPricingItem.unitCount,
            currencyCode: perUnitPricingItem.currencyCode // assuming all items in perUnitPricingItems belong to the same currency
        };
    }, {
        amount: 0,
        usersRemaining: activeUsers,
        previousPricingItemUnitCount: 0,
        currencyCode: ''
    });
    return usersRemaining === 0 ? (0, $bWAru.Either).right({
        amount: amount,
        currencyCode: currencyCode
    }) : (0, $bWAru.Either).left('Available pricing items do not cover all users');
};
const $04b06e035f9c18ff$var$maybeResolveFlatRatePrice = (flatRatePricingItems, activeUsers)=>(0, $bWAru.Option).of(flatRatePricingItems.find((frpi)=>activeUsers <= frpi.unitCount)).map((frpi)=>({
            amount: frpi.amount,
            currencyCode: frpi.currencyCode
        }));
const $04b06e035f9c18ff$var$calculatePrice = (pricingItems, activeUsers)=>$04b06e035f9c18ff$var$validatePricingItems(pricingItems).map($04b06e035f9c18ff$var$separateFlatRateAndPerUnitPricingItems).flatMap((_ref2)=>{
        let { flatRatePricingItems: flatRatePricingItems, perUnitPricingItems: perUnitPricingItems } = _ref2;
        return $04b06e035f9c18ff$var$maybeResolveFlatRatePrice(flatRatePricingItems, activeUsers).map((0, $bWAru.Either).right).getOrElseL(()=>$04b06e035f9c18ff$var$calculatePerUnitPrice(perUnitPricingItems, activeUsers));
    });
var $04b06e035f9c18ff$export$2e2bcd8739ae039 = $04b06e035f9c18ff$var$calculatePrice;

});
parcelRegister("4Gi93", function(module, exports) {

$parcel$export(module.exports, "foldPricingItem", () => $368928e024abd711$export$df84ac95c7bd261b);

function $368928e024abd711$export$df84ac95c7bd261b(pricingItem) {
    return function(flatRate, perUnit) {
        switch(pricingItem.type){
            case 0, $09427d726d6fc2a7$export$d43def0adf0a1960:
                return flatRate(pricingItem);
            case 0, $09427d726d6fc2a7$export$b3cd817f06e4fc99:
                return perUnit(pricingItem);
            default:
                pricingItem;
                return undefined;
        }
    };
}

});


parcelRegister("7zfnY", function(module, exports) {

$parcel$export(module.exports, "default", () => $5827bc8bf7d4581f$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $l501X = parcelRequire("l501X");

var $76fzC = parcelRequire("76fzC");

var $eUqFw = parcelRequire("eUqFw");

var $8KCrk = parcelRequire("8KCrk");

var $7Uh51 = parcelRequire("7Uh51");

var $ifMZN = parcelRequire("ifMZN");
function $5827bc8bf7d4581f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5827bc8bf7d4581f$export$285a930307c7132d = 'This app is already purchased and will continue to be available for free inside your sandbox.';
const $5827bc8bf7d4581f$export$216064ea367d152 = 'This app has already been purchased and will be available for free in your sandbox.';
const $5827bc8bf7d4581f$export$3123dc9700d49eab = 'Learn more about apps for sandboxes';
const $5827bc8bf7d4581f$export$6551ef972be47cd3 = 'How to manage sandboxes';
const $5827bc8bf7d4581f$export$d3a47fef8188b771 = (0, $3UXZ8.default)("div", {
    target: "e1yr7p260",
    label: "PricingContentContainer"
})({
    name: "1gnrs3k",
    styles: "text-align:left;max-width:205px;"
});
const $5827bc8bf7d4581f$export$e2969d46f73410b = (0, $3UXZ8.default)("p", {
    target: "e1yr7p261",
    label: "ContentHeading"
})({
    name: "v3rw8h",
    styles: "font-size:16px;font-weight:700;margin:5px auto;"
});
$5827bc8bf7d4581f$export$2e2bcd8739ae039.defaultProps = {
    isInstallButtonVisible: true
};
const $5827bc8bf7d4581f$var$getDialogDescriptionNew = (shouldShowRequestAppContent, eligibleForFreeOnSandbox, defaultDescription, cloudMigrationTrial)=>{
    if (eligibleForFreeOnSandbox) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, $5827bc8bf7d4581f$export$216064ea367d152);
    if (shouldShowRequestAppContent) {
        const duration = cloudMigrationTrial !== null && cloudMigrationTrial !== void 0 && cloudMigrationTrial.isEligible && cloudMigrationTrial !== null && cloudMigrationTrial !== void 0 && cloudMigrationTrial.btfSenEndDate ? (0, $76fzC).differenceInDaysOrMonths(cloudMigrationTrial.btfSenEndDate, new Date(), {
            pluralizeUnits: false,
            countUnitSeparator: '-'
        }) : '30-day';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, "This app may require an approval from your admin. Your ", duration, " free trial will start after approval."));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, defaultDescription);
};
const $5827bc8bf7d4581f$var$getDialogDescription = (shouldShowRequestAppContent, eligibleForFreeOnSandbox, defaultDescription, cloudMigrationTrial)=>{
    if (eligibleForFreeOnSandbox) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, $5827bc8bf7d4581f$export$285a930307c7132d);
    if (shouldShowRequestAppContent) {
        const duration = cloudMigrationTrial !== null && cloudMigrationTrial !== void 0 && cloudMigrationTrial.isEligible && cloudMigrationTrial !== null && cloudMigrationTrial !== void 0 && cloudMigrationTrial.btfSenEndDate ? (0, $76fzC).differenceInDaysOrMonths(cloudMigrationTrial.btfSenEndDate, new Date()) : '30-day';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, "This app may require an approval from your admin."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, "Your ", duration, " free trial will start after approval is received."));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, defaultDescription);
};
function $5827bc8bf7d4581f$export$2e2bcd8739ae039(props) {
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const onClick = ()=>{
        fireAnalyticsEvent((0, $8KCrk.makeAnalyticsForInstallableAppIdentifier)((0, $gaiog.ButtonClickedEvent), (0, $7Uh51.ANALYTICS_SUBJECT_ID_VIEW_APP_PRICING_DETAILS), (0, $ifMZN.makeInstallableAppByKeyIdentifier)({
            key: props.appKey
        })).toObject());
    };
    const getExternalLink = (shouldShowRequestAppContent, eligibleForFreeOnSandbox)=>{
        if (eligibleForFreeOnSandbox) return props.showAetherAppListingPage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l501X.default), {
            href: "https://support.atlassian.com/organization-administration/docs/manage-apps-for-sandboxes"
        }, $5827bc8bf7d4581f$export$6551ef972be47cd3) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l501X.default), {
            href: "https://support.atlassian.com/organization-administration/docs/manage-product-sandboxes#Managesandboxes-AddMarketplaceandAtlassianappstoasandbox"
        }, $5827bc8bf7d4581f$export$3123dc9700d49eab);
        let externalLinkText = 'See details';
        if (shouldShowRequestAppContent) externalLinkText = 'Learn more';
        if (props.showAetherAppListingPage) externalLinkText = 'Explore pricing options';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l501X.default), {
            href: props.links.appPricingDetails.expand({
                appKey: props.appKey
            }),
            onClick: onClick
        }, externalLinkText);
    };
    const shouldShowRequestAppContent = !props.isInstallButtonVisible;
    const description = props.showAetherAppListingPage ? $5827bc8bf7d4581f$var$getDialogDescriptionNew(shouldShowRequestAppContent, props.eligibleForFreeOnSandbox, props.description, props.cloudMigrationTrial) : $5827bc8bf7d4581f$var$getDialogDescription(shouldShowRequestAppContent, props.eligibleForFreeOnSandbox, props.description, props.cloudMigrationTrial);
    const externalLink = getExternalLink(shouldShowRequestAppContent, props.eligibleForFreeOnSandbox);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5827bc8bf7d4581f$export$d3a47fef8188b771, null, !props.showAetherAppListingPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5827bc8bf7d4581f$export$e2969d46f73410b, null, "Pricing"), description, externalLink);
}

});




parcelRegister("izRAm", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8650fdb8b1dedd8$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $kU8RF = parcelRequire("kU8RF");

var $aosfp = parcelRequire("aosfp");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $eUqFw = parcelRequire("eUqFw");

var $uNPxB = parcelRequire("uNPxB");

var $gXQsH = parcelRequire("gXQsH");

var $gwMyJ = parcelRequire("gwMyJ");

var $f6zt8 = parcelRequire("f6zt8");

var $lmAeL = parcelRequire("lmAeL");
function $d8650fdb8b1dedd8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d8650fdb8b1dedd8$export$796495a5fccbbe02 = (0, $3UXZ8.default)("div", {
    target: "e15727g30",
    label: "DialogInstallAppWithScopesContainer"
})({
    name: "1cc80k8",
    styles: "min-height:75px;overflow-x:hidden;"
});
const $d8650fdb8b1dedd8$export$7b8a8064734ade6e = (0, $3UXZ8.default)("div", {
    target: "e15727g31",
    label: "ScopesContainer"
})({
    name: "gt4wuf",
    styles: "margin-top:var(--ds-space-250, 20px);"
});
const $d8650fdb8b1dedd8$export$fb8c45af2ca86cd5 = (0, $3UXZ8.default)("div", {
    target: "e15727g32",
    label: "ForgeAppEgressAddressesContainer"
})({
    name: "gt4wuf",
    styles: "margin-top:var(--ds-space-250, 20px);"
});
const $d8650fdb8b1dedd8$var$DialogInstallAppWithScopes = (props)=>{
    const resolveScopesDescription = (appDetails)=>"".concat(appDetails.name, " will perform the following actions:");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d8650fdb8b1dedd8$export$796495a5fccbbe02, null, (0, $bWAru.Option).map2(props.installableApp, props.scopesLookup, (bria, scopesLookup)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kU8RF.default), {
            active: false,
            delay: 1000,
            size: 50
        }, bria.map((installableApp)=>{
            var _installableApp$marke;
            return(/*#__PURE__*/ // eslint-disable-next-line react/jsx-key
            (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gXQsH.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aosfp.default), {
                appHeaderDetails: (0, $uNPxB.makeAppHeaderDetails)(installableApp.marketplaceAppDetails, props.appDetailsFromSearchResponse),
                headerInjection: props.appDetailsHeaderInjection,
                appRatingLink: props.links.appRating,
                appIconLink: props.links.appIcon,
                isAppCloudFortified: (0, $f6zt8.isInstallableAppCloudFortified)(installableApp),
                bugBountyParticipant: (_installableApp$marke = installableApp.marketplaceAppDetails.programs) === null || _installableApp$marke === void 0 ? void 0 : _installableApp$marke.bugBountyParticipant,
                appIconSize: "small",
                showInstallationCount: true
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d8650fdb8b1dedd8$export$7b8a8064734ade6e, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwMyJ.default), {
                appScopes: installableApp.scopes,
                description: resolveScopesDescription(installableApp.marketplaceAppDetails),
                links: props.links,
                scopesLookup: scopesLookup
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d8650fdb8b1dedd8$export$fb8c45af2ca86cd5, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lmAeL.ForgeAppEgressAddresses), {
                forgeAppEgressAddresses: props.forgeAppEgressAddresses,
                appName: installableApp.marketplaceAppDetails.name
            }))));
        }).toOption().orNull())).getOrElseL(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kU8RF.default), {
            active: true,
            delay: 1000,
            size: 50
        }, null)));
};
var $d8650fdb8b1dedd8$export$2e2bcd8739ae039 = $d8650fdb8b1dedd8$var$DialogInstallAppWithScopes;

});
parcelRegister("aosfp", function(module, exports) {

$parcel$export(module.exports, "default", () => $79120ea206464009$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7BUhe = parcelRequire("7BUhe");

var $8xfj9 = parcelRequire("8xfj9");

var $iKF5E = parcelRequire("iKF5E");

var $94W0i = parcelRequire("94W0i");

var $lHuB6 = parcelRequire("lHuB6");

var $aFbzH = parcelRequire("aFbzH");

var $j7LzR = parcelRequire("j7LzR");

var $fm8vZ = parcelRequire("fm8vZ");

var $fmcsZ = parcelRequire("fmcsZ");

var $eoMJc = parcelRequire("eoMJc");
function $79120ea206464009$var$AppHeader(_ref) {
    var _appHeaderDetails$com;
    let { appHeaderDetails: appHeaderDetails, appIconLink: appIconLink, appIconSize: appIconSize = 'large', appRatingLink: appRatingLink, bottomSeparator: bottomSeparator = true, compatibilitySummary: compatibilitySummary = null, headerInjection: headerInjection, isAppCloudFortified: isAppCloudFortified = false, lozenges: lozenges = [], openMarketplaceLinksInNewTab: openMarketplaceLinksInNewTab = true, showInstallationCount: showInstallationCount = false, bugBountyParticipant: bugBountyParticipant = null, showStaffPickBadge: showStaffPickBadge = false } = _ref;
    const showNewAppMessage = $lHuB6.showNewAppMessage(appHeaderDetails);
    const { tooltipMessage: installTooltipMessage, installCountMessage: installCountMessage, showDownloadIcon: showDownloadIcon, isLoading: isInstallMessageLoading } = (0, $iKF5E.useInstallMessage)({
        distribution: appHeaderDetails.distribution,
        showNewAppMessage: showNewAppMessage,
        compatibleProducts: (_appHeaderDetails$com = appHeaderDetails.compatibleProducts) !== null && _appHeaderDetails$com !== void 0 ? _appHeaderDetails$com : [],
        showAetherAppListingPage: false
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $94W0i.HeaderContainer), {
        "data-testid": (0, $7BUhe.TEST_IDS).APP_HEADER,
        bottomSeparator: bottomSeparator
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $94W0i.IconContainer), {
        "data-testid": (0, $7BUhe.TEST_IDS).APP_HEADER_ICON
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aFbzH.default), {
        size: appIconSize,
        origin: appHeaderDetails.origin,
        icon: appHeaderDetails.icon,
        appKey: appHeaderDetails.key,
        appIconLink: appIconLink
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $94W0i.AppDetailsContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $94W0i.AppName), {
        "data-testid": (0, $7BUhe.TEST_IDS).APP_HEADER_APP_NAME
    }, appHeaderDetails.name, " ", showStaffPickBadge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eoMJc.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8xfj9.default), {
        name: appHeaderDetails.partner.name,
        link: appHeaderDetails.partner.link,
        partnerTierType: appHeaderDetails.partner.partnerTierType
    }), compatibilitySummary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $94W0i.CompatibilitiesContainer), {
        "data-testid": (0, $7BUhe.TEST_IDS).APP_HEADER_COMPATIBILITIES
    }, compatibilitySummary)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $94W0i.TrustSignalsContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $94W0i.TrustSignalsRow), null, !showNewAppMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $94W0i.RatingsContainer), {
        "data-testid": (0, $7BUhe.TEST_IDS).APP_HEADER_RATINGS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fmcsZ.default), {
        appKey: appHeaderDetails.key,
        appRatingLink: appRatingLink,
        openMarketplaceLinksInNewTab: openMarketplaceLinksInNewTab,
        ratings: appHeaderDetails.ratings
    })), showInstallationCount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $94W0i.InstallCountContainer), {
        "data-testid": (0, $7BUhe.TEST_IDS).APP_HEADER_INSTALL_COUNT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKF5E.InstallCount), {
        tooltipMessage: installTooltipMessage,
        installCountMessage: installCountMessage,
        showDownloadIcon: showDownloadIcon,
        isLoading: isInstallMessageLoading
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $94W0i.CertificationContainer), {
        "data-testid": (0, $7BUhe.TEST_IDS).APP_HEADER_CERTIFICATION
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j7LzR.default), {
        isAppCloudFortified: isAppCloudFortified,
        bugBountyParticipant: bugBountyParticipant
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fm8vZ.default), {
        lozenges: lozenges
    }))), !!headerInjection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $94W0i.HeaderInjectionContainer), null, headerInjection));
}
$79120ea206464009$var$AppHeader.getAppIcon = (0, $aFbzH.getAppIcon);
var $79120ea206464009$export$2e2bcd8739ae039 = $79120ea206464009$var$AppHeader;

});
parcelRegister("iKF5E", function(module, exports) {

$parcel$export(module.exports, "useInstallMessage", () => $da6c658928d2b927$export$29fe0f9bc7becfdc);
$parcel$export(module.exports, "InstallCount", () => $da6c658928d2b927$export$626438f97f0aeb8d);

var $j0gMm = parcelRequire("j0gMm");

var $2eG9N = parcelRequire("2eG9N");

var $hgNMk = parcelRequire("hgNMk");

var $eUqFw = parcelRequire("eUqFw");

var $bZbjp = parcelRequire("bZbjp");
const $da6c658928d2b927$var$getPreinstalledMessage = (isPreinstalled, compatibleProducts)=>{
    if (!isPreinstalled) return null;
    let tooltipMessage = '';
    if (compatibleProducts.length === 1) tooltipMessage = "This app comes preinstalled in ".concat(compatibleProducts[0], " instances");
    else if (compatibleProducts.length === 2) tooltipMessage = "This app comes preinstalled in ".concat(compatibleProducts[0], " and ").concat(compatibleProducts[1], " instances");
    else if (compatibleProducts.length >= 3) tooltipMessage = "This app comes preinstalled in ".concat(compatibleProducts[0], ", ").concat(compatibleProducts[1], " and other products");
    return {
        tooltipMessage: tooltipMessage,
        showDownloadIcon: false,
        installCountMessage: 'Preinstalled',
        title: 'INSTALLS'
    };
};
const $da6c658928d2b927$var$getNewAppMessage = (showNewAppMessage, showAetherAppListingPage)=>{
    if (!showNewAppMessage) return null;
    return {
        tooltipMessage: null,
        installCountMessage: showAetherAppListingPage ? 'No installs yet' : 'New!',
        showDownloadIcon: false,
        title: 'INSTALLS'
    };
};
const $da6c658928d2b927$var$getInstallCountMessage = (installCount, isPreinstalledInAnyHosting, isError, showAetherAppListingPage)=>{
    if (!installCount || isPreinstalledInAnyHosting || isError) return null;
    const countInLocaleString = installCount.toLocaleString();
    return {
        tooltipMessage: "Customers have installed this app in at least ".concat(countInLocaleString, " active ").concat((0, $hgNMk.pluralize)('instance', installCount)),
        installCountMessage: "".concat(countInLocaleString, " ").concat(showAetherAppListingPage ? '' : (0, $hgNMk.pluralize)('install', installCount)),
        showDownloadIcon: true,
        title: 'INSTALLS'
    };
};
const $da6c658928d2b927$var$getDownloadCountMessage = (downloadCount, isPreinstalledInAnyHosting, isError, showAetherAppListingPage)=>{
    if (!downloadCount || isPreinstalledInAnyHosting || isError) return null;
    const countInLocaleString = downloadCount.toLocaleString();
    return {
        tooltipMessage: "Customers have downloaded this app in at least ".concat(countInLocaleString, " active ").concat((0, $hgNMk.pluralize)('instance', downloadCount)),
        installCountMessage: "".concat(countInLocaleString, " ").concat(showAetherAppListingPage ? '' : (0, $hgNMk.pluralize)('download', downloadCount)),
        showDownloadIcon: true,
        title: 'DOWNLOADS'
    };
};
const $da6c658928d2b927$export$29fe0f9bc7becfdc = (_ref)=>{
    let { distribution: distribution, showNewAppMessage: showNewAppMessage, compatibleProducts: compatibleProducts, showAetherAppListingPage: showAetherAppListingPage } = _ref;
    const { installationCount: installationCount, downloadCount: downloadCount, isPreinstalled: isPreinstalled, isPreinstalledInAnyHosting: isPreinstalledInAnyHosting, isLoading: isLoading, isError: isError } = distribution || {};
    const { tooltipMessage: tooltipMessage, installCountMessage: installCountMessage, showDownloadIcon: showDownloadIcon, title: title } = $da6c658928d2b927$var$getPreinstalledMessage(isPreinstalled, compatibleProducts) || $da6c658928d2b927$var$getNewAppMessage(showNewAppMessage, showAetherAppListingPage) || $da6c658928d2b927$var$getInstallCountMessage(installationCount, isPreinstalledInAnyHosting, isError, showAetherAppListingPage) || $da6c658928d2b927$var$getDownloadCountMessage(downloadCount, isPreinstalledInAnyHosting, isError, showAetherAppListingPage) || {};
    return {
        tooltipMessage: tooltipMessage,
        installCountMessage: installCountMessage,
        showDownloadIcon: showDownloadIcon,
        isLoading: isLoading,
        isError: isError,
        title: title
    };
};
const $da6c658928d2b927$export$626438f97f0aeb8d = (_ref2)=>{
    let { showAetherAppListingPage: showAetherAppListingPage, tooltipMessage: tooltipMessage, installCountMessage: installCountMessage, showDownloadIcon: showDownloadIcon, isLoading: isLoading } = _ref2;
    if (installCountMessage == null) return null;
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bZbjp.InstallCountWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bZbjp.InstallCountLoader), {
        "data-testid": "install-count-loader"
    }));
    const InstallCountText = showAetherAppListingPage ? (0, $bZbjp.InstallCountTextV2) : (0, $bZbjp.InstallCountTextV1);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: tooltipMessage,
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bZbjp.InstallCountWrapper), null, showDownloadIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bZbjp.DownloadIcon), {
        label: installCountMessage,
        primaryColor: "var(--ds-icon-subtle, ".concat((0, $j0gMm.N500), ")"),
        size: showAetherAppListingPage ? 'medium' : 'small'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(InstallCountText, null, installCountMessage)));
};
var $da6c658928d2b927$export$2e2bcd8739ae039 = $da6c658928d2b927$export$626438f97f0aeb8d;

});
parcelRegister("bZbjp", function(module, exports) {

$parcel$export(module.exports, "InstallCountWrapper", () => $8b9e2a90b55de629$export$f329876cedabef0e);
$parcel$export(module.exports, "InstallCountTextV1", () => $8b9e2a90b55de629$export$9c80158bd602821a);
$parcel$export(module.exports, "InstallCountTextV2", () => $8b9e2a90b55de629$export$66b3865e75d9d5e5);
$parcel$export(module.exports, "DownloadIcon", () => $8b9e2a90b55de629$export$4e54df4252b4a99c);
$parcel$export(module.exports, "InstallCountLoader", () => $8b9e2a90b55de629$export$e10c0592dd92a5bc);
/* InstallCount.styles.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $kU09D = parcelRequire("kU09D");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1ZFzZ = parcelRequire("1ZFzZ");

var $ivTMz = parcelRequire("ivTMz");


var $cCrLo = parcelRequire("cCrLo");
const $8b9e2a90b55de629$var$_excluded = [
    "as",
    "style"
], $8b9e2a90b55de629$var$_excluded2 = [
    "as",
    "style"
], $8b9e2a90b55de629$var$_excluded3 = [
    "as",
    "style"
], $8b9e2a90b55de629$var$_excluded4 = [
    "as",
    "style"
], $8b9e2a90b55de629$var$_excluded5 = [
    "as",
    "style"
];
const $8b9e2a90b55de629$var$shimmer = (0, $ivTMz.skeletonShimmer)();
const $8b9e2a90b55de629$export$f329876cedabef0e = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "span", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $8b9e2a90b55de629$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _4cvr1h6o _syazjjyb _1n261q9c",
            __cmplp.className
        ])
    }));
});
const $8b9e2a90b55de629$export$8d3100b53fd67df2 = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "span", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $8b9e2a90b55de629$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _2hwx1b66 _12hn14w8",
            __cmplp.className
        ])
    }));
});
const $8b9e2a90b55de629$export$9c80158bd602821a = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = "span", style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $8b9e2a90b55de629$var$_excluded3);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _o5721q9c",
            __cmplp.className
        ])
    }));
});
const $8b9e2a90b55de629$export$66b3865e75d9d5e5 = (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodyNormal), style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $8b9e2a90b55de629$var$_excluded4);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _o5721q9c _19pkidpf",
            __cmplp.className
        ])
    }));
});
const $8b9e2a90b55de629$export$4e54df4252b4a99c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8b9e2a90b55de629$export$8d3100b53fd67df2, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1ZFzZ))), (0, $kU09D.default)({}, props, {
        label: "Download Icon"
    })));
};
const $8b9e2a90b55de629$export$e10c0592dd92a5bc = (0, $eUqFw.forwardRef)((_ref5, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref5, __cmplp = (0, $bwPfh.default)(_ref5, $8b9e2a90b55de629$var$_excluded5);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbcmky _4t3idlk8 _2rkoftgi _j7hq19hg _bfhk1mnh _5sag12o8 _tip812c5 _1pglp3kn _7hjf1yy8",
            __cmplp.className
        ])
    }));
});

});


parcelRegister("94W0i", function(module, exports) {

$parcel$export(module.exports, "AppName", () => $69c17b20eff48a93$export$e3fa2c64115299cc);
$parcel$export(module.exports, "HeaderContainer", () => $69c17b20eff48a93$export$1e86fd0e1db89578);
$parcel$export(module.exports, "IconContainer", () => $69c17b20eff48a93$export$8f314e512d92575f);
$parcel$export(module.exports, "AppDetailsContainer", () => $69c17b20eff48a93$export$66089487c21dd717);
$parcel$export(module.exports, "CompatibilitiesContainer", () => $69c17b20eff48a93$export$a3e5b8c63bd057f3);
$parcel$export(module.exports, "TrustSignalsContainer", () => $69c17b20eff48a93$export$4ce2a3945be9a02f);
$parcel$export(module.exports, "HeaderInjectionContainer", () => $69c17b20eff48a93$export$22d7f11e7dcd0a91);
$parcel$export(module.exports, "TrustSignalsRow", () => $69c17b20eff48a93$export$b0a56f686f741d77);
$parcel$export(module.exports, "RatingsContainer", () => $69c17b20eff48a93$export$508a6a934eaeeb30);
$parcel$export(module.exports, "InstallCountContainer", () => $69c17b20eff48a93$export$88744b1ccb2b55c9);
$parcel$export(module.exports, "CertificationContainer", () => $69c17b20eff48a93$export$d3fc906e2447136e);

var $jqNEH = parcelRequire("jqNEH");

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $62cXe = parcelRequire("62cXe");

var $8gcXz = parcelRequire("8gcXz");

var $kO6Ah = parcelRequire("kO6Ah");

var $1JvFV = parcelRequire("1JvFV");
var $69c17b20eff48a93$var$_templateObject;
function $69c17b20eff48a93$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $69c17b20eff48a93$export$e3fa2c64115299cc = (0, $3UXZ8.default)("h1", {
    target: "elk6fai0",
    label: "AppName"
})((0, $8gcXz.baseHeadingsCss), " font-size:20px;line-height:", (0, $62cXe.headingSizes).h100.lineHeight / (0, $62cXe.headingSizes).h100.size, ";margin:0 0 var(--ds-space-025, 2px);display:inline-block;");
const $69c17b20eff48a93$export$1e86fd0e1db89578 = (0, $3UXZ8.default)("div", {
    target: "elk6fai1",
    label: "HeaderContainer"
})("display:grid;font-size:14px;line-height:1.42857143;grid-gap:var(--ds-space-150, 12px);grid-template-columns:max-content 1fr;grid-template-areas:'icon app-details' 'trust-signals trust-signals' 'header-injection header-injection';margin-bottom:var(--ds-space-200, 16px);@media screen and (min-width:", (0, $1JvFV.APP_HEADER_MOBILE_BREAKPOINT), "px){line-height:var(--ds-space-300, 24px);grid-gap:0 var(--ds-space-300, 24px);grid-template-columns:max-content 1fr max-content;grid-template-areas:'icon app-details header-injection' 'icon trust-signals header-injection';margin-bottom:var(--ds-space-400, 32px);}", (props)=>props.bottomSeparator && "\n    padding-bottom: ".concat("var(--ds-space-150, 12px)", ";\n    border-bottom: 1px solid ", "var(--ds-border, ".concat((0, $j0gMm.N30), ")"), ";\n  "), "");
const $69c17b20eff48a93$export$8f314e512d92575f = (0, $3UXZ8.default)("div", {
    target: "elk6fai2",
    label: "IconContainer"
})({
    name: "374ojd",
    styles: "grid-area:icon;"
});
const $69c17b20eff48a93$export$66089487c21dd717 = (0, $3UXZ8.default)("div", {
    target: "elk6fai3",
    label: "AppDetailsContainer"
})({
    name: "107ws4u",
    styles: "grid-area:app-details;"
});
const $69c17b20eff48a93$export$a3e5b8c63bd057f3 = (0, $3UXZ8.default)("div", {
    target: "elk6fai4",
    label: "CompatibilitiesContainer"
})("display:none;color:", "var(--ds-text, ".concat((0, $j0gMm.N300), ")"), ";margin-bottom:var(--ds-space-050, 4px);", (0, $kO6Ah.mediaBreakpoints).smallUp($69c17b20eff48a93$var$_templateObject || ($69c17b20eff48a93$var$_templateObject = (0, $jqNEH.default)([
    "\n    display: block\n  "
]))), "");
const $69c17b20eff48a93$export$4ce2a3945be9a02f = (0, $3UXZ8.default)("div", {
    target: "elk6fai5",
    label: "TrustSignalsContainer"
})({
    name: "b0c1oy",
    styles: "grid-area:trust-signals;"
});
const $69c17b20eff48a93$export$22d7f11e7dcd0a91 = (0, $3UXZ8.default)("div", {
    target: "elk6fai6",
    label: "HeaderInjectionContainer"
})("grid-area:header-injection;@media screen and (min-width:", (0, $1JvFV.APP_HEADER_MOBILE_BREAKPOINT), "px){display:flex;flex-direction:column;justify-content:center;}");
const $69c17b20eff48a93$export$b0a56f686f741d77 = (0, $3UXZ8.default)("div", {
    target: "elk6fai7",
    label: "TrustSignalsRow"
})({
    name: "1tjvj5q",
    styles: "display:flex;grid-column-gap:var(--ds-space-200, 16px);flex-wrap:wrap;margin-bottom:var(--ds-space-050, 4px);"
});
const $69c17b20eff48a93$export$508a6a934eaeeb30 = (0, $3UXZ8.default)("div", {
    target: "elk6fai8",
    label: "RatingsContainer"
})("@media screen and (max-width:", (0, $1JvFV.APP_HEADER_MOBILE_BREAKPOINT) - 1, "px){order:2;}");
const $69c17b20eff48a93$export$88744b1ccb2b55c9 = (0, $3UXZ8.default)("div", {
    target: "elk6fai9",
    label: "InstallCountContainer"
})("@media screen and (max-width:", (0, $1JvFV.APP_HEADER_MOBILE_BREAKPOINT) - 1, "px){order:2;}");
const $69c17b20eff48a93$export$d3fc906e2447136e = (0, $3UXZ8.default)("div", {
    target: "elk6fai10",
    label: "CertificationContainer"
})("@media screen and (max-width:", (0, $1JvFV.APP_HEADER_MOBILE_BREAKPOINT) - 1, "px){order:1;width:100%;}");

});
parcelRegister("jqNEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e256f68f3295e6bf$export$2e2bcd8739ae039);
function $e256f68f3295e6bf$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("kO6Ah", function(module, exports) {

$parcel$export(module.exports, "gridBreakpoints", () => $f25d95a5735986e6$export$273d622ab270ee14);
$parcel$export(module.exports, "mediaBreakpoints", () => $f25d95a5735986e6$export$9a428948031ea39f);

var $ibjku = parcelRequire("ibjku");
const $f25d95a5735986e6$export$273d622ab270ee14 = Object.freeze({
    sm: 576,
    // max-width for mobiles/small devices
    md: 768,
    lg: 992
});
/**
 * This delta is to prevent two states co-existing on boundary condition.
 * for example: when screen width is of exact 768px, the small-only and medium-only
 * view would co-exist if they had same bounds.
 * therefore, to prevent we introduce 0.02px difference in them
 */ const $f25d95a5735986e6$var$delta = 0.02;
const $f25d95a5735986e6$var$getMediaQuery = (screenQuery)=>{
    return function(strings) {
        for(var _len = arguments.length, expressions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)expressions[_key - 1] = arguments[_key];
        return /*#__PURE__*/ (0, $ibjku.css)("@media (", screenQuery, "){", /*#__PURE__*/ (0, $ibjku.css)(strings, ...expressions), "}");
    };
};
const $f25d95a5735986e6$export$9a428948031ea39f = {
    smallUp: $f25d95a5735986e6$var$getMediaQuery("min-width: ".concat($f25d95a5735986e6$export$273d622ab270ee14.sm, "px")),
    smallDown: $f25d95a5735986e6$var$getMediaQuery("max-width: ".concat($f25d95a5735986e6$export$273d622ab270ee14.sm - $f25d95a5735986e6$var$delta, "px")),
    mediumUp: $f25d95a5735986e6$var$getMediaQuery("min-width: ".concat($f25d95a5735986e6$export$273d622ab270ee14.md, "px")),
    mediumDown: $f25d95a5735986e6$var$getMediaQuery("max-width: ".concat($f25d95a5735986e6$export$273d622ab270ee14.md - $f25d95a5735986e6$var$delta, "px")),
    mediumOnly: $f25d95a5735986e6$var$getMediaQuery("min-width: ".concat($f25d95a5735986e6$export$273d622ab270ee14.sm, "px) and (max-width: ").concat($f25d95a5735986e6$export$273d622ab270ee14.md - $f25d95a5735986e6$var$delta, "px")),
    largeUp: $f25d95a5735986e6$var$getMediaQuery("min-width: ".concat($f25d95a5735986e6$export$273d622ab270ee14.lg, "px")),
    largeDown: $f25d95a5735986e6$var$getMediaQuery("max-width: ".concat($f25d95a5735986e6$export$273d622ab270ee14.lg - $f25d95a5735986e6$var$delta, "px")),
    largeOnly: $f25d95a5735986e6$var$getMediaQuery("min-width: ".concat($f25d95a5735986e6$export$273d622ab270ee14.md, "px) and (max-width: ").concat($f25d95a5735986e6$export$273d622ab270ee14.lg - $f25d95a5735986e6$var$delta, "px"))
};

});

parcelRegister("1JvFV", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_RATINGS", () => $1432906e0def8423$export$59c88dd19625276f);
$parcel$export(module.exports, "APP_HEADER_MOBILE_BREAKPOINT", () => $1432906e0def8423$export$55ea70f9dd0a382c);

var $kO6Ah = parcelRequire("kO6Ah");
const $1432906e0def8423$export$1a92a405aaa81c31 = 'appHeader';
const $1432906e0def8423$export$59c88dd19625276f = 'ratings';
const $1432906e0def8423$export$55ea70f9dd0a382c = (0, $kO6Ah.gridBreakpoints).sm;

});


parcelRegister("lHuB6", function(module, exports) {

$parcel$export(module.exports, "showNewAppMessage", () => $fcc5591ec19d8770$export$3c3e3248d680e3a0);

var $d2wNG = parcelRequire("d2wNG");
const $fcc5591ec19d8770$export$3c3e3248d680e3a0 = (appHeaderDetails)=>{
    const { createdAt: createdAt, distribution: distribution, ratings: ratings } = appHeaderDetails;
    const { installationCount: installationCount, downloadCount: downloadCount, isPreinstalledInAnyHosting: isPreinstalledInAnyHosting, isPreinstalled: isPreinstalled } = distribution || {};
    const isNewApp = !!createdAt && (0, $d2wNG.default)(new Date(), createdAt) <= 30;
    return isNewApp && !isPreinstalled && !isPreinstalledInAnyHosting && !downloadCount && !installationCount && !ratings.numRatings;
};

});

parcelRegister("aFbzH", function(module, exports) {

$parcel$export(module.exports, "getAppIcon", () => $7c36b63fc0d9c5ec$export$68e78e52e6d2f064);
$parcel$export(module.exports, "default", () => $7c36b63fc0d9c5ec$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $8oBYp = parcelRequire("8oBYp");

var $c0qPT = parcelRequire("c0qPT");

var $eUqFw = parcelRequire("eUqFw");

var $8U0Ec = parcelRequire("8U0Ec");

var $8RTbO = parcelRequire("8RTbO");

var $1JvFV = parcelRequire("1JvFV");

var $7GLYA = parcelRequire("7GLYA");
const $7c36b63fc0d9c5ec$export$3c3e0c6096dd55ef = (0, $3UXZ8.default)("div", {
    target: "e17jj8wx0",
    label: "IconContainerV1"
})("width:", (props)=>props.size === 'large' ? '64px' : '48px', ";height:", (props)=>props.size === 'large' ? '64px' : '48px', ";@media (min-width:", (0, $1JvFV.APP_HEADER_MOBILE_BREAKPOINT), "px){width:", (props)=>props.size === 'large' ? '104px' : '48px', ";height:", (props)=>props.size === 'large' ? '104px' : '48px', ";}");
const $7c36b63fc0d9c5ec$export$427da3f28943b1da = (0, $3UXZ8.default)("div", {
    target: "e17jj8wx1",
    label: "IconContainerMPACV2"
})({
    width: '3.5rem',
    height: '3.5rem',
    [(0, $8oBYp.media).above.sm]: {
        width: '5.875rem',
        height: '5.875rem'
    }
}, "");
const $7c36b63fc0d9c5ec$export$444e98ac03abbe0 = (0, $3UXZ8.default)("div", {
    target: "e17jj8wx2",
    label: "IconContainerEMCEEV2"
})({
    width: '3.5rem',
    height: '3.5rem',
    [(0, $8oBYp.media).above.sm]: {
        width: '4rem',
        height: '4rem'
    }
}, "");
const $7c36b63fc0d9c5ec$export$68e78e52e6d2f064 = (origin, appKey, icon, appIconLink)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8RTbO.default), {
        uniqueKey: appKey,
        iconUrl: (0, $7GLYA.getIconUrl)({
            origin: origin,
            appKey: appKey,
            appIconLink: appIconLink
        }),
        fallbackIconUrl: (0, $7GLYA.getFallbackIconUrl)(origin, icon),
        iconType: (0, $7GLYA.getIconType)(origin)
    });
const $7c36b63fc0d9c5ec$export$a2795a58007caf5a = (_ref)=>{
    let { isMPAC: isMPAC, showAetherAppListingPage: showAetherAppListingPage } = _ref;
    if (showAetherAppListingPage) {
        if (isMPAC) return $7c36b63fc0d9c5ec$export$427da3f28943b1da;
        else return $7c36b63fc0d9c5ec$export$444e98ac03abbe0;
    }
    return $7c36b63fc0d9c5ec$export$3c3e0c6096dd55ef;
};
const $7c36b63fc0d9c5ec$var$HeaderAppIcon = (props)=>{
    const { appKey: appKey, origin: origin, appIconLink: appIconLink, icon: icon, size: size = 'large', showAetherAppListingPage: showAetherAppListingPage } = props;
    const source = (0, $c0qPT.useSource)();
    const isMPAC = source === 'MPAC';
    const IconContainer = $7c36b63fc0d9c5ec$export$a2795a58007caf5a({
        showAetherAppListingPage: showAetherAppListingPage,
        isMPAC: isMPAC
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IconContainer, {
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8U0Ec.default), null, $7c36b63fc0d9c5ec$export$68e78e52e6d2f064(origin, appKey, icon, appIconLink)));
};
var $7c36b63fc0d9c5ec$export$2e2bcd8739ae039 = $7c36b63fc0d9c5ec$var$HeaderAppIcon;

});
parcelRegister("c0qPT", function(module, exports) {

$parcel$export(module.exports, "ApplicationConfigProvider", () => $8bda4d319329cc81$export$573ea730061074fd);
$parcel$export(module.exports, "useApplicationConfig", () => $8bda4d319329cc81$export$8bb18d9f2fcfba06);
$parcel$export(module.exports, "useEnvironment", () => $8bda4d319329cc81$export$ea7ed2425832167d);
$parcel$export(module.exports, "useHostUrl", () => $8bda4d319329cc81$export$78cfd5a06734c78e);
$parcel$export(module.exports, "useSource", () => $8bda4d319329cc81$export$fe488720f15adbf8);
$parcel$export(module.exports, "useMountPath", () => $8bda4d319329cc81$export$4987786278697d67);

var $1fIAX = parcelRequire("1fIAX");

var $eUqFw = parcelRequire("eUqFw");
const $8bda4d319329cc81$var$ApplicationConfig = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $8bda4d319329cc81$export$573ea730061074fd = (_ref)=>{
    let { children: children, applicationConfig: applicationConfig } = _ref;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8bda4d319329cc81$var$ApplicationConfig.Provider, {
        value: applicationConfig
    }, children);
};
const $8bda4d319329cc81$export$8bb18d9f2fcfba06 = ()=>{
    return (0, $eUqFw.useContext)($8bda4d319329cc81$var$ApplicationConfig);
};
const $8bda4d319329cc81$export$ea7ed2425832167d = ()=>{
    const applicationConfig = $8bda4d319329cc81$export$8bb18d9f2fcfba06();
    const environment = applicationConfig === null || applicationConfig === void 0 ? void 0 : applicationConfig.environment;
    if (!environment) throw new Error('useEnvironment must be used within a ApplicationConfigProvider');
    return environment;
};
const $8bda4d319329cc81$export$3cc557c49a8fd7f0 = ()=>{
    const applicationConfig = $8bda4d319329cc81$export$8bb18d9f2fcfba06();
    const algoliaConfig = applicationConfig === null || applicationConfig === void 0 ? void 0 : applicationConfig.algoliaConfig;
    if (!algoliaConfig) throw new Error('useAlgoliaConfig must be used within a ApplicationConfigProvider');
    return algoliaConfig;
};
const $8bda4d319329cc81$export$78cfd5a06734c78e = ()=>{
    const applicationConfig = $8bda4d319329cc81$export$8bb18d9f2fcfba06();
    const hostUrl = applicationConfig === null || applicationConfig === void 0 ? void 0 : applicationConfig.hostUrl;
    if (!hostUrl) throw new Error('useHostUrl must be used within a ApplicationConfigProvider');
    return hostUrl;
};
const $8bda4d319329cc81$export$fe488720f15adbf8 = ()=>{
    const applicationConfig = $8bda4d319329cc81$export$8bb18d9f2fcfba06();
    const source = applicationConfig === null || applicationConfig === void 0 ? void 0 : applicationConfig.source;
    return source || (0, $1fIAX.Source).PRODUCT;
};
const $8bda4d319329cc81$export$4987786278697d67 = ()=>{
    const applicationConfig = $8bda4d319329cc81$export$8bb18d9f2fcfba06();
    const mountPath = applicationConfig === null || applicationConfig === void 0 ? void 0 : applicationConfig.mountPath;
    return mountPath || '';
};

});

parcelRegister("8RTbO", function(module, exports) {

$parcel$export(module.exports, "default", () => $674e157355a70f21$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $gC8Po = parcelRequire("gC8Po");

var $g5DHJ = parcelRequire("g5DHJ");

var $eUqFw = parcelRequire("eUqFw");
function $674e157355a70f21$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $674e157355a70f21$var$ICON_COLORS = [
    (0, $j0gMm.R300),
    (0, $j0gMm.Y300),
    (0, $j0gMm.G300),
    (0, $j0gMm.T300),
    (0, $j0gMm.P300)
];
const $674e157355a70f21$var$KEY_ICON = '<path d="M36.7340089,18.0415853 L38.6479513,16.1276428 L35.4580473,12.9377388 L37.3719897,11.0237963 C38.0766839,10.3191022 38.0766839,9.17656721 37.3719897,8.47187306 C36.6672956,7.76717891 35.5247606,7.76717891 34.8200664,8.47187306 L20.4654981,22.8264414 C17.4100825,21.0528024 13.5130975,21.8208178 11.3591119,24.6211223 C9.20512621,27.4214269 9.46257344,31.3850187 11.9607087,33.883154 C14.458844,36.3812893 18.4224359,36.6387366 21.2227404,34.4847509 C24.023045,32.3307652 24.7910604,28.4337803 23.0174214,25.3783647 L29.7082452,18.6875409 L32.2601684,21.2394641 L34.1741109,19.3255217 L31.6221876,16.7735984 L33.5361301,14.859656 L36.7340089,18.0415853 Z M16.9566036,32.0771632 C15.1948682,32.0771632 13.7666995,30.6489945 13.7666995,28.8872592 C13.7666995,27.1255238 15.1948682,25.6973551 16.9566036,25.6973551 C18.718339,25.6973551 20.1465077,27.1255238 20.1465077,28.8872592 C20.1465077,30.6489945 18.718339,32.0771632 16.9566036,32.0771632 Z" fill="#FFFFFF"></path>';
const $674e157355a70f21$var$APP_ICON = '<g transform="translate(5.000000, 5.000000)" fill="#FFFFFF">\n<path d="M8.06370103,9.68214963 L15.936299,5.02597189 C17.124057,4.32348301 18.879979,4.32587008 20.063701,5.02597189 L27.936299,9.68214963 C29.124057,10.3846385 30,11.9436186 30,13.3438223 L30,22.6561777 C30,24.0611555 29.120021,25.6177486 27.936299,26.3178504 L20.063701,30.9740281 C18.875943,31.676517 17.120021,31.6741299 15.936299,30.9740281 L8.06370103,26.3178504 C6.87594301,25.6153615 6,24.0563814 6,22.6561777 L6,13.3438223 C6,11.9388445 6.87997902,10.3822514 8.06370103,9.68214963 Z M18.5501172,7.71155875 C18.3016811,7.56462341 17.6997026,7.56380505 17.4498828,7.71155875 L9.57728483,12.3677365 C9.32884867,12.5146718 9.02716761,13.0483149 9.02716761,13.3438223 L9.02716761,22.6561777 C9.02716761,22.9500484 9.32746501,23.4845098 9.57728483,23.6322635 L17.4498828,28.2884412 C17.6983189,28.4353766 18.3002974,28.4361949 18.5501172,28.2884412 L26.4227152,23.6322635 C26.6711513,23.4853282 26.9728324,22.9516851 26.9728324,22.6561777 L26.9728324,13.3438223 C26.9728324,13.0499516 26.672535,12.5154902 26.4227152,12.3677365 L18.5501172,7.71155875 Z"></path>\n<path d="M18,24 C14.6862915,24 12,21.3137085 12,18 C12,14.6862915 14.6862915,12 18,12 C21.3137085,12 24,14.6862915 24,18 C24,21.3137085 21.3137085,24 18,24 Z M18,21 C19.6568542,21 21,19.6568542 21,18 C21,16.3431458 19.6568542,15 18,15 C16.3431458,15 15,16.3431458 15,18 C15,19.6568542 16.3431458,21 18,21 Z"></path>\n</g>';
const $674e157355a70f21$var$IconContainer = (0, $3UXZ8.default)("div", {
    target: "e1ow4rfu0",
    label: "IconContainer"
})({
    name: "b7jmoi",
    styles: "width:100%;height:100%;position:relative;"
});
const $674e157355a70f21$var$IconImg = (0, $3UXZ8.default)("img", {
    target: "e1ow4rfu1",
    label: "IconImg"
})({
    name: "mtxokv",
    styles: "width:auto;height:auto;max-width:100%;max-height:100%;margin:auto;position:absolute;top:0;left:0;bottom:0;right:0;"
});
class $674e157355a70f21$export$2e2bcd8739ae039 extends $eUqFw.PureComponent {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "state", {
            icon: null
        });
        (0, $5zQU9.default)(this, "handleError", (currentUrl)=>()=>{
                this.setState({
                    icon: this.props.fallbackIconUrl !== currentUrl ? this.props.fallbackIconUrl : this.generateDefaultIcon(this.props)
                });
            });
    }
    componentDidUpdate(prevProps) {
        if (!(this.props.uniqueKey === prevProps.uniqueKey && this.props.iconUrl === prevProps.iconUrl && this.props.fallbackIconUrl === prevProps.fallbackIconUrl && this.props.iconType === prevProps.iconType)) this.setState({
            icon: null
        });
    }
    generateDefaultIcon(props) {
        const innerEl = $674e157355a70f21$export$f89e53ba6fc8a5c5(this.props.iconType)((_)=>$674e157355a70f21$var$KEY_ICON, (_)=>$674e157355a70f21$var$APP_ICON);
        // Deterministically generate a color from the unique key
        const color = (0, $g5DHJ.List)(props.uniqueKey.split('')).reduce((acc, c)=>(acc + c.charCodeAt(0)) % $674e157355a70f21$var$ICON_COLORS.length, 0);
        const result = '<?xml version="1.0" encoding="UTF-8"?>\n<svg width="46px" height="46px" viewBox="0 0 46 46" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n<rect fill="' + $674e157355a70f21$var$ICON_COLORS[color] + '" x="0" y="0" width="46" height="46" rx="3"></rect>\n' + innerEl + '</svg>';
        return 'data:image/svg+xml;base64,' + window.btoa(result);
    }
    render() {
        const iconUrl = this.state.icon || this.props.iconUrl || this.props.fallbackIconUrl || this.generateDefaultIcon(this.props);
        return /*#__PURE__*/ $eUqFw.createElement($674e157355a70f21$var$IconContainer, null, /*#__PURE__*/ $eUqFw.createElement($674e157355a70f21$var$IconImg, {
            alt: "",
            draggable: false,
            onError: this.handleError(iconUrl),
            src: iconUrl
        }));
    }
}
const $674e157355a70f21$export$f89e53ba6fc8a5c5 = (a)=>(key, app)=>{
        switch(a){
            case 'key':
                return key();
            case 'app':
                return app();
            default:
                throw (0, $gC8Po.default).unexpectedCase(a);
        }
    };

});

parcelRegister("7GLYA", function(module, exports) {

$parcel$export(module.exports, "getIconUrl", () => $5991abbeb1b19d28$export$89d1c740383224f4);
$parcel$export(module.exports, "getFallbackIconUrl", () => $5991abbeb1b19d28$export$4170fc8c398d9d2c);
$parcel$export(module.exports, "getIconType", () => $5991abbeb1b19d28$export$6fa311f7baf2e348);
const $5991abbeb1b19d28$export$89d1c740383224f4 = (_ref)=>{
    let { origin: origin, appKey: appKey, appIconLink: appIconLink } = _ref;
    if (origin === 'token') return null;
    return appIconLink.expand({
        appKey: appKey
    });
};
const $5991abbeb1b19d28$export$4170fc8c398d9d2c = (origin, icon)=>origin === 'token' ? null : icon;
const $5991abbeb1b19d28$export$6fa311f7baf2e348 = (origin)=>origin === 'token' ? 'key' : 'app';

});


parcelRegister("j7LzR", function(module, exports) {

$parcel$export(module.exports, "default", () => $dec393a580e7f403$export$2e2bcd8739ae039);

var $gwoWU = parcelRequire("gwoWU");

var $inwKI = parcelRequire("inwKI");

var $ammkg = parcelRequire("ammkg");

var $eUqFw = parcelRequire("eUqFw");

var $5YcrV = parcelRequire("5YcrV");

var $3ihpf = parcelRequire("3ihpf");
/**
 * Renders either the "Cloud Fortified" or "Cloud Security Participant" badge,
 * whichever is applicable, with preference to the former when both are applicable.
 */ const $dec393a580e7f403$var$HeaderCertificationBadge = (props)=>{
    const { enableCloudFortifiedAppsDiscovery: enableCloudFortifiedAppsDiscovery } = (0, $inwKI.useFeatureFlags)();
    if (enableCloudFortifiedAppsDiscovery && props.isAppCloudFortified) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5YcrV.default), {
        showLabel: true,
        source: (0, $5YcrV.CloudFortifiedAppBadgeSources).AppListing,
        showAetherAppListingPage: props.showAetherAppListingPage
    });
    if ((0, $gwoWU.isBugBountyParticipant)((0, $ammkg.AtlassianProductHostingType).Cloud, props.bugBountyParticipant)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ihpf.default), {
        showLabel: true,
        showAetherAppListingPage: props.showAetherAppListingPage
    });
    return null;
};
var $dec393a580e7f403$export$2e2bcd8739ae039 = $dec393a580e7f403$var$HeaderCertificationBadge;

});

parcelRegister("fm8vZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2df83f853b691f7$export$2e2bcd8739ae039);

var $ffiyv = parcelRequire("ffiyv");

var $eUqFw = parcelRequire("eUqFw");

var $4lmb9 = parcelRequire("4lmb9");

var $7BUhe = parcelRequire("7BUhe");

var $6B6gX = parcelRequire("6B6gX");
const $b2df83f853b691f7$export$135bdaed9fa67b45 = (_ref)=>{
    let { lozenge: lozenge } = _ref;
    const { label: label, isBold: isBold = false, appearance: appearance = 'default', tooltipContent: tooltipContent = null } = lozenge;
    const lozengeContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: appearance,
        isBold: isBold
    }, label);
    if (tooltipContent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", {
        key: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4lmb9.default), {
        content: tooltipContent
    }, lozengeContent));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", {
        key: label
    }, lozengeContent);
};
const $b2df83f853b691f7$var$HeaderLozenges = (_ref2)=>{
    let { lozenges: lozenges } = _ref2;
    if (!lozenges.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6B6gX.LozengeList), {
        "data-testid": (0, $7BUhe.TEST_IDS).APP_HEADER_LOZENGES
    }, lozenges.map((lozenge)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b2df83f853b691f7$export$135bdaed9fa67b45, {
            key: lozenge.label,
            lozenge: lozenge
        })));
};
var $b2df83f853b691f7$export$2e2bcd8739ae039 = $b2df83f853b691f7$var$HeaderLozenges;

});
parcelRegister("6B6gX", function(module, exports) {

$parcel$export(module.exports, "LozengeList", () => $4cdb105806814b10$export$949aeb67ba4cfcde);

var $3UXZ8 = parcelRequire("3UXZ8");
function $4cdb105806814b10$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4cdb105806814b10$export$949aeb67ba4cfcde = (0, $3UXZ8.default)("ul", {
    target: "e1ck3slc0",
    label: "LozengeList"
})({
    name: "1jukx08",
    styles: "list-style:none;margin:0;padding:0;display:flex;align-items:center;justify-content:start;flex-wrap:wrap;li{margin:0 var(--ds-space-100, 8px) var(--ds-space-050, 4px) 0;}li:last-of-type{margin-right:0;}"
});

});


parcelRegister("fmcsZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2e294b495c93414$export$2e2bcd8739ae039);

var $d4qUE = parcelRequire("d4qUE");

var $FHhXl = parcelRequire("FHhXl");

var $KC0XU = parcelRequire("KC0XU");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $j0vr1 = parcelRequire("j0vr1");

var $c9Mth = parcelRequire("c9Mth");
var $g01ln = parcelRequire("g01ln");

var $eUqFw = parcelRequire("eUqFw");

var $dM9ZW = parcelRequire("dM9ZW");

var $1JvFV = parcelRequire("1JvFV");
const $b2e294b495c93414$var$pressableStyles = (0, $d4qUE.xcss)({
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    },
    borderRadius: 'border.radius.100',
    paddingLeft: 'space.0',
    paddingRight: 'space.0'
});
const $b2e294b495c93414$var$HeaderRatings = (props)=>{
    const history = (0, $dM9ZW.useHistory)();
    const { appRatingLink: appRatingLink, openMarketplaceLinksInNewTab: openMarketplaceLinksInNewTab, appKey: appKey, ratings: ratings, showAetherAppListingPage: showAetherAppListingPage } = props;
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const onRatingsClick = ()=>{
        fireAnalyticsEvent({
            eventType: (0, $gaiog.LinkClickedEvent),
            actionSubjectId: (0, $1JvFV.ANALYTICS_SUBJECT_ID_RATINGS)
        });
        if (openMarketplaceLinksInNewTab) {
            const appReviewsUrl = appRatingLink.expand({
                appKey: appKey
            });
            (0, $g01ln).openPage(appReviewsUrl, '_blank');
        } else history === null || history === void 0 || history.push((0, $c9Mth).updateQueryParam(window.location.href, 'tab', 'reviews'));
    };
    if (showAetherAppListingPage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $FHhXl.default), {
        xcss: $b2e294b495c93414$var$pressableStyles,
        backgroundColor: "color.background.neutral.subtle",
        onClick: onRatingsClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j0vr1.Ratings), {
        ratings: ratings,
        testId: "app-header-ratings",
        showNoRatingsMessage: true,
        boldAverageStars: true
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $KC0XU.default), {
        ratings: ratings,
        onClick: ratings.numRatings ? onRatingsClick : undefined
    });
};
var $b2e294b495c93414$export$2e2bcd8739ae039 = $b2e294b495c93414$var$HeaderRatings;

});
parcelRegister("d4qUE", function(module, exports) {

$parcel$export(module.exports, "parseXcss", () => $9840866a5e434d98$export$a9c84988c8f81f2d);
$parcel$export(module.exports, "xcss", () => $9840866a5e434d98$export$f6c783d06584602c);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $byn9U = parcelRequire("byn9U");

var $g35uP = parcelRequire("g35uP");

var $2fFJv = parcelRequire("2fFJv");
const $9840866a5e434d98$export$9a199fbafee0014e = {
    backgroundColor: (0, $g35uP.backgroundColorMap),
    blockSize: (0, $g35uP.dimensionMap),
    borderBlockColor: (0, $g35uP.borderColorMap),
    borderBlockEndColor: (0, $g35uP.borderColorMap),
    borderBlockEndWidth: (0, $g35uP.borderWidthMap),
    borderBlockStartColor: (0, $g35uP.borderColorMap),
    borderBlockStartWidth: (0, $g35uP.borderWidthMap),
    borderBlockWidth: (0, $g35uP.borderWidthMap),
    borderBottomColor: (0, $g35uP.borderColorMap),
    borderBottomLeftRadius: (0, $g35uP.borderRadiusMap),
    borderBottomRightRadius: (0, $g35uP.borderRadiusMap),
    borderBottomWidth: (0, $g35uP.borderWidthMap),
    borderColor: (0, $g35uP.borderColorMap),
    borderEndEndRadius: (0, $g35uP.borderRadiusMap),
    borderEndStartRadius: (0, $g35uP.borderRadiusMap),
    borderInlineColor: (0, $g35uP.borderColorMap),
    borderInlineEndColor: (0, $g35uP.borderColorMap),
    borderInlineEndWidth: (0, $g35uP.borderWidthMap),
    borderInlineStartColor: (0, $g35uP.borderColorMap),
    borderInlineStartWidth: (0, $g35uP.borderWidthMap),
    borderInlineWidth: (0, $g35uP.borderWidthMap),
    borderLeftColor: (0, $g35uP.borderColorMap),
    borderLeftWidth: (0, $g35uP.borderWidthMap),
    borderRadius: (0, $g35uP.borderRadiusMap),
    borderRightColor: (0, $g35uP.borderColorMap),
    borderRightWidth: (0, $g35uP.borderWidthMap),
    borderStartEndRadius: (0, $g35uP.borderRadiusMap),
    borderStartStartRadius: (0, $g35uP.borderRadiusMap),
    borderTopColor: (0, $g35uP.borderColorMap),
    borderTopLeftRadius: (0, $g35uP.borderRadiusMap),
    borderTopRightRadius: (0, $g35uP.borderRadiusMap),
    borderTopWidth: (0, $g35uP.borderWidthMap),
    borderWidth: (0, $g35uP.borderWidthMap),
    bottom: (0, $g35uP.allSpaceMap),
    boxShadow: (0, $g35uP.shadowMap),
    color: (0, $g35uP.textColorMap),
    columnGap: (0, $g35uP.positiveSpaceMap),
    gap: (0, $g35uP.positiveSpaceMap),
    height: (0, $g35uP.dimensionMap),
    inlineSize: (0, $g35uP.dimensionMap),
    inset: (0, $g35uP.allSpaceMap),
    insetBlock: (0, $g35uP.allSpaceMap),
    insetBlockEnd: (0, $g35uP.allSpaceMap),
    insetBlockStart: (0, $g35uP.allSpaceMap),
    insetInline: (0, $g35uP.allSpaceMap),
    insetInlineEnd: (0, $g35uP.allSpaceMap),
    insetInlineStart: (0, $g35uP.allSpaceMap),
    left: (0, $g35uP.allSpaceMap),
    margin: (0, $g35uP.allSpaceMap),
    marginBlock: (0, $g35uP.allSpaceMap),
    marginBlockEnd: (0, $g35uP.allSpaceMap),
    marginBlockStart: (0, $g35uP.allSpaceMap),
    marginBottom: (0, $g35uP.allSpaceMap),
    marginInline: (0, $g35uP.allSpaceMap),
    marginInlineEnd: (0, $g35uP.allSpaceMap),
    marginInlineStart: (0, $g35uP.allSpaceMap),
    marginLeft: (0, $g35uP.allSpaceMap),
    marginRight: (0, $g35uP.allSpaceMap),
    marginTop: (0, $g35uP.allSpaceMap),
    maxBlockSize: (0, $g35uP.dimensionMap),
    maxHeight: (0, $g35uP.dimensionMap),
    maxInlineSize: (0, $g35uP.dimensionMap),
    maxWidth: (0, $g35uP.dimensionMap),
    minBlockSize: (0, $g35uP.dimensionMap),
    minHeight: (0, $g35uP.dimensionMap),
    minInlineSize: (0, $g35uP.dimensionMap),
    minWidth: (0, $g35uP.dimensionMap),
    opacity: (0, $g35uP.opacityMap),
    outlineColor: (0, $g35uP.borderColorMap),
    outlineOffset: (0, $g35uP.positiveSpaceMap),
    outlineWidth: (0, $g35uP.borderWidthMap),
    padding: (0, $g35uP.positiveSpaceMap),
    paddingBlock: (0, $g35uP.positiveSpaceMap),
    paddingBlockEnd: (0, $g35uP.positiveSpaceMap),
    paddingBlockStart: (0, $g35uP.positiveSpaceMap),
    paddingBottom: (0, $g35uP.positiveSpaceMap),
    paddingInline: (0, $g35uP.positiveSpaceMap),
    paddingInlineEnd: (0, $g35uP.positiveSpaceMap),
    paddingInlineStart: (0, $g35uP.positiveSpaceMap),
    paddingLeft: (0, $g35uP.positiveSpaceMap),
    paddingRight: (0, $g35uP.positiveSpaceMap),
    paddingTop: (0, $g35uP.positiveSpaceMap),
    right: (0, $g35uP.allSpaceMap),
    rowGap: (0, $g35uP.positiveSpaceMap),
    top: (0, $g35uP.allSpaceMap),
    width: (0, $g35uP.dimensionMap),
    zIndex: (0, $g35uP.layerMap)
};
const $9840866a5e434d98$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
const $9840866a5e434d98$var$isSafeEnvToThrow = ()=>typeof $2fFJv === 'object' && typeof $2fFJv.env === 'object' && false;
const $9840866a5e434d98$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
const $9840866a5e434d98$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
const $9840866a5e434d98$var$transformStyles = (styleObj)=>{
    if (!styleObj || typeof styleObj !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($9840866a5e434d98$var$transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(([key, value])=>{
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if (typeof value === 'object' && $9840866a5e434d98$var$safeSelectors.test(key)) {
            styleObj[key] = $9840866a5e434d98$var$transformStyles(value);
            return;
        }
        if ($9840866a5e434d98$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($9840866a5e434d98$var$reNestedSelectors.test(key)) throw new Error(`Styles not supported for key '${key}'.`);
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $9840866a5e434d98$export$9a199fbafee0014e)) return;
        const tokenValue = $9840866a5e434d98$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
const $9840866a5e434d98$var$baseXcss = (style)=>{
    const transformedStyles = $9840866a5e434d98$var$transformStyles(style);
    return {
        [$9840866a5e434d98$var$uniqueSymbol]: (0, $byn9U.css)(transformedStyles)
    };
};
const $9840866a5e434d98$export$a9c84988c8f81f2d = (args)=>{
    if (Array.isArray(args)) return args.map((x)=>x && $9840866a5e434d98$export$a9c84988c8f81f2d(x)).filter(Boolean);
    const { [$9840866a5e434d98$var$uniqueSymbol]: styles } = args;
    typeof $2fFJv;
    return styles;
};
function $9840866a5e434d98$export$f6c783d06584602c(style) {
    return $9840866a5e434d98$var$baseXcss(style);
}

});
parcelRegister("g35uP", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", () => $baf130922324c09a$export$6ccdbebca2ee545f);
$parcel$export(module.exports, "positiveSpaceMap", () => $baf130922324c09a$export$958d0ae7f2977ae4);
$parcel$export(module.exports, "allSpaceMap", () => $baf130922324c09a$export$632685d741f3dbbf);
$parcel$export(module.exports, "inverseColorMap", () => $baf130922324c09a$export$2185ce37f9bdd963);
$parcel$export(module.exports, "opacityMap", () => $baf130922324c09a$export$daf94a976c798b4f);
$parcel$export(module.exports, "shadowMap", () => $baf130922324c09a$export$7aff6e7ba39bb774);
$parcel$export(module.exports, "borderColorMap", () => $baf130922324c09a$export$1531ad5bb3fbedac);
$parcel$export(module.exports, "backgroundColorMap", () => $baf130922324c09a$export$d1d79bf68ac056bd);
$parcel$export(module.exports, "textColorMap", () => $baf130922324c09a$export$8473307aa00d6ea1);
$parcel$export(module.exports, "layerMap", () => $baf130922324c09a$export$b5f31a7e431d2eab);
$parcel$export(module.exports, "borderWidthMap", () => $baf130922324c09a$export$e1b83c5210c471b8);
$parcel$export(module.exports, "borderRadiusMap", () => $baf130922324c09a$export$3c0a6c3e64bb180d);
$parcel$export(module.exports, "paddingStylesMap", () => $baf130922324c09a$export$e615f061ca585a6c);
$parcel$export(module.exports, "spaceStylesMap", () => $baf130922324c09a$export$bf46c3f9eeafc71f);
$parcel$export(module.exports, "backgroundColorStylesMap", () => $baf130922324c09a$export$e7af83bafe7f9e63);
$parcel$export(module.exports, "textColorStylesMap", () => $baf130922324c09a$export$3a1bcba60b23d7f0);
$parcel$export(module.exports, "fontWeightStylesMap", () => $baf130922324c09a$export$45f3f4fe16f9f7d5);
$parcel$export(module.exports, "bodyTextStylesMap", () => $baf130922324c09a$export$a1962444bbf058e);
$parcel$export(module.exports, "uiTextStylesMap", () => $baf130922324c09a$export$ca3e246f24657bd6);
$parcel$export(module.exports, "surfaceColorStylesMap", () => $baf130922324c09a$export$ff257d957d48c421);
$parcel$export(module.exports, "isSurfaceColorToken", () => $baf130922324c09a$export$5e65a44e5b6ecadb);

var $byn9U = parcelRequire("byn9U");

var $axYky = parcelRequire("axYky");
const $baf130922324c09a$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
const $baf130922324c09a$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
const $baf130922324c09a$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
const $baf130922324c09a$export$632685d741f3dbbf = {
    ...$baf130922324c09a$export$958d0ae7f2977ae4,
    ...$baf130922324c09a$export$d2dc61f58390201c
};
const $baf130922324c09a$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
const $baf130922324c09a$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
const $baf130922324c09a$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
const $baf130922324c09a$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
const $baf130922324c09a$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
const $baf130922324c09a$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
const $baf130922324c09a$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)"
};
const $baf130922324c09a$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
const $baf130922324c09a$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
const $baf130922324c09a$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
const $baf130922324c09a$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
const $baf130922324c09a$export$6cc560b4dedf3816 = {
    'font.size.050': "var(--ds-font-size-050, 11px)",
    'font.size.075': "var(--ds-font-size-075, 12px)",
    'font.size.100': "var(--ds-font-size-100, 14px)",
    'font.size.200': "var(--ds-font-size-200, 16px)",
    'font.size.300': "var(--ds-font-size-300, 20px)",
    'font.size.400': "var(--ds-font-size-400, 24px)",
    'font.size.500': "var(--ds-font-size-500, 29px)",
    'font.size.600': "var(--ds-font-size-600, 35px)"
};
const $baf130922324c09a$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
const $baf130922324c09a$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand': "var(--ds-font-family-brand, Charlie Sans)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.monospace': "var(--ds-font-family-monospace, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.sans': "var(--ds-font-family-sans, -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif)"
};
const $baf130922324c09a$export$360c29a380c1a34 = {
    'font.lineHeight.1': "var(--ds-font-lineHeight-1, 1)",
    'font.lineHeight.100': "var(--ds-font-lineHeight-100, 16px)",
    'font.lineHeight.200': "var(--ds-font-lineHeight-200, 20px)",
    'font.lineHeight.300': "var(--ds-font-lineHeight-300, 24px)",
    'font.lineHeight.400': "var(--ds-font-lineHeight-400, 28px)",
    'font.lineHeight.500': "var(--ds-font-lineHeight-500, 32px)",
    'font.lineHeight.600': "var(--ds-font-lineHeight-600, 40px)"
};
const $baf130922324c09a$export$b5bac06d7d8fd0d1 = {
    body: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $baf130922324c09a$export$b27166c9cf2c9f74 = {
    ui: "var(--ds-font-ui, normal 500 14px/1 ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'ui.small': "var(--ds-font-ui-small, normal 400 11px/1 ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
const $baf130922324c09a$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
const $baf130922324c09a$var$getSerializedStylesMap = (cssProperty, tokenMap)=>{
    return Object.keys(tokenMap).reduce((emotionSpacingMap, token)=>{
        emotionSpacingMap[token] = (0, $byn9U.css)({
            [cssProperty]: tokenMap[token]
        });
        return emotionSpacingMap;
    }, {});
};
const $baf130922324c09a$export$e615f061ca585a6c = $baf130922324c09a$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $baf130922324c09a$var$getSerializedStylesMap(spacingProperty, $baf130922324c09a$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $baf130922324c09a$export$bf46c3f9eeafc71f = $baf130922324c09a$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $baf130922324c09a$var$getSerializedStylesMap(spacingProperty, $baf130922324c09a$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $baf130922324c09a$export$e7af83bafe7f9e63 = $baf130922324c09a$var$getSerializedStylesMap('backgroundColor', $baf130922324c09a$export$d1d79bf68ac056bd);
const $baf130922324c09a$export$3a1bcba60b23d7f0 = $baf130922324c09a$var$getSerializedStylesMap('color', $baf130922324c09a$export$8473307aa00d6ea1);
const $baf130922324c09a$export$f7183c9e2dbc2543 = $baf130922324c09a$var$getSerializedStylesMap('fontSize', $baf130922324c09a$export$6cc560b4dedf3816);
const $baf130922324c09a$export$45f3f4fe16f9f7d5 = $baf130922324c09a$var$getSerializedStylesMap('fontWeight', $baf130922324c09a$export$303e322c6b1ed114);
const $baf130922324c09a$export$68cc305da27dbaa4 = $baf130922324c09a$var$getSerializedStylesMap('fontFamily', $baf130922324c09a$export$3c7e9587132614b4);
const $baf130922324c09a$export$8be4a21014f48eb1 = $baf130922324c09a$var$getSerializedStylesMap('lineHeight', $baf130922324c09a$export$360c29a380c1a34);
const $baf130922324c09a$export$a1962444bbf058e = $baf130922324c09a$var$getSerializedStylesMap('font', $baf130922324c09a$export$b5bac06d7d8fd0d1);
const $baf130922324c09a$export$ca3e246f24657bd6 = $baf130922324c09a$var$getSerializedStylesMap('font', $baf130922324c09a$export$b27166c9cf2c9f74);
const $baf130922324c09a$export$ff257d957d48c421 = $baf130922324c09a$var$getSerializedStylesMap((0, $axYky.CURRENT_SURFACE_CSS_VAR), $baf130922324c09a$export$41a358c9c2356760);
const $baf130922324c09a$export$5e65a44e5b6ecadb = (color)=>$baf130922324c09a$export$41a358c9c2356760[color] !== undefined;

});


parcelRegister("FHhXl", function(module, exports) {

$parcel$export(module.exports, "default", () => $07d568aac57b1030$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $d4qUE = parcelRequire("d4qUE");

var $379fO = parcelRequire("379fO");
// TODO: Duplicated FocusRing styles due to lack of `xcss` support
// and to prevent additional dependency
const $07d568aac57b1030$var$baseFocusRingStyles = {
    outlineColor: 'color.border.focused',
    outlineWidth: 'border.width.outline',
    outlineStyle: 'solid',
    outlineOffset: 'space.025'
};
const $07d568aac57b1030$var$focusRingStyles = (0, $d4qUE.xcss)({
    ':focus-visible': $07d568aac57b1030$var$baseFocusRingStyles,
    '@supports not selector(*:focus-visible)': {
        ':focus': $07d568aac57b1030$var$baseFocusRingStyles
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        ':focus-visible': {
            outline: '1px solid'
        }
    }
});
/**
 * __UNSAFE_PRESSABLE__
 *
 * @internal Still under development. Do not use.
 *
 * A Pressable is a primitive component that renders a `<button>`.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ const $07d568aac57b1030$var$UNSAFE_PRESSABLE = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, isDisabled: isDisabled, type: type = 'button', testId: testId, xcss: xcssStyles, ...htmlAttributes }, ref)=>{
    // Combine default styles with supplied styles. XCSS does not support deep nested arrays
    let styles = [
        (0, $d4qUE.xcss)({
            cursor: isDisabled ? 'not-allowed' : 'pointer'
        }),
        $07d568aac57b1030$var$focusRingStyles
    ];
    styles = Array.isArray(xcssStyles) ? [
        ...styles,
        ...xcssStyles
    ] : [
        ...styles,
        xcssStyles
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $379fO.default), (0, $kU09D.default)({}, htmlAttributes, {
        as: "button",
        ref: ref,
        testId: testId,
        type: type,
        backgroundColor: backgroundColor,
        padding: padding,
        paddingBlock: paddingBlock,
        paddingBlockStart: paddingBlockStart,
        paddingBlockEnd: paddingBlockEnd,
        paddingInline: paddingInline,
        paddingInlineStart: paddingInlineStart,
        paddingInlineEnd: paddingInlineEnd,
        xcss: styles,
        disabled: isDisabled
    }), children);
});
var $07d568aac57b1030$export$2e2bcd8739ae039 = $07d568aac57b1030$var$UNSAFE_PRESSABLE;

});
parcelRegister("379fO", function(module, exports) {

$parcel$export(module.exports, "default", () => $2449343452db694b$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $g35uP = parcelRequire("g35uP");

var $d4qUE = parcelRequire("d4qUE");

var $YfW8q = parcelRequire("YfW8q");
const $2449343452db694b$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: as = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const Component = as;
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const className = xcss && (0, $d4qUE.parseXcss)(xcss);
    const node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $byn9U.jsx)(Component, (0, $kU09D.default)({
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        css: [
            $2449343452db694b$var$baseStyles,
            backgroundColor && (0, $g35uP.backgroundColorStylesMap)[backgroundColor],
            (0, $g35uP.isSurfaceColorToken)(backgroundColor) && (0, $g35uP.surfaceColorStylesMap)[backgroundColor],
            padding && (0, $g35uP.paddingStylesMap).padding[padding],
            paddingBlock && (0, $g35uP.paddingStylesMap).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $g35uP.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $g35uP.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $g35uP.paddingStylesMap).paddingInline[paddingInline],
            paddingInlineStart && (0, $g35uP.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $g35uP.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            className
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $byn9U.jsx)((0, $YfW8q.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $2449343452db694b$export$2e2bcd8739ae039 = $2449343452db694b$export$e71c4d32a2263218;
const $2449343452db694b$var$baseStyles = (0, $byn9U.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

});
parcelRegister("YfW8q", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", () => $0b51f76679a8e589$export$1ca2a26fecb070ae);
$parcel$export(module.exports, "useSurface", () => $0b51f76679a8e589$export$1aeb4f6b93c4540d);

var $eUqFw = parcelRequire("eUqFw");
const $0b51f76679a8e589$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $eUqFw.createContext)('elevation.surface');
const $0b51f76679a8e589$export$1aeb4f6b93c4540d = ()=>{
    return (0, $eUqFw.useContext)($0b51f76679a8e589$export$1ca2a26fecb070ae);
};
$0b51f76679a8e589$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});



parcelRegister("j0vr1", function(module, exports) {

$parcel$export(module.exports, "Ratings", () => $dd6666b6da9b622a$export$63624e0823f82b87);

var $hlWtt = parcelRequire("hlWtt");

var $eUqFw = parcelRequire("eUqFw");

var $eFxr4 = parcelRequire("eFxr4");

var $7XETd = parcelRequire("7XETd");

var $dtVo5 = parcelRequire("dtVo5");

var $6AmUQ = parcelRequire("6AmUQ");
const $dd6666b6da9b622a$var$NumericRating = (_ref)=>{
    let { avgStars: avgStars, boldAverageStars: boldAverageStars } = _ref;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7XETd.NumericRatingStyled), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7XETd.AverageStars), {
        isBold: boldAverageStars
    }, avgStars), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7XETd.TotalStars), null, "/", (0, $eFxr4.TOTAL_STARS)));
};
const $dd6666b6da9b622a$var$StarRating = (_ref2)=>{
    let { ratings: ratings, size: size = 'medium' } = _ref2;
    const stars = (0, $dtVo5.getStarVariations)(ratings);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6AmUQ.StarGradients), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7XETd.StarRatingStyled), null, stars.map((variation, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7XETd.StarIconContainer), {
            key: index,
            "data-testid": "star-rating-".concat(variation),
            variation: variation,
            size: size
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hlWtt))), {
            label: "Star rating",
            size: size
        })))));
};
const $dd6666b6da9b622a$var$RatingsCount = (_ref3)=>{
    let { numRatings: numRatings } = _ref3;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7XETd.RatingsCountStyled), null, "(", numRatings, ")");
};
const $dd6666b6da9b622a$export$a981e6ce19d71083 = (_ref4)=>{
    let { testId: testId, size: size = 'medium' } = _ref4;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7XETd.NoRatingContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7XETd.StarIconContainer), {
        "data-testid": testId,
        variation: (0, $eFxr4.EMPTY_STAR),
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hlWtt))), {
        label: "No star rating yet",
        size: size
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7XETd.NoRatingText), null, "No reviews yet"));
};
const $dd6666b6da9b622a$export$63624e0823f82b87 = (_ref5)=>{
    let { testId: testId, ratings: ratings, size: size, showNumberRatings: showNumberRatings = true, showNoRatingsMessage: showNoRatingsMessage = false, boldAverageStars: boldAverageStars = false } = _ref5;
    const { avgStars: avgStars, numRatings: numRatings } = ratings;
    const roundRating = (0, $dtVo5.roundRatingToOneDecimal)(avgStars || 0);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "img",
        "data-testid": testId,
        "aria-label": "Rating of ".concat(roundRating, " out of ").concat((0, $eFxr4.TOTAL_STARS), " stars based on ").concat(numRatings, " reviews")
    }, showNoRatingsMessage && !numRatings ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dd6666b6da9b622a$export$a981e6ce19d71083, {
        testId: testId,
        size: size
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7XETd.RatingsContainer), {
        "aria-hidden": "true"
    }, showNumberRatings && !!numRatings && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dd6666b6da9b622a$var$NumericRating, {
        boldAverageStars: boldAverageStars,
        avgStars: roundRating
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dd6666b6da9b622a$var$StarRating, {
        ratings: ratings,
        size: size
    }), showNumberRatings && !!numRatings && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dd6666b6da9b622a$var$RatingsCount, {
        numRatings: numRatings
    })));
};

});
parcelRegister("eFxr4", function(module, exports) {

$parcel$export(module.exports, "TOTAL_STARS", () => $aaded4aaceb5dbb0$export$8cb47a0365023893);
$parcel$export(module.exports, "FULL_STAR", () => $aaded4aaceb5dbb0$export$cddb236a3f07ccae);
$parcel$export(module.exports, "EMPTY_STAR", () => $aaded4aaceb5dbb0$export$3fe9f96ae4e9046);
$parcel$export(module.exports, "QUARTER_STAR", () => $aaded4aaceb5dbb0$export$5ba14a4123b4d7e7);
$parcel$export(module.exports, "HALF_STAR", () => $aaded4aaceb5dbb0$export$c0557090bfd42e78);
$parcel$export(module.exports, "THREE_QUARTER_STAR", () => $aaded4aaceb5dbb0$export$a908142c7b579a36);
$parcel$export(module.exports, "NO_RATING_STAR", () => $aaded4aaceb5dbb0$export$d02fa2cb21ed23bd);
$parcel$export(module.exports, "STAR_FILL_MAP", () => $aaded4aaceb5dbb0$export$fe8acbce00b8388b);

var $j0gMm = parcelRequire("j0gMm");
const $aaded4aaceb5dbb0$export$8cb47a0365023893 = 4;
const $aaded4aaceb5dbb0$export$cddb236a3f07ccae = 'fullStar';
const $aaded4aaceb5dbb0$export$3fe9f96ae4e9046 = 'emptyStar';
const $aaded4aaceb5dbb0$export$5ba14a4123b4d7e7 = 'quarterStar';
const $aaded4aaceb5dbb0$export$c0557090bfd42e78 = 'halfStar';
const $aaded4aaceb5dbb0$export$a908142c7b579a36 = 'threeQuarterStar';
const $aaded4aaceb5dbb0$export$d02fa2cb21ed23bd = 'noRatingStar';
const $aaded4aaceb5dbb0$export$fe8acbce00b8388b = {
    [$aaded4aaceb5dbb0$export$cddb236a3f07ccae]: {
        fill: "var(--ds-icon-accent-orange, ".concat((0, $j0gMm.R300), ")")
    },
    [$aaded4aaceb5dbb0$export$3fe9f96ae4e9046]: {
        fill: "var(--ds-background-accent-gray-subtle, ".concat((0, $j0gMm.N500), ")")
    },
    [$aaded4aaceb5dbb0$export$5ba14a4123b4d7e7]: {
        fill: "url(#".concat($aaded4aaceb5dbb0$export$5ba14a4123b4d7e7, ")")
    },
    [$aaded4aaceb5dbb0$export$c0557090bfd42e78]: {
        fill: "url(#".concat($aaded4aaceb5dbb0$export$c0557090bfd42e78, ")")
    },
    [$aaded4aaceb5dbb0$export$a908142c7b579a36]: {
        fill: "url(#".concat($aaded4aaceb5dbb0$export$a908142c7b579a36, ")")
    },
    [$aaded4aaceb5dbb0$export$d02fa2cb21ed23bd]: {
        fill: "var(--ds-icon-disabled)"
    }
};

});

parcelRegister("7XETd", function(module, exports) {

$parcel$export(module.exports, "RatingsContainer", () => $5cbdc2e5b40195e3$export$508a6a934eaeeb30);
$parcel$export(module.exports, "StarIconContainer", () => $5cbdc2e5b40195e3$export$a6a73f636a2683f4);
$parcel$export(module.exports, "AverageStars", () => $5cbdc2e5b40195e3$export$1c7edfe1a6f80b9c);
$parcel$export(module.exports, "TotalStars", () => $5cbdc2e5b40195e3$export$7a0aad1834050ae3);
$parcel$export(module.exports, "RatingsCountStyled", () => $5cbdc2e5b40195e3$export$ddfb77fae3956ff7);
$parcel$export(module.exports, "StarRatingStyled", () => $5cbdc2e5b40195e3$export$e7481638283f6b25);
$parcel$export(module.exports, "StarGradientContainer", () => $5cbdc2e5b40195e3$export$aff3f8e463c240a6);
$parcel$export(module.exports, "NumericRatingStyled", () => $5cbdc2e5b40195e3$export$9d085bd035d1362a);
$parcel$export(module.exports, "NoRatingContainer", () => $5cbdc2e5b40195e3$export$8494e7ff3c135992);
$parcel$export(module.exports, "NoRatingText", () => $5cbdc2e5b40195e3$export$88ec7b3ea06dee1f);
/* Ratings.styles.ts generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $kU09D = parcelRequire("kU09D");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $cCrLo = parcelRequire("cCrLo");

var $eFxr4 = parcelRequire("eFxr4");
const $5cbdc2e5b40195e3$var$_excluded = [
    "as",
    "style"
], $5cbdc2e5b40195e3$var$_excluded2 = [
    "as",
    "style"
], $5cbdc2e5b40195e3$var$_excluded3 = [
    "variation"
], $5cbdc2e5b40195e3$var$_excluded4 = [
    "as",
    "style"
], $5cbdc2e5b40195e3$var$_excluded5 = [
    "as",
    "style"
], $5cbdc2e5b40195e3$var$_excluded6 = [
    "as",
    "style"
], $5cbdc2e5b40195e3$var$_excluded7 = [
    "as",
    "style"
], $5cbdc2e5b40195e3$var$_excluded8 = [
    "as",
    "style"
], $5cbdc2e5b40195e3$var$_excluded9 = [
    "as",
    "style"
], $5cbdc2e5b40195e3$var$_excluded10 = [
    "as",
    "style"
], $5cbdc2e5b40195e3$var$_excluded11 = [
    "as",
    "style"
];
function $5cbdc2e5b40195e3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5cbdc2e5b40195e3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5cbdc2e5b40195e3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5cbdc2e5b40195e3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $5cbdc2e5b40195e3$export$508a6a934eaeeb30 = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $5cbdc2e5b40195e3$var$_excluded);
    return /*#__PURE__*/ $eUqFw.createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_zulph461 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    }));
});
const $5cbdc2e5b40195e3$export$a6a73f636a2683f4 = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "span", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $5cbdc2e5b40195e3$var$_excluded2);
    const { variation: variation } = __cmplp, __cmpldp = (0, $bwPfh.default)(__cmplp, $5cbdc2e5b40195e3$var$_excluded3);
    return /*#__PURE__*/ $eUqFw.createElement(C, (0, $kU09D.default)({}, __cmpldp, {
        style: $5cbdc2e5b40195e3$var$_objectSpread($5cbdc2e5b40195e3$var$_objectSpread({}, __cmpls), {}, {
            "--_l74hby": (0, $9t7rW.default)((0, $eFxr4.STAR_FILL_MAP)[__cmplp.variation].fill)
        }),
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1axpun14",
            __cmplp.size === 'large' ? "_1bsbzwfg" : "_1bsb1tcg",
            __cmplp.size === 'large' ? "_4t3izwfg" : "_4t3i1tcg",
            __cmplp.className
        ])
    }));
});
const $5cbdc2e5b40195e3$export$1c7edfe1a6f80b9c = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodyNormal), style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $5cbdc2e5b40195e3$var$_excluded4);
    return /*#__PURE__*/ $eUqFw.createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf",
            __cmplp.isBold ? "_k48p1fw0" : "_k48p1nn1",
            __cmplp.className
        ])
    }));
});
const $5cbdc2e5b40195e3$export$7a0aad1834050ae3 = (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodyNormal), style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $5cbdc2e5b40195e3$var$_excluded5);
    return /*#__PURE__*/ $eUqFw.createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _syaz1k3w _k48p1nn1",
            __cmplp.className
        ])
    }));
});
const $5cbdc2e5b40195e3$export$ddfb77fae3956ff7 = (0, $eUqFw.forwardRef)((_ref5, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodyNormal), style: __cmpls } = _ref5, __cmplp = (0, $bwPfh.default)(_ref5, $5cbdc2e5b40195e3$var$_excluded6);
    return /*#__PURE__*/ $eUqFw.createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _syaz1k3w _k48p1nn1",
            __cmplp.className
        ])
    }));
});
const $5cbdc2e5b40195e3$export$e7481638283f6b25 = (0, $eUqFw.forwardRef)((_ref6, __cmplr)=>{
    let { as: C = "span", style: __cmpls } = _ref6, __cmplp = (0, $bwPfh.default)(_ref6, $5cbdc2e5b40195e3$var$_excluded7);
    return /*#__PURE__*/ $eUqFw.createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    }));
});
const $5cbdc2e5b40195e3$export$aff3f8e463c240a6 = (0, $eUqFw.forwardRef)((_ref7, __cmplr)=>{
    let { as: C = "svg", style: __cmpls } = _ref7, __cmplp = (0, $bwPfh.default)(_ref7, $5cbdc2e5b40195e3$var$_excluded8);
    return /*#__PURE__*/ $eUqFw.createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbidpf _4t3iidpf _kqswstnw",
            __cmplp.className
        ])
    }));
});
const $5cbdc2e5b40195e3$export$9d085bd035d1362a = (0, $eUqFw.forwardRef)((_ref8, __cmplr)=>{
    let { as: C = "p", style: __cmpls } = _ref8, __cmplp = (0, $bwPfh.default)(_ref8, $5cbdc2e5b40195e3$var$_excluded9);
    return /*#__PURE__*/ $eUqFw.createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _zulp1fcb _4cvr1h6o",
            __cmplp.className
        ])
    }));
});
const $5cbdc2e5b40195e3$export$8494e7ff3c135992 = (0, $eUqFw.forwardRef)((_ref9, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref9, __cmplp = (0, $bwPfh.default)(_ref9, $5cbdc2e5b40195e3$var$_excluded10);
    return /*#__PURE__*/ $eUqFw.createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _gy1ph461",
            __cmplp.className
        ])
    }));
});
const $5cbdc2e5b40195e3$export$88ec7b3ea06dee1f = (0, $eUqFw.forwardRef)((_ref10, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodyNormal), style: __cmpls } = _ref10, __cmplp = (0, $bwPfh.default)(_ref10, $5cbdc2e5b40195e3$var$_excluded11);
    return /*#__PURE__*/ $eUqFw.createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf",
            __cmplp.className
        ])
    }));
});

});

parcelRegister("dtVo5", function(module, exports) {

$parcel$export(module.exports, "getStarVariations", () => $9d0a7fbeead10ef6$export$2463346a7bf59173);
$parcel$export(module.exports, "roundRatingToOneDecimal", () => $9d0a7fbeead10ef6$export$9641f1f2cc762aeb);

var $5zQU9 = parcelRequire("5zQU9");

var $eFxr4 = parcelRequire("eFxr4");
function $9d0a7fbeead10ef6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9d0a7fbeead10ef6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9d0a7fbeead10ef6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9d0a7fbeead10ef6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $9d0a7fbeead10ef6$export$d1d41317c3f0fae = (val)=>{
    if (val >= 0.875) return 1;
    else if (val >= 0.625) return 0.75;
    else if (val >= 0.375) return 0.5;
    else if (val >= 0.125) return 0.25;
    return 0;
};
const $9d0a7fbeead10ef6$export$e7373081cdd0df48 = (averageStars)=>{
    const integer = Math.trunc(averageStars);
    const decimal = averageStars % 1;
    return integer + $9d0a7fbeead10ef6$export$d1d41317c3f0fae(decimal);
};
const $9d0a7fbeead10ef6$export$c3b5857cf6a23fc = {
    0: {},
    0.25: {
        quarterStarsCount: 1
    },
    0.5: {
        halfStarsCount: 1
    },
    0.75: {
        threeQuarterStarsCount: 1
    }
};
const $9d0a7fbeead10ef6$export$a00beb5a07c70ef1 = (averageStars)=>{
    const discreteRating = $9d0a7fbeead10ef6$export$e7373081cdd0df48(averageStars);
    const fullStarsCount = Math.trunc(discreteRating);
    const partiallyFilledStarsCount = Math.ceil(discreteRating % 1);
    const partiallyFilledStars = $9d0a7fbeead10ef6$export$c3b5857cf6a23fc[discreteRating % 1];
    const emptyStarsCount = (0, $eFxr4.TOTAL_STARS) - fullStarsCount - partiallyFilledStarsCount;
    return $9d0a7fbeead10ef6$var$_objectSpread({
        fullStarsCount: fullStarsCount,
        emptyStarsCount: emptyStarsCount
    }, partiallyFilledStars);
};
const $9d0a7fbeead10ef6$export$2463346a7bf59173 = (ratings)=>{
    if (!ratings.numRatings) return [
        ...new Array((0, $eFxr4.TOTAL_STARS)).fill((0, $eFxr4.NO_RATING_STAR))
    ];
    const { fullStarsCount: fullStarsCount = 0, quarterStarsCount: quarterStarsCount = 0, halfStarsCount: halfStarsCount = 0, threeQuarterStarsCount: threeQuarterStarsCount = 0, emptyStarsCount: emptyStarsCount = 0 } = $9d0a7fbeead10ef6$export$a00beb5a07c70ef1(ratings.avgStars);
    return [
        ...new Array(fullStarsCount).fill((0, $eFxr4.FULL_STAR)),
        ...new Array(quarterStarsCount).fill((0, $eFxr4.QUARTER_STAR)),
        ...new Array(halfStarsCount).fill((0, $eFxr4.HALF_STAR)),
        ...new Array(threeQuarterStarsCount).fill((0, $eFxr4.THREE_QUARTER_STAR)),
        ...new Array(emptyStarsCount).fill((0, $eFxr4.EMPTY_STAR))
    ];
};
const $9d0a7fbeead10ef6$export$9641f1f2cc762aeb = (rating)=>Number(rating.toFixed(1));

});

parcelRegister("6AmUQ", function(module, exports) {

$parcel$export(module.exports, "StarGradients", () => $4cb7e17e20c28b6a$export$9e5638a6deed949e);

var $eUqFw = parcelRequire("eUqFw");

var $eFxr4 = parcelRequire("eFxr4");

var $7XETd = parcelRequire("7XETd");
const $4cb7e17e20c28b6a$var$STAR_GRADIENT_CONFIG = [
    {
        id: (0, $eFxr4.QUARTER_STAR),
        offset: '25%'
    },
    {
        id: (0, $eFxr4.HALF_STAR),
        offset: '50%'
    },
    {
        id: (0, $eFxr4.THREE_QUARTER_STAR),
        offset: '75%'
    }
];
const $4cb7e17e20c28b6a$export$9e5638a6deed949e = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, $4cb7e17e20c28b6a$var$STAR_GRADIENT_CONFIG.map((_ref, index)=>{
        let { id: id, offset: offset } = _ref;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7XETd.StarGradientContainer), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
            id: id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
            offset: offset,
            stopColor: (0, $eFxr4.STAR_FILL_MAP)[0, $eFxr4.FULL_STAR].fill
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
            offset: offset,
            stopColor: (0, $eFxr4.STAR_FILL_MAP)[0, $eFxr4.EMPTY_STAR].fill
        })));
    }));
};

});


parcelRegister("dM9ZW", function(module, exports) {

$parcel$export(module.exports, "useLocation", () => $a07783720b17fb4a$export$45d76561a5302f2b);
$parcel$export(module.exports, "useLocationHref", () => $a07783720b17fb4a$export$49fc3f3d8c7f99);
$parcel$export(module.exports, "useHistory", () => $a07783720b17fb4a$export$3420e1dc2c4a518c);
$parcel$export(module.exports, "useQueryParams", () => $a07783720b17fb4a$export$b37ee0d76c6d2fbc);

var $5zQU9 = parcelRequire("5zQU9");

var $c9Mth = parcelRequire("c9Mth");

var $kt9Cs = parcelRequire("kt9Cs");

var $eUqFw = parcelRequire("eUqFw");

var $2j88s = parcelRequire("2j88s");
function $a07783720b17fb4a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a07783720b17fb4a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a07783720b17fb4a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a07783720b17fb4a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a07783720b17fb4a$export$45d76561a5302f2b() {
    const { location: location } = (0, $eUqFw.useContext)((0, $2j88s.default));
    return location;
}
const $a07783720b17fb4a$export$49fc3f3d8c7f99 = ()=>{
    const location = $a07783720b17fb4a$export$45d76561a5302f2b();
    if (typeof location === 'string') return location;
    const { pathname: pathname, search: search } = location;
    return "".concat(pathname).concat(search);
};
function $a07783720b17fb4a$export$3420e1dc2c4a518c() {
    const { history: history } = (0, $eUqFw.useContext)((0, $2j88s.default));
    return history;
}
function $a07783720b17fb4a$export$99eaa27ddbbb95ef() {
    const { match: match } = (0, $eUqFw.useContext)((0, $2j88s.default));
    return match ? match.params : {};
}
function $a07783720b17fb4a$export$b37ee0d76c6d2fbc() {
    const { search: search } = $a07783720b17fb4a$export$45d76561a5302f2b();
    return $kt9Cs.parse(search || '');
}
function $a07783720b17fb4a$export$cb5afe0593c0213f(queryParam) {
    const queryParams = $a07783720b17fb4a$export$b37ee0d76c6d2fbc();
    const history = $a07783720b17fb4a$export$3420e1dc2c4a518c();
    const currentPath = window.location.href;
    const updatedPath = (0, $c9Mth).unsetQueryParam(window.location.href, queryParam);
    if (!currentPath.endsWith(updatedPath)) history === null || history === void 0 || history.replace(updatedPath);
    return queryParams[queryParam];
}
const $a07783720b17fb4a$export$1fc7227ddad78bcb = (paramValidation)=>{
    const { search: oldSearch, pathname: pathname } = $a07783720b17fb4a$export$45d76561a5302f2b();
    const queryParams = $kt9Cs.parse(oldSearch || '');
    const updatedQueryParams = $a07783720b17fb4a$var$_objectSpread({}, queryParams);
    let hasInvalidOrMissingParams = false;
    Object.keys(paramValidation).forEach((key)=>{
        const { validate: validate, defaultValue: defaultValue } = paramValidation[key];
        const originalValue = queryParams[key];
        const isMissingValue = typeof originalValue === 'undefined' && typeof defaultValue !== 'undefined';
        const isValidValue = validate ? validate(originalValue) : true;
        if (isMissingValue || !isValidValue) {
            hasInvalidOrMissingParams = true;
            updatedQueryParams[key] = defaultValue;
        }
    });
    const updatedQueryString = $kt9Cs.stringify(updatedQueryParams);
    const updatedSearch = updatedQueryString ? "?".concat(updatedQueryString) : '';
    const redirectRoute = hasInvalidOrMissingParams ? pathname + updatedSearch : null;
    return {
        redirectRoute: redirectRoute,
        queryParams: updatedQueryParams
    };
};

});
parcelRegister("2j88s", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ae3aaa3993088af$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $1ae3aaa3993088af$var$defaultContextValue = {
    location: {},
    history: {},
    match: {},
    staticContext: {}
};
var $1ae3aaa3993088af$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext($1ae3aaa3993088af$var$defaultContextValue);

});



parcelRegister("eoMJc", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7b91af0690e0cd9$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $ivTMz = parcelRequire("ivTMz");

var $j0gMm = parcelRequire("j0gMm");

var $2eG9N = parcelRequire("2eG9N");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $eUqFw = parcelRequire("eUqFw");

var $7BUhe = parcelRequire("7BUhe");
function $a7b91af0690e0cd9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a7b91af0690e0cd9$export$9ad0f767bf8dc483 = 'staffPickTooltip';
const $a7b91af0690e0cd9$export$1d0daa2d189cdf35 = (0, $3UXZ8.default)("div", {
    target: "e17z47mm0",
    label: "StaffPickBadgeText"
})("box-sizing:border-box;font-family:", (0, $ivTMz.fontFamily)(), ";font-size:10px;font-style:normal;font-weight:600;line-height:14px;padding:0px var(--ds-space-050, 4px);margin:1px 0px;border-radius:3px;white-space:nowrap;background:var(--ds-background-accent-purple-bolder, #6E5DC6);color:", "var(--ds-text-inverse, ".concat((0, $j0gMm.N0), ")"), ";");
const $a7b91af0690e0cd9$export$b4d75f17f7229fb1 = (0, $3UXZ8.default)("div", {
    target: "e17z47mm1",
    label: "StaffPickBadgeContainer"
})({
    name: "18e8814",
    styles: "display:inline-block;position:absolute;transform:translate(0,50%);margin-left:var(--ds-space-100, 8px);"
});
const $a7b91af0690e0cd9$var$StaffPickBadge = ()=>{
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const onToolTipShow = ()=>{
        fireAnalyticsEvent({
            eventType: (0, $gaiog.TooltipViewedEvent),
            actionSubjectId: $a7b91af0690e0cd9$export$9ad0f767bf8dc483
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a7b91af0690e0cd9$export$b4d75f17f7229fb1, {
        "data-testid": (0, $7BUhe.TEST_IDS).APP_HEADER_STAFF_PICK
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        onShow: onToolTipShow,
        content: "Apps picked quarterly to suit your dynamic needs"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a7b91af0690e0cd9$export$1d0daa2d189cdf35, null, "STAFF PICK")));
};
var $a7b91af0690e0cd9$export$2e2bcd8739ae039 = $a7b91af0690e0cd9$var$StaffPickBadge;

});


parcelRegister("uNPxB", function(module, exports) {

$parcel$export(module.exports, "makeAppHeaderDetails", () => $05c974b7aa139e15$export$8d625da576760458);
const $05c974b7aa139e15$export$8d625da576760458 = (app, appDetailsFromSearchResponse)=>{
    var _appDetailsFromSearch, _ref, _appDetailsFromSearch2, _ref2, _appDetailsFromSearch3, _app$vendor$partnerTi, _app$distribution$isP, _app$distribution, _app$distribution$isP2, _app$distribution2;
    const appDetailsFromSearchDistribution = appDetailsFromSearchResponse === null || appDetailsFromSearchResponse === void 0 ? void 0 : (_appDetailsFromSearch = appDetailsFromSearchResponse.appData) === null || _appDetailsFromSearch === void 0 ? void 0 : _appDetailsFromSearch.distribution;
    const appDistribution = app === null || app === void 0 ? void 0 : app.distribution;
    const downloadCount = (_ref = (_appDetailsFromSearch2 = appDetailsFromSearchDistribution === null || appDetailsFromSearchDistribution === void 0 ? void 0 : appDetailsFromSearchDistribution.downloads) !== null && _appDetailsFromSearch2 !== void 0 ? _appDetailsFromSearch2 : appDistribution === null || appDistribution === void 0 ? void 0 : appDistribution.downloadCount) !== null && _ref !== void 0 ? _ref : 0;
    const installationCount = (_ref2 = (_appDetailsFromSearch3 = appDetailsFromSearchDistribution === null || appDetailsFromSearchDistribution === void 0 ? void 0 : appDetailsFromSearchDistribution.activeInstalls) !== null && _appDetailsFromSearch3 !== void 0 ? _appDetailsFromSearch3 : appDistribution === null || appDistribution === void 0 ? void 0 : appDistribution.installationCount) !== null && _ref2 !== void 0 ? _ref2 : 0;
    return {
        name: app.name,
        key: app.key,
        icon: app.icon,
        ratings: app.ratings,
        origin: app.origin,
        partner: {
            name: app.vendor.name,
            link: app.vendor.link,
            partnerTierType: (_app$vendor$partnerTi = app.vendor.partnerTier) === null || _app$vendor$partnerTi === void 0 ? void 0 : _app$vendor$partnerTi.type
        },
        distribution: {
            downloadCount: downloadCount,
            installationCount: installationCount,
            isPreinstalled: (_app$distribution$isP = app === null || app === void 0 ? void 0 : (_app$distribution = app.distribution) === null || _app$distribution === void 0 ? void 0 : _app$distribution.isPreinstalled) !== null && _app$distribution$isP !== void 0 ? _app$distribution$isP : false,
            isPreinstalledInAnyHosting: (_app$distribution$isP2 = app === null || app === void 0 ? void 0 : (_app$distribution2 = app.distribution) === null || _app$distribution2 === void 0 ? void 0 : _app$distribution2.isPreinstalledInAnyHosting) !== null && _app$distribution$isP2 !== void 0 ? _app$distribution$isP2 : false,
            isLoading: appDetailsFromSearchResponse === null || appDetailsFromSearchResponse === void 0 ? void 0 : appDetailsFromSearchResponse.loading,
            isError: appDetailsFromSearchResponse === null || appDetailsFromSearchResponse === void 0 ? void 0 : appDetailsFromSearchResponse.error
        }
    };
};

});

parcelRegister("gXQsH", function(module, exports) {

$parcel$export(module.exports, "default", () => $c59ad9de30190103$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $eUqFw = parcelRequire("eUqFw");
function $c59ad9de30190103$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c59ad9de30190103$var$FADE_HEIGHT = '30px';
const $c59ad9de30190103$var$ChildrenWrapDiv = (0, $3UXZ8.default)("div", {
    target: "eh4c6380",
    label: "ChildrenWrapDiv"
})("overflow:hidden;padding-bottom:", $c59ad9de30190103$var$FADE_HEIGHT, ";");
const $c59ad9de30190103$var$RelativeDiv = (0, $3UXZ8.default)("div", {
    target: "eh4c6381",
    label: "RelativeDiv"
})({
    name: "n27z15",
    styles: "position:relative;height:0;"
});
const $c59ad9de30190103$var$FadeDiv = (0, $3UXZ8.default)("div", {
    target: "eh4c6382",
    label: "FadeDiv"
})("height:", $c59ad9de30190103$var$FADE_HEIGHT, ";background:linear-gradient( to bottom,var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0)),var(--ds-surface-overlay, rgba(255, 255, 255, 1)) );position:absolute;bottom:0;left:0;right:0;");
class $c59ad9de30190103$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c59ad9de30190103$var$ChildrenWrapDiv, null, this.props.children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c59ad9de30190103$var$RelativeDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c59ad9de30190103$var$FadeDiv, null)));
    }
}

});

parcelRegister("gwMyJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0854d5ba8170c73$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $9oiuL = parcelRequire("9oiuL");

var $j0gMm = parcelRequire("j0gMm");

var $8kbfx = parcelRequire("8kbfx");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $eUqFw = parcelRequire("eUqFw");
function $c0854d5ba8170c73$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c0854d5ba8170c73$export$31dea26885d599bc = (0, $3UXZ8.default)("div", {
    target: "e14kt8w70",
    label: "DescriptionContainer"
})("font-weight:400;font-size:14px;color:", "var(--ds-text, ".concat((0, $j0gMm.N800), ")"), ";");
const $c0854d5ba8170c73$export$3f4e9180815b917 = (0, $3UXZ8.default)("ul", {
    target: "e14kt8w71",
    label: "ScopesUl"
})("font-weight:400;font-size:14px;line-height:20px;color:", "var(--ds-text-subtle, ".concat((0, $j0gMm.N500), ")"), ";margin:0;padding-left:1.5em;");
const $c0854d5ba8170c73$export$f5342fb93e025bb6 = (0, $3UXZ8.default)("li", {
    target: "e14kt8w72",
    label: "ScopeLi"
})({
    name: "19f8am9",
    styles: "& + &{margin-top:var(--ds-space-050, 4px);}"
});
const $c0854d5ba8170c73$export$211593c580c85cd0 = (0, $3UXZ8.default)("div", {
    target: "e14kt8w73",
    label: "ScopesSection"
})({
    name: "mb6my3",
    styles: "& + &{margin-top:13px;}"
});
const $c0854d5ba8170c73$export$3e4b7f4c4f001e89 = (0, $3UXZ8.default)("div", {
    target: "e14kt8w74",
    label: "ExpandAllDetailsSection"
})({
    name: "18c6pm0",
    styles: "& + &{margin-top:var(--ds-space-075, 6px);}"
});
const $c0854d5ba8170c73$var$Scopes = (props)=>{
    const [showAllScopes, setShowAllScopes] = (0, $eUqFw.useState)(false);
    const initialScopesSize = 4;
    const translateScope = (_ref)=>{
        let { scopesLookup: scopesLookup, scope: scope } = _ref;
        const description = (0, $bWAru.Option).of(scopesLookup.getIn([
            (0, $8kbfx.makeScopeKey)(scope.toUpperCase()),
            'description'
        ])).orElseL(()=>{
            const scopeSplit = scope.split(':');
            const scopeHalfKey = scopeSplit[scopeSplit.length - 1];
            return (0, $bWAru.Option).of(scopesLookup.getIn([
                (0, $8kbfx.makeScopeKey)(scopeHalfKey.toUpperCase()),
                'description'
            ]));
        }).getOrElse(scope);
        return description;
    };
    const handleExpandAllScopes = ()=>{
        setShowAllScopes(true);
    };
    const scopesList = showAllScopes ? props.appScopes : props.appScopes.slice(0, initialScopesSize);
    const renderNoScopes = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c0854d5ba8170c73$export$211593c580c85cd0, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c0854d5ba8170c73$export$31dea26885d599bc, null, "This app does not require additional permissions."));
    const renderScopes = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c0854d5ba8170c73$export$211593c580c85cd0, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c0854d5ba8170c73$export$31dea26885d599bc, null, props.description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c0854d5ba8170c73$export$211593c580c85cd0, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c0854d5ba8170c73$export$3f4e9180815b917, null, props.scopesLookup.fold((_)=>scopesList.map((s)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c0854d5ba8170c73$export$f5342fb93e025bb6, {
                    key: s
                }, s)), (scopesLookup)=>scopesList.map((s)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c0854d5ba8170c73$export$f5342fb93e025bb6, {
                    key: s
                }, translateScope({
                    scopesLookup: scopesLookup,
                    scope: s
                })))))), props.appScopes.size > initialScopesSize && !showAllScopes ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c0854d5ba8170c73$export$3e4b7f4c4f001e89, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9oiuL.default), {
            appearance: "link",
            onClick: handleExpandAllScopes
        }, "Expand all details")) : null);
    return props.appScopes.size > 0 ? renderScopes() : renderNoScopes();
};
var $c0854d5ba8170c73$export$2e2bcd8739ae039 = $c0854d5ba8170c73$var$Scopes;

});

parcelRegister("lmAeL", function(module, exports) {

$parcel$export(module.exports, "ForgeAppEgressAddresses", () => $f8d7c2fda63fa6b3$export$8478d8cd465f84f2);

var $3UXZ8 = parcelRequire("3UXZ8");

var $9oiuL = parcelRequire("9oiuL");

var $j0gMm = parcelRequire("j0gMm");

var $eUqFw = parcelRequire("eUqFw");
function $f8d7c2fda63fa6b3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f8d7c2fda63fa6b3$export$c2f7404bc8662f3f = (0, $3UXZ8.default)("ul", {
    target: "eswv1f60",
    label: "EgressUl"
})("font-weight:400;font-size:14px;line-height:20px;color:", "var(--ds-text-subtle, ".concat((0, $j0gMm.N500), ")"), ";margin:0;padding-left:1.5em;");
const $f8d7c2fda63fa6b3$export$ea8a946be4c79376 = (0, $3UXZ8.default)("li", {
    target: "eswv1f61",
    label: "EgressLi"
})({
    name: "188h8i6",
    styles: "margin-top:var(--ds-space-050, 4px);"
});
const $f8d7c2fda63fa6b3$export$9772332eaabfd9c6 = (0, $3UXZ8.default)("div", {
    target: "eswv1f62",
    label: "EgressAddresesSection"
})({
    name: "mb6my3",
    styles: "& + &{margin-top:13px;}"
});
const $f8d7c2fda63fa6b3$export$3e4b7f4c4f001e89 = (0, $3UXZ8.default)("div", {
    target: "eswv1f63",
    label: "ExpandAllDetailsSection"
})({
    name: "2cpdjg",
    styles: "margin-top:var(--ds-space-075, 6px);"
});
const $f8d7c2fda63fa6b3$export$31dea26885d599bc = (0, $3UXZ8.default)("div", {
    target: "eswv1f64",
    label: "DescriptionContainer"
})("font-weight:400;font-size:14px;color:", "var(--ds-text, ".concat((0, $j0gMm.N800), ")"), ";");
const $f8d7c2fda63fa6b3$export$8478d8cd465f84f2 = (props)=>{
    const { forgeAppEgressAddresses: forgeAppEgressAddresses, appName: appName } = props;
    const resolveScopesDescription = "".concat(appName, " can send data to the following domains:");
    const [showAllEgressAddresses, setShowAllEgressAddresses] = (0, $eUqFw.useState)(false);
    const egressAddressesDescription = (address)=>{
        const prefix = '*.';
        if (address.startsWith(prefix)) return "Only subdomains of ".concat(address.slice(prefix.length));
        else return address;
    };
    const egressAddressesList = showAllEgressAddresses ? forgeAppEgressAddresses : forgeAppEgressAddresses === null || forgeAppEgressAddresses === void 0 ? void 0 : forgeAppEgressAddresses.slice(0, 4);
    const handleshowAllDetailsClick = ()=>{
        setShowAllEgressAddresses(true);
    };
    const showExpandAllDetailsButton = !showAllEgressAddresses && forgeAppEgressAddresses && forgeAppEgressAddresses.length > 4;
    const renderEgressAddresses = egressAddressesList && (egressAddressesList === null || egressAddressesList === void 0 ? void 0 : egressAddressesList.length) > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f8d7c2fda63fa6b3$export$9772332eaabfd9c6, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f8d7c2fda63fa6b3$export$31dea26885d599bc, null, resolveScopesDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f8d7c2fda63fa6b3$export$9772332eaabfd9c6, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f8d7c2fda63fa6b3$export$c2f7404bc8662f3f, null, egressAddressesList.map((addresses)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f8d7c2fda63fa6b3$export$ea8a946be4c79376, {
            key: addresses
        }, egressAddressesDescription(addresses));
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f8d7c2fda63fa6b3$export$3e4b7f4c4f001e89, null, showExpandAllDetailsButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9oiuL.default), {
        appearance: "link",
        onClick: handleshowAllDetailsClick
    }, "Expand all details") : null)) : null;
    return renderEgressAddresses;
};

});




parcelRegister("g9u53", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc24d1fb7efa5532$export$2e2bcd8739ae039);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $eUqFw = parcelRequire("eUqFw");

var $gIQkA = parcelRequire("gIQkA");

var $jnM8o = parcelRequire("jnM8o");

var $joPUX = parcelRequire("joPUX");

var $2fW4H = parcelRequire("2fW4H");
const $bc24d1fb7efa5532$var$resolveDialogInstructional = (_ref)=>{
    let { closeInstallDialog: closeInstallDialog, instructionalInstallMode: instructionalInstallMode, links: links, appDetailsFromSearchResponse: appDetailsFromSearchResponse, onRendered: onRendered } = _ref;
    return {
        analyticsSourceModal: (0, $gIQkA.ANALYTICS_MODAL_INSTRUCTIONAL),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $joPUX.default), {
            appDetailsFromSearchResponse: appDetailsFromSearchResponse,
            instructionalApp: instructionalInstallMode.instructionalApp,
            links: links,
            onRendered: onRendered
        }),
        heading: 'Installation instructions',
        footerLeft: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jnM8o.default), {
            marketplaceAppDetails: instructionalInstallMode.instructionalApp.details,
            links: links
        }),
        footerRight: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2fW4H.default), {
            closeInstallDialog: closeInstallDialog,
            instructionalApp: instructionalInstallMode.instructionalApp
        }),
        preventDialogClosing: false,
        errorDetails: (0, $bWAru.Option).empty()
    };
};
var $bc24d1fb7efa5532$export$2e2bcd8739ae039 = $bc24d1fb7efa5532$var$resolveDialogInstructional;

});
parcelRegister("joPUX", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1f887f6569c2219$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $gGAJ8 = parcelRequire("gGAJ8");

var $aosfp = parcelRequire("aosfp");
var $hvzDU = parcelRequire("hvzDU");

var $eUqFw = parcelRequire("eUqFw");

var $uNPxB = parcelRequire("uNPxB");
function $e1f887f6569c2219$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e1f887f6569c2219$export$a2bb30aefb2a488 = (0, $3UXZ8.default)("div", {
    target: "e1x90ej00",
    label: "DialogInstructionalContainer"
})({
    name: "ymy1qt",
    styles: "min-height:75px;"
});
const $e1f887f6569c2219$export$1859a226b0527ca7 = (0, $3UXZ8.default)("li", {
    target: "e1x90ej01",
    label: "DialogInstructionalListItem"
})({
    name: "19f8am9",
    styles: "& + &{margin-top:var(--ds-space-050, 4px);}"
});
const $e1f887f6569c2219$export$38996a7777891d07 = (0, $3UXZ8.default)("img", {
    target: "e1x90ej02",
    label: "DialogInstructionalListItemImage"
})({
    name: "gt8gvs",
    styles: "margin:10px 0;max-width:100%;"
});
const $e1f887f6569c2219$export$d031efc798646aff = (0, $3UXZ8.default)("div", {
    target: "e1x90ej03",
    label: "NoInstructionsDiv"
})({
    name: "1q7njkh",
    styles: "margin-top:10px;"
});
const $e1f887f6569c2219$var$DialogInstructionalContent = (props)=>{
    const { instructionalApp: instructionalApp, links: links, onRendered: onRendered, appDetailsFromSearchResponse: appDetailsFromSearchResponse } = props;
    (0, $eUqFw.useEffect)(()=>{
        if (typeof onRendered === 'function') onRendered();
    }, []);
    const getNoInstructionsText = ()=>{
        const vendorName = instructionalApp.details.vendor.name;
        return vendorName ? instructionalApp.learnMoreLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e1f887f6569c2219$export$d031efc798646aff, null, "We don't have instructions for this app. Please view information on ", vendorName, "'s website, or go to\xA0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
            href: instructionalApp.learnMoreLink,
            target: "_blank",
            rel: "noreferrer"
        }, instructionalApp.learnMoreLink)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e1f887f6569c2219$export$d031efc798646aff, null, "We don't have instructions for this app. Please view information on ", vendorName, "'s website.") : instructionalApp.learnMoreLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e1f887f6569c2219$export$d031efc798646aff, null, "We don't have instructions for this app. Go to", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
            href: instructionalApp.learnMoreLink,
            target: "_blank",
            rel: "noreferrer"
        }, instructionalApp.learnMoreLink)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e1f887f6569c2219$export$d031efc798646aff, null, "We don't have instructions for this app.");
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e1f887f6569c2219$export$a2bb30aefb2a488, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aosfp.default), {
        appHeaderDetails: (0, $uNPxB.makeAppHeaderDetails)(instructionalApp.details, appDetailsFromSearchResponse),
        appRatingLink: links.appRating,
        appIconLink: links.appIcon,
        appIconSize: "small",
        showInstallationCount: true
    }), (0, $gGAJ8.nonEmptyList)(instructionalApp.steps).fold((_)=>getNoInstructionsText(), (_)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("ol", null, instructionalApp.steps.map((step, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e1f887f6569c2219$export$1859a226b0527ca7, {
                key: i
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hvzDU.default), {
                dangerousHtml: step.bodyHTML
            }), step.image && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e1f887f6569c2219$export$38996a7777891d07, {
                alt: "",
                draggable: false,
                src: step.image
            }))))));
};
var $e1f887f6569c2219$export$2e2bcd8739ae039 = $e1f887f6569c2219$var$DialogInstructionalContent;

});
parcelRegister("gGAJ8", function(module, exports) {

$parcel$export(module.exports, "nonEmptyList", () => $c25d0ed258f4bcc9$export$889482be59f95193);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");
const $c25d0ed258f4bcc9$export$889482be59f95193 = (l)=>l.isEmpty() ? (0, $bWAru.Option).empty() : (0, $bWAru.Option).some(l);
const $c25d0ed258f4bcc9$export$59e6ab3685971b90 = (e)=>(0, $g5DHJ.List)([
        e
    ]);
const $c25d0ed258f4bcc9$export$47be768bb1d48251 = (l)=>(0, $bWAru.Option).of(l.get(0)).getOrElseL(()=>{
        throw new Error("Illegal state - shouldn't have a NonEmptyList without an item");
    });

});

parcelRegister("hvzDU", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbf0facdd2da4996$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $bwPfh = parcelRequire("bwPfh");

var $3UXZ8 = parcelRequire("3UXZ8");

var $hvUUg = parcelRequire("hvUUg");
var $6YChr = parcelRequire("6YChr");

var $kfRpm = parcelRequire("kfRpm");

var $eUqFw = parcelRequire("eUqFw");
const $cbf0facdd2da4996$var$_excluded = [
    "dangerousHtml",
    "extraStyle"
];
const $cbf0facdd2da4996$export$929c06907e214cc8 = (0, $3UXZ8.default)("div", {
    target: "e5n0qpn0",
    label: "ContentDiv"
})((0, $hvUUg.baseMediumFontSize), " line-height:24px;ul{margin-top:5px;li{margin:0 0 5px;}}");
/**
 * @deprecated Use UserGeneratedHtml from "@atlassian/mpac-primitives" instead
 */ const $cbf0facdd2da4996$var$UserGeneratedHtml = (_ref)=>{
    let { dangerousHtml: dangerousHtml, extraStyle: extraStyle } = _ref, otherProps = (0, $bwPfh.default)(_ref, $cbf0facdd2da4996$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6YChr.default), {
        target: "_blank",
        extraStyle: extraStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cbf0facdd2da4996$export$929c06907e214cc8, (0, $kU09D.default)({
        style: extraStyle
    }, otherProps, {
        /* eslint-disable-next-line marketplace-frontend/no-dangerous-html -- This is the common component to be used for all dangerouslySetInnerHTML required cases*/ dangerouslySetInnerHTML: {
            __html: (0, (/*@__PURE__*/$parcel$interopDefault($kfRpm))).sanitize(dangerousHtml)
        }
    })));
};
var $cbf0facdd2da4996$export$2e2bcd8739ae039 = $cbf0facdd2da4996$var$UserGeneratedHtml;

});
parcelRegister("6YChr", function(module, exports) {

$parcel$export(module.exports, "default", () => $51460a5b5163a1dc$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $9rIMC = parcelRequire("9rIMC");

var $eUqFw = parcelRequire("eUqFw");
class $51460a5b5163a1dc$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "linksContainerEle", void 0);
        (0, $5zQU9.default)(this, "render", ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                ref: (linksContainerEle)=>this.linksContainerEle = linksContainerEle,
                style: this.props.extraStyle
            }, this.props.children));
    }
    componentDidMount() {
        (0, $9rIMC).setTargetForAllLinks(this.linksContainerEle, this.props.target);
    }
    componentDidUpdate() {
        (0, $9rIMC).setTargetForAllLinks(this.linksContainerEle, this.props.target);
    }
}

});

parcelRegister("kfRpm", function(module, exports) {
/*! @license DOMPurify 2.5.1 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.1/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (_isNativeReflectConstruct()) _construct = Reflect.construct;
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    var _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!construct) construct = function construct(Func, args) {
        return _construct(Func, _toConsumableArray(args));
    };
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringToString = unapply(String.prototype.toString);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /* Add properties to a lookup table */ function addToSet(set, array, transformCaseFunc) {
        var _transformCaseFunc;
        transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        var l = array.length;
        while(l--){
            var element = array[l];
            if (typeof element === 'string') {
                var lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /* Shallow clone an object */ function clone(object) {
        var newObject = create(null);
        var property;
        for(property in object)if (apply(hasOwnProperty, object, [
            property
        ]) === true) newObject[property] = object[property];
        return newObject;
    }
    /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */ function lookupGetter(object, prop) {
        while(object !== null){
            var desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue(element) {
            console.warn('fallback value for', element);
            return null;
        }
        return fallbackValue;
    }
    var html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    // SVG
    var svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    var svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    var svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'fedropshadow',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    var mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    var mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    var text = freeze([
        '#text'
    ]);
    var html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'xmlns',
        'slot'
    ]);
    var svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    var mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    var xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    var DOCTYPE_NAME = seal(/^html$/i);
    var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */ var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
        if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        var suffix = null;
        var ATTR_NAME = 'data-tt-policy-suffix';
        if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) suffix = document.currentScript.getAttribute(ATTR_NAME);
        var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML: function createHTML(html) {
                    return html;
                },
                createScriptURL: function createScriptURL(scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    function createDOMPurify() {
        var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
        };
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = '2.5.1';
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        var originalDocument = window1.document;
        var document = window1.document;
        var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        var ElementPrototype = Element.prototype;
        var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        var getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            var template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
        var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
        var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        var importNode = originalDocument.importNode;
        var documentMode = {};
        try {
            documentMode = clone(document).documentMode ? document.documentMode : {};
        } catch (_) {}
        var hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
        var MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ var ALLOWED_TAGS = null;
        var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
        /* Allowed attribute names */ var ALLOWED_ATTR = null;
        var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ var FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ var FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ var ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ var ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ var ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ var ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ var SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ var SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ var WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ var SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ var FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ var RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ var RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ var RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ var SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ var SANITIZE_NAMED_PROPS = false;
        var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ var KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ var IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ var USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ var FORBID_CONTENTS = null;
        var DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ var DATA_URI_TAGS = null;
        var DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ var URI_SAFE_ATTRIBUTES = null;
        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ var NAMESPACE = HTML_NAMESPACE;
        var IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ var ALLOWED_NAMESPACES = null;
        var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ var PARSER_MEDIA_TYPE;
        var SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        var transformCaseFunc;
        /* Keep a reference to config to pass to hooks */ var CONFIG = null;
        /* Specify the maximum element nesting depth to prevent mXSS */ var MAX_NESTING_DEPTH = 255;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ var formElement = document.createElement('form');
        var isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || _typeof(cfg) !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
            cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
            cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        var HTML_INTEGRATION_POINTS = addToSet({}, [
            'foreignobject',
            'desc',
            'title',
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ var ALL_SVG_TAGS = addToSet({}, svg$1);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                try {
                    node.outerHTML = emptyHTML;
                } catch (_) {
                    node.remove();
                }
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ var _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === 'is' && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ var doc;
            var leadingWhitespace;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            var body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */ var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ var _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.__depth !== 'undefined' && typeof elm.__depth !== 'number' || typeof elm.__removalCount !== 'undefined' && typeof elm.__removalCount !== 'number' || typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
        };
        /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ var _isNode = function _isNode(object) {
            return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], function(hook) {
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content;
            /* Execute a hook if present */ _executeHook('beforeSanitizeElements', currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Check if tagname contains Unicode */ if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ var tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook('uponSanitizeElement', currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Mitigate a problem with templates inside select */ if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any ocurrence of processing instructions */ if (currentNode.nodeType === 7) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        var childCount = childNodes.length;
                        for(var i = childCount - 1; i >= 0; --i){
                            var childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
                content = stringReplace(content, ERB_EXPR$1, ' ');
                content = stringReplace(content, TMPLIT_EXPR$1, ' ');
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeElements', currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */ var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr;
            var value;
            var lcName;
            var l;
            /* Execute a hook if present */ _executeHook('beforeSanitizeAttributes', currentNode, null);
            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes) return;
            var hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                attr = attributes[l];
                var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                value = name === 'value' ? attr.value : stringTrim(attr.value);
                lcName = transformCaseFunc(name);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) {
                    value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
                    value = stringReplace(value, ERB_EXPR$1, ' ');
                    value = stringReplace(value, TMPLIT_EXPR$1, ' ');
                }
                /* Is `value` valid for this attribute? */ var lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeAttributes', currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode;
            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */ _executeHook('beforeSanitizeShadowDOM', fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook('uponSanitizeShadowNode', shadowNode, null);
                /* Sanitize tags and elements */ if (_sanitizeElements(shadowNode)) continue;
                /* Set the nesting depth of an element */ if (shadowNode.nodeType === 1) {
                    if (shadowNode.parentNode && shadowNode.parentNode.__depth) /*
              We want the depth of the node in the original tree, which can
              change when it's removed from its parent.
            */ shadowNode.__depth = (shadowNode.__removalCount || 0) + shadowNode.parentNode.__depth + 1;
                    else shadowNode.__depth = 1;
                }
                /* Remove an element if nested too deeply to avoid mXSS */ if (shadowNode.__depth >= MAX_NESTING_DEPTH) _forceRemove(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) {
                    shadowNode.content.__depth = shadowNode.__depth;
                    _sanitizeShadowDOM(shadowNode.content);
                }
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(shadowNode);
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeShadowDOM', fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var body;
            var importedNode;
            var currentNode;
            var oldNode;
            var returnNode;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Check we can run. Otherwise fall back or ignore */ if (!DOMPurify.isSupported) {
                if (_typeof(window1.toStaticHTML) === 'object' || typeof window1.toStaticHTML === 'function') {
                    if (typeof dirty === 'string') return window1.toStaticHTML(dirty);
                    if (_isNode(dirty)) return window1.toStaticHTML(dirty.outerHTML);
                }
                return dirty;
            }
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    var tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Fix IE's strange behavior with manipulated textNodes #89 */ if (currentNode.nodeType === 3 && currentNode === oldNode) continue;
                /* Sanitize tags and elements */ if (_sanitizeElements(currentNode)) continue;
                /* Set the nesting depth of an element */ if (currentNode.nodeType === 1) {
                    if (currentNode.parentNode && currentNode.parentNode.__depth) /*
              We want the depth of the node in the original tree, which can
              change when it's removed from its parent.
            */ currentNode.__depth = (currentNode.__removalCount || 0) + currentNode.parentNode.__depth + 1;
                    else currentNode.__depth = 1;
                }
                /* Remove an element if nested too deeply to avoid mXSS */ if (currentNode.__depth >= MAX_NESTING_DEPTH) _forceRemove(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) {
                    currentNode.content.__depth = currentNode.__depth;
                    _sanitizeShadowDOM(currentNode.content);
                }
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(currentNode);
                oldNode = currentNode;
            }
            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) {
                serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
            }
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function(cfg) {
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

});



parcelRegister("2fW4H", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a4a07ebc6ca515d$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $9goJJ = parcelRequire("9goJJ");

var $gGAJ8 = parcelRequire("gGAJ8");
var $bPByu = parcelRequire("bPByu");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $g01ln = parcelRequire("g01ln");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $h6MeC = parcelRequire("h6MeC");
class $1a4a07ebc6ca515d$export$c9ec999db8681a6a extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "onClickLearnMore", (learnMoreLink)=>()=>{
                this.props.fireAnalyticsEvent({
                    eventType: (0, $gaiog.ButtonClickedEvent),
                    actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_LEARN_MORE),
                    objectType: 'key',
                    objectId: this.props.instructionalApp.details.key
                });
                (0, $g01ln).openPage(learnMoreLink, "".concat(this.props.instructionalApp.details.key, "-learnMore"));
            });
        (0, $5zQU9.default)(this, "render", ()=>(0, $bWAru.Option).map2((0, $gGAJ8.nonEmptyList)(this.props.instructionalApp.steps), (0, $bWAru.Option).of(this.props.instructionalApp.learnMoreLink), (_, learnMoreLink)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9goJJ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bPByu.default), {
                    onClick: this.onClickLearnMore(learnMoreLink)
                }, "Learn more"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h6MeC.default), {
                    isDisabled: false,
                    onClick: this.props.closeInstallDialog
                }, "Cancel"))).getOrElseL(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bPByu.default), {
                    onClick: this.props.closeInstallDialog
                }, "Done")));
    }
}
var $1a4a07ebc6ca515d$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($1a4a07ebc6ca515d$export$c9ec999db8681a6a);

});


parcelRegister("iEdQ1", function(module, exports) {

$parcel$export(module.exports, "useLinkTemplates", () => $d936b25c153c9eb8$export$afba633b8038bced);

var $9fEFB = parcelRequire("9fEFB");

var $eUqFw = parcelRequire("eUqFw");
const $d936b25c153c9eb8$export$afba633b8038bced = (_ref)=>{
    let { adminHubBaseUrl: adminHubBaseUrl, mpacBaseUrl: mpacBaseUrl, mpacCdnBaseUrl: mpacCdnBaseUrl, macBaseUrl: macBaseUrl, wacBaseUrl: wacBaseUrl, atlassianCommunityBaseUrl: atlassianCommunityBaseUrl } = _ref;
    return (0, $eUqFw.useMemo)(()=>(0, $9fEFB.linkTemplates)({
            adminHubBaseUrl: adminHubBaseUrl,
            mpacBaseUrl: mpacBaseUrl,
            mpacCdnBaseUrl: mpacCdnBaseUrl,
            macBaseUrl: macBaseUrl,
            wacBaseUrl: wacBaseUrl,
            atlassianCommunityBaseUrl: atlassianCommunityBaseUrl
        }), [
        adminHubBaseUrl,
        mpacBaseUrl,
        mpacCdnBaseUrl,
        macBaseUrl,
        wacBaseUrl,
        atlassianCommunityBaseUrl
    ]);
};

});


parcelRegister("lOrRB", function(module, exports) {

$parcel$export(module.exports, "useMarketplaceAppInstall", () => $fe13e1977550ee54$export$691faccdcdea5ad7);

var $5zQU9 = parcelRequire("5zQU9");

var $e3rcq = parcelRequire("e3rcq");

var $dKnCb = parcelRequire("dKnCb");
var $f2QOW = parcelRequire("f2QOW");
var $9osuT = parcelRequire("9osuT");

var $jaVVd = parcelRequire("jaVVd");
var $buxnS = parcelRequire("buxnS");

var $inwKI = parcelRequire("inwKI");

var $fUOHe = parcelRequire("fUOHe");

var $cVLrH = parcelRequire("cVLrH");
var $iyohm = parcelRequire("iyohm");

var $6LpFI = parcelRequire("6LpFI");

var $ighTk = parcelRequire("ighTk");
var $1S6Gv = parcelRequire("1S6Gv");
var $bTrQR = parcelRequire("bTrQR");

var $eUqFw = parcelRequire("eUqFw");

var $iUPNF = parcelRequire("iUPNF");

var $7YbkQ = parcelRequire("7YbkQ");

var $7Uh51 = parcelRequire("7Uh51");

var $5JCOp = parcelRequire("5JCOp");

var $ifMZN = parcelRequire("ifMZN");

var $55gtq = parcelRequire("55gtq");

var $3lzNh = parcelRequire("3lzNh");

var $9IC13 = parcelRequire("9IC13");

var $hdXYz = parcelRequire("hdXYz");

var $2FnMA = parcelRequire("2FnMA");

var $5E4rM = parcelRequire("5E4rM");

var $1nC6Q = parcelRequire("1nC6Q");

var $8pHa5 = parcelRequire("8pHa5");

var $atCSv = parcelRequire("atCSv");

var $jKojs = parcelRequire("jKojs");

var $kNokf = parcelRequire("kNokf");

var $2bHSm = parcelRequire("2bHSm");
function $fe13e1977550ee54$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fe13e1977550ee54$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fe13e1977550ee54$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fe13e1977550ee54$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $fe13e1977550ee54$var$APP_INSTALLER_STATES = {
    INITIALIZED: 'INITIALIZED',
    DETERMINING: 'DETERMINING',
    AWAITING_USER_CONFIRMATION: 'AWAITING_USER_CONFIRMATION',
    INSTALL_IN_PROGRESS: 'INSTALL_IN_PROGRESS',
    INSTALL_SUCCESS: 'INSTALL_SUCCESS',
    INSTALL_FAILED: 'INSTALL_FAILED',
    INSTALL_DISMISSED: 'INSTALL_DISMISSED'
};
function $fe13e1977550ee54$export$691faccdcdea5ad7(spi, appInstallConfig, installLocation, vendorSupportTicketUrl) {
    const [installIdentifier, setInstallIdentifier] = (0, $eUqFw.useState)(null);
    const [appInstallerState, setAppInstallerState] = (0, $eUqFw.useState)($fe13e1977550ee54$var$APP_INSTALLER_STATES.INITIALIZED);
    const { installationState: installationState, dispatch: installationStateDispatch } = (0, $5E4rM.useInstallationLock)();
    const featureFlags = (0, $inwKI.useFeatureFlags)();
    const { hostInfo: hostInfo, hostConfig: hostConfig } = (0, $2bHSm.useHostData)();
    const currentUser = (0, $kNokf.useCurrentUser)();
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const installFeedbackConfigRef = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        if (hostInfo && currentUser !== null && currentUser !== void 0 && currentUser.atlassianAccountId) {
            (0, $7YbkQ.default).init(appInstallConfig, hostConfig, hostInfo);
            (0, $5JCOp.initializeBackends)(hostInfo, (0, $iyohm.makeUserId)(currentUser.atlassianAccountId));
        }
    }, [
        hostInfo,
        currentUser
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const isDev = appInstallConfig.environment === 'local' || appInstallConfig.environment === 'dev';
        const releaseVersion = "EMCEE_NATIVE_".concat((0, $iUPNF.default)).concat(isDev ? '-dev' : '');
        (0, $1S6Gv.initSentry)($fe13e1977550ee54$var$_objectSpread($fe13e1977550ee54$var$_objectSpread({}, appInstallConfig.sentryConfig), {}, {
            releaseVersion: releaseVersion,
            setupGlobalListeners: false
        }));
    }, [
        appInstallConfig
    ]);
    (0, $eUqFw.useMemo)(()=>(0, $55gtq.initSPI)(spi), [
        spi
    ]);
    (0, $eUqFw.useEffect)(()=>{
        var _getSentryClient;
        if (installIdentifier === null) return;
        (_getSentryClient = (0, $ighTk.default)()) === null || _getSentryClient === void 0 || _getSentryClient.setTag('installLocation', installLocation);
        return ()=>{
            var _getSentryClient2;
            (_getSentryClient2 = (0, $ighTk.default)()) === null || _getSentryClient2 === void 0 || _getSentryClient2.setTag('installLocation', undefined);
        };
    }, [
        installLocation,
        installIdentifier
    ]);
    const baseData = (0, $jKojs.useAppInstallBaseData)(appInstallConfig.mpacBaseUrl, appInstallConfig.graphQLGatewayUrl, appInstallConfig.environment, installIdentifier, hostInfo);
    const { fireEvent: fireEvent, analyticsContext: analyticsContext } = (0, $atCSv.useAppInstallAnalytics)({
        baseData: baseData,
        installLocation: installLocation
    });
    const handleInstallDialogRendered = ()=>{
        setAppInstallerState($fe13e1977550ee54$var$APP_INSTALLER_STATES.AWAITING_USER_CONFIRMATION);
        fireEvent.viewedScreen.awaitingUserConfirmation();
    };
    const handleAppInstallDialogClose = ()=>setAppInstallerState($fe13e1977550ee54$var$APP_INSTALLER_STATES.INSTALL_DISMISSED);
    const dismissInstallErrorFlag = (appIdentifier)=>setTimeout(()=>{
            var _installFeedbackConfi;
            return (_installFeedbackConfi = installFeedbackConfigRef.current) === null || _installFeedbackConfi === void 0 ? void 0 : _installFeedbackConfi.flags.dismiss((0, $2FnMA.appInstallFlagKeys).installError(appIdentifier));
        }, 0);
    const showAppInstallInProgressStatus = (appIdentifier, appName)=>{
        var _installFeedbackConfi2;
        (_installFeedbackConfi2 = installFeedbackConfigRef.current) === null || _installFeedbackConfi2 === void 0 || _installFeedbackConfi2.flags.show((0, $2FnMA.getInstallInProgressFlagProps)(appIdentifier, appName, (flagId)=>{
            var _installFeedbackConfi3;
            return (_installFeedbackConfi3 = installFeedbackConfigRef.current) === null || _installFeedbackConfi3 === void 0 ? void 0 : _installFeedbackConfi3.flags.dismiss(flagId);
        }));
    };
    const showAppInstallSuccessStatus = (appIdentifier, appName, installedAddon)=>{
        var _installFeedbackConfi4, _installFeedbackConfi5, _installFeedbackConfi6;
        (_installFeedbackConfi4 = installFeedbackConfigRef.current) === null || _installFeedbackConfi4 === void 0 || _installFeedbackConfi4.flags.show((0, $2FnMA.getInstallSuccessFlagProps)(appIdentifier, appName, installedAddon));
        (_installFeedbackConfi5 = installFeedbackConfigRef.current) === null || _installFeedbackConfi5 === void 0 || _installFeedbackConfi5.flags.dismiss((0, $2FnMA.appInstallFlagKeys).noSimultaneousInstalls());
        (_installFeedbackConfi6 = installFeedbackConfigRef.current) === null || _installFeedbackConfi6 === void 0 || _installFeedbackConfi6.flags.dismiss((0, $2FnMA.appInstallFlagKeys).inProgress(appIdentifier));
    };
    const showAppInstallFailureStatus = (_ref)=>{
        var _installFeedbackConfi7, _installFeedbackConfi9, _installFeedbackConfi10;
        let { appIdentifier: appIdentifier, installError: installError, appName: appName } = _ref;
        (_installFeedbackConfi7 = installFeedbackConfigRef.current) === null || _installFeedbackConfi7 === void 0 || _installFeedbackConfi7.flags.show((0, $2FnMA.getInstallErrorFlagProps)({
            appIdentifier: appIdentifier,
            hostConfig: hostConfig,
            installError: installError,
            featureFlags: featureFlags,
            appName: appName,
            onDismiss: ()=>{
                var _installFeedbackConfi8;
                return (_installFeedbackConfi8 = installFeedbackConfigRef.current) === null || _installFeedbackConfi8 === void 0 ? void 0 : _installFeedbackConfi8.flags.dismiss((0, $2FnMA.appInstallFlagKeys).installError(appIdentifier));
            },
            vendorSupportTicketUrl: vendorSupportTicketUrl
        }));
        (_installFeedbackConfi9 = installFeedbackConfigRef.current) === null || _installFeedbackConfi9 === void 0 || _installFeedbackConfi9.flags.dismiss((0, $2FnMA.appInstallFlagKeys).noSimultaneousInstalls());
        (_installFeedbackConfi10 = installFeedbackConfigRef.current) === null || _installFeedbackConfi10 === void 0 || _installFeedbackConfi10.flags.dismiss((0, $2FnMA.appInstallFlagKeys).inProgress(appIdentifier));
    };
    const showSimultaneousInstallAttemptedErrorStatus = ()=>{
        var _installFeedbackConfi11;
        (_installFeedbackConfi11 = installFeedbackConfigRef.current) === null || _installFeedbackConfi11 === void 0 || _installFeedbackConfi11.flags.show((0, $2FnMA.getSimultaneousInstallErrorFlagProps)());
    };
    const showAppInstallationBlockageErrorStatus = (appIdentifier)=>{
        var _installFeedbackConfi12;
        (_installFeedbackConfi12 = installFeedbackConfigRef.current) === null || _installFeedbackConfi12 === void 0 || _installFeedbackConfi12.flags.show((0, $2FnMA.getCCPBillingSystemErrorFlag)(appIdentifier));
    };
    const installInProgress = ()=>installationState.installationInProgressAppKey !== null;
    const isAppInstallationSupported = (installMode)=>(0, $buxnS.isFreeApp)(installMode.installableApp.marketplaceAppDetails.paymentModel) || baseData.result.hostData.hostLicense.billingSystem === (0, $cVLrH.BillingSystem).HAMS || baseData.result.hostData.hostLicense.billingSystem === (0, $cVLrH.BillingSystem).CCP;
    const allowRequestFromRegion = async ()=>{
        try {
            const geoDetails = await (0, $jaVVd.getCurrentGeoIPRegion)(appInstallConfig.mpacBaseUrl);
            const { countryCode: countryCode } = geoDetails;
            if ((0, $e3rcq.isCountryBlacklisted)(countryCode)) {
                fireAnalyticsEvent((0, $dKnCb.makeAnalyticsData)({
                    eventType: (0, $7Uh51.AppInstallBlockedForRussianUserEvent),
                    actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_RUSSIAN_USER_BLOCKED)
                }).toObject());
                (0, $bTrQR.default).info('useMarketplaceInstallApp', 'Prevented app install for Russia');
                return false;
            } else return true;
        } catch (error) {
            (0, $bTrQR.default).error('useMarketplaceAppInstall', "Failed to retrieve geoIP", {
                error: error
            });
            return true;
        }
    };
    const handleAppInstallClick = async (installableAppIdentifier)=>{
        var _installFeedbackConfi14, _installFeedbackConfi15, _installFeedbackConfi16;
        const { appIdentifier: appIdentifier, installMode: installMode, hostData: hostData } = baseData.result;
        if (!(0, $9IC13.installableAppIdentifiersAreEqual)(installMode.installableAppId, installableAppIdentifier)) {
            (0, $bTrQR.default).error('useMarketplaceAppInstall', 'App requested to be installed differs from installMode data');
            return;
        }
        if (!isAppInstallationSupported(installMode)) {
            setAppInstallerState($fe13e1977550ee54$var$APP_INSTALLER_STATES.INSTALL_FAILED);
            showAppInstallationBlockageErrorStatus(appIdentifier);
            return;
        }
        const appKey = (0, $8pHa5.getAppKeyFromInstallableAppIdentifier)(appIdentifier);
        const appName = installMode.installableApp.details.name;
        installationStateDispatch({
            type: 'set_install_in_progress',
            payload: {
                appKey: appKey
            }
        });
        setAppInstallerState($fe13e1977550ee54$var$APP_INSTALLER_STATES.INSTALL_IN_PROGRESS);
        if (featureFlags.disableAppInstall) {
            const allowRegionRequest = await allowRequestFromRegion();
            if (!allowRegionRequest) {
                var _installFeedbackConfi13;
                handleAppInstallDialogClose();
                installationStateDispatch({
                    type: 'clear_install_in_progress'
                });
                (_installFeedbackConfi13 = installFeedbackConfigRef.current) === null || _installFeedbackConfi13 === void 0 || _installFeedbackConfi13.flags.show((0, $e3rcq.flagConfigForRussianUsers));
                return;
            }
        }
        if (!((_installFeedbackConfi14 = installFeedbackConfigRef.current) !== null && _installFeedbackConfi14 !== void 0 && _installFeedbackConfi14.suppressProgressFlag)) showAppInstallInProgressStatus(appKey, appName);
        dismissInstallErrorFlag(appKey);
        (0, $3lzNh.AppInstallTask).start();
        (_installFeedbackConfi15 = installFeedbackConfigRef.current) === null || _installFeedbackConfi15 === void 0 || (_installFeedbackConfi16 = _installFeedbackConfi15.onInstallStarted) === null || _installFeedbackConfi16 === void 0 || _installFeedbackConfi16.call(_installFeedbackConfi15, {
            appKey: appKey,
            appName: appName
        });
        (0, $55gtq.default)().installAddon({
            identifier: (0, $ifMZN.toSPIInstallableAddonIdentifier)(appIdentifier),
            paymentModel: installMode.installableApp.marketplaceAppDetails.paymentModel
        }, {
            contextId: hostData.hostInfo.globalContext.workspaceAri,
            billing: {
                system: baseData.result.hostData.hostLicense.billingSystem
            },
            productName: baseData.result.hostData.hostInfo.product,
            cmtEligible: installMode.installableApp.cloudMigrationTrial.isEligible
        }, {
            retryForLicenseDetails: featureFlags.enableRetryForLicenseDetailsPostInstallation,
            /* Flag passed to trigger the app subscribe flow instead of the app install flow for paid Forge apps which are installed
      on HAMS sites but are unsubscribed.
      A separate flag is not passed for CCP since the endpoint called for install and subscribe are the same in the case of CCP sites.
      */ enableReactivateForgeAppFromEmcee: featureFlags.enableReactivateForgeAppFromEmceeForHAMS && baseData.result.hostData.hostLicense.billingSystem === (0, $cVLrH.BillingSystem).HAMS,
            enableDeprecatedInstallationsGQL: featureFlags.enableDeprecatedInstallationsGQL
        }).then((installedApp)=>{
            var _installFeedbackConfi17, _installFeedbackConfi18;
            showAppInstallSuccessStatus(appKey, appName, installedApp);
            (0, $3lzNh.AppInstallTask).succeeded();
            installationStateDispatch({
                type: 'installation_success',
                payload: {
                    installedApp: installedApp,
                    enableDeprecatedInstallationsGQL: featureFlags.enableDeprecatedInstallationsGQL
                }
            });
            setAppInstallerState($fe13e1977550ee54$var$APP_INSTALLER_STATES.INSTALL_SUCCESS);
            fireEvent.installSucceeded(appKey);
            (_installFeedbackConfi17 = installFeedbackConfigRef.current) === null || _installFeedbackConfi17 === void 0 || (_installFeedbackConfi18 = _installFeedbackConfi17.onInstallSuccess) === null || _installFeedbackConfi18 === void 0 || _installFeedbackConfi18.call(_installFeedbackConfi17, installedApp);
        }).catch((error)=>{
            var _installFeedbackConfi19, _installFeedbackConfi20;
            (0, $bTrQR.default).error('useMarketplaceAppInstall', "Failed to install the App", {
                error: error,
                tags: {
                    installLocation: installLocation
                }
            });
            showAppInstallFailureStatus({
                appIdentifier: appKey,
                installError: error,
                appName: appName
            });
            // Add error log to get the stack trace for the app install error code 12
            if (error.code === '12') (0, $bTrQR.default).error('useMarketplaceAppInstall', "App install failed for app ".concat(appKey, " with error code ").concat(error.code));
            (0, $9IC13.trackAppInstallTelemetryTaskError)(error);
            installationStateDispatch({
                type: 'clear_install_in_progress'
            });
            setAppInstallerState($fe13e1977550ee54$var$APP_INSTALLER_STATES.INSTALL_FAILED);
            fireEvent.installFailed(appKey, error);
            (_installFeedbackConfi19 = installFeedbackConfigRef.current) === null || _installFeedbackConfi19 === void 0 || (_installFeedbackConfi20 = _installFeedbackConfi19.onInstallFailure) === null || _installFeedbackConfi20 === void 0 || _installFeedbackConfi20.call(_installFeedbackConfi19, {
                appKey: appKey,
                appName: appName
            });
        }).finally(()=>setInstallIdentifier(null));
    };
    const onInstallClick = (installableAppIdentifier)=>{
        (0, $fUOHe.default).traceUFOPress('install-app');
        handleAppInstallClick(installableAppIdentifier);
    };
    const getInstallerElement = ()=>{
        var _installFeedbackConfi21, _installFeedbackConfi22;
        const showAppInstallDialog = appInstallerState === $fe13e1977550ee54$var$APP_INSTALLER_STATES.DETERMINING || appInstallerState === $fe13e1977550ee54$var$APP_INSTALLER_STATES.AWAITING_USER_CONFIRMATION || appInstallerState === $fe13e1977550ee54$var$APP_INSTALLER_STATES.INSTALL_IN_PROGRESS && ((_installFeedbackConfi21 = installFeedbackConfigRef.current) === null || _installFeedbackConfi21 === void 0 ? void 0 : _installFeedbackConfi21.suppressProgressFlag);
        const appKey = (0, $8pHa5.getAppKeyFromInstallIdentifier)(installIdentifier);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            id: "marketplace-app-installer-root"
        }, showAppInstallDialog && ((_installFeedbackConfi22 = installFeedbackConfigRef.current) === null || _installFeedbackConfi22 === void 0 ? void 0 : _installFeedbackConfi22.flags) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6LpFI.FlagsImplementationProvider), {
            value: {
                showFlag: installFeedbackConfigRef.current.flags.show,
                dismissFlag: installFeedbackConfigRef.current.flags.dismiss
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f2QOW.default), analyticsContext, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hdXYz.default), {
            appInstallConfig: appInstallConfig,
            appKey: appKey,
            onClose: handleAppInstallDialogClose,
            onRendered: handleInstallDialogRendered,
            onInstallClick: onInstallClick,
            baseData: baseData,
            isInstallInProgress: installInProgress
        }))));
    };
    const handleAppInstallStart = (appKey, installFeedbackConfig)=>{
        installFeedbackConfigRef.current = installFeedbackConfig;
        if (installInProgress()) {
            showSimultaneousInstallAttemptedErrorStatus();
            return;
        }
        if (typeof appKey === 'string') setInstallIdentifier((0, $1nC6Q.makeMarketplaceAppKeyIdentifier)(appKey));
        else setInstallIdentifier((0, $1nC6Q.makeInstallableAppKeyIdentifier)(appKey));
        setAppInstallerState($fe13e1977550ee54$var$APP_INSTALLER_STATES.DETERMINING);
        fireEvent.viewedScreen.determining();
    };
    return {
        installerElement: getInstallerElement(),
        installApp: handleAppInstallStart,
        installAppByInstallableIdentifier: handleAppInstallStart
    };
}

});
parcelRegister("e3rcq", function(module, exports) {

$parcel$export(module.exports, "flagConfigForRussianUsers", () => $a3b671ba29ce97fb$export$dec00d1652aa41c7);
$parcel$export(module.exports, "isCountryBlacklisted", () => $a3b671ba29ce97fb$export$1eed75c8ca844d5f);

var $bm7IM = parcelRequire("bm7IM");
const $a3b671ba29ce97fb$var$RUSSIA_ISO_CODE = 'RU';
const $a3b671ba29ce97fb$var$BELARUS_ISO_CODE = 'BY';
const $a3b671ba29ce97fb$var$BLACKLISTED_COUNTRIES = [
    $a3b671ba29ce97fb$var$RUSSIA_ISO_CODE,
    $a3b671ba29ce97fb$var$BELARUS_ISO_CODE
];
const $a3b671ba29ce97fb$var$MESSAGE_TITLE = "We stand with Ukraine";
const $a3b671ba29ce97fb$var$MESSAGE_DESCRIPTION = 'We have a commitment to our customers to provide a trusted service. Hence, we are pausing the sale of all new software to Russia and Belarus.';
const $a3b671ba29ce97fb$var$MESSAGE_LINK = 'https://www.atlassian.com/blog/announcements/atlassian-stands-with-ukraine';
const $a3b671ba29ce97fb$export$dec00d1652aa41c7 = {
    id: 'marketplace-app-install-blocked-region-denied-service',
    title: $a3b671ba29ce97fb$var$MESSAGE_TITLE,
    description: $a3b671ba29ce97fb$var$MESSAGE_DESCRIPTION,
    type: (0, $bm7IM.FLAG_TYPE_ERROR),
    isAutoDismiss: true,
    actions: [
        {
            content: 'Read the public blog',
            href: $a3b671ba29ce97fb$var$MESSAGE_LINK,
            target: '_blank'
        }
    ]
};
const $a3b671ba29ce97fb$export$1eed75c8ca844d5f = (countryCode)=>$a3b671ba29ce97fb$var$BLACKLISTED_COUNTRIES.some((blacklistedCountry)=>blacklistedCountry === countryCode);

});
parcelRegister("bm7IM", function(module, exports) {

$parcel$export(module.exports, "FLAG_TYPE_SUCCESS", () => $8447bd1290229122$export$1d0740fae54799e6);
$parcel$export(module.exports, "FLAG_TYPE_ERROR", () => $8447bd1290229122$export$b0516b50882e8fbc);
$parcel$export(module.exports, "FLAG_TYPE_INFO", () => $8447bd1290229122$export$f1471fc4e853391b);
$parcel$export(module.exports, "FLAG_TYPE_WARNING", () => $8447bd1290229122$export$3e8caae81220a92d);
const $8447bd1290229122$export$1d0740fae54799e6 = 'success';
const $8447bd1290229122$export$b0516b50882e8fbc = 'error';
const $8447bd1290229122$export$f1471fc4e853391b = 'info';
const $8447bd1290229122$export$3e8caae81220a92d = 'warning';
let $8447bd1290229122$export$ef846fa6d1318a9b = /*#__PURE__*/ function(TilesVariation) {
    TilesVariation["LARGE"] = "LARGE";
    TilesVariation["SMALL"] = "SMALL";
    return TilesVariation;
}({});
let $8447bd1290229122$export$581091871f506bfa = /*#__PURE__*/ function(HighlightedSectionVariation) {
    HighlightedSectionVariation["PROMINENT"] = "PROMINENT";
    return HighlightedSectionVariation;
}({});
let $8447bd1290229122$export$34b2fc32d759efd8 = /*#__PURE__*/ function(ProductMarketingGroupType) {
    ProductMarketingGroupType["COLLECTION"] = "COLLECTION";
    ProductMarketingGroupType["CATEGORY"] = "CATEGORY";
    return ProductMarketingGroupType;
}({});

});


parcelRegister("jaVVd", function(module, exports) {

$parcel$export(module.exports, "getCurrentGeoIPRegion", () => $df5be18c127b9147$export$c2d4a31573de5dfc);

var $dO8LH = parcelRequire("dO8LH");
const $df5be18c127b9147$export$c2d4a31573de5dfc = (mpacBaseUrl)=>(0, $dO8LH.fetchOk)("".concat(mpacBaseUrl, "/rest/2/geoip")).then((response)=>response.json());

});

parcelRegister("6LpFI", function(module, exports) {

$parcel$export(module.exports, "FlagsImplementationProvider", () => $4ecb0bc6f10c5668$export$26190d5d9037bc62);
$parcel$export(module.exports, "useFlagsImplementation", () => $4ecb0bc6f10c5668$export$91364bd08a3bf2df);

var $eUqFw = parcelRequire("eUqFw");
const $4ecb0bc6f10c5668$var$FlagsImplementationContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(null);
const $4ecb0bc6f10c5668$export$26190d5d9037bc62 = $4ecb0bc6f10c5668$var$FlagsImplementationContext.Provider;
function $4ecb0bc6f10c5668$export$91364bd08a3bf2df() {
    const context = (0, $eUqFw.useContext)($4ecb0bc6f10c5668$var$FlagsImplementationContext);
    if (context === undefined) throw new Error('useFlagsImplementation must be used within a FlagsImplementationProvider');
    return context;
}

});

parcelRegister("1S6Gv", function(module, exports) {

$parcel$export(module.exports, "initSentry", () => $15d004ff874d7070$export$f5ae3c4820871661);
$parcel$export(module.exports, "attachGlobalSentryListeners", () => $15d004ff874d7070$export$3e63e46a6b1c4e7e);
$parcel$export(module.exports, "detachSentryListeners", () => $15d004ff874d7070$export$f709362b9fa5f73d);

var $5zQU9 = parcelRequire("5zQU9");

var $fPzSk = parcelRequire("fPzSk");
var $jaeY6 = parcelRequire("jaeY6");
var $2gk4m = parcelRequire("2gk4m");
var $jLMZ4 = parcelRequire("jLMZ4");
var $jwnlf = parcelRequire("jwnlf");
var $fytMA = parcelRequire("fytMA");

var $HeIBQ = parcelRequire("HeIBQ");

var $4xrfU = parcelRequire("4xrfU");

var $cdSID = parcelRequire("cdSID");

var $7lvGB = parcelRequire("7lvGB");

var $ighTk = parcelRequire("ighTk");
function $15d004ff874d7070$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $15d004ff874d7070$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $15d004ff874d7070$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $15d004ff874d7070$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $15d004ff874d7070$var$getEmceePath() {
    if (window.location.href.includes('emcee')) return window.location.hash.split('#')[1];
}
const $15d004ff874d7070$var$getFormattedEventWithTags = (event)=>{
    let message = '';
    let tags = {};
    const args = event.message;
    const pathname = $15d004ff874d7070$var$getEmceePath();
    message = args.filter((arg)=>typeof arg === 'string' || arg.constructor !== Object).join(' ');
    tags = args.filter((arg)=>arg.constructor === Object).reduce((arg, tagsAccumulated)=>$15d004ff874d7070$var$_objectSpread($15d004ff874d7070$var$_objectSpread({}, tagsAccumulated), (0, $7lvGB.objectToPathValuePair)(arg)), {});
    $fytMA.withScope((scope)=>{
        scope.setExtra('arguments', args);
    });
    message = message || JSON.stringify(args);
    return $15d004ff874d7070$var$_objectSpread($15d004ff874d7070$var$_objectSpread($15d004ff874d7070$var$_objectSpread({}, event), pathname && {
        request: $15d004ff874d7070$var$_objectSpread($15d004ff874d7070$var$_objectSpread({}, event.request), {}, {
            url: pathname
        })
    }), {}, {
        message: message,
        // This is display error message in the header
        exception: message,
        tags: $15d004ff874d7070$var$_objectSpread($15d004ff874d7070$var$_objectSpread({}, event.tags), tags)
    });
};
const $15d004ff874d7070$var$beforeSend = (event)=>{
    const formattedEvent = Array.isArray(event.message) ? $15d004ff874d7070$var$getFormattedEventWithTags(event) : event;
    (0, $cdSID.default).add(formattedEvent.event_id);
    return formattedEvent;
};
const $15d004ff874d7070$var$ignoredHTTPTraffic = [
    /api.segment.io/,
    /google-analytics.com/,
    /https:\/\/xid\./,
    /pingdom.net/,
    /stats.g.doubleclick.net/,
    /api-private.atlassian.com\/gasv3/,
    /hn.inspectlet.com/,
    /events.launchdarkly.com/,
    /gateway\/api\/session\/heartbeat/,
    /logx.optimizely.com\/v1\/events/,
    /gateway\/api\/gasv3\/api\/v1/
];
const $15d004ff874d7070$var$beforeBreadcrumb = (crumb)=>{
    if (crumb.type === 'http' && $15d004ff874d7070$var$ignoredHTTPTraffic.some((denyUrl)=>denyUrl.test(crumb.data.url))) return false;
    return crumb;
};
async function $15d004ff874d7070$var$SHA256(message) {
    var _window$crypto;
    if (!((_window$crypto = window.crypto) !== null && _window$crypto !== void 0 && _window$crypto.subtle)) return;
    return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(message));
}
let $15d004ff874d7070$var$isCapturingGlobalErrors = false;
/**
 * Adds a prefix to exception messages
 */ function $15d004ff874d7070$var$prefixExceptionValue(event) {
    var _event$exception, _event$exception$valu;
    const exceptionValue = (_event$exception = event.exception) === null || _event$exception === void 0 ? void 0 : (_event$exception$valu = _event$exception.values) === null || _event$exception$valu === void 0 ? void 0 : _event$exception$valu[0].value;
    if (!exceptionValue) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4xrfU)))([
        'exception',
        'values',
        '0',
        'value'
    ])("[Marketplace] ".concat(exceptionValue))(event);
}
function $15d004ff874d7070$export$f5ae3c4820871661(sentryConfig) {
    let sentryInstance = (0, $ighTk.default)(false);
    if (sentryInstance) return sentryInstance;
    const integrations = sentryConfig.setupGlobalListeners ? [
        ...$jaeY6.defaultIntegrations,
        new (0, $HeIBQ.Integrations).BrowserTracing()
    ] : [
        ...$jaeY6.defaultIntegrations.filter((integration)=>integration.name !== 'GlobalHandlers'),
        new (0, $HeIBQ.Integrations).BrowserTracing()
    ];
    const tracesSampler = ()=>{
        if (sentryConfig.environment === 'production') return 0.5;
        return 1;
    };
    const sentryOptions = {
        dsn: sentryConfig.dsn,
        beforeBreadcrumb: $15d004ff874d7070$var$beforeBreadcrumb,
        environment: sentryConfig.environment,
        attachStacktrace: true,
        release: sentryConfig.releaseVersion,
        denyUrls: [
            /cdn.segment.com/
        ],
        beforeSend: $15d004ff874d7070$var$beforeSend,
        integrations: integrations,
        tracesSampler: tracesSampler,
        normalizeDepth: 5
    };
    if (sentryConfig.setupGlobalListeners) {
        $jaeY6.init(sentryOptions);
        // sentry init() internally creates a hub
        sentryInstance = (0, $ighTk.setSentryClient)($jLMZ4.getCurrentHub());
    } else {
        const client = new $fPzSk.BrowserClient($15d004ff874d7070$var$_objectSpread({
            transport: $jwnlf.makeFetchTransport,
            stackParser: $2gk4m.defaultStackParser,
            integrations: integrations
        }, sentryConfig));
        sentryInstance = (0, $ighTk.setSentryClient)(new $jLMZ4.Hub(client), true);
    }
    if (sentryConfig.productVersion) sentryInstance.setTag('productVersion', sentryConfig.productVersion);
    $15d004ff874d7070$var$isCapturingGlobalErrors = sentryConfig.setupGlobalListeners;
}
function $15d004ff874d7070$export$3e63e46a6b1c4e7e(onSentryEvent) {
    $15d004ff874d7070$var$isCapturingGlobalErrors = true;
    onSentryEvent((event)=>{
        var _event$tags, _event$tags2;
        if (!$15d004ff874d7070$var$isCapturingGlobalErrors) return;
        const hasBeenPreviouslyProcessed = ((_event$tags = event.tags) === null || _event$tags === void 0 ? void 0 : _event$tags.structuredLog) || ((_event$tags2 = event.tags) === null || _event$tags2 === void 0 ? void 0 : _event$tags2.processedError);
        const rewrittenEvent = $15d004ff874d7070$var$prefixExceptionValue(event);
        if (!hasBeenPreviouslyProcessed && rewrittenEvent) {
            rewrittenEvent.tags = $15d004ff874d7070$var$_objectSpread($15d004ff874d7070$var$_objectSpread({}, event.tags), {}, {
                processedError: 'true'
            });
            const sentryInstance = (0, $ighTk.default)(false);
            sentryInstance === null || sentryInstance === void 0 || sentryInstance.captureEvent(rewrittenEvent);
        }
    });
}
function $15d004ff874d7070$export$f709362b9fa5f73d() {
    $15d004ff874d7070$var$isCapturingGlobalErrors = false;
}
async function $15d004ff874d7070$export$55ca9de3e3dcdd17(id) {
    const saltedId = "KE3WvP2iYT14lIfa".concat(id, "ATtNdgf1Qhok0D9bhv");
    const userIdHashed = await $15d004ff874d7070$var$SHA256(saltedId);
    const sentryInstance = (0, $ighTk.default)();
    sentryInstance === null || sentryInstance === void 0 || sentryInstance.configureScope((scope)=>{
        scope.setUser({
            id: userIdHashed
        });
    });
}

});
parcelRegister("HeIBQ", function(module, exports) {

$parcel$export(module.exports, "Integrations", () => $081f6f0e43c5117f$export$99d02219d259eb94);

var $6gKsn = parcelRequire("6gKsn");
var $bv9YB = parcelRequire("bv9YB");
var $aYACQ = parcelRequire("aYACQ");
var $lpkeJ = parcelRequire("lpkeJ");
var $8szh8 = parcelRequire("8szh8");
var $3LZi0 = parcelRequire("3LZi0");
var $ebD1W = parcelRequire("ebD1W");
var $kWON5 = parcelRequire("kWON5");
var $9hRAY = parcelRequire("9hRAY");
var $26wej = parcelRequire("26wej");
var $571pR = parcelRequire("571pR");
var $he8el = parcelRequire("he8el");
var $d1Bxg = parcelRequire("d1Bxg");
var $fv3Z4 = parcelRequire("fv3Z4");
var $cIUeM = parcelRequire("cIUeM");
var $kBpSh = parcelRequire("kBpSh");
var $103Ol = parcelRequire("103Ol");
var $d4cKa = parcelRequire("d4cKa");
var $fTr2B = parcelRequire("fTr2B");
// BrowserTracing is already exported as part of `Integrations` below (and for the moment will remain so for
// backwards compatibility), but that interferes with treeshaking, so we also export it separately
// here.
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 * `BrowserTracing` can be imported from `@sentry/browser` or your framework SDK
 *
 * import { BrowserTracing } from '@sentry/browser';
 * new BrowserTracing()
 */ const $081f6f0e43c5117f$export$46d3bbd0375f5fa4 = (0, $aYACQ.BrowserTracing);
// BrowserTracing is already exported as part of `Integrations` below (and for the moment will remain so for
// backwards compatibility), but that interferes with treeshaking, so we also export it separately
// here.
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 * `BrowserTracing` can be imported from `@sentry/browser` or your framework SDK
 *
 * import { BrowserTracing } from '@sentry/browser';
 * new BrowserTracing()
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $081f6f0e43c5117f$export$5a20b45239a3c0a6 = (0, $6gKsn.addExtensionMethods);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `getActiveTransaction` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $081f6f0e43c5117f$export$a7feb32fdd923295 = (0, $ebD1W.getActiveTransaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `extractTraceparentData` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $081f6f0e43c5117f$export$8e9a29865c0a1226 = (0, $3LZi0.extractTraceparentData);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `spanStatusfromHttpCode` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $081f6f0e43c5117f$export$ac65c70d78fcdb55 = (0, $cIUeM.spanStatusfromHttpCode);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `SpanStatusType` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Transaction` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $081f6f0e43c5117f$export$febc5573c75cefb0 = (0, $fTr2B.Transaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Transaction` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Span` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $081f6f0e43c5117f$export$5f1714a13ed34c01 = (0, $cIUeM.Span);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Span` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $081f6f0e43c5117f$export$bbd2089f30bd3708 = (0, $aYACQ.BROWSER_TRACING_INTEGRATION_ID);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `defaultRequestInstrumentationOptions` can be imported from `@sentry/browser`, or your framework SDK
 */ const $081f6f0e43c5117f$export$cc17fb3c0bc95cd7 = (0, $lpkeJ.defaultRequestInstrumentationOptions);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `hasTracingEnabled` can be imported from `@sentry/utils`
 */ const $081f6f0e43c5117f$export$5008da00b1b6dee6 = (0, $9hRAY.hasTracingEnabled);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `stripUrlQueryAndFragment` can be imported from `@sentry/utils`
 */ const $081f6f0e43c5117f$export$ce084c78234bd35 = (0, $d4cKa.stripUrlQueryAndFragment);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `TRACEPARENT_REGEXP` can be imported from `@sentry/utils`
 */ const $081f6f0e43c5117f$export$394a210812ba3012 = (0, $3LZi0.TRACEPARENT_REGEXP);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $081f6f0e43c5117f$export$b279e6bd7040371f = (0, $26wej.IdleTransaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $081f6f0e43c5117f$export$864489cb3478db3e = (0, $lpkeJ.instrumentOutgoingRequests);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $081f6f0e43c5117f$export$479dbd817e392a4f = (0, $103Ol.startIdleTransaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ // eslint-disable-next-line deprecation/deprecation
const $081f6f0e43c5117f$export$beb8e6a823e89c5d = (0, $kBpSh.SpanStatus);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ // eslint-disable-next-line deprecation/deprecation
const $081f6f0e43c5117f$export$99d02219d259eb94 = {
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `BrowserTracing` can be imported from `@sentry/browser` or your framework SDK
   *
   * import { BrowserTracing } from '@sentry/browser';
   * new BrowserTracing()
   */ // eslint-disable-next-line deprecation/deprecation
    BrowserTracing: $081f6f0e43c5117f$export$46d3bbd0375f5fa4,
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Apollo` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Apollo({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Apollo: (0, $bv9YB.Apollo),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Express` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Express({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Express: (0, $8szh8.Express),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `GraphQL` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.GraphQL({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    GraphQL: (0, $kWON5.GraphQL),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Mongo` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Mongo({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Mongo: (0, $571pR.Mongo),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Mysql` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Mysql({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Mysql: (0, $he8el.Mysql),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Postgres` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Postgres({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Postgres: (0, $d1Bxg.Postgres),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Prisma` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Prisma({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Prisma: (0, $fv3Z4.Prisma)
};
// Treeshakable guard to remove all code related to tracing
// Guard for tree
if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) // We are patching the global object with our hub extension methods
(0, $6gKsn.addExtensionMethods)();

});
parcelRegister("6gKsn", function(module, exports) {

$parcel$export(module.exports, "addExtensionMethods", () => addExtensionMethods);

var $103Ol = parcelRequire("103Ol");
var $7Qe7s = parcelRequire("7Qe7s");

var $fEKkD = parcelRequire("fEKkD");
/**
 * @private
 */ function _autoloadDatabaseIntegrations() {
    const carrier = (0, $7Qe7s.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    const packageToIntegrationMapping = {
        mongodb () {
            const integration = (0, $fEKkD.dynamicRequire)(module, './node/integrations/mongo');
            return new integration.Mongo();
        },
        mongoose () {
            const integration = (0, $fEKkD.dynamicRequire)(module, './node/integrations/mongo');
            return new integration.Mongo({
                mongoose: true
            });
        },
        mysql () {
            const integration = (0, $fEKkD.dynamicRequire)(module, './node/integrations/mysql');
            return new integration.Mysql();
        },
        pg () {
            const integration = (0, $fEKkD.dynamicRequire)(module, './node/integrations/postgres');
            return new integration.Postgres();
        }
    };
    const mappedPackages = Object.keys(packageToIntegrationMapping).filter((moduleName)=>!!(0, $fEKkD.loadModule)(moduleName)).map((pkg)=>{
        try {
            return packageToIntegrationMapping[pkg]();
        } catch (e) {
            return undefined;
        }
    }).filter((p)=>p);
    if (mappedPackages.length > 0) carrier.__SENTRY__.integrations = [
        ...carrier.__SENTRY__.integrations || [],
        ...mappedPackages
    ];
}
/**
 * This patches the global object and injects the Tracing extensions methods
 */ function addExtensionMethods() {
    (0, $103Ol.addTracingExtensions)();
    // Detect and automatically load specified integrations.
    if ((0, $fEKkD.isNodeEnv)()) _autoloadDatabaseIntegrations();
}

});
parcelRegister("103Ol", function(module, exports) {

$parcel$export(module.exports, "startIdleTransaction", () => $0ba8bf5499097e04$export$479dbd817e392a4f);
$parcel$export(module.exports, "addTracingExtensions", () => $0ba8bf5499097e04$export$653d0ef2bad9cdf9);

var $k7rM9 = parcelRequire("k7rM9");
var $elKLM = parcelRequire("elKLM");

var $7Qe7s = parcelRequire("7Qe7s");

var $9hRAY = parcelRequire("9hRAY");

var $cXhcW = parcelRequire("cXhcW");

var $26wej = parcelRequire("26wej");

var $fTr2B = parcelRequire("fTr2B");
/** Returns all trace headers that are currently on the top scope. */ function $0ba8bf5499097e04$var$traceHeaders() {
    const scope = this.getScope();
    const span = scope.getSpan();
    return span ? {
        'sentry-trace': span.toTraceparent()
    } : {};
}
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * @param transaction: The transaction needing a sampling decision
 * @param options: The current client's options, so we can access `tracesSampleRate` and/or `tracesSampler`
 * @param samplingContext: Default and user-provided data which may be used to help make the decision
 *
 * @returns The given transaction with its `sampled` value set
 */ function $0ba8bf5499097e04$var$sample(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $9hRAY.hasTracingEnabled)(options)) {
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    if (transaction.sampled !== undefined) {
        transaction.setMetadata({
            sampleRate: Number(transaction.sampled)
        });
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setMetadata({
            sampleRate: Number(sampleRate)
        });
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') {
        sampleRate = options.tracesSampleRate;
        transaction.setMetadata({
            sampleRate: Number(sampleRate)
        });
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setMetadata({
            sampleRate: sampleRate
        });
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$0ba8bf5499097e04$var$isValidSampleRate(sampleRate)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn('[Tracing] Discarding transaction because of invalid sample rate.');
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    if (!transaction.sampled) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log(`[Tracing] starting ${transaction.op} transaction - ${transaction.name}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $0ba8bf5499097e04$var$isValidSampleRate(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $k7rM9.isNaN)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $0ba8bf5499097e04$var$_startTransaction(transactionContext, customSamplingContext) {
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || 'sentry';
    const transactionInstrumenter = transactionContext.instrumenter || 'sentry';
    if (configInstrumenter !== transactionInstrumenter) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        transactionContext.sampled = false;
    }
    let transaction = new (0, $fTr2B.Transaction)(transactionContext, this);
    transaction = $0ba8bf5499097e04$var$sample(transaction, options, {
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        ...customSamplingContext
    });
    if (transaction.sampled) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit('startTransaction', transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $0ba8bf5499097e04$export$479dbd817e392a4f(hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval) {
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    let transaction = new (0, $26wej.IdleTransaction)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope);
    transaction = $0ba8bf5499097e04$var$sample(transaction, options, {
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        ...customSamplingContext
    });
    if (transaction.sampled) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit('startTransaction', transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $0ba8bf5499097e04$export$653d0ef2bad9cdf9() {
    const carrier = (0, $7Qe7s.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $0ba8bf5499097e04$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $0ba8bf5499097e04$var$traceHeaders;
    (0, $cXhcW.registerErrorInstrumentation)();
}

});
parcelRegister("k7rM9", function(module, exports) {

$parcel$export(module.exports, "isError", () => $ea5a01c26e7e3a1f$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $ea5a01c26e7e3a1f$export$49034edbe6b62415);
$parcel$export(module.exports, "isString", () => $ea5a01c26e7e3a1f$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $ea5a01c26e7e3a1f$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $ea5a01c26e7e3a1f$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $ea5a01c26e7e3a1f$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $ea5a01c26e7e3a1f$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $ea5a01c26e7e3a1f$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $ea5a01c26e7e3a1f$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $ea5a01c26e7e3a1f$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $ea5a01c26e7e3a1f$export$c9f5652083b8129d);
// eslint-disable-next-line @typescript-eslint/unbound-method
const $ea5a01c26e7e3a1f$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ea5a01c26e7e3a1f$export$e6127cc7fe7395c3(wat) {
    switch($ea5a01c26e7e3a1f$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $ea5a01c26e7e3a1f$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $ea5a01c26e7e3a1f$var$isBuiltin(wat, className) {
    return $ea5a01c26e7e3a1f$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ea5a01c26e7e3a1f$export$9f9636d330b71954(wat) {
    return $ea5a01c26e7e3a1f$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ea5a01c26e7e3a1f$export$ef9e2056653f0c8e(wat) {
    return $ea5a01c26e7e3a1f$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ea5a01c26e7e3a1f$export$12e869b2a583f783(wat) {
    return $ea5a01c26e7e3a1f$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ea5a01c26e7e3a1f$export$844ec244b1367d54(wat) {
    return $ea5a01c26e7e3a1f$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ea5a01c26e7e3a1f$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ea5a01c26e7e3a1f$export$53b83ca8eaab0383(wat) {
    return $ea5a01c26e7e3a1f$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ea5a01c26e7e3a1f$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $ea5a01c26e7e3a1f$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ea5a01c26e7e3a1f$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $ea5a01c26e7e3a1f$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ea5a01c26e7e3a1f$export$49841c62b9eff15(wat) {
    return $ea5a01c26e7e3a1f$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $ea5a01c26e7e3a1f$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ea5a01c26e7e3a1f$export$bc2894c7158efbac(wat) {
    return $ea5a01c26e7e3a1f$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ea5a01c26e7e3a1f$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $ea5a01c26e7e3a1f$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});

parcelRegister("elKLM", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", () => $a7274e53d5c777ba$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "consoleSandbox", () => $a7274e53d5c777ba$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $a7274e53d5c777ba$export$af88d00dbe7f521);

var $dQTB1 = parcelRequire("dQTB1");
/** Prefix for logging strings */ const $a7274e53d5c777ba$var$PREFIX = 'Sentry Logger ';
const $a7274e53d5c777ba$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $a7274e53d5c777ba$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $dQTB1.GLOBAL_OBJ))) return callback();
    const originalConsole = (0, $dQTB1.GLOBAL_OBJ).console;
    const wrappedLevels = {};
    // Restore all wrapped console methods
    $a7274e53d5c777ba$export$2a2b1d2252a69ecb.forEach((level)=>{
        // TODO(v7): Remove this check as it's only needed for Node 6
        const originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in originalConsole && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach((level)=>{
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $a7274e53d5c777ba$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        }
    };
    if (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) $a7274e53d5c777ba$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $a7274e53d5c777ba$export$cda52e2a8927a2ca(()=>{
                (0, $dQTB1.GLOBAL_OBJ).console[name](`${$a7274e53d5c777ba$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $a7274e53d5c777ba$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
let $a7274e53d5c777ba$export$af88d00dbe7f521;
if (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) $a7274e53d5c777ba$export$af88d00dbe7f521 = (0, $dQTB1.getGlobalSingleton)('logger', $a7274e53d5c777ba$var$makeLogger);
else $a7274e53d5c777ba$export$af88d00dbe7f521 = $a7274e53d5c777ba$var$makeLogger();

});
parcelRegister("dQTB1", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", () => $a15b41f059b7d958$export$f1a6cdb1459e81d1);
$parcel$export(module.exports, "getGlobalObject", () => $a15b41f059b7d958$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $a15b41f059b7d958$export$7e223ec222791509);
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $a15b41f059b7d958$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $a15b41f059b7d958$export$f1a6cdb1459e81d1 = typeof globalThis == 'object' && $a15b41f059b7d958$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == 'object' && $a15b41f059b7d958$var$isGlobalObj(window) || typeof self == 'object' && $a15b41f059b7d958$var$isGlobalObj(self) || typeof $parcel$global == 'object' && $a15b41f059b7d958$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $a15b41f059b7d958$export$256479dc0cea61c4() {
    return $a15b41f059b7d958$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $a15b41f059b7d958$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $a15b41f059b7d958$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});


parcelRegister("7Qe7s", function(module, exports) {

$parcel$export(module.exports, "getMainCarrier", () => $5b5857818542040b$export$19eade501500c6c1);
$parcel$export(module.exports, "getCurrentHub", () => $5b5857818542040b$export$a07cdf6544bbd7c);

var $elKLM = parcelRequire("elKLM");
var $43Vyk = parcelRequire("43Vyk");
var $dQTB1 = parcelRequire("dQTB1");
var $fEKkD = parcelRequire("fEKkD");
var $aG8PM = parcelRequire("aG8PM");

var $94HCL = parcelRequire("94HCL");

var $drFYh = parcelRequire("drFYh");

var $8ureE = parcelRequire("8ureE");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $5b5857818542040b$export$24a86ef7798177e4 = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $5b5857818542040b$var$DEFAULT_BREADCRUMBS = 100;
/**
 * A layer in the process stack.
 * @hidden
 */ /**
 * @inheritDoc
 */ class $5b5857818542040b$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */ constructor(client, scope = new (0, $drFYh.Scope)(), _version = $5b5857818542040b$export$24a86ef7798177e4){
        this._version = _version;
        this._stack = [
            {
                scope: scope
            }
        ];
        if (client) this.bindClient(client);
    }
    /**
   * @inheritDoc
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * @inheritDoc
   */ bindClient(client) {
        const top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    }
    /**
   * @inheritDoc
   */ pushScope() {
        // We want to clone the content of prev scope
        const scope = (0, $drFYh.Scope).clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   */ popScope() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   */ withScope(callback) {
        const scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    }
    /**
   * @inheritDoc
   */ getClient() {
        return this.getStackTop().client;
    }
    /** Returns the scope of the top stack. */ getScope() {
        return this.getStackTop().scope;
    }
    /** Returns the scope stack for domains or the process. */ getStack() {
        return this._stack;
    }
    /** Returns the topmost scope layer in the order domain > local > process. */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $aG8PM.uuid4)();
        const syntheticException = new Error('Sentry syntheticException');
        this._withClient((client, scope)=>{
            client.captureException(exception, {
                originalException: exception,
                syntheticException: syntheticException,
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $aG8PM.uuid4)();
        const syntheticException = new Error(message);
        this._withClient((client, scope)=>{
            client.captureMessage(message, level, {
                originalException: message,
                syntheticException: syntheticException,
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $aG8PM.uuid4)();
        if (!event.type) this._lastEventId = eventId;
        this._withClient((client, scope)=>{
            client.captureEvent(event, {
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, hint) {
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $5b5857818542040b$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $43Vyk.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $elKLM.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        this.getScope().setUser(user);
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this.getScope().setTags(tags);
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this.getScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this.getScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this.getScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        this.getScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   */ configureScope(callback) {
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ run(callback) {
        const oldHub = $5b5857818542040b$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            $5b5857818542040b$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   */ getIntegration(integration) {
        const client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ startTransaction(context, customSamplingContext) {
        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
    }
    /**
   * @inheritDoc
   */ traceHeaders() {
        return this._callExtensionMethod('traceHeaders');
    }
    /**
   * @inheritDoc
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   */ endSession() {
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $8ureE.closeSession)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   */ startSession(context) {
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $94HCL.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $dQTB1.GLOBAL_OBJ).navigator || {};
        const session = (0, $8ureE.makeSession)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === 'ok') (0, $8ureE.updateSession)(currentSession, {
            status: 'exited'
        });
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */ shouldSendDefaultPii() {
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */ _withClient(callback) {
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(client, scope);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $5b5857818542040b$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $5b5857818542040b$export$19eade501500c6c1() {
    (0, $dQTB1.GLOBAL_OBJ).__SENTRY__ = (0, $dQTB1.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $dQTB1.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */ function $5b5857818542040b$export$4188a14ad302d1bc(hub) {
    const registry = $5b5857818542040b$export$19eade501500c6c1();
    const oldHub = $5b5857818542040b$export$bfa8a924a84a76b7(registry);
    $5b5857818542040b$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */ function $5b5857818542040b$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $5b5857818542040b$export$19eade501500c6c1();
    // If there's no hub, or its an old API, assign a new one
    if (!$5b5857818542040b$var$hasHubOnCarrier(registry) || $5b5857818542040b$export$bfa8a924a84a76b7(registry).isOlderThan($5b5857818542040b$export$24a86ef7798177e4)) $5b5857818542040b$export$849f05434e95d2f2(registry, new $5b5857818542040b$export$8c41bb232f1008b1());
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0, $fEKkD.isNodeEnv)()) return $5b5857818542040b$var$getHubFromActiveDomain(registry);
    // Return hub that lives on a global object
    return $5b5857818542040b$export$bfa8a924a84a76b7(registry);
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */ function $5b5857818542040b$var$getHubFromActiveDomain(registry) {
    try {
        const sentry = $5b5857818542040b$export$19eade501500c6c1().__SENTRY__;
        const activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) return $5b5857818542040b$export$bfa8a924a84a76b7(registry);
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!$5b5857818542040b$var$hasHubOnCarrier(activeDomain) || $5b5857818542040b$export$bfa8a924a84a76b7(activeDomain).isOlderThan($5b5857818542040b$export$24a86ef7798177e4)) {
            const registryHubTopStack = $5b5857818542040b$export$bfa8a924a84a76b7(registry).getStackTop();
            $5b5857818542040b$export$849f05434e95d2f2(activeDomain, new $5b5857818542040b$export$8c41bb232f1008b1(registryHubTopStack.client, (0, $drFYh.Scope).clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return $5b5857818542040b$export$bfa8a924a84a76b7(activeDomain);
    } catch (_Oo) {
        // Return hub that lives on a global object
        return $5b5857818542040b$export$bfa8a924a84a76b7(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $5b5857818542040b$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ function $5b5857818542040b$export$bfa8a924a84a76b7(carrier) {
    return (0, $dQTB1.getGlobalSingleton)('hub', ()=>new $5b5857818542040b$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ function $5b5857818542040b$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("43Vyk", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds);
$parcel$export(module.exports, "timestampInSeconds", () => timestampInSeconds);
$parcel$export(module.exports, "timestampWithMs", () => timestampWithMs);
$parcel$export(module.exports, "browserPerformanceTimeOrigin", () => browserPerformanceTimeOrigin);

var $fEKkD = parcelRequire("fEKkD");

var $dQTB1 = parcelRequire("dQTB1");
// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0, $dQTB1.getGlobalObject)();
/**
 * An object that can return the current timestamp in seconds since the UNIX epoch.
 */ /**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ const dateTimestampSource = {
    nowSeconds: ()=>Date.now() / 1000
};
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    const { performance } = WINDOW;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    const timeOrigin = Date.now() - performance.now();
    return {
        now: ()=>performance.now(),
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        const perfHooks = (0, $fEKkD.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ const platformPerformance = (0, $fEKkD.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
const timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: ()=>(platformPerformance.timeOrigin + platformPerformance.now()) / 1000
};
/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ const dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
// Re-exported with an old name for backwards-compatibility.
const timestampWithMs = timestampInSeconds;
/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */ const usingPerformanceAPI = platformPerformance !== undefined;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let _browserPerformanceTimeOriginMode;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const browserPerformanceTimeOrigin = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance } = WINDOW;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
})();

});
parcelRegister("fEKkD", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire);
$parcel$export(module.exports, "loadModule", () => loadModule);

var $5aT4e = parcelRequire("5aT4e");

var $2fFJv = parcelRequire("2fFJv");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $5aT4e.isBrowserBundle)() && Object.prototype.toString.call(typeof $2fFJv !== 'undefined' ? $2fFJv : 0) === '[object process]';
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        const { cwd } = dynamicRequire(module, 'process');
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("5aT4e", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", () => $3c489a1c020467c4$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $3c489a1c020467c4$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $3c489a1c020467c4$export$8ad33f488b1ab046() {
    // @ts-ignore "npm" is injected by rollup during build process
    return "npm";
}

});



parcelRegister("aG8PM", function(module, exports) {

$parcel$export(module.exports, "uuid4", () => $7c64ade93992989e$export$19f53698e68b2496);
$parcel$export(module.exports, "arrayify", () => $7c64ade93992989e$export$3131421a7d01b4fb);

var $3CK1O = parcelRequire("3CK1O");

var $4J3fm = parcelRequire("4J3fm");

var $dQTB1 = parcelRequire("dQTB1");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $7c64ade93992989e$export$19f53698e68b2496() {
    const gbl = (0, $dQTB1.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
    const getRandomByte = crypto && crypto.getRandomValues ? ()=>crypto.getRandomValues(new Uint8Array(1))[0] : ()=>Math.random() * 16;
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $7c64ade93992989e$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $7c64ade93992989e$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $7c64ade93992989e$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $7c64ade93992989e$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $7c64ade93992989e$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $7c64ade93992989e$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $7c64ade93992989e$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $7c64ade93992989e$export$d364f2020ab30578(input) {
    const match = input.match($7c64ade93992989e$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $7c64ade93992989e$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $4J3fm.snipLine)(line, 0));
    frame.context_line = (0, $4J3fm.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $4J3fm.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $7c64ade93992989e$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $3CK1O.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $7c64ade93992989e$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

});
parcelRegister("3CK1O", function(module, exports) {

$parcel$export(module.exports, "fill", () => $2a389ff2091c49a1$export$9563e054e6f787fb);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $2a389ff2091c49a1$export$e73679ffaf56810e);
$parcel$export(module.exports, "convertToPlainObject", () => $2a389ff2091c49a1$export$62ff257738bf57f5);
$parcel$export(module.exports, "dropUndefinedKeys", () => $2a389ff2091c49a1$export$d25f2688db1bb433);

var $c12av = parcelRequire("c12av");

var $k7rM9 = parcelRequire("k7rM9");

var $4J3fm = parcelRequire("4J3fm");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $2a389ff2091c49a1$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $2a389ff2091c49a1$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $2a389ff2091c49a1$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $2a389ff2091c49a1$export$5c1499e2e5d010ae(wrapped, original) {
    const proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $2a389ff2091c49a1$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $2a389ff2091c49a1$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $2a389ff2091c49a1$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join('&');
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $2a389ff2091c49a1$export$62ff257738bf57f5(value) {
    if ((0, $k7rM9.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$2a389ff2091c49a1$var$getOwnProperties(value)
    };
    else if ((0, $k7rM9.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $2a389ff2091c49a1$var$serializeEventTarget(value.target),
            currentTarget: $2a389ff2091c49a1$var$serializeEventTarget(value.currentTarget),
            ...$2a389ff2091c49a1$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $k7rM9.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $2a389ff2091c49a1$var$serializeEventTarget(target) {
    try {
        return (0, $k7rM9.isElement)(target) ? (0, $c12av.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $2a389ff2091c49a1$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $2a389ff2091c49a1$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($2a389ff2091c49a1$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $4J3fm.truncate)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $4J3fm.truncate)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $2a389ff2091c49a1$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $2a389ff2091c49a1$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $2a389ff2091c49a1$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ((0, $k7rM9.isPlainObject)(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== 'undefined') returnValue[key] = $2a389ff2091c49a1$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($2a389ff2091c49a1$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $2a389ff2091c49a1$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $k7rM9.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("c12av", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", () => $8bf742a186aee709$export$5647df6b7814ac86);
$parcel$export(module.exports, "getDomElement", () => $8bf742a186aee709$export$c660c1f3ab49225c);

var $k7rM9 = parcelRequire("k7rM9");

var $dQTB1 = parcelRequire("dQTB1");
// eslint-disable-next-line deprecation/deprecation
const $8bf742a186aee709$var$WINDOW = (0, $dQTB1.getGlobalObject)();
const $8bf742a186aee709$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $8bf742a186aee709$export$5647df6b7814ac86(elem, options = {}) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $8bf742a186aee709$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $8bf742a186aee709$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $8bf742a186aee709$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $k7rM9.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $8bf742a186aee709$export$1cfafeee2987818b() {
    try {
        return $8bf742a186aee709$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8bf742a186aee709$export$c660c1f3ab49225c(selector) {
    if ($8bf742a186aee709$var$WINDOW.document && $8bf742a186aee709$var$WINDOW.document.querySelector) return $8bf742a186aee709$var$WINDOW.document.querySelector(selector);
    return null;
}

});

parcelRegister("4J3fm", function(module, exports) {

$parcel$export(module.exports, "truncate", () => $370de222704f04cc$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $370de222704f04cc$export$4215662d762d6f9d);
$parcel$export(module.exports, "stringMatchesSomePattern", () => $370de222704f04cc$export$a7a5ec66062ea5d);

var $k7rM9 = parcelRequire("k7rM9");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $370de222704f04cc$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $370de222704f04cc$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $370de222704f04cc$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $370de222704f04cc$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $k7rM9.isString)(value)) return false;
    if ((0, $k7rM9.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $k7rM9.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $370de222704f04cc$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$370de222704f04cc$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRegister("94HCL", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", () => $69b6539f233067c3$export$849dbeeeda01ae98);
const $69b6539f233067c3$export$849dbeeeda01ae98 = 'production';

});

parcelRegister("drFYh", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $9c9e5a93b8a75971$export$775b6bb06e53a214);

var $aG8PM = parcelRequire("aG8PM");
var $43Vyk = parcelRequire("43Vyk");
var $dQTB1 = parcelRequire("dQTB1");
var $k7rM9 = parcelRequire("k7rM9");
var $elKLM = parcelRequire("elKLM");
var $f2NIL = parcelRequire("f2NIL");

var $8ureE = parcelRequire("8ureE");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $9c9e5a93b8a75971$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $9c9e5a93b8a75971$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /** Transaction Name */ /** Span */ /** Session */ /** Request Mode Session Status */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
    }
    /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */ static clone(scope) {
        const newScope = new $9c9e5a93b8a75971$export$775b6bb06e53a214();
        if (scope) {
            newScope._breadcrumbs = [
                ...scope._breadcrumbs
            ];
            newScope._tags = {
                ...scope._tags
            };
            newScope._extra = {
                ...scope._extra
            };
            newScope._contexts = {
                ...scope._contexts
            };
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = [
                ...scope._eventProcessors
            ];
            newScope._requestSession = scope._requestSession;
            newScope._attachments = [
                ...scope._attachments
            ];
            newScope._sdkProcessingMetadata = {
                ...scope._sdkProcessingMetadata
            };
        }
        return newScope;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        this._user = user || {};
        if (this._session) (0, $8ureE.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSpan() {
        return this._span;
    }
    /**
   * @inheritDoc
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this.getSpan();
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === 'function') {
            const updatedScope = captureContext(this);
            return updatedScope instanceof $9c9e5a93b8a75971$export$775b6bb06e53a214 ? updatedScope : this;
        }
        if (captureContext instanceof $9c9e5a93b8a75971$export$775b6bb06e53a214) {
            this._tags = {
                ...this._tags,
                ...captureContext._tags
            };
            this._extra = {
                ...this._extra,
                ...captureContext._extra
            };
            this._contexts = {
                ...this._contexts,
                ...captureContext._contexts
            };
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
            if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
        } else if ((0, $k7rM9.isPlainObject)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext;
            this._tags = {
                ...this._tags,
                ...captureContext.tags
            };
            this._extra = {
                ...this._extra,
                ...captureContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...captureContext.contexts
            };
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
            if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $9c9e5a93b8a75971$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $43Vyk.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        this._breadcrumbs = [
            ...this._breadcrumbs,
            mergedBreadcrumb
        ].slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   */ getAttachments() {
        return this._attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   */ applyToEvent(event, hint = {}) {
        if (this._extra && Object.keys(this._extra).length) event.extra = {
            ...this._extra,
            ...event.extra
        };
        if (this._tags && Object.keys(this._tags).length) event.tags = {
            ...this._tags,
            ...event.tags
        };
        if (this._user && Object.keys(this._user).length) event.user = {
            ...this._user,
            ...event.user
        };
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = {
            ...this._contexts,
            ...event.contexts
        };
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = {
                trace: this._span.getTraceContext(),
                ...event.contexts
            };
            const transactionName = this._span.transaction && this._span.transaction.name;
            if (transactionName) event.tags = {
                transaction: transactionName,
                ...event.tags
            };
        }
        this._applyFingerprint(event);
        event.breadcrumbs = [
            ...event.breadcrumbs || [],
            ...this._breadcrumbs
        ];
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = {
            ...event.sdkProcessingMetadata,
            ...this._sdkProcessingMetadata
        };
        return this._notifyEventProcessors([
            ...$9c9e5a93b8a75971$var$getGlobalEventProcessors(),
            ...this._eventProcessors
        ], event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * This will be called after {@link applyToEvent} is finished.
   */ _notifyEventProcessors(processors, event, hint, index = 0) {
        return new (0, $f2NIL.SyncPromise)((resolve, reject)=>{
            const processor = processors[index];
            if (event === null || typeof processor !== 'function') resolve(event);
            else {
                const result = processor({
                    ...event
                }, hint);
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && processor.id && result === null && (0, $elKLM.logger).log(`Event processor "${processor.id}" dropped event`);
                if ((0, $k7rM9.isThenable)(result)) result.then((final)=>this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve)).then(null, reject);
                else this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        });
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
    /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */ _applyFingerprint(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? (0, $aG8PM.arrayify)(event.fingerprint) : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    }
}
/**
 * Returns the global event processors.
 */ function $9c9e5a93b8a75971$var$getGlobalEventProcessors() {
    return (0, $dQTB1.getGlobalSingleton)('globalEventProcessors', ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */ function $9c9e5a93b8a75971$export$8e4e25f54d456511(callback) {
    $9c9e5a93b8a75971$var$getGlobalEventProcessors().push(callback);
}

});
parcelRegister("f2NIL", function(module, exports) {

$parcel$export(module.exports, "SyncPromise", () => $af3d9c7da797ccef$export$6f292d4960313241);

var $k7rM9 = parcelRequire("k7rM9");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $af3d9c7da797ccef$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($af3d9c7da797ccef$var$States || ($af3d9c7da797ccef$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $af3d9c7da797ccef$export$1fda8aa4d135f8aa(value) {
    return new $af3d9c7da797ccef$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $af3d9c7da797ccef$export$78e43115b553f358(reason) {
    return new $af3d9c7da797ccef$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $af3d9c7da797ccef$export$6f292d4960313241 {
    __init() {
        this._state = $af3d9c7da797ccef$var$States.PENDING;
    }
    __init2() {
        this._handlers = [];
    }
    constructor(executor){
        $af3d9c7da797ccef$export$6f292d4960313241.prototype.__init.call(this);
        $af3d9c7da797ccef$export$6f292d4960313241.prototype.__init2.call(this);
        $af3d9c7da797ccef$export$6f292d4960313241.prototype.__init3.call(this);
        $af3d9c7da797ccef$export$6f292d4960313241.prototype.__init4.call(this);
        $af3d9c7da797ccef$export$6f292d4960313241.prototype.__init5.call(this);
        $af3d9c7da797ccef$export$6f292d4960313241.prototype.__init6.call(this);
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $af3d9c7da797ccef$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $af3d9c7da797ccef$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init3() {
        this._resolve = (value)=>{
            this._setResult($af3d9c7da797ccef$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init4() {
        this._reject = (reason)=>{
            this._setResult($af3d9c7da797ccef$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init5() {
        this._setResult = (state, value)=>{
            if (this._state !== $af3d9c7da797ccef$var$States.PENDING) return;
            if ((0, $k7rM9.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init6() {
        this._executeHandlers = ()=>{
            if (this._state === $af3d9c7da797ccef$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $af3d9c7da797ccef$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $af3d9c7da797ccef$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}

});

parcelRegister("8ureE", function(module, exports) {

$parcel$export(module.exports, "makeSession", () => $62e64069fcf5bf2c$export$14a186326edbb264);
$parcel$export(module.exports, "updateSession", () => $62e64069fcf5bf2c$export$531818e825e774db);
$parcel$export(module.exports, "closeSession", () => $62e64069fcf5bf2c$export$56521d9ba90f62ee);

var $3CK1O = parcelRequire("3CK1O");
var $43Vyk = parcelRequire("43Vyk");
var $aG8PM = parcelRequire("aG8PM");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $62e64069fcf5bf2c$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $43Vyk.timestampInSeconds)();
    const session = {
        sid: (0, $aG8PM.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$62e64069fcf5bf2c$var$sessionToJSON(session)
    };
    if (context) $62e64069fcf5bf2c$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $62e64069fcf5bf2c$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $43Vyk.timestampInSeconds)();
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $aG8PM.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $62e64069fcf5bf2c$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $62e64069fcf5bf2c$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $62e64069fcf5bf2c$var$sessionToJSON(session) {
    return (0, $3CK1O.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});



parcelRegister("9hRAY", function(module, exports) {

$parcel$export(module.exports, "hasTracingEnabled", () => $6c2f46828a8a05a8$export$5008da00b1b6dee6);

var $7Qe7s = parcelRequire("7Qe7s");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $6c2f46828a8a05a8$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const client = (0, $7Qe7s.getCurrentHub)().getClient();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}

});

parcelRegister("cXhcW", function(module, exports) {

$parcel$export(module.exports, "registerErrorInstrumentation", () => $96e857ce9486361b$export$637857c1d87b640c);

var $lChn2 = parcelRequire("lChn2");
var $elKLM = parcelRequire("elKLM");

var $ebD1W = parcelRequire("ebD1W");
let $96e857ce9486361b$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $96e857ce9486361b$export$637857c1d87b640c() {
    if ($96e857ce9486361b$var$errorsInstrumented) return;
    $96e857ce9486361b$var$errorsInstrumented = true;
    (0, $lChn2.addInstrumentationHandler)('error', $96e857ce9486361b$var$errorCallback);
    (0, $lChn2.addInstrumentationHandler)('unhandledrejection', $96e857ce9486361b$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $96e857ce9486361b$var$errorCallback() {
    const activeTransaction = (0, $ebD1W.getActiveTransaction)();
    if (activeTransaction) {
        const status = 'internal_error';
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$96e857ce9486361b$var$errorCallback.tag = 'sentry_tracingErrorCallback';

});
parcelRegister("lChn2", function(module, exports) {

$parcel$export(module.exports, "addInstrumentationHandler", () => $fbca9f0141e13736$export$285b9172a3741fb7);

var $k7rM9 = parcelRequire("k7rM9");

var $elKLM = parcelRequire("elKLM");

var $3CK1O = parcelRequire("3CK1O");

var $8yub9 = parcelRequire("8yub9");

var $7VirA = parcelRequire("7VirA");

var $dQTB1 = parcelRequire("dQTB1");

var $2t4YI = parcelRequire("2t4YI");
// eslint-disable-next-line deprecation/deprecation
const $fbca9f0141e13736$var$WINDOW = (0, $dQTB1.getGlobalObject)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ const $fbca9f0141e13736$var$handlers = {};
const $fbca9f0141e13736$var$instrumented = {};
/** Instruments given API */ function $fbca9f0141e13736$var$instrument(type) {
    if ($fbca9f0141e13736$var$instrumented[type]) return;
    $fbca9f0141e13736$var$instrumented[type] = true;
    switch(type){
        case 'console':
            $fbca9f0141e13736$var$instrumentConsole();
            break;
        case 'dom':
            $fbca9f0141e13736$var$instrumentDOM();
            break;
        case 'xhr':
            $fbca9f0141e13736$var$instrumentXHR();
            break;
        case 'fetch':
            $fbca9f0141e13736$var$instrumentFetch();
            break;
        case 'history':
            $fbca9f0141e13736$var$instrumentHistory();
            break;
        case 'error':
            $fbca9f0141e13736$var$instrumentError();
            break;
        case 'unhandledrejection':
            $fbca9f0141e13736$var$instrumentUnhandledRejection();
            break;
        default:
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn('unknown instrumentation type:', type);
            return;
    }
}
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $fbca9f0141e13736$export$285b9172a3741fb7(type, callback) {
    $fbca9f0141e13736$var$handlers[type] = $fbca9f0141e13736$var$handlers[type] || [];
    $fbca9f0141e13736$var$handlers[type].push(callback);
    $fbca9f0141e13736$var$instrument(type);
}
/** JSDoc */ function $fbca9f0141e13736$var$triggerHandlers(type, data) {
    if (!type || !$fbca9f0141e13736$var$handlers[type]) return;
    for (const handler of $fbca9f0141e13736$var$handlers[type] || [])try {
        handler(data);
    } catch (e) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $8yub9.getFunctionName)(handler)}\nError:`, e);
    }
}
/** JSDoc */ function $fbca9f0141e13736$var$instrumentConsole() {
    if (!('console' in $fbca9f0141e13736$var$WINDOW)) return;
    (0, $elKLM.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in $fbca9f0141e13736$var$WINDOW.console)) return;
        (0, $3CK1O.fill)($fbca9f0141e13736$var$WINDOW.console, level, function(originalConsoleMethod) {
            return function(...args) {
                $fbca9f0141e13736$var$triggerHandlers('console', {
                    args: args,
                    level: level
                });
                // this fails for some browsers. :(
                if (originalConsoleMethod) originalConsoleMethod.apply($fbca9f0141e13736$var$WINDOW.console, args);
            };
        });
    });
}
/** JSDoc */ function $fbca9f0141e13736$var$instrumentFetch() {
    if (!(0, $7VirA.supportsNativeFetch)()) return;
    (0, $3CK1O.fill)($fbca9f0141e13736$var$WINDOW, 'fetch', function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $fbca9f0141e13736$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            $fbca9f0141e13736$var$triggerHandlers('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply($fbca9f0141e13736$var$WINDOW, args).then((response)=>{
                $fbca9f0141e13736$var$triggerHandlers('fetch', {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                });
                return response;
            }, (error)=>{
                $fbca9f0141e13736$var$triggerHandlers('fetch', {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                });
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $fbca9f0141e13736$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $fbca9f0141e13736$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($fbca9f0141e13736$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request
 */ function $fbca9f0141e13736$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $fbca9f0141e13736$var$getUrlFromResource(url),
            method: $fbca9f0141e13736$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $fbca9f0141e13736$var$getUrlFromResource(arg),
        method: $fbca9f0141e13736$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}
/** JSDoc */ function $fbca9f0141e13736$var$instrumentXHR() {
    if (!('XMLHttpRequest' in $fbca9f0141e13736$var$WINDOW)) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $3CK1O.fill)(xhrproto, 'open', function(originalOpen) {
        return function(...args) {
            const url = args[1];
            const xhrInfo = this.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, $k7rM9.isString)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1],
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, $k7rM9.isString)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this.__sentry_xhr__;
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    $fbca9f0141e13736$var$triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: this
                    });
                }
            };
            if ('onreadystatechange' in this && typeof this.onreadystatechange === 'function') (0, $3CK1O.fill)(this, 'onreadystatechange', function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $3CK1O.fill)(this, 'setRequestHeader', function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this.__sentry_xhr__;
                    if (xhrInfo) xhrInfo.request_headers[header] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $3CK1O.fill)(xhrproto, 'send', function(originalSend) {
        return function(...args) {
            if (this.__sentry_xhr__ && args[0] !== undefined) this.__sentry_xhr__.body = args[0];
            $fbca9f0141e13736$var$triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
let $fbca9f0141e13736$var$lastHref;
/** JSDoc */ function $fbca9f0141e13736$var$instrumentHistory() {
    if (!(0, $2t4YI.supportsHistory)()) return;
    const oldOnPopState = $fbca9f0141e13736$var$WINDOW.onpopstate;
    $fbca9f0141e13736$var$WINDOW.onpopstate = function(...args) {
        const to = $fbca9f0141e13736$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $fbca9f0141e13736$var$lastHref;
        $fbca9f0141e13736$var$lastHref = to;
        $fbca9f0141e13736$var$triggerHandlers('history', {
            from: from,
            to: to
        });
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $fbca9f0141e13736$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $fbca9f0141e13736$var$lastHref = to;
                $fbca9f0141e13736$var$triggerHandlers('history', {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $3CK1O.fill)($fbca9f0141e13736$var$WINDOW.history, 'pushState', historyReplacementFunction);
    (0, $3CK1O.fill)($fbca9f0141e13736$var$WINDOW.history, 'replaceState', historyReplacementFunction);
}
const $fbca9f0141e13736$var$debounceDuration = 1000;
let $fbca9f0141e13736$var$debounceTimerID;
let $fbca9f0141e13736$var$lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */ function $fbca9f0141e13736$var$shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) return true;
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) return true;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) return true;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $fbca9f0141e13736$var$shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') return false;
    try {
        const target = event.target;
        if (!target || !target.tagName) return true;
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $fbca9f0141e13736$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || $fbca9f0141e13736$var$lastCapturedEvent === event) return;
        // We always want to skip _some_ events.
        if ($fbca9f0141e13736$var$shouldSkipDOMEvent(event)) return;
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if ($fbca9f0141e13736$var$debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $fbca9f0141e13736$var$lastCapturedEvent = event;
        } else if ($fbca9f0141e13736$var$shouldShortcircuitPreviousDebounce($fbca9f0141e13736$var$lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $fbca9f0141e13736$var$lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($fbca9f0141e13736$var$debounceTimerID);
        $fbca9f0141e13736$var$debounceTimerID = $fbca9f0141e13736$var$WINDOW.setTimeout(()=>{
            $fbca9f0141e13736$var$debounceTimerID = undefined;
        }, $fbca9f0141e13736$var$debounceDuration);
    };
}
/** JSDoc */ function $fbca9f0141e13736$var$instrumentDOM() {
    if (!('document' in $fbca9f0141e13736$var$WINDOW)) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = $fbca9f0141e13736$var$triggerHandlers.bind(null, 'dom');
    const globalDOMEventHandler = $fbca9f0141e13736$var$makeDOMEventHandler(triggerDOMHandler, true);
    $fbca9f0141e13736$var$WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
    $fbca9f0141e13736$var$WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $fbca9f0141e13736$var$WINDOW[target] && $fbca9f0141e13736$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $3CK1O.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $fbca9f0141e13736$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $3CK1O.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
let $fbca9f0141e13736$var$_oldOnErrorHandler = null;
/** JSDoc */ function $fbca9f0141e13736$var$instrumentError() {
    $fbca9f0141e13736$var$_oldOnErrorHandler = $fbca9f0141e13736$var$WINDOW.onerror;
    $fbca9f0141e13736$var$WINDOW.onerror = function(msg, url, line, column, error) {
        $fbca9f0141e13736$var$triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($fbca9f0141e13736$var$_oldOnErrorHandler && !$fbca9f0141e13736$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $fbca9f0141e13736$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    $fbca9f0141e13736$var$WINDOW.onerror.__SENTRY_INSTRUMENTED__ = true;
}
let $fbca9f0141e13736$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $fbca9f0141e13736$var$instrumentUnhandledRejection() {
    $fbca9f0141e13736$var$_oldOnUnhandledRejectionHandler = $fbca9f0141e13736$var$WINDOW.onunhandledrejection;
    $fbca9f0141e13736$var$WINDOW.onunhandledrejection = function(e) {
        $fbca9f0141e13736$var$triggerHandlers('unhandledrejection', e);
        if ($fbca9f0141e13736$var$_oldOnUnhandledRejectionHandler && !$fbca9f0141e13736$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $fbca9f0141e13736$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    $fbca9f0141e13736$var$WINDOW.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});
parcelRegister("8yub9", function(module, exports) {

$parcel$export(module.exports, "getFunctionName", () => $63a8e898f1509e2a$export$aad197c7121a6651);

var $hvdHR = parcelRequire("hvdHR");
const $63a8e898f1509e2a$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $63a8e898f1509e2a$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $63a8e898f1509e2a$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $63a8e898f1509e2a$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($63a8e898f1509e2a$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $63a8e898f1509e2a$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $63a8e898f1509e2a$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $63a8e898f1509e2a$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $63a8e898f1509e2a$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $63a8e898f1509e2a$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = stack.slice(0, $63a8e898f1509e2a$var$STACKTRACE_FRAME_LIMIT);
    const lastFrameFunction = localStack[localStack.length - 1].function;
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (lastFrameFunction && /sentryWrapped/.test(lastFrameFunction)) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    const firstFrameFunction = localStack[localStack.length - 1].function;
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (firstFrameFunction && /captureMessage|captureException/.test(firstFrameFunction)) localStack.pop();
    return localStack.map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || '?'
        }));
}
const $63a8e898f1509e2a$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $63a8e898f1509e2a$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $63a8e898f1509e2a$var$defaultFunctionName;
        return fn.name || $63a8e898f1509e2a$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $63a8e898f1509e2a$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $63a8e898f1509e2a$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $hvdHR.node)(getModule)
    ];
}

});
parcelRegister("hvdHR", function(module, exports) {

$parcel$export(module.exports, "node", () => $cbdff6bfb5826762$export$35059013cd4a06db);
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $cbdff6bfb5826762$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf('.');
                if (functionName[methodStart - 1] === '.') methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf('.Module');
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === '<anonymous>') {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || '<anonymous>';
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith('file://') ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === 'native';
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            const isInternal = isNative || filename && !filename.startsWith('/') && !filename.startsWith('.') && !filename.includes(':\\');
            // in_app is all that's not an internal Node function or a module within node_modules
            // note that isNative appears to return true even for node core libraries
            // see https://github.com/getsentry/raven-node/issues/176
            const in_app = !isInternal && filename !== undefined && !filename.includes('node_modules/');
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: in_app
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}

});


parcelRegister("7VirA", function(module, exports) {

$parcel$export(module.exports, "supportsNativeFetch", () => $5c4c29dc9a8086e3$export$c82d238e23c40b21);

var $elKLM = parcelRequire("elKLM");

var $dQTB1 = parcelRequire("dQTB1");
// eslint-disable-next-line deprecation/deprecation
const $5c4c29dc9a8086e3$var$WINDOW = (0, $dQTB1.getGlobalObject)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $5c4c29dc9a8086e3$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $5c4c29dc9a8086e3$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $5c4c29dc9a8086e3$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $5c4c29dc9a8086e3$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $5c4c29dc9a8086e3$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $5c4c29dc9a8086e3$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $5c4c29dc9a8086e3$export$c82d238e23c40b21() {
    if (!$5c4c29dc9a8086e3$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($5c4c29dc9a8086e3$export$18cf36ed71d733e7($5c4c29dc9a8086e3$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $5c4c29dc9a8086e3$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $5c4c29dc9a8086e3$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $5c4c29dc9a8086e3$export$531055a6c684a70a() {
    return 'ReportingObserver' in $5c4c29dc9a8086e3$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $5c4c29dc9a8086e3$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$5c4c29dc9a8086e3$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("2t4YI", function(module, exports) {

$parcel$export(module.exports, "supportsHistory", () => $1cc226cd197b06c3$export$67fc34576016d6ec);

var $dQTB1 = parcelRequire("dQTB1");
// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $1cc226cd197b06c3$var$WINDOW = (0, $dQTB1.getGlobalObject)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $1cc226cd197b06c3$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chrome = $1cc226cd197b06c3$var$WINDOW.chrome;
    const isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = 'history' in $1cc226cd197b06c3$var$WINDOW && !!$1cc226cd197b06c3$var$WINDOW.history.pushState && !!$1cc226cd197b06c3$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});


parcelRegister("ebD1W", function(module, exports) {

$parcel$export(module.exports, "getActiveTransaction", () => $a5405e5c6e90ec59$export$a7feb32fdd923295);

var $7Qe7s = parcelRequire("7Qe7s");

/** Grabs active transaction off scope, if any */ function $a5405e5c6e90ec59$export$a7feb32fdd923295(maybeHub) {
    const hub = maybeHub || (0, $7Qe7s.getCurrentHub)();
    const scope = hub.getScope();
    return scope.getTransaction();
}

});


parcelRegister("26wej", function(module, exports) {

$parcel$export(module.exports, "TRACING_DEFAULTS", () => $188524781b2d46ba$export$809a2b7987fd5306);
$parcel$export(module.exports, "IdleTransaction", () => $188524781b2d46ba$export$b279e6bd7040371f);

var $elKLM = parcelRequire("elKLM");
var $43Vyk = parcelRequire("43Vyk");

var $cIUeM = parcelRequire("cIUeM");

var $fTr2B = parcelRequire("fTr2B");
const $188524781b2d46ba$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const $188524781b2d46ba$var$FINISH_REASON_TAG = 'finishReason';
const $188524781b2d46ba$var$IDLE_TRANSACTION_FINISH_REASONS = [
    'heartbeatFailed',
    'idleTimeout',
    'documentHidden',
    'finalTimeout',
    'externalFinish',
    'cancelled'
];
/**
 * @inheritDoc
 */ class $188524781b2d46ba$export$370d6113c18ba86c extends (0, $cIUeM.SpanRecorder) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanId !== this.transactionSpanId) {
            // We patch span.finish() to pop an activity after setting an endTimestamp.
            span.finish = (endTimestamp)=>{
                span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0, $43Vyk.timestampWithMs)();
                this._popActivity(span.spanId);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if (span.endTimestamp === undefined) this._pushActivity(span.spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $188524781b2d46ba$export$b279e6bd7040371f extends (0, $fTr2B.Transaction) {
    // Activities store a list of active spans
    __init() {
        this.activities = {};
    }
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    __init2() {
        this._heartbeatCounter = 0;
    }
    // We should not use heartbeat if we finished a transaction
    __init3() {
        this._finished = false;
    }
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    __init4() {
        this._idleTimeoutCanceledPermanently = false;
    }
    __init5() {
        this._beforeFinishCallbacks = [];
    }
    /**
   * Timer that tracks Transaction idleTimeout
   */ __init6() {
        this._finishReason = $188524781b2d46ba$var$IDLE_TRANSACTION_FINISH_REASONS[4];
    }
    constructor(transactionContext, _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $188524781b2d46ba$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $188524781b2d46ba$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = $188524781b2d46ba$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        $188524781b2d46ba$export$b279e6bd7040371f.prototype.__init.call(this);
        $188524781b2d46ba$export$b279e6bd7040371f.prototype.__init2.call(this);
        $188524781b2d46ba$export$b279e6bd7040371f.prototype.__init3.call(this);
        $188524781b2d46ba$export$b279e6bd7040371f.prototype.__init4.call(this);
        $188524781b2d46ba$export$b279e6bd7040371f.prototype.__init5.call(this);
        $188524781b2d46ba$export$b279e6bd7040371f.prototype.__init6.call(this);
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log(`Setting idle transaction on scope. Span ID: ${this.spanId}`);
            _idleHub.configureScope((scope)=>scope.setSpan(this));
        }
        this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus('deadline_exceeded');
                this._finishReason = $188524781b2d46ba$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                this.finish();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ finish(endTimestamp = (0, $43Vyk.timestampWithMs)()) {
        this._finished = true;
        this.activities = {};
        if (this.op === 'ui.action.click') this.setTag($188524781b2d46ba$var$FINISH_REASON_TAG, this._finishReason);
        if (this.spanRecorder) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestamp);
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanId === this.spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!span.endTimestamp) {
                    span.endTimestamp = endTimestamp;
                    span.setStatus('cancelled');
                    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
                }
                const keepSpan = span.startTimestamp < endTimestamp;
                if (!keepSpan) (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Tracing] discarding Span since it happened after Transaction was finished', JSON.stringify(span, undefined, 2));
                return keepSpan;
            });
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Tracing] flushing IdleTransaction');
        } else (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Tracing] No active IdleTransaction');
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            const scope = this._idleHub.getScope();
            if (scope.getTransaction() === this) scope.setSpan(undefined);
        }
        return super.finish(endTimestamp);
    }
    /**
   * Register a callback function that gets excecuted before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            this.spanRecorder = new $188524781b2d46ba$export$370d6113c18ba86c(pushActivity, popActivity, this.spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('Starting heartbeat');
            this._pingHeartbeat();
        }
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange: restartOnChildSpanChange } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = $188524781b2d46ba$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.finish(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = $188524781b2d46ba$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                this.finish(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Tracing] new activities count', Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Tracing] new activities count', Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, $43Vyk.timestampWithMs)();
            if (this._idleTimeoutCanceledPermanently) {
                this._finishReason = $188524781b2d46ba$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.finish(endTimestamp);
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampWithMs is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join('');
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Tracing] Transaction finished because of no change for 3 heart beats');
            this.setStatus('deadline_exceeded');
            this._finishReason = $188524781b2d46ba$var$IDLE_TRANSACTION_FINISH_REASONS[0];
            this.finish();
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}

});
parcelRegister("cIUeM", function(module, exports) {

$parcel$export(module.exports, "SpanRecorder", () => $943537a60a46221f$export$10c95c129cd0d4fe);
$parcel$export(module.exports, "Span", () => $943537a60a46221f$export$5f1714a13ed34c01);
$parcel$export(module.exports, "spanStatusfromHttpCode", () => $943537a60a46221f$export$ac65c70d78fcdb55);

var $3CK1O = parcelRequire("3CK1O");
var $elKLM = parcelRequire("elKLM");
var $43Vyk = parcelRequire("43Vyk");
var $aG8PM = parcelRequire("aG8PM");
/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $943537a60a46221f$export$10c95c129cd0d4fe {
    __init() {
        this.spans = [];
    }
    constructor(maxlen = 1000){
        $943537a60a46221f$export$10c95c129cd0d4fe.prototype.__init.call(this);
        this._maxlen = maxlen;
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $943537a60a46221f$export$5f1714a13ed34c01 {
    /**
   * @inheritDoc
   */ __init2() {
        this.traceId = (0, $aG8PM.uuid4)();
    }
    /**
   * @inheritDoc
   */ __init3() {
        this.spanId = (0, $aG8PM.uuid4)().substring(16);
    }
    /**
   * @inheritDoc
   */ /**
   * Internal keeper of the status
   */ /**
   * @inheritDoc
   */ /**
   * Timestamp in seconds when the span was created.
   */ __init4() {
        this.startTimestamp = (0, $43Vyk.timestampWithMs)();
    }
    /**
   * Timestamp in seconds when the span ended.
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ __init5() {
        this.tags = {};
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    __init6() {
        this.data = {};
    }
    /**
   * List of spans that were finalized
   */ /**
   * @inheritDoc
   */ /**
   * The instrumenter that created this span.
   */ __init7() {
        this.instrumenter = 'sentry';
    }
    /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext){
        $943537a60a46221f$export$5f1714a13ed34c01.prototype.__init2.call(this);
        $943537a60a46221f$export$5f1714a13ed34c01.prototype.__init3.call(this);
        $943537a60a46221f$export$5f1714a13ed34c01.prototype.__init4.call(this);
        $943537a60a46221f$export$5f1714a13ed34c01.prototype.__init5.call(this);
        $943537a60a46221f$export$5f1714a13ed34c01.prototype.__init6.call(this);
        $943537a60a46221f$export$5f1714a13ed34c01.prototype.__init7.call(this);
        if (!spanContext) return this;
        if (spanContext.traceId) this.traceId = spanContext.traceId;
        if (spanContext.spanId) this.spanId = spanContext.spanId;
        if (spanContext.parentSpanId) this.parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this.sampled = spanContext.sampled;
        if (spanContext.op) this.op = spanContext.op;
        if (spanContext.description) this.description = spanContext.description;
        if (spanContext.data) this.data = spanContext.data;
        if (spanContext.tags) this.tags = spanContext.tags;
        if (spanContext.status) this.status = spanContext.status;
        if (spanContext.startTimestamp) this.startTimestamp = spanContext.startTimestamp;
        if (spanContext.endTimestamp) this.endTimestamp = spanContext.endTimestamp;
        if (spanContext.instrumenter) this.instrumenter = spanContext.instrumenter;
    }
    /**
   * @inheritDoc
   */ startChild(spanContext) {
        const childSpan = new $943537a60a46221f$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this.spanId,
            sampled: this.sampled,
            traceId: this.traceId
        });
        childSpan.spanRecorder = this.spanRecorder;
        if (childSpan.spanRecorder) childSpan.spanRecorder.add(childSpan);
        childSpan.transaction = this.transaction;
        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && childSpan.transaction) {
            const opStr = spanContext && spanContext.op || '< unknown op >';
            const nameStr = childSpan.transaction.name || '< unknown name >';
            const idStr = childSpan.transaction.spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            childSpan.transaction.metadata.spanMetadata[childSpan.spanId] = {
                logMessage: logMessage
            };
            (0, $elKLM.logger).log(logMessage);
        }
        return childSpan;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    setData(key, value) {
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this.status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ setHttpStatus(httpStatus) {
        this.setTag('http.status_code', String(httpStatus));
        const spanStatus = $943537a60a46221f$export$ac65c70d78fcdb55(httpStatus);
        if (spanStatus !== 'unknown_error') this.setStatus(spanStatus);
        return this;
    }
    /**
   * @inheritDoc
   */ isSuccess() {
        return this.status === 'ok';
    }
    /**
   * @inheritDoc
   */ finish(endTimestamp) {
        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && // Don't call this for transactions
        this.transaction && this.transaction.spanId !== this.spanId) {
            const { logMessage: logMessage } = this.transaction.metadata.spanMetadata[this.spanId];
            if (logMessage) (0, $elKLM.logger).log(logMessage.replace('Starting', 'Finishing'));
        }
        this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0, $43Vyk.timestampWithMs)();
    }
    /**
   * @inheritDoc
   */ toTraceparent() {
        let sampledString = '';
        if (this.sampled !== undefined) sampledString = this.sampled ? '-1' : '-0';
        return `${this.traceId}-${this.spanId}${sampledString}`;
    }
    /**
   * @inheritDoc
   */ toContext() {
        return (0, $3CK1O.dropUndefinedKeys)({
            data: this.data,
            description: this.description,
            endTimestamp: this.endTimestamp,
            op: this.op,
            parentSpanId: this.parentSpanId,
            sampled: this.sampled,
            spanId: this.spanId,
            startTimestamp: this.startTimestamp,
            status: this.status,
            tags: this.tags,
            traceId: this.traceId
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(spanContext) {
        this.data = spanContext.data || {};
        this.description = spanContext.description;
        this.endTimestamp = spanContext.endTimestamp;
        this.op = spanContext.op;
        this.parentSpanId = spanContext.parentSpanId;
        this.sampled = spanContext.sampled;
        this.spanId = spanContext.spanId || this.spanId;
        this.startTimestamp = spanContext.startTimestamp || this.startTimestamp;
        this.status = spanContext.status;
        this.tags = spanContext.tags || {};
        this.traceId = spanContext.traceId || this.traceId;
        return this;
    }
    /**
   * @inheritDoc
   */ getTraceContext() {
        return (0, $3CK1O.dropUndefinedKeys)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            trace_id: this.traceId
        });
    }
    /**
   * @inheritDoc
   */ toJSON() {
        return (0, $3CK1O.dropUndefinedKeys)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            start_timestamp: this.startTimestamp,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this.endTimestamp,
            trace_id: this.traceId
        });
    }
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $943537a60a46221f$export$ac65c70d78fcdb55(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return 'ok';
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return 'unauthenticated';
        case 403:
            return 'permission_denied';
        case 404:
            return 'not_found';
        case 409:
            return 'already_exists';
        case 413:
            return 'failed_precondition';
        case 429:
            return 'resource_exhausted';
        default:
            return 'invalid_argument';
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return 'unimplemented';
        case 503:
            return 'unavailable';
        case 504:
            return 'deadline_exceeded';
        default:
            return 'internal_error';
    }
    return 'unknown_error';
}

});

parcelRegister("fTr2B", function(module, exports) {

$parcel$export(module.exports, "Transaction", () => $b920f7d2140dfb3f$export$febc5573c75cefb0);

var $3CK1O = parcelRequire("3CK1O");
var $elKLM = parcelRequire("elKLM");

var $94HCL = parcelRequire("94HCL");

var $7Qe7s = parcelRequire("7Qe7s");

var $cIUeM = parcelRequire("cIUeM");
/** JSDoc */ class $b920f7d2140dfb3f$export$febc5573c75cefb0 extends (0, $cIUeM.Span) {
    /**
   * The reference to the current hub.
   */ __init() {
        this._measurements = {};
    }
    __init2() {
        this._contexts = {};
    }
    __init3() {
        this._frozenDynamicSamplingContext = undefined;
    }
    /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(transactionContext, hub){
        super(transactionContext);
        $b920f7d2140dfb3f$export$febc5573c75cefb0.prototype.__init.call(this);
        $b920f7d2140dfb3f$export$febc5573c75cefb0.prototype.__init2.call(this);
        $b920f7d2140dfb3f$export$febc5573c75cefb0.prototype.__init3.call(this);
        this._hub = hub || (0, $7Qe7s.getCurrentHub)();
        this._name = transactionContext.name || '';
        this.metadata = {
            source: 'custom',
            ...transactionContext.metadata,
            spanMetadata: {}
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this.metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    /** Getter for `name` property */ get name() {
        return this._name;
    }
    /** Setter for `name` property, which also sets `source` as custom */ set name(newName) {
        this.setName(newName);
    }
    /**
   * JSDoc
   */ setName(name, source = 'custom') {
        this._name = name;
        this.metadata.source = source;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        if (!this.spanRecorder) this.spanRecorder = new (0, $cIUeM.SpanRecorder)(maxlen);
        this.spanRecorder.add(this);
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   */ setMeasurement(name, value, unit = '') {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * @inheritDoc
   */ setMetadata(newMetadata) {
        this.metadata = {
            ...this.metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ finish(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this.endTimestamp !== undefined) return undefined;
        if (!this.name) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this.name = '<unlabeled transaction>';
        }
        // just sets the end timestamp
        super.finish(endTimestamp);
        const client = this._hub.getClient();
        if (client && client.emit) client.emit('finishTransaction', this);
        if (this.sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
            if (client) client.recordDroppedEvent('sample_rate', 'transaction');
            return undefined;
        }
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((s)=>s !== this && s.endTimestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) this.endTimestamp = finishedSpans.reduce((prev, current)=>{
            if (prev.endTimestamp && current.endTimestamp) return prev.endTimestamp > current.endTimestamp ? prev : current;
            return prev;
        }).endTimestamp;
        const metadata = this.metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: this.getTraceContext()
            },
            spans: finishedSpans,
            start_timestamp: this.startTimestamp,
            tags: this.tags,
            timestamp: this.endTimestamp,
            transaction: this.name,
            type: 'transaction',
            sdkProcessingMetadata: {
                ...metadata,
                dynamicSamplingContext: this.getDynamicSamplingContext()
            },
            ...metadata.source && {
                transaction_info: {
                    source: metadata.source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Measurements] Adding measurements to transaction', JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log(`[Tracing] Finishing ${this.op} transaction: ${this.name}.`);
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        const spanContext = super.toContext();
        return (0, $3CK1O.dropUndefinedKeys)({
            ...spanContext,
            name: this.name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        super.updateWithContext(transactionContext);
        this.name = transactionContext.name || '';
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   */ getDynamicSamplingContext() {
        if (this._frozenDynamicSamplingContext) return this._frozenDynamicSamplingContext;
        const hub = this._hub || (0, $7Qe7s.getCurrentHub)();
        const client = hub && hub.getClient();
        if (!client) return {};
        const { environment: environment, release: release } = client.getOptions() || {};
        const { publicKey: public_key } = client.getDsn() || {};
        const maybeSampleRate = this.metadata.sampleRate;
        const sample_rate = maybeSampleRate !== undefined ? maybeSampleRate.toString() : undefined;
        const { segment: user_segment } = hub.getScope().getUser() || {};
        const source = this.metadata.source;
        // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
        const transaction = source && source !== 'url' ? this.name : undefined;
        const dsc = (0, $3CK1O.dropUndefinedKeys)({
            environment: environment || (0, $94HCL.DEFAULT_ENVIRONMENT),
            release: release,
            transaction: transaction,
            user_segment: user_segment,
            public_key: public_key,
            trace_id: this.traceId,
            sample_rate: sample_rate
        });
        // Uncomment if we want to make DSC immutable
        // this._frozenDynamicSamplingContext = dsc;
        client.emit && client.emit('createDsc', dsc);
        return dsc;
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ setHub(hub) {
        this._hub = hub;
    }
}

});




parcelRegister("bv9YB", function(module, exports) {

$parcel$export(module.exports, "Apollo", () => $85fa5419e8b334e7$export$3db3e396472fda8d);

var $4Aa3G = parcelRequire("4Aa3G");

var $aG8PM = parcelRequire("aG8PM");
var $3CK1O = parcelRequire("3CK1O");
var $k7rM9 = parcelRequire("k7rM9");
var $fEKkD = parcelRequire("fEKkD");
var $elKLM = parcelRequire("elKLM");

var $fzFcM = parcelRequire("fzFcM");
/** Tracing integration for Apollo */ class $85fa5419e8b334e7$export$3db3e396472fda8d {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Apollo';
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $85fa5419e8b334e7$export$3db3e396472fda8d.id;
    }
    /**
   * @inheritDoc
   */ constructor(options = {
        useNestjs: false
    }){
        $85fa5419e8b334e7$export$3db3e396472fda8d.prototype.__init.call(this);
        this._useNest = !!options.useNestjs;
    }
    /** @inheritdoc */ loadDependency() {
        if (this._useNest) this._module = this._module || (0, $fEKkD.loadModule)('@nestjs/graphql');
        else this._module = this._module || (0, $fEKkD.loadModule)('apollo-server-core');
        return this._module;
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if ((0, $fzFcM.shouldDisableAutoInstrumentation)(getCurrentHub)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('Apollo Integration is skipped because of instrumenter configuration.');
            return;
        }
        if (this._useNest) {
            const pkg = this.loadDependency();
            if (!pkg) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).error('Apollo-NestJS Integration was unable to require @nestjs/graphql package.');
                return;
            }
            /**
       * Iterate over resolvers of NestJS ResolversExplorerService before schemas are constructed.
       */ (0, $3CK1O.fill)(pkg.GraphQLFactory.prototype, 'mergeWithSchema', function(orig) {
                return function(...args) {
                    (0, $3CK1O.fill)(this.resolversExplorerService, 'explore', function(orig) {
                        return function() {
                            const resolvers = (0, $aG8PM.arrayify)(orig.call(this));
                            const instrumentedResolvers = $85fa5419e8b334e7$var$instrumentResolvers(resolvers, getCurrentHub);
                            return instrumentedResolvers;
                        };
                    });
                    return orig.call(this, ...args);
                };
            });
        } else {
            const pkg = this.loadDependency();
            if (!pkg) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).error('Apollo Integration was unable to require apollo-server-core package.');
                return;
            }
            /**
       * Iterate over resolvers of the ApolloServer instance before schemas are constructed.
       */ (0, $3CK1O.fill)(pkg.ApolloServerBase.prototype, 'constructSchema', function(orig) {
                return function() {
                    if (!this.config.resolvers) {
                        if (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) {
                            if (this.config.schema) {
                                (0, $elKLM.logger).warn("Apollo integration is not able to trace `ApolloServer` instances constructed via `schema` property.If you are using NestJS with Apollo, please use `Sentry.Integrations.Apollo({ useNestjs: true })` instead.");
                                (0, $elKLM.logger).warn();
                            } else if (this.config.modules) (0, $elKLM.logger).warn('Apollo integration is not able to trace `ApolloServer` instances constructed via `modules` property.');
                            (0, $elKLM.logger).error('Skipping tracing as no resolvers found on the `ApolloServer` instance.');
                        }
                        return orig.call(this);
                    }
                    const resolvers = (0, $aG8PM.arrayify)(this.config.resolvers);
                    this.config.resolvers = $85fa5419e8b334e7$var$instrumentResolvers(resolvers, getCurrentHub);
                    return orig.call(this);
                };
            });
        }
    }
}
$85fa5419e8b334e7$export$3db3e396472fda8d.__initStatic();
function $85fa5419e8b334e7$var$instrumentResolvers(resolvers, getCurrentHub) {
    return resolvers.map((model)=>{
        Object.keys(model).forEach((resolverGroupName)=>{
            Object.keys(model[resolverGroupName]).forEach((resolverName)=>{
                if (typeof model[resolverGroupName][resolverName] !== 'function') return;
                $85fa5419e8b334e7$var$wrapResolver(model, resolverGroupName, resolverName, getCurrentHub);
            });
        });
        return model;
    });
}
/**
 * Wrap a single resolver which can be a parent of other resolvers and/or db operations.
 */ function $85fa5419e8b334e7$var$wrapResolver(model, resolverGroupName, resolverName, getCurrentHub) {
    (0, $3CK1O.fill)(model[resolverGroupName], resolverName, function(orig) {
        return function(...args) {
            const scope = getCurrentHub().getScope();
            const parentSpan = (0, $4Aa3G._optionalChain)([
                scope,
                'optionalAccess',
                (_2)=>_2.getSpan,
                'call',
                (_3)=>_3()
            ]);
            const span = (0, $4Aa3G._optionalChain)([
                parentSpan,
                'optionalAccess',
                (_4)=>_4.startChild,
                'call',
                (_5)=>_5({
                        description: `${resolverGroupName}.${resolverName}`,
                        op: 'graphql.resolve'
                    })
            ]);
            const rv = orig.call(this, ...args);
            if ((0, $k7rM9.isThenable)(rv)) return rv.then((res)=>{
                (0, $4Aa3G._optionalChain)([
                    span,
                    'optionalAccess',
                    (_6)=>_6.finish,
                    'call',
                    (_7)=>_7()
                ]);
                return res;
            });
            (0, $4Aa3G._optionalChain)([
                span,
                'optionalAccess',
                (_8)=>_8.finish,
                'call',
                (_9)=>_9()
            ]);
            return rv;
        };
    });
}

});
parcelRegister("4Aa3G", function(module, exports) {

$parcel$export(module.exports, "_optionalChain", () => $356253a02a7490cb$export$3cc482e6b02f32f7);
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ function $356253a02a7490cb$export$3cc482e6b02f32f7(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}

});

parcelRegister("fzFcM", function(module, exports) {

$parcel$export(module.exports, "shouldDisableAutoInstrumentation", () => $b56a165d4a2bfa75$export$34db76d03eb96b7e);

var $4Aa3G = parcelRequire("4Aa3G");
/**
 * Check if Sentry auto-instrumentation should be disabled.
 *
 * @param getCurrentHub A method to fetch the current hub
 * @returns boolean
 */ function $b56a165d4a2bfa75$export$34db76d03eb96b7e(getCurrentHub) {
    const clientOptions = (0, $4Aa3G._optionalChain)([
        getCurrentHub,
        'call',
        (_)=>_(),
        'access',
        (_2)=>_2.getClient,
        'call',
        (_3)=>_3(),
        'optionalAccess',
        (_4)=>_4.getOptions,
        'call',
        (_5)=>_5()
    ]);
    const instrumenter = (0, $4Aa3G._optionalChain)([
        clientOptions,
        'optionalAccess',
        (_6)=>_6.instrumenter
    ]) || 'sentry';
    return instrumenter !== 'sentry';
}

});


parcelRegister("aYACQ", function(module, exports) {

$parcel$export(module.exports, "BROWSER_TRACING_INTEGRATION_ID", () => $7fdbeb07910059fd$export$bbd2089f30bd3708);
$parcel$export(module.exports, "BrowserTracing", () => $7fdbeb07910059fd$export$46d3bbd0375f5fa4);

var $103Ol = parcelRequire("103Ol");
var $3LZi0 = parcelRequire("3LZi0");
var $ebD1W = parcelRequire("ebD1W");
var $26wej = parcelRequire("26wej");

var $eNSFS = parcelRequire("eNSFS");
var $c12av = parcelRequire("c12av");
var $elKLM = parcelRequire("elKLM");

var $a9CTT = parcelRequire("a9CTT");

var $aX8fK = parcelRequire("aX8fK");

var $lpkeJ = parcelRequire("lpkeJ");

var $4V91W = parcelRequire("4V91W");

var $7qPZ8 = parcelRequire("7qPZ8");
const $7fdbeb07910059fd$export$bbd2089f30bd3708 = 'BrowserTracing';
/** Options for Browser Tracing integration */ const $7fdbeb07910059fd$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $26wej.TRACING_DEFAULTS),
    markBackgroundTransactions: true,
    routingInstrumentation: (0, $4V91W.instrumentRoutingWithDefaults),
    startTransactionOnLocationChange: true,
    startTransactionOnPageLoad: true,
    enableLongTask: true,
    _experiments: {},
    ...(0, $lpkeJ.defaultRequestInstrumentationOptions)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */ class $7fdbeb07910059fd$export$46d3bbd0375f5fa4 {
    // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
    // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
    // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
    // integrations.
    /** Browser Tracing integration options */ /**
   * @inheritDoc
   */ __init() {
        this.name = $7fdbeb07910059fd$export$bbd2089f30bd3708;
    }
    constructor(_options){
        $7fdbeb07910059fd$export$46d3bbd0375f5fa4.prototype.__init.call(this);
        (0, $103Ol.addTracingExtensions)();
        this.options = {
            ...$7fdbeb07910059fd$var$DEFAULT_BROWSER_TRACING_OPTIONS,
            ..._options
        };
        // Special case: enableLongTask can be set in _experiments
        // TODO (v8): Remove this in v8
        if (this.options._experiments.enableLongTask !== undefined) this.options.enableLongTask = this.options._experiments.enableLongTask;
        // TODO (v8): remove this block after tracingOrigins is removed
        // Set tracePropagationTargets to tracingOrigins if specified by the user
        // In case both are specified, tracePropagationTargets takes precedence
        // eslint-disable-next-line deprecation/deprecation
        if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
        this.options.tracePropagationTargets = _options.tracingOrigins;
        this._collectWebVitals = (0, $aX8fK.startTrackingWebVitals)();
        if (this.options.enableLongTask) (0, $aX8fK.startTrackingLongTasks)();
        if (this.options._experiments.enableInteractions) (0, $aX8fK.startTrackingInteractions)();
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        this._getCurrentHub = getCurrentHub;
        const { routingInstrumentation: instrumentRouting, startTransactionOnLocationChange: startTransactionOnLocationChange, startTransactionOnPageLoad: startTransactionOnPageLoad, markBackgroundTransactions: markBackgroundTransactions, traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: tracePropagationTargets, shouldCreateSpanForRequest: shouldCreateSpanForRequest, _experiments: _experiments } = this.options;
        instrumentRouting((context)=>{
            const transaction = this._createRouteTransaction(context);
            this.options._experiments.onStartRouteTransaction && this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);
            return transaction;
        }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) (0, $a9CTT.registerBackgroundTabDetection)();
        if (_experiments.enableInteractions) this._registerInteractionListener();
        (0, $lpkeJ.instrumentOutgoingRequests)({
            traceFetch: traceFetch,
            traceXHR: traceXHR,
            tracePropagationTargets: tracePropagationTargets,
            shouldCreateSpanForRequest: shouldCreateSpanForRequest
        });
    }
    /** Create routing idle transaction. */ _createRouteTransaction(context) {
        if (!this._getCurrentHub) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
            return undefined;
        }
        const { beforeNavigate: beforeNavigate, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
        const isPageloadTransaction = context.op === 'pageload';
        const sentryTraceMetaTagValue = isPageloadTransaction ? $7fdbeb07910059fd$export$f147b32b03c9cf11('sentry-trace') : null;
        const baggageMetaTagValue = isPageloadTransaction ? $7fdbeb07910059fd$export$f147b32b03c9cf11('baggage') : null;
        const traceParentData = sentryTraceMetaTagValue ? (0, $3LZi0.extractTraceparentData)(sentryTraceMetaTagValue) : undefined;
        const dynamicSamplingContext = baggageMetaTagValue ? (0, $eNSFS.baggageHeaderToDynamicSamplingContext)(baggageMetaTagValue) : undefined;
        const expandedContext = {
            ...context,
            ...traceParentData,
            metadata: {
                ...context.metadata,
                dynamicSamplingContext: traceParentData && !dynamicSamplingContext ? {} : dynamicSamplingContext
            },
            trimEnd: true
        };
        const modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        const finalContext = modifiedContext === undefined ? {
            ...expandedContext,
            sampled: false
        } : modifiedContext;
        // If `beforeNavigate` set a custom name, record that fact
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: 'custom'
        } : finalContext.metadata;
        this._latestRouteName = finalContext.name;
        this._latestRouteSource = finalContext.metadata && finalContext.metadata.source;
        if (finalContext.sampled === false) (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const hub = this._getCurrentHub();
        const { location: location } = (0, $7qPZ8.WINDOW);
        const idleTransaction = (0, $103Ol.startIdleTransaction)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval);
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            this._collectWebVitals();
            (0, $aX8fK.addPerformanceEntries)(transaction);
        });
        return idleTransaction;
    }
    /** Start listener for interaction transactions */ _registerInteractionListener() {
        let inflightInteractionTransaction;
        const registerInteractionTransaction = ()=>{
            const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
            const op = 'ui.action.click';
            const currentTransaction = (0, $ebD1W.getActiveTransaction)();
            if (currentTransaction && currentTransaction.op && [
                'navigation',
                'pageload'
            ].includes(currentTransaction.op)) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
                return undefined;
            }
            if (inflightInteractionTransaction) {
                inflightInteractionTransaction.setFinishReason('interactionInterrupted');
                inflightInteractionTransaction.finish();
                inflightInteractionTransaction = undefined;
            }
            if (!this._getCurrentHub) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
                return undefined;
            }
            if (!this._latestRouteName) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
                return undefined;
            }
            const hub = this._getCurrentHub();
            const { location: location } = (0, $7qPZ8.WINDOW);
            const context = {
                name: this._latestRouteName,
                op: op,
                trimEnd: true,
                metadata: {
                    source: this._latestRouteSource || 'url'
                }
            };
            inflightInteractionTransaction = (0, $103Ol.startIdleTransaction)(hub, context, idleTimeout, finalTimeout, true, {
                location: location
            }, heartbeatInterval);
        };
        [
            'click'
        ].forEach((type)=>{
            addEventListener(type, registerInteractionTransaction, {
                once: false,
                capture: true
            });
        });
    }
}
/** Returns the value of a meta tag */ function $7fdbeb07910059fd$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $c12av.getDomElement)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute('content') : null;
}

});
parcelRegister("3LZi0", function(module, exports) {

$parcel$export(module.exports, "TRACEPARENT_REGEXP", () => $2bf54daf8a1dd4aa$export$394a210812ba3012);
$parcel$export(module.exports, "extractTraceparentData", () => $2bf54daf8a1dd4aa$export$8e9a29865c0a1226);
const $2bf54daf8a1dd4aa$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $2bf54daf8a1dd4aa$export$8e9a29865c0a1226(traceparent) {
    const matches = traceparent.match($2bf54daf8a1dd4aa$export$394a210812ba3012);
    if (!traceparent || !matches) // empty string or no matches is invalid traceparent data
    return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}

});

parcelRegister("eNSFS", function(module, exports) {

$parcel$export(module.exports, "BAGGAGE_HEADER_NAME", () => $ac700d7ad7652c84$export$9ca9946bd449ac06);
$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", () => $ac700d7ad7652c84$export$5b96ee2c8421f107);
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", () => $ac700d7ad7652c84$export$56766feef403f365);

var $k7rM9 = parcelRequire("k7rM9");

var $elKLM = parcelRequire("elKLM");
const $ac700d7ad7652c84$export$9ca9946bd449ac06 = 'baggage';
const $ac700d7ad7652c84$export$6e69537d67fa20f = 'sentry-';
const $ac700d7ad7652c84$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $ac700d7ad7652c84$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $ac700d7ad7652c84$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $k7rM9.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $ac700d7ad7652c84$var$baggageHeaderToObject(curr);
        return {
            ...acc,
            ...currBaggageObject
        };
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $ac700d7ad7652c84$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($ac700d7ad7652c84$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($ac700d7ad7652c84$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $ac700d7ad7652c84$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$ac700d7ad7652c84$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $ac700d7ad7652c84$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $ac700d7ad7652c84$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $ac700d7ad7652c84$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $ac700d7ad7652c84$export$bdd844ddb2def819) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}

});

parcelRegister("a9CTT", function(module, exports) {

$parcel$export(module.exports, "registerBackgroundTabDetection", () => $7648eb77d2222fdd$export$6f18f55521af71a1);

var $ebD1W = parcelRequire("ebD1W");

var $elKLM = parcelRequire("elKLM");

var $7qPZ8 = parcelRequire("7qPZ8");
/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $7648eb77d2222fdd$export$6f18f55521af71a1() {
    if ((0, $7qPZ8.WINDOW) && (0, $7qPZ8.WINDOW).document) (0, $7qPZ8.WINDOW).document.addEventListener('visibilitychange', ()=>{
        const activeTransaction = (0, $ebD1W.getActiveTransaction)();
        if ((0, $7qPZ8.WINDOW).document.hidden && activeTransaction) {
            const statusType = 'cancelled';
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${activeTransaction.op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!activeTransaction.status) activeTransaction.setStatus(statusType);
            activeTransaction.setTag('visibilitychange', 'document.hidden');
            activeTransaction.finish();
        }
    });
    else (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn('[Tracing] Could not set up background tab detection due to lack of global document');
}

});
parcelRegister("7qPZ8", function(module, exports) {

$parcel$export(module.exports, "WINDOW", () => $5693493d7afcb0fd$export$56d8a8a25bd48b81);

var $dQTB1 = parcelRequire("dQTB1");
const $5693493d7afcb0fd$export$56d8a8a25bd48b81 = (0, $dQTB1.GLOBAL_OBJ);

});


parcelRegister("aX8fK", function(module, exports) {

$parcel$export(module.exports, "startTrackingWebVitals", () => $7f95d0f3331744df$export$7c69f0412d101b88);
$parcel$export(module.exports, "startTrackingLongTasks", () => $7f95d0f3331744df$export$f396d19077034ad2);
$parcel$export(module.exports, "startTrackingInteractions", () => $7f95d0f3331744df$export$e27543e0976315e4);
$parcel$export(module.exports, "addPerformanceEntries", () => $7f95d0f3331744df$export$5f8fa6b3467a7443);

var $ebD1W = parcelRequire("ebD1W");

var $43Vyk = parcelRequire("43Vyk");
var $c12av = parcelRequire("c12av");
var $elKLM = parcelRequire("elKLM");

var $7qPZ8 = parcelRequire("7qPZ8");

var $bnUbo = parcelRequire("bnUbo");

var $2DGo3 = parcelRequire("2DGo3");

var $1iEEQ = parcelRequire("1iEEQ");

var $dwcXr = parcelRequire("dwcXr");

var $jiVMn = parcelRequire("jiVMn");

var $74dVd = parcelRequire("74dVd");
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $7f95d0f3331744df$var$msToSec(time) {
    return time / 1000;
}
function $7f95d0f3331744df$var$getBrowserPerformanceAPI() {
    return (0, $7qPZ8.WINDOW) && (0, $7qPZ8.WINDOW).addEventListener && (0, $7qPZ8.WINDOW).performance;
}
let $7f95d0f3331744df$var$_performanceCursor = 0;
let $7f95d0f3331744df$var$_measurements = {};
let $7f95d0f3331744df$var$_lcpEntry;
let $7f95d0f3331744df$var$_clsEntry;
/**
 * Start tracking web vitals
 *
 * @returns A function that forces web vitals collection
 */ function $7f95d0f3331744df$export$7c69f0412d101b88() {
    const performance = $7f95d0f3331744df$var$getBrowserPerformanceAPI();
    if (performance && (0, $43Vyk.browserPerformanceTimeOrigin)) {
        if (performance.mark) (0, $7qPZ8.WINDOW).performance.mark('sentry-tracing-init');
        $7f95d0f3331744df$var$_trackFID();
        const clsCallback = $7f95d0f3331744df$var$_trackCLS();
        const lcpCallback = $7f95d0f3331744df$var$_trackLCP();
        return ()=>{
            if (clsCallback) clsCallback();
            if (lcpCallback) lcpCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $7f95d0f3331744df$export$f396d19077034ad2() {
    const entryHandler = (entries)=>{
        for (const entry of entries){
            const transaction = (0, $ebD1W.getActiveTransaction)();
            if (!transaction) return;
            const startTime = $7f95d0f3331744df$var$msToSec((0, $43Vyk.browserPerformanceTimeOrigin) + entry.startTime);
            const duration = $7f95d0f3331744df$var$msToSec(entry.duration);
            transaction.startChild({
                description: 'Main UI thread blocked',
                op: 'ui.long-task',
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    };
    (0, $jiVMn.observe)('longtask', entryHandler);
}
/**
 * Start tracking interaction events.
 */ function $7f95d0f3331744df$export$e27543e0976315e4() {
    const entryHandler = (entries)=>{
        for (const entry of entries){
            const transaction = (0, $ebD1W.getActiveTransaction)();
            if (!transaction) return;
            if (entry.name === 'click') {
                const startTime = $7f95d0f3331744df$var$msToSec((0, $43Vyk.browserPerformanceTimeOrigin) + entry.startTime);
                const duration = $7f95d0f3331744df$var$msToSec(entry.duration);
                transaction.startChild({
                    description: (0, $c12av.htmlTreeAsString)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                });
            }
        }
    };
    (0, $jiVMn.observe)('event', entryHandler, {
        durationThreshold: 0
    });
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $7f95d0f3331744df$var$_trackCLS() {
    // See:
    // https://web.dev/evolving-cls/
    // https://web.dev/cls-web-tooling/
    return (0, $bnUbo.onCLS)((metric)=>{
        const entry = metric.entries.pop();
        if (!entry) return;
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Measurements] Adding CLS');
        $7f95d0f3331744df$var$_measurements['cls'] = {
            value: metric.value,
            unit: ''
        };
        $7f95d0f3331744df$var$_clsEntry = entry;
    });
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $7f95d0f3331744df$var$_trackLCP() {
    return (0, $1iEEQ.onLCP)((metric)=>{
        const entry = metric.entries.pop();
        if (!entry) return;
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Measurements] Adding LCP');
        $7f95d0f3331744df$var$_measurements['lcp'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $7f95d0f3331744df$var$_lcpEntry = entry;
    });
}
/** Starts tracking the First Input Delay on the current page. */ function $7f95d0f3331744df$var$_trackFID() {
    (0, $2DGo3.onFID)((metric)=>{
        const entry = metric.entries.pop();
        if (!entry) return;
        const timeOrigin = $7f95d0f3331744df$var$msToSec((0, $43Vyk.browserPerformanceTimeOrigin));
        const startTime = $7f95d0f3331744df$var$msToSec(entry.startTime);
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Measurements] Adding FID');
        $7f95d0f3331744df$var$_measurements['fid'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $7f95d0f3331744df$var$_measurements['mark.fid'] = {
            value: timeOrigin + startTime,
            unit: 'second'
        };
    });
}
/** Add performance related spans to a transaction */ function $7f95d0f3331744df$export$5f8fa6b3467a7443(transaction) {
    const performance = $7f95d0f3331744df$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $7qPZ8.WINDOW).performance.getEntries || !(0, $43Vyk.browserPerformanceTimeOrigin)) // Gatekeeper if performance API not available
    return;
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Tracing] Adding & adjusting spans using Performance API');
    const timeOrigin = $7f95d0f3331744df$var$msToSec((0, $43Vyk.browserPerformanceTimeOrigin));
    const performanceEntries = performance.getEntries();
    let responseStartTimestamp;
    let requestStartTimestamp;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($7f95d0f3331744df$var$_performanceCursor).forEach((entry)=>{
        const startTime = $7f95d0f3331744df$var$msToSec(entry.startTime);
        const duration = $7f95d0f3331744df$var$msToSec(entry.duration);
        if (transaction.op === 'navigation' && timeOrigin + startTime < transaction.startTimestamp) return;
        switch(entry.entryType){
            case 'navigation':
                $7f95d0f3331744df$var$_addNavigationSpans(transaction, entry, timeOrigin);
                responseStartTimestamp = timeOrigin + $7f95d0f3331744df$var$msToSec(entry.responseStart);
                requestStartTimestamp = timeOrigin + $7f95d0f3331744df$var$msToSec(entry.requestStart);
                break;
            case 'mark':
            case 'paint':
            case 'measure':
                {
                    $7f95d0f3331744df$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $dwcXr.getVisibilityWatcher)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) {
                        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Measurements] Adding FP');
                        $7f95d0f3331744df$var$_measurements['fp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    if (entry.name === 'first-contentful-paint' && shouldRecord) {
                        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Measurements] Adding FCP');
                        $7f95d0f3331744df$var$_measurements['fcp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    break;
                }
            case 'resource':
                {
                    const resourceName = entry.name.replace((0, $7qPZ8.WINDOW).location.origin, '');
                    $7f95d0f3331744df$export$c82fe1a70634f317(transaction, entry, resourceName, startTime, duration, timeOrigin);
                    break;
                }
        }
    });
    $7f95d0f3331744df$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $7f95d0f3331744df$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (transaction.op === 'pageload') {
        // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
        // start of the response in milliseconds
        if (typeof responseStartTimestamp === 'number') {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Measurements] Adding TTFB');
            $7f95d0f3331744df$var$_measurements['ttfb'] = {
                value: (responseStartTimestamp - transaction.startTimestamp) * 1000,
                unit: 'millisecond'
            };
            if (typeof requestStartTimestamp === 'number' && requestStartTimestamp <= responseStartTimestamp) // Capture the time spent making the request and receiving the first byte of the response.
            // This is the time between the start of the request and the start of the response in milliseconds.
            $7f95d0f3331744df$var$_measurements['ttfb.requestTime'] = {
                value: (responseStartTimestamp - requestStartTimestamp) * 1000,
                unit: 'millisecond'
            };
        }
        [
            'fcp',
            'fp',
            'lcp'
        ].forEach((name)=>{
            if (!$7f95d0f3331744df$var$_measurements[name] || timeOrigin >= transaction.startTimestamp) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = $7f95d0f3331744df$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + $7f95d0f3331744df$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
            const delta = normalizedValue - oldValue;
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $7f95d0f3331744df$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $7f95d0f3331744df$var$_measurements['mark.fid'];
        if (fidMark && $7f95d0f3331744df$var$_measurements['fid']) {
            // create span for FID
            (0, $74dVd._startChild)(transaction, {
                description: 'first input delay',
                endTimestamp: fidMark.value + $7f95d0f3331744df$var$msToSec($7f95d0f3331744df$var$_measurements['fid'].value),
                op: 'ui.action',
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $7f95d0f3331744df$var$_measurements['mark.fid'];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!('fcp' in $7f95d0f3331744df$var$_measurements)) delete $7f95d0f3331744df$var$_measurements.cls;
        Object.keys($7f95d0f3331744df$var$_measurements).forEach((measurementName)=>{
            transaction.setMeasurement(measurementName, $7f95d0f3331744df$var$_measurements[measurementName].value, $7f95d0f3331744df$var$_measurements[measurementName].unit);
        });
        $7f95d0f3331744df$var$_tagMetricInfo(transaction);
    }
    $7f95d0f3331744df$var$_lcpEntry = undefined;
    $7f95d0f3331744df$var$_clsEntry = undefined;
    $7f95d0f3331744df$var$_measurements = {};
}
/** Create measure related spans */ function $7f95d0f3331744df$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $74dVd._startChild)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $7f95d0f3331744df$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        'unloadEvent',
        'redirect',
        'domContentLoadedEvent',
        'loadEvent',
        'connect'
    ].forEach((event)=>{
        $7f95d0f3331744df$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $7f95d0f3331744df$var$_addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
    $7f95d0f3331744df$var$_addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
    $7f95d0f3331744df$var$_addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
    $7f95d0f3331744df$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $7f95d0f3331744df$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $74dVd._startChild)(transaction, {
        op: 'browser',
        description: description || event,
        startTimestamp: timeOrigin + $7f95d0f3331744df$var$msToSec(start),
        endTimestamp: timeOrigin + $7f95d0f3331744df$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $7f95d0f3331744df$var$_addRequest(transaction, entry, timeOrigin) {
    (0, $74dVd._startChild)(transaction, {
        op: 'browser',
        description: 'request',
        startTimestamp: timeOrigin + $7f95d0f3331744df$var$msToSec(entry.requestStart),
        endTimestamp: timeOrigin + $7f95d0f3331744df$var$msToSec(entry.responseEnd)
    });
    (0, $74dVd._startChild)(transaction, {
        op: 'browser',
        description: 'response',
        startTimestamp: timeOrigin + $7f95d0f3331744df$var$msToSec(entry.responseStart),
        endTimestamp: timeOrigin + $7f95d0f3331744df$var$msToSec(entry.responseEnd)
    });
}
/** Create resource-related spans */ function $7f95d0f3331744df$export$c82fe1a70634f317(transaction, entry, resourceName, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') return;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    if ('transferSize' in entry) data['Transfer Size'] = entry.transferSize;
    if ('encodedBodySize' in entry) data['Encoded Body Size'] = entry.encodedBodySize;
    if ('decodedBodySize' in entry) data['Decoded Body Size'] = entry.decodedBodySize;
    if ('renderBlockingStatus' in entry) data['resource.render_blocking_status'] = entry.renderBlockingStatus;
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $74dVd._startChild)(transaction, {
        description: resourceName,
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $7f95d0f3331744df$var$_trackNavigator(transaction) {
    const navigator = (0, $7qPZ8.WINDOW).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) transaction.setTag('effectiveConnectionType', connection.effectiveType);
        if (connection.type) transaction.setTag('connectionType', connection.type);
        if ((0, $74dVd.isMeasurementValue)(connection.rtt)) $7f95d0f3331744df$var$_measurements['connection.rtt'] = {
            value: connection.rtt,
            unit: 'millisecond'
        };
    }
    if ((0, $74dVd.isMeasurementValue)(navigator.deviceMemory)) transaction.setTag('deviceMemory', `${navigator.deviceMemory} GB`);
    if ((0, $74dVd.isMeasurementValue)(navigator.hardwareConcurrency)) transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $7f95d0f3331744df$var$_tagMetricInfo(transaction) {
    if ($7f95d0f3331744df$var$_lcpEntry) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Measurements] Adding LCP Data');
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($7f95d0f3331744df$var$_lcpEntry.element) transaction.setTag('lcp.element', (0, $c12av.htmlTreeAsString)($7f95d0f3331744df$var$_lcpEntry.element));
        if ($7f95d0f3331744df$var$_lcpEntry.id) transaction.setTag('lcp.id', $7f95d0f3331744df$var$_lcpEntry.id);
        if ($7f95d0f3331744df$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        transaction.setTag('lcp.url', $7f95d0f3331744df$var$_lcpEntry.url.trim().slice(0, 200));
        transaction.setTag('lcp.size', $7f95d0f3331744df$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($7f95d0f3331744df$var$_clsEntry && $7f95d0f3331744df$var$_clsEntry.sources) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Measurements] Adding CLS Data');
        $7f95d0f3331744df$var$_clsEntry.sources.forEach((source, index)=>transaction.setTag(`cls.source.${index + 1}`, (0, $c12av.htmlTreeAsString)(source.node)));
    }
}

});
parcelRegister("bnUbo", function(module, exports) {

$parcel$export(module.exports, "onCLS", () => $849d6c6e16502dd7$export$a7873055838e5ad8);

var $9Ovd5 = parcelRequire("9Ovd5");

var $5djE8 = parcelRequire("5djE8");

var $jiVMn = parcelRequire("jiVMn");

var $cexnv = parcelRequire("cexnv");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $849d6c6e16502dd7$export$a7873055838e5ad8 = (onReport)=>{
    const metric = (0, $5djE8.initMetric)('CLS', 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, $jiVMn.observe)('layout-shift', handleEntries);
    if (po) {
        report = (0, $9Ovd5.bindReporter)(onReport, metric);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $cexnv.onHidden)(stopListening);
        return stopListening;
    }
    return;
};

});
parcelRegister("9Ovd5", function(module, exports) {

$parcel$export(module.exports, "bindReporter", () => $7250fe41ed8f8ef3$export$17679dccdd551979);
const $7250fe41ed8f8ef3$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};

});

parcelRegister("5djE8", function(module, exports) {

$parcel$export(module.exports, "initMetric", () => $3cbd67fd0b1f32b2$export$3c29b44508a0612b);

var $7qPZ8 = parcelRequire("7qPZ8");

var $ezBQe = parcelRequire("ezBQe");

var $b91AC = parcelRequire("b91AC");

var $fnJfe = parcelRequire("fnJfe");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $3cbd67fd0b1f32b2$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $fnJfe.getNavigationEntry)();
    let navigationType = 'navigate';
    if (navEntry) {
        if ((0, $7qPZ8.WINDOW).document.prerendering || (0, $b91AC.getActivationStart)() > 0) navigationType = 'prerender';
        else navigationType = navEntry.type.replace(/_/g, '-');
    }
    return {
        name: name,
        value: typeof value === 'undefined' ? -1 : value,
        rating: 'good',
        delta: 0,
        entries: [],
        id: (0, $ezBQe.generateUniqueID)(),
        navigationType: navigationType
    };
};

});
parcelRegister("ezBQe", function(module, exports) {

$parcel$export(module.exports, "generateUniqueID", () => $a9c1b01acfab9777$export$407ea409d1f3b539);
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $a9c1b01acfab9777$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};

});

parcelRegister("b91AC", function(module, exports) {

$parcel$export(module.exports, "getActivationStart", () => $81d1c4a7485c6265$export$d3e828b3c7b5b845);

var $fnJfe = parcelRequire("fnJfe");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $81d1c4a7485c6265$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $fnJfe.getNavigationEntry)();
    return navEntry && navEntry.activationStart || 0;
};

});
parcelRegister("fnJfe", function(module, exports) {

$parcel$export(module.exports, "getNavigationEntry", () => $b32c19a24e627ae7$export$6431553786c94949);

var $7qPZ8 = parcelRequire("7qPZ8");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b32c19a24e627ae7$var$getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, $7qPZ8.WINDOW).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, $7qPZ8.WINDOW).performance.navigation.type;
    const navigationEntry = {
        entryType: 'navigation',
        startTime: 0,
        type: type == 2 ? 'back_forward' : type === 1 ? 'reload' : 'navigate'
    };
    for(const key in timing)if (key !== 'navigationStart' && key !== 'toJSON') navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const $b32c19a24e627ae7$export$6431553786c94949 = ()=>{
    if ((0, $7qPZ8.WINDOW).__WEB_VITALS_POLYFILL__) return (0, $7qPZ8.WINDOW).performance && (performance.getEntriesByType && performance.getEntriesByType('navigation')[0] || $b32c19a24e627ae7$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $7qPZ8.WINDOW).performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
};

});



parcelRegister("jiVMn", function(module, exports) {

$parcel$export(module.exports, "observe", () => $e0dc848959f54dea$export$d1203567a167490e);
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $e0dc848959f54dea$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};

});

parcelRegister("cexnv", function(module, exports) {

$parcel$export(module.exports, "onHidden", () => $8e80af0c3857ece5$export$91ec2be6fdd8f1b4);

var $7qPZ8 = parcelRequire("7qPZ8");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8e80af0c3857ece5$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === 'pagehide' || (0, $7qPZ8.WINDOW).document.visibilityState === 'hidden') {
            cb(event);
            if (once) {
                removeEventListener('visibilitychange', onHiddenOrPageHide, true);
                removeEventListener('pagehide', onHiddenOrPageHide, true);
            }
        }
    };
    addEventListener('visibilitychange', onHiddenOrPageHide, true);
    // Some browsers have buggy implementations of visibilitychange,
    // so we use pagehide in addition, just to be safe.
    addEventListener('pagehide', onHiddenOrPageHide, true);
};

});


parcelRegister("2DGo3", function(module, exports) {

$parcel$export(module.exports, "onFID", () => $1ec01a75695a6448$export$39705a25c49af873);

var $9Ovd5 = parcelRequire("9Ovd5");

var $dwcXr = parcelRequire("dwcXr");

var $5djE8 = parcelRequire("5djE8");

var $jiVMn = parcelRequire("jiVMn");

var $cexnv = parcelRequire("cexnv");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $1ec01a75695a6448$export$39705a25c49af873 = (onReport)=>{
    const visibilityWatcher = (0, $dwcXr.getVisibilityWatcher)();
    const metric = (0, $5djE8.initMetric)('FID');
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, $jiVMn.observe)('first-input', handleEntries);
    report = (0, $9Ovd5.bindReporter)(onReport, metric);
    if (po) (0, $cexnv.onHidden)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};

});
parcelRegister("dwcXr", function(module, exports) {

$parcel$export(module.exports, "getVisibilityWatcher", () => $9d7850a6c70a3992$export$443f86b2c77012c4);

var $7qPZ8 = parcelRequire("7qPZ8");

var $cexnv = parcelRequire("cexnv");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $9d7850a6c70a3992$var$firstHiddenTime = -1;
const $9d7850a6c70a3992$var$initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    return (0, $7qPZ8.WINDOW).document.visibilityState === 'hidden' && !(0, $7qPZ8.WINDOW).document.prerendering ? 0 : Infinity;
};
const $9d7850a6c70a3992$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $cexnv.onHidden)(({ timeStamp: timeStamp })=>{
        $9d7850a6c70a3992$var$firstHiddenTime = timeStamp;
    }, true);
};
const $9d7850a6c70a3992$export$443f86b2c77012c4 = ()=>{
    if ($9d7850a6c70a3992$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $9d7850a6c70a3992$var$firstHiddenTime = $9d7850a6c70a3992$var$initHiddenTime();
        $9d7850a6c70a3992$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $9d7850a6c70a3992$var$firstHiddenTime;
        }
    };
};

});


parcelRegister("1iEEQ", function(module, exports) {

$parcel$export(module.exports, "onLCP", () => $0f2702aa148edfe6$export$947b1626ab8d5632);

var $9Ovd5 = parcelRequire("9Ovd5");

var $b91AC = parcelRequire("b91AC");

var $dwcXr = parcelRequire("dwcXr");

var $5djE8 = parcelRequire("5djE8");

var $jiVMn = parcelRequire("jiVMn");

var $cexnv = parcelRequire("cexnv");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0f2702aa148edfe6$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const $0f2702aa148edfe6$export$947b1626ab8d5632 = (onReport)=>{
    const visibilityWatcher = (0, $dwcXr.getVisibilityWatcher)();
    const metric = (0, $5djE8.initMetric)('LCP');
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, $b91AC.getActivationStart)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, $jiVMn.observe)('largest-contentful-paint', handleEntries);
    if (po) {
        report = (0, $9Ovd5.bindReporter)(onReport, metric);
        const stopListening = ()=>{
            if (!$0f2702aa148edfe6$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $0f2702aa148edfe6$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            'keydown',
            'click'
        ].forEach((type)=>{
            addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $cexnv.onHidden)(stopListening, true);
        return stopListening;
    }
    return;
};

});

parcelRegister("74dVd", function(module, exports) {

$parcel$export(module.exports, "isMeasurementValue", () => $5253b4b77eda1398$export$27169ccae1b439e3);
$parcel$export(module.exports, "_startChild", () => $5253b4b77eda1398$export$8bd469e1f37aa721);
/**
 * Checks if a given value is a valid measurement value.
 */ function $5253b4b77eda1398$export$27169ccae1b439e3(value) {
    return typeof value === 'number' && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */ function $5253b4b77eda1398$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp, ...ctx }) {
    if (startTimestamp && transaction.startTimestamp > startTimestamp) transaction.startTimestamp = startTimestamp;
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}

});


parcelRegister("lpkeJ", function(module, exports) {

$parcel$export(module.exports, "defaultRequestInstrumentationOptions", () => $f95ba1533cc96a20$export$cc17fb3c0bc95cd7);
$parcel$export(module.exports, "instrumentOutgoingRequests", () => $f95ba1533cc96a20$export$864489cb3478db3e);

var $7Qe7s = parcelRequire("7Qe7s");
var $9hRAY = parcelRequire("9hRAY");

var $lChn2 = parcelRequire("lChn2");
var $eNSFS = parcelRequire("eNSFS");
var $k7rM9 = parcelRequire("k7rM9");
var $4J3fm = parcelRequire("4J3fm");
/* eslint-disable max-lines */ const $f95ba1533cc96a20$export$15bd0305d05ad07b = [
    'localhost',
    /^\//
];
/** Options for Request Instrumentation */ const $f95ba1533cc96a20$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    // TODO (v8): Remove this property
    tracingOrigins: $f95ba1533cc96a20$export$15bd0305d05ad07b,
    tracePropagationTargets: $f95ba1533cc96a20$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $f95ba1533cc96a20$export$864489cb3478db3e(_options) {
    // eslint-disable-next-line deprecation/deprecation
    const { traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: tracePropagationTargets, tracingOrigins: tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest } = {
        traceFetch: $f95ba1533cc96a20$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $f95ba1533cc96a20$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>$f95ba1533cc96a20$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, $lChn2.addInstrumentationHandler)('fetch', (handlerData)=>{
        $f95ba1533cc96a20$export$cd8846dd8ea4bd7a(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
    });
    if (traceXHR) (0, $lChn2.addInstrumentationHandler)('xhr', (handlerData)=>{
        $f95ba1533cc96a20$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
    });
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $f95ba1533cc96a20$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $4J3fm.stringMatchesSomePattern)(url, tracePropagationTargets || $f95ba1533cc96a20$export$15bd0305d05ad07b);
}
/**
 * Create and track fetch request spans
 */ function $f95ba1533cc96a20$export$cd8846dd8ea4bd7a(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    if (!(0, $9hRAY.hasTracingEnabled)() || !(handlerData.fetchData && shouldCreateSpan(handlerData.fetchData.url))) return;
    if (handlerData.endTimestamp) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            if (handlerData.response) // TODO (kmclb) remove this once types PR goes through
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            span.setHttpStatus(handlerData.response.status);
            else if (handlerData.error) span.setStatus('internal_error');
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return;
    }
    const currentScope = (0, $7Qe7s.getCurrentHub)().getScope();
    const currentSpan = currentScope && currentScope.getSpan();
    const activeTransaction = currentSpan && currentSpan.transaction;
    if (currentSpan && activeTransaction) {
        const span = currentSpan.startChild({
            data: {
                ...handlerData.fetchData,
                type: 'fetch'
            },
            description: `${handlerData.fetchData.method} ${handlerData.fetchData.url}`,
            op: 'http.client'
        });
        handlerData.fetchData.__span = span.spanId;
        spans[span.spanId] = span;
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        if (shouldAttachHeaders(handlerData.fetchData.url)) options.headers = $f95ba1533cc96a20$export$6717acf674206871(request, activeTransaction.getDynamicSamplingContext(), span, options);
    }
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $f95ba1533cc96a20$export$6717acf674206871(request, dynamicSamplingContext, span, options) {
    const sentryBaggageHeader = (0, $eNSFS.dynamicSamplingContextToSentryBaggageHeader)(dynamicSamplingContext);
    const sentryTraceHeader = span.toTraceparent();
    const headers = typeof Request !== 'undefined' && (0, $k7rM9.isInstanceOf)(request, Request) ? request.headers : options.headers;
    if (!headers) return {
        'sentry-trace': sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== 'undefined' && (0, $k7rM9.isInstanceOf)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $eNSFS.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                'sentry-trace',
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $eNSFS.BAGGAGE_HEADER_NAME),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            'sentry-trace': sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined
        };
    }
}
/**
 * Create and track xhr request spans
 */ function $f95ba1533cc96a20$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    if (!(0, $9hRAY.hasTracingEnabled)() || handlerData.xhr && handlerData.xhr.__sentry_own_request__ || !(handlerData.xhr && handlerData.xhr.__sentry_xhr__ && shouldCreateSpan(handlerData.xhr.__sentry_xhr__.url))) return;
    const xhr = handlerData.xhr.__sentry_xhr__;
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp) {
        const spanId = handlerData.xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            span.setHttpStatus(xhr.status_code);
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return;
    }
    const currentScope = (0, $7Qe7s.getCurrentHub)().getScope();
    const currentSpan = currentScope && currentScope.getSpan();
    const activeTransaction = currentSpan && currentSpan.transaction;
    if (currentSpan && activeTransaction) {
        const span = currentSpan.startChild({
            data: {
                ...xhr.data,
                type: 'xhr',
                method: xhr.method,
                url: xhr.url
            },
            description: `${xhr.method} ${xhr.url}`,
            op: 'http.client'
        });
        handlerData.xhr.__sentry_xhr_span_id__ = span.spanId;
        spans[handlerData.xhr.__sentry_xhr_span_id__] = span;
        if (handlerData.xhr.setRequestHeader && shouldAttachHeaders(handlerData.xhr.__sentry_xhr__.url)) try {
            handlerData.xhr.setRequestHeader('sentry-trace', span.toTraceparent());
            const dynamicSamplingContext = activeTransaction.getDynamicSamplingContext();
            const sentryBaggageHeader = (0, $eNSFS.dynamicSamplingContextToSentryBaggageHeader)(dynamicSamplingContext);
            if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
            // We can therefore simply set a baggage header without checking what was there before
            // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
            handlerData.xhr.setRequestHeader((0, $eNSFS.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
        } catch (_) {
        // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
        }
    }
}

});

parcelRegister("4V91W", function(module, exports) {

$parcel$export(module.exports, "instrumentRoutingWithDefaults", () => $39537d8adc82dc22$export$86649cc09fe75143);

var $lChn2 = parcelRequire("lChn2");
var $43Vyk = parcelRequire("43Vyk");
var $elKLM = parcelRequire("elKLM");

var $7qPZ8 = parcelRequire("7qPZ8");
/**
 * Default function implementing pageload and navigation transactions
 */ function $39537d8adc82dc22$export$86649cc09fe75143(customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true) {
    if (!(0, $7qPZ8.WINDOW) || !(0, $7qPZ8.WINDOW).location) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn('Could not initialize routing instrumentation due to invalid location');
        return;
    }
    let startingUrl = (0, $7qPZ8.WINDOW).location.href;
    let activeTransaction;
    if (startTransactionOnPageLoad) activeTransaction = customStartTransaction({
        name: (0, $7qPZ8.WINDOW).location.pathname,
        // pageload should always start at timeOrigin
        startTimestamp: (0, $43Vyk.browserPerformanceTimeOrigin),
        op: 'pageload',
        metadata: {
            source: 'url'
        }
    });
    if (startTransactionOnLocationChange) (0, $lChn2.addInstrumentationHandler)('history', ({ to: to, from: from })=>{
        /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
            startingUrl = undefined;
            return;
        }
        if (from !== to) {
            startingUrl = undefined;
            if (activeTransaction) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
                // If there's an open transaction on the scope, we need to finish it before creating an new one.
                activeTransaction.finish();
            }
            activeTransaction = customStartTransaction({
                name: (0, $7qPZ8.WINDOW).location.pathname,
                op: 'navigation',
                metadata: {
                    source: 'url'
                }
            });
        }
    });
}

});


parcelRegister("8szh8", function(module, exports) {

$parcel$export(module.exports, "Express", () => $628c4d30933e5d98$export$6dafdd8fec05099d);

var $4Aa3G = parcelRequire("4Aa3G");

var $7vcr7 = parcelRequire("7vcr7");
var $d4cKa = parcelRequire("d4cKa");
var $k7rM9 = parcelRequire("k7rM9");
var $elKLM = parcelRequire("elKLM");

var $fzFcM = parcelRequire("fzFcM");
/**
 * Express integration
 *
 * Provides an request and error handler for Express framework as well as tracing capabilities
 */ class $628c4d30933e5d98$export$6dafdd8fec05099d {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Express';
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $628c4d30933e5d98$export$6dafdd8fec05099d.id;
    }
    /**
   * Express App instance
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        $628c4d30933e5d98$export$6dafdd8fec05099d.prototype.__init.call(this);
        this._router = options.router || options.app;
        this._methods = (Array.isArray(options.methods) ? options.methods : []).concat('use');
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if (!this._router) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).error('ExpressIntegration is missing an Express instance');
            return;
        }
        if ((0, $fzFcM.shouldDisableAutoInstrumentation)(getCurrentHub)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('Express Integration is skipped because of instrumenter configuration.');
            return;
        }
        $628c4d30933e5d98$var$instrumentMiddlewares(this._router, this._methods);
        $628c4d30933e5d98$var$instrumentRouter(this._router);
    }
}
$628c4d30933e5d98$export$6dafdd8fec05099d.__initStatic();
/**
 * Wraps original middleware function in a tracing call, which stores the info about the call as a span,
 * and finishes it once the middleware is done invoking.
 *
 * Express middlewares have 3 various forms, thus we have to take care of all of them:
 * // sync
 * app.use(function (req, res) { ... })
 * // async
 * app.use(function (req, res, next) { ... })
 * // error handler
 * app.use(function (err, req, res, next) { ... })
 *
 * They all internally delegate to the `router[method]` of the given application instance.
 */ // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any
function $628c4d30933e5d98$var$wrap(fn, method) {
    const arity = fn.length;
    switch(arity){
        case 2:
            return function(req, res) {
                const transaction = res.__sentry_transaction;
                if (transaction) {
                    const span = transaction.startChild({
                        description: fn.name,
                        op: `middleware.express.${method}`
                    });
                    res.once('finish', ()=>{
                        span.finish();
                    });
                }
                return fn.call(this, req, res);
            };
        case 3:
            return function(req, res, next) {
                const transaction = res.__sentry_transaction;
                const span = (0, $4Aa3G._optionalChain)([
                    transaction,
                    'optionalAccess',
                    (_2)=>_2.startChild,
                    'call',
                    (_3)=>_3({
                            description: fn.name,
                            op: `middleware.express.${method}`
                        })
                ]);
                fn.call(this, req, res, function(...args) {
                    (0, $4Aa3G._optionalChain)([
                        span,
                        'optionalAccess',
                        (_4)=>_4.finish,
                        'call',
                        (_5)=>_5()
                    ]);
                    next.call(this, ...args);
                });
            };
        case 4:
            return function(err, req, res, next) {
                const transaction = res.__sentry_transaction;
                const span = (0, $4Aa3G._optionalChain)([
                    transaction,
                    'optionalAccess',
                    (_6)=>_6.startChild,
                    'call',
                    (_7)=>_7({
                            description: fn.name,
                            op: `middleware.express.${method}`
                        })
                ]);
                fn.call(this, err, req, res, function(...args) {
                    (0, $4Aa3G._optionalChain)([
                        span,
                        'optionalAccess',
                        (_8)=>_8.finish,
                        'call',
                        (_9)=>_9()
                    ]);
                    next.call(this, ...args);
                });
            };
        default:
            throw new Error(`Express middleware takes 2-4 arguments. Got: ${arity}`);
    }
}
/**
 * Takes all the function arguments passed to the original `app` or `router` method, eg. `app.use` or `router.use`
 * and wraps every function, as well as array of functions with a call to our `wrap` method.
 * We have to take care of the arrays as well as iterate over all of the arguments,
 * as `app.use` can accept middlewares in few various forms.
 *
 * app.use([<path>], <fn>)
 * app.use([<path>], <fn>, ...<fn>)
 * app.use([<path>], ...<fn>[])
 */ function $628c4d30933e5d98$var$wrapMiddlewareArgs(args, method) {
    return args.map((arg)=>{
        if (typeof arg === 'function') return $628c4d30933e5d98$var$wrap(arg, method);
        if (Array.isArray(arg)) return arg.map((a)=>{
            if (typeof a === 'function') return $628c4d30933e5d98$var$wrap(a, method);
            return a;
        });
        return arg;
    });
}
/**
 * Patches original router to utilize our tracing functionality
 */ function $628c4d30933e5d98$var$patchMiddleware(router, method) {
    const originalCallback = router[method];
    router[method] = function(...args) {
        return originalCallback.call(this, ...$628c4d30933e5d98$var$wrapMiddlewareArgs(args, method));
    };
    return router;
}
/**
 * Patches original router methods
 */ function $628c4d30933e5d98$var$instrumentMiddlewares(router, methods = []) {
    methods.forEach((method)=>$628c4d30933e5d98$var$patchMiddleware(router, method));
}
/**
 * Patches the prototype of Express.Router to accumulate the resolved route
 * if a layer instance's `match` function was called and it returned a successful match.
 *
 * @see https://github.com/expressjs/express/blob/master/lib/router/index.js
 *
 * @param appOrRouter the router instance which can either be an app (i.e. top-level) or a (nested) router.
 */ function $628c4d30933e5d98$var$instrumentRouter(appOrRouter) {
    // This is how we can distinguish between app and routers
    const isApp = 'settings' in appOrRouter;
    // In case the app's top-level router hasn't been initialized yet, we have to do it now
    if (isApp && appOrRouter._router === undefined && appOrRouter.lazyrouter) appOrRouter.lazyrouter();
    const router = isApp ? appOrRouter._router : appOrRouter;
    if (!router) {
        /*
    If we end up here, this means likely that this integration is used with Express 3 or Express 5.
    For now, we don't support these versions (3 is very old and 5 is still in beta). To support Express 5,
    we'd need to make more changes to the routing instrumentation because the router is no longer part of
    the Express core package but maintained in its own package. The new router has different function
    signatures and works slightly differently, demanding more changes than just taking the router from
    `app.router` instead of `app._router`.
    @see https://github.com/pillarjs/router

    TODO: Proper Express 5 support
    */ (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).debug('Cannot instrument router for URL Parameterization (did not find a valid router).');
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).debug('Routing instrumentation is currently only supported in Express 4.');
        return;
    }
    const routerProto = Object.getPrototypeOf(router);
    const originalProcessParams = routerProto.process_params;
    routerProto.process_params = function process_params(layer, called, req, res, done) {
        // Base case: We're in the first part of the URL (thus we start with the root '/')
        if (!req._reconstructedRoute) req._reconstructedRoute = '';
        // If the layer's partial route has params, is a regex or an array, the route is stored in layer.route.
        const { layerRoutePath: layerRoutePath, isRegex: isRegex, isArray: isArray, numExtraSegments: numExtraSegments } = $628c4d30933e5d98$var$getLayerRoutePathInfo(layer);
        if (layerRoutePath || isRegex || isArray) req._hasParameters = true;
        // Otherwise, the hardcoded path (i.e. a partial route without params) is stored in layer.path
        const partialRoute = layerRoutePath || layer.path || '';
        // Normalize the partial route so that it doesn't contain leading or trailing slashes
        // and exclude empty or '*' wildcard routes.
        // The exclusion of '*' routes is our best effort to not "pollute" the transaction name
        // with interim handlers (e.g. ones that check authentication or do other middleware stuff).
        // We want to end up with the parameterized URL of the incoming request without any extraneous path segments.
        const finalPartialRoute = partialRoute.split('/').filter((segment)=>segment.length > 0 && (isRegex || isArray || !segment.includes('*'))).join('/');
        // If we found a valid partial URL, we append it to the reconstructed route
        if (finalPartialRoute && finalPartialRoute.length > 0) // If the partial route is from a regex route, we append a '/' to close the regex
        req._reconstructedRoute += `/${finalPartialRoute}${isRegex ? '/' : ''}`;
        // Now we check if we are in the "last" part of the route. We determine this by comparing the
        // number of URL segments from the original URL to that of our reconstructed parameterized URL.
        // If we've reached our final destination, we update the transaction name.
        const urlLength = (0, $d4cKa.getNumberOfUrlSegments)(req.originalUrl || '') + numExtraSegments;
        const routeLength = (0, $d4cKa.getNumberOfUrlSegments)(req._reconstructedRoute);
        if (urlLength === routeLength) {
            if (!req._hasParameters) {
                if (req._reconstructedRoute !== req.originalUrl) req._reconstructedRoute = req.originalUrl;
            }
            const transaction = res.__sentry_transaction;
            if (transaction && transaction.metadata.source !== 'custom') {
                // If the request URL is '/' or empty, the reconstructed route will be empty.
                // Therefore, we fall back to setting the final route to '/' in this case.
                const finalRoute = req._reconstructedRoute || '/';
                transaction.setName(...(0, $7vcr7.extractPathForTransaction)(req, {
                    path: true,
                    method: true,
                    customRoute: finalRoute
                }));
            }
        }
        return originalProcessParams.call(this, layer, called, req, res, done);
    };
}
/**
 * Extracts and stringifies the layer's route which can either be a string with parameters (`users/:id`),
 * a RegEx (`/test/`) or an array of strings and regexes (`['/path1', /\/path[2-5]/, /path/:id]`). Additionally
 * returns extra information about the route, such as if the route is defined as regex or as an array.
 *
 * @param layer the layer to extract the stringified route from
 *
 * @returns an object containing the stringified route, a flag determining if the route was a regex
 *          and the number of extra segments to the matched path that are additionally in the route,
 *          if the route was an array (defaults to 0).
 */ function $628c4d30933e5d98$var$getLayerRoutePathInfo(layer) {
    const lrp = (0, $4Aa3G._optionalChain)([
        layer,
        'access',
        (_10)=>_10.route,
        'optionalAccess',
        (_11)=>_11.path
    ]);
    const isRegex = (0, $k7rM9.isRegExp)(lrp);
    const isArray = Array.isArray(lrp);
    if (!lrp) return {
        isRegex: isRegex,
        isArray: isArray,
        numExtraSegments: 0
    };
    const numExtraSegments = isArray ? Math.max($628c4d30933e5d98$var$getNumberOfArrayUrlSegments(lrp) - (0, $d4cKa.getNumberOfUrlSegments)(layer.path || ''), 0) : 0;
    const layerRoutePath = $628c4d30933e5d98$var$getLayerRoutePathString(isArray, lrp);
    return {
        layerRoutePath: layerRoutePath,
        isRegex: isRegex,
        isArray: isArray,
        numExtraSegments: numExtraSegments
    };
}
/**
 * Returns the number of URL segments in an array of routes
 *
 * Example: ['/api/test', /\/api\/post[0-9]/, '/users/:id/details`] -> 7
 */ function $628c4d30933e5d98$var$getNumberOfArrayUrlSegments(routesArray) {
    return routesArray.reduce((accNumSegments, currentRoute)=>{
        // array members can be a RegEx -> convert them toString
        return accNumSegments + (0, $d4cKa.getNumberOfUrlSegments)(currentRoute.toString());
    }, 0);
}
/**
 * Extracts and returns the stringified version of the layers route path
 * Handles route arrays (by joining the paths together) as well as RegExp and normal
 * string values (in the latter case the toString conversion is technically unnecessary but
 * it doesn't hurt us either).
 */ function $628c4d30933e5d98$var$getLayerRoutePathString(isArray, lrp) {
    if (isArray) return lrp.map((r)=>r.toString()).join(',');
    return lrp && lrp.toString();
}

});
parcelRegister("7vcr7", function(module, exports) {

$parcel$export(module.exports, "extractPathForTransaction", () => $576513448c542400$export$8c5ebee2e5bb9575);

var $k7rM9 = parcelRequire("k7rM9");

var $b9f5Q = parcelRequire("b9f5Q");

var $d4cKa = parcelRequire("d4cKa");
const $576513448c542400$var$DEFAULT_INCLUDES = {
    ip: false,
    request: true,
    transaction: true,
    user: true
};
const $576513448c542400$var$DEFAULT_REQUEST_INCLUDES = [
    'cookies',
    'data',
    'headers',
    'method',
    'query_string',
    'url'
];
const $576513448c542400$var$DEFAULT_USER_INCLUDES = [
    'id',
    'username',
    'email'
];
/**
 * Sets parameterized route as transaction name e.g.: `GET /users/:id`
 * Also adds more context data on the transaction from the request
 */ function $576513448c542400$export$1973410ef8793cd6(transaction, req, deps) {
    if (!transaction) return;
    if (!transaction.metadata.source || transaction.metadata.source === 'url') // Attempt to grab a parameterized route off of the request
    transaction.setName(...$576513448c542400$export$8c5ebee2e5bb9575(req, {
        path: true,
        method: true
    }));
    transaction.setData('url', req.originalUrl || req.url);
    if (req.baseUrl) transaction.setData('baseUrl', req.baseUrl);
    transaction.setData('query', $576513448c542400$var$extractQueryParams(req, deps));
}
/**
 * Extracts a complete and parameterized path from the request object and uses it to construct transaction name.
 * If the parameterized transaction name cannot be extracted, we fall back to the raw URL.
 *
 * Additionally, this function determines and returns the transaction name source
 *
 * eg. GET /mountpoint/user/:id
 *
 * @param req A request object
 * @param options What to include in the transaction name (method, path, or a custom route name to be
 *                used instead of the request's route)
 *
 * @returns A tuple of the fully constructed transaction name [0] and its source [1] (can be either 'route' or 'url')
 */ function $576513448c542400$export$8c5ebee2e5bb9575(req, options = {}) {
    const method = req.method && req.method.toUpperCase();
    let path = '';
    let source = 'url';
    // Check to see if there's a parameterized route we can use (as there is in Express)
    if (options.customRoute || req.route) {
        path = options.customRoute || `${req.baseUrl || ''}${req.route && req.route.path}`;
        source = 'route';
    } else if (req.originalUrl || req.url) path = (0, $d4cKa.stripUrlQueryAndFragment)(req.originalUrl || req.url || '');
    let name = '';
    if (options.method && method) name += method;
    if (options.method && options.path) name += ' ';
    if (options.path && path) name += path;
    return [
        name,
        source
    ];
}
/** JSDoc */ function $576513448c542400$var$extractTransaction(req, type) {
    switch(type){
        case 'path':
            return $576513448c542400$export$8c5ebee2e5bb9575(req, {
                path: true
            })[0];
        case 'handler':
            return req.route && req.route.stack && req.route.stack[0] && req.route.stack[0].name || '<anonymous>';
        case 'methodPath':
        default:
            return $576513448c542400$export$8c5ebee2e5bb9575(req, {
                path: true,
                method: true
            })[0];
    }
}
/** JSDoc */ function $576513448c542400$var$extractUserData(user, keys) {
    const extractedUser = {};
    const attributes = Array.isArray(keys) ? keys : $576513448c542400$var$DEFAULT_USER_INCLUDES;
    attributes.forEach((key)=>{
        if (user && key in user) extractedUser[key] = user[key];
    });
    return extractedUser;
}
/**
 * Normalize data from the request object, accounting for framework differences.
 *
 * @param req The request object from which to extract data
 * @param options.include An optional array of keys to include in the normalized data. Defaults to
 * DEFAULT_REQUEST_INCLUDES if not provided.
 * @param options.deps Injected, platform-specific dependencies
 * @returns An object containing normalized request data
 */ function $576513448c542400$export$b5c5d78255f11c84(req, options) {
    const { include: include = $576513448c542400$var$DEFAULT_REQUEST_INCLUDES, deps: deps } = options || {};
    const requestData = {};
    // headers:
    //   node, express, koa, nextjs: req.headers
    const headers = req.headers || {};
    // method:
    //   node, express, koa, nextjs: req.method
    const method = req.method;
    // host:
    //   express: req.hostname in > 4 and req.host in < 4
    //   koa: req.host
    //   node, nextjs: req.headers.host
    const host = req.hostname || req.host || headers.host || '<no host>';
    // protocol:
    //   node, nextjs: <n/a>
    //   express, koa: req.protocol
    const protocol = req.protocol === 'https' || req.socket && req.socket.encrypted ? 'https' : 'http';
    // url (including path and query string):
    //   node, express: req.originalUrl
    //   koa, nextjs: req.url
    const originalUrl = req.originalUrl || req.url || '';
    // absolute url
    const absoluteUrl = `${protocol}://${host}${originalUrl}`;
    include.forEach((key)=>{
        switch(key){
            case 'headers':
                requestData.headers = headers;
                break;
            case 'method':
                requestData.method = method;
                break;
            case 'url':
                requestData.url = absoluteUrl;
                break;
            case 'cookies':
                // cookies:
                //   node, express, koa: req.headers.cookie
                //   vercel, sails.js, express (w/ cookie middleware), nextjs: req.cookies
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                requestData.cookies = // TODO (v8 / #5257): We're only sending the empty object for backwards compatibility, so the last bit can
                // come off in v8
                req.cookies || headers.cookie && deps && deps.cookie && deps.cookie.parse(headers.cookie) || {};
                break;
            case 'query_string':
                // query string:
                //   node: req.url (raw)
                //   express, koa, nextjs: req.query
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                requestData.query_string = $576513448c542400$var$extractQueryParams(req, deps);
                break;
            case 'data':
                if (method === 'GET' || method === 'HEAD') break;
                // body data:
                //   express, koa, nextjs: req.body
                //
                //   when using node by itself, you have to read the incoming stream(see
                //   https://nodejs.dev/learn/get-http-request-body-data-using-nodejs); if a user is doing that, we can't know
                //   where they're going to store the final result, so they'll have to capture this data themselves
                if (req.body !== undefined) requestData.data = (0, $k7rM9.isString)(req.body) ? req.body : JSON.stringify((0, $b9f5Q.normalize)(req.body));
                break;
            default:
                if (({}).hasOwnProperty.call(req, key)) requestData[key] = req[key];
        }
    });
    return requestData;
}
/**
 * Options deciding what parts of the request to use when enhancing an event
 */ /**
 * Add data from the given request to the given event
 *
 * @param event The event to which the request data will be added
 * @param req Request object
 * @param options.include Flags to control what data is included
 * @param options.deps Injected platform-specific dependencies
 * @hidden
 */ function $576513448c542400$export$e560aeb323d2791d(event, req, options) {
    const include = {
        ...$576513448c542400$var$DEFAULT_INCLUDES,
        ...options && options.include
    };
    if (include.request) {
        const extractedRequestData = Array.isArray(include.request) ? $576513448c542400$export$b5c5d78255f11c84(req, {
            include: include.request,
            deps: options && options.deps
        }) : $576513448c542400$export$b5c5d78255f11c84(req, {
            deps: options && options.deps
        });
        event.request = {
            ...event.request,
            ...extractedRequestData
        };
    }
    if (include.user) {
        const extractedUser = req.user && (0, $k7rM9.isPlainObject)(req.user) ? $576513448c542400$var$extractUserData(req.user, include.user) : {};
        if (Object.keys(extractedUser).length) event.user = {
            ...event.user,
            ...extractedUser
        };
    }
    // client ip:
    //   node, nextjs: req.socket.remoteAddress
    //   express, koa: req.ip
    if (include.ip) {
        const ip = req.ip || req.socket && req.socket.remoteAddress;
        if (ip) event.user = {
            ...event.user,
            ip_address: ip
        };
    }
    if (include.transaction && !event.transaction) // TODO do we even need this anymore?
    // TODO make this work for nextjs
    event.transaction = $576513448c542400$var$extractTransaction(req, include.transaction);
    return event;
}
function $576513448c542400$var$extractQueryParams(req, deps) {
    // url (including path and query string):
    //   node, express: req.originalUrl
    //   koa, nextjs: req.url
    let originalUrl = req.originalUrl || req.url || '';
    if (!originalUrl) return;
    // The `URL` constructor can't handle internal URLs of the form `/some/path/here`, so stick a dummy protocol and
    // hostname on the beginning. Since the point here is just to grab the query string, it doesn't matter what we use.
    if (originalUrl.startsWith('/')) originalUrl = `http://dogs.are.great${originalUrl}`;
    return req.query || new URL(originalUrl).search.replace('?', '') || // In Node 8, `URL` isn't in the global scope, so we have to use the built-in module from Node
    deps && deps.url && deps.url.parse(originalUrl).query || undefined;
}

});
parcelRegister("b9f5Q", function(module, exports) {

$parcel$export(module.exports, "normalize", () => $81dc3e2f626cbd24$export$a3295358bff77e);

var $k7rM9 = parcelRequire("k7rM9");

var $H8bUY = parcelRequire("H8bUY");

var $3CK1O = parcelRequire("3CK1O");

var $8yub9 = parcelRequire("8yub9");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $81dc3e2f626cbd24$export$a3295358bff77e(input, depth = Infinity, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $81dc3e2f626cbd24$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $81dc3e2f626cbd24$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $81dc3e2f626cbd24$export$a3295358bff77e(object, depth);
    if ($81dc3e2f626cbd24$var$jsonSize(normalized) > maxSize) return $81dc3e2f626cbd24$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $81dc3e2f626cbd24$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $H8bUY.memoBuilder)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $k7rM9.isNaN)(value)) return value;
    const stringified = $81dc3e2f626cbd24$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    let overriddenDepth = depth;
    if (typeof value['__sentry_override_normalization_depth__'] === 'number') overriddenDepth = value['__sentry_override_normalization_depth__'];
    // We're also done if we've reached the max depth
    if (overriddenDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $81dc3e2f626cbd24$export$588732934346abbf('', jsonValue, overriddenDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $3CK1O.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $81dc3e2f626cbd24$export$588732934346abbf(visitKey, visitValue, overriddenDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $81dc3e2f626cbd24$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $k7rM9.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return `[Function: ${(0, $8yub9.getFunctionName)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return `[object ${$81dc3e2f626cbd24$var$getConstructorName(value)}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
function $81dc3e2f626cbd24$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $81dc3e2f626cbd24$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $81dc3e2f626cbd24$var$jsonSize(value) {
    return $81dc3e2f626cbd24$var$utf8Length(JSON.stringify(value));
}

});
parcelRegister("H8bUY", function(module, exports) {

$parcel$export(module.exports, "memoBuilder", () => $081a5edf8dbb05ab$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $081a5edf8dbb05ab$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === 'function';
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});


parcelRegister("d4cKa", function(module, exports) {

$parcel$export(module.exports, "stripUrlQueryAndFragment", () => $983588b0c69df13f$export$ce084c78234bd35);
$parcel$export(module.exports, "getNumberOfUrlSegments", () => $983588b0c69df13f$export$69dd85280a8d374c);
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $983588b0c69df13f$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $983588b0c69df13f$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $983588b0c69df13f$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ',').length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $983588b0c69df13f$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    .replace(':80', '').replace(':443', '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}

});



parcelRegister("kWON5", function(module, exports) {

$parcel$export(module.exports, "GraphQL", () => $f4009f6a48aceb62$export$b735d011553f1049);

var $4Aa3G = parcelRequire("4Aa3G");

var $3CK1O = parcelRequire("3CK1O");
var $k7rM9 = parcelRequire("k7rM9");
var $fEKkD = parcelRequire("fEKkD");
var $elKLM = parcelRequire("elKLM");

var $fzFcM = parcelRequire("fzFcM");
/** Tracing integration for graphql package */ class $f4009f6a48aceb62$export$b735d011553f1049 {
    constructor(){
        $f4009f6a48aceb62$export$b735d011553f1049.prototype.__init.call(this);
    }
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'GraphQL';
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $f4009f6a48aceb62$export$b735d011553f1049.id;
    }
    /** @inheritdoc */ loadDependency() {
        return this._module = this._module || (0, $fEKkD.loadModule)('graphql/execution/execute.js');
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if ((0, $fzFcM.shouldDisableAutoInstrumentation)(getCurrentHub)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('GraphQL Integration is skipped because of instrumenter configuration.');
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).error('GraphQL Integration was unable to require graphql/execution package.');
            return;
        }
        (0, $3CK1O.fill)(pkg, 'execute', function(orig) {
            return function(...args) {
                const scope = getCurrentHub().getScope();
                const parentSpan = (0, $4Aa3G._optionalChain)([
                    scope,
                    'optionalAccess',
                    (_2)=>_2.getSpan,
                    'call',
                    (_3)=>_3()
                ]);
                const span = (0, $4Aa3G._optionalChain)([
                    parentSpan,
                    'optionalAccess',
                    (_4)=>_4.startChild,
                    'call',
                    (_5)=>_5({
                            description: 'execute',
                            op: 'graphql.execute'
                        })
                ]);
                (0, $4Aa3G._optionalChain)([
                    scope,
                    'optionalAccess',
                    (_6)=>_6.setSpan,
                    'call',
                    (_7)=>_7(span)
                ]);
                const rv = orig.call(this, ...args);
                if ((0, $k7rM9.isThenable)(rv)) return rv.then((res)=>{
                    (0, $4Aa3G._optionalChain)([
                        span,
                        'optionalAccess',
                        (_8)=>_8.finish,
                        'call',
                        (_9)=>_9()
                    ]);
                    (0, $4Aa3G._optionalChain)([
                        scope,
                        'optionalAccess',
                        (_10)=>_10.setSpan,
                        'call',
                        (_11)=>_11(parentSpan)
                    ]);
                    return res;
                });
                (0, $4Aa3G._optionalChain)([
                    span,
                    'optionalAccess',
                    (_12)=>_12.finish,
                    'call',
                    (_13)=>_13()
                ]);
                (0, $4Aa3G._optionalChain)([
                    scope,
                    'optionalAccess',
                    (_14)=>_14.setSpan,
                    'call',
                    (_15)=>_15(parentSpan)
                ]);
                return rv;
            };
        });
    }
}
$f4009f6a48aceb62$export$b735d011553f1049.__initStatic();

});

parcelRegister("571pR", function(module, exports) {

$parcel$export(module.exports, "Mongo", () => $3b8eb46a587f8679$export$968aa4360b02a334);

var $4Aa3G = parcelRequire("4Aa3G");

var $3CK1O = parcelRequire("3CK1O");
var $k7rM9 = parcelRequire("k7rM9");
var $fEKkD = parcelRequire("fEKkD");
var $elKLM = parcelRequire("elKLM");

var $fzFcM = parcelRequire("fzFcM");
// This allows us to use the same array for both defaults options and the type itself.
// (note `as const` at the end to make it a union of string literal types (i.e. "a" | "b" | ... )
// and not just a string[])
const $3b8eb46a587f8679$var$OPERATIONS = [
    'aggregate',
    'bulkWrite',
    'countDocuments',
    'createIndex',
    'createIndexes',
    'deleteMany',
    'deleteOne',
    'distinct',
    'drop',
    'dropIndex',
    'dropIndexes',
    'estimatedDocumentCount',
    'find',
    'findOne',
    'findOneAndDelete',
    'findOneAndReplace',
    'findOneAndUpdate',
    'indexes',
    'indexExists',
    'indexInformation',
    'initializeOrderedBulkOp',
    'insertMany',
    'insertOne',
    'isCapped',
    'mapReduce',
    'options',
    'parallelCollectionScan',
    'rename',
    'replaceOne',
    'stats',
    'updateMany',
    'updateOne'
];
// All of the operations above take `options` and `callback` as their final parameters, but some of them
// take additional parameters as well. For those operations, this is a map of
// { <operation name>:  [<names of additional parameters>] }, as a way to know what to call the operation's
// positional arguments when we add them to the span's `data` object later
const $3b8eb46a587f8679$var$OPERATION_SIGNATURES = {
    // aggregate intentionally not included because `pipeline` arguments are too complex to serialize well
    // see https://github.com/getsentry/sentry-javascript/pull/3102
    bulkWrite: [
        'operations'
    ],
    countDocuments: [
        'query'
    ],
    createIndex: [
        'fieldOrSpec'
    ],
    createIndexes: [
        'indexSpecs'
    ],
    deleteMany: [
        'filter'
    ],
    deleteOne: [
        'filter'
    ],
    distinct: [
        'key',
        'query'
    ],
    dropIndex: [
        'indexName'
    ],
    find: [
        'query'
    ],
    findOne: [
        'query'
    ],
    findOneAndDelete: [
        'filter'
    ],
    findOneAndReplace: [
        'filter',
        'replacement'
    ],
    findOneAndUpdate: [
        'filter',
        'update'
    ],
    indexExists: [
        'indexes'
    ],
    insertMany: [
        'docs'
    ],
    insertOne: [
        'doc'
    ],
    mapReduce: [
        'map',
        'reduce'
    ],
    rename: [
        'newName'
    ],
    replaceOne: [
        'filter',
        'doc'
    ],
    updateMany: [
        'filter',
        'update'
    ],
    updateOne: [
        'filter',
        'update'
    ]
};
function $3b8eb46a587f8679$var$isCursor(maybeCursor) {
    return maybeCursor && typeof maybeCursor === 'object' && maybeCursor.once && typeof maybeCursor.once === 'function';
}
/** Tracing integration for mongo package */ class $3b8eb46a587f8679$export$968aa4360b02a334 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Mongo';
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $3b8eb46a587f8679$export$968aa4360b02a334.id;
    }
    /**
   * @inheritDoc
   */ constructor(options = {}){
        $3b8eb46a587f8679$export$968aa4360b02a334.prototype.__init.call(this);
        this._operations = Array.isArray(options.operations) ? options.operations : $3b8eb46a587f8679$var$OPERATIONS;
        this._describeOperations = 'describeOperations' in options ? options.describeOperations : true;
        this._useMongoose = !!options.useMongoose;
    }
    /** @inheritdoc */ loadDependency() {
        const moduleName = this._useMongoose ? 'mongoose' : 'mongodb';
        return this._module = this._module || (0, $fEKkD.loadModule)(moduleName);
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if ((0, $fzFcM.shouldDisableAutoInstrumentation)(getCurrentHub)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('Mongo Integration is skipped because of instrumenter configuration.');
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            const moduleName = this._useMongoose ? 'mongoose' : 'mongodb';
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).error(`Mongo Integration was unable to require \`${moduleName}\` package.`);
            return;
        }
        this._instrumentOperations(pkg.Collection, this._operations, getCurrentHub);
    }
    /**
   * Patches original collection methods
   */ _instrumentOperations(collection, operations, getCurrentHub) {
        operations.forEach((operation)=>this._patchOperation(collection, operation, getCurrentHub));
    }
    /**
   * Patches original collection to utilize our tracing functionality
   */ _patchOperation(collection, operation, getCurrentHub) {
        if (!(operation in collection.prototype)) return;
        const getSpanContext = this._getSpanContextFromOperationArguments.bind(this);
        (0, $3CK1O.fill)(collection.prototype, operation, function(orig) {
            return function(...args) {
                const lastArg = args[args.length - 1];
                const scope = getCurrentHub().getScope();
                const parentSpan = (0, $4Aa3G._optionalChain)([
                    scope,
                    'optionalAccess',
                    (_2)=>_2.getSpan,
                    'call',
                    (_3)=>_3()
                ]);
                // Check if the operation was passed a callback. (mapReduce requires a different check, as
                // its (non-callback) arguments can also be functions.)
                if (typeof lastArg !== 'function' || operation === 'mapReduce' && args.length === 2) {
                    const span = (0, $4Aa3G._optionalChain)([
                        parentSpan,
                        'optionalAccess',
                        (_4)=>_4.startChild,
                        'call',
                        (_5)=>_5(getSpanContext(this, operation, args))
                    ]);
                    const maybePromiseOrCursor = orig.call(this, ...args);
                    if ((0, $k7rM9.isThenable)(maybePromiseOrCursor)) return maybePromiseOrCursor.then((res)=>{
                        (0, $4Aa3G._optionalChain)([
                            span,
                            'optionalAccess',
                            (_6)=>_6.finish,
                            'call',
                            (_7)=>_7()
                        ]);
                        return res;
                    });
                    else if ($3b8eb46a587f8679$var$isCursor(maybePromiseOrCursor)) {
                        const cursor = maybePromiseOrCursor;
                        try {
                            cursor.once('close', ()=>{
                                (0, $4Aa3G._optionalChain)([
                                    span,
                                    'optionalAccess',
                                    (_8)=>_8.finish,
                                    'call',
                                    (_9)=>_9()
                                ]);
                            });
                        } catch (e) {
                            // If the cursor is already closed, `once` will throw an error. In that case, we can
                            // finish the span immediately.
                            (0, $4Aa3G._optionalChain)([
                                span,
                                'optionalAccess',
                                (_10)=>_10.finish,
                                'call',
                                (_11)=>_11()
                            ]);
                        }
                        return cursor;
                    } else {
                        (0, $4Aa3G._optionalChain)([
                            span,
                            'optionalAccess',
                            (_12)=>_12.finish,
                            'call',
                            (_13)=>_13()
                        ]);
                        return maybePromiseOrCursor;
                    }
                }
                const span = (0, $4Aa3G._optionalChain)([
                    parentSpan,
                    'optionalAccess',
                    (_14)=>_14.startChild,
                    'call',
                    (_15)=>_15(getSpanContext(this, operation, args.slice(0, -1)))
                ]);
                return orig.call(this, ...args.slice(0, -1), function(err, result) {
                    (0, $4Aa3G._optionalChain)([
                        span,
                        'optionalAccess',
                        (_16)=>_16.finish,
                        'call',
                        (_17)=>_17()
                    ]);
                    lastArg(err, result);
                });
            };
        });
    }
    /**
   * Form a SpanContext based on the user input to a given operation.
   */ _getSpanContextFromOperationArguments(collection, operation, args) {
        const data = {
            collectionName: collection.collectionName,
            dbName: collection.dbName,
            namespace: collection.namespace
        };
        const spanContext = {
            op: 'db',
            description: operation,
            data: data
        };
        // If the operation takes no arguments besides `options` and `callback`, or if argument
        // collection is disabled for this operation, just return early.
        const signature = $3b8eb46a587f8679$var$OPERATION_SIGNATURES[operation];
        const shouldDescribe = Array.isArray(this._describeOperations) ? this._describeOperations.includes(operation) : this._describeOperations;
        if (!signature || !shouldDescribe) return spanContext;
        try {
            // Special case for `mapReduce`, as the only one accepting functions as arguments.
            if (operation === 'mapReduce') {
                const [map, reduce] = args;
                data[signature[0]] = typeof map === 'string' ? map : map.name || '<anonymous>';
                data[signature[1]] = typeof reduce === 'string' ? reduce : reduce.name || '<anonymous>';
            } else for(let i = 0; i < signature.length; i++)data[signature[i]] = JSON.stringify(args[i]);
        } catch (_oO) {
        // no-empty
        }
        return spanContext;
    }
}
$3b8eb46a587f8679$export$968aa4360b02a334.__initStatic();

});

parcelRegister("he8el", function(module, exports) {

$parcel$export(module.exports, "Mysql", () => $c8aa20d9a32af88d$export$a2cc26ff91a3f8ad);

var $4Aa3G = parcelRequire("4Aa3G");

var $3CK1O = parcelRequire("3CK1O");
var $fEKkD = parcelRequire("fEKkD");
var $elKLM = parcelRequire("elKLM");

var $fzFcM = parcelRequire("fzFcM");
/** Tracing integration for node-mysql package */ class $c8aa20d9a32af88d$export$a2cc26ff91a3f8ad {
    constructor(){
        $c8aa20d9a32af88d$export$a2cc26ff91a3f8ad.prototype.__init.call(this);
    }
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Mysql';
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $c8aa20d9a32af88d$export$a2cc26ff91a3f8ad.id;
    }
    /** @inheritdoc */ loadDependency() {
        return this._module = this._module || (0, $fEKkD.loadModule)('mysql/lib/Connection.js');
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if ((0, $fzFcM.shouldDisableAutoInstrumentation)(getCurrentHub)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('Mysql Integration is skipped because of instrumenter configuration.');
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).error('Mysql Integration was unable to require `mysql` package.');
            return;
        }
        // The original function will have one of these signatures:
        //    function (callback) => void
        //    function (options, callback) => void
        //    function (options, values, callback) => void
        (0, $3CK1O.fill)(pkg, 'createQuery', function(orig) {
            return function(options, values, callback) {
                const scope = getCurrentHub().getScope();
                const parentSpan = (0, $4Aa3G._optionalChain)([
                    scope,
                    'optionalAccess',
                    (_2)=>_2.getSpan,
                    'call',
                    (_3)=>_3()
                ]);
                const span = (0, $4Aa3G._optionalChain)([
                    parentSpan,
                    'optionalAccess',
                    (_4)=>_4.startChild,
                    'call',
                    (_5)=>_5({
                            description: typeof options === 'string' ? options : options.sql,
                            op: 'db'
                        })
                ]);
                if (typeof callback === 'function') return orig.call(this, options, values, function(err, result, fields) {
                    (0, $4Aa3G._optionalChain)([
                        span,
                        'optionalAccess',
                        (_6)=>_6.finish,
                        'call',
                        (_7)=>_7()
                    ]);
                    callback(err, result, fields);
                });
                if (typeof values === 'function') return orig.call(this, options, function(err, result, fields) {
                    (0, $4Aa3G._optionalChain)([
                        span,
                        'optionalAccess',
                        (_8)=>_8.finish,
                        'call',
                        (_9)=>_9()
                    ]);
                    values(err, result, fields);
                });
                return orig.call(this, options, values, callback);
            };
        });
    }
}
$c8aa20d9a32af88d$export$a2cc26ff91a3f8ad.__initStatic();

});

parcelRegister("d1Bxg", function(module, exports) {

$parcel$export(module.exports, "Postgres", () => $97b87c233cb827f1$export$806ddb599177abc4);

var $4Aa3G = parcelRequire("4Aa3G");

var $3CK1O = parcelRequire("3CK1O");
var $k7rM9 = parcelRequire("k7rM9");
var $fEKkD = parcelRequire("fEKkD");
var $elKLM = parcelRequire("elKLM");

var $fzFcM = parcelRequire("fzFcM");
/** Tracing integration for node-postgres package */ class $97b87c233cb827f1$export$806ddb599177abc4 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Postgres';
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $97b87c233cb827f1$export$806ddb599177abc4.id;
    }
    constructor(options = {}){
        $97b87c233cb827f1$export$806ddb599177abc4.prototype.__init.call(this);
        this._usePgNative = !!options.usePgNative;
    }
    /** @inheritdoc */ loadDependency() {
        return this._module = this._module || (0, $fEKkD.loadModule)('pg');
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if ((0, $fzFcM.shouldDisableAutoInstrumentation)(getCurrentHub)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('Postgres Integration is skipped because of instrumenter configuration.');
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).error('Postgres Integration was unable to require `pg` package.');
            return;
        }
        if (this._usePgNative && !(0, $4Aa3G._optionalChain)([
            pkg,
            'access',
            (_2)=>_2.native,
            'optionalAccess',
            (_3)=>_3.Client
        ])) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).error("Postgres Integration was unable to access 'pg-native' bindings.");
            return;
        }
        const { Client: Client } = this._usePgNative ? pkg.native : pkg;
        /**
     * function (query, callback) => void
     * function (query, params, callback) => void
     * function (query) => Promise
     * function (query, params) => Promise
     * function (pg.Cursor) => pg.Cursor
     */ (0, $3CK1O.fill)(Client.prototype, 'query', function(orig) {
            return function(config, values, callback) {
                const scope = getCurrentHub().getScope();
                const parentSpan = (0, $4Aa3G._optionalChain)([
                    scope,
                    'optionalAccess',
                    (_4)=>_4.getSpan,
                    'call',
                    (_5)=>_5()
                ]);
                const span = (0, $4Aa3G._optionalChain)([
                    parentSpan,
                    'optionalAccess',
                    (_6)=>_6.startChild,
                    'call',
                    (_7)=>_7({
                            description: typeof config === 'string' ? config : config.text,
                            op: 'db'
                        })
                ]);
                if (typeof callback === 'function') return orig.call(this, config, values, function(err, result) {
                    (0, $4Aa3G._optionalChain)([
                        span,
                        'optionalAccess',
                        (_8)=>_8.finish,
                        'call',
                        (_9)=>_9()
                    ]);
                    callback(err, result);
                });
                if (typeof values === 'function') return orig.call(this, config, function(err, result) {
                    (0, $4Aa3G._optionalChain)([
                        span,
                        'optionalAccess',
                        (_10)=>_10.finish,
                        'call',
                        (_11)=>_11()
                    ]);
                    values(err, result);
                });
                const rv = typeof values !== 'undefined' ? orig.call(this, config, values) : orig.call(this, config);
                if ((0, $k7rM9.isThenable)(rv)) return rv.then((res)=>{
                    (0, $4Aa3G._optionalChain)([
                        span,
                        'optionalAccess',
                        (_12)=>_12.finish,
                        'call',
                        (_13)=>_13()
                    ]);
                    return res;
                });
                (0, $4Aa3G._optionalChain)([
                    span,
                    'optionalAccess',
                    (_14)=>_14.finish,
                    'call',
                    (_15)=>_15()
                ]);
                return rv;
            };
        });
    }
}
$97b87c233cb827f1$export$806ddb599177abc4.__initStatic();

});

parcelRegister("fv3Z4", function(module, exports) {

$parcel$export(module.exports, "Prisma", () => $b48cd7643a1b3562$export$e300e6f4779d55c2);

var $4Aa3G = parcelRequire("4Aa3G");

var $k7rM9 = parcelRequire("k7rM9");
var $elKLM = parcelRequire("elKLM");

var $fzFcM = parcelRequire("fzFcM");
function $b48cd7643a1b3562$var$isValidPrismaClient(possibleClient) {
    return possibleClient && !!possibleClient['$use'];
}
/** Tracing integration for @prisma/client package */ class $b48cd7643a1b3562$export$e300e6f4779d55c2 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Prisma';
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $b48cd7643a1b3562$export$e300e6f4779d55c2.id;
    }
    /**
   * Prisma ORM Client Instance
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        $b48cd7643a1b3562$export$e300e6f4779d55c2.prototype.__init.call(this);
        if ($b48cd7643a1b3562$var$isValidPrismaClient(options.client)) this._client = options.client;
        else (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn(`Unsupported Prisma client provided to PrismaIntegration. Provided client: ${JSON.stringify(options.client)}`);
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if (!this._client) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).error('PrismaIntegration is missing a Prisma Client Instance');
            return;
        }
        if ((0, $fzFcM.shouldDisableAutoInstrumentation)(getCurrentHub)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('Prisma Integration is skipped because of instrumenter configuration.');
            return;
        }
        this._client.$use((params, next)=>{
            const scope = getCurrentHub().getScope();
            const parentSpan = (0, $4Aa3G._optionalChain)([
                scope,
                'optionalAccess',
                (_2)=>_2.getSpan,
                'call',
                (_3)=>_3()
            ]);
            const action = params.action;
            const model = params.model;
            const span = (0, $4Aa3G._optionalChain)([
                parentSpan,
                'optionalAccess',
                (_4)=>_4.startChild,
                'call',
                (_5)=>_5({
                        description: model ? `${model} ${action}` : action,
                        op: 'db.sql.prisma'
                    })
            ]);
            const rv = next(params);
            if ((0, $k7rM9.isThenable)(rv)) return rv.then((res)=>{
                (0, $4Aa3G._optionalChain)([
                    span,
                    'optionalAccess',
                    (_6)=>_6.finish,
                    'call',
                    (_7)=>_7()
                ]);
                return res;
            });
            (0, $4Aa3G._optionalChain)([
                span,
                'optionalAccess',
                (_8)=>_8.finish,
                'call',
                (_9)=>_9()
            ]);
            return rv;
        });
    }
}
$b48cd7643a1b3562$export$e300e6f4779d55c2.__initStatic();

});

parcelRegister("kBpSh", function(module, exports) {

$parcel$export(module.exports, "SpanStatus", () => $effb55811c4fa66a$export$beb8e6a823e89c5d);
/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ // eslint-disable-next-line import/export
var $effb55811c4fa66a$export$beb8e6a823e89c5d;
(function(SpanStatus) {
    /** The operation completed successfully. */ const Ok = 'ok';
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ const DeadlineExceeded = 'deadline_exceeded';
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ const Unauthenticated = 'unauthenticated';
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ const PermissionDenied = 'permission_denied';
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ const NotFound = 'not_found';
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ const ResourceExhausted = 'resource_exhausted';
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ const InvalidArgument = 'invalid_argument';
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ const Unimplemented = 'unimplemented';
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ const Unavailable = 'unavailable';
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ const InternalError = 'internal_error';
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ const UnknownError = 'unknown_error';
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ const Cancelled = 'cancelled';
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ const AlreadyExists = 'already_exists';
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ const FailedPrecondition = 'failed_precondition';
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ const Aborted = 'aborted';
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ const OutOfRange = 'out_of_range';
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ const DataLoss = 'data_loss';
    SpanStatus["DataLoss"] = DataLoss;
})($effb55811c4fa66a$export$beb8e6a823e89c5d || ($effb55811c4fa66a$export$beb8e6a823e89c5d = {}));

});


parcelRegister("4xrfU", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");

var $34df62e34a2e7a21$var$func = $jFIrw('set', (parcelRequire("a0i0f")));

$34df62e34a2e7a21$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $34df62e34a2e7a21$var$func;

});
parcelRegister("a0i0f", function(module, exports) {

var $buvff = parcelRequire("buvff");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $7487de7aebcafd99$var$set(object, path, value) {
    return object == null ? object : $buvff(object, path, value);
}
module.exports = $7487de7aebcafd99$var$set;

});


parcelRegister("cdSID", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e6124fcef72411c$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
const $8e6124fcef72411c$var$getRecentErrors = (errors, maxMinutesOld)=>{
    const maxMillisecondsOld = maxMinutesOld * 60000;
    const minAge = Date.now() - maxMillisecondsOld;
    return errors.filter((error)=>error.time >= minAge);
};
class $8e6124fcef72411c$var$ErrorKeeper {
    static add(errorId) {
        $8e6124fcef72411c$var$ErrorKeeper.errors.push({
            id: errorId,
            time: Date.now()
        });
        // keeping a stack of 20 error assuming this much stack
        // should be sufficient to debug user issues under last 3 minutes.
        // since use may chose to register a bug some time after the error has actually happened.
        // so not filtering based on time here.
        if ($8e6124fcef72411c$var$ErrorKeeper.errors.length > 20) $8e6124fcef72411c$var$ErrorKeeper.errors.shift();
    }
    static getLastNMinutesErrors() {
        let min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
        return $8e6124fcef72411c$var$getRecentErrors($8e6124fcef72411c$var$ErrorKeeper.errors, min).map((error)=>error.id);
    }
}
(0, $5zQU9.default)($8e6124fcef72411c$var$ErrorKeeper, "errors", []);
var $8e6124fcef72411c$export$2e2bcd8739ae039 = $8e6124fcef72411c$var$ErrorKeeper;

});

parcelRegister("7lvGB", function(module, exports) {

$parcel$export(module.exports, "objectToPathValuePair", () => $559312c81b6f4425$export$d030967c0b6e21ad);
$parcel$export(module.exports, "pathValuePairToObject", () => $559312c81b6f4425$export$cb17130c973f58ff);
$parcel$export(module.exports, "removeAttributes", () => $559312c81b6f4425$export$53fcb63c2c7a968f);
$parcel$export(module.exports, "isPlainObject", () => $559312c81b6f4425$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isOptionSelected", () => $559312c81b6f4425$export$1c98cb0a1dc8129e);

var $jtsd5 = parcelRequire("jtsd5");

var $kd0cS = parcelRequire("kd0cS");

var $a0i0f = parcelRequire("a0i0f");

var $fUTZC = parcelRequire("fUTZC");

var $9BtCH = parcelRequire("9BtCH");

var $1c8hB = parcelRequire("1c8hB");

var $feGjZ = parcelRequire("feGjZ");

var $lUFEu = parcelRequire("lUFEu");

var $gKA5o = parcelRequire("gKA5o");

var $jh2R9 = parcelRequire("jh2R9");
function $559312c81b6f4425$export$7ca75779cdfd0dd5(originalObject) {
    let depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return Object.entries(originalObject).reduce((transformedObject, _ref)=>{
        let [key, value] = _ref;
        const newKey = (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(key);
        const newValue = typeof value === 'object' && (depth === null || depth > 1) ? $559312c81b6f4425$export$7ca75779cdfd0dd5(value, depth === null ? depth : depth - 1) : value;
        transformedObject[newKey] = newValue;
        return transformedObject;
    }, {});
}
const $559312c81b6f4425$export$c4f1fe821c494e19 = (()=>{
    // eslint-disable-next-line unicorn/better-regex, no-useless-escape
    const UNSAFE_CHARS_REGEXP = /[<>\/\u2028\u2029]/g;
    const ESCAPED_CHARS = {
        '<': '\\u003C',
        '>': '\\u003E',
        '/': '\\u002F',
        '\u2028': '\\u2028',
        '\u2029': '\\u2029'
    };
    const escapeUnsafeChars = (unsafeChar)=>ESCAPED_CHARS[unsafeChar];
    return (obj)=>{
        const serialized = typeof obj === 'string' ? obj : JSON.stringify(obj);
        // Protects against `JSON.stringify()` returning `undefined`, by serializing
        // to the literal string: "undefined".
        if (typeof serialized !== 'string') return String(serialized);
        return serialized.replace(UNSAFE_CHARS_REGEXP, escapeUnsafeChars);
    };
})();
const $559312c81b6f4425$export$de7358b4991653b1 = function flattenObject(obj) {
    let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return Object.keys(obj).reduce((acc, k)=>{
        const pre = prefix.length ? prefix + '.' : '';
        if (obj[k] && typeof obj[k] === 'object' && !Array.isArray(obj[k])) Object.assign(acc, flattenObject(obj[k], pre + k));
        else acc[pre + k] = obj[k];
        return acc;
    }, {});
};
const $559312c81b6f4425$export$d8669a1344423b58 = (data)=>{
    const result = {};
    for(const i in data){
        const keys = i.split('.');
        keys.reduce((r, e, j)=>{
            return r[e] || (r[e] = isNaN(Number(keys[j + 1])) ? keys.length - 1 == j ? data[i] : {} : []);
        }, result);
    }
    return result;
};
function $559312c81b6f4425$export$641b3aa2ed837fc2(obj) {
    try {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($feGjZ)))(obj) || (0, (/*@__PURE__*/$parcel$interopDefault($1c8hB)))(obj)) return JSON.parse(JSON.stringify(obj));
        else throw new Error('Expected an object however received something else');
    } catch (e) {
        console.error('ERROR: objectToPathValuePair -> e', e);
        throw e;
    }
}
function $559312c81b6f4425$export$d030967c0b6e21ad(obj) {
    let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    obj = $559312c81b6f4425$export$641b3aa2ed837fc2(obj);
    return (0, (/*@__PURE__*/$parcel$interopDefault($9BtCH)))(obj, (result, value, key)=>{
        const newKey = prefix ? "".concat(prefix, ".").concat(key) : key;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($feGjZ)))(value) && !(0, (/*@__PURE__*/$parcel$interopDefault($1c8hB)))(value)) Object.assign(result, $559312c81b6f4425$export$d030967c0b6e21ad(value, newKey));
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($1c8hB)))(value)) (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(value, (item, index)=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($feGjZ)))(item) && !(0, (/*@__PURE__*/$parcel$interopDefault($1c8hB)))(item)) Object.assign(result, $559312c81b6f4425$export$d030967c0b6e21ad(item, "".concat(newKey, "[").concat(index, "]")));
            else result["".concat(newKey, "[").concat(index, "]")] = item;
        });
        else result[newKey] = value;
        return result;
    }, {});
}
function $559312c81b6f4425$export$cb17130c973f58ff(obj) {
    obj = $559312c81b6f4425$export$641b3aa2ed837fc2(obj);
    const result = {};
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(obj, (value, key)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(result, key, value);
    });
    return result;
}
function $559312c81b6f4425$export$53fcb63c2c7a968f(obj, keys) {
    const newObj = (0, (/*@__PURE__*/$parcel$interopDefault($kd0cS)))(obj);
    const helper = (paramObj)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(paramObj, (value, key)=>{
            if (value && typeof value === 'object') helper(value);
            if (keys.includes(key)) delete paramObj[key];
        });
    };
    helper(newObj);
    return newObj;
}
function $559312c81b6f4425$export$53b83ca8eaab0383(obj) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jtsd5)))(obj);
}
function $559312c81b6f4425$export$1c98cb0a1dc8129e(selectedOptions) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($lUFEu)))(selectedOptions, (option)=>(0, (/*@__PURE__*/$parcel$interopDefault($gKA5o)))(option) > 0);
}

});
parcelRegister("9BtCH", function(module, exports) {

var $flmMe = parcelRequire("flmMe");

var $awetI = parcelRequire("awetI");

var $7qARj = parcelRequire("7qARj");

var $jhbYY = parcelRequire("jhbYY");

var $1c8hB = parcelRequire("1c8hB");
/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function $6fde8c506e131c3e$var$reduce(collection, iteratee, accumulator) {
    var func = $1c8hB(collection) ? $flmMe : $jhbYY, initAccum = arguments.length < 3;
    return func(collection, $7qARj(iteratee, 4), accumulator, initAccum, $awetI);
}
module.exports = $6fde8c506e131c3e$var$reduce;

});
parcelRegister("jhbYY", function(module, exports) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function $e088e655a3a9a31d$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
module.exports = $e088e655a3a9a31d$var$baseReduce;

});


parcelRegister("lUFEu", function(module, exports) {

var $jqs7R = parcelRequire("jqs7R");

var $7qARj = parcelRequire("7qARj");

var $8v3yf = parcelRequire("8v3yf");

var $1c8hB = parcelRequire("1c8hB");

var $3P7i5 = parcelRequire("3P7i5");
/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $ff3f232f92bb24aa$var$some(collection, predicate, guard) {
    var func = $1c8hB(collection) ? $jqs7R : $8v3yf;
    if (guard && $3P7i5(collection, predicate, guard)) predicate = undefined;
    return func(collection, $7qARj(predicate, 3));
}
module.exports = $ff3f232f92bb24aa$var$some;

});
parcelRegister("8v3yf", function(module, exports) {

var $awetI = parcelRequire("awetI");
/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $6303f9332a27a1b4$var$baseSome(collection, predicate) {
    var result;
    $awetI(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
module.exports = $6303f9332a27a1b4$var$baseSome;

});


parcelRegister("gKA5o", function(module, exports) {

var $fCpZe = parcelRequire("fCpZe");

var $fjnSB = parcelRequire("fjnSB");

var $jxg5X = parcelRequire("jxg5X");

var $4ZYEI = parcelRequire("4ZYEI");

var $eQiJU = parcelRequire("eQiJU");
/** `Object#toString` result references. */ var $c31cef206f882b8b$var$mapTag = '[object Map]', $c31cef206f882b8b$var$setTag = '[object Set]';
/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */ function $c31cef206f882b8b$var$size(collection) {
    if (collection == null) return 0;
    if ($jxg5X(collection)) return $4ZYEI(collection) ? $eQiJU(collection) : collection.length;
    var tag = $fjnSB(collection);
    if (tag == $c31cef206f882b8b$var$mapTag || tag == $c31cef206f882b8b$var$setTag) return collection.size;
    return $fCpZe(collection).length;
}
module.exports = $c31cef206f882b8b$var$size;

});
parcelRegister("eQiJU", function(module, exports) {

var $3K42x = parcelRequire("3K42x");

var $fFFC0 = parcelRequire("fFFC0");

var $CYLq5 = parcelRequire("CYLq5");
/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */ function $ace4754dece6a484$var$stringSize(string) {
    return $fFFC0(string) ? $CYLq5(string) : $3K42x(string);
}
module.exports = $ace4754dece6a484$var$stringSize;

});
parcelRegister("3K42x", function(module, exports) {

var $pRnxj = parcelRequire("pRnxj");
/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ var $2b98cd398295eed4$var$asciiSize = $pRnxj('length');
module.exports = $2b98cd398295eed4$var$asciiSize;

});

parcelRegister("CYLq5", function(module, exports) {
/** Used to compose unicode character classes. */ var $0752af280e68c649$var$rsAstralRange = '\\ud800-\\udfff', $0752af280e68c649$var$rsComboMarksRange = '\\u0300-\\u036f', $0752af280e68c649$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $0752af280e68c649$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $0752af280e68c649$var$rsComboRange = $0752af280e68c649$var$rsComboMarksRange + $0752af280e68c649$var$reComboHalfMarksRange + $0752af280e68c649$var$rsComboSymbolsRange, $0752af280e68c649$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $0752af280e68c649$var$rsAstral = '[' + $0752af280e68c649$var$rsAstralRange + ']', $0752af280e68c649$var$rsCombo = '[' + $0752af280e68c649$var$rsComboRange + ']', $0752af280e68c649$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $0752af280e68c649$var$rsModifier = '(?:' + $0752af280e68c649$var$rsCombo + '|' + $0752af280e68c649$var$rsFitz + ')', $0752af280e68c649$var$rsNonAstral = '[^' + $0752af280e68c649$var$rsAstralRange + ']', $0752af280e68c649$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $0752af280e68c649$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $0752af280e68c649$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $0752af280e68c649$var$reOptMod = $0752af280e68c649$var$rsModifier + '?', $0752af280e68c649$var$rsOptVar = '[' + $0752af280e68c649$var$rsVarRange + ']?', $0752af280e68c649$var$rsOptJoin = '(?:' + $0752af280e68c649$var$rsZWJ + '(?:' + [
    $0752af280e68c649$var$rsNonAstral,
    $0752af280e68c649$var$rsRegional,
    $0752af280e68c649$var$rsSurrPair
].join('|') + ')' + $0752af280e68c649$var$rsOptVar + $0752af280e68c649$var$reOptMod + ')*', $0752af280e68c649$var$rsSeq = $0752af280e68c649$var$rsOptVar + $0752af280e68c649$var$reOptMod + $0752af280e68c649$var$rsOptJoin, $0752af280e68c649$var$rsSymbol = '(?:' + [
    $0752af280e68c649$var$rsNonAstral + $0752af280e68c649$var$rsCombo + '?',
    $0752af280e68c649$var$rsCombo,
    $0752af280e68c649$var$rsRegional,
    $0752af280e68c649$var$rsSurrPair,
    $0752af280e68c649$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $0752af280e68c649$var$reUnicode = RegExp($0752af280e68c649$var$rsFitz + '(?=' + $0752af280e68c649$var$rsFitz + ')|' + $0752af280e68c649$var$rsSymbol + $0752af280e68c649$var$rsSeq, 'g');
/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ function $0752af280e68c649$var$unicodeSize(string) {
    var result = $0752af280e68c649$var$reUnicode.lastIndex = 0;
    while($0752af280e68c649$var$reUnicode.test(string))++result;
    return result;
}
module.exports = $0752af280e68c649$var$unicodeSize;

});





parcelRegister("iUPNF", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc55a35fafe6e4e8$export$2e2bcd8739ae039);
/**
 * NOTE: THIS FILE IS ONLY USED IN DEVELOPMENT",
 * DURING PACKAGE BUILD IT IS REGENERATED WITH ACTUAL VERSION OF THE EMCEE PACKAGE
 */ const $dc55a35fafe6e4e8$var$placeholderVersion = '19.19.3';
var $dc55a35fafe6e4e8$export$2e2bcd8739ae039 = $dc55a35fafe6e4e8$var$placeholderVersion;

});

parcelRegister("3lzNh", function(module, exports) {

$parcel$export(module.exports, "HomePageTask", () => $26ff192e44e083b7$export$44d1267b1bc214e1);
$parcel$export(module.exports, "SearchPageTask", () => $26ff192e44e083b7$export$731695bdd8573f3a);
$parcel$export(module.exports, "AppListingPageTask", () => $26ff192e44e083b7$export$e0d6864f92f9de60);
$parcel$export(module.exports, "AppInstallTask", () => $26ff192e44e083b7$export$6d832d173539f446);
$parcel$export(module.exports, "AppInstallFailurePartner", () => $26ff192e44e083b7$export$c6bdfae761cfbf22);
$parcel$export(module.exports, "AppInstallFailureDownstream", () => $26ff192e44e083b7$export$7a10bd00860704ee);
$parcel$export(module.exports, "AppInstallFailureCustomer", () => $26ff192e44e083b7$export$d73f016983077cf7);
$parcel$export(module.exports, "AppInstallFailureMarketplace", () => $26ff192e44e083b7$export$12cd11034dad8cd7);
$parcel$export(module.exports, "RequestAppTask", () => $26ff192e44e083b7$export$f8c9ca65d68ce04f);

var $4fL5K = parcelRequire("4fL5K");

var $jICRJ = parcelRequire("jICRJ");

var $fUOHe = parcelRequire("fUOHe");
const $26ff192e44e083b7$export$44d1267b1bc214e1 = (0, $fUOHe.default).createPageViewTask('view-home-page').dependsOn([
    (0, $4fL5K).SearchTask
]);
const $26ff192e44e083b7$export$731695bdd8573f3a = (0, $fUOHe.default).createPageViewTask('view-search-results-page').dependsOn([
    (0, $4fL5K).SearchTask
]);
const $26ff192e44e083b7$export$e0d6864f92f9de60 = (0, $fUOHe.default).createPageViewTask('view-app-listing-page').dependsOn([
    (0, $jICRJ).AppListingTask
]);
const $26ff192e44e083b7$export$6d832d173539f446 = (0, $fUOHe.default).createGenericTask('install-app');
const $26ff192e44e083b7$export$c6bdfae761cfbf22 = (0, $fUOHe.default).createGenericTask('install-app-failure-partner');
const $26ff192e44e083b7$export$7a10bd00860704ee = (0, $fUOHe.default).createGenericTask('install-app-failure-atlassian-downstream');
const $26ff192e44e083b7$export$d73f016983077cf7 = (0, $fUOHe.default).createGenericTask('install-app-failure-customer');
const $26ff192e44e083b7$export$12cd11034dad8cd7 = (0, $fUOHe.default).createGenericTask('install-app-failure-atlassian-marketplace');
const $26ff192e44e083b7$export$f8c9ca65d68ce04f = (0, $fUOHe.default).createGenericTask('request-app');

});
parcelRegister("jICRJ", function(module, exports) {

$parcel$export(module.exports, "viewAppDetailsTask", () => $e5b046469b7f610a$export$caa82e45bc907d19);
$parcel$export(module.exports, "AppListingTask", () => $e5b046469b7f610a$export$a748921f7ae927dd);

var $fUOHe = parcelRequire("fUOHe");
const $e5b046469b7f610a$export$caa82e45bc907d19 = 'view-app-details';
const $e5b046469b7f610a$export$a748921f7ae927dd = (0, $fUOHe.default).createGenericTask($e5b046469b7f610a$export$caa82e45bc907d19);

});


parcelRegister("9IC13", function(module, exports) {

$parcel$export(module.exports, "installableAppIdentifiersAreEqual", () => $7135b64fd823227a$export$a6ebc066f4a547c0);
$parcel$export(module.exports, "trackAppInstallTelemetryTaskError", () => $7135b64fd823227a$export$1525d8981e97c316);

var $fUOHe = parcelRequire("fUOHe");

var $jM4Wc = parcelRequire("jM4Wc");

var $ifMZN = parcelRequire("ifMZN");

var $3lzNh = parcelRequire("3lzNh");
const $7135b64fd823227a$export$a6ebc066f4a547c0 = (a, b)=>(0, $ifMZN.foldInstallableAppIdentifier)(a)((installableAppByKeyId)=>installableAppByKeyId.equals(b), (installableAppByUrlId)=>installableAppByUrlId.equals(b), ()=>true);
const $7135b64fd823227a$export$1525d8981e97c316 = (error)=>{
    (0, $fUOHe.default).setUFOInteractionError({
        name: 'install-app-failed',
        errorMessage: error.code
    }, 'install-app');
    if ((0, $jM4Wc.AppInstallationPartnerErrorCodeOwnership)[error.code]) {
        (0, $3lzNh.AppInstallFailurePartner).start();
        (0, $3lzNh.AppInstallFailurePartner).failed(error, error.code); // Additional event to track errors due to partners
        (0, $3lzNh.AppInstallTask).abort(); // AppInstall Task is aborted here as failure due to an error code where the partner is responsible should not be counted in our app installation metric
    } else if ((0, $jM4Wc.AppInstallCustomerErrorCodeOwnership)[error.code]) {
        (0, $3lzNh.AppInstallFailureCustomer).start();
        (0, $3lzNh.AppInstallFailureCustomer).failed(error, error.code); // Additional event to track errors due to customers
        (0, $3lzNh.AppInstallTask).abort(); // AppInstall Task is aborted here as failure due to an error code where the customer/user is responsible should not be counted in our app installation metric
    } else {
        var _AppInstallAtlassianE;
        (0, $3lzNh.AppInstallTask).failed(error, error.code);
        if (((_AppInstallAtlassianE = (0, $jM4Wc.AppInstallAtlassianErrorCodeOwnership)[error.code]) === null || _AppInstallAtlassianE === void 0 ? void 0 : _AppInstallAtlassianE.primaryOwner) === (0, $jM4Wc.Owners).Downstream) {
            (0, $3lzNh.AppInstallFailureDownstream).start();
            (0, $3lzNh.AppInstallFailureDownstream).failed(error, error.code); // Additional event to track errors due to downstream services
        } else {
            (0, $3lzNh.AppInstallFailureMarketplace).start();
            (0, $3lzNh.AppInstallFailureMarketplace).failed(error, error.code); // Additional event to track errors due to marketplace services
        }
    }
};

});
parcelRegister("jM4Wc", function(module, exports) {

$parcel$export(module.exports, "Owners", () => $e656548815279dad$export$be90eba74a871053);
$parcel$export(module.exports, "AppInstallAtlassianErrorCodeOwnership", () => $e656548815279dad$export$c0e5898acf0cbfed);
$parcel$export(module.exports, "AppInstallationPartnerErrorCodeOwnership", () => $e656548815279dad$export$645b42a0bfb4f809);
$parcel$export(module.exports, "AppInstallCustomerErrorCodeOwnership", () => $e656548815279dad$export$9ce45f8f6d9e94e7);
/** These are the list of error codes which could lead to the failure of installing an app.
 * They are divided into 3 categories as per their owners: Atlassian, Partner & Customer
 * Also there is information added about the services for each of the error codes.
 */ var $e656548815279dad$export$be90eba74a871053 = /*#__PURE__*/ function(Owners) {
    Owners[Owners["Downstream"] = 0] = "Downstream";
    Owners[Owners["Marketplace"] = 1] = "Marketplace";
    Owners[Owners["Partner"] = 2] = "Partner";
    Owners[Owners["Customer"] = 3] = "Customer";
    return Owners;
}($e656548815279dad$export$be90eba74a871053 || {});
var $e656548815279dad$var$Services = /*#__PURE__*/ function(Services) {
    Services[Services["UPM"] = 0] = "UPM";
    Services[Services["COFS"] = 1] = "COFS";
    Services[Services["TCS"] = 2] = "TCS";
    Services[Services["Connect"] = 3] = "Connect";
    Services[Services["CAAS"] = 4] = "CAAS";
    Services[Services["AppCatalog"] = 5] = "AppCatalog";
    Services[Services["BAG"] = 6] = "BAG";
    Services[Services["Demand"] = 7] = "Demand";
    Services[Services["CCP"] = 8] = "CCP";
    Services[Services["Marketplace"] = 9] = "Marketplace";
    return Services;
}($e656548815279dad$var$Services || {});
const $e656548815279dad$export$c0e5898acf0cbfed = {
    'upm.plugin.error.install.error': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.UPM
        ]
    },
    'upm.plugin.error.timeout.license.change': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Downstream,
        otherOwners: [
            $e656548815279dad$export$be90eba74a871053.Customer
        ],
        services: [
            $e656548815279dad$var$Services.COFS,
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    'upm.error.invalid.token ': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    UPMTokenFetchError: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    UPMInstallPostError: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.UPM
        ]
    },
    FetchAddonInternalError: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.TCS,
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    AppProvisioningError: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Downstream,
        services: [
            $e656548815279dad$var$Services.CCP
        ]
    },
    Undefined: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    FetchError: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    GraphQLFetchError: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    'unexpected.exception': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    '12': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    APP_REACTIVATION_NOT_SUPPORTED: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Downstream,
        services: [
            $e656548815279dad$var$Services.CCP,
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    AppInstallationTaskFailedError: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Downstream,
        services: [
            $e656548815279dad$var$Services.CAAS
        ]
    },
    'EcosystemCloudInstallPollFailure-unknown.error.code': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Downstream,
        services: [
            $e656548815279dad$var$Services.CAAS
        ]
    },
    EcosystemCloudAppFetchFailed: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Downstream,
        services: [
            $e656548815279dad$var$Services.CAAS
        ]
    },
    'cofs.billingApi.exception': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Downstream,
        services: [
            $e656548815279dad$var$Services.BAG
        ]
    },
    'connect.install.error.conflicting.macro.alias': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Downstream,
        otherOwners: [
            $e656548815279dad$export$be90eba74a871053.Partner
        ],
        services: [
            $e656548815279dad$var$Services.Connect,
            $e656548815279dad$var$Services.CAAS,
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    'connect.install.error.dependencies.failed': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Downstream,
        services: [
            $e656548815279dad$var$Services.Connect,
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    'connect.install.error.duplicate.macro.keys': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Downstream,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    /** Errors thrown via Store BFF flow */ InvalidInstallationTargetInfo: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    UnknownErrorInMarketplaceStoreAppInstall: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    UNSUPPORTED_BILLING_SYSTEM: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    APP_ALREADY_PROVISIONED: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Downstream,
        services: [
            $e656548815279dad$var$Services.COFS,
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    PAYMENT_MODEL_NOT_FOUND: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Downstream,
        services: [
            $e656548815279dad$var$Services.AppCatalog
        ]
    },
    INCOMPATIBLE_PRODUCT: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.AppCatalog,
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    FREE_APPS_PROVISIONING_NOT_SUPPORTED: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    TRANSACTION_ACCOUNT_ID_NOT_FOUND: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Downstream,
        services: [
            $e656548815279dad$var$Services.CCP
        ]
    },
    CCP_ENTITLEMENT_RELATIONSHIP_NOT_FOUND: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Downstream,
        services: [
            $e656548815279dad$var$Services.CCP
        ]
    },
    NO_RESOURCE_PACKAGE_FOUND: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Downstream,
        services: [
            $e656548815279dad$var$Services.COFS
        ]
    },
    PAYMENT_MODEL_NOT_SUPPORTED_FOR_INSTALLATION: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.Marketplace
        ]
    }
};
const $e656548815279dad$export$645b42a0bfb4f809 = {
    /* The following category of errors are only fixable by the partner */ 'connect.install.error.remote.host.bad.response': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.remote.host.bad.response.400': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.remote.host.bad.response.401': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.remote.host.bad.response.402': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.remote.host.bad.response.403': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.remote.host.bad.response.404': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.remote.host.bad.response.500': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.remote.host.bad.response.501': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.remote.host.bad.response.502': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.remote.host.bad.response.503': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.remote.host.bad.domain': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.remote.host.timeout': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.remote.host.ssl': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.unknown.module': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.remote.descriptor.validation': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.deprecated.context.iframe.url': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.auth.with.no.installed.callback': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.page.with.invalid.condition': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.page.with.invalid.property': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.webhook.with.invalid.condition': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.missing.scope': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.no.modules': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.base_url.invalid_host': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.base_url.no_tls': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.invalid.location': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.invalid.location.mobile': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.invalid.platform.mobile': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.invalid.condition.parameters': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.missing.url': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.region.unsupported': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        otherOwners: [
            $e656548815279dad$export$be90eba74a871053.Marketplace
        ],
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.data.resident.validation.failed': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.blueprint.description.too_long': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.url.and.target.dialog.key': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.invalid.target.dialog.key': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.invalid.cacheable.iframe.url': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.webitem.dialogmodule.cacheable': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.webitem.pagecontext.cacheable': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.webhooks.url-params.deprecated': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.missing.dialogmodule.item.options': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.invalid.dialogoptions.dimension': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.invalid.dialogoptions.dimensions': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.dependencies.disabled': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.dependencies.multilevel.failed': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.marketplace.no.public.versions': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.i18n.disabled': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.i18n.download.malformed': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.i18n.download.value.long': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.duplicate.module.keys': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.entity_properties.modules.disabled': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        otherOwners: [
            $e656548815279dad$export$be90eba74a871053.Marketplace
        ],
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.user.provisioning': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.jira.issue.alpha': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        otherOwners: [
            $e656548815279dad$export$be90eba74a871053.Marketplace
        ],
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.remote.upm.install.exception': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'upm.pluginInstall.error.response.exception': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        otherOwners: [
            $e656548815279dad$export$be90eba74a871053.Marketplace
        ],
        services: [
            $e656548815279dad$var$Services.UPM
        ]
    },
    'upm.pluginInstall.error.install.failed': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.UPM
        ]
    },
    'upm.pluginInstall.error.unknown.plugin.type': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.UPM
        ]
    },
    'upm.pluginInstall.error.ssl': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.UPM
        ]
    },
    'connect.install.error.not.email.approved': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    }
};
const $e656548815279dad$export$9ce45f8f6d9e94e7 = {
    /** This error is when the user has failed to update payment details in their instance */ 'connect.remote.upm.install.payment.failure.exception': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Customer,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    /** This error is when installation for the same forge app is already in progress - [MC-2837] */ TASK_ALREADY_EXISTS: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Customer,
        services: [
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    /** Ignore erros specific to forge apps when install fails due to customer account pending renewal */ 'EcosystemCloudInstallPollFailure-account.pending.renewal': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Customer,
        services: [
            $e656548815279dad$var$Services.CAAS
        ]
    },
    'connect.install.error.addon.admin.permission': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Customer,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.locked': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Customer,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.nodefaultgroup': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Customer,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    /** This can occur if the parent product does not have an active license.*/ NO_CCP_ENTITLEMENT_FOR_PRODUCT: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Customer,
        services: [
            $e656548815279dad$var$Services.CCP
        ]
    }
};

});


parcelRegister("2FnMA", function(module, exports) {

$parcel$export(module.exports, "appInstallFlagKeys", () => $1f11dbd45093130c$export$84cd79558c737149);
$parcel$export(module.exports, "getInstallInProgressFlagProps", () => $1f11dbd45093130c$export$e0fa3d2a18e86367);
$parcel$export(module.exports, "INSTALL_SUCCESS_ACTION_CONTENT", () => $1f11dbd45093130c$export$6c588cb5c24e1f0d);
$parcel$export(module.exports, "getInstallSuccessFlagProps", () => $1f11dbd45093130c$export$445af327658688bc);
$parcel$export(module.exports, "getInstallErrorFlagProps", () => $1f11dbd45093130c$export$f6d7483e1ee8fccd);
$parcel$export(module.exports, "getSimultaneousInstallErrorFlagProps", () => $1f11dbd45093130c$export$b685409e9c4361f8);
$parcel$export(module.exports, "getCCPBillingSystemErrorFlag", () => $1f11dbd45093130c$export$54717cf88fca095b);

var $bm7IM = parcelRequire("bm7IM");

var $c9Mth = parcelRequire("c9Mth");

var $jM4Wc = parcelRequire("jM4Wc");

var $hsaiM = parcelRequire("hsaiM");

var $gISS4 = parcelRequire("gISS4");
const $1f11dbd45093130c$export$84cd79558c737149 = {
    inProgress: (appIdentifier)=>"".concat(appIdentifier, "-app-install-in-progress"),
    installSuccess: (appIdentifier)=>"".concat(appIdentifier, "-app-install-success"),
    installError: (appIdentifier)=>"".concat(appIdentifier, "-app-install-error"),
    noSimultaneousInstalls: ()=>'no-simultaneous-installs-allowed'
};
function $1f11dbd45093130c$export$e0fa3d2a18e86367(appIdentifier, appName, onDismiss) {
    return {
        id: $1f11dbd45093130c$export$84cd79558c737149.inProgress(appIdentifier),
        type: (0, $bm7IM.FLAG_TYPE_INFO),
        title: "Adding ".concat(appName, "..."),
        description: "We'll tell you when your app has been added.",
        isAutoDismiss: false,
        actions: [
            {
                content: 'Close',
                onClick: ()=>onDismiss($1f11dbd45093130c$export$84cd79558c737149.inProgress(appIdentifier))
            }
        ]
    };
}
const $1f11dbd45093130c$export$6c588cb5c24e1f0d = Object.freeze({
    getStarted: 'Get started',
    configure: 'Configure',
    manageApp: 'Manage app'
});
function $1f11dbd45093130c$export$445af327658688bc(appIdentifier, appName, installedApp) {
    return {
        id: $1f11dbd45093130c$export$84cd79558c737149.installSuccess(appIdentifier),
        type: (0, $bm7IM.FLAG_TYPE_SUCCESS),
        title: "".concat(appName, " installed successfully"),
        description: 'Your app has been added to your instance and is ready for use.',
        isAutoDismiss: false,
        actions: [
            {
                content: $1f11dbd45093130c$export$6c588cb5c24e1f0d.getStarted,
                href: installedApp.getStartedUrl,
                target: '_blank'
            },
            {
                content: $1f11dbd45093130c$export$6c588cb5c24e1f0d.configure,
                href: installedApp.configureUrl,
                target: '_blank'
            },
            {
                content: $1f11dbd45093130c$export$6c588cb5c24e1f0d.manageApp,
                href: installedApp.manageAppUrl,
                target: '_blank'
            }
        ].filter((action)=>!!action.href)
    };
}
function $1f11dbd45093130c$export$f6d7483e1ee8fccd(_ref) {
    let { appIdentifier: appIdentifier, hostConfig: hostConfig, installError: installError, featureFlags: featureFlags, appName: appName, onDismiss: onDismiss, vendorSupportTicketUrl: vendorSupportTicketUrl } = _ref;
    const { showCustomBackendErrorsFromUpm: showCustomBackendErrorsFromUpm } = featureFlags;
    /**
   * Some of the UPM errors mappings are defined by 'message' ex: 'PaymentFailure'
   * while some of them through 'code' ex: 'connect.install.error.nodefaultgroup'.
   * These error mappings are in the hostConfig file.
   *
   * Some others which are not static are defined as separate functions:
   * ex: getCustomErrorDetails or getPartnerErrorDetails
   *
   * These should be unified through a single flow & the mappings should ideally be through 'code'
   * but should still have access to 'message' to handle complex usecases.
   */ let errorDetails;
    if ((0, $jM4Wc.AppInstallationPartnerErrorCodeOwnership)[installError.code]) errorDetails = $1f11dbd45093130c$var$getPartnerErrorDetails(appName, onDismiss, vendorSupportTicketUrl);
    else errorDetails = $1f11dbd45093130c$export$3dc00266b5fd0cd7({
        errorCode: installError.code,
        errorMessage: installError.message,
        appName: appName,
        onDismiss: onDismiss
    });
    if (!errorDetails) {
        var _hostConfig$errors$ge, _errorDetails$transla;
        errorDetails = (0, $hsaiM.getErrorDetails)(installError.message, hostConfig, {
            showCustomBackendErrorsFromUpm: showCustomBackendErrorsFromUpm
        });
        if (errorDetails.translation.description === ((_hostConfig$errors$ge = hostConfig.errors.get('default')) === null || _hostConfig$errors$ge === void 0 ? void 0 : _hostConfig$errors$ge.description)) errorDetails = (0, $hsaiM.getErrorDetails)(installError.code, hostConfig, {
            showCustomBackendErrorsFromUpm: showCustomBackendErrorsFromUpm
        });
        if (((_errorDetails$transla = errorDetails.translation.actions) === null || _errorDetails$transla === void 0 ? void 0 : _errorDetails$transla.length) > 0) errorDetails.actions = errorDetails.translation.actions;
        else if (onDismiss) errorDetails.actions = [
            {
                content: 'Got it',
                onClick: onDismiss
            }
        ];
    }
    return {
        id: $1f11dbd45093130c$export$84cd79558c737149.installError(appIdentifier),
        type: (0, $bm7IM.FLAG_TYPE_ERROR),
        title: errorDetails.title || errorDetails.translation.title,
        description: errorDetails.description || errorDetails.translation.description,
        isAutoDismiss: false,
        actions: errorDetails.actions
    };
}
function $1f11dbd45093130c$var$getConflictingAppNameFromErrorMessage() {
    let errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    // Expected errorMessage format - appKey for the app we're trying to install,appKey of the Conflicting app:Conflicting App Name:macro key
    if (typeof errorMessage !== 'string') return null;
    const splitOnComma = errorMessage.split(',');
    if (splitOnComma.length < 2) return null;
    const splitOnColon = splitOnComma[1].split(':');
    if (splitOnColon.length < 2) return null;
    return splitOnColon[1].trim();
}
const $1f11dbd45093130c$export$3dc00266b5fd0cd7 = (_ref2)=>{
    let { errorCode: errorCode, errorMessage: errorMessage, appName: appName, onDismiss: onDismiss } = _ref2;
    switch(errorCode){
        case (0, $gISS4.ERROR_CODE).FETCH_ADDON_INTERNAL_ERROR:
            return {
                title: "Fetching details for ".concat(appName),
                description: "Your app installation is in progress. It may take some time to initiate the subscription. We\u2019ll update you once it\u2019s done.",
                actions: [
                    {
                        content: 'Got it',
                        onClick: onDismiss
                    }
                ]
            };
        case (0, $gISS4.ERROR_CODE).TICKET:
            {
                const ticketNumber = (0, $c9Mth).getSupportTicketNumber(errorMessage);
                return {
                    title: 'Sorry, installation failed',
                    description: "We are unable to process your app request. A support ticket ".concat(ticketNumber, " has been created for you. We are working on it to resolve the issue at the earliest")
                };
            }
        case (0, $gISS4.ERROR_CODE).APP_REACTIVATION_NOT_SUPPORTED:
            return {
                title: "Unable to install ".concat(appName),
                description: "Unfortunately, we\u2019re unable to process your request. Please contact support to install the app.",
                actions: [
                    {
                        content: 'Contact support',
                        href: 'https://www.atlassian.com/company/contact/purchasing-licensing#/',
                        target: '_blank'
                    }
                ]
            };
        case (0, $gISS4.ERROR_CODE).UPM_PLUGIN_ERROR_TIMEOUT_LICENSE_CHANGE:
        case (0, $gISS4.ERROR_CODE).ECOSYSTEM_ACCOUNT_PENDING_RENEWAL:
        case (0, $gISS4.ERROR_CODE).CONNECT_PAYMENT_FAILURE_EXCEPTION:
            return {
                title: "Unable to install ".concat(appName),
                description: 'Please reconfirm your payment details and license status, and try again to install the app.',
                actions: [
                    {
                        content: 'Got it',
                        onClick: onDismiss
                    }
                ]
            };
        case (0, $gISS4.ERROR_CODE).CONNECT_INSTALL_ERROR_CONFLICTING_MACRO_ALIAS:
            return {
                title: "Unable to install ".concat(appName),
                description: "Unfortunately, we\u2019re unable to process your request due to a technical error.",
                actions: [
                    {
                        content: 'Got it',
                        onClick: onDismiss
                    }
                ]
            };
        case (0, $gISS4.ERROR_CODE).CONNECT_INSTALL_ERROR_DEPENDENCIES_FAILED:
            return {
                title: "Unable to install ".concat(appName),
                description: "Unfortunately, we\u2019re not able to process your request due to an unexpected error. Please retry again in some time.",
                actions: [
                    {
                        content: 'Got it',
                        onClick: onDismiss
                    }
                ]
            };
        case (0, $gISS4.ERROR_CODE).ECOSYSTEM_APP_DEACTIVATED:
        case (0, $gISS4.ERROR_CODE).UPM_INSTALL_POST_ERROR:
            return {
                title: "Unable to install ".concat(appName),
                description: "Unfortunately, we\u2019re not able to process your request due to an unexpected error. Please retry again in some time.",
                actions: [
                    {
                        content: 'Got it',
                        onClick: onDismiss
                    }
                ]
            };
        case (0, $gISS4.ERROR_CODE).ECOSYSTEM_APP_INSTALL_INPROGRESS:
        case (0, $gISS4.ERROR_CODE).CONNECT_INSTALL_ERROR_LOCKED:
            return {
                title: "Unable to install ".concat(appName),
                description: 'An installation is already in progress, and we cannot initiate a new one. Please try again in some time.',
                actions: [
                    {
                        content: 'Got it',
                        onClick: onDismiss
                    }
                ]
            };
        case (0, $gISS4.ERROR_CODE).CONNECT_DUPLICATE_MACRO_KEYS_EXCEPTION:
            return {
                title: "Unable to install ".concat(appName),
                description: "Your instance has ".concat($1f11dbd45093130c$var$getConflictingAppNameFromErrorMessage(errorMessage) || 'an app', " from the same partner that does not allow installation of ").concat(appName, " due to technical constraints."),
                actions: [
                    {
                        content: 'Learn more about the issue',
                        href: 'https://support.atlassian.com/confluence-cloud/docs/what-are-macros/#Conflicts-between-two-macros',
                        target: '_blank'
                    }
                ]
            };
    }
};
const $1f11dbd45093130c$var$getPartnerErrorDetails = (appName, onDismiss, vendorSupportTicketUrl)=>{
    if (vendorSupportTicketUrl) return {
        title: "Unable to install ".concat(appName),
        description: "Unfortunately, we\u2019re facing a technical issue with the partner. You can contact the partner to know more about the issue.",
        actions: [
            {
                content: 'Contact partner',
                href: vendorSupportTicketUrl,
                target: '_blank'
            }
        ]
    };
    else return {
        title: "Unable to install ".concat(appName),
        description: "Unfortunately, we\u2019re facing a technical issue with the partner. Please try again in some time.",
        actions: [
            {
                content: 'Got it',
                onClick: onDismiss
            }
        ]
    };
};
function $1f11dbd45093130c$export$b685409e9c4361f8() {
    return {
        id: $1f11dbd45093130c$export$84cd79558c737149.noSimultaneousInstalls(),
        type: (0, $bm7IM.FLAG_TYPE_INFO),
        title: 'Hold on!',
        description: 'Another installation is still in progress. Try again when it is complete.',
        isAutoDismiss: true
    };
}
function $1f11dbd45093130c$export$54717cf88fca095b(appIdentifier) {
    return {
        id: $1f11dbd45093130c$export$84cd79558c737149.installError(appIdentifier),
        type: (0, $bm7IM.FLAG_TYPE_ERROR),
        title: 'App installation failed',
        description: 'We are unable to process your request for app installation. Please contact the support team to understand the issue.',
        isAutoDismiss: false,
        actions: [
            {
                content: 'Contact support',
                href: 'https://www.atlassian.com/company/contact/purchasing-licensing',
                target: '_blank'
            }
        ]
    };
}

});
parcelRegister("gISS4", function(module, exports) {

$parcel$export(module.exports, "ERROR_CODE", () => $c2cb51a5accfc27a$export$fe20a4d016ee5cf3);
const $c2cb51a5accfc27a$export$fe20a4d016ee5cf3 = {
    TICKET: 'TICKET',
    APP_REACTIVATION_NOT_SUPPORTED: 'APP_REACTIVATION_NOT_SUPPORTED',
    FETCH_ADDON_INTERNAL_ERROR: 'FetchAddonInternalError',
    UPM_PLUGIN_ERROR_TIMEOUT_LICENSE_CHANGE: 'upm.plugin.error.timeout.license.change',
    CONNECT_INSTALL_ERROR_CONFLICTING_MACRO_ALIAS: 'connect.install.error.conflicting.macro.alias',
    CONNECT_INSTALL_ERROR_DEPENDENCIES_FAILED: 'connect.install.error.dependencies.failed',
    UPM_INSTALL_POST_ERROR: 'UPMInstallPostError',
    ECOSYSTEM_APP_DEACTIVATED: 'EcosystemCloudInstallPollFailure-app.deactivated',
    ECOSYSTEM_APP_INSTALL_INPROGRESS: 'EcosystemCloudInstallPollFailure-app.install.inprogress',
    ECOSYSTEM_APP_MISCONFIGURED: 'EcosystemCloudInstallPollFailure-app.misconfigured',
    ECOSYSTEM_ACCOUNT_PENDING_RENEWAL: 'EcosystemCloudInstallPollFailure-account.pending.renewal',
    CONNECT_INSTALL_ERROR_LOCKED: 'connect.install.error.locked',
    CONNECT_PAYMENT_FAILURE_EXCEPTION: 'connect.remote.upm.install.payment.failure.exception',
    CONNECT_DUPLICATE_MACRO_KEYS_EXCEPTION: 'connect.install.error.duplicate.macro.keys'
};

});


parcelRegister("1nC6Q", function(module, exports) {

$parcel$export(module.exports, "MARKETPLACE_APP_KEY", () => $10158028182bca28$export$bf8edad33d1c3842);
$parcel$export(module.exports, "INSTALLABLE_APP_IDENTIFIER", () => $10158028182bca28$export$65075d6de7e54bf9);
$parcel$export(module.exports, "makeMarketplaceAppKeyIdentifier", () => $10158028182bca28$export$d4e80722d8a07d64);
$parcel$export(module.exports, "makeInstallableAppKeyIdentifier", () => $10158028182bca28$export$91c937ccaec5627);
$parcel$export(module.exports, "AppInstallLocation", () => $10158028182bca28$export$b323075bcb76de30);

var $gIQkA = parcelRequire("gIQkA");
const $10158028182bca28$export$bf8edad33d1c3842 = 'MARKETPLACE_APP_KEY';
const $10158028182bca28$export$65075d6de7e54bf9 = 'INSTALLABLE_APP_IDENTIFIER';
const $10158028182bca28$export$d4e80722d8a07d64 = (appKey)=>({
        type: $10158028182bca28$export$bf8edad33d1c3842,
        keyForInstall: appKey
    });
const $10158028182bca28$export$91c937ccaec5627 = (installableId)=>({
        type: $10158028182bca28$export$65075d6de7e54bf9,
        keyForInstall: installableId
    });
const $10158028182bca28$export$b323075bcb76de30 = Object.freeze({
    EmbeddedMarketplaceAppListing: (0, $gIQkA.ANALYTICS_SCREEN_APP_LISTING).name,
    EmbeddedMarketplaceManageAppRequests: (0, $gIQkA.ANALYTICS_SCREEN_MANAGE_APP_REQUESTS).name
});

});

parcelRegister("8pHa5", function(module, exports) {

$parcel$export(module.exports, "getAppKeyFromInstallableAppIdentifier", () => $620223875cc040a2$export$328ad57b4962acc0);
$parcel$export(module.exports, "getAppKeyFromInstallIdentifier", () => $620223875cc040a2$export$3ab9bb8addbb8706);

var $ifMZN = parcelRequire("ifMZN");

var $1nC6Q = parcelRequire("1nC6Q");
const $620223875cc040a2$export$328ad57b4962acc0 = (installableAppIdentifier)=>(0, $ifMZN.foldInstallableAppIdentifier)(installableAppIdentifier)((key)=>key.key, (url)=>url.key, (ari)=>ari.appKey);
const $620223875cc040a2$export$3ab9bb8addbb8706 = (installIdentifier)=>{
    if (installIdentifier === null) return;
    if (installIdentifier.type === (0, $1nC6Q.MARKETPLACE_APP_KEY)) return installIdentifier.keyForInstall;
    return $620223875cc040a2$export$328ad57b4962acc0(installIdentifier.keyForInstall);
};

});

parcelRegister("atCSv", function(module, exports) {

$parcel$export(module.exports, "useAppInstallAnalytics", () => $7a0ac538078d83eb$export$8f4dddb2fd24bb4a);

var $5zQU9 = parcelRequire("5zQU9");

var $9osuT = parcelRequire("9osuT");

var $inwKI = parcelRequire("inwKI");

var $7IZKi = parcelRequire("7IZKi");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $gIQkA = parcelRequire("gIQkA");

var $i7hUf = parcelRequire("i7hUf");

var $k5vUT = parcelRequire("k5vUT");

var $8AJas = parcelRequire("8AJas");
function $7a0ac538078d83eb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7a0ac538078d83eb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7a0ac538078d83eb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7a0ac538078d83eb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $7a0ac538078d83eb$export$b9fc5729d4f12057 = (installMode)=>{
    const noop = ()=>null;
    return (0, $i7hUf.foldInstallMode)(installMode)(/* determining */ noop, /* appSpecificPassword */ noop, (instructionalMode)=>instructionalMode.getIn([
            'instructionalApp',
            'details'
        ]), (installableMode)=>installableMode.getIn([
            'installableApp',
            'marketplaceAppDetails'
        ]), /* manualUrl */ noop, /* upgrade */ noop);
};
const $7a0ac538078d83eb$var$makeAnalyticsContextAttributes = (_ref)=>{
    let { baseData: baseData, installLocation: installLocation } = _ref;
    const attributes = {
        installLocation: installLocation,
        category: (0, $7Uh51.ANALYTICS_CATEGORY_MARKETPLACE_APP_INSTALL)
    };
    if (!baseData.result) return attributes;
    const appDetails = $7a0ac538078d83eb$export$b9fc5729d4f12057(baseData.result.installMode);
    if (!appDetails) return attributes;
    const { key: appKey, paymentModel: paymentModel, ecosystemCloudAppId: ecosystemCloudAppId, programs: programs } = appDetails;
    return $7a0ac538078d83eb$var$_objectSpread($7a0ac538078d83eb$var$_objectSpread($7a0ac538078d83eb$var$_objectSpread({}, attributes), {}, {
        appKey: appKey,
        paymentModel: paymentModel,
        programs: programs,
        isEcosystemCloudApp: !!ecosystemCloudAppId
    }, ecosystemCloudAppId && {
        ecosystemCloudAppId: ecosystemCloudAppId
    }), {}, {
        installPoweredByStoreBFF: (0, $8AJas.shouldInstallWithStoreBff)(baseData)
    });
};
const $7a0ac538078d83eb$var$makeAnalyticsContextProperties = (_ref2)=>{
    let { currentScreen: currentScreen } = _ref2;
    return $7a0ac538078d83eb$var$_objectSpread({}, currentScreen && {
        source: currentScreen.name
    });
};
const $7a0ac538078d83eb$export$8f4dddb2fd24bb4a = (_ref3)=>{
    let { baseData: baseData, installLocation: installLocation } = _ref3;
    const fireEvent = (0, $9osuT.useAnalyticsEvents)();
    const featureFlags = (0, $inwKI.useFeatureFlags)();
    const [currentScreen, setCurrentScreen] = (0, $eUqFw.useState)(null);
    const analyticsContext = (0, $eUqFw.useMemo)(()=>({
            properties: $7a0ac538078d83eb$var$makeAnalyticsContextProperties({
                currentScreen: currentScreen
            }),
            attributes: $7a0ac538078d83eb$var$makeAnalyticsContextAttributes({
                baseData: baseData,
                installLocation: installLocation,
                featureFlags: featureFlags
            })
        }), [
        baseData.pending,
        currentScreen,
        installLocation
    ]);
    const fireScreenEvent = function fireScreenEvent(eventType) {
        let payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return fireEvent((0, (/*@__PURE__*/$parcel$interopDefault($7IZKi)))([
            {
                eventType: eventType
            },
            {
                attributes: analyticsContext.attributes
            },
            payload
        ]));
    };
    const fireTrackEvent = function fireTrackEvent(eventType) {
        let payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return fireEvent((0, (/*@__PURE__*/$parcel$interopDefault($7IZKi)))([
            {
                eventType: eventType
            },
            {
                source: currentScreen,
                attributes: analyticsContext.attributes
            },
            payload
        ]));
    };
    return {
        fireEvent: {
            viewedScreen: {
                determining: ()=>{
                    fireScreenEvent((0, $gIQkA.ANALYTICS_MODAL_STANDALONE_INSTALL_DETERMINING));
                    setCurrentScreen((0, $gIQkA.ANALYTICS_MODAL_STANDALONE_INSTALL_DETERMINING));
                },
                awaitingUserConfirmation: ()=>{
                    if (baseData.result && baseData.result.installMode.type === (0, $k5vUT.INSTRUCTIONAL_INSTALL_MODE)) {
                        fireScreenEvent((0, $gIQkA.ANALYTICS_MODAL_STANDALONE_INSTRUCTIONAL_APP_INSTALL));
                        setCurrentScreen((0, $gIQkA.ANALYTICS_MODAL_STANDALONE_INSTRUCTIONAL_APP_INSTALL));
                    } else {
                        fireScreenEvent((0, $gIQkA.ANALYTICS_MODAL_STANDALONE_INSTALL));
                        setCurrentScreen((0, $gIQkA.ANALYTICS_MODAL_STANDALONE_INSTALL));
                    }
                }
            },
            installSucceeded: (appKey)=>{
                fireTrackEvent((0, $7Uh51.AppInstalledEvent), {
                    actionSubjectId: appKey
                });
                setCurrentScreen(null);
            },
            installFailed: (appKey, error)=>{
                fireTrackEvent((0, $7Uh51.AppInstallFailedEvent), {
                    actionSubjectId: appKey,
                    attributes: {
                        errorCode: error.code,
                        error: error.message,
                        source: error.source
                    }
                });
                setCurrentScreen(null);
            }
        },
        analyticsContext: analyticsContext
    };
};

});
parcelRegister("8AJas", function(module, exports) {

$parcel$export(module.exports, "getInstallableApp", () => $6414b8e60e40d158$export$82293f81cf93861c);
$parcel$export(module.exports, "shouldInstallWithStoreBff", () => $6414b8e60e40d158$export$373abea2041a5c7a);

var $buxnS = parcelRequire("buxnS");
var $ly50n = parcelRequire("ly50n");

var $9D4R7 = parcelRequire("9D4R7");

var $kafab = parcelRequire("kafab");
var $cVLrH = parcelRequire("cVLrH");
var $i0EDR = parcelRequire("i0EDR");

var $ifMZN = parcelRequire("ifMZN");
var $6414b8e60e40d158$var$MarketplaceAppInstallGetAppByKey = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "MarketplaceAppInstallGetAppByKey"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "appKey"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    },
                    directives: []
                }
            ],
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "marketplaceAppByKey"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "appKey"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "appKey"
                                    }
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "InstallableAppDetails"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "InstallableAppDetails"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceApp"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "appKey"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "versions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "filter"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "productHostingOptions"
                                            },
                                            value: {
                                                kind: "ListValue",
                                                values: [
                                                    {
                                                        kind: "EnumValue",
                                                        value: "CLOUD"
                                                    }
                                                ]
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "visibility"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "PUBLIC"
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "excludeHiddenIn"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "IN_PRODUCT"
                                            }
                                        }
                                    ]
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "IntValue",
                                    value: "1"
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "LatestAppVersion"
                                                            },
                                                            directives: []
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "LatestAppVersion"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceAppVersion"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "deployment"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "__typename"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                        kind: "NamedType",
                                        name: {
                                            kind: "Name",
                                            value: "MarketplaceCloudAppDeployment"
                                        }
                                    },
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "cloudAppId"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ],
    loc: {
        start: 0,
        end: 753,
        source: {
            body: "# If you are making any change here\n# Do thoroughly read our graphql contribution guidelines\n# https://bitbucket.org/atlassian-marketplace/marketplace-frontend/src/master/docs/working-with-graphql.md\n\nfragment LatestAppVersion on MarketplaceAppVersion {\n  deployment {\n    __typename\n    ... on MarketplaceCloudAppDeployment {\n      cloudAppId\n    }\n  }\n}\n\nfragment InstallableAppDetails on MarketplaceApp {\n  appKey\n  versions(\n    filter: { productHostingOptions: [CLOUD], visibility: PUBLIC, excludeHiddenIn: IN_PRODUCT }\n    first: 1\n  ) {\n    edges {\n      node {\n        ...LatestAppVersion\n      }\n    }\n  }\n}\n\nquery MarketplaceAppInstallGetAppByKey($appKey: String!) {\n  marketplaceAppByKey(appKey: $appKey) {\n    ...InstallableAppDetails\n  }\n}\n",
            name: "GraphQL request",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    }
};
const $6414b8e60e40d158$export$f705667fe848e5ae = async (gatewayUrl, appKey)=>{
    const { errors: errors, data: data } = await (0, $9D4R7.graphQLRequest)(gatewayUrl, {
        query: $6414b8e60e40d158$var$MarketplaceAppInstallGetAppByKey,
        variables: {
            appKey: appKey
        }
    });
    if (errors !== null && errors !== void 0 && errors.length) throw errors;
    if (!(data !== null && data !== void 0 && data.marketplaceAppByKey)) throw new Error("Unable to fetch app with key \"".concat(appKey, "\"'"));
    return data.marketplaceAppByKey;
};
const $6414b8e60e40d158$var$getLatestAppVersion = (appDetails)=>{
    var _appDetails$versions$, _appDetails$versions$2;
    return appDetails === null || appDetails === void 0 ? void 0 : (_appDetails$versions$ = appDetails.versions.edges) === null || _appDetails$versions$ === void 0 ? void 0 : (_appDetails$versions$2 = _appDetails$versions$[0]) === null || _appDetails$versions$2 === void 0 ? void 0 : _appDetails$versions$2.node;
};
const $6414b8e60e40d158$var$getInstallableAppIdentifier = (latestVersion, appKey)=>{
    const { deployment: appDeployment } = latestVersion;
    const deploymentType = appDeployment.__typename;
    if (deploymentType === (0, $kafab.AppDeployment).ECOSYSTEM_CLOUD && typeof appDeployment.cloudAppId === 'string') return (0, $ifMZN.makeInstallableAppByAriIdentifier)({
        ari: (0, $ly50n.makeAppKey)(appDeployment.cloudAppId || ''),
        appKey: (0, $ly50n.makeAppKey)(appKey)
    });
    else if (deploymentType === (0, $kafab.AppDeployment).CONNECT || deploymentType === (0, $kafab.AppDeployment).INSTRUCTIONAL) return (0, $ifMZN.makeInstallableAppByKeyIdentifier)({
        key: (0, $ly50n.makeAppKey)(appKey)
    });
    else throw new Error("Installation of app with deployment type ".concat(deploymentType || 'UNKNOWN_DEPLOYMENT_TYPE', " not supported"));
};
const $6414b8e60e40d158$export$82293f81cf93861c = async (gatewayUrl, appKey)=>{
    try {
        const marketplaceApp = await $6414b8e60e40d158$export$f705667fe848e5ae(gatewayUrl, appKey);
        const latestVersion = $6414b8e60e40d158$var$getLatestAppVersion(marketplaceApp);
        if (latestVersion) return $6414b8e60e40d158$var$getInstallableAppIdentifier(latestVersion, appKey);
        else throw new Error('Unable to build appIdentifier, latestVersion of marketplace app not found');
    } catch (error) {
        throw new Error('AppInstallDialog Failed in getInstallableApp ' + error);
    }
};
const $6414b8e60e40d158$export$373abea2041a5c7a = (baseData)=>{
    // Some apps like instructional apps are not installable via marketplace
    if (!baseData.result.installMode.installableApp) return false;
    const isCompassApp = baseData.result.hostData.hostInfo.product === (0, $i0EDR.CompatibleProductId).COMPASS;
    return (!(0, $buxnS.isFreeApp)(baseData.result.installMode.installableApp.marketplaceAppDetails.paymentModel) || isCompassApp) && baseData.result.hostData.hostLicense.billingSystem === (0, $cVLrH.BillingSystem).CCP;
};

});
parcelRegister("9D4R7", function(module, exports) {

$parcel$export(module.exports, "graphQLRequest", () => $702b85d6a08ca5eb$export$9f788458b7bdb55f);

var $2dcSO = parcelRequire("2dcSO");

var $dO8LH = parcelRequire("dO8LH");
const $702b85d6a08ca5eb$export$9f788458b7bdb55f = async (url, request)=>{
    const { query: document, variables: variables = null, operationName: operationName } = request;
    const fetchResponse = await (0, $dO8LH.fetchOk)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        },
        body: JSON.stringify({
            operationName: operationName,
            query: (0, $2dcSO.print)(document),
            variables: variables
        })
    });
    const response = await fetchResponse.json();
    return response;
};

});
parcelRegister("2dcSO", function(module, exports) {

$parcel$export(module.exports, "print", () => $cced06396f774aa1$export$c2d084dc44961371);

var $30Dau = parcelRequire("30Dau");

var $79FAh = parcelRequire("79FAh");

var $kQCsj = parcelRequire("kQCsj");
function $cced06396f774aa1$export$c2d084dc44961371(ast) {
    return (0, $kQCsj.visit)(ast, $cced06396f774aa1$var$printDocASTReducer);
}
const $cced06396f774aa1$var$MAX_LINE_LENGTH = 80;
const $cced06396f774aa1$var$printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>'$' + node.name
    },
    // Document
    Document: {
        leave: (node)=>$cced06396f774aa1$var$join(node.definitions, '\n\n')
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = $cced06396f774aa1$var$wrap('(', $cced06396f774aa1$var$join(node.variableDefinitions, ', '), ')');
            const prefix = $cced06396f774aa1$var$join([
                node.operation,
                $cced06396f774aa1$var$join([
                    node.name,
                    varDefs
                ]),
                $cced06396f774aa1$var$join(node.directives, ' ')
            ], ' '); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable: variable, type: type, defaultValue: defaultValue, directives: directives })=>variable + ': ' + type + $cced06396f774aa1$var$wrap(' = ', defaultValue) + $cced06396f774aa1$var$wrap(' ', $cced06396f774aa1$var$join(directives, ' '))
    },
    SelectionSet: {
        leave: ({ selections: selections })=>$cced06396f774aa1$var$block(selections)
    },
    Field: {
        leave ({ alias: alias, name: name, arguments: args, directives: directives, selectionSet: selectionSet }) {
            const prefix = $cced06396f774aa1$var$wrap('', alias, ': ') + name;
            let argsLine = prefix + $cced06396f774aa1$var$wrap('(', $cced06396f774aa1$var$join(args, ', '), ')');
            if (argsLine.length > $cced06396f774aa1$var$MAX_LINE_LENGTH) argsLine = prefix + $cced06396f774aa1$var$wrap('(\n', $cced06396f774aa1$var$indent($cced06396f774aa1$var$join(args, '\n')), '\n)');
            return $cced06396f774aa1$var$join([
                argsLine,
                $cced06396f774aa1$var$join(directives, ' '),
                selectionSet
            ], ' ');
        }
    },
    Argument: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name: name, directives: directives })=>'...' + name + $cced06396f774aa1$var$wrap(' ', $cced06396f774aa1$var$join(directives, ' '))
    },
    InlineFragment: {
        leave: ({ typeCondition: typeCondition, directives: directives, selectionSet: selectionSet })=>$cced06396f774aa1$var$join([
                '...',
                $cced06396f774aa1$var$wrap('on ', typeCondition),
                $cced06396f774aa1$var$join(directives, ' '),
                selectionSet
            ], ' ')
    },
    FragmentDefinition: {
        leave: ({ name: name, typeCondition: typeCondition, variableDefinitions: variableDefinitions, directives: directives, selectionSet: selectionSet })=>// or removed in the future.
            `fragment ${name}${$cced06396f774aa1$var$wrap('(', $cced06396f774aa1$var$join(variableDefinitions, ', '), ')')} ` + `on ${typeCondition} ${$cced06396f774aa1$var$wrap('', $cced06396f774aa1$var$join(directives, ' '), ' ')}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value: value })=>value
    },
    FloatValue: {
        leave: ({ value: value })=>value
    },
    StringValue: {
        leave: ({ value: value, block: isBlockString })=>isBlockString ? (0, $30Dau.printBlockString)(value) : (0, $79FAh.printString)(value)
    },
    BooleanValue: {
        leave: ({ value: value })=>value ? 'true' : 'false'
    },
    NullValue: {
        leave: ()=>'null'
    },
    EnumValue: {
        leave: ({ value: value })=>value
    },
    ListValue: {
        leave: ({ values: values })=>'[' + $cced06396f774aa1$var$join(values, ', ') + ']'
    },
    ObjectValue: {
        leave: ({ fields: fields })=>'{' + $cced06396f774aa1$var$join(fields, ', ') + '}'
    },
    ObjectField: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Directive
    Directive: {
        leave: ({ name: name, arguments: args })=>'@' + name + $cced06396f774aa1$var$wrap('(', $cced06396f774aa1$var$join(args, ', '), ')')
    },
    // Type
    NamedType: {
        leave: ({ name: name })=>name
    },
    ListType: {
        leave: ({ type: type })=>'[' + type + ']'
    },
    NonNullType: {
        leave: ({ type: type })=>type + '!'
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description: description, directives: directives, operationTypes: operationTypes })=>$cced06396f774aa1$var$wrap('', description, '\n') + $cced06396f774aa1$var$join([
                'schema',
                $cced06396f774aa1$var$join(directives, ' '),
                $cced06396f774aa1$var$block(operationTypes)
            ], ' ')
    },
    OperationTypeDefinition: {
        leave: ({ operation: operation, type: type })=>operation + ': ' + type
    },
    ScalarTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$cced06396f774aa1$var$wrap('', description, '\n') + $cced06396f774aa1$var$join([
                'scalar',
                name,
                $cced06396f774aa1$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$cced06396f774aa1$var$wrap('', description, '\n') + $cced06396f774aa1$var$join([
                'type',
                name,
                $cced06396f774aa1$var$wrap('implements ', $cced06396f774aa1$var$join(interfaces, ' & ')),
                $cced06396f774aa1$var$join(directives, ' '),
                $cced06396f774aa1$var$block(fields)
            ], ' ')
    },
    FieldDefinition: {
        leave: ({ description: description, name: name, arguments: args, type: type, directives: directives })=>$cced06396f774aa1$var$wrap('', description, '\n') + name + ($cced06396f774aa1$var$hasMultilineItems(args) ? $cced06396f774aa1$var$wrap('(\n', $cced06396f774aa1$var$indent($cced06396f774aa1$var$join(args, '\n')), '\n)') : $cced06396f774aa1$var$wrap('(', $cced06396f774aa1$var$join(args, ', '), ')')) + ': ' + type + $cced06396f774aa1$var$wrap(' ', $cced06396f774aa1$var$join(directives, ' '))
    },
    InputValueDefinition: {
        leave: ({ description: description, name: name, type: type, defaultValue: defaultValue, directives: directives })=>$cced06396f774aa1$var$wrap('', description, '\n') + $cced06396f774aa1$var$join([
                name + ': ' + type,
                $cced06396f774aa1$var$wrap('= ', defaultValue),
                $cced06396f774aa1$var$join(directives, ' ')
            ], ' ')
    },
    InterfaceTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$cced06396f774aa1$var$wrap('', description, '\n') + $cced06396f774aa1$var$join([
                'interface',
                name,
                $cced06396f774aa1$var$wrap('implements ', $cced06396f774aa1$var$join(interfaces, ' & ')),
                $cced06396f774aa1$var$join(directives, ' '),
                $cced06396f774aa1$var$block(fields)
            ], ' ')
    },
    UnionTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, types: types })=>$cced06396f774aa1$var$wrap('', description, '\n') + $cced06396f774aa1$var$join([
                'union',
                name,
                $cced06396f774aa1$var$join(directives, ' '),
                $cced06396f774aa1$var$wrap('= ', $cced06396f774aa1$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, values: values })=>$cced06396f774aa1$var$wrap('', description, '\n') + $cced06396f774aa1$var$join([
                'enum',
                name,
                $cced06396f774aa1$var$join(directives, ' '),
                $cced06396f774aa1$var$block(values)
            ], ' ')
    },
    EnumValueDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$cced06396f774aa1$var$wrap('', description, '\n') + $cced06396f774aa1$var$join([
                name,
                $cced06396f774aa1$var$join(directives, ' ')
            ], ' ')
    },
    InputObjectTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, fields: fields })=>$cced06396f774aa1$var$wrap('', description, '\n') + $cced06396f774aa1$var$join([
                'input',
                name,
                $cced06396f774aa1$var$join(directives, ' '),
                $cced06396f774aa1$var$block(fields)
            ], ' ')
    },
    DirectiveDefinition: {
        leave: ({ description: description, name: name, arguments: args, repeatable: repeatable, locations: locations })=>$cced06396f774aa1$var$wrap('', description, '\n') + 'directive @' + name + ($cced06396f774aa1$var$hasMultilineItems(args) ? $cced06396f774aa1$var$wrap('(\n', $cced06396f774aa1$var$indent($cced06396f774aa1$var$join(args, '\n')), '\n)') : $cced06396f774aa1$var$wrap('(', $cced06396f774aa1$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $cced06396f774aa1$var$join(locations, ' | ')
    },
    SchemaExtension: {
        leave: ({ directives: directives, operationTypes: operationTypes })=>$cced06396f774aa1$var$join([
                'extend schema',
                $cced06396f774aa1$var$join(directives, ' '),
                $cced06396f774aa1$var$block(operationTypes)
            ], ' ')
    },
    ScalarTypeExtension: {
        leave: ({ name: name, directives: directives })=>$cced06396f774aa1$var$join([
                'extend scalar',
                name,
                $cced06396f774aa1$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$cced06396f774aa1$var$join([
                'extend type',
                name,
                $cced06396f774aa1$var$wrap('implements ', $cced06396f774aa1$var$join(interfaces, ' & ')),
                $cced06396f774aa1$var$join(directives, ' '),
                $cced06396f774aa1$var$block(fields)
            ], ' ')
    },
    InterfaceTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$cced06396f774aa1$var$join([
                'extend interface',
                name,
                $cced06396f774aa1$var$wrap('implements ', $cced06396f774aa1$var$join(interfaces, ' & ')),
                $cced06396f774aa1$var$join(directives, ' '),
                $cced06396f774aa1$var$block(fields)
            ], ' ')
    },
    UnionTypeExtension: {
        leave: ({ name: name, directives: directives, types: types })=>$cced06396f774aa1$var$join([
                'extend union',
                name,
                $cced06396f774aa1$var$join(directives, ' '),
                $cced06396f774aa1$var$wrap('= ', $cced06396f774aa1$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeExtension: {
        leave: ({ name: name, directives: directives, values: values })=>$cced06396f774aa1$var$join([
                'extend enum',
                name,
                $cced06396f774aa1$var$join(directives, ' '),
                $cced06396f774aa1$var$block(values)
            ], ' ')
    },
    InputObjectTypeExtension: {
        leave: ({ name: name, directives: directives, fields: fields })=>$cced06396f774aa1$var$join([
                'extend input',
                name,
                $cced06396f774aa1$var$join(directives, ' '),
                $cced06396f774aa1$var$block(fields)
            ], ' ')
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $cced06396f774aa1$var$join(maybeArray, separator = '') {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function $cced06396f774aa1$var$block(array) {
    return $cced06396f774aa1$var$wrap('{\n', $cced06396f774aa1$var$indent($cced06396f774aa1$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $cced06396f774aa1$var$wrap(start, maybeString, end = '') {
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $cced06396f774aa1$var$indent(str) {
    return $cced06396f774aa1$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $cced06396f774aa1$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes('\n'))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}

});
parcelRegister("30Dau", function(module, exports) {

$parcel$export(module.exports, "printBlockString", () => $d7cee39935718db8$export$adb6ca997eeb1f45);

var $biARw = parcelRequire("biARw");
function $d7cee39935718db8$export$d5ee19b441e8d2ae(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $d7cee39935718db8$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $d7cee39935718db8$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $biARw.isWhiteSpace)(str.charCodeAt(i)))++i;
    return i;
}
function $d7cee39935718db8$export$40862a63ef85e395(value) {
    if (value === '') return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function $d7cee39935718db8$export$adb6ca997eeb1f45(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $biARw.isWhiteSpace)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith('\\');
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ''; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $biARw.isWhiteSpace)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += '\n';
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += '\n';
    return '"""' + result + '"""';
}

});
parcelRegister("biARw", function(module, exports) {

$parcel$export(module.exports, "isWhiteSpace", () => $057505f4cb27f3a7$export$3c52dd84024ae72c);
/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $057505f4cb27f3a7$export$3c52dd84024ae72c(code) {
    return code === 0x0009 || code === 0x0020;
}
function $057505f4cb27f3a7$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $057505f4cb27f3a7$export$79c5d5217943d6a7(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function $057505f4cb27f3a7$export$45a677ea7cb6d5c8(code) {
    return $057505f4cb27f3a7$export$79c5d5217943d6a7(code) || code === 0x005f;
}
function $057505f4cb27f3a7$export$d3f406ff46035894(code) {
    return $057505f4cb27f3a7$export$79c5d5217943d6a7(code) || $057505f4cb27f3a7$export$727d9dbc4fbb948f(code) || code === 0x005f;
}

});


parcelRegister("79FAh", function(module, exports) {

$parcel$export(module.exports, "printString", () => $1206b9d640b5a6c1$export$3cdec7cf614a0ecc);
/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ function $1206b9d640b5a6c1$export$3cdec7cf614a0ecc(str) {
    return `"${str.replace($1206b9d640b5a6c1$var$escapedRegExp, $1206b9d640b5a6c1$var$escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex
const $1206b9d640b5a6c1$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $1206b9d640b5a6c1$var$escapedReplacer(str) {
    return $1206b9d640b5a6c1$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const $1206b9d640b5a6c1$var$escapeSequences = [
    '\\u0000',
    '\\u0001',
    '\\u0002',
    '\\u0003',
    '\\u0004',
    '\\u0005',
    '\\u0006',
    '\\u0007',
    '\\b',
    '\\t',
    '\\n',
    '\\u000B',
    '\\f',
    '\\r',
    '\\u000E',
    '\\u000F',
    '\\u0010',
    '\\u0011',
    '\\u0012',
    '\\u0013',
    '\\u0014',
    '\\u0015',
    '\\u0016',
    '\\u0017',
    '\\u0018',
    '\\u0019',
    '\\u001A',
    '\\u001B',
    '\\u001C',
    '\\u001D',
    '\\u001E',
    '\\u001F',
    '',
    '',
    '\\"',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\\\',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\u007F',
    '\\u0080',
    '\\u0081',
    '\\u0082',
    '\\u0083',
    '\\u0084',
    '\\u0085',
    '\\u0086',
    '\\u0087',
    '\\u0088',
    '\\u0089',
    '\\u008A',
    '\\u008B',
    '\\u008C',
    '\\u008D',
    '\\u008E',
    '\\u008F',
    '\\u0090',
    '\\u0091',
    '\\u0092',
    '\\u0093',
    '\\u0094',
    '\\u0095',
    '\\u0096',
    '\\u0097',
    '\\u0098',
    '\\u0099',
    '\\u009A',
    '\\u009B',
    '\\u009C',
    '\\u009D',
    '\\u009E',
    '\\u009F'
];

});

parcelRegister("kQCsj", function(module, exports) {

$parcel$export(module.exports, "visit", () => $36a41cb221910af4$export$bf638b60ea8b89b7);

var $9BlDI = parcelRequire("9BlDI");

var $cvyFm = parcelRequire("cvyFm");

var $aCPwB = parcelRequire("aCPwB");

var $3OxC3 = parcelRequire("3OxC3");
const $36a41cb221910af4$export$a89c95c098ac2a58 = Object.freeze({});
function $36a41cb221910af4$export$bf638b60ea8b89b7(root, visitor, visitorKeys = (0, $aCPwB.QueryDocumentKeys)) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values((0, $3OxC3.Kind)))enterLeaveMap.set(kind, $36a41cb221910af4$export$736de8489257458(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = Object.defineProperties({}, Object.getOwnPropertyDescriptors(node));
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $aCPwB.isNode)(node) || (0, $9BlDI.devAssert)(false, `Invalid AST Node: ${(0, $cvyFm.inspect)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $36a41cb221910af4$export$a89c95c098ac2a58) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $aCPwB.isNode)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
function $36a41cb221910af4$export$728beebeea393478(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values((0, $3OxC3.Kind))){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter, leave: leave } = $36a41cb221910af4$export$736de8489257458(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $36a41cb221910af4$export$a89c95c098ac2a58) skipping[i] = $36a41cb221910af4$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $36a41cb221910af4$export$a89c95c098ac2a58) skipping[i] = $36a41cb221910af4$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
function $36a41cb221910af4$export$736de8489257458(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === 'object') // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === 'function') // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
function $36a41cb221910af4$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    const { enter: enter, leave: leave } = $36a41cb221910af4$export$736de8489257458(visitor, kind);
    return isLeaving ? leave : enter;
}

});
parcelRegister("9BlDI", function(module, exports) {

$parcel$export(module.exports, "devAssert", () => $c362a2ae8c1900ae$export$b6cb5906f04696c8);
function $c362a2ae8c1900ae$export$b6cb5906f04696c8(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("cvyFm", function(module, exports) {

$parcel$export(module.exports, "inspect", () => $5bf42893c74e38e6$export$9dec5d1b3b6a130d);
const $5bf42893c74e38e6$var$MAX_ARRAY_LENGTH = 10;
const $5bf42893c74e38e6$var$MAX_RECURSIVE_DEPTH = 2;
function $5bf42893c74e38e6$export$9dec5d1b3b6a130d(value) {
    return $5bf42893c74e38e6$var$formatValue(value, []);
}
function $5bf42893c74e38e6$var$formatValue(value, seenValues) {
    switch(typeof value){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? `[function ${value.name}]` : '[function]';
        case 'object':
            return $5bf42893c74e38e6$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $5bf42893c74e38e6$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return 'null';
    if (previouslySeenValues.includes(value)) return '[Circular]';
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($5bf42893c74e38e6$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === 'string' ? jsonValue : $5bf42893c74e38e6$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $5bf42893c74e38e6$var$formatArray(value, seenValues);
    return $5bf42893c74e38e6$var$formatObject(value, seenValues);
}
function $5bf42893c74e38e6$var$isJSONable(value) {
    return typeof value.toJSON === 'function';
}
function $5bf42893c74e38e6$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return '{}';
    if (seenValues.length > $5bf42893c74e38e6$var$MAX_RECURSIVE_DEPTH) return '[' + $5bf42893c74e38e6$var$getObjectTag(object) + ']';
    const properties = entries.map(([key, value])=>key + ': ' + $5bf42893c74e38e6$var$formatValue(value, seenValues));
    return '{ ' + properties.join(', ') + ' }';
}
function $5bf42893c74e38e6$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $5bf42893c74e38e6$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    const len = Math.min($5bf42893c74e38e6$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($5bf42893c74e38e6$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return '[' + items.join(', ') + ']';
}
function $5bf42893c74e38e6$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        const name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});

parcelRegister("aCPwB", function(module, exports) {

$parcel$export(module.exports, "QueryDocumentKeys", () => $9e7f6daba17e7622$export$4fcd777a40ccf407);
$parcel$export(module.exports, "isNode", () => $9e7f6daba17e7622$export$8ee0fc9ee280b4ee);
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $9e7f6daba17e7622$export$18a2be9195644f38 {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    get [Symbol.toStringTag]() {
        return 'Location';
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
}
class $9e7f6daba17e7622$export$50792b0e93539fde {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    get [Symbol.toStringTag]() {
        return 'Token';
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
}
const $9e7f6daba17e7622$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
const $9e7f6daba17e7622$var$kindValues = new Set(Object.keys($9e7f6daba17e7622$export$4fcd777a40ccf407));
function $9e7f6daba17e7622$export$8ee0fc9ee280b4ee(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === 'string' && $9e7f6daba17e7622$var$kindValues.has(maybeKind);
}
/** Name */ var $9e7f6daba17e7622$export$f58c50edb4aef9d4;
(function(OperationTypeNode) {
    OperationTypeNode['QUERY'] = 'query';
    OperationTypeNode['MUTATION'] = 'mutation';
    OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})($9e7f6daba17e7622$export$f58c50edb4aef9d4 || ($9e7f6daba17e7622$export$f58c50edb4aef9d4 = {}));

});

parcelRegister("3OxC3", function(module, exports) {

$parcel$export(module.exports, "Kind", () => $da5cd9493a8f02b9$export$a84bdc57c5122798);
/**
 * The set of allowed kind values for AST nodes.
 */ var $da5cd9493a8f02b9$export$a84bdc57c5122798;
(function(Kind) {
    Kind['NAME'] = 'Name';
    Kind['DOCUMENT'] = 'Document';
    Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
    Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
    Kind['SELECTION_SET'] = 'SelectionSet';
    Kind['FIELD'] = 'Field';
    Kind['ARGUMENT'] = 'Argument';
    Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
    Kind['INLINE_FRAGMENT'] = 'InlineFragment';
    Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
    Kind['VARIABLE'] = 'Variable';
    Kind['INT'] = 'IntValue';
    Kind['FLOAT'] = 'FloatValue';
    Kind['STRING'] = 'StringValue';
    Kind['BOOLEAN'] = 'BooleanValue';
    Kind['NULL'] = 'NullValue';
    Kind['ENUM'] = 'EnumValue';
    Kind['LIST'] = 'ListValue';
    Kind['OBJECT'] = 'ObjectValue';
    Kind['OBJECT_FIELD'] = 'ObjectField';
    Kind['DIRECTIVE'] = 'Directive';
    Kind['NAMED_TYPE'] = 'NamedType';
    Kind['LIST_TYPE'] = 'ListType';
    Kind['NON_NULL_TYPE'] = 'NonNullType';
    Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
    Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
    Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
    Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
    Kind['FIELD_DEFINITION'] = 'FieldDefinition';
    Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
    Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
    Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
    Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
    Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
    Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
    Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
    Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
    Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
    Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
    Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
    Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
    Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
    Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
})($da5cd9493a8f02b9$export$a84bdc57c5122798 || ($da5cd9493a8f02b9$export$a84bdc57c5122798 = {}));
 /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 
});






parcelRegister("jKojs", function(module, exports) {

$parcel$export(module.exports, "getHostConfig", () => $e6052c394d8c4017$export$48cf5e71cc7508ae);
$parcel$export(module.exports, "useAppInstallBaseData", () => $e6052c394d8c4017$export$94285004c428f0ec);

var $kIWPJ = parcelRequire("kIWPJ");
var $7xC2S = parcelRequire("7xC2S");

var $inwKI = parcelRequire("inwKI");

var $cVLrH = parcelRequire("cVLrH");

var $9c9Gu = parcelRequire("9c9Gu");
var $bTrQR = parcelRequire("bTrQR");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $7Qsmx = parcelRequire("7Qsmx");

var $ifMZN = parcelRequire("ifMZN");

var $55gtq = parcelRequire("55gtq");

var $jiykS = parcelRequire("jiykS");

var $1nC6Q = parcelRequire("1nC6Q");

var $8AJas = parcelRequire("8AJas");

var $uz0Wp = parcelRequire("uz0Wp");
const { usePromise: $e6052c394d8c4017$var$usePromise } = (0, $9c9Gu);
function $e6052c394d8c4017$export$48cf5e71cc7508ae(product) {
    const hostConfig = (0, $7Qsmx.appConfig).get(product);
    if (!hostConfig) throw new Error('Host product configuration is not defined for ' + product);
    return hostConfig;
}
async function $e6052c394d8c4017$var$getHostData(hostInfo, hostPricing) {
    try {
        const hostLicense = await (hostPricing ? Promise.resolve(hostPricing) : (0, $55gtq.default)().getHostPricingInfo());
        return {
            hostInfo: hostInfo,
            hostLicense: hostLicense,
            hostConfig: $e6052c394d8c4017$export$48cf5e71cc7508ae(hostInfo.product)
        };
    } catch (error) {
        throw new Error('Error building host data ' + error);
    }
}
const $e6052c394d8c4017$var$getAllScopes = async (graphQLGatewayUrl)=>{
    return (0, $kIWPJ.getScopesLookup)(graphQLGatewayUrl).then((scopesLookup)=>(0, $bWAru.Option).some((0, $bWAru.Either).right(scopesLookup)), (error)=>(0, $bWAru.Option).some((0, $bWAru.Either).left(error.status.toString())));
};
function $e6052c394d8c4017$export$94285004c428f0ec(mpacBaseUrl, graphQLGatewayUrl, environment, installIdentifier, hostInfo) {
    const { enableReactivateForgeAppFromEmcee: enableReactivateForgeAppFromEmcee, enableReactivateForgeAppFromEmceeForHAMS: enableReactivateForgeAppFromEmceeForHAMS, enableDeprecatedInstallationsGQL: enableDeprecatedInstallationsGQL } = (0, $inwKI.useFeatureFlags)();
    const emceeAppInstallCache = (0, $jiykS.useEmceeAppInstallCache)();
    const getFromEmceeCache = async (cache)=>{
        if (!cache.result) throw new Error('Cached data from EMCEE is falsy');
        if (!hostInfo) throw new Error('hostInfo from useMarketplaceAppInstall is null/undefined');
        const { hostLicense: hostLicense, scopesLookup: scopesLookup } = cache.result;
        return Promise.all([
            Promise.resolve($e6052c394d8c4017$var$getHostData(hostInfo, hostLicense)),
            Promise.resolve(scopesLookup),
            installIdentifier !== null && installIdentifier.type === (0, $1nC6Q.INSTALLABLE_APP_IDENTIFIER) && Promise.resolve(installIdentifier.keyForInstall)
        ]);
    };
    const getFromNetwork = async ()=>{
        if (!hostInfo) throw new Error('hostInfo from useMarketplaceAppInstall is null/undefined');
        return Promise.all([
            $e6052c394d8c4017$var$getHostData(hostInfo),
            $e6052c394d8c4017$var$getAllScopes(graphQLGatewayUrl),
            installIdentifier !== null && installIdentifier.type === (0, $1nC6Q.MARKETPLACE_APP_KEY) && (0, $8AJas.getInstallableApp)(graphQLGatewayUrl, installIdentifier.keyForInstall)
        ]);
    };
    const baseAppInstallPromise = async ()=>{
        const [hostData, scopesLookup, appIdentifier] = emceeAppInstallCache !== null ? await getFromEmceeCache(emceeAppInstallCache) : await getFromNetwork();
        const shouldEnableReactivateForgeAppFromEmcee = enableReactivateForgeAppFromEmcee && hostData.hostLicense.billingSystem === (0, $cVLrH.BillingSystem).CCP || enableReactivateForgeAppFromEmceeForHAMS && hostData.hostLicense.billingSystem === (0, $cVLrH.BillingSystem).HAMS;
        const installMode = await (0, $uz0Wp.getAppInstallMode)({
            mpacBaseUrl: mpacBaseUrl,
            hostInfo: hostData.hostInfo,
            appIdentifier: appIdentifier,
            flags: {
                enableReactivateForgeAppFromEmcee: shouldEnableReactivateForgeAppFromEmcee,
                enableDeprecatedInstallationsGQL: enableDeprecatedInstallationsGQL
            },
            hostCmtEnabled: hostData.hostLicense.hostCmtEnabled
        });
        const envForForgeAppEgressAddresses = environment === 'prod' ? 'production' : 'staging';
        const forgeAppEgressAddresses = appIdentifier.type === (0, $ifMZN.ARI_TYPE) ? await (0, $7xC2S.latestEgress)(graphQLGatewayUrl, appIdentifier.ari, envForForgeAppEgressAddresses) : null;
        return {
            hostData: hostData,
            appIdentifier: appIdentifier,
            scopesLookup: scopesLookup,
            installMode: installMode,
            forgeAppEgressAddresses: forgeAppEgressAddresses
        };
    };
    const runPromise = hostInfo !== null && installIdentifier !== null && (!emceeAppInstallCache || !emceeAppInstallCache.pending);
    const baseAppInstallPromiseDependencies = emceeAppInstallCache ? [
        installIdentifier,
        hostInfo,
        emceeAppInstallCache.pending
    ] : [
        installIdentifier,
        hostInfo
    ];
    const { pending: pending, result: result, error: error } = $e6052c394d8c4017$var$usePromise(baseAppInstallPromise, baseAppInstallPromiseDependencies, runPromise);
    if (error) (0, $bTrQR.default).error('AppInstallDialog', 'Failed to build appInstallBaseData', {
        error: error
    });
    return {
        pending: pending,
        error: error,
        result: result
    };
}

});
parcelRegister("kIWPJ", function(module, exports) {

$parcel$export(module.exports, "getScopesLookup", () => $f1658dc93697b863$export$2f8049ed764783d2);

var $9D4R7 = parcelRequire("9D4R7");

var $8kbfx = parcelRequire("8kbfx");

var $bTrQR = parcelRequire("bTrQR");

var $g5DHJ = parcelRequire("g5DHJ");
var $f1658dc93697b863$var$GetScopes = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetScopes"
            },
            variableDefinitions: [],
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "appHostServices"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "scopes"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "Scope"
                                                },
                                                directives: []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "Scope"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "AppHostServiceScope"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "key"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "description"
                        },
                        arguments: [],
                        directives: []
                    }
                ]
            }
        }
    ],
    loc: {
        start: 0,
        end: 349,
        source: {
            body: "# If you are making any change here\n# Do thoroughly read our graphql contribution guidelines\n# https://bitbucket.org/atlassian-marketplace/marketplace-frontend/src/master/docs/working-with-graphql.md\n\nquery GetScopes {\n  appHostServices {\n    scopes {\n      ...Scope\n    }\n  }\n}\n\nfragment Scope on AppHostServiceScope {\n  key\n  name\n  description\n}\n",
            name: "GraphQL request",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    }
};
const $f1658dc93697b863$export$2f8049ed764783d2 = async (gqlGatewayUrl)=>{
    try {
        var _data$appHostServices;
        const { data: data, errors: errors } = await (0, $9D4R7.graphQLRequest)(gqlGatewayUrl, {
            query: $f1658dc93697b863$var$GetScopes
        });
        if (errors !== null && errors !== void 0 && errors.length) throw new Error(errors[0].message);
        const allScopes = (data === null || data === void 0 ? void 0 : (_data$appHostServices = data.appHostServices) === null || _data$appHostServices === void 0 ? void 0 : _data$appHostServices.reduce((scopes, appHostService)=>appHostService.scopes ? [
                ...scopes,
                ...appHostService.scopes
            ] : scopes, [])) || [];
        return (0, $g5DHJ.Map)(allScopes === null || allScopes === void 0 ? void 0 : allScopes.map((obj)=>[
                (0, $8kbfx.makeScopeKey)(obj.key),
                (0, $8kbfx.makeMarketplaceScope)(obj)
            ]));
    } catch (error) {
        // TODO: Filtering by 401 should be removed once root cause for MC-2004 is found
        if (error.status !== 401) (0, $bTrQR.default).error('mpac-api-client/getScopesLookup', "Failed to retrieve scopes lookup", {
            error: error,
            extraInfo: {
                userAgent: navigator.userAgent
            }
        });
        throw error;
    }
};

});

parcelRegister("7xC2S", function(module, exports) {

$parcel$export(module.exports, "latestEgress", () => $57d9207e1c35db8e$export$a419bd25832d0522);

var $9D4R7 = parcelRequire("9D4R7");

var $bTrQR = parcelRequire("bTrQR");
var $57d9207e1c35db8e$var$ForgeLatestEgress = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "ForgeLatestEgress"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "appKey"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    },
                    directives: []
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "type"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    },
                    directives: []
                }
            ],
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "app"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "appKey"
                                    }
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "environmentByKey"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "key"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "type"
                                                }
                                            }
                                        }
                                    ],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "versions"
                                                },
                                                arguments: [
                                                    {
                                                        kind: "Argument",
                                                        name: {
                                                            kind: "Name",
                                                            value: "first"
                                                        },
                                                        value: {
                                                            kind: "IntValue",
                                                            value: "1"
                                                        }
                                                    }
                                                ],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "nodes"
                                                            },
                                                            arguments: [],
                                                            directives: [],
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        },
                                                                        arguments: [],
                                                                        directives: []
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "permissions"
                                                                        },
                                                                        arguments: [],
                                                                        directives: [],
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "egress"
                                                                                    },
                                                                                    arguments: [],
                                                                                    directives: [],
                                                                                    selectionSet: {
                                                                                        kind: "SelectionSet",
                                                                                        selections: [
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "addresses"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: []
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ],
    loc: {
        start: 0,
        end: 510,
        source: {
            body: "# If you are making any change here\n# Do thoroughly read our graphql contribution guidelines\n# https://bitbucket.org/atlassian-marketplace/marketplace-frontend/src/master/docs/working-with-graphql.md\n\nquery ForgeLatestEgress($appKey: ID!, $type: String!) {\n  app(id: $appKey) {\n    id\n    environmentByKey(key: $type) {\n      id\n      versions(first: 1) {\n        nodes {\n          id\n          permissions {\n            egress {\n              addresses\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",
            name: "GraphQL request",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    }
};
const $57d9207e1c35db8e$export$d18b215c4b4270c9 = (forgeEgressAddresses)=>{
    const flattenedForgeEgressAddresses = forgeEgressAddresses === null || forgeEgressAddresses === void 0 ? void 0 : forgeEgressAddresses.flatMap((item)=>item.addresses || []);
    return [
        ...new Set(flattenedForgeEgressAddresses)
    ];
};
const $57d9207e1c35db8e$export$a419bd25832d0522 = async (gqlGatewayUrl, appKey, environment)=>{
    try {
        var _data$app, _data$app$environment, _data$app$environment2, _data$app$environment3, _data$app$environment4, _data$app$environment5, _data$app$environment6;
        const type = environment;
        const variables = {
            appKey: appKey,
            type: type
        };
        const { data: data, errors: errors } = await (0, $9D4R7.graphQLRequest)(gqlGatewayUrl, {
            query: $57d9207e1c35db8e$var$ForgeLatestEgress,
            variables: variables
        });
        if (errors !== null && errors !== void 0 && errors.length) throw new Error(errors[0].message);
        const forgeEgressAddresses = data === null || data === void 0 ? void 0 : (_data$app = data.app) === null || _data$app === void 0 ? void 0 : (_data$app$environment = _data$app.environmentByKey) === null || _data$app$environment === void 0 ? void 0 : (_data$app$environment2 = _data$app$environment.versions) === null || _data$app$environment2 === void 0 ? void 0 : (_data$app$environment3 = _data$app$environment2.nodes) === null || _data$app$environment3 === void 0 ? void 0 : (_data$app$environment4 = _data$app$environment3[0]) === null || _data$app$environment4 === void 0 ? void 0 : (_data$app$environment5 = _data$app$environment4.permissions) === null || _data$app$environment5 === void 0 ? void 0 : (_data$app$environment6 = _data$app$environment5[0]) === null || _data$app$environment6 === void 0 ? void 0 : _data$app$environment6.egress;
        return $57d9207e1c35db8e$export$d18b215c4b4270c9(forgeEgressAddresses);
    } catch (error) {
        (0, $bTrQR.default).error('mpac-api-client/LatestEgress', "Failed to retrieve latest forge app egress", {
            error: error,
            extraInfo: {
                userAgent: navigator.userAgent
            }
        });
    }
};

});

parcelRegister("7Qsmx", function(module, exports) {

$parcel$export(module.exports, "appConfig", () => $5b6363e9d01cc8de$export$fd7ad31753ec2ad1);

var $g5DHJ = parcelRequire("g5DHJ");

var $gD0YB = parcelRequire("gD0YB");

var $iP78c = parcelRequire("iP78c");

var $2pr8U = parcelRequire("2pr8U");

var $lQmA1 = parcelRequire("lQmA1");

var $3nH7C = parcelRequire("3nH7C");
const $5b6363e9d01cc8de$export$fd7ad31753ec2ad1 = (0, $g5DHJ.Map)({
    chat: $3nH7C.default,
    jira: $lQmA1.default,
    confluence: $2pr8U.default,
    bitbucket: $gD0YB.default,
    compass: $iP78c.default
});

});
parcelRegister("gD0YB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1b10bc10eb63600$export$2e2bcd8739ae039);

var $jexQk = parcelRequire("jexQk");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $eUqFw = parcelRequire("eUqFw");

var $kC116 = parcelRequire("kC116");

var $bdw66 = parcelRequire("bdw66");

var $ex4uM = parcelRequire("ex4uM");
var $c1b10bc10eb63600$export$2e2bcd8739ae039 = (0, $ex4uM.makeHostConfig)({
    addonDiscovery: (0, $ex4uM.makeAddonDiscoveryConfig)({
        featuredContentOverride: (0, $bWAru.Option).empty(),
        productKey: 'bitbucket',
        hiddenFilters: (0, $g5DHJ.Map)({
            sort: true,
            moreFilters: (0, $g5DHJ.Set)([
                'free'
            ])
        })
    }),
    analytics: {
        productName: 'bitbucket',
        getSubproduct: (_)=>{
        /* Bitbucket has no subproduct */ }
    },
    errors: (0, $g5DHJ.Map)({
        AddonDefinitionNotFoundError: (0, $bdw66.makeErrorTranslation)({
            title: "We couldn't find the app",
            description: "It's possible the link to the app is broken."
        }),
        DescriptorFetchError: (0, $bdw66.makeErrorTranslation)({
            title: "We couldn't find the app",
            description: "We couldn't find an app at that installation URL. Please make sure the URL is correct.",
            validationError: true
        }),
        InstallationConflictError: (0, $bdw66.makeErrorTranslation)({
            title: "We're seeing double!",
            description: 'The app is already installed.'
        }),
        InvalidAddonOriginError: (0, $bdw66.makeErrorTranslation)({
            title: "This app isn't registered",
            description: 'Please enter the installation URL from your app listing in marketplace.atlassian.com',
            validationError: true
        }),
        InvalidDefinitionDetailsQueryError: (0, $bdw66.makeErrorTranslation)({
            title: "The URL isn't formatted correctly",
            description: 'Please enter a valid installation URL, beginning with http: or https:',
            validationError: true
        }),
        InvalidDescriptorError: (0, $bdw66.makeErrorTranslation)({
            title: "This app isn't working quite right",
            description: "The app at that installation URL seems to be broken. Please reach out to our Support team, so we can get it fixed.",
            showTID: true
        }),
        default: (0, $bdw66.makeErrorTranslation)({
            title: 'We ran into a little trouble',
            description: 'It might just be a hiccup. Try again in a bit.',
            showTID: true
        })
    }),
    featureFlags: {
        productName: 'bitbucket'
    },
    globalContext: (0, $bWAru.Option).some({
        icon: (0, $bWAru.Option).some((0, $kC116.makeReactContextIcon)((_ref)=>{
            let { label: label, size: size } = _ref;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jexQk.BitbucketIcon), {
                label: label,
                size: size
            });
        }))
    }),
    name: 'Bitbucket',
    installationLocation: 'Bitbucket',
    isCloseable: false,
    supportsManage: false,
    removeFromSite: {
        actionSummary: (appName)=>"Remove ".concat(appName, " from Bitbucket"),
        confirmation: (appName)=>"You're about to remove ".concat(appName, ".             Are you sure that's what you wanted to do?"),
        successNotification: (appName)=>"".concat(appName, " was removed")
    }
});

});
parcelRegister("jexQk", function(module, exports) {

$parcel$export(module.exports, "BitbucketIcon", () => $281e4c44e69e1ae0$export$5fc1066e677788d4);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $281e4c44e69e1ae0$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95"/>
    </svg>`;
};
const $281e4c44e69e1ae0$export$5fc1066e677788d4 = ({ appearance: appearance, label: label = 'Bitbucket', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        svg: $281e4c44e69e1ae0$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("kC116", function(module, exports) {

$parcel$export(module.exports, "makeUrlContextIcon", () => $f01825304d073eff$export$329c7ecbcbbbe7a1);
$parcel$export(module.exports, "makeReactContextIcon", () => $f01825304d073eff$export$935f6f08d22f7bc6);
$parcel$export(module.exports, "makeContext", () => $f01825304d073eff$export$2d2e2a019c76af3);
$parcel$export(module.exports, "makeContextFromSPIContext", () => $f01825304d073eff$export$48a2a4b4b9048dc5);
$parcel$export(module.exports, "defaultContextName", () => $f01825304d073eff$export$81f5421c00c96842);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");
const $f01825304d073eff$export$329c7ecbcbbbe7a1 = (urlIcon)=>(0, $bWAru.Either).left(urlIcon);
const $f01825304d073eff$export$935f6f08d22f7bc6 = (reactIcon)=>(0, $bWAru.Either).right(reactIcon);
const $f01825304d073eff$export$2d2e2a019c76af3 = (0, $g5DHJ.Record)({
    id: '',
    icon: (0, $bWAru.Option).none(),
    name: undefined,
    type: undefined
});
const $f01825304d073eff$export$48a2a4b4b9048dc5 = (spiContext)=>$f01825304d073eff$export$2d2e2a019c76af3({
        id: spiContext.id,
        icon: (0, $bWAru.Option).of(spiContext.icon).map($f01825304d073eff$export$329c7ecbcbbbe7a1),
        name: spiContext.name,
        type: spiContext.type
    });
const $f01825304d073eff$export$81f5421c00c96842 = 'Atlassian Marketplace';

});

parcelRegister("ex4uM", function(module, exports) {

$parcel$export(module.exports, "makeAddonDiscoveryConfig", () => $a947a27451f4a42c$export$36f705efe56390c5);
$parcel$export(module.exports, "makeTokenConfig", () => $a947a27451f4a42c$export$9b8082f21d8aa046);
$parcel$export(module.exports, "makeHostConfig", () => $a947a27451f4a42c$export$9742b3e7692ff021);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

const $a947a27451f4a42c$export$36f705efe56390c5 = (0, $g5DHJ.Record)({
    featuredContentOverride: (0, $bWAru.Option).empty(),
    productKey: '',
    hiddenFilters: (0, $g5DHJ.Map)()
});
const $a947a27451f4a42c$export$9b8082f21d8aa046 = (0, $g5DHJ.Record)({
    exampleBody: {},
    exampleEndpoint: ()=>'',
    explanation: '',
    endpointVerb: ''
});
const $a947a27451f4a42c$export$9742b3e7692ff021 = (0, $g5DHJ.Record)({
    addonDiscovery: $a947a27451f4a42c$export$36f705efe56390c5(),
    analytics: {
        productName: '',
        getSubproduct: (_)=>{
        /* no subproduct by default */ }
    },
    contextType: (0, $162f08973e9f5b39$export$e5741ce2a090e5ef),
    errors: (0, $g5DHJ.Map)(),
    featureFlags: {
        productName: ''
    },
    globalContext: (0, $bWAru.Option).empty(),
    installedApps: {
        globallyInstalledApps: {
            sectionHeading: '',
            sectionDescription: ''
        },
        locallyInstalledApps: {
            sectionHeading: ''
        }
    },
    installationLocation: '',
    isCloseable: false,
    name: '',
    removeFromSite: {
        actionSummary: ()=>'',
        confirmation: ()=>'',
        // eslint-disable-line react/display-name
        successNotification: ()=>''
    },
    token: $a947a27451f4a42c$export$9b8082f21d8aa046(),
    supportsManage: false,
    welcomeHeader: '',
    welcomeSubheader: ''
});

});
const $162f08973e9f5b39$export$e5741ce2a090e5ef = 'conversation';
const $162f08973e9f5b39$export$2bf647ebf8f553ef = 'project';
const $162f08973e9f5b39$export$f8af7f4705257c5a = 'space';



parcelRegister("iP78c", function(module, exports) {

$parcel$export(module.exports, "default", () => $db428583914589a7$export$2e2bcd8739ae039);

var $exQem = parcelRequire("exQem");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $eUqFw = parcelRequire("eUqFw");

var $kC116 = parcelRequire("kC116");

var $bdw66 = parcelRequire("bdw66");

var $ex4uM = parcelRequire("ex4uM");
var $db428583914589a7$export$2e2bcd8739ae039 = (0, $ex4uM.makeHostConfig)({
    addonDiscovery: (0, $ex4uM.makeAddonDiscoveryConfig)({
        featuredContentOverride: (0, $bWAru.Option).empty(),
        productKey: 'compass',
        hiddenFilters: (0, $g5DHJ.Map)()
    }),
    analytics: {
        productName: 'compass',
        getSubproduct: (_)=>{
        /* Compass has no subproduct */ }
    },
    errors: (0, $g5DHJ.Map)({
        AddonDefinitionNotFoundError: (0, $bdw66.makeErrorTranslation)({
            title: "We couldn't find the app",
            description: "It's possible the link to the app is broken."
        }),
        DescriptorFetchError: (0, $bdw66.makeErrorTranslation)({
            title: "We couldn't find the app",
            description: "We couldn't find an app at that installation URL. Please make sure the URL is correct.",
            validationError: true
        }),
        InstallationConflictError: (0, $bdw66.makeErrorTranslation)({
            title: "We're seeing double!",
            description: 'The app is already installed.'
        }),
        InvalidAddonOriginError: (0, $bdw66.makeErrorTranslation)({
            title: "This app isn't registered",
            description: 'Please enter the installation URL from your app listing in marketplace.atlassian.com',
            validationError: true
        }),
        InvalidDefinitionDetailsQueryError: (0, $bdw66.makeErrorTranslation)({
            title: "The URL isn't formatted correctly",
            description: 'Please enter a valid installation URL, beginning with http: or https:',
            validationError: true
        }),
        InvalidDescriptorError: (0, $bdw66.makeErrorTranslation)({
            title: "This app isn't working quite right",
            description: "The app at that installation URL seems to be broken. Please reach out to our Support team, so we can get it fixed.",
            showTID: true
        }),
        PaymentFailure: (0, $bdw66.makeErrorTranslation)({
            title: 'We ran into a little trouble',
            description: 'Please verify that your payment details and license status are correct before trying to install the app again.',
            showTID: false
        }),
        default: (0, $bdw66.makeErrorTranslation)({
            title: 'We ran into a little trouble',
            description: "Unfortunately, we\u2019re unable to process your request. Please retry again in some time.",
            showTID: true
        })
    }),
    featureFlags: {
        productName: 'compass'
    },
    globalContext: (0, $bWAru.Option).some({
        icon: (0, $bWAru.Option).some((0, $kC116.makeReactContextIcon)((_ref)=>{
            let { label: label, size: size } = _ref;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $exQem.CompassIcon), {
                label: label,
                size: size
            });
        }))
    }),
    name: 'Compass',
    installationLocation: 'Compass',
    isCloseable: false,
    supportsManage: false
});

});
parcelRegister("exQem", function(module, exports) {

$parcel$export(module.exports, "CompassIcon", () => $ef123244e25ec108$export$f7857fe64d7161d9);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $ef123244e25ec108$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M15.667 15.66v5.942H9.713V15.66zV9.722H4.807c-.58.004-1.047.47-1.043 1.04v15.755a1.04 1.04 0 0 0 1.028 1.054h15.771a1.04 1.04 0 0 0 1.042-1.04V15.66zm0-11.88v5.942h5.967v5.938h5.935V4.82a1.04 1.04 0 0 0-1.028-1.053h-.014z"/>
      </svg>
    `;
};
const $ef123244e25ec108$export$f7857fe64d7161d9 = ({ appearance: appearance, label: label = 'Compass', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        svg: $ef123244e25ec108$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});


parcelRegister("2pr8U", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c12f88d533532b8$export$2e2bcd8739ae039);

var $5KT10 = parcelRequire("5KT10");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $eUqFw = parcelRequire("eUqFw");

var $kC116 = parcelRequire("kC116");

var $bdw66 = parcelRequire("bdw66");

var $ex4uM = parcelRequire("ex4uM");
var $1c12f88d533532b8$export$2e2bcd8739ae039 = (0, $ex4uM.makeHostConfig)({
    addonDiscovery: (0, $ex4uM.makeAddonDiscoveryConfig)({
        featuredContentOverride: (0, $bWAru.Option).empty(),
        productKey: 'confluence',
        hiddenFilters: (0, $g5DHJ.Map)()
    }),
    analytics: {
        productName: 'confluence',
        getSubproduct: (_)=>{
        /* Confluence has no subproduct */ }
    },
    errors: (0, $g5DHJ.Map)({
        AddonDefinitionNotFoundError: (0, $bdw66.makeErrorTranslation)({
            title: "We couldn't find the app",
            description: "It's possible the link to the app is broken."
        }),
        DescriptorFetchError: (0, $bdw66.makeErrorTranslation)({
            title: "We couldn't find the app",
            description: "We couldn't find an app at that installation URL. Please make sure the URL is correct.",
            validationError: true
        }),
        InstallationConflictError: (0, $bdw66.makeErrorTranslation)({
            title: "We're seeing double!",
            description: 'The app is already installed.'
        }),
        InvalidAddonOriginError: (0, $bdw66.makeErrorTranslation)({
            title: "This app isn't registered",
            description: 'Please enter the installation URL from your app listing in marketplace.atlassian.com',
            validationError: true
        }),
        InvalidDefinitionDetailsQueryError: (0, $bdw66.makeErrorTranslation)({
            title: "The URL isn't formatted correctly",
            description: 'Please enter a valid installation URL, beginning with http: or https:',
            validationError: true
        }),
        InvalidDescriptorError: (0, $bdw66.makeErrorTranslation)({
            title: "This app isn't working quite right",
            description: "The app at that installation URL seems to be broken. Please reach out to our Support team, so we can get it fixed.",
            showTID: true
        }),
        PaymentFailure: (0, $bdw66.makeErrorTranslation)({
            title: 'We ran into a little trouble',
            description: 'Please verify that your payment details and license status are correct before trying to install the app again.',
            showTID: false
        }),
        'connect.install.error.nodefaultgroup': (0, $bdw66.makeErrorTranslation)({
            title: 'App installation failed',
            description: 'We are unable to process your request as there is no default group in Confluence cloud product access. Please review and create a default group for each product.',
            showTID: false,
            actions: [
                {
                    content: 'Learn more about default groups',
                    href: 'https://support.atlassian.com/user-management/docs/create-and-update-groups/',
                    target: '_blank'
                }
            ]
        }),
        default: (0, $bdw66.makeErrorTranslation)({
            title: 'We ran into a little trouble',
            description: "Unfortunately, we\u2019re unable to process your request. Please retry again in some time.",
            showTID: true
        })
    }),
    featureFlags: {
        productName: 'confluence'
    },
    globalContext: (0, $bWAru.Option).some({
        icon: (0, $bWAru.Option).some((0, $kC116.makeReactContextIcon)((_ref)=>{
            let { label: label, size: size } = _ref;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5KT10.ConfluenceIcon), {
                label: label,
                size: size
            });
        }))
    }),
    name: 'Confluence',
    installationLocation: 'Confluence',
    isCloseable: false,
    supportsManage: false,
    removeFromSite: {
        actionSummary: (appName)=>"Remove ".concat(appName, " from Confluence"),
        confirmation: (appName)=>"You're about to remove ".concat(appName, ".             Are you sure that's what you wanted to do?"),
        successNotification: (appName)=>"".concat(appName, " was removed")
    }
});

});
parcelRegister("5KT10", function(module, exports) {

$parcel$export(module.exports, "ConfluenceIcon", () => $bd2fb8be68c26b84$export$68f3db7f6af48bcb);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $bd2fb8be68c26b84$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098"/>
    </svg>`;
};
const $bd2fb8be68c26b84$export$68f3db7f6af48bcb = ({ appearance: appearance, label: label = 'Confluence', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        svg: $bd2fb8be68c26b84$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});


parcelRegister("lQmA1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe6ff83abaf7143b$export$2e2bcd8739ae039);

var $77CtJ = parcelRequire("77CtJ");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $eUqFw = parcelRequire("eUqFw");

var $kC116 = parcelRequire("kC116");

var $bdw66 = parcelRequire("bdw66");

var $ex4uM = parcelRequire("ex4uM");
const $fe6ff83abaf7143b$var$subproductTranslationTable = (0, $g5DHJ.Map)({
    'jira-software': 'software',
    'jira-servicedesk': 'serviceDesk',
    'jira-core': 'core',
    'portfolio-for-jira': 'portfolio',
    family: 'platform'
});
var $fe6ff83abaf7143b$export$2e2bcd8739ae039 = (0, $ex4uM.makeHostConfig)({
    addonDiscovery: (0, $ex4uM.makeAddonDiscoveryConfig)({
        featuredContentOverride: (0, $bWAru.Option).empty(),
        productKey: 'jira',
        hiddenFilters: (0, $g5DHJ.Map)()
    }),
    analytics: {
        productName: 'jira',
        getSubproduct: (subproduct)=>subproduct ? $fe6ff83abaf7143b$var$subproductTranslationTable.get(subproduct) : undefined
    },
    errors: (0, $g5DHJ.Map)({
        AddonDefinitionNotFoundError: (0, $bdw66.makeErrorTranslation)({
            title: "We couldn't find the app",
            description: "It's possible the link to the app is broken."
        }),
        DescriptorFetchError: (0, $bdw66.makeErrorTranslation)({
            title: "We couldn't find the app",
            description: "We couldn't find an app at that installation URL. Please make sure the URL is correct.",
            validationError: true
        }),
        InstallationConflictError: (0, $bdw66.makeErrorTranslation)({
            title: "We're seeing double!",
            description: 'The app is already installed.'
        }),
        InvalidAddonOriginError: (0, $bdw66.makeErrorTranslation)({
            title: "This app isn't registered",
            description: 'Please enter the installation URL from your app listing in marketplace.atlassian.com',
            validationError: true
        }),
        InvalidDefinitionDetailsQueryError: (0, $bdw66.makeErrorTranslation)({
            title: "The URL isn't formatted correctly",
            description: 'Please enter a valid installation URL, beginning with http: or https:',
            validationError: true
        }),
        InvalidDescriptorError: (0, $bdw66.makeErrorTranslation)({
            title: "This app isn't working quite right",
            description: "The app at that installation URL seems to be broken. Please reach out to our Support team, so we can get it fixed.",
            showTID: true
        }),
        PaymentFailure: (0, $bdw66.makeErrorTranslation)({
            title: 'We ran into a little trouble',
            description: 'Please verify that your payment details and license status are correct before trying to install the app again.',
            showTID: false
        }),
        'connect.install.error.nodefaultgroup': (0, $bdw66.makeErrorTranslation)({
            title: 'App installation failed',
            description: 'We are unable to process your request as there is no default group in Jira cloud product access. Please review and create a default group for each product.',
            showTID: false,
            actions: [
                {
                    content: 'Learn more about default groups',
                    href: 'https://support.atlassian.com/user-management/docs/create-and-update-groups/',
                    target: '_blank'
                }
            ]
        }),
        default: (0, $bdw66.makeErrorTranslation)({
            title: 'We ran into a little trouble',
            description: "Unfortunately, we\u2019re unable to process your request. Please retry again in some time.",
            showTID: true
        })
    }),
    featureFlags: {
        productName: 'jira'
    },
    globalContext: (0, $bWAru.Option).some({
        icon: (0, $bWAru.Option).some((0, $kC116.makeReactContextIcon)((_ref)=>{
            let { label: label, size: size } = _ref;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77CtJ.JiraIcon), {
                label: label,
                size: size
            });
        }))
    }),
    name: 'Jira',
    installationLocation: 'Jira',
    isCloseable: false,
    supportsManage: false,
    removeFromSite: {
        actionSummary: (appName)=>"Remove ".concat(appName, " from Jira"),
        confirmation: (appName)=>"You're about to remove ".concat(appName, ".             Are you sure that's what you wanted to do?"),
        successNotification: (appName)=>"".concat(appName, " was removed")
    }
});

});

parcelRegister("3nH7C", function(module, exports) {

$parcel$export(module.exports, "default", () => $2764f82bbcd02ad3$export$2e2bcd8739ae039);

var $eMCmH = parcelRequire("eMCmH");

var $lLYAL = parcelRequire("lLYAL");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $eUqFw = parcelRequire("eUqFw");

var $iRzCc = parcelRequire("iRzCc");

var $bdw66 = parcelRequire("bdw66");

var $ex4uM = parcelRequire("ex4uM");


var $4m18f = parcelRequire("4m18f");
var $2764f82bbcd02ad3$export$2e2bcd8739ae039 = (0, $ex4uM.makeHostConfig)({
    addonDiscovery: (0, $ex4uM.makeAddonDiscoveryConfig)({
        featuredContentOverride: (0, $bWAru.Option).some((_ref)=>{
            let { openAppSpecificPasswordDialog: openAppSpecificPasswordDialog } = _ref;
            return (0, $g5DHJ.List)([
                new (0, $eMCmH.default)({
                    index: 0,
                    // eslint-disable-next-line react/display-name
                    render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iRzCc.default), {
                            openAppSpecificPasswordDialog: openAppSpecificPasswordDialog
                        })
                })
            ]);
        }),
        productKey: 'stride',
        hiddenFilters: (0, $g5DHJ.Map)({
            sort: true,
            moreFilters: (0, $g5DHJ.Set)([
                'free'
            ])
        })
    }),
    analytics: {
        productName: 'stride',
        getSubproduct: (_)=>{
        /* no subproduct */ }
    },
    contextType: (0, $162f08973e9f5b39$export$e5741ce2a090e5ef),
    errors: (0, $g5DHJ.Map)({
        AddonDefinitionNotFoundError: (0, $bdw66.makeErrorTranslation)({
            title: "We couldn't find the app",
            description: "It's possible the link to the app is broken."
        }),
        DescriptorFetchError: (0, $bdw66.makeErrorTranslation)({
            title: "We couldn't find the app",
            description: "We couldn't find an app at that installation URL. Please make sure the URL is correct.",
            validationError: true
        }),
        InstallationConflictError: (0, $bdw66.makeErrorTranslation)({
            title: "We're seeing double!",
            description: 'The app is already installed in this conversation.'
        }),
        InvalidAddonOriginError: (0, $bdw66.makeErrorTranslation)({
            title: "This app isn't registered",
            description: 'Please enter the installation URL from your app listing in developer.atlassian.com',
            validationError: true
        }),
        InvalidDefinitionDetailsQueryError: (0, $bdw66.makeErrorTranslation)({
            title: "The URL isn't formatted correctly",
            description: 'Please enter a valid installation URL, beginning with http: or https:',
            validationError: true
        }),
        InvalidDescriptorError: (0, $bdw66.makeErrorTranslation)({
            title: "This app isn't working quite right",
            description: "The app at that installation URL seems to be broken. Please reach out to our Support team, so we can get it fixed.",
            showTID: true
        }),
        default: (0, $bdw66.makeErrorTranslation)({
            title: 'We ran into a little trouble',
            description: 'It might just be a hiccup. Try again in a bit.',
            showTID: true
        })
    }),
    featureFlags: {
        productName: 'stride'
    },
    installedApps: {
        globallyInstalledApps: {
            sectionHeading: 'Apps installed in all conversations',
            sectionDescription: 'Some apps are installed in all public rooms and conversations.'
        },
        locallyInstalledApps: {
            sectionHeading: 'Apps installed in this conversation'
        }
    },
    name: 'Stride',
    installationLocation: 'conversation',
    isCloseable: true,
    removeFromSite: {
        actionSummary: (appName)=>"Remove ".concat(appName, " from all conversations"),
        confirmation: (appName)=>"You're about to remove ".concat(appName, " from multiple conversations.             Participants in these conversations won't be able to use ").concat(appName, " in Stride. This can't be undone."),
        successNotification: (appName)=>"".concat(appName, " was removed from all conversations")
    },
    token: (0, $ex4uM.makeTokenConfig)({
        exampleBody: {
            body: {
                version: 1,
                type: 'doc',
                content: [
                    {
                        type: 'paragraph',
                        content: [
                            {
                                type: 'text',
                                text: 'My first message!'
                            }
                        ]
                    }
                ]
            }
        },
        exampleEndpoint: (context)=>{
            const ari = (0, $lLYAL.parse)(context.id);
            return (0, $4m18f.parse)('https://api.atlassian.com/site/{cloudId}/conversation/{conversationId}/message').expand({
                cloudId: ari.cloudId,
                conversationId: ari.resourceId
            });
        },
        explanation: "API tokens give you a simple way to send messages to a conversation from your own code, without having to build an app.",
        endpointVerb: 'post messages'
    }),
    supportsManage: true,
    welcomeHeader: 'Welcome to Stride!',
    welcomeSubheader: 'Pick a conversation to get going...'
});

});
parcelRegister("iRzCc", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbb8cda164bfaf8e$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $ivTMz = parcelRequire("ivTMz");

var $j0gMm = parcelRequire("j0gMm");

var $8gcXz = parcelRequire("8gcXz");
var $gykb8 = parcelRequire("gykb8");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $82QIV = parcelRequire("82QIV");
function $dbb8cda164bfaf8e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dbb8cda164bfaf8e$export$ef5dfe27ad077558 = (0, $3UXZ8.default)("div", {
    target: "e18vh9uh0",
    label: "BYOTileContainer"
})("border-radius:", (0, $ivTMz.borderRadius)(), "px;height:100%;border:2px dashed ", (0, $j0gMm.N400), ";cursor:pointer;display:flex;justify-content:space-around;flex-direction:column;");
const $dbb8cda164bfaf8e$export$bc714d455b135669 = (0, $3UXZ8.default)("div", {
    target: "e18vh9uh1",
    label: "BYOTileContent"
})({
    name: "11u0uwb",
    styles: "padding:15px;margin:auto;"
});
const $dbb8cda164bfaf8e$export$508f9a61eb3c0147 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $8gcXz.H3), {
    target: "e18vh9uh2",
    label: "BYOTileHeading"
})("color:", (0, $j0gMm.N800), ";font-size:16px;font-weight:800;margin:0 0 3px;line-height:1.42857143;max-height:42px;");
const $dbb8cda164bfaf8e$export$287fb8a3c895d99c = (0, $3UXZ8.default)("div", {
    target: "e18vh9uh3",
    label: "BYOTileTextContainer"
})({
    name: "z920ed",
    styles: "display:table;"
});
const $dbb8cda164bfaf8e$export$e644168da93dcc51 = (0, $3UXZ8.default)("div", {
    target: "e18vh9uh4",
    label: "BYOTileText"
})("display:table-cell;vertical-align:top;color:", (0, $j0gMm.N500), ";font-size:14px;word-wrap:break-word;overflow:hidden;min-height:35px;line-height:1.26;");
const $dbb8cda164bfaf8e$export$3aa1d1610e7e6799 = (0, $3UXZ8.default)("div", {
    target: "e18vh9uh5",
    label: "BYOTileTextLinkContainer"
})({
    name: "tr0r3x",
    styles: "margin-top:15px;"
});
const $dbb8cda164bfaf8e$export$be96604e57d7eea0 = (0, $3UXZ8.default)("div", {
    target: "e18vh9uh6",
    label: "BYOTileIconWrapper"
})({
    name: "xskcao",
    styles: "margin-left:10px;width:80px;"
});
const $dbb8cda164bfaf8e$export$431e1383ad029b46 = (0, $3UXZ8.default)("img", {
    target: "e18vh9uh7",
    label: "BYOTileIcon"
})({
    name: "v2kfba",
    styles: "height:100%;width:100%;"
});
class $dbb8cda164bfaf8e$export$f8f09afa2391cee9 extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "render", ()=>/*#__PURE__*/ // eslint-disable-next-line styled-components-a11y/click-events-have-key-events, styled-components-a11y/no-static-element-interactions
            (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dbb8cda164bfaf8e$export$ef5dfe27ad077558, {
                onClick: this.openBYODialog
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dbb8cda164bfaf8e$export$bc714d455b135669, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dbb8cda164bfaf8e$export$508f9a61eb3c0147, null, "Connect your own app"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dbb8cda164bfaf8e$export$287fb8a3c895d99c, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dbb8cda164bfaf8e$export$e644168da93dcc51, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, "If you've built an app, generate a token or add your installation URL to bring your custom app to life."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dbb8cda164bfaf8e$export$3aa1d1610e7e6799, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gykb8.default), null, "Connect your app"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dbb8cda164bfaf8e$export$be96604e57d7eea0, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dbb8cda164bfaf8e$export$431e1383ad029b46, {
                alt: "",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($82QIV)))
            }))))));
        (0, $5zQU9.default)(this, "openBYODialog", ()=>{
            this.props.fireAnalyticsEvent({
                eventType: (0, $gaiog.TileClickedEvent),
                actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_BYO_TILE)
            });
            this.props.openAppSpecificPasswordDialog();
        });
    }
}
var $dbb8cda164bfaf8e$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($dbb8cda164bfaf8e$export$f8f09afa2391cee9);

});
parcelRegister("82QIV", function(module, exports) {
module.exports = new URL("BYO.cb08927a.svg", import.meta.url).toString();

});


parcelRegister("4m18f", function(module, exports) {

$parcel$export(module.exports, "parse", () => $32ba184ed6577c5f$export$98e6a39c04603d36);

var $asbhz = parcelRequire("asbhz");
function $32ba184ed6577c5f$export$98e6a39c04603d36(template) {
    const parsedTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(template);
    return {
        expand: (context)=>parsedTemplate.expand(context)
    };
}

});



parcelRegister("jiykS", function(module, exports) {

$parcel$export(module.exports, "EmceeAppInstallCache", () => $e0ca5521a3c2dded$export$965f8f8a05e2bd95);
$parcel$export(module.exports, "useEmceeAppInstallCache", () => $e0ca5521a3c2dded$export$92706f754038ea7b);

var $eUqFw = parcelRequire("eUqFw");
const $e0ca5521a3c2dded$export$965f8f8a05e2bd95 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(null);
const $e0ca5521a3c2dded$export$92706f754038ea7b = ()=>{
    const cache = (0, $eUqFw.useContext)($e0ca5521a3c2dded$export$965f8f8a05e2bd95);
    if (cache && Object.keys(cache).length) return cache;
    return null;
};

});

parcelRegister("uz0Wp", function(module, exports) {

$parcel$export(module.exports, "getAppInstallMode", () => $05bdf68b11690c97$export$a01ee00d42c710f4);

var $bTrQR = parcelRequire("bTrQR");

var $6BOFf = parcelRequire("6BOFf");
const $05bdf68b11690c97$export$a01ee00d42c710f4 = async (_ref)=>{
    let { mpacBaseUrl: mpacBaseUrl, appIdentifier: appIdentifier, hostInfo: hostInfo, flags: flags, hostCmtEnabled: hostCmtEnabled } = _ref;
    try {
        const installMode = await (0, $6BOFf.getInstallMode)({
            mpacBaseUrl: mpacBaseUrl,
            installableAppId: appIdentifier,
            context: hostInfo.globalContext,
            flags: flags,
            hostCmtEnabled: hostCmtEnabled
        });
        const appInstallMode = installMode.fold((error)=>{
            console.error("Either the SPI's getInstallableAddon returned an error or invalid shape, or MPAC returned an invalid instructional listing: ", error);
        }, (im)=>im);
        return appInstallMode;
    } catch (error) {
        (0, $bTrQR.default).error('AppInstallDialog/getAppInstallMode', 'Failed with', {
            error: error
        });
    }
};

});
parcelRegister("6BOFf", function(module, exports) {

$parcel$export(module.exports, "FINISH_DETERMINING_INSTALL_MODE", () => $4cfd7fa604968627$export$cbebb8bc69111133);
$parcel$export(module.exports, "DETERMINING_INSTALL_MODE_ERROR", () => $4cfd7fa604968627$export$1e0840157eac12c);
$parcel$export(module.exports, "parseInstalledAddonResult", () => $4cfd7fa604968627$export$1ad37f4eb25808e2);
$parcel$export(module.exports, "getInstallMode", () => $4cfd7fa604968627$export$a9593d7012654efb);
$parcel$export(module.exports, "doInitiateInstallModeForIdentifier", () => $4cfd7fa604968627$export$9280e5c04d16e3df);

var $5zQU9 = parcelRequire("5zQU9");

var $cjFit = parcelRequire("cjFit");

var $ly50n = parcelRequire("ly50n");

var $4gzHi = parcelRequire("4gzHi");
var $7r0ma = parcelRequire("7r0ma");
var $eNZVr = parcelRequire("eNZVr");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $hCQtM = parcelRequire("hCQtM");

var $ifMZN = parcelRequire("ifMZN");

var $8ZSlI = parcelRequire("8ZSlI");

var $4s0An = parcelRequire("4s0An");

var $9eIgo = parcelRequire("9eIgo");

var $k5vUT = parcelRequire("k5vUT");

var $irBem = parcelRequire("irBem");

var $55gtq = parcelRequire("55gtq");

var $3DsUo = parcelRequire("3DsUo");

var $hsaiM = parcelRequire("hsaiM");

var $38gnU = parcelRequire("38gnU");

var $dSumc = parcelRequire("dSumc");
function $4cfd7fa604968627$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4cfd7fa604968627$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4cfd7fa604968627$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4cfd7fa604968627$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $4cfd7fa604968627$export$cbebb8bc69111133 = 'INSTALLATION_FINISH_DETERMINING_INSTALL_MODE';
const $4cfd7fa604968627$export$1e0840157eac12c = 'INSTALLATION_DETERMINING_INSTALL_MODE_ERROR';
const $4cfd7fa604968627$var$finishDeterminingInstallMode = (_ref)=>{
    let { installMode: installMode, retrievalId: retrievalId } = _ref;
    return {
        type: $4cfd7fa604968627$export$cbebb8bc69111133,
        installMode: installMode,
        retrievalId: retrievalId
    };
};
const $4cfd7fa604968627$var$determiningInstallModeError = (_ref2)=>{
    let { error: error, installableAppId: installableAppId, retrievalId: retrievalId } = _ref2;
    return {
        type: $4cfd7fa604968627$export$1e0840157eac12c,
        error: error,
        installableAppId: installableAppId,
        retrievalId: retrievalId
    };
};
const $4cfd7fa604968627$var$attemptInstructionalAppInstallMode = (_ref3)=>{
    var _marketplaceApp$_embe;
    let { mpacBaseUrl: mpacBaseUrl, marketplaceApp: marketplaceApp } = _ref3;
    return (0, $bWAru.Option).of((_marketplaceApp$_embe = marketplaceApp._embedded) === null || _marketplaceApp$_embe === void 0 ? void 0 : _marketplaceApp$_embe.version).map((v)=>{
        var _v$_embedded, _v$vendorLinks, _v$vendorLinks2;
        return v.deployment.connect ? (0, $bWAru.Either).left('Instructional apps cannot be connect apps') : (0, $bWAru.Either).right((0, $k5vUT.makeInstructionalInstallMode)({
            instructionalApp: (0, $irBem.makeInstructionalApp)({
                details: (0, $7r0ma.makeMarketplaceAppDisplayDetailsFromMarketplaceApp)({
                    marketplaceApp: marketplaceApp,
                    mpacBaseUrl: mpacBaseUrl
                }),
                steps: (0, $g5DHJ.List)((_v$_embedded = v._embedded) === null || _v$_embedded === void 0 ? void 0 : _v$_embedded.instructions).map((step)=>{
                    var _step$_embedded;
                    return (0, $irBem.makeInstallInstructionsStep)({
                        image: (_step$_embedded = step._embedded) === null || _step$_embedded === void 0 ? void 0 : _step$_embedded.image._links.image.href,
                        bodyHTML: step.body
                    });
                }),
                learnMoreLink: (0, $cjFit.nonEmptyString)(((_v$vendorLinks = v.vendorLinks) === null || _v$vendorLinks === void 0 ? void 0 : _v$vendorLinks.learnMore) || ((_v$vendorLinks2 = v.vendorLinks) === null || _v$vendorLinks2 === void 0 ? void 0 : _v$vendorLinks2.binary))
            })
        }));
    }).getOrElse((0, $bWAru.Either).left('Cannot resolve data from Marketplace response'));
};
const $4cfd7fa604968627$var$attemptInstallableAppForDefaultInstallMode = (_ref4)=>{
    let { installableAddon: installableAddon, installableAppId: installableAppId, installedAddon: installedAddon, installPermission: installPermission, marketplaceApp: marketplaceApp, mpacBaseUrl: mpacBaseUrl, relayState: relayState } = _ref4;
    return (0, $bWAru.Either).map2(installableAddon.fold((error)=>(0, $bWAru.Either).left("InstallableApp install mode needs a successful installableAddon resolved: ".concat(error)), (r)=>(0, $bWAru.Either).right(r)), installPermission.fold((error)=>(0, $bWAru.Either).left("InstallableApp install mode needs a successful installPermission resolved: ".concat(error)), (r)=>(0, $bWAru.Either).right(r)), (ia, p)=>(0, $4s0An.makeInstallableAppDefaultInstallMode)({
            installableApp: (0, $hCQtM.makeInstallableAppFromSPIInstallableAddonAndMarketplaceAppData)(ia, marketplaceApp, mpacBaseUrl),
            installPermission: (0, $eNZVr.makePermissionCheckResultFromSPI)(p),
            installedApp: installedAddon.toOption().map((0, $4gzHi.makeInstalledAppFromSPIInstalledApp)),
            installableAppId: installableAppId,
            relayState: relayState,
            status: (0, $9eIgo.makePendingConfirmationInstallStatus)()
        }));
};
const $4cfd7fa604968627$export$1ad37f4eb25808e2 = (installedAddonResult)=>{
    if (installedAddonResult.status && installedAddonResult.status === 'NOT_FOUND') throw new Error("Failed to fetch app details while determining install mode");
    const installedAddon = installedAddonResult;
    return installedAddon;
};
const $4cfd7fa604968627$var$handleAriDetermineMode = (mpacBaseUrl, installableAppByARI, relayState, context, flags)=>Promise.all([
        (0, $38gnU.retrieveAppDataByAri)({
            installableAppByARI: installableAppByARI,
            mpacBaseUrl: mpacBaseUrl
        }),
        (0, $3DsUo.reflect)((0, $55gtq.default)().getInstalledAddon({
            contextId: context.id,
            addon: (0, $ifMZN.toSPIInstallableAddonIdentifier)((0, $ifMZN.makeInstallableAppByAriIdentifier)({
                ari: (0, $ly50n.makeAppKey)(installableAppByARI.ari),
                appKey: (0, $ly50n.makeAppKey)(installableAppByARI.appKey)
            })),
            flags: $4cfd7fa604968627$var$_objectSpread($4cfd7fa604968627$var$_objectSpread({}, flags), {}, {
                retryForLicenseDetails: false
            })
        }).then((installedAddonResult)=>$4cfd7fa604968627$export$1ad37f4eb25808e2(installedAddonResult)))
    ]).then((_ref5)=>{
        let [{ installableAddon: installableAddon, installPermission: installPermission, marketplaceApp: marketplaceApp }, installedAddon] = _ref5;
        return $4cfd7fa604968627$var$attemptInstallableAppForDefaultInstallMode({
            installableAddon: installableAddon,
            installableAppId: installableAppByARI,
            installedAddon: installedAddon,
            installPermission: installPermission,
            marketplaceApp: marketplaceApp,
            mpacBaseUrl: mpacBaseUrl,
            relayState: relayState
        }).map((0, $bWAru.Either).right).getOrElseL(()=>$4cfd7fa604968627$var$attemptInstructionalAppInstallMode({
                mpacBaseUrl: mpacBaseUrl,
                marketplaceApp: marketplaceApp
            }));
    }).catch((error)=>(0, $bWAru.Either).left(error));
const $4cfd7fa604968627$export$a9593d7012654efb = (_ref6)=>{
    let { mpacBaseUrl: mpacBaseUrl, installableAppId: installableAppId, relayState: relayState, context: context, flags: flags, hostCmtEnabled: hostCmtEnabled = false } = _ref6;
    const installMode = (0, $ifMZN.foldInstallableAppIdentifier)(installableAppId)((installableAppByKeyId)=>Promise.all([
            (0, $38gnU.retrieveAppDataByKey)({
                installableAppByKeyId: installableAppByKeyId,
                mpacBaseUrl: mpacBaseUrl
            }, hostCmtEnabled),
            (0, $3DsUo.reflect)((0, $55gtq.default)().getInstalledAddon({
                contextId: context.id,
                addon: (0, $ifMZN.toSPIInstallableAddonIdentifier)((0, $ifMZN.makeInstallableAppByKeyIdentifier)({
                    key: (0, $ly50n.makeAppKey)(installableAppByKeyId.key)
                }))
            }).then((installedAddonResult)=>$4cfd7fa604968627$export$1ad37f4eb25808e2(installedAddonResult)))
        ]).then((_ref7)=>{
            let [{ installableAddon: installableAddon, installPermission: installPermission, marketplaceApp: marketplaceApp }, installedAddon] = _ref7;
            return $4cfd7fa604968627$var$attemptInstallableAppForDefaultInstallMode({
                installableAddon: installableAddon,
                installableAppId: installableAppByKeyId,
                installedAddon: installedAddon,
                installPermission: installPermission,
                marketplaceApp: marketplaceApp,
                mpacBaseUrl: mpacBaseUrl,
                relayState: relayState
            }).map((0, $bWAru.Either).right).getOrElseL(()=>$4cfd7fa604968627$var$attemptInstructionalAppInstallMode({
                    mpacBaseUrl: mpacBaseUrl,
                    marketplaceApp: marketplaceApp
                }));
        }).catch((error)=>(0, $bWAru.Either).left(error)), (installableAppByUrlId)=>(0, $38gnU.retrieveAppDataByUrl)({
            installableAppByUrlId: installableAppByUrlId,
            mpacBaseUrl: mpacBaseUrl
        }).then((_ref8)=>{
            let { installableAddon: installableAddon, installPermission: installPermission, marketplaceApp: marketplaceApp } = _ref8;
            const installedAddonPromise = installableAddon.fold(()=>Promise.resolve((0, $bWAru.Either).left('No installableAddon')), (ia)=>(0, $3DsUo.reflect)((0, $55gtq.default)().getInstalledAddon({
                    contextId: context.id,
                    addon: (0, $ifMZN.toSPIInstallableAddonIdentifier)((0, $ifMZN.makeInstallableAppByKeyIdentifier)({
                        key: (0, $ly50n.makeAppKey)(ia.details.key)
                    }))
                }).then((installedAddonResult)=>$4cfd7fa604968627$export$1ad37f4eb25808e2(installedAddonResult))));
            return installedAddonPromise.then((installedAddon)=>$4cfd7fa604968627$var$attemptInstallableAppForDefaultInstallMode({
                    installableAddon: installableAddon,
                    installPermission: installPermission,
                    installableAppId: installableAppByUrlId,
                    installedAddon: installedAddon,
                    marketplaceApp: marketplaceApp,
                    mpacBaseUrl: mpacBaseUrl,
                    relayState: relayState
                }));
        }).catch((error)=>(0, $bWAru.Either).left(error)), (installableAppByARI)=>$4cfd7fa604968627$var$handleAriDetermineMode(mpacBaseUrl, installableAppByARI, relayState, context, flags));
    return installMode;
};
const $4cfd7fa604968627$export$9280e5c04d16e3df = (_ref9)=>{
    let { mpacBaseUrl: mpacBaseUrl, installableAppId: installableAppId, relayState: relayState, context: context } = _ref9;
    return (dispatch)=>{
        const retrievalId = (0, $hsaiM.getRequestId)();
        const flags = {
            enableReactivateForgeAppFromEmcee: false
        };
        dispatch((0, $dSumc.doSetInstallMode)({
            installMode: (0, $8ZSlI.makeDeterminingInstallMode)({
                retrievalId: retrievalId
            })
        }));
        return $4cfd7fa604968627$export$a9593d7012654efb({
            mpacBaseUrl: mpacBaseUrl,
            installableAppId: installableAppId,
            relayState: relayState,
            context: context,
            flags: flags
        }).then((result)=>result.fold((error)=>{
                console.error("Either the SPI's getInstallableAddon returned an error or invalid shape, or MPAC returned an invalid instructional listing: ", error, "installableAppId=".concat(installableAppId.toString()));
                dispatch($4cfd7fa604968627$var$determiningInstallModeError({
                    error: error,
                    installableAppId: installableAppId,
                    retrievalId: retrievalId
                }));
            }, (installMode)=>{
                dispatch($4cfd7fa604968627$var$finishDeterminingInstallMode({
                    installMode: installMode,
                    retrievalId: retrievalId
                }));
            }));
    };
};

});
parcelRegister("38gnU", function(module, exports) {

$parcel$export(module.exports, "retrieveAppDataByKey", () => $247ed41d36312c16$export$e920efe13d7dfa6f);
$parcel$export(module.exports, "retrieveAppDataByUrl", () => $247ed41d36312c16$export$51b206d744e4540c);
$parcel$export(module.exports, "retrieveAppDataByAri", () => $247ed41d36312c16$export$7e0e388244c7e50d);

var $b9ymN = parcelRequire("b9ymN");
var $ly50n = parcelRequire("ly50n");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $ifMZN = parcelRequire("ifMZN");

var $55gtq = parcelRequire("55gtq");

var $3DsUo = parcelRequire("3DsUo");
const $247ed41d36312c16$var$getAppPermission = (ia)=>(0, $55gtq.default)().hasInstallPermission({
        addon: ia
    }).then((pc)=>({
            installableAddon: ia,
            installPermission: (0, $bWAru.Either).right(pc)
        })).catch((error)=>({
            installableAddon: ia,
            installPermission: (0, $bWAru.Either).left(error)
        }));
const $247ed41d36312c16$export$e920efe13d7dfa6f = function retrieveAppDataByKey(_ref) {
    let { installableAppByKeyId: installableAppByKeyId, mpacBaseUrl: mpacBaseUrl } = _ref;
    let hostCmtEnabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return Promise.all([
        (0, $3DsUo.reflect)((0, $55gtq.default)().getInstallableAddon({
            addon: (0, $ifMZN.toSPIInstallableAddonIdentifier)(installableAppByKeyId),
            hostCmtEnabled: hostCmtEnabled
        }).then($247ed41d36312c16$var$getAppPermission)),
        (0, $b9ymN.getCloudMarketplaceAppByKey)(mpacBaseUrl, installableAppByKeyId.key)
    ]).then((_ref2)=>{
        let [appPermission, marketplaceApp] = _ref2;
        return {
            installableAddon: appPermission.map((a)=>a.installableAddon),
            installPermission: appPermission.flatMap((a)=>a.installPermission),
            marketplaceApp: marketplaceApp
        };
    });
};
const $247ed41d36312c16$export$51b206d744e4540c = (_ref3)=>{
    let { installableAppByUrlId: installableAppByUrlId, mpacBaseUrl: mpacBaseUrl } = _ref3;
    return(// Only succeed in install-by-URL case if the SPI request succeeds
    (0, $55gtq.default)().getInstallableAddon({
        addon: (0, $ifMZN.toSPIInstallableAddonIdentifier)(installableAppByUrlId)
    }).then((installableAddon)=>Promise.all([
            (0, $b9ymN.getCloudMarketplaceAppByKey)(mpacBaseUrl, (0, $ly50n.makeAppKey)(installableAddon.details.key)),
            (0, $3DsUo.reflect)($247ed41d36312c16$var$getAppPermission(installableAddon))
        ]).then((_ref4)=>{
            let [marketplaceApp, appPermission] = _ref4;
            return {
                installableAddon: (0, $bWAru.Either).right(installableAddon),
                installPermission: appPermission.flatMap((a)=>a.installPermission),
                marketplaceApp: marketplaceApp
            };
        })));
};
const $247ed41d36312c16$export$7e0e388244c7e50d = (_ref5)=>{
    let { installableAppByARI: installableAppByARI, mpacBaseUrl: mpacBaseUrl } = _ref5;
    return Promise.all([
        (0, $3DsUo.reflect)((0, $55gtq.default)().getInstallableAddon({
            addon: (0, $ifMZN.toSPIInstallableAddonIdentifier)(installableAppByARI)
        }).then($247ed41d36312c16$var$getAppPermission)),
        (0, $b9ymN.getCloudMarketplaceAppByKey)(mpacBaseUrl, installableAppByARI.appKey)
    ]).then((_ref6)=>{
        let [appPermission, marketplaceApp] = _ref6;
        return {
            installableAddon: appPermission.map((a)=>a.installableAddon),
            installPermission: appPermission.flatMap((a)=>a.installPermission),
            marketplaceApp: marketplaceApp
        };
    });
};

});
parcelRegister("b9ymN", function(module, exports) {

$parcel$export(module.exports, "getCloudMarketplaceAppByKey", () => $81eb317770d0c6db$export$743d5a58cefe3ad5);

var $dO8LH = parcelRequire("dO8LH");

var $gC9Xo = parcelRequire("gC9Xo");
const $81eb317770d0c6db$export$6b17afb8693d5324 = (mpacBaseUrl, appKey)=>(0, $dO8LH.fetchOk)(mpacBaseUrl + "/rest/2/addons/".concat(appKey, "?hosting=cloud&withVersion=true")).then((response)=>response.json());
const $81eb317770d0c6db$export$743d5a58cefe3ad5 = (mpacBaseUrl, appKey)=>$81eb317770d0c6db$export$6b17afb8693d5324(mpacBaseUrl, appKey).then((0, $gC9Xo.makeMarketplaceApp));
const $81eb317770d0c6db$export$cc4d33cccec79e8d = (mpacBaseUrl, appId)=>(0, $dO8LH.fetchOk)("".concat(mpacBaseUrl, "/rest/internal/apps/").concat(appId, "?hosting=cloud&withVersion=true")).then((response)=>response.json());
const $81eb317770d0c6db$export$a8a38c76dcc74dfa = (mpacBaseUrl, appId)=>$81eb317770d0c6db$export$cc4d33cccec79e8d(mpacBaseUrl, appId).then((0, $gC9Xo.makeMarketplaceApp));

});
parcelRegister("gC9Xo", function(module, exports) {

$parcel$export(module.exports, "makeMarketplaceApp", () => $c187eb2c340792d6$export$dcbc6fb843a92543);

var $g5DHJ = parcelRequire("g5DHJ");

var $ly50n = parcelRequire("ly50n");
const $c187eb2c340792d6$export$dcbc6fb843a92543 = (0, $g5DHJ.Record)({
    key: (0, $ly50n.makeAppKey)(''),
    name: '',
    summary: undefined,
    tagLine: undefined,
    _embedded: undefined,
    legacy: undefined,
    vendorLinks: undefined,
    programs: undefined
});

});



parcelRegister("dSumc", function(module, exports) {

$parcel$export(module.exports, "SET_INSTALL_MODE", () => $a1a7ddc509d76041$export$b5bb2352a4aec916);
$parcel$export(module.exports, "CLEAR_INSTALL_MODE", () => $a1a7ddc509d76041$export$c9dec0e8f9ca7d3f);
$parcel$export(module.exports, "clearInstallMode", () => $a1a7ddc509d76041$export$a0216699bd648ff9);
$parcel$export(module.exports, "NO_SIMULTANEOUS_INSTALLS_FLAG_KEY", () => $a1a7ddc509d76041$export$ebe02ffcffaa47d4);
$parcel$export(module.exports, "doSetInstallMode", () => $a1a7ddc509d76041$export$382bf722466a870c);

var $jC5dB = parcelRequire("jC5dB");

var $i7hUf = parcelRequire("i7hUf");

var $9eIgo = parcelRequire("9eIgo");

var $8bwkw = parcelRequire("8bwkw");
const $a1a7ddc509d76041$export$b5bb2352a4aec916 = 'INSTALLATION_SET_INSTALL_MODE';
const $a1a7ddc509d76041$export$c9dec0e8f9ca7d3f = 'INSTALLATION_CLEAR_INSTALL_MODE';
const $a1a7ddc509d76041$var$setInstallMode = (_ref)=>{
    let { installMode: installMode } = _ref;
    return {
        type: $a1a7ddc509d76041$export$b5bb2352a4aec916,
        installMode: installMode
    };
};
const $a1a7ddc509d76041$export$a0216699bd648ff9 = ()=>({
        type: $a1a7ddc509d76041$export$c9dec0e8f9ca7d3f
    });
const $a1a7ddc509d76041$export$ebe02ffcffaa47d4 = 'no-simultaneous-installs-allowed';
const $a1a7ddc509d76041$export$382bf722466a870c = (_ref2)=>{
    let { installMode: installMode } = _ref2;
    return (dispatch, getState)=>{
        getState().installation.installMode.fold(()=>dispatch($a1a7ddc509d76041$var$setInstallMode({
                installMode: installMode
            })), (cim)=>(0, $i7hUf.foldInstallMode)(cim)(()=>true, (appSpecificPasswordInstallMode)=>appSpecificPasswordInstallMode.appSpecificPassword.forAll((asp)=>!(0, $9eIgo.isInstallStatusLoading)(asp.status)), ()=>true, (installableAppDefaultInstallMode)=>!(0, $9eIgo.isInstallStatusLoading)(installableAppDefaultInstallMode.status), (installableAppByManualUrlInstallMode)=>installableAppByManualUrlInstallMode.installableAppByManualUrl.forAll((asp)=>!(0, $9eIgo.isInstallStatusLoading)(asp.status)), (installableAppUpgradeInstallMode)=>!(0, $9eIgo.isInstallStatusLoading)(installableAppUpgradeInstallMode.status)) ? dispatch($a1a7ddc509d76041$var$setInstallMode({
                installMode: installMode
            })) : dispatch((0, $8bwkw.addFlag)({
                flag: (0, $jC5dB.makeFlag)({
                    key: $a1a7ddc509d76041$export$ebe02ffcffaa47d4,
                    appearance: (0, $jC5dB.INFO_APPEARANCE),
                    autoDismiss: true,
                    description: (0, $jC5dB.makeFlagDescription)({
                        primary: 'Another installation is still in progress... Try again when it is complete.'
                    }),
                    title: 'Hold on!'
                })
            })));
    };
};

});
parcelRegister("jC5dB", function(module, exports) {

$parcel$export(module.exports, "SUCCESS_APPEARANCE", () => $e4759d31f3d84bd6$export$d538d4924a0704b3);
$parcel$export(module.exports, "ERROR_APPEARANCE", () => $e4759d31f3d84bd6$export$b25a81054afdd0fc);
$parcel$export(module.exports, "INFO_APPEARANCE", () => $e4759d31f3d84bd6$export$95e25e8307cc43a1);
$parcel$export(module.exports, "foldAppearance", () => $e4759d31f3d84bd6$export$4230c263e63219c5);
$parcel$export(module.exports, "makeFlagAction", () => $e4759d31f3d84bd6$export$2827c8934c10366b);
$parcel$export(module.exports, "makeEmceeFlag", () => $e4759d31f3d84bd6$export$dd4c9a2f2b031e3e);
$parcel$export(module.exports, "makeFlag", () => $e4759d31f3d84bd6$export$115925bcaa88a588);
$parcel$export(module.exports, "makeFlagDescription", () => $e4759d31f3d84bd6$export$89885fb2503e60cf);

var $g5DHJ = parcelRequire("g5DHJ");
const $e4759d31f3d84bd6$export$d538d4924a0704b3 = 'success';
const $e4759d31f3d84bd6$export$b25a81054afdd0fc = 'error';
const $e4759d31f3d84bd6$export$95e25e8307cc43a1 = 'info';
const $e4759d31f3d84bd6$export$8495807f04c3701d = 'warning';
function $e4759d31f3d84bd6$export$4230c263e63219c5(appearance, success, error, info, warning) {
    switch(appearance){
        case $e4759d31f3d84bd6$export$d538d4924a0704b3:
            return success();
        case $e4759d31f3d84bd6$export$b25a81054afdd0fc:
            return error();
        case $e4759d31f3d84bd6$export$95e25e8307cc43a1:
            return info();
        case $e4759d31f3d84bd6$export$8495807f04c3701d:
            return warning();
        default:
            throw new Error("foldAppearance is not comprehensive in Appearance: ".concat(appearance));
    }
}
const $e4759d31f3d84bd6$export$2827c8934c10366b = (0, $g5DHJ.Record)({
    callback: ()=>{
    /* do nothing by default */ },
    displayText: '',
    id: '',
    key: '',
    href: '',
    target: ''
});
const $e4759d31f3d84bd6$var$makeFlagActions = (flag)=>{
    if (!flag.actions) return (0, $g5DHJ.List)([]);
    return (0, $g5DHJ.List)(flag.actions.map((action)=>{
        const flagAction = {
            displayText: action.content
        };
        if (action.href) flagAction.href = action.href;
        if (action.onClick) flagAction.callback = action.onClick;
        if (action.target) flagAction.target = action.target;
        return $e4759d31f3d84bd6$export$2827c8934c10366b(flagAction);
    }));
};
const $e4759d31f3d84bd6$export$dd4c9a2f2b031e3e = (flag)=>{
    return $e4759d31f3d84bd6$export$115925bcaa88a588({
        key: flag.id,
        appearance: flag.type,
        title: flag.title,
        description: {
            primary: flag.description
        },
        autoDismiss: flag.isAutoDismiss,
        actions: $e4759d31f3d84bd6$var$makeFlagActions(flag)
    });
};
const $e4759d31f3d84bd6$export$89885fb2503e60cf = (0, $g5DHJ.Record)({
    primary: '',
    secondary: undefined
});
const $e4759d31f3d84bd6$export$115925bcaa88a588 = (0, $g5DHJ.Record)({
    autoDismiss: true,
    actions: (0, $g5DHJ.List)(),
    appearance: $e4759d31f3d84bd6$export$d538d4924a0704b3,
    description: undefined,
    key: '',
    title: ''
});

});

parcelRegister("8bwkw", function(module, exports) {

$parcel$export(module.exports, "ADD_FLAG", () => $5f586de674c8dc32$export$8db129480af5aa95);
$parcel$export(module.exports, "REMOVE_FLAG", () => $5f586de674c8dc32$export$f49894fce0f25653);
$parcel$export(module.exports, "addFlag", () => $5f586de674c8dc32$export$820a1da46c7a4303);
$parcel$export(module.exports, "addCaasErrorFlag", () => $5f586de674c8dc32$export$652dc350e6304ac0);
$parcel$export(module.exports, "removeFlag", () => $5f586de674c8dc32$export$f2c4075a13a8b485);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $jC5dB = parcelRequire("jC5dB");

var $hsaiM = parcelRequire("hsaiM");
const $5f586de674c8dc32$export$8db129480af5aa95 = 'FLAGS_ADD_FLAG';
const $5f586de674c8dc32$export$f49894fce0f25653 = 'FLAGS_REMOVE_FLAG';
function $5f586de674c8dc32$export$820a1da46c7a4303(options) {
    return {
        type: $5f586de674c8dc32$export$8db129480af5aa95,
        flag: options.flag
    };
}
function $5f586de674c8dc32$export$652dc350e6304ac0(options) {
    var _options$featureFlags;
    const errorDetails = (0, $hsaiM.getErrorDetails)(options.message, options.hostConfig, {
        showCustomBackendErrorsFromUpm: (_options$featureFlags = options.featureFlags) === null || _options$featureFlags === void 0 ? void 0 : _options$featureFlags.showCustomBackendErrorsFromUpm
    });
    const errorTID = errorDetails.tid ? "TID: ".concat(errorDetails.tid, " ") : '';
    const errorType = errorDetails.type ? "Type: ".concat(errorDetails.type) : '';
    const secondaryDescription = errorDetails.translation.showTID ? errorTID + errorType : undefined;
    return $5f586de674c8dc32$export$820a1da46c7a4303({
        flag: (0, $jC5dB.makeFlag)({
            key: options.key,
            title: errorDetails.translation.title,
            description: (0, $jC5dB.makeFlagDescription)({
                primary: errorDetails.translation.description,
                secondary: secondaryDescription
            }),
            actions: (0, $bWAru.Option).of(options.actions).getOrElse((0, $g5DHJ.List)()),
            appearance: (0, $jC5dB.ERROR_APPEARANCE)
        })
    });
}
function $5f586de674c8dc32$export$f2c4075a13a8b485(key) {
    return {
        type: $5f586de674c8dc32$export$f49894fce0f25653,
        key: key
    };
}

});





parcelRegister("kNokf", function(module, exports) {

$parcel$export(module.exports, "useCurrentUser", () => $f23b40c72d560532$export$3901076af3749fa9);

var $eUqFw = parcelRequire("eUqFw");

var $55gtq = parcelRequire("55gtq");
const $f23b40c72d560532$export$3901076af3749fa9 = ()=>{
    const [currentUser, setCurrentUser] = (0, $eUqFw.useState)(null);
    (0, $eUqFw.useEffect)(()=>{
        async function fetchCurrentUser() {
            const currentUserResponse = await (0, $55gtq.default)().getCurrentUser();
            setCurrentUser(currentUserResponse);
        }
        fetchCurrentUser();
    }, []);
    return currentUser;
};

});

parcelRegister("2bHSm", function(module, exports) {

$parcel$export(module.exports, "useHostData", () => $197ea4af1fc468eb$export$5fa3181982e114cc);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $55gtq = parcelRequire("55gtq");

var $jKojs = parcelRequire("jKojs");
function $197ea4af1fc468eb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $197ea4af1fc468eb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $197ea4af1fc468eb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $197ea4af1fc468eb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $197ea4af1fc468eb$export$5fa3181982e114cc = ()=>{
    const [hostBaseData, setHostBaseData] = (0, $eUqFw.useState)({
        hostInfo: null,
        hostConfig: null
    });
    (0, $eUqFw.useEffect)(()=>{
        async function fetchHostInfo() {
            const hostInfo = await (0, $55gtq.default)().getHostInfo();
            setHostBaseData({
                hostInfo: hostInfo,
                hostConfig: (0, $jKojs.getHostConfig)(hostInfo.product)
            });
        }
        fetchHostInfo();
    }, []);
    return $197ea4af1fc468eb$var$_objectSpread({}, hostBaseData);
};

});


parcelRegister("9n12n", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d27110e3ddf1d2e$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $kU09D = parcelRequire("kU09D");

var $f2QOW = parcelRequire("f2QOW");

var $9e16A = parcelRequire("9e16A");

var $iyohm = parcelRequire("iyohm");

var $beqRW = parcelRequire("beqRW");

var $ighTk = parcelRequire("ighTk");
var $1S6Gv = parcelRequire("1S6Gv");

var $eUqFw = parcelRequire("eUqFw");

var $iUPNF = parcelRequire("iUPNF");

var $7YbkQ = parcelRequire("7YbkQ");

var $5JCOp = parcelRequire("5JCOp");

var $55gtq = parcelRequire("55gtq");

var $kNokf = parcelRequire("kNokf");

var $2bHSm = parcelRequire("2bHSm");

var $iEdQ1 = parcelRequire("iEdQ1");

var $7opvN = parcelRequire("7opvN");

var $gkhxl = parcelRequire("gkhxl");

var $la8zm = parcelRequire("la8zm");

var $5rzWv = parcelRequire("5rzWv");
function $6d27110e3ddf1d2e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6d27110e3ddf1d2e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6d27110e3ddf1d2e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6d27110e3ddf1d2e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6d27110e3ddf1d2e$export$27e646996cbebe98(props) {
    (0, $eUqFw.useMemo)(()=>(0, $55gtq.initSPI)(props.spi), [
        props.spi
    ]);
    const { hostInfo: hostInfo, hostConfig: hostConfig } = (0, $2bHSm.useHostData)();
    const currentUser = (0, $kNokf.useCurrentUser)();
    const appRequestBaseData = (0, $5rzWv.useAppRequestBaseData)(props.config, hostInfo, currentUser, props.appKey);
    const appDetailsFromSearchResponse = (0, $9e16A.useGetAppDetailsFromSearch)({
        appKey: props.appKey,
        algoliaConfig: props.config.algoliaConfig
    });
    const { fireEvent: fireEvent, analyticsContext: analyticsContext } = (0, $la8zm.useAppRequestAnalytics)({
        baseData: appRequestBaseData,
        requestLocation: props.requestLocation
    });
    const links = (0, $iEdQ1.useLinkTemplates)({
        adminHubBaseUrl: props.config.adminHubBaseUrl,
        mpacBaseUrl: props.config.mpacBaseUrl,
        mpacCdnBaseUrl: props.config.mpacCdnBaseUrl,
        macBaseUrl: props.config.macBaseUrl,
        wacBaseUrl: props.config.wacBaseUrl,
        atlassianCommunityBaseUrl: props.config.atlassianCommunityBaseUrl
    });
    (0, $eUqFw.useEffect)(()=>{
        if (hostInfo && currentUser !== null && currentUser !== void 0 && currentUser.atlassianAccountId) {
            (0, $7YbkQ.default).init(props.config, hostConfig, hostInfo);
            (0, $5JCOp.initializeBackends)(hostInfo, (0, $iyohm.makeUserId)(currentUser.atlassianAccountId));
        }
    }, [
        hostInfo,
        currentUser
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f2QOW.default), analyticsContext, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opvN.default), (0, $kU09D.default)({}, props, {
        hostInfo: hostInfo,
        hostConfig: hostConfig,
        links: links,
        currentUser: currentUser,
        appRequestBaseData: appRequestBaseData,
        appDetailsFromSearchResponse: appDetailsFromSearchResponse,
        fireEvent: fireEvent
    })));
}
function $6d27110e3ddf1d2e$export$2e2bcd8739ae039(props) {
    var _getSentryClient;
    const appConfig = props.config;
    const sentryConfig = appConfig.sentryConfig;
    const isDev = appConfig.environment === 'local' || appConfig.environment === 'dev';
    const releaseVersion = "EMCEE_NATIVE_".concat((0, $iUPNF.default)).concat(isDev ? '-dev' : '');
    (0, $1S6Gv.initSentry)($6d27110e3ddf1d2e$var$_objectSpread($6d27110e3ddf1d2e$var$_objectSpread({}, sentryConfig), {}, {
        releaseVersion: releaseVersion,
        setupGlobalListeners: false
    }));
    (_getSentryClient = (0, $ighTk.default)()) === null || _getSentryClient === void 0 || _getSentryClient.setTag('requestLocation', props.requestLocation);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $beqRW.default), {
        boundaryName: "marketplaceAppRequestDialog",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gkhxl.AppRequestDialogModalError), {
            onClose: props.onClose
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6d27110e3ddf1d2e$export$27e646996cbebe98, props));
}

});
parcelRegister("7opvN", function(module, exports) {

$parcel$export(module.exports, "default", () => $561e906580fef01f$export$2e2bcd8739ae039);

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $kU8RF = parcelRequire("kU8RF");

var $eUqFw = parcelRequire("eUqFw");

var $5kxcx = parcelRequire("5kxcx");

var $7Q8wd = parcelRequire("7Q8wd");

var $5OHDR = parcelRequire("5OHDR");

var $fh2YX = parcelRequire("fh2YX");

var $ce0TX = parcelRequire("ce0TX");

var $B8Ddx = parcelRequire("B8Ddx");

var $5ZqYC = parcelRequire("5ZqYC");

var $2iapx = parcelRequire("2iapx");

var $3ySzw = parcelRequire("3ySzw");
const $561e906580fef01f$export$3e30ede4df572a0e = (props)=>{
    const dialogType = (0, $5OHDR.getDialogState)(props.appRequestBaseData);
    switch(dialogType){
        case (0, $7Q8wd.DialogState).REQUESTABLE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ySzw.AppRequestDialogModalRequestable), {
                onClose: props.onClose,
                appKey: props.appKey,
                appName: props.appRequestBaseData.result.appDetails.name,
                flags: props.flags,
                onRequestSuccess: props.onRequestSuccess,
                onRequestFailure: props.onRequestFailure,
                hostInfo: (0, $5kxcx.makeHostInfo)(props.hostInfo),
                fireEvent: props.fireEvent,
                links: props.links
            }));
        case (0, $7Q8wd.DialogState).LOADING:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kU8RF.default), {
                active: true,
                delay: 200,
                size: 50
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null));
        case (0, $7Q8wd.DialogState).INSTALLED:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $B8Ddx.AppRequestDialogModalInstalled), null);
        case (0, $7Q8wd.DialogState).REJECTED:
            {
                var _result$appRequestSta;
                const { result: result } = props.appRequestBaseData;
                const rejectComment = (_result$appRequestSta = result.appRequestStatus) === null || _result$appRequestSta === void 0 ? void 0 : _result$appRequestSta.rejectComment;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ZqYC.AppRequestDialogModalRejected), {
                    rejectComment: rejectComment
                });
            }
        case (0, $7Q8wd.DialogState).REQUESTED:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2iapx.AppRequestDialogModalRequested), null);
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, "Error");
    }
};
function $561e906580fef01f$export$2e2bcd8739ae039(props) {
    (0, $eUqFw.useEffect)(()=>{
        props.fireEvent.viewedAppRequestModalScreen();
    }, []);
    const dialogType = (0, $5OHDR.getDialogState)(props.appRequestBaseData);
    const modalTitle = dialogType === (0, $7Q8wd.DialogState).LOADING ? 'Loading...' : 'Request App';
    const showAppRequestDialogFooter = dialogType === (0, $7Q8wd.DialogState).INSTALLED || dialogType === (0, $7Q8wd.DialogState).REJECTED || dialogType === (0, $7Q8wd.DialogState).REQUESTED;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        width: "large",
        onClose: props.onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, modalTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ce0TX.default), {
        baseDataResult: props.appRequestBaseData.result,
        appDetailsFromSearchResponse: props.appDetailsFromSearchResponse,
        links: props.links,
        config: props.config,
        appKey: props.appKey,
        dialogType: dialogType
    }), $561e906580fef01f$export$3e30ede4df572a0e(props), showAppRequestDialogFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fh2YX.AppRequestDialogFooter), {
        onClose: props.onClose,
        links: props.links,
        appKey: props.appKey
    }))));
}

});
parcelRegister("5kxcx", function(module, exports) {

$parcel$export(module.exports, "makeHostInfo", () => $3e1893108a7b2930$export$9ef95f2bba3e6c4d);

var $5zQU9 = parcelRequire("5zQU9");
function $3e1893108a7b2930$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3e1893108a7b2930$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3e1893108a7b2930$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3e1893108a7b2930$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $3e1893108a7b2930$export$108ec03634d71252 = (supports)=>$3e1893108a7b2930$var$_objectSpread({
        context: false,
        accessToken: false,
        enabled: false
    }, supports);
const $3e1893108a7b2930$export$2d2e2a019c76af3 = (context)=>$3e1893108a7b2930$var$_objectSpread({
        id: '',
        orgId: '',
        workspaceAri: ''
    }, context);
const $3e1893108a7b2930$export$9ef95f2bba3e6c4d = (hostInfo)=>$3e1893108a7b2930$var$_objectSpread($3e1893108a7b2930$var$_objectSpread($3e1893108a7b2930$var$_objectSpread({
        product: '',
        baseUrl: ''
    }, hostInfo), hostInfo.supports && {
        supports: $3e1893108a7b2930$export$108ec03634d71252(hostInfo.supports)
    }), hostInfo.globalContext && {
        globalContext: $3e1893108a7b2930$export$2d2e2a019c76af3(hostInfo.globalContext)
    });
const $3e1893108a7b2930$export$48a2a4b4b9048dc5 = (spiContext)=>$3e1893108a7b2930$export$2d2e2a019c76af3({
        id: spiContext.id,
        icon: spiContext.icon,
        name: spiContext.name,
        type: spiContext.type,
        orgId: spiContext.orgId,
        workspaceAri: spiContext.workspaceAri
    });

});

parcelRegister("7Q8wd", function(module, exports) {

$parcel$export(module.exports, "DialogState", () => $5b53ff56a3e61415$export$7eb25b1263d43612);
const $5b53ff56a3e61415$export$7eb25b1263d43612 = Object.freeze({
    LOADING: 'LOADING',
    INSTALLED: 'INSTALLED',
    REQUESTED: 'REQUESTED',
    REJECTED: 'REJECTED',
    REQUESTABLE: 'REQUESTABLE',
    ERROR: 'ERROR'
});

});

parcelRegister("5OHDR", function(module, exports) {

$parcel$export(module.exports, "getDialogState", () => $43c3799eda5af136$export$d6b7ed941e5e5b8a);

var $cuo8k = parcelRequire("cuo8k");

var $7Q8wd = parcelRequire("7Q8wd");
function $43c3799eda5af136$export$d6b7ed941e5e5b8a(appRequestBaseData) {
    var _result$appRequestSta, _result$appRequestSta2;
    const { pending: pending, result: result } = appRequestBaseData;
    if (pending) return (0, $7Q8wd.DialogState).LOADING;
    else if (result.appInstallStatus.installationId) return (0, $7Q8wd.DialogState).INSTALLED;
    else if (((_result$appRequestSta = result.appRequestStatus) === null || _result$appRequestSta === void 0 ? void 0 : _result$appRequestSta.status) === (0, $cuo8k.RequestStatus).REJECTED) return (0, $7Q8wd.DialogState).REJECTED;
    else if (((_result$appRequestSta2 = result.appRequestStatus) === null || _result$appRequestSta2 === void 0 ? void 0 : _result$appRequestSta2.status) === (0, $cuo8k.RequestStatus).OPEN) return (0, $7Q8wd.DialogState).REQUESTED;
    else if (!result.appRequestStatus && result.appInstallStatus.status === 'NOT_FOUND') return (0, $7Q8wd.DialogState).REQUESTABLE;
    return (0, $7Q8wd.DialogState).ERROR;
}

});
parcelRegister("cuo8k", function(module, exports) {

$parcel$export(module.exports, "RequestStatus", () => $917b01c0f922e64b$export$600e7c1f9e0414e1);
const $917b01c0f922e64b$export$600e7c1f9e0414e1 = Object.freeze({
    OPEN: 'OPEN',
    REJECTED: 'REJECTED',
    INSTALLED: 'INSTALLED'
});

});


parcelRegister("fh2YX", function(module, exports) {

$parcel$export(module.exports, "AppRequestDialogFooter", () => $b1eac1c48e332286$export$2f5209dfce17657a);

var $9oiuL = parcelRequire("9oiuL");

var $gykb8 = parcelRequire("gykb8");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $1rGPx = parcelRequire("1rGPx");
const $b1eac1c48e332286$export$2f5209dfce17657a = (props)=>{
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const handleViewAppDetailsClick = ()=>{
        fireAnalyticsEvent({
            eventType: (0, $gaiog.LinkClickedEvent),
            actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_VIEW_APP_DETAILS),
            objectType: (0, $7Uh51.ANALYTICS_OBJECT_TYPE_APP_LISTING),
            objectId: props.appKey
        });
        window.open(props.links.appDetails.expand({
            appKey: props.appKey
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1rGPx.FooterContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gykb8.default), {
        onClick: handleViewAppDetailsClick
    }, "View app details"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9oiuL.default), {
        appearance: "primary",
        onClick: props.onClose
    }, "Got it"));
};

});
parcelRegister("1rGPx", function(module, exports) {

$parcel$export(module.exports, "AppRequestStatus", () => $10d98948c4564a59$export$bcc6ea89bba34380);
$parcel$export(module.exports, "AppRequestModalBodyWrapper", () => $10d98948c4564a59$export$738ff1d76774c610);
$parcel$export(module.exports, "AppRequestModalBodyImage", () => $10d98948c4564a59$export$da641d623bce8f5b);
$parcel$export(module.exports, "AppRequestCloseButtonWrapper", () => $10d98948c4564a59$export$fe24fdf11e82dd72);
$parcel$export(module.exports, "AppRequestStatusContent", () => $10d98948c4564a59$export$2e2a56d3fc95aae8);
$parcel$export(module.exports, "FooterContainer", () => $10d98948c4564a59$export$651095642c93be3d);
$parcel$export(module.exports, "RequestableFooterContainer", () => $10d98948c4564a59$export$c1b9dfa185223546);
$parcel$export(module.exports, "RequestableFooterRightContainer", () => $10d98948c4564a59$export$f6a57766fbf42784);

var $3UXZ8 = parcelRequire("3UXZ8");

var $62cXe = parcelRequire("62cXe");

var $8gcXz = parcelRequire("8gcXz");
function $10d98948c4564a59$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $10d98948c4564a59$export$bcc6ea89bba34380 = (0, $3UXZ8.default)("h1", {
    target: "e1asaowm0",
    label: "AppRequestStatus"
})((0, $8gcXz.baseHeadingsCss), " font-size:20px;line-height:", (0, $62cXe.headingSizes).h100.lineHeight / (0, $62cXe.headingSizes).h100.size, ";margin:0 0 15px;");
const $10d98948c4564a59$export$738ff1d76774c610 = (0, $3UXZ8.default)("div", {
    target: "e1asaowm1",
    label: "AppRequestModalBodyWrapper"
})({
    name: "1ioqdc2",
    styles: "max-width:650px;margin:auto;display:flex;flex-direction:column;align-items:center;"
});
const $10d98948c4564a59$export$da641d623bce8f5b = (0, $3UXZ8.default)("img", {
    target: "e1asaowm2",
    label: "AppRequestModalBodyImage"
})({
    name: "1jydukm",
    styles: "margin:auto;margin-top:var(--ds-space-300, 24px);margin-bottom:30px;width:236px;height:212px;"
});
const $10d98948c4564a59$export$fe24fdf11e82dd72 = (0, $3UXZ8.default)("div", {
    target: "e1asaowm3",
    label: "AppRequestCloseButtonWrapper"
})({
    name: "odpfs2",
    styles: "display:flex;margin:15px;flex-direction:column;align-items:center;justify-content:center;"
});
const $10d98948c4564a59$export$2e2a56d3fc95aae8 = (0, $3UXZ8.default)("span", {
    target: "e1asaowm4",
    label: "AppRequestStatusContent"
})({
    name: "1trmeks",
    styles: "display:table-cell;vertical-align:middle;text-align:center;max-width:350px;"
});
const $10d98948c4564a59$export$651095642c93be3d = (0, $3UXZ8.default)("div", {
    target: "e1asaowm5",
    label: "FooterContainer"
})({
    name: "1wx3ipz",
    styles: "display:flex;padding:25px 0px;justify-content:space-between;"
});
const $10d98948c4564a59$export$c1b9dfa185223546 = (0, $3UXZ8.default)("div", {
    target: "e1asaowm6",
    label: "RequestableFooterContainer"
})({
    name: "1wx3ipz",
    styles: "display:flex;padding:25px 0px;justify-content:space-between;"
});
const $10d98948c4564a59$export$f6a57766fbf42784 = (0, $3UXZ8.default)("div", {
    target: "e1asaowm7",
    label: "RequestableFooterRightContainer"
})({
    name: "1tkdocb",
    styles: "display:flex:justify-content:space-between;"
});

});


parcelRegister("ce0TX", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e677ddc69aa040b$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $ly50n = parcelRequire("ly50n");

var $8dnmP = parcelRequire("8dnmP");

var $ammkg = parcelRequire("ammkg");

var $aosfp = parcelRequire("aosfp");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $eUqFw = parcelRequire("eUqFw");

var $abBcx = parcelRequire("abBcx");

var $7Q8wd = parcelRequire("7Q8wd");

var $j4jdu = parcelRequire("j4jdu");
function $8e677ddc69aa040b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8e677ddc69aa040b$var$AppDialogPricingStyled = /*#__PURE__*/ (0, $3UXZ8.default)((0, $abBcx.default), {
    target: "e17lqsz00",
    label: "AppDialogPricingStyled"
})({
    name: "1wgjut3",
    styles: "margin-bottom:10px;margin-top:33px;"
});
const $8e677ddc69aa040b$var$ContentWrapper = (0, $3UXZ8.default)("div", {
    target: "e17lqsz01",
    label: "ContentWrapper"
})({
    name: "xi606m",
    styles: "text-align:center;"
});
function $8e677ddc69aa040b$export$2e2bcd8739ae039(props) {
    const paymentModelOption = ()=>{
        var _props$baseDataResult, _props$baseDataResult2, _props$baseDataResult3;
        const paymentModel = (_props$baseDataResult = props.baseDataResult.appDetails.versions.edges) === null || _props$baseDataResult === void 0 ? void 0 : (_props$baseDataResult2 = _props$baseDataResult[0]) === null || _props$baseDataResult2 === void 0 ? void 0 : (_props$baseDataResult3 = _props$baseDataResult2.node) === null || _props$baseDataResult3 === void 0 ? void 0 : _props$baseDataResult3.paymentModel;
        return (0, $bWAru.Option).of(paymentModel).map((mpm)=>(0, $j4jdu.foldMarketplaceAppPaymentModel)(mpm)(()=>'free', ()=>'atlassian', ()=>'vendor'));
    };
    const getPrograms = ()=>(0, $8dnmP.makePrograms)(props.baseDataResult.appDetails.programs);
    const isAppCloudFortified = ()=>{
        var _props$baseDataResult4, _props$baseDataResult5;
        return ((_props$baseDataResult4 = props.baseDataResult.appDetails.programs) === null || _props$baseDataResult4 === void 0 ? void 0 : (_props$baseDataResult5 = _props$baseDataResult4.cloudFortified) === null || _props$baseDataResult5 === void 0 ? void 0 : _props$baseDataResult5.programStatus) === (0, $ammkg.MarketplaceProgramStatus).Approved;
    };
    return props.dialogType !== (0, $7Q8wd.DialogState).LOADING ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aosfp.default), {
        appHeaderDetails: (0, $j4jdu.makeRequestAppHeaderProps)(props.baseDataResult.appDetails, props.appDetailsFromSearchResponse, props.links.partnerDetails),
        headerInjection: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8e677ddc69aa040b$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8e677ddc69aa040b$var$AppDialogPricingStyled, {
            hostPricing: {
                pending: false,
                result: props.baseDataResult.hostPricing,
                error: null
            },
            appKey: (0, $ly50n.makeAppKey)(props.appKey),
            links: props.links,
            hideTryFreeHeading: true,
            installedApp: (0, $bWAru.Option).none(),
            paymentModel: paymentModelOption().getOrElse(undefined),
            mpacBaseUrl: props.config.mpacBaseUrl,
            eligibleForFreeOnSandbox: false
        })),
        appRatingLink: props.links.appRating,
        appIconLink: props.links.appIcon,
        isAppCloudFortified: isAppCloudFortified(),
        bugBountyParticipant: getPrograms().bugBountyParticipant,
        showInstallationCount: true,
        appIconSize: "small"
    }) : null;
}

});
parcelRegister("8dnmP", function(module, exports) {

$parcel$export(module.exports, "makePartner", () => $5fb1a9e12f28a6fb$export$4e86cdb9bfb37e34);
$parcel$export(module.exports, "makePrograms", () => $5fb1a9e12f28a6fb$export$75c05eeb38ce87e7);
$parcel$export(module.exports, "makeReviewSummary", () => $5fb1a9e12f28a6fb$export$b903bb79739c9fdc);
$parcel$export(module.exports, "makeDistribution", () => $5fb1a9e12f28a6fb$export$37b9fd23ea152d25);
$parcel$export(module.exports, "default", () => $5fb1a9e12f28a6fb$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $kafab = parcelRequire("kafab");
var $7ZOJD = parcelRequire("7ZOJD");

var $ammkg = parcelRequire("ammkg");

var $ebXHa = parcelRequire("ebXHa");

var $h6uOD = parcelRequire("h6uOD");
function $5fb1a9e12f28a6fb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5fb1a9e12f28a6fb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5fb1a9e12f28a6fb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5fb1a9e12f28a6fb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $5fb1a9e12f28a6fb$var$makeWatcherInfo = (info)=>{
    var _info$isUserWatchingA, _info$watchersCount;
    return {
        isUserWatchingApp: (_info$isUserWatchingA = info === null || info === void 0 ? void 0 : info.isUserWatchingApp) !== null && _info$isUserWatchingA !== void 0 ? _info$isUserWatchingA : false,
        watchersCount: (_info$watchersCount = info === null || info === void 0 ? void 0 : info.watchersCount) !== null && _info$watchersCount !== void 0 ? _info$watchersCount : 0
    };
};
function $5fb1a9e12f28a6fb$export$39ae7d355c29b45f(highlight, makeImageLink) {
    const { croppedScreenshot: croppedScreenshot, title: title, summary: summary, screenshot: screenshot } = highlight;
    const croppedImage = croppedScreenshot.highResolution || croppedScreenshot.original;
    const image = screenshot.image.highResolution || screenshot.image.original;
    const caption = highlight.caption || screenshot.caption;
    return {
        title: title,
        caption: caption,
        summary: summary,
        croppedImage: {
            width: croppedImage.width,
            height: croppedImage.height,
            url: makeImageLink(croppedImage.id)
        },
        image: {
            width: image.width,
            height: image.height,
            url: makeImageLink(image.id)
        }
    };
}
function $5fb1a9e12f28a6fb$export$a8937c5bf2e03fcb(screenshot, makeImageLink) {
    const { caption: caption, image: image } = screenshot;
    const { id: id, width: width, height: height } = image.original;
    return {
        caption: caption,
        image: {
            url: makeImageLink(id),
            width: width,
            height: height
        }
    };
}
const $5fb1a9e12f28a6fb$var$makeHeroImage = (heroImage, makeImageLink)=>{
    const image = (heroImage === null || heroImage === void 0 ? void 0 : heroImage.highResolution) || (heroImage === null || heroImage === void 0 ? void 0 : heroImage.original);
    if (!image) return null;
    return {
        width: image.width,
        height: image.height,
        url: makeImageLink(image.id)
    };
};
const $5fb1a9e12f28a6fb$export$4e86cdb9bfb37e34 = (partner, detailsLink, makeImageLink)=>{
    var _partner$programs, _partner$support, _partner$support$cont, _partner$partnerTier;
    let logo;
    if (partner !== null && partner !== void 0 && partner.logo) {
        var _partner$logo$highRes;
        const highResImageUrl = (_partner$logo$highRes = partner.logo.highResolution) === null || _partner$logo$highRes === void 0 ? void 0 : _partner$logo$highRes.imageUrl;
        const originalImageUrl = partner.logo.original.imageUrl;
        if (highResImageUrl || originalImageUrl) logo = highResImageUrl || originalImageUrl;
        else if (makeImageLink) {
            var _partner$logo$highRes2;
            const highResImageId = (_partner$logo$highRes2 = partner.logo.highResolution) === null || _partner$logo$highRes2 === void 0 ? void 0 : _partner$logo$highRes2.id;
            const originalImageId = partner.logo.original.id;
            logo = makeImageLink(highResImageId || originalImageId);
        }
    } else logo = null;
    return {
        id: partner === null || partner === void 0 ? void 0 : partner.id,
        name: partner === null || partner === void 0 ? void 0 : partner.name,
        url: partner ? detailsLink.expand({
            id: partner.id,
            slug: partner.slug
        }) : null,
        programs: {
            isCloudAppSecuritySelfAssessmentDone: (partner === null || partner === void 0 ? void 0 : (_partner$programs = partner.programs) === null || _partner$programs === void 0 ? void 0 : _partner$programs.isCloudAppSecuritySelfAssessmentDone) || false
        },
        support: {
            url: partner === null || partner === void 0 ? void 0 : (_partner$support = partner.support) === null || _partner$support === void 0 ? void 0 : (_partner$support$cont = _partner$support.contactDetails) === null || _partner$support$cont === void 0 ? void 0 : _partner$support$cont.websiteUrl
        },
        partnerType: partner === null || partner === void 0 ? void 0 : partner.partnerType,
        partnerTierType: partner === null || partner === void 0 ? void 0 : (_partner$partnerTier = partner.partnerTier) === null || _partner$partnerTier === void 0 ? void 0 : _partner$partnerTier.type,
        logo: logo
    };
};
const $5fb1a9e12f28a6fb$export$75c05eeb38ce87e7 = (programs)=>{
    var _programs$cloudFortif, _programs$bugBountyPa, _programs$bugBountyPa2, _programs$bugBountyPa3, _programs$bugBountyPa4, _programs$bugBountyPa5, _programs$bugBountyPa6;
    return {
        cloudFortified: {
            isStatusApproved: (programs === null || programs === void 0 ? void 0 : (_programs$cloudFortif = programs.cloudFortified) === null || _programs$cloudFortif === void 0 ? void 0 : _programs$cloudFortif.programStatus) === (0, $ammkg.MarketplaceProgramStatus).Approved
        },
        bugBountyParticipant: {
            cloud: {
                status: programs === null || programs === void 0 ? void 0 : (_programs$bugBountyPa = programs.bugBountyParticipant) === null || _programs$bugBountyPa === void 0 ? void 0 : (_programs$bugBountyPa2 = _programs$bugBountyPa.cloud) === null || _programs$bugBountyPa2 === void 0 ? void 0 : _programs$bugBountyPa2.status
            },
            server: {
                status: programs === null || programs === void 0 ? void 0 : (_programs$bugBountyPa3 = programs.bugBountyParticipant) === null || _programs$bugBountyPa3 === void 0 ? void 0 : (_programs$bugBountyPa4 = _programs$bugBountyPa3.server) === null || _programs$bugBountyPa4 === void 0 ? void 0 : _programs$bugBountyPa4.status
            },
            dataCenter: {
                status: programs === null || programs === void 0 ? void 0 : (_programs$bugBountyPa5 = programs.bugBountyParticipant) === null || _programs$bugBountyPa5 === void 0 ? void 0 : (_programs$bugBountyPa6 = _programs$bugBountyPa5.dataCenter) === null || _programs$bugBountyPa6 === void 0 ? void 0 : _programs$bugBountyPa6.status
            }
        }
    };
};
const $5fb1a9e12f28a6fb$export$b903bb79739c9fdc = (summary)=>{
    var _summary$count, _summary$rating;
    return {
        count: (_summary$count = summary === null || summary === void 0 ? void 0 : summary.count) !== null && _summary$count !== void 0 ? _summary$count : 0,
        rating: (_summary$rating = summary === null || summary === void 0 ? void 0 : summary.rating) !== null && _summary$rating !== void 0 ? _summary$rating : 0
    };
};
const $5fb1a9e12f28a6fb$export$e36a0bc69d7dae53 = (_ref)=>{
    var _partner$support2, _partner$support2$con, _partner$support3, _partner$support3$con, _partner$support4, _partner$support4$con, _partner$support5;
    let { selectedAppVersion: selectedAppVersion, appDetails: appDetails } = _ref;
    const { wikiUrl: wikiUrl, forumsUrl: forumsUrl, partner: partner, issueTrackerUrl: issueTrackerUrl, supportTicketSystemUrl: supportTicketSystemUrl, statusPageUrl: statusPageUrl } = appDetails;
    const { documentationUrl: documentationUrl } = selectedAppVersion || {};
    const resources = {
        documentationUrl: documentationUrl,
        wikiUrl: wikiUrl,
        forumsUrl: forumsUrl
    };
    const isSupported = (selectedAppVersion === null || selectedAppVersion === void 0 ? void 0 : selectedAppVersion.isSupported) === true;
    return {
        isSupported: isSupported,
        isAtlassianCommunityEnabled: appDetails.isAtlassianCommunityEnabled || !isSupported,
        hasResources: Object.values(resources).some((url)=>!!url),
        resources: resources,
        contact: {
            emailId: partner === null || partner === void 0 ? void 0 : (_partner$support2 = partner.support) === null || _partner$support2 === void 0 ? void 0 : (_partner$support2$con = _partner$support2.contactDetails) === null || _partner$support2$con === void 0 ? void 0 : _partner$support2$con.emailId,
            websiteUrl: partner === null || partner === void 0 ? void 0 : (_partner$support3 = partner.support) === null || _partner$support3 === void 0 ? void 0 : (_partner$support3$con = _partner$support3.contactDetails) === null || _partner$support3$con === void 0 ? void 0 : _partner$support3$con.websiteUrl,
            phoneNumber: partner === null || partner === void 0 ? void 0 : (_partner$support4 = partner.support) === null || _partner$support4 === void 0 ? void 0 : (_partner$support4$con = _partner$support4.contactDetails) === null || _partner$support4$con === void 0 ? void 0 : _partner$support4$con.phoneNumber,
            issueTrackerUrl: // support requests
            issueTrackerUrl,
            supportTicketSystemUrl: supportTicketSystemUrl,
            statusPageUrl: statusPageUrl
        },
        availability: partner === null || partner === void 0 ? void 0 : (_partner$support5 = partner.support) === null || _partner$support5 === void 0 ? void 0 : _partner$support5.availability,
        partner: {
            name: partner === null || partner === void 0 ? void 0 : partner.name
        }
    };
};
const $5fb1a9e12f28a6fb$export$8fb9fc03d975b4ef = (deployment, hosting)=>{
    if (!deployment) return false;
    const cloudPreinstalled = hosting === (0, $ammkg.AtlassianProductHostingType).Cloud && deployment.__typename === (0, $kafab.AppDeployment).PLUGINS2;
    if (deployment.__typename === (0, $kafab.AppDeployment).INSTRUCTIONAL) return deployment.isBinaryUrlAvailable;
    else if (deployment.__typename === (0, $kafab.AppDeployment).WORKFLOW) return deployment.isWorkflowDataFileAvailable;
    else return !(0, $ebXHa).isRemoteable(deployment) && !cloudPreinstalled;
};
const $5fb1a9e12f28a6fb$var$makeInstallationInstructions = (_ref2)=>{
    var _selectedAppVersion$d;
    let { selectedAppVersion: selectedAppVersion, makeMediaImage: makeMediaImage } = _ref2;
    if (selectedAppVersion && selectedAppVersion.deployment.__typename === (0, $kafab.AppDeployment).INSTRUCTIONAL && (_selectedAppVersion$d = selectedAppVersion.deployment.instructions) !== null && _selectedAppVersion$d !== void 0 && _selectedAppVersion$d.length) {
        const { instructions: instructions } = selectedAppVersion.deployment;
        return instructions.map((_ref3)=>{
            var _screenshot$highResol;
            let { instruction: instruction, screenshot: screenshot } = _ref3;
            const screenshotImage = (_screenshot$highResol = screenshot === null || screenshot === void 0 ? void 0 : screenshot.highResolution) !== null && _screenshot$highResol !== void 0 ? _screenshot$highResol : screenshot === null || screenshot === void 0 ? void 0 : screenshot.original;
            return {
                instruction: instruction,
                screenshot: screenshotImage !== null && screenshotImage !== void 0 && screenshotImage.id ? {
                    url: makeMediaImage(screenshotImage.id),
                    width: screenshotImage.width,
                    height: screenshotImage.height
                } : null
            };
        });
    }
    return [];
};
const $5fb1a9e12f28a6fb$var$makeResourceLinks = (_ref4)=>{
    let { appDetails: appDetails, latestVersion: latestVersion, appVersionHistoryLink: appVersionHistoryLink, artifactDownloadLink: artifactDownloadLink, descriptorDownloadLink: descriptorDownloadLink, hosting: hosting } = _ref4;
    const { appId: appId, slug: slug } = appDetails;
    const { deployment: deployment, buildNumber: buildNumber, endUserLicenseAgreementUrl: endUserLicenseAgreementUrl, learnMoreUrl: learnMoreUrl, documentationUrl: documentationUrl, purchaseUrl: purchaseUrl } = latestVersion || {};
    return {
        endUserLicenseAgreementUrl: endUserLicenseAgreementUrl,
        learnMoreUrl: learnMoreUrl,
        documentationUrl: documentationUrl,
        purchaseUrl: purchaseUrl,
        versionHistoryUrl: appVersionHistoryLink.expand({
            appId: appId,
            appSlug: slug,
            hosting: (0, $7ZOJD.HostingTypeToFiltersQueryParam)[hosting]
        }),
        artifactDownloadUrl: $5fb1a9e12f28a6fb$export$8fb9fc03d975b4ef(deployment, hosting) ? artifactDownloadLink.expand({
            appId: appId,
            buildNumber: buildNumber
        }) : undefined,
        descriptorDownloadUrl: (deployment === null || deployment === void 0 ? void 0 : deployment.__typename) === (0, $kafab.AppDeployment).CONNECT ? descriptorDownloadLink.expand({
            appId: appId,
            buildNumber: buildNumber
        }) : undefined
    };
};
const $5fb1a9e12f28a6fb$var$makeAppScopes = (latestVersion)=>{
    if (latestVersion && latestVersion.deployment && (latestVersion.deployment.__typename === (0, $kafab.AppDeployment).CONNECT || latestVersion.deployment.__typename === (0, $kafab.AppDeployment).ECOSYSTEM_CLOUD)) return latestVersion.deployment.scopes;
    return [];
};
const $5fb1a9e12f28a6fb$export$37b9fd23ea152d25 = (appListingDistribution, appDataFromSearchDistribution, hosting)=>{
    var _ref5, _appDataFromSearchDis, _ref6, _appDataFromSearchDis2;
    const preInstalledInSelectedHosting = hosting === (0, $ammkg.AtlassianProductHostingType).Cloud ? appListingDistribution === null || appListingDistribution === void 0 ? void 0 : appListingDistribution.isPreinstalledInCloud : appListingDistribution === null || appListingDistribution === void 0 ? void 0 : appListingDistribution.isPreinstalledInServerDC;
    const downloadCount = (_ref5 = (_appDataFromSearchDis = appDataFromSearchDistribution === null || appDataFromSearchDistribution === void 0 ? void 0 : appDataFromSearchDistribution.downloads) !== null && _appDataFromSearchDis !== void 0 ? _appDataFromSearchDis : appListingDistribution === null || appListingDistribution === void 0 ? void 0 : appListingDistribution.downloadCount) !== null && _ref5 !== void 0 ? _ref5 : 0;
    const installationCount = (_ref6 = (_appDataFromSearchDis2 = appDataFromSearchDistribution === null || appDataFromSearchDistribution === void 0 ? void 0 : appDataFromSearchDistribution.activeInstalls) !== null && _appDataFromSearchDis2 !== void 0 ? _appDataFromSearchDis2 : appListingDistribution === null || appListingDistribution === void 0 ? void 0 : appListingDistribution.installationCount) !== null && _ref6 !== void 0 ? _ref6 : 0;
    return {
        downloadCount: downloadCount,
        installationCount: installationCount,
        isPreinstalled: preInstalledInSelectedHosting || false,
        isPreinstalledInAnyHosting: (appListingDistribution === null || appListingDistribution === void 0 ? void 0 : appListingDistribution.isPreinstalledInCloud) || (appListingDistribution === null || appListingDistribution === void 0 ? void 0 : appListingDistribution.isPreinstalledInServerDC) || false
    };
};
function $5fb1a9e12f28a6fb$export$2e2bcd8739ae039(args) {
    var _appDetails$serverApp, _appDetails$serverApp2, _appDetails$cloudAppV, _appDetails$cloudAppV2, _appDetails$dataCente, _appDetails$dataCente2, _appDetails$logo$high, _appDetails$logo$high2, _highlights$map, _screenshots$map, _appDetails$tagline, _appDetails$summary, _selectedAppVersionCo, _deployment$compatibl, _latestCloudAppVersio;
    const { appDetails: appDetails, appDataFromSearch: appDataFromSearch, mediaImageLink: mediaImageLink, partnerDetailsLink: partnerDetailsLink, hosting: hosting, appVersionHistoryLink: appVersionHistoryLink, artifactDownloadLink: artifactDownloadLink, descriptorDownloadLink: descriptorDownloadLink, appIconLink: appIconLink } = args;
    const selectedAppVersion = (0, $h6uOD.getSelectedAppVersion)(hosting, appDetails);
    const selectedAppVersionConnection = (0, $h6uOD.getSelectedAppVersionConnection)(hosting, appDetails);
    const latestServerAppVersion = (_appDetails$serverApp = appDetails.serverAppVersions.edges) === null || _appDetails$serverApp === void 0 ? void 0 : (_appDetails$serverApp2 = _appDetails$serverApp[0]) === null || _appDetails$serverApp2 === void 0 ? void 0 : _appDetails$serverApp2.node;
    const latestCloudAppVersion = (_appDetails$cloudAppV = appDetails.cloudAppVersions.edges) === null || _appDetails$cloudAppV === void 0 ? void 0 : (_appDetails$cloudAppV2 = _appDetails$cloudAppV[0]) === null || _appDetails$cloudAppV2 === void 0 ? void 0 : _appDetails$cloudAppV2.node;
    const latestDataCenterAppVersion = (_appDetails$dataCente = appDetails.dataCenterAppVersions.edges) === null || _appDetails$dataCente === void 0 ? void 0 : (_appDetails$dataCente2 = _appDetails$dataCente[0]) === null || _appDetails$dataCente2 === void 0 ? void 0 : _appDetails$dataCente2.node;
    // for all UX purposes, cloud only has 1 version from a user’s POV
    const totalVersionCount = Math.min(1, appDetails.cloudAppVersions.totalCount) + appDetails.serverAppVersions.totalCount + appDetails.dataCenterAppVersions.totalCount;
    const serverCompatibleProducts = (latestServerAppVersion === null || latestServerAppVersion === void 0 ? void 0 : latestServerAppVersion.deployment.compatibleProducts) || [];
    const cloudCompatibleProducts = (latestCloudAppVersion === null || latestCloudAppVersion === void 0 ? void 0 : latestCloudAppVersion.deployment.compatibleProducts) || [];
    const dataCenterCompatibleProducts = (latestDataCenterAppVersion === null || latestDataCenterAppVersion === void 0 ? void 0 : latestDataCenterAppVersion.deployment.compatibleProducts) || [];
    const makeMediaImage = (imageId)=>mediaImageLink.expand({
            imageId: imageId
        });
    const { name: name, appKey: appKey, appId: appId, slug: slug, privacyPolicyUrl: privacyPolicyUrl, partner: partner, programs: programs } = appDetails;
    const { youtubeId: youtubeId, highlights: highlights, screenshots: screenshots, moreDetails: moreDetails, heroImage: heroImage, deployment: deployment, releaseDate: releaseDate, releaseNotes: releaseNotes, releaseSummary: releaseSummary, releaseNotesUrl: releaseNotesUrl, version: version } = selectedAppVersion || {};
    const appScopes = $5fb1a9e12f28a6fb$var$makeAppScopes(selectedAppVersion);
    const logo = appDetails.logo ? makeMediaImage((_appDetails$logo$high = (_appDetails$logo$high2 = appDetails.logo.highResolution) === null || _appDetails$logo$high2 === void 0 ? void 0 : _appDetails$logo$high2.id) !== null && _appDetails$logo$high !== void 0 ? _appDetails$logo$high : appDetails.logo.original.id) : appIconLink.expand({
        appKey: appKey
    });
    return $5fb1a9e12f28a6fb$var$_objectSpread($5fb1a9e12f28a6fb$var$_objectSpread({
        appId: appId,
        appKey: appKey,
        slug: slug,
        heroImage: $5fb1a9e12f28a6fb$var$makeHeroImage(heroImage, makeMediaImage),
        logo: logo,
        highlights: (_highlights$map = highlights === null || highlights === void 0 ? void 0 : highlights.map((highlight)=>$5fb1a9e12f28a6fb$export$39ae7d355c29b45f(highlight, makeMediaImage))) !== null && _highlights$map !== void 0 ? _highlights$map : [],
        moreDetails: moreDetails,
        name: name,
        partner: $5fb1a9e12f28a6fb$export$4e86cdb9bfb37e34(partner, partnerDetailsLink, makeMediaImage),
        privacyPolicyUrl: privacyPolicyUrl,
        screenshots: (_screenshots$map = screenshots === null || screenshots === void 0 ? void 0 : screenshots.map((screenshot)=>$5fb1a9e12f28a6fb$export$a8937c5bf2e03fcb(screenshot, makeMediaImage))) !== null && _screenshots$map !== void 0 ? _screenshots$map : [],
        tagline: (_appDetails$tagline = appDetails.tagline) !== null && _appDetails$tagline !== void 0 ? _appDetails$tagline : '',
        // Tagline is mandatory in the app details form, but historically some apps don't have it
        summary: (_appDetails$summary = appDetails.summary) !== null && _appDetails$summary !== void 0 ? _appDetails$summary : '',
        youtubeId: // Summary is mandatory in the app details form, but historically some apps don't have it
        youtubeId,
        marketingLabels: appDetails.marketingLabels,
        categories: appDetails.categories.map((category)=>({
                name: category.name
            })),
        reviewSummary: $5fb1a9e12f28a6fb$export$b903bb79739c9fdc(appDetails.reviewSummary),
        watchersInfo: $5fb1a9e12f28a6fb$var$makeWatcherInfo(appDetails.watchersInfo),
        productHostingOptions: appDetails.productHostingOptions,
        appScopes: appScopes,
        listingStatus: appDetails.listingStatus,
        releaseDate: releaseDate,
        releaseNotes: releaseNotes,
        releaseSummary: releaseSummary,
        releaseNotesUrl: releaseNotesUrl,
        serverCompatibleProducts: serverCompatibleProducts,
        cloudCompatibleProducts: cloudCompatibleProducts,
        dataCenterCompatibleProducts: dataCenterCompatibleProducts,
        versionCount: (_selectedAppVersionCo = selectedAppVersionConnection.totalCount) !== null && _selectedAppVersionCo !== void 0 ? _selectedAppVersionCo : 0,
        totalVersionCount: totalVersionCount,
        version: version,
        hasDataCenterVersion: !!appDetails.dataCenterAppVersions.totalCount,
        compatibleProducts: (_deployment$compatibl = deployment === null || deployment === void 0 ? void 0 : deployment.compatibleProducts) !== null && _deployment$compatibl !== void 0 ? _deployment$compatibl : [],
        supportDetails: $5fb1a9e12f28a6fb$export$e36a0bc69d7dae53({
            appDetails: appDetails,
            selectedAppVersion: selectedAppVersion,
            hosting: hosting
        })
    }, $5fb1a9e12f28a6fb$var$makeResourceLinks({
        appDetails: appDetails,
        latestVersion: selectedAppVersion,
        appVersionHistoryLink: appVersionHistoryLink,
        artifactDownloadLink: artifactDownloadLink,
        descriptorDownloadLink: descriptorDownloadLink,
        hosting: hosting
    })), {}, {
        createdAt: new Date(appDetails.createdAt),
        distribution: $5fb1a9e12f28a6fb$export$37b9fd23ea152d25(appDetails.distribution, appDataFromSearch === null || appDataFromSearch === void 0 ? void 0 : appDataFromSearch.distribution, hosting),
        installationInstructions: $5fb1a9e12f28a6fb$var$makeInstallationInstructions({
            selectedAppVersion: selectedAppVersion,
            makeMediaImage: makeMediaImage
        }),
        deploymentType: selectedAppVersion === null || selectedAppVersion === void 0 ? void 0 : selectedAppVersion.deployment.__typename,
        paymentModel: selectedAppVersion === null || selectedAppVersion === void 0 ? void 0 : selectedAppVersion.paymentModel,
        programs: $5fb1a9e12f28a6fb$export$75c05eeb38ce87e7(programs),
        licenseType: latestCloudAppVersion === null || latestCloudAppVersion === void 0 ? void 0 : (_latestCloudAppVersio = latestCloudAppVersion.licenseType) === null || _latestCloudAppVersio === void 0 ? void 0 : _latestCloudAppVersio.name
    });
}

});
parcelRegister("7ZOJD", function(module, exports) {

$parcel$export(module.exports, "HostingDisplayName", () => $5d2595d855da188c$export$594f3b666f5ee104);
$parcel$export(module.exports, "HostingTypeToQueryParam", () => $5d2595d855da188c$export$6b3b6105dcf77d16);
$parcel$export(module.exports, "HostingTypeToFiltersQueryParam", () => $5d2595d855da188c$export$1c938211e26a3667);
$parcel$export(module.exports, "HostingQueryParamToHostingType", () => $5d2595d855da188c$export$da3fed25eda5c5c2);

var $ammkg = parcelRequire("ammkg");
const $5d2595d855da188c$export$594f3b666f5ee104 = Object.freeze({
    [(0, $ammkg.AtlassianProductHostingType).Cloud]: 'Cloud',
    [(0, $ammkg.AtlassianProductHostingType).Server]: 'Server',
    [(0, $ammkg.AtlassianProductHostingType).DataCenter]: 'Data Center'
});
const $5d2595d855da188c$export$6b3b6105dcf77d16 = Object.freeze({
    [(0, $ammkg.AtlassianProductHostingType).DataCenter]: 'datacenter',
    [(0, $ammkg.AtlassianProductHostingType).Cloud]: 'cloud',
    [(0, $ammkg.AtlassianProductHostingType).Server]: 'server'
});
const $5d2595d855da188c$export$1c938211e26a3667 = Object.freeze({
    [(0, $ammkg.AtlassianProductHostingType).DataCenter]: 'dataCenter',
    [(0, $ammkg.AtlassianProductHostingType).Cloud]: 'cloud',
    [(0, $ammkg.AtlassianProductHostingType).Server]: 'server'
});
const $5d2595d855da188c$export$da3fed25eda5c5c2 = {
    [$5d2595d855da188c$export$6b3b6105dcf77d16[(0, $ammkg.AtlassianProductHostingType).Cloud]]: (0, $ammkg.AtlassianProductHostingType).Cloud,
    [$5d2595d855da188c$export$6b3b6105dcf77d16[(0, $ammkg.AtlassianProductHostingType).Server]]: (0, $ammkg.AtlassianProductHostingType).Server,
    [$5d2595d855da188c$export$6b3b6105dcf77d16[(0, $ammkg.AtlassianProductHostingType).DataCenter]]: (0, $ammkg.AtlassianProductHostingType).DataCenter
};

});

parcelRegister("ebXHa", function(module, exports) {

$parcel$export(module.exports, "isNotAnApp", () => $a5506601f0164752$export$a44a3015a43016f2);
$parcel$export(module.exports, "isRemoteable", () => $a5506601f0164752$export$1212125aff0982f6);
$parcel$export(module.exports, "maybeDCCompatible", () => $a5506601f0164752$export$286882bf1ad23334);
$parcel$export(module.exports, "isServerSubscriptionApp", () => $a5506601f0164752$export$7b954b967a0acd47);
$parcel$export(module.exports, "toHAMSAppKey", () => $a5506601f0164752$export$1a939d84372ecb44);
$parcel$export(module.exports, "isServerAppEol", () => $a5506601f0164752$export$5c4f21be5f4f8fd0);
$parcel$export(module.exports, "isExcludedServerApp", () => $a5506601f0164752$export$b6c10f7b06e61d09);
$parcel$export(module.exports, "isServerAppEos", () => $a5506601f0164752$export$92a9fa5342d87a3f);

var $kafab = parcelRequire("kafab");

var $ammkg = parcelRequire("ammkg");
function $a5506601f0164752$export$a44a3015a43016f2(appDeployment) {
    return [
        (0, $kafab.AppDeployment).INSTRUCTIONAL,
        (0, $kafab.AppDeployment).WORKFLOW
    ].includes(appDeployment.__typename);
}
function $a5506601f0164752$export$1212125aff0982f6(appDeployment) {
    return [
        (0, $kafab.AppDeployment).CONNECT,
        (0, $kafab.AppDeployment).ECOSYSTEM_CLOUD
    ].includes(appDeployment.__typename);
}
function // TODO verify if default value needs to be passed.
$a5506601f0164752$export$286882bf1ad23334() {
    let productHostingOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let serverCompatibleProducts = arguments.length > 1 ? arguments[1] : undefined;
    const isDCCompatible = productHostingOptions.includes((0, $ammkg.AtlassianProductHostingType).DataCenter);
    const isServerCompatible = productHostingOptions.includes((0, $ammkg.AtlassianProductHostingType).Server);
    const isCompatibleWithSomeDCEnabledProduct = serverCompatibleProducts.some((compatibleProduct)=>{
        var _compatibleProduct$at;
        return (_compatibleProduct$at = compatibleProduct.atlassianProduct) === null || _compatibleProduct$at === void 0 ? void 0 : _compatibleProduct$at.hostingOptions.includes((0, $ammkg.AtlassianProductHostingType).DataCenter);
    });
    return !isDCCompatible && isServerCompatible && isCompatibleWithSomeDCEnabledProduct;
}
function $a5506601f0164752$export$7b954b967a0acd47(appKey) {
    return [
        'atlassian-jira-training'
    ].includes(appKey);
}
function $a5506601f0164752$export$1a939d84372ecb44(appKey, hosting) {
    if (hosting === (0, $ammkg.AtlassianProductHostingType).DataCenter) return "".concat(appKey, ".data-center");
    if (hosting === (0, $ammkg.AtlassianProductHostingType).Cloud) return "".concat(appKey, ".ondemand");
    return appKey;
}
const $a5506601f0164752$var$FECRU = 'fecru';
const $a5506601f0164752$var$BAMBOO = 'bamboo';
const $a5506601f0164752$var$CROWD = 'crowd';
const $a5506601f0164752$var$getServerEolStartDate = (compatibleProducts, showServerEolWarning)=>{
    let serverEolStartDate = showServerEolWarning ? 'Feb 15, 2023' : '';
    for (const product of compatibleProducts)if (product.id === $a5506601f0164752$var$BAMBOO || product.id === $a5506601f0164752$var$CROWD) {
        serverEolStartDate = 'November 19, 2023';
        return serverEolStartDate;
    }
    return serverEolStartDate;
};
const $a5506601f0164752$export$5c4f21be5f4f8fd0 = (isServerApp, compatibleProducts, featureFlags)=>{
    const { enableMpacServerEolWarning: enableMpacServerEolWarning } = featureFlags;
    if (isServerApp && enableMpacServerEolWarning) {
        const isExcludedApp = $a5506601f0164752$export$b6c10f7b06e61d09(compatibleProducts);
        const showInstallationTab = isExcludedApp !== null && isExcludedApp !== void 0 ? isExcludedApp : true;
        const showServerEolWarning = !isExcludedApp;
        const serverEolStartDate = $a5506601f0164752$var$getServerEolStartDate(compatibleProducts, showServerEolWarning);
        return {
            showInstallationTab: showInstallationTab,
            showServerEolWarning: showServerEolWarning,
            serverEolStartDate: serverEolStartDate
        };
    }
    return {
        showInstallationTab: true,
        showServerEolWarning: false,
        serverEolStartDate: ''
    };
};
const $a5506601f0164752$export$92a9fa5342d87a3f = (isServerApp, compatibleProducts)=>{
    if (isServerApp) {
        const exculdedParentProduct = [
            $a5506601f0164752$var$FECRU
        ];
        const isExcludedServerEOSApp = compatibleProducts === null || compatibleProducts === void 0 ? void 0 : compatibleProducts.some((product)=>exculdedParentProduct.includes(product.id));
        return !isExcludedServerEOSApp;
    }
    return false;
};
const $a5506601f0164752$export$b6c10f7b06e61d09 = (compatibleProducts)=>{
    // Project CareBear Feb 2023, clean on Feb 2024
    let excludedProductTypes = [
        $a5506601f0164752$var$BAMBOO,
        $a5506601f0164752$var$CROWD,
        $a5506601f0164752$var$FECRU
    ];
    // remove bamboo and crowd from excludedProductTypes
    excludedProductTypes = excludedProductTypes.filter((product)=>![
            $a5506601f0164752$var$BAMBOO,
            $a5506601f0164752$var$CROWD
        ].includes(product));
    return compatibleProducts === null || compatibleProducts === void 0 ? void 0 : compatibleProducts.reduce((showInstallationTab, product)=>{
        return showInstallationTab || excludedProductTypes.includes(product.id);
    }, false);
};

});

parcelRegister("h6uOD", function(module, exports) {

$parcel$export(module.exports, "APP_HEADER_ORIGIN", () => $c73ae6895d9a4c28$export$d32fc29ad1b7fc58);
$parcel$export(module.exports, "makeSeeExistingQuestionsUrl", () => $c73ae6895d9a4c28$export$44d5398ba659399d);
$parcel$export(module.exports, "makeAskNewQuestionUrl", () => $c73ae6895d9a4c28$export$49d14ea959a409c7);
$parcel$export(module.exports, "getExistingCommunityQuestionsCount", () => $c73ae6895d9a4c28$export$7f69f4df9a8a9d09);
$parcel$export(module.exports, "valueForHosting", () => $c73ae6895d9a4c28$export$50fe971ec4ec2dec);
$parcel$export(module.exports, "getSelectedAppVersion", () => $c73ae6895d9a4c28$export$88dac8dff5f7f248);
$parcel$export(module.exports, "getSelectedAppVersionConnection", () => $c73ae6895d9a4c28$export$49c3ecaefe3884e5);
$parcel$export(module.exports, "makeAppHeaderProps", () => $c73ae6895d9a4c28$export$d588a44ae5c73e69);
$parcel$export(module.exports, "isRuByPartnerAppAccessDeniedError", () => $c73ae6895d9a4c28$export$989a8fca99ae1a75);

var $ammkg = parcelRequire("ammkg");

var $bTrQR = parcelRequire("bTrQR");
var $c9Mth = parcelRequire("c9Mth");

var $c1ZLO = parcelRequire("c1ZLO");
const $c73ae6895d9a4c28$export$cb5c403d4efbcd2d = 'atlassian-marketplace';
const $c73ae6895d9a4c28$export$d32fc29ad1b7fc58 = 'marketplace';
const $c73ae6895d9a4c28$export$957ec5fa69ccab9c = (appKey)=>"addon-".concat(appKey);
const $c73ae6895d9a4c28$export$44d5398ba659399d = (_ref)=>{
    let { atlassianCommunityBaseUrl: atlassianCommunityBaseUrl, appKey: appKey } = _ref;
    return "".concat(atlassianCommunityBaseUrl, "/t5/tag/").concat($c73ae6895d9a4c28$export$957ec5fa69ccab9c(appKey), "/tg-p/category-id/").concat($c73ae6895d9a4c28$export$cb5c403d4efbcd2d);
};
const $c73ae6895d9a4c28$export$49d14ea959a409c7 = (_ref2)=>{
    let { atlassianCommunityBaseUrl: atlassianCommunityBaseUrl, appKey: appKey, hosting: hosting } = _ref2;
    const pathname = "".concat(atlassianCommunityBaseUrl, "/t5/custom/page/page-id/create-post-step-1");
    const params = new URLSearchParams();
    params.append('add-tags', [
        $c73ae6895d9a4c28$export$cb5c403d4efbcd2d,
        $c73ae6895d9a4c28$export$957ec5fa69ccab9c(appKey),
        (0, $c1ZLO.CommunityTagForHostingType)[hosting]
    ].join(','));
    return "".concat(pathname, "?").concat(params.toString());
};
const $c73ae6895d9a4c28$export$4a1455b2afa8dbd4 = (_ref3)=>{
    let { mpacBaseUrl: mpacBaseUrl, appKey: appKey } = _ref3;
    return "".concat(mpacBaseUrl, "/rest/internal/community/tags/count?q=").concat($c73ae6895d9a4c28$export$957ec5fa69ccab9c(appKey));
};
const $c73ae6895d9a4c28$export$7f69f4df9a8a9d09 = async (_ref4)=>{
    let { mpacBaseUrl: mpacBaseUrl, appKey: appKey } = _ref4;
    try {
        const url = $c73ae6895d9a4c28$export$4a1455b2afa8dbd4({
            mpacBaseUrl: mpacBaseUrl,
            appKey: appKey
        });
        const response = await fetch(url, {
            credentials: 'same-origin'
        });
        if (response.ok) {
            const count = await response.json();
            if (typeof count === 'number') return count;
        }
    } catch (error) {
        (0, $bTrQR.default).error('AppListing', 'Error fetching count of existing questions on atlassian community', {
            error: error
        });
    }
    return 0;
};
const $c73ae6895d9a4c28$export$50fe971ec4ec2dec = (hosting)=>(hostingMap)=>{
        return hostingMap[hosting];
    };
const $c73ae6895d9a4c28$export$cd4bd0d91a5f2507 = (paymentModel)=>(paymentModelMap)=>{
        return paymentModelMap[paymentModel];
    };
const $c73ae6895d9a4c28$export$88c54d42f2bd4212 = (purchaseIntent)=>(purchaseIntentMap)=>{
        return purchaseIntentMap[purchaseIntent];
    };
function $c73ae6895d9a4c28$export$88dac8dff5f7f248(hosting, appDetails) {
    var _getSelectedAppVersio, _getSelectedAppVersio2;
    return (_getSelectedAppVersio = $c73ae6895d9a4c28$export$49c3ecaefe3884e5(hosting, appDetails).edges) === null || _getSelectedAppVersio === void 0 ? void 0 : (_getSelectedAppVersio2 = _getSelectedAppVersio[0]) === null || _getSelectedAppVersio2 === void 0 ? void 0 : _getSelectedAppVersio2.node;
}
function $c73ae6895d9a4c28$export$49c3ecaefe3884e5(hosting, appDetails) {
    return $c73ae6895d9a4c28$export$50fe971ec4ec2dec(hosting)({
        [(0, $ammkg.AtlassianProductHostingType).Cloud]: appDetails.cloudAppVersions,
        [(0, $ammkg.AtlassianProductHostingType).Server]: appDetails.serverAppVersions,
        [(0, $ammkg.AtlassianProductHostingType).DataCenter]: appDetails.dataCenterAppVersions
    });
}
const $c73ae6895d9a4c28$export$d588a44ae5c73e69 = (appListing, appDetailsFromSearchResponse)=>({
        name: appListing.name,
        key: appListing.appKey,
        ratings: {
            avgStars: appListing.reviewSummary.rating,
            numRatings: appListing.reviewSummary.count
        },
        createdAt: appListing.createdAt,
        distribution: {
            downloadCount: appListing.distribution.downloadCount,
            installationCount: appListing.distribution.installationCount,
            isPreinstalled: appListing.distribution.isPreinstalled,
            isPreinstalledInAnyHosting: appListing.distribution.isPreinstalledInAnyHosting,
            isLoading: appDetailsFromSearchResponse === null || appDetailsFromSearchResponse === void 0 ? void 0 : appDetailsFromSearchResponse.loading,
            isError: appDetailsFromSearchResponse === null || appDetailsFromSearchResponse === void 0 ? void 0 : appDetailsFromSearchResponse.error
        },
        compatibleProducts: appListing.compatibleProducts.map((p)=>p.name),
        origin: $c73ae6895d9a4c28$export$d32fc29ad1b7fc58,
        partner: {
            name: appListing.partner.name,
            link: (0, $c9Mth).validateSafeAbsoluteUrl(appListing.partner.url),
            partnerTierType: appListing.partner.partnerTierType
        }
    });
const $c73ae6895d9a4c28$export$989a8fca99ae1a75 = (error)=>{
    var _graphQLErrors$0$exte;
    const { graphQLErrors: graphQLErrors } = error;
    if (!graphQLErrors.length) return false;
    return ((_graphQLErrors$0$exte = graphQLErrors[0].extensions) === null || _graphQLErrors$0$exte === void 0 ? void 0 : _graphQLErrors$0$exte.errorType) === 'ruby_region_access_denied';
};

});
parcelRegister("c1ZLO", function(module, exports) {

$parcel$export(module.exports, "MAX_VISIBLE_TABS_CONFIG", () => $8c257e4a59d5c1e2$export$b0c19f7b2463ac49);
$parcel$export(module.exports, "AppListingTab", () => $8c257e4a59d5c1e2$export$e31e72f2e5150d46);
$parcel$export(module.exports, "CommunityTagForHostingType", () => $8c257e4a59d5c1e2$export$23ce376ec0b71571);
$parcel$export(module.exports, "FREE_APP_CTA_LABEL_PRIMARY", () => $8c257e4a59d5c1e2$export$2dfc14d138fd4edd);
$parcel$export(module.exports, "PAID_APP_CTA_LABEL_START_TRIAL", () => $8c257e4a59d5c1e2$export$6902c10944c3f4d7);
$parcel$export(module.exports, "TEST_ID", () => $8c257e4a59d5c1e2$export$a7bb072605d6094c);
$parcel$export(module.exports, "ELEMENT_ID", () => $8c257e4a59d5c1e2$export$e2459a55f364ff58);
$parcel$export(module.exports, "PER_USER_PRICING_FORMAT_MIN_FRACTION_DIGITS", () => $8c257e4a59d5c1e2$export$3dac34b00ae62570);

var $kafab = parcelRequire("kafab");

var $ammkg = parcelRequire("ammkg");
const $8c257e4a59d5c1e2$export$b0c19f7b2463ac49 = {
    xs: 2,
    sm: 4
};
const $8c257e4a59d5c1e2$export$e31e72f2e5150d46 = {
    Overview: 'overview',
    Reviews: 'reviews',
    Pricing: 'pricing',
    Support: 'support',
    Versions: 'versions',
    Installation: 'installation',
    PrivacyAndSecurity: 'privacy-and-security'
};
const $8c257e4a59d5c1e2$export$bff0990d64364b73 = Object.keys($8c257e4a59d5c1e2$export$e31e72f2e5150d46).map((key)=>$8c257e4a59d5c1e2$export$e31e72f2e5150d46[key]);
const $8c257e4a59d5c1e2$export$f3adfdcbb472d8e4 = $8c257e4a59d5c1e2$export$e31e72f2e5150d46.Overview;
const $8c257e4a59d5c1e2$export$23ce376ec0b71571 = {
    [(0, $ammkg.AtlassianProductHostingType).Cloud]: 'cloud',
    [(0, $ammkg.AtlassianProductHostingType).Server]: 'server',
    [(0, $ammkg.AtlassianProductHostingType).DataCenter]: 'data-center'
};
const $8c257e4a59d5c1e2$export$68af97a99c6c08b3 = {
    [(0, $kafab.CompatibleProductTypeValues).CLOUD_PRODUCT]: (0, $ammkg.AtlassianProductHostingType).Cloud,
    [(0, $kafab.CompatibleProductTypeValues).SERVER_PRODUCT]: (0, $ammkg.AtlassianProductHostingType).Server,
    [(0, $kafab.CompatibleProductTypeValues).DATACENTER_PRODUCT]: (0, $ammkg.AtlassianProductHostingType).DataCenter
};
const $8c257e4a59d5c1e2$export$2dfc14d138fd4edd = 'Get it now';
const $8c257e4a59d5c1e2$export$9bf49445298d7efc = 'Free app';
const $8c257e4a59d5c1e2$export$4e14849e4ef20a03 = 'Try it free';
const $8c257e4a59d5c1e2$export$6902c10944c3f4d7 = 'Start free trial';
const $8c257e4a59d5c1e2$export$deeed484a0411758 = 'Buy it now';
const $8c257e4a59d5c1e2$export$d06c52010bd3decf = 'Subscribe Now';
const $8c257e4a59d5c1e2$export$6cf44fb8b34bc857 = 'Learn more';
const $8c257e4a59d5c1e2$export$c2c28f1f82398bba = 'Purchase';
const $8c257e4a59d5c1e2$export$a7bb072605d6094c = {
    APP_LISTING_TAB: (tabName)=>"app-listing__tab-".concat(tabName),
    // overview tab
    OVERVIEW_TAB_MORE_DETAILS_CONTENT: 'app-listing__more-details-content',
    OVERVIEW_TAB_YOUTUBE_IFRAME: 'app-listing__youtube-iframe',
    OVERVIEW_TAB_HERO_HIGHLIGHTS: 'hero-and-highlights-container',
    OVERVIEW_TAB_HERO_IMAGE: 'app-listing__hero-img',
    OVERVIEW_TAB_HIGHLIGHT_SUMMARY: 'app-listing__highlight-summary',
    OVERVIEW_TAB_HIGHLIGHT_IMAGE: 'app-listing__highlight-img',
    OVERVIEW_TAB_MEDIA_VIEWER: 'app-listing__media-viewer',
    OVERVIEW_TAB_RESOURCES: 'app-listing__overview__resources',
    OVERVIEW_TAB_PRIVACY_AND_SECURITY: 'app-listing__overview__privacy-security',
    OVERVIEW_TAB_INTEGRATION_DETAILS: 'app-listing__overview__integration-details',
    OVERVIEW_TAB_INTEGRATION_DETAILS_MODAL: 'app-listing__overview__integration-details--modal',
    PRIVACY_SECURITY: 'privacy-security',
    RESOURCE_LINKS: 'resource-links',
    INTEGRATION_DETAILS: 'integration-details',
    GALLERY: 'gallery',
    CERTIFICATION_SECTION: 'certification-section',
    CLOUD_FORTIFIED_INFO_MODAL: 'cloudfortified-info-modal',
    // overview tab -> Resources section -> cloud migration subsection
    CLOUD_MIGRATION_ALTERNATE_APP: 'cloud-migration__alternate-app',
    CLOUD_MIGRATION_MIGRATION_DOCUMENTATION: 'cloud-migration__migration-documentation',
    CLOUD_MIGRATION_FEATURE_DIFFERENCE: 'cloud-migration__feature-difference',
    // reviews tab
    REVIEWS_TAB_HEADING: 'reviews-tab__heading',
    REVIEWS_TAB_LOADING: 'reviews-tab__skeleton',
    REVIEWS_TAB_REVIEW_FORM_CHECKBOX: 'reviews-tab__review-form-checkbox',
    REVIEWS_TAB_REVIEW_FORM_TEXTAREA: 'reviews-tab__review-form-textarea',
    REVIEWS_TAB_USER_REVIEW: 'reviews-tab__user-review',
    REVIEWS_TAB_OWN_REVIEW: 'reviews-tab__own-review',
    REVIEWS_TAB_DELETE_REVIEW: 'reviews-tab__delete-review',
    REVIEWS_TAB_RESPOND_REVIEW: 'reviews-tab__respond-review',
    REVIEWS_TAB_FLAG_UNFLAG_REVIEW: 'reviews-tab__flag-unflag-review',
    REVIEWS_TAB_SIGN_IN_LINK: 'reviews-tab__sign-in-link',
    REVIEWS_TAB_WRITE_EDIT_REVIEW_BUTTON: 'reviews-tab__write-edit-review-button',
    REVIEWS_TAB_PUBLISH_REVIEW_BUTTON: 'reviews-tab__publish-review-button',
    REVIEWS_TAB_LOAD_MORE_LOADING: 'reviews-tab__load-more-skeleton',
    // support
    SUPPORT_TAB_SUPPORT_TAGLINE: 'app-listing__support-tagline',
    SUPPORT_TAB_EMAIL_ID: 'app-listing__support-link__email-id',
    SUPPORT_TAB_PHONE_NUMBER: 'app-listing__support-link__phone-number',
    SUPPORT_TAB_STATUS_PAGE_URL: 'app-listing__support-link__status-page-url',
    SUPPORT_TAB_SUPPORT_TIMINGS: 'app-listing__support-contact__availability-timings',
    // pricing
    PRICING_TAB_VIEW_ADDITIONAL_PRICING: 'app-listing__pricing-tab-view-additional-pricing',
    PRICING_TAB_INSTALL_CTA: 'app-listing__pricing-tab__install-cta',
    // installation
    INSTALLATION_TAB_STEP_SCREENSHOT: 'app-listing__installation-step-screenshot',
    // cta
    CTA_INSTALL_APP_BTN: 'app-listing__install-app-btn',
    // hosting selector
    HOSTING_SELECTOR_MODAL_REQUEST_APP: 'hosting-selector-modal__request-app-btn',
    HOSTING_SELECTOR_MODAL_COLUMN_CLOUD: 'hosting-selector-modal__column-cloud',
    HOSTING_SELECTOR_MODAL_COLUMN_SERVER: 'hosting-selector-modal__column-server',
    HOSTING_SELECTOR_MODAL_COLUMN_DATACENTER: 'hosting-selector-modal__column-datacenter',
    HOSTING_SELECTOR_MODAL_PRIMARY_COLUMN_CTA: 'hosting-selector-modal__primary-column-cta',
    /**
   * Hosting dropdown
   * This value is a prefix, the actual testId is created by the atlaskit dropdown component:-
   * - `${HOSTING_DROPDOWN}--trigger` (for the clickable trigger)
   * - `${HOSTING_DROPDOWN}--content` (for the options container)
   */ HOSTING_DROPDOWN: 'app-listing__hosting-dropdown',
    // request app
    REQUEST_APP_BTN: 'app-listing__request-app-btn',
    REQUEST_APP_MODAL_CLOSE_BTN: 'request-app-modal__close-modal-btn',
    REQUEST_APP_MODAL_SUBMIT_BTN: 'request-app-modal__submit-request-btn',
    // gallery media viewer
    MEDIA_VIEWER_FILE_NAME: 'media-viewer-file-name',
    MEDIA_VIEWER_CLOSE_BTN: 'media-viewer-close-button',
    MEDIA_VIEWER_IMAGE: 'media-viewer-image',
    // versions tab
    VERSION_SECTION: 'versions-section',
    RESOURCE_SECTION: 'resources-section'
};
const $8c257e4a59d5c1e2$export$e2459a55f364ff58 = {
    APP_LISTING_TABS: 'app-listing__tabs',
    CLOUD_MIGRATION_SECTION_LINKS: 'app-listing__cloud-migration-links',
    REVIEW_GUIDELINE_BANNER_AND_FORM: 'app-listing__review-guideline-banner-and-form'
};
const $8c257e4a59d5c1e2$export$3dac34b00ae62570 = 2;

});



parcelRegister("j4jdu", function(module, exports) {

$parcel$export(module.exports, "getAppHeaderDetails", () => $de1d4c0af1aa6f25$export$3624fb652f7fc3fe);
$parcel$export(module.exports, "makeRequestAppHeaderProps", () => $de1d4c0af1aa6f25$export$f3b480a8af5e709f);
$parcel$export(module.exports, "foldMarketplaceAppPaymentModel", () => $de1d4c0af1aa6f25$export$5ab3a34513547cf6);

var $h6uOD = parcelRequire("h6uOD");
var $8dnmP = parcelRequire("8dnmP");

var $9D4R7 = parcelRequire("9D4R7");

var $ammkg = parcelRequire("ammkg");

var $gC8Po = parcelRequire("gC8Po");
var $c9Mth = parcelRequire("c9Mth");
var $de1d4c0af1aa6f25$var$MarketplaceAppRequestGetAppByKey = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "MarketplaceAppRequestGetAppByKey"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "appKey"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    },
                    directives: []
                }
            ],
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "marketplaceAppByKey"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "appKey"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "appKey"
                                    }
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "RequestAppHeaderDetails"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "RequestAppHeaderDetails"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceApp"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "appKey"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "versions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "filter"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "productHostingOptions"
                                            },
                                            value: {
                                                kind: "ListValue",
                                                values: [
                                                    {
                                                        kind: "EnumValue",
                                                        value: "CLOUD"
                                                    }
                                                ]
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "visibility"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "PUBLIC"
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "excludeHiddenIn"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "IN_PRODUCT"
                                            }
                                        }
                                    ]
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "IntValue",
                                    value: "1"
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "AppVersion"
                                                            },
                                                            directives: []
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "partner"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AppPartner"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "reviewSummary"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AppReviewSummary"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "distribution"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AppDistribution"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "programs"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AppProgram"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppVersion"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceAppVersion"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "paymentModel"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "deployment"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "__typename"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "compatibleProducts"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "AppCompatibleProduct"
                                                },
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                        kind: "NamedType",
                                        name: {
                                            kind: "Name",
                                            value: "MarketplaceCloudAppDeployment"
                                        }
                                    },
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "cloudAppId"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppPartner"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplacePartner"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "slug"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "partnerType"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "programs"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "isCloudAppSecuritySelfAssessmentDone"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "partnerTier"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "type"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "updatedDate"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "support"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "contactDetails"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "websiteUrl"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "AppPartnerSupportContact"
                                                },
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "availability"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "AppPartnerSupportAvailability"
                                                },
                                                directives: []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "logo"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AppListingImage"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppReviewSummary"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceAppReviewSummary"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "rating"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "count"
                        },
                        arguments: [],
                        directives: []
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppDistribution"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceAppDistribution"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "downloadCount"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "installationCount"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isPreinstalledInServerDC"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isPreinstalledInCloud"
                        },
                        arguments: [],
                        directives: []
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppProgram"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceAppPrograms"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "cloudFortified"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "status"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "programStatus"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "bugBountyParticipant"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "cloud"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "status"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "server"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "status"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "dataCenter"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "status"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppCompatibleProduct"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "CompatibleAtlassianProduct"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "__typename"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "atlassianProduct"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "hostingOptions"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppPartnerSupportContact"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplacePartnerSupportContact"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "emailId"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "phoneNumber"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "websiteUrl"
                        },
                        arguments: [],
                        directives: []
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppPartnerSupportAvailability"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplacePartnerSupportAvailability"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "daysOfWeek"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isAvailable24Hours"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "startTime"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "endTime"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "timezone"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "timezoneOffset"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "holidays"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AppPartnerSupportHolidays"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppListingImage"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceListingImage"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "original"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "width"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "height"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "highResolution"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "width"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "height"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppPartnerSupportHolidays"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplacePartnerSupportHoliday"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "holidayFrequency"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "date"
                        },
                        arguments: [],
                        directives: []
                    }
                ]
            }
        }
    ],
    loc: {
        start: 0,
        end: 2760,
        source: {
            body: "# If you are making any change here\n# Do thoroughly read our graphql contribution guidelines\n# https://bitbucket.org/atlassian-marketplace/marketplace-frontend/src/master/docs/working-with-graphql.md\n\nfragment AppCompatibleProduct on CompatibleAtlassianProduct {\n  # These should be fixed when we migrate this GraphQL query to BFF in Mosaic\n  # eslint-disable-next-line @graphql-eslint/no-deprecated\n  id\n  # eslint-disable-next-line @graphql-eslint/no-deprecated\n  name\n  __typename\n\n  atlassianProduct {\n    name\n    hostingOptions\n  }\n}\n\nfragment AppVersion on MarketplaceAppVersion {\n  paymentModel\n  deployment {\n    __typename\n    compatibleProducts {\n      ...AppCompatibleProduct\n    }\n    ... on MarketplaceCloudAppDeployment {\n      cloudAppId\n    }\n  }\n}\n\nfragment AppPartnerSupportContact on MarketplacePartnerSupportContact {\n  emailId\n  phoneNumber\n  websiteUrl\n}\n\nfragment AppPartner on MarketplacePartner {\n  name\n  id\n  slug\n  partnerType\n  programs {\n    isCloudAppSecuritySelfAssessmentDone\n  }\n  partnerTier {\n    type\n    updatedDate\n  }\n  support {\n    contactDetails {\n      websiteUrl\n      ...AppPartnerSupportContact\n    }\n\n    availability {\n      ...AppPartnerSupportAvailability\n    }\n  }\n  logo {\n    ...AppListingImage\n  }\n}\n\nfragment AppListingImage on MarketplaceListingImage {\n  original {\n    id\n    width\n    height\n  }\n  highResolution {\n    id\n    width\n    height\n  }\n}\n\nfragment AppPartnerSupportAvailability on MarketplacePartnerSupportAvailability {\n  daysOfWeek\n  isAvailable24Hours\n  startTime\n  endTime\n  timezone\n  timezoneOffset\n  holidays {\n    ...AppPartnerSupportHolidays\n  }\n}\n\nfragment AppPartnerSupportHolidays on MarketplacePartnerSupportHoliday {\n  holidayFrequency\n  date\n}\n\nfragment AppReviewSummary on MarketplaceAppReviewSummary {\n  rating\n  count\n}\n\nfragment AppDistribution on MarketplaceAppDistribution {\n  downloadCount\n  installationCount\n  isPreinstalledInServerDC\n  isPreinstalledInCloud\n}\n\nfragment AppProgram on MarketplaceAppPrograms {\n  cloudFortified {\n    status\n    programStatus\n  }\n  bugBountyParticipant {\n    cloud {\n      status\n    }\n    server {\n      status\n    }\n    dataCenter {\n      status\n    }\n  }\n}\n\nfragment RequestAppHeaderDetails on MarketplaceApp {\n  name\n  appKey\n  createdAt\n  versions(\n    filter: { productHostingOptions: [CLOUD], visibility: PUBLIC, excludeHiddenIn: IN_PRODUCT }\n    first: 1\n  ) {\n    edges {\n      node {\n        ...AppVersion\n      }\n    }\n  }\n  partner {\n    ...AppPartner\n  }\n  reviewSummary {\n    ...AppReviewSummary\n  }\n  distribution {\n    ...AppDistribution\n  }\n  programs {\n    ...AppProgram\n  }\n}\n\nquery MarketplaceAppRequestGetAppByKey($appKey: String!) {\n  marketplaceAppByKey(appKey: $appKey) {\n    ...RequestAppHeaderDetails\n  }\n}\n",
            name: "GraphQL request",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    }
};
const $de1d4c0af1aa6f25$export$3624fb652f7fc3fe = async (gatewayUrl, appKey)=>{
    const { errors: errors, data: data } = await (0, $9D4R7.graphQLRequest)(gatewayUrl, {
        query: $de1d4c0af1aa6f25$var$MarketplaceAppRequestGetAppByKey,
        variables: {
            appKey: appKey
        }
    });
    if (errors !== null && errors !== void 0 && errors.length) throw errors;
    if (!(data !== null && data !== void 0 && data.marketplaceAppByKey)) throw new Error("Unable to fetch app with key \"".concat(appKey, "\"'"));
    return data.marketplaceAppByKey;
};
const $de1d4c0af1aa6f25$export$f3b480a8af5e709f = (app, appDetailsFromSearchResponse, partnerDetailsLink)=>{
    var _appDetailsFromSearch, _app$versions$edges, _app$versions$edges$, _app$versions$edges$$;
    const reviewSummary = (0, $8dnmP.makeReviewSummary)(app.reviewSummary);
    const partner = (0, $8dnmP.makePartner)(app.partner, partnerDetailsLink);
    const distribution = (0, $8dnmP.makeDistribution)(app.distribution, appDetailsFromSearchResponse === null || appDetailsFromSearchResponse === void 0 ? void 0 : (_appDetailsFromSearch = appDetailsFromSearchResponse.appData) === null || _appDetailsFromSearch === void 0 ? void 0 : _appDetailsFromSearch.distribution, (0, $ammkg.AtlassianProductHostingType).Cloud);
    return {
        name: app.name,
        key: app.appKey,
        ratings: {
            avgStars: reviewSummary.rating,
            numRatings: reviewSummary.count
        },
        createdAt: new Date(app.createdAt),
        distribution: {
            downloadCount: distribution.downloadCount,
            installationCount: distribution.installationCount,
            isPreinstalled: distribution.isPreinstalled,
            isPreinstalledInAnyHosting: distribution.isPreinstalledInAnyHosting,
            isLoading: appDetailsFromSearchResponse === null || appDetailsFromSearchResponse === void 0 ? void 0 : appDetailsFromSearchResponse.loading,
            isError: appDetailsFromSearchResponse === null || appDetailsFromSearchResponse === void 0 ? void 0 : appDetailsFromSearchResponse.error
        },
        compatibleProducts: (_app$versions$edges = app.versions.edges) === null || _app$versions$edges === void 0 ? void 0 : (_app$versions$edges$ = _app$versions$edges[0]) === null || _app$versions$edges$ === void 0 ? void 0 : (_app$versions$edges$$ = _app$versions$edges$.node) === null || _app$versions$edges$$ === void 0 ? void 0 : _app$versions$edges$$.deployment.compatibleProducts.map((p)=>p.name),
        origin: (0, $h6uOD.APP_HEADER_ORIGIN),
        partner: {
            name: partner.name,
            link: (0, $c9Mth).validateSafeAbsoluteUrl(partner.url),
            partnerTierType: partner.partnerTierType
        }
    };
};
const $de1d4c0af1aa6f25$export$5ab3a34513547cf6 = (p)=>(free, atlassian, vendor)=>{
        switch(p){
            case 'PAID_VIA_ATLASSIAN':
                return atlassian();
            case 'FREE':
                return free();
            case 'PAID_VIA_PARTNER':
                return vendor();
            default:
                throw (0, $gC8Po.default).unexpectedCase(p);
        }
    };

});


parcelRegister("B8Ddx", function(module, exports) {

$parcel$export(module.exports, "AppRequestDialogModalInstalled", () => $06fa26dc13691949$export$b6daa97a2872916d);

var $dxopF = parcelRequire("dxopF");

var $lRvnl = parcelRequire("lRvnl");

var $eUqFw = parcelRequire("eUqFw");

var $lUBwM = parcelRequire("lUBwM");
const $06fa26dc13691949$export$b6daa97a2872916d = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: "success"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, (0, $lUBwM.INSTALLED_STATE_CONTENT))));
};

});
parcelRegister("lUBwM", function(module, exports) {

$parcel$export(module.exports, "TEST_ID", () => $ff3bf02adea2a033$export$a7bb072605d6094c);
$parcel$export(module.exports, "INSTALLED_STATE_CONTENT", () => $ff3bf02adea2a033$export$efbc7d7b1bfbdf27);
$parcel$export(module.exports, "REJECTED_STATUS_CONTENT", () => $ff3bf02adea2a033$export$aad92321a6b7d7a4);
$parcel$export(module.exports, "REQUESTED_STATE_CONTENT", () => $ff3bf02adea2a033$export$fcbf3e5843cb17d8);
const $ff3bf02adea2a033$export$a7bb072605d6094c = {
    APP_REQUEST_BTN: 'request-app__request-app-btn',
    APP_REQUEST_MODAL_CLOSE_BTN: 'request-app__close-modal-btn',
    APP_REQUEST_MODAL_SUBMIT_BTN: 'request-app-modal__submit-request-btn'
};
const $ff3bf02adea2a033$export$efbc7d7b1bfbdf27 = 'This app is already installed on your instance.';
const $ff3bf02adea2a033$export$aad92321a6b7d7a4 = 'Your app request was rejected since';
const $ff3bf02adea2a033$export$fcbf3e5843cb17d8 = 'Your app request is currently under review. Please reach out to your site admin for more details';

});


parcelRegister("5ZqYC", function(module, exports) {

$parcel$export(module.exports, "AppRequestDialogModalRejected", () => $45c79343ef866d88$export$832cc6248c8d9fd4);

var $dxopF = parcelRequire("dxopF");

var $lRvnl = parcelRequire("lRvnl");

var $eUqFw = parcelRequire("eUqFw");

var $lUBwM = parcelRequire("lUBwM");
const $45c79343ef866d88$export$832cc6248c8d9fd4 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: "error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, (0, $lUBwM.REJECTED_STATUS_CONTENT), " ", props.rejectComment)));
};

});

parcelRegister("2iapx", function(module, exports) {

$parcel$export(module.exports, "AppRequestDialogModalRequested", () => $1ab55697e310b4c1$export$8e617ba1a6e4873);

var $dxopF = parcelRequire("dxopF");

var $lRvnl = parcelRequire("lRvnl");

var $eUqFw = parcelRequire("eUqFw");

var $lUBwM = parcelRequire("lUBwM");
const $1ab55697e310b4c1$export$8e617ba1a6e4873 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, (0, $lUBwM.REQUESTED_STATE_CONTENT))));
};

});

parcelRegister("3ySzw", function(module, exports) {

$parcel$export(module.exports, "AppRequestDialogModalRequestable", () => $297ee0ec942a8e95$export$b437be0c1df1c50d);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $cQKn6 = parcelRequire("cQKn6");

var $9oiuL = parcelRequire("9oiuL");

var $boSVF = parcelRequire("boSVF");

var $lRvnl = parcelRequire("lRvnl");

var $xeS7R = parcelRequire("xeS7R");

var $j0gMm = parcelRequire("j0gMm");

var $gykb8 = parcelRequire("gykb8");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $bm7IM = parcelRequire("bm7IM");

var $bTrQR = parcelRequire("bTrQR");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $gRo3n = parcelRequire("gRo3n");

var $bSQ4o = parcelRequire("bSQ4o");

var $3lzNh = parcelRequire("3lzNh");

var $lUBwM = parcelRequire("lUBwM");

var $1rGPx = parcelRequire("1rGPx");
function $297ee0ec942a8e95$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $297ee0ec942a8e95$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $297ee0ec942a8e95$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $297ee0ec942a8e95$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $297ee0ec942a8e95$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $297ee0ec942a8e95$export$8b7b7cdfb85d78c5 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $cQKn6.default), {
    target: "ebig46w0",
    label: "SubmitButton"
})({
    name: "j6808u",
    styles: "margin-left:10px;margin-right:10px;"
});
const $297ee0ec942a8e95$export$fbe0381af1a2ee78 = (0, $3UXZ8.default)("p", {
    target: "ebig46w1",
    label: "InstructionText"
})("color:", "var(--ds-text-subtle, ".concat((0, $j0gMm.N200), ")"), ";margin-bottom:var(--ds-space-100, 8px);");
const $297ee0ec942a8e95$export$585a3b23e887288b = (0, $3UXZ8.default)("div", {
    target: "ebig46w2",
    label: "TitleWrapper"
})({
    name: "1k7usd8",
    styles: "margin-top:var(--ds-space-300, 24px);"
});
const $297ee0ec942a8e95$export$7e367b5ecaaba455 = 'Close';
const $297ee0ec942a8e95$export$370735d8e3124931 = 'Request';
const $297ee0ec942a8e95$export$8d13340382210b65 = (0, $3UXZ8.default)("p", {
    target: "ebig46w3",
    label: "Hint"
})("color:", "var(--ds-text, ".concat((0, $j0gMm.N400), ")"), ";font-size:12px;margin-top:var(--ds-space-250, 20px);white-space:pre-line;");
const $297ee0ec942a8e95$var$DEFAULT_COMMENT = "Hi, I'd like to try this app. I think it could be really useful to the team.\n\nThanks!";
const $297ee0ec942a8e95$export$da23b793d992ac4f = {
    description: 'We have sent your app request to your admin. Your work here is done!',
    title: 'App requested',
    type: (0, $bm7IM.FLAG_TYPE_SUCCESS),
    isAutoDismiss: true
};
const $297ee0ec942a8e95$var$requestAppFailureFlag = {
    description: 'It might just be a hiccup. Try again in a bit.',
    title: "We ran into some trouble!",
    type: (0, $bm7IM.FLAG_TYPE_ERROR),
    isAutoDismiss: true
};
const $297ee0ec942a8e95$export$b437be0c1df1c50d = (props)=>{
    const TITLE = 'Want this app? Let your admin know why';
    const [comment, setComment] = (0, $eUqFw.useState)($297ee0ec942a8e95$var$DEFAULT_COMMENT);
    const [isRequestingApp, setRequestingAppFlag] = (0, $eUqFw.useState)(false);
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const handleViewAppDetailsClick = ()=>{
        fireAnalyticsEvent({
            eventType: (0, $gaiog.LinkClickedEvent),
            actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_VIEW_APP_DETAILS),
            objectType: (0, $7Uh51.ANALYTICS_OBJECT_TYPE_APP_LISTING),
            objectId: props.appKey
        });
        window.open(props.links.appDetails.expand({
            appKey: props.appKey
        }));
    };
    const handleAnalyticsButtonClickEvent = (actionSubjectId)=>fireAnalyticsEvent({
            eventType: (0, $gaiog.ButtonClickedEvent),
            actionSubjectId: actionSubjectId,
            objectType: (0, $7Uh51.ANALYTICS_OBJECT_TYPE_APP_LISTING),
            objectId: props.appKey
        });
    const handleChangeBody = (event)=>{
        setComment(event.target.value.trim());
    };
    const handleSubmitAppRequest = async ()=>{
        const { appKey: appKey, hostInfo: hostInfo, fireEvent: fireEvent, appName: appName } = props;
        const productName = hostInfo.product;
        const cloudId = (0, $bSQ4o.getCloudIdFromHostInfo)(hostInfo);
        setRequestingAppFlag(true);
        handleAnalyticsButtonClickEvent((0, $7Uh51.ANALYTICS_SUBJECT_ID_REQUEST_APP_SUBMITTED));
        (0, $3lzNh.RequestAppTask).start();
        const appDetails = {
            appName: appName,
            appKey: appKey,
            productName: productName,
            comment: comment
        };
        try {
            var _props$onRequestSucce;
            await (0, $gRo3n.requestApp)({
                productName: productName,
                cloudId: cloudId,
                appKey: appKey,
                comment: comment
            });
            props.onClose();
            props.flags.show($297ee0ec942a8e95$var$_objectSpread($297ee0ec942a8e95$var$_objectSpread({}, $297ee0ec942a8e95$export$da23b793d992ac4f), {}, {
                id: "".concat(appKey, "-app-request-success")
            }));
            fireEvent.requestSucceeded(appKey);
            (0, $3lzNh.RequestAppTask).succeeded();
            (_props$onRequestSucce = props.onRequestSuccess) === null || _props$onRequestSucce === void 0 || _props$onRequestSucce.call(props, appDetails);
        } catch (error) {
            var _props$onRequestFailu;
            props.onClose();
            props.flags.show($297ee0ec942a8e95$var$_objectSpread($297ee0ec942a8e95$var$_objectSpread({}, $297ee0ec942a8e95$var$requestAppFailureFlag), {}, {
                id: "".concat(appKey, "-app-request-error")
            }));
            (0, $bTrQR.default).error('AppRequestDialogModalRequestable', error);
            fireEvent.requestFailed(appKey, error);
            (0, $3lzNh.RequestAppTask).failed(error, error.code || error.status);
            (_props$onRequestFailu = props.onRequestFailure) === null || _props$onRequestFailu === void 0 || _props$onRequestFailu.call(props, appDetails);
        } finally{
            setRequestingAppFlag(false);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, "Only product and site admin can install apps. You'll need to request your admin to install this app")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($297ee0ec942a8e95$export$585a3b23e887288b, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, TITLE)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($297ee0ec942a8e95$export$fbe0381af1a2ee78, null, "Describe the problem you are trying to solve, how many team members would use and benefit from this app, etc."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xeS7R.default), {
        placeholder: "Type your reasons in here",
        resize: "auto",
        minimumRows: 5,
        onChange: handleChangeBody,
        defaultValue: comment
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1rGPx.RequestableFooterContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gykb8.default), {
        onClick: handleViewAppDetailsClick
    }, "View app details"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1rGPx.RequestableFooterRightContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($297ee0ec942a8e95$export$8b7b7cdfb85d78c5, {
        testId: (0, $lUBwM.TEST_ID).APP_REQUEST_MODAL_SUBMIT_BTN,
        appearance: "primary",
        onClick: handleSubmitAppRequest,
        isLoading: isRequestingApp,
        isDisabled: comment.length === 0
    }, $297ee0ec942a8e95$export$370735d8e3124931), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9oiuL.default), {
        testId: (0, $lUBwM.TEST_ID).APP_REQUEST_MODAL_CLOSE_BTN,
        appearance: "subtle",
        onClick: ()=>{
            props.onClose();
            handleAnalyticsButtonClickEvent((0, $7Uh51.ANALYTICS_SUBJECT_ID_REQUEST_APP_CANCELED));
        }
    }, $297ee0ec942a8e95$export$7e367b5ecaaba455))));
};

});
parcelRegister("xeS7R", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fe3143162b284fd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $dkGpW = parcelRequire("dkGpW");
const $2fe3143162b284fd$var$packageName = "platform-pkg";
const $2fe3143162b284fd$var$packageVersion = "0.0.0-use.local";
const $2fe3143162b284fd$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $2fe3143162b284fd$var$packageName,
    packageVersion: $2fe3143162b284fd$var$packageVersion
};
const $2fe3143162b284fd$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = (0, $dkGpW.borderWidth);
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $2fe3143162b284fd$var$InnerTextArea = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const ourRef = (0, $eUqFw.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, ...rest } = props;
    (0, $eUqFw.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $2fe3143162b284fd$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$2fe3143162b284fd$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$2fe3143162b284fd$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $eUqFw.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $2fe3143162b284fd$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const baseStyles = (0, $eUqFw.useMemo)(()=>(0, $dkGpW.getBaseStyles)({
            minimumRows: minimumRows,
            resize: resize,
            appearance: appearance,
            isMonospaced: isMonospaced,
            maxHeight: maxHeight
        }), [
        minimumRows,
        resize,
        appearance,
        isMonospaced,
        maxHeight
    ]);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-array-arguments, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    const textAreaStyles = /*#__PURE__*/ (0, $byn9U.css)([
        baseStyles,
        (0, $dkGpW.dynamicStyles)(appearance)
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        // TODO refactor to follow emotion styling rules
        // see: https://product-fabric.atlassian.net/browse/DSP-6060
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: textAreaStyles,
        ...rest
    });
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ const $2fe3143162b284fd$var$TextArea = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $byn9U.jsx)($2fe3143162b284fd$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$2fe3143162b284fd$var$TextArea.displayName = 'TextArea';
var $2fe3143162b284fd$export$2e2bcd8739ae039 = $2fe3143162b284fd$var$TextArea;

});
parcelRegister("dkGpW", function(module, exports) {

$parcel$export(module.exports, "borderWidth", () => $ffa47244c710aa2a$export$12879c7697ed953d);
$parcel$export(module.exports, "getBaseStyles", () => $ffa47244c710aa2a$export$bff8031d86bb089);
$parcel$export(module.exports, "dynamicStyles", () => $ffa47244c710aa2a$export$98856a888ef36079);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $9rnqv = parcelRequire("9rnqv");
function $ffa47244c710aa2a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ffa47244c710aa2a$var$disabledRules = {
    backgroundColor: $9rnqv.disabledBackground,
    backgroundColorFocus: $9rnqv.disabledBackground,
    backgroundColorHover: $9rnqv.disabledBackground,
    borderColor: $9rnqv.disabledBorder,
    borderColorFocus: $9rnqv.defaultBorderColorFocus,
    textColor: $9rnqv.disabledTextColor
};
const $ffa47244c710aa2a$var$invalidRules = {
    borderColor: $9rnqv.invalidBorderColor,
    borderColorFocus: $9rnqv.defaultBorderColorFocus,
    backgroundColor: $9rnqv.defaultBackgroundColor,
    backgroundColorFocus: $9rnqv.defaultBackgroundColorFocus,
    backgroundColorHover: $9rnqv.defaultBackgroundColorHover
};
const $ffa47244c710aa2a$var$backgroundColor = {
    standard: $9rnqv.defaultBackgroundColor,
    subtle: $9rnqv.transparent,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$backgroundColorFocus = {
    standard: $9rnqv.defaultBackgroundColorFocus,
    subtle: $9rnqv.defaultBackgroundColorFocus,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$backgroundColorHover = {
    standard: $9rnqv.defaultBackgroundColorHover,
    subtle: $9rnqv.defaultBackgroundColorHover,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$borderColor = {
    standard: $9rnqv.defaultBorderColor,
    subtle: $9rnqv.transparent,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$borderColorFocus = {
    standard: $9rnqv.defaultBorderColorFocus,
    subtle: $9rnqv.defaultBorderColorFocus,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$borderColorHover = {
    standard: $9rnqv.defaultBorderColor,
    subtle: $9rnqv.subtleBorderColorHover,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$lineHeightBase = 20;
const $ffa47244c710aa2a$var$lineHeightCompact = 16;
const $ffa47244c710aa2a$var$compactVerticalPadding = 2;
const $ffa47244c710aa2a$var$verticalPadding = 6;
const $ffa47244c710aa2a$var$horizontalPadding = 8;
const $ffa47244c710aa2a$var$transitionDuration = '0.2s';
const $ffa47244c710aa2a$var$fontFamily = "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)";
const $ffa47244c710aa2a$var$codeFontFamily = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
const $ffa47244c710aa2a$export$12879c7697ed953d = 2;
// Safari puts on some difficult to remove styles, mainly for disabled inputs
// but we want full control so need to override them in all cases
const $ffa47244c710aa2a$var$overrideSafariDisabledStyles = {
    WebkitTextFillColor: 'unset',
    WebkitOpacity: '1'
};
const $ffa47244c710aa2a$var$borderBoxMinHeight = (minimumRows, borderHeight)=>{
    const contentHeight = $ffa47244c710aa2a$var$lineHeightBase * minimumRows;
    return contentHeight + $ffa47244c710aa2a$var$verticalPadding * 2 + borderHeight * 2;
};
const $ffa47244c710aa2a$var$borderBoxMinHeightCompact = (minimumRows, borderHeight)=>{
    const contentHeightCompact = $ffa47244c710aa2a$var$lineHeightCompact * minimumRows;
    return contentHeightCompact + $ffa47244c710aa2a$var$compactVerticalPadding * 2 + borderHeight * 2;
};
const $ffa47244c710aa2a$var$bgAndBorderColorStyles = (appearance)=>appearance && /*#__PURE__*/ (0, $byn9U.css)({
        '&:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$backgroundColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$borderColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$borderColorFocus[appearance]}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$backgroundColor[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$borderColor[appearance]
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$invalidRules.backgroundColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$invalidRules.borderColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$invalidRules.borderColorFocus}`
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$invalidRules.backgroundColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$invalidRules.borderColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$invalidRules.borderColor}`
        },
        // Disabled background and border styles should not be applied to components that
        // have either no background or transparent background to begin with
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...appearance === 'standard' ? {
            '&:disabled:focus': {
                backgroundColor: $ffa47244c710aa2a$var$disabledRules.backgroundColorFocus,
                borderColor: $ffa47244c710aa2a$var$disabledRules.borderColorFocus
            },
            '&:disabled:not(:focus)': {
                backgroundColor: $ffa47244c710aa2a$var$disabledRules.backgroundColor,
                borderColor: $ffa47244c710aa2a$var$disabledRules.borderColor
            }
        } : {}
    });
const $ffa47244c710aa2a$var$placeholderStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $9rnqv.placeholderTextColor
    },
    '&:disabled::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $ffa47244c710aa2a$var$disabledRules.textColor
    }
});
const $ffa47244c710aa2a$var$hoverBackgroundAndBorderStyles = (appearance)=>appearance && /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:hover:not(:read-only):not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$backgroundColorHover[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$borderColorHover[appearance],
            '&:disabled': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $ffa47244c710aa2a$var$disabledRules.backgroundColorHover
            },
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&[data-invalid]': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $ffa47244c710aa2a$var$invalidRules.backgroundColorHover,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderColor: $ffa47244c710aa2a$var$invalidRules.borderColor,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$invalidRules.borderColor}`
            }
        }
    });
var $ffa47244c710aa2a$var$_ref = {
    name: "utehjx",
    styles: "resize:none"
};
var $ffa47244c710aa2a$var$_ref2 = {
    name: "bolgb9",
    styles: "resize:both"
};
const $ffa47244c710aa2a$var$resizeStyle = (resize)=>{
    if (resize === 'horizontal' || resize === 'vertical') // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $byn9U.css)({
        resize: resize
    });
    if (resize === 'auto') return $ffa47244c710aa2a$var$_ref2;
    return $ffa47244c710aa2a$var$_ref;
};
const $ffa47244c710aa2a$var$borderStyle = (appearance)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderStyle: appearance === 'none' ? 'none' : 'solid'
    });
const $ffa47244c710aa2a$var$fontFamilyStyle = (isMonospaced)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontFamily: isMonospaced ? $ffa47244c710aa2a$var$codeFontFamily : $ffa47244c710aa2a$var$fontFamily
    });
const $ffa47244c710aa2a$var$borderPaddingAndHeightStyles = (minimumRows = 1, appearance)=>{
    const borderWidth = appearance !== 'none' ? 1 : 2;
    const horizontalPaddingWithoutBorderWidth = $ffa47244c710aa2a$var$horizontalPadding - borderWidth;
    const borderHeight = borderWidth;
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-compact]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $ffa47244c710aa2a$var$borderBoxMinHeightCompact(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: `${$ffa47244c710aa2a$var$compactVerticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values
            lineHeight: $ffa47244c710aa2a$var$lineHeightCompact / 14
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not([data-compact])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $ffa47244c710aa2a$var$borderBoxMinHeight(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: `${$ffa47244c710aa2a$var$verticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values
            lineHeight: $ffa47244c710aa2a$var$lineHeightBase / 14
        }
    });
};
const $ffa47244c710aa2a$var$staticStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'block',
    boxSizing: 'border-box',
    width: '100%',
    minWidth: 0,
    maxWidth: '100%',
    margin: 0,
    position: 'relative',
    flex: '1 1 100%',
    borderRadius: "var(--ds-border-radius, 3px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    borderWidth: 1,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    outline: 'none',
    overflow: 'auto',
    transition: `background-color ${$ffa47244c710aa2a$var$transitionDuration} ease-in-out,
               border-color ${$ffa47244c710aa2a$var$transitionDuration} ease-in-out`,
    wordWrap: 'break-word',
    '&:disabled': {
        cursor: 'not-allowed',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$ffa47244c710aa2a$var$overrideSafariDisabledStyles
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-ms-clear': {
        display: 'none'
    },
    '&:invalid': {
        boxShadow: 'none'
    }
});
const $ffa47244c710aa2a$export$bff8031d86bb089 = ({ minimumRows: minimumRows, resize: resize, appearance: appearance, isMonospaced: isMonospaced, maxHeight: maxHeight })=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$staticStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$borderPaddingAndHeightStyles(minimumRows, appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$resizeStyle(resize), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$borderStyle(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$fontFamilyStyle(isMonospaced), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    {
        maxHeight: maxHeight
    });
const $ffa47244c710aa2a$export$98856a888ef36079 = (appearance)=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$bgAndBorderColorStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$hoverBackgroundAndBorderStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$placeholderStyles, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $9rnqv.textColor,
        '&:disabled': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: $ffa47244c710aa2a$var$disabledRules.textColor
        }
    });

});
parcelRegister("9rnqv", function(module, exports) {

$parcel$export(module.exports, "disabledBackground", () => $f5064939140dcbf4$export$ae3cba7672df0890);
$parcel$export(module.exports, "disabledBorder", () => $f5064939140dcbf4$export$fe505fe3c5edbdf6);
$parcel$export(module.exports, "invalidBorderColor", () => $f5064939140dcbf4$export$7f333bbf7ddab792);
$parcel$export(module.exports, "defaultBorderColor", () => $f5064939140dcbf4$export$dafd83031c202ca8);
$parcel$export(module.exports, "defaultBorderColorFocus", () => $f5064939140dcbf4$export$e8320c09dc1e4012);
$parcel$export(module.exports, "defaultBackgroundColor", () => $f5064939140dcbf4$export$b13414ee9ac9cae6);
$parcel$export(module.exports, "defaultBackgroundColorHover", () => $f5064939140dcbf4$export$bca15982c103d57b);
$parcel$export(module.exports, "defaultBackgroundColorFocus", () => $f5064939140dcbf4$export$21287e4b7f134f09);
$parcel$export(module.exports, "subtleBorderColorHover", () => $f5064939140dcbf4$export$a87538d56ee366ec);
$parcel$export(module.exports, "placeholderTextColor", () => $f5064939140dcbf4$export$5e076b2557ef7bbb);
$parcel$export(module.exports, "textColor", () => $f5064939140dcbf4$export$32f78bffcd82ff28);
$parcel$export(module.exports, "disabledTextColor", () => $f5064939140dcbf4$export$eb4a7d363eec53c8);
$parcel$export(module.exports, "transparent", () => $f5064939140dcbf4$export$f4d082c200a4b4b8);

const $f5064939140dcbf4$export$ae3cba7672df0890 = `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`;
const $f5064939140dcbf4$export$fe505fe3c5edbdf6 = `var(--ds-border-disabled, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`;
const $f5064939140dcbf4$export$7f333bbf7ddab792 = `var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`;
const $f5064939140dcbf4$export$dafd83031c202ca8 = `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`;
const $f5064939140dcbf4$export$e8320c09dc1e4012 = `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`;
const $f5064939140dcbf4$export$b13414ee9ac9cae6 = `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`;
const $f5064939140dcbf4$export$bca15982c103d57b = `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`;
const $f5064939140dcbf4$export$21287e4b7f134f09 = `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`;
const $f5064939140dcbf4$export$a87538d56ee366ec = "var(--ds-border-input, transparent)";
const $f5064939140dcbf4$export$5e076b2557ef7bbb = `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`;
const $f5064939140dcbf4$export$32f78bffcd82ff28 = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$fbda843f0a27fe96)})`;
const $f5064939140dcbf4$export$eb4a7d363eec53c8 = `var(--ds-text-disabled, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`;
const $f5064939140dcbf4$export$f4d082c200a4b4b8 = 'transparent';

});



parcelRegister("gRo3n", function(module, exports) {

$parcel$export(module.exports, "getAppRequests", () => $c464411bf2ffa8ca$export$f365acffb5fff8e6);
$parcel$export(module.exports, "getAppRequestComments", () => $c464411bf2ffa8ca$export$76363e573e1b4e39);
$parcel$export(module.exports, "requestApp", () => $c464411bf2ffa8ca$export$79b82eb311ec4858);
$parcel$export(module.exports, "getAppRequestedStatus", () => $c464411bf2ffa8ca$export$2a448e1f3708455f);
$parcel$export(module.exports, "changeAppRequestStatus", () => $c464411bf2ffa8ca$export$a72a748ae1ab9096);

var $5zQU9 = parcelRequire("5zQU9");

var $55gtq = parcelRequire("55gtq");
function $c464411bf2ffa8ca$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c464411bf2ffa8ca$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c464411bf2ffa8ca$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c464411bf2ffa8ca$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $c464411bf2ffa8ca$var$demandServicePath = (productName, clouldId)=>"/internal/demand/app-requests/product-name/".concat(productName, "/cloud-id/").concat(clouldId);
// Request for an app
const $c464411bf2ffa8ca$var$requestAppUrl = (productName, cloudId, appKey)=>"".concat($c464411bf2ffa8ca$var$demandServicePath(productName, cloudId), "/app-key/").concat(appKey);
// Get a status of the app request for an app key
const $c464411bf2ffa8ca$var$getAppRequestedStatusUrl = (params)=>"".concat($c464411bf2ffa8ca$var$demandServicePath(params.productName, params.cloudId), "/app-key/").concat(params.appKey, "/status?userId=").concat(params.userId);
// Get all the app requests to render Manage App requests dashboard
const $c464411bf2ffa8ca$var$getAppRequestsUrl = (productName, cloudId)=>"".concat($c464411bf2ffa8ca$var$demandServicePath(productName, cloudId));
// Update the status of an app (for ex: Installed | Rejected)
const $c464411bf2ffa8ca$var$updateAllAppRequestStatusUrl = (productName, cloudId, appKey)=>"".concat($c464411bf2ffa8ca$var$demandServicePath(productName, cloudId), "/app-key/").concat(appKey, "/status");
// Get all the user comments for an app
const $c464411bf2ffa8ca$var$getAppRequestCommentsUrl = (_ref)=>{
    let { productName: productName, cloudId: cloudId, appKey: appKey } = _ref;
    return "".concat($c464411bf2ffa8ca$var$demandServicePath(productName, cloudId), "/app-key/").concat(appKey);
};
const $c464411bf2ffa8ca$var$defaultDemandApiConfig = {
    credentials: 'include',
    headers: {
        'Content-Type': 'application/json'
    }
};
const $c464411bf2ffa8ca$export$f365acffb5fff8e6 = (productName, cloudId)=>(0, $55gtq.default)().fetchOk($c464411bf2ffa8ca$var$getAppRequestsUrl(productName, cloudId), $c464411bf2ffa8ca$var$defaultDemandApiConfig).catch((error)=>{
        if (error.status === 404) return {
            allAppRequestDetails: []
        };
        throw error;
    });
const $c464411bf2ffa8ca$export$76363e573e1b4e39 = (requestParams)=>(0, $55gtq.default)().fetchOk($c464411bf2ffa8ca$var$getAppRequestCommentsUrl(requestParams), $c464411bf2ffa8ca$var$defaultDemandApiConfig);
const $c464411bf2ffa8ca$export$79b82eb311ec4858 = (appRequestDetails)=>(0, $55gtq.default)().fetchOk($c464411bf2ffa8ca$var$requestAppUrl(appRequestDetails.productName, appRequestDetails.cloudId, appRequestDetails.appKey), $c464411bf2ffa8ca$var$_objectSpread({
        method: 'post',
        body: JSON.stringify(appRequestDetails)
    }, $c464411bf2ffa8ca$var$defaultDemandApiConfig));
const $c464411bf2ffa8ca$export$2a448e1f3708455f = (appRequestStatusParams)=>(0, $55gtq.default)().fetchOk($c464411bf2ffa8ca$var$getAppRequestedStatusUrl(appRequestStatusParams), $c464411bf2ffa8ca$var$defaultDemandApiConfig);
const $c464411bf2ffa8ca$export$a72a748ae1ab9096 = (requestParams)=>(0, $55gtq.default)().fetchOk($c464411bf2ffa8ca$var$updateAllAppRequestStatusUrl(requestParams.productName, requestParams.cloudId, requestParams.appKey), $c464411bf2ffa8ca$var$_objectSpread({
        method: 'PATCH',
        body: JSON.stringify(requestParams)
    }, $c464411bf2ffa8ca$var$defaultDemandApiConfig));

});

parcelRegister("bSQ4o", function(module, exports) {

$parcel$export(module.exports, "getCloudIdFromHostInfo", () => $8a6d20d73e192b2c$export$f4cda0c22bc54682);

var $lLYAL = parcelRequire("lLYAL");
const $8a6d20d73e192b2c$export$f4cda0c22bc54682 = (hostInfo)=>{
    if (hostInfo) return (0, $lLYAL.parse)(hostInfo.globalContext.id).cloudId;
};

});



parcelRegister("gkhxl", function(module, exports) {

$parcel$export(module.exports, "AppRequestDialogModalError", () => $be2c1e05320e1702$export$84f78231ae342d01);

var $9oiuL = parcelRequire("9oiuL");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $dxopF = parcelRequire("dxopF");

var $eUqFw = parcelRequire("eUqFw");

var $1rGPx = parcelRequire("1rGPx");

var $jgKfD = parcelRequire("jgKfD");
const $be2c1e05320e1702$export$84f78231ae342d01 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1rGPx.AppRequestModalBodyWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1rGPx.AppRequestModalBodyImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jgKfD)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1rGPx.AppRequestStatus), null, "Error"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1rGPx.AppRequestStatusContent), null, "We ran into a little trouble and could not load the details."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1rGPx.AppRequestCloseButtonWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9oiuL.default), {
        appearance: "primary",
        onClick: props.onClose
    }, "Got it."))));
};

});
parcelRegister("jgKfD", function(module, exports) {
module.exports = new URL("app-request-error-state.94b90979.png", import.meta.url).toString();

});


parcelRegister("la8zm", function(module, exports) {

$parcel$export(module.exports, "useAppRequestAnalytics", () => $f6812dd1c4ef78c7$export$ccc2ed26eb7d6418);

var $5zQU9 = parcelRequire("5zQU9");

var $9osuT = parcelRequire("9osuT");

var $kafab = parcelRequire("kafab");

var $7IZKi = parcelRequire("7IZKi");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $gIQkA = parcelRequire("gIQkA");

var $j4jdu = parcelRequire("j4jdu");
function $f6812dd1c4ef78c7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f6812dd1c4ef78c7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f6812dd1c4ef78c7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f6812dd1c4ef78c7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $f6812dd1c4ef78c7$var$makeAnalyticsContextProperties = (_ref)=>{
    let { currentScreen: currentScreen } = _ref;
    return $f6812dd1c4ef78c7$var$_objectSpread({}, currentScreen && {
        source: currentScreen.name
    });
};
const $f6812dd1c4ef78c7$var$makeAnalyticsContextAttributes = (_ref2)=>{
    var _appDetails$versions$, _appDetails$versions$2, _appDetails$versions$3, _appDetails$versions$4, _appDetails$versions$5, _appDetails$versions$6;
    let { baseData: baseData, requestLocation: requestLocation } = _ref2;
    const attributes = {
        requestLocation: requestLocation,
        category: (0, $7Uh51.ANALYTICS_CATEGORY_MARKETPLACE_APP_REQUEST)
    };
    if (!baseData.result || !baseData.result.appDetails) return attributes;
    const appDetails = baseData.result.appDetails;
    const appKey = appDetails.appKey;
    const programs = appDetails.programs;
    let paymentModel = (_appDetails$versions$ = appDetails.versions.edges) === null || _appDetails$versions$ === void 0 ? void 0 : (_appDetails$versions$2 = _appDetails$versions$[0]) === null || _appDetails$versions$2 === void 0 ? void 0 : (_appDetails$versions$3 = _appDetails$versions$2.node) === null || _appDetails$versions$3 === void 0 ? void 0 : _appDetails$versions$3.paymentModel;
    paymentModel = paymentModel && (0, $j4jdu.foldMarketplaceAppPaymentModel)(paymentModel)(()=>'free', ()=>'atlassian', ()=>'vendor');
    const isEcosystemCloudApp = ((_appDetails$versions$4 = appDetails.versions.edges) === null || _appDetails$versions$4 === void 0 ? void 0 : (_appDetails$versions$5 = _appDetails$versions$4[0]) === null || _appDetails$versions$5 === void 0 ? void 0 : (_appDetails$versions$6 = _appDetails$versions$5.node) === null || _appDetails$versions$6 === void 0 ? void 0 : _appDetails$versions$6.deployment.__typename) === (0, $kafab.AppDeployment).ECOSYSTEM_CLOUD;
    let cloudAppDeployment;
    if (isEcosystemCloudApp) {
        var _appDetails$versions$7, _appDetails$versions$8, _appDetails$versions$9;
        cloudAppDeployment = (_appDetails$versions$7 = appDetails.versions.edges) === null || _appDetails$versions$7 === void 0 ? void 0 : (_appDetails$versions$8 = _appDetails$versions$7[0]) === null || _appDetails$versions$8 === void 0 ? void 0 : (_appDetails$versions$9 = _appDetails$versions$8.node) === null || _appDetails$versions$9 === void 0 ? void 0 : _appDetails$versions$9.deployment;
    }
    return $f6812dd1c4ef78c7$var$_objectSpread($f6812dd1c4ef78c7$var$_objectSpread({}, attributes), {}, {
        appKey: appKey,
        paymentModel: paymentModel,
        programs: programs,
        isEcosystemCloudApp: !!isEcosystemCloudApp
    }, cloudAppDeployment && {
        ecosystemCloudAppId: cloudAppDeployment.cloudAppId
    });
};
const $f6812dd1c4ef78c7$export$ccc2ed26eb7d6418 = (_ref3)=>{
    let { baseData: baseData, requestLocation: requestLocation } = _ref3;
    const fireEvent = (0, $9osuT.useAnalyticsEvents)();
    const [currentScreen, setCurrentScreen] = (0, $eUqFw.useState)(null);
    const analyticsContext = (0, $eUqFw.useMemo)(()=>({
            properties: $f6812dd1c4ef78c7$var$makeAnalyticsContextProperties({
                currentScreen: currentScreen
            }),
            attributes: $f6812dd1c4ef78c7$var$makeAnalyticsContextAttributes({
                baseData: baseData,
                requestLocation: requestLocation
            })
        }), [
        baseData.pending,
        currentScreen,
        requestLocation
    ]);
    const fireScreenEvent = function fireScreenEvent(eventType) {
        let payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return fireEvent((0, (/*@__PURE__*/$parcel$interopDefault($7IZKi)))([
            {
                eventType: eventType
            },
            {
                attributes: analyticsContext.attributes
            },
            payload
        ]));
    };
    const fireTrackEvent = function fireTrackEvent(eventType) {
        let payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return fireEvent((0, (/*@__PURE__*/$parcel$interopDefault($7IZKi)))([
            {
                eventType: eventType
            },
            {
                source: currentScreen,
                attributes: analyticsContext.attributes
            },
            payload
        ]));
    };
    return {
        fireEvent: {
            viewedAppRequestModalScreen: ()=>{
                fireScreenEvent((0, $gIQkA.ANALYTICS_MODAL_STANDALONE_APP_REQUEST));
                setCurrentScreen((0, $gIQkA.ANALYTICS_MODAL_STANDALONE_APP_REQUEST));
            },
            requestSucceeded: (appKey)=>{
                fireTrackEvent((0, $7Uh51.AppRequestedEvent), {
                    actionSubjectId: appKey
                });
                setCurrentScreen(null);
            },
            requestFailed: (appKey, error)=>{
                fireTrackEvent((0, $7Uh51.AppRequestFailedEvent), {
                    actionSubjectId: appKey,
                    attributes: {
                        errorCode: error.code,
                        error: error.message,
                        source: error.source
                    }
                });
                setCurrentScreen(null);
            }
        },
        analyticsContext: analyticsContext
    };
};

});

parcelRegister("5rzWv", function(module, exports) {

$parcel$export(module.exports, "useAppRequestBaseData", () => $3f6b5ad992545f29$export$4f3746fa72dd6449);

var $9c9Gu = parcelRequire("9c9Gu");
var $bTrQR = parcelRequire("bTrQR");

var $ifMZN = parcelRequire("ifMZN");

var $gRo3n = parcelRequire("gRo3n");

var $bSQ4o = parcelRequire("bSQ4o");

var $55gtq = parcelRequire("55gtq");

var $8AJas = parcelRequire("8AJas");

var $j4jdu = parcelRequire("j4jdu");
function $3f6b5ad992545f29$export$4f3746fa72dd6449(config, hostInfo, user, appKey) {
    const { usePromise: usePromise } = (0, $9c9Gu);
    const productName = hostInfo === null || hostInfo === void 0 ? void 0 : hostInfo.product;
    const cloudId = productName && (0, $bSQ4o.getCloudIdFromHostInfo)(hostInfo);
    const userId = user === null || user === void 0 ? void 0 : user.atlassianAccountId;
    const runPromise = !!(cloudId && userId);
    const { result: result, error: error, pending: pending } = usePromise(async ()=>{
        const hostPricingPromise = (0, $55gtq.default)().getHostPricingInfo();
        const appRequestStatusParams = {
            cloudId: cloudId,
            productName: productName,
            appKey: appKey,
            userId: userId
        };
        const appRequestStatusPromise = (0, $gRo3n.getAppRequestedStatus)(appRequestStatusParams).catch((error_)=>{
            if (error_.status !== 404) console.log('failed to fetch app request status');
            return null;
        });
        const appDetailsPromise = (0, $j4jdu.getAppHeaderDetails)(config.graphQLGatewayUrl, appKey);
        const identifier = await (0, $8AJas.getInstallableApp)(config.graphQLGatewayUrl, appKey);
        const appInstallStatusPromise = (0, $55gtq.default)().getInstalledAddon({
            contextId: hostInfo === null || hostInfo === void 0 ? void 0 : hostInfo.globalContext.id,
            addon: (0, $ifMZN.toSPIInstallableAddonIdentifier)(identifier)
        });
        const [hostPricing, appInstallStatus, appRequestStatus, appDetails] = await Promise.all([
            hostPricingPromise,
            appInstallStatusPromise,
            appRequestStatusPromise,
            appDetailsPromise
        ]);
        return {
            hostPricing: hostPricing,
            appInstallStatus: appInstallStatus,
            appRequestStatus: appRequestStatus,
            appDetails: appDetails
        };
    }, [
        runPromise
    ], runPromise);
    if (error) (0, $bTrQR.default).error('useAppRequestBaseData', "Failed to retrieve app request base data", {
        error: error
    });
    return {
        pending: pending,
        error: error,
        result: result
    };
}

});


parcelRegister("jFk3s", function(module, exports) {

$parcel$export(module.exports, "default", () => $59f1e52354f99846$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aOw1G = parcelRequire("aOw1G");

var $lSV8Z = parcelRequire("lSV8Z");

var $kGQen = parcelRequire("kGQen");

var $eI5EY = parcelRequire("eI5EY");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");


var $lUtF4 = parcelRequire("lUtF4");

var $9g2Ks = parcelRequire("9g2Ks");

var $dmaVM = parcelRequire("dmaVM");
const $59f1e52354f99846$var$ModalByStatus = ({ setModalShown: setModalShown, setShouldRefetch: setShouldRefetch, appName: appName, modalState: modalState, configurationUrl: configurationUrl, analyticsAttributes: analyticsAttributes, onTryAgain: onTryAgain, isBlanketHidden: isBlanketHidden, onDismissSuccessModal: // note: contact #makkuro-team if planning to use this prop
onDismissSuccessModal })=>{
    const handleCloseModal = (0, $eUqFw.useCallback)(()=>{
        setModalShown(false);
        if (modalState === (0, $b86bac9bd10892a3$export$10320d5a69619f00) && onDismissSuccessModal && (0, $eI5EY.fg)('jira_improve_scm_onboarding_gate')) onDismissSuccessModal();
    }, [
        setModalShown,
        modalState,
        onDismissSuccessModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "modalByStatus",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        attributes: {
            ...analyticsAttributes,
            appName: appName,
            status: modalState
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lSV8Z.default), {
        exitThenEnter: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        width: "large",
        autoFocus: false,
        isBlanketHidden: isBlanketHidden,
        onClose: handleCloseModal
    }, modalState === (0, $b86bac9bd10892a3$export$d8e3f212656d8f63) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9g2Ks.default), {
        appName: appName
    }), modalState === (0, $b86bac9bd10892a3$export$10320d5a69619f00) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dmaVM.default), {
        setShouldRefetch: setShouldRefetch,
        appName: appName,
        configurationUrl: configurationUrl,
        analyticsAttributes: analyticsAttributes,
        onConfigure: handleCloseModal,
        onMaybeLater: handleCloseModal
    }), modalState === (0, $b86bac9bd10892a3$export$f44a31be6c708b0a) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUtF4.default), {
        analyticsAttributes: analyticsAttributes,
        onTryAgain: onTryAgain,
        onCancel: handleCloseModal
    })))));
};
var $59f1e52354f99846$export$2e2bcd8739ae039 = $59f1e52354f99846$var$ModalByStatus;

});
parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : $082205e2100625d8$var$ShortcutScope;

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});
parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});



const $b86bac9bd10892a3$export$d8e3f212656d8f63 = 'IN_PROGRESS';
const $b86bac9bd10892a3$export$10320d5a69619f00 = 'SUCCESS';
const $b86bac9bd10892a3$export$f44a31be6c708b0a = 'FAIL';

parcelRegister("lUtF4", function(module, exports) {

$parcel$export(module.exports, "default", () => $72e5b971f7ada64d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bLFgh = parcelRequire("bLFgh");
var $7u4fN = parcelRequire("7u4fN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");


var $kyh7a = parcelRequire("kyh7a");

var $70mU2 = parcelRequire("70mU2");

var $3AGjQ = parcelRequire("3AGjQ");
const $72e5b971f7ada64d$var$FailureStatusModal = ({ analyticsAttributes: analyticsAttributes = {}, onTryAgain: onTryAgain, onCancel: onCancel })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onCancelClick = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'cancelTryAgainLink', analyticsAttributes);
        onCancel && onCancel();
    }, [
        analyticsAttributes,
        onCancel
    ]);
    const onTryAgainClick = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'tryAgainButton', analyticsAttributes);
        onTryAgain && onTryAgain();
    }, [
        analyticsAttributes,
        onTryAgain
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kyh7a.default), {
        imageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($70mU2))),
        heading: formatMessage((0, $3AGjQ.default).heading),
        description: formatMessage((0, $3AGjQ.default).body),
        installationState: (0, $b86bac9bd10892a3$export$f44a31be6c708b0a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onTryAgainClick,
        appearance: "primary",
        autoFocus: true,
        testId: "marketplace-dialog.common.ui.failure-status.try-again-button"
    }, formatMessage((0, $3AGjQ.default).tryAgainButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        onClick: onCancelClick,
        testId: "marketplace-dialog.common.ui.failure-status.cancel-button"
    }, formatMessage((0, $3AGjQ.default).cancelButtonLabel)))));
};
var $72e5b971f7ada64d$export$2e2bcd8739ae039 = $72e5b971f7ada64d$var$FailureStatusModal;

});
parcelRegister("kyh7a", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dbdea98fd35fcd8$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lSV8Z = parcelRequire("lSV8Z");

var $2EVgw = parcelRequire("2EVgw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");


var $25VNf = parcelRequire("25VNf");
const $7dbdea98fd35fcd8$var$InstallationStatusModal = ({ imageSrc: imageSrc, heading: heading, description: description, installationState: installationState, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7dbdea98fd35fcd8$var$StyledHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lSV8Z.default), {
        appear: true,
        exitThenEnter: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2EVgw.default), {
        enterFrom: "right"
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7dbdea98fd35fcd8$var$StyledImage, {
            ...props,
            alt: `Graphic showing the installation status for ${heading}`,
            src: imageSrc
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7dbdea98fd35fcd8$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7dbdea98fd35fcd8$var$HeadingContainer, null, installationState === (0, $b86bac9bd10892a3$export$d8e3f212656d8f63) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $25VNf.default), null), heading), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7dbdea98fd35fcd8$var$BodyContainer, null, description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $7dbdea98fd35fcd8$var$actionsContainerStyles
    }, children)));
var $7dbdea98fd35fcd8$export$2e2bcd8739ae039 = $7dbdea98fd35fcd8$var$InstallationStatusModal;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7dbdea98fd35fcd8$var$StyledHeader = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $7dbdea98fd35fcd8$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o _ca0qpxbi _4t3imgvx",
            __cmplp.className
        ])
    });
});
const $7dbdea98fd35fcd8$var$StyledImage = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3ijbd8",
            __cmplp.className
        ])
    });
});
const $7dbdea98fd35fcd8$var$HeadingContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h4", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyr1ejb",
            __cmplp.className
        ])
    });
});
const $7dbdea98fd35fcd8$var$BodyContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyrxy5q",
            __cmplp.className
        ])
    });
});
const $7dbdea98fd35fcd8$var$actionsContainerStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.400'
});

});
parcelRegister("25VNf", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fed9c97a95f2893$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iRFLU = parcelRequire("iRFLU");
const $4fed9c97a95f2893$var$ProgressBarIndeterminate = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4fed9c97a95f2893$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iRFLU.default), {
        isIndeterminate: true
    }));
var $4fed9c97a95f2893$export$2e2bcd8739ae039 = $4fed9c97a95f2893$var$ProgressBarIndeterminate;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4fed9c97a95f2893$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1ssb _18s8paju",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iRFLU", function(module, exports) {

$parcel$export(module.exports, "default", () => $741f3f691e937b15$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

function $741f3f691e937b15$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $741f3f691e937b15$var$MIN_VALUE = 0;
const $741f3f691e937b15$var$MAX_VALUE = 1;
const $741f3f691e937b15$var$increasingBarAnimation = (0, $byn9U.keyframes)({
    from: {
        left: '-5%',
        width: '5%'
    },
    to: {
        left: '130%',
        width: ' 100%'
    }
});
const $741f3f691e937b15$var$decreasingBarAnimation = (0, $byn9U.keyframes)({
    from: {
        left: '-80%',
        width: '80%'
    },
    to: {
        left: '110%',
        width: '10%'
    }
});
const $741f3f691e937b15$var$containerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: `100%`,
    height: 6,
    position: 'relative',
    background: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    overflow: 'hidden'
});
const $741f3f691e937b15$var$containerAppearance = {
    default: /*#__PURE__*/ (0, $byn9U.css)({
        background: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)})`
    }),
    success: /*#__PURE__*/ (0, $byn9U.css)({
        background: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)})`
    }),
    inverse: {
        name: "17q4nu8",
        styles: "background:var(--ds-background-inverse-subtle, rgba(255, 255, 255, 0.5))"
    }
};
const $741f3f691e937b15$var$barAppearance = {
    default: /*#__PURE__*/ (0, $byn9U.css)({
        background: `var(--ds-background-neutral-bold, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`
    }),
    success: /*#__PURE__*/ (0, $byn9U.css)({
        background: `var(--ds-background-success-bold, ${(0, $73a5c9d720aa66e1$export$940e1f69e873f202)})`
    }),
    inverse: {
        name: "1n6cgt8",
        styles: "background:var(--ds-surface, white)"
    }
};
const $741f3f691e937b15$var$barStyles = {
    name: "np1q02",
    styles: "display:block;height:6px;position:absolute;border-radius:var(--ds-border-radius, 3px)"
};
const $741f3f691e937b15$var$determinateBarStyles = {
    name: "1nxgqyg",
    styles: "transition:width 0.2s"
};
const $741f3f691e937b15$var$increasingBarStyles = /*#__PURE__*/ (0, $byn9U.css)({
    animation: `${$741f3f691e937b15$var$increasingBarAnimation} 2s infinite`
});
const $741f3f691e937b15$var$decreasingBarStyles = /*#__PURE__*/ (0, $byn9U.css)({
    animation: `${$741f3f691e937b15$var$decreasingBarAnimation} 2s 0.5s infinite`
});
/**
 * __Progress bar__
 *
 * A progress bar displays the status of a given process.
 *
 * - [Examples](https://atlassian.design/components/progress-bar/examples)
 * - [Code](https://atlassian.design/components/progress-bar/code)
 * - [Usage](https://atlassian.design/components/progress-bar/usage)
 */ const $741f3f691e937b15$var$ProgressBar = ({ appearance: appearance = 'default', ariaLabel: ariaLabel, isIndeterminate: isIndeterminate = false, testId: testId = 'progress-bar', value: value = 0 })=>{
    const valueParsed = isIndeterminate ? $741f3f691e937b15$var$MIN_VALUE : Math.max($741f3f691e937b15$var$MIN_VALUE, Math.min(value, $741f3f691e937b15$var$MAX_VALUE));
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $741f3f691e937b15$var$containerStyles,
            $741f3f691e937b15$var$containerAppearance[appearance]
        ],
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": $741f3f691e937b15$var$MIN_VALUE,
        "aria-valuenow": valueParsed,
        "aria-valuemax": $741f3f691e937b15$var$MAX_VALUE,
        tabIndex: 0,
        "data-testid": testId
    }, isIndeterminate ? /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $741f3f691e937b15$var$barStyles,
            $741f3f691e937b15$var$barAppearance[appearance],
            $741f3f691e937b15$var$increasingBarStyles
        ]
    }), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $741f3f691e937b15$var$barStyles,
            $741f3f691e937b15$var$barAppearance[appearance],
            $741f3f691e937b15$var$decreasingBarStyles
        ]
    })) : /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        style: {
            width: `${Number(value) * 100}%`
        },
        css: [
            $741f3f691e937b15$var$barStyles,
            $741f3f691e937b15$var$barAppearance[appearance],
            $741f3f691e937b15$var$determinateBarStyles
        ]
    }));
};
var $741f3f691e937b15$export$2e2bcd8739ae039 = $741f3f691e937b15$var$ProgressBar;

});



parcelRegister("70mU2", function(module, exports) {
module.exports = new URL("failure.e27bb843.png", import.meta.url).toString();

});

parcelRegister("3AGjQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f83df8de893a9dd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1f83df8de893a9dd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "marketplace-dialog.common.failure-status.heading",
        "defaultMessage": "We ran into a little trouble"
    },
    body: {
        "id": "marketplace-dialog.common.failure-status.body",
        "defaultMessage": "It might just be a hiccup. Try again in a bit."
    },
    tryAgainButtonLabel: {
        "id": "marketplace-dialog.common.failure-status.try-again-button-label",
        "defaultMessage": "Try again"
    },
    cancelButtonLabel: {
        "id": "marketplace-dialog.common.failure-status.cancel-button-label",
        "defaultMessage": "Cancel"
    }
});

});


parcelRegister("9g2Ks", function(module, exports) {

$parcel$export(module.exports, "default", () => $58a9e4f1ec1a95cd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");


var $kyh7a = parcelRequire("kyh7a");

var $aQNST = parcelRequire("aQNST");

var $gJXsI = parcelRequire("gJXsI");
const $58a9e4f1ec1a95cd$var$InProgressStatusModal = ({ appName: appName })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kyh7a.default), {
        imageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($aQNST))),
        heading: formatMessage((0, $gJXsI.default).heading, {
            appName: appName
        }),
        description: formatMessage((0, $gJXsI.default).body),
        installationState: (0, $b86bac9bd10892a3$export$d8e3f212656d8f63)
    });
};
var $58a9e4f1ec1a95cd$export$2e2bcd8739ae039 = $58a9e4f1ec1a95cd$var$InProgressStatusModal;

});
parcelRegister("aQNST", function(module, exports) {
module.exports = new URL("in-progress.213a56fe.png", import.meta.url).toString();

});

parcelRegister("gJXsI", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c99c482797e1b4a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0c99c482797e1b4a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "marketplace-dialog.common.in-progress-status.heading",
        "defaultMessage": "Installing the {appName} app..."
    },
    body: {
        "id": "marketplace-dialog.common.in-progress-status.body",
        "defaultMessage": "Sit back and relax. We'll be done in a few more seconds."
    }
});

});


parcelRegister("dmaVM", function(module, exports) {

$parcel$export(module.exports, "default", () => $1056df322e3d6283$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bLFgh = parcelRequire("bLFgh");
var $7u4fN = parcelRequire("7u4fN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");


var $kyh7a = parcelRequire("kyh7a");

var $5LFQH = parcelRequire("5LFQH");

var $j8r6J = parcelRequire("j8r6J");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1056df322e3d6283$var$ConfigureButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1toh18uv _5jyq1kw7 _mrqmnqa1",
            __cmplp.className
        ])
    });
});
const $1056df322e3d6283$var$SuccessStatusModal = ({ appName: appName, setShouldRefetch: setShouldRefetch, onConfigure: onConfigure, onMaybeLater: onMaybeLater, configurationUrl: configurationUrl, analyticsAttributes: analyticsAttributes = {} })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $eUqFw.useEffect)(()=>()=>{
            setShouldRefetch?.(true);
        }, [
        setShouldRefetch
    ]);
    const onConfigureClick = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        onConfigure && onConfigure();
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'configureNow', analyticsAttributes);
    }, [
        analyticsAttributes,
        onConfigure
    ]);
    const handleMaybeLater = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        onMaybeLater && onMaybeLater();
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'configureLater', analyticsAttributes);
    }, [
        analyticsAttributes,
        onMaybeLater
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kyh7a.default), {
        imageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($5LFQH))),
        heading: formatMessage((0, $j8r6J.default).heading, {
            appName: appName
        }),
        description: formatMessage((0, $j8r6J.default).body),
        installationState: (0, $b86bac9bd10892a3$export$10320d5a69619f00)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1056df322e3d6283$var$ConfigureButton // @ts-expect-error - TS2322 - Type '(e: ChangeEvent<HTMLInputElement>, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to type '(e: MouseEvent<HTMLElement, MouseEvent>, analyticsEvent: UIAnalyticsEvent) => void'.
    , {
        onClick: onConfigureClick,
        appearance: "primary",
        autoFocus: true,
        href: configurationUrl,
        target: "_blank",
        testId: "marketplace-dialog.common.ui.success-status.configure-button"
    }, formatMessage((0, $j8r6J.default).configureAppButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link" // @ts-expect-error - TS2322 - Type '(e: ChangeEvent<HTMLInputElement>, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to type '(e: MouseEvent<HTMLElement, MouseEvent>, analyticsEvent: UIAnalyticsEvent) => void'.
        ,
        onClick: handleMaybeLater,
        testId: "marketplace-dialog.common.ui.success-status.maybe-later-button"
    }, formatMessage((0, $j8r6J.default).maybeLaterButtonLabel)))));
};
var $1056df322e3d6283$export$2e2bcd8739ae039 = $1056df322e3d6283$var$SuccessStatusModal;

});
parcelRegister("5LFQH", function(module, exports) {
module.exports = new URL("success.e3e14e6e.png", import.meta.url).toString();

});

parcelRegister("j8r6J", function(module, exports) {

$parcel$export(module.exports, "default", () => $074849437987dc79$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $074849437987dc79$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "marketplace-dialog.common.success-status.heading",
        "defaultMessage": "Voila! {appName} is now installed"
    },
    body: {
        "id": "marketplace-dialog.common.success-status.body",
        "defaultMessage": "You must configure this app before it can send data to your Jira project."
    },
    configureAppButtonLabel: {
        "id": "marketplace-dialog.common.success-status.configure-app-button-label",
        "defaultMessage": "Configure app"
    },
    maybeLaterButtonLabel: {
        "id": "marketplace-dialog.common.success-status.maybe-later-button-label",
        "defaultMessage": "Maybe later"
    }
});

});



parcelRegister("atoE9", function(module, exports) {

$parcel$export(module.exports, "GRAPHQL_GATEWAY_PATH", () => $f5e01ee2ab5b7eed$export$851c5df667ca24c8);
$parcel$export(module.exports, "DEFAULT_APP_CONFIGURATION_URL", () => $f5e01ee2ab5b7eed$export$1fbf987ca5920013);
$parcel$export(module.exports, "APP_POST_INSTALL_CONFIGURE_ACTIONS", () => $f5e01ee2ab5b7eed$export$12f2eb6f5e6e2801);

var $2FnMA = parcelRequire("2FnMA");
const $f5e01ee2ab5b7eed$export$851c5df667ca24c8 = '/gateway/api/graphql';
const $f5e01ee2ab5b7eed$export$1fbf987ca5920013 = '/plugins/servlet/upm';
const $f5e01ee2ab5b7eed$export$12f2eb6f5e6e2801 = [
    (0, $2FnMA.INSTALL_SUCCESS_ACTION_CONTENT).getStarted,
    (0, $2FnMA.INSTALL_SUCCESS_ACTION_CONTENT).configure
];

});

parcelRegister("h2CmH", function(module, exports) {

$parcel$export(module.exports, "createInstallationStatusConfig", () => $804c7e350182894b$export$3fa7801543bfc2a0);
$parcel$export(module.exports, "handleAppInstallFlagShow", () => $804c7e350182894b$export$735ece61ddf098bb);

var $eo17r = parcelRequire("eo17r");

var $atoE9 = parcelRequire("atoE9");
const $804c7e350182894b$var$createIsModalStatePredicate = (suffix)=>(flagId)=>flagId?.endsWith(suffix) ?? false;
const $804c7e350182894b$export$ac61eb97f58fb046 = $804c7e350182894b$var$createIsModalStatePredicate('-install-success');
const $804c7e350182894b$export$29e386cc050cef6c = $804c7e350182894b$var$createIsModalStatePredicate('-install-error');
const $804c7e350182894b$export$dc07121f4fb49d6 = $804c7e350182894b$var$createIsModalStatePredicate('-install-in-progress');
const $804c7e350182894b$export$65ed809b36513b1b = (flagId)=>$804c7e350182894b$export$dc07121f4fb49d6(flagId) || $804c7e350182894b$export$29e386cc050cef6c(flagId) || $804c7e350182894b$export$ac61eb97f58fb046(flagId);
const $804c7e350182894b$export$d0c2f54b2e196a99 = (flagId)=>{
    if ($804c7e350182894b$export$29e386cc050cef6c(flagId)) return 'FAIL';
    if ($804c7e350182894b$export$ac61eb97f58fb046(flagId)) return 'SUCCESS';
    return 'IN_PROGRESS';
};
const $804c7e350182894b$var$getMessage = (message)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    typeof message === 'string' ? message : message.defaultMessage; // The type can mismatch because of how the flag object is created in the marketplace emcee package
const $804c7e350182894b$export$b23f193c2ae37fdc = (flag)=>({
        key: (0, $eo17r.toFlagId)(flag.id ?? ''),
        type: flag.type,
        title: {
            id: 'marketplace.app-install.flag-title',
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            defaultMessage: flag.title
        },
        description: {
            id: 'marketplace.app-install.flag-description',
            defaultMessage: $804c7e350182894b$var$getMessage(flag.description)
        },
        actions: flag.actions?.map((action, index)=>({
                ...action,
                content: {
                    id: `marketplace.app-install.action${index}`,
                    // @ts-expect-error - TS2322 - Type 'FlagMessage' is not assignable to type 'string | undefined'. Type 'MessageDescriptorV2' is not assignable to type 'string'.
                    defaultMessage: action.content
                }
            }))
    });
const $804c7e350182894b$export$1b88ccd0505ff86e = (flag)=>flag.actions?.find((action)=>(0, $atoE9.APP_POST_INSTALL_CONFIGURE_ACTIONS).includes($804c7e350182894b$var$getMessage(action.content) ?? ''));
const $804c7e350182894b$export$3fa7801543bfc2a0 = (flag)=>({
        modalState: $804c7e350182894b$export$d0c2f54b2e196a99(flag.id),
        configurationUrl: $804c7e350182894b$export$1b88ccd0505ff86e(flag)?.href ?? (0, $atoE9.DEFAULT_APP_CONFIGURATION_URL),
        onTryAgain: flag.actions?.[0]?.onClick
    });
const $804c7e350182894b$export$735ece61ddf098bb = ({ flag: flag, enablePostInstallModal: enablePostInstallModal, openInstallationStatusModal: openInstallationStatusModal, closeInstallationStatusModal: closeInstallationStatusModal, showFlag: showFlag })=>{
    if (!enablePostInstallModal || !$804c7e350182894b$export$65ed809b36513b1b(flag.id)) {
        showFlag($804c7e350182894b$export$b23f193c2ae37fdc(flag));
        return;
    }
    // only show post-install success modal if the flag has post-install actions
    if ($804c7e350182894b$export$ac61eb97f58fb046(flag.id)) {
        if ($804c7e350182894b$export$1b88ccd0505ff86e(flag)) {
            openInstallationStatusModal(flag);
            return;
        }
        showFlag($804c7e350182894b$export$b23f193c2ae37fdc(flag));
        closeInstallationStatusModal();
        return;
    }
    openInstallationStatusModal(flag);
};

});


parcelRegister("jxzG5", function(module, exports) {

$parcel$export(module.exports, "getEmceeDiscoverLink", () => $20f94d12e4a0a9d7$export$f26dabf284aefb17);
$parcel$export(module.exports, "getEmceeAppListingLink", () => $20f94d12e4a0a9d7$export$eb09695b9e9f6a3);
$parcel$export(module.exports, "getAppRequestsLink", () => $20f94d12e4a0a9d7$export$7ab8c48f9081e976);
$parcel$export(module.exports, "getManagePromotionsLink", () => $20f94d12e4a0a9d7$export$350ca33eed6a2742);

var $1ybV0 = parcelRequire("1ybV0");
const $20f94d12e4a0a9d7$var$sanitiseParams = (params)=>params ? Object.entries(params).reduce((res, [key, value])=>{
        if (value) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'EmceeQueryParams | JiraQueryParams'.
        res[key] = params[key];
        return res;
    }, {}) : {};
const $20f94d12e4a0a9d7$var$addQueryParamsToLink = (params, link)=>{
    // @ts-expect-error - TS2345 - Argument of type 'EmceeQueryParams | JiraQueryParams | null | undefined' is not assignable to parameter of type 'EmceeQueryParams | JiraQueryParams | undefined'.
    const queryParams = $20f94d12e4a0a9d7$var$sanitiseParams(params);
    const queryString = new URLSearchParams(queryParams).toString();
    return queryString ? `${link}?${queryString}` : link;
};
const $20f94d12e4a0a9d7$var$resolveConnectDiscoverUrl = (connectUrlDiscoverVariant = 'ENDUSER_DISCOVER', jiraQueryParams)=>{
    let connectDiscoverUrl = `/plugins/servlet/ac/com.atlassian.jira.emcee/${connectUrlDiscoverVariant === 'DISCOVER' ? 'discover' : 'enduser-discover'}`;
    if (jiraQueryParams) connectDiscoverUrl = $20f94d12e4a0a9d7$var$addQueryParamsToLink(jiraQueryParams, connectDiscoverUrl);
    return connectDiscoverUrl;
};
const $20f94d12e4a0a9d7$export$f26dabf284aefb17 = (params, connectUrlDiscoverVariant = 'ENDUSER_DISCOVER')=>{
    const link = (0, $1ybV0.ff)('marketplace.emcee.native.spa.enable') ? '/jira/marketplace/discover' : $20f94d12e4a0a9d7$var$resolveConnectDiscoverUrl(connectUrlDiscoverVariant);
    return $20f94d12e4a0a9d7$var$addQueryParamsToLink(params, link);
};
const $20f94d12e4a0a9d7$export$eb09695b9e9f6a3 = (appKey, params, jiraQueryParams, connectUrlDiscoverVariant = 'ENDUSER_DISCOVER')=>(0, $1ybV0.ff)('marketplace.emcee.native.spa.enable') ? $20f94d12e4a0a9d7$var$addQueryParamsToLink({
        ...jiraQueryParams,
        ...params
    }, `/jira/marketplace/discover/app/${appKey}`) : $20f94d12e4a0a9d7$var$addQueryParamsToLink(params, `${$20f94d12e4a0a9d7$var$resolveConnectDiscoverUrl(connectUrlDiscoverVariant, // @ts-expect-error - TS2345 - Argument of type 'JiraQueryParams | null | undefined' is not assignable to parameter of type 'JiraQueryParams | undefined'.
    jiraQueryParams)}#!/discover/app/${appKey}`);
const $20f94d12e4a0a9d7$export$7ab8c48f9081e976 = (params)=>{
    const link = (0, $1ybV0.ff)('marketplace.emcee.native.spa.enable') ? '/jira/marketplace/manage/app-requests' : '/plugins/servlet/ac/com.atlassian.jira.emcee/app-requests';
    return $20f94d12e4a0a9d7$var$addQueryParamsToLink(params, link);
};
const $20f94d12e4a0a9d7$export$350ca33eed6a2742 = (params)=>{
    const link = (0, $1ybV0.ff)('marketplace.emcee.native.spa.enable') ? '/jira/marketplace/manage/promotions' : '/plugins/servlet/ac/com.atlassian.jira.emcee/promotions';
    return $20f94d12e4a0a9d7$var$addQueryParamsToLink(params, link);
};

});


parcelRegister("be3PE", function(module, exports) {

$parcel$export(module.exports, "JsmPageInteractiveEvent", () => $695cc37a0df2f37c$export$c4ba40c380ee9a11);

var $eUqFw = parcelRequire("eUqFw");

var $7vf5z = parcelRequire("7vf5z");
const $695cc37a0df2f37c$export$c4ba40c380ee9a11 = (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), args);
$695cc37a0df2f37c$export$c4ba40c380ee9a11.defaultProps = {
    isExpectedToHaveSsr: false,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    withMarks: [],
    extra: {}
};
$695cc37a0df2f37c$export$c4ba40c380ee9a11.displayName = 'JsmPageInteractiveEvent';

});
parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $3iMaY = parcelRequire("3iMaY");

var $eJ3kO = parcelRequire("eJ3kO");

var $51JrV = parcelRequire("51JrV");

var $4nnPJ = parcelRequire("4nnPJ");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame, waitForLongTaskIdleTTI: waitForLongTaskIdleTTI } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3iMaY.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJ3kO.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $51JrV.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame,
            waitForLongTaskIdleTTI: waitForLongTaskIdleTTI
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("eJ3kO", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $8841aa10a213faf4$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $8841aa10a213faf4$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $8841aa10a213faf4$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $8841aa10a213faf4$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $8841aa10a213faf4$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $3Hphq.default));
    const interactionId = (0, $51JrV.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $8841aa10a213faf4$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $51JrV.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fYqUr.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $acbV3 = parcelRequire("acbV3");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $6M8Uw = parcelRequire("6M8Uw");

var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $3Hphq = parcelRequire("3Hphq");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $acbV3.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (this.props.waitForLongTaskIdleTTI) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            (0, $cNlZD.getTTIValue)().then((tti)=>{
                (0, $cNlZD.resetTTIObserver)();
                (0, $6iz4v.setMark)('BROWSER_METRICS_LONG_TASK_TTI_END', {
                    startTime: tti
                });
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_LONG_TASK_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_LONG_TASK_TTI_END');
                $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
        } else if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("cNlZD", function(module, exports) {

$parcel$export(module.exports, "resetTTIObserver", () => $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c);
$parcel$export(module.exports, "startTTIObserver", () => $2134fd1f8b4ec9b6$export$d2209a9a3184ff99);
$parcel$export(module.exports, "getTTIValue", () => $2134fd1f8b4ec9b6$export$e67176cf000b0a2e);

var $ba8ih = parcelRequire("ba8ih");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let $2134fd1f8b4ec9b6$var$resolveTti = (_v)=>{};
let $2134fd1f8b4ec9b6$var$observerStarted = false;
/**
 * Initialize module state and return the promise a consumer can use to wait
 * for the TTI event.
 */ function $2134fd1f8b4ec9b6$var$initTtiPromise() {
    return new Promise((resolve)=>{
        let hasResolved = false;
        const callback = (ttiResult)=>{
            if (hasResolved) return;
            hasResolved = true;
            resolve(ttiResult);
        };
        $2134fd1f8b4ec9b6$var$resolveTti = callback;
    });
}
let $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
function $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c() {
    $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
    $2134fd1f8b4ec9b6$var$observerStarted = false;
}
function $2134fd1f8b4ec9b6$export$d2209a9a3184ff99() {
    $2134fd1f8b4ec9b6$var$observerStarted = true;
    let cleanupObserver = null;
    let lastSeenEventTime = performance.now();
    const callback = ()=>{
        cleanupObserver?.();
        $2134fd1f8b4ec9b6$var$resolveTti(lastSeenEventTime);
    };
    let timeoutId = setTimeout(callback, 5000);
    cleanupObserver = (0, $ba8ih.startLongTaskObserver)(()=>{
        lastSeenEventTime = performance.now();
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, 5000);
    });
}
function $2134fd1f8b4ec9b6$export$e67176cf000b0a2e() {
    const promise = $2134fd1f8b4ec9b6$var$ttiPromise ?? $2134fd1f8b4ec9b6$var$initTtiPromise();
    if (!$2134fd1f8b4ec9b6$var$observerStarted) $2134fd1f8b4ec9b6$export$d2209a9a3184ff99();
    return promise;
}

});
parcelRegister("ba8ih", function(module, exports) {

$parcel$export(module.exports, "startLongTaskObserver", () => $c3f66a1c0c2d8c9c$export$af412d3da3bf848a);
/**
 * Starts a long-task observer that will call `cb` on each observation.
 * Returns a disposal function
 */ function $c3f66a1c0c2d8c9c$export$af412d3da3bf848a(cb) {
    const observer = new PerformanceObserver(()=>{
        cb();
    });
    observer.observe({
        type: 'longtask'
    });
    return ()=>{
        observer.disconnect();
    };
}

});


parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $4nnPJ = parcelRequire("4nnPJ");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $4nnPJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");

var $4nnPJ = parcelRequire("4nnPJ");
var $aPkDp = parcelRequire("aPkDp");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $4nnPJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $aPkDp.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $51JrV = parcelRequire("51JrV");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});



parcelRegister("9YeNs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebc59d0e2ffcf525$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7ehAr = parcelRequire("7ehAr");

var $1YMP9 = parcelRequire("1YMP9");

var $dpXKE = parcelRequire("dpXKE");

var $7ZZxN = parcelRequire("7ZZxN");
const $ebc59d0e2ffcf525$var$AppDiscoveryProjectSettingsBreadcrumb = ({ isProjectSimplified: isProjectSimplified, children: children, baseUrl: baseUrl, projectKey: projectKey, projectName: projectName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ehAr.BreadcrumbManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpXKE.default), {
        baseUrl: baseUrl,
        projectKey: projectKey,
        projectName: projectName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1YMP9.default), {
        baseUrl: baseUrl,
        projectKey: projectKey,
        projectType: (0, $7ZZxN.SERVICE_DESK_PROJECT),
        isSimplified: isProjectSimplified
    }, children)));
var $ebc59d0e2ffcf525$export$2e2bcd8739ae039 = $ebc59d0e2ffcf525$var$AppDiscoveryProjectSettingsBreadcrumb;

});
parcelRegister("1YMP9", function(module, exports) {

$parcel$export(module.exports, "default", () => $90e5325849889e8c$export$2e2bcd8739ae039);

var $giAhk = parcelRequire("giAhk");

var $7AJNu = parcelRequire("7AJNu");
var $90e5325849889e8c$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)((0, $7AJNu.default));

});
parcelRegister("7AJNu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a78352310a6c306$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $aTgXo = parcelRequire("aTgXo");

var $5IARc = parcelRequire("5IARc");

var $jBULE = parcelRequire("jBULE");
const $8a78352310a6c306$var$ProjectSettingsBreadcrumb = ({ children: children, projectKey: projectKey, projectType: projectType, isSimplified: isSimplified = false, intl: { formatMessage: formatMessage } })=>projectType && // <- we need this first condition just to avoid Flow error at createProjectSettingsUrl
    (projectType === (0, $7ZZxN.CORE_PROJECT) || projectType === (0, $7ZZxN.SOFTWARE_PROJECT) || projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTgXo.default), {
        breadcrumb: {
            href: (0, $5IARc.createProjectSettingsUrl)(projectKey, projectType, isSimplified),
            text: formatMessage((0, $jBULE.default).projectSettingsTitle),
            type: 'projectSettings'
        }
    }, children) : children;
var $8a78352310a6c306$export$2e2bcd8739ae039 = $8a78352310a6c306$var$ProjectSettingsBreadcrumb;

});
parcelRegister("jBULE", function(module, exports) {

$parcel$export(module.exports, "default", () => $b99c71c52f70e552$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b99c71c52f70e552$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    projectSettingsTitle: {
        "id": "platform.ui.breadcrumbs.common-breadcrumbs.project-settings.project-settings-title",
        "defaultMessage": "Project settings"
    }
});

});




parcelRegister("4hLx8", function(module, exports) {

$parcel$export(module.exports, "APP_DISCOVERY_TTI_THRESHOLD", () => $72adfd00617157ae$export$8d39af56933c07c9);
$parcel$export(module.exports, "APP_DISCOVERY_TTR_THRESHOLD", () => $72adfd00617157ae$export$ba63e41cec5d510e);
$parcel$export(module.exports, "appsDiscoveryPageLoad", () => $72adfd00617157ae$export$3911d3e7cc69f086);

var $lNfG4 = parcelRequire("lNfG4");
const $72adfd00617157ae$export$8d39af56933c07c9 = 4000;
const $72adfd00617157ae$export$ba63e41cec5d510e = 1000;
const $72adfd00617157ae$export$3911d3e7cc69f086 = (0, $lNfG4.metrics).pageLoad({
    key: 'service-management.app-discovery',
    slo: {
        fmp: {
            initial: {
                threshold: $72adfd00617157ae$export$ba63e41cec5d510e
            },
            transition: {
                threshold: $72adfd00617157ae$export$ba63e41cec5d510e
            }
        },
        tti: {
            initial: {
                threshold: $72adfd00617157ae$export$8d39af56933c07c9
            },
            transition: {
                threshold: $72adfd00617157ae$export$8d39af56933c07c9
            }
        }
    }
});

});

parcelRegister("g8MSG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1fb953041a85b80$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d1fb953041a85b80$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    header: {
        "id": "servicedesk-app-discovery.header",
        "defaultMessage": "Discover apps"
    },
    headerNew: {
        "id": "servicedesk-app-discovery.header-new",
        "defaultMessage": "Explore apps"
    },
    subHeaderJsm: {
        "id": "servicedesk-app-discovery.sub-header-jsm",
        "defaultMessage": "Supercharge your service project with our favorite apps from the Atlassian Marketplace."
    },
    categoryAssetManagement: {
        "id": "servicedesk-app-discovery.category-asset-management",
        "defaultMessage": "Asset management"
    },
    categoryHelpCenterFormCustomization: {
        "id": "servicedesk-app-discovery.category-help-center-form-customization",
        "defaultMessage": "Help center & form customization"
    },
    categoryAgentProductivity: {
        "id": "servicedesk-app-discovery.category-agent-productivity",
        "defaultMessage": "Agent productivity"
    },
    categoryReportingAnalytics: {
        "id": "servicedesk-app-discovery.category-reporting-analytics",
        "defaultMessage": "Reporting & Analytics"
    },
    categoryAlertingIncidentManagement: {
        "id": "servicedesk-app-discovery.category-alerting-incident-management",
        "defaultMessage": "Alerting & Incident Management"
    },
    featureFlagOffError: {
        "id": "servicedesk-app-discovery.feature-flag-off-error",
        "defaultMessage": "This page is not yet available"
    }
});

});





//# sourceMappingURL=async-project-settings-app-discovery-settings.c224fe01.js.map
